(() => {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2KSIf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $201a5170cda57e0a$export$2e2bcd8739ae039);

var $cb5KT = parcelRequire("cb5KT");

var $eZSa4 = parcelRequire("eZSa4");

var $iwBa6 = parcelRequire("iwBa6");

var $5eviF = parcelRequire("5eviF");

var $6oQp6 = parcelRequire("6oQp6");

var $arXM4 = parcelRequire("arXM4");
var $201a5170cda57e0a$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: {
        lang: {
            type: String,
            default: 'de'
        },
        project: {
            type: String
        },
        loginusername: {
            type: String,
            default: ''
        },
        initialOfferId: {
            type: Number
        },
        preselectedCategory: {
            type: Number
        },
        initialCouponCode: {
            type: String,
            default: ''
        },
        fullDescription: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Navigation: $arXM4.default,
        TicketList: $cb5KT.default,
        Checkout: $eZSa4.default,
        OrderSummary: $iwBa6.default,
        PersonalizeTickets: $5eviF.default
    },
    data: ()=>{
        return {
            hasErrors: false,
            errorMessage: '',
            errorHeadline: '',
            hasSuccess: false,
            successMessage: '',
            settings: {},
            loading: false,
            serverError: false,
            direction: "left",
            currentStep: 0,
            initialized: false,
            scrollPosition: null,
            projectId: '',
            hideNav: {
                isHidden: true
            },
            small: false
        };
    },
    mounted () {
        this.$root.$i18n.locale = this.lang;
        this.$vueform.i18n.locale = this.lang;
        // Ticket.vue haengt zu tief, um die Prop durchgereicht zu bekommen —
        // der Store ist der Weg dorthin. Muss vor onGetSettings gesetzt sein,
        // damit die Ticketliste beim ersten Rendern schon den Wert sieht.
        this.store.state.fullDescription = this.fullDescription;
        if (document.body.clientWidth < 960) this.small = true;
        window.onresize = function(event) {
            this.small = document.body.clientWidth < 960;
        };
        if (this.orderstatus) {
            this.store.state.loading = false;
            return;
        }
        this.projectId = this.project;
        this.doOctoberRequest("onGetSettings", {}).then((response)=>{
            if (typeof response.code == 'undefined') {
                this.settings = response;
                window.projectId = response.project;
                this.store.commit("init", {
                    settings: this.settings,
                    doOctoberRequest: this.doOctoberRequest,
                    $t: this.$t,
                    initialCouponCode: this.initialCouponCode
                });
                this.initialized = true;
                if (this.settings.google_tag_id || this.settings.meta_pixel_id || this.settings.matomo_site_id && this.settings.matomo_url) this.initCookieConsent();
            } else if (response.code == 404) this.emitError('server', this.$t("Dieser Shop wurde nicht gefunden."), false, this.$t('Fehler'));
            else if (response.code == 410) this.emitError('server', this.$t("Dieser Shop ist zurzeit nicht aktiv."), false, this.$t('Fehler'));
            else this.emitError('server', this.$t("Entschuldigung, der Server meldet einen Fehler. Bitte versuche es sp\xe4ter noch einmal."));
        }).catch((error)=>{
            this.emitError('server', this.$t("Entschuldigung, der Server meldet einen Fehler. Bitte versuche es sp\xe4ter noch einmal."));
            console.log(error);
        }).finally(()=>{
            this.store.state.loading = false;
        });
        window.addEventListener('Festiware::Error', this.handleErrors);
        window.addEventListener('Festiware::Success', this.handleSuccess);
        window.addEventListener("scroll", this.updateScroll);
    },
    unmounted () {
        window.removeEventListener('Festiware::Error', this.handleErrors);
        window.removeEventListener('Festiware::Success', this.handleSuccess);
        window.removeEventListener("scroll", this.updateScroll);
    },
    methods: {
        back (steps = 1) {
            this.store.state.currentStep -= steps;
            if (this.store.state.currentStep > 0 && Object.keys(this.store.state.selection).length) this.updatePage();
            this.store.commit('emitScroll');
        },
        next (steps = 1) {
            this.store.state.currentStep += steps;
            this.updatePage();
            this.store.commit('emitScroll');
        },
        updatePage (setPage) {
            this.store.state.currentStep = setPage !== undefined ? setPage : this.store.state.currentStep;
            this.$scrollTo(this.$.appContext.app._container, 500, {
                offset: -120
            });
            this.store.commit("updateSession");
        },
        updateScroll () {
            this.scrollPosition = window.scrollY;
        },
        handleErrors (payload) {
            if (payload.detail.onlyNotification) UIkit.notification({
                message: payload.detail.message,
                status: 'danger',
                pos: 'top-center',
                timeout: 5000
            });
            else {
                this.hasErrors = true;
                this.errorMessage = payload.detail.message;
                this.errorHeadline = payload.detail.errorHeadline;
            }
        },
        handleSuccess (payload) {
            this.hasSuccess = true;
            this.successMessage = payload.detail.message;
            this.store.commit("removeCookieStore", this.doOctoberRequest);
        },
        initCookieConsent () {
            const loadTracking = ()=>{
                if (this.settings.google_tag_id && typeof window.loadGoogleAnalytics === 'function') window.loadGoogleAnalytics(this.settings.google_tag_id);
                if (this.settings.meta_pixel_id && typeof window.loadMetaPixel === 'function') window.loadMetaPixel(this.settings.meta_pixel_id);
                if (this.settings.matomo_site_id && this.settings.matomo_url && typeof window.loadMatomo === 'function') window.loadMatomo(this.settings.matomo_url, this.settings.matomo_site_id);
            };
            const isAllowed = window.top !== window.self || typeof CookieConsent !== "undefined" && CookieConsent.acceptedCategory('analytics');
            if (isAllowed) loadTracking();
            window.onConsentAnalytics = loadTracking;
        }
    }
};

});
parcelRegister("cb5KT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ddafa05b8bd660c$export$2e2bcd8739ae039);
let $8ddafa05b8bd660c$var$script;



let $8ddafa05b8bd660c$var$initialize = ()=>{
    $8ddafa05b8bd660c$var$script = (parcelRequire("14SCr"));
    if ($8ddafa05b8bd660c$var$script.__esModule) $8ddafa05b8bd660c$var$script = $8ddafa05b8bd660c$var$script.default;
    $8ddafa05b8bd660c$var$script.render = (parcelRequire("iQBYc")).render;
    (parcelRequire("8aZYK")).default($8ddafa05b8bd660c$var$script);
    $8ddafa05b8bd660c$var$script.__scopeId = 'data-v-5652ae';
    $8ddafa05b8bd660c$var$script.__file = "TicketList.vue";
};
$8ddafa05b8bd660c$var$initialize();
var $8ddafa05b8bd660c$export$2e2bcd8739ae039 = $8ddafa05b8bd660c$var$script;

});
parcelRegister("14SCr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0c908861ab97547c$export$2e2bcd8739ae039);

var $eaCLO = parcelRequire("eaCLO");

var $g9Aab = parcelRequire("g9Aab");

var $6Vica = parcelRequire("6Vica");

var $6oQp6 = parcelRequire("6oQp6");

var $cDUAh = parcelRequire("cDUAh");

var $dXhd9 = parcelRequire("dXhd9");

var $bXsWn = parcelRequire("bXsWn");
/**
 * True when the HTML shows something: text after stripping tags, or an image.
 * `&nbsp;` counts as empty.
 */ function $0c908861ab97547c$var$hasVisibleText(html) {
    if (typeof html !== 'string') return false;
    if (/<img\b/i.test(html)) return true;
    return html.replace(/<[^>]*>/g, '').replace(/&nbsp;|\u00a0/gi, ' ').trim() !== '';
}
var $0c908861ab97547c$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        "settings",
        "initialOfferId",
        "preselectedCategory",
        "initialCouponCode"
    ],
    components: {
        Ticket: $eaCLO.default,
        Coupons: $g9Aab.default,
        Cart: $6Vica.default
    },
    data: ()=>{
        return {
            currentCategory: undefined,
            sortedOffers: [],
            categories: {},
            offerId: null,
            searchTerm: '',
            searchOpen: false,
            refocusSearchToggle: false,
            lockedOfferId: null,
            lockedCategoryId: null,
            embedded: (0, $dXhd9.isEmbedded)(),
            stopCartCommands: null
        };
    },
    computed: {
        /**
         * The intro text in the shop's language.
         *
         * The backend sends it twice: `intro_text_translations` as a locale map and
         * `intro_text` as a single string. A backend that predates the map sends only
         * the string, so the map is used only when one is actually there.
         *
         * Same fallback as php-core's Helper::getFilledTranslatedValue(): the shop's
         * language first, then German, then any language with visible text. A Redactor
         * field cleared by hand holds `<p></p>` or `<p><br></p>`, a truthy string that
         * shows nothing, so "filled" means visible text, not a non-empty string.
         */ introText () {
            const locale = this.$root.$i18n.locale;
            const single = this.settings.intro_text;
            // `intro_text` itself can be a map: an instance that ran the migration while
            // still on the old backend code passes the stored map through unfiltered, and
            // without this check the buyer reads "[object Object]".
            const map = this.settings.intro_text_translations || (single && typeof single === 'object' ? single : null);
            if (!map) return typeof single === 'string' ? single : '';
            return [
                map[locale],
                map.de,
                ...Object.values(map)
            ].find($0c908861ab97547c$var$hasVisibleText) || '';
        },
        hasNoItems () {
            return Object.keys(this.store.state.selection).length === 0 || Object.keys(this.store.state.selection).filter((id)=>this.store.state.selection[id].amount > 0).length === 0;
        },
        isSearchActive () {
            return this.searchTerm !== '';
        },
        shouldShowSearch () {
            return !this.offerId && this.sortedOffers.length > 8;
        },
        showTabs () {
            return !this.directLinkLocked && (this.categories.length > 1 || this.offerId);
        },
        showFilterBar () {
            return this.showTabs || this.shouldShowSearch;
        },
        searchResultLabel () {
            const count = this.displayedOffers.length;
            return `${count} ${count === 1 ? this.$t('Produkt') : this.$t('Produkte')}`;
        },
        displayedOffers () {
            if (!this.isSearchActive) return this.sortedOffers;
            const needle = (0, $cDUAh.normalizeSearchText)(this.searchTerm);
            return this.sortedOffers.filter((offer)=>(0, $cDUAh.normalizeSearchText)(offer.name + ' ' + offer.category.name).includes(needle));
        },
        displayedHeadlines () {
            const headlines = {};
            this.displayedOffers.forEach((offer)=>{
                if (!headlines[offer.category.id]) headlines[offer.category.id] = offer.id;
            });
            return headlines;
        },
        /**
         * Stückzahl über alle gewählten Tickets — nicht die Anzahl der
         * Ticketarten. Die Leiste soll "3 Tickets" zeigen, wenn drei Stück
         * einer Art gewählt sind, nicht "1".
         */ cartAmount () {
            return Object.values(this.store.state.selection).reduce((sum, entry)=>sum + (entry.amount || 0), 0);
        },
        /**
         * state.total, nicht state.price: der Coupon-Rabatt wird schon in
         * diesem Schritt verrechnet (store.updatePrice), und die Leiste soll
         * denselben Betrag zeigen wie der Warenkorb im Checkout.
         */ cartTotal () {
            return this.store.state.total;
        },
        /**
         * Was die einbettende Seite braucht, um ihre Leiste zu rendern. Als
         * eigenes computed, damit ein Watcher darauf reagieren kann: bei jeder
         * Neuberechnung entsteht ein neues Objekt, der Watcher feuert also
         * genau dann, wenn sich Menge oder Summe wirklich geändert haben.
         */ cartPayload () {
            return {
                amount: this.cartAmount,
                total: this.cartTotal,
                totalFormatted: this.$filters.currency(this.cartTotal),
                canProceed: !this.hasNoItems,
                // Fertig übersetzt, nicht als Bausteine: embed.js kennt die
                // Sprache des Shops nicht, und eine zweite Übersetzungstabelle
                // im Theme würde bei jedem neuen Text auseinanderlaufen.
                label: this.cartLabel,
                nextLabel: this.$t('Weiter')
            };
        },
        /** Ein Text, zwei Darstellungen — Leiste im iframe wie außerhalb. */ cartLabel () {
            const unit = this.cartAmount === 1 ? this.$t('Ticket') : this.$t('Tickets');
            return `${this.cartAmount} ${unit} ${this.$t("f\xfcr")} ${this.$filters.currency(this.cartTotal)}`;
        },
        /**
         * A direct link (?oid= / ?cat=) whose target carries the backend switch
         * "hide show all tickets". While locked, the whole category subnav is
         * gone — there is no "Alle Tickets anzeigen", no "Alle Arten" and no
         * category tab, and the offers outside the locked scope never render.
         */ directLinkLocked () {
            return this.lockedOfferId !== null || this.lockedCategoryId !== null;
        }
    },
    watch: {
        cartPayload: {
            immediate: true,
            handler (payload) {
                (0, $dXhd9.sendToParent)({
                    cart: payload
                });
            }
        }
    },
    mounted () {
        this.offerId = this.initialOfferId;
        this.init();
        const offerIds = Object.keys(this.store.state.offers);
        if (offerIds.length) {
            const offers = Object.values(this.store.state.offers);
            this.trackMetaPixel('ViewContent', {
                content_ids: offerIds,
                content_type: 'ticket',
                contents: offerIds.map((id)=>({
                        id: id,
                        quantity: 1
                    }))
            });
            this.trackGA('view_item_list', {
                item_list_name: 'Tickets',
                items: offers.map((o)=>({
                        item_id: o.id,
                        item_name: o.name,
                        price: o.price,
                        currency: 'EUR'
                    }))
            });
            offers.forEach((o)=>{
                this.trackMatomo('setEcommerceView', String(o.id), o.name, '', o.price);
            });
        }
        if (this.preselectedCategory) window.setTimeout(()=>{
            let elm = document.querySelector("li[uk-filter-control='.tag-" + this.preselectedCategory + "'] > a");
            if (elm) elm.click();
        });
        // Der Klick auf die Leiste der einbettenden Seite kommt hier an und
        // nimmt denselben Weg wie der Button darunter — inklusive Tracking.
        // hasNoItems wird trotzdem geprüft: die Elternseite ist nicht die
        // Instanz, die über die Gültigkeit der Auswahl entscheidet.
        this.stopCartCommands = (0, $dXhd9.onParentCommand)('cartNext', ()=>{
            if (!this.hasNoItems) this.next();
        });
    },
    unmounted () {
        this.stopCartCommands?.();
        // Ohne dieses Signal bliebe die Leiste der einbettenden Seite in den
        // Folgeschritten stehen: der Shop rendert die Ticketliste dann nicht
        // mehr, und ohne Ticketliste käme kein Update mehr, das sie ausblendet.
        (0, $dXhd9.sendToParent)({
            cart: {
                amount: 0,
                total: 0,
                totalFormatted: '',
                canProceed: false,
                label: '',
                nextLabel: ''
            }
        });
    },
    methods: {
        openSearch () {
            this.searchOpen = true;
        },
        closeSearch () {
            this.searchTerm = '';
            this.searchOpen = false;
            this.refocusSearchToggle = true;
        },
        focusSearchInput () {
            this.$nextTick(()=>this.$refs.searchInput?.focus());
        },
        /* The swap runs out-in, so the element to focus only exists once it has entered. */ afterFilterSwap () {
            if (this.searchOpen) this.focusSearchInput();
            else if (this.refocusSearchToggle) {
                // Back to the toggle, so a keyboard user does not land at the top of the page.
                this.refocusSearchToggle = false;
                this.$refs.searchToggle?.focus();
            }
        },
        init (onlyShowCoupons = false) {
            const offers = Object.values(this.store.state.offers);
            this.resolveDirectLinkLock(offers);
            const categories = {};
            this.sortedOffers = this.applyDirectLinkLock(offers).sort((0, $bXsWn.firstBy)((a, b)=>a.category.sortOrder - b.category.sortOrder).thenBy((a, b)=>a.sortOrder - b.sortOrder));
            this.sortedOffers.forEach((offer)=>{
                categories[offer.category.id] = offer.category;
            });
            this.categories = Object.values(categories).sort((a, b)=>a.sortOrder - b.sortOrder);
            // A locked direct link has no subnav to switch, so there is no
            // coupon tab to activate either — the revealed coupon offers inside
            // the locked scope simply show up in place. The optional chaining
            // also covers the (pre-existing) case of a shop with a single
            // category, where the subnav is not rendered at all.
            /* A redeemed coupon clears the search: the revealed offers must not be filtered
               away, and an active search removes the pill bar from the DOM, so the
               .tag-coupon querySelector below would find nothing. */ if (onlyShowCoupons) {
                this.searchTerm = '';
                this.searchOpen = false;
            }
            if (onlyShowCoupons && !this.directLinkLocked) {
                this.categories.push({
                    id: 'coupon',
                    name: this.$t('Coupon-Tickets'),
                    description: ""
                });
                this.currentCategory = 'coupon';
                setTimeout(()=>{
                    document.querySelector('[uk-filter-control=".tag-coupon"] a')?.click();
                });
            }
        },
        /**
         * Reads the direct-link lock off the backend payload.
         *
         * Scope — the narrowest thing the link names: the offer when `?oid=` is
         * present, otherwise the category from `?cat=`. Trigger — the flag on
         * that target; a flagged category additionally locks the `?oid=` links
         * into it, since "no way from here to the full list" holds for its
         * products too.
         *
         * Once established the lock is never released: `updateOffers` merges
         * coupon offers into the store and re-runs init(), and no later payload
         * may hand the buyer back the full ticket list.
         */ resolveDirectLinkLock (offers) {
            if (this.directLinkLocked) return;
            const sameId = (a, b)=>a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b);
            const linkedOffer = offers.find((offer)=>sameId(offer.id, this.initialOfferId));
            if (linkedOffer && (linkedOffer.hide_show_all_link || linkedOffer.category.hideShowAllLink)) {
                this.lockedOfferId = linkedOffer.id;
                return;
            }
            const inLinkedCategory = offers.find((offer)=>sameId(offer.category.id, this.preselectedCategory));
            if (inLinkedCategory && inLinkedCategory.category.hideShowAllLink) {
                this.lockedCategoryId = inLinkedCategory.category.id;
                // Keep the state coherent: with the subnav gone there is nothing
                // left that could widen a single-offer view back to its category.
                this.offerId = null;
            }
        },
        /**
         * @gotcha The locked scope has to be cut out of the offer list itself,
         *         it cannot be left to UIkit: the visible selection is driven by
         *         the *active filter control* inside the subnav, so with the
         *         subnav hidden nothing is active any more and `uk-filter` shows
         *         every item — hiding the nav alone would reveal the full list
         *         instead of restricting it.
         */ applyDirectLinkLock (offers) {
            if (this.lockedOfferId !== null) return offers.filter((offer)=>String(offer.id) === String(this.lockedOfferId));
            if (this.lockedCategoryId !== null) return offers.filter((offer)=>String(offer.category.id) === String(this.lockedCategoryId));
            return offers;
        },
        next () {
            const contents = Object.keys(this.store.state.selection).map((id)=>({
                    id: id,
                    name: this.store.state.selection[id].ticket.name,
                    quantity: this.store.state.selection[id].amount,
                    price: this.store.state.selection[id].ticket.price
                }));
            this.trackMetaPixel('AddToCart', {
                content_ids: contents.map((c)=>c.id),
                contents: contents.map((c)=>({
                        id: c.id,
                        quantity: c.quantity
                    })),
                content_type: 'ticket',
                num_items: contents.reduce((sum, c)=>sum + c.quantity, 0),
                value: this.store.state.price,
                currency: 'EUR'
            });
            this.trackGA('add_to_cart', {
                currency: 'EUR',
                value: this.store.state.price,
                items: contents.map((c)=>({
                        item_id: c.id,
                        item_name: c.name,
                        price: c.price,
                        quantity: c.quantity
                    }))
            });
            contents.forEach((c)=>{
                this.trackMatomo('addEcommerceItem', String(c.id), c.name, '', c.price, c.quantity);
            });
            this.trackMatomo('trackEcommerceCartUpdate', this.store.state.price);
            this.$emit("next", this.store.state.personalize && !this.store.state.onlyNoChipTicketsSelected ? 1 : 2);
        }
    }
};

});
parcelRegister("eaCLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51012cc215b364d$export$2e2bcd8739ae039);
let $a51012cc215b364d$var$script;



let $a51012cc215b364d$var$initialize = ()=>{
    $a51012cc215b364d$var$script = (parcelRequire("kIhzR"));
    if ($a51012cc215b364d$var$script.__esModule) $a51012cc215b364d$var$script = $a51012cc215b364d$var$script.default;
    $a51012cc215b364d$var$script.render = (parcelRequire("kO8nc")).render;
    (parcelRequire("4rOa1")).default($a51012cc215b364d$var$script);
    $a51012cc215b364d$var$script.__scopeId = 'data-v-13ba45';
    $a51012cc215b364d$var$script.__file = "Ticket.vue";
};
$a51012cc215b364d$var$initialize();
var $a51012cc215b364d$export$2e2bcd8739ae039 = $a51012cc215b364d$var$script;

});
parcelRegister("kIhzR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f1458d38e4a90901$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");
var $f1458d38e4a90901$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'ticket',
        'id',
        'offerId'
    ],
    components: {},
    data: {
        optionMemory: '',
        shortened: false,
        opened: false,
        maxDescriptionLength: 200
    },
    computed: {
        selection: {
            get () {
                if (this.ticket.required_ticket_types && !this.requirementMet() && this.store.state.selection[this.id]) delete this.store.state.selection[this.id];
                return this.store.state.selection[this.id] ? this.store.state.selection[this.id].amount : 0;
            },
            set (amount) {
                let option = this.option;
                this.store.commit("addTicket", {
                    ticketId: this.id,
                    amount: amount,
                    option: option
                });
                this.$forceUpdate();
            }
        },
        hasOtherSelectedCouponTickets () {
            return Object.entries(this.store.state.selection).some(([id, selection])=>{
                return this.ticket.coupon_required && selection.ticket.coupon_required && id != this.id;
            });
        },
        option: {
            get () {
                return this.store.state.selection[this.id] ? this.store.state.selection[this.id].option : this.optionMemory;
            },
            set (option) {
                if (this.store.state.selection[this.id]) {
                    this.store.commit("addTicket", {
                        ticketId: this.id,
                        amount: this.selection,
                        option: option
                    });
                    this.$forceUpdate();
                } else this.optionMemory = option;
                this.selection = Math.min(this.selection, this.getMaxOrderAmount(this.option) - 1);
            }
        },
        offers () {
            return this.store.state.offers;
        }
    },
    watch: {
        'store.state.selection': {
            deep: true,
            handler () {
                this.$forceUpdate();
            }
        }
    },
    mounted () {
        this.optionMemory = '';
    },
    methods: {
        getMaxOrderAmount (option_id) {
            let ticket_type_id = this.store.state.offers[this.id].offerable_id;
            let option = null;
            if (option_id) {
                for(let i in this.ticket.options)if (this.ticket.options[i].id == option_id) option = this.ticket.options[i];
            }
            let max_amount = !option ? this.ticket.max_order_amount : option.max_order_amount;
            if (typeof this.store.state.maxOrderAmounts.offerables[ticket_type_id] != 'undefined') {
                let alreadySelected = 0;
                let max_order_amount = !option ? this.store.state.maxOrderAmounts.offerables[ticket_type_id].max_order_amount : this.store.state.maxOrderAmounts.options[option_id].max_order_amount;
                for(let idx in this.store.state.offers)if (idx != this.id && this.store.state.offers[idx].offerable_id == ticket_type_id && typeof this.store.state.selection[idx] != 'undefined') {
                    if (!option_id) alreadySelected += this.store.state.selection[idx].amount;
                    else if (this.store.state.selection[idx].option == option_id) alreadySelected += typeof this.store.state.selection[idx] != 'undefined' ? this.store.state.selection[idx].amount : 0;
                }
                if (this.getCouponOverbookAllowance(option) > 0) // A covering coupon books into this option's overbook reserve
                // (artist/crew extra seats). Allow exactly ONE seat per order, even
                // when the option is publicly sold out — a single order must never
                // drain the reserve. Regular remaining is irrelevant here: a coupon
                // seat is booked against the reserve, not the public capacity. The
                // global reserve size and any per-coupon usage limit are enforced by
                // php-core (overbook_remaining shrinks per booked seat).
                return Math.max(0, Math.min(1, max_amount) - alreadySelected) + 1;
                return Math.min(max_amount, max_order_amount - alreadySelected) + 1;
            }
            return max_amount + 1;
        },
        // Overbook reserve still available to this offer under an applied covering
        // coupon (artist/crew extra seats above the public bus capacity). php-core
        // shrinks overbook_remaining as coupon seats are booked, so once the reserve
        // is used up this returns 0 again. Used by getMaxOrderAmount ONLY as a gate
        // (> 0 → allow one overbook seat this order); the value itself is never added
        // to the regular remaining, so the reserve cannot be over-drawn from here.
        // Returns 0 when no applied coupon covers this offer, no reserve is left, or
        // php-core does not expose the field yet.
        getCouponOverbookAllowance (option) {
            if (!option) return 0;
            const state = this.store.state;
            const covered = state.couponValue && (state.couponOffers.length === 0 || state.couponOffers.includes(parseInt(this.id)));
            if (!covered) return 0;
            return Math.max(0, parseInt(option.overbook_remaining) || 0);
        },
        getDescription () {
            if (this.offerId || this.opened || this.store.state.fullDescription || this.ticket.description.length <= this.maxDescriptionLength) {
                this.shortened = false;
                return this.ticket.description.replace(/<br \/>/g, '<br /><span class="break"></span>');
            }
            this.shortened = true;
            return this.ticket.description.substring(0, this.maxDescriptionLength) + '...';
        },
        getRequiredText () {
            let txt = '';
            for(let idx in this.store.state.offers)if (this.store.state.offers[idx].available && this.ticket.required_ticket_types.includes(this.store.state.offers[idx].offerable_id.toString())) txt += (txt ? ', ' : '') + this.store.state.offers[idx].name;
            return txt;
        },
        requirementMet () {
            if (this.store.state.ownerData) for(let idx in this.store.state.ownerData.ticket_types){
                if (this.ticket.required_ticket_types.includes(this.store.state.ownerData.ticket_types[idx].toString())) return true;
            }
            for(let idx in this.store.state.selection){
                if (this.ticket.required_ticket_types.includes(this.store.state.offers[idx].offerable_id.toString())) return true;
            }
            return false;
        }
    }
};

});
parcelRegister("6oQp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8da2496ea4d299$export$2e2bcd8739ae039);

var $PEtmm = parcelRequire("PEtmm");
var $4a8da2496ea4d299$export$2e2bcd8739ae039 = {
    data: ()=>({
            store: (0, $PEtmm.useStore)()
        }),
    methods: {
        doOctoberRequest (requestName, data, messages = false, silent = false) {
            return new Promise((resolve, reject)=>{
                if (window.projectId) {
                    if (data) data.project = window.projectId;
                    else data = {
                        project: window.projectId
                    };
                }
                $.request(requestName, {
                    data: data,
                    error: (jqXHR)=>{
                        const message = this.backendMessage(jqXHR) || 'Ein Fehler ist aufgetreten / An error occurred.';
                        UIkit.notification({
                            message: '<span uk-icon="warning"></span> ' + message,
                            status: 'danger',
                            pos: 'bottom-center',
                            timeout: 7000
                        });
                        // @gotcha Reject with the jqXHR, NEVER with the parsed body. Callers
                        //   read `responseJSON` / `responseText` / `statusText` off whatever
                        //   arrives here; handing them the body alone leaves all three
                        //   undefined, so SummaryPayment.placeOrder()'s layered fallback chain
                        //   missed on every branch and fell through to its generic wording.
                        //   Result: a buyer whose departure was sold out read "Bitte versuche
                        //   es später nochmal" while the real reason sat in the response the
                        //   whole time (2026-08-27).
                        reject(jqXHR);
                    },
                    success: (data)=>resolve(data)
                });
            });
        },
        emitEvent (name, detail) {
            const event = new CustomEvent('Festiware::' + name, {
                detail: detail
            });
            window.dispatchEvent(event);
        },
        /**
         * The backend's own wording for a failed request, or null when it did not send
         * one worth reading. Callers fall back to their own copy in that case.
         *
         * @gotcha The placeholder list is the whole point. Laravel answers anything that
         *   is not an HttpException with the literal string "Server Error" once debug is
         *   off, and statusText is never more than "Internal Server Error" — so a naive
         *   `responseJSON.message || statusText` chain reports those to the buyer as if
         *   they explained something. They are worse than the shop's own sentence, which
         *   at least tells him to try again later.
         */ backendMessage (jqXHR) {
            const placeholders = [
                'Server Error',
                'Internal Server Error',
                'Bad Request',
                'Not Found',
                'Forbidden',
                'Unprocessable Content',
                'Unprocessable Entity',
                'Service Unavailable'
            ];
            const usable = (text)=>typeof text === 'string' && text.trim() !== '' && !placeholders.includes(text.trim());
            const fromBody = jqXHR?.responseJSON?.X_OCTOBER_ERROR_MESSAGE || jqXHR?.responseJSON?.message || jqXHR?.responseJSON?.error;
            if (usable(fromBody)) return fromBody;
            // A non-JSON body can still be the message itself (older October versions
            // answered an AJAX handler in plain text). An HTML error page or a JSON blob
            // is not, so those are excluded rather than printed at the buyer.
            const raw = (jqXHR?.responseText ?? '').trim();
            if (usable(raw) && raw.length < 500 && !raw.startsWith('<') && !raw.startsWith('{')) return raw;
            return null;
        },
        emitError (type, message, onlyNotification = false, errorHeadline = '') {
            const detail = {
                type: type,
                message: message,
                onlyNotification: onlyNotification,
                errorHeadline: errorHeadline
            };
            this.emitEvent('Error', detail);
            this.$emit('error', detail);
        },
        getPrice (ticket, selection) {
            let price = ticket.price;
            if (ticket.included_products) ticket.included_products.forEach((product)=>{
                price -= parseFloat(product.attributes.price);
            });
            return this.$filters.currency(price * (selection ? selection : 1));
        },
        getIncludedProducts (ticket) {
            let includedProducts = '';
            ticket.included_products.forEach((product)=>{
                includedProducts += '<span>+ ' + this.$filters.currency(product.attributes.price) + ' ' + product.attributes.title + '</span><br>';
            });
            return includedProducts;
        },
        trackMetaPixel (eventName, params = {}) {
            if (typeof window.fbq === 'function') window.fbq('track', eventName, params);
        },
        trackGA (eventName, params = {}) {
            if (typeof window.gtag === 'function') window.gtag('event', eventName, params);
        },
        trackMatomo (action, ...args) {
            if (window._paq) window._paq.push([
                action,
                ...args
            ]);
        }
    }
};

});
parcelRegister("PEtmm", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $09b42889ded19e60$export$6ccbb43953eebf8);
$parcel$export(module.exports, "createStore", () => $09b42889ded19e60$export$f51a9068ac82ea43);
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */ parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");

var $4GZdJ = parcelRequire("4GZdJ");
var $09b42889ded19e60$export$67bdc3ac2df6c0d1 = 'store';
function $09b42889ded19e60$export$6ccbb43953eebf8(key) {
    if (key === void 0) key = null;
    return (0, $ani5R.inject)(key !== null ? key : $09b42889ded19e60$export$67bdc3ac2df6c0d1);
}
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */ function $09b42889ded19e60$var$find(list, f) {
    return list.filter(f)[0];
}
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */ function $09b42889ded19e60$var$deepCopy(obj, cache) {
    if (cache === void 0) cache = [];
    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') return obj;
    // if obj is hit, it is in circular structure
    var hit = $09b42889ded19e60$var$find(cache, function(c) {
        return c.original === obj;
    });
    if (hit) return hit.copy;
    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy: copy
    });
    Object.keys(obj).forEach(function(key) {
        copy[key] = $09b42889ded19e60$var$deepCopy(obj[key], cache);
    });
    return copy;
}
/**
 * forEach for object
 */ function $09b42889ded19e60$var$forEachValue(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
function $09b42889ded19e60$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $09b42889ded19e60$var$isPromise(val) {
    return val && typeof val.then === 'function';
}
function $09b42889ded19e60$var$assert(condition, msg) {
    if (!condition) throw new Error("[vuex] " + msg);
}
function $09b42889ded19e60$var$partial(fn, arg) {
    return function() {
        return fn(arg);
    };
}
function $09b42889ded19e60$var$genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    return function() {
        var i = subs.indexOf(fn);
        if (i > -1) subs.splice(i, 1);
    };
}
function $09b42889ded19e60$var$resetStore(store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state;
    // init all modules
    $09b42889ded19e60$var$installModule(store, state, [], store._modules.root, true);
    // reset state
    $09b42889ded19e60$var$resetStoreState(store, state, hot);
}
function $09b42889ded19e60$var$resetStoreState(store, state, hot) {
    var oldState = store._state;
    var oldScope = store._scope;
    // bind store public getters
    store.getters = {};
    // reset local getters cache
    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computedObj = {};
    var computedCache = {};
    // create a new effect scope and create computed object inside it to avoid
    // getters (computed) getting destroyed on component unmount.
    var scope = (0, $8bTPG.effectScope)(true);
    scope.run(function() {
        $09b42889ded19e60$var$forEachValue(wrappedGetters, function(fn, key) {
            // use computed to leverage its lazy-caching mechanism
            // direct inline function use will lead to closure preserving oldState.
            // using partial to return function with only arguments preserved in closure environment.
            computedObj[key] = $09b42889ded19e60$var$partial(fn, store);
            computedCache[key] = (0, $8bTPG.computed)(function() {
                return computedObj[key]();
            });
            Object.defineProperty(store.getters, key, {
                get: function() {
                    return computedCache[key].value;
                },
                enumerable: true // for local getters
            });
        });
    });
    store._state = (0, $8bTPG.reactive)({
        data: state
    });
    // register the newly created effect scope to the store so that we can
    // dispose the effects when this method runs again in the future.
    store._scope = scope;
    // enable strict mode for new state
    if (store.strict) $09b42889ded19e60$var$enableStrictMode(store);
    if (oldState) {
        if (hot) // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function() {
            oldState.data = null;
        });
    }
    // dispose previously registered effect scope if there is one.
    if (oldScope) oldScope.stop();
}
function $09b42889ded19e60$var$installModule(store, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store._modules.getNamespace(path);
    // register in namespace map
    if (module.namespaced) {
        if (store._modulesNamespaceMap[namespace] && true) console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
        store._modulesNamespaceMap[namespace] = module;
    }
    // set state
    if (!isRoot && !hot) {
        var parentState = $09b42889ded19e60$var$getNestedState(rootState, path.slice(0, -1));
        var moduleName = path[path.length - 1];
        store._withCommit(function() {
            if (moduleName in parentState) console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
            parentState[moduleName] = module.state;
        });
    }
    var local = module.context = $09b42889ded19e60$var$makeLocalContext(store, namespace, path);
    module.forEachMutation(function(mutation, key) {
        var namespacedType = namespace + key;
        $09b42889ded19e60$var$registerMutation(store, namespacedType, mutation, local);
    });
    module.forEachAction(function(action, key) {
        var type = action.root ? key : namespace + key;
        var handler = action.handler || action;
        $09b42889ded19e60$var$registerAction(store, type, handler, local);
    });
    module.forEachGetter(function(getter, key) {
        var namespacedType = namespace + key;
        $09b42889ded19e60$var$registerGetter(store, namespacedType, getter, local);
    });
    module.forEachChild(function(child, key) {
        $09b42889ded19e60$var$installModule(store, rootState, path.concat(key), child, hot);
    });
}
/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */ function $09b42889ded19e60$var$makeLocalContext(store, namespace, path) {
    var noNamespace = namespace === '';
    var local = {
        dispatch: noNamespace ? store.dispatch : function(_type, _payload, _options) {
            var args = $09b42889ded19e60$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._actions[type]) {
                    console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            return store.dispatch(type, payload);
        },
        commit: noNamespace ? store.commit : function(_type, _payload, _options) {
            var args = $09b42889ded19e60$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._mutations[type]) {
                    console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            store.commit(type, payload, options);
        }
    };
    // getters and state object must be gotten lazily
    // because they will be changed by state update
    Object.defineProperties(local, {
        getters: {
            get: noNamespace ? function() {
                return store.getters;
            } : function() {
                return $09b42889ded19e60$var$makeLocalGetters(store, namespace);
            }
        },
        state: {
            get: function() {
                return $09b42889ded19e60$var$getNestedState(store.state, path);
            }
        }
    });
    return local;
}
function $09b42889ded19e60$var$makeLocalGetters(store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
        var gettersProxy = {};
        var splitPos = namespace.length;
        Object.keys(store.getters).forEach(function(type) {
            // skip if the target getter is not match this namespace
            if (type.slice(0, splitPos) !== namespace) return;
            // extract local getter type
            var localType = type.slice(splitPos);
            // Add a port to the getters proxy.
            // Define as getter property because
            // we do not want to evaluate the getters in this time.
            Object.defineProperty(gettersProxy, localType, {
                get: function() {
                    return store.getters[type];
                },
                enumerable: true
            });
        });
        store._makeLocalGettersCache[namespace] = gettersProxy;
    }
    return store._makeLocalGettersCache[namespace];
}
function $09b42889ded19e60$var$registerMutation(store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
        handler.call(store, local.state, payload);
    });
}
function $09b42889ded19e60$var$registerAction(store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
        var res = handler.call(store, {
            dispatch: local.dispatch,
            commit: local.commit,
            getters: local.getters,
            state: local.state,
            rootGetters: store.getters,
            rootState: store.state
        }, payload);
        if (!$09b42889ded19e60$var$isPromise(res)) res = Promise.resolve(res);
        if (store._devtoolHook) return res.catch(function(err) {
            store._devtoolHook.emit('vuex:error', err);
            throw err;
        });
        else return res;
    });
}
function $09b42889ded19e60$var$registerGetter(store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
        console.error("[vuex] duplicate getter key: " + type);
        return;
    }
    store._wrappedGetters[type] = function wrappedGetter(store) {
        return rawGetter(local.state, local.getters, store.state, store.getters // root getters
        );
    };
}
function $09b42889ded19e60$var$enableStrictMode(store) {
    (0, $8bTPG.watch)(function() {
        return store._state.data;
    }, function() {
        $09b42889ded19e60$var$assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }, {
        deep: true,
        flush: 'sync'
    });
}
function $09b42889ded19e60$var$getNestedState(state, path) {
    return path.reduce(function(state, key) {
        return state[key];
    }, state);
}
function $09b42889ded19e60$var$unifyObjectStyle(type, payload, options) {
    if ($09b42889ded19e60$var$isObject(type) && type.type) {
        options = payload;
        payload = type;
        type = type.type;
    }
    $09b42889ded19e60$var$assert(typeof type === 'string', "expects string as the type, but found " + typeof type + ".");
    return {
        type: type,
        payload: payload,
        options: options
    };
}
var $09b42889ded19e60$var$LABEL_VUEX_BINDINGS = 'vuex bindings';
var $09b42889ded19e60$var$MUTATIONS_LAYER_ID = 'vuex:mutations';
var $09b42889ded19e60$var$ACTIONS_LAYER_ID = 'vuex:actions';
var $09b42889ded19e60$var$INSPECTOR_ID = 'vuex';
var $09b42889ded19e60$var$actionId = 0;
function $09b42889ded19e60$var$addDevtools(app, store) {
    (0, $4GZdJ.setupDevtoolsPlugin)({
        id: 'org.vuejs.vuex',
        app: app,
        label: 'Vuex',
        homepage: 'https://next.vuex.vuejs.org/',
        logo: 'https://vuejs.org/images/icons/favicon-96x96.png',
        packageName: 'vuex',
        componentStateTypes: [
            $09b42889ded19e60$var$LABEL_VUEX_BINDINGS
        ]
    }, function(api) {
        api.addTimelineLayer({
            id: $09b42889ded19e60$var$MUTATIONS_LAYER_ID,
            label: 'Vuex Mutations',
            color: $09b42889ded19e60$var$COLOR_LIME_500
        });
        api.addTimelineLayer({
            id: $09b42889ded19e60$var$ACTIONS_LAYER_ID,
            label: 'Vuex Actions',
            color: $09b42889ded19e60$var$COLOR_LIME_500
        });
        api.addInspector({
            id: $09b42889ded19e60$var$INSPECTOR_ID,
            label: 'Vuex',
            icon: 'storage',
            treeFilterPlaceholder: 'Filter stores...'
        });
        api.on.getInspectorTree(function(payload) {
            if (payload.app === app && payload.inspectorId === $09b42889ded19e60$var$INSPECTOR_ID) {
                if (payload.filter) {
                    var nodes = [];
                    $09b42889ded19e60$var$flattenStoreForInspectorTree(nodes, store._modules.root, payload.filter, '');
                    payload.rootNodes = nodes;
                } else payload.rootNodes = [
                    $09b42889ded19e60$var$formatStoreForInspectorTree(store._modules.root, '')
                ];
            }
        });
        api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $09b42889ded19e60$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                $09b42889ded19e60$var$makeLocalGetters(store, modulePath);
                payload.state = $09b42889ded19e60$var$formatStoreForInspectorState($09b42889ded19e60$var$getStoreModule(store._modules, modulePath), modulePath === 'root' ? store.getters : store._makeLocalGettersCache, modulePath);
            }
        });
        api.on.editInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $09b42889ded19e60$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                var path = payload.path;
                if (modulePath !== 'root') path = modulePath.split('/').filter(Boolean).concat(path);
                store._withCommit(function() {
                    payload.set(store._state.data, path, payload.state.value);
                });
            }
        });
        store.subscribe(function(mutation, state) {
            var data = {};
            if (mutation.payload) data.payload = mutation.payload;
            data.state = state;
            api.notifyComponentUpdate();
            api.sendInspectorTree($09b42889ded19e60$var$INSPECTOR_ID);
            api.sendInspectorState($09b42889ded19e60$var$INSPECTOR_ID);
            api.addTimelineEvent({
                layerId: $09b42889ded19e60$var$MUTATIONS_LAYER_ID,
                event: {
                    time: Date.now(),
                    title: mutation.type,
                    data: data
                }
            });
        });
        store.subscribeAction({
            before: function(action, state) {
                var data = {};
                if (action.payload) data.payload = action.payload;
                action._id = $09b42889ded19e60$var$actionId++;
                action._time = Date.now();
                data.state = state;
                api.addTimelineEvent({
                    layerId: $09b42889ded19e60$var$ACTIONS_LAYER_ID,
                    event: {
                        time: action._time,
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'start',
                        data: data
                    }
                });
            },
            after: function(action, state) {
                var data = {};
                var duration = Date.now() - action._time;
                data.duration = {
                    _custom: {
                        type: 'duration',
                        display: duration + "ms",
                        tooltip: 'Action duration',
                        value: duration
                    }
                };
                if (action.payload) data.payload = action.payload;
                data.state = state;
                api.addTimelineEvent({
                    layerId: $09b42889ded19e60$var$ACTIONS_LAYER_ID,
                    event: {
                        time: Date.now(),
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'end',
                        data: data
                    }
                });
            }
        });
    });
}
// extracted from tailwind palette
var $09b42889ded19e60$var$COLOR_LIME_500 = 0x84cc16;
var $09b42889ded19e60$var$COLOR_DARK = 0x666666;
var $09b42889ded19e60$var$COLOR_WHITE = 0xffffff;
var $09b42889ded19e60$var$TAG_NAMESPACED = {
    label: 'namespaced',
    textColor: $09b42889ded19e60$var$COLOR_WHITE,
    backgroundColor: $09b42889ded19e60$var$COLOR_DARK
};
/**
 * @param {string} path
 */ function $09b42889ded19e60$var$extractNameFromPath(path) {
    return path && path !== 'root' ? path.split('/').slice(-2, -1)[0] : 'Root';
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorNode}
 */ function $09b42889ded19e60$var$formatStoreForInspectorTree(module, path) {
    return {
        id: path || 'root',
        // all modules end with a `/`, we want the last segment only
        // cart/ -> cart
        // nested/cart/ -> cart
        label: $09b42889ded19e60$var$extractNameFromPath(path),
        tags: module.namespaced ? [
            $09b42889ded19e60$var$TAG_NAMESPACED
        ] : [],
        children: Object.keys(module._children).map(function(moduleName) {
            return $09b42889ded19e60$var$formatStoreForInspectorTree(module._children[moduleName], path + moduleName + '/');
        })
    };
}
/**
 * @param {import('@vue/devtools-api').CustomInspectorNode[]} result
 * @param {*} module
 * @param {string} filter
 * @param {string} path
 */ function $09b42889ded19e60$var$flattenStoreForInspectorTree(result, module, filter, path) {
    if (path.includes(filter)) result.push({
        id: path || 'root',
        label: path.endsWith('/') ? path.slice(0, path.length - 1) : path || 'Root',
        tags: module.namespaced ? [
            $09b42889ded19e60$var$TAG_NAMESPACED
        ] : []
    });
    Object.keys(module._children).forEach(function(moduleName) {
        $09b42889ded19e60$var$flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + '/');
    });
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorState}
 */ function $09b42889ded19e60$var$formatStoreForInspectorState(module, getters, path) {
    getters = path === 'root' ? getters : getters[path];
    var gettersKeys = Object.keys(getters);
    var storeState = {
        state: Object.keys(module.state).map(function(key) {
            return {
                key: key,
                editable: true,
                value: module.state[key]
            };
        })
    };
    if (gettersKeys.length) {
        var tree = $09b42889ded19e60$var$transformPathsToObjectTree(getters);
        storeState.getters = Object.keys(tree).map(function(key) {
            return {
                key: key.endsWith('/') ? $09b42889ded19e60$var$extractNameFromPath(key) : key,
                editable: false,
                value: $09b42889ded19e60$var$canThrow(function() {
                    return tree[key];
                })
            };
        });
    }
    return storeState;
}
function $09b42889ded19e60$var$transformPathsToObjectTree(getters) {
    var result = {};
    Object.keys(getters).forEach(function(key) {
        var path = key.split('/');
        if (path.length > 1) {
            var target = result;
            var leafKey = path.pop();
            path.forEach(function(p) {
                if (!target[p]) target[p] = {
                    _custom: {
                        value: {},
                        display: p,
                        tooltip: 'Module',
                        abstract: true
                    }
                };
                target = target[p]._custom.value;
            });
            target[leafKey] = $09b42889ded19e60$var$canThrow(function() {
                return getters[key];
            });
        } else result[key] = $09b42889ded19e60$var$canThrow(function() {
            return getters[key];
        });
    });
    return result;
}
function $09b42889ded19e60$var$getStoreModule(moduleMap, path) {
    var names = path.split('/').filter(function(n) {
        return n;
    });
    return names.reduce(function(module, moduleName, i) {
        var child = module[moduleName];
        if (!child) throw new Error("Missing module \"" + moduleName + "\" for path \"" + path + "\".");
        return i === names.length - 1 ? child : child._children;
    }, path === 'root' ? moduleMap : moduleMap.root._children);
}
function $09b42889ded19e60$var$canThrow(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
// Base data struct for store's module, package with some attribute and method
var $09b42889ded19e60$var$Module = function Module(rawModule, runtime) {
    this.runtime = runtime;
    // Store some children item
    this._children = Object.create(null);
    // Store the origin module object which passed by programmer
    this._rawModule = rawModule;
    var rawState = rawModule.state;
    // Store the origin module's state
    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};
var $09b42889ded19e60$var$prototypeAccessors$1 = {
    namespaced: {
        configurable: true
    }
};
$09b42889ded19e60$var$prototypeAccessors$1.namespaced.get = function() {
    return !!this._rawModule.namespaced;
};
$09b42889ded19e60$var$Module.prototype.addChild = function addChild(key, module) {
    this._children[key] = module;
};
$09b42889ded19e60$var$Module.prototype.removeChild = function removeChild(key) {
    delete this._children[key];
};
$09b42889ded19e60$var$Module.prototype.getChild = function getChild(key) {
    return this._children[key];
};
$09b42889ded19e60$var$Module.prototype.hasChild = function hasChild(key) {
    return key in this._children;
};
$09b42889ded19e60$var$Module.prototype.update = function update(rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;
    if (rawModule.actions) this._rawModule.actions = rawModule.actions;
    if (rawModule.mutations) this._rawModule.mutations = rawModule.mutations;
    if (rawModule.getters) this._rawModule.getters = rawModule.getters;
};
$09b42889ded19e60$var$Module.prototype.forEachChild = function forEachChild(fn) {
    $09b42889ded19e60$var$forEachValue(this._children, fn);
};
$09b42889ded19e60$var$Module.prototype.forEachGetter = function forEachGetter(fn) {
    if (this._rawModule.getters) $09b42889ded19e60$var$forEachValue(this._rawModule.getters, fn);
};
$09b42889ded19e60$var$Module.prototype.forEachAction = function forEachAction(fn) {
    if (this._rawModule.actions) $09b42889ded19e60$var$forEachValue(this._rawModule.actions, fn);
};
$09b42889ded19e60$var$Module.prototype.forEachMutation = function forEachMutation(fn) {
    if (this._rawModule.mutations) $09b42889ded19e60$var$forEachValue(this._rawModule.mutations, fn);
};
Object.defineProperties($09b42889ded19e60$var$Module.prototype, $09b42889ded19e60$var$prototypeAccessors$1);
var $09b42889ded19e60$var$ModuleCollection = function ModuleCollection(rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
};
$09b42889ded19e60$var$ModuleCollection.prototype.get = function get(path) {
    return path.reduce(function(module, key) {
        return module.getChild(key);
    }, this.root);
};
$09b42889ded19e60$var$ModuleCollection.prototype.getNamespace = function getNamespace(path) {
    var module = this.root;
    return path.reduce(function(namespace, key) {
        module = module.getChild(key);
        return namespace + (module.namespaced ? key + '/' : '');
    }, '');
};
$09b42889ded19e60$var$ModuleCollection.prototype.update = function update$1(rawRootModule) {
    $09b42889ded19e60$var$update([], this.root, rawRootModule);
};
$09b42889ded19e60$var$ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
    var this$1$1 = this;
    if (runtime === void 0) runtime = true;
    $09b42889ded19e60$var$assertRawModule(path, rawModule);
    var newModule = new $09b42889ded19e60$var$Module(rawModule, runtime);
    if (path.length === 0) this.root = newModule;
    else {
        var parent = this.get(path.slice(0, -1));
        parent.addChild(path[path.length - 1], newModule);
    }
    // register nested modules
    if (rawModule.modules) $09b42889ded19e60$var$forEachValue(rawModule.modules, function(rawChildModule, key) {
        this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
};
$09b42889ded19e60$var$ModuleCollection.prototype.unregister = function unregister(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);
    if (!child) {
        console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
        return;
    }
    if (!child.runtime) return;
    parent.removeChild(key);
};
$09b42889ded19e60$var$ModuleCollection.prototype.isRegistered = function isRegistered(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    if (parent) return parent.hasChild(key);
    return false;
};
function $09b42889ded19e60$var$update(path, targetModule, newModule) {
    $09b42889ded19e60$var$assertRawModule(path, newModule);
    // update target module
    targetModule.update(newModule);
    // update nested modules
    if (newModule.modules) for(var key in newModule.modules){
        if (!targetModule.getChild(key)) {
            console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
            return;
        }
        $09b42889ded19e60$var$update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
}
var $09b42889ded19e60$var$functionAssert = {
    assert: function(value) {
        return typeof value === 'function';
    },
    expected: 'function'
};
var $09b42889ded19e60$var$objectAssert = {
    assert: function(value) {
        return typeof value === 'function' || typeof value === 'object' && typeof value.handler === 'function';
    },
    expected: 'function or object with "handler" function'
};
var $09b42889ded19e60$var$assertTypes = {
    getters: $09b42889ded19e60$var$functionAssert,
    mutations: $09b42889ded19e60$var$functionAssert,
    actions: $09b42889ded19e60$var$objectAssert
};
function $09b42889ded19e60$var$assertRawModule(path, rawModule) {
    Object.keys($09b42889ded19e60$var$assertTypes).forEach(function(key) {
        if (!rawModule[key]) return;
        var assertOptions = $09b42889ded19e60$var$assertTypes[key];
        $09b42889ded19e60$var$forEachValue(rawModule[key], function(value, type) {
            $09b42889ded19e60$var$assert(assertOptions.assert(value), $09b42889ded19e60$var$makeAssertionMessage(path, key, type, value, assertOptions.expected));
        });
    });
}
function $09b42889ded19e60$var$makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
    if (path.length > 0) buf += " in module \"" + path.join('.') + "\"";
    buf += " is " + JSON.stringify(value) + ".";
    return buf;
}
function $09b42889ded19e60$export$f51a9068ac82ea43(options) {
    return new $09b42889ded19e60$export$390f32400eaf98c9(options);
}
var $09b42889ded19e60$export$390f32400eaf98c9 = function Store(options) {
    var this$1$1 = this;
    if (options === void 0) options = {};
    $09b42889ded19e60$var$assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    $09b42889ded19e60$var$assert(this instanceof Store, "store must be called with the new operator.");
    var plugins = options.plugins;
    if (plugins === void 0) plugins = [];
    var strict = options.strict;
    if (strict === void 0) strict = false;
    var devtools = options.devtools;
    // store internal state
    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new $09b42889ded19e60$var$ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._makeLocalGettersCache = Object.create(null);
    // EffectScope instance. when registering new getters, we wrap them inside
    // EffectScope so that getters (computed) would not be destroyed on
    // component unmount.
    this._scope = null;
    this._devtools = devtools;
    // bind commit and dispatch to self
    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    this.dispatch = function boundDispatch(type, payload) {
        return dispatch.call(store, type, payload);
    };
    this.commit = function boundCommit(type, payload, options) {
        return commit.call(store, type, payload, options);
    };
    // strict mode
    this.strict = strict;
    var state = this._modules.root.state;
    // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters
    $09b42889ded19e60$var$installModule(this, state, [], this._modules.root);
    // initialize the store state, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)
    $09b42889ded19e60$var$resetStoreState(this, state);
    // apply plugins
    plugins.forEach(function(plugin) {
        return plugin(this$1$1);
    });
};
var $09b42889ded19e60$var$prototypeAccessors = {
    state: {
        configurable: true
    }
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.install = function install(app, injectKey) {
    app.provide(injectKey || $09b42889ded19e60$export$67bdc3ac2df6c0d1, this);
    app.config.globalProperties.$store = this;
    var useDevtools = this._devtools !== undefined ? this._devtools : true;
    if (useDevtools) $09b42889ded19e60$var$addDevtools(app, this);
};
$09b42889ded19e60$var$prototypeAccessors.state.get = function() {
    return this._state.data;
};
$09b42889ded19e60$var$prototypeAccessors.state.set = function(v) {
    $09b42889ded19e60$var$assert(false, "use store.replaceState() to explicit replace store state.");
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.commit = function commit(_type, _payload, _options) {
    var this$1$1 = this;
    // check object-style commit
    var ref = $09b42889ded19e60$var$unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;
    var mutation = {
        type: type,
        payload: payload
    };
    var entry = this._mutations[type];
    if (!entry) {
        console.error("[vuex] unknown mutation type: " + type);
        return;
    }
    this._withCommit(function() {
        entry.forEach(function commitIterator(handler) {
            handler(payload);
        });
    });
    this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function(sub) {
        return sub(mutation, this$1$1.state);
    });
    if (options && options.silent) console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.dispatch = function dispatch(_type, _payload) {
    var this$1$1 = this;
    // check object-style dispatch
    var ref = $09b42889ded19e60$var$unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;
    var action = {
        type: type,
        payload: payload
    };
    var entry = this._actions[type];
    if (!entry) {
        console.error("[vuex] unknown action type: " + type);
        return;
    }
    try {
        this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
        .filter(function(sub) {
            return sub.before;
        }).forEach(function(sub) {
            return sub.before(action, this$1$1.state);
        });
    } catch (e) {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
    }
    var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
        return handler(payload);
    })) : entry[0](payload);
    return new Promise(function(resolve, reject) {
        result.then(function(res) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.after;
                }).forEach(function(sub) {
                    return sub.after(action, this$1$1.state);
                });
            } catch (e) {
                console.warn("[vuex] error in after action subscribers: ");
                console.error(e);
            }
            resolve(res);
        }, function(error) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.error;
                }).forEach(function(sub) {
                    return sub.error(action, this$1$1.state, error);
                });
            } catch (e) {
                console.warn("[vuex] error in error action subscribers: ");
                console.error(e);
            }
            reject(error);
        });
    });
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.subscribe = function subscribe(fn, options) {
    return $09b42889ded19e60$var$genericSubscribe(fn, this._subscribers, options);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.subscribeAction = function subscribeAction(fn, options) {
    var subs = typeof fn === 'function' ? {
        before: fn
    } : fn;
    return $09b42889ded19e60$var$genericSubscribe(subs, this._actionSubscribers, options);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.watch = function watch$1(getter, cb, options) {
    var this$1$1 = this;
    $09b42889ded19e60$var$assert(typeof getter === 'function', "store.watch only accepts a function.");
    return (0, $8bTPG.watch)(function() {
        return getter(this$1$1.state, this$1$1.getters);
    }, cb, Object.assign({}, options));
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.replaceState = function replaceState(state) {
    var this$1$1 = this;
    this._withCommit(function() {
        this$1$1._state.data = state;
    });
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.registerModule = function registerModule(path, rawModule, options) {
    if (options === void 0) options = {};
    if (typeof path === 'string') path = [
        path
    ];
    $09b42889ded19e60$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    $09b42889ded19e60$var$assert(path.length > 0, 'cannot register the root module by using registerModule.');
    this._modules.register(path, rawModule);
    $09b42889ded19e60$var$installModule(this, this.state, path, this._modules.get(path), options.preserveState);
    // reset store to update getters...
    $09b42889ded19e60$var$resetStoreState(this, this.state);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.unregisterModule = function unregisterModule(path) {
    var this$1$1 = this;
    if (typeof path === 'string') path = [
        path
    ];
    $09b42889ded19e60$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    this._modules.unregister(path);
    this._withCommit(function() {
        var parentState = $09b42889ded19e60$var$getNestedState(this$1$1.state, path.slice(0, -1));
        delete parentState[path[path.length - 1]];
    });
    $09b42889ded19e60$var$resetStore(this);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.hasModule = function hasModule(path) {
    if (typeof path === 'string') path = [
        path
    ];
    $09b42889ded19e60$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    return this._modules.isRegistered(path);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype.hotUpdate = function hotUpdate(newOptions) {
    this._modules.update(newOptions);
    $09b42889ded19e60$var$resetStore(this, true);
};
$09b42889ded19e60$export$390f32400eaf98c9.prototype._withCommit = function _withCommit(fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
};
Object.defineProperties($09b42889ded19e60$export$390f32400eaf98c9.prototype, $09b42889ded19e60$var$prototypeAccessors);
/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */ var $09b42889ded19e60$export$a337c713bdba072 = $09b42889ded19e60$var$normalizeNamespace(function(namespace, states) {
    var res = {};
    if (!$09b42889ded19e60$var$isValidMap(states)) console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    $09b42889ded19e60$var$normalizeMap(states).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedState() {
            var state = this.$store.state;
            var getters = this.$store.getters;
            if (namespace) {
                var module = $09b42889ded19e60$var$getModuleByNamespace(this.$store, 'mapState', namespace);
                if (!module) return;
                state = module.context.state;
                getters = module.context.getters;
            }
            return typeof val === 'function' ? val.call(this, state, getters) : state[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $09b42889ded19e60$export$6763e3aa6121e797 = $09b42889ded19e60$var$normalizeNamespace(function(namespace, mutations) {
    var res = {};
    if (!$09b42889ded19e60$var$isValidMap(mutations)) console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    $09b42889ded19e60$var$normalizeMap(mutations).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedMutation() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // Get the commit method from store
            var commit = this.$store.commit;
            if (namespace) {
                var module = $09b42889ded19e60$var$getModuleByNamespace(this.$store, 'mapMutations', namespace);
                if (!module) return;
                commit = module.context.commit;
            }
            return typeof val === 'function' ? val.apply(this, [
                commit
            ].concat(args)) : commit.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */ var $09b42889ded19e60$export$74d9085e6d5a97cb = $09b42889ded19e60$var$normalizeNamespace(function(namespace, getters) {
    var res = {};
    if (!$09b42889ded19e60$var$isValidMap(getters)) console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    $09b42889ded19e60$var$normalizeMap(getters).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        // The namespace has been mutated by normalizeNamespace
        val = namespace + val;
        res[key] = function mappedGetter() {
            if (namespace && !$09b42889ded19e60$var$getModuleByNamespace(this.$store, 'mapGetters', namespace)) return;
            if (!(val in this.$store.getters)) {
                console.error("[vuex] unknown getter: " + val);
                return;
            }
            return this.$store.getters[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $09b42889ded19e60$export$1d73b9b98821f6dc = $09b42889ded19e60$var$normalizeNamespace(function(namespace, actions) {
    var res = {};
    if (!$09b42889ded19e60$var$isValidMap(actions)) console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    $09b42889ded19e60$var$normalizeMap(actions).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedAction() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // get dispatch function from store
            var dispatch = this.$store.dispatch;
            if (namespace) {
                var module = $09b42889ded19e60$var$getModuleByNamespace(this.$store, 'mapActions', namespace);
                if (!module) return;
                dispatch = module.context.dispatch;
            }
            return typeof val === 'function' ? val.apply(this, [
                dispatch
            ].concat(args)) : dispatch.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */ var $09b42889ded19e60$export$22ea1818d73549dc = function(namespace) {
    return {
        mapState: $09b42889ded19e60$export$a337c713bdba072.bind(null, namespace),
        mapGetters: $09b42889ded19e60$export$74d9085e6d5a97cb.bind(null, namespace),
        mapMutations: $09b42889ded19e60$export$6763e3aa6121e797.bind(null, namespace),
        mapActions: $09b42889ded19e60$export$1d73b9b98821f6dc.bind(null, namespace)
    };
};
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */ function $09b42889ded19e60$var$normalizeMap(map) {
    if (!$09b42889ded19e60$var$isValidMap(map)) return [];
    return Array.isArray(map) ? map.map(function(key) {
        return {
            key: key,
            val: key
        };
    }) : Object.keys(map).map(function(key) {
        return {
            key: key,
            val: map[key]
        };
    });
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */ function $09b42889ded19e60$var$isValidMap(map) {
    return Array.isArray(map) || $09b42889ded19e60$var$isObject(map);
}
/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */ function $09b42889ded19e60$var$normalizeNamespace(fn) {
    return function(namespace, map) {
        if (typeof namespace !== 'string') {
            map = namespace;
            namespace = '';
        } else if (namespace.charAt(namespace.length - 1) !== '/') namespace += '/';
        return fn(namespace, map);
    };
}
/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */ function $09b42889ded19e60$var$getModuleByNamespace(store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];
    if (!module) console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    return module;
}
// Credits: borrowed code from fcomb/redux-logger
function $09b42889ded19e60$export$fe2e61603b61130d(ref) {
    if (ref === void 0) ref = {};
    var collapsed = ref.collapsed;
    if (collapsed === void 0) collapsed = true;
    var filter = ref.filter;
    if (filter === void 0) filter = function(mutation, stateBefore, stateAfter) {
        return true;
    };
    var transformer = ref.transformer;
    if (transformer === void 0) transformer = function(state) {
        return state;
    };
    var mutationTransformer = ref.mutationTransformer;
    if (mutationTransformer === void 0) mutationTransformer = function(mut) {
        return mut;
    };
    var actionFilter = ref.actionFilter;
    if (actionFilter === void 0) actionFilter = function(action, state) {
        return true;
    };
    var actionTransformer = ref.actionTransformer;
    if (actionTransformer === void 0) actionTransformer = function(act) {
        return act;
    };
    var logMutations = ref.logMutations;
    if (logMutations === void 0) logMutations = true;
    var logActions = ref.logActions;
    if (logActions === void 0) logActions = true;
    var logger = ref.logger;
    if (logger === void 0) logger = console;
    return function(store) {
        var prevState = $09b42889ded19e60$var$deepCopy(store.state);
        if (typeof logger === 'undefined') return;
        if (logMutations) store.subscribe(function(mutation, state) {
            var nextState = $09b42889ded19e60$var$deepCopy(state);
            if (filter(mutation, prevState, nextState)) {
                var formattedTime = $09b42889ded19e60$var$getFormattedTime();
                var formattedMutation = mutationTransformer(mutation);
                var message = "mutation " + mutation.type + formattedTime;
                $09b42889ded19e60$var$startMessage(logger, message, collapsed);
                logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
                logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
                logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
                $09b42889ded19e60$var$endMessage(logger);
            }
            prevState = nextState;
        });
        if (logActions) store.subscribeAction(function(action, state) {
            if (actionFilter(action, state)) {
                var formattedTime = $09b42889ded19e60$var$getFormattedTime();
                var formattedAction = actionTransformer(action);
                var message = "action " + action.type + formattedTime;
                $09b42889ded19e60$var$startMessage(logger, message, collapsed);
                logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
                $09b42889ded19e60$var$endMessage(logger);
            }
        });
    };
}
function $09b42889ded19e60$var$startMessage(logger, message, collapsed) {
    var startMessage = collapsed ? logger.groupCollapsed : logger.group;
    // render
    try {
        startMessage.call(logger, message);
    } catch (e) {
        logger.log(message);
    }
}
function $09b42889ded19e60$var$endMessage(logger) {
    try {
        logger.groupEnd();
    } catch (e) {
        logger.log("\u2014\u2014 log end \u2014\u2014");
    }
}
function $09b42889ded19e60$var$getFormattedTime() {
    var time = new Date();
    return " @ " + $09b42889ded19e60$var$pad(time.getHours(), 2) + ":" + $09b42889ded19e60$var$pad(time.getMinutes(), 2) + ":" + $09b42889ded19e60$var$pad(time.getSeconds(), 2) + "." + $09b42889ded19e60$var$pad(time.getMilliseconds(), 3);
}
function $09b42889ded19e60$var$repeat(str, times) {
    return new Array(times + 1).join(str);
}
function $09b42889ded19e60$var$pad(num, maxLength) {
    return $09b42889ded19e60$var$repeat('0', maxLength - num.toString().length) + num;
}
var $09b42889ded19e60$var$index = {
    version: '4.1.0',
    Store: $09b42889ded19e60$export$390f32400eaf98c9,
    storeKey: $09b42889ded19e60$export$67bdc3ac2df6c0d1,
    createStore: $09b42889ded19e60$export$f51a9068ac82ea43,
    useStore: $09b42889ded19e60$export$6ccbb43953eebf8,
    mapState: $09b42889ded19e60$export$a337c713bdba072,
    mapMutations: $09b42889ded19e60$export$6763e3aa6121e797,
    mapGetters: $09b42889ded19e60$export$74d9085e6d5a97cb,
    mapActions: $09b42889ded19e60$export$1d73b9b98821f6dc,
    createNamespacedHelpers: $09b42889ded19e60$export$22ea1818d73549dc,
    createLogger: $09b42889ded19e60$export$fe2e61603b61130d
};
var $09b42889ded19e60$export$2e2bcd8739ae039 = $09b42889ded19e60$var$index;

});
parcelRegister("ey4ci", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("ani5R")).createSlots);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("ani5R")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("X5A94")).normalizeStyle);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("ani5R")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("ani5R")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("ani5R")).Text);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("dDLnc")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("dDLnc")).Transition);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("dDLnc")).vModelCheckbox);
$parcel$export(module.exports, "vModelRadio", () => (parcelRequire("dDLnc")).vModelRadio);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("dDLnc")).vModelSelect);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("dDLnc")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("dDLnc")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("dDLnc")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("dDLnc")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("X5A94")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");parcelRequire("dDLnc");parcelRequire("8bTPG");parcelRequire("X5A94");
function $a9777f2bcb9d7de1$var$initDev() {
    (0, $ani5R.initCustomFormatter)();
}
const $a9777f2bcb9d7de1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("ani5R", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $78da16583ad93b9f$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $78da16583ad93b9f$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $78da16583ad93b9f$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $78da16583ad93b9f$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $78da16583ad93b9f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Static", () => $78da16583ad93b9f$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $78da16583ad93b9f$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $78da16583ad93b9f$export$49729353e7c1e6c5);
$parcel$export(module.exports, "Teleport", () => $78da16583ad93b9f$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $78da16583ad93b9f$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $78da16583ad93b9f$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $78da16583ad93b9f$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $78da16583ad93b9f$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $78da16583ad93b9f$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $78da16583ad93b9f$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $78da16583ad93b9f$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $78da16583ad93b9f$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $78da16583ad93b9f$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $78da16583ad93b9f$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $78da16583ad93b9f$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $78da16583ad93b9f$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $78da16583ad93b9f$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $78da16583ad93b9f$export$5876c47052fb88b1);
$parcel$export(module.exports, "onUnmounted", () => $78da16583ad93b9f$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $78da16583ad93b9f$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $78da16583ad93b9f$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $78da16583ad93b9f$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $78da16583ad93b9f$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $78da16583ad93b9f$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $78da16583ad93b9f$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $78da16583ad93b9f$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $78da16583ad93b9f$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $78da16583ad93b9f$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $78da16583ad93b9f$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $78da16583ad93b9f$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $78da16583ad93b9f$export$a976684a0efeb93f);
$parcel$export(module.exports, "createRenderer", () => $78da16583ad93b9f$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $78da16583ad93b9f$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $78da16583ad93b9f$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $78da16583ad93b9f$export$42098e0eaa15c48e);
$parcel$export(module.exports, "guardReactiveProps", () => $78da16583ad93b9f$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $78da16583ad93b9f$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createCommentVNode", () => $78da16583ad93b9f$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $78da16583ad93b9f$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $78da16583ad93b9f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $78da16583ad93b9f$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $78da16583ad93b9f$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("X5A94")).normalizeStyle);
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8bTPG = parcelRequire("8bTPG");

var $X5A94 = parcelRequire("X5A94");
const $78da16583ad93b9f$var$stack = [];
function $78da16583ad93b9f$var$pushWarningContext(vnode) {
    $78da16583ad93b9f$var$stack.push(vnode);
}
function $78da16583ad93b9f$var$popWarningContext() {
    $78da16583ad93b9f$var$stack.pop();
}
let $78da16583ad93b9f$var$isWarning = false;
function $78da16583ad93b9f$var$warn$1(msg, ...args) {
    if ($78da16583ad93b9f$var$isWarning) return;
    $78da16583ad93b9f$var$isWarning = true;
    (0, $8bTPG.pauseTracking)();
    const instance = $78da16583ad93b9f$var$stack.length ? $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $78da16583ad93b9f$var$getComponentTrace();
    if (appWarnHandler) $78da16583ad93b9f$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$78da16583ad93b9f$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$78da16583ad93b9f$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $8bTPG.resetTracking)();
    $78da16583ad93b9f$var$isWarning = false;
}
function $78da16583ad93b9f$var$getComponentTrace() {
    let currentVNode = $78da16583ad93b9f$var$stack[$78da16583ad93b9f$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $78da16583ad93b9f$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$78da16583ad93b9f$var$formatTraceEntry(entry));
    });
    return logs;
}
function $78da16583ad93b9f$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$78da16583ad93b9f$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$78da16583ad93b9f$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $78da16583ad93b9f$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$78da16583ad93b9f$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $78da16583ad93b9f$var$formatProp(key, value, raw) {
    if ((0, $X5A94.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $8bTPG.isRef)(value)) {
        value = $78da16583ad93b9f$var$formatProp(key, (0, $8bTPG.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $X5A94.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $8bTPG.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $78da16583ad93b9f$export$dfbcecb440255e4a(val, type) {
    return;
}
const $78da16583ad93b9f$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $78da16583ad93b9f$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $X5A94.isFunction)(fn)) {
        const res = $78da16583ad93b9f$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $X5A94.isPromise)(res)) res.catch((err)=>{
            $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $X5A94.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($78da16583ad93b9f$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $X5A94.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $8bTPG.resetTracking)();
            return;
        }
    }
    $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $78da16583ad93b9f$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $78da16583ad93b9f$var$queue = [];
let $78da16583ad93b9f$var$flushIndex = -1;
const $78da16583ad93b9f$var$pendingPostFlushCbs = [];
let $78da16583ad93b9f$var$activePostFlushCbs = null;
let $78da16583ad93b9f$var$postFlushIndex = 0;
const $78da16583ad93b9f$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $78da16583ad93b9f$var$currentFlushPromise = null;
const $78da16583ad93b9f$var$RECURSION_LIMIT = 100;
function $78da16583ad93b9f$export$bdd553fddd433dcb(fn) {
    const p = $78da16583ad93b9f$var$currentFlushPromise || $78da16583ad93b9f$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $78da16583ad93b9f$var$findInsertionIndex(id) {
    let start = $78da16583ad93b9f$var$flushIndex + 1;
    let end = $78da16583ad93b9f$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $78da16583ad93b9f$var$queue[middle];
        const middleJobId = $78da16583ad93b9f$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $78da16583ad93b9f$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $78da16583ad93b9f$var$getId(job);
        const lastJob = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $78da16583ad93b9f$var$getId(lastJob)) $78da16583ad93b9f$var$queue.push(job);
        else $78da16583ad93b9f$var$queue.splice($78da16583ad93b9f$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $78da16583ad93b9f$var$queueFlush();
    }
}
function $78da16583ad93b9f$var$queueFlush() {
    if (!$78da16583ad93b9f$var$currentFlushPromise) $78da16583ad93b9f$var$currentFlushPromise = $78da16583ad93b9f$var$resolvedPromise.then($78da16583ad93b9f$var$flushJobs);
}
function $78da16583ad93b9f$export$59536a0199721cab(cb) {
    if (!(0, $X5A94.isArray)(cb)) {
        if ($78da16583ad93b9f$var$activePostFlushCbs && cb.id === -1) $78da16583ad93b9f$var$activePostFlushCbs.splice($78da16583ad93b9f$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $78da16583ad93b9f$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $78da16583ad93b9f$var$pendingPostFlushCbs.push(...cb);
    $78da16583ad93b9f$var$queueFlush();
}
function $78da16583ad93b9f$var$flushPreFlushCbs(instance, seen, i = $78da16583ad93b9f$var$flushIndex + 1) {
    for(; i < $78da16583ad93b9f$var$queue.length; i++){
        const cb = $78da16583ad93b9f$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $78da16583ad93b9f$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $78da16583ad93b9f$var$flushPostFlushCbs(seen) {
    if ($78da16583ad93b9f$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($78da16583ad93b9f$var$pendingPostFlushCbs)
        ].sort((a, b)=>$78da16583ad93b9f$var$getId(a) - $78da16583ad93b9f$var$getId(b));
        $78da16583ad93b9f$var$pendingPostFlushCbs.length = 0;
        if ($78da16583ad93b9f$var$activePostFlushCbs) {
            $78da16583ad93b9f$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = deduped;
        for($78da16583ad93b9f$var$postFlushIndex = 0; $78da16583ad93b9f$var$postFlushIndex < $78da16583ad93b9f$var$activePostFlushCbs.length; $78da16583ad93b9f$var$postFlushIndex++){
            const cb = $78da16583ad93b9f$var$activePostFlushCbs[$78da16583ad93b9f$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $78da16583ad93b9f$var$activePostFlushCbs = null;
        $78da16583ad93b9f$var$postFlushIndex = 0;
    }
}
const $78da16583ad93b9f$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $78da16583ad93b9f$var$flushJobs(seen) {
    const check = (0, $X5A94.NOOP);
    try {
        for($78da16583ad93b9f$var$flushIndex = 0; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $78da16583ad93b9f$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $78da16583ad93b9f$var$flushIndex < $78da16583ad93b9f$var$queue.length; $78da16583ad93b9f$var$flushIndex++){
            const job = $78da16583ad93b9f$var$queue[$78da16583ad93b9f$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $78da16583ad93b9f$var$flushIndex = -1;
        $78da16583ad93b9f$var$queue.length = 0;
        $78da16583ad93b9f$var$flushPostFlushCbs(seen);
        $78da16583ad93b9f$var$currentFlushPromise = null;
        if ($78da16583ad93b9f$var$queue.length || $78da16583ad93b9f$var$pendingPostFlushCbs.length) $78da16583ad93b9f$var$flushJobs(seen);
    }
}
function $78da16583ad93b9f$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $78da16583ad93b9f$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $78da16583ad93b9f$var$getComponentName(instance.type);
        $78da16583ad93b9f$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $78da16583ad93b9f$var$isHmrUpdating = false;
const $78da16583ad93b9f$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $78da16583ad93b9f$var$map = /* @__PURE__ */ new Map();
function $78da16583ad93b9f$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $78da16583ad93b9f$var$map.get(id);
    if (!record) {
        $78da16583ad93b9f$var$createRecord(id, instance.type);
        record = $78da16583ad93b9f$var$map.get(id);
    }
    record.instances.add(instance);
}
function $78da16583ad93b9f$var$unregisterHMR(instance) {
    $78da16583ad93b9f$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $78da16583ad93b9f$var$createRecord(id, initialDef) {
    if ($78da16583ad93b9f$var$map.has(id)) return false;
    $78da16583ad93b9f$var$map.set(id, {
        initialDef: $78da16583ad93b9f$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $78da16583ad93b9f$var$normalizeClassComponent(component) {
    return $78da16583ad93b9f$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $78da16583ad93b9f$var$rerender(id, newRender) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $78da16583ad93b9f$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $78da16583ad93b9f$var$isHmrUpdating = true;
        instance.update();
        $78da16583ad93b9f$var$isHmrUpdating = false;
    });
}
function $78da16583ad93b9f$var$reload(id, newComp) {
    const record = $78da16583ad93b9f$var$map.get(id);
    if (!record) return;
    newComp = $78da16583ad93b9f$var$normalizeClassComponent(newComp);
    $78da16583ad93b9f$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $78da16583ad93b9f$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $78da16583ad93b9f$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp);
            $78da16583ad93b9f$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $78da16583ad93b9f$var$queueJob(()=>{
            $78da16583ad93b9f$var$isHmrUpdating = true;
            instance.parent.update();
            $78da16583ad93b9f$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $78da16583ad93b9f$export$59536a0199721cab(()=>{
        $78da16583ad93b9f$var$hmrDirtyComponents.clear();
    });
}
function $78da16583ad93b9f$var$updateComponentDef(oldComp, newComp) {
    (0, $X5A94.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $78da16583ad93b9f$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $78da16583ad93b9f$var$devtools$1;
let $78da16583ad93b9f$var$buffer = [];
let $78da16583ad93b9f$var$devtoolsNotInstalled = false;
function $78da16583ad93b9f$var$emit$1(event, ...args) {
    if ($78da16583ad93b9f$var$devtools$1) $78da16583ad93b9f$var$devtools$1.emit(event, ...args);
    else if (!$78da16583ad93b9f$var$devtoolsNotInstalled) $78da16583ad93b9f$var$buffer.push({
        event: event,
        args: args
    });
}
function $78da16583ad93b9f$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $78da16583ad93b9f$var$devtools$1 = hook;
    if ($78da16583ad93b9f$var$devtools$1) {
        $78da16583ad93b9f$var$devtools$1.enabled = true;
        $78da16583ad93b9f$var$buffer.forEach(({ event: event, args: args })=>$78da16583ad93b9f$var$devtools$1.emit(event, ...args));
        $78da16583ad93b9f$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $78da16583ad93b9f$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$78da16583ad93b9f$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $78da16583ad93b9f$var$devtoolsNotInstalled = true;
                $78da16583ad93b9f$var$buffer = [];
            }
        }, 3e3);
    } else {
        $78da16583ad93b9f$var$devtoolsNotInstalled = true;
        $78da16583ad93b9f$var$buffer = [];
    }
}
function $78da16583ad93b9f$var$devtoolsInitApp(app, version) {
    $78da16583ad93b9f$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $78da16583ad93b9f$export$ffb0004e005737fa,
        Text: $78da16583ad93b9f$export$5f1af8db9871e1d6,
        Comment: $78da16583ad93b9f$export$4d299b491347818a,
        Static: $78da16583ad93b9f$export$c1b9a1d3af45b7b6
    });
}
function $78da16583ad93b9f$var$devtoolsUnmountApp(app) {
    $78da16583ad93b9f$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $78da16583ad93b9f$var$devtoolsComponentAdded = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $78da16583ad93b9f$var$devtoolsComponentUpdated = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $78da16583ad93b9f$var$_devtoolsComponentRemoved = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $78da16583ad93b9f$var$devtoolsComponentRemoved = (component)=>{
    if ($78da16583ad93b9f$var$devtools$1 && typeof $78da16583ad93b9f$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$78da16583ad93b9f$var$devtools$1.cleanupBuffer(component)) $78da16583ad93b9f$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $78da16583ad93b9f$var$devtoolsPerfStart = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $78da16583ad93b9f$var$devtoolsPerfEnd = /* @__PURE__ */ $78da16583ad93b9f$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $78da16583ad93b9f$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $78da16583ad93b9f$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $78da16583ad93b9f$var$devtoolsComponentEmit(component, event, params) {
    $78da16583ad93b9f$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $78da16583ad93b9f$var$currentRenderingInstance = null;
let $78da16583ad93b9f$var$currentScopeId = null;
function $78da16583ad93b9f$var$setCurrentRenderingInstance(instance) {
    const prev = $78da16583ad93b9f$var$currentRenderingInstance;
    $78da16583ad93b9f$var$currentRenderingInstance = instance;
    $78da16583ad93b9f$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $78da16583ad93b9f$export$ac020265ca2cc4cd(id) {
    $78da16583ad93b9f$var$currentScopeId = id;
}
function $78da16583ad93b9f$export$f2dc6805dc11834e() {
    $78da16583ad93b9f$var$currentScopeId = null;
}
const $78da16583ad93b9f$export$15ba313e13f3dd04 = (_id)=>$78da16583ad93b9f$export$694b237e827a3d23;
function $78da16583ad93b9f$export$694b237e827a3d23(fn, ctx = $78da16583ad93b9f$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(-1);
        const prevInstance = $78da16583ad93b9f$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $78da16583ad93b9f$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $78da16583ad93b9f$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $78da16583ad93b9f$var$validateDirectiveName(name) {
    if ((0, $X5A94.isBuiltInDirective)(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $78da16583ad93b9f$export$49729353e7c1e6c5(vnode, directives) {
    if ($78da16583ad93b9f$var$currentRenderingInstance === null) return vnode;
    const instance = $78da16583ad93b9f$var$getComponentPublicInstance($78da16583ad93b9f$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $X5A94.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $X5A94.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $8bTPG.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $78da16583ad93b9f$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $8bTPG.pauseTracking)();
            $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $8bTPG.resetTracking)();
        }
    }
}
const $78da16583ad93b9f$var$TeleportEndKey = Symbol("_vte");
const $78da16583ad93b9f$var$isTeleport = (type)=>type.__isTeleport;
const $78da16583ad93b9f$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $78da16583ad93b9f$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $78da16583ad93b9f$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $78da16583ad93b9f$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $78da16583ad93b9f$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $X5A94.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $78da16583ad93b9f$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $78da16583ad93b9f$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $78da16583ad93b9f$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $78da16583ad93b9f$var$updateCssVars(n2, true);
            }
            if ($78da16583ad93b9f$var$isTeleportDeferred(n2.props)) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if ($78da16583ad93b9f$var$isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                    $78da16583ad93b9f$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $78da16583ad93b9f$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $78da16583ad93b9f$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $78da16583ad93b9f$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $78da16583ad93b9f$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $78da16583ad93b9f$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $78da16583ad93b9f$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $78da16583ad93b9f$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$78da16583ad93b9f$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $78da16583ad93b9f$var$moveTeleport,
    hydrate: $78da16583ad93b9f$var$hydrateTeleport
};
function $78da16583ad93b9f$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $78da16583ad93b9f$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $78da16583ad93b9f$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $78da16583ad93b9f$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $78da16583ad93b9f$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $78da16583ad93b9f$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $78da16583ad93b9f$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $78da16583ad93b9f$export$76d55a0304a371f4 = $78da16583ad93b9f$var$TeleportImpl;
function $78da16583ad93b9f$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $78da16583ad93b9f$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$78da16583ad93b9f$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $78da16583ad93b9f$var$leaveCbKey = Symbol("_leaveCb");
const $78da16583ad93b9f$var$enterCbKey = Symbol("_enterCb");
function $78da16583ad93b9f$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $78da16583ad93b9f$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $78da16583ad93b9f$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $78da16583ad93b9f$var$TransitionHookValidator = [
    Function,
    Array
];
const $78da16583ad93b9f$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterEnter: $78da16583ad93b9f$var$TransitionHookValidator,
    onEnterCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterLeave: $78da16583ad93b9f$var$TransitionHookValidator,
    onLeaveCancelled: $78da16583ad93b9f$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAfterAppear: $78da16583ad93b9f$var$TransitionHookValidator,
    onAppearCancelled: $78da16583ad93b9f$var$TransitionHookValidator
};
const $78da16583ad93b9f$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $78da16583ad93b9f$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $78da16583ad93b9f$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $78da16583ad93b9f$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const state = $78da16583ad93b9f$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $78da16583ad93b9f$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $78da16583ad93b9f$var$findNonCommentChild(children);
            const rawProps = (0, $8bTPG.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            const innerChild = $78da16583ad93b9f$var$getInnerChild$1(child);
            if (!innerChild) return $78da16583ad93b9f$var$emptyPlaceholder(child);
            let enterHooks = $78da16583ad93b9f$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) $78da16583ad93b9f$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $78da16583ad93b9f$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $78da16583ad93b9f$export$4d299b491347818a && !$78da16583ad93b9f$var$isSameVNodeType(innerChild, oldInnerChild) && $78da16583ad93b9f$var$recursiveGetSubtree(instance).type !== $78da16583ad93b9f$export$4d299b491347818a) {
                let leavingHooks = $78da16583ad93b9f$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $78da16583ad93b9f$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $78da16583ad93b9f$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $78da16583ad93b9f$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$78da16583ad93b9f$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $78da16583ad93b9f$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $78da16583ad93b9f$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $78da16583ad93b9f$export$abd95b5f5e8a8837 = $78da16583ad93b9f$var$BaseTransitionImpl;
function $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $78da16583ad93b9f$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $78da16583ad93b9f$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $X5A94.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$78da16583ad93b9f$var$leaveCbKey]) el[$78da16583ad93b9f$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $78da16583ad93b9f$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]) leavingVNode.el[$78da16583ad93b9f$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$78da16583ad93b9f$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$78da16583ad93b9f$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$78da16583ad93b9f$var$enterCbKey]) el[$78da16583ad93b9f$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$78da16583ad93b9f$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$78da16583ad93b9f$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $78da16583ad93b9f$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $78da16583ad93b9f$var$emptyPlaceholder(vnode) {
    if ($78da16583ad93b9f$var$isKeepAlive(vnode)) {
        vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $78da16583ad93b9f$var$getInnerChild$1(vnode) {
    if (!$78da16583ad93b9f$var$isKeepAlive(vnode)) {
        if ($78da16583ad93b9f$var$isTeleport(vnode.type) && vnode.children) return $78da16583ad93b9f$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $X5A94.isFunction)(children.default)) return children.default();
    }
}
function $78da16583ad93b9f$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $78da16583ad93b9f$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $78da16583ad93b9f$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($78da16583ad93b9f$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $78da16583ad93b9f$export$4d299b491347818a) ret.push(key != null ? $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $X5A94.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $X5A94.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $78da16583ad93b9f$export$f680877a34711e37() {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $78da16583ad93b9f$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $78da16583ad93b9f$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $78da16583ad93b9f$export$83a5dbc1f35517ca(key) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    const r = (0, $8bTPG.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $X5A94.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $X5A94.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$78da16583ad93b9f$var$setRef(r, oldRawRef && ((0, $X5A94.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $78da16583ad93b9f$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $78da16583ad93b9f$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $X5A94.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $8bTPG.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $X5A94.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $X5A94.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $X5A94.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $8bTPG.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $X5A94.isFunction)(ref)) $78da16583ad93b9f$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $X5A94.isString)(ref);
        const _isRef = (0, $8bTPG.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $X5A94.isArray)(existing) && (0, $X5A94.remove)(existing, refValue);
                    else {
                        if (!(0, $X5A94.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $78da16583ad93b9f$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $78da16583ad93b9f$var$hasLoggedMismatchError = false;
const $78da16583ad93b9f$var$logMismatchError = ()=>{
    if ($78da16583ad93b9f$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $78da16583ad93b9f$var$hasLoggedMismatchError = true;
};
const $78da16583ad93b9f$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $78da16583ad93b9f$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $78da16583ad93b9f$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($78da16583ad93b9f$var$isSVGContainer(container)) return "svg";
    if ($78da16583ad93b9f$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $78da16583ad93b9f$var$isComment = (node)=>node.nodeType === 8;
function $78da16583ad93b9f$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $78da16583ad93b9f$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $78da16583ad93b9f$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $78da16583ad93b9f$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $X5A94.def)(node, "__vnode", vnode, true);
            (0, $X5A94.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $78da16583ad93b9f$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($78da16583ad93b9f$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), optimized);
                    if ($78da16583ad93b9f$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $78da16583ad93b9f$export$22f9b5ffd89dac9("") : $78da16583ad93b9f$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $78da16583ad93b9f$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$78da16583ad93b9f$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $78da16583ad93b9f$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$78da16583ad93b9f$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $78da16583ad93b9f$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $78da16583ad93b9f$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $78da16583ad93b9f$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $X5A94.isOn)(key) && !(0, $X5A94.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $8bTPG.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $78da16583ad93b9f$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $78da16583ad93b9f$var$normalizeVNode(children[i]);
            const isText = vnode.type === $78da16583ad93b9f$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $78da16583ad93b9f$var$normalizeVNode(children[i + 1]).type === $78da16583ad93b9f$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$78da16583ad93b9f$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $78da16583ad93b9f$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $78da16583ad93b9f$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $78da16583ad93b9f$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $78da16583ad93b9f$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$78da16583ad93b9f$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $78da16583ad93b9f$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $78da16583ad93b9f$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $78da16583ad93b9f$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $78da16583ad93b9f$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $78da16583ad93b9f$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $78da16583ad93b9f$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $X5A94.normalizeClass)(clientValue);
        if (!$78da16583ad93b9f$var$isSetEqual($78da16583ad93b9f$var$toClassSet(actual || ""), $78da16583ad93b9f$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $X5A94.isString)(clientValue) ? clientValue : (0, $X5A94.stringifyStyle)((0, $X5A94.normalizeStyle)(clientValue));
        const actualMap = $78da16583ad93b9f$var$toStyleMap(actual);
        const expectedMap = $78da16583ad93b9f$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $78da16583ad93b9f$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$78da16583ad93b9f$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $X5A94.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $X5A94.isBooleanAttr)(key) || (0, $X5A94.isKnownHtmlAttr)(key))) {
        if ((0, $X5A94.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $X5A94.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $X5A94.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$78da16583ad93b9f$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$78da16583ad93b9f$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $78da16583ad93b9f$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $78da16583ad93b9f$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $78da16583ad93b9f$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $78da16583ad93b9f$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $78da16583ad93b9f$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $78da16583ad93b9f$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $78da16583ad93b9f$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $X5A94.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $78da16583ad93b9f$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $78da16583ad93b9f$var$allowMismatchAttr = "data-allow-mismatch";
const $78da16583ad93b9f$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $78da16583ad93b9f$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($78da16583ad93b9f$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($78da16583ad93b9f$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($78da16583ad93b9f$var$MismatchTypeString[allowedType]);
    }
}
const $78da16583ad93b9f$var$requestIdleCallback = (0, $X5A94.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $78da16583ad93b9f$var$cancelIdleCallback = (0, $X5A94.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $78da16583ad93b9f$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $78da16583ad93b9f$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$78da16583ad93b9f$var$cancelIdleCallback(id);
    };
function $78da16583ad93b9f$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $78da16583ad93b9f$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($78da16583ad93b9f$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $78da16583ad93b9f$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $78da16583ad93b9f$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $X5A94.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $78da16583ad93b9f$var$forEachElement(node, cb) {
    if ($78da16583ad93b9f$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($78da16583ad93b9f$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $78da16583ad93b9f$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $78da16583ad93b9f$export$d75d499b4c16cf21(source) {
    if ((0, $X5A94.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $78da16583ad93b9f$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$78da16583ad93b9f$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $78da16583ad93b9f$var$currentInstance;
            $78da16583ad93b9f$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $78da16583ad93b9f$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$78da16583ad93b9f$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $8bTPG.ref)(false);
            const error = (0, $8bTPG.ref)();
            const delayed = (0, $8bTPG.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $78da16583ad93b9f$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $78da16583ad93b9f$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $78da16583ad93b9f$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $78da16583ad93b9f$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $78da16583ad93b9f$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $78da16583ad93b9f$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $78da16583ad93b9f$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $78da16583ad93b9f$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $X5A94.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $78da16583ad93b9f$var$invalidateMount(instance2.m);
            $78da16583ad93b9f$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $X5A94.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $78da16583ad93b9f$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $78da16583ad93b9f$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$78da16583ad93b9f$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $78da16583ad93b9f$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $78da16583ad93b9f$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$78da16583ad93b9f$var$matches(include, name));
            exclude && pruneCache((name)=>!$78da16583ad93b9f$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($78da16583ad93b9f$var$isSuspense(instance.subTree.type)) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $78da16583ad93b9f$var$getInnerChild(instance.subTree));
            }
        };
        $78da16583ad93b9f$export$6d1641039221b5cb(cacheSubtree);
        $78da16583ad93b9f$export$5876c47052fb88b1(cacheSubtree);
        $78da16583ad93b9f$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $78da16583ad93b9f$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $78da16583ad93b9f$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $78da16583ad93b9f$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$78da16583ad93b9f$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $78da16583ad93b9f$var$getInnerChild(rawVNode);
            if (vnode.type === $78da16583ad93b9f$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $78da16583ad93b9f$var$getComponentName($78da16583ad93b9f$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$78da16583ad93b9f$var$matches(include, name)) || exclude && name && $78da16583ad93b9f$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $78da16583ad93b9f$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $78da16583ad93b9f$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $78da16583ad93b9f$export$70eb8a58709972df = $78da16583ad93b9f$var$KeepAliveImpl;
function $78da16583ad93b9f$var$matches(pattern, name) {
    if ((0, $X5A94.isArray)(pattern)) return pattern.some((p)=>$78da16583ad93b9f$var$matches(p, name));
    else if ((0, $X5A94.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $X5A94.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $78da16583ad93b9f$export$ba52d824b95a2154(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "a", target);
}
function $78da16583ad93b9f$export$bf1440eeaf5fa709(hook, target) {
    $78da16583ad93b9f$var$registerKeepAliveHook(hook, "da", target);
}
function $78da16583ad93b9f$var$registerKeepAliveHook(hook, type, target = $78da16583ad93b9f$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $78da16583ad93b9f$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($78da16583ad93b9f$var$isKeepAlive(current.parent.vnode)) $78da16583ad93b9f$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $78da16583ad93b9f$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $78da16583ad93b9f$var$injectHook(type, hook, keepAliveRoot, true);
    $78da16583ad93b9f$export$13348a43ccacfe58(()=>{
        (0, $X5A94.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $78da16583ad93b9f$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $78da16583ad93b9f$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $78da16583ad93b9f$var$injectHook(type, hook, target = $78da16583ad93b9f$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $8bTPG.pauseTracking)();
            const reset = $78da16583ad93b9f$var$setCurrentInstance(target);
            const res = $78da16583ad93b9f$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $8bTPG.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $78da16583ad93b9f$var$createHook = (lifecycle)=>(hook, target = $78da16583ad93b9f$var$currentInstance)=>{
        if (!$78da16583ad93b9f$var$isInSSRComponentSetup || lifecycle === "sp") $78da16583ad93b9f$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $78da16583ad93b9f$export$23b7aeb0d671f804 = $78da16583ad93b9f$var$createHook("bm");
const $78da16583ad93b9f$export$6d1641039221b5cb = $78da16583ad93b9f$var$createHook("m");
const $78da16583ad93b9f$export$ab91988a13872e4c = $78da16583ad93b9f$var$createHook("bu");
const $78da16583ad93b9f$export$5876c47052fb88b1 = $78da16583ad93b9f$var$createHook("u");
const $78da16583ad93b9f$export$40c420df62d2614 = $78da16583ad93b9f$var$createHook("bum");
const $78da16583ad93b9f$export$13348a43ccacfe58 = $78da16583ad93b9f$var$createHook("um");
const $78da16583ad93b9f$export$ebf0c601f267bceb = $78da16583ad93b9f$var$createHook("sp");
const $78da16583ad93b9f$export$898295a813d662eb = $78da16583ad93b9f$var$createHook("rtg");
const $78da16583ad93b9f$export$2b41f4235363e921 = $78da16583ad93b9f$var$createHook("rtc");
function $78da16583ad93b9f$export$6a3a15856e50ad19(hook, target = $78da16583ad93b9f$var$currentInstance) {
    $78da16583ad93b9f$var$injectHook("ec", hook, target);
}
const $78da16583ad93b9f$var$COMPONENTS = "components";
const $78da16583ad93b9f$var$DIRECTIVES = "directives";
function $78da16583ad93b9f$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $78da16583ad93b9f$export$b44c564a05ca975(component) {
    if ((0, $X5A94.isString)(component)) return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$COMPONENTS, component, false) || component;
    else return component || $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT;
}
function $78da16583ad93b9f$export$a1989e995cd481be(name) {
    return $78da16583ad93b9f$var$resolveAsset($78da16583ad93b9f$var$DIRECTIVES, name);
}
function $78da16583ad93b9f$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $78da16583ad93b9f$var$COMPONENTS) {
            const selfName = $78da16583ad93b9f$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $X5A94.camelize)(name) || selfName === (0, $X5A94.capitalize)((0, $X5A94.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $78da16583ad93b9f$var$resolve(instance[type] || Component[type], name) || // global registration
        $78da16583ad93b9f$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $78da16583ad93b9f$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $X5A94.camelize)(name)] || registry[(0, $X5A94.capitalize)((0, $X5A94.camelize)(name))]);
}
function $78da16583ad93b9f$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $X5A94.isArray)(source);
    if (sourceIsArray || (0, $X5A94.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $8bTPG.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $8bTPG.isShallow)(source);
            source = (0, $8bTPG.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, $8bTPG.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $X5A94.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $78da16583ad93b9f$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $X5A94.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $78da16583ad93b9f$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($78da16583ad93b9f$var$currentRenderingInstance.ce || $78da16583ad93b9f$var$currentRenderingInstance.parent && $78da16583ad93b9f$var$isAsyncWrapper($78da16583ad93b9f$var$currentRenderingInstance.parent) && $78da16583ad93b9f$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, null, [
            $78da16583ad93b9f$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $78da16583ad93b9f$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $78da16583ad93b9f$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $X5A94.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $78da16583ad93b9f$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$78da16583ad93b9f$export$3868d13f8734ae81(child)) return true;
        if (child.type === $78da16583ad93b9f$export$4d299b491347818a) return false;
        if (child.type === $78da16583ad93b9f$export$ffb0004e005737fa && !$78da16583ad93b9f$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $78da16583ad93b9f$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $X5A94.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $78da16583ad93b9f$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($78da16583ad93b9f$var$isStatefulComponent(i)) return $78da16583ad93b9f$var$getComponentPublicInstance(i);
    return $78da16583ad93b9f$var$getPublicInstance(i.parent);
};
const $78da16583ad93b9f$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.parent),
    $root: (i)=>$78da16583ad93b9f$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $78da16583ad93b9f$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $78da16583ad93b9f$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $78da16583ad93b9f$var$instanceWatch.bind(i) : (0, $X5A94.NOOP)
});
const $78da16583ad93b9f$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $78da16583ad93b9f$var$hasSetupBinding = (state, key)=>state !== (0, $X5A94.EMPTY_OBJ) && !state.__isScriptSetup && (0, $X5A94.hasOwn)(state, key);
const $78da16583ad93b9f$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $78da16583ad93b9f$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $78da16583ad93b9f$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $8bTPG.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $X5A94.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($78da16583ad93b9f$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $X5A94.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasOwn)(data, key) || $78da16583ad93b9f$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $X5A94.hasOwn)(normalizedProps, key) || (0, $X5A94.hasOwn)(ctx, key) || (0, $X5A94.hasOwn)($78da16583ad93b9f$var$publicPropertiesMap, key) || (0, $X5A94.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $X5A94.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $78da16583ad93b9f$var$target;
const $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $X5A94.extend)({}, $78da16583ad93b9f$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $78da16583ad93b9f$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $X5A94.isGloballyAllowed)(key);
        return has;
    }
});
function $78da16583ad93b9f$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($78da16583ad93b9f$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$78da16583ad93b9f$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $X5A94.NOOP)
        });
    });
    return target;
}
function $78da16583ad93b9f$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $X5A94.NOOP)
        });
    });
}
function $78da16583ad93b9f$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $8bTPG.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($78da16583ad93b9f$var$isReservedPrefix(key[0])) {
                $78da16583ad93b9f$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $X5A94.NOOP)
            });
        }
    });
}
const $78da16583ad93b9f$var$warnRuntimeUsage = (method)=>$78da16583ad93b9f$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $78da16583ad93b9f$export$80b33eababae110e() {
    return null;
}
function $78da16583ad93b9f$export$51ecece22fc17ddc() {
    return null;
}
function $78da16583ad93b9f$export$da25b65ca24b518a(exposed) {}
function $78da16583ad93b9f$export$77e79129327f3d0d(options) {}
function $78da16583ad93b9f$export$1b3acd4bb805b712() {
    return null;
}
function $78da16583ad93b9f$export$acd55aa037e791bb() {}
function $78da16583ad93b9f$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $78da16583ad93b9f$export$9203a8e84125433c() {
    return $78da16583ad93b9f$var$getContext().slots;
}
function $78da16583ad93b9f$export$75e29435042cd2ea() {
    return $78da16583ad93b9f$var$getContext().attrs;
}
function $78da16583ad93b9f$var$getContext() {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $78da16583ad93b9f$var$createSetupContext(i));
}
function $78da16583ad93b9f$var$normalizePropsOrEmits(props) {
    return (0, $X5A94.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $78da16583ad93b9f$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $78da16583ad93b9f$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $78da16583ad93b9f$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $X5A94.isArray)(a) && (0, $X5A94.isArray)(b)) return a.concat(b);
    return (0, $X5A94.extend)({}, $78da16583ad93b9f$var$normalizePropsOrEmits(a), $78da16583ad93b9f$var$normalizePropsOrEmits(b));
}
function $78da16583ad93b9f$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $78da16583ad93b9f$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $78da16583ad93b9f$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $78da16583ad93b9f$var$unsetCurrentInstance();
    if ((0, $X5A94.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $78da16583ad93b9f$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$78da16583ad93b9f$var$setCurrentInstance(ctx)
    ];
}
function $78da16583ad93b9f$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $78da16583ad93b9f$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $78da16583ad93b9f$var$shouldCacheAccess = true;
function $78da16583ad93b9f$var$applyOptions(instance) {
    const options = $78da16583ad93b9f$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $78da16583ad93b9f$var$shouldCacheAccess = false;
    if (options.beforeCreate) $78da16583ad93b9f$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $X5A94.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $X5A94.isObject)(data)) ;
        else instance.data = (0, $8bTPG.reactive)(data);
    }
    $78da16583ad93b9f$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $X5A94.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $X5A94.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $X5A94.NOOP);
        const set = !(0, $X5A94.isFunction)(opt) && (0, $X5A94.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $X5A94.NOOP);
        const c = $78da16583ad93b9f$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$78da16583ad93b9f$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $X5A94.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $78da16583ad93b9f$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $78da16583ad93b9f$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $X5A94.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($78da16583ad93b9f$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($78da16583ad93b9f$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($78da16583ad93b9f$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($78da16583ad93b9f$export$5876c47052fb88b1, updated);
    registerLifecycleHook($78da16583ad93b9f$export$ba52d824b95a2154, activated);
    registerLifecycleHook($78da16583ad93b9f$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($78da16583ad93b9f$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($78da16583ad93b9f$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($78da16583ad93b9f$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($78da16583ad93b9f$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($78da16583ad93b9f$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($78da16583ad93b9f$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $X5A94.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $X5A94.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $78da16583ad93b9f$var$markAsyncBoundary(instance);
}
function $78da16583ad93b9f$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $X5A94.NOOP)) {
    if ((0, $X5A94.isArray)(injectOptions)) injectOptions = $78da16583ad93b9f$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $X5A94.isObject)(opt)) {
            if ("default" in opt) injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt.from || key);
        } else injected = $78da16583ad93b9f$export$a976684a0efeb93f(opt);
        if ((0, $8bTPG.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $78da16583ad93b9f$var$callHook(hook, instance, type) {
    $78da16583ad93b9f$export$dae85862a8d94378((0, $X5A94.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $78da16583ad93b9f$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $X5A94.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $X5A94.isFunction)(raw)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $X5A94.isObject)(raw)) {
        if ((0, $X5A94.isArray)(raw)) raw.forEach((r)=>$78da16583ad93b9f$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $X5A94.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $X5A94.isFunction)(handler)) $78da16583ad93b9f$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $78da16583ad93b9f$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $78da16583ad93b9f$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $X5A94.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $78da16583ad93b9f$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $78da16583ad93b9f$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$78da16583ad93b9f$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $78da16583ad93b9f$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $78da16583ad93b9f$var$internalOptionMergeStrats = {
    data: $78da16583ad93b9f$var$mergeDataFn,
    props: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    emits: $78da16583ad93b9f$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $78da16583ad93b9f$var$mergeObjectOptions,
    computed: $78da16583ad93b9f$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $78da16583ad93b9f$var$mergeAsArray,
    created: $78da16583ad93b9f$var$mergeAsArray,
    beforeMount: $78da16583ad93b9f$var$mergeAsArray,
    mounted: $78da16583ad93b9f$var$mergeAsArray,
    beforeUpdate: $78da16583ad93b9f$var$mergeAsArray,
    updated: $78da16583ad93b9f$var$mergeAsArray,
    beforeDestroy: $78da16583ad93b9f$var$mergeAsArray,
    beforeUnmount: $78da16583ad93b9f$var$mergeAsArray,
    destroyed: $78da16583ad93b9f$var$mergeAsArray,
    unmounted: $78da16583ad93b9f$var$mergeAsArray,
    activated: $78da16583ad93b9f$var$mergeAsArray,
    deactivated: $78da16583ad93b9f$var$mergeAsArray,
    errorCaptured: $78da16583ad93b9f$var$mergeAsArray,
    serverPrefetch: $78da16583ad93b9f$var$mergeAsArray,
    // assets
    components: $78da16583ad93b9f$var$mergeObjectOptions,
    directives: $78da16583ad93b9f$var$mergeObjectOptions,
    // watch
    watch: $78da16583ad93b9f$var$mergeWatchOptions,
    // provide / inject
    provide: $78da16583ad93b9f$var$mergeDataFn,
    inject: $78da16583ad93b9f$var$mergeInject
};
function $78da16583ad93b9f$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $X5A94.extend)((0, $X5A94.isFunction)(to) ? to.call(this, this) : to, (0, $X5A94.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $78da16583ad93b9f$var$mergeInject(to, from) {
    return $78da16583ad93b9f$var$mergeObjectOptions($78da16583ad93b9f$var$normalizeInject(to), $78da16583ad93b9f$var$normalizeInject(from));
}
function $78da16583ad93b9f$var$normalizeInject(raw) {
    if ((0, $X5A94.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $78da16583ad93b9f$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $78da16583ad93b9f$var$mergeObjectOptions(to, from) {
    return to ? (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $78da16583ad93b9f$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $X5A94.isArray)(to) && (0, $X5A94.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), $78da16583ad93b9f$var$normalizePropsOrEmits(to), $78da16583ad93b9f$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $78da16583ad93b9f$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $X5A94.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $78da16583ad93b9f$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $78da16583ad93b9f$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $X5A94.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $78da16583ad93b9f$var$uid$1 = 0;
function $78da16583ad93b9f$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $X5A94.isFunction)(rootComponent)) rootComponent = (0, $X5A94.extend)({}, rootComponent);
        if (rootProps != null && !(0, $X5A94.isObject)(rootProps)) rootProps = null;
        const context = $78da16583ad93b9f$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $78da16583ad93b9f$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $78da16583ad93b9f$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $X5A94.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $X5A94.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $78da16583ad93b9f$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $78da16583ad93b9f$var$devtoolsInitApp(app, $78da16583ad93b9f$export$83d89fbfd8236492);
                    }
                    return $78da16583ad93b9f$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $78da16583ad93b9f$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $78da16583ad93b9f$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $78da16583ad93b9f$var$currentApp;
                $78da16583ad93b9f$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $78da16583ad93b9f$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $78da16583ad93b9f$var$currentApp = null;
function $78da16583ad93b9f$export$abe1e183e22e10ad(key, value) {
    if (!$78da16583ad93b9f$var$currentInstance) ;
    else {
        let provides = $78da16583ad93b9f$var$currentInstance.provides;
        const parentProvides = $78da16583ad93b9f$var$currentInstance.parent && $78da16583ad93b9f$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $78da16583ad93b9f$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $78da16583ad93b9f$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
    if (instance || $78da16583ad93b9f$var$currentApp) {
        const provides = $78da16583ad93b9f$var$currentApp ? $78da16583ad93b9f$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $X5A94.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $78da16583ad93b9f$export$caf6761f24fc571a() {
    return !!($78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance || $78da16583ad93b9f$var$currentApp);
}
const $78da16583ad93b9f$var$internalObjectProto = {};
const $78da16583ad93b9f$var$createInternalObject = ()=>Object.create($78da16583ad93b9f$var$internalObjectProto);
const $78da16583ad93b9f$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $78da16583ad93b9f$var$internalObjectProto;
function $78da16583ad93b9f$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $78da16583ad93b9f$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $8bTPG.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $78da16583ad93b9f$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $78da16583ad93b9f$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $8bTPG.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $X5A94.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $X5A94.camelize)(key);
                        props[camelizedKey] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $X5A94.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $X5A94.hyphenate)(key)) === key || !(0, $X5A94.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $X5A94.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $8bTPG.trigger)(instance.attrs, "set", "");
}
function $78da16583ad93b9f$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $X5A94.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $X5A94.hasOwn)(options, camelKey = (0, $X5A94.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$78da16583ad93b9f$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $8bTPG.toRaw)(props);
        const castValues = rawCastValues || (0, $X5A94.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $78da16583ad93b9f$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $X5A94.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $78da16583ad93b9f$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $X5A94.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $X5A94.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $X5A94.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $78da16583ad93b9f$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $78da16583ad93b9f$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $78da16583ad93b9f$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $78da16583ad93b9f$var$normalizePropsOptions(raw2, appContext, true);
            (0, $X5A94.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, (0, $X5A94.EMPTY_ARR));
        return 0, $X5A94.EMPTY_ARR;
    }
    if ((0, $X5A94.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $X5A94.camelize)(raw[i]);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $X5A94.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $X5A94.camelize)(key);
        if ($78da16583ad93b9f$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $X5A94.isArray)(opt) || (0, $X5A94.isFunction)(opt) ? {
                type: opt
            } : (0, $X5A94.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $X5A94.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $X5A94.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $X5A94.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $X5A94.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $78da16583ad93b9f$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $X5A94.isReservedProp)(key)) return true;
    return false;
}
function $78da16583ad93b9f$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $78da16583ad93b9f$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $8bTPG.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $X5A94.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $78da16583ad93b9f$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $78da16583ad93b9f$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $78da16583ad93b9f$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $X5A94.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $78da16583ad93b9f$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $78da16583ad93b9f$var$warn$1($78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $78da16583ad93b9f$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $78da16583ad93b9f$var$isSimpleType = /* @__PURE__ */ (0, $X5A94.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $78da16583ad93b9f$var$assertType(value, type) {
    let valid;
    const expectedType = $78da16583ad93b9f$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($78da16583ad93b9f$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $X5A94.isObject)(value);
    else if (expectedType === "Array") valid = (0, $X5A94.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $78da16583ad93b9f$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $X5A94.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $X5A94.toRawType)(value);
    const expectedValue = $78da16583ad93b9f$var$styleValue(value, expectedType);
    const receivedValue = $78da16583ad93b9f$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $78da16583ad93b9f$var$isExplicable(expectedType) && !$78da16583ad93b9f$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($78da16583ad93b9f$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $78da16583ad93b9f$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $78da16583ad93b9f$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $78da16583ad93b9f$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $78da16583ad93b9f$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $78da16583ad93b9f$var$normalizeSlotValue = (value)=>(0, $X5A94.isArray)(value) ? value.map($78da16583ad93b9f$var$normalizeVNode) : [
        $78da16583ad93b9f$var$normalizeVNode(value)
    ];
const $78da16583ad93b9f$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $78da16583ad93b9f$export$694b237e827a3d23((...args)=>{
        return $78da16583ad93b9f$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $78da16583ad93b9f$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($78da16583ad93b9f$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $X5A94.isFunction)(value)) slots[key] = $78da16583ad93b9f$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $78da16583ad93b9f$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $78da16583ad93b9f$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $78da16583ad93b9f$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $78da16583ad93b9f$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const $78da16583ad93b9f$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $78da16583ad93b9f$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $78da16583ad93b9f$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $X5A94.def)(slots, "_", type, true);
        } else $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
    } else if (children) $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
};
const $78da16583ad93b9f$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $X5A94.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $78da16583ad93b9f$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $78da16583ad93b9f$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $78da16583ad93b9f$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$78da16583ad93b9f$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $78da16583ad93b9f$var$supported;
let $78da16583ad93b9f$var$perf;
function $78da16583ad93b9f$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) $78da16583ad93b9f$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfStart(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $78da16583ad93b9f$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $78da16583ad93b9f$var$perf.mark(endTag);
        $78da16583ad93b9f$var$perf.measure(`<${$78da16583ad93b9f$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $78da16583ad93b9f$var$perf.clearMarks(startTag);
        $78da16583ad93b9f$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsPerfEnd(instance, type, $78da16583ad93b9f$var$isSupported() ? $78da16583ad93b9f$var$perf.now() : Date.now());
}
function $78da16583ad93b9f$var$isSupported() {
    if ($78da16583ad93b9f$var$supported !== void 0) return $78da16583ad93b9f$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $78da16583ad93b9f$var$supported = true;
        $78da16583ad93b9f$var$perf = window.performance;
    } else $78da16583ad93b9f$var$supported = false;
    return $78da16583ad93b9f$var$supported;
}
function $78da16583ad93b9f$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $X5A94.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $78da16583ad93b9f$var$queuePostRenderEffect = $78da16583ad93b9f$var$queueEffectWithSuspense;
function $78da16583ad93b9f$export$53ae2f996c64e9a(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options);
}
function $78da16583ad93b9f$export$200524cf0d997ff0(options) {
    return $78da16583ad93b9f$var$baseCreateRenderer(options, $78da16583ad93b9f$var$createHydrationFunctions);
}
function $78da16583ad93b9f$var$baseCreateRenderer(options, createHydrationFns) {
    $78da16583ad93b9f$var$initFeatureFlags();
    const target = (0, $X5A94.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $X5A94.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$78da16583ad93b9f$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $78da16583ad93b9f$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $78da16583ad93b9f$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $78da16583ad93b9f$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $78da16583ad93b9f$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $X5A94.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $X5A94.def)(el, "__vnode", vnode, true);
            (0, $X5A94.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $78da16583ad93b9f$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $78da16583ad93b9f$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(children[i]) : $78da16583ad93b9f$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $X5A94.EMPTY_OBJ);
        const newProps = n2.props || (0, $X5A94.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $78da16583ad93b9f$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $78da16583ad93b9f$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $78da16583ad93b9f$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $78da16583ad93b9f$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$78da16583ad93b9f$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $X5A94.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $X5A94.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $X5A94.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $78da16583ad93b9f$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($78da16583ad93b9f$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $78da16583ad93b9f$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($78da16583ad93b9f$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $78da16583ad93b9f$var$isAsyncWrapper(initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (bm) (0, $X5A94.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $78da16583ad93b9f$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $78da16583ad93b9f$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $78da16583ad93b9f$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $78da16583ad93b9f$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $X5A94.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $78da16583ad93b9f$var$toggleRecurse(instance, true);
                const nextTree = $78da16583ad93b9f$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $78da16583ad93b9f$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $78da16583ad93b9f$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $78da16583ad93b9f$var$queuePostRenderEffect(()=>$78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $8bTPG.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$78da16583ad93b9f$var$queueJob(job);
        $78da16583ad93b9f$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $78da16583ad93b9f$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $78da16583ad93b9f$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $8bTPG.pauseTracking)();
        $78da16583ad93b9f$var$flushPreFlushCbs(instance);
        (0, $8bTPG.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $X5A94.EMPTY_ARR);
        c2 = c2 || (0, $X5A94.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[e2]) : $78da16583ad93b9f$var$normalizeVNode(c2[e2]);
            if ($78da16583ad93b9f$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $78da16583ad93b9f$var$cloneIfMounted(c2[i]) : $78da16583ad93b9f$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $78da16583ad93b9f$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $78da16583ad93b9f$var$getSequence(newIndexToOldIndexMap) : (0, $X5A94.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $78da16583ad93b9f$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $78da16583ad93b9f$var$setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$78da16583ad93b9f$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $78da16583ad93b9f$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $78da16583ad93b9f$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            vnodeHook && $78da16583ad93b9f$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $78da16583ad93b9f$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $78da16583ad93b9f$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $78da16583ad93b9f$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $78da16583ad93b9f$var$invalidateMount(m);
        $78da16583ad93b9f$var$invalidateMount(a);
        if (bum) (0, $X5A94.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $78da16583ad93b9f$var$queuePostRenderEffect(um, parentSuspense);
        $78da16583ad93b9f$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$78da16583ad93b9f$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $78da16583ad93b9f$var$flushPreFlushCbs();
            $78da16583ad93b9f$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $78da16583ad93b9f$var$createAppAPI(render, hydrate)
    };
}
function $78da16583ad93b9f$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $78da16583ad93b9f$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $78da16583ad93b9f$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $78da16583ad93b9f$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $X5A94.isArray)(ch1) && (0, $X5A94.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $78da16583ad93b9f$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $78da16583ad93b9f$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $78da16583ad93b9f$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $78da16583ad93b9f$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $78da16583ad93b9f$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $78da16583ad93b9f$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $78da16583ad93b9f$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $78da16583ad93b9f$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $78da16583ad93b9f$export$a976684a0efeb93f($78da16583ad93b9f$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $78da16583ad93b9f$export$ede35fc0e5500309(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, options);
}
function $78da16583ad93b9f$export$b7f27ea67102d543(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $78da16583ad93b9f$export$2035654f31b0e555(effect, options) {
    return $78da16583ad93b9f$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $78da16583ad93b9f$export$3db5d71bdb2d5499(source, cb, options) {
    return $78da16583ad93b9f$var$doWatch(source, cb, options);
}
function $78da16583ad93b9f$var$doWatch(source, cb, options = (0, $X5A94.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $X5A94.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $78da16583ad93b9f$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $X5A94.NOOP);
            watchStopHandle.resume = (0, $X5A94.NOOP);
            watchStopHandle.pause = (0, $X5A94.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $78da16583ad93b9f$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$78da16583ad93b9f$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $78da16583ad93b9f$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $78da16583ad93b9f$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $8bTPG.watch)(source, cb, baseWatchOptions);
    if ($78da16583ad93b9f$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $78da16583ad93b9f$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $X5A94.isString)(source) ? source.includes(".") ? $78da16583ad93b9f$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $X5A94.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $78da16583ad93b9f$var$setCurrentInstance(this);
    const res = $78da16583ad93b9f$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $78da16583ad93b9f$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $78da16583ad93b9f$export$fb78bd113157f1a1(props, name, options = (0, $X5A94.EMPTY_OBJ)) {
    const i = $78da16583ad93b9f$export$f13e630aa3915748();
    const camelizedName = (0, $X5A94.camelize)(name);
    const hyphenatedName = (0, $X5A94.hyphenate)(name);
    const modifiers = $78da16583ad93b9f$var$getModelModifiers(props, camelizedName);
    const res = (0, $8bTPG.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $X5A94.EMPTY_OBJ);
        let prevEmittedValue;
        $78da16583ad93b9f$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $X5A94.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $X5A94.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $X5A94.EMPTY_OBJ) && (0, $X5A94.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $X5A94.hasChanged)(value, emittedValue) && (0, $X5A94.hasChanged)(value, prevSetValue) && !(0, $X5A94.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $X5A94.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $78da16583ad93b9f$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $X5A94.camelize)(modelName)}Modifiers`] || props[`${(0, $X5A94.hyphenate)(modelName)}Modifiers`];
};
function $78da16583ad93b9f$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $X5A94.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $78da16583ad93b9f$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $X5A94.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $X5A94.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $78da16583ad93b9f$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $X5A94.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $X5A94.toHandlerKey)((0, $X5A94.hyphenate)(event))];
    if (handler) $78da16583ad93b9f$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $78da16583ad93b9f$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $78da16583ad93b9f$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $X5A94.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $78da16583ad93b9f$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $X5A94.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $X5A94.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $X5A94.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $X5A94.extend)(normalized, raw);
    if ((0, $X5A94.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $78da16583ad93b9f$var$isEmitListener(options, key) {
    if (!options || !(0, $X5A94.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $X5A94.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $X5A94.hasOwn)(options, (0, $X5A94.hyphenate)(key)) || (0, $X5A94.hasOwn)(options, key);
}
let $78da16583ad93b9f$var$accessedAttrs = false;
function $78da16583ad93b9f$var$markAttrsAccessed() {
    $78da16583ad93b9f$var$accessedAttrs = true;
}
function $78da16583ad93b9f$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $78da16583ad93b9f$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $78da16583ad93b9f$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $78da16583ad93b9f$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $78da16583ad93b9f$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $78da16583ad93b9f$var$blockStack.length = 0;
        $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 1);
        result = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $X5A94.isModelListener))) fallthroughAttrs = $78da16583ad93b9f$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $78da16583ad93b9f$export$7770a22486565649(root, vnode.transition);
    result = root;
    $78da16583ad93b9f$var$setCurrentRenderingInstance(prev);
    return result;
}
const $78da16583ad93b9f$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $78da16583ad93b9f$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $78da16583ad93b9f$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $78da16583ad93b9f$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) {
            if (child.type !== $78da16583ad93b9f$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $78da16583ad93b9f$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $X5A94.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $X5A94.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $78da16583ad93b9f$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $78da16583ad93b9f$export$4d299b491347818a;
};
function $78da16583ad93b9f$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $78da16583ad93b9f$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$78da16583ad93b9f$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $78da16583ad93b9f$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $78da16583ad93b9f$var$isSuspense = (type)=>type.__isSuspense;
let $78da16583ad93b9f$var$suspenseId = 0;
const $78da16583ad93b9f$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $78da16583ad93b9f$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $78da16583ad93b9f$var$hydrateSuspense,
    normalize: $78da16583ad93b9f$var$normalizeSuspenseChildren
};
const $78da16583ad93b9f$export$74bf444e3cd11ea5 = $78da16583ad93b9f$var$SuspenseImpl;
function $78da16583ad93b9f$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $X5A94.isFunction)(eventListener)) eventListener();
}
function $78da16583ad93b9f$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $78da16583ad93b9f$var$triggerEvent(vnode, "onPending");
        $78da16583ad93b9f$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $78da16583ad93b9f$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $78da16583ad93b9f$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($78da16583ad93b9f$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $78da16583ad93b9f$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $78da16583ad93b9f$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $78da16583ad93b9f$var$setActiveBranch(suspense, newBranch);
    } else {
        $78da16583ad93b9f$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $78da16583ad93b9f$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $78da16583ad93b9f$var$hasWarned = false;
function $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $78da16583ad93b9f$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $X5A94.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $78da16583ad93b9f$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $78da16583ad93b9f$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $78da16583ad93b9f$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $78da16583ad93b9f$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $78da16583ad93b9f$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $78da16583ad93b9f$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $78da16583ad93b9f$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $78da16583ad93b9f$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $78da16583ad93b9f$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $78da16583ad93b9f$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $78da16583ad93b9f$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $78da16583ad93b9f$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $78da16583ad93b9f$var$normalizeSuspenseSlot(children.fallback) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
}
function $78da16583ad93b9f$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $X5A94.isFunction)(s)) {
        const trackBlock = $78da16583ad93b9f$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $78da16583ad93b9f$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $78da16583ad93b9f$var$currentBlock;
            $78da16583ad93b9f$var$closeBlock();
        }
    }
    if ((0, $X5A94.isArray)(s)) {
        const singleChild = $78da16583ad93b9f$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $78da16583ad93b9f$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $78da16583ad93b9f$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $X5A94.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $78da16583ad93b9f$export$59536a0199721cab(fn);
}
function $78da16583ad93b9f$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $78da16583ad93b9f$var$updateHOCHostEl(parentComponent, el);
    }
}
function $78da16583ad93b9f$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $78da16583ad93b9f$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $78da16583ad93b9f$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $78da16583ad93b9f$export$4d299b491347818a = Symbol.for("v-cmt");
const $78da16583ad93b9f$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $78da16583ad93b9f$var$blockStack = [];
let $78da16583ad93b9f$var$currentBlock = null;
function $78da16583ad93b9f$export$e7eaa45e502fe5cc(disableTracking = false) {
    $78da16583ad93b9f$var$blockStack.push($78da16583ad93b9f$var$currentBlock = disableTracking ? null : []);
}
function $78da16583ad93b9f$var$closeBlock() {
    $78da16583ad93b9f$var$blockStack.pop();
    $78da16583ad93b9f$var$currentBlock = $78da16583ad93b9f$var$blockStack[$78da16583ad93b9f$var$blockStack.length - 1] || null;
}
let $78da16583ad93b9f$var$isBlockTreeEnabled = 1;
function $78da16583ad93b9f$export$c20bee82f26f1e27(value, inVOnce = false) {
    $78da16583ad93b9f$var$isBlockTreeEnabled += value;
    if (value < 0 && $78da16583ad93b9f$var$currentBlock && inVOnce) $78da16583ad93b9f$var$currentBlock.hasOnce = true;
}
function $78da16583ad93b9f$var$setupBlock(vnode) {
    vnode.dynamicChildren = $78da16583ad93b9f$var$isBlockTreeEnabled > 0 ? $78da16583ad93b9f$var$currentBlock || (0, $X5A94.EMPTY_ARR) : null;
    $78da16583ad93b9f$var$closeBlock();
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
function $78da16583ad93b9f$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $78da16583ad93b9f$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $78da16583ad93b9f$var$setupBlock($78da16583ad93b9f$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $78da16583ad93b9f$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $78da16583ad93b9f$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $78da16583ad93b9f$var$vnodeArgsTransformer;
function $78da16583ad93b9f$export$83beccd3afeeb809(transformer) {
    $78da16583ad93b9f$var$vnodeArgsTransformer = transformer;
}
const $78da16583ad93b9f$var$createVNodeWithArgsTransform = (...args)=>{
    return $78da16583ad93b9f$var$_createVNode(...$78da16583ad93b9f$var$vnodeArgsTransformer ? $78da16583ad93b9f$var$vnodeArgsTransformer(args, $78da16583ad93b9f$var$currentRenderingInstance) : args);
};
const $78da16583ad93b9f$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $78da16583ad93b9f$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $X5A94.isString)(ref) || (0, $8bTPG.isRef)(ref) || (0, $X5A94.isFunction)(ref) ? {
        i: $78da16583ad93b9f$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $78da16583ad93b9f$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $78da16583ad93b9f$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $78da16583ad93b9f$var$normalizeKey(props),
        ref: props && $78da16583ad93b9f$var$normalizeRef(props),
        scopeId: $78da16583ad93b9f$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $78da16583ad93b9f$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $78da16583ad93b9f$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $X5A94.isString)(children) ? 8 : 16;
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $78da16583ad93b9f$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $78da16583ad93b9f$var$currentBlock.push(vnode);
    return vnode;
}
const $78da16583ad93b9f$export$bf5c4cf060303d58 = $78da16583ad93b9f$var$_createVNode;
function $78da16583ad93b9f$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $78da16583ad93b9f$var$NULL_DYNAMIC_COMPONENT) type = $78da16583ad93b9f$export$4d299b491347818a;
    if ($78da16583ad93b9f$export$3868d13f8734ae81(type)) {
        const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $78da16583ad93b9f$var$normalizeChildren(cloned, children);
        if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && !isBlockNode && $78da16583ad93b9f$var$currentBlock) {
            if (cloned.shapeFlag & 6) $78da16583ad93b9f$var$currentBlock[$78da16583ad93b9f$var$currentBlock.indexOf(type)] = cloned;
            else $78da16583ad93b9f$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($78da16583ad93b9f$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $78da16583ad93b9f$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $X5A94.isString)(klass)) props.class = (0, $X5A94.normalizeClass)(klass);
        if ((0, $X5A94.isObject)(style)) {
            if ((0, $8bTPG.isProxy)(style) && !(0, $X5A94.isArray)(style)) style = (0, $X5A94.extend)({}, style);
            props.style = (0, $X5A94.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $X5A94.isString)(type) ? 1 : $78da16583ad93b9f$var$isSuspense(type) ? 128 : $78da16583ad93b9f$var$isTeleport(type) ? 64 : (0, $X5A94.isObject)(type) ? 4 : (0, $X5A94.isFunction)(type) ? 2 : 0;
    return $78da16583ad93b9f$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $78da16583ad93b9f$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $8bTPG.isProxy)(props) || $78da16583ad93b9f$var$isInternalObject(props) ? (0, $X5A94.extend)({}, props) : props;
}
function $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $78da16583ad93b9f$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $78da16583ad93b9f$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $X5A94.isArray)(ref) ? ref.concat($78da16583ad93b9f$var$normalizeRef(extraProps)) : [
            ref,
            $78da16583ad93b9f$var$normalizeRef(extraProps)
        ] : $78da16583ad93b9f$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $78da16583ad93b9f$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $78da16583ad93b9f$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $78da16583ad93b9f$var$deepCloneVNode(vnode) {
    const cloned = $78da16583ad93b9f$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $X5A94.isArray)(vnode.children)) cloned.children = vnode.children.map($78da16583ad93b9f$var$deepCloneVNode);
    return cloned;
}
function $78da16583ad93b9f$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, text, flag);
}
function $78da16583ad93b9f$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $78da16583ad93b9f$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($78da16583ad93b9f$export$e7eaa45e502fe5cc(), $78da16583ad93b9f$export$9f2dfe8048dfb22b($78da16583ad93b9f$export$4d299b491347818a, null, text)) : $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a, null, text);
}
function $78da16583ad93b9f$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$4d299b491347818a);
    else if ((0, $X5A94.isArray)(child)) return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($78da16583ad93b9f$export$3868d13f8734ae81(child)) return $78da16583ad93b9f$var$cloneIfMounted(child);
    else return $78da16583ad93b9f$export$bf5c4cf060303d58($78da16583ad93b9f$export$5f1af8db9871e1d6, null, String(child));
}
function $78da16583ad93b9f$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $78da16583ad93b9f$export$ee4f9e12c0a92a1a(child);
}
function $78da16583ad93b9f$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $X5A94.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $78da16583ad93b9f$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$78da16583ad93b9f$var$isInternalObject(children)) children._ctx = $78da16583ad93b9f$var$currentRenderingInstance;
            else if (slotFlag === 3 && $78da16583ad93b9f$var$currentRenderingInstance) {
                if ($78da16583ad93b9f$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $X5A94.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $78da16583ad93b9f$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $78da16583ad93b9f$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $78da16583ad93b9f$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $X5A94.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $X5A94.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $X5A94.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $X5A94.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $78da16583ad93b9f$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $78da16583ad93b9f$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $78da16583ad93b9f$var$emptyAppContext = $78da16583ad93b9f$var$createAppContext();
let $78da16583ad93b9f$var$uid = 0;
function $78da16583ad93b9f$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $78da16583ad93b9f$var$emptyAppContext;
    const instance = {
        uid: $78da16583ad93b9f$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $8bTPG.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $78da16583ad93b9f$var$normalizePropsOptions(type, appContext),
        emitsOptions: $78da16583ad93b9f$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $X5A94.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $X5A94.EMPTY_OBJ),
        data: (0, $X5A94.EMPTY_OBJ),
        props: (0, $X5A94.EMPTY_OBJ),
        attrs: (0, $X5A94.EMPTY_OBJ),
        slots: (0, $X5A94.EMPTY_OBJ),
        refs: (0, $X5A94.EMPTY_OBJ),
        setupState: (0, $X5A94.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $78da16583ad93b9f$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $78da16583ad93b9f$var$currentInstance = null;
const $78da16583ad93b9f$export$f13e630aa3915748 = ()=>$78da16583ad93b9f$var$currentInstance || $78da16583ad93b9f$var$currentRenderingInstance;
let $78da16583ad93b9f$var$internalSetCurrentInstance;
let $78da16583ad93b9f$var$setInSSRSetupState;
{
    const g = (0, $X5A94.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $78da16583ad93b9f$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$78da16583ad93b9f$var$currentInstance = v1);
    $78da16583ad93b9f$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$78da16583ad93b9f$var$isInSSRComponentSetup = v1);
}const $78da16583ad93b9f$var$setCurrentInstance = (instance)=>{
    const prev = $78da16583ad93b9f$var$currentInstance;
    $78da16583ad93b9f$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $78da16583ad93b9f$var$internalSetCurrentInstance(prev);
    };
};
const $78da16583ad93b9f$var$unsetCurrentInstance = ()=>{
    $78da16583ad93b9f$var$currentInstance && $78da16583ad93b9f$var$currentInstance.scope.off();
    $78da16583ad93b9f$var$internalSetCurrentInstance(null);
};
const $78da16583ad93b9f$var$isBuiltInTag = /* @__PURE__ */ (0, $X5A94.makeMap)("slot,component");
function $78da16583ad93b9f$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($78da16583ad93b9f$var$isBuiltInTag(name) || isNativeTag(name)) $78da16583ad93b9f$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $78da16583ad93b9f$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $78da16583ad93b9f$var$isInSSRComponentSetup = false;
function $78da16583ad93b9f$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $78da16583ad93b9f$var$isStatefulComponent(instance);
    $78da16583ad93b9f$var$initProps(instance, props, isStateful, isSSR);
    $78da16583ad93b9f$var$initSlots(instance, children, optimized);
    const setupResult = isStateful ? $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $78da16583ad93b9f$var$setInSSRSetupState(false);
    return setupResult;
}
function $78da16583ad93b9f$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $78da16583ad93b9f$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $8bTPG.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $78da16583ad93b9f$var$createSetupContext(instance) : null;
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        const setupResult = $78da16583ad93b9f$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $X5A94.isPromise)(setupResult);
        (0, $8bTPG.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$78da16583ad93b9f$var$isAsyncWrapper(instance)) $78da16583ad93b9f$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($78da16583ad93b9f$var$unsetCurrentInstance, $78da16583ad93b9f$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $78da16583ad93b9f$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $78da16583ad93b9f$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR);
    } else $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
function $78da16583ad93b9f$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $X5A94.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $X5A94.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $8bTPG.proxyRefs)(setupResult);
    }
    $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR);
}
let $78da16583ad93b9f$var$compile;
let $78da16583ad93b9f$var$installWithProxy;
function $78da16583ad93b9f$export$667bb5a67822b941(_compile) {
    $78da16583ad93b9f$var$compile = _compile;
    $78da16583ad93b9f$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $78da16583ad93b9f$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $78da16583ad93b9f$export$c93a9c496c5211fa = ()=>!$78da16583ad93b9f$var$compile;
function $78da16583ad93b9f$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $78da16583ad93b9f$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $78da16583ad93b9f$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $X5A94.extend)((0, $X5A94.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $78da16583ad93b9f$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $X5A94.NOOP);
        if ($78da16583ad93b9f$var$installWithProxy) $78da16583ad93b9f$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $78da16583ad93b9f$var$setCurrentInstance(instance);
        (0, $8bTPG.pauseTracking)();
        try {
            $78da16583ad93b9f$var$applyOptions(instance);
        } finally{
            (0, $8bTPG.resetTracking)();
            reset();
        }
    }
}
const $78da16583ad93b9f$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $8bTPG.track)(target, "get", "");
        return target[key];
    }
};
function $78da16583ad93b9f$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $8bTPG.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $78da16583ad93b9f$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $78da16583ad93b9f$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $78da16583ad93b9f$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $8bTPG.proxyRefs)((0, $8bTPG.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $78da16583ad93b9f$var$publicPropertiesMap) return $78da16583ad93b9f$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $78da16583ad93b9f$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $78da16583ad93b9f$var$classifyRE = /(?:^|[-_])(\w)/g;
const $78da16583ad93b9f$var$classify = (str)=>str.replace($78da16583ad93b9f$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $78da16583ad93b9f$var$getComponentName(Component, includeInferred = true) {
    return (0, $X5A94.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $78da16583ad93b9f$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $78da16583ad93b9f$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $78da16583ad93b9f$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $78da16583ad93b9f$var$isClassComponent(value) {
    return (0, $X5A94.isFunction)(value) && "__vccOpts" in value;
}
const $78da16583ad93b9f$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $8bTPG.computed)(getterOrOptions, debugOptions, $78da16583ad93b9f$var$isInSSRComponentSetup);
    return c;
};
function $78da16583ad93b9f$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $X5A94.isObject)(propsOrChildren) && !(0, $X5A94.isArray)(propsOrChildren)) {
            if ($78da16583ad93b9f$export$3868d13f8734ae81(propsOrChildren)) return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $78da16583ad93b9f$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $78da16583ad93b9f$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $78da16583ad93b9f$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $78da16583ad93b9f$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $8bTPG.toRaw)(instance.props)));
        if (instance.setupState !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $X5A94.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $8bTPG.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $X5A94.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $X5A94.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $8bTPG.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $X5A94.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $X5A94.isArray)(opts) && opts.includes(key) || (0, $X5A94.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $8bTPG.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $78da16583ad93b9f$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $78da16583ad93b9f$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $78da16583ad93b9f$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $X5A94.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($78da16583ad93b9f$var$isBlockTreeEnabled > 0 && $78da16583ad93b9f$var$currentBlock) $78da16583ad93b9f$var$currentBlock.push(cached);
    return true;
}
const $78da16583ad93b9f$export$83d89fbfd8236492 = "3.5.13";
const $78da16583ad93b9f$export$c106dd0671a0fc2d = (0, $X5A94.NOOP);
const $78da16583ad93b9f$export$795e0ad4a0e2ed30 = $78da16583ad93b9f$var$ErrorTypeStrings$1;
const $78da16583ad93b9f$export$6922d3b3a607469e = $78da16583ad93b9f$var$devtools$1;
const $78da16583ad93b9f$export$b0c258b32c26c785 = $78da16583ad93b9f$var$setDevtoolsHook$1;
const $78da16583ad93b9f$var$_ssrUtils = {
    createComponentInstance: $78da16583ad93b9f$var$createComponentInstance,
    setupComponent: $78da16583ad93b9f$var$setupComponent,
    renderComponentRoot: $78da16583ad93b9f$var$renderComponentRoot,
    setCurrentRenderingInstance: $78da16583ad93b9f$var$setCurrentRenderingInstance,
    isVNode: $78da16583ad93b9f$export$3868d13f8734ae81,
    normalizeVNode: $78da16583ad93b9f$var$normalizeVNode,
    getComponentPublicInstance: $78da16583ad93b9f$var$getComponentPublicInstance,
    ensureValidVNode: $78da16583ad93b9f$var$ensureValidVNode,
    pushWarningContext: $78da16583ad93b9f$var$pushWarningContext,
    popWarningContext: $78da16583ad93b9f$var$popWarningContext
};
const $78da16583ad93b9f$export$a9679033567b336d = $78da16583ad93b9f$var$_ssrUtils;
const $78da16583ad93b9f$export$83cf26e06ea620e1 = null;
const $78da16583ad93b9f$export$dc678eddf276286e = null;
const $78da16583ad93b9f$export$22072a82865312f6 = null;

});
parcelRegister("8bTPG", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $5f6aa8fade9cc028$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $5f6aa8fade9cc028$export$7056603ea81600be);
$parcel$export(module.exports, "ReactiveEffect", () => $5f6aa8fade9cc028$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $5f6aa8fade9cc028$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $5f6aa8fade9cc028$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $5f6aa8fade9cc028$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $5f6aa8fade9cc028$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $5f6aa8fade9cc028$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $5f6aa8fade9cc028$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $5f6aa8fade9cc028$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $5f6aa8fade9cc028$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $5f6aa8fade9cc028$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $5f6aa8fade9cc028$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $5f6aa8fade9cc028$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $5f6aa8fade9cc028$export$92d09b48637741e7);
$parcel$export(module.exports, "shallowReactive", () => $5f6aa8fade9cc028$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $5f6aa8fade9cc028$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $5f6aa8fade9cc028$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $5f6aa8fade9cc028$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $5f6aa8fade9cc028$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $5f6aa8fade9cc028$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $5f6aa8fade9cc028$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $5f6aa8fade9cc028$export$2e9533675e5e70e0);
$parcel$export(module.exports, "computed", () => $5f6aa8fade9cc028$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $5f6aa8fade9cc028$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $5f6aa8fade9cc028$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $X5A94 = parcelRequire("X5A94");
function $5f6aa8fade9cc028$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $5f6aa8fade9cc028$var$activeEffectScope;
class $5f6aa8fade9cc028$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $5f6aa8fade9cc028$var$activeEffectScope;
        if (!detached && $5f6aa8fade9cc028$var$activeEffectScope) this.index = ($5f6aa8fade9cc028$var$activeEffectScope.scopes || ($5f6aa8fade9cc028$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $5f6aa8fade9cc028$var$activeEffectScope;
            try {
                $5f6aa8fade9cc028$var$activeEffectScope = this;
                return fn();
            } finally{
                $5f6aa8fade9cc028$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $5f6aa8fade9cc028$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $5f6aa8fade9cc028$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $5f6aa8fade9cc028$export$7056603ea81600be(detached) {
    return new $5f6aa8fade9cc028$export$1168ed9dbc71ddbd(detached);
}
function $5f6aa8fade9cc028$export$c7be4b0125a10cba() {
    return $5f6aa8fade9cc028$var$activeEffectScope;
}
function $5f6aa8fade9cc028$export$a780418acd4762da(fn, failSilently = false) {
    if ($5f6aa8fade9cc028$var$activeEffectScope) $5f6aa8fade9cc028$var$activeEffectScope.cleanups.push(fn);
}
let $5f6aa8fade9cc028$var$activeSub;
const $5f6aa8fade9cc028$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const $5f6aa8fade9cc028$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $5f6aa8fade9cc028$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($5f6aa8fade9cc028$var$activeEffectScope && $5f6aa8fade9cc028$var$activeEffectScope.active) $5f6aa8fade9cc028$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($5f6aa8fade9cc028$var$pausedQueueEffects.has(this)) {
                $5f6aa8fade9cc028$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $5f6aa8fade9cc028$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $5f6aa8fade9cc028$var$cleanupEffect(this);
        $5f6aa8fade9cc028$var$prepareDeps(this);
        const prevEffect = $5f6aa8fade9cc028$var$activeSub;
        const prevShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
        $5f6aa8fade9cc028$var$activeSub = this;
        $5f6aa8fade9cc028$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $5f6aa8fade9cc028$var$cleanupDeps(this);
            $5f6aa8fade9cc028$var$activeSub = prevEffect;
            $5f6aa8fade9cc028$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$5f6aa8fade9cc028$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $5f6aa8fade9cc028$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $5f6aa8fade9cc028$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($5f6aa8fade9cc028$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $5f6aa8fade9cc028$var$isDirty(this);
    }
}
let $5f6aa8fade9cc028$var$batchDepth = 0;
let $5f6aa8fade9cc028$var$batchedSub;
let $5f6aa8fade9cc028$var$batchedComputed;
function $5f6aa8fade9cc028$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $5f6aa8fade9cc028$var$batchedComputed;
        $5f6aa8fade9cc028$var$batchedComputed = sub;
        return;
    }
    sub.next = $5f6aa8fade9cc028$var$batchedSub;
    $5f6aa8fade9cc028$var$batchedSub = sub;
}
function $5f6aa8fade9cc028$var$startBatch() {
    $5f6aa8fade9cc028$var$batchDepth++;
}
function $5f6aa8fade9cc028$var$endBatch() {
    if (--$5f6aa8fade9cc028$var$batchDepth > 0) return;
    if ($5f6aa8fade9cc028$var$batchedComputed) {
        let e = $5f6aa8fade9cc028$var$batchedComputed;
        $5f6aa8fade9cc028$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($5f6aa8fade9cc028$var$batchedSub){
        let e = $5f6aa8fade9cc028$var$batchedSub;
        $5f6aa8fade9cc028$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $5f6aa8fade9cc028$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $5f6aa8fade9cc028$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $5f6aa8fade9cc028$var$removeSub(link);
            $5f6aa8fade9cc028$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $5f6aa8fade9cc028$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($5f6aa8fade9cc028$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $5f6aa8fade9cc028$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $5f6aa8fade9cc028$var$globalVersion) return;
    computed.globalVersion = $5f6aa8fade9cc028$var$globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !$5f6aa8fade9cc028$var$isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = $5f6aa8fade9cc028$var$activeSub;
    const prevShouldTrack = $5f6aa8fade9cc028$var$shouldTrack;
    $5f6aa8fade9cc028$var$activeSub = computed;
    $5f6aa8fade9cc028$var$shouldTrack = true;
    try {
        $5f6aa8fade9cc028$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $X5A94.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $5f6aa8fade9cc028$var$activeSub = prevSub;
        $5f6aa8fade9cc028$var$shouldTrack = prevShouldTrack;
        $5f6aa8fade9cc028$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $5f6aa8fade9cc028$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$5f6aa8fade9cc028$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $5f6aa8fade9cc028$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $5f6aa8fade9cc028$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $5f6aa8fade9cc028$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $5f6aa8fade9cc028$export$28352bb4dd362521(fn);
    if (options) (0, $X5A94.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $5f6aa8fade9cc028$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $5f6aa8fade9cc028$var$shouldTrack = true;
const $5f6aa8fade9cc028$var$trackStack = [];
function $5f6aa8fade9cc028$export$938a971395fef855() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = false;
}
function $5f6aa8fade9cc028$export$1f8ffc6fd33b1d16() {
    $5f6aa8fade9cc028$var$trackStack.push($5f6aa8fade9cc028$var$shouldTrack);
    $5f6aa8fade9cc028$var$shouldTrack = true;
}
function $5f6aa8fade9cc028$export$c39176b1babaa8b8() {
    const last = $5f6aa8fade9cc028$var$trackStack.pop();
    $5f6aa8fade9cc028$var$shouldTrack = last === void 0 ? true : last;
}
function $5f6aa8fade9cc028$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($5f6aa8fade9cc028$var$activeSub instanceof $5f6aa8fade9cc028$export$28352bb4dd362521) $5f6aa8fade9cc028$var$activeSub.cleanup = fn;
}
function $5f6aa8fade9cc028$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $5f6aa8fade9cc028$var$activeSub;
        $5f6aa8fade9cc028$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $5f6aa8fade9cc028$var$activeSub = prevSub;
        }
    }
}
let $5f6aa8fade9cc028$var$globalVersion = 0;
class $5f6aa8fade9cc028$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $5f6aa8fade9cc028$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$5f6aa8fade9cc028$var$activeSub || !$5f6aa8fade9cc028$var$shouldTrack || $5f6aa8fade9cc028$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $5f6aa8fade9cc028$var$activeSub) {
            link = this.activeLink = new $5f6aa8fade9cc028$var$Link($5f6aa8fade9cc028$var$activeSub, this);
            if (!$5f6aa8fade9cc028$var$activeSub.deps) $5f6aa8fade9cc028$var$activeSub.deps = $5f6aa8fade9cc028$var$activeSub.depsTail = link;
            else {
                link.prevDep = $5f6aa8fade9cc028$var$activeSub.depsTail;
                $5f6aa8fade9cc028$var$activeSub.depsTail.nextDep = link;
                $5f6aa8fade9cc028$var$activeSub.depsTail = link;
            }
            $5f6aa8fade9cc028$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $5f6aa8fade9cc028$var$activeSub.depsTail;
                link.nextDep = void 0;
                $5f6aa8fade9cc028$var$activeSub.depsTail.nextDep = link;
                $5f6aa8fade9cc028$var$activeSub.depsTail = link;
                if ($5f6aa8fade9cc028$var$activeSub.deps === link) $5f6aa8fade9cc028$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $5f6aa8fade9cc028$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $5f6aa8fade9cc028$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $5f6aa8fade9cc028$var$endBatch();
        }
    }
}
function $5f6aa8fade9cc028$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$5f6aa8fade9cc028$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $5f6aa8fade9cc028$var$targetMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$export$3c41b1a4e06acc14 = Symbol("");
const $5f6aa8fade9cc028$export$49093fa1cddcb78d = Symbol("");
const $5f6aa8fade9cc028$export$4f926f0baab682cd = Symbol("");
function $5f6aa8fade9cc028$export$6b2a7d5132615086(target, type, key) {
    if ($5f6aa8fade9cc028$var$shouldTrack && $5f6aa8fade9cc028$var$activeSub) {
        let depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
        if (!depsMap) $5f6aa8fade9cc028$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $5f6aa8fade9cc028$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5f6aa8fade9cc028$var$targetMap.get(target);
    if (!depsMap) {
        $5f6aa8fade9cc028$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $5f6aa8fade9cc028$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $X5A94.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $X5A94.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $5f6aa8fade9cc028$export$4f926f0baab682cd || !(0, $X5A94.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($5f6aa8fade9cc028$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                        if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                        if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $X5A94.isMap)(target)) run(depsMap.get($5f6aa8fade9cc028$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $5f6aa8fade9cc028$var$endBatch();
}
function $5f6aa8fade9cc028$var$getDepFromReactive(object, key) {
    const depMap = $5f6aa8fade9cc028$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $5f6aa8fade9cc028$export$1544eab4943788e4(array) {
    const raw = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $5f6aa8fade9cc028$export$6b2a7d5132615086(raw, "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    return $5f6aa8fade9cc028$export$7f3fe6025abfa26e(array) ? raw : raw.map($5f6aa8fade9cc028$export$45c769cf449a508c);
}
function $5f6aa8fade9cc028$export$5eb48af14254449e(arr) {
    $5f6aa8fade9cc028$export$6b2a7d5132615086(arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(arr), "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    return arr;
}
const $5f6aa8fade9cc028$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $5f6aa8fade9cc028$var$iterator(this, Symbol.iterator, $5f6aa8fade9cc028$export$45c769cf449a508c);
    },
    concat (...args) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $X5A94.isArray)(x) ? $5f6aa8fade9cc028$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $5f6aa8fade9cc028$var$iterator(this, "entries", (value)=>{
            value[1] = $5f6aa8fade9cc028$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "filter", fn, thisArg, (v)=>v.map($5f6aa8fade9cc028$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "find", fn, thisArg, $5f6aa8fade9cc028$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findLast", fn, thisArg, $5f6aa8fade9cc028$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $5f6aa8fade9cc028$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $5f6aa8fade9cc028$var$noTracking(this, "pop");
    },
    push (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $5f6aa8fade9cc028$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $5f6aa8fade9cc028$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $5f6aa8fade9cc028$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $5f6aa8fade9cc028$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $5f6aa8fade9cc028$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $5f6aa8fade9cc028$var$noTracking(this, "unshift", args);
    },
    values () {
        return $5f6aa8fade9cc028$var$iterator(this, "values", $5f6aa8fade9cc028$export$45c769cf449a508c);
    }
};
function $5f6aa8fade9cc028$var$iterator(self, method, wrapValue) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $5f6aa8fade9cc028$var$arrayProto = Array.prototype;
function $5f6aa8fade9cc028$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $5f6aa8fade9cc028$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $5f6aa8fade9cc028$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $5f6aa8fade9cc028$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $5f6aa8fade9cc028$var$reduce(self, method, fn, args) {
    const arr = $5f6aa8fade9cc028$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $5f6aa8fade9cc028$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $5f6aa8fade9cc028$var$searchProxy(self, method, args) {
    const arr = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(self);
    $5f6aa8fade9cc028$export$6b2a7d5132615086(arr, "iterate", $5f6aa8fade9cc028$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $5f6aa8fade9cc028$export$5f3ca29d057519b3(args[0])) {
        args[0] = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $5f6aa8fade9cc028$var$noTracking(self, method, args = []) {
    $5f6aa8fade9cc028$export$938a971395fef855();
    $5f6aa8fade9cc028$var$startBatch();
    const res = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $5f6aa8fade9cc028$var$endBatch();
    $5f6aa8fade9cc028$export$c39176b1babaa8b8();
    return res;
}
const $5f6aa8fade9cc028$var$isNonTrackableKeys = /* @__PURE__ */ (0, $X5A94.makeMap)(`__proto__,__v_isRef,__isVue`);
const $5f6aa8fade9cc028$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $X5A94.isSymbol)));
function $5f6aa8fade9cc028$var$hasOwnProperty(key) {
    if (!(0, $X5A94.isSymbol)(key)) key = String(key);
    const obj = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
    $5f6aa8fade9cc028$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $5f6aa8fade9cc028$var$shallowReadonlyMap : $5f6aa8fade9cc028$var$readonlyMap : isShallow2 ? $5f6aa8fade9cc028$var$shallowReactiveMap : $5f6aa8fade9cc028$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $X5A94.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $5f6aa8fade9cc028$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $5f6aa8fade9cc028$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $5f6aa8fade9cc028$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $X5A94.isSymbol)(key) ? $5f6aa8fade9cc028$var$builtInSymbols.has(key) : $5f6aa8fade9cc028$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $X5A94.isIntegerKey)(key) ? res : res.value;
        if ((0, $X5A94.isObject)(res)) return isReadonly2 ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(res) : $5f6aa8fade9cc028$export$90a44edba14e47be(res);
        return res;
    }
}
class $5f6aa8fade9cc028$var$MutableReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $5f6aa8fade9cc028$export$92d09b48637741e7(oldValue);
            if (!$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) {
                oldValue = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(oldValue);
                value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $X5A94.isArray)(target) && $5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $X5A94.isArray)(target) && (0, $X5A94.isIntegerKey)(key) ? Number(key) < target.length : (0, $X5A94.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $5f6aa8fade9cc028$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $5f6aa8fade9cc028$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $X5A94.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $X5A94.isSymbol)(key) || !$5f6aa8fade9cc028$var$builtInSymbols.has(key)) $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $5f6aa8fade9cc028$export$6b2a7d5132615086(target, "iterate", (0, $X5A94.isArray)(target) ? "length" : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $5f6aa8fade9cc028$var$ReadonlyReactiveHandler extends $5f6aa8fade9cc028$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $5f6aa8fade9cc028$var$mutableHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler();
const $5f6aa8fade9cc028$var$readonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler();
const $5f6aa8fade9cc028$var$shallowReactiveHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$MutableReactiveHandler(true);
const $5f6aa8fade9cc028$var$shallowReadonlyHandlers = /* @__PURE__ */ new $5f6aa8fade9cc028$var$ReadonlyReactiveHandler(true);
const $5f6aa8fade9cc028$var$toShallow = (value)=>value;
const $5f6aa8fade9cc028$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5f6aa8fade9cc028$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $X5A94.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $5f6aa8fade9cc028$var$toShallow : isReadonly2 ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
        !isReadonly2 && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $5f6aa8fade9cc028$export$49093fa1cddcb78d : $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $5f6aa8fade9cc028$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $5f6aa8fade9cc028$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", key);
                $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $5f6aa8fade9cc028$var$getProto(rawTarget);
            const wrap = shallow ? $5f6aa8fade9cc028$var$toShallow : readonly ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $5f6aa8fade9cc028$export$6b2a7d5132615086($5f6aa8fade9cc028$export$ab18938b9fc5f28e(target), "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $X5A94.hasChanged)(key, rawKey)) $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", key);
                $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $5f6aa8fade9cc028$var$toShallow : readonly ? $5f6aa8fade9cc028$export$4a78e7a2a4fb689f : $5f6aa8fade9cc028$export$45c769cf449a508c;
            !readonly && $5f6aa8fade9cc028$export$6b2a7d5132615086(rawTarget, "iterate", $5f6aa8fade9cc028$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $X5A94.extend)(instrumentations, readonly ? {
        add: $5f6aa8fade9cc028$var$createReadonlyMethod("add"),
        set: $5f6aa8fade9cc028$var$createReadonlyMethod("set"),
        delete: $5f6aa8fade9cc028$var$createReadonlyMethod("delete"),
        clear: $5f6aa8fade9cc028$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const proto = $5f6aa8fade9cc028$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) && !$5f6aa8fade9cc028$export$92d09b48637741e7(value)) value = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $X5A94.hasChanged)(value, oldValue)) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $5f6aa8fade9cc028$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $5f6aa8fade9cc028$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $5f6aa8fade9cc028$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $5f6aa8fade9cc028$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $5f6aa8fade9cc028$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $X5A94.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $5f6aa8fade9cc028$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, false)
};
const $5f6aa8fade9cc028$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(false, true)
};
const $5f6aa8fade9cc028$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, false)
};
const $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6aa8fade9cc028$var$createInstrumentationGetter(true, true)
};
function $5f6aa8fade9cc028$var$checkIdentityKeys(target, has, key) {
    const rawKey = $5f6aa8fade9cc028$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $X5A94.toRawType)(target);
        $5f6aa8fade9cc028$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $5f6aa8fade9cc028$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $5f6aa8fade9cc028$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $5f6aa8fade9cc028$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $5f6aa8fade9cc028$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $5f6aa8fade9cc028$var$targetTypeMap((0, $X5A94.toRawType)(value));
}
function $5f6aa8fade9cc028$export$90a44edba14e47be(target) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(target)) return target;
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$mutableHandlers, $5f6aa8fade9cc028$var$mutableCollectionHandlers, $5f6aa8fade9cc028$var$reactiveMap);
}
function $5f6aa8fade9cc028$export$8d81cefd22d22260(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, false, $5f6aa8fade9cc028$var$shallowReactiveHandlers, $5f6aa8fade9cc028$var$shallowCollectionHandlers, $5f6aa8fade9cc028$var$shallowReactiveMap);
}
function $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$readonlyHandlers, $5f6aa8fade9cc028$var$readonlyCollectionHandlers, $5f6aa8fade9cc028$var$readonlyMap);
}
function $5f6aa8fade9cc028$export$7c4b5f2b50f09f6b(target) {
    return $5f6aa8fade9cc028$var$createReactiveObject(target, true, $5f6aa8fade9cc028$var$shallowReadonlyHandlers, $5f6aa8fade9cc028$var$shallowReadonlyCollectionHandlers, $5f6aa8fade9cc028$var$shallowReadonlyMap);
}
function $5f6aa8fade9cc028$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $X5A94.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $5f6aa8fade9cc028$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5f6aa8fade9cc028$export$352205f445242f02(value) {
    if ($5f6aa8fade9cc028$export$92d09b48637741e7(value)) return $5f6aa8fade9cc028$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $5f6aa8fade9cc028$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $5f6aa8fade9cc028$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $5f6aa8fade9cc028$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $5f6aa8fade9cc028$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $5f6aa8fade9cc028$export$ab18938b9fc5f28e(raw) : observed;
}
function $5f6aa8fade9cc028$export$995ab8b13ad7a9d0(value) {
    if (!(0, $X5A94.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $X5A94.def)(value, "__v_skip", true);
    return value;
}
const $5f6aa8fade9cc028$export$45c769cf449a508c = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$90a44edba14e47be(value) : value;
const $5f6aa8fade9cc028$export$4a78e7a2a4fb689f = (value)=>(0, $X5A94.isObject)(value) ? $5f6aa8fade9cc028$export$6ec456bd5b7b3c51(value) : value;
function $5f6aa8fade9cc028$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $5f6aa8fade9cc028$export$eff4d24c3ff7876e(value) {
    return $5f6aa8fade9cc028$var$createRef(value, false);
}
function $5f6aa8fade9cc028$export$9b7bc5fe3b17c8b3(value) {
    return $5f6aa8fade9cc028$var$createRef(value, true);
}
function $5f6aa8fade9cc028$var$createRef(rawValue, shallow) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $5f6aa8fade9cc028$var$RefImpl(rawValue, shallow);
}
class $5f6aa8fade9cc028$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $5f6aa8fade9cc028$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $5f6aa8fade9cc028$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $5f6aa8fade9cc028$export$7f3fe6025abfa26e(newValue) || $5f6aa8fade9cc028$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $5f6aa8fade9cc028$export$ab18938b9fc5f28e(newValue);
        if ((0, $X5A94.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $5f6aa8fade9cc028$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $5f6aa8fade9cc028$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $5f6aa8fade9cc028$export$a239a76781616204(ref2) {
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $5f6aa8fade9cc028$export$30bdcc2218aa9458(source) {
    return (0, $X5A94.isFunction)(source) ? source() : $5f6aa8fade9cc028$export$a239a76781616204(source);
}
const $5f6aa8fade9cc028$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $5f6aa8fade9cc028$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(oldValue) && !$5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $5f6aa8fade9cc028$export$f353fd1b97db3fa0(objectWithRefs) {
    return $5f6aa8fade9cc028$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $5f6aa8fade9cc028$var$shallowUnwrapHandlers);
}
class $5f6aa8fade9cc028$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $5f6aa8fade9cc028$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $5f6aa8fade9cc028$export$a20c2dd6199824cb(factory) {
    return new $5f6aa8fade9cc028$var$CustomRefImpl(factory);
}
function $5f6aa8fade9cc028$export$2e9533675e5e70e0(object) {
    const ret = (0, $X5A94.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $5f6aa8fade9cc028$var$propertyToRef(object, key);
    return ret;
}
class $5f6aa8fade9cc028$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $5f6aa8fade9cc028$var$getDepFromReactive($5f6aa8fade9cc028$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $5f6aa8fade9cc028$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $5f6aa8fade9cc028$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $X5A94.isFunction)(source)) return new $5f6aa8fade9cc028$var$GetterRefImpl(source);
    else if ((0, $X5A94.isObject)(source) && arguments.length > 1) return $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue);
    else return $5f6aa8fade9cc028$export$eff4d24c3ff7876e(source);
}
function $5f6aa8fade9cc028$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $5f6aa8fade9cc028$export$4f9f5282de18fc69(val) ? val : new $5f6aa8fade9cc028$var$ObjectRefImpl(source, key, defaultValue);
}
class $5f6aa8fade9cc028$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $5f6aa8fade9cc028$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $5f6aa8fade9cc028$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $5f6aa8fade9cc028$var$activeSub !== this) {
            $5f6aa8fade9cc028$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $5f6aa8fade9cc028$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $5f6aa8fade9cc028$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $X5A94.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $5f6aa8fade9cc028$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $5f6aa8fade9cc028$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $5f6aa8fade9cc028$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $5f6aa8fade9cc028$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $5f6aa8fade9cc028$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE = {};
const $5f6aa8fade9cc028$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $5f6aa8fade9cc028$var$activeWatcher = void 0;
function $5f6aa8fade9cc028$export$2532f7acfca7c82d() {
    return $5f6aa8fade9cc028$var$activeWatcher;
}
function $5f6aa8fade9cc028$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $5f6aa8fade9cc028$var$activeWatcher) {
    if (owner) {
        let cleanups = $5f6aa8fade9cc028$var$cleanupMap.get(owner);
        if (!cleanups) $5f6aa8fade9cc028$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $5f6aa8fade9cc028$export$3db5d71bdb2d5499(source, cb, options = (0, $X5A94.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $5f6aa8fade9cc028$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($5f6aa8fade9cc028$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $5f6aa8fade9cc028$export$df3f009e3d155b20(source2, 1);
        return $5f6aa8fade9cc028$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $5f6aa8fade9cc028$export$7f3fe6025abfa26e(source);
    } else if ($5f6aa8fade9cc028$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $X5A94.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$5f6aa8fade9cc028$export$352205f445242f02(s) || $5f6aa8fade9cc028$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(s)) return s.value;
                else if ($5f6aa8fade9cc028$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $X5A94.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $X5A94.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $5f6aa8fade9cc028$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $5f6aa8fade9cc028$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $5f6aa8fade9cc028$var$activeWatcher;
            $5f6aa8fade9cc028$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $5f6aa8fade9cc028$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $X5A94.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$5f6aa8fade9cc028$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $5f6aa8fade9cc028$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $X5A94.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE) : $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $X5A94.hasChanged)(v, oldValue[i])) : (0, $X5A94.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $5f6aa8fade9cc028$var$activeWatcher;
                $5f6aa8fade9cc028$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $5f6aa8fade9cc028$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $5f6aa8fade9cc028$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $5f6aa8fade9cc028$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$5f6aa8fade9cc028$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $5f6aa8fade9cc028$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $5f6aa8fade9cc028$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $5f6aa8fade9cc028$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $X5A94.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($5f6aa8fade9cc028$export$4f9f5282de18fc69(value)) $5f6aa8fade9cc028$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $X5A94.isArray)(value)) for(let i = 0; i < value.length; i++)$5f6aa8fade9cc028$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $X5A94.isSet)(value) || (0, $X5A94.isMap)(value)) value.forEach((v)=>{
        $5f6aa8fade9cc028$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $X5A94.isPlainObject)(value)) {
        for(const key in value)$5f6aa8fade9cc028$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $5f6aa8fade9cc028$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("X5A94", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $0b19d744f65e59ab$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $0b19d744f65e59ab$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $0b19d744f65e59ab$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $0b19d744f65e59ab$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $0b19d744f65e59ab$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $0b19d744f65e59ab$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $0b19d744f65e59ab$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $0b19d744f65e59ab$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $0b19d744f65e59ab$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $0b19d744f65e59ab$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $0b19d744f65e59ab$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $0b19d744f65e59ab$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $0b19d744f65e59ab$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $0b19d744f65e59ab$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $0b19d744f65e59ab$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $0b19d744f65e59ab$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $0b19d744f65e59ab$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $0b19d744f65e59ab$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $0b19d744f65e59ab$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $0b19d744f65e59ab$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $0b19d744f65e59ab$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $0b19d744f65e59ab$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $0b19d744f65e59ab$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $0b19d744f65e59ab$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $0b19d744f65e59ab$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $0b19d744f65e59ab$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $0b19d744f65e59ab$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $0b19d744f65e59ab$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $0b19d744f65e59ab$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $0b19d744f65e59ab$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $0b19d744f65e59ab$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $0b19d744f65e59ab$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $0b19d744f65e59ab$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $0b19d744f65e59ab$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $0b19d744f65e59ab$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $0b19d744f65e59ab$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $0b19d744f65e59ab$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $0b19d744f65e59ab$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $0b19d744f65e59ab$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $0b19d744f65e59ab$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $0b19d744f65e59ab$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $0b19d744f65e59ab$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $0b19d744f65e59ab$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $0b19d744f65e59ab$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $0b19d744f65e59ab$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $0b19d744f65e59ab$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $0b19d744f65e59ab$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $0b19d744f65e59ab$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $0b19d744f65e59ab$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $0b19d744f65e59ab$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $0b19d744f65e59ab$export$b5b1545233b45293);
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0b19d744f65e59ab$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $0b19d744f65e59ab$export$cf583d23ab39677c = {};
const $0b19d744f65e59ab$export$6bd8558f433f1cc1 = [];
const $0b19d744f65e59ab$export$5702a91a6f42969f = ()=>{};
const $0b19d744f65e59ab$export$c01351c0af048e39 = ()=>false;
const $0b19d744f65e59ab$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $0b19d744f65e59ab$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $0b19d744f65e59ab$export$8b58be045bf06082 = Object.assign;
const $0b19d744f65e59ab$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $0b19d744f65e59ab$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0b19d744f65e59ab$export$b5a638e9b3fff9f3 = (val, key)=>$0b19d744f65e59ab$var$hasOwnProperty.call(val, key);
const $0b19d744f65e59ab$export$43bee75e5e14138e = Array.isArray;
const $0b19d744f65e59ab$export$5c90113a285f2241 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Map]";
const $0b19d744f65e59ab$export$6750766a7c7ec627 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Set]";
const $0b19d744f65e59ab$export$871608497c498473 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Date]";
const $0b19d744f65e59ab$export$49841c62b9eff15 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object RegExp]";
const $0b19d744f65e59ab$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $0b19d744f65e59ab$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $0b19d744f65e59ab$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $0b19d744f65e59ab$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $0b19d744f65e59ab$export$4369c812aac99591 = (val)=>{
    return ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) || $0b19d744f65e59ab$export$f6e2535fb5126e54(val)) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.then) && $0b19d744f65e59ab$export$f6e2535fb5126e54(val.catch);
};
const $0b19d744f65e59ab$export$830c053460e5ddf6 = Object.prototype.toString;
const $0b19d744f65e59ab$export$1dccc787cc36538b = (value)=>$0b19d744f65e59ab$export$830c053460e5ddf6.call(value);
const $0b19d744f65e59ab$export$5ad0a3c360b8fbb5 = (value)=>{
    return $0b19d744f65e59ab$export$1dccc787cc36538b(value).slice(8, -1);
};
const $0b19d744f65e59ab$export$53b83ca8eaab0383 = (val)=>$0b19d744f65e59ab$export$1dccc787cc36538b(val) === "[object Object]";
const $0b19d744f65e59ab$export$e2a2b93446ec9fe = (key)=>$0b19d744f65e59ab$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $0b19d744f65e59ab$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $0b19d744f65e59ab$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $0b19d744f65e59ab$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $0b19d744f65e59ab$var$camelizeRE = /-(\w)/g;
const $0b19d744f65e59ab$export$161d051f5dd25de7 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.replace($0b19d744f65e59ab$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $0b19d744f65e59ab$var$hyphenateRE = /\B([A-Z])/g;
const $0b19d744f65e59ab$export$6e6a0a3676c4b8bb = $0b19d744f65e59ab$var$cacheStringFunction((str)=>str.replace($0b19d744f65e59ab$var$hyphenateRE, "-$1").toLowerCase());
const $0b19d744f65e59ab$export$9a00dee1beb8f576 = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $0b19d744f65e59ab$export$8c022799eeaaefcd = $0b19d744f65e59ab$var$cacheStringFunction((str)=>{
    const s = str ? `on${$0b19d744f65e59ab$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $0b19d744f65e59ab$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $0b19d744f65e59ab$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $0b19d744f65e59ab$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $0b19d744f65e59ab$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $0b19d744f65e59ab$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $0b19d744f65e59ab$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $0b19d744f65e59ab$var$_globalThis;
const $0b19d744f65e59ab$export$ff5f2eeb11fc7e14 = ()=>{
    return $0b19d744f65e59ab$var$_globalThis || ($0b19d744f65e59ab$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $0b19d744f65e59ab$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $0b19d744f65e59ab$export$53d5e12f9a1d3cde(name) {
    return $0b19d744f65e59ab$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $0b19d744f65e59ab$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $0b19d744f65e59ab$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $0b19d744f65e59ab$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $0b19d744f65e59ab$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $0b19d744f65e59ab$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $0b19d744f65e59ab$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $0b19d744f65e59ab$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $0b19d744f65e59ab$export$f73b8c13b7f97ebf = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$GLOBALS_ALLOWED);
const $0b19d744f65e59ab$export$d6571a1911e4f27e = $0b19d744f65e59ab$export$f73b8c13b7f97ebf;
const $0b19d744f65e59ab$var$range = 2;
function $0b19d744f65e59ab$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $0b19d744f65e59ab$var$range; j <= i + $0b19d744f65e59ab$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $0b19d744f65e59ab$export$8756898546458274(value) {
    if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $0b19d744f65e59ab$export$844ec244b1367d54(item) ? $0b19d744f65e59ab$export$76a205ce979d066a(item) : $0b19d744f65e59ab$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) return value;
}
const $0b19d744f65e59ab$var$listDelimiterRE = /;(?![^(]*\))/g;
const $0b19d744f65e59ab$var$propertyDelimiterRE = /:([^]+)/;
const $0b19d744f65e59ab$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $0b19d744f65e59ab$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($0b19d744f65e59ab$var$styleCommentRE, "").split($0b19d744f65e59ab$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($0b19d744f65e59ab$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $0b19d744f65e59ab$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($0b19d744f65e59ab$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($0b19d744f65e59ab$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $0b19d744f65e59ab$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($0b19d744f65e59ab$export$844ec244b1367d54(value)) res = value;
    else if ($0b19d744f65e59ab$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $0b19d744f65e59ab$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$0b19d744f65e59ab$export$844ec244b1367d54(klass)) props.class = $0b19d744f65e59ab$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $0b19d744f65e59ab$export$8756898546458274(style);
    return props;
}
const $0b19d744f65e59ab$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $0b19d744f65e59ab$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $0b19d744f65e59ab$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $0b19d744f65e59ab$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $0b19d744f65e59ab$export$1ccf854a0984f890 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$HTML_TAGS);
const $0b19d744f65e59ab$export$6328ce7565ea1049 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$SVG_TAGS);
const $0b19d744f65e59ab$export$4a46ca4c5be17b20 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$MATH_TAGS);
const $0b19d744f65e59ab$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$VOID_TAGS);
const $0b19d744f65e59ab$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $0b19d744f65e59ab$export$d186f5eb2e810715 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs);
const $0b19d744f65e59ab$export$f763ba3b84e9cd8c = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8($0b19d744f65e59ab$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $0b19d744f65e59ab$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $0b19d744f65e59ab$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $0b19d744f65e59ab$var$attrValidationCache = {};
function $0b19d744f65e59ab$export$d55ef77660f30d12(name) {
    if ($0b19d744f65e59ab$var$attrValidationCache.hasOwnProperty(name)) return $0b19d744f65e59ab$var$attrValidationCache[name];
    const isUnsafe = $0b19d744f65e59ab$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $0b19d744f65e59ab$var$attrValidationCache[name] = !isUnsafe;
}
const $0b19d744f65e59ab$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $0b19d744f65e59ab$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $0b19d744f65e59ab$export$80da416f43933831 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $0b19d744f65e59ab$export$fc0748a8e0014066 = /* @__PURE__ */ $0b19d744f65e59ab$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $0b19d744f65e59ab$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $0b19d744f65e59ab$var$escapeRE = /["'&<>]/;
function $0b19d744f65e59ab$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $0b19d744f65e59ab$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $0b19d744f65e59ab$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $0b19d744f65e59ab$export$7b105034a53bde5f(src) {
    return src.replace($0b19d744f65e59ab$var$commentStripRE, "");
}
const $0b19d744f65e59ab$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $0b19d744f65e59ab$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($0b19d744f65e59ab$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $0b19d744f65e59ab$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $0b19d744f65e59ab$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $0b19d744f65e59ab$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $0b19d744f65e59ab$export$871608497c498473(a);
    let bValidType = $0b19d744f65e59ab$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(a);
    bValidType = $0b19d744f65e59ab$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(a);
    bValidType = $0b19d744f65e59ab$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $0b19d744f65e59ab$var$looseCompareArrays(a, b) : false;
    aValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(a);
    bValidType = $0b19d744f65e59ab$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$0b19d744f65e59ab$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $0b19d744f65e59ab$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$0b19d744f65e59ab$export$ae8015769846262c(item, val));
}
const $0b19d744f65e59ab$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $0b19d744f65e59ab$export$b5b1545233b45293 = (val)=>{
    return $0b19d744f65e59ab$export$844ec244b1367d54(val) ? val : val == null ? "" : $0b19d744f65e59ab$export$43bee75e5e14138e(val) || $0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && (val.toString === $0b19d744f65e59ab$export$830c053460e5ddf6 || !$0b19d744f65e59ab$export$f6e2535fb5126e54(val.toString)) ? $0b19d744f65e59ab$var$isRef(val) ? $0b19d744f65e59ab$export$b5b1545233b45293(val.value) : JSON.stringify(val, $0b19d744f65e59ab$var$replacer, 2) : String(val);
};
const $0b19d744f65e59ab$var$replacer = (_key, val)=>{
    if ($0b19d744f65e59ab$var$isRef(val)) return $0b19d744f65e59ab$var$replacer(_key, val.value);
    else if ($0b19d744f65e59ab$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$0b19d744f65e59ab$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($0b19d744f65e59ab$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$0b19d744f65e59ab$var$stringifySymbol(v))
    };
    else if ($0b19d744f65e59ab$export$a244864fd9645c7f(val)) return $0b19d744f65e59ab$var$stringifySymbol(val);
    else if ($0b19d744f65e59ab$export$a6cdc56e425d0d0a(val) && !$0b19d744f65e59ab$export$43bee75e5e14138e(val) && !$0b19d744f65e59ab$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $0b19d744f65e59ab$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $0b19d744f65e59ab$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("dDLnc", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("ani5R")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("ani5R")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("ani5R")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("X5A94")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("ani5R")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("ani5R")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("ani5R")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("ani5R")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("ani5R")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("ani5R")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("ani5R")).createRenderer);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("ani5R")).createSlots);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("ani5R")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("ani5R")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("8bTPG")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("ani5R")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("ani5R")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("ani5R")).getTransitionRawChildren);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("ani5R")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("ani5R")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("ani5R")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("ani5R")).isRuntimeOnly);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("8bTPG")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("ani5R")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("X5A94")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("X5A94")).normalizeStyle);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("ani5R")).onBeforeUpdate);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("ani5R")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("ani5R")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("ani5R")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("ani5R")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("ani5R")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("ani5R")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("ani5R")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("ani5R")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("ani5R")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("ani5R")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("ani5R")).setTransitionHooks);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("8bTPG")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("ani5R")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("ani5R")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("ani5R")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("8bTPG")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("ani5R")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("ani5R")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("ani5R")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("ani5R")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("ani5R")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("8bTPG")).effectScope);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("8bTPG")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("X5A94")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("X5A94")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $9ee3aa3420ae2c81$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $9ee3aa3420ae2c81$export$4e373c34abfa8c68);
$parcel$export(module.exports, "vModelText", () => $9ee3aa3420ae2c81$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $9ee3aa3420ae2c81$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $9ee3aa3420ae2c81$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $9ee3aa3420ae2c81$export$87d227567b51ca39);
$parcel$export(module.exports, "withModifiers", () => $9ee3aa3420ae2c81$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $9ee3aa3420ae2c81$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $8bTPG = parcelRequire("8bTPG");
var $8bTPG = parcelRequire("8bTPG");parcelRequire("X5A94");

var $X5A94 = parcelRequire("X5A94");
let $9ee3aa3420ae2c81$var$policy = void 0;
const $9ee3aa3420ae2c81$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($9ee3aa3420ae2c81$var$tt) try {
    $9ee3aa3420ae2c81$var$policy = /* @__PURE__ */ $9ee3aa3420ae2c81$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $9ee3aa3420ae2c81$var$unsafeToTrustedHTML = $9ee3aa3420ae2c81$var$policy ? (val)=>$9ee3aa3420ae2c81$var$policy.createHTML(val) : (val)=>val;
const $9ee3aa3420ae2c81$var$svgNS = "http://www.w3.org/2000/svg";
const $9ee3aa3420ae2c81$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $9ee3aa3420ae2c81$var$doc = typeof document !== "undefined" ? document : null;
const $9ee3aa3420ae2c81$var$templateContainer = $9ee3aa3420ae2c81$var$doc && /* @__PURE__ */ $9ee3aa3420ae2c81$var$doc.createElement("template");
const $9ee3aa3420ae2c81$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$svgNS, tag) : namespace === "mathml" ? $9ee3aa3420ae2c81$var$doc.createElementNS($9ee3aa3420ae2c81$var$mathmlNS, tag) : is ? $9ee3aa3420ae2c81$var$doc.createElement(tag, {
            is: is
        }) : $9ee3aa3420ae2c81$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$9ee3aa3420ae2c81$var$doc.createTextNode(text),
    createComment: (text)=>$9ee3aa3420ae2c81$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$9ee3aa3420ae2c81$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $9ee3aa3420ae2c81$var$templateContainer.innerHTML = $9ee3aa3420ae2c81$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $9ee3aa3420ae2c81$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $9ee3aa3420ae2c81$var$TRANSITION = "transition";
const $9ee3aa3420ae2c81$var$ANIMATION = "animation";
const $9ee3aa3420ae2c81$var$vtcKey = Symbol("_vtc");
const $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $9ee3aa3420ae2c81$var$TransitionPropsValidators = /* @__PURE__ */ (0, $X5A94.extend)({}, (0, $ani5R.BaseTransitionPropsValidators), $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators);
const $9ee3aa3420ae2c81$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $9ee3aa3420ae2c81$var$TransitionPropsValidators;
    return t;
};
const $9ee3aa3420ae2c81$export$be58926105124dd4 = /* @__PURE__ */ $9ee3aa3420ae2c81$var$decorate$1((props, { slots: slots })=>(0, $ani5R.h)((0, $ani5R.BaseTransition), $9ee3aa3420ae2c81$var$resolveTransitionProps(props), slots));
const $9ee3aa3420ae2c81$var$callHook = (hook, args = [])=>{
    if ((0, $X5A94.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $9ee3aa3420ae2c81$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $X5A94.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $9ee3aa3420ae2c81$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $9ee3aa3420ae2c81$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveToClass);
        $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $9ee3aa3420ae2c81$var$callHook(hook, [
                el,
                resolve
            ]);
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(hook)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $X5A94.extend)(baseProps, {
        onBeforeEnter (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeEnter, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $9ee3aa3420ae2c81$var$callHook(onBeforeAppear, [
                el
            ]);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearFromClass);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $9ee3aa3420ae2c81$var$forceReflow();
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveActiveClass);
                $9ee3aa3420ae2c81$var$forceReflow();
            }
            $9ee3aa3420ae2c81$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $9ee3aa3420ae2c81$var$removeTransitionClass(el, leaveFromClass);
                $9ee3aa3420ae2c81$var$addTransitionClass(el, leaveToClass);
                if (!$9ee3aa3420ae2c81$var$hasExplicitCallback(onLeave)) $9ee3aa3420ae2c81$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $9ee3aa3420ae2c81$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $9ee3aa3420ae2c81$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $9ee3aa3420ae2c81$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $9ee3aa3420ae2c81$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $9ee3aa3420ae2c81$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $X5A94.isObject)(duration)) return [
        $9ee3aa3420ae2c81$var$NumberOf(duration.enter),
        $9ee3aa3420ae2c81$var$NumberOf(duration.leave)
    ];
    else {
        const n = $9ee3aa3420ae2c81$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $9ee3aa3420ae2c81$var$NumberOf(val) {
    const res = (0, $X5A94.toNumber)(val);
    return res;
}
function $9ee3aa3420ae2c81$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$9ee3aa3420ae2c81$var$vtcKey] || (el[$9ee3aa3420ae2c81$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $9ee3aa3420ae2c81$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$9ee3aa3420ae2c81$var$vtcKey] = void 0;
    }
}
function $9ee3aa3420ae2c81$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $9ee3aa3420ae2c81$var$endId = 0;
function $9ee3aa3420ae2c81$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$9ee3aa3420ae2c81$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $9ee3aa3420ae2c81$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Duration`);
    const transitionTimeout = $9ee3aa3420ae2c81$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$9ee3aa3420ae2c81$var$ANIMATION}Duration`);
    const animationTimeout = $9ee3aa3420ae2c81$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $9ee3aa3420ae2c81$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $9ee3aa3420ae2c81$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $9ee3aa3420ae2c81$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $9ee3aa3420ae2c81$var$TRANSITION : $9ee3aa3420ae2c81$var$ANIMATION : null;
        propCount = type ? type === $9ee3aa3420ae2c81$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $9ee3aa3420ae2c81$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$9ee3aa3420ae2c81$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $9ee3aa3420ae2c81$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$9ee3aa3420ae2c81$var$toMs(d) + $9ee3aa3420ae2c81$var$toMs(delays[i])));
}
function $9ee3aa3420ae2c81$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $9ee3aa3420ae2c81$var$forceReflow() {
    return document.body.offsetHeight;
}
function $9ee3aa3420ae2c81$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $9ee3aa3420ae2c81$var$vShowOriginalDisplay = Symbol("_vod");
const $9ee3aa3420ae2c81$var$vShowHidden = Symbol("_vsh");
const $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $9ee3aa3420ae2c81$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $9ee3aa3420ae2c81$var$setDisplay(el, false);
            });
        } else $9ee3aa3420ae2c81$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setDisplay(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setDisplay(el, value) {
    el.style.display = value ? el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] : "none";
    el[$9ee3aa3420ae2c81$var$vShowHidden] = !value;
}
function $9ee3aa3420ae2c81$var$initVShowForSSR() {
    $9ee3aa3420ae2c81$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $9ee3aa3420ae2c81$var$CSS_VAR_TEXT = Symbol("");
function $9ee3aa3420ae2c81$export$ef28b76f07940108(getter) {
    const instance = (0, $ani5R.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$9ee3aa3420ae2c81$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $9ee3aa3420ae2c81$var$setVarsOnNode(instance.ce, vars);
        else $9ee3aa3420ae2c81$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $ani5R.onBeforeUpdate)(()=>{
        (0, $ani5R.queuePostFlushCb)(setVars);
    });
    (0, $ani5R.onMounted)(()=>{
        (0, $ani5R.watch)(setVars, (0, $X5A94.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $ani5R.onUnmounted)(()=>ob.disconnect());
    });
}
function $9ee3aa3420ae2c81$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $9ee3aa3420ae2c81$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $9ee3aa3420ae2c81$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $ani5R.Fragment)) vnode.children.forEach((c)=>$9ee3aa3420ae2c81$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $ani5R.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $9ee3aa3420ae2c81$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT] = cssText;
    }
}
const $9ee3aa3420ae2c81$var$displayRE = /(^|;)\s*display\s*:/;
function $9ee3aa3420ae2c81$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $X5A94.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $X5A94.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $9ee3aa3420ae2c81$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $9ee3aa3420ae2c81$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$9ee3aa3420ae2c81$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $9ee3aa3420ae2c81$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($9ee3aa3420ae2c81$var$vShowOriginalDisplay in el) {
        el[$9ee3aa3420ae2c81$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$9ee3aa3420ae2c81$var$vShowHidden]) style.display = "none";
    }
}
const $9ee3aa3420ae2c81$var$semicolonRE = /[^\\];\s*$/;
const $9ee3aa3420ae2c81$var$importantRE = /\s*!important$/;
function $9ee3aa3420ae2c81$var$setStyle(style, name, val) {
    if ((0, $X5A94.isArray)(val)) val.forEach((v)=>$9ee3aa3420ae2c81$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $9ee3aa3420ae2c81$var$autoPrefix(style, name);
            if ($9ee3aa3420ae2c81$var$importantRE.test(val)) style.setProperty((0, $X5A94.hyphenate)(prefixed), val.replace($9ee3aa3420ae2c81$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $9ee3aa3420ae2c81$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $9ee3aa3420ae2c81$var$prefixCache = {};
function $9ee3aa3420ae2c81$var$autoPrefix(style, rawName) {
    const cached = $9ee3aa3420ae2c81$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $X5A94.camelize)(rawName);
    if (name !== "filter" && name in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = name;
    name = (0, $X5A94.capitalize)(name);
    for(let i = 0; i < $9ee3aa3420ae2c81$var$prefixes.length; i++){
        const prefixed = $9ee3aa3420ae2c81$var$prefixes[i] + name;
        if (prefixed in style) return $9ee3aa3420ae2c81$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $9ee3aa3420ae2c81$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $9ee3aa3420ae2c81$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $X5A94.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($9ee3aa3420ae2c81$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $X5A94.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $X5A94.isSymbol)(value) ? String(value) : value);
}
function $9ee3aa3420ae2c81$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $9ee3aa3420ae2c81$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $X5A94.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $9ee3aa3420ae2c81$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $9ee3aa3420ae2c81$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $9ee3aa3420ae2c81$var$veiKey = Symbol("_vei");
function $9ee3aa3420ae2c81$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$9ee3aa3420ae2c81$var$veiKey] || (el[$9ee3aa3420ae2c81$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $9ee3aa3420ae2c81$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $9ee3aa3420ae2c81$var$createInvoker(nextValue, instance);
            $9ee3aa3420ae2c81$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $9ee3aa3420ae2c81$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $9ee3aa3420ae2c81$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $9ee3aa3420ae2c81$var$parseName(name) {
    let options;
    if ($9ee3aa3420ae2c81$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($9ee3aa3420ae2c81$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $X5A94.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $9ee3aa3420ae2c81$var$cachedNow = 0;
const $9ee3aa3420ae2c81$var$p = /* @__PURE__ */ Promise.resolve();
const $9ee3aa3420ae2c81$var$getNow = ()=>$9ee3aa3420ae2c81$var$cachedNow || ($9ee3aa3420ae2c81$var$p.then(()=>$9ee3aa3420ae2c81$var$cachedNow = 0), $9ee3aa3420ae2c81$var$cachedNow = Date.now());
function $9ee3aa3420ae2c81$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $ani5R.callWithAsyncErrorHandling)($9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $9ee3aa3420ae2c81$var$getNow();
    return invoker;
}
function $9ee3aa3420ae2c81$var$sanitizeEventValue(value, propName) {
    if ((0, $X5A94.isFunction)(value) || (0, $X5A94.isArray)(value)) return value;
    (0, $ani5R.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $X5A94.NOOP;
}
function $9ee3aa3420ae2c81$var$patchStopImmediatePropagation(e, value) {
    if ((0, $X5A94.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $9ee3aa3420ae2c81$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $9ee3aa3420ae2c81$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $9ee3aa3420ae2c81$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $9ee3aa3420ae2c81$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $X5A94.isOn)(key)) {
        if (!(0, $X5A94.isModelListener)(key)) $9ee3aa3420ae2c81$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $9ee3aa3420ae2c81$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $X5A94.isString)(nextValue))) $9ee3aa3420ae2c81$var$patchDOMProp(el, (0, $X5A94.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $9ee3aa3420ae2c81$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $9ee3aa3420ae2c81$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($9ee3aa3420ae2c81$var$isNativeOn(key) && (0, $X5A94.isString)(value)) return false;
    return key in el;
}
const $9ee3aa3420ae2c81$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $ani5R.defineComponent)(options, extraOptions);
    if ((0, $X5A94.isPlainObject)(Comp)) (0, $X5A94.extend)(Comp, extraOptions);
    class VueCustomElement extends $9ee3aa3420ae2c81$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $9ee3aa3420ae2c81$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $9ee3aa3420ae2c81$export$a00e2346eabbdbef(options, extraOptions, $9ee3aa3420ae2c81$export$35800275c0037383);
};
const $9ee3aa3420ae2c81$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $9ee3aa3420ae2c81$export$b337c1a55163dbe3 extends $9ee3aa3420ae2c81$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $9ee3aa3420ae2c81$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $9ee3aa3420ae2c81$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $9ee3aa3420ae2c81$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $ani5R.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $X5A94.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $X5A94.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $X5A94.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $X5A94.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $8bTPG.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $X5A94.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $X5A94.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $9ee3aa3420ae2c81$var$REMOVAL;
        const camelKey = (0, $X5A94.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $X5A94.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $9ee3aa3420ae2c81$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $X5A94.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $X5A94.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $X5A94.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        $9ee3aa3420ae2c81$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $ani5R.createVNode)(this._def, (0, $X5A94.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $X5A94.isPlainObject)(args[0]) ? (0, $X5A94.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $X5A94.hyphenate)(event) !== event) dispatch((0, $X5A94.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $9ee3aa3420ae2c81$export$da5acfe93a94e37d(caller) {
    const instance = (0, $ani5R.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $ani5R.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $ani5R.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $9ee3aa3420ae2c81$export$64d45095031fa749() {
    const el = $9ee3aa3420ae2c81$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $9ee3aa3420ae2c81$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $ani5R.getCurrentInstance)();
        if (!instance) return 0, $X5A94.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $X5A94.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $X5A94.EMPTY_OBJ;
        return mod;
    }
}
const $9ee3aa3420ae2c81$var$positionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $9ee3aa3420ae2c81$var$moveCbKey = Symbol("_moveCb");
const $9ee3aa3420ae2c81$var$enterCbKey = Symbol("_enterCb");
const $9ee3aa3420ae2c81$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $9ee3aa3420ae2c81$var$TransitionGroupImpl = /* @__PURE__ */ $9ee3aa3420ae2c81$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $X5A94.extend)({}, $9ee3aa3420ae2c81$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $ani5R.getCurrentInstance)();
        const state = (0, $ani5R.useTransitionState)();
        let prevChildren;
        let children;
        (0, $ani5R.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$9ee3aa3420ae2c81$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($9ee3aa3420ae2c81$var$callPendingCbs);
            prevChildren.forEach($9ee3aa3420ae2c81$var$recordPosition);
            const movedChildren = prevChildren.filter($9ee3aa3420ae2c81$var$applyTranslation);
            $9ee3aa3420ae2c81$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $9ee3aa3420ae2c81$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$9ee3aa3420ae2c81$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$9ee3aa3420ae2c81$var$moveCbKey] = null;
                        $9ee3aa3420ae2c81$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $8bTPG.toRaw)(props);
            const cssTransitionProps = $9ee3aa3420ae2c81$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $ani5R.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $9ee3aa3420ae2c81$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $ani5R.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $ani5R.setTransitionHooks)(child, (0, $ani5R.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $ani5R.createVNode)(tag, null, children);
        };
    }
});
const $9ee3aa3420ae2c81$export$19ffa8f511f7bc2e = $9ee3aa3420ae2c81$var$TransitionGroupImpl;
function $9ee3aa3420ae2c81$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$9ee3aa3420ae2c81$var$moveCbKey]) el[$9ee3aa3420ae2c81$var$moveCbKey]();
    if (el[$9ee3aa3420ae2c81$var$enterCbKey]) el[$9ee3aa3420ae2c81$var$enterCbKey]();
}
function $9ee3aa3420ae2c81$var$recordPosition(c) {
    $9ee3aa3420ae2c81$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $9ee3aa3420ae2c81$var$applyTranslation(c) {
    const oldPos = $9ee3aa3420ae2c81$var$positionMap.get(c);
    const newPos = $9ee3aa3420ae2c81$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $9ee3aa3420ae2c81$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$9ee3aa3420ae2c81$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $9ee3aa3420ae2c81$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $9ee3aa3420ae2c81$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $X5A94.isArray)(fn) ? (value)=>(0, $X5A94.invokeArrayFns)(fn, value) : fn;
};
function $9ee3aa3420ae2c81$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $9ee3aa3420ae2c81$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $9ee3aa3420ae2c81$var$assignKey = Symbol("_assign");
const $9ee3aa3420ae2c81$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $9ee3aa3420ae2c81$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $X5A94.looseToNumber)(domValue);
            el[$9ee3aa3420ae2c81$var$assignKey](domValue);
        });
        if (trim) $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionstart", $9ee3aa3420ae2c81$var$onCompositionStart);
            $9ee3aa3420ae2c81$var$addEventListener(el, "compositionend", $9ee3aa3420ae2c81$var$onCompositionEnd);
            $9ee3aa3420ae2c81$var$addEventListener(el, "change", $9ee3aa3420ae2c81$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $X5A94.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $9ee3aa3420ae2c81$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $9ee3aa3420ae2c81$var$getValue(el);
            const checked = el.checked;
            const assign = el[$9ee3aa3420ae2c81$var$assignKey];
            if ((0, $X5A94.isArray)(modelValue)) {
                const index = (0, $X5A94.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $X5A94.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($9ee3aa3420ae2c81$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $9ee3aa3420ae2c81$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$setChecked(el, binding, vnode);
    }
};
function $9ee3aa3420ae2c81$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $X5A94.isArray)(value)) checked = (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $X5A94.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $X5A94.looseEqual)(value, $9ee3aa3420ae2c81$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $9ee3aa3420ae2c81$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            el[$9ee3aa3420ae2c81$var$assignKey]($9ee3aa3420ae2c81$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $X5A94.looseEqual)(value, vnode.props.value);
    }
};
const $9ee3aa3420ae2c81$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $X5A94.isSet)(value);
        $9ee3aa3420ae2c81$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $X5A94.looseToNumber)($9ee3aa3420ae2c81$var$getValue(o)) : $9ee3aa3420ae2c81$var$getValue(o));
            el[$9ee3aa3420ae2c81$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $ani5R.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $9ee3aa3420ae2c81$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$9ee3aa3420ae2c81$var$assignKey] = $9ee3aa3420ae2c81$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $9ee3aa3420ae2c81$var$setSelected(el, value);
    }
};
function $9ee3aa3420ae2c81$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $X5A94.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $X5A94.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $9ee3aa3420ae2c81$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $X5A94.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $X5A94.looseEqual)($9ee3aa3420ae2c81$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $9ee3aa3420ae2c81$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $9ee3aa3420ae2c81$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $9ee3aa3420ae2c81$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $9ee3aa3420ae2c81$export$87d227567b51ca39;
        case "TEXTAREA":
            return $9ee3aa3420ae2c81$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $9ee3aa3420ae2c81$export$8847c2e532b35714;
                case "radio":
                    return $9ee3aa3420ae2c81$export$b4356c59b38b7aa9;
                default:
                    return $9ee3aa3420ae2c81$export$f1f88689f5728478;
            }
    }
}
function $9ee3aa3420ae2c81$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $9ee3aa3420ae2c81$var$initVModelForSSR() {
    $9ee3aa3420ae2c81$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $9ee3aa3420ae2c81$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $X5A94.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $X5A94.isArray)(value)) {
            if (vnode.props && (0, $X5A94.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $X5A94.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $9ee3aa3420ae2c81$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $9ee3aa3420ae2c81$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $9ee3aa3420ae2c81$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $9ee3aa3420ae2c81$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$9ee3aa3420ae2c81$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $9ee3aa3420ae2c81$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $9ee3aa3420ae2c81$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $9ee3aa3420ae2c81$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $9ee3aa3420ae2c81$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $X5A94.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $9ee3aa3420ae2c81$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $9ee3aa3420ae2c81$var$rendererOptions = /* @__PURE__ */ (0, $X5A94.extend)({
    patchProp: $9ee3aa3420ae2c81$var$patchProp
}, $9ee3aa3420ae2c81$var$nodeOps);
let $9ee3aa3420ae2c81$var$renderer;
let $9ee3aa3420ae2c81$var$enabledHydration = false;
function $9ee3aa3420ae2c81$var$ensureRenderer() {
    return $9ee3aa3420ae2c81$var$renderer || ($9ee3aa3420ae2c81$var$renderer = (0, $ani5R.createRenderer)($9ee3aa3420ae2c81$var$rendererOptions));
}
function $9ee3aa3420ae2c81$var$ensureHydrationRenderer() {
    $9ee3aa3420ae2c81$var$renderer = $9ee3aa3420ae2c81$var$enabledHydration ? $9ee3aa3420ae2c81$var$renderer : (0, $ani5R.createHydrationRenderer)($9ee3aa3420ae2c81$var$rendererOptions);
    $9ee3aa3420ae2c81$var$enabledHydration = true;
    return $9ee3aa3420ae2c81$var$renderer;
}
const $9ee3aa3420ae2c81$export$b3890eb0ae9dca99 = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureRenderer().render(...args);
};
const $9ee3aa3420ae2c81$export$fa8d919ba61d84db = (...args)=>{
    $9ee3aa3420ae2c81$var$ensureHydrationRenderer().hydrate(...args);
};
const $9ee3aa3420ae2c81$export$4e373c34abfa8c68 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $X5A94.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $9ee3aa3420ae2c81$export$35800275c0037383 = (...args)=>{
    const app = $9ee3aa3420ae2c81$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $9ee3aa3420ae2c81$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $9ee3aa3420ae2c81$var$resolveRootNamespace(container));
    };
    return app;
};
function $9ee3aa3420ae2c81$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $9ee3aa3420ae2c81$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $X5A94.isHTMLTag)(tag) || (0, $X5A94.isSVGTag)(tag) || (0, $X5A94.isMathMLTag)(tag),
        writable: false
    });
}
function $9ee3aa3420ae2c81$var$injectCompilerOptionsCheck(app) {
    if ((0, $ani5R.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $ani5R.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $ani5R.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $ani5R.warn)(msg);
            }
        });
    }
}
function $9ee3aa3420ae2c81$var$normalizeContainer(container) {
    if ((0, $X5A94.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = false;
const $9ee3aa3420ae2c81$export$800b28255aa678d9 = ()=>{
    if (!$9ee3aa3420ae2c81$var$ssrDirectiveInitialized) {
        $9ee3aa3420ae2c81$var$ssrDirectiveInitialized = true;
        $9ee3aa3420ae2c81$var$initVModelForSSR();
        $9ee3aa3420ae2c81$var$initVShowForSSR();
    }
};

});


parcelRegister("4GZdJ", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $36aa92c7adf41d43$export$63b9a9bba9f20f3e);

var $g21Uz = parcelRequire("g21Uz");

var $sP9n3 = parcelRequire("sP9n3");

var $ccfC2 = parcelRequire("ccfC2");



function $36aa92c7adf41d43$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $g21Uz.getTarget)();
    const hook = (0, $g21Uz.getDevtoolsGlobalHook)();
    const enableProxy = (0, $g21Uz.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $sP9n3.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $ccfC2.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("g21Uz", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $babe50d3fc546cfa$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $babe50d3fc546cfa$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $babe50d3fc546cfa$export$bc32a04c49ed7464);
function $babe50d3fc546cfa$export$5a2d366b2d9f38f6() {
    return $babe50d3fc546cfa$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $babe50d3fc546cfa$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $babe50d3fc546cfa$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("sP9n3", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $056a4afe07f3e731$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $056a4afe07f3e731$export$a0897f44accbe922);
const $056a4afe07f3e731$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $056a4afe07f3e731$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("ccfC2", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $8e12b756c61c1b85$export$5728f3776e9b2ac1);

var $sP9n3 = parcelRequire("sP9n3");

var $kAhkL = parcelRequire("kAhkL");
class $8e12b756c61c1b85$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $kAhkL.now)();
            }
        };
        if (hook) hook.on((0, $sP9n3.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("kAhkL", function(module, exports) {

$parcel$export(module.exports, "now", () => $efc49d9c17851a9d$export$461939dd4422153);
let $efc49d9c17851a9d$var$supported;
let $efc49d9c17851a9d$var$perf;
function $efc49d9c17851a9d$export$70d26280bc1ca547() {
    var _a;
    if ($efc49d9c17851a9d$var$supported !== undefined) return $efc49d9c17851a9d$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $efc49d9c17851a9d$var$supported = true;
        $efc49d9c17851a9d$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $efc49d9c17851a9d$var$supported = true;
        $efc49d9c17851a9d$var$perf = globalThis.perf_hooks.performance;
    } else $efc49d9c17851a9d$var$supported = false;
    return $efc49d9c17851a9d$var$supported;
}
function $efc49d9c17851a9d$export$461939dd4422153() {
    return $efc49d9c17851a9d$export$70d26280bc1ca547() ? $efc49d9c17851a9d$var$perf.now() : Date.now();
}

});






parcelRegister("kO8nc", function(module, exports) {

$parcel$export(module.exports, "render", () => $f25ef8e5b0075e8b$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $f25ef8e5b0075e8b$var$_hoisted_1 = {
    class: "ticket-details uk-flex uk-flex-column uk-flex-between"
};
const $f25ef8e5b0075e8b$var$_hoisted_2 = [
    "innerHTML"
];
const $f25ef8e5b0075e8b$var$_hoisted_3 = {
    class: "category"
};
const $f25ef8e5b0075e8b$var$_hoisted_4 = [
    "uk-tooltip"
];
const $f25ef8e5b0075e8b$var$_hoisted_5 = [
    "innerHTML"
];
const $f25ef8e5b0075e8b$var$_hoisted_6 = {
    key: 1
};
const $f25ef8e5b0075e8b$var$_hoisted_7 = [
    "uk-tooltip"
];
const $f25ef8e5b0075e8b$var$_hoisted_8 = {
    key: 2
};
const $f25ef8e5b0075e8b$var$_hoisted_9 = {
    disabled: "",
    value: ""
};
const $f25ef8e5b0075e8b$var$_hoisted_10 = [
    "value"
];
const $f25ef8e5b0075e8b$var$_hoisted_11 = {
    class: "uk-text-large uk-text-bold uk-margin-top"
};
const $f25ef8e5b0075e8b$var$_hoisted_12 = [
    "innerHTML"
];
const $f25ef8e5b0075e8b$var$_hoisted_13 = {
    class: "ticket-control"
};
const $f25ef8e5b0075e8b$var$_hoisted_14 = {
    class: "uk-flex uk-width-expand uk-flex-right uk-text-nowrap"
};
const $f25ef8e5b0075e8b$var$_hoisted_15 = {
    class: "uk-form-controls"
};
const $f25ef8e5b0075e8b$var$_hoisted_16 = [
    "disabled"
];
const $f25ef8e5b0075e8b$var$_hoisted_17 = [
    "value"
];
const $f25ef8e5b0075e8b$var$_hoisted_18 = {
    key: 1,
    class: "unavailable-text"
};
const $f25ef8e5b0075e8b$var$_hoisted_19 = {
    key: 2,
    class: "unavailable-text"
};
const $f25ef8e5b0075e8b$var$_hoisted_20 = {
    key: 3,
    class: "unavailable-text"
};
function $f25ef8e5b0075e8b$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        class: (0, $X5A94.normalizeClass)([
            "uk-position-relative",
            {
                'unavailable-ticket': !$props.ticket.available || $props.ticket.required_ticket_types && !$options.requirementMet(),
                ['tag-' + $props.ticket.category.id]: true,
                'singleview': !$props.offerId || $props.ticket.id == $props.offerId,
                'uk-active': $options.selection,
                'multiple': $options.selection > 1,
                'tag-coupon': $props.ticket.coupon_required || $props.ticket.coupon_highlight,
                'disable-by-coupon': $options.hasOtherSelectedCouponTickets,
                'tag-added_by_coupon': $props.ticket.coupon_required
            }
        ])
    }, [
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)({
                'ticket': true,
                'with-image': $props.ticket.image
            })
        }, [
            (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_1, [
                (0, $ani5R.createElementVNode)("div", null, [
                    (0, $ani5R.createElementVNode)("h4", {
                        class: "uk-card-title uk-margin-remove",
                        innerHTML: '<span>' + $props.ticket.name.split(' ').join('</span> <span>') + '</span>'
                    }, null, 8, $f25ef8e5b0075e8b$var$_hoisted_2),
                    (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_3, [
                        (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)($props.ticket.category.name) + " ", 1),
                        $props.ticket.category.description ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("i", {
                            key: 0,
                            "uk-icon": "info",
                            "uk-tooltip": $props.ticket.category.description
                        }, null, 8, $f25ef8e5b0075e8b$var$_hoisted_4)) : (0, $ani5R.createCommentVNode)("", true)
                    ]),
                    (0, $ani5R.createElementVNode)("p", {
                        class: (0, $X5A94.normalizeClass)({
                            'uk-margin-remove-bottom': _ctx.shortened && !_ctx.opened
                        }),
                        innerHTML: $options.getDescription()
                    }, null, 10, $f25ef8e5b0075e8b$var$_hoisted_5),
                    _ctx.shortened && !_ctx.opened ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        class: "showmore uk-display-inline-block",
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.opened = true)
                    }, (0, $X5A94.toDisplayString)(_ctx.$t("Mehr erfahren")), 1)) : (0, $ani5R.createCommentVNode)("", true),
                    $props.ticket.category.detail ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f25ef8e5b0075e8b$var$_hoisted_6, [
                        (0, $ani5R.createElementVNode)("i", {
                            "uk-icon": "info",
                            "uk-tooltip": $props.ticket.category.detail
                        }, null, 8, $f25ef8e5b0075e8b$var$_hoisted_7)
                    ])) : (0, $ani5R.createCommentVNode)("", true),
                    $props.ticket.options.length > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f25ef8e5b0075e8b$var$_hoisted_8, [
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                            class: "uk-select options",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$options.option = $event)
                        }, [
                            (0, $ani5R.createElementVNode)("option", $f25ef8e5b0075e8b$var$_hoisted_9, (0, $X5A94.toDisplayString)(_ctx.$t("Bitte ausw\xe4hlen")), 1),
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($props.ticket.options, (option)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                    value: option.id
                                }, (0, $X5A94.toDisplayString)(option.name), 9, $f25ef8e5b0075e8b$var$_hoisted_10);
                            }), 256))
                        ], 512), [
                            [
                                (0, $dDLnc.vModelSelect),
                                $options.option
                            ]
                        ])
                    ])) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_11, [
                    (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.getPrice($props.ticket, $options.selection)) + " ", 1),
                    $props.ticket.included_products.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 0,
                        class: "included-products",
                        innerHTML: _ctx.getIncludedProducts($props.ticket)
                    }, null, 8, $f25ef8e5b0075e8b$var$_hoisted_12)) : (0, $ani5R.createCommentVNode)("", true)
                ])
            ]),
            $props.ticket.image ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                key: 0,
                class: "ticket-image",
                style: (0, $X5A94.normalizeStyle)({
                    backgroundImage: 'url(' + $props.ticket.image + ')'
                })
            }, null, 4)) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_13, [
                (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_14, [
                    (0, $ani5R.createElementVNode)("div", $f25ef8e5b0075e8b$var$_hoisted_15, [
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                            class: "uk-select",
                            disabled: $props.ticket.options.length > 0 && !$options.option,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$options.selection = $event)
                        }, [
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(Array(Math.max(0, $options.getMaxOrderAmount($options.option))), (i, amount)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                    value: amount
                                }, (0, $X5A94.toDisplayString)(amount), 9, $f25ef8e5b0075e8b$var$_hoisted_17);
                            }), 256))
                        ], 8, $f25ef8e5b0075e8b$var$_hoisted_16), [
                            [
                                (0, $dDLnc.vModelSelect),
                                $options.selection
                            ]
                        ])
                    ])
                ])
            ]),
            $props.ticket.available_info == 'notyet' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f25ef8e5b0075e8b$var$_hoisted_18, (0, $X5A94.toDisplayString)(_ctx.$t("Noch nicht verf\xfcgbar")), 1)) : $props.ticket.required_ticket_types && !$options.requirementMet() ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f25ef8e5b0075e8b$var$_hoisted_19, (0, $X5A94.toDisplayString)(_ctx.$t("Required")) + ": " + (0, $X5A94.toDisplayString)($options.getRequiredText()), 1)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f25ef8e5b0075e8b$var$_hoisted_20, (0, $X5A94.toDisplayString)(_ctx.$t("Nicht mehr verf\xfcgbar")), 1))
        ], 2)
    ], 2);
}

});

parcelRegister("4rOa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d097e186dd4316$export$2e2bcd8739ae039);
let $33d097e186dd4316$var$NOOP = ()=>{};
var $33d097e186dd4316$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("g9Aab", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2989dc7e58cc92$export$2e2bcd8739ae039);
let $bc2989dc7e58cc92$var$script;



let $bc2989dc7e58cc92$var$initialize = ()=>{
    $bc2989dc7e58cc92$var$script = (parcelRequire("1hGK4"));
    if ($bc2989dc7e58cc92$var$script.__esModule) $bc2989dc7e58cc92$var$script = $bc2989dc7e58cc92$var$script.default;
    $bc2989dc7e58cc92$var$script.render = (parcelRequire("bYbaS")).render;
    (parcelRequire("dbMuu")).default($bc2989dc7e58cc92$var$script);
    $bc2989dc7e58cc92$var$script.__scopeId = 'data-v-91317c';
    $bc2989dc7e58cc92$var$script.__file = "Coupons.vue";
};
$bc2989dc7e58cc92$var$initialize();
var $bc2989dc7e58cc92$export$2e2bcd8739ae039 = $bc2989dc7e58cc92$var$script;

});
parcelRegister("1hGK4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0ef888a447791cfd$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");
var $0ef888a447791cfd$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        "settings"
    ],
    data: ()=>{
        return {
            couponChecking: false,
            couponResponse: ''
        };
    },
    computed: {
        couponCode: {
            get () {
                return this.store.state.couponCode;
            },
            set (newValue) {
                this.store.state.couponCode = newValue;
            }
        }
    },
    mounted () {
        // A code the buyer arrived with (?coupon=CODE, or the embed handing it on) is
        // checked without a click — the products a coupon unlocks would otherwise stay
        // invisible and the link would buy him nothing. `couponChecked` keeps it at one
        // check: stepping back to the ticket list remounts this component with the code
        // still in the store, and a code already checked needs no second round trip.
        if (this.couponCode && !this.store.state.couponChecked) this.checkCoupon();
    },
    methods: {
        checkCoupon (state) {
            this.store.state.couponChecked = true;
            this.couponChecking = true;
            this.couponResponse = this.$t("L\xe4dt..");
            this.doOctoberRequest("onInitialCouponCheck", {
                code: this.couponCode
            }).then((response)=>{
                if (response.length == 0) {
                    this.couponResponse = this.$t("Coupon-Code nicht gefunden oder nicht mehr g\xfcltig.");
                    setTimeout(()=>{
                        this.couponChecking = false;
                    }, 2000);
                    return;
                }
                this.couponResponse = this.$t('Code wurde gefunden!');
                this.store.state.couponCode = this.couponCode;
                this.store.state.couponSwitch = true;
                if (response.couponWithValue) this.couponResponse += '<br>' + this.$t('Der Rabatt wird vor Kaufabschluss angezeigt.');
                if (response.offers) {
                    if (response.couponWithValue) this.couponResponse += ' (' + this.$t('Reduzierte Produkte sind hervorgehoben.') + ')';
                    this.couponResponse += '<br>' + this.$t("Es werden zus\xe4tzliche Produkte angezeigt.");
                    this.store.commit("updateOffers", response);
                    const initialOfferId = response.initialOfferId;
                    this.$emit('coupon-found', initialOfferId);
                //                    setTimeout(() => {this.couponChecking = false}, 2000)
                }
            }).catch((_)=>{
                this.couponResponse = '';
                this.couponChecking = false;
            });
        }
    }
};

});

parcelRegister("bYbaS", function(module, exports) {

$parcel$export(module.exports, "render", () => $8b6df74c1ae8b080$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $8b6df74c1ae8b080$var$_hoisted_1 = {
    class: "uk-margin-small-bottom uk-margin-small-top coupon-wrapper"
};
const $8b6df74c1ae8b080$var$_hoisted_2 = {
    for: "couponCode"
};
const $8b6df74c1ae8b080$var$_hoisted_3 = {
    class: "uk-form-controls uk-margin-small-top",
    "uk-grid": ""
};
const $8b6df74c1ae8b080$var$_hoisted_4 = {
    class: "uk-width-expand uk-margin-right"
};
const $8b6df74c1ae8b080$var$_hoisted_5 = [
    "disabled",
    "placeholder"
];
const $8b6df74c1ae8b080$var$_hoisted_6 = [
    "disabled"
];
const $8b6df74c1ae8b080$var$_hoisted_7 = [
    "innerHTML"
];
function $8b6df74c1ae8b080$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8b6df74c1ae8b080$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("label", $8b6df74c1ae8b080$var$_hoisted_2, (0, $X5A94.toDisplayString)(_ctx.$t('Einen Coupon / Code hier eingeben')) + ": ", 1),
        (0, $ani5R.createElementVNode)("div", $8b6df74c1ae8b080$var$_hoisted_3, [
            (0, $ani5R.createElementVNode)("div", $8b6df74c1ae8b080$var$_hoisted_4, [
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                    onKeydown: _cache[0] || (_cache[0] = (0, $dDLnc.withKeys)((...args)=>$options.checkCoupon && $options.checkCoupon(...args), [
                        "enter"
                    ])),
                    disabled: _ctx.couponChecking,
                    id: "couponCode",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$options.couponCode = $event),
                    class: "uk-input",
                    type: "text",
                    placeholder: _ctx.$t('Gutschein-Code')
                }, null, 40, $8b6df74c1ae8b080$var$_hoisted_5), [
                    [
                        (0, $dDLnc.vModelText),
                        $options.couponCode
                    ]
                ])
            ]),
            (0, $ani5R.createElementVNode)("button", {
                disabled: _ctx.couponChecking,
                class: "uk-button uk-button-primary check-button",
                onClick: _cache[2] || (_cache[2] = (...args)=>$options.checkCoupon && $options.checkCoupon(...args))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Jetzt pr\xfcfen")), 9, $8b6df74c1ae8b080$var$_hoisted_6),
            _ctx.couponResponse ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                key: 0,
                style: {
                    "flex-basis": "100%",
                    "margin-top": "15px"
                },
                innerHTML: _ctx.couponResponse
            }, null, 8, $8b6df74c1ae8b080$var$_hoisted_7)) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("dbMuu", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a1eaaebc59cde4$export$2e2bcd8739ae039);
let $99a1eaaebc59cde4$var$NOOP = ()=>{};
var $99a1eaaebc59cde4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("6Vica", function(module, exports) {

$parcel$export(module.exports, "default", () => $50a62e1f960f0574$export$2e2bcd8739ae039);
let $50a62e1f960f0574$var$script;



let $50a62e1f960f0574$var$initialize = ()=>{
    $50a62e1f960f0574$var$script = (parcelRequire("aJmtm"));
    if ($50a62e1f960f0574$var$script.__esModule) $50a62e1f960f0574$var$script = $50a62e1f960f0574$var$script.default;
    $50a62e1f960f0574$var$script.render = (parcelRequire("ml42D")).render;
    (parcelRequire("kAeja")).default($50a62e1f960f0574$var$script);
    $50a62e1f960f0574$var$script.__scopeId = 'data-v-d85c16';
    $50a62e1f960f0574$var$script.__file = "Cart.vue";
};
$50a62e1f960f0574$var$initialize();
var $50a62e1f960f0574$export$2e2bcd8739ae039 = $50a62e1f960f0574$var$script;

});
parcelRegister("aJmtm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7cff89efd0015a08$export$2e2bcd8739ae039);
/**
 * Das Aussehen liegt in
 * plugins/kosmoskosmos/festiware/assets/styles/ticketshop/_cart.scss und
 * kommt über den Theme-Build in die kombinierte CSS der Instanz.
 *
 * @gotcha Nach Änderungen dort muss die kombinierte CSS der Instanz neu
 *   gebaut werden (`festiware:update-css` bzw. themes/<theme>/assets/combined/
 *   <instance>.css löschen) — sonst bleibt die Leiste auf der Instanz
 *   ungestylt. Die von Parcel aus SFC-Styles gebaute assets/styles/
 *   ticketshop.css lädt kein Theme, taugt also nicht als Ablage.
 *
 * Eingebettet rendert die Leiste die einbettende Seite (embed.js), die ihr
 * eigenes CSS mitbringt; TicketList entscheidet anhand von isEmbedded().
 */ var $7cff89efd0015a08$export$2e2bcd8739ae039 = {
    props: {
        /** Stückzahl über alle gewählten Tickets, nicht Anzahl der Ticketarten */ amount: {
            type: Number,
            required: true
        },
        /** Fertiger Text, z.B. "3 Tickets für 597,00 €" — kommt aus TicketList,
         *  damit eingebettet und standalone dieselbe Zeile steht. */ label: {
            type: String,
            required: true
        },
        nextLabel: {
            type: String,
            required: true
        }
    },
    emits: [
        'next'
    ]
};

});

parcelRegister("ml42D", function(module, exports) {

$parcel$export(module.exports, "render", () => $04326518d71c1a5c$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $04326518d71c1a5c$var$_hoisted_1 = {
    key: 0,
    class: "festiware-cart-spacer",
    "aria-hidden": "true"
};
const $04326518d71c1a5c$var$_hoisted_2 = {
    key: 0,
    class: "festiware-cart"
};
const $04326518d71c1a5c$var$_hoisted_3 = {
    class: "festiware-cart-inner"
};
const $04326518d71c1a5c$var$_hoisted_4 = {
    class: "festiware-cart-summary"
};
const $04326518d71c1a5c$var$_hoisted_5 = {
    class: "festiware-cart-label"
};
function $04326518d71c1a5c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        $props.amount > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $04326518d71c1a5c$var$_hoisted_1)) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
            name: "festiware-cart"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    $props.amount > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $04326518d71c1a5c$var$_hoisted_2, [
                        (0, $ani5R.createElementVNode)("div", $04326518d71c1a5c$var$_hoisted_3, [
                            (0, $ani5R.createElementVNode)("span", $04326518d71c1a5c$var$_hoisted_4, [
                                _cache[1] || (_cache[1] = (0, $ani5R.createElementVNode)("i", {
                                    class: "festiware-cart-icon",
                                    "uk-icon": "cart"
                                }, null, -1)),
                                (0, $ani5R.createElementVNode)("span", $04326518d71c1a5c$var$_hoisted_5, (0, $X5A94.toDisplayString)($props.label), 1)
                            ]),
                            (0, $ani5R.createElementVNode)("button", {
                                class: "uk-button uk-button-primary festiware-cart-next",
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('next'))
                            }, (0, $X5A94.toDisplayString)($props.nextLabel), 1)
                        ])
                    ])) : (0, $ani5R.createCommentVNode)("", true)
                ]),
            _: 1
        })
    ], 64);
}

});

parcelRegister("kAeja", function(module, exports) {

$parcel$export(module.exports, "default", () => $efc244c09528f051$export$2e2bcd8739ae039);
let $efc244c09528f051$var$NOOP = ()=>{};
var $efc244c09528f051$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cDUAh", function(module, exports) {

$parcel$export(module.exports, "normalizeSearchText", () => $934504ffeea80ff8$export$90964cb44568db29);
/*
 * Fold German text for the shop search: lowercase, ß→ss, strip diacritics
 * (ä→a, é→e). Applied to needle and haystack, so "strasse" finds "Straße".
 */ function $934504ffeea80ff8$export$90964cb44568db29(value) {
    return String(value ?? '').toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

});

parcelRegister("dXhd9", function(module, exports) {

$parcel$export(module.exports, "isEmbedded", () => $a28e22d7fbdec098$export$5bc70640704fc231);
$parcel$export(module.exports, "sendToParent", () => $a28e22d7fbdec098$export$661a311d63b0797b);
$parcel$export(module.exports, "onParentCommand", () => $a28e22d7fbdec098$export$3fb0fd914bfa5e33);
/**
 * Der postMessage-Kanal zur einbettenden Seite.
 *
 * WARUM ES DIESEN KANAL BRAUCHT
 * -----------------------------
 * Eine angeheftete Warenkorb-Leiste kann NICHT im iframe leben.
 *
 * Gescrollt wird die einbettende Seite, nicht das iframe-Dokument.
 * `position: sticky` braucht aber einen Scrollport, und `position: fixed`
 * bezieht sich im iframe auf die iframe-Box statt auf das Browserfenster.
 * Beides landet damit am unteren Ende des iframes statt im Blickfeld.
 *
 * Gemessen (Chrome, iframe 8100px hoch, Elternseite auf y=3000 gescrollt):
 * eine Leiste mit `position:fixed; bottom:0` im iframe liegt bei y=8040 im
 * iframe-Dokument, also rund 7000px unterhalb des sichtbaren Bereichs.
 * `scrollTop` des iframe-Dokuments bleibt dabei konstant 0 — es scrollt
 * wirklich nie. Oben angeheftet ist es dasselbe Bild: die Leiste wandert im
 * Gleichschritt mit der Seite aus dem Bild.
 *
 * Deshalb rendert die Leiste die einbettende Seite (embed.js), und der Shop
 * schickt ihr nur den Warenkorbstand. Der Klick auf "Weiter" kommt auf
 * demselben Weg zurück und löst hier denselben Pfad aus wie der Button in
 * der Ticketliste.
 *
 * `window.parent`, nicht `window.top`: embed.js läuft in der DIREKTEN
 * Elternseite. Bei mehrfach verschachtelten iframes ist `top` ein anderes
 * Fenster, das gar nicht zuhört.
 */ /**
 * Läuft der Shop in einer fremden Seite? Nur dann gibt es einen Empfänger.
 */ function $a28e22d7fbdec098$export$5bc70640704fc231() {
    return window.parent !== window;
}
function $a28e22d7fbdec098$export$661a311d63b0797b(payload) {
    if (!$a28e22d7fbdec098$export$5bc70640704fc231()) return;
    window.parent.postMessage(payload, '*');
}
function $a28e22d7fbdec098$export$3fb0fd914bfa5e33(name, handler) {
    const listener = (event)=>{
        if (event.source !== window.parent) return;
        if (!event.data || typeof event.data !== 'object') return;
        if (!event.data[name]) return;
        handler(event.data);
    };
    window.addEventListener('message', listener);
    return ()=>window.removeEventListener('message', listener);
}

});

parcelRegister("bXsWn", function(module, exports) {
/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ module.exports = function() {
    function identity(v) {
        return v;
    }
    function ignoreCase(v) {
        return typeof v === "string" ? v.toLowerCase() : v;
    }
    function makeCompareFunction(f, opt) {
        opt = typeof opt === "object" ? opt : {
            direction: opt
        };
        if (typeof f != "function") {
            var prop = f;
            // make unary function
            f = function(v1) {
                return !!v1[prop] ? v1[prop] : "";
            };
        }
        if (f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase ? ignoreCase : identity;
            var cmp = opt.cmp || function(v1, v2) {
                return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
            };
            f = function(v1, v2) {
                return cmp(preprocess(uf(v1)), preprocess(uf(v2)));
            };
        }
        const descTokens = {
            "-1": '',
            desc: ''
        };
        if (opt.direction in descTokens) return function(v1, v2) {
            return -f(v1, v2);
        };
        return f;
    }
    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */ function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */ var x = typeof this == "function" && !this.firstBy ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
            return x(a, b) || y(a, b);
        } : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
}();

});


parcelRegister("iQBYc", function(module, exports) {

$parcel$export(module.exports, "render", () => $db8a89585fbcbb64$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $db8a89585fbcbb64$var$_hoisted_1 = {
    key: 0
};
const $db8a89585fbcbb64$var$_hoisted_2 = {
    key: 1,
    "uk-filter": "target: .js-filter; animation: fade"
};
const $db8a89585fbcbb64$var$_hoisted_3 = {
    class: "uk-margin-remove"
};
const $db8a89585fbcbb64$var$_hoisted_4 = [
    "innerHTML"
];
const $db8a89585fbcbb64$var$_hoisted_5 = {
    key: 2,
    ref: "filter",
    class: "fw-shop-filter uk-margin"
};
const $db8a89585fbcbb64$var$_hoisted_6 = [
    "placeholder",
    "aria-label"
];
const $db8a89585fbcbb64$var$_hoisted_7 = {
    key: 0,
    class: "fw-shop-search-count",
    "aria-live": "polite"
};
const $db8a89585fbcbb64$var$_hoisted_8 = [
    "aria-label",
    "title"
];
const $db8a89585fbcbb64$var$_hoisted_9 = {
    key: "tabs",
    class: "uk-subnav uk-subnav-pill uk-margin-remove fw-shop-tabs"
};
const $db8a89585fbcbb64$var$_hoisted_10 = {
    key: 0,
    "uk-filter-control": ".singleview",
    class: "uk-hidden uk-padding-remove uk-active"
};
const $db8a89585fbcbb64$var$_hoisted_11 = {
    key: 1,
    "uk-filter-control": "",
    class: "uk-padding-remove"
};
const $db8a89585fbcbb64$var$_hoisted_12 = {
    key: 2,
    "uk-filter-control": "",
    class: "uk-padding-remove"
};
const $db8a89585fbcbb64$var$_hoisted_13 = {
    href: "#"
};
const $db8a89585fbcbb64$var$_hoisted_14 = [
    "uk-filter-control"
];
const $db8a89585fbcbb64$var$_hoisted_15 = {
    href: "#"
};
const $db8a89585fbcbb64$var$_hoisted_16 = {
    key: 1,
    class: "fw-shop-search-toggle"
};
const $db8a89585fbcbb64$var$_hoisted_17 = [
    "aria-label",
    "title"
];
const $db8a89585fbcbb64$var$_hoisted_18 = {
    class: "uk-margin uk-position-relative"
};
const $db8a89585fbcbb64$var$_hoisted_19 = {
    class: /*@__PURE__*/ (0, $X5A94.normalizeClass)({
        ['uk-child-width-1-2@s']: true,
        'uk-grid-match': true,
        'js-filter': true
    }),
    id: "ticketgrid",
    "uk-grid": ""
};
const $db8a89585fbcbb64$var$_hoisted_20 = {
    key: 0,
    class: "fw-shop-search-empty"
};
const $db8a89585fbcbb64$var$_hoisted_21 = {
    class: "uk-margin-medium-top uk-flex uk-flex-right"
};
const $db8a89585fbcbb64$var$_hoisted_22 = [
    "disabled"
];
function $db8a89585fbcbb64$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Coupons = (0, $ani5R.resolveComponent)("Coupons");
    const _component_ticket = (0, $ani5R.resolveComponent)("ticket");
    const _component_cart = (0, $ani5R.resolveComponent)("cart");
    return _ctx.sortedOffers.length == 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $db8a89585fbcbb64$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("h2", null, (0, $X5A94.toDisplayString)(_ctx.$t("Aktuell gibt es keine Produkte in diesem Shop.")), 1)
    ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $db8a89585fbcbb64$var$_hoisted_2, [
        (0, $ani5R.createElementVNode)("h2", $db8a89585fbcbb64$var$_hoisted_3, (0, $X5A94.toDisplayString)(_ctx.$t("Tickets ausw\xe4hlen")), 1),
        $options.introText ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)({
                'uk-margin-medium-bottom': !($props.settings.coupons_enabled && ($props.settings.coupons_first || $props.initialCouponCode)),
                'uk-margin-medium-top': true
            }),
            innerHTML: $options.introText
        }, null, 10, $db8a89585fbcbb64$var$_hoisted_4)) : (0, $ani5R.createCommentVNode)("", true),
        $props.settings.coupons_enabled && ($props.settings.coupons_first || $props.initialCouponCode) ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_Coupons, {
            key: 1,
            onCouponFound: _cache[0] || (_cache[0] = ($event)=>$options.init(true))
        })) : (0, $ani5R.createCommentVNode)("", true),
        $options.showFilterBar ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $db8a89585fbcbb64$var$_hoisted_5, [
            (0, $ani5R.createVNode)((0, $dDLnc.Transition), {
                name: "fw-shop-filter-swap",
                mode: "out-in",
                onAfterEnter: $options.afterFilterSwap
            }, {
                default: (0, $ani5R.withCtx)(()=>[
                        _ctx.searchOpen ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("form", {
                            key: "search",
                            class: "fw-shop-search",
                            role: "search",
                            onSubmit: _cache[3] || (_cache[3] = (0, $dDLnc.withModifiers)(()=>{}, [
                                "prevent"
                            ])),
                            onKeydown: _cache[4] || (_cache[4] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>$options.closeSearch && $options.closeSearch(...args), [
                                "prevent"
                            ]), [
                                "esc"
                            ]))
                        }, [
                            _cache[10] || (_cache[10] = (0, $ani5R.createElementVNode)("span", {
                                class: "fw-shop-search-icon",
                                "uk-icon": "icon: search"
                            }, null, -1)),
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                                ref: "searchInput",
                                class: "fw-shop-search-input",
                                type: "search",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.searchTerm = $event),
                                enterkeyhint: "search",
                                autocomplete: "off",
                                placeholder: _ctx.$t('Produkte durchsuchen'),
                                "aria-label": _ctx.$t('Produkte durchsuchen')
                            }, null, 8, $db8a89585fbcbb64$var$_hoisted_6), [
                                [
                                    (0, $dDLnc.vModelText),
                                    _ctx.searchTerm,
                                    void 0,
                                    {
                                        trim: true
                                    }
                                ]
                            ]),
                            $options.isSearchActive ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $db8a89585fbcbb64$var$_hoisted_7, (0, $X5A94.toDisplayString)($options.searchResultLabel), 1)) : (0, $ani5R.createCommentVNode)("", true),
                            (0, $ani5R.createElementVNode)("button", {
                                type: "button",
                                class: "fw-shop-search-close",
                                onClick: _cache[2] || (_cache[2] = (...args)=>$options.closeSearch && $options.closeSearch(...args)),
                                "aria-label": _ctx.$t("Suche schlie\xdfen"),
                                title: _ctx.$t("Suche schlie\xdfen")
                            }, _cache[9] || (_cache[9] = [
                                (0, $ani5R.createElementVNode)("span", {
                                    "uk-icon": "icon: close; ratio: .9"
                                }, null, -1)
                            ]), 8, $db8a89585fbcbb64$var$_hoisted_8)
                        ], 32)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", $db8a89585fbcbb64$var$_hoisted_9, [
                            $options.showTabs ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                key: 0
                            }, [
                                _ctx.offerId ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", $db8a89585fbcbb64$var$_hoisted_10, _cache[11] || (_cache[11] = [
                                    (0, $ani5R.createElementVNode)("a", {
                                        href: "#"
                                    }, "...", -1)
                                ]))) : (0, $ani5R.createCommentVNode)("", true),
                                _ctx.offerId ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", $db8a89585fbcbb64$var$_hoisted_11, [
                                    (0, $ani5R.createElementVNode)("a", {
                                        href: "#",
                                        onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.offerId = null)
                                    }, (0, $X5A94.toDisplayString)(_ctx.$t('Alle Tickets anzeigen')), 1)
                                ])) : (0, $ani5R.createCommentVNode)("", true),
                                !_ctx.offerId ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", $db8a89585fbcbb64$var$_hoisted_12, [
                                    (0, $ani5R.createElementVNode)("a", $db8a89585fbcbb64$var$_hoisted_13, (0, $X5A94.toDisplayString)(_ctx.$t('Alle Arten')), 1)
                                ])) : (0, $ani5R.createCommentVNode)("", true),
                                !_ctx.offerId ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                                    key: 3
                                }, (0, $ani5R.renderList)(_ctx.categories, (category)=>{
                                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                                        "uk-filter-control": '.tag-' + category.id
                                    }, [
                                        (0, $ani5R.createElementVNode)("a", $db8a89585fbcbb64$var$_hoisted_15, (0, $X5A94.toDisplayString)(category.name), 1)
                                    ], 8, $db8a89585fbcbb64$var$_hoisted_14);
                                }), 256)) : (0, $ani5R.createCommentVNode)("", true)
                            ], 64)) : (0, $ani5R.createCommentVNode)("", true),
                            $options.shouldShowSearch ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", $db8a89585fbcbb64$var$_hoisted_16, [
                                (0, $ani5R.createElementVNode)("a", {
                                    ref: "searchToggle",
                                    href: "#",
                                    role: "button",
                                    onClick: _cache[6] || (_cache[6] = (0, $dDLnc.withModifiers)((...args)=>$options.openSearch && $options.openSearch(...args), [
                                        "prevent"
                                    ])),
                                    "aria-label": _ctx.$t('Produkte durchsuchen'),
                                    title: _ctx.$t('Produkte durchsuchen')
                                }, _cache[12] || (_cache[12] = [
                                    (0, $ani5R.createElementVNode)("span", {
                                        "uk-icon": "icon: search; ratio: .9"
                                    }, null, -1)
                                ]), 8, $db8a89585fbcbb64$var$_hoisted_17)
                            ])) : (0, $ani5R.createCommentVNode)("", true)
                        ]))
                    ]),
                _: 1
            }, 8, [
                "onAfterEnter"
            ])
        ], 512)) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.createElementVNode)("div", $db8a89585fbcbb64$var$_hoisted_18, [
            (0, $ani5R.createElementVNode)("ul", $db8a89585fbcbb64$var$_hoisted_19, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.displayedOffers, (ticket)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: ticket.id
                    }, [
                        !_ctx.offerId && _ctx.currentCategory === undefined && $options.displayedHeadlines[ticket.category.id] === ticket.id ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                            key: 0,
                            class: (0, $X5A94.normalizeClass)([
                                "uk-width-1-1 category",
                                {
                                    ['tag-' + ticket.category.id]: true
                                }
                            ])
                        }, [
                            (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(ticket.category.name), 1)
                        ], 2)) : (0, $ani5R.createCommentVNode)("", true),
                        (0, $ani5R.createVNode)(_component_ticket, {
                            offerId: _ctx.offerId,
                            ticket: ticket,
                            id: ticket.id
                        }, null, 8, [
                            "offerId",
                            "ticket",
                            "id"
                        ])
                    ], 64);
                }), 128))
            ]),
            $options.isSearchActive && $options.displayedOffers.length === 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $db8a89585fbcbb64$var$_hoisted_20, [
                _cache[13] || (_cache[13] = (0, $ani5R.createElementVNode)("span", {
                    "uk-icon": "icon: search; ratio: 1.6"
                }, null, -1)),
                (0, $ani5R.createElementVNode)("p", null, (0, $X5A94.toDisplayString)(_ctx.$t("Keine Produkte gefunden")), 1),
                (0, $ani5R.createElementVNode)("button", {
                    type: "button",
                    class: "uk-button uk-button-default uk-button-small",
                    onClick: _cache[7] || (_cache[7] = ($event)=>{
                        _ctx.searchTerm = '';
                        $options.focusSearchInput();
                    })
                }, (0, $X5A94.toDisplayString)(_ctx.$t("Suche zur\xfccksetzen")), 1)
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ]),
        (0, $ani5R.createElementVNode)("div", $db8a89585fbcbb64$var$_hoisted_21, [
            (0, $ani5R.createElementVNode)("button", {
                class: "uk-button uk-button-primary",
                disabled: $options.hasNoItems,
                onClick: _cache[8] || (_cache[8] = (...args)=>$options.next && $options.next(...args))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Weiter")), 9, $db8a89585fbcbb64$var$_hoisted_22)
        ]),
        !_ctx.embedded ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_cart, {
            key: 3,
            amount: $options.cartAmount,
            label: $options.cartLabel,
            "next-label": _ctx.$t('Weiter'),
            onNext: $options.next
        }, null, 8, [
            "amount",
            "label",
            "next-label",
            "onNext"
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ]));
}

});

parcelRegister("8aZYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f3f5598cf536d6f$export$2e2bcd8739ae039);
let $5f3f5598cf536d6f$var$NOOP = ()=>{};
var $5f3f5598cf536d6f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eZSa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeb0c680721c4ce8$export$2e2bcd8739ae039);
let $aeb0c680721c4ce8$var$script;




let $aeb0c680721c4ce8$var$initialize = ()=>{
    $aeb0c680721c4ce8$var$script = (parcelRequire("4Lnol"));
    if ($aeb0c680721c4ce8$var$script.__esModule) $aeb0c680721c4ce8$var$script = $aeb0c680721c4ce8$var$script.default;
    $aeb0c680721c4ce8$var$script.render = (parcelRequire("6cKWi")).render;
    $aeb0c680721c4ce8$var$script.__cssModules = {};
    (parcelRequire("kgMfP")).default($aeb0c680721c4ce8$var$script);
    $aeb0c680721c4ce8$var$script.__scopeId = 'data-v-1073ff';
    $aeb0c680721c4ce8$var$script.__file = "Checkout.vue";
};
$aeb0c680721c4ce8$var$initialize();
var $aeb0c680721c4ce8$export$2e2bcd8739ae039 = $aeb0c680721c4ce8$var$script;

});
parcelRegister("4Lnol", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $377db249fef9c701$export$2e2bcd8739ae039);

var $a4qgT = parcelRequire("a4qgT");

var $aDEF2 = parcelRequire("aDEF2");

var $6oQp6 = parcelRequire("6oQp6");
var $377db249fef9c701$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        "settings",
        "paymentOptionsForLabel",
        "loginusername"
    ],
    components: {
        CheckoutPayment: $a4qgT.default,
        CheckoutPerson: $aDEF2.default
    },
    data: ()=>{
        return {
            couponErrorMsg: '',
            couponWrongProductMsg: ''
        };
    },
    mounted () {
        // The step is mounted again on every visit (v-if), so without the flag each
        // back-and-forth would count as a new checkout.
        if (this.store.state.checkoutTracked) return;
        this.store.state.checkoutTracked = true;
        this.store.commit("updateSession");
        const contents = Object.keys(this.store.state.selection).map((id)=>({
                id: id,
                name: this.store.state.selection[id].ticket.name,
                quantity: this.store.state.selection[id].amount,
                price: this.store.state.selection[id].ticket.price
            }));
        this.trackMetaPixel('InitiateCheckout', {
            content_ids: contents.map((c)=>c.id),
            content_type: 'ticket',
            num_items: contents.reduce((sum, c)=>sum + c.quantity, 0),
            value: this.store.state.price,
            currency: 'EUR'
        });
        this.trackGA('begin_checkout', {
            currency: 'EUR',
            value: this.store.state.price,
            items: contents.map((c)=>({
                    item_id: c.id,
                    item_name: c.name,
                    price: c.price,
                    quantity: c.quantity
                }))
        });
    },
    methods: {
        async next () {
            if (await this.validate()) {
                this.checkCoupon();
                this.store.state.allDataCollected = true;
                this.$emit("next");
            } else {
                if (document.querySelector('.vf-input-group-danger')) window.setTimeout(()=>this.$scrollTo('.vf-input-group-danger', 500, {
                        offset: -120
                    }));
                this.store.state.allDataCollected = false;
            }
        },
        back () {
            this.$emit("back", this.store.state.personalize && !this.store.state.onlyNoChipTicketsSelected ? 1 : 2);
        },
        async validate () {
            let valid = this.loginusername ? true : this.$refs.paymentType.validate();
            valid = await this.$refs.personData.validate() && valid;
            return valid;
        },
        checkCoupon () {
            this.couponErrorMsg = this.$t("Der eingegebene Gutschein-Code ist nicht g\xfcltig.");
            this.couponWrongProductMsg = this.$t("Der eingegebene Gutschein-Code erfordert ein anderes Produkt.");
            this.store.state.couponType = null;
            this.store.state.couponValue = null;
            this.store.state.couponOffers = [];
            this.store.commit("updatePrice");
            if (this.store.state.couponSwitch && this.store.state.couponCode.length) $.request("onCheckCouponCode", {
                data: {
                    code: this.store.state.couponCode
                },
                success: (data)=>{
                    if (!data.error) {
                        this.store.state.couponType = data.type;
                        this.store.state.couponValue = data.value;
                        this.store.state.couponOffers = data.offers || [];
                        this.store.commit("updatePrice");
                        this.store.commit("updateSession");
                        if (!this.store.state.couponDiscount) {
                            if (data.offers) for (let offerId of data.offers){
                                this.store.state.selection[offerId];
                                return;
                            }
                            this.store.state.couponType = null;
                            this.store.state.couponValue = null;
                            this.store.state.couponOffers = [];
                            UIkit.notification(this.couponWrongProductMsg);
                        }
                    } else UIkit.notification(this.couponErrorMsg);
                }
            });
        }
    }
};

});
parcelRegister("a4qgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $754ea8171f7d8785$export$2e2bcd8739ae039);
let $754ea8171f7d8785$var$script;




let $754ea8171f7d8785$var$initialize = ()=>{
    $754ea8171f7d8785$var$script = (parcelRequire("dMWrj"));
    if ($754ea8171f7d8785$var$script.__esModule) $754ea8171f7d8785$var$script = $754ea8171f7d8785$var$script.default;
    $754ea8171f7d8785$var$script.render = (parcelRequire("h70hP")).render;
    $754ea8171f7d8785$var$script.__cssModules = {};
    (parcelRequire("3NR3p")).default($754ea8171f7d8785$var$script);
    $754ea8171f7d8785$var$script.__scopeId = 'data-v-5e651b';
    $754ea8171f7d8785$var$script.__file = "CheckoutPayment.vue";
};
$754ea8171f7d8785$var$initialize();
var $754ea8171f7d8785$export$2e2bcd8739ae039 = $754ea8171f7d8785$var$script;

});
parcelRegister("dMWrj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a09d16f08d5588b6$export$2e2bcd8739ae039);

var $bzXEj = parcelRequire("bzXEj");

var $48wMP = parcelRequire("48wMP");

var $gI8rb = parcelRequire("gI8rb");

var $6oQp6 = parcelRequire("6oQp6");

var $64CYh = parcelRequire("64CYh");
/**
 * Reseller-Tender catalog. Maps each backend-allowed tender to the
 * payment_type the API expects, plus the label/icon shown on the POS.
 *
 * @gotcha The DB column `payment_type` distinguishes only "directsale"
 *         (cash, no PSP) from "mollie" (any Mollie product, here POS).
 *         The Reseller-only `tender` discriminator is what flips
 *         TransactionLifecycle to openAndFinishBar vs. openUnbar+TapToPay
 *         vs. markExternalProvider (cashless).
 * @gotcha `cashless` shares the `directsale` payment_type with `cash` but
 *         must NOT be sent as `cash`: the guest pays at the cashless
 *         provider's terminal, which fiscalises that revenue. A cash tender
 *         would sign the same sale a second time on our own TSE.
 */ const $a09d16f08d5588b6$var$RESELLER_TENDERS = {
    cash: {
        tender: 'cash',
        paymentType: 'directsale',
        icon: "\uD83D\uDCB6",
        label: 'Bar kassieren'
    },
    cashless: {
        tender: 'cashless',
        paymentType: 'directsale',
        icon: "\uD83E\uDE99",
        label: 'Cashless kassieren'
    },
    card_terminal: {
        tender: 'card_terminal',
        paymentType: 'mollie',
        icon: "\uD83D\uDCB3",
        label: 'Mit Karte kassieren'
    }
};
var $a09d16f08d5588b6$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'settings',
        'loginusername'
    ],
    components: {},
    data: ()=>{
        return {
            v$: (0, $48wMP.default)(),
            options: [],
            terminals: []
        };
    },
    validations () {
        return this.loginusername ? {
            tender: {
                required: $gI8rb.required
            }
        } : {
            paymentType: {
                required: $gI8rb.required
            }
        };
    },
    computed: {
        error () {
            return this.loginusername ? this.v$.tender?.$error : this.v$.paymentType.$error;
        },
        allowedTypes () {
            return (0, $64CYh.allowedPaymentTypes)(this.store.state.paymentCountryRules, this.store.state.billingCountry);
        },
        /** Normal-shop tiles after the country rules; the reseller POS keeps `options`. */ shopOptions () {
            const allowed = this.allowedTypes;
            return allowed === null ? this.options : this.options.filter((option)=>allowed.includes(option.type));
        },
        waitingForCountry () {
            return Array.isArray(this.allowedTypes) && this.allowedTypes.length === 0;
        },
        paymentType: {
            get () {
                return this.store.state.paymentType;
            },
            set (newValue) {
                this.store.state.paymentType = newValue;
            }
        },
        tender: {
            get () {
                return this.store.state.tender;
            },
            set (newValue) {
                this.store.state.tender = newValue;
                const def = $a09d16f08d5588b6$var$RESELLER_TENDERS[newValue];
                if (def) this.store.state.paymentType = def.paymentType;
                if (newValue === 'card_terminal' && this.terminals.length === 1) this.store.state.terminalId = this.terminals[0].id;
                if (newValue !== 'card_terminal') this.store.state.terminalId = '';
            }
        },
        terminalId: {
            get () {
                return this.store.state.terminalId;
            },
            set (newValue) {
                this.store.state.terminalId = newValue;
            }
        },
        couponSwitch: {
            get () {
                return this.store.state.couponSwitch;
            },
            set (newValue) {
                this.store.state.couponSwitch = newValue;
            }
        },
        couponCode: {
            get () {
                return this.store.state.couponCode;
            },
            set (newValue) {
                this.store.state.couponCode = newValue;
            }
        },
        donationSwitch: {
            get () {
                return this.store.state.donationSwitch;
            },
            set (newValue) {
                this.store.state.donationSwitch = newValue;
            }
        },
        donationAmount: {
            get () {
                return this.store.state.donationAmount;
            },
            set (newValue) {
                this.store.state.donationAmount = newValue;
            }
        },
        newsletterSignup: {
            get () {
                return this.store.state.newsletterSignup;
            },
            set (newValue) {
                this.store.state.newsletterSignup = newValue;
            }
        },
        suggestedAmounts () {
            // Configured per project (php-core setting DonationSuggestedAmounts); older
            // backends don't send the key, so the former fixed amounts stay the fallback.
            const configured = (this.settings.donation_amounts || []).map((amount)=>parseInt(amount)).filter((amount)=>amount > 0);
            return configured.length ? configured : [
                2,
                5,
                10
            ];
        },
        customAmountInput: {
            get () {
                const stored = parseInt(this.donationAmount);
                if (!this.donationSwitch || !stored || this.suggestedAmounts.includes(stored)) return '';
                return String(stored);
            },
            set (newValue) {
                const n = parseInt(newValue);
                if (n > 0) {
                    this.donationSwitch = true;
                    this.donationAmount = n + "\u20AC";
                } else {
                    this.donationSwitch = false;
                    this.donationAmount = "0\u20AC";
                }
            }
        }
    },
    mounted () {
        if (this.loginusername) this.buildResellerOptions();
        else {
            Object.keys(this.settings.paymentOptions).forEach((paymentOption)=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($bzXEj)))[paymentOption]) {
                    const option = (0, (/*@__PURE__*/$parcel$interopDefault($bzXEj)))[paymentOption];
                    if (!option.hide || this.settings.paymentOptions) {
                        option.type = paymentOption;
                        if (this.settings.paymentOptions[paymentOption].custom_image) option.img = this.settings.paymentOptions[paymentOption].custom_image;
                        this.options.push(option);
                    }
                } else this.emitError('payment', `Bezahlmethode <strong class="uk-text-uppercase">${paymentOption}</strong> noch nicht implementiert.`, true);
            });
            this.syncPaymentType();
        }
    },
    watch: {
        shopOptions () {
            if (!this.loginusername) this.syncPaymentType();
        }
    },
    methods: {
        /**
         * Reseller-Backend liefert paymentOptions in der Form
         *   { cash: [], card_terminal: { terminals: [...] } }
         * Tender, die im Backend gefiltert werden (kein TSS, keine Terminals
         * konfiguriert), kommen erst gar nicht an. Hier nur noch Render-Logik.
         */ buildResellerOptions () {
            const opts = this.settings.paymentOptions || {};
            Object.keys($a09d16f08d5588b6$var$RESELLER_TENDERS).forEach((key)=>{
                if (!(key in opts)) return;
                const def = {
                    ...$a09d16f08d5588b6$var$RESELLER_TENDERS[key]
                };
                if (key === 'card_terminal') {
                    // Backend liefert Terminals als normalisierte Liste
                    //   [{ id: 'term_abc123', label: 'Kasse 1' }, …]
                    // (siehe TicketShopController::normalizeMollieTerminals).
                    // Fallbacks decken legacy-Shapes ab, falls ein älteres Backend
                    // noch das rohe Object schickt.
                    const terminals = opts.card_terminal && opts.card_terminal.terminals || [];
                    if (Array.isArray(terminals)) this.terminals = terminals.map((t)=>{
                        if (t && typeof t === 'object') return {
                            id: String(t.id || ''),
                            label: String(t.label || t.id || '')
                        };
                        return {
                            id: String(t),
                            label: String(t)
                        };
                    }).filter((t)=>t.id);
                    else if (terminals && typeof terminals === 'object') this.terminals = Object.entries(terminals).map(([k, v])=>{
                        const ks = String(k);
                        const vs = String(v || '');
                        // Legacy: {term_xxx: "label"} — key=id
                        if (ks.startsWith('term_') && !vs.startsWith('term_')) return {
                            id: ks,
                            label: vs || ks
                        };
                        // Current: {label: term_xxx} — value=id
                        return {
                            id: vs || ks,
                            label: ks
                        };
                    });
                    else this.terminals = [];
                    if (this.terminals.length === 0) {
                        def.disabled = true;
                        def.disabledHint = 'Kein Mollie-Terminal konfiguriert.';
                    }
                }
                this.options.push(def);
            });
            if (this.options.length === 1 && !this.options[0].disabled) this.tender = this.options[0].tender;
        },
        /**
         * Picks the only tile automatically and drops a choice the country no
         * longer allows (buyer changed the country after choosing).
         */ syncPaymentType () {
            if (this.shopOptions.length === 1) this.paymentType = this.shopOptions[0].type;
            else if (this.paymentType && !this.shopOptions.some((option)=>option.type === this.paymentType)) this.paymentType = '';
        },
        validate () {
            this.v$.$touch();
            if (this.v$.$invalid) return false;
            if (this.loginusername && this.tender === 'card_terminal' && !this.terminalId) {
                this.emitError('payment', "Bitte ein Terminal ausw\xe4hlen.", false);
                return false;
            }
            return true;
        },
        suggestedActive (amount) {
            return this.donationSwitch && this.suggestedAmounts.includes(parseInt(this.donationAmount)) && parseInt(this.donationAmount) === amount;
        },
        toggleDonationAmount (amount) {
            if (this.suggestedActive(amount)) {
                this.donationSwitch = false;
                this.donationAmount = "0\u20AC";
                return;
            }
            this.donationSwitch = true;
            this.donationAmount = amount + "\u20AC";
        },
        formatDonation (e) {
            if ($('#donationAmount').length) {
                let donationField = $('#donationAmount')[0];
                let currentPosition = donationField.selectionDirection == 'backward' ? donationField.selectionStart : donationField.selectionEnd;
                let currentValue = parseInt($('#donationAmount').val().replace(/[^0-9]/, ''));
                if (isNaN(currentValue)) currentValue = 0;
                this.donationAmount = currentValue + "\u20AC";
                $('#donationAmount').val(this.donationAmount);
                if (e.key && e.key.length == 1) {
                    let carretPosition = Math.max(0, Math.min(currentPosition, $('#donationAmount').val().length - 1));
                    if ("0123456789".indexOf(e.key) == -1) carretPosition = Math.max(0, carretPosition - 1);
                    donationField.setSelectionRange(carretPosition, carretPosition);
                }
            }
        }
    }
};

});
parcelRegister("bzXEj", function(module, exports) {
module.exports = JSON.parse("{\"stripe\":{\"label\":\"Stripe\",\"checkoutLabel\":\"Stripe\",\"icon\":\"%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 468 222.5' style='enable-background:new 0 0 468 222.5;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23635BFF;%7D%0A%3C/style%3E%3Cg%3E%3Cpath class='st0' d='M414,113.4c0-25.6-12.4-45.8-36.1-45.8c-23.8,0-38.2,20.2-38.2,45.6c0,30.1,17,45.3,41.4,45.3 c11.9,0,20.9-2.7,27.7-6.5v-20c-6.8,3.4-14.6,5.5-24.5,5.5c-9.7,0-18.3-3.4-19.4-15.2h48.9C413.8,121,414,115.8,414,113.4z M364.6,103.9c0-11.3,6.9-16,13.2-16c6.1,0,12.6,4.7,12.6,16H364.6z'/%3E%3Cpath class='st0' d='M301.1,67.6c-9.8,0-16.1,4.6-19.6,7.8l-1.3-6.2h-22v116.6l25-5.3l0.1-28.3c3.6,2.6,8.9,6.3,17.7,6.3 c17.9,0,34.2-14.4,34.2-46.1C335.1,83.4,318.6,67.6,301.1,67.6z M295.1,136.5c-5.9,0-9.4-2.1-11.8-4.7l-0.1-37.1 c2.6-2.9,6.2-4.9,11.9-4.9c9.1,0,15.4,10.2,15.4,23.3C310.5,126.5,304.3,136.5,295.1,136.5z'/%3E%3Cpolygon class='st0' points='223.8,61.7 248.9,56.3 248.9,36 223.8,41.3 '/%3E%3Crect x='223.8' y='69.3' class='st0' width='25.1' height='87.5'/%3E%3Cpath class='st0' d='M196.9,76.7l-1.6-7.4h-21.6v87.5h25V97.5c5.9-7.7,15.9-6.3,19-5.2v-23C214.5,68.1,202.8,65.9,196.9,76.7z'/%3E%3Cpath class='st0' d='M146.9,47.6l-24.4,5.2l-0.1,80.1c0,14.8,11.1,25.7,25.9,25.7c8.2,0,14.2-1.5,17.5-3.3V135 c-3.2,1.3-19,5.9-19-8.9V90.6h19V69.3h-19L146.9,47.6z'/%3E%3Cpath class='st0' d='M79.3,94.7c0-3.9,3.2-5.4,8.5-5.4c7.6,0,17.2,2.3,24.8,6.4V72.2c-8.3-3.3-16.5-4.6-24.8-4.6 C67.5,67.6,54,78.2,54,95.9c0,27.6,38,23.2,38,35.1c0,4.6-4,6.1-9.6,6.1c-8.3,0-18.9-3.4-27.3-8v23.8c9.3,4,18.7,5.7,27.3,5.7 c20.8,0,35.1-10.3,35.1-28.2C117.4,100.6,79.3,105.9,79.3,94.7z'/%3E%3C/g%3E%3C/svg%3E%0A\"},\"bank\":{\"label\":\"Vorkasse\",\"checkoutLabel\":\"Vorkasse\",\"icon\":\"%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 117 50' style='enable-background:new 0 0 117 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FF9900;%7D%0A%3C/style%3E%3Ctitle%3EUeberweisung_icon%3C/title%3E%3Cg id='Symbols'%3E%3Cg id='Ueberweisung'%3E%3Cg id='Fill' transform='translate(1.000000, 5.000000)'%3E%3Cg%3E%3Cpath id='Shape' class='st0' d='M44.7679482,1.7583302c4.7359505,0,8.6624947,3.4655061,9.3820915,7.9989891 l14.1179047,0.0010109c0.5522919,0,1,0.4477148,1,1c0,0.5128355-0.3860321,0.9355068-0.8833771,0.9932718l-0.1166229,0.0067282 L54.2550545,11.757596c-0.0746727,1.4422369-0.4710007,2.7993975-1.118618,4.0011206l1.1315155-0.0003862 c0.5522842,0,1,0.4477148,1,1.000001c0,0.5128345-0.3860435,0.9355068-0.8833809,0.9932709l-0.1166191,0.0067272 l-2.5724716,0.0007629c-1.7330513,1.8460941-4.1956253,2.9992371-6.9275322,2.9992371 c-0.8651619,0-1.7033157-0.1156502-2.4998398-0.3323345l-0.0001602,14.3323364 c0,0.5128365,0.3860435,0.9355049,0.8833809,0.9932709l0.1166191,0.0067291h29.9999962 c0.5128403,0,0.9355164-0.3860397,0.9932785-0.8833809l0.0067215-0.1166191V22.7583294c0-0.5522842,0.4477234-1,1-1 c0.5128403,0,0.9355164,0.3860416,0.9932785,0.883379l0.0067215,0.116621v12.0000019 c0,1.5976791-1.2489166,2.9036598-2.8237228,2.9949074l-0.1762772,0.0050926H43.2679482 c-1.5976791,0-2.9036598-1.2489204-2.9949074-2.8237267l-0.0050926-0.1762733l0.0006065-15.1309814 c-2.9771843-1.6039753-5.0006065-4.7502003-5.0006065-8.3690195C35.2679482,6.0116253,39.521244,1.7583302,44.7679482,1.7583302 z M71.2679443,31.7583294c0.5522919,0,1,0.4477177,1,1.0000019c0,0.5128365-0.3860321,0.9355049-0.8833771,0.9932709 l-0.1166229,0.0067291H59.267952c-0.5522881,0-1-0.4477158-1-1c0-0.5128365,0.3860397-0.9355087,0.8833771-0.9932728 l0.1166229-0.0067291H71.2679443z M51.267952,31.7583294c0.5522842,0,1,0.4477177,1,1.0000019 c0,0.5128365-0.3860435,0.9355049-0.8833809,0.9932709l-0.1166191,0.0067291h-6.0000038c-0.5522842,0-1-0.4477158-1-1 c0-0.5128365,0.3860435-0.9355087,0.8833809-0.9932728l0.1166191-0.0067291H51.267952z M74.6698761,5.8660254 c0.5259857-0.9110336,1.6604919-1.2516952,2.5936813-0.8049893l0.1383667,0.0729384l1.732048,1 c0.9110413,0.5259857,1.2516937,1.6604934,0.8049927,2.5936828l-0.072937,0.1383686L69.4840546,26.8481178 c-0.1241913,0.2151146-0.2870941,0.4047318-0.47995,0.5595665l-0.150116,0.109457l-3.5350494,2.3340302 c-0.6564178,0.433403-1.5162201-0.0260773-1.550087-0.7841606l0.0008926-0.1102657l0.2538071-4.2284584 c0.0148849-0.2479458,0.0757828-0.4903946,0.1790314-0.7151299l0.0853195-0.1650391l0.0500488-0.0897884H63.267952 c-0.5522881,0-1-0.4477139-1-1c0-0.5128345,0.3860397-0.9355068,0.8833771-0.9932709l0.1166229-0.0067291h2 c0.0729599,0,0.1440964,0.0078144,0.2126236,0.0226517L74.6698761,5.8660254z M58.267952,26.2583294l0.1166191,0.0067291 c0.4973373,0.0577641,0.8833809,0.4804363,0.8833809,0.9932709c0,0.5128365-0.3860435,0.9355087-0.8833809,0.9932728 l-0.1166191,0.0067272h-4l-0.1166229-0.0067272c-0.4973373-0.0577641-0.8833771-0.4804363-0.8833771-0.9932728 c0-0.5128345,0.3860397-0.9355068,0.8833771-0.9932709l0.1166229-0.0067291H58.267952z M51.267952,26.2583294 l0.1166191,0.0067291c0.4973373,0.0577641,0.8833809,0.4804363,0.8833809,0.9932709 c0,0.5128365-0.3860435,0.9355087-0.8833809,0.9932728l-0.1166191,0.0067272h-6.0000038l-0.1166191-0.0067272 c-0.4973373-0.0577641-0.8833809-0.4804363-0.8833809-0.9932728c0-0.5128345,0.3860435-0.9355068,0.8833809-0.9932709 l0.1166191-0.0067291H51.267952z M76.4019241,6.8660254L66.0199585,24.8481178l-0.1346664,2.2313499l1.8667221-1.2313499 l10.381958-17.9820919L76.4019241,6.8660254z M48.2679482,21.7583294c0.5522881,0,1,0.4477158,1,1 c0,0.5128365-0.3860397,0.9355087-0.8833771,0.9932728l-0.1166229,0.0067272h-3c-0.5522842,0-1-0.4477139-1-1 c0-0.5128345,0.3860435-0.9355068,0.8833809-0.9932709l0.1166191-0.0067291H48.2679482z M54.267952,21.7583294 c0.5522842,0,1,0.4477158,1,1c0,0.5128365-0.3860435,0.9355087-0.8833809,0.9932728l-0.1166191,0.0067272h-3 c-0.5522881,0-1.0000038-0.4477139-1.0000038-1c0-0.5128345,0.3860435-0.9355068,0.8833809-0.9932709l0.1166229-0.0067291 H54.267952z M60.267952,21.7583294c0.5522842,0,1,0.4477158,1,1c0,0.5128365-0.3860435,0.9355087-0.8833809,0.9932728 l-0.1166191,0.0067272h-3c-0.5522881,0-1-0.4477139-1-1c0-0.5128345,0.3860397-0.9355068,0.8833771-0.9932709 l0.1166229-0.0067291H60.267952z M44.7679482,3.7583303c-4.1421356,0-7.5,3.3578644-7.5,7.5 c0,3.0046825,1.7668991,5.5966845,4.3183556,6.7936621c0.0602226,0.0199795,0.1176262,0.045639,0.1718903,0.0762177 c0.9208031,0.4057674,1.9390793,0.6301193,3.0097542,0.6301193c4.1421356,0,7.5000038-3.3578634,7.5000038-7.499999 S48.9100838,3.7583303,44.7679482,3.7583303z M63.267952,15.7583303c0.5522842,0,1,0.4477148,1,1.000001 c0,0.5128345-0.3860435,0.9355068-0.8833809,0.9932709l-0.1166191,0.0067272h-6c-0.5522881,0-1-0.4477139-1-0.9999981 c0-0.5128365,0.3860397-0.9355078,0.8833771-0.9932737l0.1166229-0.0067272H63.267952z M45.7648697,5.9083304 c0.8514748,0,1.6767464,0.1865726,2.4227829,0.540288c0.4241829,0.2011147,0.605011,0.7080159,0.4039001,1.1321964 c-0.2011147,0.4241805-0.7080154,0.6050105-1.1321983,0.4038963c-0.5189209-0.2460341-1.0954895-0.3763809-1.6944847-0.3763809 c-1.1970673,0-2.2545586,0.5199218-2.9296455,1.3219466l2.8741989,0.0002756 c0.4694443,0,0.8500023,0.380558,0.8500023,0.8500004c0,0.4333305-0.3242645,0.790926-0.7433777,0.8433771l-0.1066246,0.0066223 l-3.6243286,0.0001869c-0.0150032,0.1240692-0.0227013,0.250062-0.0227013,0.3775911 c0,0.1603622,0.0121727,0.3182945,0.0357361,0.4730272l3.8364868-0.0008049c0.4694443,0,0.8499985,0.380558,0.8499985,0.8500004 c0,0.4333305-0.3242607,0.790926-0.7433777,0.8433771l-0.1066208,0.0066223l-3.0162582,0.0010386 c0.6770782,0.7477217,1.6974983,1.2267389,2.8465118,1.2267389c0.5773087,0,1.1338654-0.1210613,1.6383286-0.3503094 c0.4273796-0.1942196,0.9312859-0.0052042,1.1255074,0.4221773c0.1942177,0.4273815,0.0052032,0.9312878-0.4221764,1.1255074 c-0.7248726,0.3294106-1.5211945,0.5026245-2.3416595,0.5026245c-2.1540756,0-4.0244179-1.193058-4.8902054-2.9277716 l-0.6067162-0.0000057c-0.4694405,0-0.8499985-0.380558-0.8499985-0.8499994 c0-0.4333315,0.3242607-0.7909269,0.7433777-0.8433781l0.1066208-0.0066223l0.1172371,0.0002546 c-0.0150833-0.1555119-0.0227928-0.3131056-0.0227928-0.472477c0-0.1269531,0.0048943-0.252779,0.0145073-0.3773222 l-0.1089516-0.0004559c-0.4694405,0-0.8499985-0.380558-0.8499985-0.8499994 c0-0.4333315,0.3242607-0.7909269,0.7433777-0.8433771l0.1066208-0.0066233l0.5609474-0.0002565 C41.673214,7.1447239,43.5720215,5.9083304,45.7648697,5.9083304z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\"},\"mollie\":{\"label\":\"\",\"checkoutLabel\":\"Mollie\",\"img\":\"/plugins/kosmoskosmos/ticketshop/assets/output-onlinepngtools.46d152fb.png?1648723714516\"},\"directsale\":{\"checkoutLabel\":\"Direktverkauf\",\"label\":\"Direktverkauf\"}}");

});

parcelRegister("48wMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9402aef6797fd7ff$export$2e2bcd8739ae039);
parcelRequire("hjQNM");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
function $9402aef6797fd7ff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9402aef6797fd7ff$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9402aef6797fd7ff$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9402aef6797fd7ff$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9402aef6797fd7ff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9402aef6797fd7ff$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9402aef6797fd7ff$var$unwrapObj(obj) {
    let ignoreKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return Object.keys(obj).reduce((o, k)=>{
        if (ignoreKeys.includes(k)) return o;
        o[k] = (0, $8bTPG.unref)(obj[k]);
        return o;
    }, {});
}
function $9402aef6797fd7ff$var$isFunction(val) {
    return typeof val === 'function';
}
function $9402aef6797fd7ff$var$isProxy(value) {
    return (0, $8bTPG.isReactive)(value) || (0, $8bTPG.isReadonly)(value);
}
function $9402aef6797fd7ff$var$get(obj, stringPath, def) {
    let current = obj;
    const path = stringPath.split('.');
    for(let i = 0; i < path.length; i++){
        if (!current[path[i]]) return def;
        current = current[path[i]];
    }
    return current;
}
function $9402aef6797fd7ff$var$gatherBooleanGroupProperties(group, nestedResults, property) {
    return (0, $8bTPG.computed)(()=>{
        return group.some((path)=>{
            return $9402aef6797fd7ff$var$get(nestedResults, path, {
                [property]: false
            })[property];
        });
    });
}
function $9402aef6797fd7ff$var$gatherArrayGroupProperties(group, nestedResults, property) {
    return (0, $8bTPG.computed)(()=>{
        return group.reduce((all, path)=>{
            const fetchedProperty = $9402aef6797fd7ff$var$get(nestedResults, path, {
                [property]: false
            })[property] || [];
            return all.concat(fetchedProperty);
        }, []);
    });
}
function $9402aef6797fd7ff$var$callRule(rule, value, siblingState, instance) {
    return rule.call(instance, (0, $8bTPG.unref)(value), (0, $8bTPG.unref)(siblingState), instance);
}
function $9402aef6797fd7ff$var$normalizeValidatorResponse(result) {
    return result.$valid !== undefined ? !result.$valid : !result;
}
function $9402aef6797fd7ff$var$createAsyncResult(rule, model, $pending, $dirty, _ref, $response, instance) {
    let { $lazy: $lazy, $rewardEarly: $rewardEarly } = _ref;
    let watchTargets = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
    let siblingState = arguments.length > 8 ? arguments[8] : undefined;
    let $lastInvalidState = arguments.length > 9 ? arguments[9] : undefined;
    let $lastCommittedOn = arguments.length > 10 ? arguments[10] : undefined;
    const $invalid = (0, $8bTPG.ref)(!!$dirty.value);
    const $pendingCounter = (0, $8bTPG.ref)(0);
    $pending.value = false;
    const $unwatch = (0, $8bTPG.watch)([
        model,
        $dirty
    ].concat(watchTargets, $lastCommittedOn), ()=>{
        if ($lazy && !$dirty.value || $rewardEarly && !$lastInvalidState.value && !$pending.value) return;
        let ruleResult;
        try {
            ruleResult = $9402aef6797fd7ff$var$callRule(rule, model, siblingState, instance);
        } catch (err) {
            ruleResult = Promise.reject(err);
        }
        $pendingCounter.value++;
        $pending.value = !!$pendingCounter.value;
        $invalid.value = false;
        Promise.resolve(ruleResult).then((data)=>{
            $pendingCounter.value--;
            $pending.value = !!$pendingCounter.value;
            $response.value = data;
            $invalid.value = $9402aef6797fd7ff$var$normalizeValidatorResponse(data);
        }).catch((error)=>{
            $pendingCounter.value--;
            $pending.value = !!$pendingCounter.value;
            $response.value = error;
            $invalid.value = true;
        });
    }, {
        immediate: true,
        deep: typeof model === 'object'
    });
    return {
        $invalid: $invalid,
        $unwatch: $unwatch
    };
}
function $9402aef6797fd7ff$var$createSyncResult(rule, model, $dirty, _ref2, $response, instance, siblingState, $lastInvalidState) {
    let { $lazy: $lazy, $rewardEarly: $rewardEarly } = _ref2;
    const $unwatch = ()=>({});
    const $invalid = (0, $8bTPG.computed)(()=>{
        if ($lazy && !$dirty.value || $rewardEarly && !$lastInvalidState.value) return false;
        let returnValue = true;
        try {
            const result = $9402aef6797fd7ff$var$callRule(rule, model, siblingState, instance);
            $response.value = result;
            returnValue = $9402aef6797fd7ff$var$normalizeValidatorResponse(result);
        } catch (err) {
            $response.value = err;
        }
        return returnValue;
    });
    return {
        $unwatch: $unwatch,
        $invalid: $invalid
    };
}
function $9402aef6797fd7ff$var$createValidatorResult(rule, model, $dirty, config, instance, validatorName, propertyKey, propertyPath, siblingState, $lastInvalidState, $lastCommittedOn) {
    const $pending = (0, $8bTPG.ref)(false);
    const $params = rule.$params || {};
    const $response = (0, $8bTPG.ref)(null);
    let $invalid;
    let $unwatch;
    if (rule.$async) ({ $invalid: $invalid, $unwatch: $unwatch } = $9402aef6797fd7ff$var$createAsyncResult(rule.$validator, model, $pending, $dirty, config, $response, instance, rule.$watchTargets, siblingState, $lastInvalidState, $lastCommittedOn));
    else ({ $invalid: $invalid, $unwatch: $unwatch } = $9402aef6797fd7ff$var$createSyncResult(rule.$validator, model, $dirty, config, $response, instance, siblingState, $lastInvalidState));
    const message = rule.$message;
    const $message = $9402aef6797fd7ff$var$isFunction(message) ? (0, $8bTPG.computed)(()=>message($9402aef6797fd7ff$var$unwrapObj({
            $pending: $pending,
            $invalid: $invalid,
            $params: $9402aef6797fd7ff$var$unwrapObj($params),
            $model: model,
            $response: $response,
            $validator: validatorName,
            $propertyPath: propertyPath,
            $property: propertyKey
        }))) : message || '';
    return {
        $message: $message,
        $params: $params,
        $pending: $pending,
        $invalid: $invalid,
        $response: $response,
        $unwatch: $unwatch
    };
}
function $9402aef6797fd7ff$var$sortValidations() {
    let validationsRaw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const validations = (0, $8bTPG.unref)(validationsRaw);
    const validationKeys = Object.keys(validations);
    const rules = {};
    const nestedValidators = {};
    const config = {};
    let validationGroups = null;
    validationKeys.forEach((key)=>{
        const v = validations[key];
        switch(true){
            case $9402aef6797fd7ff$var$isFunction(v.$validator):
                rules[key] = v;
                break;
            case $9402aef6797fd7ff$var$isFunction(v):
                rules[key] = {
                    $validator: v
                };
                break;
            case key === '$validationGroups':
                validationGroups = v;
                break;
            case key.startsWith('$'):
                config[key] = v;
                break;
            default:
                nestedValidators[key] = v;
        }
    });
    return {
        rules: rules,
        nestedValidators: nestedValidators,
        config: config,
        validationGroups: validationGroups
    };
}
const $9402aef6797fd7ff$var$ROOT_PATH = '__root';
function $9402aef6797fd7ff$var$createValidationResults(rules, model, key, resultsCache, path, config, instance, externalResults, siblingState) {
    const ruleKeys = Object.keys(rules);
    const cachedResult = resultsCache.get(path, rules);
    const $dirty = (0, $8bTPG.ref)(false);
    const $lastInvalidState = (0, $8bTPG.ref)(false);
    const $lastCommittedOn = (0, $8bTPG.ref)(0);
    if (cachedResult) {
        if (!cachedResult.$partial) return cachedResult;
        cachedResult.$unwatch();
        $dirty.value = cachedResult.$dirty.value;
    }
    const result = {
        $dirty: $dirty,
        $path: path,
        $touch: ()=>{
            if (!$dirty.value) $dirty.value = true;
        },
        $reset: ()=>{
            if ($dirty.value) $dirty.value = false;
        },
        $commit: ()=>{}
    };
    if (!ruleKeys.length) {
        cachedResult && resultsCache.set(path, rules, result);
        return result;
    }
    ruleKeys.forEach((ruleKey)=>{
        result[ruleKey] = $9402aef6797fd7ff$var$createValidatorResult(rules[ruleKey], model, result.$dirty, config, instance, ruleKey, key, path, siblingState, $lastInvalidState, $lastCommittedOn);
    });
    result.$externalResults = (0, $8bTPG.computed)(()=>{
        if (!externalResults.value) return [];
        return [].concat(externalResults.value).map((stringError, index)=>({
                $propertyPath: path,
                $property: key,
                $validator: '$externalResults',
                $uid: `${path}-externalResult-${index}`,
                $message: stringError,
                $params: {},
                $response: null,
                $pending: false
            }));
    });
    result.$invalid = (0, $8bTPG.computed)(()=>{
        const r = ruleKeys.some((ruleKey)=>(0, $8bTPG.unref)(result[ruleKey].$invalid));
        $lastInvalidState.value = r;
        return !!result.$externalResults.value.length || r;
    });
    result.$pending = (0, $8bTPG.computed)(()=>ruleKeys.some((ruleKey)=>(0, $8bTPG.unref)(result[ruleKey].$pending)));
    result.$error = (0, $8bTPG.computed)(()=>result.$dirty.value ? result.$pending.value || result.$invalid.value : false);
    result.$silentErrors = (0, $8bTPG.computed)(()=>ruleKeys.filter((ruleKey)=>(0, $8bTPG.unref)(result[ruleKey].$invalid)).map((ruleKey)=>{
            const res = result[ruleKey];
            return (0, $8bTPG.reactive)({
                $propertyPath: path,
                $property: key,
                $validator: ruleKey,
                $uid: `${path}-${ruleKey}`,
                $message: res.$message,
                $params: res.$params,
                $response: res.$response,
                $pending: res.$pending
            });
        }).concat(result.$externalResults.value));
    result.$errors = (0, $8bTPG.computed)(()=>result.$dirty.value ? result.$silentErrors.value : []);
    result.$unwatch = ()=>ruleKeys.forEach((ruleKey)=>{
            result[ruleKey].$unwatch();
        });
    result.$commit = ()=>{
        $lastInvalidState.value = true;
        $lastCommittedOn.value = Date.now();
    };
    resultsCache.set(path, rules, result);
    return result;
}
function $9402aef6797fd7ff$var$collectNestedValidationResults(validations, nestedState, path, resultsCache, config, instance, nestedExternalResults) {
    const nestedValidationKeys = Object.keys(validations);
    if (!nestedValidationKeys.length) return {};
    return nestedValidationKeys.reduce((results, nestedKey)=>{
        results[nestedKey] = $9402aef6797fd7ff$var$setValidations({
            validations: validations[nestedKey],
            state: nestedState,
            key: nestedKey,
            parentKey: path,
            resultsCache: resultsCache,
            globalConfig: config,
            instance: instance,
            externalResults: nestedExternalResults
        });
        return results;
    }, {});
}
function $9402aef6797fd7ff$var$createMetaFields(results, nestedResults, childResults) {
    const allResults = (0, $8bTPG.computed)(()=>[
            nestedResults,
            childResults
        ].filter((res)=>res).reduce((allRes, res)=>{
            return allRes.concat(Object.values((0, $8bTPG.unref)(res)));
        }, []));
    const $dirty = (0, $8bTPG.computed)({
        get () {
            return results.$dirty.value || (allResults.value.length ? allResults.value.every((r)=>r.$dirty) : false);
        },
        set (v) {
            results.$dirty.value = v;
        }
    });
    const $silentErrors = (0, $8bTPG.computed)(()=>{
        const modelErrors = (0, $8bTPG.unref)(results.$silentErrors) || [];
        const nestedErrors = allResults.value.filter((result)=>((0, $8bTPG.unref)(result).$silentErrors || []).length).reduce((errors, result)=>{
            return errors.concat(...result.$silentErrors);
        }, []);
        return modelErrors.concat(nestedErrors);
    });
    const $errors = (0, $8bTPG.computed)(()=>{
        const modelErrors = (0, $8bTPG.unref)(results.$errors) || [];
        const nestedErrors = allResults.value.filter((result)=>((0, $8bTPG.unref)(result).$errors || []).length).reduce((errors, result)=>{
            return errors.concat(...result.$errors);
        }, []);
        return modelErrors.concat(nestedErrors);
    });
    const $invalid = (0, $8bTPG.computed)(()=>allResults.value.some((r)=>r.$invalid) || (0, $8bTPG.unref)(results.$invalid) || false);
    const $pending = (0, $8bTPG.computed)(()=>allResults.value.some((r)=>(0, $8bTPG.unref)(r.$pending)) || (0, $8bTPG.unref)(results.$pending) || false);
    const $anyDirty = (0, $8bTPG.computed)(()=>allResults.value.some((r)=>r.$dirty) || allResults.value.some((r)=>r.$anyDirty) || $dirty.value);
    const $error = (0, $8bTPG.computed)(()=>$dirty.value ? $pending.value || $invalid.value : false);
    const $touch = ()=>{
        results.$touch();
        allResults.value.forEach((result)=>{
            result.$touch();
        });
    };
    const $commit = ()=>{
        results.$commit();
        allResults.value.forEach((result)=>{
            result.$commit();
        });
    };
    const $reset = ()=>{
        results.$reset();
        allResults.value.forEach((result)=>{
            result.$reset();
        });
    };
    if (allResults.value.length && allResults.value.every((nr)=>nr.$dirty)) $touch();
    return {
        $dirty: $dirty,
        $errors: $errors,
        $invalid: $invalid,
        $anyDirty: $anyDirty,
        $error: $error,
        $pending: $pending,
        $touch: $touch,
        $reset: $reset,
        $silentErrors: $silentErrors,
        $commit: $commit
    };
}
function $9402aef6797fd7ff$var$setValidations(_ref) {
    let { validations: validations, state: state, key: key, parentKey: parentKey, childResults: childResults, resultsCache: resultsCache, globalConfig: globalConfig = {}, instance: instance, externalResults: externalResults } = _ref;
    const path = parentKey ? `${parentKey}.${key}` : key;
    const { rules: rules, nestedValidators: nestedValidators, config: config, validationGroups: validationGroups } = $9402aef6797fd7ff$var$sortValidations(validations);
    const mergedConfig = $9402aef6797fd7ff$var$_objectSpread2($9402aef6797fd7ff$var$_objectSpread2({}, globalConfig), config);
    const nestedState = key ? (0, $8bTPG.computed)(()=>{
        const s = (0, $8bTPG.unref)(state);
        return s ? (0, $8bTPG.unref)(s[key]) : undefined;
    }) : state;
    const cachedExternalResults = $9402aef6797fd7ff$var$_objectSpread2({}, (0, $8bTPG.unref)(externalResults) || {});
    const nestedExternalResults = (0, $8bTPG.computed)(()=>{
        const results = (0, $8bTPG.unref)(externalResults);
        if (!key) return results;
        return results ? (0, $8bTPG.unref)(results[key]) : undefined;
    });
    const results = $9402aef6797fd7ff$var$createValidationResults(rules, nestedState, key, resultsCache, path, mergedConfig, instance, nestedExternalResults, state);
    const nestedResults = $9402aef6797fd7ff$var$collectNestedValidationResults(nestedValidators, nestedState, path, resultsCache, mergedConfig, instance, nestedExternalResults);
    const $validationGroups = {};
    if (validationGroups) Object.entries(validationGroups).forEach((_ref2)=>{
        let [key, group] = _ref2;
        $validationGroups[key] = {
            $invalid: $9402aef6797fd7ff$var$gatherBooleanGroupProperties(group, nestedResults, '$invalid'),
            $error: $9402aef6797fd7ff$var$gatherBooleanGroupProperties(group, nestedResults, '$error'),
            $pending: $9402aef6797fd7ff$var$gatherBooleanGroupProperties(group, nestedResults, '$pending'),
            $errors: $9402aef6797fd7ff$var$gatherArrayGroupProperties(group, nestedResults, '$errors'),
            $silentErrors: $9402aef6797fd7ff$var$gatherArrayGroupProperties(group, nestedResults, '$silentErrors')
        };
    });
    const { $dirty: $dirty, $errors: $errors, $invalid: $invalid, $anyDirty: $anyDirty, $error: $error, $pending: $pending, $touch: $touch, $reset: $reset, $silentErrors: $silentErrors, $commit: $commit } = $9402aef6797fd7ff$var$createMetaFields(results, nestedResults, childResults);
    const $model = key ? (0, $8bTPG.computed)({
        get: ()=>(0, $8bTPG.unref)(nestedState),
        set: (val)=>{
            $dirty.value = true;
            const s = (0, $8bTPG.unref)(state);
            const external = (0, $8bTPG.unref)(externalResults);
            if (external) external[key] = cachedExternalResults[key];
            if ((0, $8bTPG.isRef)(s[key])) s[key].value = val;
            else s[key] = val;
        }
    }) : null;
    if (key && mergedConfig.$autoDirty) (0, $8bTPG.watch)(nestedState, ()=>{
        if (!$dirty.value) $touch();
        const external = (0, $8bTPG.unref)(externalResults);
        if (external) external[key] = cachedExternalResults[key];
    }, {
        flush: 'sync'
    });
    async function $validate() {
        $touch();
        if (mergedConfig.$rewardEarly) {
            $commit();
            await (0, $ani5R.nextTick)();
        }
        await (0, $ani5R.nextTick)();
        return new Promise((resolve)=>{
            if (!$pending.value) return resolve(!$invalid.value);
            const unwatch = (0, $8bTPG.watch)($pending, ()=>{
                resolve(!$invalid.value);
                unwatch();
            });
        });
    }
    function $getResultsForChild(key) {
        return (childResults.value || {})[key];
    }
    function $clearExternalResults() {
        if ((0, $8bTPG.isRef)(externalResults)) externalResults.value = cachedExternalResults;
        else if (Object.keys(cachedExternalResults).length === 0) Object.keys(externalResults).forEach((k)=>{
            delete externalResults[k];
        });
        else Object.assign(externalResults, cachedExternalResults);
    }
    return (0, $8bTPG.reactive)($9402aef6797fd7ff$var$_objectSpread2($9402aef6797fd7ff$var$_objectSpread2($9402aef6797fd7ff$var$_objectSpread2({}, results), {}, {
        $model: $model,
        $dirty: $dirty,
        $error: $error,
        $errors: $errors,
        $invalid: $invalid,
        $anyDirty: $anyDirty,
        $pending: $pending,
        $touch: $touch,
        $reset: $reset,
        $path: path || $9402aef6797fd7ff$var$ROOT_PATH,
        $silentErrors: $silentErrors,
        $validate: $validate,
        $commit: $commit
    }, childResults && {
        $getResultsForChild: $getResultsForChild,
        $clearExternalResults: $clearExternalResults,
        $validationGroups: $validationGroups
    }), nestedResults));
}
class $9402aef6797fd7ff$var$ResultsStorage {
    constructor(){
        this.storage = new Map();
    }
    set(path, rules, result) {
        this.storage.set(path, {
            rules: rules,
            result: result
        });
    }
    checkRulesValidity(path, rules, storedRules) {
        const storedRulesKeys = Object.keys(storedRules);
        const newRulesKeys = Object.keys(rules);
        if (newRulesKeys.length !== storedRulesKeys.length) return false;
        const hasAllValidators = newRulesKeys.every((ruleKey)=>storedRulesKeys.includes(ruleKey));
        if (!hasAllValidators) return false;
        return newRulesKeys.every((ruleKey)=>{
            if (!rules[ruleKey].$params) return true;
            return Object.keys(rules[ruleKey].$params).every((paramKey)=>{
                return (0, $8bTPG.unref)(storedRules[ruleKey].$params[paramKey]) === (0, $8bTPG.unref)(rules[ruleKey].$params[paramKey]);
            });
        });
    }
    get(path, rules) {
        const storedRuleResultPair = this.storage.get(path);
        if (!storedRuleResultPair) return undefined;
        const { rules: storedRules, result: result } = storedRuleResultPair;
        const isValidCache = this.checkRulesValidity(path, rules, storedRules);
        const $unwatch = result.$unwatch ? result.$unwatch : ()=>({});
        if (!isValidCache) return {
            $dirty: result.$dirty,
            $partial: true,
            $unwatch: $unwatch
        };
        return result;
    }
}
const $9402aef6797fd7ff$export$2370ce9dc35003f3 = {
    COLLECT_ALL: true,
    COLLECT_NONE: false
};
const $9402aef6797fd7ff$var$VuelidateInjectChildResults = Symbol('vuelidate#injectChildResults');
const $9402aef6797fd7ff$var$VuelidateRemoveChildResults = Symbol('vuelidate#removeChildResults');
function $9402aef6797fd7ff$var$nestedValidations(_ref) {
    let { $scope: $scope, instance: instance } = _ref;
    const childResultsRaw = {};
    const childResultsKeys = (0, $8bTPG.ref)([]);
    const childResults = (0, $8bTPG.computed)(()=>childResultsKeys.value.reduce((results, key)=>{
            results[key] = (0, $8bTPG.unref)(childResultsRaw[key]);
            return results;
        }, {}));
    function injectChildResultsIntoParent(results, _ref2) {
        let { $registerAs: key, $scope: childScope, $stopPropagation: $stopPropagation } = _ref2;
        if ($stopPropagation || $scope === $9402aef6797fd7ff$export$2370ce9dc35003f3.COLLECT_NONE || childScope === $9402aef6797fd7ff$export$2370ce9dc35003f3.COLLECT_NONE || $scope !== $9402aef6797fd7ff$export$2370ce9dc35003f3.COLLECT_ALL && $scope !== childScope) return;
        childResultsRaw[key] = results;
        childResultsKeys.value.push(key);
    }
    instance.__vuelidateInjectInstances = [].concat(instance.__vuelidateInjectInstances || [], injectChildResultsIntoParent);
    function removeChildResultsFromParent(key) {
        childResultsKeys.value = childResultsKeys.value.filter((childKey)=>childKey !== key);
        delete childResultsRaw[key];
    }
    instance.__vuelidateRemoveInstances = [].concat(instance.__vuelidateRemoveInstances || [], removeChildResultsFromParent);
    const sendValidationResultsToParent = (0, $ani5R.inject)($9402aef6797fd7ff$var$VuelidateInjectChildResults, []);
    (0, $ani5R.provide)($9402aef6797fd7ff$var$VuelidateInjectChildResults, instance.__vuelidateInjectInstances);
    const removeValidationResultsFromParent = (0, $ani5R.inject)($9402aef6797fd7ff$var$VuelidateRemoveChildResults, []);
    (0, $ani5R.provide)($9402aef6797fd7ff$var$VuelidateRemoveChildResults, instance.__vuelidateRemoveInstances);
    return {
        childResults: childResults,
        sendValidationResultsToParent: sendValidationResultsToParent,
        removeValidationResultsFromParent: removeValidationResultsFromParent
    };
}
function $9402aef6797fd7ff$var$ComputedProxyFactory(target) {
    return new Proxy(target, {
        get (target, prop) {
            return typeof target[prop] === 'object' ? $9402aef6797fd7ff$var$ComputedProxyFactory(target[prop]) : (0, $8bTPG.computed)(()=>target[prop]);
        }
    });
}
let $9402aef6797fd7ff$var$uid = 0;
function $9402aef6797fd7ff$export$2e2bcd8739ae039(validations, state) {
    var _getCurrentInstance;
    let globalConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (arguments.length === 1) {
        globalConfig = validations;
        validations = undefined;
        state = undefined;
    }
    let { $registerAs: $registerAs, $scope: $scope = $9402aef6797fd7ff$export$2370ce9dc35003f3.COLLECT_ALL, $stopPropagation: $stopPropagation, $externalResults: $externalResults, currentVueInstance: currentVueInstance } = globalConfig;
    const instance = currentVueInstance || ((_getCurrentInstance = (0, $ani5R.getCurrentInstance)()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy);
    const componentOptions = instance ? instance.$options : {};
    if (!$registerAs) {
        $9402aef6797fd7ff$var$uid += 1;
        $registerAs = `_vuelidate_${$9402aef6797fd7ff$var$uid}`;
    }
    const validationResults = (0, $8bTPG.ref)({});
    const resultsCache = new $9402aef6797fd7ff$var$ResultsStorage();
    const { childResults: childResults, sendValidationResultsToParent: sendValidationResultsToParent, removeValidationResultsFromParent: removeValidationResultsFromParent } = instance ? $9402aef6797fd7ff$var$nestedValidations({
        $scope: $scope,
        instance: instance
    }) : {
        childResults: (0, $8bTPG.ref)({})
    };
    if (!validations && componentOptions.validations) {
        const rules = componentOptions.validations;
        state = (0, $8bTPG.ref)({});
        (0, $ani5R.onBeforeMount)(()=>{
            state.value = instance;
            (0, $8bTPG.watch)(()=>$9402aef6797fd7ff$var$isFunction(rules) ? rules.call(state.value, new $9402aef6797fd7ff$var$ComputedProxyFactory(state.value)) : rules, (validations)=>{
                validationResults.value = $9402aef6797fd7ff$var$setValidations({
                    validations: validations,
                    state: state,
                    childResults: childResults,
                    resultsCache: resultsCache,
                    globalConfig: globalConfig,
                    instance: instance,
                    externalResults: $externalResults || instance.vuelidateExternalResults
                });
            }, {
                immediate: true
            });
        });
        globalConfig = componentOptions.validationsConfig || globalConfig;
    } else {
        const validationsWatchTarget = (0, $8bTPG.isRef)(validations) || $9402aef6797fd7ff$var$isProxy(validations) ? validations : (0, $8bTPG.reactive)(validations || {});
        (0, $8bTPG.watch)(validationsWatchTarget, (newValidationRules)=>{
            validationResults.value = $9402aef6797fd7ff$var$setValidations({
                validations: newValidationRules,
                state: state,
                childResults: childResults,
                resultsCache: resultsCache,
                globalConfig: globalConfig,
                instance: instance !== null && instance !== void 0 ? instance : {},
                externalResults: $externalResults
            });
        }, {
            immediate: true
        });
    }
    if (instance) {
        sendValidationResultsToParent.forEach((f)=>f(validationResults, {
                $registerAs: $registerAs,
                $scope: $scope,
                $stopPropagation: $stopPropagation
            }));
        (0, $ani5R.onBeforeUnmount)(()=>removeValidationResultsFromParent.forEach((f)=>f($registerAs)));
    }
    return (0, $8bTPG.computed)(()=>{
        return $9402aef6797fd7ff$var$_objectSpread2($9402aef6797fd7ff$var$_objectSpread2({}, (0, $8bTPG.unref)(validationResults.value)), childResults.value);
    });
}

});
parcelRegister("hjQNM", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("8bTPG")).computed);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("ani5R")).getCurrentInstance);
$parcel$export(module.exports, "inject", () => (parcelRequire("ani5R")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("8bTPG")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("8bTPG")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("8bTPG")).isRef);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("ani5R")).nextTick);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("ani5R")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("ani5R")).onBeforeUnmount);
$parcel$export(module.exports, "provide", () => (parcelRequire("ani5R")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("8bTPG")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("8bTPG")).ref);
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
$parcel$export(module.exports, "watch", () => (parcelRequire("8bTPG")).watch);
parcelRequire("ey4ci");
var $fee46427aa9165cb$export$1da84e343e81ceb9 = false;
var $fee46427aa9165cb$export$34b222e3d4733e48 = true;
var $fee46427aa9165cb$export$a8cb34872e7d8b79 = undefined;
function $fee46427aa9165cb$export$4b3e715f166fdd78() {}
function $fee46427aa9165cb$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $fee46427aa9165cb$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});


parcelRegister("gI8rb", function(module, exports) {

$parcel$export(module.exports, "required", () => $7d8fdfa81fd5f9e7$export$a7a0278c004aac3f);
parcelRequire("4nmGo");
var $8bTPG = parcelRequire("8bTPG");
function $7d8fdfa81fd5f9e7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d8fdfa81fd5f9e7$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d8fdfa81fd5f9e7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7d8fdfa81fd5f9e7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d8fdfa81fd5f9e7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7d8fdfa81fd5f9e7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d8fdfa81fd5f9e7$var$isFunction(val) {
    return typeof val === 'function';
}
function $7d8fdfa81fd5f9e7$var$isObject(o) {
    return o !== null && typeof o === 'object' && !Array.isArray(o);
}
function $7d8fdfa81fd5f9e7$var$normalizeValidatorObject(validator) {
    return $7d8fdfa81fd5f9e7$var$isFunction(validator.$validator) ? $7d8fdfa81fd5f9e7$var$_objectSpread2({}, validator) : {
        $validator: validator
    };
}
function $7d8fdfa81fd5f9e7$var$isPromise(object) {
    return $7d8fdfa81fd5f9e7$var$isObject(object) && $7d8fdfa81fd5f9e7$var$isFunction(object.then);
}
function $7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(result) {
    if (typeof result === 'object') return result.$valid;
    return result;
}
function $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(validator) {
    return validator.$validator || validator;
}
function $7d8fdfa81fd5f9e7$var$withParams($params, $validator) {
    if (!$7d8fdfa81fd5f9e7$var$isObject($params)) throw new Error(`[@vuelidate/validators]: First parameter to "withParams" should be an object, provided ${typeof $params}`);
    if (!$7d8fdfa81fd5f9e7$var$isObject($validator) && !$7d8fdfa81fd5f9e7$var$isFunction($validator)) throw new Error(`[@vuelidate/validators]: Validator must be a function or object with $validator parameter`);
    const validatorObj = $7d8fdfa81fd5f9e7$var$normalizeValidatorObject($validator);
    validatorObj.$params = $7d8fdfa81fd5f9e7$var$_objectSpread2($7d8fdfa81fd5f9e7$var$_objectSpread2({}, validatorObj.$params || {}), $params);
    return validatorObj;
}
function $7d8fdfa81fd5f9e7$var$withMessage($message, $validator) {
    if (!$7d8fdfa81fd5f9e7$var$isFunction($message) && typeof (0, $8bTPG.unref)($message) !== 'string') throw new Error(`[@vuelidate/validators]: First parameter to "withMessage" should be string or a function returning a string, provided ${typeof $message}`);
    if (!$7d8fdfa81fd5f9e7$var$isObject($validator) && !$7d8fdfa81fd5f9e7$var$isFunction($validator)) throw new Error(`[@vuelidate/validators]: Validator must be a function or object with $validator parameter`);
    const validatorObj = $7d8fdfa81fd5f9e7$var$normalizeValidatorObject($validator);
    validatorObj.$message = $message;
    return validatorObj;
}
function $7d8fdfa81fd5f9e7$var$withAsync($validator) {
    let $watchTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    const validatorObj = $7d8fdfa81fd5f9e7$var$normalizeValidatorObject($validator);
    return $7d8fdfa81fd5f9e7$var$_objectSpread2($7d8fdfa81fd5f9e7$var$_objectSpread2({}, validatorObj), {}, {
        $async: true,
        $watchTargets: $watchTargets
    });
}
function $7d8fdfa81fd5f9e7$var$forEach(validators) {
    return {
        $validator (collection) {
            for(var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)others[_key - 1] = arguments[_key];
            return (0, $8bTPG.unref)(collection).reduce((previous, collectionItem, index)=>{
                const collectionEntryResult = Object.entries(collectionItem).reduce((all, _ref)=>{
                    let [property, $model] = _ref;
                    const innerValidators = validators[property] || {};
                    const propertyResult = Object.entries(innerValidators).reduce((all, _ref2)=>{
                        let [validatorName, currentValidator] = _ref2;
                        const validatorFunction = $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(currentValidator);
                        const $response = validatorFunction.call(this, $model, collectionItem, index, ...others);
                        const $valid = $7d8fdfa81fd5f9e7$var$unwrapValidatorResponse($response);
                        all.$data[validatorName] = $response;
                        all.$data.$invalid = !$valid || !!all.$data.$invalid;
                        all.$data.$error = all.$data.$invalid;
                        if (!$valid) {
                            let $message = currentValidator.$message || '';
                            const $params = currentValidator.$params || {};
                            if (typeof $message === 'function') $message = $message({
                                $pending: false,
                                $invalid: !$valid,
                                $params: $params,
                                $model: $model,
                                $response: $response
                            });
                            all.$errors.push({
                                $property: property,
                                $message: $message,
                                $params: $params,
                                $response: $response,
                                $model: $model,
                                $pending: false,
                                $validator: validatorName
                            });
                        }
                        return {
                            $valid: all.$valid && $valid,
                            $data: all.$data,
                            $errors: all.$errors
                        };
                    }, {
                        $valid: true,
                        $data: {},
                        $errors: []
                    });
                    all.$data[property] = propertyResult.$data;
                    all.$errors[property] = propertyResult.$errors;
                    return {
                        $valid: all.$valid && propertyResult.$valid,
                        $data: all.$data,
                        $errors: all.$errors
                    };
                }, {
                    $valid: true,
                    $data: {},
                    $errors: {}
                });
                return {
                    $valid: previous.$valid && collectionEntryResult.$valid,
                    $data: previous.$data.concat(collectionEntryResult.$data),
                    $errors: previous.$errors.concat(collectionEntryResult.$errors)
                };
            }, {
                $valid: true,
                $data: [],
                $errors: []
            });
        },
        $message: (_ref3)=>{
            let { $response: $response } = _ref3;
            return $response ? $response.$errors.map((context)=>{
                return Object.values(context).map((errors)=>errors.map((error)=>error.$message)).reduce((a, b)=>a.concat(b), []);
            }) : [];
        }
    };
}
const $7d8fdfa81fd5f9e7$var$req = (value)=>{
    value = (0, $8bTPG.unref)(value);
    if (Array.isArray(value)) return !!value.length;
    if (value === undefined || value === null) return false;
    if (value === false) return true;
    if (value instanceof Date) return !isNaN(value.getTime());
    if (typeof value === 'object') {
        for(let _ in value)return true;
        return false;
    }
    return !!String(value).length;
};
const $7d8fdfa81fd5f9e7$var$len = (value)=>{
    value = (0, $8bTPG.unref)(value);
    if (Array.isArray(value)) return value.length;
    if (typeof value === 'object') return Object.keys(value).length;
    return String(value).length;
};
function $7d8fdfa81fd5f9e7$var$regex() {
    for(var _len = arguments.length, expr = new Array(_len), _key = 0; _key < _len; _key++)expr[_key] = arguments[_key];
    return (value)=>{
        value = (0, $8bTPG.unref)(value);
        return !$7d8fdfa81fd5f9e7$var$req(value) || expr.every((reg)=>{
            reg.lastIndex = 0;
            return reg.test(value);
        });
    };
}
var $7d8fdfa81fd5f9e7$export$cbfd4c4104bf5a27 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    forEach: $7d8fdfa81fd5f9e7$var$forEach,
    len: $7d8fdfa81fd5f9e7$var$len,
    normalizeValidatorObject: $7d8fdfa81fd5f9e7$var$normalizeValidatorObject,
    regex: $7d8fdfa81fd5f9e7$var$regex,
    req: $7d8fdfa81fd5f9e7$var$req,
    unwrap: (0, $8bTPG.unref),
    unwrapNormalizedValidator: $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator,
    unwrapValidatorResponse: $7d8fdfa81fd5f9e7$var$unwrapValidatorResponse,
    withAsync: $7d8fdfa81fd5f9e7$var$withAsync,
    withMessage: $7d8fdfa81fd5f9e7$var$withMessage,
    withParams: $7d8fdfa81fd5f9e7$var$withParams
});
var $7d8fdfa81fd5f9e7$var$alpha$1 = $7d8fdfa81fd5f9e7$var$regex(/^[a-zA-Z]*$/);
var $7d8fdfa81fd5f9e7$export$58f0f39f63f3cf42 = {
    $validator: $7d8fdfa81fd5f9e7$var$alpha$1,
    $message: 'The value is not alphabetical',
    $params: {
        type: 'alpha'
    }
};
var $7d8fdfa81fd5f9e7$var$alphaNum$1 = $7d8fdfa81fd5f9e7$var$regex(/^[a-zA-Z0-9]*$/);
var $7d8fdfa81fd5f9e7$export$2f9d0d831d496619 = {
    $validator: $7d8fdfa81fd5f9e7$var$alphaNum$1,
    $message: 'The value must be alpha-numeric',
    $params: {
        type: 'alphaNum'
    }
};
var $7d8fdfa81fd5f9e7$var$numeric$1 = $7d8fdfa81fd5f9e7$var$regex(/^\d*(\.\d+)?$/);
var $7d8fdfa81fd5f9e7$export$b7a508fa8dae59fc = {
    $validator: $7d8fdfa81fd5f9e7$var$numeric$1,
    $message: 'Value must be numeric',
    $params: {
        type: 'numeric'
    }
};
function $7d8fdfa81fd5f9e7$var$between$1(min, max) {
    return (value)=>!$7d8fdfa81fd5f9e7$var$req(value) || (!/\s/.test(value) || value instanceof Date) && +(0, $8bTPG.unref)(min) <= +value && +(0, $8bTPG.unref)(max) >= +value;
}
function $7d8fdfa81fd5f9e7$export$cf95c51b03f10bae(min, max) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$between$1(min, max),
        $message: (_ref)=>{
            let { $params: $params } = _ref;
            return `The value must be between ${$params.min} and ${$params.max}`;
        },
        $params: {
            min: min,
            max: max,
            type: 'between'
        }
    };
}
const $7d8fdfa81fd5f9e7$var$emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var $7d8fdfa81fd5f9e7$var$email$1 = $7d8fdfa81fd5f9e7$var$regex($7d8fdfa81fd5f9e7$var$emailRegex);
var $7d8fdfa81fd5f9e7$export$d290fa47940df19d = {
    $validator: $7d8fdfa81fd5f9e7$var$email$1,
    $message: 'Value is not a valid email address',
    $params: {
        type: 'email'
    }
};
function $7d8fdfa81fd5f9e7$var$ipAddress$1(value) {
    if (!$7d8fdfa81fd5f9e7$var$req(value)) return true;
    if (typeof value !== 'string') return false;
    const nibbles = value.split('.');
    return nibbles.length === 4 && nibbles.every($7d8fdfa81fd5f9e7$var$nibbleValid);
}
const $7d8fdfa81fd5f9e7$var$nibbleValid = (nibble)=>{
    if (nibble.length > 3 || nibble.length === 0) return false;
    if (nibble[0] === '0' && nibble !== '0') return false;
    if (!nibble.match(/^\d+$/)) return false;
    const numeric = +nibble | 0;
    return numeric >= 0 && numeric <= 255;
};
var $7d8fdfa81fd5f9e7$export$450e57019586b28f = {
    $validator: $7d8fdfa81fd5f9e7$var$ipAddress$1,
    $message: 'The value is not a valid IP address',
    $params: {
        type: 'ipAddress'
    }
};
function $7d8fdfa81fd5f9e7$var$macAddress$1() {
    let separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
    return (value)=>{
        separator = (0, $8bTPG.unref)(separator);
        if (!$7d8fdfa81fd5f9e7$var$req(value)) return true;
        if (typeof value !== 'string') return false;
        const parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
        return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every($7d8fdfa81fd5f9e7$var$hexValid);
    };
}
const $7d8fdfa81fd5f9e7$var$hexValid = (hex)=>hex.toLowerCase().match(/^[0-9a-f]{2}$/);
function $7d8fdfa81fd5f9e7$export$4aae620858fd13ea(separator) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$macAddress$1(separator),
        $message: 'The value is not a valid MAC Address',
        $params: {
            type: 'macAddress'
        }
    };
}
function $7d8fdfa81fd5f9e7$var$maxLength$1(length) {
    return (value)=>!$7d8fdfa81fd5f9e7$var$req(value) || $7d8fdfa81fd5f9e7$var$len(value) <= (0, $8bTPG.unref)(length);
}
function $7d8fdfa81fd5f9e7$export$c9f461152c658a8b(max) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$maxLength$1(max),
        $message: (_ref)=>{
            let { $params: $params } = _ref;
            return `The maximum length allowed is ${$params.max}`;
        },
        $params: {
            max: max,
            type: 'maxLength'
        }
    };
}
function $7d8fdfa81fd5f9e7$var$minLength$1(length) {
    return (value)=>!$7d8fdfa81fd5f9e7$var$req(value) || $7d8fdfa81fd5f9e7$var$len(value) >= (0, $8bTPG.unref)(length);
}
function $7d8fdfa81fd5f9e7$export$8fe860a115a1e636(min) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$minLength$1(min),
        $message: (_ref)=>{
            let { $params: $params } = _ref;
            return `This field should be at least ${$params.min} characters long`;
        },
        $params: {
            min: min,
            type: 'minLength'
        }
    };
}
function $7d8fdfa81fd5f9e7$var$required$1(value) {
    if (typeof value === 'string') value = value.trim();
    return $7d8fdfa81fd5f9e7$var$req(value);
}
var $7d8fdfa81fd5f9e7$export$a7a0278c004aac3f = {
    $validator: $7d8fdfa81fd5f9e7$var$required$1,
    $message: 'Value is required',
    $params: {
        type: 'required'
    }
};
const $7d8fdfa81fd5f9e7$var$validate$1 = (prop, val)=>prop ? $7d8fdfa81fd5f9e7$var$req(typeof val === 'string' ? val.trim() : val) : true;
function $7d8fdfa81fd5f9e7$var$requiredIf$1(propOrFunction) {
    return function(value, parentVM) {
        if (typeof propOrFunction !== 'function') return $7d8fdfa81fd5f9e7$var$validate$1((0, $8bTPG.unref)(propOrFunction), value);
        const result = propOrFunction.call(this, value, parentVM);
        return $7d8fdfa81fd5f9e7$var$validate$1(result, value);
    };
}
function $7d8fdfa81fd5f9e7$export$aa0fab0f481c439(prop) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$requiredIf$1(prop),
        $message: 'The value is required',
        $params: {
            type: 'requiredIf',
            prop: prop
        }
    };
}
const $7d8fdfa81fd5f9e7$var$validate = (prop, val)=>!prop ? $7d8fdfa81fd5f9e7$var$req(typeof val === 'string' ? val.trim() : val) : true;
function $7d8fdfa81fd5f9e7$var$requiredUnless$1(propOrFunction) {
    return function(value, parentVM) {
        if (typeof propOrFunction !== 'function') return $7d8fdfa81fd5f9e7$var$validate((0, $8bTPG.unref)(propOrFunction), value);
        const result = propOrFunction.call(this, value, parentVM);
        return $7d8fdfa81fd5f9e7$var$validate(result, value);
    };
}
function $7d8fdfa81fd5f9e7$export$95ff2549065aafd7(prop) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$requiredUnless$1(prop),
        $message: 'The value is required',
        $params: {
            type: 'requiredUnless',
            prop: prop
        }
    };
}
function $7d8fdfa81fd5f9e7$var$sameAs$1(equalTo) {
    return (value)=>(0, $8bTPG.unref)(value) === (0, $8bTPG.unref)(equalTo);
}
function $7d8fdfa81fd5f9e7$export$cd09d0de2eb5c367(equalTo) {
    let otherName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'other';
    return {
        $validator: $7d8fdfa81fd5f9e7$var$sameAs$1(equalTo),
        $message: (_ref)=>{
            return `The value must be equal to the ${otherName} value`;
        },
        $params: {
            equalTo: equalTo,
            otherName: otherName,
            type: 'sameAs'
        }
    };
}
const $7d8fdfa81fd5f9e7$var$urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
var $7d8fdfa81fd5f9e7$var$url$1 = $7d8fdfa81fd5f9e7$var$regex($7d8fdfa81fd5f9e7$var$urlRegex);
var $7d8fdfa81fd5f9e7$export$128fa18b7194ef = {
    $validator: $7d8fdfa81fd5f9e7$var$url$1,
    $message: 'The value is not a valid URL address',
    $params: {
        type: 'url'
    }
};
function $7d8fdfa81fd5f9e7$var$syncOr(validators) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return validators.reduce((valid, fn)=>{
            if ($7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(valid)) return valid;
            return $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(fn).apply(this, args);
        }, false);
    };
}
function $7d8fdfa81fd5f9e7$var$asyncOr(validators) {
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return validators.reduce(async (valid, fn)=>{
            const r = await valid;
            if ($7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(r)) return r;
            return $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(fn).apply(this, args);
        }, Promise.resolve(false));
    };
}
function $7d8fdfa81fd5f9e7$var$or$1() {
    for(var _len3 = arguments.length, validators = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)validators[_key3] = arguments[_key3];
    const $async = validators.some((v)=>v.$async);
    const $watchTargets = validators.reduce((all, v)=>{
        if (!v.$watchTargets) return all;
        return all.concat(v.$watchTargets);
    }, []);
    let $validator = ()=>false;
    if (validators.length) $validator = $async ? $7d8fdfa81fd5f9e7$var$asyncOr(validators) : $7d8fdfa81fd5f9e7$var$syncOr(validators);
    return {
        $async: $async,
        $validator: $validator,
        $watchTargets: $watchTargets
    };
}
function $7d8fdfa81fd5f9e7$export$252bb8b3bbdf6749() {
    return $7d8fdfa81fd5f9e7$var$withParams({
        type: 'or'
    }, $7d8fdfa81fd5f9e7$var$withMessage('The value does not match any of the provided validators', $7d8fdfa81fd5f9e7$var$or$1(...arguments)));
}
function $7d8fdfa81fd5f9e7$var$syncAnd(validators) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return validators.reduce((valid, fn)=>{
            if (!$7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(valid)) return valid;
            return $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(fn).apply(this, args);
        }, true);
    };
}
function $7d8fdfa81fd5f9e7$var$asyncAnd(validators) {
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return validators.reduce(async (valid, fn)=>{
            const r = await valid;
            if (!$7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(r)) return r;
            return $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(fn).apply(this, args);
        }, Promise.resolve(true));
    };
}
function $7d8fdfa81fd5f9e7$var$and$1() {
    for(var _len3 = arguments.length, validators = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)validators[_key3] = arguments[_key3];
    const $async = validators.some((v)=>v.$async);
    const $watchTargets = validators.reduce((all, v)=>{
        if (!v.$watchTargets) return all;
        return all.concat(v.$watchTargets);
    }, []);
    let $validator = ()=>false;
    if (validators.length) $validator = $async ? $7d8fdfa81fd5f9e7$var$asyncAnd(validators) : $7d8fdfa81fd5f9e7$var$syncAnd(validators);
    return {
        $async: $async,
        $validator: $validator,
        $watchTargets: $watchTargets
    };
}
function $7d8fdfa81fd5f9e7$export$21c0ac7fe1cef1b8() {
    return $7d8fdfa81fd5f9e7$var$withParams({
        type: 'and'
    }, $7d8fdfa81fd5f9e7$var$withMessage('The value does not match all of the provided validators', $7d8fdfa81fd5f9e7$var$and$1(...arguments)));
}
function $7d8fdfa81fd5f9e7$var$not$1(validator) {
    return function(value, vm) {
        if (!$7d8fdfa81fd5f9e7$var$req(value)) return true;
        const response = $7d8fdfa81fd5f9e7$var$unwrapNormalizedValidator(validator).call(this, value, vm);
        if (!$7d8fdfa81fd5f9e7$var$isPromise(response)) return !$7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(response);
        return response.then((r)=>!$7d8fdfa81fd5f9e7$var$unwrapValidatorResponse(r));
    };
}
function $7d8fdfa81fd5f9e7$export$6003a5f097c73977(validator) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$not$1(validator),
        $message: `The value does not match the provided validator`,
        $params: {
            type: 'not'
        }
    };
}
function $7d8fdfa81fd5f9e7$var$minValue$1(min) {
    return (value)=>!$7d8fdfa81fd5f9e7$var$req(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +(0, $8bTPG.unref)(min);
}
function $7d8fdfa81fd5f9e7$export$5805e19da86cbb3c(min) {
    return {
        $validator: $7d8fdfa81fd5f9e7$var$minValue$1(min),
        $message: (_ref)=>{
            let { $params: $params } = _ref;
            return `The minimum value allowed is ${$params.min}`;
        },
        $params: {
            min: min,
            type: 'minValue'
        }
    };
}
function $7d8fdfa81fd5f9e7$var$maxValue$1(max) {
    return (value)=>!$7d8fdfa81fd5f9e7$var$req(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +(0, $8bTPG.unref)(max);
}
var $7d8fdfa81fd5f9e7$export$b9dc90d6499a9909 = (max)=>({
        $validator: $7d8fdfa81fd5f9e7$var$maxValue$1(max),
        $message: (_ref)=>{
            let { $params: $params } = _ref;
            return `The maximum value allowed is ${$params.max}`;
        },
        $params: {
            max: max,
            type: 'maxValue'
        }
    });
var $7d8fdfa81fd5f9e7$var$integer$1 = $7d8fdfa81fd5f9e7$var$regex(/(^[0-9]*$)|(^-[0-9]+$)/);
var $7d8fdfa81fd5f9e7$export$32744b5b3bba4764 = {
    $validator: $7d8fdfa81fd5f9e7$var$integer$1,
    $message: 'Value is not an integer',
    $params: {
        type: 'integer'
    }
};
var $7d8fdfa81fd5f9e7$var$decimal$1 = $7d8fdfa81fd5f9e7$var$regex(/^[-]?\d*(\.\d+)?$/);
var $7d8fdfa81fd5f9e7$export$78a48a3d1e5dbe89 = {
    $validator: $7d8fdfa81fd5f9e7$var$decimal$1,
    $message: 'Value must be decimal',
    $params: {
        type: 'decimal'
    }
};
function $7d8fdfa81fd5f9e7$export$a5b925809d34737d(_ref) {
    let { t: t, messagePath: messagePath = (_ref2)=>{
        let { $validator: $validator } = _ref2;
        return `validations.${$validator}`;
    }, messageParams: messageParams = (params)=>params } = _ref;
    return function withI18nMessage(validator) {
        let { withArguments: withArguments = false, messagePath: localMessagePath = messagePath, messageParams: localMessageParams = messageParams } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        function message(props) {
            return t(localMessagePath(props), localMessageParams($7d8fdfa81fd5f9e7$var$_objectSpread2({
                model: props.$model,
                property: props.$property,
                pending: props.$pending,
                invalid: props.$invalid,
                response: props.$response,
                validator: props.$validator,
                propertyPath: props.$propertyPath
            }, props.$params)));
        }
        if (withArguments && typeof validator === 'function') return function() {
            return $7d8fdfa81fd5f9e7$var$withMessage(message, validator(...arguments));
        };
        return $7d8fdfa81fd5f9e7$var$withMessage(message, validator);
    };
}

});
parcelRegister("4nmGo", function(module, exports) {
$parcel$export(module.exports, "unref", () => (parcelRequire("8bTPG")).unref);
parcelRequire("ey4ci");
var $931c5e0ba9729cf1$export$1da84e343e81ceb9 = false;
var $931c5e0ba9729cf1$export$34b222e3d4733e48 = true;
var $931c5e0ba9729cf1$export$a8cb34872e7d8b79 = undefined;
function $931c5e0ba9729cf1$export$4b3e715f166fdd78() {}
function $931c5e0ba9729cf1$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $931c5e0ba9729cf1$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});


parcelRegister("64CYh", function(module, exports) {

$parcel$export(module.exports, "allowedPaymentTypes", () => $46c158b3bcb3ffd3$export$e786f16d1fd77928);
/**
 * Payment types (`bank`, `mollie`) the buyer may choose for a country, mirroring
 * php-core CountryPaymentMethods. php-core validates the order again, this only
 * decides which tiles the checkout shows.
 *
 * Returns null when no rule applies (feature off, or the country's group is
 * unrestricted) and [] while the rules are active but no country is chosen yet.
 */ function $46c158b3bcb3ffd3$export$e786f16d1fd77928(rules, country) {
    if (!rules || !rules.groups) return null;
    let code = String(country || '').trim().toUpperCase();
    if (!code) return [];
    if (code === 'UK') code = 'GB';
    const group = (rules.sepa_countries || []).includes(code) ? 'sepa' : 'non_sepa';
    return rules.groups[group] ?? null;
}

});


parcelRegister("h70hP", function(module, exports) {

$parcel$export(module.exports, "render", () => $c753500a5e261b4e$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $c753500a5e261b4e$var$_hoisted_1 = {
    class: "uk-margin-medium-top uk-clearfix"
};
const $c753500a5e261b4e$var$_hoisted_2 = {
    key: 0
};
const $c753500a5e261b4e$var$_hoisted_3 = [
    "value",
    "disabled"
];
const $c753500a5e261b4e$var$_hoisted_4 = {
    class: "reseller-tender-icon"
};
const $c753500a5e261b4e$var$_hoisted_5 = {
    class: "reseller-tender-label"
};
const $c753500a5e261b4e$var$_hoisted_6 = {
    key: 0,
    class: "uk-text-meta uk-margin-small-top"
};
const $c753500a5e261b4e$var$_hoisted_7 = {
    key: 0,
    class: "uk-margin-medium-top"
};
const $c753500a5e261b4e$var$_hoisted_8 = [
    "value"
];
const $c753500a5e261b4e$var$_hoisted_9 = [
    "value"
];
const $c753500a5e261b4e$var$_hoisted_10 = [
    "src"
];
const $c753500a5e261b4e$var$_hoisted_11 = [
    "src"
];
const $c753500a5e261b4e$var$_hoisted_12 = {
    key: 0,
    class: "uk-margin-small-bottom uk-margin-small-top"
};
const $c753500a5e261b4e$var$_hoisted_13 = {
    for: "couponSwitch",
    style: {
        "user-select": "none"
    }
};
const $c753500a5e261b4e$var$_hoisted_14 = {
    key: 0,
    class: "uk-form-controls uk-margin-small-top"
};
const $c753500a5e261b4e$var$_hoisted_15 = [
    "placeholder"
];
const $c753500a5e261b4e$var$_hoisted_16 = {
    class: "uk-text-small uk-margin-remove-top"
};
const $c753500a5e261b4e$var$_hoisted_17 = {
    key: 1,
    class: "uk-margin-small-top"
};
const $c753500a5e261b4e$var$_hoisted_18 = {
    for: "newsletterSignup",
    style: {
        "user-select": "none"
    }
};
const $c753500a5e261b4e$var$_hoisted_19 = {
    key: 1,
    class: "donation-card-wrapper uk-margin-medium-top uk-width-1-1 uk-width-1-2@m"
};
const $c753500a5e261b4e$var$_hoisted_20 = {
    class: "donation-card uk-card uk-card-body uk-card-small uk-text-center"
};
const $c753500a5e261b4e$var$_hoisted_21 = {
    class: "uk-margin-remove-top uk-margin-small-bottom"
};
const $c753500a5e261b4e$var$_hoisted_22 = {
    class: "uk-margin-small uk-text-muted"
};
const $c753500a5e261b4e$var$_hoisted_23 = {
    class: "uk-flex uk-flex-center uk-flex-middle uk-flex-wrap uk-grid-small",
    "uk-grid": ""
};
const $c753500a5e261b4e$var$_hoisted_24 = [
    "onClick"
];
const $c753500a5e261b4e$var$_hoisted_25 = {
    class: "uk-margin-small-top"
};
const $c753500a5e261b4e$var$_hoisted_26 = [
    "placeholder"
];
function $c753500a5e261b4e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_1, [
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", null, (0, $X5A94.toDisplayString)(_ctx.$t('Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert.')), 513), [
            [
                (0, $dDLnc.vShow),
                _ctx.options.length == 0
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", null, [
            (0, $ani5R.createElementVNode)("h2", null, (0, $X5A94.toDisplayString)(_ctx.$t("Zahlungsart ausw\xe4hlen")), 1),
            (0, $ani5R.createElementVNode)("p", null, (0, $X5A94.toDisplayString)(_ctx.$t("Die Zahlungsarten erscheinen, sobald ein Land ausgew\xe4hlt ist.")), 1)
        ], 512), [
            [
                (0, $dDLnc.vShow),
                !$props.loginusername && _ctx.options.length > 0 && $options.waitingForCountry
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", null, (0, $X5A94.toDisplayString)(_ctx.$t("F\xfcr das gew\xe4hlte Land ist keine Zahlungsart verf\xfcgbar.")), 513), [
            [
                (0, $dDLnc.vShow),
                !$props.loginusername && _ctx.options.length > 0 && !$options.waitingForCountry && $options.shopOptions.length == 0
            ]
        ]),
        $props.loginusername && _ctx.options.length > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("h2", null, (0, $X5A94.toDisplayString)(_ctx.$t("Zahlungsart")), 1),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)([
                    "uk-grid-small uk-child-width-1-2@s reseller-tender-block",
                    {
                        invalid: $options.error
                    }
                ]),
                "uk-grid": ""
            }, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.options, (opt)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: opt.tender
                    }, [
                        (0, $ani5R.createElementVNode)("label", {
                            class: (0, $X5A94.normalizeClass)([
                                "reseller-tender-card",
                                {
                                    'reseller-tender-card--active': $options.tender === opt.tender,
                                    'reseller-tender-card--disabled': opt.disabled
                                }
                            ])
                        }, [
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                                class: "reseller-tender-radio",
                                type: "radio",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.tender = $event),
                                value: opt.tender,
                                disabled: opt.disabled,
                                name: "reseller-tender"
                            }, null, 8, $c753500a5e261b4e$var$_hoisted_3), [
                                [
                                    (0, $dDLnc.vModelRadio),
                                    $options.tender
                                ]
                            ]),
                            (0, $ani5R.createElementVNode)("div", $c753500a5e261b4e$var$_hoisted_4, (0, $X5A94.toDisplayString)(opt.icon), 1),
                            (0, $ani5R.createElementVNode)("div", $c753500a5e261b4e$var$_hoisted_5, (0, $X5A94.toDisplayString)(_ctx.$t(opt.label)), 1),
                            opt.disabled ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_6, (0, $X5A94.toDisplayString)(_ctx.$t(opt.disabledHint)), 1)) : (0, $ani5R.createCommentVNode)("", true)
                        ], 2)
                    ]);
                }), 128))
            ], 2),
            $options.tender === 'card_terminal' && _ctx.terminals.length > 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_7, [
                (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.$t("Terminal ausw\xe4hlen")), 1),
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$options.terminalId = $event),
                    class: "uk-select",
                    style: {
                        "max-width": "400px"
                    }
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.terminals, (t)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                            key: t.id,
                            value: t.id
                        }, (0, $X5A94.toDisplayString)(t.label), 9, $c753500a5e261b4e$var$_hoisted_8);
                    }), 128))
                ], 512), [
                    [
                        (0, $dDLnc.vModelSelect),
                        $options.terminalId
                    ]
                ])
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ])) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", null, [
            (0, $ani5R.createElementVNode)("h2", null, (0, $X5A94.toDisplayString)(_ctx.$t("Zahlungsart ausw\xe4hlen")), 1),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)([
                    "uk-form-controls input-section uk-width-1-1 uk-width-1-2@s uk-width-1-3@m uk-float-left paymentTypeBlock",
                    {
                        invalid: $options.error
                    }
                ])
            }, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.shopOptions, (paymentOption)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
                        key: paymentOption.type,
                        class: "payment-option uk-display-block uk-margin-small-top uk-card uk-card uk-card-default uk-width-1-1 uk-padding-small"
                    }, [
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                            class: "uk-radio uk-margin-small-right",
                            type: "radio",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$options.paymentType = $event),
                            value: paymentOption.type,
                            name: "payment"
                        }, null, 8, $c753500a5e261b4e$var$_hoisted_9), [
                            [
                                (0, $dDLnc.vModelRadio),
                                $options.paymentType
                            ]
                        ]),
                        paymentOption.icon ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("img", {
                            key: 0,
                            src: 'data:image/svg+xml,' + paymentOption.icon,
                            class: "payment-icon",
                            style: {
                                "height": "20px"
                            }
                        }, null, 8, $c753500a5e261b4e$var$_hoisted_10)) : (0, $ani5R.createCommentVNode)("", true),
                        paymentOption.img ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("img", {
                            key: 1,
                            src: paymentOption.img,
                            style: {
                                "width": "100%",
                                "max-width": "280px"
                            }
                        }, null, 8, $c753500a5e261b4e$var$_hoisted_11)) : (0, $ani5R.createCommentVNode)("", true),
                        (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t(paymentOption.label)), 1)
                    ]);
                }), 128))
            ], 2)
        ], 512), [
            [
                (0, $dDLnc.vShow),
                !$props.loginusername && $options.shopOptions.length > 1
            ]
        ]),
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)([
                "uk-float-left additionalsBlock",
                {
                    'uk-margin-large-left': _ctx.options.length > 1,
                    'uk-margin-small-top': _ctx.options.length > 1
                }
            ])
        }, [
            $props.settings.coupons_enabled && !$props.settings.coupons_first ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_12, [
                (0, $ani5R.createElementVNode)("label", $c753500a5e261b4e$var$_hoisted_13, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        id: "couponSwitch",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$options.couponSwitch = $event),
                        onChange: _cache[4] || (_cache[4] = ($event)=>$options.formatDonation($event)),
                        class: "uk-checkbox",
                        type: "checkbox"
                    }, null, 544), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            $options.couponSwitch
                        ]
                    ]),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t('Ich habe einen Gutschein-Code')), 1)
                ]),
                $options.couponSwitch ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_14, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        id: "couponCode",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$options.couponCode = $event),
                        class: "uk-input",
                        type: "text",
                        placeholder: _ctx.$t('Gutschein-Code')
                    }, null, 8, $c753500a5e261b4e$var$_hoisted_15), [
                        [
                            (0, $dDLnc.vModelText),
                            $options.couponCode
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("p", $c753500a5e261b4e$var$_hoisted_16, "(" + (0, $X5A94.toDisplayString)(_ctx.$t("Die Pr\xfcfung des Gutscheins erfolgt im n\xe4chsten Schritt")) + ")", 1)
                ])) : (0, $ani5R.createCommentVNode)("", true)
            ])) : (0, $ani5R.createCommentVNode)("", true),
            $props.settings.newsletter_signup_enabled && !$props.loginusername ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_17, [
                (0, $ani5R.createElementVNode)("label", $c753500a5e261b4e$var$_hoisted_18, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        id: "newsletterSignup",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$options.newsletterSignup = $event),
                        class: "uk-checkbox",
                        type: "checkbox"
                    }, null, 512), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            $options.newsletterSignup
                        ]
                    ]),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)($props.settings.newsletter_signup_text ? $props.settings.newsletter_signup_text : _ctx.$t("Ich m\xf6chte auf dem Laufenden bleiben")), 1)
                ])
            ])) : (0, $ani5R.createCommentVNode)("", true)
        ], 2),
        $props.settings.donations_enabled ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c753500a5e261b4e$var$_hoisted_19, [
            (0, $ani5R.createElementVNode)("div", $c753500a5e261b4e$var$_hoisted_20, [
                (0, $ani5R.createElementVNode)("h4", $c753500a5e261b4e$var$_hoisted_21, [
                    _cache[8] || (_cache[8] = (0, $ani5R.createElementVNode)("span", {
                        "uk-icon": "icon: heart; ratio: 1.2",
                        class: "donation-card__icon uk-margin-small-right"
                    }, null, -1)),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t('Spende')), 1)
                ]),
                (0, $ani5R.createElementVNode)("p", $c753500a5e261b4e$var$_hoisted_22, (0, $X5A94.toDisplayString)($props.settings.donation_text ? $props.settings.donation_text : _ctx.$t("Wir freuen uns \xfcber eine freiwillige Spende.")), 1),
                (0, $ani5R.createElementVNode)("div", $c753500a5e261b4e$var$_hoisted_23, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.suggestedAmounts, (amount)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            key: amount
                        }, [
                            (0, $ani5R.createElementVNode)("button", {
                                type: "button",
                                class: (0, $X5A94.normalizeClass)([
                                    "uk-button uk-border-pill",
                                    $options.suggestedActive(amount) ? 'uk-button-primary' : 'uk-button-default'
                                ]),
                                onClick: ($event)=>$options.toggleDonationAmount(amount)
                            }, (0, $X5A94.toDisplayString)(amount) + "\u20AC ", 11, $c753500a5e261b4e$var$_hoisted_24)
                        ]);
                    }), 128))
                ]),
                (0, $ani5R.createElementVNode)("div", $c753500a5e261b4e$var$_hoisted_25, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$options.customAmountInput = $event),
                        class: "uk-input uk-width-1-1 uk-text-center uk-border-pill",
                        type: "number",
                        min: "1",
                        step: "1",
                        placeholder: _ctx.$t('Anderer Betrag'),
                        id: "donationAmount"
                    }, null, 8, $c753500a5e261b4e$var$_hoisted_26), [
                        [
                            (0, $dDLnc.vModelText),
                            $options.customAmountInput
                        ]
                    ])
                ])
            ])
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("3NR3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4f1a20a18c2670$export$2e2bcd8739ae039);
let $2c4f1a20a18c2670$var$NOOP = ()=>{};
var $2c4f1a20a18c2670$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aDEF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bed164966b97576$export$2e2bcd8739ae039);
let $7bed164966b97576$var$script;



let $7bed164966b97576$var$initialize = ()=>{
    $7bed164966b97576$var$script = (parcelRequire("k2NQL"));
    if ($7bed164966b97576$var$script.__esModule) $7bed164966b97576$var$script = $7bed164966b97576$var$script.default;
    $7bed164966b97576$var$script.render = (parcelRequire("huUoa")).render;
    (parcelRequire("giJeM")).default($7bed164966b97576$var$script);
    $7bed164966b97576$var$script.__scopeId = 'data-v-645d1d';
    $7bed164966b97576$var$script.__file = "CheckoutPerson.vue";
};
$7bed164966b97576$var$initialize();
var $7bed164966b97576$export$2e2bcd8739ae039 = $7bed164966b97576$var$script;

});
parcelRegister("k2NQL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e97aa9beb2876f60$export$2e2bcd8739ae039);

var $PEtmm = parcelRequire("PEtmm");
var $e97aa9beb2876f60$export$2e2bcd8739ae039 = {
    props: [
        'loginusername'
    ],
    data: ()=>{
        return {
            model: {},
            schema: {},
            store: (0, $PEtmm.useStore)(),
            person_fields: {
                firstname: {
                    attrs: {
                        autofocus: true
                    },
                    type: 'text',
                    floating: {
                        de: 'Vorname',
                        en: 'Name'
                    },
                    placeholder: {
                        de: 'Vorname',
                        en: 'Name'
                    },
                    rules: 'required',
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                lastname: {
                    type: "text",
                    floating: {
                        de: 'Nachname',
                        en: 'Surname'
                    },
                    placeholder: {
                        de: 'Nachname',
                        en: 'Surname'
                    },
                    rules: 'required',
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                email: {
                    type: "text",
                    inputType: 'email',
                    floating: 'E-Mail',
                    placeholder: 'E-Mail',
                    // `email` is the festiware validator from vueform.config.js; without it
                    // only the backend (StoreOrderRequest `required|email`) rejected the
                    // format, after submit and with a generic error (FWT-2809).
                    rules: 'required|email',
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                _hidden: {
                    type: "hidden",
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                address: {
                    type: "text",
                    floating: {
                        de: "Stra\xdfe und Hausnummer",
                        en: 'Street and house number'
                    },
                    placeholder: {
                        de: "Stra\xdfe und Hausnummer",
                        en: 'Street and house number'
                    },
                    rules: 'required',
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                zip: {
                    type: "text",
                    floating: {
                        de: 'Postleitzahl',
                        en: 'Zip'
                    },
                    placeholder: {
                        de: 'Postleitzahl',
                        en: 'Zip'
                    },
                    rules: 'required',
                    columns: {
                        container: 3,
                        label: 12,
                        wrapper: 12
                    }
                },
                city: {
                    type: "text",
                    floating: {
                        de: 'Stadt',
                        en: 'City'
                    },
                    placeholder: {
                        de: 'Stadt',
                        en: 'City'
                    },
                    rules: 'required',
                    columns: {
                        container: 3,
                        label: 12,
                        wrapper: 12
                    }
                },
                country: {
                    type: "select",
                    floating: {
                        de: 'Land',
                        en: 'Country'
                    },
                    placeholder: {
                        de: 'Land',
                        en: 'Country'
                    },
                    staticType: 'country',
                    search: true,
                    rules: 'required',
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                }
            },
            company_fields: {
                company: {
                    type: 'text',
                    floating: {
                        de: 'Firma',
                        en: 'Company'
                    },
                    placeholder: {
                        de: 'Firma',
                        en: 'Company'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                vat_id: {
                    type: 'text',
                    floating: {
                        de: 'USt-Id',
                        en: 'VAT ID'
                    },
                    placeholder: {
                        de: 'USt-Id',
                        en: 'VAT ID'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                }
            },
            // Reseller-POS: Käuferdaten sind komplett optional. Nur Format-Check
            // bei E-Mail (falls eingegeben), aber kein required mehr — Bar- und
            // Kartenterminal-Verkäufe dürfen anonym laufen. Adressfelder werden
            // sichtbar gerendert, damit der Kassierer Stammkunden-/Rechnungs-
            // daten direkt erfassen kann.
            with_login_user: {
                email: {
                    type: "text",
                    inputType: 'email',
                    floating: 'E-Mail',
                    placeholder: 'E-Mail',
                    rules: 'email',
                    columns: {
                        container: 12,
                        label: 12,
                        wrapper: 12
                    }
                },
                firstname: {
                    type: 'text',
                    floating: {
                        de: 'Vorname (optional)',
                        en: 'First name (optional)'
                    },
                    placeholder: {
                        de: 'Vorname',
                        en: 'First name'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                lastname: {
                    type: 'text',
                    floating: {
                        de: 'Nachname (optional)',
                        en: 'Surname (optional)'
                    },
                    placeholder: {
                        de: 'Nachname',
                        en: 'Surname'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                company: {
                    type: 'text',
                    floating: {
                        de: 'Firma (optional)',
                        en: 'Company (optional)'
                    },
                    placeholder: {
                        de: 'Firma',
                        en: 'Company'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                vat_id: {
                    type: 'text',
                    floating: {
                        de: 'USt-Id (optional)',
                        en: 'VAT ID (optional)'
                    },
                    placeholder: {
                        de: 'USt-Id',
                        en: 'VAT ID'
                    },
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                address: {
                    type: 'text',
                    floating: {
                        de: "Stra\xdfe und Hausnummer (optional)",
                        en: 'Street and house number (optional)'
                    },
                    placeholder: {
                        de: "Stra\xdfe und Hausnummer",
                        en: 'Street and house number'
                    },
                    columns: {
                        container: 12,
                        label: 12,
                        wrapper: 12
                    }
                },
                zip: {
                    type: 'text',
                    floating: {
                        de: 'PLZ (optional)',
                        en: 'Zip (optional)'
                    },
                    placeholder: {
                        de: 'PLZ',
                        en: 'Zip'
                    },
                    columns: {
                        container: 3,
                        label: 12,
                        wrapper: 12
                    }
                },
                city: {
                    type: 'text',
                    floating: {
                        de: 'Stadt (optional)',
                        en: 'City (optional)'
                    },
                    placeholder: {
                        de: 'Stadt',
                        en: 'City'
                    },
                    columns: {
                        container: 3,
                        label: 12,
                        wrapper: 12
                    }
                },
                country: {
                    type: 'select',
                    floating: {
                        de: 'Land (optional)',
                        en: 'Country (optional)'
                    },
                    placeholder: {
                        de: 'Land',
                        en: 'Country'
                    },
                    staticType: 'country',
                    search: true,
                    columns: {
                        container: 6,
                        label: 12,
                        wrapper: 12
                    }
                },
                "send-ticket-to-client": {
                    type: 'checkbox',
                    text: {
                        de: "Ticket direkt an K\xe4ufer:In schicken",
                        en: 'Send ticket directly to buyer'
                    },
                    columns: {
                        container: 12,
                        label: 12,
                        wrapper: 12
                    },
                    // Nur aktivierbar, wenn eine Email-Adresse erfasst wurde — sonst gibt es niemanden, an den gesendet werden könnte.
                    conditions: [
                        [
                            'email',
                            '!=',
                            ''
                        ]
                    ]
                }
            }
        };
    },
    mounted () {
        this.schema = this.loginusername ? this.with_login_user : {
            ...this.store.state.withCompany ? this.company_fields : {},
            ...this.person_fields
        };
        this.$nextTick(()=>{
            this.$refs.form.update(this.store.state.personData ? this.store.state.personData : {});
        });
    },
    watch: {
        // The payment tiles below depend on the country, and personData only
        // reaches the store on validate().
        'model.country': {
            handler (country) {
                this.store.state.billingCountry = country || '';
            },
            immediate: true
        }
    },
    methods: {
        validate () {
            return new Promise((resolve)=>{
                this.store.state.personData = this.model;
                this.$refs.form.validate().then(()=>{
                    const isInvalid = this.$refs.form.invalid;
                    if (isInvalid) this.store.commit('emitScroll');
                    resolve(!isInvalid);
                });
            });
        }
    }
};

});

parcelRegister("huUoa", function(module, exports) {

$parcel$export(module.exports, "render", () => $cbd0faa4b2467426$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
function $cbd0faa4b2467426$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Vueform = (0, $ani5R.resolveComponent)("Vueform");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createElementVNode)("h2", null, (0, $X5A94.toDisplayString)(_ctx.$t("Rechnungsdaten")), 1),
        (0, $ani5R.createVNode)(_component_Vueform, {
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.model = $event),
            ref: "form",
            schema: _ctx.schema,
            displayErrors: false
        }, null, 8, [
            "modelValue",
            "schema"
        ])
    ]);
}

});

parcelRegister("giJeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde16afaa3e4f91e$export$2e2bcd8739ae039);
let $bde16afaa3e4f91e$var$NOOP = ()=>{};
var $bde16afaa3e4f91e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("6cKWi", function(module, exports) {

$parcel$export(module.exports, "render", () => $4848463f05ee5686$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $4848463f05ee5686$var$_hoisted_1 = {
    class: "uk-margin-medium uk-flex uk-flex-right"
};
function $4848463f05ee5686$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_checkout_person = (0, $ani5R.resolveComponent)("checkout-person");
    const _component_checkout_payment = (0, $ani5R.resolveComponent)("checkout-payment");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createVNode)(_component_checkout_person, {
            ref: "personData",
            loginusername: $props.loginusername
        }, null, 8, [
            "loginusername"
        ]),
        (0, $ani5R.createVNode)(_component_checkout_payment, {
            ref: "paymentType",
            loginusername: $props.loginusername,
            settings: $props.settings
        }, null, 8, [
            "loginusername",
            "settings"
        ]),
        (0, $ani5R.createElementVNode)("div", $4848463f05ee5686$var$_hoisted_1, [
            (0, $ani5R.createElementVNode)("button", {
                class: "uk-button uk-button-default uk-margin-small-right",
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.back && $options.back(...args))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Zur\xfcck")), 1),
            (0, $ani5R.createElementVNode)("button", {
                class: "uk-button uk-button-primary",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.next && $options.next(...args))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Weiter")), 1)
        ])
    ]);
}

});

parcelRegister("kgMfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec1abb929c4d332c$export$2e2bcd8739ae039);
let $ec1abb929c4d332c$var$NOOP = ()=>{};
var $ec1abb929c4d332c$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iwBa6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c80ac06672c75c$export$2e2bcd8739ae039);
let $d7c80ac06672c75c$var$script;



let $d7c80ac06672c75c$var$initialize = ()=>{
    $d7c80ac06672c75c$var$script = (parcelRequire("ed3xz"));
    if ($d7c80ac06672c75c$var$script.__esModule) $d7c80ac06672c75c$var$script = $d7c80ac06672c75c$var$script.default;
    $d7c80ac06672c75c$var$script.render = (parcelRequire("hSadF")).render;
    (parcelRequire("gXbUR")).default($d7c80ac06672c75c$var$script);
    $d7c80ac06672c75c$var$script.__scopeId = 'data-v-7289cb';
    $d7c80ac06672c75c$var$script.__file = "Summary.vue";
};
$d7c80ac06672c75c$var$initialize();
var $d7c80ac06672c75c$export$2e2bcd8739ae039 = $d7c80ac06672c75c$var$script;

});
parcelRegister("ed3xz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a58506aa3e0d3f54$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");

var $ldVCg = parcelRequire("ldVCg");

var $9WNau = parcelRequire("9WNau");

var $23rBU = parcelRequire("23rBU");

var $19kqn = parcelRequire("19kqn");

var $eIbbJ = parcelRequire("eIbbJ");

var $7E8kN = parcelRequire("7E8kN");
var $a58506aa3e0d3f54$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        "settings",
        "loginusername"
    ],
    components: {
        SummaryPersonalize: $eIbbJ.default,
        SummaryMessages: $ldVCg.default,
        SummaryReceiver: $9WNau.default,
        SummaryCart: $23rBU.default,
        SummaryPayment: $19kqn.default,
        ResellerOrderResult: $7E8kN.default
    },
    data: ()=>{
        return {
            hasError: false,
            showMessage: false,
            orderNumber: undefined,
            resellerResult: null,
            messageContainer: {
                message: "",
                sorryMessage: "Bitte versuche es sp\xe4ter noch einmal.",
                modalDescription: "",
                serverError: false,
                unavailableTickets: false,
                paymentSuccess: false
            }
        };
    },
    mounted () {},
    methods: {
        onSuccess (payload) {
            console.log('success', payload);
        },
        onError (payload) {
            console.log('error', payload);
        },
        onResellerSuccess (response) {
            this.resellerResult = response;
        },
        onNewOrder () {
            // Reseller "next sale": drop server-side cart so the post-reload
            // init() does not prompt "vorherige Eingaben verwenden?", then
            // hard-reload to guarantee a clean shop view (step 0, empty cart,
            // no residual coupon/donation/tender state).
            const reload = ()=>window.location.reload();
            const forget = this.store.state.doOctoberRequest;
            if (typeof forget === 'function') {
                const result = forget('onForgetStore');
                if (result && typeof result.then === 'function') {
                    result.then(reload, reload);
                    return;
                }
            }
            reload();
        }
    }
};

});
parcelRegister("ldVCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7378138cfe8163c$export$2e2bcd8739ae039);
let $f7378138cfe8163c$var$script;



let $f7378138cfe8163c$var$initialize = ()=>{
    $f7378138cfe8163c$var$script = (parcelRequire("2DD8d"));
    if ($f7378138cfe8163c$var$script.__esModule) $f7378138cfe8163c$var$script = $f7378138cfe8163c$var$script.default;
    $f7378138cfe8163c$var$script.render = (parcelRequire("hixcl")).render;
    (parcelRequire("6xOGH")).default($f7378138cfe8163c$var$script);
    $f7378138cfe8163c$var$script.__scopeId = 'data-v-adcbb9';
    $f7378138cfe8163c$var$script.__file = "SummaryMessages.vue";
};
$f7378138cfe8163c$var$initialize();
var $f7378138cfe8163c$export$2e2bcd8739ae039 = $f7378138cfe8163c$var$script;

});
parcelRegister("2DD8d", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1ebd940243c85b3c$export$2e2bcd8739ae039);
var $1ebd940243c85b3c$export$2e2bcd8739ae039 = {
    mixins: [],
    props: [
        'messageContainer'
    ],
    components: {},
    data: ()=>{
        return {};
    },
    mounted () {},
    methods: {}
};

});

parcelRegister("hixcl", function(module, exports) {

$parcel$export(module.exports, "render", () => $c97dde8a5f7c2391$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $c97dde8a5f7c2391$var$_hoisted_1 = {
    key: 0
};
const $c97dde8a5f7c2391$var$_hoisted_2 = {
    class: "text-container"
};
const $c97dde8a5f7c2391$var$_hoisted_3 = {
    class: "successMessage"
};
const $c97dde8a5f7c2391$var$_hoisted_4 = {
    key: 1
};
const $c97dde8a5f7c2391$var$_hoisted_5 = {
    class: "alert-container"
};
const $c97dde8a5f7c2391$var$_hoisted_6 = {
    class: "alertMessage"
};
const $c97dde8a5f7c2391$var$_hoisted_7 = {
    key: 2
};
const $c97dde8a5f7c2391$var$_hoisted_8 = {
    class: "alert-container"
};
const $c97dde8a5f7c2391$var$_hoisted_9 = {
    class: "alertMessage"
};
function $c97dde8a5f7c2391$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.messageContainer.paymentSuccess ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c97dde8a5f7c2391$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("div", $c97dde8a5f7c2391$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("p", $c97dde8a5f7c2391$var$_hoisted_3, (0, $X5A94.toDisplayString)(_ctx.$t("Vielen Dank f\xfcr die Bestellung! In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.")), 1)
        ])
    ])) : $props.messageContainer.serverError ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c97dde8a5f7c2391$var$_hoisted_4, [
        (0, $ani5R.createElementVNode)("div", $c97dde8a5f7c2391$var$_hoisted_5, [
            (0, $ani5R.createElementVNode)("p", $c97dde8a5f7c2391$var$_hoisted_6, [
                (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)($props.messageContainer.modalDescription) + " " + (0, $X5A94.toDisplayString)($props.messageContainer.message) + ".", 1),
                _cache[0] || (_cache[0] = (0, $ani5R.createElementVNode)("br", null, null, -1)),
                (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)($props.messageContainer.sorryMessage), 1)
            ])
        ])
    ])) : _ctx.unavailableTickets ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $c97dde8a5f7c2391$var$_hoisted_7, [
        (0, $ani5R.createElementVNode)("div", $c97dde8a5f7c2391$var$_hoisted_8, [
            (0, $ani5R.createElementVNode)("p", $c97dde8a5f7c2391$var$_hoisted_9, (0, $X5A94.toDisplayString)(_ctx.$t("Entschuldigung. Die Anzahl der gew\xfcnschten Tickets ist derzeit nicht verf\xfcgbar.")), 1)
        ])
    ])) : (0, $ani5R.createCommentVNode)("", true);
}

});

parcelRegister("6xOGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c3d24a63fa92973$export$2e2bcd8739ae039);
let $4c3d24a63fa92973$var$NOOP = ()=>{};
var $4c3d24a63fa92973$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9WNau", function(module, exports) {

$parcel$export(module.exports, "default", () => $73dfab986812c4f7$export$2e2bcd8739ae039);
let $73dfab986812c4f7$var$script;



let $73dfab986812c4f7$var$initialize = ()=>{
    $73dfab986812c4f7$var$script = (parcelRequire("fWQWQ"));
    if ($73dfab986812c4f7$var$script.__esModule) $73dfab986812c4f7$var$script = $73dfab986812c4f7$var$script.default;
    $73dfab986812c4f7$var$script.render = (parcelRequire("c6vUC")).render;
    (parcelRequire("hki2F")).default($73dfab986812c4f7$var$script);
    $73dfab986812c4f7$var$script.__scopeId = 'data-v-5b35db';
    $73dfab986812c4f7$var$script.__file = "SummaryReceiver.vue";
};
$73dfab986812c4f7$var$initialize();
var $73dfab986812c4f7$export$2e2bcd8739ae039 = $73dfab986812c4f7$var$script;

});
parcelRegister("fWQWQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b9c5582a77237f07$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");

var $csjUm = parcelRequire("csjUm");

var $jOvqL = parcelRequire("jOvqL");
var $b9c5582a77237f07$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [],
    components: {},
    data: ()=>{
        return {
            personData: {},
            otherFields: []
        };
    },
    mounted () {
        Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($csjUm)))).forEach((fieldName)=>{
            const field = (0, (/*@__PURE__*/$parcel$interopDefault($csjUm)))[fieldName];
            if (field.type !== "spacer") {
                this.personData[fieldName] = field;
                this.personData[fieldName].value = this.store.state.personData[fieldName];
            }
        });
        const addressFields = [
            'firstname',
            'lastname',
            'city',
            'zip',
            'address',
            'country'
        ];
        this.otherFields = Object.keys(this.personData).filter((fieldName)=>!addressFields.includes(fieldName)).map((fieldName)=>this.personData[fieldName])// Firma und USt-Id werden nur erhoben, wenn der Shop sie anbietet — und an der
        // Reseller-Kasse auch dann, wenn die Option aus ist. Deshalb entscheidet der
        // ausgefüllte Wert, ob die Zeile erscheint, nicht die Einstellung: sonst fehlt,
        // was der Kassierer gerade eingetippt hat, oder es stehen leere Zeilen da.
        .filter((field)=>String(field.value ?? '').trim() !== '');
    },
    methods: {
        getCountryName (code) {
            const country = (0, $jOvqL.default)[this.$root.$i18n.locale].filter((country)=>country.code === code);
            return country.length ? country[0].name : '';
        }
    }
};

});
parcelRegister("csjUm", function(module, exports) {
module.exports = JSON.parse('{"firstname":{"label":"Vorname","required":true},"lastname":{"label":"Nachname","required":true},"email":{"label":"E-Mail","type":"email","required":true},"company":{"label":"Firma"},"vat_id":{"label":"USt-Id"},"spacer":{"type":"spacer"},"address":{"label":"Stra\xdfe und Hausnummer","required":true},"zip":{"label":"PLZ","classes":"uk-width-1-6@s","required":true},"city":{"label":"Ort","classes":"uk-width-1-3@s","required":true},"country":{"type":"country","label":"Land","required":true}}');

});

parcelRegister("jOvqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cb114ecd4938ac$export$2e2bcd8739ae039);

var $he9sv = parcelRequire("he9sv");

var $dpP26 = parcelRequire("dpP26");

var $dSh30 = parcelRequire("dSh30");

var $3g9pS = parcelRequire("3g9pS");

var $lT0Kb = parcelRequire("lT0Kb");

var $7Qx26 = parcelRequire("7Qx26");

var $cOf3g = parcelRequire("cOf3g");
var $e6cb114ecd4938ac$export$2e2bcd8739ae039 = {
    de: $he9sv.default,
    en: $dpP26.default,
    es: $dSh30.default,
    it: $3g9pS.default,
    pl: $lT0Kb.default,
    cz: $7Qx26.default,
    fr: $cOf3g.default
};

});
parcelRegister("he9sv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ab14c7e8463357$export$2e2bcd8739ae039);
var $c8ab14c7e8463357$export$2e2bcd8739ae039 = [
    {
        name: "Afghanistan",
        code: "af"
    },
    {
        name: "\xc4gypten",
        code: "eg"
    },
    {
        name: "\xc5land",
        code: "ax"
    },
    {
        name: "Albanien",
        code: "al"
    },
    {
        name: "Algerien",
        code: "dz"
    },
    {
        name: "Amerikanisch-Samoa",
        code: "as"
    },
    {
        name: "Andorra",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antigua und Barbuda",
        code: "ag"
    },
    {
        name: "\xc4quatorialguinea",
        code: "gq"
    },
    {
        name: "Argentinien",
        code: "ar"
    },
    {
        name: "Armenien",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Aserbaidschan",
        code: "az"
    },
    {
        name: "\xc4thiopien",
        code: "et"
    },
    {
        name: "Australien",
        code: "au"
    },
    {
        name: "Bahamas",
        code: "bs"
    },
    {
        name: "Bahrain",
        code: "bh"
    },
    {
        name: "Bangladesch",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Wei\xdfrussland",
        code: "by"
    },
    {
        name: "Belgien",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "Benin",
        code: "bj"
    },
    {
        name: "Bermuda",
        code: "bm"
    },
    {
        name: "Bhutan",
        code: "bt"
    },
    {
        name: "Bolivien",
        code: "bo"
    },
    {
        name: "Bosnien und Herzegowina",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "Bouvetinsel",
        code: "bv"
    },
    {
        name: "Brasilien",
        code: "br"
    },
    {
        name: "Britische Jungferninseln",
        code: "vg"
    },
    {
        name: "Brunei",
        code: "bn"
    },
    {
        name: "Bulgarien",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "Chile",
        code: "cl"
    },
    {
        name: "Volksrepublik China",
        code: "cn"
    },
    {
        name: "Cookinseln",
        code: "ck"
    },
    {
        name: "Costa Rica",
        code: "cr"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "D\xe4nemark",
        code: "dk"
    },
    {
        name: "Deutschland",
        code: "de"
    },
    {
        name: "Dominica",
        code: "dm"
    },
    {
        name: "Dominikanische Republik",
        code: "do"
    },
    {
        name: "Dschibuti",
        code: "dj"
    },
    {
        name: "Ecuador",
        code: "ec"
    },
    {
        name: "Elfenbeink\xfcste",
        code: "ci"
    },
    {
        name: "El Salvador",
        code: "sv"
    },
    {
        name: "Eritrea",
        code: "er"
    },
    {
        name: "Estland",
        code: "ee"
    },
    {
        name: "Swasiland",
        code: "sz"
    },
    {
        name: "Falklandinseln",
        code: "fk"
    },
    {
        name: "F\xe4r\xf6er",
        code: "fo"
    },
    {
        name: "Fidschi",
        code: "fj"
    },
    {
        name: "Finnland",
        code: "fi"
    },
    {
        name: "Frankreich",
        code: "fr"
    },
    {
        name: "Franz\xf6sisch-Guayana",
        code: "gf"
    },
    {
        name: "Franz\xf6sisch-Polynesien",
        code: "pf"
    },
    {
        name: "Gabun",
        code: "ga"
    },
    {
        name: "Gambia",
        code: "gm"
    },
    {
        name: "Georgien",
        code: "ge"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Grenada",
        code: "gd"
    },
    {
        name: "Griechenland",
        code: "gr"
    },
    {
        name: "Gr\xf6nland",
        code: "gl"
    },
    {
        name: "Guadeloupe",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guernsey (Kanalinsel)",
        code: "gg"
    },
    {
        name: "Guinea",
        code: "gn"
    },
    {
        name: "Guinea-Bissau",
        code: "gw"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Haiti",
        code: "ht"
    },
    {
        name: "Heard und McDonaldinseln",
        code: "hm"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hongkong",
        code: "hk"
    },
    {
        name: "Indien",
        code: "in"
    },
    {
        name: "Indonesien",
        code: "id"
    },
    {
        name: "Insel Man",
        code: "im"
    },
    {
        name: "Irak",
        code: "iq"
    },
    {
        name: "Iran",
        code: "ir"
    },
    {
        name: "Irland",
        code: "ie"
    },
    {
        name: "Island",
        code: "is"
    },
    {
        name: "Israel",
        code: "il"
    },
    {
        name: "Italien",
        code: "it"
    },
    {
        name: "Jamaika",
        code: "jm"
    },
    {
        name: "Japan",
        code: "jp"
    },
    {
        name: "Jemen",
        code: "ye"
    },
    {
        name: "Jersey (Kanalinsel)",
        code: "je"
    },
    {
        name: "Jordanien",
        code: "jo"
    },
    {
        name: "Kaimaninseln",
        code: "ky"
    },
    {
        name: "Kambodscha",
        code: "kh"
    },
    {
        name: "Kamerun",
        code: "cm"
    },
    {
        name: "Kanada",
        code: "ca"
    },
    {
        name: "Kap Verde",
        code: "cv"
    },
    {
        name: "Kasachstan",
        code: "kz"
    },
    {
        name: "Katar",
        code: "qa"
    },
    {
        name: "Kenia",
        code: "ke"
    },
    {
        name: "Kirgisistan",
        code: "kg"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kokosinseln",
        code: "cc"
    },
    {
        name: "Kolumbien",
        code: "co"
    },
    {
        name: "Komoren",
        code: "km"
    },
    {
        name: "Kongo, Republik",
        code: "cg"
    },
    {
        name: "Korea, Nord",
        code: "kp"
    },
    {
        name: "Korea, S\xfcd",
        code: "kr"
    },
    {
        name: "Kroatien",
        code: "hr"
    },
    {
        name: "Kuba",
        code: "cu"
    },
    {
        name: "Kuwait",
        code: "kw"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Lettland",
        code: "lv"
    },
    {
        name: "Libanon",
        code: "lb"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libyen",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Litauen",
        code: "lt"
    },
    {
        name: "Luxemburg",
        code: "lu"
    },
    {
        name: "Macau",
        code: "mo"
    },
    {
        name: "Madagaskar",
        code: "mg"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Malaysia",
        code: "my"
    },
    {
        name: "Malediven",
        code: "mv"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Marokko",
        code: "ma"
    },
    {
        name: "Marshallinseln",
        code: "mh"
    },
    {
        name: "Martinique",
        code: "mq"
    },
    {
        name: "Mauretanien",
        code: "mr"
    },
    {
        name: "Mauritius",
        code: "mu"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "Mexiko",
        code: "mx"
    },
    {
        name: "Mikronesien",
        code: "fm"
    },
    {
        name: "Moldau",
        code: "md"
    },
    {
        name: "Monaco",
        code: "mc"
    },
    {
        name: "Mongolei",
        code: "mn"
    },
    {
        name: "Montenegro",
        code: "me"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mosambik",
        code: "mz"
    },
    {
        name: "Myanmar",
        code: "mm"
    },
    {
        name: "Namibia",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "Nepal",
        code: "np"
    },
    {
        name: "Neukaledonien",
        code: "nc"
    },
    {
        name: "Neuseeland",
        code: "nz"
    },
    {
        name: "Nicaragua",
        code: "ni"
    },
    {
        name: "Niederlande",
        code: "nl"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "N\xf6rdliche Marianen",
        code: "mp"
    },
    {
        name: "Nordmazedonien",
        code: "mk"
    },
    {
        name: "Norfolkinsel",
        code: "nf"
    },
    {
        name: "Norwegen",
        code: "no"
    },
    {
        name: "Oman",
        code: "om"
    },
    {
        name: "\xd6sterreich",
        code: "at"
    },
    {
        name: "Osttimor",
        code: "tl"
    },
    {
        name: "Pakistan",
        code: "pk"
    },
    {
        name: "Pal\xe4stina",
        code: "ps"
    },
    {
        name: "Palau",
        code: "pw"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Papua-Neuguinea",
        code: "pg"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Peru",
        code: "pe"
    },
    {
        name: "Philippinen",
        code: "ph"
    },
    {
        name: "Pitcairninseln",
        code: "pn"
    },
    {
        name: "Polen",
        code: "pl"
    },
    {
        name: "Portugal",
        code: "pt"
    },
    {
        name: "Puerto Rico",
        code: "pr"
    },
    {
        name: "R\xe9union",
        code: "re"
    },
    {
        name: "Ruanda",
        code: "rw"
    },
    {
        name: "Rum\xe4nien",
        code: "ro"
    },
    {
        name: "Russland",
        code: "ru"
    },
    {
        name: "Salomonen",
        code: "sb"
    },
    {
        name: "Saint-Barth\xe9lemy",
        code: "bl"
    },
    {
        name: "Sambia",
        code: "zm"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "S\xe3o Tom\xe9 und Pr\xedncipe",
        code: "st"
    },
    {
        name: "Saudi-Arabien",
        code: "sa"
    },
    {
        name: "Schweden",
        code: "se"
    },
    {
        name: "Schweiz",
        code: "ch"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Serbien",
        code: "rs"
    },
    {
        name: "Seychellen",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Simbabwe",
        code: "zw"
    },
    {
        name: "Singapur",
        code: "sg"
    },
    {
        name: "Sint Maarten",
        code: "sx"
    },
    {
        name: "Slowakei",
        code: "sk"
    },
    {
        name: "Slowenien",
        code: "si"
    },
    {
        name: "Somalia",
        code: "so"
    },
    {
        name: "Spanien",
        code: "es"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "St. Kitts und Nevis",
        code: "kn"
    },
    {
        name: "St. Lucia",
        code: "lc"
    },
    {
        name: "Saint-Pierre und Miquelon",
        code: "pm"
    },
    {
        name: "S\xfcdafrika",
        code: "za"
    },
    {
        name: "Sudan",
        code: "sd"
    },
    {
        name: "S\xfcdsudan",
        code: "ss"
    },
    {
        name: "Suriname",
        code: "sr"
    },
    {
        name: "Spitzbergen und Jan Mayen",
        code: "sj"
    },
    {
        name: "Syrien",
        code: "sy"
    },
    {
        name: "Tadschikistan",
        code: "tj"
    },
    {
        name: "Taiwan",
        code: "tw"
    },
    {
        name: "Tansania",
        code: "tz"
    },
    {
        name: "Thailand",
        code: "th"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinidad und Tobago",
        code: "tt"
    },
    {
        name: "Tschad",
        code: "td"
    },
    {
        name: "Tschechien",
        code: "cz"
    },
    {
        name: "Tunesien",
        code: "tn"
    },
    {
        name: "T\xfcrkei",
        code: "tr"
    },
    {
        name: "Turkmenistan",
        code: "tm"
    },
    {
        name: "Turks- und Caicosinseln",
        code: "tc"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Ukraine",
        code: "ua"
    },
    {
        name: "Ungarn",
        code: "hu"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Usbekistan",
        code: "uz"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Vatikanstadt",
        code: "va"
    },
    {
        name: "Venezuela",
        code: "ve"
    },
    {
        name: "Vereinigte Staaten",
        code: "us"
    },
    {
        name: "Vereinigtes K\xf6nigreich",
        code: "gb"
    },
    {
        name: "Vietnam",
        code: "vn"
    },
    {
        name: "Wallis und Futuna",
        code: "wf"
    },
    {
        name: "Weihnachtsinsel",
        code: "cx"
    },
    {
        name: "Westsahara",
        code: "eh"
    },
    {
        name: "Zypern",
        code: "cy"
    }
];

});

parcelRegister("dpP26", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c453237412a3f7d$export$2e2bcd8739ae039);
var $9c453237412a3f7d$export$2e2bcd8739ae039 = [
    {
        name: "Afghanistan",
        code: "af"
    },
    {
        name: "\xc5land Islands",
        code: "ax"
    },
    {
        name: "Albania",
        code: "al"
    },
    {
        name: "Algeria",
        code: "dz"
    },
    {
        name: "American Samoa",
        code: "as"
    },
    {
        name: "Andorra",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antarctica",
        code: "aq"
    },
    {
        name: "Antigua and Barbuda",
        code: "ag"
    },
    {
        name: "Argentina",
        code: "ar"
    },
    {
        name: "Armenia",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Australia",
        code: "au"
    },
    {
        name: "Austria",
        code: "at"
    },
    {
        name: "Azerbaijan",
        code: "az"
    },
    {
        name: "Bahamas",
        code: "bs"
    },
    {
        name: "Bahrain",
        code: "bh"
    },
    {
        name: "Bangladesh",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Belarus",
        code: "by"
    },
    {
        name: "Belgium",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "Benin",
        code: "bj"
    },
    {
        name: "Bermuda",
        code: "bm"
    },
    {
        name: "Bhutan",
        code: "bt"
    },
    {
        name: "Sint Eustatius and Saba",
        code: "bq"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "Bouvet Island",
        code: "bv"
    },
    {
        name: "Brazil",
        code: "br"
    },
    {
        name: "Brunei Darussalam",
        code: "bn"
    },
    {
        name: "Bulgaria",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "Cabo Verde",
        code: "cv"
    },
    {
        name: "Cambodia",
        code: "kh"
    },
    {
        name: "Cameroon",
        code: "cm"
    },
    {
        name: "Canada",
        code: "ca"
    },
    {
        name: "Cayman Islands",
        code: "ky"
    },
    {
        name: "Central African Republic",
        code: "cf"
    },
    {
        name: "Chad",
        code: "td"
    },
    {
        name: "Chile",
        code: "cl"
    },
    {
        name: "China",
        code: "cn"
    },
    {
        name: "Christmas Island",
        code: "cx"
    },
    {
        name: "Cocos (Keeling) Islands",
        code: "cc"
    },
    {
        name: "Colombia",
        code: "co"
    },
    {
        name: "Comoros",
        code: "km"
    },
    {
        name: "Congo",
        code: "cg"
    },
    {
        name: "Democratic Republic of the",
        code: "cd"
    },
    {
        name: "Cook Islands",
        code: "ck"
    },
    {
        name: "Costa Rica",
        code: "cr"
    },
    {
        name: "C\xf4te d'Ivoire",
        code: "ci"
    },
    {
        name: "Croatia",
        code: "hr"
    },
    {
        name: "Cuba",
        code: "cu"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "Cyprus",
        code: "cy"
    },
    {
        name: "Czechia",
        code: "cz"
    },
    {
        name: "Denmark",
        code: "dk"
    },
    {
        name: "Djibouti",
        code: "dj"
    },
    {
        name: "Dominica",
        code: "dm"
    },
    {
        name: "Dominican Republic",
        code: "do"
    },
    {
        name: "Ecuador",
        code: "ec"
    },
    {
        name: "Egypt",
        code: "eg"
    },
    {
        name: "El Salvador",
        code: "sv"
    },
    {
        name: "Equatorial Guinea",
        code: "gq"
    },
    {
        name: "Eritrea",
        code: "er"
    },
    {
        name: "Estonia",
        code: "ee"
    },
    {
        name: "Eswatini",
        code: "sz"
    },
    {
        name: "Ethiopia",
        code: "et"
    },
    {
        name: "Falkland Islands (Malvinas)",
        code: "fk"
    },
    {
        name: "Faroe Islands",
        code: "fo"
    },
    {
        name: "Fiji",
        code: "fj"
    },
    {
        name: "Finland",
        code: "fi"
    },
    {
        name: "France",
        code: "fr"
    },
    {
        name: "French Guiana",
        code: "gf"
    },
    {
        name: "French Polynesia",
        code: "pf"
    },
    {
        name: "French Southern Territories",
        code: "tf"
    },
    {
        name: "Gabon",
        code: "ga"
    },
    {
        name: "Gambia",
        code: "gm"
    },
    {
        name: "Georgia",
        code: "ge"
    },
    {
        name: "Germany",
        code: "de"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Greece",
        code: "gr"
    },
    {
        name: "Greenland",
        code: "gl"
    },
    {
        name: "Grenada",
        code: "gd"
    },
    {
        name: "Guadeloupe",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guernsey",
        code: "gg"
    },
    {
        name: "Guinea",
        code: "gn"
    },
    {
        name: "Guinea-Bissau",
        code: "gw"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Haiti",
        code: "ht"
    },
    {
        name: "Holy See",
        code: "va"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hong Kong",
        code: "hk"
    },
    {
        name: "Hungary",
        code: "hu"
    },
    {
        name: "Iceland",
        code: "is"
    },
    {
        name: "India",
        code: "in"
    },
    {
        name: "Indonesia",
        code: "id"
    },
    {
        name: "Iran (Islamic Republic of)",
        code: "ir"
    },
    {
        name: "Iraq",
        code: "iq"
    },
    {
        name: "Ireland",
        code: "ie"
    },
    {
        name: "Isle of Man",
        code: "im"
    },
    {
        name: "Israel",
        code: "il"
    },
    {
        name: "Italy",
        code: "it"
    },
    {
        name: "Jamaica",
        code: "jm"
    },
    {
        name: "Japan",
        code: "jp"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Jordan",
        code: "jo"
    },
    {
        name: "Kazakhstan",
        code: "kz"
    },
    {
        name: "Kenya",
        code: "ke"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Korea, Republic of",
        code: "kr"
    },
    {
        name: "Kuwait",
        code: "kw"
    },
    {
        name: "Kyrgyzstan",
        code: "kg"
    },
    {
        name: "Latvia",
        code: "lv"
    },
    {
        name: "Lebanon",
        code: "lb"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libya",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Lithuania",
        code: "lt"
    },
    {
        name: "Luxembourg",
        code: "lu"
    },
    {
        name: "Macao",
        code: "mo"
    },
    {
        name: "Madagascar",
        code: "mg"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Malaysia",
        code: "my"
    },
    {
        name: "Maldives",
        code: "mv"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Marshall Islands",
        code: "mh"
    },
    {
        name: "Martinique",
        code: "mq"
    },
    {
        name: "Mauritania",
        code: "mr"
    },
    {
        name: "Mauritius",
        code: "mu"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "Mexico",
        code: "mx"
    },
    {
        name: "Moldova, Republic of",
        code: "md"
    },
    {
        name: "Monaco",
        code: "mc"
    },
    {
        name: "Mongolia",
        code: "mn"
    },
    {
        name: "Montenegro",
        code: "me"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Morocco",
        code: "ma"
    },
    {
        name: "Mozambique",
        code: "mz"
    },
    {
        name: "Myanmar",
        code: "mm"
    },
    {
        name: "Namibia",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "Nepal",
        code: "np"
    },
    {
        name: "Netherlands",
        code: "nl"
    },
    {
        name: "New Caledonia",
        code: "nc"
    },
    {
        name: "New Zealand",
        code: "nz"
    },
    {
        name: "Nicaragua",
        code: "ni"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "Norfolk Island",
        code: "nf"
    },
    {
        name: "North Macedonia",
        code: "mk"
    },
    {
        name: "Northern Mariana Islands",
        code: "mp"
    },
    {
        name: "Norway",
        code: "no"
    },
    {
        name: "Oman",
        code: "om"
    },
    {
        name: "Pakistan",
        code: "pk"
    },
    {
        name: "Palau",
        code: "pw"
    },
    {
        name: "Palestine, State of",
        code: "ps"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Papua New Guinea",
        code: "pg"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Peru",
        code: "pe"
    },
    {
        name: "Philippines",
        code: "ph"
    },
    {
        name: "Pitcairn",
        code: "pn"
    },
    {
        name: "Poland",
        code: "pl"
    },
    {
        name: "Portugal",
        code: "pt"
    },
    {
        name: "Puerto Rico",
        code: "pr"
    },
    {
        name: "Qatar",
        code: "qa"
    },
    {
        name: "R\xe9union",
        code: "re"
    },
    {
        name: "Romania",
        code: "ro"
    },
    {
        name: "Russian Federation",
        code: "ru"
    },
    {
        name: "Rwanda",
        code: "rw"
    },
    {
        name: "Saint Barth\xe9lemy",
        code: "bl"
    },
    {
        name: "Ascension and Tristan da Cunha",
        code: "sh"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "kn"
    },
    {
        name: "Saint Lucia",
        code: "lc"
    },
    {
        name: "Saint Martin (French part)",
        code: "mf"
    },
    {
        name: "Saint Pierre and Miquelon",
        code: "pm"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "Sao Tome and Principe",
        code: "st"
    },
    {
        name: "Saudi Arabia",
        code: "sa"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Serbia",
        code: "rs"
    },
    {
        name: "Seychelles",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Singapore",
        code: "sg"
    },
    {
        name: "Sint Maarten (Dutch part)",
        code: "sx"
    },
    {
        name: "Slovakia",
        code: "sk"
    },
    {
        name: "Slovenia",
        code: "si"
    },
    {
        name: "Solomon Islands",
        code: "sb"
    },
    {
        name: "Somalia",
        code: "so"
    },
    {
        name: "South Africa",
        code: "za"
    },
    {
        name: "South Sudan",
        code: "ss"
    },
    {
        name: "Spain",
        code: "es"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "Sudan",
        code: "sd"
    },
    {
        name: "Suriname",
        code: "sr"
    },
    {
        name: "Svalbard and Jan Mayen",
        code: "sj"
    },
    {
        name: "Sweden",
        code: "se"
    },
    {
        name: "Switzerland",
        code: "ch"
    },
    {
        name: "Syrian Arab Republic",
        code: "sy"
    },
    {
        name: "Taiwan",
        code: "tw"
    },
    {
        name: "Tajikistan",
        code: "tj"
    },
    {
        name: "United Republic of Tansania",
        code: "tz"
    },
    {
        name: "Thailand",
        code: "th"
    },
    {
        name: "Timor-Leste",
        code: "tl"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinidad and Tobago",
        code: "tt"
    },
    {
        name: "Tunisia",
        code: "tn"
    },
    {
        name: "Turkey",
        code: "tr"
    },
    {
        name: "Turkmenistan",
        code: "tm"
    },
    {
        name: "Turks and Caicos Islands",
        code: "tc"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Ukraine",
        code: "ua"
    },
    {
        name: "United Arab Emirates",
        code: "ae"
    },
    {
        name: "United Kingdom",
        code: "gb"
    },
    {
        name: "United States of America",
        code: "us"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Uzbekistan",
        code: "uz"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Viet Nam",
        code: "vn"
    },
    {
        name: "Virgin Islands (British)",
        code: "vg"
    },
    {
        name: "Virgin Islands (U.S.)",
        code: "vi"
    },
    {
        name: "Wallis and Futuna",
        code: "wf"
    },
    {
        name: "Western Sahara",
        code: "eh"
    },
    {
        name: "Yemen",
        code: "ye"
    },
    {
        name: "Zambia",
        code: "zm"
    },
    {
        name: "Zimbabwe",
        code: "zw"
    }
];

});

parcelRegister("dSh30", function(module, exports) {

$parcel$export(module.exports, "default", () => $a19d8ac4f366edfc$export$2e2bcd8739ae039);
var $a19d8ac4f366edfc$export$2e2bcd8739ae039 = [
    {
        name: "Afganist\xe1n",
        code: "af"
    },
    {
        name: "\xc5land",
        code: "ax"
    },
    {
        name: "Albania",
        code: "al"
    },
    {
        name: "Alemania",
        code: "de"
    },
    {
        name: "Andorra",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguila",
        code: "ai"
    },
    {
        name: "Ant\xe1rtida",
        code: "aq"
    },
    {
        name: "Antigua y Barbuda",
        code: "ag"
    },
    {
        name: "Arabia Saudita",
        code: "sa"
    },
    {
        name: "Argelia",
        code: "dz"
    },
    {
        name: "Argentina",
        code: "ar"
    },
    {
        name: "Armenia",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Australia",
        code: "au"
    },
    {
        name: "Austria",
        code: "at"
    },
    {
        name: "Azerbaiy\xe1n",
        code: "az"
    },
    {
        name: "Bahamas",
        code: "bs"
    },
    {
        name: "Banglad\xe9s",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Bar\xe9in",
        code: "bh"
    },
    {
        name: "B\xe9lgica",
        code: "be"
    },
    {
        name: "Belice",
        code: "bz"
    },
    {
        name: "Ben\xedn",
        code: "bj"
    },
    {
        name: "Bermudas",
        code: "bm"
    },
    {
        name: "Bielorrusia",
        code: "by"
    },
    {
        name: "Bolivia",
        code: "bo"
    },
    {
        name: "Bosnia y Herzegovina",
        code: "ba"
    },
    {
        name: "Botsuana",
        code: "bw"
    },
    {
        name: "Brasil",
        code: "br"
    },
    {
        name: "Brun\xe9i",
        code: "bn"
    },
    {
        name: "Bulgaria",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "But\xe1n",
        code: "bt"
    },
    {
        name: "Cabo Verde",
        code: "cv"
    },
    {
        name: "Camboya",
        code: "kh"
    },
    {
        name: "Camer\xfan",
        code: "cm"
    },
    {
        name: "Canad\xe1",
        code: "ca"
    },
    {
        name: "Catar",
        code: "qa"
    },
    {
        name: "Chad",
        code: "td"
    },
    {
        name: "Chile",
        code: "cl"
    },
    {
        name: "China",
        code: "cn"
    },
    {
        name: "Chipre",
        code: "cy"
    },
    {
        name: "Colombia",
        code: "co"
    },
    {
        name: "Comoras",
        code: "km"
    },
    {
        name: "Corea del Norte",
        code: "kp"
    },
    {
        name: "Corea del Sur",
        code: "kr"
    },
    {
        name: "Costa de Marfil",
        code: "ci"
    },
    {
        name: "Costa Rica",
        code: "cr"
    },
    {
        name: "Croacia",
        code: "hr"
    },
    {
        name: "Cuba",
        code: "cu"
    },
    {
        name: "Curazao",
        code: "cw"
    },
    {
        name: "Dinamarca",
        code: "dk"
    },
    {
        name: "Dominica",
        code: "dm"
    },
    {
        name: "Ecuador",
        code: "ec"
    },
    {
        name: "Egipto",
        code: "eg"
    },
    {
        name: "El Salvador",
        code: "sv"
    },
    {
        name: "Eritrea",
        code: "er"
    },
    {
        name: "Eslovaquia",
        code: "sk"
    },
    {
        name: "Eslovenia",
        code: "si"
    },
    {
        name: "Espa\xf1a",
        code: "es"
    },
    {
        name: "Estados Unidos",
        code: "us"
    },
    {
        name: "Estonia",
        code: "ee"
    },
    {
        name: "Etiop\xeda",
        code: "et"
    },
    {
        name: "Filipinas",
        code: "ph"
    },
    {
        name: "Finlandia",
        code: "fi"
    },
    {
        name: "Fiyi",
        code: "fj"
    },
    {
        name: "Francia",
        code: "fr"
    },
    {
        name: "Gab\xf3n",
        code: "ga"
    },
    {
        name: "Gambia",
        code: "gm"
    },
    {
        name: "Georgia",
        code: "ge"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Granada",
        code: "gd"
    },
    {
        name: "Grecia",
        code: "gr"
    },
    {
        name: "Groenlandia",
        code: "gl"
    },
    {
        name: "Guadalupe",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guayana Francesa",
        code: "gf"
    },
    {
        name: "Guernsey",
        code: "gg"
    },
    {
        name: "Guinea",
        code: "gn"
    },
    {
        name: "Guinea-Bis\xe1u",
        code: "gw"
    },
    {
        name: "Guinea Ecuatorial",
        code: "gq"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Hait\xed",
        code: "ht"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hong Kong",
        code: "hk"
    },
    {
        name: "Hungr\xeda",
        code: "hu"
    },
    {
        name: "India",
        code: "in"
    },
    {
        name: "Indonesia",
        code: "id"
    },
    {
        name: "Irak",
        code: "iq"
    },
    {
        name: "Ir\xe1n",
        code: "ir"
    },
    {
        name: "Irlanda",
        code: "ie"
    },
    {
        name: "Isla Bouvet",
        code: "bv"
    },
    {
        name: "Isla de Man",
        code: "im"
    },
    {
        name: "Isla de Navidad",
        code: "cx"
    },
    {
        name: "Islandia",
        code: "is"
    },
    {
        name: "Islas Caim\xe1n",
        code: "ky"
    },
    {
        name: "Islas Cocos",
        code: "cc"
    },
    {
        name: "Islas Cook",
        code: "ck"
    },
    {
        name: "Islas Feroe",
        code: "fo"
    },
    {
        name: "Islas Malvinas",
        code: "fk"
    },
    {
        name: "Islas Marshall",
        code: "mh"
    },
    {
        name: "Islas Pitcairn",
        code: "pn"
    },
    {
        name: "Islas Salom\xf3n",
        code: "sb"
    },
    {
        name: "Israel",
        code: "il"
    },
    {
        name: "Italia",
        code: "it"
    },
    {
        name: "Jamaica",
        code: "jm"
    },
    {
        name: "Jap\xf3n",
        code: "jp"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Jordania",
        code: "jo"
    },
    {
        name: "Kazajist\xe1n",
        code: "kz"
    },
    {
        name: "Kenia",
        code: "ke"
    },
    {
        name: "Kirguist\xe1n",
        code: "kg"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kuwait",
        code: "kw"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesoto",
        code: "ls"
    },
    {
        name: "Letonia",
        code: "lv"
    },
    {
        name: "L\xedbano",
        code: "lb"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libia",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Lituania",
        code: "lt"
    },
    {
        name: "Luxemburgo",
        code: "lu"
    },
    {
        name: "Macao",
        code: "mo"
    },
    {
        name: "Macedonia del Norte",
        code: "mk"
    },
    {
        name: "Madagascar",
        code: "mg"
    },
    {
        name: "Malasia",
        code: "my"
    },
    {
        name: "Malaui",
        code: "mw"
    },
    {
        name: "Maldivas",
        code: "mv"
    },
    {
        name: "Mal\xed",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Marruecos",
        code: "ma"
    },
    {
        name: "Martinica",
        code: "mq"
    },
    {
        name: "Mauricio",
        code: "mu"
    },
    {
        name: "Mauritania",
        code: "mr"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "M\xe9xico",
        code: "mx"
    },
    {
        name: "Micronesia",
        code: "fm"
    },
    {
        name: "Moldavia",
        code: "md"
    },
    {
        name: "M\xf3naco",
        code: "mc"
    },
    {
        name: "Mongolia",
        code: "mn"
    },
    {
        name: "Montenegro",
        code: "me"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mozambique",
        code: "mz"
    },
    {
        name: "Birmania",
        code: "mm"
    },
    {
        name: "Namibia",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "Nepal",
        code: "np"
    },
    {
        name: "Nicaragua",
        code: "ni"
    },
    {
        name: "N\xedger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "Isla Norfolk",
        code: "nf"
    },
    {
        name: "Noruega",
        code: "no"
    },
    {
        name: "Nueva Caledonia",
        code: "nc"
    },
    {
        name: "Nueva Zelanda",
        code: "nz"
    },
    {
        name: "Om\xe1n",
        code: "om"
    },
    {
        name: "Pa\xedses Bajos",
        code: "nl"
    },
    {
        name: "Pakist\xe1n",
        code: "pk"
    },
    {
        name: "Palaos",
        code: "pw"
    },
    {
        name: "Palestina",
        code: "ps"
    },
    {
        name: "Panam\xe1",
        code: "pa"
    },
    {
        name: "Pap\xfaa Nueva Guinea",
        code: "pg"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Per\xfa",
        code: "pe"
    },
    {
        name: "Polinesia Francesa",
        code: "pf"
    },
    {
        name: "Polonia",
        code: "pl"
    },
    {
        name: "Portugal",
        code: "pt"
    },
    {
        name: "Puerto Rico",
        code: "pr"
    },
    {
        name: "Reino Unido",
        code: "gb"
    },
    {
        name: "Rep\xfablica Checa",
        code: "cz"
    },
    {
        name: "Rep\xfablica del Congo",
        code: "cg"
    },
    {
        name: "Reuni\xf3n",
        code: "re"
    },
    {
        name: "Ruanda",
        code: "rw"
    },
    {
        name: "Rumania",
        code: "ro"
    },
    {
        name: "Rusia",
        code: "ru"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "Samoa Americana",
        code: "as"
    },
    {
        name: "San Bartolom\xe9",
        code: "bl"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "San Mart\xedn",
        code: "mf"
    },
    {
        name: "Santa Luc\xeda",
        code: "lc"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Serbia",
        code: "rs"
    },
    {
        name: "Seychelles",
        code: "sc"
    },
    {
        name: "Sierra Leona",
        code: "sl"
    },
    {
        name: "Singapur",
        code: "sg"
    },
    {
        name: "San Mart\xedn",
        code: "sx"
    },
    {
        name: "Siria",
        code: "sy"
    },
    {
        name: "Somalia",
        code: "so"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "Suazilandia",
        code: "sz"
    },
    {
        name: "Sud\xe1frica",
        code: "za"
    },
    {
        name: "Sud\xe1n",
        code: "sd"
    },
    {
        name: "Sud\xe1n del Sur",
        code: "ss"
    },
    {
        name: "Suecia",
        code: "se"
    },
    {
        name: "Suiza",
        code: "ch"
    },
    {
        name: "Surinam",
        code: "sr"
    },
    {
        name: "Tailandia",
        code: "th"
    },
    {
        name: "Tanzania",
        code: "tz"
    },
    {
        name: "Tayikist\xe1n",
        code: "tj"
    },
    {
        name: "Timor Oriental",
        code: "tl"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinidad y Tobago",
        code: "tt"
    },
    {
        name: "T\xfanez",
        code: "tn"
    },
    {
        name: "Turkmenist\xe1n",
        code: "tm"
    },
    {
        name: "Turqu\xeda",
        code: "tr"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Ucrania",
        code: "ua"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Uzbekist\xe1n",
        code: "uz"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Venezuela",
        code: "ve"
    },
    {
        name: "Vietnam",
        code: "vn"
    },
    {
        name: "Wallis y Futuna",
        code: "wf"
    },
    {
        name: "Yemen",
        code: "ye"
    },
    {
        name: "Yibuti",
        code: "dj"
    },
    {
        name: "Zambia",
        code: "zm"
    },
    {
        name: "Zimbabue",
        code: "zw"
    }
];

});

parcelRegister("3g9pS", function(module, exports) {

$parcel$export(module.exports, "default", () => $25fa2b97a5e3f0c1$export$2e2bcd8739ae039);
var $25fa2b97a5e3f0c1$export$2e2bcd8739ae039 = [
    {
        name: "Afghanistan",
        code: "af"
    },
    {
        name: "Albania",
        code: "al"
    },
    {
        name: "Algeria",
        code: "dz"
    },
    {
        name: "Andorra",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antartide",
        code: "aq"
    },
    {
        name: "Antigua e Barbuda",
        code: "ag"
    },
    {
        name: "Arabia Saudita",
        code: "sa"
    },
    {
        name: "Argentina",
        code: "ar"
    },
    {
        name: "Armenia",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Australia",
        code: "au"
    },
    {
        name: "Austria",
        code: "at"
    },
    {
        name: "Azerbaigian",
        code: "az"
    },
    {
        name: "Bahamas",
        code: "bs"
    },
    {
        name: "Bahrein",
        code: "bh"
    },
    {
        name: "Bangladesh",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Belgio",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "Benin",
        code: "bj"
    },
    {
        name: "Bermuda",
        code: "bm"
    },
    {
        name: "Bhutan",
        code: "bt"
    },
    {
        name: "Bielorussia",
        code: "by"
    },
    {
        name: "Birmania",
        code: "mm"
    },
    {
        name: "Bolivia",
        code: "bo"
    },
    {
        name: "Bosnia ed Erzegovina",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "Brasile",
        code: "br"
    },
    {
        name: "Brunei",
        code: "bn"
    },
    {
        name: "Bulgaria",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "Cambogia",
        code: "kh"
    },
    {
        name: "Camerun",
        code: "cm"
    },
    {
        name: "Canada",
        code: "ca"
    },
    {
        name: "Capo Verde",
        code: "cv"
    },
    {
        name: "Ciad",
        code: "td"
    },
    {
        name: "Cile",
        code: "cl"
    },
    {
        name: "Cina",
        code: "cn"
    },
    {
        name: "Cipro",
        code: "cy"
    },
    {
        name: "Citt\xe0 del Vaticano",
        code: "va"
    },
    {
        name: "Colombia",
        code: "co"
    },
    {
        name: "Comore",
        code: "km"
    },
    {
        name: "Corea del Nord",
        code: "kp"
    },
    {
        name: "Corea del Sud",
        code: "kr"
    },
    {
        name: "Costa d'Avorio",
        code: "ci"
    },
    {
        name: "Costa Rica",
        code: "cr"
    },
    {
        name: "Croazia",
        code: "hr"
    },
    {
        name: "Cuba",
        code: "cu"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "Danimarca",
        code: "dk"
    },
    {
        name: "Dominica",
        code: "dm"
    },
    {
        name: "Ecuador",
        code: "ec"
    },
    {
        name: "Egitto",
        code: "eg"
    },
    {
        name: "El Salvador",
        code: "sv"
    },
    {
        name: "Emirati Arabi Uniti",
        code: "ae"
    },
    {
        name: "Eritrea",
        code: "er"
    },
    {
        name: "Estonia",
        code: "ee"
    },
    {
        name: "Etiopia",
        code: "et"
    },
    {
        name: "Figi",
        code: "fj"
    },
    {
        name: "Filippine",
        code: "ph"
    },
    {
        name: "Finlandia",
        code: "fi"
    },
    {
        name: "Francia",
        code: "fr"
    },
    {
        name: "Gabon",
        code: "ga"
    },
    {
        name: "Gambia",
        code: "gm"
    },
    {
        name: "Georgia",
        code: "ge"
    },
    {
        name: "Georgia del Sud e Isole Sandwich Australi",
        code: "gs"
    },
    {
        name: "Germania",
        code: "de"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Giamaica",
        code: "jm"
    },
    {
        name: "Giappone",
        code: "jp"
    },
    {
        name: "Gibilterra",
        code: "gi"
    },
    {
        name: "Gibuti",
        code: "dj"
    },
    {
        name: "Giordania",
        code: "jo"
    },
    {
        name: "Grecia",
        code: "gr"
    },
    {
        name: "Grenada",
        code: "gd"
    },
    {
        name: "Groenlandia",
        code: "gl"
    },
    {
        name: "Guadalupa",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guernsey",
        code: "gg"
    },
    {
        name: "Guinea",
        code: "gn"
    },
    {
        name: "Guinea-Bissau",
        code: "gw"
    },
    {
        name: "Guinea Equatoriale",
        code: "gq"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Guyana francese",
        code: "gf"
    },
    {
        name: "Haiti",
        code: "ht"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hong Kong",
        code: "hk"
    },
    {
        name: "India",
        code: "in"
    },
    {
        name: "Indonesia",
        code: "id"
    },
    {
        name: "Iran",
        code: "ir"
    },
    {
        name: "Iraq",
        code: "iq"
    },
    {
        name: "Irlanda",
        code: "ie"
    },
    {
        name: "Islanda",
        code: "is"
    },
    {
        name: "Isola Bouvet",
        code: "bv"
    },
    {
        name: "Isola di Man",
        code: "im"
    },
    {
        name: "Isola di Natale",
        code: "cx"
    },
    {
        name: "Isola Norfolk",
        code: "nf"
    },
    {
        name: "Isole \xc5land",
        code: "ax"
    },
    {
        name: "Isole BES",
        code: "bq"
    },
    {
        name: "Isole Cayman",
        code: "ky"
    },
    {
        name: "Isole Cocos (Keeling)",
        code: "cc"
    },
    {
        name: "Isole Cook",
        code: "ck"
    },
    {
        name: "F\xe6r \xd8er",
        code: "fo"
    },
    {
        name: "Isole Falkland",
        code: "fk"
    },
    {
        name: "Isole Heard e McDonald",
        code: "hm"
    },
    {
        name: "Isole Marianne Settentrionali",
        code: "mp"
    },
    {
        name: "Isole Marshall",
        code: "mh"
    },
    {
        name: "Isole minori esterne degli Stati Uniti",
        code: "um"
    },
    {
        name: "Isole Pitcairn",
        code: "pn"
    },
    {
        name: "Isole Salomone",
        code: "sb"
    },
    {
        name: "Isole Vergini britanniche",
        code: "vg"
    },
    {
        name: "Isole Vergini americane",
        code: "vi"
    },
    {
        name: "Israele",
        code: "il"
    },
    {
        name: "Italia",
        code: "it"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Kazakistan",
        code: "kz"
    },
    {
        name: "Kenya",
        code: "ke"
    },
    {
        name: "Kirghizistan",
        code: "kg"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kuwait",
        code: "kw"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Lettonia",
        code: "lv"
    },
    {
        name: "Libano",
        code: "lb"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libia",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Lituania",
        code: "lt"
    },
    {
        name: "Lussemburgo",
        code: "lu"
    },
    {
        name: "Macao",
        code: "mo"
    },
    {
        name: "Macedonia del Nord",
        code: "mk"
    },
    {
        name: "Madagascar",
        code: "mg"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Malaysia",
        code: "my"
    },
    {
        name: "Maldive",
        code: "mv"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Marocco",
        code: "ma"
    },
    {
        name: "Martinica",
        code: "mq"
    },
    {
        name: "Mauritania",
        code: "mr"
    },
    {
        name: "Mauritius",
        code: "mu"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "Messico",
        code: "mx"
    },
    {
        name: "Micronesia",
        code: "fm"
    },
    {
        name: "Moldavia",
        code: "md"
    },
    {
        name: "Mongolia",
        code: "mn"
    },
    {
        name: "Montenegro",
        code: "me"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mozambico",
        code: "mz"
    },
    {
        name: "Namibia",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "Nepal",
        code: "np"
    },
    {
        name: "Nicaragua",
        code: "ni"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "Norvegia",
        code: "no"
    },
    {
        name: "Nuova Caledonia",
        code: "nc"
    },
    {
        name: "Nuova Zelanda",
        code: "nz"
    },
    {
        name: "Oman",
        code: "om"
    },
    {
        name: "Paesi Bassi",
        code: "nl"
    },
    {
        name: "Pakistan",
        code: "pk"
    },
    {
        name: "Palau",
        code: "pw"
    },
    {
        name: "Palestina",
        code: "ps"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Papua Nuova Guinea",
        code: "pg"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Per\xf9",
        code: "pe"
    },
    {
        name: "Polinesia francese",
        code: "pf"
    },
    {
        name: "Polonia",
        code: "pl"
    },
    {
        name: "Porto Rico",
        code: "pr"
    },
    {
        name: "Portogallo",
        code: "pt"
    },
    {
        name: "Monaco",
        code: "mc"
    },
    {
        name: "Qatar",
        code: "qa"
    },
    {
        name: "Regno Unito",
        code: "gb"
    },
    {
        name: "RD del Congo",
        code: "cd"
    },
    {
        name: "Rep. Ceca",
        code: "cz"
    },
    {
        name: "Rep. Centrafricana",
        code: "cf"
    },
    {
        name: "Rep. del Congo",
        code: "cg"
    },
    {
        name: "Rep. Dominicana",
        code: "do"
    },
    {
        name: "Riunione",
        code: "re"
    },
    {
        name: "Romania",
        code: "ro"
    },
    {
        name: "Ruanda",
        code: "rw"
    },
    {
        name: "Russia",
        code: "ru"
    },
    {
        name: "Sahara Occidentale",
        code: "eh"
    },
    {
        name: "Saint Kitts e Nevis",
        code: "kn"
    },
    {
        name: "Saint Lucia",
        code: "lc"
    },
    {
        name: "Sant'Elena, Ascensione e Tristan da Cunha",
        code: "sh"
    },
    {
        name: "Saint Vincent e Grenadine",
        code: "vc"
    },
    {
        name: "Saint-Barth\xe9lemy",
        code: "bl"
    },
    {
        name: "Saint-Martin",
        code: "mf"
    },
    {
        name: "Saint-Pierre e Miquelon",
        code: "pm"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "Samoa Americane",
        code: "as"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "S\xe3o Tom\xe9 e Pr\xedncipe",
        code: "st"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Serbia",
        code: "rs"
    },
    {
        name: "Seychelles",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Singapore",
        code: "sg"
    },
    {
        name: "Sint Maarten",
        code: "sx"
    },
    {
        name: "Siria",
        code: "sy"
    },
    {
        name: "Slovacchia",
        code: "sk"
    },
    {
        name: "Slovenia",
        code: "si"
    },
    {
        name: "Somalia",
        code: "so"
    },
    {
        name: "Spagna",
        code: "es"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "Stati Uniti",
        code: "us"
    },
    {
        name: "Sudafrica",
        code: "za"
    },
    {
        name: "Sudan",
        code: "sd"
    },
    {
        name: "Sudan del Sud",
        code: "ss"
    },
    {
        name: "Suriname",
        code: "sr"
    },
    {
        name: "Svalbard e Jan Mayen",
        code: "sj"
    },
    {
        name: "Svezia",
        code: "se"
    },
    {
        name: "Svizzera",
        code: "ch"
    },
    {
        name: "Swaziland",
        code: "sz"
    },
    {
        name: "Taiwan",
        code: "tw"
    },
    {
        name: "Tagikistan",
        code: "tj"
    },
    {
        name: "Tanzania",
        code: "tz"
    },
    {
        name: "Terre australi e antartiche francesi",
        code: "tf"
    },
    {
        name: "Territorio britannico dell'Oceano Indiano",
        code: "io"
    },
    {
        name: "Thailandia",
        code: "th"
    },
    {
        name: "Timor Est",
        code: "tl"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinidad e Tobago",
        code: "tt"
    },
    {
        name: "Tunisia",
        code: "tn"
    },
    {
        name: "Turchia",
        code: "tr"
    },
    {
        name: "Turkmenistan",
        code: "tm"
    },
    {
        name: "Turks e Caicos",
        code: "tc"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Ucraina",
        code: "ua"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Ungheria",
        code: "hu"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Uzbekistan",
        code: "uz"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Venezuela",
        code: "ve"
    },
    {
        name: "Vietnam",
        code: "vn"
    },
    {
        name: "Wallis e Futuna",
        code: "wf"
    },
    {
        name: "Yemen",
        code: "ye"
    },
    {
        name: "Zambia",
        code: "zm"
    },
    {
        name: "Zimbabwe",
        code: "zw"
    }
];

});

parcelRegister("lT0Kb", function(module, exports) {

$parcel$export(module.exports, "default", () => $feef4fb9bd64b2b5$export$2e2bcd8739ae039);
var $feef4fb9bd64b2b5$export$2e2bcd8739ae039 = [
    {
        name: "Afganistan",
        code: "af"
    },
    {
        name: "Albania",
        code: "al"
    },
    {
        name: "Algieria",
        code: "dz"
    },
    {
        name: "Andora",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antarktyka",
        code: "aq"
    },
    {
        name: "Antigua i Barbuda",
        code: "ag"
    },
    {
        name: "Arabia Saudyjska",
        code: "sa"
    },
    {
        name: "Argentyna",
        code: "ar"
    },
    {
        name: "Armenia",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Australia",
        code: "au"
    },
    {
        name: "Austria",
        code: "at"
    },
    {
        name: "Azerbejd\u017Can",
        code: "az"
    },
    {
        name: "Bahamy",
        code: "bs"
    },
    {
        name: "Bahrajn",
        code: "bh"
    },
    {
        name: "Bangladesz",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Belgia",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "Benin",
        code: "bj"
    },
    {
        name: "Bermudy",
        code: "bm"
    },
    {
        name: "Bhutan",
        code: "bt"
    },
    {
        name: "Bia\u0142oru\u015B",
        code: "by"
    },
    {
        name: "Boliwia",
        code: "bo"
    },
    {
        name: "Bonaire, Sint Eustatius i Saba",
        code: "bq"
    },
    {
        name: "Bo\u015Bnia i Hercegowina",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "Brazylia",
        code: "br"
    },
    {
        name: "Brunei",
        code: "bn"
    },
    {
        name: "Brytyjskie Terytorium Oceanu Indyjskiego",
        code: "io"
    },
    {
        name: "Brytyjskie Wyspy Dziewicze",
        code: "vg"
    },
    {
        name: "Bu\u0142garia",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "Chile",
        code: "cl"
    },
    {
        name: "Chiny",
        code: "cn"
    },
    {
        name: "Chorwacja",
        code: "hr"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "Cypr",
        code: "cy"
    },
    {
        name: "Czad",
        code: "td"
    },
    {
        name: "Czarnog\xf3ra",
        code: "me"
    },
    {
        name: "Czechy",
        code: "cz"
    },
    {
        name: "Dalekie Wyspy Mniejsze Stan\xf3w Zjednoczonych",
        code: "um"
    },
    {
        name: "Dania",
        code: "dk"
    },
    {
        name: "Demokratyczna Republika Konga",
        code: "cd"
    },
    {
        name: "Dominika",
        code: "dm"
    },
    {
        name: "Dominikana",
        code: "do"
    },
    {
        name: "D\u017Cibuti",
        code: "dj"
    },
    {
        name: "Egipt",
        code: "eg"
    },
    {
        name: "Ekwador",
        code: "ec"
    },
    {
        name: "Erytrea",
        code: "er"
    },
    {
        name: "Estonia",
        code: "ee"
    },
    {
        name: "Eswatini",
        code: "sz"
    },
    {
        name: "Etiopia",
        code: "et"
    },
    {
        name: "Falklandy",
        code: "fk"
    },
    {
        name: "Fid\u017Ci",
        code: "fj"
    },
    {
        name: "Filipiny",
        code: "ph"
    },
    {
        name: "Finlandia",
        code: "fi"
    },
    {
        name: "Francja",
        code: "fr"
    },
    {
        name: "Francuskie Terytoria Po\u0142udniowe i Antarktyczne",
        code: "tf"
    },
    {
        name: "Gabon",
        code: "ga"
    },
    {
        name: "Gambia",
        code: "gm"
    },
    {
        name: "Georgia Po\u0142udniowa i Sandwich Po\u0142udniowy",
        code: "gs"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Grecja",
        code: "gr"
    },
    {
        name: "Grenada",
        code: "gd"
    },
    {
        name: "Grenlandia",
        code: "gl"
    },
    {
        name: "Gruzja",
        code: "ge"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guernsey",
        code: "gg"
    },
    {
        name: "Gujana Francuska",
        code: "gf"
    },
    {
        name: "Gujana",
        code: "gy"
    },
    {
        name: "Gwadelupa",
        code: "gp"
    },
    {
        name: "Gwatemala",
        code: "gt"
    },
    {
        name: "Gwinea Bissau",
        code: "gw"
    },
    {
        name: "Gwinea R\xf3wnikowa",
        code: "gq"
    },
    {
        name: "Gwinea",
        code: "gn"
    },
    {
        name: "Haiti",
        code: "ht"
    },
    {
        name: "Hiszpania",
        code: "es"
    },
    {
        name: "Holandia",
        code: "nl"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hongkong",
        code: "hk"
    },
    {
        name: "Indie",
        code: "in"
    },
    {
        name: "Indonezja",
        code: "id"
    },
    {
        name: "Irak",
        code: "iq"
    },
    {
        name: "Iran",
        code: "ir"
    },
    {
        name: "Irlandia",
        code: "ie"
    },
    {
        name: "Islandia",
        code: "is"
    },
    {
        name: "Izrael",
        code: "il"
    },
    {
        name: "Jamajka",
        code: "jm"
    },
    {
        name: "Japonia",
        code: "jp"
    },
    {
        name: "Jemen",
        code: "ye"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Jordania",
        code: "jo"
    },
    {
        name: "Kajmany",
        code: "ky"
    },
    {
        name: "Kambod\u017Ca",
        code: "kh"
    },
    {
        name: "Kamerun",
        code: "cm"
    },
    {
        name: "Kanada",
        code: "ca"
    },
    {
        name: "Katar",
        code: "qa"
    },
    {
        name: "Kazachstan",
        code: "kz"
    },
    {
        name: "Kenia",
        code: "ke"
    },
    {
        name: "Kirgistan",
        code: "kg"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kolumbia",
        code: "co"
    },
    {
        name: "Komory",
        code: "km"
    },
    {
        name: "Kongo",
        code: "cg"
    },
    {
        name: "Korea Po\u0142udniowa",
        code: "kr"
    },
    {
        name: "Korea P\xf3\u0142nocna",
        code: "kp"
    },
    {
        name: "Kostaryka",
        code: "cr"
    },
    {
        name: "Kuba",
        code: "cu"
    },
    {
        name: "Kuwejt",
        code: "kw"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Liban",
        code: "lb"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libia",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Litwa",
        code: "lt"
    },
    {
        name: "Luksemburg",
        code: "lu"
    },
    {
        name: "\u0141otwa",
        code: "lv"
    },
    {
        name: "Macedonia P\xf3\u0142nocna",
        code: "mk"
    },
    {
        name: "Madagaskar",
        code: "mg"
    },
    {
        name: "Majotta",
        code: "yt"
    },
    {
        name: "Makau",
        code: "mo"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Malediwy",
        code: "mv"
    },
    {
        name: "Malezja",
        code: "my"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Mariany P\xf3\u0142nocne",
        code: "mp"
    },
    {
        name: "Maroko",
        code: "ma"
    },
    {
        name: "Martynika",
        code: "mq"
    },
    {
        name: "Mauretania",
        code: "mr"
    },
    {
        name: "Mauritius",
        code: "mu"
    },
    {
        name: "Meksyk",
        code: "mx"
    },
    {
        name: "Mikronezja",
        code: "fm"
    },
    {
        name: "Mjanma",
        code: "mm"
    },
    {
        name: "Mo\u0142dawia",
        code: "md"
    },
    {
        name: "Monako",
        code: "mc"
    },
    {
        name: "Mongolia",
        code: "mn"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mozambik",
        code: "mz"
    },
    {
        name: "Namibia",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "Nepal",
        code: "np"
    },
    {
        name: "Niemcy",
        code: "de"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Nikaragua",
        code: "ni"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "Norfolk",
        code: "nf"
    },
    {
        name: "Norwegia",
        code: "no"
    },
    {
        name: "Nowa Kaledonia",
        code: "nc"
    },
    {
        name: "Nowa Zelandia",
        code: "nz"
    },
    {
        name: "Oman",
        code: "om"
    },
    {
        name: "Pakistan",
        code: "pk"
    },
    {
        name: "Palau",
        code: "pw"
    },
    {
        name: "Palestyna",
        code: "ps"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Papua-Nowa Gwinea",
        code: "pg"
    },
    {
        name: "Paragwaj",
        code: "py"
    },
    {
        name: "Peru",
        code: "pe"
    },
    {
        name: "Pitcairn",
        code: "pn"
    },
    {
        name: "Polinezja Francuska",
        code: "pf"
    },
    {
        name: "Polska",
        code: "pl"
    },
    {
        name: "Portoryko",
        code: "pr"
    },
    {
        name: "Portugalia",
        code: "pt"
    },
    {
        name: "Po\u0142udniowa Afryka",
        code: "za"
    },
    {
        name: "Republika \u015Arodkowoafryka\u0144ska",
        code: "cf"
    },
    {
        name: "Republika Zielonego Przyl\u0105dka",
        code: "cv"
    },
    {
        name: "Reunion",
        code: "re"
    },
    {
        name: "Rosja",
        code: "ru"
    },
    {
        name: "Rumunia",
        code: "ro"
    },
    {
        name: "Rwanda",
        code: "rw"
    },
    {
        name: "Sahara Zachodnia",
        code: "eh"
    },
    {
        name: "Saint Kitts i Nevis",
        code: "kn"
    },
    {
        name: "Saint Lucia",
        code: "lc"
    },
    {
        name: "Saint Vincent i Grenadyny",
        code: "vc"
    },
    {
        name: "Saint-Barth\xe9lemy",
        code: "bl"
    },
    {
        name: "Saint-Martin",
        code: "mf"
    },
    {
        name: "Saint-Pierre i Miquelon",
        code: "pm"
    },
    {
        name: "Salwador",
        code: "sv"
    },
    {
        name: "Samoa Ameryka\u0144skie",
        code: "as"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Serbia",
        code: "rs"
    },
    {
        name: "Seszele",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Singapur",
        code: "sg"
    },
    {
        name: "Sint Maarten",
        code: "sx"
    },
    {
        name: "S\u0142owacja",
        code: "sk"
    },
    {
        name: "S\u0142owenia",
        code: "si"
    },
    {
        name: "Somalia",
        code: "so"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "Stany Zjednoczone",
        code: "us"
    },
    {
        name: "Sudan",
        code: "sd"
    },
    {
        name: "Sudan Po\u0142udniowy",
        code: "ss"
    },
    {
        name: "Surinam",
        code: "sr"
    },
    {
        name: "Svalbard i Jan Mayen",
        code: "sj"
    },
    {
        name: "Syria",
        code: "sy"
    },
    {
        name: "Szwajcaria",
        code: "ch"
    },
    {
        name: "Szwecja",
        code: "se"
    },
    {
        name: "Tad\u017Cykistan",
        code: "tj"
    },
    {
        name: "Tajlandia",
        code: "th"
    },
    {
        name: "Tajwan",
        code: "tw"
    },
    {
        name: "Tanzania",
        code: "tz"
    },
    {
        name: "Timor Wschodni",
        code: "tl"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trynidad i Tobago",
        code: "tt"
    },
    {
        name: "Tunezja",
        code: "tn"
    },
    {
        name: "Turcja",
        code: "tr"
    },
    {
        name: "Turkmenistan",
        code: "tm"
    },
    {
        name: "Turks i Caicos",
        code: "tc"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Ukraina",
        code: "ua"
    },
    {
        name: "Urugwaj",
        code: "uy"
    },
    {
        name: "Uzbekistan",
        code: "uz"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Wallis i Futuna",
        code: "wf"
    },
    {
        name: "Watykan",
        code: "va"
    },
    {
        name: "Wenezuela",
        code: "ve"
    },
    {
        name: "W\u0119gry",
        code: "hu"
    },
    {
        name: "Wielka Brytania",
        code: "gb"
    },
    {
        name: "Wietnam",
        code: "vn"
    },
    {
        name: "W\u0142ochy",
        code: "it"
    },
    {
        name: "Wybrze\u017Ce Ko\u015Bci S\u0142oniowej",
        code: "ci"
    },
    {
        name: "Wyspa Bouveta",
        code: "bv"
    },
    {
        name: "Wyspa Bo\u017Cego Narodzenia",
        code: "cx"
    },
    {
        name: "Wyspa Man",
        code: "im"
    },
    {
        name: "Wyspa \u015Awi\u0119tej Heleny, Wyspa Wniebowst\u0105pienia i Tristan da Cunha",
        code: "sh"
    },
    {
        name: "Wyspy Alandzkie",
        code: "ax"
    },
    {
        name: "Wyspy Cooka",
        code: "ck"
    },
    {
        name: "Wyspy Dziewicze Stan\xf3w Zjednoczonych",
        code: "vi"
    },
    {
        name: "Wyspy Heard i McDonalda",
        code: "hm"
    },
    {
        name: "Wyspy Kokosowe",
        code: "cc"
    },
    {
        name: "Wyspy Marshalla",
        code: "mh"
    },
    {
        name: "Wyspy Owcze",
        code: "fo"
    },
    {
        name: "Wyspy Salomona",
        code: "sb"
    },
    {
        name: "Wyspy \u015Awi\u0119tego Tomasza i Ksi\u0105\u017C\u0119ca",
        code: "st"
    },
    {
        name: "Zambia",
        code: "zm"
    },
    {
        name: "Zimbabwe",
        code: "zw"
    },
    {
        name: "Zjednoczone Emiraty Arabskie",
        code: "ae"
    }
];

});

parcelRegister("7Qx26", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b67035bc7394af3$export$2e2bcd8739ae039);
var $5b67035bc7394af3$export$2e2bcd8739ae039 = [
    {
        name: "Afgh\xe1nist\xe1n",
        code: "af"
    },
    {
        name: "Alandy",
        code: "ax"
    },
    {
        name: "Alb\xe1nie",
        code: "al"
    },
    {
        name: "Al\u017E\xedrsko",
        code: "dz"
    },
    {
        name: "Americk\xe1 Samoa",
        code: "as"
    },
    {
        name: "Andorra",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antarktida",
        code: "aq"
    },
    {
        name: "Antigua a Barbuda",
        code: "ag"
    },
    {
        name: "Argentina",
        code: "ar"
    },
    {
        name: "Arm\xe9nie",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Austr\xe1lie",
        code: "au"
    },
    {
        name: "\xc1zerb\xe1jd\u017E\xe1n",
        code: "az"
    },
    {
        name: "Bahamy",
        code: "bs"
    },
    {
        name: "Bahrajn",
        code: "bh"
    },
    {
        name: "Banglad\xe9\u0161",
        code: "bd"
    },
    {
        name: "Barbados",
        code: "bb"
    },
    {
        name: "Belgie",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "B\u011Blorusko",
        code: "by"
    },
    {
        name: "Benin",
        code: "bj"
    },
    {
        name: "Bermudy",
        code: "bm"
    },
    {
        name: "Bh\xfat\xe1n",
        code: "bt"
    },
    {
        name: "Bol\xedvie",
        code: "bo"
    },
    {
        name: "Bosna a Hercegovina",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "Bouvet\u016Fv ostrov",
        code: "bv"
    },
    {
        name: "Braz\xedlie",
        code: "br"
    },
    {
        name: "Brunej",
        code: "bn"
    },
    {
        name: "Bulharsko",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "Cookovy ostrovy",
        code: "ck"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "\u010Cad",
        code: "td"
    },
    {
        name: "\u010Cern\xe1 Hora",
        code: "me"
    },
    {
        name: "\u010Cesko",
        code: "cz"
    },
    {
        name: "\u010C\xedna",
        code: "cn"
    },
    {
        name: "D\xe1nsko",
        code: "dk"
    },
    {
        name: "Dominika",
        code: "dm"
    },
    {
        name: "D\u017Eibutsko",
        code: "dj"
    },
    {
        name: "Egypt",
        code: "eg"
    },
    {
        name: "Ekv\xe1dor",
        code: "ec"
    },
    {
        name: "Eritrea",
        code: "er"
    },
    {
        name: "Estonsko",
        code: "ee"
    },
    {
        name: "Etiopie",
        code: "et"
    },
    {
        name: "Faersk\xe9 ostrovy",
        code: "fo"
    },
    {
        name: "Falklandy (Malv\xedny)",
        code: "fk"
    },
    {
        name: "Fid\u017Ei",
        code: "fj"
    },
    {
        name: "Filip\xedny",
        code: "ph"
    },
    {
        name: "Finsko",
        code: "fi"
    },
    {
        name: "Francie",
        code: "fr"
    },
    {
        name: "Francouzsk\xe1 Guyana",
        code: "gf"
    },
    {
        name: "Gabon",
        code: "ga"
    },
    {
        name: "Gambie",
        code: "gm"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Grenada",
        code: "gd"
    },
    {
        name: "Gr\xf3nsko",
        code: "gl"
    },
    {
        name: "Gruzie",
        code: "ge"
    },
    {
        name: "Guadeloupe",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guinea",
        code: "gn"
    },
    {
        name: "Guinea-Bissau",
        code: "gw"
    },
    {
        name: "Guernsey",
        code: "gg"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Haiti",
        code: "ht"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hongkong",
        code: "hk"
    },
    {
        name: "Chile",
        code: "cl"
    },
    {
        name: "Chorvatsko",
        code: "hr"
    },
    {
        name: "Indie",
        code: "in"
    },
    {
        name: "Indon\xe9sie",
        code: "id"
    },
    {
        name: "Ir\xe1k",
        code: "iq"
    },
    {
        name: "\xcdr\xe1n",
        code: "ir"
    },
    {
        name: "Irsko",
        code: "ie"
    },
    {
        name: "Island",
        code: "is"
    },
    {
        name: "It\xe1lie",
        code: "it"
    },
    {
        name: "Izrael",
        code: "il"
    },
    {
        name: "Jamajka",
        code: "jm"
    },
    {
        name: "Japonsko",
        code: "jp"
    },
    {
        name: "Jemen",
        code: "ye"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Ji\u017En\xed Korea",
        code: "kr"
    },
    {
        name: "Ji\u017En\xed S\xfad\xe1n",
        code: "ss"
    },
    {
        name: "Jord\xe1nsko",
        code: "jo"
    },
    {
        name: "Kajmansk\xe9 ostrovy",
        code: "ky"
    },
    {
        name: "Kambod\u017Ea",
        code: "kh"
    },
    {
        name: "Kamerun",
        code: "cm"
    },
    {
        name: "Kanada",
        code: "ca"
    },
    {
        name: "Kapverdy",
        code: "cv"
    },
    {
        name: "Katar",
        code: "qa"
    },
    {
        name: "Kazachst\xe1n",
        code: "kz"
    },
    {
        name: "Ke\u0148a",
        code: "ke"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kokosov\xe9 ostrovy",
        code: "cc"
    },
    {
        name: "Kolumbie",
        code: "co"
    },
    {
        name: "Komory",
        code: "km"
    },
    {
        name: "Kongo",
        code: "cg"
    },
    {
        name: "Kostarika",
        code: "cr"
    },
    {
        name: "Kuba",
        code: "cu"
    },
    {
        name: "Kuvajt",
        code: "kw"
    },
    {
        name: "Kypr",
        code: "cy"
    },
    {
        name: "Kyrgyzst\xe1n",
        code: "kg"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Libanon",
        code: "lb"
    },
    {
        name: "Lib\xe9rie",
        code: "lr"
    },
    {
        name: "Libye",
        code: "ly"
    },
    {
        name: "Lichten\u0161tejnsko",
        code: "li"
    },
    {
        name: "Litva",
        code: "lt"
    },
    {
        name: "Loty\u0161sko",
        code: "lv"
    },
    {
        name: "Lucembursko",
        code: "lu"
    },
    {
        name: "Macao",
        code: "mo"
    },
    {
        name: "Madagaskar",
        code: "mg"
    },
    {
        name: "Ma\u010Farsko",
        code: "hu"
    },
    {
        name: "Malajsie",
        code: "my"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Maledivy",
        code: "mv"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malta",
        code: "mt"
    },
    {
        name: "Ostrov Man",
        code: "im"
    },
    {
        name: "Maroko",
        code: "ma"
    },
    {
        name: "Marshallovy ostrovy",
        code: "mh"
    },
    {
        name: "Martinik",
        code: "mq"
    },
    {
        name: "Mauricius",
        code: "mu"
    },
    {
        name: "Maurit\xe1nie",
        code: "mr"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "Mexiko",
        code: "mx"
    },
    {
        name: "Mikron\xe9sie",
        code: "fm"
    },
    {
        name: "Moldavsko",
        code: "md"
    },
    {
        name: "Monako",
        code: "mc"
    },
    {
        name: "Mongolsko",
        code: "mn"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mosambik",
        code: "mz"
    },
    {
        name: "Myanmar",
        code: "mm"
    },
    {
        name: "Namibie",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "N\u011Bmecko",
        code: "de"
    },
    {
        name: "Nep\xe1l",
        code: "np"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nig\xe9rie",
        code: "ng"
    },
    {
        name: "Nikaragua",
        code: "ni"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "Nizozemsko",
        code: "nl"
    },
    {
        name: "Norfolk",
        code: "nf"
    },
    {
        name: "Norsko",
        code: "no"
    },
    {
        name: "Nov\xe1 Kaledonie",
        code: "nc"
    },
    {
        name: "Nov\xfd Z\xe9land",
        code: "nz"
    },
    {
        name: "Om\xe1n",
        code: "om"
    },
    {
        name: "P\xe1kist\xe1n",
        code: "pk"
    },
    {
        name: "Palau",
        code: "pw"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Papua Nov\xe1 Guinea",
        code: "pg"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Peru",
        code: "pe"
    },
    {
        name: "Pitcairnovy ostrovy",
        code: "pn"
    },
    {
        name: "Pob\u0159e\u017E\xed slonoviny",
        code: "ci"
    },
    {
        name: "Polsko",
        code: "pl"
    },
    {
        name: "Portoriko",
        code: "pr"
    },
    {
        name: "Portugalsko",
        code: "pt"
    },
    {
        name: "Rakousko",
        code: "at"
    },
    {
        name: "R\xe9union",
        code: "re"
    },
    {
        name: "Rovn\xedkov\xe1 Guinea",
        code: "gq"
    },
    {
        name: "Rumunsko",
        code: "ro"
    },
    {
        name: "Rusko",
        code: "ru"
    },
    {
        name: "Rwanda",
        code: "rw"
    },
    {
        name: "\u0158ecko",
        code: "gr"
    },
    {
        name: "Salvador",
        code: "sv"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "San Marino",
        code: "sm"
    },
    {
        name: "Sa\xfadsk\xe1 Ar\xe1bie",
        code: "sa"
    },
    {
        name: "Senegal",
        code: "sn"
    },
    {
        name: "Severn\xed Korea",
        code: "kp"
    },
    {
        name: "Severn\xed Makedonie",
        code: "mk"
    },
    {
        name: "Severn\xed Mariany",
        code: "mp"
    },
    {
        name: "Seychely",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Singapur",
        code: "sg"
    },
    {
        name: "Slovensko",
        code: "sk"
    },
    {
        name: "Slovinsko",
        code: "si"
    },
    {
        name: "Som\xe1lsko",
        code: "so"
    },
    {
        name: "Srbsko",
        code: "rs"
    },
    {
        name: "Sr\xed Lanka",
        code: "lk"
    },
    {
        name: "S\xfad\xe1n",
        code: "sd"
    },
    {
        name: "Surinam",
        code: "sr"
    },
    {
        name: "Svat\xe1 Lucie",
        code: "lc"
    },
    {
        name: "Svat\xfd Bartolom\u011Bj",
        code: "bl"
    },
    {
        name: "Svazijsko",
        code: "sz"
    },
    {
        name: "S\xfdrie",
        code: "sy"
    },
    {
        name: "\u0160alomounovy ostrovy",
        code: "sb"
    },
    {
        name: "\u0160pan\u011Blsko",
        code: "es"
    },
    {
        name: "\u0160v\xe9dsko",
        code: "se"
    },
    {
        name: "\u0160v\xfdcarsko",
        code: "ch"
    },
    {
        name: "T\xe1d\u017Eikist\xe1n",
        code: "tj"
    },
    {
        name: "Tanzanie",
        code: "tz"
    },
    {
        name: "Thajsko",
        code: "th"
    },
    {
        name: "Tchaj-wan",
        code: "tw"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinidad a Tobago",
        code: "tt"
    },
    {
        name: "Tunisko",
        code: "tn"
    },
    {
        name: "Turecko",
        code: "tr"
    },
    {
        name: "Turkmenist\xe1n",
        code: "tm"
    },
    {
        name: "Turks a Caicos",
        code: "tc"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Uganda",
        code: "ug"
    },
    {
        name: "Ukrajina",
        code: "ua"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Uzbekist\xe1n",
        code: "uz"
    },
    {
        name: "V\xe1no\u010Dn\xed ostrov",
        code: "cx"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Vatik\xe1n",
        code: "va"
    },
    {
        name: "Venezuela",
        code: "ve"
    },
    {
        name: "Vietnam",
        code: "vn"
    },
    {
        name: "V\xfdchodn\xed Timor",
        code: "tl"
    },
    {
        name: "Wallis a Futuna",
        code: "wf"
    },
    {
        name: "Zambie",
        code: "zm"
    },
    {
        name: "Z\xe1padn\xed Sahara",
        code: "eh"
    },
    {
        name: "Zimbabwe",
        code: "zw"
    }
];

});

parcelRegister("cOf3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $9535d47b321012bb$export$2e2bcd8739ae039);
var $9535d47b321012bb$export$2e2bcd8739ae039 = [
    {
        name: "Afghanistan",
        code: "af"
    },
    {
        name: "Afrique du Sud",
        code: "za"
    },
    {
        name: "\xceles \xc5land",
        code: "ax"
    },
    {
        name: "Albanie",
        code: "al"
    },
    {
        name: "Alg\xe9rie",
        code: "dz"
    },
    {
        name: "Allemagne",
        code: "de"
    },
    {
        name: "Andorre",
        code: "ad"
    },
    {
        name: "Angola",
        code: "ao"
    },
    {
        name: "Anguilla",
        code: "ai"
    },
    {
        name: "Antarctique",
        code: "aq"
    },
    {
        name: "Antigua-et-Barbuda",
        code: "ag"
    },
    {
        name: "Arabie saoudite",
        code: "sa"
    },
    {
        name: "Argentine",
        code: "ar"
    },
    {
        name: "Arm\xe9nie",
        code: "am"
    },
    {
        name: "Aruba",
        code: "aw"
    },
    {
        name: "Australie",
        code: "au"
    },
    {
        name: "Autriche",
        code: "at"
    },
    {
        name: "Azerba\xefdjan",
        code: "az"
    },
    {
        name: "Bahamas",
        code: "bs"
    },
    {
        name: "Bahre\xefn",
        code: "bh"
    },
    {
        name: "Bangladesh",
        code: "bd"
    },
    {
        name: "Barbade",
        code: "bb"
    },
    {
        name: "Bi\xe9lorussie",
        code: "by"
    },
    {
        name: "Belgique",
        code: "be"
    },
    {
        name: "Belize",
        code: "bz"
    },
    {
        name: "B\xe9nin",
        code: "bj"
    },
    {
        name: "Bermudes",
        code: "bm"
    },
    {
        name: "Bhoutan",
        code: "bt"
    },
    {
        name: "Bolivie",
        code: "bo"
    },
    {
        name: "Pays-Bas carib\xe9ens",
        code: "bq"
    },
    {
        name: "Bosnie-Herz\xe9govine",
        code: "ba"
    },
    {
        name: "Botswana",
        code: "bw"
    },
    {
        name: "\xcele Bouvet",
        code: "bv"
    },
    {
        name: "Br\xe9sil",
        code: "br"
    },
    {
        name: "Brunei",
        code: "bn"
    },
    {
        name: "Bulgarie",
        code: "bg"
    },
    {
        name: "Burkina Faso",
        code: "bf"
    },
    {
        name: "Burundi",
        code: "bi"
    },
    {
        name: "\xceles Ca\xefmans",
        code: "ky"
    },
    {
        name: "Cambodge",
        code: "kh"
    },
    {
        name: "Cameroun",
        code: "cm"
    },
    {
        name: "Canada",
        code: "ca"
    },
    {
        name: "Cap-Vert",
        code: "cv"
    },
    {
        name: "Chili",
        code: "cl"
    },
    {
        name: "Chine",
        code: "cn"
    },
    {
        name: "\xcele Christmas",
        code: "cx"
    },
    {
        name: "Chypre (pays)",
        code: "cy"
    },
    {
        name: "\xceles Cocos",
        code: "cc"
    },
    {
        name: "Colombie",
        code: "co"
    },
    {
        name: "Comores (pays)",
        code: "km"
    },
    {
        name: "R\xe9publique du Congo",
        code: "cg"
    },
    {
        name: "\xceles Cook",
        code: "ck"
    },
    {
        name: "Cor\xe9e du Sud",
        code: "kr"
    },
    {
        name: "Cor\xe9e du Nord",
        code: "kp"
    },
    {
        name: "Costa Rica",
        code: "cr"
    },
    {
        name: "C\xf4te d'Ivoire",
        code: "ci"
    },
    {
        name: "Croatie",
        code: "hr"
    },
    {
        name: "Cuba",
        code: "cu"
    },
    {
        name: "Cura\xe7ao",
        code: "cw"
    },
    {
        name: "Danemark",
        code: "dk"
    },
    {
        name: "Djibouti",
        code: "dj"
    },
    {
        name: "Dominique",
        code: "dm"
    },
    {
        name: "\xc9gypte",
        code: "eg"
    },
    {
        name: "Salvador",
        code: "sv"
    },
    {
        name: "\xc9mirats arabes unis",
        code: "ae"
    },
    {
        name: "\xc9quateur (pays)",
        code: "ec"
    },
    {
        name: "\xc9rythr\xe9e",
        code: "er"
    },
    {
        name: "Espagne",
        code: "es"
    },
    {
        name: "Estonie",
        code: "ee"
    },
    {
        name: "\xc9tats-Unis",
        code: "us"
    },
    {
        name: "\xc9thiopie",
        code: "et"
    },
    {
        name: "Malouines",
        code: "fk"
    },
    {
        name: "\xceles F\xe9ro\xe9",
        code: "fo"
    },
    {
        name: "Fidji",
        code: "fj"
    },
    {
        name: "Finlande",
        code: "fi"
    },
    {
        name: "France",
        code: "fr"
    },
    {
        name: "Gabon",
        code: "ga"
    },
    {
        name: "Gambie",
        code: "gm"
    },
    {
        name: "G\xe9orgie (pays)",
        code: "ge"
    },
    {
        name: "Ghana",
        code: "gh"
    },
    {
        name: "Gibraltar",
        code: "gi"
    },
    {
        name: "Gr\xe8ce",
        code: "gr"
    },
    {
        name: "Grenade (pays)",
        code: "gd"
    },
    {
        name: "Groenland",
        code: "gl"
    },
    {
        name: "Guadeloupe",
        code: "gp"
    },
    {
        name: "Guam",
        code: "gu"
    },
    {
        name: "Guatemala",
        code: "gt"
    },
    {
        name: "Guernesey",
        code: "gg"
    },
    {
        name: "Guin\xe9e",
        code: "gn"
    },
    {
        name: "Guin\xe9e-Bissau",
        code: "gw"
    },
    {
        name: "Guin\xe9e \xe9quatoriale",
        code: "gq"
    },
    {
        name: "Guyana",
        code: "gy"
    },
    {
        name: "Guyane",
        code: "gf"
    },
    {
        name: "Ha\xefti",
        code: "ht"
    },
    {
        name: "Honduras",
        code: "hn"
    },
    {
        name: "Hong Kong",
        code: "hk"
    },
    {
        name: "Hongrie",
        code: "hu"
    },
    {
        name: "\xcele de Man",
        code: "im"
    },
    {
        name: "Inde",
        code: "in"
    },
    {
        name: "Indon\xe9sie",
        code: "id"
    },
    {
        name: "Iran",
        code: "ir"
    },
    {
        name: "Irak",
        code: "iq"
    },
    {
        name: "Irlande (pays)",
        code: "ie"
    },
    {
        name: "Islande",
        code: "is"
    },
    {
        name: "Isra\xebl",
        code: "il"
    },
    {
        name: "Italie",
        code: "it"
    },
    {
        name: "Jama\xefque",
        code: "jm"
    },
    {
        name: "Japon",
        code: "jp"
    },
    {
        name: "Jersey",
        code: "je"
    },
    {
        name: "Jordanie",
        code: "jo"
    },
    {
        name: "Kazakhstan",
        code: "kz"
    },
    {
        name: "Kenya",
        code: "ke"
    },
    {
        name: "Kirghizistan",
        code: "kg"
    },
    {
        name: "Kiribati",
        code: "ki"
    },
    {
        name: "Kowe\xeft",
        code: "kw"
    },
    {
        name: "Laos",
        code: "la"
    },
    {
        name: "Lesotho",
        code: "ls"
    },
    {
        name: "Lettonie",
        code: "lv"
    },
    {
        name: "Liban",
        code: "lb"
    },
    {
        name: "Liberia",
        code: "lr"
    },
    {
        name: "Libye",
        code: "ly"
    },
    {
        name: "Liechtenstein",
        code: "li"
    },
    {
        name: "Lituanie",
        code: "lt"
    },
    {
        name: "Luxembourg (pays)",
        code: "lu"
    },
    {
        name: "Macao",
        code: "mo"
    },
    {
        name: "Mac\xe9doine du Nord",
        code: "mk"
    },
    {
        name: "Madagascar",
        code: "mg"
    },
    {
        name: "Malaisie",
        code: "my"
    },
    {
        name: "Malawi",
        code: "mw"
    },
    {
        name: "Maldives",
        code: "mv"
    },
    {
        name: "Mali",
        code: "ml"
    },
    {
        name: "Malte",
        code: "mt"
    },
    {
        name: "Maroc",
        code: "ma"
    },
    {
        name: "Martinique",
        code: "mq"
    },
    {
        name: "Maurice (pays)",
        code: "mu"
    },
    {
        name: "Mauritanie",
        code: "mr"
    },
    {
        name: "Mayotte",
        code: "yt"
    },
    {
        name: "Mexique",
        code: "mx"
    },
    {
        name: "Moldavie",
        code: "md"
    },
    {
        name: "Monaco",
        code: "mc"
    },
    {
        name: "Mongolie",
        code: "mn"
    },
    {
        name: "Mont\xe9n\xe9gro",
        code: "me"
    },
    {
        name: "Montserrat",
        code: "ms"
    },
    {
        name: "Mozambique",
        code: "mz"
    },
    {
        name: "Birmanie",
        code: "mm"
    },
    {
        name: "Namibie",
        code: "na"
    },
    {
        name: "Nauru",
        code: "nr"
    },
    {
        name: "N\xe9pal",
        code: "np"
    },
    {
        name: "Nicaragua",
        code: "ni"
    },
    {
        name: "Niger",
        code: "ne"
    },
    {
        name: "Nigeria",
        code: "ng"
    },
    {
        name: "Niue",
        code: "nu"
    },
    {
        name: "\xcele Norfolk",
        code: "nf"
    },
    {
        name: "Norv\xe8ge",
        code: "no"
    },
    {
        name: "Nouvelle-Cal\xe9donie",
        code: "nc"
    },
    {
        name: "Nouvelle-Z\xe9lande",
        code: "nz"
    },
    {
        name: "Oman",
        code: "om"
    },
    {
        name: "Ouganda",
        code: "ug"
    },
    {
        name: "Ouzb\xe9kistan",
        code: "uz"
    },
    {
        name: "Pakistan",
        code: "pk"
    },
    {
        name: "Palaos",
        code: "pw"
    },
    {
        name: "Palestine",
        code: "ps"
    },
    {
        name: "Panama",
        code: "pa"
    },
    {
        name: "Paraguay",
        code: "py"
    },
    {
        name: "Pays-Bas",
        code: "nl"
    },
    {
        name: "P\xe9rou",
        code: "pe"
    },
    {
        name: "Philippines",
        code: "ph"
    },
    {
        name: "\xceles Pitcairn",
        code: "pn"
    },
    {
        name: "Pologne",
        code: "pl"
    },
    {
        name: "Polyn\xe9sie fran\xe7aise",
        code: "pf"
    },
    {
        name: "Porto Rico",
        code: "pr"
    },
    {
        name: "Portugal",
        code: "pt"
    },
    {
        name: "Qatar",
        code: "qa"
    },
    {
        name: "La R\xe9union",
        code: "re"
    },
    {
        name: "Roumanie",
        code: "ro"
    },
    {
        name: "Royaume-Uni",
        code: "gb"
    },
    {
        name: "Russie",
        code: "ru"
    },
    {
        name: "Rwanda",
        code: "rw"
    },
    {
        name: "Saint-Barth\xe9lemy",
        code: "bl"
    },
    {
        name: "Saint-Marin",
        code: "sm"
    },
    {
        name: "Saint-Martin",
        code: "mf"
    },
    {
        name: "Saint-Martin",
        code: "sx"
    },
    {
        name: "Ascension et Tristan da Cunha",
        code: "sh"
    },
    {
        name: "Sainte-Lucie",
        code: "lc"
    },
    {
        name: "Salomon",
        code: "sb"
    },
    {
        name: "Samoa",
        code: "ws"
    },
    {
        name: "Samoa am\xe9ricaines",
        code: "as"
    },
    {
        name: "S\xe9n\xe9gal",
        code: "sn"
    },
    {
        name: "Serbie",
        code: "rs"
    },
    {
        name: "Seychelles",
        code: "sc"
    },
    {
        name: "Sierra Leone",
        code: "sl"
    },
    {
        name: "Singapour",
        code: "sg"
    },
    {
        name: "Slovaquie",
        code: "sk"
    },
    {
        name: "Slov\xe9nie",
        code: "si"
    },
    {
        name: "Somalie",
        code: "so"
    },
    {
        name: "Soudan",
        code: "sd"
    },
    {
        name: "Soudan du Sud",
        code: "ss"
    },
    {
        name: "Sri Lanka",
        code: "lk"
    },
    {
        name: "Su\xe8de",
        code: "se"
    },
    {
        name: "Suisse",
        code: "ch"
    },
    {
        name: "Suriname",
        code: "sr"
    },
    {
        name: "Eswatini",
        code: "sz"
    },
    {
        name: "Syrie",
        code: "sy"
    },
    {
        name: "Tadjikistan",
        code: "tj"
    },
    {
        name: "Tanzanie",
        code: "tz"
    },
    {
        name: "Tchad",
        code: "td"
    },
    {
        name: "Tch\xe9quie",
        code: "cz"
    },
    {
        name: "Tha\xeflande",
        code: "th"
    },
    {
        name: "Timor oriental",
        code: "tl"
    },
    {
        name: "Togo",
        code: "tg"
    },
    {
        name: "Tokelau",
        code: "tk"
    },
    {
        name: "Tonga",
        code: "to"
    },
    {
        name: "Trinit\xe9-et-Tobago",
        code: "tt"
    },
    {
        name: "Tunisie",
        code: "tn"
    },
    {
        name: "Turkm\xe9nistan",
        code: "tm"
    },
    {
        name: "Turquie",
        code: "tr"
    },
    {
        name: "Tuvalu",
        code: "tv"
    },
    {
        name: "Ukraine",
        code: "ua"
    },
    {
        name: "Uruguay",
        code: "uy"
    },
    {
        name: "Vanuatu",
        code: "vu"
    },
    {
        name: "Venezuela",
        code: "ve"
    },
    {
        name: "Vi\xeat Nam",
        code: "vn"
    },
    {
        name: "Wallis-et-Futuna",
        code: "wf"
    },
    {
        name: "Y\xe9men",
        code: "ye"
    },
    {
        name: "Zambie",
        code: "zm"
    },
    {
        name: "Zimbabwe",
        code: "zw"
    }
];

});



parcelRegister("c6vUC", function(module, exports) {

$parcel$export(module.exports, "render", () => $8cfeccb072343fc3$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $8cfeccb072343fc3$var$_hoisted_1 = {
    "uk-grid": ""
};
const $8cfeccb072343fc3$var$_hoisted_2 = {
    key: 0,
    class: "uk-width-1-3@m"
};
const $8cfeccb072343fc3$var$_hoisted_3 = {
    key: 1,
    class: "uk-width-2-3@m"
};
const $8cfeccb072343fc3$var$_hoisted_4 = {
    "uk-grid": "",
    class: "uk-form-stacked uk-grid-small"
};
const $8cfeccb072343fc3$var$_hoisted_5 = {
    class: "uk-form-label"
};
const $8cfeccb072343fc3$var$_hoisted_6 = {
    class: "uk-form-controls"
};
function $8cfeccb072343fc3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8cfeccb072343fc3$var$_hoisted_1, [
        _ctx.personData.firstname ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8cfeccb072343fc3$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.$t("Empf\xe4nger")), 1),
            (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.personData.firstname.value) + " " + (0, $X5A94.toDisplayString)(_ctx.personData.lastname.value), 1),
            _cache[0] || (_cache[0] = (0, $ani5R.createElementVNode)("br", null, null, -1)),
            (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.personData.address.value), 1),
            _cache[1] || (_cache[1] = (0, $ani5R.createElementVNode)("br", null, null, -1)),
            (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.personData.zip.value) + " " + (0, $X5A94.toDisplayString)(_ctx.personData.city.value), 1),
            _cache[2] || (_cache[2] = (0, $ani5R.createElementVNode)("br", null, null, -1)),
            (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)($options.getCountryName(_ctx.personData.country.value)), 1)
        ])) : (0, $ani5R.createCommentVNode)("", true),
        _ctx.otherFields.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $8cfeccb072343fc3$var$_hoisted_3, [
            (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.$t('Weitere Angaben')), 1),
            (0, $ani5R.createElementVNode)("div", $8cfeccb072343fc3$var$_hoisted_4, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.otherFields, (field)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
                        (0, $ani5R.createElementVNode)("label", $8cfeccb072343fc3$var$_hoisted_5, (0, $X5A94.toDisplayString)(_ctx.$t(field.label)), 1),
                        (0, $ani5R.createElementVNode)("div", $8cfeccb072343fc3$var$_hoisted_6, (0, $X5A94.toDisplayString)(field.type === "country" ? $options.getCountryName(field.value) : field.value), 1)
                    ]);
                }), 256))
            ])
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("hki2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d24cb24d664b7f$export$2e2bcd8739ae039);
let $c9d24cb24d664b7f$var$NOOP = ()=>{};
var $c9d24cb24d664b7f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("23rBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f1476c37d5115f$export$2e2bcd8739ae039);
let $17f1476c37d5115f$var$script;



let $17f1476c37d5115f$var$initialize = ()=>{
    $17f1476c37d5115f$var$script = (parcelRequire("kJWse"));
    if ($17f1476c37d5115f$var$script.__esModule) $17f1476c37d5115f$var$script = $17f1476c37d5115f$var$script.default;
    $17f1476c37d5115f$var$script.render = (parcelRequire("kZfdt")).render;
    (parcelRequire("fApg5")).default($17f1476c37d5115f$var$script);
    $17f1476c37d5115f$var$script.__scopeId = 'data-v-68bbfc';
    $17f1476c37d5115f$var$script.__file = "SummaryCart.vue";
};
$17f1476c37d5115f$var$initialize();
var $17f1476c37d5115f$export$2e2bcd8739ae039 = $17f1476c37d5115f$var$script;

});
parcelRegister("kJWse", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f1955a68929e1865$export$2e2bcd8739ae039);

var $bzXEj = parcelRequire("bzXEj");

var $6oQp6 = parcelRequire("6oQp6");
const $f1955a68929e1865$var$formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
var $f1955a68929e1865$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'settings'
    ],
    components: {},
    data: ()=>{
        return {
            selection: {},
            paymentTypes: (/*@__PURE__*/$parcel$interopDefault($bzXEj))
        };
    },
    mounted () {
        this.selection = this.store.state.selection;
        this.paymentTypes = (0, (/*@__PURE__*/$parcel$interopDefault($bzXEj)));
    },
    computed: {
        sumTaxes () {
            let tax = 0;
            Object.keys(this.selection).forEach((id)=>{
                const cartItem = this.selection[id];
                tax += parseFloat(this.taxCalculate(cartItem));
            });
            return tax;
        },
        couponRelative () {
            return this.store.state.couponType == 'relative';
        }
    },
    methods: {
        taxCalculate (cartItem) {
            const price = this.discountedPrice(cartItem);
            return (price - price / (cartItem.ticket.tax + 1)).toFixed(2);
        },
        // Gross price the customer actually pays for this line item, after coupon.
        // VAT must be derived from this, not the list price, otherwise the
        // "included VAT" stays at the full-price amount while the total is discounted.
        discountedPrice (cartItem) {
            const price = cartItem.amount * cartItem.ticket.price;
            const offers = this.store.state.couponOffers;
            const applies = offers.length === 0 || offers.includes(cartItem.ticket.id);
            if (!this.store.state.couponDiscount || !applies) return price;
            if (this.couponRelative) return price - Math.min(price, price * this.store.state.couponValue / 100);
            // Absolute coupon: distribute the total discount across all applicable
            // line items proportionally to their gross price.
            let applicableTotal = 0;
            Object.keys(this.selection).forEach((id)=>{
                const item = this.selection[id];
                if (offers.length === 0 || offers.includes(item.ticket.id)) applicableTotal += item.amount * item.ticket.price;
            });
            if (applicableTotal <= 0) return price;
            return price - this.store.state.couponDiscount * (price / applicableTotal);
        },
        getPrice (selectionTicketId) {
            const amount = this.selection[selectionTicketId].amount;
            return this.selection[selectionTicketId].ticket.price * amount;
        },
        getOptionName (cartItem) {
            for(let i in cartItem.ticket.options){
                if (cartItem.ticket.options[i].id == cartItem.option) return cartItem.ticket.options[i].name;
            }
        }
    }
};

});

parcelRegister("kZfdt", function(module, exports) {

$parcel$export(module.exports, "render", () => $f4754eca62ae6249$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $f4754eca62ae6249$var$_hoisted_1 = {
    class: "uk-margin uk-overflow-auto"
};
const $f4754eca62ae6249$var$_hoisted_2 = {
    class: "uk-margin-remove"
};
const $f4754eca62ae6249$var$_hoisted_3 = {
    class: "uk-table-striped uk-table uk-margin-remove-top cart-table"
};
const $f4754eca62ae6249$var$_hoisted_4 = {
    class: "uk-text-bold"
};
const $f4754eca62ae6249$var$_hoisted_5 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_6 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_7 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_8 = {
    key: 0
};
const $f4754eca62ae6249$var$_hoisted_9 = {
    key: 1,
    class: "uk-flex uk-text-small summary-included-products"
};
const $f4754eca62ae6249$var$_hoisted_10 = {
    class: "uk-text-right uk-padding-small uk-padding-remove-vertical uk-text-bolder"
};
const $f4754eca62ae6249$var$_hoisted_11 = {
    class: "uk-padding-remove uk-text-bolder"
};
const $f4754eca62ae6249$var$_hoisted_12 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_13 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_14 = {
    class: "uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_15 = {
    key: 0
};
const $f4754eca62ae6249$var$_hoisted_16 = {
    class: "uk-text-right uk-text-bolder",
    colspan: "4"
};
const $f4754eca62ae6249$var$_hoisted_17 = {
    key: 0
};
const $f4754eca62ae6249$var$_hoisted_18 = {
    key: 1,
    class: "uk-display-block"
};
const $f4754eca62ae6249$var$_hoisted_19 = {
    class: "uk-text-bolder uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_20 = {
    key: 1
};
const $f4754eca62ae6249$var$_hoisted_21 = {
    class: "uk-text-right uk-text-bolder",
    colspan: "4"
};
const $f4754eca62ae6249$var$_hoisted_22 = {
    class: "uk-text-bolder uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_23 = {
    key: 0
};
const $f4754eca62ae6249$var$_hoisted_24 = {
    class: "uk-text-right uk-text-bolder",
    colspan: "4"
};
const $f4754eca62ae6249$var$_hoisted_25 = {
    class: "uk-text-bolder uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_26 = {
    class: "uk-text-right uk-text-bolder",
    colspan: "4"
};
const $f4754eca62ae6249$var$_hoisted_27 = {
    class: "uk-text-bolder uk-text-right"
};
const $f4754eca62ae6249$var$_hoisted_28 = {
    class: "uk-text-right uk-text-bolder uk-text-large",
    colspan: "4"
};
const $f4754eca62ae6249$var$_hoisted_29 = {
    class: "uk-text-bolder uk-text-large uk-text-right uk-text-nowrap"
};
function $f4754eca62ae6249$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f4754eca62ae6249$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("h3", $f4754eca62ae6249$var$_hoisted_2, (0, $X5A94.toDisplayString)(_ctx.$t("Einkaufsliste")), 1),
        (0, $ani5R.createElementVNode)("table", $f4754eca62ae6249$var$_hoisted_3, [
            (0, $ani5R.createElementVNode)("thead", $f4754eca62ae6249$var$_hoisted_4, [
                (0, $ani5R.createElementVNode)("tr", null, [
                    (0, $ani5R.createElementVNode)("td", null, (0, $X5A94.toDisplayString)(_ctx.$t("Anzahl")), 1),
                    (0, $ani5R.createElementVNode)("td", null, (0, $X5A94.toDisplayString)(_ctx.$t("Art")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_5, (0, $X5A94.toDisplayString)(_ctx.$t("Preis")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_6, (0, $X5A94.toDisplayString)(_ctx.$t("Enthaltene MwSt.")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_7, (0, $X5A94.toDisplayString)(_ctx.$t("Total")), 1)
                ])
            ]),
            (0, $ani5R.createElementVNode)("tbody", null, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.selection, (cartItem, ticketId)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", {
                        key: ticketId
                    }, [
                        (0, $ani5R.createElementVNode)("td", null, (0, $X5A94.toDisplayString)(cartItem.amount), 1),
                        (0, $ani5R.createElementVNode)("td", null, [
                            (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(cartItem.ticket.name), 1),
                            cartItem.option ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $f4754eca62ae6249$var$_hoisted_8, " (" + (0, $X5A94.toDisplayString)($options.getOptionName(cartItem)) + ")", 1)) : (0, $ani5R.createCommentVNode)("", true),
                            cartItem.ticket.included_products.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $f4754eca62ae6249$var$_hoisted_9, [
                                (0, $ani5R.createElementVNode)("span", null, (0, $X5A94.toDisplayString)(_ctx.$t('Beinhaltet')) + ":", 1),
                                (0, $ani5R.createElementVNode)("table", null, [
                                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(cartItem.ticket.included_products, (product)=>{
                                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", null, [
                                            (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_10, (0, $X5A94.toDisplayString)(cartItem.amount > 1 ? cartItem.amount + ' x ' : '') + (0, $X5A94.toDisplayString)(_ctx.$filters.currency(product.attributes.price)), 1),
                                            (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_11, (0, $X5A94.toDisplayString)(product.attributes.title), 1)
                                        ]);
                                    }), 256))
                                ])
                            ])) : (0, $ani5R.createCommentVNode)("", true)
                        ]),
                        (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_12, (0, $X5A94.toDisplayString)(_ctx.$filters.currency(cartItem.ticket.price)), 1),
                        (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_13, (0, $X5A94.toDisplayString)(_ctx.$filters.currency($options.taxCalculate(cartItem))), 1),
                        (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_14, (0, $X5A94.toDisplayString)(_ctx.$filters.currency($options.getPrice(ticketId))), 1)
                    ]);
                }), 128)),
                _ctx.store.state.couponDiscount ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", $f4754eca62ae6249$var$_hoisted_15, [
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_16, [
                        (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(this.$t('Gutschein')) + " \"" + (0, $X5A94.toDisplayString)(_ctx.store.state.couponCode) + "\" ", 1),
                        $options.couponRelative ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $f4754eca62ae6249$var$_hoisted_17, "(" + (0, $X5A94.toDisplayString)(_ctx.store.state.couponValue) + "%)", 1)) : (0, $ani5R.createCommentVNode)("", true),
                        _ctx.store.state.couponOffers.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("small", $f4754eca62ae6249$var$_hoisted_18, (0, $X5A94.toDisplayString)(_ctx.$t("Gutschein gilt nur f\xfcr bestimmte Produkte")), 1)) : (0, $ani5R.createCommentVNode)("", true)
                    ]),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_19, " -" + (0, $X5A94.toDisplayString)(_ctx.$filters.currency(_ctx.store.state.couponDiscount)), 1)
                ])) : (0, $ani5R.createCommentVNode)("", true),
                _ctx.store.state.donationSwitch && parseInt(_ctx.store.state.donationAmount) ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", $f4754eca62ae6249$var$_hoisted_20, [
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_21, (0, $X5A94.toDisplayString)(this.$t('Spende')), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_22, (0, $X5A94.toDisplayString)(_ctx.$filters.currency(parseInt(_ctx.store.state.donationAmount))), 1)
                ])) : (0, $ani5R.createCommentVNode)("", true)
            ]),
            (0, $ani5R.createElementVNode)("tfoot", null, [
                _ctx.store.state.paymentType && _ctx.paymentTypes[_ctx.store.state.paymentType].checkoutLabel.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", $f4754eca62ae6249$var$_hoisted_23, [
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_24, (0, $X5A94.toDisplayString)(_ctx.$t("Zahlungsweise")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_25, (0, $X5A94.toDisplayString)(_ctx.$t(_ctx.paymentTypes[_ctx.store.state.paymentType].checkoutLabel)), 1)
                ])) : (0, $ani5R.createCommentVNode)("", true),
                (0, $ani5R.createElementVNode)("tr", null, [
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_26, (0, $X5A94.toDisplayString)(_ctx.$t("Enthaltene MwSt.")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_27, (0, $X5A94.toDisplayString)(_ctx.$filters.currency($options.sumTaxes)), 1)
                ]),
                (0, $ani5R.createElementVNode)("tr", null, [
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_28, (0, $X5A94.toDisplayString)(_ctx.$t("Gesamt")), 1),
                    (0, $ani5R.createElementVNode)("td", $f4754eca62ae6249$var$_hoisted_29, (0, $X5A94.toDisplayString)(_ctx.$filters.currency(_ctx.store.state.total)), 1)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("fApg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58dcfa1eff1636d$export$2e2bcd8739ae039);
let $b58dcfa1eff1636d$var$NOOP = ()=>{};
var $b58dcfa1eff1636d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("19kqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d667995641b089e$export$2e2bcd8739ae039);
let $0d667995641b089e$var$script;



let $0d667995641b089e$var$initialize = ()=>{
    $0d667995641b089e$var$script = (parcelRequire("dlyqz"));
    if ($0d667995641b089e$var$script.__esModule) $0d667995641b089e$var$script = $0d667995641b089e$var$script.default;
    $0d667995641b089e$var$script.render = (parcelRequire("48Z4m")).render;
    (parcelRequire("aYdWd")).default($0d667995641b089e$var$script);
    $0d667995641b089e$var$script.__scopeId = 'data-v-66f6f1';
    $0d667995641b089e$var$script.__file = "SummaryPayment.vue";
};
$0d667995641b089e$var$initialize();
var $0d667995641b089e$export$2e2bcd8739ae039 = $0d667995641b089e$var$script;

});
parcelRegister("dlyqz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9b77f1209572ceb0$export$2e2bcd8739ae039);

var $jdsL7 = parcelRequire("jdsL7");

var $6oQp6 = parcelRequire("6oQp6");
var $9b77f1209572ceb0$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'settings',
        'loginusername'
    ],
    components: {
        SummaryAgb: $jdsL7.default
    },
    data: ()=>{
        return {
            orderNumber: '',
            serverErrorWording: '',
            mollieRedirect: ''
        };
    },
    computed: {
        // A 0 € cart is not "kostenpflichtig" — the button must not claim a payment obligation.
        buyButtonLabel () {
            return this.store.state.total <= 0 ? 'Jetzt kostenlos bestellen' : 'Jetzt kaufen';
        },
        resellerButtonLabel () {
            if (this.store.state.tender === 'card_terminal') return 'Mit Karte kassieren';
            if (this.store.state.tender === 'cash') return 'Bar kassieren';
            if (this.store.state.tender === 'cashless') return 'Cashless kassieren';
            return 'Kassieren';
        },
        resellerButtonIcon () {
            if (this.store.state.tender === 'card_terminal') return "\uD83D\uDCB3";
            if (this.store.state.tender === 'cash') return "\uD83D\uDCB6";
            if (this.store.state.tender === 'cashless') return "\uD83E\uDE99";
            return '';
        }
    },
    mounted () {
        this.serverErrorWording = this.$t("Leider gab es Probleme bei der Verarbeitung der Bestellung. Bitte versuche es sp\xe4ter nochmal.");
    },
    methods: {
        back () {
            this.$emit("back");
        },
        getOrderInformation () {
            const orderInfo = this.store.state.personData;
            orderInfo.payment_type = this.store.state.paymentType;
            if (this.store.state.couponType) {
                orderInfo.couponCode = this.store.state.couponCode;
                orderInfo.couponDiscount = this.store.state.couponDiscount;
            }
            if (this.store.state.donationSwitch && this.store.state.donationAmount) orderInfo.donationAmount = parseInt(this.store.state.donationAmount ?? 0);
            if (this.store.state.newsletterSignup) orderInfo.newsletterSignup = this.store.state.newsletterSignup;
            if (this.store.state.ownerData.token) orderInfo.owner = this.store.state.ownerData.token;
            if (this.loginusername && this.store.state.tender) {
                orderInfo.tender = this.store.state.tender;
                if (this.store.state.tender === 'card_terminal' && this.store.state.terminalId) orderInfo.terminal_id = this.store.state.terminalId;
            }
            const orders = Object.keys(this.store.state.selection).map((ticketId)=>{
                const ticket = this.store.state.selection[ticketId];
                const position = {
                    offer_id: ticketId,
                    amount: ticket.amount,
                    option: ticket.option
                };
                // Only send contacts for actually personalized offers; persons is
                // undefined for non-personalized / no_chip tickets and php-core's
                // OrderPositionsValid rejects a non-array contacts property.
                if (Array.isArray(ticket.persons) && ticket.persons.length) position.contacts = ticket.persons;
                return position;
            });
            return {
                orderInfo: orderInfo,
                orders: orders
            };
        },
        placeOrder () {
            this.store.state.loading = true;
            this.doOctoberRequest("onPlaceOrder", this.getOrderInformation()).then((response)=>{
                if (!response.error) {
                    this.orderNumber = response.order_number;
                    document.cookie = 'festiware::form=';
                    if (typeof response.mollieRedirect !== 'undefined') {
                        this.mollieRedirect = response.mollieRedirect;
                        this.openMollieWindow();
                    } else if (response.reseller) this.$emit('reseller-success', response);
                    else window.location.href = response.redirect;
                } else UIkit.notification(Object.values(response.error.error.response)[0]);
            }).catch((error)=>{
                // backendMessage() returns the reason the backend actually gave, or null
                // when it only sent a placeholder — then our own wording is the better
                // answer. Never statusText: "Internal Server Error" explains nothing.
                const message = this.backendMessage(error) || this.serverErrorWording;
                this.emitError('server', message, (error.responseText ?? '').includes("exceeds offer"));
            }).finally(()=>{
                this.store.state.loading = false;
            });
        },
        openMollieWindow () {
            if (!this.inIframe()) window.location.href = this.mollieRedirect;
            else try {
                window.top.location.href = this.mollieRedirect;
            } catch (e) {
                window.open(this.mollieRedirect, '_blank', 'noopener');
            }
        },
        inIframe () {
            try {
                return window.self !== window.top;
            } catch (e) {
                return true;
            }
        },
        submit () {
            if (this.$refs.agb.validate()) this.placeOrder();
        },
        submitReseller () {
            // Reseller-POS: keine AGB-Validierung — der Kassierer handelt im Auftrag.
            // Tender + ggf. terminal_id sind in CheckoutPayment validiert worden.
            this.placeOrder();
        },
        submitMollie () {
            if (this.orderNumber) {
                this.openMollieWindow();
                return;
            }
            if (this.$refs.agb.validate()) this.placeOrder();
        }
    }
};

});
parcelRegister("jdsL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfd58a29d3f092ee$export$2e2bcd8739ae039);
let $dfd58a29d3f092ee$var$script;



let $dfd58a29d3f092ee$var$initialize = ()=>{
    $dfd58a29d3f092ee$var$script = (parcelRequire("aNET5"));
    if ($dfd58a29d3f092ee$var$script.__esModule) $dfd58a29d3f092ee$var$script = $dfd58a29d3f092ee$var$script.default;
    $dfd58a29d3f092ee$var$script.render = (parcelRequire("b7Eyh")).render;
    (parcelRequire("lTEp8")).default($dfd58a29d3f092ee$var$script);
    $dfd58a29d3f092ee$var$script.__scopeId = 'data-v-43ad03';
    $dfd58a29d3f092ee$var$script.__file = "SummaryAgb.vue";
};
$dfd58a29d3f092ee$var$initialize();
var $dfd58a29d3f092ee$export$2e2bcd8739ae039 = $dfd58a29d3f092ee$var$script;

});
parcelRegister("aNET5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7dce325ef620db8b$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");

var $48wMP = parcelRequire("48wMP");

var $4OLAN = parcelRequire("4OLAN");
var $7dce325ef620db8b$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'settings'
    ],
    components: {},
    data: ()=>{
        return {
            v$: (0, $48wMP.default)(),
            acceptTerms: false,
            acceptPrivacy: false
        };
    },
    validations: {
        acceptTerms: {
            sameAs: (0, $4OLAN.sameAs)(()=>true)
        },
        acceptPrivacy: {
            sameAs: (0, $4OLAN.sameAs)(()=>true)
        }
    },
    computed: {
        showAgbHint () {
            return this.v$.$dirty && this.v$.$error;
        },
        noAcceptTerms () {
            return {
                invalid: this.v$.acceptTerms.$dirty && this.v$.acceptTerms.$error
            };
        },
        noAcceptPrivacy () {
            return {
                invalid: this.v$.acceptPrivacy.$dirty && this.v$.acceptPrivacy.$error
            };
        }
    },
    mounted () {},
    methods: {
        validate () {
            this.v$.$touch();
            return !this.v$.$invalid;
        }
    }
};

});
parcelRegister("4OLAN", function(module, exports) {
"use strict";
function $3820bfce26b86932$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3820bfce26b86932$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3820bfce26b86932$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3820bfce26b86932$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "alpha", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_alpha.default;
    }
});
Object.defineProperty(module.exports, "alphaNum", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_alphaNum.default;
    }
});
Object.defineProperty(module.exports, "and", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_and.default;
    }
});
Object.defineProperty(module.exports, "between", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_between.default;
    }
});
Object.defineProperty(module.exports, "decimal", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_decimal.default;
    }
});
Object.defineProperty(module.exports, "email", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_email.default;
    }
});
module.exports.helpers = void 0;
Object.defineProperty(module.exports, "integer", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_integer.default;
    }
});
Object.defineProperty(module.exports, "ipAddress", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_ipAddress.default;
    }
});
Object.defineProperty(module.exports, "macAddress", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_macAddress.default;
    }
});
Object.defineProperty(module.exports, "maxLength", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_maxLength.default;
    }
});
Object.defineProperty(module.exports, "maxValue", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_maxValue.default;
    }
});
Object.defineProperty(module.exports, "minLength", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_minLength.default;
    }
});
Object.defineProperty(module.exports, "minValue", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_minValue.default;
    }
});
Object.defineProperty(module.exports, "not", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_not.default;
    }
});
Object.defineProperty(module.exports, "numeric", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_numeric.default;
    }
});
Object.defineProperty(module.exports, "or", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_or.default;
    }
});
Object.defineProperty(module.exports, "required", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_required.default;
    }
});
Object.defineProperty(module.exports, "requiredIf", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_requiredIf.default;
    }
});
Object.defineProperty(module.exports, "requiredUnless", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_requiredUnless.default;
    }
});
Object.defineProperty(module.exports, "sameAs", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_sameAs.default;
    }
});
Object.defineProperty(module.exports, "url", {
    enumerable: true,
    get: function get() {
        return $3820bfce26b86932$var$_url.default;
    }
});

var $3820bfce26b86932$var$_alpha = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("8iSiI")));

var $3820bfce26b86932$var$_alphaNum = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("1XicK")));

var $3820bfce26b86932$var$_numeric = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("2MPCM")));

var $3820bfce26b86932$var$_between = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("2FAuG")));

var $3820bfce26b86932$var$_email = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("i7jzQ")));

var $3820bfce26b86932$var$_ipAddress = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("020kZ")));

var $3820bfce26b86932$var$_macAddress = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("eAygl")));

var $3820bfce26b86932$var$_maxLength = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("lnU8D")));

var $3820bfce26b86932$var$_minLength = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("fzuwP")));

var $3820bfce26b86932$var$_required = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("bKn3z")));

var $3820bfce26b86932$var$_requiredIf = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("1Ny5a")));

var $3820bfce26b86932$var$_requiredUnless = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("hcvJU")));

var $3820bfce26b86932$var$_sameAs = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("96ZdT")));

var $3820bfce26b86932$var$_url = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("dYOn9")));

var $3820bfce26b86932$var$_or = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("6wI8y")));

var $3820bfce26b86932$var$_and = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("fzoRG")));

var $3820bfce26b86932$var$_not = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("bMYxy")));

var $3820bfce26b86932$var$_minValue = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("l7XKs")));

var $3820bfce26b86932$var$_maxValue = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("anKbK")));

var $3820bfce26b86932$var$_integer = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("6apY9")));

var $3820bfce26b86932$var$_decimal = $3820bfce26b86932$var$_interopRequireDefault((parcelRequire("4l0yj")));

var $3820bfce26b86932$var$helpers = $3820bfce26b86932$var$_interopRequireWildcard((parcelRequire("dwUBd")));
module.exports.helpers = $3820bfce26b86932$var$helpers;
function $3820bfce26b86932$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3820bfce26b86932$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3820bfce26b86932$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $3820bfce26b86932$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3820bfce26b86932$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3820bfce26b86932$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("8iSiI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $60ba2030aff20570$var$_default = (0, $dwUBd.regex)('alpha', /^[a-zA-Z]*$/);
module.exports.default = $60ba2030aff20570$var$_default;

});
parcelRegister("dwUBd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.req = module.exports.regex = module.exports.ref = module.exports.len = void 0;
Object.defineProperty(module.exports, "withParams", {
    enumerable: true,
    get: function get() {
        return $9d9a2aefb58ce283$var$_withParams.default;
    }
});

var $9d9a2aefb58ce283$var$_withParams = $9d9a2aefb58ce283$var$_interopRequireDefault((parcelRequire("d80GS")));
function $9d9a2aefb58ce283$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9d9a2aefb58ce283$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9d9a2aefb58ce283$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9d9a2aefb58ce283$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9d9a2aefb58ce283$var$_typeof(obj);
}
var $9d9a2aefb58ce283$var$req = function req(value) {
    if (Array.isArray(value)) return !!value.length;
    if (value === undefined || value === null) return false;
    if (value === false) return true;
    if (value instanceof Date) return !isNaN(value.getTime());
    if ($9d9a2aefb58ce283$var$_typeof(value) === 'object') {
        for(var _ in value)return true;
        return false;
    }
    return !!String(value).length;
};
module.exports.req = $9d9a2aefb58ce283$var$req;
var $9d9a2aefb58ce283$var$len = function len(value) {
    if (Array.isArray(value)) return value.length;
    if ($9d9a2aefb58ce283$var$_typeof(value) === 'object') return Object.keys(value).length;
    return String(value).length;
};
module.exports.len = $9d9a2aefb58ce283$var$len;
var $9d9a2aefb58ce283$var$ref = function ref(reference, vm, parentVm) {
    return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};
module.exports.ref = $9d9a2aefb58ce283$var$ref;
var $9d9a2aefb58ce283$var$regex = function regex(type, expr) {
    return (0, $9d9a2aefb58ce283$var$_withParams.default)({
        type: type
    }, function(value) {
        return !$9d9a2aefb58ce283$var$req(value) || expr.test(value);
    });
};
module.exports.regex = $9d9a2aefb58ce283$var$regex;

});
parcelRegister("d80GS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98ec8edd3bda2d16$var$withParams = (0, (parcelRequire("1qwpp")).withParams);
var $98ec8edd3bda2d16$var$_default = $98ec8edd3bda2d16$var$withParams;
module.exports.default = $98ec8edd3bda2d16$var$_default;

});
parcelRegister("1qwpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setTarget = void 0;
module.exports.popParams = $10a15bdc8f307fae$var$popParams;
module.exports.pushParams = $10a15bdc8f307fae$var$pushParams;
module.exports.target = void 0;
module.exports.withParams = $10a15bdc8f307fae$var$withParams;
function $10a15bdc8f307fae$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $10a15bdc8f307fae$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $10a15bdc8f307fae$var$ownKeys(Object(source), true).forEach(function(key) {
            $10a15bdc8f307fae$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $10a15bdc8f307fae$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $10a15bdc8f307fae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $10a15bdc8f307fae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $10a15bdc8f307fae$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $10a15bdc8f307fae$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $10a15bdc8f307fae$var$_typeof(obj);
}
var $10a15bdc8f307fae$var$stack = [];
var $10a15bdc8f307fae$var$target = null;
module.exports.target = $10a15bdc8f307fae$var$target;
var $10a15bdc8f307fae$var$_setTarget = function _setTarget(x) {
    module.exports.target = $10a15bdc8f307fae$var$target = x;
};
module.exports._setTarget = $10a15bdc8f307fae$var$_setTarget;
function $10a15bdc8f307fae$var$pushParams() {
    if ($10a15bdc8f307fae$var$target !== null) $10a15bdc8f307fae$var$stack.push($10a15bdc8f307fae$var$target);
    module.exports.target = $10a15bdc8f307fae$var$target = {};
}
function $10a15bdc8f307fae$var$popParams() {
    var lastTarget = $10a15bdc8f307fae$var$target;
    var newTarget = module.exports.target = $10a15bdc8f307fae$var$target = $10a15bdc8f307fae$var$stack.pop() || null;
    if (newTarget) {
        if (!Array.isArray(newTarget.$sub)) newTarget.$sub = [];
        newTarget.$sub.push(lastTarget);
    }
    return lastTarget;
}
function $10a15bdc8f307fae$var$addParams(params) {
    if ($10a15bdc8f307fae$var$_typeof(params) === 'object' && !Array.isArray(params)) module.exports.target = $10a15bdc8f307fae$var$target = $10a15bdc8f307fae$var$_objectSpread($10a15bdc8f307fae$var$_objectSpread({}, $10a15bdc8f307fae$var$target), params);
    else throw new Error('params must be an object');
}
function $10a15bdc8f307fae$var$withParamsDirect(params, validator) {
    return $10a15bdc8f307fae$var$withParamsClosure(function(add) {
        return function() {
            add(params);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return validator.apply(this, args);
        };
    });
}
function $10a15bdc8f307fae$var$withParamsClosure(closure) {
    var validator = closure($10a15bdc8f307fae$var$addParams);
    return function() {
        $10a15bdc8f307fae$var$pushParams();
        try {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return validator.apply(this, args);
        } finally{
            $10a15bdc8f307fae$var$popParams();
        }
    };
}
function $10a15bdc8f307fae$var$withParams(paramsOrClosure, maybeValidator) {
    if ($10a15bdc8f307fae$var$_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) return $10a15bdc8f307fae$var$withParamsDirect(paramsOrClosure, maybeValidator);
    return $10a15bdc8f307fae$var$withParamsClosure(paramsOrClosure);
}

});




parcelRegister("1XicK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $16c96c329f801a4c$var$_default = (0, $dwUBd.regex)('alphaNum', /^[a-zA-Z0-9]*$/);
module.exports.default = $16c96c329f801a4c$var$_default;

});

parcelRegister("2MPCM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $20781c0489b85cd2$var$_default = (0, $dwUBd.regex)('numeric', /^[0-9]*$/);
module.exports.default = $20781c0489b85cd2$var$_default;

});

parcelRegister("2FAuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $1f1bb80bee2306f8$var$_default = function _default(min, max) {
    return (0, $dwUBd.withParams)({
        type: 'between',
        min: min,
        max: max
    }, function(value) {
        return !(0, $dwUBd.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
    });
};
module.exports.default = $1f1bb80bee2306f8$var$_default;

});

parcelRegister("i7jzQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $d3081110c9382f86$var$emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var $d3081110c9382f86$var$_default = (0, $dwUBd.regex)('email', $d3081110c9382f86$var$emailRegex);
module.exports.default = $d3081110c9382f86$var$_default;

});

parcelRegister("020kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $00607307a5b247eb$var$_default = (0, $dwUBd.withParams)({
    type: 'ipAddress'
}, function(value) {
    if (!(0, $dwUBd.req)(value)) return true;
    if (typeof value !== 'string') return false;
    var nibbles = value.split('.');
    return nibbles.length === 4 && nibbles.every($00607307a5b247eb$var$nibbleValid);
});
module.exports.default = $00607307a5b247eb$var$_default;
var $00607307a5b247eb$var$nibbleValid = function nibbleValid(nibble) {
    if (nibble.length > 3 || nibble.length === 0) return false;
    if (nibble[0] === '0' && nibble !== '0') return false;
    if (!nibble.match(/^\d+$/)) return false;
    var numeric = +nibble | 0;
    return numeric >= 0 && numeric <= 255;
};

});

parcelRegister("eAygl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $a9ef0152a3f84fd9$var$_default = function _default() {
    var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
    return (0, $dwUBd.withParams)({
        type: 'macAddress'
    }, function(value) {
        if (!(0, $dwUBd.req)(value)) return true;
        if (typeof value !== 'string') return false;
        var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
        return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every($a9ef0152a3f84fd9$var$hexValid);
    });
};
module.exports.default = $a9ef0152a3f84fd9$var$_default;
var $a9ef0152a3f84fd9$var$hexValid = function hexValid(hex) {
    return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

});

parcelRegister("lnU8D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $f9174adcc9b10bd9$var$_default = function _default(length) {
    return (0, $dwUBd.withParams)({
        type: 'maxLength',
        max: length
    }, function(value) {
        return !(0, $dwUBd.req)(value) || (0, $dwUBd.len)(value) <= length;
    });
};
module.exports.default = $f9174adcc9b10bd9$var$_default;

});

parcelRegister("fzuwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $b561ce3c44c4a817$var$_default = function _default(length) {
    return (0, $dwUBd.withParams)({
        type: 'minLength',
        min: length
    }, function(value) {
        return !(0, $dwUBd.req)(value) || (0, $dwUBd.len)(value) >= length;
    });
};
module.exports.default = $b561ce3c44c4a817$var$_default;

});

parcelRegister("bKn3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $88d5e02571bca9cb$var$_default = (0, $dwUBd.withParams)({
    type: 'required'
}, function(value) {
    if (typeof value === 'string') return (0, $dwUBd.req)(value.trim());
    return (0, $dwUBd.req)(value);
});
module.exports.default = $88d5e02571bca9cb$var$_default;

});

parcelRegister("1Ny5a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $14f4ce14d2e1eaaf$var$_default = function _default(prop) {
    return (0, $dwUBd.withParams)({
        type: 'requiredIf',
        prop: prop
    }, function(value, parentVm) {
        return (0, $dwUBd.ref)(prop, this, parentVm) ? (0, $dwUBd.req)(value) : true;
    });
};
module.exports.default = $14f4ce14d2e1eaaf$var$_default;

});

parcelRegister("hcvJU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $c85c2d75f9ed783b$var$_default = function _default(prop) {
    return (0, $dwUBd.withParams)({
        type: 'requiredUnless',
        prop: prop
    }, function(value, parentVm) {
        return !(0, $dwUBd.ref)(prop, this, parentVm) ? (0, $dwUBd.req)(value) : true;
    });
};
module.exports.default = $c85c2d75f9ed783b$var$_default;

});

parcelRegister("96ZdT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $6a242a33541821e4$var$_default = function _default(equalTo) {
    return (0, $dwUBd.withParams)({
        type: 'sameAs',
        eq: equalTo
    }, function(value, parentVm) {
        return value === (0, $dwUBd.ref)(equalTo, this, parentVm);
    });
};
module.exports.default = $6a242a33541821e4$var$_default;

});

parcelRegister("dYOn9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $a2d7f3df2964d5ae$var$urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
var $a2d7f3df2964d5ae$var$_default = (0, $dwUBd.regex)('url', $a2d7f3df2964d5ae$var$urlRegex);
module.exports.default = $a2d7f3df2964d5ae$var$_default;

});

parcelRegister("6wI8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $4c07f7ec93e7246f$var$_default = function _default() {
    for(var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    return (0, $dwUBd.withParams)({
        type: 'or'
    }, function() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return validators.length > 0 && validators.reduce(function(valid, fn) {
            return valid || fn.apply(_this, args);
        }, false);
    });
};
module.exports.default = $4c07f7ec93e7246f$var$_default;

});

parcelRegister("fzoRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $b55d6990f442dbd3$var$_default = function _default() {
    for(var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    return (0, $dwUBd.withParams)({
        type: 'and'
    }, function() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return validators.length > 0 && validators.reduce(function(valid, fn) {
            return valid && fn.apply(_this, args);
        }, true);
    });
};
module.exports.default = $b55d6990f442dbd3$var$_default;

});

parcelRegister("bMYxy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $89532369b5bb28bd$var$_default = function _default(validator) {
    return (0, $dwUBd.withParams)({
        type: 'not'
    }, function(value, vm) {
        return !(0, $dwUBd.req)(value) || !validator.call(this, value, vm);
    });
};
module.exports.default = $89532369b5bb28bd$var$_default;

});

parcelRegister("l7XKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $03f82380d639de42$var$_default = function _default(min) {
    return (0, $dwUBd.withParams)({
        type: 'minValue',
        min: min
    }, function(value) {
        return !(0, $dwUBd.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
    });
};
module.exports.default = $03f82380d639de42$var$_default;

});

parcelRegister("anKbK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $78efe16beff6356a$var$_default = function _default(max) {
    return (0, $dwUBd.withParams)({
        type: 'maxValue',
        max: max
    }, function(value) {
        return !(0, $dwUBd.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
    });
};
module.exports.default = $78efe16beff6356a$var$_default;

});

parcelRegister("6apY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $47d7d229b41870eb$var$_default = (0, $dwUBd.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);
module.exports.default = $47d7d229b41870eb$var$_default;

});

parcelRegister("4l0yj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dwUBd = parcelRequire("dwUBd");
var $32898d460f9df62a$var$_default = (0, $dwUBd.regex)('decimal', /^[-]?\d*(\.\d+)?$/);
module.exports.default = $32898d460f9df62a$var$_default;

});



parcelRegister("b7Eyh", function(module, exports) {

$parcel$export(module.exports, "render", () => $818fcde5a41870f1$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
const $818fcde5a41870f1$var$_hoisted_1 = {
    class: "uk-flex uk-flex-column uk-margin-large-top uk-margin-medium-bottom"
};
const $818fcde5a41870f1$var$_hoisted_2 = {
    for: "agb"
};
const $818fcde5a41870f1$var$_hoisted_3 = [
    "href"
];
const $818fcde5a41870f1$var$_hoisted_4 = {
    for: "datenschutz"
};
const $818fcde5a41870f1$var$_hoisted_5 = [
    "href"
];
const $818fcde5a41870f1$var$_hoisted_6 = {
    key: 0,
    class: "alert-AGB"
};
function $818fcde5a41870f1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        (0, $ani5R.createElementVNode)("div", $818fcde5a41870f1$var$_hoisted_1, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)($options.noAcceptTerms)
            }, [
                (0, $ani5R.createElementVNode)("label", $818fcde5a41870f1$var$_hoisted_2, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        class: "uk-checkbox",
                        type: "checkbox",
                        value: "acceptTerms",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.acceptTerms = $event),
                        id: "agb"
                    }, null, 512), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            _ctx.acceptTerms
                        ]
                    ]),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t("Ich habe die")) + " ", 1),
                    (0, $ani5R.createElementVNode)("a", {
                        href: $props.settings.custom_terms_url,
                        class: "uk-link-muted uk-text-danger",
                        target: "_blank"
                    }, (0, $X5A94.toDisplayString)(_ctx.$t("AGB")), 9, $818fcde5a41870f1$var$_hoisted_3),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t("gelesen und akzeptiert.")), 1)
                ])
            ], 2),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)($options.noAcceptPrivacy)
            }, [
                (0, $ani5R.createElementVNode)("label", $818fcde5a41870f1$var$_hoisted_4, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        class: "uk-checkbox",
                        type: "checkbox",
                        value: "acceptPrivacy",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.acceptPrivacy = $event),
                        id: "datenschutz"
                    }, null, 512), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            _ctx.acceptPrivacy
                        ]
                    ]),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t("Ich habe die")) + " ", 1),
                    (0, $ani5R.createElementVNode)("a", {
                        class: "uk-link-muted uk-text-danger",
                        href: $props.settings.linkToPrivacy,
                        target: "_blank"
                    }, (0, $X5A94.toDisplayString)(_ctx.$t("Datenschutzerkl\xe4rung")), 9, $818fcde5a41870f1$var$_hoisted_5),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t("gelesen und akzeptiert.")), 1)
                ])
            ], 2),
            $options.showAgbHint ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $818fcde5a41870f1$var$_hoisted_6, (0, $X5A94.toDisplayString)(_ctx.$t("Bitte \xfcberpr\xfcfe die AGBs")), 1)) : (0, $ani5R.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("lTEp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0e137f99aa2fae$export$2e2bcd8739ae039);
let $ff0e137f99aa2fae$var$NOOP = ()=>{};
var $ff0e137f99aa2fae$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("48Z4m", function(module, exports) {

$parcel$export(module.exports, "render", () => $304747e65023f65e$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $304747e65023f65e$var$_hoisted_1 = {
    class: "summary-payment"
};
const $304747e65023f65e$var$_hoisted_2 = {
    class: "uk-margin-medium-top uk-flex uk-flex-right"
};
const $304747e65023f65e$var$_hoisted_3 = {
    class: "uk-margin-small-right"
};
const $304747e65023f65e$var$_hoisted_4 = {
    key: 3
};
function $304747e65023f65e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_summary_agb = (0, $ani5R.resolveComponent)("summary-agb");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $304747e65023f65e$var$_hoisted_1, [
        !_ctx.orderNumber && !$props.loginusername ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_summary_agb, {
            key: 0,
            settings: $props.settings,
            ref: "agb"
        }, null, 8, [
            "settings"
        ])) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.createElementVNode)("div", $304747e65023f65e$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("div", null, [
                !_ctx.orderNumber ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                    key: 0,
                    class: "uk-button uk-button-default uk-margin-small-right",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.back && $options.back(...args))
                }, (0, $X5A94.toDisplayString)(_ctx.$t("Zur\xfcck")), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ]),
            (0, $ani5R.createElementVNode)("div", null, [
                !_ctx.orderNumber && $props.loginusername ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.submitReseller && $options.submitReseller(...args)),
                    class: "uk-button uk-button-primary submitbtn",
                    type: "button"
                }, [
                    (0, $ani5R.createElementVNode)("span", $304747e65023f65e$var$_hoisted_3, (0, $X5A94.toDisplayString)($options.resellerButtonIcon), 1),
                    (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.$t($options.resellerButtonLabel)), 1)
                ])) : !_ctx.orderNumber && (_ctx.store.state.paymentType == 'bank' || _ctx.store.state.paymentType == 'directsale' || _ctx.store.state.total == 0) ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = (...args)=>$options.submit && $options.submit(...args)),
                    class: "uk-button uk-button-primary submitbtn",
                    type: "button"
                }, (0, $X5A94.toDisplayString)(_ctx.$t($options.buyButtonLabel)), 1)) : _ctx.store.state.paymentType === 'mollie' && _ctx.store.state.total > 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                    key: 2,
                    class: "uk-button uk-button-primary submitbtn",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = (...args)=>$options.submitMollie && $options.submitMollie(...args))
                }, (0, $X5A94.toDisplayString)(_ctx.$t($options.buyButtonLabel)), 1)) : (0, $ani5R.createCommentVNode)("", true),
                _ctx.mollieRedirect && $options.inIframe() ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $304747e65023f65e$var$_hoisted_4, (0, $X5A94.toDisplayString)(_ctx.$t("CheckPopup")), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ])
        ])
    ]);
}

});

parcelRegister("aYdWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fca51c798a6932e$export$2e2bcd8739ae039);
let $7fca51c798a6932e$var$NOOP = ()=>{};
var $7fca51c798a6932e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("eIbbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab5dda83ce19c481$export$2e2bcd8739ae039);
let $ab5dda83ce19c481$var$script;



let $ab5dda83ce19c481$var$initialize = ()=>{
    $ab5dda83ce19c481$var$script = (parcelRequire("f89N0"));
    if ($ab5dda83ce19c481$var$script.__esModule) $ab5dda83ce19c481$var$script = $ab5dda83ce19c481$var$script.default;
    $ab5dda83ce19c481$var$script.render = (parcelRequire("5W4Xi")).render;
    (parcelRequire("5LCgE")).default($ab5dda83ce19c481$var$script);
    $ab5dda83ce19c481$var$script.__scopeId = 'data-v-613e08';
    $ab5dda83ce19c481$var$script.__file = "SummaryPersonalize.vue";
};
$ab5dda83ce19c481$var$initialize();
var $ab5dda83ce19c481$export$2e2bcd8739ae039 = $ab5dda83ce19c481$var$script;

});
parcelRegister("f89N0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b03f325c82a68a30$export$2e2bcd8739ae039);

var $PEtmm = parcelRequire("PEtmm");

var $iMShf = parcelRequire("iMShf");
var $b03f325c82a68a30$export$2e2bcd8739ae039 = {
    data: ()=>({
            store: (0, $PEtmm.useStore)()
        }),
    computed: {
        /**
         * Die Felder, die eine Spalte verdienen. Ohne den Filter erzeugt ein
         * static-Feld — reiner Erklärtext im Formular — eine Spalte ohne Kopf
         * und ohne Inhalt.
         */ fields () {
            return (0, $iMShf.valueFields)(this.store.state.vue_personalize_fields);
        }
    },
    methods: {
        /**
         * floating ist normalerweise {de: …, en: …}, bei manchen Feldern aber
         * ein leerer String. Der Helper nimmt beides.
         */ label (floating) {
            return (0, $iMShf.localizedText)(floating, this.$root.$i18n.locale);
        },
        /**
         * Im Store steht der Wert, der ANS BACKEND geht — beim Select der
         * Options-Key ('option_yes'), beim Datum das value-format
         * ('2010-01-01'). Angezeigt werden soll, was im Formular zu lesen war.
         */ value (field, raw) {
            return (0, $iMShf.displayValue)(field, raw, this.$root.$i18n.locale);
        }
    }
};

});
parcelRegister("iMShf", function(module, exports) {

$parcel$export(module.exports, "localizedText", () => $dad6d0038195bf2a$export$ac40a617eb620139);
$parcel$export(module.exports, "displayValue", () => $dad6d0038195bf2a$export$7db1d0049c09f9c3);
$parcel$export(module.exports, "valueFields", () => $dad6d0038195bf2a$export$656c35c3cce553bb);
/**
 * Anzeigewerte für die Personalisierungsfelder.
 *
 * Der Store hält pro Person die Werte, die ANS BACKEND gehen — bei einem
 * Select also den Options-Key, bei einem Datum das value-format. In der
 * Zusammenfassung soll dagegen stehen, was der Käufer im Formular gesehen
 * hat. Beides steckt in der Felddefinition, die aus /shopsettings kommt:
 *
 *   Select   items: {option_yes: {de: 'Ja!', en: 'Yes!'}, …}
 *   Datum    value-format: 'YYYY-MM-DD', display-format: 'DD.MM.YYYY'
 *
 * Die Funktionen hier liegen bewusst außerhalb der Komponente: so sind sie
 * ohne gerenderten Shop prüfbar.
 */ /**
 * Lokalisierten Text aus einem Schemafeld holen.
 *
 * Das Schema liefert Beschriftungen als {de: …, en: …}, aber nicht immer:
 * ein static-Feld hat floating: '' (ein String). Deshalb beide Formen
 * annehmen und im Zweifel auf Deutsch und dann auf den ersten vorhandenen
 * Wert zurückfallen — eine leere Zelle wäre schlechter als die falsche
 * Sprache.
 */ function $dad6d0038195bf2a$export$ac40a617eb620139(value, locale) {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value !== 'object') return String(value);
    if (value[locale] !== undefined) return value[locale];
    if (value.de !== undefined) return value.de;
    const first = Object.values(value).find((v)=>typeof v === 'string');
    return first === undefined ? '' : first;
}
/**
 * Ein Datum von einem Format ins andere bringen.
 *
 * Bewusst OHNE new Date(): 'YYYY-MM-DD' wird als UTC-Mitternacht gelesen,
 * und in Zeitzonen westlich von UTC zeigt toLocaleDateString() dann den
 * Vortag — bei einem Geburtsdatum ein echter Fehler. Stattdessen werden
 * die Stellen anhand des value-format ausgelesen und ins display-format
 * gesetzt; es wird also nur umsortiert, nicht gerechnet.
 *
 * Passt der Wert nicht zum Format, kommt er unverändert zurück.
 */ const $dad6d0038195bf2a$var$TOKEN = /YYYY|YY|MM|DD|HH|mm|ss/g;
function $dad6d0038195bf2a$export$f44f0373cb35592a(value, valueFormat, displayFormat) {
    if (typeof value !== 'string' || !value) return value;
    if (!valueFormat || !displayFormat) return value;
    const parts = {};
    let cursor = 0;
    let ok = true;
    // value-format Stück für Stück abgehen und die Stellen mitschneiden.
    valueFormat.replace(/(YYYY|YY|MM|DD|HH|mm|ss)|([^YMDHms]+)/g, (match, token, literal)=>{
        if (!ok) return match;
        if (token) {
            const piece = value.substr(cursor, token.length);
            if (piece.length !== token.length || !/^\d+$/.test(piece)) {
                ok = false;
                return match;
            }
            parts[token] = piece;
            cursor += token.length;
        } else if (literal) {
            if (value.substr(cursor, literal.length) !== literal) {
                ok = false;
                return match;
            }
            cursor += literal.length;
        }
        return match;
    });
    if (!ok) return value;
    // YY und YYYY sind austauschbar: das eine ist das gekürzte andere.
    if (parts.YYYY && !parts.YY) parts.YY = parts.YYYY.slice(-2);
    if (parts.YY && !parts.YYYY) parts.YYYY = parts.YY;
    let missing = false;
    const out = displayFormat.replace($dad6d0038195bf2a$var$TOKEN, (token)=>{
        if (parts[token] === undefined) {
            missing = true;
            return token;
        }
        return parts[token];
    });
    return missing ? value : out;
}
function $dad6d0038195bf2a$export$245ad05b0468ea5e(items, value, locale) {
    if (items === null || items === undefined) return String(value);
    if (Array.isArray(items)) {
        const hit = items.find((item)=>{
            if (item === null || typeof item !== 'object') return String(item) === String(value);
            return String(item.value) === String(value);
        });
        if (hit === undefined) return String(value);
        if (hit === null || typeof hit !== 'object') return String(hit);
        return $dad6d0038195bf2a$export$ac40a617eb620139(hit.label !== undefined ? hit.label : hit.value, locale) || String(value);
    }
    if (typeof items === 'object') {
        const hit = Object.prototype.hasOwnProperty.call(items, value) ? items[value] : undefined;
        if (hit === undefined) return String(value);
        return $dad6d0038195bf2a$export$ac40a617eb620139(hit, locale) || String(value);
    }
    return String(value);
}
function $dad6d0038195bf2a$export$7db1d0049c09f9c3(field, value, locale) {
    if (value === null || value === undefined || value === '') return '';
    if (!field) return String(value);
    const type = field.type;
    if (type === 'select' || type === 'multiselect' || type === 'tags' || field.items) {
        if (Array.isArray(value)) return value.map((v)=>$dad6d0038195bf2a$export$245ad05b0468ea5e(field.items, v, locale)).join(', ');
        return $dad6d0038195bf2a$export$245ad05b0468ea5e(field.items, value, locale);
    }
    if (type === 'date' || field.date) return $dad6d0038195bf2a$export$f44f0373cb35592a(value, field['value-format'], field['display-format']);
    if (typeof value === 'boolean') return value ? "\u2713" : '';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return $dad6d0038195bf2a$export$ac40a617eb620139(value, locale);
    return String(value);
}
function $dad6d0038195bf2a$export$656c35c3cce553bb(fields) {
    const out = {};
    if (!fields || typeof fields !== 'object') return out;
    Object.keys(fields).forEach((key)=>{
        const field = fields[key];
        if (field && field.type === 'static') return;
        out[key] = field;
    });
    return out;
}

});


parcelRegister("5W4Xi", function(module, exports) {

$parcel$export(module.exports, "render", () => $4526368f1b446d3e$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $4526368f1b446d3e$var$_hoisted_1 = {
    class: "uk-margin-top"
};
const $4526368f1b446d3e$var$_hoisted_2 = {
    class: "uk-overflow-auto"
};
const $4526368f1b446d3e$var$_hoisted_3 = {
    class: "uk-table uk-table-striped uk-margin-remove-top"
};
const $4526368f1b446d3e$var$_hoisted_4 = {
    class: "uk-text-bold"
};
const $4526368f1b446d3e$var$_hoisted_5 = {
    class: "uk-text-bold"
};
function $4526368f1b446d3e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createElementVNode)("h3", $4526368f1b446d3e$var$_hoisted_1, (0, $X5A94.toDisplayString)(_ctx.$t("Personalisierung")), 1),
        (0, $ani5R.createElementVNode)("div", $4526368f1b446d3e$var$_hoisted_2, [
            (0, $ani5R.createElementVNode)("table", $4526368f1b446d3e$var$_hoisted_3, [
                (0, $ani5R.createElementVNode)("thead", null, [
                    (0, $ani5R.createElementVNode)("tr", null, [
                        (0, $ani5R.createElementVNode)("td", $4526368f1b446d3e$var$_hoisted_4, (0, $X5A94.toDisplayString)(_ctx.$t('Ticket')), 1),
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.fields, (field)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("td", $4526368f1b446d3e$var$_hoisted_5, (0, $X5A94.toDisplayString)($options.label(field.floating)), 1);
                        }), 256))
                    ])
                ]),
                (0, $ani5R.createElementVNode)("tbody", null, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.store.state.selection, (selection)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(selection.persons, (person)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("tr", null, [
                                    (0, $ani5R.createElementVNode)("td", null, (0, $X5A94.toDisplayString)(selection.ticket.name), 1),
                                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.fields, (field, key)=>{
                                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("td", null, (0, $X5A94.toDisplayString)($options.value(field, person[key])), 1);
                                    }), 256))
                                ]);
                            }), 256))
                        ], 64);
                    }), 256))
                ])
            ])
        ])
    ], 64);
}

});

parcelRegister("5LCgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $432f06af1cb562c4$export$2e2bcd8739ae039);
let $432f06af1cb562c4$var$NOOP = ()=>{};
var $432f06af1cb562c4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7E8kN", function(module, exports) {

$parcel$export(module.exports, "default", () => $5912bbdbeeb7bb8b$export$2e2bcd8739ae039);
let $5912bbdbeeb7bb8b$var$script;



let $5912bbdbeeb7bb8b$var$initialize = ()=>{
    $5912bbdbeeb7bb8b$var$script = (parcelRequire("e9n36"));
    if ($5912bbdbeeb7bb8b$var$script.__esModule) $5912bbdbeeb7bb8b$var$script = $5912bbdbeeb7bb8b$var$script.default;
    $5912bbdbeeb7bb8b$var$script.render = (parcelRequire("3iLw8")).render;
    (parcelRequire("2mjOW")).default($5912bbdbeeb7bb8b$var$script);
    $5912bbdbeeb7bb8b$var$script.__scopeId = 'data-v-2d73f2';
    $5912bbdbeeb7bb8b$var$script.__file = "ResellerOrderResult.vue";
};
$5912bbdbeeb7bb8b$var$initialize();
var $5912bbdbeeb7bb8b$export$2e2bcd8739ae039 = $5912bbdbeeb7bb8b$var$script;

});
parcelRegister("e9n36", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a4d3c90335a7878d$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");
const $a4d3c90335a7878d$var$POLL_INTERVAL_MS = 5000;
var $a4d3c90335a7878d$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: {
        orderNumber: {
            type: String,
            required: true
        },
        reseller: {
            type: Object,
            default: ()=>({})
        }
    },
    data () {
        return {
            // local mutable copy — initial value comes from prop, polling overwrites
            currentReseller: this.reseller || {},
            isPaid: this.computeIsPaid(this.reseller),
            pollHandle: null,
            mollieModalOpened: false,
            // Print destinations
            printers: [],
            selectedPdfTargetId: 'download',
            selectedLabelTargetId: 'download',
            // Per-row job state — key = 'pdf-0' / 'label-2'; value = 'busy' | 'done' | 'error'
            printJobs: {}
        };
    },
    computed: {
        ready () {
            // @gotcha Cash-Flow: ticket_codes werden asynchron via Queue erzeugt
            // (TicketCodeCreateFromOrderPositions-Job). Die Initial-Response liefert
            // bei offline_pending/signed sofort isPaid=true, aber ticket_pdf_urls=[].
            // Ohne hasAnyPrintUrl-Gate würde mounted() kein Polling starten und die
            // Druck-Buttons blieben für immer leer.
            return this.isPaid && this.hasAnyPrintUrl;
        },
        isCardFlow () {
            // Card-Flow ist eindeutig an status='awaiting_customer_tap' erkennbar.
            // Alles andere im Pending-State (signed/offline_pending ohne URLs) ist Cash.
            return this.currentReseller && this.currentReseller.status === 'awaiting_customer_tap';
        },
        printMode () {
            return this.currentReseller && this.currentReseller.print_mode || 'pdf_only';
        },
        showPdf () {
            return this.printMode === 'pdf_only' || this.printMode === 'both';
        },
        showLabel () {
            return this.printMode === 'label_only' || this.printMode === 'both';
        },
        pdfUrls () {
            return this.currentReseller && this.currentReseller.ticket_pdf_urls || [];
        },
        labelUrls () {
            return this.currentReseller && this.currentReseller.ticket_label_urls || [];
        },
        hasAnyPrintUrl () {
            return this.showPdf && this.pdfUrls.length > 0 || this.showLabel && this.labelUrls.length > 0;
        },
        iconUrl () {
            // SVG bringt eigene CSS-Animation mit (Rotation + Rainbow-Cycle).
            // Inline-styled <img> umgeht den toten ticketshop.css-Pfad — die
            // Animation läuft, sobald das SVG geladen ist, ohne externes CSS.
            return '/plugins/kosmoskosmos/festiware/assets/images/festiware_loading-spinner_v1.svg';
        },
        testCheckoutUrl () {
            // Test-Modus: Mollie-Checkout-URL wird mitgeliefert, damit der
            // Kassierer den Tap im Sandbox-Dashboard auslösen kann.
            if (!this.currentReseller || !this.currentReseller.mollie_testmode) return '';
            return this.currentReseller.mollie_checkout_url || '';
        },
        orderBackendUrl () {
            return this.currentReseller && this.currentReseller.order_backend_url ? this.currentReseller.order_backend_url : '';
        },
        invoiceUrl () {
            return this.currentReseller && this.currentReseller.invoice_url || '';
        },
        pdfButtonLabel () {
            return this.selectedPdfTargetId === 'download' ? this.$t('PDF herunterladen') : this.$t('PDF drucken');
        },
        labelButtonLabel () {
            return this.selectedLabelTargetId === 'download' ? this.$t('Label herunterladen') : this.$t('Label drucken');
        }
    },
    mounted () {
        // Test-Modus: Mollie-Checkout-Modal automatisch beim ersten Render
        // öffnen — der Kassierer muss dort die Sandbox-Zahlung bestätigen,
        // damit der Webhook auslöst und das Polling auf paid umschwenkt.
        if (this.testCheckoutUrl && !this.mollieModalOpened) this.openMollieTestCheckout();
        if (!this.ready) this.startPolling();
        // Restore choice + load available printers (one shot, cached server-side)
        this.restorePrintTargets();
        this.fetchPrinters();
    },
    beforeUnmount () {
        this.stopPolling();
    },
    beforeDestroy () {
        this.stopPolling();
    },
    methods: {
        computeIsPaid (reseller) {
            if (!reseller) return false;
            // Cash-Flow: kein status-Feld, aber sofort signed → paid.
            // Card-Flow: explizit status === 'awaiting_customer_tap' bis Webhook paid liefert.
            if (reseller.status === 'awaiting_customer_tap') return false;
            if (reseller.status === 'paid') return true;
            // Cash: signed (oder offline_pending) + ticket urls bedeutet paid.
            const hasUrls = reseller.ticket_pdf_urls && reseller.ticket_pdf_urls.length > 0 || reseller.ticket_label_urls && reseller.ticket_label_urls.length > 0;
            return hasUrls || reseller.fiskaly_state === 'signed' || reseller.fiskaly_state === 'offline_pending';
        },
        startPolling () {
            this.stopPolling();
            this.pollHandle = setInterval(()=>this.pollOnce(), $a4d3c90335a7878d$var$POLL_INTERVAL_MS);
        },
        stopPolling () {
            if (this.pollHandle) {
                clearInterval(this.pollHandle);
                this.pollHandle = null;
            }
        },
        pollOnce () {
            this.doOctoberRequest('onPollResellerOrderStatus', {
                order_number: this.orderNumber
            }).then((response)=>{
                if (!response || !response.reseller) return;
                this.currentReseller = response.reseller;
                if (response.is_paid || this.computeIsPaid(response.reseller)) this.isPaid = true;
                // Stop only once URLs have actually materialized — Cash-Flow
                // reports isPaid before the ticket_codes Job has finished.
                if (this.ready) this.stopPolling();
            }).catch(()=>{
            // Single failure = transient (Webhook-Roundtrip läuft noch).
            // Polling läuft weiter; bei dauerhafter Misskonfig sieht der
            // Kassierer das im Network-Tab — UI-Seitig ohne Toast bleiben,
            // sonst wird's ein Spam-Karussell.
            });
        },
        openMollieTestCheckout () {
            this.mollieModalOpened = true;
            const url = this.testCheckoutUrl;
            if (!url) return;
            // 1. Versuch: neues Tab/Fenster
            const win = window.open(url, '_blank', 'noopener');
            if (win) return;
            // 2. Fallback: UIkit-Modal mit klickbarem Link
            if (typeof UIkit !== 'undefined' && UIkit.modal && UIkit.modal.dialog) UIkit.modal.dialog(`<div class="uk-modal-body">
                        <h3>${this.$t('Test-Zahlung Mollie')}</h3>
                        <p>${this.$t("Pop-up wurde blockiert. Bitte den folgenden Link \xf6ffnen:")}</p>
                        <p><a href="${url}" target="_blank" rel="noopener">${url}</a></p>
                        <p class="uk-text-meta">
                            ${this.$t('Alternativ im Mollie-Dashboard unter "Umsatz" die offene Zahlung manuell auf bezahlt setzen.')}
                        </p>
                    </div>
                    <div class="uk-modal-footer uk-text-right">
                        <button class="uk-button uk-button-default uk-modal-close" type="button">
                            ${this.$t("Schlie\xdfen")}
                        </button>
                    </div>`);
            else // 3. Letzter Fallback: window.location
            window.location.href = url;
        },
        cancel () {
            this.stopPolling();
            // Order wird über den existierenden Cleanup-Cron aufgeräumt
            // (started → cancel nach Grace-Period; offline_pending → bleibt für
            // späteren Retry, falls Mollie doch noch paid liefert).
            this.$emit('new-order');
        },
        newOrder () {
            this.$emit('new-order');
        },
        // ── Print target selection ──────────────────────────────────────────
        /**
         * One key per browser+host; the cashier's machine maps 1:1 to one
         * instance, so we don't need a per-tenant scope beyond the hostname.
         */ lsKey (format) {
            return `festiware.reseller.print_target.${window.location.hostname}.${format}`;
        },
        restorePrintTargets () {
            try {
                this.selectedPdfTargetId = localStorage.getItem(this.lsKey('pdf')) || 'download';
                this.selectedLabelTargetId = localStorage.getItem(this.lsKey('label')) || 'download';
            } catch (e) {}
        },
        fetchPrinters () {
            this.doOctoberRequest('onGetResellerPrinters', {}).then((response)=>{
                const list = response && response.printers || [];
                this.printers = list;
                // First load: if user has no saved choice and there is a
                // default printer, pre-select it (still saved on first
                // explicit change — we don't write back here so the user
                // can fall back to Download by leaving the page alone).
                if (this.selectedPdfTargetId === 'download') {
                    const def = list.find((p)=>p.is_default);
                    if (def) this.selectedPdfTargetId = String(def.id);
                }
                if (this.selectedLabelTargetId === 'download') {
                    const def = list.find((p)=>p.is_default);
                    if (def) this.selectedLabelTargetId = String(def.id);
                }
            }).catch(()=>{
                this.printers = [];
            });
        },
        onPdfTargetChange (value) {
            this.selectedPdfTargetId = value;
            try {
                localStorage.setItem(this.lsKey('pdf'), value);
            } catch (e) {}
        },
        onLabelTargetChange (value) {
            this.selectedLabelTargetId = value;
            try {
                localStorage.setItem(this.lsKey('label'), value);
            } catch (e) {}
        },
        printJobBusy (key) {
            return this.printJobs[key] === 'busy';
        },
        printJobStatus (key) {
            switch(this.printJobs[key]){
                case 'busy':
                    return this.$t("\u2026 wird gedruckt");
                case 'done':
                    return this.$t("\u2713 gedruckt");
                case 'error':
                    return this.$t("Fehler \u2014 bitte erneut versuchen");
                default:
                    return '';
            }
        },
        /**
         * Either open the asset URL (legacy Download flow) or hand it off
         * to the festiware.app print queue. The button stays per-ticket so
         * the cashier can re-print a single ticket without re-printing all.
         */ handlePrint (format, index, url) {
            const target = format === 'pdf' ? this.selectedPdfTargetId : this.selectedLabelTargetId;
            const key = `${format}-${index}`;
            if (target === 'download' || !target) {
                window.open(url, '_blank', 'noopener');
                return;
            }
            this.printJobs = {
                ...this.printJobs,
                [key]: 'busy'
            };
            this.doOctoberRequest('onSendResellerPrintJob', {
                url: url,
                supply_item_id: target,
                context_ref: `order:${this.orderNumber}#${format}-${index + 1}`
            }).then(()=>{
                this.printJobs = {
                    ...this.printJobs,
                    [key]: 'done'
                };
            }).catch(()=>{
                this.printJobs = {
                    ...this.printJobs,
                    [key]: 'error'
                };
            });
        }
    }
};

});

parcelRegister("3iLw8", function(module, exports) {

$parcel$export(module.exports, "render", () => $2677e97e8fac6b1d$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $2677e97e8fac6b1d$var$_hoisted_1 = {
    class: "reseller-order-result"
};
const $2677e97e8fac6b1d$var$_hoisted_2 = {
    class: "uk-alert-primary",
    "uk-alert": ""
};
const $2677e97e8fac6b1d$var$_hoisted_3 = {
    class: "uk-margin-remove"
};
const $2677e97e8fac6b1d$var$_hoisted_4 = {
    class: "uk-margin-remove-bottom"
};
const $2677e97e8fac6b1d$var$_hoisted_5 = [
    "href"
];
const $2677e97e8fac6b1d$var$_hoisted_6 = {
    key: 1
};
const $2677e97e8fac6b1d$var$_hoisted_7 = {
    key: 0,
    class: "uk-text-meta uk-margin-remove-top"
};
const $2677e97e8fac6b1d$var$_hoisted_8 = {
    class: "uk-flex uk-flex-middle uk-flex-column uk-margin-medium-top uk-text-center"
};
const $2677e97e8fac6b1d$var$_hoisted_9 = [
    "src",
    "alt"
];
const $2677e97e8fac6b1d$var$_hoisted_10 = {
    class: "uk-margin-medium-top uk-margin-remove-bottom"
};
const $2677e97e8fac6b1d$var$_hoisted_11 = {
    class: "uk-text-meta uk-margin-small-top"
};
const $2677e97e8fac6b1d$var$_hoisted_12 = {
    key: 0,
    class: "uk-margin-medium-top uk-text-center"
};
const $2677e97e8fac6b1d$var$_hoisted_13 = {
    class: "uk-margin-medium-top uk-flex uk-flex-right"
};
const $2677e97e8fac6b1d$var$_hoisted_14 = {
    class: "uk-alert-success",
    "uk-alert": ""
};
const $2677e97e8fac6b1d$var$_hoisted_15 = {
    class: "uk-margin-remove"
};
const $2677e97e8fac6b1d$var$_hoisted_16 = {
    class: "uk-flex uk-flex-middle uk-flex-between uk-flex-wrap uk-margin-remove-bottom"
};
const $2677e97e8fac6b1d$var$_hoisted_17 = {
    class: "uk-margin-remove"
};
const $2677e97e8fac6b1d$var$_hoisted_18 = [
    "href"
];
const $2677e97e8fac6b1d$var$_hoisted_19 = {
    key: 1
};
const $2677e97e8fac6b1d$var$_hoisted_20 = [
    "href"
];
const $2677e97e8fac6b1d$var$_hoisted_21 = {
    key: 0,
    class: "uk-text-meta uk-margin-remove-top"
};
const $2677e97e8fac6b1d$var$_hoisted_22 = {
    key: 0,
    class: "uk-alert-primary",
    "uk-alert": ""
};
const $2677e97e8fac6b1d$var$_hoisted_23 = {
    class: "uk-margin-remove"
};
const $2677e97e8fac6b1d$var$_hoisted_24 = {
    key: 1,
    class: "uk-alert-warning",
    "uk-alert": ""
};
const $2677e97e8fac6b1d$var$_hoisted_25 = {
    class: "uk-margin-remove"
};
const $2677e97e8fac6b1d$var$_hoisted_26 = {
    class: "uk-margin-medium-top"
};
const $2677e97e8fac6b1d$var$_hoisted_27 = {
    key: 2,
    class: "uk-text-muted"
};
const $2677e97e8fac6b1d$var$_hoisted_28 = {
    key: 3,
    class: "uk-margin-small-bottom uk-grid-small",
    "uk-grid": ""
};
const $2677e97e8fac6b1d$var$_hoisted_29 = {
    key: 0,
    class: "uk-width-1-1 uk-width-1-2@s"
};
const $2677e97e8fac6b1d$var$_hoisted_30 = {
    class: "uk-form-label uk-text-small"
};
const $2677e97e8fac6b1d$var$_hoisted_31 = [
    "value"
];
const $2677e97e8fac6b1d$var$_hoisted_32 = {
    value: "download"
};
const $2677e97e8fac6b1d$var$_hoisted_33 = [
    "value"
];
const $2677e97e8fac6b1d$var$_hoisted_34 = {
    key: 1,
    class: "uk-width-1-1 uk-width-1-2@s"
};
const $2677e97e8fac6b1d$var$_hoisted_35 = {
    class: "uk-form-label uk-text-small"
};
const $2677e97e8fac6b1d$var$_hoisted_36 = [
    "value"
];
const $2677e97e8fac6b1d$var$_hoisted_37 = {
    value: "download"
};
const $2677e97e8fac6b1d$var$_hoisted_38 = [
    "value"
];
const $2677e97e8fac6b1d$var$_hoisted_39 = {
    key: 4,
    class: "uk-list uk-list-divider"
};
const $2677e97e8fac6b1d$var$_hoisted_40 = {
    class: "uk-margin-small-right"
};
const $2677e97e8fac6b1d$var$_hoisted_41 = {
    key: 0,
    class: "uk-text-meta uk-margin-small-left"
};
const $2677e97e8fac6b1d$var$_hoisted_42 = [
    "disabled",
    "onClick"
];
const $2677e97e8fac6b1d$var$_hoisted_43 = [
    "disabled",
    "onClick"
];
const $2677e97e8fac6b1d$var$_hoisted_44 = {
    class: "uk-margin-medium-top uk-flex uk-flex-right"
};
function $2677e97e8fac6b1d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_1, [
        !$options.ready ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 0
        }, [
            (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_2, [
                (0, $ani5R.createElementVNode)("h3", $2677e97e8fac6b1d$var$_hoisted_3, (0, $X5A94.toDisplayString)(_ctx.$t('Bestellung in Abwicklung')), 1),
                (0, $ani5R.createElementVNode)("p", $2677e97e8fac6b1d$var$_hoisted_4, [
                    (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.$t('Bestellnummer')) + ": ", 1),
                    $options.orderBackendUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        href: $options.orderBackendUrl,
                        target: "_blank",
                        rel: "noopener"
                    }, [
                        (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)($props.orderNumber), 1)
                    ], 8, $2677e97e8fac6b1d$var$_hoisted_5)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("strong", $2677e97e8fac6b1d$var$_hoisted_6, (0, $X5A94.toDisplayString)($props.orderNumber), 1))
                ]),
                $props.reseller && $props.reseller.fiskaly_signature_counter ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $2677e97e8fac6b1d$var$_hoisted_7, " TSE #" + (0, $X5A94.toDisplayString)($props.reseller.fiskaly_signature_counter), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ]),
            (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_8, [
                (0, $ani5R.createElementVNode)("img", {
                    src: $options.iconUrl,
                    alt: $options.isCardFlow ? _ctx.$t('Warte auf Zahlung') : _ctx.$t('Bestellung wird verarbeitet'),
                    style: {
                        "width": "96px",
                        "height": "96px"
                    }
                }, null, 8, $2677e97e8fac6b1d$var$_hoisted_9),
                (0, $ani5R.createElementVNode)("h4", $2677e97e8fac6b1d$var$_hoisted_10, (0, $X5A94.toDisplayString)($options.isCardFlow ? _ctx.$t('Warte auf Zahlung') : _ctx.$t('Bestellung wird verarbeitet')), 1),
                (0, $ani5R.createElementVNode)("p", $2677e97e8fac6b1d$var$_hoisted_11, (0, $X5A94.toDisplayString)($options.isCardFlow ? _ctx.$t('Bitte Karte am Terminal halten. Diese Seite aktualisiert sich automatisch.') : _ctx.$t('Die Bestellung wird gerade verarbeitet, bitte einen Moment warten.')), 1)
            ]),
            $options.testCheckoutUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_12, [
                (0, $ani5R.createElementVNode)("button", {
                    class: "uk-button uk-button-default uk-button-small",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.openMollieTestCheckout && $options.openMollieTestCheckout(...args))
                }, (0, $X5A94.toDisplayString)(_ctx.$t("Test-Bezahlung im Mollie-Dashboard \xf6ffnen")), 1)
            ])) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_13, [
                (0, $ani5R.createElementVNode)("button", {
                    class: "uk-button uk-button-danger uk-button-small",
                    onClick: _cache[1] || (_cache[1] = (...args)=>$options.cancel && $options.cancel(...args))
                }, (0, $X5A94.toDisplayString)(_ctx.$t('Bestellung abbrechen')), 1)
            ])
        ], 64)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_14, [
                (0, $ani5R.createElementVNode)("h3", $2677e97e8fac6b1d$var$_hoisted_15, (0, $X5A94.toDisplayString)(_ctx.$t('Bestellung erfolgreich')), 1),
                (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_16, [
                    (0, $ani5R.createElementVNode)("p", $2677e97e8fac6b1d$var$_hoisted_17, [
                        (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.$t('Bestellnummer')) + ": ", 1),
                        $options.orderBackendUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                            key: 0,
                            href: $options.orderBackendUrl,
                            target: "_blank",
                            rel: "noopener"
                        }, [
                            (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)($props.orderNumber), 1)
                        ], 8, $2677e97e8fac6b1d$var$_hoisted_18)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("strong", $2677e97e8fac6b1d$var$_hoisted_19, (0, $X5A94.toDisplayString)($props.orderNumber), 1))
                    ]),
                    $options.invoiceUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                        key: 0,
                        href: $options.invoiceUrl,
                        target: "_blank",
                        rel: "noopener",
                        class: "uk-button uk-button-default uk-button-small"
                    }, (0, $X5A94.toDisplayString)(_ctx.$t('Rechnung herunterladen')), 9, $2677e97e8fac6b1d$var$_hoisted_20)) : (0, $ani5R.createCommentVNode)("", true)
                ]),
                $props.reseller && $props.reseller.fiskaly_signature_counter && !$props.reseller.fiskaly_offline ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $2677e97e8fac6b1d$var$_hoisted_21, " TSE #" + (0, $X5A94.toDisplayString)($props.reseller.fiskaly_signature_counter), 1)) : (0, $ani5R.createCommentVNode)("", true)
            ]),
            $props.reseller && $props.reseller.external_provider ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_22, [
                (0, $ani5R.createElementVNode)("p", $2677e97e8fac6b1d$var$_hoisted_23, (0, $X5A94.toDisplayString)(_ctx.$t("Cashless-Zahlung \u2014 der Beleg kommt vom Terminal des Cashless-Anbieters. festiware erstellt f\xfcr diesen Verkauf keinen eigenen Kassenbeleg.")), 1)
            ])) : (0, $ani5R.createCommentVNode)("", true),
            $props.reseller && $props.reseller.fiskaly_offline ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_24, [
                (0, $ani5R.createElementVNode)("p", $2677e97e8fac6b1d$var$_hoisted_25, [
                    (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)(_ctx.$t('TSE aktuell offline')) + ".", 1),
                    (0, $ani5R.createTextVNode)(" " + (0, $X5A94.toDisplayString)(_ctx.$t("Verkauf erfasst und Ticket g\xfcltig \u2014 die Fiskaly-Signatur wird automatisch nachgeholt, sobald die TSE wieder erreichbar ist. Bitte das Problem zeitnah von der Administration beheben lassen (\xa7146a AO).")), 1)
                ])
            ])) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("h4", $2677e97e8fac6b1d$var$_hoisted_26, (0, $X5A94.toDisplayString)(_ctx.$t('Tickets drucken')), 1),
            !$options.hasAnyPrintUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("p", $2677e97e8fac6b1d$var$_hoisted_27, (0, $X5A94.toDisplayString)(_ctx.$t('Es wurden keine Ticket-PDFs erzeugt.')), 1)) : (0, $ani5R.createCommentVNode)("", true),
            $options.hasAnyPrintUrl && $data.printers.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_28, [
                $options.showPdf ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_29, [
                    (0, $ani5R.createElementVNode)("label", $2677e97e8fac6b1d$var$_hoisted_30, (0, $X5A94.toDisplayString)(_ctx.$t("PDF drucken \xfcber")), 1),
                    (0, $ani5R.createElementVNode)("select", {
                        class: "uk-select uk-form-small",
                        value: $data.selectedPdfTargetId,
                        onChange: _cache[2] || (_cache[2] = ($event)=>$options.onPdfTargetChange($event.target.value))
                    }, [
                        (0, $ani5R.createElementVNode)("option", $2677e97e8fac6b1d$var$_hoisted_32, (0, $X5A94.toDisplayString)(_ctx.$t("Download (in neuem Tab \xf6ffnen)")), 1),
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.printers, (p)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                key: `pdf-${p.id}`,
                                value: String(p.id)
                            }, (0, $X5A94.toDisplayString)(p.name), 9, $2677e97e8fac6b1d$var$_hoisted_33);
                        }), 128))
                    ], 40, $2677e97e8fac6b1d$var$_hoisted_31)
                ])) : (0, $ani5R.createCommentVNode)("", true),
                $options.showLabel ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2677e97e8fac6b1d$var$_hoisted_34, [
                    (0, $ani5R.createElementVNode)("label", $2677e97e8fac6b1d$var$_hoisted_35, (0, $X5A94.toDisplayString)(_ctx.$t("Label drucken \xfcber")), 1),
                    (0, $ani5R.createElementVNode)("select", {
                        class: "uk-select uk-form-small",
                        value: $data.selectedLabelTargetId,
                        onChange: _cache[3] || (_cache[3] = ($event)=>$options.onLabelTargetChange($event.target.value))
                    }, [
                        (0, $ani5R.createElementVNode)("option", $2677e97e8fac6b1d$var$_hoisted_37, (0, $X5A94.toDisplayString)(_ctx.$t("Download (in neuem Tab \xf6ffnen)")), 1),
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($data.printers, (p)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                key: `label-${p.id}`,
                                value: String(p.id)
                            }, (0, $X5A94.toDisplayString)(p.name), 9, $2677e97e8fac6b1d$var$_hoisted_38);
                        }), 128))
                    ], 40, $2677e97e8fac6b1d$var$_hoisted_36)
                ])) : (0, $ani5R.createCommentVNode)("", true)
            ])) : (0, $ani5R.createCommentVNode)("", true),
            $options.hasAnyPrintUrl ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", $2677e97e8fac6b1d$var$_hoisted_39, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.pdfUrls, (_, index)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                        key: `row-${index}`,
                        class: "uk-flex uk-flex-middle uk-flex-between uk-flex-wrap"
                    }, [
                        (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_40, [
                            (0, $ani5R.createElementVNode)("strong", null, (0, $X5A94.toDisplayString)(_ctx.$t('Ticket')) + " " + (0, $X5A94.toDisplayString)(index + 1), 1),
                            $options.printJobStatus(`pdf-${index}`) ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $2677e97e8fac6b1d$var$_hoisted_41, (0, $X5A94.toDisplayString)($options.printJobStatus(`pdf-${index}`)), 1)) : (0, $ani5R.createCommentVNode)("", true)
                        ]),
                        (0, $ani5R.createElementVNode)("div", null, [
                            $options.showPdf && $options.pdfUrls[index] ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                                key: 0,
                                type: "button",
                                disabled: $options.printJobBusy(`pdf-${index}`),
                                class: "uk-button uk-button-primary uk-button-small uk-margin-small-right",
                                onClick: ($event)=>$options.handlePrint('pdf', index, $options.pdfUrls[index])
                            }, (0, $X5A94.toDisplayString)($options.pdfButtonLabel), 9, $2677e97e8fac6b1d$var$_hoisted_42)) : (0, $ani5R.createCommentVNode)("", true),
                            $options.showLabel && $options.labelUrls[index] ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
                                key: 1,
                                type: "button",
                                disabled: $options.printJobBusy(`label-${index}`),
                                class: "uk-button uk-button-secondary uk-button-small",
                                onClick: ($event)=>$options.handlePrint('label', index, $options.labelUrls[index])
                            }, (0, $X5A94.toDisplayString)($options.labelButtonLabel), 9, $2677e97e8fac6b1d$var$_hoisted_43)) : (0, $ani5R.createCommentVNode)("", true)
                        ])
                    ]);
                }), 128))
            ])) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("div", $2677e97e8fac6b1d$var$_hoisted_44, [
                (0, $ani5R.createElementVNode)("button", {
                    class: "uk-button uk-button-default",
                    onClick: _cache[4] || (_cache[4] = (...args)=>$options.newOrder && $options.newOrder(...args))
                }, (0, $X5A94.toDisplayString)(_ctx.$t('Neue Bestellung')), 1)
            ])
        ], 64))
    ]);
}

});

parcelRegister("2mjOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7d02ce724f8ffc$export$2e2bcd8739ae039);
let $1b7d02ce724f8ffc$var$NOOP = ()=>{};
var $1b7d02ce724f8ffc$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("hSadF", function(module, exports) {

$parcel$export(module.exports, "render", () => $d02f682f8c597be0$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $d02f682f8c597be0$var$_hoisted_1 = {
    key: 2
};
const $d02f682f8c597be0$var$_hoisted_2 = {
    class: "uk-margin-medium-bottom"
};
function $d02f682f8c597be0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_summary_messages = (0, $ani5R.resolveComponent)("summary-messages");
    const _component_reseller_order_result = (0, $ani5R.resolveComponent)("reseller-order-result");
    const _component_summary_receiver = (0, $ani5R.resolveComponent)("summary-receiver");
    const _component_summary_personalize = (0, $ani5R.resolveComponent)("summary-personalize");
    const _component_summary_cart = (0, $ani5R.resolveComponent)("summary-cart");
    const _component_summary_payment = (0, $ani5R.resolveComponent)("summary-payment");
    return _ctx.showMessage ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_summary_messages, {
        key: 0,
        message: _ctx.messageContainer
    }, null, 8, [
        "message"
    ])) : _ctx.resellerResult ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_reseller_order_result, {
        key: 1,
        "order-number": _ctx.resellerResult.order_number || '',
        reseller: _ctx.resellerResult.reseller || {},
        onNewOrder: $options.onNewOrder
    }, null, 8, [
        "order-number",
        "reseller",
        "onNewOrder"
    ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $d02f682f8c597be0$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("h2", $d02f682f8c597be0$var$_hoisted_2, (0, $X5A94.toDisplayString)(_ctx.$t("Zusammenfassung")), 1),
        (0, $ani5R.createVNode)(_component_summary_receiver),
        _ctx.store.state.personalize ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_summary_personalize, {
            key: 0
        })) : (0, $ani5R.createCommentVNode)("", true),
        (0, $ani5R.createVNode)(_component_summary_cart, {
            settings: $props.settings
        }, null, 8, [
            "settings"
        ]),
        (0, $ani5R.createVNode)(_component_summary_payment, {
            settings: $props.settings,
            loginusername: $props.loginusername,
            onSuccess: $options.onSuccess,
            onError: $options.onError,
            onResellerSuccess: $options.onResellerSuccess,
            onBack: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('back', 1))
        }, null, 8, [
            "settings",
            "loginusername",
            "onSuccess",
            "onError",
            "onResellerSuccess"
        ])
    ]));
}

});

parcelRegister("gXbUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c57b6651b978bb7b$export$2e2bcd8739ae039);
let $c57b6651b978bb7b$var$NOOP = ()=>{};
var $c57b6651b978bb7b$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5eviF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cf68a17cff9c4f6$export$2e2bcd8739ae039);
let $3cf68a17cff9c4f6$var$script;



let $3cf68a17cff9c4f6$var$initialize = ()=>{
    $3cf68a17cff9c4f6$var$script = (parcelRequire("iw8CX"));
    if ($3cf68a17cff9c4f6$var$script.__esModule) $3cf68a17cff9c4f6$var$script = $3cf68a17cff9c4f6$var$script.default;
    $3cf68a17cff9c4f6$var$script.render = (parcelRequire("669TM")).render;
    (parcelRequire("8ogmq")).default($3cf68a17cff9c4f6$var$script);
    $3cf68a17cff9c4f6$var$script.__scopeId = 'data-v-63b69c';
    $3cf68a17cff9c4f6$var$script.__file = "PersonalizeTickets.vue";
};
$3cf68a17cff9c4f6$var$initialize();
var $3cf68a17cff9c4f6$export$2e2bcd8739ae039 = $3cf68a17cff9c4f6$var$script;

});
parcelRegister("iw8CX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d7b1e858f0f42187$export$2e2bcd8739ae039);

var $1uamp = parcelRequire("1uamp");

var $6oQp6 = parcelRequire("6oQp6");
var $d7b1e858f0f42187$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [],
    components: {
        PersonalizeTicketForm: $1uamp.default
    },
    data: ()=>{
        return {
            personRefs: {}
        };
    },
    computed: {
        selection () {
            let selection = this.store.state.selection;
            if (Object.keys(this.store.state.ownerData).length) for(let offerId in selection){
                for(let key in this.store.state.vue_personalize_fields)if (!selection[offerId].persons[0][key] && this.store.state.ownerData[key]) selection[offerId].persons[0][key] = this.store.state.ownerData[key];
            }
            return selection;
        }
    },
    methods: {
        async next () {
            if (await this.validate()) {
                this.store.state.personalized = true;
                this.$emit('next');
            } else {
                window.setTimeout(()=>{
                    this.$scrollTo('.vf-element-layout-error', 500, {
                        offset: -120
                    });
                });
                this.store.commit('emitScroll');
                this.store.state.personalized = false;
            }
        },
        setItemRef (ticketId, index, ref) {
            if (ref) this.personRefs[ticketId + '_' + index] = ref;
        },
        removeTicket (ticketId, index) {
            this.store.commit('emitScroll');
            UIkit.modal.confirm(this.$t('Ticket entfernen?')).then(()=>{
                delete this.personRefs[ticketId + '_' + index];
                this.store.commit("removeTicket", {
                    ticketId: ticketId,
                    index: index
                });
                this.$forceUpdate();
                if (!Object.keys(this.selection).length) this.$emit("back");
            }, ()=>{});
        },
        async validate () {
            // A removed ticket's form stays in personRefs (its key may now belong to another
            // ticket, the list is not keyed), and its $refs.form is null: only mounted forms count.
            const forms = new Set(Object.values(this.personRefs).filter((form)=>!form.$.isUnmounted));
            const promises = [
                ...forms
            ].map((form)=>form.validate());
            return Promise.all(promises).then((values)=>{
                return values.every(Boolean);
            });
        }
    }
};

});
parcelRegister("1uamp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1150a124baf0a0cd$export$2e2bcd8739ae039);
let $1150a124baf0a0cd$var$script;



let $1150a124baf0a0cd$var$initialize = ()=>{
    $1150a124baf0a0cd$var$script = (parcelRequire("3FWw9"));
    if ($1150a124baf0a0cd$var$script.__esModule) $1150a124baf0a0cd$var$script = $1150a124baf0a0cd$var$script.default;
    $1150a124baf0a0cd$var$script.render = (parcelRequire("4H020")).render;
    (parcelRequire("fakS1")).default($1150a124baf0a0cd$var$script);
    $1150a124baf0a0cd$var$script.__scopeId = 'data-v-0c8f71';
    $1150a124baf0a0cd$var$script.__file = "PersonalizeTicketForm.vue";
};
$1150a124baf0a0cd$var$initialize();
var $1150a124baf0a0cd$export$2e2bcd8739ae039 = $1150a124baf0a0cd$var$script;

});
parcelRegister("3FWw9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ad297c86a06c697$export$2e2bcd8739ae039);

var $PEtmm = parcelRequire("PEtmm");
var $2ad297c86a06c697$export$2e2bcd8739ae039 = {
    emits: [
        "update"
    ],
    props: [
        'person'
    ],
    data: ()=>({
            model: {},
            store: (0, $PEtmm.useStore)()
        }),
    mounted () {
        this.$nextTick(()=>this.$refs.form.update(this.person));
    },
    methods: {
        validate () {
            return new Promise((resolve)=>{
                this.$refs.form.validate().then(()=>{
                    this.$emit('update', this.model);
                    resolve(!this.$refs.form.invalid);
                });
            });
        }
    }
};

});

parcelRegister("4H020", function(module, exports) {

$parcel$export(module.exports, "render", () => $36ab33d016659cee$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
function $36ab33d016659cee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Vueform = (0, $ani5R.resolveComponent)("Vueform");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_Vueform, {
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.model = $event),
        ref: "form",
        schema: _ctx.store.state.vue_personalize_fields,
        displayErrors: false
    }, null, 8, [
        "modelValue",
        "schema"
    ]);
}

});

parcelRegister("fakS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a7fa956026f670$export$2e2bcd8739ae039);
let $b0a7fa956026f670$var$NOOP = ()=>{};
var $b0a7fa956026f670$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("669TM", function(module, exports) {

$parcel$export(module.exports, "render", () => $470afb489369f1da$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $470afb489369f1da$var$_hoisted_1 = {
    class: "personalize-tickets"
};
const $470afb489369f1da$var$_hoisted_2 = {
    class: "uk-margin-bottom"
};
const $470afb489369f1da$var$_hoisted_3 = {
    class: "uk-child-width-1-2@m uk-margin",
    "uk-grid": ""
};
const $470afb489369f1da$var$_hoisted_4 = {
    class: "personalize-ticket uk-position-relative"
};
const $470afb489369f1da$var$_hoisted_5 = {
    class: "ticket-details"
};
const $470afb489369f1da$var$_hoisted_6 = {
    class: "content uk-flex uk-flex-column uk-flex-between"
};
const $470afb489369f1da$var$_hoisted_7 = [
    "innerHTML"
];
const $470afb489369f1da$var$_hoisted_8 = {
    class: "ticket-person uk-margin-small-top"
};
const $470afb489369f1da$var$_hoisted_9 = {
    class: "uk-display-block"
};
const $470afb489369f1da$var$_hoisted_10 = {
    class: "uk-text-large uk-text-bold uk-margin-top"
};
const $470afb489369f1da$var$_hoisted_11 = [
    "innerHTML"
];
const $470afb489369f1da$var$_hoisted_12 = [
    "onClick"
];
const $470afb489369f1da$var$_hoisted_13 = {
    class: "uk-margin-medium uk-flex uk-flex-right"
};
function $470afb489369f1da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_personalize_ticket_form = (0, $ani5R.resolveComponent)("personalize-ticket-form");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $470afb489369f1da$var$_hoisted_1, [
        (0, $ani5R.createElementVNode)("h2", $470afb489369f1da$var$_hoisted_2, (0, $X5A94.toDisplayString)(_ctx.$t("Personalisiere die Tickets")), 1),
        (0, $ani5R.createElementVNode)("ul", $470afb489369f1da$var$_hoisted_3, [
            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)($options.selection, (cartItem, ticketId)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
                    _ctx.store.state.offers[ticketId] && !_ctx.store.state.offers[ticketId].no_chip ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 0
                    }, (0, $ani5R.renderList)(cartItem.persons, (person, index)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                            class: (0, $X5A94.normalizeClass)({
                                ['tag-' + cartItem.ticket.category.id]: true
                            })
                        }, [
                            (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_4, [
                                (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_5, [
                                    cartItem.ticket.image ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                        key: 0,
                                        class: "ticket-image",
                                        style: (0, $X5A94.normalizeStyle)({
                                            backgroundImage: 'url(' + cartItem.ticket.image + ')'
                                        })
                                    }, null, 4)) : (0, $ani5R.createCommentVNode)("", true),
                                    (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_6, [
                                        (0, $ani5R.createElementVNode)("h4", {
                                            class: "uk-card-title uk-margin-remove-top",
                                            innerHTML: '<span>' + cartItem.ticket.name.split(' ').join('</span> <span>') + '</span>'
                                        }, null, 8, $470afb489369f1da$var$_hoisted_7),
                                        (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_8, [
                                            (0, $ani5R.createVNode)(_component_personalize_ticket_form, {
                                                ref_for: true,
                                                ref: (ref)=>$options.setItemRef(ticketId, index, ref),
                                                person: person,
                                                onUpdate: ($event)=>this.store.state.selection[ticketId].persons[index] = $event
                                            }, null, 8, [
                                                "person",
                                                "onUpdate"
                                            ])
                                        ]),
                                        (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_9, [
                                            (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_10, [
                                                (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.getPrice(cartItem.ticket, 1)) + " ", 1),
                                                cartItem.ticket.included_products.length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                                    key: 0,
                                                    class: "included-products uk-margin-small-bottom",
                                                    innerHTML: _ctx.getIncludedProducts(cartItem.ticket)
                                                }, null, 8, $470afb489369f1da$var$_hoisted_11)) : (0, $ani5R.createCommentVNode)("", true)
                                            ]),
                                            (0, $ani5R.createElementVNode)("a", {
                                                onClick: ($event)=>$options.removeTicket(ticketId, index),
                                                class: "uk-button uk-button-primary uk-button-small"
                                            }, (0, $X5A94.toDisplayString)(_ctx.$t("Ticket entfernen")), 9, $470afb489369f1da$var$_hoisted_12)
                                        ])
                                    ])
                                ])
                            ])
                        ], 2);
                    }), 256)) : (0, $ani5R.createCommentVNode)("", true)
                ], 64);
            }), 256))
        ]),
        (0, $ani5R.createElementVNode)("div", $470afb489369f1da$var$_hoisted_13, [
            (0, $ani5R.createElementVNode)("button", {
                class: "uk-button uk-button-default uk-margin-small-right",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('back'))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Zur\xfcck")), 1),
            (0, $ani5R.createElementVNode)("button", {
                class: "uk-button uk-button-primary",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.next && $options.next(...args))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Weiter")), 1)
        ])
    ]);
}

});

parcelRegister("8ogmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bd418181c9b5b7$export$2e2bcd8739ae039);
let $61bd418181c9b5b7$var$NOOP = ()=>{};
var $61bd418181c9b5b7$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("arXM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $79bacae9bdcd1514$export$2e2bcd8739ae039);
let $79bacae9bdcd1514$var$script;



let $79bacae9bdcd1514$var$initialize = ()=>{
    $79bacae9bdcd1514$var$script = (parcelRequire("lDfor"));
    if ($79bacae9bdcd1514$var$script.__esModule) $79bacae9bdcd1514$var$script = $79bacae9bdcd1514$var$script.default;
    $79bacae9bdcd1514$var$script.render = (parcelRequire("5D5T7")).render;
    (parcelRequire("ldaG1")).default($79bacae9bdcd1514$var$script);
    $79bacae9bdcd1514$var$script.__scopeId = 'data-v-708295';
    $79bacae9bdcd1514$var$script.__file = "Navigation.vue";
};
$79bacae9bdcd1514$var$initialize();
var $79bacae9bdcd1514$export$2e2bcd8739ae039 = $79bacae9bdcd1514$var$script;

});
parcelRegister("lDfor", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fbf92e42758201f2$export$2e2bcd8739ae039);

var $6oQp6 = parcelRequire("6oQp6");
var $fbf92e42758201f2$export$2e2bcd8739ae039 = {
    mixins: [
        (0, $6oQp6.default)
    ],
    props: [
        'currentStep',
        'twoColumns',
        'small'
    ],
    data: ()=>{
        return {};
    },
    computed: {
        hasTickets () {
            return Object.keys(this.store.state.selection).length;
        },
        personalizable () {
            return this.store.state.personalize && !this.store.state.onlyNoChipTicketsSelected;
        },
        personalizabled () {
            return !this.store.state.personalize || this.store.state.personalize && this.store.state.personalized;
        },
        allDataCollected () {
            return this.store.state.allDataCollected;
        }
    },
    mounted () {},
    methods: {}
};

});

parcelRegister("5D5T7", function(module, exports) {

$parcel$export(module.exports, "render", () => $41952987878c3394$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
function $41952987878c3394$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", {
        ref: "switcher",
        "uk-tab": "connect: #component-tab-left; animation: uk-animation-fade; media: @m",
        class: (0, $X5A94.normalizeClass)({
            'uk-tab-left': !$props.small && $props.twoColumns
        })
    }, [
        (0, $ani5R.createElementVNode)("li", {
            class: (0, $X5A94.normalizeClass)({
                'uk-active': $props.currentStep === 0
            })
        }, [
            (0, $ani5R.createElementVNode)("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('updatePage', 0))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Ticket w\xe4hlen")), 1)
        ], 2),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("li", {
            class: (0, $X5A94.normalizeClass)({
                'uk-active': $props.currentStep === 1
            })
        }, [
            (0, $ani5R.createElementVNode)("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('updatePage', 1))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Personalisieren")), 1)
        ], 2), [
            [
                (0, $dDLnc.vShow),
                $options.hasTickets && $options.personalizable
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("li", {
            class: (0, $X5A94.normalizeClass)({
                'uk-active': $props.currentStep === 2
            })
        }, [
            (0, $ani5R.createElementVNode)("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('updatePage', 2))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Checkout")), 1)
        ], 2), [
            [
                (0, $dDLnc.vShow),
                $options.hasTickets && $options.personalizabled
            ]
        ]),
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("li", {
            class: (0, $X5A94.normalizeClass)({
                'uk-active': $props.currentStep === 3
            })
        }, [
            (0, $ani5R.createElementVNode)("a", {
                href: "#",
                onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit('updatePage', 3))
            }, (0, $X5A94.toDisplayString)(_ctx.$t("Zusammenfassung")), 1)
        ], 2), [
            [
                (0, $dDLnc.vShow),
                $options.allDataCollected
            ]
        ])
    ], 2);
}

});

parcelRegister("ldaG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f713180c96c13c54$export$2e2bcd8739ae039);
let $f713180c96c13c54$var$NOOP = ()=>{};
var $f713180c96c13c54$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3JpMF", function(module, exports) {

$parcel$export(module.exports, "render", () => $2b7993391a253518$export$b3890eb0ae9dca99);
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
const $2b7993391a253518$var$_hoisted_1 = {
    key: 0,
    "uk-alert": ""
};
const $2b7993391a253518$var$_hoisted_2 = {
    class: "uk-text-small"
};
const $2b7993391a253518$var$_hoisted_3 = {
    "data-request": "onShopLogout",
    "data-request-success": "window.location.href = data.redirectUrl;"
};
const $2b7993391a253518$var$_hoisted_4 = {
    key: 1,
    style: {
        "position": "fixed",
        "inset": "0",
        "z-index": "2147483600",
        "background": "rgba(255,255,255,0.55)",
        "backdrop-filter": "blur(2px)",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
    }
};
const $2b7993391a253518$var$_hoisted_5 = {
    key: 2,
    class: "uk-alert-danger uk-padding",
    "uk-alert": ""
};
const $2b7993391a253518$var$_hoisted_6 = {
    class: "uk-grid"
};
const $2b7993391a253518$var$_hoisted_7 = {
    class: "uk-width-3-4"
};
const $2b7993391a253518$var$_hoisted_8 = {
    key: 3,
    class: "uk-alert-success uk-padding",
    style: {
        "background-color": "var(--color1)",
        "color": "white"
    },
    "uk-alert": ""
};
const $2b7993391a253518$var$_hoisted_9 = {
    class: "uk-grid"
};
const $2b7993391a253518$var$_hoisted_10 = [
    "innerHTML"
];
const $2b7993391a253518$var$_hoisted_11 = {
    key: 4,
    id: "shop-wrapper",
    "uk-grid": ""
};
const $2b7993391a253518$var$_hoisted_12 = {
    class: "uk-width-expand@m uk-position-relative"
};
const $2b7993391a253518$var$_hoisted_13 = {
    id: "component-tab-left",
    class: "uk-switcher",
    ref: "switcher"
};
function $2b7993391a253518$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_navigation = (0, $ani5R.resolveComponent)("navigation");
    const _component_ticket_list = (0, $ani5R.resolveComponent)("ticket-list");
    const _component_personalize_tickets = (0, $ani5R.resolveComponent)("personalize-tickets");
    const _component_checkout = (0, $ani5R.resolveComponent)("checkout");
    const _component_order_summary = (0, $ani5R.resolveComponent)("order-summary");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", null, [
        $props.loginusername ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2b7993391a253518$var$_hoisted_1, [
            (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.$t('Vor-Ort Ticketshop')), 1),
            (0, $ani5R.createElementVNode)("p", $2b7993391a253518$var$_hoisted_2, [
                (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.$t('Eingeloggt als:')) + " " + (0, $X5A94.toDisplayString)($props.loginusername) + " ", 1),
                (0, $ani5R.createElementVNode)("a", $2b7993391a253518$var$_hoisted_3, (0, $X5A94.toDisplayString)(_ctx.$t('Ausloggen')), 1)
            ])
        ])) : (0, $ani5R.createCommentVNode)("", true),
        _ctx.store.state.loading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2b7993391a253518$var$_hoisted_4, _cache[0] || (_cache[0] = [
            (0, $ani5R.createElementVNode)("img", {
                src: "/plugins/kosmoskosmos/festiware/assets/images/festiware_loading-spinner_v1.svg",
                alt: "Loading",
                style: {
                    "width": "128px",
                    "height": "128px"
                }
            }, null, -1)
        ]))) : (0, $ani5R.createCommentVNode)("", true),
        _ctx.hasErrors ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2b7993391a253518$var$_hoisted_5, [
            (0, $ani5R.createElementVNode)("div", $2b7993391a253518$var$_hoisted_6, [
                _cache[1] || (_cache[1] = (0, $ani5R.createElementVNode)("div", {
                    class: "uk-width-1-6"
                }, [
                    (0, $ani5R.createElementVNode)("i", {
                        "uk-icon": "icon:warning; ratio: 5"
                    })
                ], -1)),
                (0, $ani5R.createElementVNode)("div", $2b7993391a253518$var$_hoisted_7, [
                    (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.errorHeadline || _ctx.$t('Oh nein! Ein Fehler trat auf')), 1),
                    (0, $ani5R.createElementVNode)("p", null, (0, $X5A94.toDisplayString)(_ctx.errorMessage), 1)
                ])
            ])
        ])) : _ctx.hasSuccess ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2b7993391a253518$var$_hoisted_8, [
            (0, $ani5R.createElementVNode)("div", $2b7993391a253518$var$_hoisted_9, [
                _cache[2] || (_cache[2] = (0, $ani5R.createElementVNode)("div", {
                    class: "uk-width-1-6"
                }, [
                    (0, $ani5R.createElementVNode)("i", {
                        "uk-icon": "icon:happy; ratio: 5"
                    })
                ], -1)),
                (0, $ani5R.createElementVNode)("div", null, [
                    (0, $ani5R.createElementVNode)("h3", null, (0, $X5A94.toDisplayString)(_ctx.$t("Vielen Dank f\xfcr die Bestellung!")), 1),
                    (0, $ani5R.createElementVNode)("p", null, (0, $X5A94.toDisplayString)(_ctx.$t("In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.")), 1),
                    _ctx.settings.outro_text ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 0,
                        class: "uk-margin-medium-bottom uk-margin-medium-top",
                        innerHTML: _ctx.settings.outro_text
                    }, null, 8, $2b7993391a253518$var$_hoisted_10)) : (0, $ani5R.createCommentVNode)("", true)
                ])
            ])
        ])) : _ctx.store.state.initialized ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", $2b7993391a253518$var$_hoisted_11, [
            _ctx.settings.showNav ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                key: 0,
                class: (0, $X5A94.normalizeClass)([
                    "uk-width-1-1",
                    {
                        'uk-width-1-5@s': _ctx.settings.twoColumns
                    }
                ])
            }, [
                (0, $ani5R.createVNode)(_component_navigation, {
                    "current-step": _ctx.store.state.currentStep,
                    onUpdatePage: $options.updatePage,
                    twoColumns: _ctx.settings.twoColumns,
                    small: _ctx.small
                }, null, 8, [
                    "current-step",
                    "onUpdatePage",
                    "twoColumns",
                    "small"
                ])
            ], 2)) : (0, $ani5R.createCommentVNode)("", true),
            (0, $ani5R.createElementVNode)("div", $2b7993391a253518$var$_hoisted_12, [
                (0, $ani5R.createElementVNode)("ul", $2b7993391a253518$var$_hoisted_13, [
                    (0, $ani5R.createElementVNode)("li", {
                        class: (0, $X5A94.normalizeClass)({
                            'uk-active': _ctx.store.state.currentStep === 0,
                            'ticket-list': true
                        })
                    }, [
                        _ctx.store.state.currentStep === 0 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ticket_list, {
                            key: 0,
                            settings: _ctx.settings,
                            initialOfferId: $props.initialOfferId,
                            preselectedCategory: $props.preselectedCategory,
                            initialCouponCode: $props.initialCouponCode,
                            onNext: $options.next
                        }, null, 8, [
                            "settings",
                            "initialOfferId",
                            "preselectedCategory",
                            "initialCouponCode",
                            "onNext"
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ], 2),
                    (0, $ani5R.createElementVNode)("li", {
                        class: (0, $X5A94.normalizeClass)({
                            'uk-active': _ctx.store.state.currentStep === 1,
                            'personalize': true
                        })
                    }, [
                        _ctx.store.state.currentStep === 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_personalize_tickets, {
                            key: 0,
                            onNext: $options.next,
                            onBack: $options.back,
                            settings: _ctx.settings
                        }, null, 8, [
                            "onNext",
                            "onBack",
                            "settings"
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ], 2),
                    (0, $ani5R.createElementVNode)("li", {
                        class: (0, $X5A94.normalizeClass)({
                            'uk-active': _ctx.store.state.currentStep === 2,
                            'checkout': true
                        })
                    }, [
                        _ctx.store.state.currentStep === 2 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_checkout, {
                            key: 0,
                            settings: _ctx.settings,
                            loginusername: $props.loginusername,
                            onNext: $options.next,
                            onBack: $options.back
                        }, null, 8, [
                            "settings",
                            "loginusername",
                            "onNext",
                            "onBack"
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ], 2),
                    (0, $ani5R.createElementVNode)("li", {
                        class: (0, $X5A94.normalizeClass)({
                            'uk-active': _ctx.store.state.currentStep === 3,
                            'order-summary': true
                        })
                    }, [
                        _ctx.store.state.currentStep === 3 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_order_summary, {
                            key: 0,
                            settings: _ctx.settings,
                            loginusername: $props.loginusername,
                            onBack: $options.back
                        }, null, 8, [
                            "settings",
                            "loginusername",
                            "onBack"
                        ])) : (0, $ani5R.createCommentVNode)("", true)
                    ], 2)
                ], 512)
            ])
        ])) : (0, $ani5R.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("bON8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $89aa7a958b96d39c$export$2e2bcd8739ae039);
let $89aa7a958b96d39c$var$NOOP = ()=>{};
var $89aa7a958b96d39c$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("1M2zR", function(module, exports) {

$parcel$export(module.exports, "DatetimeFormat", () => $119be03f5b7cea55$export$64ca50867510e64e, (v) => $119be03f5b7cea55$export$64ca50867510e64e = v);
$parcel$export(module.exports, "I18nD", () => $119be03f5b7cea55$export$c741260b89dcb234, (v) => $119be03f5b7cea55$export$c741260b89dcb234 = v);
$parcel$export(module.exports, "I18nInjectionKey", () => $119be03f5b7cea55$export$b19990ca6e622dd2, (v) => $119be03f5b7cea55$export$b19990ca6e622dd2 = v);
$parcel$export(module.exports, "I18nN", () => $119be03f5b7cea55$export$4665d24327644133, (v) => $119be03f5b7cea55$export$4665d24327644133 = v);
$parcel$export(module.exports, "I18nT", () => $119be03f5b7cea55$export$1d08de71ac06ffd6, (v) => $119be03f5b7cea55$export$1d08de71ac06ffd6 = v);
$parcel$export(module.exports, "NumberFormat", () => $119be03f5b7cea55$export$27bce688931fdfcc, (v) => $119be03f5b7cea55$export$27bce688931fdfcc = v);
$parcel$export(module.exports, "Translation", () => $119be03f5b7cea55$export$b63289fbda65eed1, (v) => $119be03f5b7cea55$export$b63289fbda65eed1 = v);
$parcel$export(module.exports, "VERSION", () => $119be03f5b7cea55$export$a4ad2735b021c132, (v) => $119be03f5b7cea55$export$a4ad2735b021c132 = v);
$parcel$export(module.exports, "createI18n", () => $119be03f5b7cea55$export$920091e3d72d80ee, (v) => $119be03f5b7cea55$export$920091e3d72d80ee = v);
$parcel$export(module.exports, "useI18n", () => $119be03f5b7cea55$export$3f3caade1c12f8c9, (v) => $119be03f5b7cea55$export$3f3caade1c12f8c9 = v);
$parcel$export(module.exports, "vTDirective", () => $119be03f5b7cea55$export$8a5a05546006d0b5, (v) => $119be03f5b7cea55$export$8a5a05546006d0b5 = v);
/*!
  * vue-i18n v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ var $119be03f5b7cea55$export$64ca50867510e64e;
var $119be03f5b7cea55$export$c741260b89dcb234;
var $119be03f5b7cea55$export$b19990ca6e622dd2;
var $119be03f5b7cea55$export$4665d24327644133;
var $119be03f5b7cea55$export$1d08de71ac06ffd6;
var $119be03f5b7cea55$export$27bce688931fdfcc;
var $119be03f5b7cea55$export$b63289fbda65eed1;
var $119be03f5b7cea55$export$a4ad2735b021c132;
var $119be03f5b7cea55$export$920091e3d72d80ee;
var $119be03f5b7cea55$export$3f3caade1c12f8c9;
var $119be03f5b7cea55$export$8a5a05546006d0b5;
'use strict';

var $ei7AW = parcelRequire("ei7AW");
var $6ZJ5y = parcelRequire("6ZJ5y");

var $9FmEQ = parcelRequire("9FmEQ");
parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $119be03f5b7cea55$var$VERSION = '11.1.2';
const $119be03f5b7cea55$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $ei7AW.CORE_ERROR_CODES_EXTEND_POINT,
    // legacy module errors
    INVALID_ARGUMENT: 25,
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: 26,
    NOT_INSTALLED: 27,
    // directive module errors
    REQUIRED_VALUE: 28,
    INVALID_VALUE: 29,
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
    NOT_INSTALLED_WITH_PROVIDE: 31,
    // unexpected error
    UNEXPECTED_ERROR: 32,
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function $119be03f5b7cea55$var$createI18nError(code, ...args) {
    return $6ZJ5y.createCompileError(code, null, undefined);
}
const $119be03f5b7cea55$var$TranslateVNodeSymbol = /* #__PURE__*/ $9FmEQ.makeSymbol('__translateVNode');
const $119be03f5b7cea55$var$DatetimePartsSymbol = /* #__PURE__*/ $9FmEQ.makeSymbol('__datetimeParts');
const $119be03f5b7cea55$var$NumberPartsSymbol = /* #__PURE__*/ $9FmEQ.makeSymbol('__numberParts');
const $119be03f5b7cea55$var$SetPluralRulesSymbol = $9FmEQ.makeSymbol('__setPluralRules');
$9FmEQ.makeSymbol('__intlifyMeta');
const $119be03f5b7cea55$var$InejctWithOptionSymbol = /* #__PURE__*/ $9FmEQ.makeSymbol('__injectWithOption');
const $119be03f5b7cea55$var$DisposeSymbol = /* #__PURE__*/ $9FmEQ.makeSymbol('__dispose');
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $119be03f5b7cea55$var$handleFlatJson(obj) {
    // check obj
    if (!$9FmEQ.isObject(obj)) return obj;
    for(const key in obj){
        // check key
        if (!$9FmEQ.hasOwn(obj, key)) continue;
        // handle for normal json
        if (!key.includes('.')) // recursive process value if value is also a object
        {
            if ($9FmEQ.isObject(obj[key])) $119be03f5b7cea55$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (subKeys[i] === '__proto__') throw new Error(`unsafe key: ${subKeys[i]}`);
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = $9FmEQ.create();
                if (!$9FmEQ.isObject(currentObj[subKeys[i]])) {
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                currentObj[subKeys[lastIndex]] = obj[key];
                delete obj[key];
            }
            // recursive process value if value is also a object
            if ($9FmEQ.isObject(currentObj[subKeys[lastIndex]])) $119be03f5b7cea55$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $119be03f5b7cea55$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = $9FmEQ.isPlainObject(messages) ? messages : $9FmEQ.isArray(__i18n) ? $9FmEQ.create() : {
        [locale]: $9FmEQ.create()
    };
    // merge locale messages of i18n custom block
    if ($9FmEQ.isArray(__i18n)) __i18n.forEach((custom)=>{
        if ('locale' in custom && 'resource' in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || $9FmEQ.create();
                $9FmEQ.deepCopy(resource, ret[locale]);
            } else $9FmEQ.deepCopy(resource, ret);
        } else $9FmEQ.isString(custom) && $9FmEQ.deepCopy(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ($9FmEQ.hasOwn(ret, key)) $119be03f5b7cea55$var$handleFlatJson(ret[key]);
    }
    return ret;
}
function $119be03f5b7cea55$var$getComponentOptions(instance) {
    return instance.type;
}
function $119be03f5b7cea55$var$adjustI18nResources(gl, options, componentOptions) {
    // prettier-ignore
    let messages = $9FmEQ.isObject(options.messages) ? options.messages : $9FmEQ.create();
    if ('__i18nGlobal' in componentOptions) messages = $119be03f5b7cea55$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ($9FmEQ.isObject(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ($9FmEQ.isObject(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $119be03f5b7cea55$var$createTextNode(key) {
    return $ani5R.createVNode($ani5R.Text, null, key, 0);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $119be03f5b7cea55$var$DEVTOOLS_META = '__INTLIFY_META__';
const $119be03f5b7cea55$var$NOOP_RETURN_ARRAY = ()=>[];
const $119be03f5b7cea55$var$NOOP_RETURN_FALSE = ()=>false;
let $119be03f5b7cea55$var$composerID = 0;
function $119be03f5b7cea55$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, $ani5R.getCurrentInstance() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $119be03f5b7cea55$var$getMetaInfo = ()=>{
    const instance = $ani5R.getCurrentInstance();
    let meta = null;
    return instance && (meta = $119be03f5b7cea55$var$getComponentOptions(instance)[$119be03f5b7cea55$var$DEVTOOLS_META]) ? {
        [$119be03f5b7cea55$var$DEVTOOLS_META]: meta
    } : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ function $119be03f5b7cea55$var$createComposer(options = {}) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = $9FmEQ.inBrowser ? $8bTPG.ref : $8bTPG.shallowRef;
    let _inheritLocale = $9FmEQ.isBoolean(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : $9FmEQ.isString(options.locale) ? options.locale : $ei7AW.DEFAULT_LOCALE);
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : $9FmEQ.isString(options.fallbackLocale) || $9FmEQ.isArray(options.fallbackLocale) || $9FmEQ.isPlainObject(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($119be03f5b7cea55$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref($9FmEQ.isPlainObject(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref($9FmEQ.isPlainObject(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : $9FmEQ.isBoolean(options.missingWarn) || $9FmEQ.isRegExp(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : $9FmEQ.isBoolean(options.fallbackWarn) || $9FmEQ.isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : $9FmEQ.isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = $9FmEQ.isFunction(options.missing) ? options.missing : null;
    let _runtimeMissing = $9FmEQ.isFunction(options.missing) ? $119be03f5b7cea55$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = $9FmEQ.isFunction(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : $9FmEQ.isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : $9FmEQ.isPlainObject(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && $ei7AW.setFallbackContext(null);
        const ctxOptions = {
            version: $119be03f5b7cea55$var$VERSION,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: 'vue'
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = $9FmEQ.isPlainObject(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = $9FmEQ.isPlainObject(_context) ? _context.__numberFormatters : undefined;
        const ctx = $ei7AW.createCoreContext(ctxOptions);
        _isGlobal && $ei7AW.setFallbackContext(ctx);
        return ctx;
    };
    _context = getCoreContext();
    $ei7AW.updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = $8bTPG.computed({
        get: ()=>_locale.value,
        set: (val1)=>{
            _context.locale = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = $8bTPG.computed({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _context.fallbackLocale = val1;
            _fallbackLocale.value = val1;
            $ei7AW.updateFallbackLocale(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = $8bTPG.computed(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ $8bTPG.computed(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ $8bTPG.computed(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return $9FmEQ.isFunction(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $119be03f5b7cea55$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (!_isGlobal) _context.fallbackContext = __root ? $ei7AW.getFallbackContext() : undefined;
            ret = fn(_context);
        } finally{
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== 'translate exists' && // for not `te` (e.g `t`)
        $9FmEQ.isNumber(ret) && ret === $ei7AW.NOT_REOSLVED || warnType === 'translate exists' && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply($ei7AW.translate, null, [
                context,
                ...args
            ]), ()=>$ei7AW.parseTranslateArgs(...args), 'translate', (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>$9FmEQ.isString(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !$9FmEQ.isObject(arg3)) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            $9FmEQ.assign({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply($ei7AW.datetime, null, [
                context,
                ...args
            ]), ()=>$ei7AW.parseDateTimeArgs(...args), 'datetime format', (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>$ei7AW.MISSING_RESOLVE_VALUE, (val1)=>$9FmEQ.isString(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply($ei7AW.number, null, [
                context,
                ...args
            ]), ()=>$ei7AW.parseNumberArgs(...args), 'number format', (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>$ei7AW.MISSING_RESOLVE_VALUE, (val1)=>$9FmEQ.isString(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>$9FmEQ.isString(val1) || $9FmEQ.isNumber(val1) || $9FmEQ.isBoolean(val1) ? $119be03f5b7cea55$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: 'vnode'
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply($ei7AW.translate, null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>$ei7AW.parseTranslateArgs(...args), 'translate', (root)=>root[$119be03f5b7cea55$var$TranslateVNodeSymbol](...args), (key)=>[
                $119be03f5b7cea55$var$createTextNode(key)
            ], (val1)=>$9FmEQ.isArray(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply($ei7AW.number, null, [
                context,
                ...args
            ]), ()=>$ei7AW.parseNumberArgs(...args), 'number format', (root)=>root[$119be03f5b7cea55$var$NumberPartsSymbol](...args), $119be03f5b7cea55$var$NOOP_RETURN_ARRAY, (val1)=>$9FmEQ.isString(val1) || $9FmEQ.isArray(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply($ei7AW.datetime, null, [
                context,
                ...args
            ]), ()=>$ei7AW.parseDateTimeArgs(...args), 'datetime format', (root)=>root[$119be03f5b7cea55$var$DatetimePartsSymbol](...args), $119be03f5b7cea55$var$NOOP_RETURN_ARRAY, (val1)=>$9FmEQ.isString(val1) || $9FmEQ.isArray(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = $9FmEQ.isString(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return $ei7AW.isMessageAST(resolved) || $ei7AW.isMessageFunction(resolved) || $9FmEQ.isString(resolved);
        }, ()=>[
                key
            ], 'translate exists', (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $119be03f5b7cea55$var$NOOP_RETURN_FALSE, (val1)=>$9FmEQ.isBoolean(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = $ei7AW.fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ($9FmEQ.hasOwn(_message, key)) $119be03f5b7cea55$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ($9FmEQ.hasOwn(_message, key)) $119be03f5b7cea55$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        $9FmEQ.deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        $ei7AW.clearDateTimeFormat(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = $9FmEQ.assign(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        $ei7AW.clearDateTimeFormat(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        $ei7AW.clearNumberFormat(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = $9FmEQ.assign(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        $ei7AW.clearNumberFormat(_context, locale, format);
    }
    // for debug
    $119be03f5b7cea55$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && $9FmEQ.inBrowser) {
        $8bTPG.watch(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                $ei7AW.updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
        $8bTPG.watch(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                $ei7AW.updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $119be03f5b7cea55$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                $ei7AW.updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$119be03f5b7cea55$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$119be03f5b7cea55$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$119be03f5b7cea55$var$TranslateVNodeSymbol] = translateVNode;
    composer[$119be03f5b7cea55$var$DatetimePartsSymbol] = datetimeParts;
    composer[$119be03f5b7cea55$var$NumberPartsSymbol] = numberParts;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $119be03f5b7cea55$var$convertComposerOptions(options) {
    const locale = $9FmEQ.isString(options.locale) ? options.locale : $ei7AW.DEFAULT_LOCALE;
    const fallbackLocale = $9FmEQ.isString(options.fallbackLocale) || $9FmEQ.isArray(options.fallbackLocale) || $9FmEQ.isPlainObject(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = $9FmEQ.isFunction(options.missing) ? options.missing : undefined;
    const missingWarn = $9FmEQ.isBoolean(options.silentTranslationWarn) || $9FmEQ.isRegExp(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = $9FmEQ.isBoolean(options.silentFallbackWarn) || $9FmEQ.isRegExp(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = $9FmEQ.isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = $9FmEQ.isPlainObject(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = $9FmEQ.isFunction(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = $9FmEQ.isString(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== 'off' : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = $9FmEQ.isBoolean(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ($9FmEQ.isPlainObject(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            $9FmEQ.assign(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 *
 * @deprecated will be removed at vue-i18n v12
 */ function $119be03f5b7cea55$var$createVueI18n(options = {}) {
    const composer = $119be03f5b7cea55$var$createComposer($119be03f5b7cea55$var$convertComposerOptions(options));
    const { __extender: __extender } = options;
    // defines VueI18n
    const vueI18n = {
        // id
        id: composer.id,
        // locale
        get locale () {
            return composer.locale.value;
        },
        set locale (val){
            composer.locale.value = val;
        },
        // fallbackLocale
        get fallbackLocale () {
            return composer.fallbackLocale.value;
        },
        set fallbackLocale (val){
            composer.fallbackLocale.value = val;
        },
        // messages
        get messages () {
            return composer.messages.value;
        },
        // datetimeFormats
        get datetimeFormats () {
            return composer.datetimeFormats.value;
        },
        // numberFormats
        get numberFormats () {
            return composer.numberFormats.value;
        },
        // availableLocales
        get availableLocales () {
            return composer.availableLocales;
        },
        // missing
        get missing () {
            return composer.getMissingHandler();
        },
        set missing (handler){
            composer.setMissingHandler(handler);
        },
        // silentTranslationWarn
        get silentTranslationWarn () {
            return $9FmEQ.isBoolean(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
        },
        set silentTranslationWarn (val){
            composer.missingWarn = $9FmEQ.isBoolean(val) ? !val : val;
        },
        // silentFallbackWarn
        get silentFallbackWarn () {
            return $9FmEQ.isBoolean(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
        },
        set silentFallbackWarn (val){
            composer.fallbackWarn = $9FmEQ.isBoolean(val) ? !val : val;
        },
        // modifiers
        get modifiers () {
            return composer.modifiers;
        },
        // formatFallbackMessages
        get formatFallbackMessages () {
            return composer.fallbackFormat;
        },
        set formatFallbackMessages (val){
            composer.fallbackFormat = val;
        },
        // postTranslation
        get postTranslation () {
            return composer.getPostTranslationHandler();
        },
        set postTranslation (handler){
            composer.setPostTranslationHandler(handler);
        },
        // sync
        get sync () {
            return composer.inheritLocale;
        },
        set sync (val){
            composer.inheritLocale = val;
        },
        // warnInHtmlMessage
        get warnHtmlInMessage () {
            return composer.warnHtmlMessage ? 'warn' : 'off';
        },
        set warnHtmlInMessage (val){
            composer.warnHtmlMessage = val !== 'off';
        },
        // escapeParameterHtml
        get escapeParameterHtml () {
            return composer.escapeParameter;
        },
        set escapeParameterHtml (val){
            composer.escapeParameter = val;
        },
        // pluralizationRules
        get pluralizationRules () {
            return composer.pluralRules || {};
        },
        // for internal
        __composer: composer,
        // t
        t (...args) {
            return Reflect.apply(composer.t, composer, [
                ...args
            ]);
        },
        // rt
        rt (...args) {
            return Reflect.apply(composer.rt, composer, [
                ...args
            ]);
        },
        // te
        te (key, locale) {
            return composer.te(key, locale);
        },
        // tm
        tm (key) {
            return composer.tm(key);
        },
        // getLocaleMessage
        getLocaleMessage (locale) {
            return composer.getLocaleMessage(locale);
        },
        // setLocaleMessage
        setLocaleMessage (locale, message) {
            composer.setLocaleMessage(locale, message);
        },
        // mergeLocaleMessage
        mergeLocaleMessage (locale, message) {
            composer.mergeLocaleMessage(locale, message);
        },
        // d
        d (...args) {
            return Reflect.apply(composer.d, composer, [
                ...args
            ]);
        },
        // getDateTimeFormat
        getDateTimeFormat (locale) {
            return composer.getDateTimeFormat(locale);
        },
        // setDateTimeFormat
        setDateTimeFormat (locale, format) {
            composer.setDateTimeFormat(locale, format);
        },
        // mergeDateTimeFormat
        mergeDateTimeFormat (locale, format) {
            composer.mergeDateTimeFormat(locale, format);
        },
        // n
        n (...args) {
            return Reflect.apply(composer.n, composer, [
                ...args
            ]);
        },
        // getNumberFormat
        getNumberFormat (locale) {
            return composer.getNumberFormat(locale);
        },
        // setNumberFormat
        setNumberFormat (locale, format) {
            composer.setNumberFormat(locale, format);
        },
        // mergeNumberFormat
        mergeNumberFormat (locale, format) {
            composer.mergeNumberFormat(locale, format);
        }
    };
    vueI18n.__extender = __extender;
    return vueI18n;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $119be03f5b7cea55$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = $ani5R.getCurrentInstance();
            /* istanbul ignore if */ if (!instance) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $119be03f5b7cea55$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $119be03f5b7cea55$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $119be03f5b7cea55$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $119be03f5b7cea55$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $119be03f5b7cea55$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {},
        unmounted () {
            const instance = $ani5R.getCurrentInstance();
            /* istanbul ignore if */ if (!instance) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            delete this.$t;
            delete this.$rt;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $119be03f5b7cea55$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$119be03f5b7cea55$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $119be03f5b7cea55$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
const $119be03f5b7cea55$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === 'parent' || val1 === 'global',
        default: 'parent' /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $119be03f5b7cea55$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === $ani5R.Fragment ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, $9FmEQ.create());
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $119be03f5b7cea55$var$getFragmentableTag() {
    return $ani5R.Fragment;
}
const $119be03f5b7cea55$var$TranslationImpl = /*#__PURE__*/ $ani5R.defineComponent({
    /* eslint-disable */ name: 'i18n-t',
    props: $9FmEQ.assign({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            validator: (val1)=>$9FmEQ.isNumber(val1) || !isNaN(val1)
        }
    }, $119be03f5b7cea55$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $119be03f5b7cea55$var$useI18n({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== '_');
            const options = $9FmEQ.create();
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = $9FmEQ.isString(props.plural) ? +props.plural : props.plural;
            const arg = $119be03f5b7cea55$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$119be03f5b7cea55$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = $9FmEQ.assign($9FmEQ.create(), attrs);
            const tag = $9FmEQ.isString(props.tag) || $9FmEQ.isObject(props.tag) ? props.tag : $119be03f5b7cea55$var$getFragmentableTag();
            return $ani5R.h(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $119be03f5b7cea55$var$Translation = $119be03f5b7cea55$var$TranslationImpl;
const $119be03f5b7cea55$var$I18nT = $119be03f5b7cea55$var$Translation;
function $119be03f5b7cea55$var$isVNode(target) {
    return $9FmEQ.isArray(target) && !$9FmEQ.isString(target[0]);
}
function $119be03f5b7cea55$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = $9FmEQ.create();
        if (props.locale) options.locale = props.locale;
        if ($9FmEQ.isString(props.format)) options.key = props.format;
        else if ($9FmEQ.isObject(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ($9FmEQ.isString(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? $9FmEQ.assign($9FmEQ.create(), options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, $9FmEQ.create());
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ($9FmEQ.isArray(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($119be03f5b7cea55$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ($9FmEQ.isString(parts)) children = [
            parts
        ];
        const assignedAttrs = $9FmEQ.assign($9FmEQ.create(), attrs);
        const tag = $9FmEQ.isString(props.tag) || $9FmEQ.isObject(props.tag) ? props.tag : $119be03f5b7cea55$var$getFragmentableTag();
        return $ani5R.h(tag, assignedAttrs, children);
    };
}
const $119be03f5b7cea55$var$NumberFormatImpl = /*#__PURE__*/ $ani5R.defineComponent({
    /* eslint-disable */ name: 'i18n-n',
    props: $9FmEQ.assign({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $119be03f5b7cea55$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $119be03f5b7cea55$var$useI18n({
            useScope: props.scope,
            __useComponent: true
        });
        return $119be03f5b7cea55$var$renderFormatter(props, context, $ei7AW.NUMBER_FORMAT_OPTIONS_KEYS, (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$119be03f5b7cea55$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $119be03f5b7cea55$var$NumberFormat = $119be03f5b7cea55$var$NumberFormatImpl;
const $119be03f5b7cea55$var$I18nN = $119be03f5b7cea55$var$NumberFormat;
function $119be03f5b7cea55$var$getComposer$1(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === 'composition') return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
/**
 * @deprecated will be removed at vue-i18n v12
 */ function $119be03f5b7cea55$var$vTDirective(i18n) {
    const _process = (binding)=>{
        const { instance: instance, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $119be03f5b7cea55$var$getComposer$1(i18n, instance.$);
        const parsedValue = $119be03f5b7cea55$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$119be03f5b7cea55$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ($9FmEQ.inBrowser && i18n.global === composer) // global scope only
        el.__i18nWatcher = $8bTPG.watch(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ($9FmEQ.inBrowser && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $119be03f5b7cea55$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$119be03f5b7cea55$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $119be03f5b7cea55$var$parseValue(value) {
    if ($9FmEQ.isString(value)) return {
        path: value
    };
    else if ($9FmEQ.isPlainObject(value)) {
        if (!('path' in value)) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.REQUIRED_VALUE, 'path');
        return value;
    } else throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.INVALID_VALUE);
}
function $119be03f5b7cea55$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ($9FmEQ.isString(locale)) options.locale = locale;
    if ($9FmEQ.isNumber(choice)) options.plural = choice;
    if ($9FmEQ.isNumber(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $119be03f5b7cea55$var$apply(app, i18n, ...options) {
    const pluginOptions = $9FmEQ.isPlainObject(options[0]) ? options[0] : {};
    const globalInstall = $9FmEQ.isBoolean(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        [
            $119be03f5b7cea55$var$Translation.name,
            'I18nT'
        ].forEach((name)=>app.component(name, $119be03f5b7cea55$var$Translation));
        [
            $119be03f5b7cea55$var$NumberFormat.name,
            'I18nN'
        ].forEach((name)=>app.component(name, $119be03f5b7cea55$var$NumberFormat));
        [
            $119be03f5b7cea55$var$DatetimeFormat.name,
            'I18nD'
        ].forEach((name)=>app.component(name, $119be03f5b7cea55$var$DatetimeFormat));
    }
    app.directive('t', $119be03f5b7cea55$var$vTDirective(i18n));
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $119be03f5b7cea55$var$I18nInjectionKey = /* #__PURE__*/ $9FmEQ.makeSymbol('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $119be03f5b7cea55$var$createI18n(options = {}) {
    // prettier-ignore
    const __legacyMode = $9FmEQ.isBoolean(options.legacy) ? options.legacy : true;
    // prettier-ignore
    const __globalInjection = $9FmEQ.isBoolean(options.globalInjection) ? options.globalInjection : true;
    const __instances = new Map();
    const [globalScope, __global] = $119be03f5b7cea55$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ $9FmEQ.makeSymbol('');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    const i18n = {
        // mode
        get mode () {
            return __legacyMode ? 'legacy' : 'composition';
        },
        // install plugin
        async install (app, ...options) {
            // setup global provider
            app.__VUE_I18N_SYMBOL__ = symbol;
            app.provide(app.__VUE_I18N_SYMBOL__, i18n);
            // set composer & vuei18n extend hook options from plugin options
            if ($9FmEQ.isPlainObject(options[0])) {
                const opts = options[0];
                i18n.__composerExtend = opts.__composerExtend;
                i18n.__vueI18nExtend = opts.__vueI18nExtend;
            }
            // global method and properties injection for Composition API
            let globalReleaseHandler = null;
            if (!__legacyMode && __globalInjection) globalReleaseHandler = $119be03f5b7cea55$var$injectGlobalFields(app, i18n.global);
            $119be03f5b7cea55$var$apply(app, i18n, ...options);
            // setup mixin for Legacy API
            if (__legacyMode) app.mixin($119be03f5b7cea55$var$defineMixin(__global, __global.__composer, i18n));
            // release global scope
            const unmountApp = app.unmount;
            app.unmount = ()=>{
                globalReleaseHandler && globalReleaseHandler();
                i18n.dispose();
                unmountApp();
            };
        },
        // global accessor
        get global () {
            return __global;
        },
        dispose () {
            globalScope.stop();
        },
        __instances: // @internal
        __instances,
        __getInstance: // @internal
        __getInstance,
        __setInstance: // @internal
        __setInstance,
        __deleteInstance: // @internal
        __deleteInstance
    };
    return i18n;
}
function $119be03f5b7cea55$var$useI18n(options = {}) {
    const instance = $ani5R.getCurrentInstance();
    if (instance == null) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $119be03f5b7cea55$var$getI18nInstance(instance);
    const gl = $119be03f5b7cea55$var$getGlobalComposer(i18n);
    const componentOptions = $119be03f5b7cea55$var$getComponentOptions(instance);
    const scope = $119be03f5b7cea55$var$getScope(options, componentOptions);
    if (scope === 'global') {
        $119be03f5b7cea55$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $119be03f5b7cea55$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = gl;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = $9FmEQ.assign({}, options);
        if ('__i18n' in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $119be03f5b7cea55$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$119be03f5b7cea55$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $119be03f5b7cea55$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
function $119be03f5b7cea55$var$createGlobal(options, legacyMode) {
    const scope = $8bTPG.effectScope();
    const obj = legacyMode ? scope.run(()=>$119be03f5b7cea55$var$createVueI18n(options)) : scope.run(()=>$119be03f5b7cea55$var$createComposer(options));
    if (obj == null) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
    return [
        scope,
        obj
    ];
}
function $119be03f5b7cea55$var$getI18nInstance(instance) {
    const i18n = $ani5R.inject(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $119be03f5b7cea55$var$I18nInjectionKey);
    /* istanbul ignore if */ if (!i18n) throw $119be03f5b7cea55$var$createI18nError(!instance.isCE ? $119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR : $119be03f5b7cea55$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
    return i18n;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $119be03f5b7cea55$var$getScope(options, componentOptions) {
    // prettier-ignore
    return $9FmEQ.isEmptyObject(options) ? '__i18n' in componentOptions ? 'local' : 'global' : !options.useScope ? 'local' : options.useScope;
}
function $119be03f5b7cea55$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition' ? i18n.global : i18n.global.__composer;
}
function $119be03f5b7cea55$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $119be03f5b7cea55$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') composer = i18nInternal.__getInstance(current);
        else {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$119be03f5b7cea55$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $119be03f5b7cea55$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $119be03f5b7cea55$var$setupLifeCycle(i18n, target, composer) {
    $ani5R.onMounted(()=>{}, target);
    $ani5R.onUnmounted(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$119be03f5b7cea55$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$119be03f5b7cea55$var$DisposeSymbol];
        }
    }, target);
}
const $119be03f5b7cea55$var$globalExportProps = [
    'locale',
    'fallbackLocale',
    'availableLocales'
];
const $119be03f5b7cea55$var$globalExportMethods = [
    't',
    'rt',
    'd',
    'n',
    'tm',
    'te'
];
function $119be03f5b7cea55$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $119be03f5b7cea55$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = $8bTPG.isRef(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $119be03f5b7cea55$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $119be03f5b7cea55$var$createI18nError($119be03f5b7cea55$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $119be03f5b7cea55$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
const $119be03f5b7cea55$var$DatetimeFormatImpl = /* #__PURE__*/ $ani5R.defineComponent({
    /* eslint-disable */ name: 'i18n-d',
    props: $9FmEQ.assign({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $119be03f5b7cea55$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $119be03f5b7cea55$var$useI18n({
            useScope: props.scope,
            __useComponent: true
        });
        return $119be03f5b7cea55$var$renderFormatter(props, context, $ei7AW.DATETIME_FORMAT_OPTIONS_KEYS, (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$119be03f5b7cea55$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $119be03f5b7cea55$var$DatetimeFormat = $119be03f5b7cea55$var$DatetimeFormatImpl;
const $119be03f5b7cea55$var$I18nD = $119be03f5b7cea55$var$DatetimeFormat;
// register message compiler at vue-i18n
$ei7AW.registerMessageCompiler($ei7AW.compile);
// register message resolver at vue-i18n
$ei7AW.registerMessageResolver($ei7AW.resolveValue);
// register fallback locale at vue-i18n
$ei7AW.registerLocaleFallbacker($ei7AW.fallbackWithLocaleChain);
$119be03f5b7cea55$export$64ca50867510e64e = $119be03f5b7cea55$var$DatetimeFormat;
$119be03f5b7cea55$export$c741260b89dcb234 = $119be03f5b7cea55$var$I18nD;
$119be03f5b7cea55$export$b19990ca6e622dd2 = $119be03f5b7cea55$var$I18nInjectionKey;
$119be03f5b7cea55$export$4665d24327644133 = $119be03f5b7cea55$var$I18nN;
$119be03f5b7cea55$export$1d08de71ac06ffd6 = $119be03f5b7cea55$var$I18nT;
$119be03f5b7cea55$export$27bce688931fdfcc = $119be03f5b7cea55$var$NumberFormat;
$119be03f5b7cea55$export$b63289fbda65eed1 = $119be03f5b7cea55$var$Translation;
$119be03f5b7cea55$export$a4ad2735b021c132 = $119be03f5b7cea55$var$VERSION;
$119be03f5b7cea55$export$920091e3d72d80ee = $119be03f5b7cea55$var$createI18n;
$119be03f5b7cea55$export$3f3caade1c12f8c9 = $119be03f5b7cea55$var$useI18n;
$119be03f5b7cea55$export$8a5a05546006d0b5 = $119be03f5b7cea55$var$vTDirective;

});
parcelRegister("ei7AW", function(module, exports) {

$parcel$export(module.exports, "isMessageAST", () => $7b6583d2aaea6a3d$export$9ba95744594b90e0);
$parcel$export(module.exports, "compile", () => $7b6583d2aaea6a3d$export$ef7acd7185315e22);
$parcel$export(module.exports, "CORE_ERROR_CODES_EXTEND_POINT", () => $7b6583d2aaea6a3d$export$6d413eb5613d704c);
$parcel$export(module.exports, "fallbackWithLocaleChain", () => $7b6583d2aaea6a3d$export$71df9db82dc445);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $7b6583d2aaea6a3d$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "resolveValue", () => $7b6583d2aaea6a3d$export$d812c8e1906863d0);
$parcel$export(module.exports, "NOT_REOSLVED", () => $7b6583d2aaea6a3d$export$b7f13a18d1d0f835);
$parcel$export(module.exports, "MISSING_RESOLVE_VALUE", () => $7b6583d2aaea6a3d$export$a04371e9dbb3870b);
$parcel$export(module.exports, "registerMessageCompiler", () => $7b6583d2aaea6a3d$export$6ee2fbe83628b40b);
$parcel$export(module.exports, "registerMessageResolver", () => $7b6583d2aaea6a3d$export$45dacdc710815463);
$parcel$export(module.exports, "registerLocaleFallbacker", () => $7b6583d2aaea6a3d$export$fd8ec9dd8067edec);
$parcel$export(module.exports, "setFallbackContext", () => $7b6583d2aaea6a3d$export$e16aca6786e72a5e);
$parcel$export(module.exports, "getFallbackContext", () => $7b6583d2aaea6a3d$export$3adddc434faa9e35);
$parcel$export(module.exports, "createCoreContext", () => $7b6583d2aaea6a3d$export$3599d465b05a74a5);
$parcel$export(module.exports, "updateFallbackLocale", () => $7b6583d2aaea6a3d$export$c743ad8a3cc01530);
$parcel$export(module.exports, "datetime", () => $7b6583d2aaea6a3d$export$7ba4466dbd0f07e1);
$parcel$export(module.exports, "parseDateTimeArgs", () => $7b6583d2aaea6a3d$export$165524b21a0d6b5e);
$parcel$export(module.exports, "DATETIME_FORMAT_OPTIONS_KEYS", () => $7b6583d2aaea6a3d$export$c77049eaf05b1508);
$parcel$export(module.exports, "clearDateTimeFormat", () => $7b6583d2aaea6a3d$export$5bc4fc7cf15d6ccd);
$parcel$export(module.exports, "number", () => $7b6583d2aaea6a3d$export$98e628dec113755e);
$parcel$export(module.exports, "parseNumberArgs", () => $7b6583d2aaea6a3d$export$d0e2eec8b686cf72);
$parcel$export(module.exports, "NUMBER_FORMAT_OPTIONS_KEYS", () => $7b6583d2aaea6a3d$export$c39a7c3789c46ed6);
$parcel$export(module.exports, "clearNumberFormat", () => $7b6583d2aaea6a3d$export$6a8717b3043a4f23);
$parcel$export(module.exports, "isMessageFunction", () => $7b6583d2aaea6a3d$export$92c0a039cf358271);
$parcel$export(module.exports, "translate", () => $7b6583d2aaea6a3d$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "parseTranslateArgs", () => $7b6583d2aaea6a3d$export$8d9616744e22681a);
$parcel$export(module.exports, "createCompileError", () => (parcelRequire("6ZJ5y")).createCompileError);
/*!
  * core-base v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9FmEQ = parcelRequire("9FmEQ");

var $6ZJ5y = parcelRequire("6ZJ5y");
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $7b6583d2aaea6a3d$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') (0, $9FmEQ.getGlobalThis)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') (0, $9FmEQ.getGlobalThis)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
function $7b6583d2aaea6a3d$var$format(ast) {
    const msg = (ctx)=>$7b6583d2aaea6a3d$var$formatParts(ctx, ast);
    return msg;
}
function $7b6583d2aaea6a3d$var$formatParts(ctx, ast) {
    const body = $7b6583d2aaea6a3d$var$resolveBody(ast);
    if (body == null) throw $7b6583d2aaea6a3d$var$createUnhandleNodeError(0 /* NodeTypes.Resource */ );
    const type = $7b6583d2aaea6a3d$var$resolveType(body);
    if (type === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = $7b6583d2aaea6a3d$var$resolveCases(plural);
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $7b6583d2aaea6a3d$var$formatMessageParts(ctx, c)
            ], []));
    } else return $7b6583d2aaea6a3d$var$formatMessageParts(ctx, body);
}
const $7b6583d2aaea6a3d$var$PROPS_BODY = [
    'b',
    'body'
];
function $7b6583d2aaea6a3d$var$resolveBody(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_BODY);
}
const $7b6583d2aaea6a3d$var$PROPS_CASES = [
    'c',
    'cases'
];
function $7b6583d2aaea6a3d$var$resolveCases(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_CASES, []);
}
function $7b6583d2aaea6a3d$var$formatMessageParts(ctx, node) {
    const static_ = $7b6583d2aaea6a3d$var$resolveStatic(node);
    if (static_ != null) return ctx.type === 'text' ? static_ : ctx.normalize([
        static_
    ]);
    else {
        const messages = $7b6583d2aaea6a3d$var$resolveItems(node).reduce((acm, c)=>[
                ...acm,
                $7b6583d2aaea6a3d$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
const $7b6583d2aaea6a3d$var$PROPS_STATIC = [
    's',
    'static'
];
function $7b6583d2aaea6a3d$var$resolveStatic(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_STATIC);
}
const $7b6583d2aaea6a3d$var$PROPS_ITEMS = [
    'i',
    'items'
];
function $7b6583d2aaea6a3d$var$resolveItems(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_ITEMS, []);
}
function $7b6583d2aaea6a3d$var$formatMessagePart(ctx, node) {
    const type = $7b6583d2aaea6a3d$var$resolveType(node);
    switch(type){
        case 3 /* NodeTypes.Text */ :
            return $7b6583d2aaea6a3d$var$resolveValue$1(node, type);
        case 9 /* NodeTypes.Literal */ :
            return $7b6583d2aaea6a3d$var$resolveValue$1(node, type);
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                if ((0, $9FmEQ.hasOwn)(named, 'k') && named.k) return ctx.interpolate(ctx.named(named.k));
                if ((0, $9FmEQ.hasOwn)(named, 'key') && named.key) return ctx.interpolate(ctx.named(named.key));
                throw $7b6583d2aaea6a3d$var$createUnhandleNodeError(type);
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                if ((0, $9FmEQ.hasOwn)(list, 'i') && (0, $9FmEQ.isNumber)(list.i)) return ctx.interpolate(ctx.list(list.i));
                if ((0, $9FmEQ.hasOwn)(list, 'index') && (0, $9FmEQ.isNumber)(list.index)) return ctx.interpolate(ctx.list(list.index));
                throw $7b6583d2aaea6a3d$var$createUnhandleNodeError(type);
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = $7b6583d2aaea6a3d$var$resolveLinkedModifier(linked);
                const key = $7b6583d2aaea6a3d$var$resolveLinkedKey(linked);
                return ctx.linked($7b6583d2aaea6a3d$var$formatMessagePart(ctx, key), modifier ? $7b6583d2aaea6a3d$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            return $7b6583d2aaea6a3d$var$resolveValue$1(node, type);
        case 8 /* NodeTypes.LinkedModifier */ :
            return $7b6583d2aaea6a3d$var$resolveValue$1(node, type);
        default:
            throw new Error(`unhandled node on format message part: ${type}`);
    }
}
const $7b6583d2aaea6a3d$var$PROPS_TYPE = [
    't',
    'type'
];
function $7b6583d2aaea6a3d$var$resolveType(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_TYPE);
}
const $7b6583d2aaea6a3d$var$PROPS_VALUE = [
    'v',
    'value'
];
function $7b6583d2aaea6a3d$var$resolveValue$1(node, type) {
    const resolved = $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_VALUE);
    if (resolved) return resolved;
    else throw $7b6583d2aaea6a3d$var$createUnhandleNodeError(type);
}
const $7b6583d2aaea6a3d$var$PROPS_MODIFIER = [
    'm',
    'modifier'
];
function $7b6583d2aaea6a3d$var$resolveLinkedModifier(node) {
    return $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_MODIFIER);
}
const $7b6583d2aaea6a3d$var$PROPS_KEY = [
    'k',
    'key'
];
function $7b6583d2aaea6a3d$var$resolveLinkedKey(node) {
    const resolved = $7b6583d2aaea6a3d$var$resolveProps(node, $7b6583d2aaea6a3d$var$PROPS_KEY);
    if (resolved) return resolved;
    else throw $7b6583d2aaea6a3d$var$createUnhandleNodeError(6 /* NodeTypes.Linked */ );
}
function $7b6583d2aaea6a3d$var$resolveProps(node, props, defaultValue) {
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((0, $9FmEQ.hasOwn)(node, prop) && node[prop] != null) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return node[prop];
    }
    return defaultValue;
}
function $7b6583d2aaea6a3d$var$createUnhandleNodeError(type) {
    return new Error(`unhandled node type: ${type}`);
}
const $7b6583d2aaea6a3d$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $7b6583d2aaea6a3d$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $6ZJ5y.detectHtmlTag)(source)) (0, $9FmEQ.warn)((0, $9FmEQ.format)($7b6583d2aaea6a3d$var$WARN_MESSAGE, {
        source: source
    }));
}
const $7b6583d2aaea6a3d$var$defaultOnCacheKey = (message)=>message;
let $7b6583d2aaea6a3d$var$compileCache = (0, $9FmEQ.create)();
function $7b6583d2aaea6a3d$export$2683c80ae3fe544() {
    $7b6583d2aaea6a3d$var$compileCache = (0, $9FmEQ.create)();
}
function $7b6583d2aaea6a3d$export$9ba95744594b90e0(val) {
    return (0, $9FmEQ.isObject)(val) && $7b6583d2aaea6a3d$var$resolveType(val) === 0 && ((0, $9FmEQ.hasOwn)(val, 'b') || (0, $9FmEQ.hasOwn)(val, 'body'));
}
function $7b6583d2aaea6a3d$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $6ZJ5y.defaultOnError);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $6ZJ5y.baseCompile)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ function $7b6583d2aaea6a3d$export$ef7acd7185315e22(message, context) {
    if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $9FmEQ.isString)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $9FmEQ.isBoolean)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $7b6583d2aaea6a3d$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $7b6583d2aaea6a3d$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $7b6583d2aaea6a3d$var$baseCompile(message, {
            ...context,
            location: false,
            jit: true
        });
        // compose message function from AST
        const msg = $7b6583d2aaea6a3d$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $7b6583d2aaea6a3d$var$compileCache[cacheKey] = msg : msg;
    } else {
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $7b6583d2aaea6a3d$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $7b6583d2aaea6a3d$var$compileCache[cacheKey] = $7b6583d2aaea6a3d$var$format(message);
        } else return $7b6583d2aaea6a3d$var$format(message);
    }
}
let $7b6583d2aaea6a3d$var$devtools = null;
function $7b6583d2aaea6a3d$export$c893d6c8966908b9(hook) {
    $7b6583d2aaea6a3d$var$devtools = hook;
}
function $7b6583d2aaea6a3d$export$8bd08e70642dc6f4() {
    return $7b6583d2aaea6a3d$var$devtools;
}
function $7b6583d2aaea6a3d$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $7b6583d2aaea6a3d$var$devtools && $7b6583d2aaea6a3d$var$devtools.emit('i18n:init', {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $7b6583d2aaea6a3d$export$190d71a47ff3f767 = /* #__PURE__*/ $7b6583d2aaea6a3d$var$createDevToolsHook('function:translate');
function $7b6583d2aaea6a3d$var$createDevToolsHook(hook) {
    return (payloads)=>$7b6583d2aaea6a3d$var$devtools && $7b6583d2aaea6a3d$var$devtools.emit(hook, payloads);
}
const $7b6583d2aaea6a3d$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: (0, $6ZJ5y.COMPILE_ERROR_CODES_EXTEND_POINT),
    INVALID_DATE_ARGUMENT: 18,
    INVALID_ISO_DATE_ARGUMENT: 19,
    NOT_SUPPORT_NON_STRING_MESSAGE: 20,
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
    NOT_SUPPORT_LOCALE_TYPE: 23
};
const $7b6583d2aaea6a3d$export$6d413eb5613d704c = 24;
function $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b(code) {
    return (0, $6ZJ5y.createCompileError)(code, null, undefined);
}
/** @internal */ const $7b6583d2aaea6a3d$var$errorMessages = {
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ARGUMENT]: 'Invalid arguments',
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: 'The argument provided is not a valid ISO date string',
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: 'Not support non-string message',
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: 'cannot support promise value',
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: 'cannot support async function',
    [$7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: 'cannot support locale type'
};
/** @internal */ function $7b6583d2aaea6a3d$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $7b6583d2aaea6a3d$export$df9bcabe7f932e01(options.locale) : $7b6583d2aaea6a3d$export$df9bcabe7f932e01(context.locale);
}
let $7b6583d2aaea6a3d$var$_resolveLocale;
/** @internal */ function $7b6583d2aaea6a3d$export$df9bcabe7f932e01(locale) {
    if ((0, $9FmEQ.isString)(locale)) return locale;
    else {
        if ((0, $9FmEQ.isFunction)(locale)) {
            if (locale.resolvedOnce && $7b6583d2aaea6a3d$var$_resolveLocale != null) return $7b6583d2aaea6a3d$var$_resolveLocale;
            else if (locale.constructor.name === 'Function') {
                const resolve = locale();
                if ((0, $9FmEQ.isPromise)(resolve)) throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $7b6583d2aaea6a3d$var$_resolveLocale = resolve;
            } else throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$e3330076537ef9d1(ctx, fallback, start) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $9FmEQ.isArray)(fallback) ? fallback : (0, $9FmEQ.isObject)(fallback) ? Object.keys(fallback) : (0, $9FmEQ.isString)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $9FmEQ.isString)(start) ? start : $7b6583d2aaea6a3d$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $9FmEQ.isArray)(block))block = $7b6583d2aaea6a3d$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $9FmEQ.isArray)(fallback) || !(0, $9FmEQ.isPlainObject)(fallback) ? fallback : fallback['default'] ? fallback['default'] : null;
        // convert defaults to array
        block = (0, $9FmEQ.isString)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $9FmEQ.isArray)(block)) $7b6583d2aaea6a3d$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $7b6583d2aaea6a3d$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $9FmEQ.isBoolean)(follow); i++){
        const locale = block[i];
        if ((0, $9FmEQ.isString)(locale)) follow = $7b6583d2aaea6a3d$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $7b6583d2aaea6a3d$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = $7b6583d2aaea6a3d$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $7b6583d2aaea6a3d$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if (((0, $9FmEQ.isArray)(blocks) || (0, $9FmEQ.isPlainObject)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
const $7b6583d2aaea6a3d$var$pathStateMachine = [];
$7b6583d2aaea6a3d$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$7b6583d2aaea6a3d$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $7b6583d2aaea6a3d$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $7b6583d2aaea6a3d$var$isLiteral(exp) {
    return $7b6583d2aaea6a3d$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $7b6583d2aaea6a3d$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $7b6583d2aaea6a3d$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $7b6583d2aaea6a3d$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) return false;
    return $7b6583d2aaea6a3d$var$isLiteral(trimmed) ? $7b6583d2aaea6a3d$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $7b6583d2aaea6a3d$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $7b6583d2aaea6a3d$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === "\"" /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) continue;
        type = $7b6583d2aaea6a3d$var$getPathCharType(c);
        typeMap = $7b6583d2aaea6a3d$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $7b6583d2aaea6a3d$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$b365de4c3506886c(obj, path) {
    return (0, $9FmEQ.isObject)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $9FmEQ.isObject)(obj)) return null;
    // parse path
    let hit = $7b6583d2aaea6a3d$var$cache.get(path);
    if (!hit) {
        hit = $7b6583d2aaea6a3d$export$98e6a39c04603d36(path);
        if (hit) $7b6583d2aaea6a3d$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const val = last[hit[i]];
        if (val === undefined) return null;
        if ((0, $9FmEQ.isFunction)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $7b6583d2aaea6a3d$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
};
const $7b6583d2aaea6a3d$export$1b0dc55e850c0e7d = 8;
/** @internal */ const $7b6583d2aaea6a3d$var$warnMessages = {
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$7b6583d2aaea6a3d$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $7b6583d2aaea6a3d$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $9FmEQ.format)($7b6583d2aaea6a3d$var$warnMessages[code], ...args);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $7b6583d2aaea6a3d$export$a4ad2735b021c132 = '11.1.2';
const $7b6583d2aaea6a3d$export$b7f13a18d1d0f835 = -1;
const $7b6583d2aaea6a3d$export$1af4c7e47ad72f44 = 'en-US';
const $7b6583d2aaea6a3d$export$a04371e9dbb3870b = '';
const $7b6583d2aaea6a3d$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $7b6583d2aaea6a3d$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9FmEQ.isString)(val) ? val.toUpperCase() : type === 'vnode' && (0, $9FmEQ.isObject)(val) && '__v_isVNode' in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9FmEQ.isString)(val) ? val.toLowerCase() : type === 'vnode' && (0, $9FmEQ.isObject)(val) && '__v_isVNode' in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9FmEQ.isString)(val) ? $7b6583d2aaea6a3d$var$capitalize(val) : type === 'vnode' && (0, $9FmEQ.isObject)(val) && '__v_isVNode' in val ? $7b6583d2aaea6a3d$var$capitalize(val.children) : val;
        }
    };
}
let $7b6583d2aaea6a3d$var$_compiler;
function $7b6583d2aaea6a3d$export$6ee2fbe83628b40b(compiler) {
    $7b6583d2aaea6a3d$var$_compiler = compiler;
}
let $7b6583d2aaea6a3d$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$45dacdc710815463(resolver) {
    $7b6583d2aaea6a3d$var$_resolver = resolver;
}
let $7b6583d2aaea6a3d$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $7b6583d2aaea6a3d$export$fd8ec9dd8067edec(fallbacker) {
    $7b6583d2aaea6a3d$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $7b6583d2aaea6a3d$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $7b6583d2aaea6a3d$export$605703447dca72aa = (meta)=>{
    $7b6583d2aaea6a3d$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $7b6583d2aaea6a3d$export$817795a14e5c6622 = ()=>$7b6583d2aaea6a3d$var$_additionalMeta;
let $7b6583d2aaea6a3d$var$_fallbackContext = null;
const $7b6583d2aaea6a3d$export$e16aca6786e72a5e = (context)=>{
    $7b6583d2aaea6a3d$var$_fallbackContext = context;
};
const $7b6583d2aaea6a3d$export$3adddc434faa9e35 = ()=>$7b6583d2aaea6a3d$var$_fallbackContext;
// ID for CoreContext
let $7b6583d2aaea6a3d$var$_cid = 0;
function $7b6583d2aaea6a3d$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $9FmEQ.isFunction)(options.onWarn) ? options.onWarn : (0, $9FmEQ.warn);
    const version = (0, $9FmEQ.isString)(options.version) ? options.version : $7b6583d2aaea6a3d$export$a4ad2735b021c132;
    const locale = (0, $9FmEQ.isString)(options.locale) || (0, $9FmEQ.isFunction)(options.locale) ? options.locale : $7b6583d2aaea6a3d$export$1af4c7e47ad72f44;
    const _locale = (0, $9FmEQ.isFunction)(locale) ? $7b6583d2aaea6a3d$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $9FmEQ.isArray)(options.fallbackLocale) || (0, $9FmEQ.isPlainObject)(options.fallbackLocale) || (0, $9FmEQ.isString)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $9FmEQ.isPlainObject)(options.messages) ? options.messages : $7b6583d2aaea6a3d$var$createResources(_locale);
    const datetimeFormats = (0, $9FmEQ.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : $7b6583d2aaea6a3d$var$createResources(_locale);
    const numberFormats = (0, $9FmEQ.isPlainObject)(options.numberFormats) ? options.numberFormats : $7b6583d2aaea6a3d$var$createResources(_locale);
    const modifiers = (0, $9FmEQ.assign)((0, $9FmEQ.create)(), options.modifiers, $7b6583d2aaea6a3d$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || (0, $9FmEQ.create)();
    const missing = (0, $9FmEQ.isFunction)(options.missing) ? options.missing : null;
    const missingWarn = (0, $9FmEQ.isBoolean)(options.missingWarn) || (0, $9FmEQ.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $9FmEQ.isBoolean)(options.fallbackWarn) || (0, $9FmEQ.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $9FmEQ.isFunction)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $9FmEQ.isPlainObject)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $9FmEQ.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $9FmEQ.isFunction)(options.messageCompiler) ? options.messageCompiler : $7b6583d2aaea6a3d$var$_compiler;
    const messageResolver = (0, $9FmEQ.isFunction)(options.messageResolver) ? options.messageResolver : $7b6583d2aaea6a3d$var$_resolver || $7b6583d2aaea6a3d$export$b365de4c3506886c;
    const localeFallbacker = (0, $9FmEQ.isFunction)(options.localeFallbacker) ? options.localeFallbacker : $7b6583d2aaea6a3d$var$_fallbacker || $7b6583d2aaea6a3d$export$e3330076537ef9d1;
    const fallbackContext = (0, $9FmEQ.isObject)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $9FmEQ.isObject)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $9FmEQ.isObject)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $9FmEQ.isObject)(internalOptions.__meta) ? internalOptions.__meta : {};
    $7b6583d2aaea6a3d$var$_cid++;
    const context = {
        version: version,
        cid: $7b6583d2aaea6a3d$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $7b6583d2aaea6a3d$export$725afc6a300324a0(context, version, __meta);
    return context;
}
const $7b6583d2aaea6a3d$var$createResources = (locale)=>({
        [locale]: (0, $9FmEQ.create)()
    });
/** @internal */ function $7b6583d2aaea6a3d$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $7b6583d2aaea6a3d$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $7b6583d2aaea6a3d$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $9FmEQ.isString)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $7b6583d2aaea6a3d$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $7b6583d2aaea6a3d$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split('-')[0] === compareLocale.split('-')[0];
}
/** @internal */ function $7b6583d2aaea6a3d$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($7b6583d2aaea6a3d$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $7b6583d2aaea6a3d$var$intlDefined = typeof Intl !== 'undefined';
const $7b6583d2aaea6a3d$var$Availabilities = {
    dateTimeFormat: $7b6583d2aaea6a3d$var$intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
    numberFormat: $7b6583d2aaea6a3d$var$intlDefined && typeof Intl.NumberFormat !== 'undefined'
};
// implementation of `datetime` function
function $7b6583d2aaea6a3d$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $7b6583d2aaea6a3d$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $9FmEQ.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9FmEQ.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $7b6583d2aaea6a3d$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9FmEQ.isString)(key) || key === '') return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'datetime format';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $9FmEQ.isPlainObject)(format)) break;
        $7b6583d2aaea6a3d$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9FmEQ.isPlainObject)(format) || !(0, $9FmEQ.isString)(targetLocale)) return unresolving ? $7b6583d2aaea6a3d$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9FmEQ.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $9FmEQ.assign)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $7b6583d2aaea6a3d$export$c77049eaf05b1508 = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */ function $7b6583d2aaea6a3d$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $9FmEQ.create)();
    let overrides = (0, $9FmEQ.create)();
    let value;
    if ((0, $9FmEQ.isString)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith('T') ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch  {
            throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $9FmEQ.isDate)(arg1)) {
        if (isNaN(arg1.getTime())) throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $9FmEQ.isNumber)(arg1)) value = arg1;
    else throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $9FmEQ.isString)(arg2)) options.key = arg2;
    else if ((0, $9FmEQ.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($7b6583d2aaea6a3d$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9FmEQ.isString)(arg3)) options.locale = arg3;
    else if ((0, $9FmEQ.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9FmEQ.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || '',
        value,
        options,
        overrides
    ];
}
/** @internal */ function $7b6583d2aaea6a3d$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $7b6583d2aaea6a3d$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $7b6583d2aaea6a3d$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $9FmEQ.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9FmEQ.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $7b6583d2aaea6a3d$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9FmEQ.isString)(key) || key === '') return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'number format';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $9FmEQ.isPlainObject)(format)) break;
        $7b6583d2aaea6a3d$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9FmEQ.isPlainObject)(format) || !(0, $9FmEQ.isString)(targetLocale)) return unresolving ? $7b6583d2aaea6a3d$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9FmEQ.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $9FmEQ.assign)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $7b6583d2aaea6a3d$export$c39a7c3789c46ed6 = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'roundingMode',
    'roundingPriority',
    'roundingIncrement',
    'trailingZeroDisplay'
];
/** @internal */ function $7b6583d2aaea6a3d$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $9FmEQ.create)();
    let overrides = (0, $9FmEQ.create)();
    if (!(0, $9FmEQ.isNumber)(arg1)) throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $9FmEQ.isString)(arg2)) options.key = arg2;
    else if ((0, $9FmEQ.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($7b6583d2aaea6a3d$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9FmEQ.isString)(arg3)) options.locale = arg3;
    else if ((0, $9FmEQ.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9FmEQ.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || '',
        value,
        options,
        overrides
    ];
}
/** @internal */ function $7b6583d2aaea6a3d$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
const $7b6583d2aaea6a3d$var$DEFAULT_MODIFIER = (str)=>str;
const $7b6583d2aaea6a3d$var$DEFAULT_MESSAGE = (ctx)=>''; // eslint-disable-line
const $7b6583d2aaea6a3d$export$12b53af6b8529bfc = 'text';
const $7b6583d2aaea6a3d$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? '' : (0, $9FmEQ.join)(values);
const $7b6583d2aaea6a3d$var$DEFAULT_INTERPOLATE = (0, $9FmEQ.toDisplayString);
function $7b6583d2aaea6a3d$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $7b6583d2aaea6a3d$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $9FmEQ.isNumber)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $9FmEQ.isNumber)(options.named.count) || (0, $9FmEQ.isNumber)(options.named.n)) ? (0, $9FmEQ.isNumber)(options.named.count) ? options.named.count : (0, $9FmEQ.isNumber)(options.named.n) ? options.named.n : index : index;
}
function $7b6583d2aaea6a3d$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $7b6583d2aaea6a3d$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $7b6583d2aaea6a3d$var$getPluralIndex(options);
    const pluralRule = (0, $9FmEQ.isObject)(options.pluralRules) && (0, $9FmEQ.isString)(locale) && (0, $9FmEQ.isFunction)(options.pluralRules[locale]) ? options.pluralRules[locale] : $7b6583d2aaea6a3d$var$pluralDefault;
    const orgPluralRule = (0, $9FmEQ.isObject)(options.pluralRules) && (0, $9FmEQ.isString)(locale) && (0, $9FmEQ.isFunction)(options.pluralRules[locale]) ? $7b6583d2aaea6a3d$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || (0, $9FmEQ.create)();
    (0, $9FmEQ.isNumber)(options.pluralIndex) && $7b6583d2aaea6a3d$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key, useLinked) {
        // prettier-ignore
        const msg = (0, $9FmEQ.isFunction)(options.messages) ? options.messages(key, !!useLinked) : (0, $9FmEQ.isObject)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $7b6583d2aaea6a3d$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $7b6583d2aaea6a3d$var$DEFAULT_MODIFIER;
    const normalize = (0, $9FmEQ.isPlainObject)(options.processor) && (0, $9FmEQ.isFunction)(options.processor.normalize) ? options.processor.normalize : $7b6583d2aaea6a3d$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $9FmEQ.isPlainObject)(options.processor) && (0, $9FmEQ.isFunction)(options.processor.interpolate) ? options.processor.interpolate : $7b6583d2aaea6a3d$var$DEFAULT_INTERPOLATE;
    const type = (0, $9FmEQ.isPlainObject)(options.processor) && (0, $9FmEQ.isString)(options.processor.type) ? options.processor.type : $7b6583d2aaea6a3d$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if ((0, $9FmEQ.isObject)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $9FmEQ.isString)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $9FmEQ.isString)(arg1)) modifier = arg1 || modifier;
            if ((0, $9FmEQ.isString)(arg2)) type = arg2 || type;
        }
        const ret = message(key, true)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === 'vnode' && (0, $9FmEQ.isArray)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $9FmEQ.assign)((0, $9FmEQ.create)(), _list, _named)
    };
    return ctx;
}
const $7b6583d2aaea6a3d$var$NOOP_MESSAGE_FUNCTION = ()=>'';
const $7b6583d2aaea6a3d$export$92c0a039cf358271 = (val)=>(0, $9FmEQ.isFunction)(val);
// implementation of `translate` function
function $7b6583d2aaea6a3d$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $7b6583d2aaea6a3d$export$8d9616744e22681a(...args);
    const missingWarn = (0, $9FmEQ.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9FmEQ.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $9FmEQ.isBoolean)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $9FmEQ.isString)(options.default) || (0, $9FmEQ.isBoolean)(options.default) // default by function option
     ? !(0, $9FmEQ.isBoolean)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : null;
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey != null && ((0, $9FmEQ.isString)(defaultMsgOrKey) || (0, $9FmEQ.isFunction)(defaultMsgOrKey));
    const locale = $7b6583d2aaea6a3d$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $7b6583d2aaea6a3d$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $7b6583d2aaea6a3d$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || (0, $9FmEQ.create)()
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $9FmEQ.isString)(format) || $7b6583d2aaea6a3d$export$9ba95744594b90e0(format) || $7b6583d2aaea6a3d$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $9FmEQ.isString)(format) || $7b6583d2aaea6a3d$export$9ba95744594b90e0(format) || $7b6583d2aaea6a3d$export$92c0a039cf358271(format)) || !(0, $9FmEQ.isString)(targetLocale))) return unresolving ? $7b6583d2aaea6a3d$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$7b6583d2aaea6a3d$export$92c0a039cf358271(format) ? $7b6583d2aaea6a3d$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $7b6583d2aaea6a3d$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $7b6583d2aaea6a3d$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $7b6583d2aaea6a3d$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $9FmEQ.isString)(key) ? key : $7b6583d2aaea6a3d$export$92c0a039cf358271(format) ? format.key : '',
            locale: targetLocale || ($7b6583d2aaea6a3d$export$92c0a039cf358271(format) ? format.locale : ''),
            format: (0, $9FmEQ.isString)(format) ? format : $7b6583d2aaea6a3d$export$92c0a039cf358271(format) ? format.source : '',
            message: ret
        };
        payloads.meta = (0, $9FmEQ.assign)({}, context.__meta, $7b6583d2aaea6a3d$export$817795a14e5c6622() || {});
        $7b6583d2aaea6a3d$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $7b6583d2aaea6a3d$var$escapeParams(options) {
    if ((0, $9FmEQ.isArray)(options.list)) options.list = options.list.map((item)=>(0, $9FmEQ.isString)(item) ? (0, $9FmEQ.escapeHtml)(item) : item);
    else if ((0, $9FmEQ.isObject)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $9FmEQ.isString)(options.named[key])) options.named[key] = (0, $9FmEQ.escapeHtml)(options.named[key]);
    });
}
function $7b6583d2aaea6a3d$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = (0, $9FmEQ.create)();
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'translate';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || (0, $9FmEQ.create)();
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $9FmEQ.isString)(format) || $7b6583d2aaea6a3d$export$9ba95744594b90e0(format) || $7b6583d2aaea6a3d$export$92c0a039cf358271(format)) break;
        if (!$7b6583d2aaea6a3d$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $7b6583d2aaea6a3d$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $7b6583d2aaea6a3d$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($7b6583d2aaea6a3d$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $7b6583d2aaea6a3d$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $7b6583d2aaea6a3d$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $7b6583d2aaea6a3d$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = (0, $9FmEQ.create)();
    if (!(0, $9FmEQ.isString)(arg1) && !(0, $9FmEQ.isNumber)(arg1) && !$7b6583d2aaea6a3d$export$92c0a039cf358271(arg1) && !$7b6583d2aaea6a3d$export$9ba95744594b90e0(arg1)) throw $7b6583d2aaea6a3d$export$3d702f7ac45b0a6b($7b6583d2aaea6a3d$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $9FmEQ.isNumber)(arg1) ? String(arg1) : $7b6583d2aaea6a3d$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $9FmEQ.isNumber)(arg2)) options.plural = arg2;
    else if ((0, $9FmEQ.isString)(arg2)) options.default = arg2;
    else if ((0, $9FmEQ.isPlainObject)(arg2) && !(0, $9FmEQ.isEmptyObject)(arg2)) options.named = arg2;
    else if ((0, $9FmEQ.isArray)(arg2)) options.list = arg2;
    if ((0, $9FmEQ.isNumber)(arg3)) options.plural = arg3;
    else if ((0, $9FmEQ.isString)(arg3)) options.default = arg3;
    else if ((0, $9FmEQ.isPlainObject)(arg3)) (0, $9FmEQ.assign)(options, arg3);
    return [
        key,
        options
    ];
}
function $7b6583d2aaea6a3d$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $9FmEQ.generateFormatCacheKey)(locale, key, source)
    };
}
function $7b6583d2aaea6a3d$var$getSourceForCodeFrame(source) {
    if ((0, $9FmEQ.isString)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $7b6583d2aaea6a3d$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key, useLinked)=>{
        let val = resolveValue(message, key);
        // fallback
        if (val == null && (fallbackContext || useLinked)) {
            const [, , message] = $7b6583d2aaea6a3d$var$resolveMessageFormat(fallbackContext || context, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $9FmEQ.isString)(val) || $7b6583d2aaea6a3d$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $7b6583d2aaea6a3d$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $7b6583d2aaea6a3d$var$NOOP_MESSAGE_FUNCTION;
        } else if ($7b6583d2aaea6a3d$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $7b6583d2aaea6a3d$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $9FmEQ.isNumber)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
$7b6583d2aaea6a3d$var$initFeatureFlags();

});
parcelRegister("9FmEQ", function(module, exports) {

$parcel$export(module.exports, "inBrowser", () => $8678435223df8161$export$620a268685f0ac45);
$parcel$export(module.exports, "format", () => $8678435223df8161$export$d9468344d3651243);
$parcel$export(module.exports, "isObject", () => $8678435223df8161$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "makeSymbol", () => $8678435223df8161$export$cd133c5e04906ece);
$parcel$export(module.exports, "generateFormatCacheKey", () => $8678435223df8161$export$5024ef1f92c9a364);
$parcel$export(module.exports, "isNumber", () => $8678435223df8161$export$7e4aa119212bc614);
$parcel$export(module.exports, "isDate", () => $8678435223df8161$export$871608497c498473);
$parcel$export(module.exports, "isRegExp", () => $8678435223df8161$export$49841c62b9eff15);
$parcel$export(module.exports, "isEmptyObject", () => $8678435223df8161$export$83b788b1a3698c03);
$parcel$export(module.exports, "isPlainObject", () => $8678435223df8161$export$53b83ca8eaab0383);
$parcel$export(module.exports, "assign", () => $8678435223df8161$export$e6e34fd1f2686227);
$parcel$export(module.exports, "create", () => $8678435223df8161$export$185802fd694ee1f5);
$parcel$export(module.exports, "getGlobalThis", () => $8678435223df8161$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "escapeHtml", () => $8678435223df8161$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "hasOwn", () => $8678435223df8161$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $8678435223df8161$export$43bee75e5e14138e);
$parcel$export(module.exports, "isFunction", () => $8678435223df8161$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $8678435223df8161$export$844ec244b1367d54);
$parcel$export(module.exports, "isBoolean", () => $8678435223df8161$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isPromise", () => $8678435223df8161$export$4369c812aac99591);
$parcel$export(module.exports, "toDisplayString", () => $8678435223df8161$export$b5b1545233b45293);
$parcel$export(module.exports, "join", () => $8678435223df8161$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "warn", () => $8678435223df8161$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "deepCopy", () => $8678435223df8161$export$6c40052bed430212);
/*!
  * shared v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $8678435223df8161$export$620a268685f0ac45 = typeof window !== 'undefined';
let $8678435223df8161$export$bf7f2fce5c1cf636;
let $8678435223df8161$export$83602b44513dc228;
var $8678435223df8161$var$tag, $8678435223df8161$var$name, $8678435223df8161$var$startTag, $8678435223df8161$var$endTag;
const $8678435223df8161$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $8678435223df8161$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $8678435223df8161$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($8678435223df8161$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const $8678435223df8161$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $8678435223df8161$export$5024ef1f92c9a364 = (locale, key, source)=>$8678435223df8161$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $8678435223df8161$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029').replace(/\u0027/g, '\\u0027');
const $8678435223df8161$export$7e4aa119212bc614 = (val)=>typeof val === 'number' && isFinite(val);
const $8678435223df8161$export$871608497c498473 = (val)=>$8678435223df8161$export$1dccc787cc36538b(val) === '[object Date]';
const $8678435223df8161$export$49841c62b9eff15 = (val)=>$8678435223df8161$export$1dccc787cc36538b(val) === '[object RegExp]';
const $8678435223df8161$export$83b788b1a3698c03 = (val)=>$8678435223df8161$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $8678435223df8161$export$e6e34fd1f2686227 = Object.assign;
const $8678435223df8161$var$_create = Object.create;
const $8678435223df8161$export$185802fd694ee1f5 = (obj = null)=>$8678435223df8161$var$_create(obj);
let $8678435223df8161$var$_globalThis;
const $8678435223df8161$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $8678435223df8161$var$_globalThis || ($8678435223df8161$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : $8678435223df8161$export$185802fd694ee1f5());
};
function $8678435223df8161$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}
const $8678435223df8161$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8678435223df8161$export$b5a638e9b3fff9f3(obj, key) {
    return $8678435223df8161$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $8678435223df8161$export$43bee75e5e14138e = Array.isArray;
const $8678435223df8161$export$f6e2535fb5126e54 = (val)=>typeof val === 'function';
const $8678435223df8161$export$844ec244b1367d54 = (val)=>typeof val === 'string';
const $8678435223df8161$export$f9ce7b637dfbe238 = (val)=>typeof val === 'boolean';
const $8678435223df8161$export$a244864fd9645c7f = (val)=>typeof val === 'symbol';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8678435223df8161$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === 'object';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8678435223df8161$export$4369c812aac99591 = (val)=>{
    return $8678435223df8161$export$a6cdc56e425d0d0a(val) && $8678435223df8161$export$f6e2535fb5126e54(val.then) && $8678435223df8161$export$f6e2535fb5126e54(val.catch);
};
const $8678435223df8161$export$830c053460e5ddf6 = Object.prototype.toString;
const $8678435223df8161$export$1dccc787cc36538b = (value)=>$8678435223df8161$export$830c053460e5ddf6.call(value);
const $8678435223df8161$export$53b83ca8eaab0383 = (val)=>$8678435223df8161$export$1dccc787cc36538b(val) === '[object Object]';
// for converting list and named values to displayed strings.
const $8678435223df8161$export$b5b1545233b45293 = (val)=>{
    return val == null ? '' : $8678435223df8161$export$43bee75e5e14138e(val) || $8678435223df8161$export$53b83ca8eaab0383(val) && val.toString === $8678435223df8161$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $8678435223df8161$export$f7e2c8231c57a8bd(items, separator = '') {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, '');
}
const $8678435223df8161$var$RANGE = 2;
function $8678435223df8161$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $8678435223df8161$var$RANGE; j <= i + $8678435223df8161$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function $8678435223df8161$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $8678435223df8161$var$hasWarned = {};
function $8678435223df8161$export$5b28268982f175ba(msg) {
    if (!$8678435223df8161$var$hasWarned[msg]) {
        $8678435223df8161$var$hasWarned[msg] = true;
        $8678435223df8161$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $8678435223df8161$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get('*') || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $8678435223df8161$var$isNotObjectOrIsArray = (val)=>!$8678435223df8161$export$a6cdc56e425d0d0a(val) || $8678435223df8161$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8678435223df8161$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($8678435223df8161$var$isNotObjectOrIsArray(src) || $8678435223df8161$var$isNotObjectOrIsArray(des)) throw new Error('Invalid value');
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        // using `Object.keys` which skips prototype properties
        Object.keys(src).forEach((key)=>{
            if (key === '__proto__') return;
            // if src[key] is an object/array, set des[key]
            // to empty object/array to prevent setting by reference
            if ($8678435223df8161$export$a6cdc56e425d0d0a(src[key]) && !$8678435223df8161$export$a6cdc56e425d0d0a(des[key])) des[key] = Array.isArray(src[key]) ? [] : $8678435223df8161$export$185802fd694ee1f5();
            if ($8678435223df8161$var$isNotObjectOrIsArray(des[key]) || $8678435223df8161$var$isNotObjectOrIsArray(src[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}

});

parcelRegister("6ZJ5y", function(module, exports) {

$parcel$export(module.exports, "COMPILE_ERROR_CODES_EXTEND_POINT", () => $ca640327c340cd5b$export$7e7c8f5214db59b5);
$parcel$export(module.exports, "createCompileError", () => $ca640327c340cd5b$export$21efa8bb37d5fecb);
$parcel$export(module.exports, "defaultOnError", () => $ca640327c340cd5b$export$ad0eb2c702f03471);
$parcel$export(module.exports, "detectHtmlTag", () => $ca640327c340cd5b$export$6de85467cbd6ae39);
$parcel$export(module.exports, "baseCompile", () => $ca640327c340cd5b$export$3243579822c486a0);
/*!
  * message-compiler v11.1.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9FmEQ = parcelRequire("9FmEQ");
const $ca640327c340cd5b$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $ca640327c340cd5b$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $ca640327c340cd5b$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $ca640327c340cd5b$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16
};
// Special value for higher-order compilers to pick up the last code
// to avoid collision of error codes.
// This should always be kept as the last item.
const $ca640327c340cd5b$export$7e7c8f5214db59b5 = 17;
/** @internal */ const $ca640327c340cd5b$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$ca640327c340cd5b$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$ca640327c340cd5b$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$ca640327c340cd5b$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$ca640327c340cd5b$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$ca640327c340cd5b$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$ca640327c340cd5b$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$ca640327c340cd5b$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$ca640327c340cd5b$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$ca640327c340cd5b$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $ca640327c340cd5b$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $ca640327c340cd5b$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $ca640327c340cd5b$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $ca640327c340cd5b$export$6de85467cbd6ae39 = (source)=>$ca640327c340cd5b$var$RE_HTML_TAG.test(source);
const $ca640327c340cd5b$var$CHAR_SP = ' ';
const $ca640327c340cd5b$var$CHAR_CR = '\r';
const $ca640327c340cd5b$var$CHAR_LF = '\n';
const $ca640327c340cd5b$var$CHAR_LS = String.fromCharCode(0x2028);
const $ca640327c340cd5b$var$CHAR_PS = String.fromCharCode(0x2029);
function $ca640327c340cd5b$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $ca640327c340cd5b$var$CHAR_CR && _buf[index + 1] === $ca640327c340cd5b$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $ca640327c340cd5b$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $ca640327c340cd5b$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $ca640327c340cd5b$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $ca640327c340cd5b$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $ca640327c340cd5b$var$EOF = undefined;
const $ca640327c340cd5b$var$DOT = '.';
const $ca640327c340cd5b$var$LITERAL_DELIMITER = "'";
const $ca640327c340cd5b$var$ERROR_DOMAIN$3 = 'tokenizer';
function $ca640327c340cd5b$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $ca640327c340cd5b$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$ca640327c340cd5b$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 13 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 13 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $ca640327c340cd5b$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $ca640327c340cd5b$export$21efa8bb37d5fecb(code, loc, {
                domain: $ca640327c340cd5b$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $ca640327c340cd5b$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 13 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($ca640327c340cd5b$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while(scnr.currentPeek() === $ca640327c340cd5b$var$CHAR_SP || scnr.currentPeek() === $ca640327c340cd5b$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $ca640327c340cd5b$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $ca640327c340cd5b$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $ca640327c340cd5b$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 7 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 7 /* TokenTypes.LinkedAlias */  || currentType === 11 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $ca640327c340cd5b$var$CHAR_SP || !ch) return false;
            else if (ch === $ca640327c340cd5b$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '')=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return hasSpace;
            else if (ch === "|" /* TokenChars.Pipe */ ) return !(prev === $ca640327c340cd5b$var$CHAR_SP || prev === $ca640327c340cd5b$var$CHAR_LF);
            else if (ch === $ca640327c340cd5b$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $ca640327c340cd5b$var$CHAR_SP);
            } else if (ch === $ca640327c340cd5b$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $ca640327c340cd5b$var$CHAR_LF);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $ca640327c340cd5b$var$EOF) return $ca640327c340cd5b$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readText(scnr) {
        let buf = '';
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === $ca640327c340cd5b$var$CHAR_SP || ch === $ca640327c340cd5b$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $ca640327c340cd5b$var$EOF) emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $ca640327c340cd5b$var$EOF) emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $ca640327c340cd5b$var$LITERAL_DELIMITER && ch !== $ca640327c340cd5b$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        while(ch = takeChar(scnr, isLiteral))if (ch === '\\') literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $ca640327c340cd5b$var$CHAR_LF || current === $ca640327c340cd5b$var$EOF) {
            emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $ca640327c340cd5b$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case '\\':
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($ca640327c340cd5b$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($ca640327c340cd5b$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $ca640327c340cd5b$var$CHAR_SP && ch !== $ca640327c340cd5b$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $ca640327c340cd5b$var$CHAR_SP) return buf;
            else if (ch === $ca640327c340cd5b$var$CHAR_LF || ch === $ca640327c340cd5b$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn('');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($ca640327c340cd5b$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($ca640327c340cd5b$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 4 /* TokenTypes.Named */  || context.currentType === 5 /* TokenTypes.List */  || context.currentType === 6 /* TokenTypes.Literal */ )) {
                        emitError($ca640327c340cd5b$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 4 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 12 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($ca640327c340cd5b$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 7 /* TokenTypes.LinkedAlias */  || currentType === 8 /* TokenTypes.LinkedDot */  || currentType === 11 /* TokenTypes.LinkedModifier */  || currentType === 9 /* TokenTypes.LinkedDelimiter */ ) && (ch === $ca640327c340cd5b$var$CHAR_LF || ch === $ca640327c340cd5b$var$CHAR_SP)) emitError($ca640327c340cd5b$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 7 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 8 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 11 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 10 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 7 /* TokenTypes.LinkedAlias */ ) emitError($ca640327c340cd5b$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 13 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($ca640327c340cd5b$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                break;
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $ca640327c340cd5b$var$EOF) return getToken(_context, 13 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $ca640327c340cd5b$export$9838302824baa7fa = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $ca640327c340cd5b$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $ca640327c340cd5b$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $ca640327c340cd5b$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $ca640327c340cd5b$export$90c043f1c57770b8(start, end) : null;
            const err = $ca640327c340cd5b$export$21efa8bb37d5fecb(code, loc, {
                domain: $ca640327c340cd5b$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($ca640327c340cd5b$var$KNOWN_ESCAPES, $ca640327c340cd5b$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 11 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 8 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 9 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 10 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 4 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 5 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 6 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = '';
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 5 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 4 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || ''));
                    break;
                case 6 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $ca640327c340cd5b$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 7 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 13 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 13 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 13 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $ca640327c340cd5b$var$createTokenizer(source, (0, $9FmEQ.assign)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 13 /* TokenTypes.EOF */ ) emitError(tokenizer, $ca640327c340cd5b$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $ca640327c340cd5b$var$getTokenCaption(token) {
    if (token.type === 13 /* TokenTypes.EOF */ ) return 'EOF';
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $ca640327c340cd5b$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $ca640327c340cd5b$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$ca640327c340cd5b$var$traverseNode(nodes[i], transformer);
}
function $ca640327c340cd5b$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $ca640327c340cd5b$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $ca640327c340cd5b$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $ca640327c340cd5b$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $ca640327c340cd5b$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $ca640327c340cd5b$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $ca640327c340cd5b$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $ca640327c340cd5b$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $ca640327c340cd5b$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$ca640327c340cd5b$var$optimizeMessageNode(c));
    return ast;
}
function $ca640327c340cd5b$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $9FmEQ.join)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $ca640327c340cd5b$var$ERROR_DOMAIN$1 = 'minifier';
/* eslint-disable @typescript-eslint/no-explicit-any */ function $ca640327c340cd5b$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $ca640327c340cd5b$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$ca640327c340cd5b$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$ca640327c340cd5b$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $ca640327c340cd5b$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $ca640327c340cd5b$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $ca640327c340cd5b$var$ERROR_DOMAIN = 'parser';
function $ca640327c340cd5b$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $ca640327c340cd5b$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $ca640327c340cd5b$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $ca640327c340cd5b$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $ca640327c340cd5b$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $ca640327c340cd5b$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function $ca640327c340cd5b$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $ca640327c340cd5b$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $ca640327c340cd5b$var$generateResource(generator, node) {
    if (node.body) $ca640327c340cd5b$var$generateNode(generator, node.body);
    else generator.push('null');
}
function $ca640327c340cd5b$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $ca640327c340cd5b$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $ca640327c340cd5b$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $ca640327c340cd5b$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $ca640327c340cd5b$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $ca640327c340cd5b$var$generate = (ast, options = {})=>{
    const mode = (0, $9FmEQ.isString)(options.mode) ? options.mode : 'normal';
    const filename = (0, $9FmEQ.isString)(options.filename) ? options.filename : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === 'arrow' ? ';' : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = $ca640327c340cd5b$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $9FmEQ.join)(helpers.map((s)=>`${s}: _${s}`), ', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $ca640327c340cd5b$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $ca640327c340cd5b$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $9FmEQ.assign)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $ca640327c340cd5b$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $ca640327c340cd5b$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $ca640327c340cd5b$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $ca640327c340cd5b$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $ca640327c340cd5b$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ''
        };
    }
}

});



parcelRegister("2fn8G", function(module, exports) {

$parcel$export(module.exports, "useVueform", () => base$1g);
$parcel$export(module.exports, "useClasses", () => base$1f);
$parcel$export(module.exports, "Vueform", () => VueformComponent);
$parcel$export(module.exports, "Validator", () => Validator);
$parcel$export(module.exports, "accepted", () => accepted);
$parcel$export(module.exports, "active_url", () => active_url);
$parcel$export(module.exports, "after", () => after);
$parcel$export(module.exports, "after_or_equal", () => after_or_equal);
$parcel$export(module.exports, "alpha", () => alpha);
$parcel$export(module.exports, "alpha_dash", () => alpha_dash);
$parcel$export(module.exports, "alpha_num", () => alpha_num);
$parcel$export(module.exports, "array", () => array$2);
$parcel$export(module.exports, "before", () => before);
$parcel$export(module.exports, "before_or_equal", () => before_or_equal);
$parcel$export(module.exports, "between", () => between);
$parcel$export(module.exports, "boolean", () => boolean$1);
$parcel$export(module.exports, "captcha", () => captcha$2);
$parcel$export(module.exports, "completed", () => completed);
$parcel$export(module.exports, "confirmed", () => confirmed);
$parcel$export(module.exports, "date", () => date$4);
$parcel$export(module.exports, "date_equals", () => date_equals);
$parcel$export(module.exports, "date_format", () => date_format);
$parcel$export(module.exports, "different", () => different);
$parcel$export(module.exports, "digits", () => digits);
$parcel$export(module.exports, "digits_between", () => digits_between);
$parcel$export(module.exports, "dimensions", () => dimensions);
$parcel$export(module.exports, "distinct", () => distinct);
$parcel$export(module.exports, "email", () => email);
$parcel$export(module.exports, "exists", () => exists);
$parcel$export(module.exports, "file", () => file$5);
$parcel$export(module.exports, "filled", () => filled);
$parcel$export(module.exports, "gt", () => gt);
$parcel$export(module.exports, "gte", () => gte);
$parcel$export(module.exports, "image", () => image);
$parcel$export(module.exports, "in_", () => in_);
$parcel$export(module.exports, "in_array", () => in_array);
$parcel$export(module.exports, "integer", () => integer);
$parcel$export(module.exports, "ipv4", () => ipv4);
$parcel$export(module.exports, "ipv6", () => ipv6);
$parcel$export(module.exports, "ip", () => ip);
$parcel$export(module.exports, "json", () => json);
$parcel$export(module.exports, "lt", () => lt);
$parcel$export(module.exports, "lte", () => lte);
$parcel$export(module.exports, "max", () => max);
$parcel$export(module.exports, "mimes", () => mimes);
$parcel$export(module.exports, "mimetypes", () => mimetypes);
$parcel$export(module.exports, "min", () => min$1);
$parcel$export(module.exports, "not_in", () => not_in);
$parcel$export(module.exports, "not_regex", () => not_regex);
$parcel$export(module.exports, "nullable", () => nullable);
$parcel$export(module.exports, "numeric", () => numeric);
$parcel$export(module.exports, "regex", () => regex);
$parcel$export(module.exports, "required", () => required);
$parcel$export(module.exports, "same", () => same);
$parcel$export(module.exports, "size", () => size);
$parcel$export(module.exports, "string", () => string);
$parcel$export(module.exports, "timezone", () => timezone);
$parcel$export(module.exports, "unique", () => unique);
$parcel$export(module.exports, "url", () => url);
$parcel$export(module.exports, "uuid", () => uuid);
$parcel$export(module.exports, "installer", () => installer);
$parcel$export(module.exports, "FormErrors", () => FormErrors);
$parcel$export(module.exports, "FormMessages", () => FormMessages);
$parcel$export(module.exports, "FormLanguages", () => FormLanguages);
$parcel$export(module.exports, "FormLanguage", () => FormLanguage);
$parcel$export(module.exports, "FormTabs", () => FormTabs);
$parcel$export(module.exports, "FormTab", () => FormTab);
$parcel$export(module.exports, "FormSteps", () => FormSteps);
$parcel$export(module.exports, "FormStepsControls", () => FormStepsControls);
$parcel$export(module.exports, "FormStepsControl", () => FormStepsControl);
$parcel$export(module.exports, "FormStep", () => FormStep);
$parcel$export(module.exports, "FormElements", () => FormElements);
$parcel$export(module.exports, "ElementLayout", () => ElementLayout);
$parcel$export(module.exports, "ElementLayoutInline", () => ElementLayoutInline);
$parcel$export(module.exports, "ElementLoader", () => ElementLoader);
$parcel$export(module.exports, "ElementLabelFloating", () => ElementLabelFloating);
$parcel$export(module.exports, "ElementLabel", () => ElementLabel);
$parcel$export(module.exports, "ElementInfo", () => ElementInfo);
$parcel$export(module.exports, "ElementDescription", () => ElementDescription);
$parcel$export(module.exports, "ElementError", () => ElementError);
$parcel$export(module.exports, "ElementMessage", () => ElementMessage);
$parcel$export(module.exports, "ElementRequired", () => ElementRequired);
$parcel$export(module.exports, "ElementText", () => ElementText);
$parcel$export(module.exports, "DragAndDrop", () => DragAndDrop);
$parcel$export(module.exports, "ElementAddon", () => ElementAddon);
$parcel$export(module.exports, "ElementAddonOptions", () => ElementAddonOptions);
$parcel$export(module.exports, "DatepickerWrapper", () => DatepickerWrapper);
$parcel$export(module.exports, "EditorWrapper", () => EditorWrapper);
$parcel$export(module.exports, "ButtonElement", () => ButtonElement);
$parcel$export(module.exports, "CaptchaElement", () => CaptchaElement);
$parcel$export(module.exports, "CheckboxElement", () => CheckboxElement);
$parcel$export(module.exports, "CheckboxgroupElement", () => CheckboxgroupElement);
$parcel$export(module.exports, "DateElement", () => DateElement);
$parcel$export(module.exports, "DatesElement", () => DatesElement);
$parcel$export(module.exports, "FileElement", () => FileElement);
$parcel$export(module.exports, "GenericElement", () => GenericElement);
$parcel$export(module.exports, "GridElement", () => GridElement);
$parcel$export(module.exports, "GroupElement", () => GroupElement);
$parcel$export(module.exports, "HiddenElement", () => HiddenElement);
$parcel$export(module.exports, "ListElement", () => ListElement);
$parcel$export(module.exports, "LocationElement", () => LocationElement);
$parcel$export(module.exports, "MatrixElement", () => MatrixElement);
$parcel$export(module.exports, "MultifileElement", () => MultifileElement);
$parcel$export(module.exports, "MultiselectElement", () => MultiselectElement);
$parcel$export(module.exports, "ObjectElement", () => ObjectElement);
$parcel$export(module.exports, "PhoneElement", () => PhoneElement);
$parcel$export(module.exports, "RadioElement", () => RadioElement);
$parcel$export(module.exports, "RadiogroupElement", () => RadiogroupElement);
$parcel$export(module.exports, "SelectElement", () => SelectElement);
$parcel$export(module.exports, "SignatureElement", () => SignatureElement);
$parcel$export(module.exports, "SliderElement", () => SliderElement);
$parcel$export(module.exports, "StaticElement", () => StaticElement);
$parcel$export(module.exports, "TagsElement", () => TagsElement);
$parcel$export(module.exports, "TextareaElement", () => TextareaElement);
$parcel$export(module.exports, "TextElement", () => TextElement);
$parcel$export(module.exports, "ToggleElement", () => ToggleElement);
$parcel$export(module.exports, "EditorElement", () => EditorElement);
$parcel$export(module.exports, "TTextareaElement", () => TTextareaElement);
$parcel$export(module.exports, "TTextElement", () => TTextElement);
$parcel$export(module.exports, "TEditorElement", () => TEditorElement);
$parcel$export(module.exports, "CheckboxgroupCheckbox", () => CheckboxgroupCheckbox);
$parcel$export(module.exports, "FilePreview", () => FilePreview);
$parcel$export(module.exports, "RadiogroupRadio", () => RadiogroupRadio);
$parcel$export(module.exports, "element", () => element);
$parcel$export(module.exports, "defineConfig", () => defineConfig);
$parcel$export(module.exports, "VueformElement", () => VueformElement);
$parcel$export(module.exports, "defineElement", () => defineElement);
$parcel$export(module.exports, "default", () => vueform);
$parcel$export(module.exports, "vueform", () => vueform);
/*!
 * Vueform v1.12.4 (https://github.com/vueform/vueform)
 * Copyright (c) 2025 Adam Berecz <adam@vueform.com>
 * Licensed under the MIT License
 */ parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");

var $YChVI = parcelRequire("YChVI");
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function _defineProperty$2(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
            _defineProperty$2(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var each$1 = {
    exports: {}
};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach$2(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var _arrayEach = arrayEach$2;
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor$1(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor$2 = createBaseFor();
var _baseFor = baseFor$2;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes$1(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var _baseTimes = baseTimes$1;
/** Detect free variable `global` from Node.js. */ var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root$8 = freeGlobal || freeSelf || Function('return this')();
var _root = root$8;
var root$7 = _root;
/** Built-in value references. */ var Symbol$7 = root$7.Symbol;
var _Symbol = Symbol$7;
var Symbol$6 = _Symbol;
/** Used for built-in method references. */ var objectProto$g = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$e = objectProto$g.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString$1 = objectProto$g.toString;
/** Built-in value references. */ var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag$1(value) {
    var isOwn = hasOwnProperty$e.call(value, symToStringTag$1), tag = value[symToStringTag$1];
    try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag$1] = tag;
        else delete value[symToStringTag$1];
    }
    return result;
}
var _getRawTag = getRawTag$1;
/** Used for built-in method references. */ var objectProto$f = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto$f.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString$1(value) {
    return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag$7(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$7;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike$a(value) {
    return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike$a;
var baseGetTag$6 = _baseGetTag, isObjectLike$9 = isObjectLike_1;
/** `Object#toString` result references. */ var argsTag$3 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments$1(value) {
    return isObjectLike$9(value) && baseGetTag$6(value) == argsTag$3;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$8 = isObjectLike_1;
/** Used for built-in method references. */ var objectProto$e = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$d = objectProto$e.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable$1 = objectProto$e.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments$5 = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike$8(value) && hasOwnProperty$d.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments$5;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray$k = Array.isArray;
var isArray_1 = isArray$k;
var isBuffer$6 = {
    exports: {}
};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
    var root = _root, stubFalse = stubFalse_1;
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
    /**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */ var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
})(isBuffer$6, isBuffer$6.exports);
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex$4(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex$4;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength$3(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var baseGetTag$5 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$7 = isObjectLike_1;
/** `Object#toString` result references. */ var argsTag$2 = '[object Arguments]', arrayTag$2 = '[object Array]', boolTag$3 = '[object Boolean]', dateTag$3 = '[object Date]', errorTag$2 = '[object Error]', funcTag$2 = '[object Function]', mapTag$6 = '[object Map]', numberTag$3 = '[object Number]', objectTag$4 = '[object Object]', regexpTag$3 = '[object RegExp]', setTag$6 = '[object Set]', stringTag$4 = '[object String]', weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$3 = '[object ArrayBuffer]', dataViewTag$4 = '[object DataView]', float32Tag$2 = '[object Float32Array]', float64Tag$2 = '[object Float64Array]', int8Tag$2 = '[object Int8Array]', int16Tag$2 = '[object Int16Array]', int32Tag$2 = '[object Int32Array]', uint8Tag$2 = '[object Uint8Array]', uint8ClampedTag$2 = '[object Uint8ClampedArray]', uint16Tag$2 = '[object Uint16Array]', uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray$1(value) {
    return isObjectLike$7(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$5(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary$5(func) {
    return function(value) {
        return func(value);
    };
}
var _baseUnary = baseUnary$5;
var _nodeUtil = {
    exports: {}
};
(function(module, exports) {
    var freeGlobal = _freeGlobal;
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    module.exports = nodeUtil;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary$4 = _baseUnary, nodeUtil$2 = _nodeUtil.exports;
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray$4 = nodeIsTypedArray ? baseUnary$4(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$4;
var baseTimes = _baseTimes, isArguments$4 = isArguments_1, isArray$j = isArray_1, isBuffer$5 = isBuffer$6.exports, isIndex$3 = _isIndex, isTypedArray$3 = isTypedArray_1;
/** Used for built-in method references. */ var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$c = objectProto$d.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys$2(value, inherited) {
    var isArr = isArray$j(value), isArg = !isArr && isArguments$4(value), isBuff = !isArr && !isArg && isBuffer$5(value), isType = !isArr && !isArg && !isBuff && isTypedArray$3(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty$c.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex$3(key, length)))) result.push(key);
    return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
/** Used for built-in method references. */ var objectProto$c = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype$4(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$c;
    return value === proto;
}
var _isPrototype = isPrototype$4;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg$2(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$3 = _isPrototype, nativeKeys = _nativeKeys;
/** Used for built-in method references. */ var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$b = objectProto$b.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys$2(object) {
    if (!isPrototype$3(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty$b.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var _baseKeys = baseKeys$2;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject$b(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$b;
var baseGetTag$4 = _baseGetTag, isObject$a = isObject_1;
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag$1 = '[object Function]', genTag$1 = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction$4(value) {
    if (!isObject$a(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag$4(value);
    return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$4;
var isFunction$3 = isFunction_1, isLength$1 = isLength_1;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike$9(value) {
    return value != null && isLength$1(value.length) && !isFunction$3(value);
}
var isArrayLike_1 = isArrayLike$9;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$8 = isArrayLike_1;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys$7(object) {
    return isArrayLike$8(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}
var keys_1 = keys$7;
var baseFor$1 = _baseFor, keys$6 = keys_1;
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn$2(object, iteratee) {
    return object && baseFor$1(object, iteratee, keys$6);
}
var _baseForOwn = baseForOwn$2;
var isArrayLike$7 = isArrayLike_1;
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach$1(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike$7(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn$1 = _baseForOwn, createBaseEach = _createBaseEach;
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach$5 = createBaseEach(baseForOwn$1);
var _baseEach = baseEach$5;
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity$5(value) {
    return value;
}
var identity_1 = identity$5;
var identity$4 = identity_1;
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction$1(value) {
    return typeof value == 'function' ? value : identity$4;
}
var _castFunction = castFunction$1;
var arrayEach$1 = _arrayEach, baseEach$4 = _baseEach, castFunction = _castFunction, isArray$i = isArray_1;
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = isArray$i(collection) ? arrayEach$1 : baseEach$4;
    return func(collection, castFunction(iteratee));
}
var forEach_1 = forEach;
(function(module) {
    module.exports = forEach_1;
})(each$1);
var each = /*@__PURE__*/ getDefaultExportFromCjs(each$1.exports);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear$1() {
    this.__data__ = [];
    this.size = 0;
}
var _listCacheClear = listCacheClear$1;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq$5(value, other) {
    return value === other || value !== value && other !== other;
}
var eq_1 = eq$5;
var eq$4 = eq_1;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf$4(array, key) {
    var length = array.length;
    while(length--){
        if (eq$4(array[length][0], key)) return length;
    }
    return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete$1(key) {
    var data = this.__data__, index = assocIndexOf$3(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet$1(key) {
    var data = this.__data__, index = assocIndexOf$2(data, key);
    return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas$1(key) {
    return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet$1(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache$4(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear$1() {
    this.__data__ = new ListCache$3;
    this.size = 0;
}
var _stackClear = stackClear$1;
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete$1(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var _stackDelete = stackDelete$1;
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet$1(key) {
    return this.__data__.get(key);
}
var _stackGet = stackGet$1;
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas$1(key) {
    return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var root$6 = _root;
/** Used to detect overreaching core-js shims. */ var coreJsData$1 = root$6['__core-js_shared__'];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked$1(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
/** Used for built-in method references. */ var funcProto$2 = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString$2 = funcProto$2.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource$2(func) {
    if (func != null) {
        try {
            return funcToString$2.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1, isMasked = _isMasked, isObject$9 = isObject_1, toSource$1 = _toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto$1 = Function.prototype, objectProto$a = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */ var hasOwnProperty$a = objectProto$a.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative$1(value) {
    if (!isObject$9(value) || isMasked(value)) return false;
    var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue$1(object, key) {
    return object == null ? undefined : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative$7(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
var _getNative = getNative$7;
var getNative$6 = _getNative, root$5 = _root;
/* Built-in method references that are verified to be native. */ var Map$4 = getNative$6(root$5, 'Map');
var _Map = Map$4;
var getNative$5 = _getNative;
/* Built-in method references that are verified to be native. */ var nativeCreate$4 = getNative$5(Object, 'create');
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear$1() {
    this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
    this.size = 0;
}
var _hashClear = hashClear$1;
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete$1(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$9 = objectProto$9.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet$1(key) {
    var data = this.__data__;
    if (nativeCreate$2) {
        var result = data[key];
        return result === HASH_UNDEFINED$2 ? undefined : result;
    }
    return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
/** Used for built-in method references. */ var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$8 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas$1(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet$1(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash$1(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear$1() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map$3 || ListCache$2),
        'string': new Hash
    };
}
var _mapCacheClear = mapCacheClear$1;
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable$1(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData$4(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete$1(key) {
    var result = getMapData$3(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet$1(key) {
    return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas$1(key) {
    return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet$1(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache$3(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$2 = _MapCache;
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE$2 = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet$1(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache$1) {
        var pairs = data.__data__;
        if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache$2(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack$4(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack$4.prototype.clear = stackClear;
Stack$4.prototype['delete'] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;
var _Stack = Stack$4;
var getNative$4 = _getNative;
var defineProperty$2 = function() {
    try {
        var func = getNative$4(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var _defineProperty$1 = defineProperty$2;
var defineProperty$1 = _defineProperty$1;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue$4(object, key, value) {
    if (key == '__proto__' && defineProperty$1) defineProperty$1(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var _baseAssignValue = baseAssignValue$4;
var baseAssignValue$3 = _baseAssignValue, eq$3 = eq_1;
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue$2(object, key, value) {
    if (value !== undefined && !eq$3(object[key], value) || value === undefined && !(key in object)) baseAssignValue$3(object, key, value);
}
var _assignMergeValue = assignMergeValue$2;
var _cloneBuffer = {
    exports: {}
};
(function(module, exports) {
    var root = _root;
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
    /**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */ function cloneBuffer(buffer, isDeep) {
        if (isDeep) return buffer.slice();
        var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
    }
    module.exports = cloneBuffer;
})(_cloneBuffer, _cloneBuffer.exports);
var root$4 = _root;
/** Built-in value references. */ var Uint8Array$2 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$2;
var Uint8Array$1 = _Uint8Array;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer$3(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
    return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$3;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray$2(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$2;
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray$3(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var _copyArray = copyArray$3;
var isObject$8 = isObject_1;
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate$1 = function() {
    function object() {}
    return function(proto) {
        if (!isObject$8(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var _baseCreate = baseCreate$1;
var overArg = _overArg;
/** Built-in value references. */ var getPrototype$3 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$3;
var baseCreate = _baseCreate, getPrototype$2 = _getPrototype, isPrototype$2 = _isPrototype;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject$2(object) {
    return typeof object.constructor == 'function' && !isPrototype$2(object) ? baseCreate(getPrototype$2(object)) : {};
}
var _initCloneObject = initCloneObject$2;
var isArrayLike$6 = isArrayLike_1, isObjectLike$6 = isObjectLike_1;
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject$4(value) {
    return isObjectLike$6(value) && isArrayLike$6(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$4;
var baseGetTag$3 = _baseGetTag, getPrototype$1 = _getPrototype, isObjectLike$5 = isObjectLike_1;
/** `Object#toString` result references. */ var objectTag$3 = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto$7 = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty$7 = objectProto$7.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject$2(value) {
    if (!isObjectLike$5(value) || baseGetTag$3(value) != objectTag$3) return false;
    var proto = getPrototype$1(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty$7.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$2;
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet$2(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
var _safeGet = safeGet$2;
var baseAssignValue$2 = _baseAssignValue, eq$2 = eq_1;
/** Used for built-in method references. */ var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$6 = objectProto$6.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue$3(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$6.call(object, key) && eq$2(objValue, value)) || value === undefined && !(key in object)) baseAssignValue$2(object, key, value);
}
var _assignValue = assignValue$3;
var assignValue$2 = _assignValue, baseAssignValue$1 = _baseAssignValue;
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject$6(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue$1(object, key, newValue);
        else assignValue$2(object, key, newValue);
    }
    return object;
}
var _copyObject = copyObject$6;
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn$1(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$7 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
/** Used for built-in method references. */ var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$5 = objectProto$5.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn$1(object) {
    if (!isObject$7(object)) return nativeKeysIn(object);
    var isProto = isPrototype$1(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty$5.call(object, key)))) result.push(key);
    return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$5 = isArrayLike_1;
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn$5(object) {
    return isArrayLike$5(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$5;
var copyObject$5 = _copyObject, keysIn$4 = keysIn_1;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject$1(value) {
    return copyObject$5(value, keysIn$4(value));
}
var toPlainObject_1 = toPlainObject$1;
var assignMergeValue$1 = _assignMergeValue, cloneBuffer$1 = _cloneBuffer.exports, cloneTypedArray$1 = _cloneTypedArray, copyArray$2 = _copyArray, initCloneObject$1 = _initCloneObject, isArguments$3 = isArguments_1, isArray$h = isArray_1, isArrayLikeObject$3 = isArrayLikeObject_1, isBuffer$4 = isBuffer$6.exports, isFunction$1 = isFunction_1, isObject$6 = isObject_1, isPlainObject$1 = isPlainObject_1, isTypedArray$2 = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet$1(object, key), srcValue = safeGet$1(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue$1(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray$h(srcValue), isBuff = !isArr && isBuffer$4(srcValue), isTyped = !isArr && !isBuff && isTypedArray$2(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray$h(objValue)) newValue = objValue;
            else if (isArrayLikeObject$3(objValue)) newValue = copyArray$2(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer$1(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray$1(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject$1(srcValue) || isArguments$3(srcValue)) {
            newValue = objValue;
            if (isArguments$3(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject$6(objValue) || isFunction$1(objValue)) newValue = initCloneObject$1(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue$1(object, key, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;
var Stack$3 = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$5 = isObject_1, keysIn$3 = keysIn_1, safeGet = _safeGet;
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge$1(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack$3);
        if (isObject$5(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn$3);
}
var _baseMerge = baseMerge$1;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply$1(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax$3 = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest$2(func, start, transform) {
    start = nativeMax$3(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax$3(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
var _overRest = overRest$2;
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant$1(value) {
    return function() {
        return value;
    };
}
var constant_1 = constant$1;
var constant = constant_1, defineProperty = _defineProperty$1, identity$3 = identity_1;
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString$1 = !defineProperty ? identity$3 : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
var _baseSetToString = baseSetToString$1;
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut$1(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;
var identity$2 = identity_1, overRest$1 = _overRest, setToString$1 = _setToString;
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest$5(func, start) {
    return setToString$1(overRest$1(func, start, identity$2), func + '');
}
var _baseRest = baseRest$5;
var eq$1 = eq_1, isArrayLike$4 = isArrayLike_1, isIndex$2 = _isIndex, isObject$4 = isObject_1;
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall$3(value, index, object) {
    if (!isObject$4(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike$4(object) && isIndex$2(index, object.length) : type == 'string' && index in object) return eq$1(object[index], value);
    return false;
}
var _isIterateeCall = isIterateeCall$3;
var baseRest$4 = _baseRest, isIterateeCall$2 = _isIterateeCall;
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner$1(assigner) {
    return baseRest$4(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall$2(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var _createAssigner = createAssigner$1;
var baseMerge = _baseMerge, createAssigner = _createAssigner;
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
var merge_1 = merge;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome$2(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var _arraySome = arraySome$2;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd$1(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
var _setCacheAdd = setCacheAdd$1;
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas$1(value) {
    return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache$1 = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache$3(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache$1;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache$3.prototype.add = SetCache$3.prototype.push = setCacheAdd;
SetCache$3.prototype.has = setCacheHas;
var _SetCache = SetCache$3;
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas$3(cache, key) {
    return cache.has(key);
}
var _cacheHas = cacheHas$3;
var SetCache$2 = _SetCache, arraySome$1 = _arraySome, cacheHas$2 = _cacheHas;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$2 : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome$1(other, function(othValue, othIndex) {
                if (!cacheHas$2(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
var _equalArrays = equalArrays$2;
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray$1(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var _mapToArray = mapToArray$1;
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray$3(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var _setToArray = setToArray$3;
var Symbol$4 = _Symbol, Uint8Array = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
/** `Object#toString` result references. */ var boolTag$2 = '[object Boolean]', dateTag$2 = '[object Date]', errorTag$1 = '[object Error]', mapTag$5 = '[object Map]', numberTag$2 = '[object Number]', regexpTag$2 = '[object RegExp]', setTag$5 = '[object Set]', stringTag$3 = '[object String]', symbolTag$3 = '[object Symbol]';
var arrayBufferTag$2 = '[object ArrayBuffer]', dataViewTag$3 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag$3:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag$2:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag$2:
        case dateTag$2:
        case numberTag$2:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag$1:
            return object.name == other.name && object.message == other.message;
        case regexpTag$2:
        case stringTag$3:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag$5:
            var convert = mapToArray;
        case setTag$5:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
            convert || (convert = setToArray$2);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG$2;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag$3:
            if (symbolValueOf$1) return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
    }
    return false;
}
var _equalByTag = equalByTag$1;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush$4(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var _arrayPush = arrayPush$4;
var arrayPush$3 = _arrayPush, isArray$g = isArray_1;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$g(object) ? result : arrayPush$3(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter$2(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var _arrayFilter = arrayFilter$2;
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray$2() {
    return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter$1 = _arrayFilter, stubArray$1 = stubArray_1;
/** Used for built-in method references. */ var objectProto$4 = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto$4.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter$1(nativeGetSymbols$1(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
var _getSymbols = getSymbols$3;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$2 = _getSymbols, keys$5 = keys_1;
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys$2(object) {
    return baseGetAllKeys$1(object, keys$5, getSymbols$2);
}
var _getAllKeys = getAllKeys$2;
var getAllKeys$1 = _getAllKeys;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$3 = 1;
/** Used for built-in method references. */ var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$4 = objectProto$3.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys$1(object), objLength = objProps.length, othProps = getAllKeys$1(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty$4.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative, root$3 = _root;
/* Built-in method references that are verified to be native. */ var DataView$1 = getNative$3(root$3, 'DataView');
var _DataView = DataView$1;
var getNative$2 = _getNative, root$2 = _root;
/* Built-in method references that are verified to be native. */ var Promise$2 = getNative$2(root$2, 'Promise');
var _Promise = Promise$2;
var getNative$1 = _getNative, root$1 = _root;
/* Built-in method references that are verified to be native. */ var Set$2 = getNative$1(root$1, 'Set');
var _Set = Set$2;
var getNative = _getNative, root = _root;
/* Built-in method references that are verified to be native. */ var WeakMap$1 = getNative(root, 'WeakMap');
var _WeakMap = WeakMap$1;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap = _WeakMap, baseGetTag$2 = _baseGetTag, toSource = _toSource;
/** `Object#toString` result references. */ var mapTag$4 = '[object Map]', objectTag$2 = '[object Object]', promiseTag = '[object Promise]', setTag$4 = '[object Set]', weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag$5 = baseGetTag$2;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag$5(new DataView(new ArrayBuffer(1))) != dataViewTag$2 || Map$1 && getTag$5(new Map$1) != mapTag$4 || Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag || Set$1 && getTag$5(new Set$1) != setTag$4 || WeakMap && getTag$5(new WeakMap) != weakMapTag$1) getTag$5 = function(value) {
    var result = baseGetTag$2(value), Ctor = result == objectTag$2 ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag$2;
        case mapCtorString:
            return mapTag$4;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag$4;
        case weakMapCtorString:
            return weakMapTag$1;
    }
    return result;
};
var _getTag = getTag$5;
var Stack$2 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$4 = _getTag, isArray$f = isArray_1, isBuffer$3 = isBuffer$6.exports, isTypedArray$1 = isTypedArray_1;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$2 = 1;
/** `Object#toString` result references. */ var argsTag$1 = '[object Arguments]', arrayTag$1 = '[object Array]', objectTag$1 = '[object Object]';
/** Used for built-in method references. */ var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$f(object), othIsArr = isArray$f(other), objTag = objIsArr ? arrayTag$1 : getTag$4(object), othTag = othIsArr ? arrayTag$1 : getTag$4(other);
    objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
    othTag = othTag == argsTag$1 ? objectTag$1 : othTag;
    var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer$3(object)) {
        if (!isBuffer$3(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack$2);
        return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
        var objIsWrapped = objIsObj && hasOwnProperty$3.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty$3.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack$2);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack$2);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$4 = isObjectLike_1;
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual$3(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike$4(value) && !isObjectLike$4(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}
var _baseIsEqual = baseIsEqual$3;
var Stack$1 = _Stack, baseIsEqual$2 = _baseIsEqual;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch$1(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack$1;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$3 = isObject_1;
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable$2(value) {
    return value === value && !isObject$3(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$4 = keys_1;
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData$1(object) {
    var result = keys$4(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable$1(value)
        ];
    }
    return result;
}
var _getMatchData = getMatchData$1;
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable$2(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches$1(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
var _baseMatches = baseMatches$1;
var baseGetTag$1 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
/** `Object#toString` result references. */ var symbolTag$2 = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol$5(value) {
    return typeof value == 'symbol' || isObjectLike$3(value) && baseGetTag$1(value) == symbolTag$2;
}
var isSymbol_1 = isSymbol$5;
var isArray$e = isArray_1, isSymbol$4 = isSymbol_1;
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey$3(value, object) {
    if (isArray$e(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol$4(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
var MapCache = _MapCache;
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize$1(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize$1.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize$1.Cache = MapCache;
var memoize_1 = memoize$1;
var memoize = memoize_1;
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped$1(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath$1 = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
var _stringToPath = stringToPath$1;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap$6(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var _arrayMap = arrayMap$6;
var Symbol$3 = _Symbol, arrayMap$5 = _arrayMap, isArray$d = isArray_1, isSymbol$3 = isSymbol_1;
/** Used as references for various `Number` constants. */ var INFINITY$4 = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined, symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString$4(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray$d(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap$5(value, baseToString$4) + '';
    if (isSymbol$3(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$4 ? '-0' : result;
}
var _baseToString = baseToString$4;
var baseToString$3 = _baseToString;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString$9(value) {
    return value == null ? '' : baseToString$3(value);
}
var toString_1 = toString$9;
var isArray$c = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$8 = toString_1;
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath$6(value, object) {
    if (isArray$c(value)) return value;
    return isKey$2(value, object) ? [
        value
    ] : stringToPath(toString$8(value));
}
var _castPath = castPath$6;
var isSymbol$2 = isSymbol_1;
/** Used as references for various `Number` constants. */ var INFINITY$3 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey$6(value) {
    if (typeof value == 'string' || isSymbol$2(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
}
var _toKey = toKey$6;
var castPath$5 = _castPath, toKey$5 = _toKey;
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet$5(object, path) {
    path = castPath$5(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey$5(path[index++])];
    return index && index == length ? object : undefined;
}
var _baseGet = baseGet$5;
var baseGet$4 = _baseGet;
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get$1(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet$4(object, path);
    return result === undefined ? defaultValue : result;
}
var get_1 = get$1;
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn$1(object, key) {
    return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var castPath$4 = _castPath, isArguments$2 = isArguments_1, isArray$b = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$4 = _toKey;
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath$1(object, path, hasFunc) {
    path = castPath$4(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey$4(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex$1(key, length) && (isArray$b(object) || isArguments$2(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn$2(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$2;
var baseIsEqual$1 = _baseIsEqual, get = get_1, hasIn$1 = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$3 = _toKey;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty$1(path, srcValue) {
    if (isKey$1(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey$3(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn$1(object, path) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
var _baseMatchesProperty = baseMatchesProperty$1;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty$1(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var _baseProperty = baseProperty$1;
var baseGet$3 = _baseGet;
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep$1(path) {
    return function(object) {
        return baseGet$3(object, path);
    };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey$2 = _toKey;
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property$1(path) {
    return isKey(path) ? baseProperty(toKey$2(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$1 = identity_1, isArray$a = isArray_1, property = property_1;
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee$9(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity$1;
    if (typeof value == 'object') return isArray$a(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
var _baseIteratee = baseIteratee$9;
var baseEach$3 = _baseEach;
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function baseSome$1(collection, predicate) {
    var result;
    baseEach$3(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
var _baseSome = baseSome$1;
var arraySome = _arraySome, baseIteratee$8 = _baseIteratee, baseSome = _baseSome, isArray$9 = isArray_1, isIterateeCall$1 = _isIterateeCall;
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function some(collection, predicate, guard) {
    var func = isArray$9(collection) ? arraySome : baseSome;
    if (guard && isIterateeCall$1(collection, predicate, guard)) predicate = undefined;
    return func(collection, baseIteratee$8(predicate));
}
var some_1 = some;
var baseKeys = _baseKeys, getTag$3 = _getTag, isArguments$1 = isArguments_1, isArray$8 = isArray_1, isArrayLike$3 = isArrayLike_1, isBuffer$2 = isBuffer$6.exports, isPrototype = _isPrototype, isTypedArray = isTypedArray_1;
/** `Object#toString` result references. */ var mapTag$3 = '[object Map]', setTag$3 = '[object Set]';
/** Used for built-in method references. */ var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike$3(value) && (isArray$8(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer$2(value) || isTypedArray(value) || isArguments$1(value))) return !value.length;
    var tag = getTag$3(value);
    if (tag == mapTag$3 || tag == setTag$3) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty$2.call(value, key)) return false;
    }
    return true;
}
var isEmpty_1 = isEmpty;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice$2(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var _baseSlice = baseSlice$2;
var baseSlice$1 = _baseSlice;
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice$2(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice$1(array, start, end);
}
var _castSlice = castSlice$2;
/** Used to compose unicode character classes. */ var rsAstralRange$2 = '\\ud800-\\udfff', rsComboMarksRange$3 = '\\u0300-\\u036f', reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f', rsComboSymbolsRange$3 = '\\u20d0-\\u20ff', rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3, rsVarRange$2 = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ$2 = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode$2(string) {
    return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray$1(string) {
    return string.split('');
}
var _asciiToArray = asciiToArray$1;
/** Used to compose unicode character classes. */ var rsAstralRange$1 = '\\ud800-\\udfff', rsComboMarksRange$2 = '\\u0300-\\u036f', reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f', rsComboSymbolsRange$2 = '\\u20d0-\\u20ff', rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsVarRange$1 = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange$1 + ']', rsCombo$2 = '[' + rsComboRange$2 + ']', rsFitz$1 = '\\ud83c[\\udffb-\\udfff]', rsModifier$1 = '(?:' + rsCombo$2 + '|' + rsFitz$1 + ')', rsNonAstral$1 = '[^' + rsAstralRange$1 + ']', rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ$1 = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod$1 = rsModifier$1 + '?', rsOptVar$1 = '[' + rsVarRange$1 + ']?', rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [
    rsNonAstral$1,
    rsRegional$1,
    rsSurrPair$1
].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*', rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsSymbol = '(?:' + [
    rsNonAstral$1 + rsCombo$2 + '?',
    rsCombo$2,
    rsRegional$1,
    rsSurrPair$1,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz$1 + '(?=' + rsFitz$1 + ')|' + rsSymbol + rsSeq$1, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray$1(string) {
    return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray$2(string) {
    return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$2;
var castSlice$1 = _castSlice, hasUnicode = _hasUnicode, stringToArray$1 = _stringToArray, toString$7 = toString_1;
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst$2(methodName) {
    return function(string) {
        string = toString$7(string);
        var strSymbols = hasUnicode(string) ? stringToArray$1(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice$1(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
var _createCaseFirst = createCaseFirst$2;
var createCaseFirst$1 = _createCaseFirst;
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst$1 = createCaseFirst$1('toUpperCase');
var upperFirst_1 = upperFirst$1;
var baseEach$2 = _baseEach;
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function baseFilter$1(collection, predicate) {
    var result = [];
    baseEach$2(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
var _baseFilter = baseFilter$1;
var arrayFilter = _arrayFilter, baseFilter = _baseFilter, baseIteratee$7 = _baseIteratee, isArray$7 = isArray_1;
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function filter(collection, predicate) {
    var func = isArray$7(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee$7(predicate));
}
var filter_1 = filter;
var copyObject$4 = _copyObject, keys$3 = keys_1;
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign$1(object, source) {
    return object && copyObject$4(source, keys$3(source), object);
}
var _baseAssign = baseAssign$1;
var copyObject$3 = _copyObject, keysIn$2 = keysIn_1;
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn$1(object, source) {
    return object && copyObject$3(source, keysIn$2(source), object);
}
var _baseAssignIn = baseAssignIn$1;
var copyObject$2 = _copyObject, getSymbols$1 = _getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols$1(source, object) {
    return copyObject$2(source, getSymbols$1(source), object);
}
var _copySymbols = copySymbols$1;
var arrayPush$2 = _arrayPush, getPrototype = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush$2(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject$1 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn$1(source, object) {
    return copyObject$1(source, getSymbolsIn$1(source), object);
}
var _copySymbolsIn = copySymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$1 = keysIn_1;
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn$2(object) {
    return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$2;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray$1(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var _initCloneArray = initCloneArray$1;
var cloneArrayBuffer$1 = _cloneArrayBuffer;
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView$1(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer$1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp$1(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$2 = _Symbol;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol$1(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray = _cloneTypedArray;
/** `Object#toString` result references. */ var boolTag$1 = '[object Boolean]', dateTag$1 = '[object Date]', mapTag$2 = '[object Map]', numberTag$1 = '[object Number]', regexpTag$1 = '[object RegExp]', setTag$2 = '[object Set]', stringTag$2 = '[object String]', symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]', dataViewTag$1 = '[object DataView]', float32Tag$1 = '[object Float32Array]', float64Tag$1 = '[object Float64Array]', int8Tag$1 = '[object Int8Array]', int16Tag$1 = '[object Int16Array]', int32Tag$1 = '[object Int32Array]', uint8Tag$1 = '[object Uint8Array]', uint8ClampedTag$1 = '[object Uint8ClampedArray]', uint16Tag$1 = '[object Uint16Array]', uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag$1(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag$1:
            return cloneArrayBuffer(object);
        case boolTag$1:
        case dateTag$1:
            return new Ctor(+object);
        case dataViewTag$1:
            return cloneDataView(object, isDeep);
        case float32Tag$1:
        case float64Tag$1:
        case int8Tag$1:
        case int16Tag$1:
        case int32Tag$1:
        case uint8Tag$1:
        case uint8ClampedTag$1:
        case uint16Tag$1:
        case uint32Tag$1:
            return cloneTypedArray(object, isDeep);
        case mapTag$2:
            return new Ctor;
        case numberTag$1:
        case stringTag$2:
            return new Ctor(object);
        case regexpTag$1:
            return cloneRegExp(object);
        case setTag$2:
            return new Ctor;
        case symbolTag$1:
            return cloneSymbol(object);
    }
}
var _initCloneByTag = initCloneByTag$1;
var getTag$2 = _getTag, isObjectLike$2 = isObjectLike_1;
/** `Object#toString` result references. */ var mapTag$1 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap$1(value) {
    return isObjectLike$2(value) && getTag$2(value) == mapTag$1;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$3 = _baseUnary, nodeUtil$1 = _nodeUtil.exports;
/* Node.js helper references. */ var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap$1 = nodeIsMap ? baseUnary$3(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$1 = _getTag, isObjectLike$1 = isObjectLike_1;
/** `Object#toString` result references. */ var setTag$1 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet$1(value) {
    return isObjectLike$1(value) && getTag$1(value) == setTag$1;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary$2 = _baseUnary, nodeUtil = _nodeUtil.exports;
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet$1 = nodeIsSet ? baseUnary$2(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack = _Stack, arrayEach = _arrayEach, assignValue$1 = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer = _cloneBuffer.exports, copyArray$1 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys = _getAllKeys, getAllKeysIn$1 = _getAllKeysIn, getTag = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject = _initCloneObject, isArray$6 = isArray_1, isBuffer$1 = isBuffer$6.exports, isMap = isMap_1, isObject$2 = isObject_1, isSet = isSet_1, keys$2 = keys_1, keysIn = keysIn_1;
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$3 = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag$1 = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag$1] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone$3(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$3;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject$2(value)) return value;
    var isArr = isArray$6(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray$1(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer$1(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone$3(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone$3(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn$1 : getAllKeys : isFlat ? keysIn : keys$2;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue$1(result, key, baseClone$3(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var _baseClone = baseClone$3;
var baseClone$2 = _baseClone;
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$2 = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone$2(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$2);
}
var cloneDeep_1 = cloneDeep;
var assignValue = _assignValue, castPath$3 = _castPath, isIndex = _isIndex, isObject$1 = isObject_1, toKey$1 = _toKey;
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet$2(object, path, value, customizer) {
    if (!isObject$1(object)) return object;
    path = castPath$3(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey$1(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject$1(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var _baseSet = baseSet$2;
var baseSet$1 = _baseSet;
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet$1(object, path, value);
}
var set_1 = set;
var Symbol$1 = _Symbol, isArguments = isArguments_1, isArray$5 = isArray_1;
/** Built-in value references. */ var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable$1(value) {
    return isArray$5(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$1 = _arrayPush, isFlattenable = _isFlattenable;
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten$6(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten$6(value, depth - 1, predicate, isStrict, result);
            else arrayPush$1(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var _baseFlatten = baseFlatten$6;
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex$3(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var _baseFindIndex = baseFindIndex$3;
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN$1(value) {
    return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf$1(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex$2 = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf$4(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex$2(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$4;
var baseIndexOf$3 = _baseIndexOf;
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes$2(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf$3(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$2;
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith$2(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var _arrayIncludesWith = arrayIncludesWith$2;
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop$1() {
// No operation performed.
}
var noop_1 = noop$1;
var Set = _Set, noop = noop_1, setToArray$1 = _setToArray;
/** Used as references for various `Number` constants. */ var INFINITY$2 = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet$1 = !(Set && 1 / setToArray$1(new Set([
    ,
    -0
]))[1] == INFINITY$2) ? noop : function(values) {
    return new Set(values);
};
var _createSet = createSet$1;
var SetCache$1 = _SetCache, arrayIncludes$1 = _arrayIncludes, arrayIncludesWith$1 = _arrayIncludesWith, cacheHas$1 = _cacheHas, createSet = _createSet, setToArray = _setToArray;
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE$1 = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq$1(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes$1, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith$1;
    } else if (length >= LARGE_ARRAY_SIZE$1) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas$1;
        seen = new SetCache$1;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var _baseUniq = baseUniq$1;
var baseFlatten$5 = _baseFlatten, baseRest$3 = _baseRest, baseUniq = _baseUniq, isArrayLikeObject$2 = isArrayLikeObject_1;
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest$3(function(arrays) {
    return baseUniq(baseFlatten$5(arrays, 1, isArrayLikeObject$2, true));
});
var union_1 = union;
var baseFlatten$4 = _baseFlatten;
/** Used as references for various `Number` constants. */ var INFINITY$1 = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten$4(array, INFINITY$1) : [];
}
var flattenDeep_1 = flattenDeep;
var MERGE_KEYS = [
    'presets',
    'usePresets',
    'addClasses',
    'prependClasses',
    'removeClasses',
    'replaceClasses',
    'overrideClasses'
];
var LOCALS_KEYS = [
    'addClass',
    'removeClass',
    'replaceClass',
    'overrideClass'
];
class MergeClasses {
    constructor(){
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.options = options;
        if (this.shouldMergeTemplateClasses) {
            this.componentClasses = this.templateClasses;
            this.merge({
                overrideClasses: {
                    [this.component]: this.themeClasses
                }
            });
        } else this.componentClasses = this.templateClasses;
        this.merge(this.config);
        each(options.merge, (merge)=>{
            this.merge(merge);
        });
        this.merge(this.locals || this.component$.value, true);
        if (this.config.classHelpers && this.config.env !== 'production') this.merge({
            prependClasses: {
                [this.component]: this.getClassHelpers(this.componentClasses, [
                    this.component
                ])
            }
        });
    }
    get classes() {
        return new Proxy(this.componentClasses, {
            get: (target, prop)=>{
                if (typeof prop !== 'string') return target[prop];
                return this.getDynamicClasses(target, prop);
            }
        });
    }
    get config() {
        return this.options.config || {};
    }
    get component() {
        return this.options.component;
    }
    get component$() {
        return this.options.component$;
    }
    get locals() {
        return this.options.locals;
    }
    get view() {
        return this.options.view;
    }
    get theme() {
        return this.options.theme;
    }
    get presets() {
        return this.config.presets;
    }
    get templates() {
        return this.options.templates || {};
    }
    get template() {
        return this.view && this.templates["".concat(this.component, "_").concat(this.view)] ? this.templates["".concat(this.component, "_").concat(this.view)] : this.templates[this.component] || {};
    }
    get themeClasses() {
        return cloneDeep_1(this.toArray(this.view && this.theme.classes["".concat(this.component, "_").concat(this.view)] ? this.theme.classes["".concat(this.component, "_").concat(this.view)] : this.theme.classes[this.component]));
    }
    get templateClasses() {
        return cloneDeep_1(this.toArray(this.defaultClasses));
    }
    get shouldMergeTemplateClasses() {
        var merge = typeof this.template.data === 'function' && this.template.data().merge !== undefined ? this.template.data().merge : this.component$.value.merge;
        return merge !== undefined ? merge : false;
    }
    get defaultClasses() {
        return typeof this.template.data === 'function' && this.template.data().defaultClasses ? this.template.data().defaultClasses : this.component$.value.defaultClasses;
    }
    get mainClass() {
        var defaultClasses = typeof this.template.data === 'function' && this.template.data().defaultClasses ? this.template.data().defaultClasses : this.component$.value.defaultClasses;
        return Object.keys(defaultClasses)[0];
    }
    merge(merge) {
        var locals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        each(this.pick(merge, locals ? LOCALS_KEYS : MERGE_KEYS), (mergables, key)=>{
            if (typeof mergables === 'function') mergables = mergables(this.component$.value.form$, 'el$' in this.component$.value && typeof this.component$.value.el$ === 'object' ? this.component$.value.el$ : undefined, this.component$.value);
            switch(key){
                case 'addClasses':
                case 'prependClasses':
                case 'overrideClasses':
                    if (!mergables || mergables[this.component] === undefined) return;
                    this.mergeComponentClasses(this.toArray(mergables[this.component]), key);
                    break;
                case 'removeClasses':
                case 'replaceClasses':
                    if (!mergables || mergables[this.component] === undefined) return;
                    this.mergeComponentClasses(mergables[this.component], key);
                    break;
                case 'addClass':
                case 'removeClass':
                case 'replaceClass':
                case 'overrideClass':
                    if (!mergables) return;
                    if (typeof mergables === 'string' || Array.isArray(mergables)) {
                        if (!Array.isArray(mergables)) mergables = mergables.length > 0 ? mergables.split(' ') : [];
                        this.mergeComponentClasses({
                            [this.mainClass]: mergables
                        }, "".concat(key, "es"));
                    } else if (key === 'replaceClass') this.mergeComponentClasses(mergables, "".concat(key, "es"));
                    else if (isPlainObject_1(mergables)) this.mergeComponentClasses(this.toArray(mergables), "".concat(key, "es"));
                    break;
                case 'presets':
                case 'usePresets':
                    if (!Array.isArray(mergables)) return;
                    each(mergables, (presetName)=>{
                        this.merge(this.presets[presetName]);
                    });
                    break;
            }
        });
    }
    mergeComponentClasses(componentClasses, key) {
        each(componentClasses, (classes, className)=>{
            this[key](classes, [
                className
            ]);
        });
    }
    addClasses(add, levels) {
        var base = get_1(this.componentClasses, levels.join('.'));
        if (add.length == 1 && !add[0]) return;
        if (isPlainObject_1(base)) each(add, (subclasses, subclassName)=>{
            this.addClasses(subclasses, levels.concat(subclassName));
        });
        else set_1(this.componentClasses, levels.join('.'), union_1(base, add));
    }
    prependClasses(prepend, levels) {
        var base = get_1(this.componentClasses, levels.join('.'));
        if (prepend.length == 1 && !prepend[0]) return;
        if (isPlainObject_1(base)) each(prepend, (subclasses, subclassName)=>{
            this.prependClasses(subclasses, levels.concat(subclassName));
        });
        else set_1(this.componentClasses, levels.join('.'), union_1(prepend, base));
    }
    removeClasses(remove, levels) {
        var base = get_1(this.componentClasses, levels.join('.'));
        if (isPlainObject_1(base)) each(remove, (subclasses, subclassName)=>{
            this.removeClasses(subclasses, levels.concat(subclassName));
        });
        else if (Array.isArray(base)) set_1(this.componentClasses, levels.join('.'), base.filter((c)=>{
            return typeof c !== 'string' || remove.indexOf(c) === -1;
        }));
    }
    replaceClasses(replace, levels) {
        var base = get_1(this.componentClasses, levels.join('.'));
        if (Array.isArray(replace)) {
            var tempReplace = {};
            replace.forEach((r)=>{
                tempReplace = _objectSpread2$1(_objectSpread2$1({}, tempReplace), r);
            });
            replace = tempReplace;
        }
        if (isPlainObject_1(base)) each(replace, (subclasses, subclassName)=>{
            this.replaceClasses(subclasses, levels.concat(subclassName));
        });
        else if (Array.isArray(base)) set_1(this.componentClasses, levels.join('.'), base.map((c)=>{
            return typeof c !== 'string' || Object.keys(replace).indexOf(c) === -1 ? c : replace[c];
        }));
    }
    overrideClasses(override, levels) {
        var base = get_1(this.componentClasses, levels.join('.'));
        if (isPlainObject_1(base)) each(override, (subclasses, subclassName)=>{
            this.overrideClasses(subclasses, levels.concat(subclassName));
        });
        else set_1(this.componentClasses, levels.join('.'), override);
    }
    toArray(componentClasses) {
        var arrayClasses = {};
        each(componentClasses, (classes, className)=>{
            arrayClasses[className] = this.classesToArray(classes, [
                className
            ]);
        });
        return arrayClasses;
    }
    classesToArray(classes, path) {
        var _classes$constructor;
        var arrayClasses = classes;
        var base = path ? get_1(this.componentClasses, path.join('.')) : undefined;
        if (typeof classes === 'string') arrayClasses = classes.length > 0 ? classes.split(' ') : [];
        else if (isPlainObject_1(classes)) {
            if (base && Array.isArray(base)) arrayClasses = [
                classes
            ];
            else if (!base || isPlainObject_1(base)) {
                arrayClasses = {};
                each(classes, (subclasses, subclassName)=>{
                    arrayClasses[subclassName] = this.classesToArray(subclasses, path.concat([
                        subclassName
                    ]));
                });
            }
        } else if (typeof classes === 'boolean' || typeof classes === 'object' && [
            'ComputedRefImpl',
            'RefImpl'
        ].indexOf(classes === null || classes === void 0 || (_classes$constructor = classes.constructor) === null || _classes$constructor === void 0 ? void 0 : _classes$constructor.name) !== -1) throw Error("Cannot add conditional class to ".concat(this.component, ": '").concat(path.join('.'), "'"));
        return arrayClasses;
    }
    getDynamicClasses(target, prop, mainTarget) {
        if (!mainTarget) mainTarget = target;
        var classes = Array.isArray(target[prop]) ? flattenDeep_1(target[prop]) : target[prop];
        if (target["$".concat(prop)]) {
            var propVal = target["$".concat(prop)](mainTarget, this.component$.value);
            return typeof propVal === 'function' ? propVal : flattenDeep_1(propVal);
        }
        if (isPlainObject_1(classes)) {
            classes = cloneDeep_1(classes);
            each(classes, (classList, className)=>{
                classes[className] = this.getDynamicClasses(classes, className, target);
            });
        }
        return classes;
    }
    getClassHelpers(componentClasses, path) {
        var classHelpers = {};
        each(componentClasses, (classes, className)=>{
            if (className.match(/[$]/)) return;
            // let name = componentClasses[`$${className}`] !== undefined ? `$${className}` : className
            if (isPlainObject_1(classes)) classHelpers[className] = this.getClassHelpers(componentClasses[className], path.concat([
                className
            ]));
            else classHelpers[className] = [
                "".concat(path.join('.'), ".").concat(className, "-->")
            ];
        });
        return classHelpers;
    }
    pick(from, picks) {
        var picked = {};
        if (!from) return picked;
        each(picks, (pick)=>{
            if (pick in from) picked[pick] = from[pick];
        });
        return picked;
    }
}
var _getFormData = function getFormData(data, formData, namespace) {
    if (formData === undefined) formData = new FormData();
    if (namespace === undefined) namespace = '';
    if (isArray_1(data)) each(data, (value, key)=>{
        _getFormData(value, formData, namespace + '[' + key + ']');
    });
    else if (isPlainObject_1(data)) each(data, (value, key)=>{
        _getFormData(value, formData, namespace ? namespace + '[' + key + ']' : key);
    });
    else formData.append(namespace, data === null ? '' : data);
    return formData;
};
var arrayMap$4 = _arrayMap;
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues$1(object, props) {
    return arrayMap$4(props, function(key) {
        return object[key];
    });
}
var _baseValues = baseValues$1;
var baseValues = _baseValues, keys$1 = keys_1;
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values$1(object) {
    return object == null ? [] : baseValues(object, keys$1(object));
}
var values_1 = values$1;
function asyncForEach(_x, _x2) {
    return _asyncForEach.apply(this, arguments);
}
function _asyncForEach() {
    _asyncForEach = _asyncToGenerator(function*(array, callback) {
        for(var index = 0; index < (isPlainObject_1(array) ? values_1(array) : array).length; index++){
            var key = isPlainObject_1(array) ? keys_1(array)[index] : index;
            yield callback(array[key], key, array);
        }
    });
    return _asyncForEach.apply(this, arguments);
}
var baseAssignValue = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee$6 = _baseIteratee;
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function mapValues(object, iteratee) {
    var result = {};
    iteratee = baseIteratee$6(iteratee);
    baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
    });
    return result;
}
var mapValues_1 = mapValues;
var baseIsEqual = _baseIsEqual;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
var isEqual_1 = isEqual;
var fileToObject = function fileToObject(file) {
    return {
        lastModified: file.lastModified,
        name: file.name,
        size: file.size,
        type: file.type
    };
};
var _dataToComperable = function dataToComperable(data) {
    if (data instanceof File) return fileToObject(data);
    else if (data instanceof Date) return data.toString();
    else if (Array.isArray(data)) return data.map(_dataToComperable);
    else if (typeof data === 'object' && data !== null) return mapValues_1(data, _dataToComperable);
    return data;
};
function dataEquals(a, b) {
    return isEqual_1(_dataToComperable(a), _dataToComperable(b));
}
var findScrollableParent = (element)=>{
    var currentElement = element.parentElement;
    while(currentElement && currentElement !== document.body){
        var overflowY = window.getComputedStyle(currentElement).overflowY;
        var overflowX = window.getComputedStyle(currentElement).overflowX;
        var isScrollableY = (overflowY === 'scroll' || overflowY === 'auto') && currentElement.scrollHeight > currentElement.clientHeight;
        var isScrollableX = (overflowX === 'scroll' || overflowX === 'auto') && currentElement.scrollWidth > currentElement.clientWidth;
        if (isScrollableY || isScrollableX) return currentElement;
        currentElement = currentElement.parentElement;
    }
    return null;
};
var scrollIntoView = (element, scrollableParent)=>{
    if (!scrollableParent) return;
    var elementRect = element.getBoundingClientRect();
    var parentRect = scrollableParent.getBoundingClientRect();
    var offsetTop = elementRect.top - parentRect.top + scrollableParent.scrollTop;
    var offsetLeft = elementRect.left - parentRect.left + scrollableParent.scrollLeft;
    scrollableParent.scrollTo({
        top: offsetTop,
        left: offsetLeft,
        behavior: 'smooth'
    });
};
function isComponentRegistered(vm, component) {
    return vm.appContext !== undefined ? typeof vm.appContext.app.component(component) !== 'string' : !!vm.proxy.$root.$options.components[component];
}
var flatten$3 = (source)=>{
    var collection = [];
    source.forEach((item)=>{
        collection.push(item.path);
        if (item.children) flatten$3(item.children).forEach((child)=>{
            collection.push(child);
        });
    });
    return collection;
};
var _collect = function collect(elements, pages) {
    var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var createMember = (name)=>{
        var element = elements[name];
        var path = prefix.length ? "".concat(prefix, ".").concat(name) : name;
        var member = {
            name: name,
            path: path,
            type: element.type
        };
        if ([
            'group',
            'object'
        ].indexOf(element.type) !== -1 && Object.keys(element.schema || {}).length) member.children = _collect(element.schema, null, path);
        if (element.type === 'list' && Object.keys((element === null || element === void 0 ? void 0 : element.element) || {}).length) member.children = _collect({
            0: element.element
        }, null, path);
        return member;
    };
    var children = [];
    if (pages && Object.keys(pages).length) Object.values(pages).forEach((page)=>{
        page.elements.forEach((name)=>{
            children.push(createMember(name));
        });
    });
    else Object.keys(elements).forEach((name)=>{
        children.push(createMember(name));
    });
    return children;
};
var toString$6 = toString_1, upperFirst = upperFirst_1;
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize$1(string) {
    return upperFirst(toString$6(string).toLowerCase());
}
var capitalize_1 = capitalize$1;
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce$2(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var _arrayReduce = arrayReduce$2;
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf$1(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter, toString$5 = toString_1;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsComboMarksRange$1 = '\\u0300-\\u036f', reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f', rsComboSymbolsRange$1 = '\\u20d0-\\u20ff', rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
/** Used to compose unicode capture groups. */ var rsCombo$1 = '[' + rsComboRange$1 + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo$1, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr$1(string) {
    string = toString$5(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}
var deburr_1 = deburr$1;
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords$1(string) {
    return string.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord$1(string) {
    return reHasUnicodeWord.test(string);
}
var _hasUnicodeWord = hasUnicodeWord$1;
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos$1 = "['\u2019]", rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsSeq;
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
        rsBreak,
        rsUpper,
        '$'
    ].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
        rsBreak,
        rsUpper + rsMiscLower,
        '$'
    ].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords$1(string) {
    return string.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords, hasUnicodeWord = _hasUnicodeWord, toString$4 = toString_1, unicodeWords = _unicodeWords;
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words$1(string, pattern, guard) {
    string = toString$4(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
var words_1 = words$1;
var arrayReduce$1 = _arrayReduce, deburr = deburr_1, words = words_1;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder$1(callback) {
    return function(string) {
        return arrayReduce$1(words(deburr(string).replace(reApos, '')), callback, '');
    };
}
var _createCompounder = createCompounder$1;
var capitalize = capitalize_1, createCompounder = _createCompounder;
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var camelCase = createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
});
var camelCase_1 = camelCase;
var base$1h = function base(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (!options.events) throw new Error('`events` option is required for useEvents');
    // ================ DATA ================
    /**
   * Helper property used to store available events for the element.
   * 
   * @type {array}
   * @default []
   * @private
   */ var events = (0, $8bTPG.ref)(options.events);
    /**
   * Helper property used to store listeners for events.
   * 
   * @type {object}
   * @default {}
   * @private
   */ var listeners = (0, $8bTPG.ref)({});
    // =============== METHODS ==============
    /**
   * Adds a listener for an event.
   *
   * @param {string} event* name of the event to listen for
   * @param {function} callback* callback to run when the event is triggered
   * @returns {void}
   */ var on = (evt, callback)=>{
        if (!listeners.value[evt]) listeners.value[evt] = [];
        listeners.value[evt].push(callback);
    };
    /**
   * Removes all listeners for an event.
   *
   * @param {string} event* name of the event to remove
   * @returns {void}
   */ var off = (evt)=>{
        delete listeners.value[evt];
    };
    /**
   * Fires and emits an event.
   *
   * @param {any} args list of arguments to pass over to the event callback 
   * @returns {void}
   */ var fire = function fire() {
        var evt = arguments[0];
        var args = [].slice.call(arguments).splice(1);
        each(listeners.value[evt], (callback)=>{
            callback(...args);
        });
        if (!listeners.value[evt] || !listeners.value[evt].length) context.emit(...[
            evt
        ].concat(args));
    };
    // =============== HOOKS ================
    // If component has descriptor subscribe upfront
    // for events using `onEvent` format 
    each(events.value, (evt)=>{
        var callback = props['on' + upperFirst_1(camelCase_1(evt))];
        if (callback) on(evt, callback);
    });
    return {
        events: events,
        listeners: listeners,
        on: on,
        off: off,
        fire: fire
    };
};
function useModel(props, context, dependencies) {
    var { value: v, modelValue: mv, sync } = (0, $8bTPG.toRefs)(props);
    var $this = dependencies.$this;
    /**
   * Any `v-model` / `value` / `modelValue` prop provided for the form.
   * 
   * @type {object}
   * @private
   */ var externalValue = $this.$vueform.vueVersion === 3 ? mv : v;
    // ================ DATA =================
    /**
   * The internal store for the form's model. 
   * 
   * @type {object}
   * @default {}
   * @private
   */ var internalData = (0, $8bTPG.ref)({});
    /**
   * The intermediary value.
   * 
   * @type {object}
   * @private
   */ var intermediaryValue = (0, $8bTPG.ref)(externalValue && externalValue.value ? cloneDeep_1(externalValue.value) : null);
    // ============== COMPUTED ===============
    /**
   * Whether form data should be synced when the external value changes (when external value is used).
   * 
   * @type {boolean}
   * @private
   */ var isSync = (0, $8bTPG.computed)(()=>{
        return sync.value && externalValue && externalValue.value !== undefined;
    });
    /**
   * The form's model, which either comes from `externalValue` or `internalData`.
   * 
   * @type {object}
   * @private
   */ var model = (0, $8bTPG.computed)(()=>{
        return cloneDeep_1(externalValue.value || internalData.value);
    });
    // =============== METHODS ==============
    /**
   * Updates an element's data in the form model.
   * 
   * @param {string} dataPath* the `dataPath` property of the element to update
   * @param {any} val* value to update with
   * @returns {void}
   * @private
   */ var updateModel = (dataPath, val)=>{
        // When using v-model as model
        if (externalValue.value) {
            // Non-flat elements
            if (dataPath) {
                var parts = dataPath.split('.');
                var element = parts.pop();
                var parent = parts.join('.') || null;
                var externalValueObject = parent ? get_1(externalValue.value, parent) : externalValue.value;
                // Thinking about cases when it tries to to set an element 
                // which no longer exists in the same tick (eg. when removing
                // a list element with order and tries to refresh its order field)
                if (externalValueObject !== undefined) // We are setting externalValue (v-model) to instantly reflect changes in field value
                $this.$set(externalValueObject, element, val);
                // Setting directly because externalValue might contain changes
                // that intermediary does not have yet, so it would overwrite
                // external model with old value
                intermediaryValue.value = cloneDeep_1(externalValue.value);
            } else each(val, (v, key)=>{
                if (externalValue.value !== undefined) $this.$set(externalValue.value, key, v);
                if (intermediaryValue.value !== undefined) $this.$set(intermediaryValue.value, key, v);
            });
        } else {
            // We need a different clone than this.valueValue clone to not effect children watching model
            var _model = cloneDeep_1(externalValue.value || internalData.value);
            // Non-flat elements
            if (dataPath) set_1(_model, dataPath, val);
            else _model = Object.assign({}, _model, val);
            internalData.value = _model;
        }
    };
    if (externalValue && externalValue.value) (0, $8bTPG.watch)(model, (n, o)=>{
        if (dataEquals(n, o)) return;
        internalData.value = n;
    }, {
        deep: true,
        immediate: false
    });
    return {
        model: model,
        internalData: internalData,
        intermediaryValue: intermediaryValue,
        externalValue: externalValue,
        isSync: isSync,
        updateModel: updateModel
    };
}
var base$1g = function base(props, context) {
    var { schema, tabs, steps, size, view, views, addClass, removeClass, replaceClass, overrideClass, addClasses, removeClasses, replaceClasses, overrideClasses, presets, templates, theme, messages, columns, languages, formKey, endpoint, method, formData, language, locale, validateOn, scrollToInvalid, scrollOnNext, showRequired, forceLabels, floatPlaceholders, multilingual, stepsControls, displayErrors, displayMessages, formatLoad: formatLoad1, formatData, forceNumbers, prepare, default: default_, disabled, loading, providers, useProviders, providerOptions, onChange: _onChange, onReset: _onReset, onClear: _onClear, onSubmit: _onSubmit, onSuccess: _onSuccess, onError: _onError, onLanguage: _onLanguage, onBeforeMount: _onBeforeMount, onMounted: _onMounted, onBeforeUpdate: _onBeforeUpdate, onUpdated: _onUpdated, onBeforeUnmount: _onBeforeUnmount, onUnmounted: _onUnmounted } = (0, $8bTPG.toRefs)(props);
    var evts = [
        'change',
        'reset',
        'clear',
        'submit',
        'success',
        'error',
        'language',
        'response',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ];
    var vm = (0, $ani5R.getCurrentInstance)();
    var $this = vm.proxy;
    // ============ DEPENDENCIES ============
    var { events, listeners, fire, on, off } = base$1h(props, context, {
        form$: $this
    }, {
        events: evts
    });
    var { externalValue, model, internalData, intermediaryValue, isSync, updateModel } = useModel(props, context, {
        $this: $this,
        fire: fire
    });
    // ================ DATA ================
    /**
  * The components of highest level form elements.
  *
  * @type {object}
  * @default {}
  * @private
  */ var elements$ = (0, $8bTPG.ref)({});
    /**
  * The [`FormTabs`](/reference/form-tabs) component.
  *
  * @type {FormTabs}
  */ var tabs$ = (0, $8bTPG.ref)(null);
    /**
  * The [`FormSteps`](/reference/form-steps) component.
  *
  * @type {FormSteps}
  */ var steps$ = (0, $8bTPG.ref)(null);
    /**
   * Enables/disables validation for the form globally.
   *
   * @type {boolean}
   * @default true
   */ var validation = (0, $8bTPG.ref)(true);
    /**
   * Enables/disables conditions for the form globally.
   *
   * @type {boolean}
   * @default true
   */ var conditions = (0, $8bTPG.ref)(true);
    /**
   * Instance of MessageBag service. It can be used to add [custom errors and messages](/docs/validating-elements#custom-errors-and-messages).
   *
   * @type {MessageBag}
   * @default MessageBag
   */ var messageBag = (0, $8bTPG.ref)({});
    /**
   * Whether the async process of submitting the form is currently in progress.
   *
   * @type {boolean}
   * @default false
   */ var submitting = (0, $8bTPG.ref)(false);
    /**
   * Whether the async process of preparing the elements for submit is currently in progress.
   *
   * @type {boolean}
   * @default false
   */ var preparing = (0, $8bTPG.ref)(false);
    /**
   * The axios cancel token when a request is in progress.
   *
   * @type {boolean}
   * @default false
   */ var cancelToken = (0, $8bTPG.ref)(null);
    /**
   * The code of the currently selected language (eg. `en`).
   *
   * @type {string}
   * @default config.language
   */ var selectedLanguage = (0, $8bTPG.ref)(null);
    /**
   * The configuration object of the user when using SFC mode. Basically the value of the component's `data.vueform` object.
   *
   * @type {object}
   * @default {}
   * @private
   */ var userConfig = (0, $8bTPG.ref)({});
    /**
   * Whether the form has been mounted.
   *
   * @type {boolean}
   * @default false
   */ var mounted = (0, $8bTPG.ref)(false);
    /**
   * Whether FormMessages component is registered.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var messagesRegistered = (0, $8bTPG.ref)(isComponentRegistered(vm, 'FormMessages'));
    /**
   * Whether FormErrors component is registered.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var errorsRegistered = (0, $8bTPG.ref)(isComponentRegistered(vm, 'FormErrors'));
    /**
   * Whether FormLanguages component is registered.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var languagesRegistered = (0, $8bTPG.ref)(isComponentRegistered(vm, 'FormLanguages'));
    /**
   * Whether FormTabs component is registered.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var tabsRegistered = (0, $8bTPG.ref)(isComponentRegistered(vm, 'FormTabs'));
    /**
   * Whether FormSteps component is registered.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var stepsRegistered = (0, $8bTPG.ref)(isComponentRegistered(vm, 'FormSteps'));
    // ============== COMPUTED ==============
    /**
   * The form component instance (self).
   *
   * @type {Vueform}
   */ var form$ = (0, $8bTPG.computed)(()=>{
        return $this;
    });
    /**
   * The default configuration object.
   *
   * @type {object}
   * @private
   */ var baseConfig = (0, $8bTPG.computed)(()=>{
        return $this.$vueform;
    });
    /**
   * The default configuration object.
   *
   * @type {object}
   */ var config$ = (0, $8bTPG.computed)(()=>{
        return baseConfig.value;
    });
    /**
   * The active locale of the form.
   *
   * @type {string}
   */ var locale$ = (0, $8bTPG.computed)(()=>{
        return options.value.locale || baseConfig.value.i18n.locale;
    });
    /**
   * Registered services.
   *
   * @type {object}
   */ var services = (0, $8bTPG.computed)(()=>{
        return $this.$vueform.services;
    });
    /**
   * Form options merged from config, component props & the component's `data.vueform` options.
   *
   * @type {object}
   * @private
   */ var options = (0, $8bTPG.computed)(()=>{
        var options = {
            schema: orderedSchema.value,
            tabs: formTabs.value,
            steps: formSteps.value
        };
        // Prop options will override Component.data() options
        var override = {
            columns: columns,
            languages: languages,
            language: language,
            theme: theme,
            method: method,
            validateOn: validateOn,
            showRequired: showRequired,
            messages: messages,
            formKey: formKey,
            multilingual: multilingual,
            formatLoad: formatLoad1,
            formatData: formatData,
            prepare: prepare,
            default: default_,
            formData: formData,
            templates: templates,
            addClass: addClass,
            removeClass: removeClass,
            replaceClass: replaceClass,
            overrideClass: overrideClass,
            addClasses: addClasses,
            removeClasses: removeClasses,
            replaceClasses: replaceClasses,
            overrideClasses: overrideClasses,
            presets: presets,
            size: size,
            view: view,
            views: views,
            locale: locale
        };
        // Only set from prop option if it is not `null` - means the prop is set
        // (otherwise will use the value defined in `defaults` or `undefined` if not)
        var ifPropSet = {
            stepsControls: stepsControls,
            displayErrors: displayErrors,
            displayMessages: displayMessages,
            forceLabels: forceLabels,
            disabled: disabled,
            loading: loading,
            floatPlaceholders: floatPlaceholders,
            endpoint: endpoint,
            forceNumbers: forceNumbers,
            scrollOnNext: scrollOnNext,
            scrollToInvalid: scrollToInvalid,
            onChange: _onChange.value,
            onReset: _onReset.value,
            onClear: _onClear.value,
            onSubmit: _onSubmit.value,
            onSuccess: _onSuccess.value,
            onError: _onError.value,
            onLanguage: _onLanguage.value,
            onBeforeMount: _onBeforeMount.value,
            onMounted: _onMounted.value,
            onBeforeUpdate: _onBeforeUpdate.value,
            onUpdated: _onUpdated.value,
            onBeforeUnmount: _onBeforeUnmount.value,
            onUnmounted: _onUnmounted.value
        };
        var toMerge = {
            useProviders: useProviders,
            providers: providers,
            providerOptions: providerOptions
        };
        var defaults = {
            providers: baseConfig.value.config.providers,
            useProviders: baseConfig.value.config.useProviders,
            providerOptions: baseConfig.value.config.providerOptions,
            languages: baseConfig.value.config.languages,
            language: baseConfig.value.config.language,
            endpoint: typeof baseConfig.value.config.endpoints.submit === 'function' ? baseConfig.value.config.endpoints.submit : baseConfig.value.config.endpoints.submit.url,
            method: typeof baseConfig.value.config.endpoints.submit === 'function' ? null : baseConfig.value.config.endpoints.submit.method,
            validateOn: baseConfig.value.config.validateOn,
            scrollToInvalid: baseConfig.value.config.scrollToInvalid,
            scrollOnNext: baseConfig.value.config.scrollOnNext,
            showRequired: baseConfig.value.config.showRequired,
            displayErrors: baseConfig.value.config.displayErrors,
            displayMessages: baseConfig.value.config.displayMessages,
            forceLabels: baseConfig.value.config.forceLabels,
            floatPlaceholders: baseConfig.value.config.floatPlaceholders,
            formData: baseConfig.value.config.formData,
            theme: baseConfig.value.theme,
            view: baseConfig.value.config.view,
            views: {},
            columns: {},
            size: null,
            addClass: null,
            removeClass: null,
            replaceClass: null,
            overrideClass: null,
            addClasses: {},
            removeClasses: {},
            replaceClasses: {},
            overrideClasses: {},
            presets: [],
            templates: {},
            messages: {},
            default: {},
            formKey: null,
            formatLoad: null,
            formatData: null,
            forceNumbers: null,
            prepare: null,
            multilingual: false,
            stepsControls: true,
            disabled: false,
            loading: false
        };
        each(override, (val, key)=>{
            options[key] = userConfig.value[key] !== undefined ? userConfig.value[key] : (val && val.value ? val.value : undefined) || defaults[key];
        });
        each(ifPropSet, (val, key)=>{
            options[key] = userConfig.value[key] !== undefined ? userConfig.value[key] : val && val.value !== null ? val.value : defaults[key];
        });
        each(toMerge, (val, key)=>{
            options[key] = merge_1({}, defaults[key], userConfig.value[key] || {}, val && val.value ? val.value : {});
        });
        return options;
    });
    /**
  * The global schema which has already been ordered based on tabs/steps element order.
  *
  * @type {object}
  * @private
  */ var orderedSchema = (0, $8bTPG.computed)(()=>{
        var blocks;
        var orderedSchema = formSchema.value;
        if (Object.keys(formSteps.value).length > 0) blocks = formSteps.value;
        if (Object.keys(formTabs.value).length > 0) blocks = formTabs.value;
        if (blocks) {
            orderedSchema = {};
            each(blocks, (block)=>{
                each(block.elements, (name)=>{
                    if (formSchema.value[name]) orderedSchema[name] = formSchema.value[name];
                });
            });
            each(Object.keys(formSchema.value), (name)=>{
                if (orderedSchema[name] === undefined) orderedSchema[name] = formSchema.value[name];
            });
        }
        return orderedSchema;
    });
    /**
   * The form's schema merged from `schema` prop and the component's `data.vueform.schema` object.
   *
   * @type {object}
   * @private
   */ var formSchema = (0, $8bTPG.computed)(()=>{
        return merge_1({}, schema && schema.value ? schema.value : {}, userConfig.value.schema || {});
    });
    /**
   * The form's tabs merged from `tabs` prop and the component's `data.vueform.tabs` object.
   *
   * @type {object}
   * @private
   */ var formTabs = (0, $8bTPG.computed)(()=>{
        return merge_1({}, tabs && tabs.value ? tabs.value : {}, userConfig.value.tabs || {});
    });
    /**
   * The form's steps merged from `steps` prop and the component's `data.vueform.steps` object.
   *
   * @type {object}
   * @private
   */ var formSteps = (0, $8bTPG.computed)(()=>{
        return merge_1({}, steps && steps.value ? steps.value : {}, userConfig.value.steps || {});
    });
    /**
   * The tree representation of the form schema.
   *
   * @type {array}
   */ var tree = (0, $8bTPG.computed)(()=>{
        return _collect(formSchema.value, hasTabs.value ? formTabs.value : formSteps.value);
    });
    /**
   * The flat tree representation of the form schema.
   *
   * @type {array}
   */ var flatTree = (0, $8bTPG.computed)(()=>{
        return flatten$3(tree.value);
    });
    /**
   * The form data including the data of all elements even the ones with `available: false` and `submit: false`.
   *
   * @type {object}
   */ var data = (0, $8bTPG.computed)(()=>{
        var data = {};
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            data = Object.assign({}, data, e$.data);
        });
        return data;
    });
    /**
   * The form data excluding elements with `available: false` and `submit: false`. This one gets submitted by default, but can be changed with [`formData`](#option-form-data)
   *
   * @type {object}
   */ var requestData = (0, $8bTPG.computed)(()=>{
        var requestData = {};
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            requestData = Object.assign({}, requestData, e$.requestData);
        });
        return formatData.value ? formatData.value(requestData) : requestData;
    });
    /**
   * Whether the form has any elements which were modified.
   *
   * @type {boolean}
   */ var dirty = (0, $8bTPG.computed)(()=>{
        return some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.dirty === true;
        });
    });
    /**
   * Whether the form has any invalid elements.
   *
   * @type {boolean}
   */ var invalid = (0, $8bTPG.computed)(()=>{
        return some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.invalid === true;
        });
    });
    /**
   * Whether the form has any elements with active debounce process.
   *
   * @type {boolean}
   */ var debouncing = (0, $8bTPG.computed)(()=>{
        return some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.debouncing === true;
        });
    });
    /**
   * Whether the form has any elements with pending async validation.
   *
   * @type {boolean}
   */ var pending = (0, $8bTPG.computed)(()=>{
        return some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.pending === true;
        });
    });
    /**
   * Whether each element in the form has been validated at least once.
   *
   * @type {boolean}
   */ var validated = (0, $8bTPG.computed)(()=>{
        return !some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.validated === false;
        });
    });
    /**
   * Whether the form has any elements with `busy: true` or the [`isLoading`](#property-is-loading), [`preparing`](#property-preparing) or [`submitting`](#property-submitting) property is `true`.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return some_1(elements$.value, (element$)=>{
            return element$.isStatic === false && element$.available === true && element$.busy === true;
        }) || submitting.value || preparing.value || isLoading.value;
    });
    // no export
    /**
   * Errors collected from elements.
   *
   * @type {array}
   * @private
   */ var elementErrors = (0, $8bTPG.computed)(()=>{
        var errors = [];
        each(filter_1(elements$.value, {
            available: true,
            isStatic: false
        }), (element$)=>{
            each(element$.errors, (error)=>{
                errors.push(error);
            });
        });
        return errors;
    });
    /**
   * Form errors including element errors and the ones added to [`messageBag`](#property-message-bag) manually.
   *
   * @type {array}
   */ var formErrors = (0, $8bTPG.computed)(()=>{
        return messageBag.value.errors;
    });
    /**
   * Whether the form has any errors.
   *
   * @type {boolean}
   */ var hasErrors = (0, $8bTPG.computed)(()=>{
        return formErrors.value.length > 0;
    });
    /**
   * Whether the form should display errors above the form with [`FormErrors`](form-errors) component. Can be disabled by [`displayErrors`](#option-display-errors) or in `config.displayErrors`.
   *
   * @type {boolean}
   */ var showErrors = (0, $8bTPG.computed)(()=>{
        return hasErrors.value && options.value.displayErrors && errorsRegistered.value;
    });
    /**
   * Form messages including element messages and the ones added to [`messageBag`](#property-message-bag) manually.
   *
   * @type {array}
   */ var formMessages = (0, $8bTPG.computed)(()=>{
        return messageBag.value.messages;
    });
    /**
   * Whether the form has any messages.
   *
   * @ignore
   * @type {boolean}
   */ var hasMessages = (0, $8bTPG.computed)(()=>{
        return formMessages.value.length > 0;
    });
    /**
   * Whether the form should display messages above the form with [`FormMessages`](form-messages) component. Can be disabled by [`displayMessages`](#option-display-messages) or in `config.displayMessages`.
   *
   * @type {boolean}
   */ var showMessages = (0, $8bTPG.computed)(()=>{
        return hasMessages.value && options.value.displayMessages && messagesRegistered.value;
    });
    /**
   * Whether the form is multilingual and should show [`FormLanguages`](form-languages) component. Returns `true` if [`multilingual`](#option-multilingual) is enabled.
   *
   * @type {boolean}
   */ var isMultilingual = (0, $8bTPG.computed)(()=>{
        return options.value.multilingual;
    });
    /**
   * Whether the form should show langauge selectors.
   *
   * @type {boolean}
   */ var showLanguages = (0, $8bTPG.computed)(()=>{
        return isMultilingual.value && languagesRegistered.value;
    });
    /**
   * Whether submitting the form is disabled. Returns `true` if:
   * * the form has any invalid elements and [`validateOn`](#option-validate-on) contains `change`
   * * the form is [`busy`](#property-busy)
   * * manually disabled with [`disabled`](#option-disabled) option.
   *
   * @type {boolean}
   */ var isDisabled = (0, $8bTPG.computed)(()=>{
        if (invalid.value && shouldValidateOnChange.value || busy.value) return true;
        if (typeof options.value.disabled === 'boolean') return options.value.disabled;
        if (typeof options.value.disabled === 'object' && options.value.disabled && options.value.disabled.value !== undefined) return options.value.disabled.value;
        if (typeof options.value.disabled === 'function') return options.value.disabled(form$.value);
        if (Array.isArray(options.value.disabled)) return options.value.disabled.every((condition)=>{
            return $this.$vueform.services.condition.check(condition, null, form$.value);
        });
    });
    /**
   * Whether loading state is triggered manually via [`loading`](#option-loading) option.
   *
   * @type {boolean}
   */ var isLoading = (0, $8bTPG.computed)(()=>{
        return options.value.loading;
    });
    /**
   * Whether the `validateOn` prop or `config.validateOn` contains `'change'`.
   *
   * @type {boolean}
   * @private
   */ var shouldValidateOnChange = (0, $8bTPG.computed)(()=>{
        return options.value.validateOn.split('|').indexOf('change') !== -1;
    });
    /**
   * Whether the `validateOn` prop or `config.validateOn` contains `'step'`.
   *
   * @type {boolean}
   * @private
   */ var shouldValidateOnStep = (0, $8bTPG.computed)(()=>{
        return options.value.validateOn.split('|').indexOf('step') !== -1;
    });
    /**
   * Whether the form has any steps.
   *
   * @type {boolean}
   * @private
   */ var hasSteps = (0, $8bTPG.computed)(()=>{
        return !isEmpty_1(options.value.steps);
    });
    /**
   * Whether the form should show [`FormSteps`](form-steps) component. Returns `true` if [`steps`](#option-steps) has value.
   *
   * @type {boolean}
   */ var showSteps = (0, $8bTPG.computed)(()=>{
        return hasSteps.value && stepsRegistered.value;
    });
    /**
   * Whether the form should display steps controls below form with [`FormStepsControls`](form-steps-control) component when it has [`steps`](#option-steps). Can be disabled with [`stepsControls`](#option-steps-controls).
   *
   * @type {boolean}
   */ var showStepsControls = (0, $8bTPG.computed)(()=>{
        return hasSteps.value && options.value.stepsControls && stepsRegistered.value;
    });
    /**
   * Whether the form has any tabs.
   *
   * @ignore
   * @type {boolean}
   */ var hasTabs = (0, $8bTPG.computed)(()=>{
        return !isEmpty_1(options.value.tabs);
    });
    /**
   * Whether the form should show [`FormTabs`](form-tabs) component. Returns `true` if [`tabs`](#option-tabs) has value.
   *
   * @type {boolean}
   */ var showTabs = (0, $8bTPG.computed)(()=>{
        return hasTabs.value && tabsRegistered.value;
    });
    /**
   * The selected theme, extended by local template and class overrides, using [`templates`](#option-replace-templates), [`addClasses`](#option-add-classes) and [`replaceClasses`](#option-replace-classes).
   *
   * @type {object}
   */ var extendedTheme = (0, $8bTPG.computed)(()=>{
        var presetTemplates = {};
        each(baseConfig.value.config.usePresets.concat(options.value.presets), (presetName)=>{
            var preset = baseConfig.value.config.presets[presetName];
            if (!preset || !preset.templates) return;
            presetTemplates = Object.assign({}, presetTemplates, preset.templates);
        });
        return Object.assign({}, options.value.theme, {
            // Add registered component to theme (or overwrite)
            templates: Object.assign({}, options.value.theme.templates, baseConfig.value.templates, presetTemplates, options.value.templates || {})
        });
    });
    /**
   * The default list of templates available to the form components.
   *
   * @type {object}
   * @private
   */ var Templates = (0, $8bTPG.computed)(()=>{
        return extendedTheme.value.templates;
    });
    /**
   * The component's template.
   *
   * @type {object}
   */ var template = (0, $8bTPG.computed)(()=>{
        return View.value && Templates.value["Vueform_".concat(View.value)] ? Templates.value["Vueform_".concat(View.value)] : Templates.value.Vueform;
    });
    /**
   * The component's classes.
   *
   * @type {object}
   */ var classes = (0, $8bTPG.computed)(()=>{
        return new MergeClasses({
            component: 'Vueform',
            component$: form$,
            theme: extendedTheme.value,
            config: baseConfig.value.config,
            templates: Templates.value,
            view: View.value,
            locals: options.value,
            merge: [
                options.value
            ]
        }).classes;
    });
    /**
   * The resolved default size for each element and component within the form.
   *
   * @type {string}
   */ var Size = (0, $8bTPG.computed)(()=>{
        var Size;
        if (options.value.size) Size = options.value.size;
        else each(baseConfig.value.config.usePresets.concat(options.value.presets), (presetName)=>{
            var preset = baseConfig.value.config.presets[presetName];
            if (!preset || !preset.size) return;
            Size = preset.size;
        });
        if (!Size) Size = baseConfig.value.config.size;
        return Size;
    });
    /**
   * The name of the views for the components within the form.
   *
   * @type {object}
   * @private
   */ var Views = (0, $8bTPG.computed)(()=>{
        var Views = baseConfig.value.config.views;
        each(baseConfig.value.config.usePresets.concat(options.value.presets), (presetName)=>{
            var preset = baseConfig.value.config.presets[presetName];
            if (!preset || !preset.views) return;
            Views = Object.assign({}, Views, preset.views);
        });
        Views = Object.assign({}, Views, options.value.views);
        return Views;
    });
    /**
   * The name of the resolved view for Vueform component. This one should be used to determine the component's view in class functions.
   *
   * @type {string}
   */ var View = (0, $8bTPG.computed)(()=>{
        if (options.value.view) return options.value.view;
        return Views.value.Vueform;
    });
    /**
   * The translation tags of the current locale.
   *
   * @type {object}
   */ var translations = (0, $8bTPG.computed)(()=>{
        var i18n = $this.$vueform.i18n;
        var locales = i18n.locales;
        var currentLocale = locale.value || i18n.locale;
        var fallbackLocale = i18n.fallbackLocale || 'en';
        return currentLocale ? merge_1({}, locales[fallbackLocale], locales[currentLocale]) : locales[fallbackLocale];
    });
    // =============== METHODS ==============
    /**
   * Updates the form data. Can be used to update a single element by providing the element's `path` as second option.
   *
   * @param {object} data* data to update with
   * @param {object} path the `path` of the element to update (default: `null`)
   * @returns {void}
   */ var update = function update(data) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (path) {
            el$1(path).update(data);
            return;
        }
        each(elements$.value, (element$)=>{
            if (element$.isStatic) return;
            if (data[element$.name] === undefined && !element$.flat) return;
            element$.update(element$.flat ? data : data[element$.name]);
        });
    };
    /**
   * Loads data to the form using optional [`formatLoad`](#option-format-load) formatter.
   *
   * @param {string} value* the value to be loaded
   * @param {boolean} format whether the loaded value should be formatted with [`formatLoad`](#option-format-load) (default: `false`)
   * @returns {Promise}
   */ var load = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*(data) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (steps$.value !== null) steps$.value.enableAllSteps();
            var formatted = format && options.value.formatLoad !== null ? options.value.formatLoad(data) : data;
            yield asyncForEach(elements$.value, /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(function*(e$) {
                    if (e$.isStatic) return;
                    var loadValue = e$.flat ? formatted : formatted[e$.name];
                    if (loadValue === undefined) {
                        e$.clear();
                        return;
                    }
                    yield e$.load(loadValue, format);
                });
                return function(_x2) {
                    return _ref2.apply(this, arguments);
                };
            }());
        });
        return function load(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Resets the form's data to default state. Also resets all the validation state for the elements.
   *
   * @returns {void}
   */ var reset = ()=>{
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            e$.reset();
        });
        if (steps$.value !== null) steps$.value.reset();
        if (tabs$.value !== null) tabs$.value.reset();
        fire('reset');
    };
    /**
   * Clears the forms data.
   *
   * @returns {void}
   */ var clear = ()=>{
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            e$.clear();
        });
        if (steps$.value !== null) steps$.value.reset();
        if (tabs$.value !== null) tabs$.value.reset();
        fire('clear');
    };
    /**
   * Sets all elements' `dirty` to `false`.
   *
   * @returns {void}
   */ var clean = ()=>{
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            e$.clean();
        });
    };
    /**
   * Clears the manually added messages from the form's and each element's `messageBag`.
   *
   * @returns {void}
   */ var clearMessages = ()=>{
        if (messageBag.value) messageBag.value.clear();
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            e$.clearMessages();
        });
    };
    /**
   * Validates all elements (async) which weren't validated before. If [`validateOn`](#option-validate-on) does not contain `change` it will validate all elements on each call.
   *
   * @public
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref3 = _asyncToGenerator(function*() {
            if (!invalid.value && validated.value && shouldValidateOnChange.value) return;
            var validatableElements = Object.values(elements$.value).filter((e$)=>{
                return e$.available && !e$.isStatic && (!e$.validated || !shouldValidateOnChange.value);
            });
            yield asyncForEach(validatableElements, /*#__PURE__*/ function() {
                var _ref4 = _asyncToGenerator(function*(e$) {
                    yield e$.validate();
                });
                return function(_x3) {
                    return _ref4.apply(this, arguments);
                };
            }());
        });
        return function validate() {
            return _ref3.apply(this, arguments);
        };
    }();
    /**
   * Sets all element validators to default state.
   *
   * @returns {void}
   */ var resetValidators = ()=>{
        each(elements$.value, (e$)=>{
            if (e$.isStatic) return;
            e$.resetValidators();
        });
    };
    var scrollToFirstInvalid = ()=>{
        if (!options.value.scrollToInvalid) return;
        var findFirstInvalid$ = (elements$)=>{
            var firstInvalid$;
            Object.keys(elements$).forEach((key)=>{
                if (firstInvalid$) return;
                var e$ = elements$[key];
                if (e$ && !e$.isStatic && e$.available && e$.invalid) {
                    if (e$.isObjectType || e$.isGroupType || e$.isListType || e$.isGridType) firstInvalid$ = findFirstInvalid$(e$.children$);
                    else firstInvalid$ = e$;
                }
            });
            return firstInvalid$;
        };
        var firstInvalid$ = findFirstInvalid$(elements$.value);
        if (!firstInvalid$) return;
        var scrollableParent = findScrollableParent(firstInvalid$.$el);
        if (scrollableParent) scrollIntoView(firstInvalid$.$el, scrollableParent);
        else if (firstInvalid$.$el.scrollIntoView) firstInvalid$.$el.scrollIntoView({
            behavior: 'smooth'
        });
    };
    /**
   * Validates and prepares elements then submits the form (async).
   *
   * @returns {Promise}
   */ var submit = /*#__PURE__*/ function() {
        var _ref5 = _asyncToGenerator(function*() {
            if (isDisabled.value) return;
            yield validate();
            if (invalid.value) {
                scrollToFirstInvalid();
                return;
            }
            preparing.value = true;
            try {
                yield prepareElements();
                if (typeof options.value.prepare === 'function') yield options.value.prepare(form$.value);
                if (typeof $this.$vueform.config.beforeSend === 'function') yield $this.$vueform.config.beforeSend(form$.value);
            } catch (error) {
                fire('error', error, {
                    type: 'prepare'
                }, form$.value);
                console.error(error);
                return;
            } finally{
                preparing.value = false;
            }
            var data = options.value.formData(form$.value);
            fire('submit', form$.value, data);
            if (!options.value.endpoint) return;
            send();
        });
        return function submit() {
            return _ref5.apply(this, arguments);
        };
    }();
    /**
   * Sends form data to [`endpoint`](#option-endpoint) with the selected [`method`](#option-method) (async).
   *
   * @returns {Promise}
   */ var send = /*#__PURE__*/ function() {
        var _ref6 = _asyncToGenerator(function*() {
            submitting.value = true;
            var response = {};
            try {
                var _response2, _response3;
                resetValidators();
                var _data = options.value.formData(form$.value);
                if (typeof options.value.endpoint === 'function') response = yield options.value.endpoint(_data, form$.value);
                else {
                    var _$this$$vueform$confi, _$this$$vueform$confi2;
                    cancelToken.value = services.value.axios.CancelToken.source();
                    var url = ((_$this$$vueform$confi = $this.$vueform.config.endpoints[options.value.endpoint]) === null || _$this$$vueform$confi === void 0 ? void 0 : _$this$$vueform$confi.url) || options.value.endpoint;
                    var _method = ((_$this$$vueform$confi2 = $this.$vueform.config.endpoints[options.value.endpoint]) === null || _$this$$vueform$confi2 === void 0 ? void 0 : _$this$$vueform$confi2.method) || options.value.method;
                    response = yield services.value.axios.request({
                        url: url,
                        method: _method.toLowerCase(),
                        [_method.toLowerCase() === 'get' ? 'params' : 'data']: _data,
                        cancelToken: cancelToken.value.token
                    });
                }
                if (response && !(response instanceof Promise)) {
                    var _response;
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.data) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && _response.updates) update(response.data.payload.updates);
                }
                if (((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.status) >= 200 && ((_response3 = response) === null || _response3 === void 0 ? void 0 : _response3.status) < 300) fire('success', response, form$.value);
                else fire('error', {
                    response: response
                }, {
                    type: 'submit'
                }, form$.value);
            } catch (error) {
                if (error.response) {
                    fire('error', error, {
                        type: 'submit'
                    }, form$.value);
                    fire('response', error.response, form$.value);
                } else if (services.value.axios.isCancel(error)) fire('error', error, {
                    type: 'cancel'
                }, form$.value);
                else fire('error', error, {
                    type: 'other'
                }, form$.value);
                console.error(error);
                return;
            } finally{
                cancelToken.value = null;
                submitting.value = false;
            }
            fire('response', response, form$.value);
        });
        return function send() {
            return _ref6.apply(this, arguments);
        };
    }();
    /**
   * Cancels the form request in progress.
   *
   * @returns {void}
   */ var cancel = ()=>{
        if (!cancelToken.value) return;
        cancelToken.value.cancel();
    };
    /**
  * Prepares all elements to submit (async).
  *
  * @returns {Promise}
  * @private
  */ var prepareElements = /*#__PURE__*/ function() {
        var _ref7 = _asyncToGenerator(function*() {
            try {
                yield asyncForEach(elements$.value, /*#__PURE__*/ function() {
                    var _ref8 = _asyncToGenerator(function*(e$) {
                        if (e$.prepare) yield e$.prepare();
                    });
                    return function(_x4) {
                        return _ref8.apply(this, arguments);
                    };
                }());
            } catch (e) {
                throw new Error(e);
            }
        });
        return function prepareElements() {
            return _ref7.apply(this, arguments);
        };
    }();
    /**
   * Disabled form validation globally.
   *
   * @returns {void}
   */ var disableValidation = ()=>{
        validation.value = false;
    };
    /**
   * Enables form validation globally.
   *
   * @returns {void}
   */ var enableValidation = ()=>{
        validation.value = true;
    };
    /**
  * Enables conditions globally.
  *
  * @returns {void}
  */ var enableConditions = ()=>{
        conditions.value = true;
    };
    /**
  * Disables conditions globally.
  *
  * @returns {void}
  */ var disableConditions = ()=>{
        conditions.value = false;
    };
    /**
  * Sets current language when using [`multilingual`](#option-multilingual).
  *
  * @param {string} code* the language code to be selected
  * @returns {void}
  */ var setLanguage = (code)=>{
        selectedLanguage.value = code;
        fire('language', code);
    };
    /**
   * Handles `submit` event.
   *
   * @returns {void}
   */ var handleSubmit = ()=>{
        submit();
    };
    /**
  * Converts form data to [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData).
  *
  * @param {object} data* the data to be converted
  * @returns {FormData}
  */ var convertFormData = (data)=>{
        return _getFormData(data);
    };
    /**
   * Returns an element by its path.
   *
   * @param {string} path* path of the element
   * @param {object} elements the object of elements to look into (defaults to elements$)
   * @returns {VueformElement|null}
   */ var el$1 = (path, elements)=>{
        if (elements === undefined) elements = elements$.value;
        if (isEmpty_1(elements) || !path) return null;
        var matches = String(path).match(/^[^.]+\./);
        if (matches) {
            var current = matches[0].replace('.', '');
            if (!elements[current]) return null;
            return el$1(path.replace(matches[0], ''), elements[current].children$);
        } else if (elements[path] !== undefined) return elements[path];
        return null;
    };
    /**
   * Returns the siblings of an element.
   *
   * @param {string} path* path of the element
   * @returns {void}
   */ var siblings$ = (path)=>{
        var _el$;
        if (!/\.+/.test(path)) return elements$.value;
        return ((_el$ = el$1(path.match(/.*(?=\.)/)[0])) === null || _el$ === void 0 ? void 0 : _el$.children$) || {};
    };
    /**
  * Inits MessageBag service.
  *
  * @returns {void}
  * @private
  */ var initMessageBag = ()=>{
        messageBag.value = new services.value.messageBag(elementErrors);
    };
    // ============== PROVIDES ==============
    (0, $ani5R.provide)('form$', form$);
    (0, $ani5R.provide)('theme', extendedTheme);
    (0, $ani5R.provide)('Size', Size);
    (0, $ani5R.provide)('Views', Views);
    (0, $ani5R.provide)('translations', translations);
    (0, $ani5R.provide)('config$', config$);
    // ================ HOOKS ===============
    initMessageBag();
    setLanguage(options.value.language);
    (0, $ani5R.onBeforeMount)(()=>{
        userConfig.value = $this.vueform || {};
        // Manually subscribe to events defined in options object
        each(evts, (evt)=>{
            var callback = options.value['on' + upperFirst_1(evt)];
            if (callback) on(evt, callback);
        });
        fire('beforeMount', $this);
    });
    (0, $ani5R.onMounted)(()=>{
        mounted.value = true;
        // Watching model to track old/new values
        (0, $8bTPG.watch)(data, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, $this);
            if (externalValue && externalValue.value !== undefined) {
                context.emit('input', n);
                context.emit('update:modelValue', n);
            }
        }, {
            deep: true,
            immediate: false
        });
        // If has v-model & not equals to form data
        if (externalValue && externalValue.value !== undefined && JSON.stringify(externalValue.value) !== JSON.stringify(data.value)) {
            context.emit('input', data.value);
            context.emit('update:modelValue', data.value);
        }
        fire('mounted', $this);
    });
    (0, $ani5R.onBeforeUpdate)(()=>fire('beforeUpdate', $this));
    (0, $ani5R.onUpdated)(()=>fire('updated', $this));
    (0, $ani5R.onBeforeUnmount)(()=>fire('beforeUnmount', $this));
    (0, $ani5R.onUnmounted)(()=>fire('unmounted', $this));
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)((0, $8bTPG.computed)(()=>options.value.language), (n, o)=>{
        if (n) setLanguage(n);
    });
    return {
        tabs$: tabs$,
        steps$: steps$,
        elements$: elements$,
        options: options,
        validation: validation,
        conditions: conditions,
        messageBag: messageBag,
        selectedLanguage: selectedLanguage,
        submitting: submitting,
        preparing: preparing,
        cancelToken: cancelToken,
        events: events,
        listeners: listeners,
        internalData: internalData,
        data: data,
        requestData: requestData,
        dirty: dirty,
        invalid: invalid,
        debouncing: debouncing,
        pending: pending,
        validated: validated,
        busy: busy,
        formErrors: formErrors,
        formMessages: formMessages,
        isDisabled: isDisabled,
        isLoading: isLoading,
        shouldValidateOnChange: shouldValidateOnChange,
        shouldValidateOnStep: shouldValidateOnStep,
        hasSteps: hasSteps,
        hasTabs: hasTabs,
        hasErrors: hasErrors,
        hasMessages: hasMessages,
        isMultilingual: isMultilingual,
        showErrors: showErrors,
        showMessages: showMessages,
        showLanguages: showLanguages,
        showSteps: showSteps,
        showTabs: showTabs,
        showStepsControls: showStepsControls,
        classes: classes,
        Templates: Templates,
        template: template,
        extendedTheme: extendedTheme,
        Size: Size,
        View: View,
        Views: Views,
        form$: form$,
        model: model,
        intermediaryValue: intermediaryValue,
        userConfig: userConfig,
        isSync: isSync,
        tree: tree,
        flatTree: flatTree,
        translations: translations,
        locale$: locale$,
        prepareElements: prepareElements,
        updateModel: updateModel,
        update: update,
        load: load,
        reset: reset,
        clear: clear,
        clean: clean,
        clearMessages: clearMessages,
        validate: validate,
        resetValidators: resetValidators,
        convertFormData: convertFormData,
        submit: submit,
        scrollToFirstInvalid: scrollToFirstInvalid,
        send: send,
        cancel: cancel,
        disableValidation: disableValidation,
        enableValidation: enableValidation,
        enableConditions: enableConditions,
        disableConditions: disableConditions,
        setLanguage: setLanguage,
        handleSubmit: handleSubmit,
        el$: el$1,
        siblings$: siblings$,
        initMessageBag: initMessageBag,
        fire: fire,
        on: on,
        off: off,
        messagesRegistered: messagesRegistered,
        errorsRegistered: errorsRegistered,
        languagesRegistered: languagesRegistered,
        tabsRegistered: tabsRegistered,
        stepsRegistered: stepsRegistered
    };
};
var base$1f = function base(props, context, dependencies) {
    var componentName = context.name;
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var component$ = dependencies.component$ || dependencies.el$;
    var theme = dependencies.theme;
    var Templates = dependencies.Templates;
    var View = dependencies.View;
    // ============== COMPUTED ==============
    /**
   * The classes instance (for testing purpose).
   *
   * @type {MergeClasses}
   * @private
   */ var classesInstance = (0, $8bTPG.computed)(()=>{
        return new MergeClasses({
            component: componentName.value,
            component$: component$,
            theme: theme.value,
            config: form$.value.$vueform.config,
            templates: Templates.value,
            view: View.value,
            merge: [
                form$.value.options,
                el$1.value
            ]
        });
    });
    /**
   * The component's classes.
   *
   * @type {object}
   */ var classes = (0, $8bTPG.computed)(()=>{
        var _classesInstance$valu;
        return _objectSpread2$1({}, (_classesInstance$valu = classesInstance.value) === null || _classesInstance$valu === void 0 ? void 0 : _classesInstance$valu.classes);
    });
    return {
        classes: classes,
        classesInstance: classesInstance
    };
};
var VueformComponent = {
    name: 'Vueform',
    emits: [
        'input',
        'update:modelValue',
        'change',
        'reset',
        'clear',
        'submit',
        'success',
        'error',
        'response',
        'language',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    slots: [
        'default',
        'empty'
    ],
    setup: (props, context)=>{
        context.emits = [
            'input',
            'update:modelValue',
            'change',
            'reset',
            'clear',
            'submit',
            'success',
            'error',
            'response',
            'language',
            'beforeCreate',
            'created',
            'beforeMount',
            'mounted',
            'beforeUpdate',
            'updated',
            'beforeUnmount',
            'unmounted'
        ];
        context.name = (0, $8bTPG.ref)('Vueform');
        var { tabs$, steps$, elements$, options, validation, conditions, messageBag, selectedLanguage, submitting, preparing, cancelToken, events, listeners, internalData, data, requestData, dirty, invalid, debouncing, pending, validated, busy, formErrors, formMessages, isDisabled, isLoading, shouldValidateOnChange, shouldValidateOnStep, hasSteps, hasTabs, hasErrors, hasMessages, isMultilingual, showErrors, showMessages, showLanguages, showSteps, showTabs, showStepsControls, classes, Templates, template, extendedTheme, Size, View, Views, form$, model, intermediaryValue, userConfig, isSync, tree, flatTree, translations, locale$, prepareElements, updateModel, update, load, reset, clear, clean, clearMessages, validate, resetValidators, convertFormData, submit, scrollToFirstInvalid, scrollOnNext, send, cancel, disableValidation, enableValidation, enableConditions, disableConditions, setLanguage, handleSubmit, el$: el$1, siblings$, initMessageBag, fire, on, off, messagesRegistered, errorsRegistered, languagesRegistered, tabsRegistered, stepsRegistered } = base$1g(props, context);
        return {
            tabs$: tabs$,
            steps$: steps$,
            elements$: elements$,
            options: options,
            validation: validation,
            conditions: conditions,
            messageBag: messageBag,
            selectedLanguage: selectedLanguage,
            submitting: submitting,
            preparing: preparing,
            cancelToken: cancelToken,
            events: events,
            listeners: listeners,
            internalData: internalData,
            data: data,
            requestData: requestData,
            dirty: dirty,
            invalid: invalid,
            debouncing: debouncing,
            pending: pending,
            validated: validated,
            busy: busy,
            formErrors: formErrors,
            formMessages: formMessages,
            isDisabled: isDisabled,
            isLoading: isLoading,
            shouldValidateOnChange: shouldValidateOnChange,
            shouldValidateOnStep: shouldValidateOnStep,
            hasSteps: hasSteps,
            hasTabs: hasTabs,
            hasErrors: hasErrors,
            hasMessages: hasMessages,
            isMultilingual: isMultilingual,
            showErrors: showErrors,
            showMessages: showMessages,
            showLanguages: showLanguages,
            showSteps: showSteps,
            showTabs: showTabs,
            showStepsControls: showStepsControls,
            classes: classes,
            Templates: Templates,
            template: template,
            extendedTheme: extendedTheme,
            Size: Size,
            View: View,
            Views: Views,
            form$: form$,
            model: model,
            intermediaryValue: intermediaryValue,
            userConfig: userConfig,
            isSync: isSync,
            tree: tree,
            flatTree: flatTree,
            translations: translations,
            locale$: locale$,
            prepareElements: prepareElements,
            updateModel: updateModel,
            update: update,
            load: load,
            reset: reset,
            clear: clear,
            clean: clean,
            clearMessages: clearMessages,
            validate: validate,
            resetValidators: resetValidators,
            convertFormData: convertFormData,
            submit: submit,
            scrollToFirstInvalid: scrollToFirstInvalid,
            scrollOnNext: scrollOnNext,
            send: send,
            cancel: cancel,
            disableValidation: disableValidation,
            enableValidation: enableValidation,
            enableConditions: enableConditions,
            disableConditions: disableConditions,
            setLanguage: setLanguage,
            handleSubmit: handleSubmit,
            el$: el$1,
            siblings$: siblings$,
            initMessageBag: initMessageBag,
            fire: fire,
            on: on,
            off: off,
            messagesRegistered: messagesRegistered,
            errorsRegistered: errorsRegistered,
            languagesRegistered: languagesRegistered,
            tabsRegistered: tabsRegistered,
            stepsRegistered: stepsRegistered
        };
    },
    props: {
        schema: {
            type: Object,
            required: false,
            default: null
        },
        name: {
            type: String,
            required: false,
            default: null,
            private: true
        },
        tabs: {
            type: Object,
            required: false,
            default: null
        },
        steps: {
            type: Object,
            required: false,
            default: null
        },
        stepsControls: {
            type: Boolean,
            required: false,
            default: null,
            '@default': true
        },
        scrollOnNext: {
            type: Boolean,
            required: false,
            default: null
        },
        validateOn: {
            type: String,
            required: false,
            default: null
        },
        scrollToInvalid: {
            type: Boolean,
            required: false,
            default: null
        },
        showRequired: {
            type: Array,
            required: false,
            default: null
        },
        displayErrors: {
            type: Boolean,
            required: false,
            default: null
        },
        displayMessages: {
            type: Boolean,
            required: false,
            default: null
        },
        messages: {
            type: Object,
            required: false,
            default: null
        },
        endpoint: {
            type: [
                String,
                Boolean,
                Function,
                Promise
            ],
            required: false,
            default: null
        },
        method: {
            type: String,
            required: false,
            default: null
        },
        prepare: {
            type: Function,
            required: false,
            default: null
        },
        formKey: {
            type: [
                String,
                Number
            ],
            required: false,
            default: null
        },
        formData: {
            type: Function,
            required: false,
            default: null
        },
        value: {
            type: Object,
            required: false,
            default: undefined
        },
        modelValue: {
            type: Object,
            required: false,
            default: undefined
        },
        sync: {
            type: Boolean,
            required: false,
            default: false
        },
        default: {
            type: Object,
            required: false,
            default: null
        },
        forceNumbers: {
            required: false,
            type: [
                Boolean
            ],
            default: null
        },
        formatData: {
            type: Function,
            required: false,
            default: null
        },
        formatLoad: {
            type: Function,
            required: false,
            default: null
        },
        loading: {
            type: Boolean,
            required: false,
            default: null
        },
        disabled: {
            type: [
                Boolean,
                Function,
                Object,
                Array
            ],
            required: false,
            default: null
        },
        columns: {
            type: Object,
            required: false,
            default: null
        },
        forceLabels: {
            type: Boolean,
            required: false,
            default: null
        },
        floatPlaceholders: {
            type: Boolean,
            required: false,
            default: null
        },
        size: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        views: {
            required: false,
            type: [
                Object
            ],
            default: null
        },
        addClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        addClass: {
            required: false,
            type: [
                Array,
                Object,
                String,
                Function
            ],
            default: null
        },
        removeClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        removeClass: {
            required: false,
            type: [
                Array,
                Object,
                Function
            ],
            default: null
        },
        replaceClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        replaceClass: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        overrideClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        overrideClass: {
            required: false,
            type: [
                Array,
                Object,
                String,
                Function
            ],
            default: null
        },
        templates: {
            type: Object,
            required: false,
            default: null
        },
        presets: {
            required: false,
            type: [
                Array
            ],
            default: null
        },
        multilingual: {
            type: Boolean,
            required: false,
            default: null
        },
        languages: {
            type: Object,
            required: false,
            default: null
        },
        language: {
            type: String,
            required: false,
            default: null
        },
        locale: {
            type: String,
            required: false,
            default: null
        },
        providers: {
            type: [
                Object
            ],
            required: false,
            default: null
        },
        useProviders: {
            type: [
                Object
            ],
            required: false,
            default: null
        },
        providerOptions: {
            type: [
                Object
            ],
            required: false,
            default: null
        },
        onChange: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onReset: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClear: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSubmit: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onResponse: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSuccess: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onError: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onLanguage: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeMount: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onMounted: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeUpdate: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onUpdated: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeUnmount: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onUnmounted: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    render () {
        return this.template.render.apply(this, arguments);
    }
};
var baseEach$1 = _baseEach, isArrayLike$2 = isArrayLike_1;
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap$2(collection, iteratee) {
    var index = -1, result = isArrayLike$2(collection) ? Array(collection.length) : [];
    baseEach$1(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var _baseMap = baseMap$2;
var arrayMap$3 = _arrayMap, baseIteratee$5 = _baseIteratee, baseMap$1 = _baseMap, isArray$4 = isArray_1;
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray$4(collection) ? arrayMap$3 : baseMap$1;
    return func(collection, baseIteratee$5(iteratee));
}
var map_1 = map;
var baseGetTag = _baseGetTag, isArray$3 = isArray_1, isObjectLike = isObjectLike_1;
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString$1(value) {
    return typeof value == 'string' || !isArray$3(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
var isString_1 = isString$1;
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex$1(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim$2(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
var _baseTrim = baseTrim$2;
var baseIndexOf$2 = _baseIndexOf;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function charsEndIndex$1(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && baseIndexOf$2(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
var _charsEndIndex = charsEndIndex$1;
var baseIndexOf$1 = _baseIndexOf;
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function charsStartIndex$1(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && baseIndexOf$1(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
var _charsStartIndex = charsStartIndex$1;
var baseToString$2 = _baseToString, baseTrim$1 = _baseTrim, castSlice = _castSlice, charsEndIndex = _charsEndIndex, charsStartIndex = _charsStartIndex, stringToArray = _stringToArray, toString$3 = toString_1;
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function trim(string, chars, guard) {
    string = toString$3(string);
    if (string && (guard || chars === undefined)) return baseTrim$1(string);
    if (!string || !(chars = baseToString$2(chars))) return string;
    var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
    return castSlice(strSymbols, start, end).join('');
}
var trim_1 = trim;
var Validator = class {
    constructor(rule, props){
        var _props$element$;
        this.rule = rule;
        this.attributes = rule.attributes || {};
        this.conditions = rule.conditions || [];
        this.dependents = rule.dependents || [];
        this.element$ = props.element$;
        this.form$ = ((_props$element$ = props.element$) === null || _props$element$ === void 0 ? void 0 : _props$element$.form$) || {};
        this.numeric = props.numeric || false;
        this.elementMessages = props.element$.messages;
        this.invalid = false;
        this.pending = false;
        this.debouncer = null;
        this.lastValue = null;
        this.watchers = {};
        this.dependents.forEach((dependent)=>{
            (0, $8bTPG.watch)((0, $8bTPG.computed)(()=>{
                var _this$form$$el$;
                return (_this$form$$el$ = this.form$.el$(dependent)) === null || _this$form$$el$ === void 0 ? void 0 : _this$form$$el$.value;
            }), ()=>{
                if (this.element$.validated) {
                    // we need to revalidate the whole element
                    if (this.name === 'nullable') this.element$.validate();
                    else // We need to do this instead of this.validate()
                    // because Vue3 does not recognize `invalid` as
                    // as a reactive property if used that way.
                    this.revalidate();
                }
            });
        });
        (0, $8bTPG.watch)((0, $8bTPG.computed)(()=>props.element$.messages), (n, o)=>{
            if (isEqual_1(n, o)) return;
            this.elementMessages = props.element$.messages;
        }, {
            deep: true
        });
        this.init();
    }
    get moment() {
        return this.form$.$vueform.services.moment;
    }
    get name() {
        return this.rule.name;
    }
    get failing() {
        return this.invalid;
    }
    get defaultMessage() {
        return this.form$.translations.vueform.defaultMessage;
    }
    get message() {
        var _this$form$$translati;
        var message = '';
        if (this.msg) message = this.msg;
        else if (this.elementMessages[this.name]) message = this.elementMessages[this.name];
        else if (this.form$.options.messages[this.name]) message = this.form$.options.messages[this.name];
        else if (this.name !== '_class' && ((_this$form$$translati = this.form$.translations.validation) === null || _this$form$$translati === void 0 ? void 0 : _this$form$$translati[this.name]) !== undefined) {
            message = this.form$.translations.validation[this.name];
            if (isPlainObject_1(message)) message = message[this.messageType];
        } else message = this.defaultMessage;
        // replace :params
        each(map_1(message.match(/:\w+/g), (p)=>p.replace(':', '')), (param)=>{
            message = message.replace(":".concat(param), this.messageParams[param]);
        });
        // replace {params}
        each(map_1(message.match(/{[^}]+/g), (p)=>p.replace('{', '')), (param)=>{
            message = message.replace("{".concat(param, "}"), this.messageParams[param]);
        });
        return message;
    }
    get messageType() {
        if (this.isNumeric) return 'numeric';
        else if (this.isFile) return 'file';
        else if (this.isArray) return 'array';
        return 'string';
    }
    get messageParams() {
        return {
            attribute: this.attributeName
        };
    }
    get attributeName() {
        return this.element$.genericName;
    }
    get type() {
        if (this.isNumeric) return 'numeric';
        else if (this.isFile) return 'file';
        else if (this.isArray) return 'array';
        return 'string';
    }
    get isNumeric() {
        return some_1(this.element$.Validators, {
            name: 'numeric'
        }) || some_1(this.element$.Validators, {
            name: 'integer'
        });
    }
    get isNullable() {
        var nullable = false;
        each(this.element$.Validators, (Validator)=>{
            if (Validator.name !== 'nullable') return;
            if (!Validator.conditions.length) {
                nullable = true;
                return;
            }
            nullable = Validator.conditions(this.form$, this, this.element$);
        });
        return nullable;
    }
    get isFile() {
        return this.element$.isFileType;
    }
    get isArray() {
        return this.element$.isArrayType;
    }
    get isAsync() {
        return false;
    }
    get debounce() {
        if (this.attributes.debounce) return this.attributes.debounce;
        if (this.element$.debounce) return this.element$.debounce;
        return false;
    }
    get debouncing() {
        return this.debouncer !== null;
    }
    init() {}
    validate(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            if (value === undefined) {
                var _this$element$;
                value = (_this$element$ = _this.element$) === null || _this$element$ === void 0 ? void 0 : _this$element$.value;
            }
            if (!_this.form$.validation) return;
            if (_this.isNullable && !_this.filled(value)) {
                _this.invalid = false;
                return;
            }
            if (_this.conditions.length) {
                if (!_this.conditions(_this.form$, _this, _this.element$)) {
                    _this.invalid = false;
                    return;
                }
            }
            if (_this.debounce && _this.filled(value)) yield _this._validateWithDebounce(value);
            else {
                if (_this.debounce && _this.debouncer) clearTimeout(_this.debouncer);
                yield _this._validate(value);
            }
        })();
    }
    replaceParams(message) {
        // replace :params
        each(map_1(message.match(/:\w+/g), (p)=>p.replace(':', '')), (param)=>{
            message = message.replace(":".concat(param), this.messageParams[param]);
        });
        // replace {params}
        each(map_1(message.match(/{[^}]+/g), (p)=>p.replace('{', '')), (param)=>{
            message = message.replace("{".concat(param, "}"), this.messageParams[param]);
        });
        return message;
    }
    reset() {
        this.invalid = false;
    }
    watch(variables) {
        if (!Array.isArray(variables)) variables = [
            variables
        ];
        variables.forEach((variable)=>{
            this.addWatcher(variable);
        });
    }
    addWatcher(variable) {
        if (this.watchers[variable]) return;
        this.watchers[variable] = (0, $8bTPG.watch)((0, $8bTPG.computed)(()=>get_1(this.form$.data, variable)), ()=>{
            this.revalidate();
        });
    }
    revalidate() {
        this.element$.Validators.forEach((Validator)=>{
            if (Validator.rule.name === this.rule.name) Validator.validate();
        });
    }
    watchOther() {
        this.form$.$nextTick(()=>{
            if (!this.other$) return;
            this.form$.$watch(()=>{
                var _this$other$;
                return (_this$other$ = this.other$) === null || _this$other$ === void 0 ? void 0 : _this$other$.value;
            }, ()=>{
                if (this.element$.validated) this.element$.validate();
            });
        });
    }
    size(value) {
        if (this.isNumeric) {
            if (!isNaN(value)) {
                var num = parseFloat(value);
                if (Number.isInteger(num)) return parseInt(value);
                return num;
            }
            return null;
        } else if (this.isFile) return value ? value.size / 1000 : 0;
        else if (this.isArray) return value.length;
        else if (value === null) return 0;
        else if (value === undefined) return 0;
        else if (value === '') return 0;
        return String(value).length;
    }
    filled(value) {
        if (this.element$.useCustomFilled) return this.element$.isFilled;
        else if (value === undefined || value === null && value !== this.element$.trueValue || value === this.element$.falseValue) return false;
        else if (this.isNumeric && trim_1(value) === '') return false;
        else if (isString_1(value) && trim_1(value) === '') return false;
        else if (isArray_1(value) && value.length < 1) return false;
        else if (value instanceof File && value.name === '') return false;
        return true;
    }
    _validate(value) {
        var _this2 = this;
        return _asyncToGenerator(function*() {
            if (_this2.isAsync) yield _this2._validateAsync(value);
            else _this2._validateSync(value);
        })();
    }
    _validateAsync(value) {
        var _this3 = this;
        return _asyncToGenerator(function*() {
            _this3.lastValue = value;
            _this3.pending = true;
            var valid = yield _this3.check(value);
            if (dataEquals(_this3.lastValue, value)) {
                _this3.invalid = !valid;
                _this3.pending = false;
            }
        })();
    }
    _validateSync(value) {
        this.invalid = !this.check(value);
    }
    _validateWithDebounce(value) {
        var _this4 = this;
        return _asyncToGenerator(function*() {
            return new Promise((resolve, reject)=>{
                if (_this4.debouncer) {
                    resolve();
                    clearTimeout(_this4.debouncer);
                }
                _this4.debouncer = setTimeout(/*#__PURE__*/ _asyncToGenerator(function*() {
                    yield _this4._validate(value);
                    _this4.debouncer = null;
                    resolve();
                }), _this4.debounce);
            });
        })();
    }
};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last$1(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var last_1 = last$1;
var baseGet$2 = _baseGet, baseSlice = _baseSlice;
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent$1(object, path) {
    return path.length < 2 ? object : baseGet$2(object, baseSlice(path, 0, -1));
}
var _parent = parent$1;
var castPath$2 = _castPath, last = last_1, parent = _parent, toKey = _toKey;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset$1(object, path) {
    path = castPath$2(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
var _baseUnset = baseUnset$1;
var isPlainObject = isPlainObject_1;
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone$1(value) {
    return isPlainObject(value) ? undefined : value;
}
var _customOmitClone = customOmitClone$1;
var baseFlatten$3 = _baseFlatten;
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten$2(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten$3(array, 1) : [];
}
var flatten_1 = flatten$2;
var flatten$1 = flatten_1, overRest = _overRest, setToString = _setToString;
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest$2(func) {
    return setToString(overRest(func, undefined, flatten$1), func + '');
}
var _flatRest = flatRest$2;
var arrayMap$2 = _arrayMap, baseClone$1 = _baseClone, baseUnset = _baseUnset, castPath$1 = _castPath, copyObject = _copyObject, customOmitClone = _customOmitClone, flatRest$1 = _flatRest, getAllKeysIn = _getAllKeysIn;
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest$1(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap$2(paths, function(path) {
        path = castPath$1(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone$1(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG$1, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
var omit_1 = omit;
var baseGet$1 = _baseGet, baseSet = _baseSet, castPath = _castPath;
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy$1(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet$1(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
var _basePickBy = basePickBy$1;
var basePickBy = _basePickBy, hasIn = hasIn_1;
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick$1(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
var _basePick = basePick$1;
var basePick = _basePick, flatRest = _flatRest;
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
var pick_1 = pick;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, arrayMap$1 = _arrayMap, baseUnary$1 = _baseUnary, cacheHas = _cacheHas;
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference$2(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap$1(values, baseUnary$1(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
var _baseDifference = baseDifference$2;
var baseDifference$1 = _baseDifference, baseRest$2 = _baseRest, isArrayLikeObject$1 = isArrayLikeObject_1;
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest$2(function(array, values) {
    return isArrayLikeObject$1(array) ? baseDifference$1(array, values) : [];
});
var without_1 = without;
function isBuffer(obj) {
    return obj && obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
function keyIdentity(key) {
    return key;
}
function flatten(target, opts) {
    opts = opts || {};
    var delimiter = opts.delimiter || '.';
    var maxDepth = opts.maxDepth;
    var transformKey = opts.transformKey || keyIdentity;
    var output = {};
    function step(object, prev, currentDepth) {
        currentDepth = currentDepth || 1;
        Object.keys(object).forEach(function(key) {
            var value = object[key];
            var isarray = opts.safe && Array.isArray(value);
            var type = Object.prototype.toString.call(value);
            var isbuffer = isBuffer(value);
            var isobject = type === '[object Object]' || type === '[object Array]';
            var newKey = prev ? prev + delimiter + transformKey(key) : transformKey(key);
            if (!isarray && !isbuffer && isobject && Object.keys(value).length && (!opts.maxDepth || currentDepth < maxDepth)) return step(value, newKey, currentDepth + 1);
            output[newKey] = value;
        });
    }
    step(target);
    return output;
}
var baseDifference = _baseDifference, baseFlatten$2 = _baseFlatten, baseRest$1 = _baseRest, isArrayLikeObject = isArrayLikeObject_1;
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var difference = baseRest$1(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten$2(values, 1, isArrayLikeObject, true)) : [];
});
var difference_1 = difference;
function shouldApplyPlugin(name, plugin) {
    if (!plugin.apply && difference_1(Object.keys(plugin), [
        'config',
        'install'
    ]).length > 0) return true;
    var apply = plugin.apply;
    if (!Array.isArray(apply)) apply = [
        apply
    ];
    var shouldApply = false;
    each(apply, (condition)=>{
        if (typeof condition === 'string' && condition === name) {
            shouldApply = true;
            return false;
        } else if (typeof condition === 'object' && condition instanceof RegExp && name.match(condition)) {
            shouldApply = true;
            return false;
        }
    });
    return shouldApply;
}
var name = "@vueform/vueform";
var version$1 = "1.12.4";
var description = "Open-Source Form Framework for Vue";
var homepage = "https://vueform.com";
var license = "MIT";
var authors = [
    {
        name: "Adam Berecz",
        email: "adam@vueform.com"
    }
];
var sideEffects = [
    "./themes/tailwind/templates/**/*.css",
    "./themes/vueform/templates/**/*.css"
];
var main = "./dist/index.mjs";
var module = "./dist/index.mjs";
var types = "./types/index.d.ts";
var exports = {
    ".": {
        types: "./types/index.d.ts",
        "default": "./dist/index.mjs"
    },
    "./core": {
        types: "./types/index.d.ts",
        "default": "./dist/core.mjs"
    },
    "./core.js": {
        types: "./types/index.d.ts",
        "default": "./dist/core.mjs"
    },
    "./element": "./element.mjs",
    "./element.js": "./element.mjs",
    "./plugin": "./plugin.mjs",
    "./plugin.js": "./plugin.mjs",
    "./locales/*.js": "./locales/*/index.mjs",
    "./locales/*": "./locales/*/index.mjs",
    "./src/*": "./src/*",
    "./src/components": "./src/components/index.js",
    "./src/services/validation/rules": "./src/services/validation/rules/index.js",
    "./types/*": "./types/*",
    "./dist/*.js": "./dist/*.mjs",
    "./dist/*": "./dist/*.mjs",
    "./dist/*.css": "./dist/*.css",
    "./tailwind": "./tailwind.js",
    "./tailwind.js": "./tailwind.js",
    "./vite": "./vite.js",
    "./vite.js": "./vite.js",
    "./vite.d.ts": "./vite.d.ts",
    "./tailwind-prefixer": "./tailwind-prefixer.js",
    "./tailwind-prefixer.js": "./tailwind-prefixer.js",
    "./postcss.config": "./postcss.config.js",
    "./postcss.config.js": "./postcss.config.js",
    "./tailwind.config": "./tailwind.config.js",
    "./tailwind.config.js": "./tailwind.config.js",
    "./package.json": "./package.json",
    "./themes/blank/templates/*": "./themes/blank/templates/*",
    "./themes/blank/*": "./themes/blank/*.mjs",
    "./themes/blank/*.js": "./themes/blank/*.mjs",
    "./themes/bootstrap/css/*": "./themes/bootstrap/css/*",
    "./themes/bootstrap/scss/*": "./themes/bootstrap/scss/*",
    "./themes/bootstrap/*": "./themes/bootstrap/*.mjs",
    "./themes/bootstrap/*.js": "./themes/bootstrap/*.mjs",
    "./themes/bootstrap.js": "./themes/bootstrap/index.mjs",
    "./themes/material/css/*": "./themes/material/css/*",
    "./themes/material/scss/*": "./themes/material/scss/*",
    "./themes/material/*": "./themes/material/*.mjs",
    "./themes/material/*.js": "./themes/material/*.mjs",
    "./themes/material.js": "./themes/material/index.mjs",
    "./themes/tailwind/templates/*": "./themes/tailwind/templates/*",
    "./themes/tailwind/*": "./themes/tailwind/*.mjs",
    "./themes/tailwind/*.js": "./themes/tailwind/*.mjs",
    "./themes/tailwind.js": "./themes/tailwind/index.mjs",
    "./themes/tailwind-material/css/*": "./themes/tailwind-material/css/*",
    "./themes/tailwind-material/scss/*": "./themes/tailwind-material/scss/*",
    "./themes/tailwind-material/*": "./themes/tailwind-material/*.mjs",
    "./themes/tailwind-material/*.js": "./themes/tailwind-material/*.mjs",
    "./themes/tailwind-material.js": "./themes/tailwind-material/index.mjs",
    "./themes/vueform/css/*": "./themes/vueform/css/*",
    "./themes/vueform/scss/*": "./themes/vueform/scss/*",
    "./themes/vueform/templates/*": "./themes/vueform/templates/*",
    "./themes/vueform/*": "./themes/vueform/*.mjs",
    "./themes/vueform/*.js": "./themes/vueform/*.mjs",
    "./themes/vueform.js": "./themes/vueform/index.mjs",
    "./themes/*": {
        types: "./dist/*.d.mts",
        "default": "./themes/*/index.mjs"
    }
};
var scripts = {
    build: "npm run build3 && npm run build2 && npm run generate",
    build2: "node ./scripts/pre-build-vue2 && rollup --config build/rollup.vue2.config.js && node ./scripts/post-build-vue2",
    build3: "rollup --config build/rollup.config.js",
    test: "npm run generate:elements-base && NODE_OPTIONS=\"--max_old_space_size=5120 --no-experimental-fetch\" VUE=3 jest --config=./tests/jest.config.js",
    "generate:types": "npx babel-node  scripts/generate-types.js --presets @babel/preset-env",
    "generate:common-features": "npx babel-node scripts/generate-common-features.js --presets @babel/preset-env",
    "generate:element-features": "npx babel-node scripts/generate-element-features.js --presets @babel/preset-env",
    "generate:elements-base": "npx babel-node scripts/generate-elements-base.js --presets @babel/preset-env",
    "generate:elements": "npx babel-node scripts/generate-elements.js --presets @babel/preset-env",
    "generate:components": "npx babel-node scripts/generate-components.js --presets @babel/preset-env",
    generate: "npm run generate:common-features; npm run generate:element-features; npm run generate:elements-base; npm run generate:elements; npm run generate:components; npm run generate:types; npm run fix-locales",
    "fix-locales": "npx babel-node --presets @babel/preset-env ./scripts/fix-locales.js"
};
var devDependencies = {
    "@babel/core": "^7.2.2",
    "@babel/node": "^7.12.10",
    "@babel/preset-env": "^7.3.1",
    "@rollup/plugin-alias": "^5.1.0",
    "@rollup/plugin-babel": "^5.3.0",
    "@rollup/plugin-commonjs": "^22.0.1",
    "@rollup/plugin-json": "^4.1.0",
    "@rollup/plugin-node-resolve": "^13.0.6",
    "@testing-library/jest-dom": "^5.11.5",
    "@vue/compiler-sfc": "^3.0.0",
    "@vue/test-utils": "2.0.0-rc.16",
    autoprefixer: "^9",
    autosize: "^6.0.1",
    "babel-core": "^7.0.0-bridge.0",
    "babel-loader": "^8.0.5",
    "core-js": "^3.10.1",
    "css-loader": "^2.1.0",
    flatpickr: "^4.6.13",
    "flush-promises": "^1.0.2",
    "html-loader": "^1.3.2",
    jest: "^27.3.1",
    "jest-canvas-mock": "^2.3.1",
    "jest-environment-jsdom-sixteen": "^1.0.3",
    "jest-transform-stub": "^2.0.0",
    "json-loader": "^0.5.7",
    locutus: "^2.0.16",
    "module-alias": "^2.2.3",
    moxios: "^0.4.0",
    "mutationobserver-shim": "^0.3.7",
    ncp: "^2.0.0",
    "rollup-plugin-license": "^3.2.0",
    "rollup-plugin-postcss": "^4.0.1",
    "rollup-plugin-terser": "^7.0.2",
    "rollup-plugin-vue": "^6.0.0",
    "rollup-plugin-vue2": "npm:rollup-plugin-vue@^5.1.9",
    "sass-loader": "^7.1.0",
    signature_pad: "^5.0.2",
    sortablejs: "^1.15.0",
    tailwindcss: "npm:@tailwindcss/postcss7-compat@^2.0.2",
    vue: "3.3.13",
    "vue-jest": "npm:@vue/vue3-jest@^27.0.0-alpha.1",
    "vue-loader": "^15.10.0",
    "vue-template-compiler": "^2.7.8",
    vue2: "npm:vue@^2.7.0"
};
var dependencies = {
    "@popperjs/core": "^2.11.8",
    "@vueform/country-phones": "^1.0.3",
    "@vueform/multiselect": "^2.6.11",
    "@vueform/slider": "^2.1.10",
    "@vueform/toggle": "^2.1.4",
    axios: "^1.7.2",
    color: "^4.2.3",
    lodash: "^4.17.21",
    "mini-svg-data-uri": "^1.4.4",
    moment: "^2.30.1",
    nouislider: "^15.8.0",
    sass: "^1.66.1",
    trix: "^2.1.1",
    wnumb: "^1.2.0"
};
var packageJson = {
    "private": false,
    name: name,
    version: version$1,
    description: description,
    homepage: homepage,
    license: license,
    authors: authors,
    sideEffects: sideEffects,
    main: main,
    module: module,
    types: types,
    exports: exports,
    scripts: scripts,
    devDependencies: devDependencies,
    dependencies: dependencies
};
var normalize = function normalize(value) {
    if (value === undefined || typeof value != 'string') return value;
    // is number
    if (value.match(/^-*\d+$/)) return parseInt(value, 10);
    else if (value.match(/^\d+\.\d+$/)) return parseFloat(value);
    else return value;
};
var parse = (string)=>{
    var parseRule = ()=>{
        return string.split(':')[0];
    };
    var parseAttributes = ()=>{
        var parts = string.split(':');
        if (parts.length <= 1) return null;
        var attributes = {};
        var rule = parts[0];
        parts.shift();
        var params = parts.join(':');
        if ([
            'regex',
            'not_regex'
        ].indexOf(rule) !== -1) {
            attributes[0] = params;
            return attributes;
        }
        each(params.split(','), (attribute, index)=>{
            var attrParts = attribute.split('=');
            if (attrParts.length <= 1) attributes[index] = normalize(attribute);
            else attributes[attrParts[0]] = normalize(attrParts[1]);
        });
        return attributes;
    };
    return {
        name: parseRule(),
        attributes: parseAttributes()
    };
};
function replaceWildcards(fillable, fill) {
    if (!fill.match(/\.([0-9]+)(?![a-zA-Z]+)/g)) return fillable;
    fill.match(/\.([0-9]+)(?![a-zA-Z]+)/g).forEach((match)=>{
        fillable = fillable.replace('.*', match);
    });
    return fillable;
}
var baseTrim = _baseTrim, isObject = isObject_1, isSymbol$1 = isSymbol_1;
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber$1(value) {
    if (typeof value == 'number') return value;
    if (isSymbol$1(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var toNumber = toNumber_1;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite$1(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var toFinite_1 = toFinite$1;
var toFinite = toFinite_1;
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger$5(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$5;
var baseIndexOf = _baseIndexOf, isArrayLike$1 = isArrayLike_1, isString = isString_1, toInteger$4 = toInteger_1, values = values_1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax$2 = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function includes(collection, value, fromIndex, guard) {
    collection = isArrayLike$1(collection) ? collection : values(collection);
    fromIndex = fromIndex && !guard ? toInteger$4(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = nativeMax$2(length + fromIndex, 0);
    return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
}
var includes_1 = includes;
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function baseClamp$2(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
var _baseClamp = baseClamp$2;
var baseClamp$1 = _baseClamp, baseToString$1 = _baseToString, toInteger$3 = toInteger_1, toString$2 = toString_1;
/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */ function startsWith(string, target, position) {
    string = toString$2(string);
    position = position == null ? 0 : baseClamp$1(toInteger$3(position), 0, string.length);
    target = baseToString$1(target);
    return string.slice(position, position + target.length) == target;
}
var startsWith_1 = startsWith;
var baseClamp = _baseClamp, baseToString = _baseToString, toInteger$2 = toInteger_1, toString$1 = toString_1;
/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function endsWith(string, target, position) {
    string = toString$1(string);
    target = baseToString(target);
    var length = string.length;
    position = position === undefined ? length : baseClamp(toInteger$2(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
var endsWith_1 = endsWith;
function compare(actual, operator, expected, el$1, form$) {
    if (!operator) return false;
    var strict = form$.$vueform.config.strictConditions;
    actual = Array.isArray(actual) ? actual.map((e)=>normalize(e)) : normalize(actual);
    expected = Array.isArray(expected) ? expected.map((e)=>normalize(e)) : normalize(expected);
    var moment = form$.$vueform.services.moment;
    switch(operator.toLowerCase()){
        case '>':
            return isArray_1(actual) ? actual.every((a)=>a > expected) : actual > expected;
        case '>=':
            return isArray_1(actual) ? strict ? actual.every((a)=>a >= expected && a !== null && a !== undefined && a !== '') : actual.every((a)=>a >= expected) : strict ? actual >= expected && actual !== null && actual !== undefined && actual !== '' : actual >= expected;
        case '<':
            return isArray_1(actual) ? strict ? actual.every((a)=>a < expected && a !== null && a !== undefined && a !== '') : actual.every((a)=>a < expected) : strict ? actual < expected && actual !== null && actual !== undefined && actual !== '' : actual < expected;
        case '<=':
            return isArray_1(actual) ? strict ? actual.every((a)=>a <= expected && a !== null && a !== undefined && a !== '') : actual.every((a)=>a <= expected) : strict ? actual <= expected && actual !== null && actual !== undefined && actual !== '' : actual <= expected;
        case 'between':
            return actual > expected[0] && actual < expected[1];
        case 'empty':
            if (isArray_1(actual)) return !actual.length;
            else if (actual && actual instanceof File) return false;
            else if (actual && actual instanceof Blob) return false;
            else if (actual && typeof actual === 'object') {
                var values = Object.values(actual);
                return !values.length || values.every((v)=>{
                    if (Array.isArray(v)) return !v.length;
                    else if (v && typeof v === 'object') return Object.values(v).every((ov)=>{
                        if (Array.isArray(ov)) return !ov.length;
                        else return [
                            '',
                            null,
                            undefined
                        ].indexOf(ov) !== -1;
                    });
                    else return [
                        '',
                        null,
                        undefined
                    ].indexOf(v) !== -1;
                });
            } else return [
                '',
                null,
                undefined
            ].indexOf(actual) !== -1;
        case 'not_empty':
            if (isArray_1(actual)) return !!actual.length;
            else if (actual && actual instanceof File) return true;
            else if (actual && actual instanceof Blob) return true;
            else if (actual && typeof actual === 'object') {
                var _values = Object.values(actual);
                return _values.length && _values.some((v)=>{
                    if (Array.isArray(v)) return v.length;
                    else if (v && typeof v === 'object') return Object.values(v).some((ov)=>{
                        if (Array.isArray(ov)) return ov.length;
                        else return [
                            '',
                            null,
                            undefined
                        ].indexOf(ov) === -1;
                    });
                    else return [
                        '',
                        null,
                        undefined
                    ].indexOf(v) === -1;
                });
            } else return [
                '',
                null,
                undefined
            ].indexOf(actual) === -1;
        case '==':
        case 'in':
            if (isArray_1(expected)) {
                if (isArray_1(actual)) // ['checkboxes', [1,2,3]]
                return !expected.length ? !actual.length : actual.filter((a)=>includes_1(expected, a)).length > 0;
                else // ['text', [1,2,3]]
                return expected.indexOf(actual) !== -1;
            } else {
                if (isArray_1(actual)) // ['checkboxes', 1]
                return actual.indexOf(expected) !== -1;
                else // ['text', 1]
                return actual == expected;
            }
        case '!=':
        case 'not_in':
            if (isArray_1(expected)) {
                if (isArray_1(actual)) // ['checkboxes', 'not_in', [1,2,3]]
                return !expected.length ? !!actual.length : actual.filter((e)=>includes_1(expected, e)).length == 0;
                else // ['text', 'not_in', [1,2,3]]
                return expected.indexOf(actual) === -1;
            } else {
                if (isArray_1(actual)) // ['checkboxes', '!=', 1]
                return actual.indexOf(expected) === -1;
                else // ['text', '!=', 1]
                return actual != expected;
            }
        case 'today':
            if (!isArray_1(actual)) actual = [
                actual
            ];
            return actual.length && actual.every((a)=>moment(a, el$1.valueDateFormat).isSame(moment(), 'day'));
        case 'before':
            if (!isArray_1(actual)) actual = [
                actual
            ];
            return actual.length && actual.every((a)=>{
                var date = moment(a, el$1.valueDateFormat);
                return date.isValid() && date.isBefore(moment(expected === 'today' ? undefined : expected), 'day');
            });
        case 'after':
            if (!isArray_1(actual)) actual = [
                actual
            ];
            return actual.length && actual.every((a)=>{
                var date = moment(a, el$1.valueDateFormat);
                return date.isValid() && date.isAfter(moment(expected === 'today' ? undefined : expected), 'day');
            });
        case '^':
            return startsWith_1(actual, expected);
        case '$':
            return endsWith_1(actual, expected);
        case '*':
            return includes_1(actual, expected);
        default:
            var customOperators = form$.$vueform.config.operators || {};
            if (customOperators[operator]) return customOperators[operator](actual, expected, el$1, form$);
    }
}
var Factory = class {
    constructor(path, form$){
        this.form$ = form$;
        this.element$ = form$.el$(path);
    }
    get rules() {
        var rules = Object.assign({}, this.form$.$vueform.services.validation.rules, this.form$.$vueform.rules);
        if (!rules.in && rules.in_) rules.in = rules.in_;
        return rules;
    }
    makeAll(rules) {
        var parsedRules = this.parseRules(rules);
        if (parsedRules.length == 0) return [];
        return map_1(parsedRules, (rule)=>{
            return this.make(rule);
        });
    }
    make(rule) {
        var ruleClass = typeof rule == 'function' ? rule : Array.isArray(rule) ? rule[0] : this.rules[rule.name];
        if (!ruleClass) throw new Error("Unknown rule: '".concat(rule.name, "'"));
        return new ruleClass(rule !== null && rule !== void 0 && rule.name ? rule : {
            name: "custom_rule_".concat(Math.floor(Math.random() * 9000000) + 1000000),
            attributes: Array.isArray(rule) && rule[1] ? rule[1] : []
        }, {
            element$: this.element$
        });
    }
    parseRules(rules) {
        if (!isArray_1(rules)) rules = rules.split('|');
        return rules.map((rule)=>{
            if (typeof rule == 'function' || Array.isArray(rule)) return rule;
            return this.isConditional(rule) ? this.parseConditional(rule) : this.parse(rule);
        });
    }
    parse(rule) {
        return parse(rule);
    }
    isConditional(rule) {
        return isPlainObject_1(rule);
    }
    parseConditional(rule) {
        var _conditions = values_1(rule)[0];
        if (!Array.isArray(_conditions[0])) _conditions = [
            _conditions
        ];
        var parsed = _objectSpread2$1(_objectSpread2$1({}, parse(keys_1(rule)[0])), {}, {
            conditions: (form$, Validator, el$1)=>{
                return _conditions.every((condition)=>{
                    if (isArray_1(condition)) {
                        if (isArray_1(condition[0])) return condition.some((subcondition)=>{
                            if (isArray_1(subcondition)) return this.createConditionFromArray(subcondition)(form$, Validator, el$1);
                            else return condition(form$, Validator, el$1);
                        });
                        else return this.createConditionFromArray(condition)(form$, Validator, el$1);
                    } else return condition(form$, Validator, el$1);
                });
            },
            dependents: []
        });
        _conditions.forEach((condition)=>{
            if (isArray_1(condition)) {
                if (isArray_1(condition[0])) condition.forEach((subcondition)=>{
                    if (isArray_1(subcondition)) parsed.dependents.push(replaceWildcards(subcondition[0], this.element$.path));
                });
                else parsed.dependents.push(replaceWildcards(condition[0], this.element$.path));
            }
        });
        return parsed;
    }
    createConditionFromArray(condition) {
        var field = replaceWildcards(condition[0], this.element$.path);
        var operator = condition.length == 3 || [
            'empty',
            'not_empty',
            'today'
        ].indexOf(condition[1]) !== -1 ? condition[1] : '==';
        var value = condition.length == 3 ? condition[2] : [
            'empty',
            'not_empty',
            'today'
        ].indexOf(condition[1]) === -1 ? condition[1] : true;
        return (form$, Validator, el$1)=>{
            var _form$$el$;
            var actual = (_form$$el$ = form$.el$(field)) === null || _form$$el$ === void 0 ? void 0 : _form$$el$.value;
            var expected = value;
            return compare(actual, operator, expected, this.element$, form$);
        };
    }
};
class accepted extends Validator {
    check(value) {
        return [
            'yes',
            'on',
            '1',
            1,
            true,
            'true'
        ].indexOf(value) !== -1;
    }
}
class active_url extends Validator {
    get isAsync() {
        return true;
    }
    check(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            var endpoint = _this.form$.$vueform.config.endpoints.activeUrl;
            var method = typeof endpoint !== 'function' ? endpoint.method : null;
            var res;
            if (typeof endpoint === 'function') res = yield endpoint(value, _this.element$, _this.form$);
            else res = yield _this.form$.$vueform.services.axios.request({
                url: endpoint.url,
                method: method,
                [method.toLowerCase() === 'get' ? 'params' : 'data']: {
                    url: value
                }
            });
            return res.data;
        })();
    }
}
class after extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            date: this.date.format(this.format)
        };
    }
    get param() {
        return this.attributes[0];
    }
    get format() {
        return [
            'date',
            'dates'
        ].indexOf(this.element$.type) !== -1 && this.element$.valueFormat ? this.element$.valueFormat : 'YYYY-MM-DD';
    }
    get otherFormat() {
        if (this.dateType != 'element') return this.format;
        return [
            'date',
            'dates'
        ].indexOf(this.other$.type) !== -1 && this.other$.valueFormat ? this.other$.valueFormat : this.format;
    }
    get otherPath() {
        if (this.dateType != 'element') return null;
        return this.param;
    }
    get other$() {
        if (this.dateType != 'element') return {};
        return this.form$.el$(this.param);
    }
    get date() {
        var date = '';
        switch(this.dateType){
            case 'relative':
                if (this.param === 'today') date = this.moment().startOf('day');
                if (this.param === 'tomorrow') date = this.moment().startOf('day').add(1, 'days');
                if (this.param === 'yesterday') date = this.moment().startOf('day').subtract(1, 'days');
                break;
            case 'element':
                date = this.moment(this.other$.value, this.otherFormat);
                break;
            case 'absolute':
                date = this.moment(this.param, this.format);
                break;
        }
        return date;
    }
    get dateType() {
        if ([
            'today',
            'tomorrow',
            'yesterday'
        ].indexOf(this.param) !== -1) return 'relative';
        else if (this.form$.el$(this.param)) return 'element';
        else return 'absolute';
    }
    init() {
        this.form$.$nextTick(()=>{
            if (this.dateType == 'element') this.watchOther();
        });
    }
    check(value) {
        if (isArray_1(value)) {
            var valid = true;
            each(value, (date)=>{
                if (!this.checkDate(date)) valid = false;
            });
            return valid;
        }
        return this.checkDate(value);
    }
    checkDate(value) {
        return this.moment(value, this.format).isAfter(this.moment(this.date, this.otherFormat));
    }
}
class after_or_equal extends after {
    checkDate(value) {
        return this.moment(value, this.format).isSameOrAfter(this.moment(this.date, this.otherFormat));
    }
}
class alpha extends Validator {
    check(value) {
        // Solution from XRegExp library:
        // https://stackoverflow.com/a/15861883/1276358
        return /^[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*$/.test(value);
    }
}
class alpha_dash extends Validator {
    check(value) {
        // Solution from XRegExp library:
        // https://stackoverflow.com/a/15861883/1276358
        return /^[0-9-_\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*$/.test(value);
    }
}
class alpha_num extends Validator {
    check(value) {
        // Solution from XRegExp library:
        // https://stackoverflow.com/a/15861883/1276358
        return /^[0-9\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*$/.test(value);
    }
}
class array$2 extends Validator {
    check(value) {
        return isArray_1(value);
    }
}
class before extends after {
    checkDate(value) {
        return this.moment(value, this.format).isBefore(this.moment(this.date, this.otherFormat));
    }
}
class before_or_equal extends after {
    checkDate(value) {
        return this.moment(value, this.format).isSameOrBefore(this.moment(this.date, this.otherFormat));
    }
}
class between extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            min: this.min,
            max: this.max
        };
    }
    get min() {
        return this.attributes[0];
    }
    get max() {
        return this.attributes[1];
    }
    check(value) {
        if (typeof value !== 'number' && !value) return true;
        var size = this.size(value);
        return size >= this.min && size <= this.max;
    }
}
class boolean$1 extends Validator {
    check(value) {
        var accepted = [
            true,
            false,
            0,
            1,
            '0',
            '1'
        ];
        return accepted.indexOf(value) !== -1;
    }
}
class captcha$2 extends Validator {
    get isAsync() {
        return true;
    }
    check(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            if (!_this.element$.shouldVerify) return true;
            return yield _this.element$.Provider.validate(_this.element$.Provider.getResponse());
        })();
    }
}
class completed extends Validator {
    get debounce() {
        if (this.attributes.debounce !== undefined) return this.attributes.debounce;
        if (this.element$.debounce !== null) return this.element$.debounce;
        return 1000;
    }
    check(value) {
        var _this$element$$Mask$m;
        if (!this.element$.Mask) return this.filled(value);
        var isComplete = (_this$element$$Mask$m = this.element$.Mask.masked.currentMask) === null || _this$element$$Mask$m === void 0 ? void 0 : _this$element$$Mask$m.isComplete;
        return isComplete === undefined || this.element$.empty ? true : isComplete;
    }
}
class confirmed extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            other: this.other$.genericName
        };
    }
    get otherPath() {
        return "".concat(this.element$.path, "_confirmation");
    }
    get other$() {
        return this.form$.el$(replaceWildcards(this.otherPath, this.element$.path));
    }
    init() {
        this.watchOther();
    }
    check(value) {
        if (!this.filled(this.other$.value)) return true;
        return value == this.other$.value;
    }
}
var reSpace = '[ \\t]+';
var reSpaceOpt = '[ \\t]*';
var reMeridian = '(?:([ap])\\.?m\\.?([\\t ]|$))';
var reHour24 = '(2[0-4]|[01]?[0-9])';
var reHour24lz = '([01][0-9]|2[0-4])';
var reHour12 = '(0?[1-9]|1[0-2])';
var reMinute = '([0-5]?[0-9])';
var reMinutelz = '([0-5][0-9])';
var reSecond = '(60|[0-5]?[0-9])';
var reSecondlz = '(60|[0-5][0-9])';
var reFrac = '(?:\\.([0-9]+))';
var reDayfull = 'sunday|monday|tuesday|wednesday|thursday|friday|saturday';
var reDayabbr = 'sun|mon|tue|wed|thu|fri|sat';
var reDaytext = reDayfull + '|' + reDayabbr + '|weekdays?';
var reReltextnumber = 'first|second|third|fourth|fifth|sixth|seventh|eighth?|ninth|tenth|eleventh|twelfth';
var reReltexttext = 'next|last|previous|this';
var reReltextunit = '(?:second|sec|minute|min|hour|day|fortnight|forthnight|month|year)s?|weeks|' + reDaytext;
var reYear = '([0-9]{1,4})';
var reYear2 = '([0-9]{2})';
var reYear4 = '([0-9]{4})';
var reYear4withSign = '([+-]?[0-9]{4})';
var reMonth = '(1[0-2]|0?[0-9])';
var reMonthlz = '(0[0-9]|1[0-2])';
var reDay = '(?:(3[01]|[0-2]?[0-9])(?:st|nd|rd|th)?)';
var reDaylz = '(0[0-9]|[1-2][0-9]|3[01])';
var reMonthFull = 'january|february|march|april|may|june|july|august|september|october|november|december';
var reMonthAbbr = 'jan|feb|mar|apr|may|jun|jul|aug|sept?|oct|nov|dec';
var reMonthroman = 'i[vx]|vi{0,3}|xi{0,2}|i{1,3}';
var reMonthText = '(' + reMonthFull + '|' + reMonthAbbr + '|' + reMonthroman + ')';
var reTzCorrection = '((?:GMT)?([+-])' + reHour24 + ':?' + reMinute + '?)';
var reTzAbbr = '\\(?([a-zA-Z]{1,6})\\)?';
var reDayOfYear = '(00[1-9]|0[1-9][0-9]|[12][0-9][0-9]|3[0-5][0-9]|36[0-6])';
var reWeekOfYear = '(0[1-9]|[1-4][0-9]|5[0-3])';
var reDateNoYear = reMonthText + '[ .\\t-]*' + reDay + '[,.stndrh\\t ]*';
function processMeridian(hour, meridian) {
    meridian = meridian && meridian.toLowerCase();
    switch(meridian){
        case 'a':
            hour += hour === 12 ? -12 : 0;
            break;
        case 'p':
            hour += hour !== 12 ? 12 : 0;
            break;
    }
    return hour;
}
function processYear(yearStr) {
    var year = +yearStr;
    if (yearStr.length < 4 && year < 100) year += year < 70 ? 2000 : 1900;
    return year;
}
function lookupMonth(monthStr) {
    return ({
        jan: 0,
        january: 0,
        i: 0,
        feb: 1,
        february: 1,
        ii: 1,
        mar: 2,
        march: 2,
        iii: 2,
        apr: 3,
        april: 3,
        iv: 3,
        may: 4,
        v: 4,
        jun: 5,
        june: 5,
        vi: 5,
        jul: 6,
        july: 6,
        vii: 6,
        aug: 7,
        august: 7,
        viii: 7,
        sep: 8,
        sept: 8,
        september: 8,
        ix: 8,
        oct: 9,
        october: 9,
        x: 9,
        nov: 10,
        november: 10,
        xi: 10,
        dec: 11,
        december: 11,
        xii: 11
    })[monthStr.toLowerCase()];
}
function lookupWeekday(dayStr) {
    var desiredSundayNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var dayNumbers = {
        mon: 1,
        monday: 1,
        tue: 2,
        tuesday: 2,
        wed: 3,
        wednesday: 3,
        thu: 4,
        thursday: 4,
        fri: 5,
        friday: 5,
        sat: 6,
        saturday: 6,
        sun: 0,
        sunday: 0
    };
    return dayNumbers[dayStr.toLowerCase()] || desiredSundayNumber;
}
function lookupRelative(relText) {
    var relativeNumbers = {
        last: -1,
        previous: -1,
        this: 0,
        first: 1,
        next: 1,
        second: 2,
        third: 3,
        fourth: 4,
        fifth: 5,
        sixth: 6,
        seventh: 7,
        eight: 8,
        eighth: 8,
        ninth: 9,
        tenth: 10,
        eleventh: 11,
        twelfth: 12
    };
    var relativeBehavior = {
        this: 1
    };
    var relTextLower = relText.toLowerCase();
    return {
        amount: relativeNumbers[relTextLower],
        behavior: relativeBehavior[relTextLower] || 0
    };
}
function processTzCorrection(tzOffset, oldValue) {
    var reTzCorrectionLoose = /(?:GMT)?([+-])(\d+)(:?)(\d{0,2})/i;
    tzOffset = tzOffset && tzOffset.match(reTzCorrectionLoose);
    if (!tzOffset) return oldValue;
    var sign = tzOffset[1] === '-' ? -1 : 1;
    var hours = +tzOffset[2];
    var minutes = +tzOffset[4];
    if (!tzOffset[4] && !tzOffset[3]) {
        minutes = Math.floor(hours % 100);
        hours = Math.floor(hours / 100);
    }
    // timezone offset in seconds
    return sign * (hours * 60 + minutes) * 60;
}
// tz abbrevation : tz offset in seconds
var tzAbbrOffsets = {
    acdt: 37800,
    acst: 34200,
    addt: -7200,
    adt: -10800,
    aedt: 39600,
    aest: 36000,
    ahdt: -32400,
    ahst: -36000,
    akdt: -28800,
    akst: -32400,
    amt: -13840,
    apt: -10800,
    ast: -14400,
    awdt: 32400,
    awst: 28800,
    awt: -10800,
    bdst: 7200,
    bdt: -36000,
    bmt: -14309,
    bst: 3600,
    cast: 34200,
    cat: 7200,
    cddt: -14400,
    cdt: -18000,
    cemt: 10800,
    cest: 7200,
    cet: 3600,
    cmt: -15408,
    cpt: -18000,
    cst: -21600,
    cwt: -18000,
    chst: 36000,
    dmt: -1521,
    eat: 10800,
    eddt: -10800,
    edt: -14400,
    eest: 10800,
    eet: 7200,
    emt: -26248,
    ept: -14400,
    est: -18000,
    ewt: -14400,
    ffmt: -14660,
    fmt: -4056,
    gdt: 39600,
    gmt: 0,
    gst: 36000,
    hdt: -34200,
    hkst: 32400,
    hkt: 28800,
    hmt: -19776,
    hpt: -34200,
    hst: -36000,
    hwt: -34200,
    iddt: 14400,
    idt: 10800,
    imt: 25025,
    ist: 7200,
    jdt: 36000,
    jmt: 8440,
    jst: 32400,
    kdt: 36000,
    kmt: 5736,
    kst: 30600,
    lst: 9394,
    mddt: -18000,
    mdst: 16279,
    mdt: -21600,
    mest: 7200,
    met: 3600,
    mmt: 9017,
    mpt: -21600,
    msd: 14400,
    msk: 10800,
    mst: -25200,
    mwt: -21600,
    nddt: -5400,
    ndt: -9052,
    npt: -9000,
    nst: -12600,
    nwt: -9000,
    nzdt: 46800,
    nzmt: 41400,
    nzst: 43200,
    pddt: -21600,
    pdt: -25200,
    pkst: 21600,
    pkt: 18000,
    plmt: 25590,
    pmt: -13236,
    ppmt: -17340,
    ppt: -25200,
    pst: -28800,
    pwt: -25200,
    qmt: -18840,
    rmt: 5794,
    sast: 7200,
    sdmt: -16800,
    sjmt: -20173,
    smt: -13884,
    sst: -39600,
    tbmt: 10751,
    tmt: 12344,
    uct: 0,
    utc: 0,
    wast: 7200,
    wat: 3600,
    wemt: 7200,
    west: 3600,
    wet: 0,
    wib: 25200,
    wita: 28800,
    wit: 32400,
    wmt: 5040,
    yddt: -25200,
    ydt: -28800,
    ypt: -28800,
    yst: -32400,
    ywt: -28800,
    a: 3600,
    b: 7200,
    c: 10800,
    d: 14400,
    e: 18000,
    f: 21600,
    g: 25200,
    h: 28800,
    i: 32400,
    k: 36000,
    l: 39600,
    m: 43200,
    n: -3600,
    o: -7200,
    p: -10800,
    q: -14400,
    r: -18000,
    s: -21600,
    t: -25200,
    u: -28800,
    v: -32400,
    w: -36000,
    x: -39600,
    y: -43200,
    z: 0
};
var formats$1 = {
    yesterday: {
        regex: /^yesterday/i,
        name: 'yesterday',
        callback: function callback() {
            this.rd -= 1;
            return this.resetTime();
        }
    },
    now: {
        regex: /^now/i,
        name: 'now'
    },
    noon: {
        regex: /^noon/i,
        name: 'noon',
        callback: function callback() {
            return this.resetTime() && this.time(12, 0, 0, 0);
        }
    },
    midnightOrToday: {
        regex: /^(midnight|today)/i,
        name: 'midnight | today',
        callback: function callback() {
            return this.resetTime();
        }
    },
    tomorrow: {
        regex: /^tomorrow/i,
        name: 'tomorrow',
        callback: function callback() {
            this.rd += 1;
            return this.resetTime();
        }
    },
    timestamp: {
        regex: /^@(-?\d+)/i,
        name: 'timestamp',
        callback: function callback(match, timestamp) {
            this.rs += +timestamp;
            this.y = 1970;
            this.m = 0;
            this.d = 1;
            this.dates = 0;
            return this.resetTime() && this.zone(0);
        }
    },
    firstOrLastDay: {
        regex: /^(first|last) day of/i,
        name: 'firstdayof | lastdayof',
        callback: function callback(match, day) {
            if (day.toLowerCase() === 'first') this.firstOrLastDayOfMonth = 1;
            else this.firstOrLastDayOfMonth = -1;
        }
    },
    backOrFrontOf: {
        regex: RegExp('^(back|front) of ' + reHour24 + reSpaceOpt + reMeridian + '?', 'i'),
        name: 'backof | frontof',
        callback: function callback(match, side, hours, meridian) {
            var back = side.toLowerCase() === 'back';
            var hour = +hours;
            var minute = 15;
            if (!back) {
                hour -= 1;
                minute = 45;
            }
            hour = processMeridian(hour, meridian);
            return this.resetTime() && this.time(hour, minute, 0, 0);
        }
    },
    weekdayOf: {
        regex: RegExp('^(' + reReltextnumber + '|' + reReltexttext + ')' + reSpace + '(' + reDayfull + '|' + reDayabbr + ')' + reSpace + 'of', 'i'),
        name: 'weekdayof'
    },
    mssqltime: {
        regex: RegExp('^' + reHour12 + ':' + reMinutelz + ':' + reSecondlz + '[:.]([0-9]+)' + reMeridian, 'i'),
        name: 'mssqltime',
        callback: function callback(match, hour, minute, second, frac, meridian) {
            return this.time(processMeridian(+hour, meridian), +minute, +second, +frac.substr(0, 3));
        }
    },
    oracledate: {
        regex: /^(\d{2})-([A-Z]{3})-(\d{2})$/i,
        name: 'd-M-y',
        callback: function callback(match, day, monthText, year) {
            var month = {
                JAN: 0,
                FEB: 1,
                MAR: 2,
                APR: 3,
                MAY: 4,
                JUN: 5,
                JUL: 6,
                AUG: 7,
                SEP: 8,
                OCT: 9,
                NOV: 10,
                DEC: 11
            }[monthText.toUpperCase()];
            return this.ymd(2000 + parseInt(year, 10), month, parseInt(day, 10));
        }
    },
    timeLong12: {
        regex: RegExp('^' + reHour12 + '[:.]' + reMinute + '[:.]' + reSecondlz + reSpaceOpt + reMeridian, 'i'),
        name: 'timelong12',
        callback: function callback(match, hour, minute, second, meridian) {
            return this.time(processMeridian(+hour, meridian), +minute, +second, 0);
        }
    },
    timeShort12: {
        regex: RegExp('^' + reHour12 + '[:.]' + reMinutelz + reSpaceOpt + reMeridian, 'i'),
        name: 'timeshort12',
        callback: function callback(match, hour, minute, meridian) {
            return this.time(processMeridian(+hour, meridian), +minute, 0, 0);
        }
    },
    timeTiny12: {
        regex: RegExp('^' + reHour12 + reSpaceOpt + reMeridian, 'i'),
        name: 'timetiny12',
        callback: function callback(match, hour, meridian) {
            return this.time(processMeridian(+hour, meridian), 0, 0, 0);
        }
    },
    soap: {
        regex: RegExp('^' + reYear4 + '-' + reMonthlz + '-' + reDaylz + 'T' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz + reFrac + reTzCorrection + '?', 'i'),
        name: 'soap',
        callback: function callback(match, year, month, day, hour, minute, second, frac, tzCorrection) {
            return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, +frac.substr(0, 3)) && this.zone(processTzCorrection(tzCorrection));
        }
    },
    wddx: {
        regex: RegExp('^' + reYear4 + '-' + reMonth + '-' + reDay + 'T' + reHour24 + ':' + reMinute + ':' + reSecond),
        name: 'wddx',
        callback: function callback(match, year, month, day, hour, minute, second) {
            return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
        }
    },
    exif: {
        regex: RegExp('^' + reYear4 + ':' + reMonthlz + ':' + reDaylz + ' ' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz, 'i'),
        name: 'exif',
        callback: function callback(match, year, month, day, hour, minute, second) {
            return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
        }
    },
    xmlRpc: {
        regex: RegExp('^' + reYear4 + reMonthlz + reDaylz + 'T' + reHour24 + ':' + reMinutelz + ':' + reSecondlz),
        name: 'xmlrpc',
        callback: function callback(match, year, month, day, hour, minute, second) {
            return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
        }
    },
    xmlRpcNoColon: {
        regex: RegExp('^' + reYear4 + reMonthlz + reDaylz + '[Tt]' + reHour24 + reMinutelz + reSecondlz),
        name: 'xmlrpcnocolon',
        callback: function callback(match, year, month, day, hour, minute, second) {
            return this.ymd(+year, month - 1, +day) && this.time(+hour, +minute, +second, 0);
        }
    },
    clf: {
        regex: RegExp('^' + reDay + '/(' + reMonthAbbr + ')/' + reYear4 + ':' + reHour24lz + ':' + reMinutelz + ':' + reSecondlz + reSpace + reTzCorrection, 'i'),
        name: 'clf',
        callback: function callback(match, day, month, year, hour, minute, second, tzCorrection) {
            return this.ymd(+year, lookupMonth(month), +day) && this.time(+hour, +minute, +second, 0) && this.zone(processTzCorrection(tzCorrection));
        }
    },
    iso8601long: {
        regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute + '[:.]' + reSecond + reFrac, 'i'),
        name: 'iso8601long',
        callback: function callback(match, hour, minute, second, frac) {
            return this.time(+hour, +minute, +second, +frac.substr(0, 3));
        }
    },
    dateTextual: {
        regex: RegExp('^' + reMonthText + '[ .\\t-]*' + reDay + '[,.stndrh\\t ]+' + reYear, 'i'),
        name: 'datetextual',
        callback: function callback(match, month, day, year) {
            return this.ymd(processYear(year), lookupMonth(month), +day);
        }
    },
    pointedDate4: {
        regex: RegExp('^' + reDay + '[.\\t-]' + reMonth + '[.-]' + reYear4),
        name: 'pointeddate4',
        callback: function callback(match, day, month, year) {
            return this.ymd(+year, month - 1, +day);
        }
    },
    pointedDate2: {
        regex: RegExp('^' + reDay + '[.\\t]' + reMonth + '\\.' + reYear2),
        name: 'pointeddate2',
        callback: function callback(match, day, month, year) {
            return this.ymd(processYear(year), month - 1, +day);
        }
    },
    timeLong24: {
        regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute + '[:.]' + reSecond),
        name: 'timelong24',
        callback: function callback(match, hour, minute, second) {
            return this.time(+hour, +minute, +second, 0);
        }
    },
    dateNoColon: {
        regex: RegExp('^' + reYear4 + reMonthlz + reDaylz),
        name: 'datenocolon',
        callback: function callback(match, year, month, day) {
            return this.ymd(+year, month - 1, +day);
        }
    },
    pgydotd: {
        regex: RegExp('^' + reYear4 + '\\.?' + reDayOfYear),
        name: 'pgydotd',
        callback: function callback(match, year, day) {
            return this.ymd(+year, 0, +day);
        }
    },
    timeShort24: {
        regex: RegExp('^t?' + reHour24 + '[:.]' + reMinute, 'i'),
        name: 'timeshort24',
        callback: function callback(match, hour, minute) {
            return this.time(+hour, +minute, 0, 0);
        }
    },
    iso8601noColon: {
        regex: RegExp('^t?' + reHour24lz + reMinutelz + reSecondlz, 'i'),
        name: 'iso8601nocolon',
        callback: function callback(match, hour, minute, second) {
            return this.time(+hour, +minute, +second, 0);
        }
    },
    iso8601dateSlash: {
        // eventhough the trailing slash is optional in PHP
        // here it's mandatory and inputs without the slash
        // are handled by dateslash
        regex: RegExp('^' + reYear4 + '/' + reMonthlz + '/' + reDaylz + '/'),
        name: 'iso8601dateslash',
        callback: function callback(match, year, month, day) {
            return this.ymd(+year, month - 1, +day);
        }
    },
    dateSlash: {
        regex: RegExp('^' + reYear4 + '/' + reMonth + '/' + reDay),
        name: 'dateslash',
        callback: function callback(match, year, month, day) {
            return this.ymd(+year, month - 1, +day);
        }
    },
    american: {
        regex: RegExp('^' + reMonth + '/' + reDay + '/' + reYear),
        name: 'american',
        callback: function callback(match, month, day, year) {
            return this.ymd(processYear(year), month - 1, +day);
        }
    },
    americanShort: {
        regex: RegExp('^' + reMonth + '/' + reDay),
        name: 'americanshort',
        callback: function callback(match, month, day) {
            return this.ymd(this.y, month - 1, +day);
        }
    },
    gnuDateShortOrIso8601date2: {
        // iso8601date2 is complete subset of gnudateshort
        regex: RegExp('^' + reYear + '-' + reMonth + '-' + reDay),
        name: 'gnudateshort | iso8601date2',
        callback: function callback(match, year, month, day) {
            return this.ymd(processYear(year), month - 1, +day);
        }
    },
    iso8601date4: {
        regex: RegExp('^' + reYear4withSign + '-' + reMonthlz + '-' + reDaylz),
        name: 'iso8601date4',
        callback: function callback(match, year, month, day) {
            return this.ymd(+year, month - 1, +day);
        }
    },
    gnuNoColon: {
        regex: RegExp('^t?' + reHour24lz + reMinutelz, 'i'),
        name: 'gnunocolon',
        callback: function callback(match, hour, minute) {
            // this rule is a special case
            // if time was already set once by any preceding rule, it sets the captured value as year
            switch(this.times){
                case 0:
                    return this.time(+hour, +minute, 0, this.f);
                case 1:
                    this.y = hour * 100 + +minute;
                    this.times++;
                    return true;
                default:
                    return false;
            }
        }
    },
    gnuDateShorter: {
        regex: RegExp('^' + reYear4 + '-' + reMonth),
        name: 'gnudateshorter',
        callback: function callback(match, year, month) {
            return this.ymd(+year, month - 1, 1);
        }
    },
    pgTextReverse: {
        // note: allowed years are from 32-9999
        // years below 32 should be treated as days in datefull
        regex: RegExp("^(\\d{3,4}|[4-9]\\d|3[2-9])-(" + reMonthAbbr + ')-' + reDaylz, 'i'),
        name: 'pgtextreverse',
        callback: function callback(match, year, month, day) {
            return this.ymd(processYear(year), lookupMonth(month), +day);
        }
    },
    dateFull: {
        regex: RegExp('^' + reDay + '[ \\t.-]*' + reMonthText + '[ \\t.-]*' + reYear, 'i'),
        name: 'datefull',
        callback: function callback(match, day, month, year) {
            return this.ymd(processYear(year), lookupMonth(month), +day);
        }
    },
    dateNoDay: {
        regex: RegExp('^' + reMonthText + '[ .\\t-]*' + reYear4, 'i'),
        name: 'datenoday',
        callback: function callback(match, month, year) {
            return this.ymd(+year, lookupMonth(month), 1);
        }
    },
    dateNoDayRev: {
        regex: RegExp('^' + reYear4 + '[ .\\t-]*' + reMonthText, 'i'),
        name: 'datenodayrev',
        callback: function callback(match, year, month) {
            return this.ymd(+year, lookupMonth(month), 1);
        }
    },
    pgTextShort: {
        regex: RegExp('^(' + reMonthAbbr + ')-' + reDaylz + '-' + reYear, 'i'),
        name: 'pgtextshort',
        callback: function callback(match, month, day, year) {
            return this.ymd(processYear(year), lookupMonth(month), +day);
        }
    },
    dateNoYear: {
        regex: RegExp('^' + reDateNoYear, 'i'),
        name: 'datenoyear',
        callback: function callback(match, month, day) {
            return this.ymd(this.y, lookupMonth(month), +day);
        }
    },
    dateNoYearRev: {
        regex: RegExp('^' + reDay + '[ .\\t-]*' + reMonthText, 'i'),
        name: 'datenoyearrev',
        callback: function callback(match, day, month) {
            return this.ymd(this.y, lookupMonth(month), +day);
        }
    },
    isoWeekDay: {
        regex: RegExp('^' + reYear4 + '-?W' + reWeekOfYear + '(?:-?([0-7]))?'),
        name: 'isoweekday | isoweek',
        callback: function callback(match, year, week, day) {
            day = day ? +day : 1;
            if (!this.ymd(+year, 0, 1)) return false;
            // get day of week for Jan 1st
            var dayOfWeek = new Date(this.y, this.m, this.d).getDay();
            // and use the day to figure out the offset for day 1 of week 1
            dayOfWeek = 0 - (dayOfWeek > 4 ? dayOfWeek - 7 : dayOfWeek);
            this.rd += dayOfWeek + (week - 1) * 7 + day;
        }
    },
    relativeText: {
        regex: RegExp('^(' + reReltextnumber + '|' + reReltexttext + ')' + reSpace + '(' + reReltextunit + ')', 'i'),
        name: 'relativetext',
        callback: function callback(match, relValue, relUnit) {
            // todo: implement handling of 'this time-unit'
            // eslint-disable-next-line no-unused-vars
            var _lookupRelative = lookupRelative(relValue), amount = _lookupRelative.amount;
            switch(relUnit.toLowerCase()){
                case 'sec':
                case 'secs':
                case 'second':
                case 'seconds':
                    this.rs += amount;
                    break;
                case 'min':
                case 'mins':
                case 'minute':
                case 'minutes':
                    this.ri += amount;
                    break;
                case 'hour':
                case 'hours':
                    this.rh += amount;
                    break;
                case 'day':
                case 'days':
                    this.rd += amount;
                    break;
                case 'fortnight':
                case 'fortnights':
                case 'forthnight':
                case 'forthnights':
                    this.rd += amount * 14;
                    break;
                case 'week':
                case 'weeks':
                    this.rd += amount * 7;
                    break;
                case 'month':
                case 'months':
                    this.rm += amount;
                    break;
                case 'year':
                case 'years':
                    this.ry += amount;
                    break;
                case 'mon':
                case 'monday':
                case 'tue':
                case 'tuesday':
                case 'wed':
                case 'wednesday':
                case 'thu':
                case 'thursday':
                case 'fri':
                case 'friday':
                case 'sat':
                case 'saturday':
                case 'sun':
                case 'sunday':
                    this.resetTime();
                    this.weekday = lookupWeekday(relUnit, 7);
                    this.weekdayBehavior = 1;
                    this.rd += (amount > 0 ? amount - 1 : amount) * 7;
                    break;
            }
        }
    },
    relative: {
        regex: RegExp('^([+-]*)[ \\t]*(\\d+)' + reSpaceOpt + '(' + reReltextunit + '|week)', 'i'),
        name: 'relative',
        callback: function callback(match, signs, relValue, relUnit) {
            var minuses = signs.replace(/[^-]/g, '').length;
            var amount = +relValue * Math.pow(-1, minuses);
            switch(relUnit.toLowerCase()){
                case 'sec':
                case 'secs':
                case 'second':
                case 'seconds':
                    this.rs += amount;
                    break;
                case 'min':
                case 'mins':
                case 'minute':
                case 'minutes':
                    this.ri += amount;
                    break;
                case 'hour':
                case 'hours':
                    this.rh += amount;
                    break;
                case 'day':
                case 'days':
                    this.rd += amount;
                    break;
                case 'fortnight':
                case 'fortnights':
                case 'forthnight':
                case 'forthnights':
                    this.rd += amount * 14;
                    break;
                case 'week':
                case 'weeks':
                    this.rd += amount * 7;
                    break;
                case 'month':
                case 'months':
                    this.rm += amount;
                    break;
                case 'year':
                case 'years':
                    this.ry += amount;
                    break;
                case 'mon':
                case 'monday':
                case 'tue':
                case 'tuesday':
                case 'wed':
                case 'wednesday':
                case 'thu':
                case 'thursday':
                case 'fri':
                case 'friday':
                case 'sat':
                case 'saturday':
                case 'sun':
                case 'sunday':
                    this.resetTime();
                    this.weekday = lookupWeekday(relUnit, 7);
                    this.weekdayBehavior = 1;
                    this.rd += (amount > 0 ? amount - 1 : amount) * 7;
                    break;
            }
        }
    },
    dayText: {
        regex: RegExp('^(' + reDaytext + ')', 'i'),
        name: 'daytext',
        callback: function callback(match, dayText) {
            this.resetTime();
            this.weekday = lookupWeekday(dayText, 0);
            if (this.weekdayBehavior !== 2) this.weekdayBehavior = 1;
        }
    },
    relativeTextWeek: {
        regex: RegExp('^(' + reReltexttext + ')' + reSpace + 'week', 'i'),
        name: 'relativetextweek',
        callback: function callback(match, relText) {
            this.weekdayBehavior = 2;
            switch(relText.toLowerCase()){
                case 'this':
                    this.rd += 0;
                    break;
                case 'next':
                    this.rd += 7;
                    break;
                case 'last':
                case 'previous':
                    this.rd -= 7;
                    break;
            }
            if (isNaN(this.weekday)) this.weekday = 1;
        }
    },
    monthFullOrMonthAbbr: {
        regex: RegExp('^(' + reMonthFull + '|' + reMonthAbbr + ')', 'i'),
        name: 'monthfull | monthabbr',
        callback: function callback(match, month) {
            return this.ymd(this.y, lookupMonth(month), this.d);
        }
    },
    tzCorrection: {
        regex: RegExp('^' + reTzCorrection, 'i'),
        name: 'tzcorrection',
        callback: function callback(tzCorrection) {
            return this.zone(processTzCorrection(tzCorrection));
        }
    },
    tzAbbr: {
        regex: RegExp('^' + reTzAbbr),
        name: 'tzabbr',
        callback: function callback(match, abbr) {
            var offset = tzAbbrOffsets[abbr.toLowerCase()];
            if (isNaN(offset)) return false;
            return this.zone(offset);
        }
    },
    ago: {
        regex: /^ago/i,
        name: 'ago',
        callback: function callback() {
            this.ry = -this.ry;
            this.rm = -this.rm;
            this.rd = -this.rd;
            this.rh = -this.rh;
            this.ri = -this.ri;
            this.rs = -this.rs;
            this.rf = -this.rf;
        }
    },
    year4: {
        regex: RegExp('^' + reYear4),
        name: 'year4',
        callback: function callback(match, year) {
            this.y = +year;
            return true;
        }
    },
    whitespace: {
        regex: /^[ .,\t]+/,
        name: 'whitespace'
    },
    dateShortWithTimeLong: {
        regex: RegExp('^' + reDateNoYear + 't?' + reHour24 + '[:.]' + reMinute + '[:.]' + reSecond, 'i'),
        name: 'dateshortwithtimelong',
        callback: function callback(match, month, day, hour, minute, second) {
            return this.ymd(this.y, lookupMonth(month), +day) && this.time(+hour, +minute, +second, 0);
        }
    },
    dateShortWithTimeLong12: {
        regex: RegExp('^' + reDateNoYear + reHour12 + '[:.]' + reMinute + '[:.]' + reSecondlz + reSpaceOpt + reMeridian, 'i'),
        name: 'dateshortwithtimelong12',
        callback: function callback(match, month, day, hour, minute, second, meridian) {
            return this.ymd(this.y, lookupMonth(month), +day) && this.time(processMeridian(+hour, meridian), +minute, +second, 0);
        }
    },
    dateShortWithTimeShort: {
        regex: RegExp('^' + reDateNoYear + 't?' + reHour24 + '[:.]' + reMinute, 'i'),
        name: 'dateshortwithtimeshort',
        callback: function callback(match, month, day, hour, minute) {
            return this.ymd(this.y, lookupMonth(month), +day) && this.time(+hour, +minute, 0, 0);
        }
    },
    dateShortWithTimeShort12: {
        regex: RegExp('^' + reDateNoYear + reHour12 + '[:.]' + reMinutelz + reSpaceOpt + reMeridian, 'i'),
        name: 'dateshortwithtimeshort12',
        callback: function callback(match, month, day, hour, minute, meridian) {
            return this.ymd(this.y, lookupMonth(month), +day) && this.time(processMeridian(+hour, meridian), +minute, 0, 0);
        }
    }
};
var resultProto = {
    // date
    y: NaN,
    m: NaN,
    d: NaN,
    // time
    h: NaN,
    i: NaN,
    s: NaN,
    f: NaN,
    // relative shifts
    ry: 0,
    rm: 0,
    rd: 0,
    rh: 0,
    ri: 0,
    rs: 0,
    rf: 0,
    // weekday related shifts
    weekday: NaN,
    weekdayBehavior: 0,
    // first or last day of month
    // 0 none, 1 first, -1 last
    firstOrLastDayOfMonth: 0,
    // timezone correction in minutes
    z: NaN,
    // counters
    dates: 0,
    times: 0,
    zones: 0,
    // helper functions
    ymd: function ymd(y, m, d) {
        if (this.dates > 0) return false;
        this.dates++;
        this.y = y;
        this.m = m;
        this.d = d;
        return true;
    },
    time: function time(h, i, s, f) {
        if (this.times > 0) return false;
        this.times++;
        this.h = h;
        this.i = i;
        this.s = s;
        this.f = f;
        return true;
    },
    resetTime: function resetTime() {
        this.h = 0;
        this.i = 0;
        this.s = 0;
        this.f = 0;
        this.times = 0;
        return true;
    },
    zone: function zone(minutes) {
        if (this.zones <= 1) {
            this.zones++;
            this.z = minutes;
            return true;
        }
        return false;
    },
    toDate: function toDate(relativeTo) {
        if (this.dates && !this.times) this.h = this.i = this.s = this.f = 0;
        // fill holes
        if (isNaN(this.y)) this.y = relativeTo.getFullYear();
        if (isNaN(this.m)) this.m = relativeTo.getMonth();
        if (isNaN(this.d)) this.d = relativeTo.getDate();
        if (isNaN(this.h)) this.h = relativeTo.getHours();
        if (isNaN(this.i)) this.i = relativeTo.getMinutes();
        if (isNaN(this.s)) this.s = relativeTo.getSeconds();
        if (isNaN(this.f)) this.f = relativeTo.getMilliseconds();
        // adjust special early
        switch(this.firstOrLastDayOfMonth){
            case 1:
                this.d = 1;
                break;
            case -1:
                this.d = 0;
                this.m += 1;
                break;
        }
        if (!isNaN(this.weekday)) {
            var date = new Date(relativeTo.getTime());
            date.setFullYear(this.y, this.m, this.d);
            date.setHours(this.h, this.i, this.s, this.f);
            var dow = date.getDay();
            if (this.weekdayBehavior === 2) {
                // To make "this week" work, where the current day of week is a "sunday"
                if (dow === 0 && this.weekday !== 0) this.weekday = -6;
                // To make "sunday this week" work, where the current day of week is not a "sunday"
                if (this.weekday === 0 && dow !== 0) this.weekday = 7;
                this.d -= dow;
                this.d += this.weekday;
            } else {
                var diff = this.weekday - dow;
                // some PHP magic
                if (this.rd < 0 && diff < 0 || this.rd >= 0 && diff <= -this.weekdayBehavior) diff += 7;
                if (this.weekday >= 0) this.d += diff;
                else this.d -= 7 - (Math.abs(this.weekday) - dow);
                this.weekday = NaN;
            }
        }
        // adjust relative
        this.y += this.ry;
        this.m += this.rm;
        this.d += this.rd;
        this.h += this.rh;
        this.i += this.ri;
        this.s += this.rs;
        this.f += this.rf;
        this.ry = this.rm = this.rd = 0;
        this.rh = this.ri = this.rs = this.rf = 0;
        var result = new Date(relativeTo.getTime());
        // since Date constructor treats years <= 99 as 1900+
        // it can't be used, thus this weird way
        result.setFullYear(this.y, this.m, this.d);
        result.setHours(this.h, this.i, this.s, this.f);
        // note: this is done twice in PHP
        // early when processing special relatives
        // and late
        // todo: check if the logic can be reduced
        // to just one time action
        switch(this.firstOrLastDayOfMonth){
            case 1:
                result.setDate(1);
                break;
            case -1:
                result.setMonth(result.getMonth() + 1, 0);
                break;
        }
        // adjust timezone
        if (!isNaN(this.z) && result.getTimezoneOffset() !== this.z) {
            result.setUTCFullYear(result.getFullYear(), result.getMonth(), result.getDate());
            result.setUTCHours(result.getHours(), result.getMinutes(), result.getSeconds() - this.z, result.getMilliseconds());
        }
        return result;
    }
};
var strtotime = function strtotime(str, now) {
    //       discuss at: https://locutus.io/php/strtotime/
    //      original by: Caio Ariede (https://caioariede.com)
    //      improved by: Kevin van Zonneveld (https://kvz.io)
    //      improved by: Caio Ariede (https://caioariede.com)
    //      improved by: A. Matías Quezada (https://amatiasq.com)
    //      improved by: preuter
    //      improved by: Brett Zamir (https://brett-zamir.me)
    //      improved by: Mirko Faber
    //         input by: David
    //      bugfixed by: Wagner B. Soares
    //      bugfixed by: Artur Tchernychev
    //      bugfixed by: Stephan Bösch-Plepelits (https://github.com/plepe)
    // reimplemented by: Rafał Kukawski
    //           note 1: Examples all have a fixed timestamp to prevent
    //           note 1: tests to fail because of variable time(zones)
    //        example 1: strtotime('+1 day', 1129633200)
    //        returns 1: 1129719600
    //        example 2: strtotime('+1 week 2 days 4 hours 2 seconds', 1129633200)
    //        returns 2: 1130425202
    //        example 3: strtotime('last month', 1129633200)
    //        returns 3: 1127041200
    //        example 4: strtotime('2009-05-04 08:30:00+00')
    //        returns 4: 1241425800
    //        example 5: strtotime('2009-05-04 08:30:00+02:00')
    //        returns 5: 1241418600
    //        example 6: strtotime('2009-05-04 08:30:00 YWT')
    //        returns 6: 1241454600
    //        example 7: strtotime('10-JUL-17')
    //        returns 7: 1499644800
    if (now == null) now = Math.floor(Date.now() / 1000);
    // the rule order is important
    // if multiple rules match, the longest match wins
    // if multiple rules match the same string, the first match wins
    var rules = [
        formats$1.yesterday,
        formats$1.now,
        formats$1.noon,
        formats$1.midnightOrToday,
        formats$1.tomorrow,
        formats$1.timestamp,
        formats$1.firstOrLastDay,
        formats$1.backOrFrontOf,
        // formats.weekdayOf, // not yet implemented
        formats$1.timeTiny12,
        formats$1.timeShort12,
        formats$1.timeLong12,
        formats$1.mssqltime,
        formats$1.oracledate,
        formats$1.timeShort24,
        formats$1.timeLong24,
        formats$1.iso8601long,
        formats$1.gnuNoColon,
        formats$1.iso8601noColon,
        formats$1.americanShort,
        formats$1.american,
        formats$1.iso8601date4,
        formats$1.iso8601dateSlash,
        formats$1.dateSlash,
        formats$1.gnuDateShortOrIso8601date2,
        formats$1.gnuDateShorter,
        formats$1.dateFull,
        formats$1.pointedDate4,
        formats$1.pointedDate2,
        formats$1.dateNoDay,
        formats$1.dateNoDayRev,
        formats$1.dateTextual,
        formats$1.dateNoYear,
        formats$1.dateNoYearRev,
        formats$1.dateNoColon,
        formats$1.xmlRpc,
        formats$1.xmlRpcNoColon,
        formats$1.soap,
        formats$1.wddx,
        formats$1.exif,
        formats$1.pgydotd,
        formats$1.isoWeekDay,
        formats$1.pgTextShort,
        formats$1.pgTextReverse,
        formats$1.clf,
        formats$1.year4,
        formats$1.ago,
        formats$1.dayText,
        formats$1.relativeTextWeek,
        formats$1.relativeText,
        formats$1.monthFullOrMonthAbbr,
        formats$1.tzCorrection,
        formats$1.tzAbbr,
        formats$1.dateShortWithTimeShort12,
        formats$1.dateShortWithTimeLong12,
        formats$1.dateShortWithTimeShort,
        formats$1.dateShortWithTimeLong,
        formats$1.relative,
        formats$1.whitespace
    ];
    var result = Object.create(resultProto);
    while(str.length){
        var longestMatch = null;
        var finalRule = null;
        for(var i = 0, l = rules.length; i < l; i++){
            var format = rules[i];
            var match = str.match(format.regex);
            if (match) {
                if (!longestMatch || match[0].length > longestMatch[0].length) {
                    longestMatch = match;
                    finalRule = format;
                }
            }
        }
        if (!finalRule || finalRule.callback && finalRule.callback.apply(result, longestMatch) === false) return false;
        str = str.substr(longestMatch[0].length);
        finalRule = null;
        longestMatch = null;
    }
    return Math.floor(result.toDate(new Date(now * 1000)) / 1000);
};
class date$4 extends Validator {
    check(value) {
        return !!strtotime(value);
    }
}
class date_equals extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            date: this.date
        };
    }
    get date() {
        return this.attributes[0];
    }
    check(value) {
        return value === this.date;
    }
}
class date_format extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            format: this.format
        };
    }
    get format() {
        return this.attributes[0];
    }
    check(value) {
        return value && this.moment(value, this.format).format(this.format) === value;
    }
}
class different extends Validator {
    get otherPath() {
        return this.attributes[0];
    }
    get other$() {
        return this.form$.el$(replaceWildcards(this.otherPath, this.element$.path));
    }
    get messageParams() {
        return {
            attribute: this.attributeName,
            other: this.other$.genericName
        };
    }
    init() {
        this.watchOther();
    }
    check(value) {
        if (!this.filled(value) && !this.filled(this.other$.value)) return true;
        return value != this.other$.value;
    }
}
class digits extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            digits: this.digits
        };
    }
    get digits() {
        return this.attributes[0];
    }
    check(value) {
        return /^\d+$/.test(value) && value.toString().length == this.digits;
    }
}
class digits_between extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            min: this.min,
            max: this.max
        };
    }
    get min() {
        return this.attributes[0];
    }
    get max() {
        return this.attributes[1];
    }
    check(value) {
        var length = value.toString().length;
        return /^\d+$/.test(value) && length >= this.min && length <= this.max;
    }
}
class dimensions extends Validator {
    get isAsync() {
        return true;
    }
    readImage(inputFile) {
        return _asyncToGenerator(function*() {
            var reader = new FileReader();
            return new Promise((resolve, reject)=>{
                reader.onerror = ()=>{
                    temporaryFileReader.abort();
                    reject(new DOMException("File cannot be parsed."));
                };
                reader.onloadend = (event)=>{
                    resolve(event.target.result);
                };
                reader.readAsDataURL(inputFile);
            });
        })();
    }
    loadImage(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            var source = yield _this.readImage(value);
            var image = new Image();
            return new Promise((resolve, reject)=>{
                image.onerror = ()=>{
                    reject(new DOMException("Image could not be loaded."));
                };
                image.onload = (event)=>{
                    resolve(event.target);
                };
                image.src = source;
            });
        })();
    }
    hasAttribute(attribute) {
        return Object.keys(this.attributes).map((a)=>a.toLowerCase()).indexOf(attribute) !== -1;
    }
    check(value) {
        var _this2 = this;
        return _asyncToGenerator(function*() {
            if (_this2.isFile && !value) return true;
            if (!_this2.isFile || !(value instanceof File)) return false;
            var image = yield _this2.loadImage(value);
            if (_this2.hasAttribute('min_width')) {
                if (image.width < _this2.attributes['min_width']) return false;
            }
            if (_this2.hasAttribute('max_width')) {
                if (image.width > _this2.attributes['max_width']) return false;
            }
            if (_this2.hasAttribute('min_height')) {
                if (image.height < _this2.attributes['min_height']) return false;
            }
            if (_this2.hasAttribute('max_height')) {
                if (image.height > _this2.attributes['max_height']) return false;
            }
            if (_this2.hasAttribute('width')) {
                if (image.width != _this2.attributes['width']) return false;
            }
            if (_this2.hasAttribute('height')) {
                if (image.height != _this2.attributes['height']) return false;
            }
            if (_this2.hasAttribute('ratio')) {
                var ratio = _this2.attributes['ratio'];
                var precision = 1 / (Math.min(image.width, image.height) + 1);
                var numerator = /\//.test(ratio) ? ratio.split('/')[0] : ratio;
                var denominator = /\//.test(ratio) ? ratio.split('/')[1] : 1;
                if (Math.abs(numerator / denominator - image.width / image.height) > precision) return false;
            }
            return true;
        })();
    }
}
function pregQuote(str, delimiter) {
    // eslint-disable-line camelcase
    //  discuss at: http://locutus.io/php/preg_quote/
    // original by: booeyOH
    // improved by: Ates Goral (http://magnetiq.com)
    // improved by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    //   example 1: preg_quote("$40")
    //   returns 1: '\\$40'
    //   example 2: preg_quote("*RRRING* Hello?")
    //   returns 2: '\\*RRRING\\* Hello\\?'
    //   example 3: preg_quote("\\.+*?[^]$(){}=!<>|:")
    //   returns 3: '\\\\\\.\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:'
    return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
}
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce$1(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
var _baseReduce = baseReduce$1;
var arrayReduce = _arrayReduce, baseEach = _baseEach, baseIteratee$4 = _baseIteratee, baseReduce = _baseReduce, isArray$2 = isArray_1;
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray$2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee$4(iteratee), accumulator, initAccum, baseEach);
}
var reduce_1 = reduce;
var _flattenKeys = function flattenKeys(obj) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return !isObject_1(obj) ? {
        [path.join('.')]: obj
    } : reduce_1(obj, (cum, next, key)=>merge_1(cum, _flattenKeys(next, [
            ...path,
            key
        ])), {});
};
class distinct extends Validator {
    check(value) {
        var attribute = this.element$.path;
        var attributeName = attribute.replace(/\d+(?!\d+)/, '*');
        var rootVariable = attribute.match(/^[\w-]+/)[0];
        var attributeData = {
            [rootVariable]: this.form$.data[rootVariable]
        };
        var pattern = pregQuote(attributeName, '#').replace('\\*', '[^.]+');
        var data = {};
        each(_flattenKeys(attributeData), (v, k)=>{
            if (k != attribute && k.match('^' + pattern + '$') !== null) data[k] = v;
        });
        return !(values_1(data).indexOf(value) !== -1);
    }
}
class email extends Validator {
    check(value) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(value).toLowerCase());
    }
}
class exists extends Validator {
    get isAsync() {
        return true;
    }
    get requestParams() {
        var params = {};
        each(this.attributes, (param, key)=>{
            var requestParam = key;
            if (!isNaN(key)) requestParam = param;
            if (requestParam == 'debounce') return;
            var el = this.form$.el$(requestParam);
            // set the element value or the param name itself
            params[keys_1(params).length] = el && key != 0 ? el.value : requestParam;
        });
        return params;
    }
    check(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            var name = _this.element$.name;
            var endpoint = _this.form$.$vueform.config.endpoints.exists;
            var method = typeof endpoint !== 'function' ? endpoint.method : null;
            var res;
            if (typeof endpoint === 'function') res = yield endpoint(value, name, _this.requestParams, _this.element$, _this.form$);
            else {
                res = yield _this.form$.$vueform.services.axios.request({
                    url: endpoint.url,
                    method: method,
                    [method.toLowerCase() === 'get' ? 'params' : 'data']: {
                        params: _this.requestParams,
                        [name]: value,
                        vueformFieldName: name,
                        value: value,
                        name: name
                    }
                });
                res = res.data;
            }
            return res;
        })();
    }
}
class file$5 extends Validator {
    check(value) {
        return (!value || value instanceof File) && this.isFile;
    }
}
class filled extends Validator {
    check(value) {
        return this.filled(value);
    }
}
class gt extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            value: this.other$.value != null ? this.size(this.other$.value) : 0
        };
    }
    get otherPath() {
        return this.attributes[0];
    }
    get other$() {
        return this.form$.el$(replaceWildcards(this.otherPath, this.element$.path));
    }
    init() {
        this.watchOther();
    }
    check(value) {
        var otherValue = this.other$.value;
        return this.compare(value, otherValue);
    }
    compare(value, otherValue) {
        var otherSize = this.size(otherValue);
        return otherSize == 0 || this.size(value) > otherSize;
    }
}
class gte extends gt {
    compare(value, otherValue) {
        var otherSize = this.size(otherValue);
        return otherSize == 0 || this.size(value) >= otherSize;
    }
}
class image extends Validator {
    check(value) {
        if (this.isFile && !value) return true;
        if (!this.isFile || !(value instanceof File) || !value.name) return false;
        var extension = value.name.split('.').pop();
        return [
            'jpg',
            'jpeg',
            'png',
            'gif',
            'bmp',
            'svg',
            'webp'
        ].indexOf(extension) !== -1;
    }
}
class in_ extends Validator {
    check(value) {
        return values_1(this.attributes).indexOf(normalize(String(value).trim())) !== -1;
    }
}
class in_array extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            other: this.other$.genericName
        };
    }
    get other$() {
        return this.form$.el$(replaceWildcards(this.otherPath, this.element$.path));
    }
    get otherPath() {
        var matches = this.attributes[0].match(/.*(?=\.\*)/);
        if (matches === null) throw new Error('in_array rule\'s other attribute should end with .*');
        return matches[0];
    }
    init() {
        this.watchOther();
    }
    check(value) {
        var data = this.other$.value;
        if (!data) return false;
        return data.indexOf(value) !== -1;
    }
}
class integer extends Validator {
    check(value) {
        var normalized = normalize(String(value).trim());
        return normalized === parseInt(normalized, 10);
    }
}
var checker$1 = function checker(value) {
    var re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;
    return re.test(value);
};
class ipv4 extends Validator {
    check(value) {
        return checker$1(value);
    }
}
var checker = function checker(value) {
    var re = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*(\/(\d|\d\d|1[0-1]\d|12[0-8]))?$/;
    return re.test(value);
};
class ipv6 extends Validator {
    check(value) {
        return checker(value);
    }
}
class ip extends Validator {
    check(value) {
        return checker$1(value) || checker(value);
    }
}
function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
class json extends Validator {
    check(value) {
        return isJson(value);
    }
}
class lt extends gt {
    compare(value, otherValue) {
        var size = this.size(value);
        var otherSize = this.size(otherValue);
        return otherSize == 0 && size == 0 || this.size(value) < otherSize;
    }
}
class lte extends gt {
    compare(value, otherValue) {
        var size = this.size(value);
        var otherSize = this.size(otherValue);
        return otherSize == 0 && size == 0 || this.size(value) <= otherSize;
    }
}
class max extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            max: this.max
        };
    }
    get max() {
        return this.attributes[0];
    }
    check(value) {
        if (typeof value !== 'number' && !value) return true;
        return this.size(value) <= this.max;
    }
}
class mimes extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            values: this.accepted.join(', ')
        };
    }
    get accepted() {
        return Object.values(this.attributes).map((a)=>a.toLowerCase());
    }
    check(value) {
        if (this.isFile && !value) return true;
        if (!this.isFile || !(value instanceof File) || !value.name) return false;
        var extension = value.name.split('.').pop();
        return this.accepted.indexOf(extension.toLowerCase()) !== -1;
    }
}
class mimetypes extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            values: this.accepted.join(', ')
        };
    }
    get accepted() {
        return Object.values(this.attributes).map((a)=>a.toLowerCase());
    }
    check(value) {
        if (this.isFile && !value) return true;
        if (!this.isFile || !(value instanceof File) || !value.type) return false;
        return this.accepted.indexOf(value.type.toLowerCase()) !== -1;
    }
}
class min$1 extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            min: this.min
        };
    }
    get min() {
        return this.attributes[0];
    }
    check(value) {
        if (typeof value !== 'number' && !value) return true;
        return this.size(value) >= this.min;
    }
}
class not_in extends Validator {
    check(value) {
        return values_1(this.attributes).indexOf(value) === -1;
    }
}
class not_regex extends Validator {
    check(value) {
        var regex = new RegExp(this.attributes[0].replace(/^\/|\/[^\/]*$/g, ''));
        return !regex.test(value);
    }
}
class nullable extends Validator {
    check(value) {
        return true;
    }
}
class numeric extends Validator {
    check(value) {
        return !isNaN(parseFloat(value)) && isFinite(value) && !/\s/.test(String(value)) && !Boolean(String(value).match(/^0x[0-9a-f]+$/i));
    }
}
class regex extends Validator {
    check(value) {
        var regex = new RegExp(this.attributes[0].replace(/^\/|\/[^\/]*$/g, ''));
        return regex.test(value);
    }
}
class required extends Validator {
    check(value) {
        return this.filled(value);
    }
}
class same extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            other: this.other$.genericName
        };
    }
    get otherPath() {
        return this.attributes[0];
    }
    get other$() {
        return this.form$.el$(replaceWildcards(this.otherPath, this.element$.path));
    }
    init() {
        this.watchOther();
    }
    check(value) {
        if (!this.filled(value) && !this.filled(this.other$.value)) return true;
        return value == this.other$.value;
    }
}
class size extends Validator {
    get messageParams() {
        return {
            attribute: this.attributeName,
            size: this.size_
        };
    }
    get size_() {
        return this.attributes[0];
    }
    check(value) {
        if (typeof value !== 'number' && !value) return true;
        return this.size(value) == this.size_;
    }
}
class string extends Validator {
    check(value) {
        return isString_1(value);
    }
}
class timezone extends Validator {
    check(value) {
        try {
            Intl.DateTimeFormat(undefined, {
                timeZone: value
            });
            return true;
        } catch (ex) {
            return false;
        }
    }
}
class unique extends Validator {
    get isAsync() {
        return true;
    }
    get requestParams() {
        var params = {};
        each(this.attributes, (param, key)=>{
            var requestParam = key;
            if (!isNaN(key)) requestParam = param;
            if (requestParam == 'debounce') return;
            var el = this.form$.el$(requestParam);
            // set the element value or the param name itself
            params[keys_1(params).length] = el && key != 0 ? el.value : requestParam;
        });
        return params;
    }
    check(value) {
        var _this = this;
        return _asyncToGenerator(function*() {
            var name = _this.element$.name;
            var endpoint = _this.form$.$vueform.config.endpoints.unique;
            var method = typeof endpoint !== 'function' ? endpoint.method : null;
            var res;
            if (typeof endpoint === 'function') res = yield endpoint(value, name, _this.requestParams, _this.element$, _this.form$);
            else {
                res = yield _this.form$.$vueform.services.axios.request({
                    url: endpoint.url,
                    method: method,
                    [method.toLowerCase() === 'get' ? 'params' : 'data']: {
                        params: _this.requestParams,
                        name: name,
                        value: value
                    }
                });
                res = res.data;
            }
            return res;
        })();
    }
}
class url extends Validator {
    check(value) {
        // https://gist.github.com/dperini/729294
        var regex = new RegExp("^(?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+(?:[a-z\\u00a1-\\uffff]{2,}\\.?))(?::\\d{2,5})?(?:[/?#]\\S*)?$", "i");
        return regex.test(value);
    }
}
class uuid extends Validator {
    check(value) {
        var regex = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i;
        return regex.test(value);
    }
}
var index$2 = {
    accepted: accepted,
    active_url: active_url,
    after: after,
    after_or_equal: after_or_equal,
    alpha: alpha,
    alpha_dash: alpha_dash,
    alpha_num: alpha_num,
    array: array$2,
    before: before,
    before_or_equal: before_or_equal,
    between: between,
    boolean: boolean$1,
    confirmed: confirmed,
    date: date$4,
    date_equals: date_equals,
    date_format: date_format,
    different: different,
    digits: digits,
    digits_between: digits_between,
    dimensions: dimensions,
    distinct: distinct,
    email: email,
    exists: exists,
    file: file$5,
    filled: filled,
    gt: gt,
    gte: gte,
    image: image,
    in: in_,
    in_array: in_array,
    integer: integer,
    ip: ip,
    ipv4: ipv4,
    ipv6: ipv6,
    json: json,
    lt: lt,
    lte: lte,
    max: max,
    mimes: mimes,
    mimetypes: mimetypes,
    min: min$1,
    not_in: not_in,
    not_regex: not_regex,
    nullable: nullable,
    numeric: numeric,
    regex: regex,
    required: required,
    same: same,
    size: size,
    string: string,
    timezone: timezone,
    unique: unique,
    url: url,
    uuid: uuid
};
var rules = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    accepted: accepted,
    active_url: active_url,
    after: after,
    after_or_equal: after_or_equal,
    alpha: alpha,
    alpha_dash: alpha_dash,
    alpha_num: alpha_num,
    array: array$2,
    before: before,
    before_or_equal: before_or_equal,
    between: between,
    boolean: boolean$1,
    captcha: captcha$2,
    completed: completed,
    confirmed: confirmed,
    date: date$4,
    date_equals: date_equals,
    date_format: date_format,
    different: different,
    digits: digits,
    digits_between: digits_between,
    dimensions: dimensions,
    distinct: distinct,
    email: email,
    exists: exists,
    file: file$5,
    filled: filled,
    gt: gt,
    gte: gte,
    image: image,
    in_: in_,
    in_array: in_array,
    integer: integer,
    ip: ip,
    ipv4: ipv4,
    ipv6: ipv6,
    json: json,
    lt: lt,
    lte: lte,
    max: max,
    mimes: mimes,
    mimetypes: mimetypes,
    min: min$1,
    not_in: not_in,
    not_regex: not_regex,
    nullable: nullable,
    numeric: numeric,
    regex: regex,
    required: required,
    same: same,
    size: size,
    string: string,
    timezone: timezone,
    unique: unique,
    url: url,
    uuid: uuid,
    'default': index$2
});
var validation = {
    factory: Factory,
    rules: {}
};
var arrayPush = _arrayPush, baseFlatten$1 = _baseFlatten, copyArray = _copyArray, isArray$1 = isArray_1;
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return arrayPush(isArray$1(array) ? copyArray(array) : [
        array
    ], baseFlatten$1(args, 1));
}
var concat_1 = concat;
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function head(array) {
    return array && array.length ? array[0] : undefined;
}
var head_1 = head;
class messageBag {
    constructor(baseErrors){
        this.baseErrors = baseErrors;
        this.prepends = {
            errors: [],
            messages: []
        };
        this.appends = {
            errors: [],
            messages: []
        };
    }
    get errors() {
        return concat_1(this.prepends.errors, this.baseErrors, this.appends.errors);
    }
    get messages() {
        return concat_1(this.prepends.messages, this.appends.messages);
    }
    /**
   * The first error
   * 
   * @type {string}
   */ get error() {
        return head_1(this.errors);
    }
    /**
   * The first message
   * 
   * @type {string}
   */ get message() {
        return head_1(this.messages);
    }
    prepend(msg, type) {
        if (type === undefined) type = 'error';
        this.prepends[type == 'error' ? 'errors' : 'messages'].unshift(msg);
    }
    append(msg, type) {
        if (type === undefined) type = 'error';
        this.appends[type == 'error' ? 'errors' : 'messages'].push(msg);
    }
    remove(msg, type) {
        if (type === undefined) type = 'any';
        if ([
            'any',
            'error'
        ].indexOf(type) !== -1) {
            each(this.prepends.errors, (error, index)=>{
                if (error == msg) this.rm('prepends', 'errors', index);
            });
            each(this.appends.errors, (error, index)=>{
                if (error == msg) this.rm('appends', 'errors', index);
            });
        }
        if ([
            'any',
            'message'
        ].indexOf(type) !== -1) {
            each(this.prepends.messages, (error, index)=>{
                if (error == msg) this.rm('prepends', 'messages', index);
            });
            each(this.appends.messages, (error, index)=>{
                if (error == msg) this.rm('appends', 'messages', index);
            });
        }
    }
    rm(group, type, index) {
        this[group][type].splice(index, 1);
    }
    clear(type) {
        if (type === undefined) type = 'all';
        if (type == 'all') {
            this.prepends = {
                errors: [],
                messages: []
            };
            this.appends = {
                errors: [],
                messages: []
            };
        } else {
            this.prepends[type] = [];
            this.appends[type] = [];
        }
    }
    clearPrepended(type) {
        if (type === undefined) type = 'all';
        if (type == 'all') this.prepends = {
            errors: [],
            messages: []
        };
        else this.prepends[type] = [];
    }
    clearAppended(type) {
        if (type === undefined) type = 'all';
        if (type == 'all') this.appends = {
            errors: [],
            messages: []
        };
        else this.appends[type] = [];
    }
}
var e = new Map;
function t(t) {
    var o = e.get(t);
    o && o.destroy();
}
function o(t) {
    var o = e.get(t);
    o && o.update();
}
var r = null;
"undefined" == typeof window ? ((r = function(e) {
    return e;
}).destroy = function(e) {
    return e;
}, r.update = function(e) {
    return e;
}) : ((r = function(t, o) {
    return t && Array.prototype.forEach.call(t.length ? t : [
        t
    ], function(t) {
        return function(t) {
            if (t && t.nodeName && "TEXTAREA" === t.nodeName && !e.has(t)) {
                var o, r = null, n = window.getComputedStyle(t), i = (o = t.value, function() {
                    a({
                        testForHeightReduction: "" === o || !t.value.startsWith(o),
                        restoreTextAlign: null
                    }), o = t.value;
                }), l = (function(o) {
                    t.removeEventListener("autosize:destroy", l), t.removeEventListener("autosize:update", s), t.removeEventListener("input", i), window.removeEventListener("resize", s), Object.keys(o).forEach(function(e) {
                        return t.style[e] = o[e];
                    }), e.delete(t);
                }).bind(t, {
                    height: t.style.height,
                    resize: t.style.resize,
                    textAlign: t.style.textAlign,
                    overflowY: t.style.overflowY,
                    overflowX: t.style.overflowX,
                    wordWrap: t.style.wordWrap
                });
                t.addEventListener("autosize:destroy", l), t.addEventListener("autosize:update", s), t.addEventListener("input", i), window.addEventListener("resize", s), t.style.overflowX = "hidden", t.style.wordWrap = "break-word", e.set(t, {
                    destroy: l,
                    update: s
                }), s();
            }
            function a(e) {
                var o, i, l = e.restoreTextAlign, s = void 0 === l ? null : l, d = e.testForHeightReduction, u = void 0 === d || d, c = n.overflowY;
                if (0 !== t.scrollHeight && ("vertical" === n.resize ? t.style.resize = "none" : "both" === n.resize && (t.style.resize = "horizontal"), u && (o = function(e) {
                    for(var t = []; e && e.parentNode && e.parentNode instanceof Element;)e.parentNode.scrollTop && t.push([
                        e.parentNode,
                        e.parentNode.scrollTop
                    ]), e = e.parentNode;
                    return function() {
                        return t.forEach(function(e) {
                            var t = e[0], o = e[1];
                            t.style.scrollBehavior = "auto", t.scrollTop = o, t.style.scrollBehavior = null;
                        });
                    };
                }(t), t.style.height = ""), i = "content-box" === n.boxSizing ? t.scrollHeight - (parseFloat(n.paddingTop) + parseFloat(n.paddingBottom)) : t.scrollHeight + parseFloat(n.borderTopWidth) + parseFloat(n.borderBottomWidth), "none" !== n.maxHeight && i > parseFloat(n.maxHeight) ? ("hidden" === n.overflowY && (t.style.overflow = "scroll"), i = parseFloat(n.maxHeight)) : "hidden" !== n.overflowY && (t.style.overflow = "hidden"), t.style.height = i + "px", s && (t.style.textAlign = s), o && o(), r !== i && (t.dispatchEvent(new Event("autosize:resized", {
                    bubbles: !0
                })), r = i), c !== n.overflow && !s)) {
                    var v = n.textAlign;
                    "hidden" === n.overflow && (t.style.textAlign = "start" === v ? "end" : "start"), a({
                        restoreTextAlign: v,
                        testForHeightReduction: !0
                    });
                }
            }
            function s() {
                a({
                    testForHeightReduction: !0,
                    restoreTextAlign: null
                });
            }
        }(t);
    }), t;
}).destroy = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], t), e;
}, r.update = function(e) {
    return e && Array.prototype.forEach.call(e.length ? e : [
        e
    ], o), e;
});
var n = r;
class google {
    constructor(){
        this.autocomplete = null;
        this.autocompleteListener = null;
        this.options = {};
    }
    init(container, onChange, options) {
        window.google === undefined || window.google.maps === undefined || window.google.maps.places === undefined || window.google.maps.places.Autocomplete;
        this.options = options;
        this.autocomplete = new window.google.maps.places.Autocomplete(container, options);
        this.autocompleteListener = this.autocomplete.addListener('place_changed', ()=>{
            var place = this.autocomplete.getPlace();
            onChange(this.formatValue(place), place);
        });
    }
    destroy() {
        window.google.maps.event.removeListener(this.autocompleteListener);
        window.google.maps.event.clearInstanceListeners(this.autocomplete);
        var pac = document.querySelector('.pac-container');
        if (pac) pac.remove();
    }
    formatValue(value) {
        if (!isPlainObject_1(value)) return value;
        var addressComponents = value.address_components;
        var street = this.addressComponent(addressComponents, 'street');
        var streetNumber = this.addressComponent(addressComponents, 'street_number');
        var address = null;
        if (street !== null) address = street;
        if (streetNumber !== null) address += (street !== null ? ' ' : '') + streetNumber;
        return {
            country: this.addressComponent(addressComponents, 'country'),
            country_code: this.addressComponent(addressComponents, 'country_code'),
            state: this.addressComponent(addressComponents, 'state'),
            state_code: this.addressComponent(addressComponents, 'state_code'),
            city: this.addressComponent(addressComponents, 'city'),
            zip: this.addressComponent(addressComponents, 'zip'),
            address: address,
            formatted_address: value.formatted_address || null,
            lat: value.geometry.location.lat() || null,
            lng: value.geometry.location.lng() || null
        };
    }
    addressComponent(addressComponents, type) {
        var typeMap = {
            country: {
                field: 'country',
                type: 'long_name'
            },
            country_code: {
                field: 'country',
                type: 'short_name'
            },
            state: {
                field: 'administrative_area_level_1',
                type: 'long_name'
            },
            state_code: {
                field: 'administrative_area_level_1',
                type: 'short_name'
            },
            city: {
                field: 'locality',
                type: 'long_name'
            },
            zip: {
                field: 'postal_code',
                type: 'long_name'
            },
            street: {
                field: 'route',
                type: 'long_name'
            },
            street_number: {
                field: 'street_number',
                type: 'long_name'
            }
        };
        var addressComponent = null;
        each(addressComponents, (component)=>{
            if (component.types.indexOf(typeMap[type].field) !== -1) {
                if ([
                    'state',
                    'state_code'
                ].indexOf(type) !== -1 && this.addressComponent(addressComponents, 'country_code') != 'US') return;
                addressComponent = component[typeMap[type].type] || null;
            }
        });
        return addressComponent;
    }
}
class algolia {
    constructor(){
        this.places = null;
        this.options = {};
    }
    init(container, onChange, options) {
        if (window.places === undefined) throw new Error('Algolia Places API missing. Please include script in your project from https://community.algolia.com/places/documentation.html#cdn-script or install via npm and set to `window.places`.');
        this.options = options;
        this.places = window.places(Object.assign({}, {
            container: container
        }, options));
        this.places.on('change', (e)=>{
            onChange(this.formatValue(e.suggestion), e.suggestion);
        });
    }
    destroy() {
        this.places.destroy();
    }
    formatValue(value) {
        if (!isPlainObject_1(value)) return value;
        return {
            country: value.country,
            country_code: value.countryCode ? value.countryCode.toUpperCase() : null,
            state: value.countryCode == 'us' ? value.administrative : null,
            state_code: value.countryCode == 'us' ? this.stateCode(value.administrative.toLowerCase()) : null,
            city: value.city,
            zip: value.postcode,
            address: value.name,
            formatted_address: value.value,
            lat: value.latlng.lat,
            lng: value.latlng.lng
        };
    }
    stateCode(name) {
        var states = {
            AL: 'alabama',
            AK: 'alaska',
            AZ: 'arizona',
            AR: 'arkansas',
            CA: 'california',
            CO: 'colorado',
            CT: 'connecticut',
            DE: 'delaware',
            DC: 'district of columbia',
            FL: 'florida',
            GA: 'georgia',
            HI: 'hawaii',
            ID: 'idaho',
            IL: 'illinois',
            IN: 'indiana',
            IA: 'iowa',
            KS: 'kansas',
            KY: 'kentucky',
            LA: 'louisiana',
            ME: 'maine',
            MD: 'maryland',
            MA: 'massachusetts',
            MI: 'michigan',
            MN: 'minnesota',
            MS: 'mississippi',
            MO: 'missouri',
            MT: 'montana',
            NE: 'nebraska',
            NV: 'nevada',
            NH: 'new hampshire',
            NJ: 'new Jersey',
            NM: 'new Mexico',
            NY: 'new york',
            NC: 'north carolina',
            ND: 'north dakota',
            OH: 'ohio',
            OK: 'oklahoma',
            OR: 'oregon',
            PA: 'pennsylvania',
            RI: 'rhode Island',
            SC: 'south carolina',
            SD: 'south dakota',
            TN: 'tennessee',
            TX: 'texas',
            UT: 'utah',
            VT: 'vermont',
            VA: 'virginia',
            WA: 'washington',
            WV: 'west virginia',
            WI: 'wisconsin',
            WY: 'wyoming'
        };
        if (values_1(states).indexOf(name) === -1) return null;
        return keys_1(states)[values_1(states).indexOf(name)];
    }
}
var location$4 = {
    google: google,
    algolia: algolia
};
// condition - condition information [otherPath, operator, expectedValue]
// elementPath - current
var check = (condition, elementPath, form$, el$1)=>{
    var checkFunction = ()=>{
        return condition(form$, el$1);
    };
    var checkArray = (condition)=>{
        var { conditionPath, operator, expected } = details(condition);
        // other
        var element$ = form$.el$(conditionPath);
        var hasCircularCondition = false;
        // other && currentPath
        if (element$ && elementPath) each(element$.conditions, (condition)=>{
            if (!Array.isArray(condition)) return;
            if (condition[0] == elementPath) hasCircularCondition = true;
        });
        if (!element$ || !hasCircularCondition && !element$.available) return false;
        return compareValues(element$.value, expected, operator);
    };
    var details = (condition)=>{
        return {
            conditionPath: elementPath ? replaceWildcards(condition[0], elementPath) : condition[0],
            operator: condition.length == 3 || [
                'empty',
                'not_empty',
                'today'
            ].indexOf(condition[1]) !== -1 ? condition[1] : '==',
            expected: condition.length == 3 ? condition[2] : [
                'empty',
                'not_empty',
                'today'
            ].indexOf(condition[1]) === -1 ? condition[1] : true
        };
    };
    var compareValues = (actual, expected, operator)=>{
        return compare(actual, operator, expected, el$1, form$);
    };
    if (typeof condition == 'function') return checkFunction();
    else if (isArray_1(condition) && isArray_1(condition[0])) return condition.reduce((prev, curr)=>{
        if (prev) return prev;
        if (isArray_1(curr[0])) return curr.reduce((p, c)=>!p ? p : checkArray(c), true);
        return checkArray(curr);
    }, false);
    else if (isArray_1(condition)) return checkArray(condition);
    throw new Error('Condition must be a function or an array');
};
var condition = {
    check: check
};
class i18n {
    constructor(options){
        this.locales = options.locales;
        this.locale = options.locale;
        this.fallbackLocale = options.fallbackLocale;
    }
    $t(expr) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var tag = get_1(this.locales[this.locale], expr) || expr;
        if (tag === expr) tag = get_1(this.locales[this.fallbackLocale], expr) || expr;
        each(data, (value, key)=>{
            tag = tag.replace(':' + key, value);
        });
        each(data, (value, key)=>{
            tag = tag.replace('{' + key + '}', value);
        });
        return tag;
    }
}
class Columns {
    constructor(options, hasLabel, getClass, presets){
        _defineProperty$2(this, "defaultBreakpoint", 'default');
        this.presets = presets;
        this.configPresetColumns = this.serialize(this.columnsFromPresets(options.configPresetColumns) || {});
        this.configColumns = this.serialize(options.configColumns || {});
        this.formPresetColumns = this.serialize(this.columnsFromPresets(options.formPresetColumns) || {});
        this.formColumns = this.serialize(options.formColumns || {});
        this.presetColumns = this.serialize(this.columnsFromPresets(options.elementPresetColumns) || {});
        this.columns = this.serialize(options.elementColumns || {});
        this.hasLabel = hasLabel;
        this.getClass = getClass;
        this.cols = this.getCols();
    }
    get classes() {
        return {
            container: this.getClasses('container'),
            label: this.getClasses('label'),
            innerContainer: this.getClasses('innerContainer'),
            wrapper: this.getClasses('wrapper')
        };
    }
    serialize(columns) {
        // columns: 8
        if ([
            'number',
            'string'
        ].indexOf(typeof columns) !== -1) return {
            [this.defaultBreakpoint]: {
                container: columns
            }
        };
        // columns: { container: 8, wrapper: { default: 8, lg: 8 } }
        if (typeof columns === 'object' && [
            'container',
            'label',
            'wrapper'
        ].indexOf(Object.keys(columns)[0]) !== -1) {
            var serialized = {};
            each(columns, (size, type)=>{
                // columns: { container: 8 }
                if ([
                    'number',
                    'string'
                ].indexOf(typeof size) !== -1) {
                    if (serialized[this.defaultBreakpoint] === undefined) serialized[this.defaultBreakpoint] = {};
                    serialized[this.defaultBreakpoint][type] = size;
                } else each(size, (s, breakpoint)=>{
                    if (serialized[breakpoint] === undefined) serialized[breakpoint] = {};
                    serialized[breakpoint][type] = s;
                });
            });
            return serialized;
        } else {
            var _serialized = {};
            each(columns, (size, breakpoint)=>{
                // columns: { lg: 8 }
                if ([
                    'number',
                    'string'
                ].indexOf(typeof size) !== -1) {
                    if (_serialized[breakpoint] === undefined) _serialized[breakpoint] = {};
                    _serialized[breakpoint].container = size;
                } else _serialized[breakpoint] = size;
            });
            return _serialized;
        }
    }
    columnsFromPresets(presets) {
        var columns;
        each(presets, (presetName)=>{
            var preset = this.presets[presetName];
            if (!preset || !preset.columns) return;
            columns = preset.columns;
        });
        return columns;
    }
    getNullClass() {
        return [
            this.getClass(this.defaultBreakpoint, 0)
        ];
    }
    getClasses(type) {
        var classes = [];
        Object.keys(this.cols).forEach((breakpoint)=>{
            var size;
            if (type === 'innerContainer') {
                size = this.cols[breakpoint].label;
                size = size >= 12 || !this.hasLabel ? 12 : 12 - size;
            } else {
                size = this.cols[breakpoint][type];
                if (type === 'label' && !this.hasLabel) size = 0;
            // if (type === 'wrapper' && !this.hasLabel) {
            //   size += this.cols[breakpoint].label || 0
            //   if (size > 12) {
            //     size = 12
            //   }
            // }
            }
            if (size !== undefined && !isNaN(size)) classes.push(this.getClass(breakpoint, size));
        });
        return classes;
    }
    getCols() {
        return merge_1({}, {
            [this.defaultBreakpoint]: {
                container: 12,
                label: 12,
                wrapper: 12
            }
        }, this.configPresetColumns || {}, this.configColumns || {}, this.formPresetColumns || {}, this.formColumns || {}, this.presetColumns || {}, this.columns || {});
    }
}
class CaptchaProviderInterface {
    constructor(element, options, el$1){}
    init() {}
    render() {}
    reset() {}
    getResponse() {}
    validate(response) {
        return _asyncToGenerator(function*() {})();
    }
}
class Recaptcha2Provider extends CaptchaProviderInterface {
    constructor(element, options, el$1){
        super(element, options, el$1);
        _defineProperty$2(this, "src", 'https://www.google.com/recaptcha/api.js?onload=recaptcha2LoadCallback&render=explicit');
        _defineProperty$2(this, "element", void 0);
        _defineProperty$2(this, "options", {});
        _defineProperty$2(this, "el$", {});
        _defineProperty$2(this, "id", void 0);
        _defineProperty$2(this, "rendered", false);
        _defineProperty$2(this, "interval", void 0);
        this.element = element;
        this.options = options;
        this.el$ = el$1;
        this.init();
    }
    init() {
        this.loadScript();
    }
    render() {
        this.id = window.grecaptcha.render(this.element, _objectSpread2$1({
            callback: (token)=>{
                this.el$.update(token);
            },
            'expired-callback': ()=>{
                this.el$.clear();
            },
            'error-callback': ()=>{
                this.el$.clear();
            }
        }, this.options));
        this.rendered = true;
    }
    reset() {
        if (!this.rendered) return;
        return window.grecaptcha.reset(this.id);
    }
    getResponse() {
        return window.grecaptcha.getResponse(this.id);
    }
    validate(response) {
        return _asyncToGenerator(function*() {
            return !!response;
        })();
    }
    loadScript() {
        if (this.isCaptchaLoaded()) {
            this.render();
            return;
        }
        if (this.isScriptAdded()) {
            this.interval = setInterval(()=>{
                if (this.isCaptchaLoaded()) {
                    this.render();
                    clearInterval(this.interval);
                }
            }, 500);
            return;
        }
        window.recaptcha2LoadCallback = ()=>{
            this.render();
        };
        var script = document.createElement('script');
        script.src = this.src;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
        script.onload = ()=>{};
        script.onerror = ()=>{
            console.error('Error loading reCAPTCHA!');
        };
    }
    isCaptchaLoaded() {
        return typeof window !== 'undefined' && window.grecaptcha;
    }
    isScriptAdded() {
        var scripts = document.getElementsByTagName('script');
        for(var i = 0; i < scripts.length; i++){
            if (scripts[i].src.includes('https://www.google.com/recaptcha/api.js')) return true;
        }
        return false;
    }
}
var config = {
    /**
   * General
   */ env: 'development',
    plugins: [],
    elements: [],
    /**
   * Theme & layout
   */ theme: {},
    templates: {},
    views: {},
    size: 'md',
    addClasses: {},
    removeClasses: {},
    replaceClasses: {},
    overrideClasses: {},
    presets: {},
    usePresets: [],
    classHelpers: false,
    columns: {},
    forceLabels: false,
    floatPlaceholders: true,
    displayErrors: true,
    displayMessages: true,
    breakpoints: [
        'sm',
        'md',
        'lg',
        'xl',
        '2xl'
    ],
    /**
   * Localization
   */ languages: {
        en: 'English'
    },
    language: 'en',
    locales: {},
    locale: null,
    fallbackLocale: 'en',
    /**
   * Sorting
   */ orderFrom: 1,
    /**
   * Validation
   */ rules: {},
    validateOn: 'change|step',
    scrollToInvalid: true,
    showRequired: [],
    /**
   * Steps
   */ scrollOnNext: true,
    /**
   * Data
   */ forceNumbers: false,
    /**
   * Condition
   */ operators: {},
    strictConditions: false,
    /**
   * Submitting
   */ endpoints: {
        submit: {
            url: '/vueform/process',
            method: 'post'
        },
        uploadTempFile: {
            url: '/vueform/file/upload-temp',
            method: 'post'
        },
        removeTempFile: {
            url: '/vueform/file/remove-temp',
            method: 'post'
        },
        removeFile: {
            url: '/vueform/file/remove',
            method: 'post'
        },
        attachment: {
            url: '/vueform/editor/attachment',
            method: 'post'
        },
        activeUrl: {
            url: '/vueform/validators/active_url',
            method: 'post'
        },
        unique: {
            url: '/vueform/validators/unique',
            method: 'post'
        },
        exists: {
            url: '/vueform/validators/exists',
            method: 'post'
        }
    },
    formData (form$) {
        return form$.convertFormData(_objectSpread2$1(_objectSpread2$1({}, form$.requestData), form$.formKey ? {
            formKey: form$.formKey
        } : {}));
    },
    beforeSend: null,
    axios: {},
    /**
   * Providers
   */ locationProvider: 'google',
    providers: {
        captcha: {
            recaptcha2: Recaptcha2Provider
        }
    },
    useProviders: {
        captcha: 'recaptcha2'
    },
    providerOptions: {
        recaptcha2: {
            sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
        }
    },
    /**
   * Services
   */ services: {
        algolia: {
            app_id: '',
            api_key: ''
        }
    }
};
function installer() {
    var config$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config;
    var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var services = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var Vueform = class {
        constructor(){
            this.options = {
                config: omit_1(config$1, [
                    'theme',
                    'templates',
                    'locales',
                    'rules',
                    'plugins'
                ]),
                templates: config$1.templates || {},
                components: config$1.components || {},
                theme: config$1.theme || {},
                rules: _objectSpread2$1(_objectSpread2$1({}, rules), config$1.rules || {}),
                locales: config$1.locales || {},
                plugins: config$1.plugins || [],
                i18n: null,
                vueVersion: null,
                services: _objectSpread2$1({
                    validation: validation,
                    axios: $81tj9.default,
                    messageBag: messageBag,
                    autosize: n,
                    location: location$4,
                    condition: condition,
                    columns: Columns
                }, services),
                version: packageJson.version
            };
        }
        config(config) {
            var _config$theme;
            // merge
            each([
                'theme',
                'templates',
                'locales',
                'rules'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options[attr] = Object.assign({}, this.options[attr], config[attr]);
            });
            // replace
            each([
                'plugins',
                'components'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options[attr] = config[attr];
            });
            // merge (config)
            each([
                'languages',
                'services',
                'presets',
                'views',
                'operators'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options.config[attr] = Object.assign({}, this.options.config[attr], config[attr]);
            });
            each([
                'addClasses',
                'removeClasses',
                'replaceClasses',
                'overrideClasses'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options.config[attr] = typeof config[attr] === 'function' ? config[attr] : Object.assign({}, this.options.config[attr], config[attr]);
            });
            // deep merge
            each([
                'endpoints',
                'providers',
                'useProviders',
                'providerOptions'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options.config[attr] = merge_1({}, this.options.config[attr], config[attr]);
            });
            // replace
            each([
                'columns',
                'forceLabels',
                'displayErrors',
                'floatPlaceholders',
                'displayErrors',
                'displayMessages',
                'language',
                'locale',
                'fallbackLocale',
                'orderFrom',
                'validateOn',
                'formData',
                'beforeSend',
                'locationProvider',
                'classHelpers',
                'env',
                'usePresets',
                'plugins',
                'size',
                'apiKey',
                'forceNumbers',
                'scrollToInvalid',
                'showRequired',
                'scrollOnNext',
                'strictConditions'
            ], (attr)=>{
                if (config[attr] !== undefined) this.options.config[attr] = config[attr];
            });
            this.options.config.presets = _objectSpread2$1(_objectSpread2$1({}, this.options.config.presets || {}), ((_config$theme = config.theme) === null || _config$theme === void 0 ? void 0 : _config$theme.presets) || {});
            if (config.elements) {
                config.elements.forEach((element)=>{
                    components[element.name] = omit_1(element, [
                        'render',
                        'staticRenderFns',
                        'components'
                    ]);
                });
                config.elements.forEach((element)=>{
                    if (this.options.templates[element.name] === undefined) this.options.templates[element.name] = pick_1(element, [
                        'render',
                        'staticRenderFns',
                        'components'
                    ]);
                });
            }
            if (config.axios !== undefined) {
                if (typeof config.axios === 'function') this.options.services.axios = config.axios;
                else this.options.config.axios = config.axios;
            }
        }
        registerComponents(appOrVue) {
            each(components, (comp, name)=>{
                if (comp.register === false) return;
                var component = _objectSpread2$1({}, comp);
                component.setup = (props, context)=>{
                    context = Object.assign({}, context, {
                        name: (0, $8bTPG.ref)(name),
                        emits: component.emits
                    });
                    var setup = comp.setup(props, context);
                    this.options.plugins.forEach((p)=>{
                        if (typeof p === 'function') p = p();
                        p = Array.isArray(p) ? p : [
                            p
                        ];
                        p.forEach((plugin)=>{
                            var pluginOptions = typeof plugin === 'function' ? plugin() : plugin;
                            if (pluginOptions.setup && shouldApplyPlugin(name, pluginOptions)) setup = pluginOptions.setup(props, context, setup);
                        });
                    });
                    return setup;
                };
                if (component.components === undefined) {
                    var _this$options$templat, _this$options$theme$t;
                    component.components = ((_this$options$templat = this.options.templates[name]) === null || _this$options$templat === void 0 ? void 0 : _this$options$templat.components) || ((_this$options$theme$t = this.options.theme.templates[name]) === null || _this$options$theme$t === void 0 ? void 0 : _this$options$theme$t.components) || {};
                }
                component.render = function() {
                    return this.template.render.apply(this, arguments);
                };
                component.staticRenderFns = function() {
                    return this.template.staticRenderFns;
                };
                this.options.plugins.forEach((p)=>{
                    if (typeof p === 'function') p = p();
                    p = Array.isArray(p) ? p : [
                        p
                    ];
                    p.forEach((plugin)=>{
                        var pluginOptions = typeof plugin === 'function' ? plugin() : plugin;
                        each(without_1(Object.keys(pluginOptions), 'setup', 'apply', 'config', 'install'), (key)=>{
                            if (pluginOptions[key] && shouldApplyPlugin(name, pluginOptions)) {
                                if (Array.isArray(pluginOptions[key])) {
                                    var base = component[key] || [];
                                    component[key] = base.concat(pluginOptions[key]);
                                } else if (isPlainObject_1(pluginOptions[key])) component[key] = Object.assign({}, component[key] || {}, pluginOptions[key]);
                                else component[key] = pluginOptions[key];
                            }
                        });
                    });
                });
                appOrVue.component(name, component);
            });
        }
        initAxios() {
            var $axios = this.options.services.axios;
            var axiosConfig = this.options.config.axios;
            var axiosConfigFlat = flatten(this.options.config.axios);
            Object.keys(axiosConfigFlat).forEach((key)=>{
                var value = axiosConfigFlat[key];
                if ([
                    'onUnauthenticated'
                ].indexOf(key) === -1 && key.indexOf('csrfRequest.') === -1) set_1($axios.defaults, key, value);
            });
            $axios.interceptors.response.use((r)=>r, (error)=>{
                if (!error.response) return Promise.reject(error);
                return new Promise((resolve, reject)=>{
                    var response = error.response;
                    var originalRequest = response.config;
                    if ([
                        401,
                        419
                    ].indexOf(error.response.status) !== -1) {
                        if (axiosConfig.csrfRequest && !originalRequest.CSRF) $axios.request(_objectSpread2$1(_objectSpread2$1({}, axiosConfig.csrfRequest), {}, {
                            CSRF: true
                        })).then(()=>{
                            resolve($axios.request(_objectSpread2$1(_objectSpread2$1({}, originalRequest), {}, {
                                CSRF: true
                            })));
                        }).catch((error)=>{
                            reject(error);
                        });
                        else if (axiosConfig.onUnauthenticated) axiosConfig.onUnauthenticated(originalRequest);
                        else reject(error);
                    } else reject(error);
                });
            });
        }
        initI18n() {
            this.options.i18n = new i18n({
                locales: this.options.locales,
                locale: this.options.config.locale,
                fallbackLocale: this.options.config.fallbackLocale
            });
        }
        install(appOrVue) {
            var _this$options$theme;
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var version = parseInt(appOrVue.version.split('.')[0]);
            var minor = parseInt(appOrVue.version.split('.')[1]);
            this.options.vueVersion = version;
            var plugins = options.plugins || [];
            plugins.forEach((p)=>{
                if (typeof p === 'function') p = p();
                p = Array.isArray(p) ? p : [
                    p
                ];
                p.forEach((plugin)=>{
                    var pluginOptions = typeof plugin === 'function' ? plugin() : plugin;
                    if (pluginOptions.config) pluginOptions.config(options);
                });
            });
            if (options) this.config(options);
            this.options.plugins.forEach((p)=>{
                if (typeof p === 'function') p = p();
                p = Array.isArray(p) ? p : [
                    p
                ];
                p.forEach((plugin)=>{
                    var pluginOptions = typeof plugin === 'function' ? plugin() : plugin;
                    if (pluginOptions.install) pluginOptions.install(appOrVue, this.options);
                });
            });
            if (typeof config$1.axios !== 'function') this.initAxios();
            this.initI18n();
            Object.keys(this.options.components).forEach((componentName)=>{
                components[componentName] = this.options.components[componentName];
            });
            this.registerComponents(appOrVue);
            var themeTemplates = ((_this$options$theme = this.options.theme) === null || _this$options$theme === void 0 ? void 0 : _this$options$theme.templates) || {};
            Object.keys(themeTemplates).forEach((componentName)=>{
                themeTemplates[componentName] = (0, $8bTPG.markRaw)(themeTemplates[componentName]);
            });
            var $vueform = (0, $8bTPG.ref)(_objectSpread2$1(_objectSpread2$1({}, this.options), {}, {
                theme: _objectSpread2$1(_objectSpread2$1({}, this.options.theme), {}, {
                    templates: themeTemplates
                })
            }));
            switch(version){
                case 2:
                    appOrVue.config.ignoredElements = [
                        'trix-editor'
                    ];
                    appOrVue.config.unwrapInjectedRef = true;
                    if (!appOrVue.prototype.$vueform) appOrVue.prototype.$vueform = new Proxy($vueform, {
                        get: (target, prop, receiver)=>{
                            return target.value[prop];
                        }
                    });
                    if (!appOrVue.__VUEFORM__) {
                        appOrVue.__VUEFORM__ = true;
                        appOrVue.mixin({
                            methods: {
                                __: (expr, data)=>{
                                    if (!data) console.warn('DEPRECATED: __ method should be no longer used for translating labels, only if they contain variables. For general translation use form$.translation.TAG instead.');
                                    return this.options.i18n.$t(expr, data);
                                }
                            }
                        });
                    }
                    break;
                case 3:
                    if (minor < 3) appOrVue.config.unwrapInjectedRef = true;
                    if (!appOrVue.component('trix-editor')) appOrVue.component('trix-editor', {
                        render () {
                            return (0, $ani5R.h)('trix-editor');
                        }
                    });
                    appOrVue.config.globalProperties.$vueform = new Proxy($vueform, {
                        get: (target, prop, receiver)=>{
                            return target.value[prop];
                        }
                    });
                    appOrVue.provide('$vueform', $vueform);
                    appOrVue.mixin({
                        methods: {
                            $set (obj, key, value) {
                                obj[key] = value;
                            },
                            $delete (obj, key) {
                                delete obj[key];
                            },
                            __: (expr, data)=>{
                                if (!data) console.warn('DEPRECATED: __ method should be no longer used for translating labels, only if they contain variables. For general translation use form$.translation.TAG instead.');
                                return this.options.i18n.$t(expr, data);
                            }
                        }
                    });
                    break;
            }
        }
    };
    return new Vueform();
}
var base$1e = function base(props, context, dependencies) {
    // =============== INJECT ===============
    /**
  * The root form's component.
  * 
  * @type {Vueform}
  */ var form$ = (0, $ani5R.inject)('form$');
    return {
        form$: form$
    };
};
var base$1d = function base(props, context, dependencies) {
    // =============== INJECT ===============
    /**
  * The global theme object, which contains all the default templates and classes.
  * 
  * @type {object}
  */ var theme = (0, $ani5R.inject)('theme');
    return {
        theme: theme
    };
};
var base$1c = function base(props, context, dependencies) {
    // =============== INJECT ===============
    /**
  * The size of the component.
  * 
  * @type {string}
  */ var Size = (0, $ani5R.inject)('Size');
    return {
        Size: Size
    };
};
var base$1b = function base(props, context, dependencies) {
    var { view } = (0, $8bTPG.toRefs)(props);
    var componentName = context.name;
    // =============== INJECT ===============
    /**
  * The name of the views for the components.
  * 
  * @type {object}
  * @private
  */ var Views = (0, $ani5R.inject)('Views') || (0, $8bTPG.ref)({});
    /**
  * The injected view.
  * 
  * @type {string}
  * @private
  */ var ViewInject = (0, $ani5R.inject)('View', (0, $8bTPG.ref)(undefined));
    // ============== COMPUTED ==============
    /**
   * The name of the resolved view for the component. This one should be used to determine the component's view in class functions.
   * 
   * @type {string}
   */ var View = (0, $8bTPG.computed)(()=>{
        if (view && view.value) return view.value;
        if (Views.value[componentName.value]) return Views.value[componentName.value];
        return ViewInject.value;
    });
    return {
        View: View
    };
};
var base$1a = function base(props, context, dependencies) {
    var componentName = context.name;
    // =============== INJECT ===============
    var { form$ } = base$1e();
    var { theme } = base$1d();
    var { Size } = base$1c();
    var { View } = base$1b(props, context);
    // ============== COMPUTED ===============
    /**
   * The component instance (self).
   * 
   * @type {VueformComponent}
   */ var component$ = (0, $8bTPG.computed)(()=>{
        return (0, $ani5R.getCurrentInstance)().proxy;
    });
    /**
   * An object containaing all the component's classes in key/value pairs. Class values are merged based on the default classes provided by the theme respecing any additional classes / overrides.
   * 
   * @type {MergeClasses}
   * @private
   */ var classesInstance = (0, $8bTPG.computed)(()=>{
        return new MergeClasses({
            component: componentName.value,
            component$: component$,
            theme: theme.value,
            config: form$.value.$vueform.config,
            templates: Templates.value,
            view: View.value,
            merge: [
                form$.value.options
            ]
        });
    });
    /**
   * The component's classes.
   * 
   * @type {object}
   */ var classes = (0, $8bTPG.computed)(()=>{
        return classesInstance.value.classes;
    });
    /**
   * The list of templates available to the component.
   * 
   * @type {object}
   * @private
   */ var Templates = (0, $8bTPG.computed)(()=>{
        return theme.value.templates;
    });
    /**
   * The component's template.
   * 
   * @type {object}
   */ var template = (0, $8bTPG.computed)(()=>{
        return View.value && Templates.value["".concat(componentName.value, "_").concat(View.value)] ? Templates.value["".concat(componentName.value, "_").concat(View.value)] : Templates.value[componentName.value];
    });
    return {
        form$: form$,
        theme: theme,
        Size: Size,
        View: View,
        classesInstance: classesInstance,
        classes: classes,
        Templates: Templates,
        template: template
    };
};
var FormErrors = {
    name: 'FormErrors',
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== COMPUTED ==============
        /**
     * Form errors including element errors and the ones added to `messageBag` manually.
     * 
     * @type {array}
     */ var errors = (0, $8bTPG.computed)(()=>{
            return form$.value.formErrors;
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            errors: errors
        };
    }
};
var FormMessages = {
    name: 'FormMessages',
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== COMPUTED ==============
        /**
     * Form messages including element messages and the ones added to `messageBag` manually.
     * 
     * @type {array}
     */ var messages = (0, $8bTPG.computed)(()=>{
            return form$.value.formMessages;
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            messages: messages
        };
    }
};
var FormLanguages = {
    name: 'FormLanguages',
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== COMPUTED ==============
        /**
     * The language code of the currently selected language (2 letters).
     * 
     * @type {string}
     */ var language = (0, $8bTPG.computed)(()=>{
            return form$.value.selectedLanguage;
        });
        /**
     * The available languages.
     * 
     * @type {object}
     */ var languages = (0, $8bTPG.computed)(()=>{
            return form$.value.options.languages;
        });
        // =============== METHODS ==============
        /**
     * Selects a language.
     * 
     * @param {string} code* the language code to be selected
     * @returns {void}
     */ var select = (code)=>{
            form$.value.setLanguage(code);
        };
        /**
     * Handles `select` event.
     *
     * @param {string} code* the language code to be selected
     * @returns {void}
     * @private
     */ var handleSelect = (code)=>{
            select(code);
        };
        // ============== PROVIDE ===============
        (0, $ani5R.provide)('View', View);
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            language: language,
            languages: languages,
            select: select,
            handleSelect: handleSelect
        };
    }
};
var FormLanguage = {
    name: 'FormLanguage',
    emits: [
        'select'
    ],
    props: {
        language: {
            type: String,
            required: true
        },
        code: {
            type: String,
            required: true
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        var { code } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== COMPUTED ==============
        /**
     * The language code of the currently selected language (2 letters).
     * 
     * @type {string}
     */ var selectedLanguage = (0, $8bTPG.computed)(()=>{
            return form$.value.selectedLanguage;
        });
        /**
     * Whether the current language is the selected one.
     * 
     * @type {boolean}
     */ var selected = (0, $8bTPG.computed)(()=>{
            return selectedLanguage.value == code.value;
        });
        // =============== METHODS ==============
        /**
     * Select the language.
     * 
     * @returns {void}
     */ var select = ()=>{
            context.emit('select', code.value);
        };
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            selectedLanguage: selectedLanguage,
            selected: selected,
            classes: classes,
            Templates: Templates,
            template: template,
            select: select
        };
    }
};
var baseIteratee$3 = _baseIteratee, isArrayLike = isArrayLike_1, keys = keys_1;
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function createFind$2(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
            var iteratee = baseIteratee$3(predicate);
            collection = keys(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
var _createFind = createFind$2;
var baseFindIndex$1 = _baseFindIndex, baseIteratee$2 = _baseIteratee, toInteger$1 = toInteger_1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax$1 = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex$1(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger$1(fromIndex);
    if (index < 0) index = nativeMax$1(length + index, 0);
    return baseFindIndex$1(array, baseIteratee$2(predicate), index);
}
var findIndex_1 = findIndex$1;
var createFind$1 = _createFind, findIndex = findIndex_1;
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var find$1 = createFind$1(findIndex);
var find_1 = find$1;
var baseFindIndex = _baseFindIndex, baseIteratee$1 = _baseIteratee, toInteger = toInteger_1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function findLastIndex$1(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
    }
    return baseFindIndex(array, baseIteratee$1(predicate), index, true);
}
var findLastIndex_1 = findLastIndex$1;
var createFind = _createFind, findLastIndex = findLastIndex_1;
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var findLast = createFind(findLastIndex);
var findLast_1 = findLast;
var FormTabs = {
    name: 'FormTabs',
    emits: [
        'select'
    ],
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        var $this = (0, $ani5R.getCurrentInstance)().proxy;
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        var { events, listeners, on, off, fire } = base$1h(props, context, {
            form$: form$
        }, {
            events: context.emits
        });
        // ================ DATA ================
        /**
     * The child [`FormTab`](form-tab) components.
     *
     * @type {array}
     * @default []
     */ var tabs$Array = (0, $8bTPG.ref)([]);
        /**
     * Helper prop used for checking if the component exists.
     *
     * @type {boolean}
     * @private
     */ var exists = (0, $8bTPG.ref)(true);
        // ============== COMPUTED ==============
        /**
     * The form elements' components.
     *
     * @type {object}
     */ var elements$ = (0, $8bTPG.computed)(()=>{
            return form$.value.elements$;
        });
        /**
     * The object containing tabs defined in [`Vueform`](vueform#option-tabs).
     *
     * @type {object}
     */ var tabs = (0, $8bTPG.computed)(()=>{
            return form$.value.options.tabs;
        });
        /**
     * The child [`FormTab`](form-tab) components with indexed keys.
     *
     * @type {object}
     */ var tabs$ = (0, $8bTPG.computed)(()=>{
            var tabList$ = {};
            each(tabs$Array.value, (formTab$)=>{
                tabList$[formTab$.name] = formTab$;
            });
            return tabList$;
        });
        /**
     * All the visible [`FormTab`](form-tab) components.
     *
     * @type {object}
     */ var visible$ = (0, $8bTPG.computed)(()=>{
            var tabList$ = {};
            each(tabs$.value, (tab$)=>{
                if (tab$.visible) tabList$[tab$.name] = tab$;
            });
            return tabList$;
        });
        /**
     * The current [`FormTab`](form-tab) component.
     *
     * @type {FormTab}
     */ var current$ = (0, $8bTPG.computed)(()=>{
            var current = find_1(tabs$.value, {
                active: true
            });
            return current !== undefined ? current : {};
        });
        /**
     * The first visible [`FormTab`](form-tab) component.
     *
     * @type {FormTab}
     */ var first$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, (tab)=>{
                return tab.visible;
            });
        });
        /**
     * The last visible [`FormTab`](form-tab) component.
     *
     * @type {FormTab}
     */ var last$ = (0, $8bTPG.computed)(()=>{
            return Object.values(visible$.value).pop();
        });
        /**
     * The next visible [`FormTab`](form-tab) component.
     *
     * @type {FormTab}
     */ var next$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, (tab)=>{
                return tab.index > current$.value.index && tab.visible;
            });
        });
        /**
     * The previous visible [`FormTab`](form-tab) component.
     *
     * @type {FormTab}
     */ var previous$ = (0, $8bTPG.computed)(()=>{
            return findLast_1(visible$.value, (tab)=>{
                return tab.index < current$.value.index && tab.visible;
            });
        });
        // =============== METHODS ==============
        /**
     * Go to a tab.
     *
     * @param {string} name* name of tab to go to
     * @returns {void}
     */ var goTo = (name)=>{
            var tab$ = visible$.value[name];
            tab$.select();
        };
        /**
     * Select a tab.
     *
     * @param {FormTab} tab$* the [`FormTab`](form-tab) component to select
     * @returns {void}
     * @private
     */ var select = (tab$)=>{
            var curr$ = current$.value;
            each(elements$.value, (element$)=>{
                element$.deactivate();
            });
            each(tabs$.value, (tab$)=>{
                tab$.deactivate();
            });
            fire('select', tab$, curr$);
        };
        /**
     * Returns a specific [`FormTab`](form-tab) by index.
     *
     * @param {string} tab* name of the tab
     * @returns {FormTab}
     */ var tab$ = (name)=>{
            return find_1(tabs$.value, {
                name: name
            });
        };
        /**
     * Jump back to the first visible tab.
     *
     * @returns {void}
     */ var reset = ()=>{
            first$.value.select();
        };
        /**
     * Set the component to the parent as if `refs` were used.
     *
     * @param {VNode} $parent parent component
     * @param {function} assignToParent the assignToParent function for recursion
     * @returns {void}
     * @private
     */ var assignToParent = ($parent, assignToParent)=>{
            if ($parent.tabs$ !== undefined) form$.value.$set($parent, 'tabs$', $this);
            else assignToParent($parent.$parent, assignToParent);
        };
        /**
    * Removes the component from the parent.
    *
    * @param {VNode} $parent parent component
    * @param {function} removeFromParent the removeFromParent function for recursion
    * @private
    */ var removeFromParent = ($parent, removeFromParent)=>{
            if ($parent.tabs$ !== undefined) form$.value.$set($parent, 'tabs$', null);
            else /* @todo:adam test later */ removeFromParent($parent.$parent, removeFromParent);
        };
        // ============== PROVIDE ===============
        (0, $ani5R.provide)('View', View);
        // ============== WATCHERS ==============
        /* istanbul ignore next: can not reproduce */ (0, $8bTPG.watch)(elements$, (newValue, oldValue)=>{
            var newElements$ = difference_1(keys_1(newValue), keys_1(oldValue));
            each(newElements$, (newElement$)=>{
                elements$.value[newElement$].deactivate();
            });
        }, {
            deep: false,
            lazy: true
        });
        (0, $8bTPG.watch)(tabs, /*#__PURE__*/ _asyncToGenerator(function*() {
            yield (0, $ani5R.nextTick)();
            yield (0, $ani5R.nextTick)();
            //@todo:adam we came up with change together
            if ((current$.value === undefined || current$.value.index === undefined) && first$.value) first$.value.select();
        }), {
            deep: true,
            lazy: true
        });
        // Resort tabs$Array when tabs
        // order changes or a tab is removed
        (0, $8bTPG.watch)(tabs, (newValue)=>{
            var newTabs$Array = [];
            each(newValue, (t, name)=>{
                newTabs$Array.push(tabs$Array.value[tabs$Array.value.map((t$)=>normalize(t$.name)).indexOf(normalize(name))]);
            });
            tabs$Array.value = newTabs$Array;
        }, {
            flush: 'post'
        });
        // =============== HOOKS ================
        (0, $ani5R.onBeforeMount)(()=>{
            assignToParent($this.$parent, assignToParent);
        });
        (0, $ani5R.onBeforeUnmount)(()=>{
            removeFromParent($this.$parent, removeFromParent);
        });
        (0, $ani5R.onMounted)(()=>{
            (0, $ani5R.nextTick)(()=>{
                if (!find_1(tabs$.value, {
                    active: true
                })) first$.value.select();
            });
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            tabs: tabs,
            elements$: elements$,
            tabs$Array: tabs$Array,
            events: events,
            listeners: listeners,
            exists: exists,
            classes: classes,
            Templates: Templates,
            template: template,
            tabs$: tabs$,
            visible$: visible$,
            current$: current$,
            first$: first$,
            last$: last$,
            next$: next$,
            previous$: previous$,
            goTo: goTo,
            select: select,
            tab$: tab$,
            reset: reset,
            on: on,
            off: off,
            fire: fire
        };
    }
};
var base$19 = function base(props, context, dependencies) {
    var { conditions } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var path = dependencies.path || (0, $8bTPG.ref)(null);
    var el$1 = dependencies.el$ || (0, $8bTPG.ref)(undefined);
    var parent = dependencies.parent;
    // ================ DATA ================
    /**
   * The current conditions of the element.
   * 
   * @type {array}
   * @private
   */ var conditionList = (0, $8bTPG.ref)(conditions.value);
    var additionalConditions = (0, $8bTPG.ref)({});
    // ============== COMPUTED ==============
    /**
   * Whether no [`conditions`](#option-conditions) are defined or they are all fulfilled.
   * 
   * @type {boolean}
   */ var available = (0, $8bTPG.computed)(()=>{
        if (!form$.value.conditions) return true;
        if (parent && parent.value && parent.value.available !== undefined && !parent.value.available) return false;
        if (!conditionList.value || !conditionList.value.length) return true;
        return !some_1(conditionList.value, (condition)=>{
            return !form$.value.$vueform.services.condition.check(condition, path.value, form$.value, el$1.value);
        });
    });
    // ============== METHODS ===============
    /**
   * Updates element conditions after they have been changed.
   * 
   * @returns {void}
   * @private
   */ var updateConditions = ()=>{
        conditionList.value = Object.values(additionalConditions.value).reduce((prev, curr)=>{
            return prev.concat(curr);
        }, conditions.value);
    };
    var addConditions = (key, conditions)=>{
        additionalConditions.value[key] = conditions;
        updateConditions();
    };
    var removeConditions = (key)=>{
        delete additionalConditions.value[key];
        updateConditions();
    };
    // Conditions should not be watched, because if they
    // are defined inline they will trigger infinite updates
    // watch(conditions, () => {
    //   updateConditions()
    // }, { immediate: false, deep: true })
    return {
        conditionList: conditionList,
        available: available,
        additionalConditions: additionalConditions,
        updateConditions: updateConditions,
        addConditions: addConditions,
        removeConditions: removeConditions
    };
};
var list$5 = function list(props, context, dependencies) {
    var { conditionList, available, additionalConditions, addConditions, removeConditions } = base$19(props, context, dependencies);
    var { conditions } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var children$Array = dependencies.children$Array;
    // ============== METHODS ===============
    var updateConditions = ()=>{
        conditionList.value = Object.values(additionalConditions.value).reduce((prev, curr)=>{
            return prev.concat(curr);
        }, conditions.value);
        children$Array.value.forEach((child$)=>{
            child$.updateConditions();
        });
    };
    return {
        conditionList: conditionList,
        available: available,
        updateConditions: updateConditions,
        addConditions: addConditions,
        removeConditions: removeConditions
    };
};
var object$8 = list$5;
var group$8 = list$5;
/**
 * From: https://github.com/fengyuanchen/is-vue-component/blob/master/src/index.js
 */ var { hasOwnProperty, toString } = Object.prototype;
/**
 * Check if the given value is a non-empty string.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a non-empty string, else `false`.
 */ function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
/**
 * Check if the given value is a function.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */ function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Check if the given value is a non-empty array.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a non-empty array, else `false`.
 */ /* istanbul ignore next */ function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function isNonNullObject(value) {
    return !!value;
}
/**
 * Check if the given value is an element.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an element, else `false`.
 */ /* istanbul ignore next */ function isElement(value) {
    return isNonNullObject(value) && value.nodeType === 1 && toString.call(value).indexOf('Element') > -1;
}
/**
 * Check if the given value is a valid Vue component.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a valid Vue component, else `false`.
 */ function isVueComponent(value) {
    /* istanbul ignore next */ return isPlainObject_1(value) && (isNonEmptyString(value.template) || isFunction(value.render) || isNonEmptyString(value.el) || isElement(value.el) || isVueComponent(value.extends) || isNonEmptyArray(value.mixins) && value.mixins.some((val)=>isVueComponent(val))) || typeof value === 'function' && value.prototype && value.prototype.constructor.name === 'VueComponent';
}
function localize(object, $config, form$) {
    var locale = form$.locale$ || $config.i18n.locale;
    if (!locale) return object;
    return object && typeof object === 'object' ? (object === null || object === void 0 ? void 0 : object[locale]) || (object === null || object === void 0 ? void 0 : object[locale.toUpperCase()]) || (object === null || object === void 0 ? void 0 : object[$config.i18n.fallbackLocale]) || (object === null || object === void 0 ? void 0 : object[$config.i18n.fallbackLocale.toUpperCase()]) || (object === null || object === void 0 ? void 0 : object[Object.keys(object)[0]]) || '' : object;
}
var base$18 = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var labelDefinition = dependencies.labelDefinition;
    var component$ = dependencies.component$ || (0, $8bTPG.ref)(null);
    // =============== INJECT ===============
    var form$ = (0, $ani5R.inject)('form$');
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
  * The label definition of the component.
  * 
  * @type {string|function|Component}
  * @private
  */ var baseLabel = (0, $8bTPG.computed)(()=>{
        return labelDefinition.value;
    });
    /**
  * Whether the label is provided as a function.
  * 
  * @type {boolean}
  * @private
  */ var isLabelFunction = (0, $8bTPG.computed)(()=>{
        return typeof baseLabel.value === 'function' && (!baseLabel.value.prototype || !baseLabel.value.prototype.constructor || baseLabel.value.prototype.constructor && baseLabel.value.prototype.constructor.name !== 'VueComponent');
    });
    /**
  * Whether label is provided as a Vue component.
  * 
  * @type {boolean}
  * @private
  */ var isLabelComponent = (0, $8bTPG.computed)(()=>{
        return isVueComponent(baseLabel.value);
    });
    /**
  * The label of the component.
  * 
  * @type {string|Component}
  */ var label = (0, $8bTPG.computed)(()=>{
        var label = isLabelFunction.value ? baseLabel.value(component$.value) : baseLabel.value || null;
        if (!isLabelComponent.value) label = localize(label, config$.value, form$.value);
        return label;
    });
    return {
        label: label,
        isLabelComponent: isLabelComponent
    };
};
var FormTab = {
    name: 'FormTab',
    emits: [
        'activate',
        'inactivate'
    ],
    slots: [
        'default'
    ],
    props: {
        /**
     * Name of tab within [tabs](reference/frontend-form#prop-tabs) object.
     */ name: {
            type: [
                String,
                Number
            ],
            required: true
        },
        label: {
            type: [
                String,
                Object,
                Function
            ],
            required: false,
            default: null
        },
        elements: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[]
        },
        conditions: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[]
        },
        addClass: {
            required: false,
            type: [
                Array,
                Object,
                String
            ],
            default: null
        },
        removeClass: {
            required: false,
            type: [
                Array,
                Object
            ],
            default: null
        },
        replaceClass: {
            required: false,
            type: [
                Object
            ],
            default: null
        },
        overrideClass: {
            required: false,
            type: [
                Array,
                Object,
                String
            ],
            default: null
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        onActivate: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        },
        onInactivate: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        }
    },
    setup (props, context) {
        var { name, label, elements } = (0, $8bTPG.toRefs)(props);
        var $this = (0, $ani5R.getCurrentInstance)().proxy;
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        var { available, conditionList, updateConditions } = base$19(props, context, {
            form$: form$
        });
        var { isLabelComponent, label: tabLabel_ } = base$18(props, context, {
            component$: form$,
            labelDefinition: label
        });
        var { events, listeners, on, off, fire } = base$1h(props, context, {
            form$: form$
        }, {
            events: context.emits
        });
        // ================ DATA ================
        /**
     * Whether the tab is active.
     *
     * @type {boolean}
     * @default false
     */ var active = (0, $8bTPG.ref)(false);
        /**
     * The label of the tab.
     *
     * @type {string|Component}
     * @default null
     */ var tabLabel = (0, $8bTPG.ref)(tabLabel_.value && typeof tabLabel_.value === 'object' ? (0, $8bTPG.markRaw)(tabLabel_.value) : tabLabel_.value);
        // ============== COMPUTED ==============
        /**
     * The components of highest level form elements.
     *
     * @type {object}
     */ var elements$ = (0, $8bTPG.computed)(()=>{
            return form$.value.elements$;
        });
        /**
     * The parent [`FormTabs`](form-tabs) component.
     *
     * @type {FormTabs}
     */ var tabs$ = (0, $8bTPG.computed)(()=>{
            return form$.value.tabs$;
        });
        /**
     * Index of this tab among the other tabs which are not hidden by unmet conditions.
     *
     * @type {number}
     */ var index = (0, $8bTPG.computed)(()=>{
            var _tabs$$value;
            return Object.keys((tabs$ === null || tabs$ === void 0 || (_tabs$$value = tabs$.value) === null || _tabs$$value === void 0 ? void 0 : _tabs$$value.tabs$) || /* istanbul ignore next: tab can not stand by itself */ {}).indexOf(name.value);
        });
        /**
     * Whether the tab is the first.
     *
     * @type {boolean}
     */ var isFirst = (0, $8bTPG.computed)(()=>{
            return index.value === 0;
        });
        /**
     * Whether the tab is the first.
     *
     * @type {boolean}
     */ var isLast = (0, $8bTPG.computed)(()=>{
            return tabs$.value.last$.name === name.value;
        });
        /**
     * The components of form elements within the tab.
     *
     * @type {object}
     */ var children$ = (0, $8bTPG.computed)(()=>{
            return filter_1(elements$.value, (element$, key)=>{
                return elements.value.indexOf(key) !== -1;
            });
        });
        /**
     * Whether the tab should be visible.
     *
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            return available.value;
        });
        /**
     * Whether the tab has any invalid elements.
     *
     * @type {boolean}
     */ var invalid = (0, $8bTPG.computed)(()=>{
            return some_1(children$.value, {
                available: true,
                invalid: true
            });
        });
        /**
     * The tab's component.
     *
     * @type {FormTab}
     */ var tab$ = (0, $8bTPG.computed)(()=>{
            return form$.value.tabs$.tabs$[name.value];
        });
        // =============== METHODS ==============
        /**
     * Deactivate all other tabs and set the current one as active.
     *
     * @returns {void}
     */ var select = ()=>{
            var _tabs$$value2, _tabs$$value3;
            if (active.value || !((_tabs$$value2 = tabs$.value) !== null && _tabs$$value2 !== void 0 && _tabs$$value2.select)) return;
            (_tabs$$value3 = tabs$.value) === null || _tabs$$value3 === void 0 || _tabs$$value3.select(tab$.value);
            activate();
        };
        /**
     * Activate the tab.
     *
     * @returns {void}
     */ var activate = ()=>{
            if (active.value) return;
            active.value = true;
            each(children$.value, (element$)=>{
                element$.activate();
            });
            fire('activate');
        };
        /**
     * Deactivate the tab.
     *
     * @returns {void}
     */ var deactivate = ()=>{
            if (!active.value) return;
            active.value = false;
            each(children$.value, (element$)=>{
                element$.deactivate();
            });
            fire('inactivate');
        };
        /**
      * Apply conditions of the tab to its elements.
      *
      * @returns {void}
      * @private
      */ var addChildConditions = ()=>{
            if (conditionList.value.length == 0) return;
            Object.values(children$.value).forEach((element$)=>{
                element$.addConditions('tab', conditionList.value);
            });
        };
        /**
      * Remove conditions of the elements of the tab.
      *
      * @returns {void}
      * @private
      */ var removeChildConditions = ()=>{
            Object.values(children$.value).forEach((element$)=>{
                element$.removeConditions('tab');
            });
        };
        /**
      * Resets conditions of the elements of the tab.
      *
      * @returns {void}
      * @private
      */ var resetChildConditions = ()=>{
            removeChildConditions();
            addChildConditions();
        };
        /**
     * Set the component to the parent as if `refs` were used.
     *
     * @param {VNode} $parent parent component
     * @param {function} assignToParent the assignToParent function for recursion
     * @returns {void}
     * @private
     */ var assignToParent = ($parent, assignToParent)=>{
            if ($parent.tabs$Array) $parent.tabs$Array.push($this);
            else assignToParent($parent.$parent, assignToParent);
        };
        /**
    * Removes the component from the parent.
    *
    * @param {VNode} $parent parent component
    * @param {function} removeFromParent the removeFromParent function for recursion
    * @private
    */ var removeFromParent = ($parent, removeFromParent)=>{
            if ($parent.tabs$Array) $parent.tabs$Array.splice($parent.tabs$Array.map((t$)=>normalize(t$.name)).indexOf(normalize(name.value)), 1);
            else /* @todo:adam test later */ removeFromParent($parent.$parent, removeFromParent);
        };
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(children$, ()=>{
            /* istanbul ignore else */ if (!active.value) return;
            each(children$.value, (element$)=>{
                element$.activate();
            });
        }, {
            deep: false,
            lazy: true
        });
        (0, $8bTPG.watch)(tabLabel_, ()=>{
            tabLabel.value = tabLabel_.value && typeof tabLabel_.value === 'object' ? (0, $8bTPG.markRaw)(tabLabel_.value) : tabLabel_.value;
        });
        (0, $8bTPG.watch)(conditionList, (n, o)=>{
            if (!(n !== null && n !== void 0 && n.length)) removeChildConditions();
            else addChildConditions();
        });
        // ================ HOOKS ===============
        (0, $ani5R.onMounted)(()=>{
            // nextTick is required because elements$
            // only available after form is mounted,
            // which is later than the tab mount
            (0, $ani5R.nextTick)(()=>{
                addChildConditions();
            });
        });
        (0, $ani5R.onBeforeMount)(()=>{
            assignToParent($this.$parent, assignToParent);
        });
        (0, $ani5R.onBeforeUnmount)(()=>{
            removeChildConditions();
            removeFromParent($this.$parent, removeFromParent);
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            elements$: elements$,
            index: index,
            isFirst: isFirst,
            isLast: isLast,
            active: active,
            events: events,
            listeners: listeners,
            children$: children$,
            visible: visible,
            invalid: invalid,
            classes: classes,
            Templates: Templates,
            template: template,
            available: available,
            isLabelComponent: isLabelComponent,
            tabLabel: tabLabel,
            tab$: tab$,
            tabs$: tabs$,
            conditionList: conditionList,
            select: select,
            activate: activate,
            deactivate: deactivate,
            on: on,
            off: off,
            fire: fire,
            addChildConditions: addChildConditions,
            removeChildConditions: removeChildConditions,
            resetChildConditions: resetChildConditions,
            updateConditions: updateConditions
        };
    }
};
var FormSteps = {
    name: 'FormSteps',
    emits: [
        'select',
        'next',
        'previous',
        'finish'
    ],
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        var $this = (0, $ani5R.getCurrentInstance)().proxy;
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        var { events, listeners, on, off, fire } = base$1h(props, context, {
            form$: form$
        }, {
            events: context.emits
        });
        // ================ DATA ================
        /**
     * The child [`FormStep`](form-step) components.
     *
     * @type {array}
     * @default []
     */ var steps$Array = (0, $8bTPG.ref)([]);
        /**
     * Helper to store a watcher.
     *
     * @type {object}
     * @default null
     */ var unwatchInvalid = (0, $8bTPG.ref)(null);
        /**
     * Helper prop used for checking if the component exists.
     *
     * @type {boolean}
     * @private
     */ var exists = (0, $8bTPG.ref)(true);
        // ============== COMPUTED ==============
        /**
     * The object containing steps defined in [`Vueform`](vueform#option-steps).
     *
     * @type {object}
     */ var steps = (0, $8bTPG.computed)(()=>{
            return form$.value.options.steps;
        });
        /**
     * The form elements' components.
     *
     * @type {object}
     */ var elements$ = (0, $8bTPG.computed)(()=>{
            return form$.value.elements$;
        });
        /**
     * Whether there are any steps in [`pending`](form-step#property-pending) state.
     *
     * @type {boolean}
     */ var pending = (0, $8bTPG.computed)(()=>{
            return some_1(visible$.value, {
                pending: true
            });
        });
        /**
     * Whether there are any steps in [`debouncing`](form-step#property-debouncing) state.
     *
     * @type {boolean}
     */ var debouncing = (0, $8bTPG.computed)(()=>{
            return some_1(visible$.value, {
                debouncing: true
            });
        });
        /**
     * Whether there are any steps in [`invalid`](form-step#property-invalid) state.
     *
     * @type {boolean}
     */ var invalid = (0, $8bTPG.computed)(()=>{
            return some_1(visible$.value, {
                invalid: true
            });
        });
        /**
     * Whether all the steps are [`done`](form-step#property-done).
     *
     * @type {boolean}
     */ var done = (0, $8bTPG.computed)(()=>{
            return !some_1(visible$.value, {
                done: false
            });
        });
        /**
     * Whether there are any steps in [`busys`](form-step#property-busys) state.
     *
     * @type {boolean}
     */ var busy = (0, $8bTPG.computed)(()=>{
            return pending.value || debouncing.value;
        });
        /**
     * The child [`FormStep`](form-step) components with indexed keys.
     *
     * @type {object}
     */ var steps$ = (0, $8bTPG.computed)(()=>{
            var steps$ = {};
            each(steps$Array.value, (step$)=>{
                steps$[step$.name] = step$;
            });
            return steps$;
        });
        /**
     * All the visible [`FormStep`](form-step) components.
     *
     * @type {object}
     */ var visible$ = (0, $8bTPG.computed)(()=>{
            var stepList$ = {};
            each(steps$.value, (step$)=>{
                if (step$.visible) stepList$[step$.name] = step$;
            });
            return stepList$;
        });
        /**
     * The first visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var first$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, (step)=>{
                return step.visible;
            });
        });
        /**
     * The last visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var last$ = (0, $8bTPG.computed)(()=>{
            return Object.values(visible$.value).pop();
        });
        /**
     * The current [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var current$ = (0, $8bTPG.computed)(()=>{
            var current = find_1(steps$.value, {
                active: true
            });
            return current !== undefined ? current : {};
        });
        /**
     * The next visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var next$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, (step)=>{
                return step.index > current$.value.index && step.visible;
            });
        });
        /**
     * The previous visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var previous$ = (0, $8bTPG.computed)(()=>{
            return findLast_1(visible$.value, (step)=>{
                return step.index < current$.value.index && step.visible;
            });
        });
        /**
     * The first invalid & visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var firstInvalid$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, {
                invalid: true
            });
        });
        /**
     * The first visible [`FormStep`](form-step) component which is not done yet.
     *
     * @type {FormStep|undefined}
     */ var firstNonDone$ = (0, $8bTPG.computed)(()=>{
            return find_1(visible$.value, {
                done: false
            });
        });
        /**
     * The last enabled & visible [`FormStep`](form-step) component.
     *
     * @type {FormStep|undefined}
     */ var lastEnabled$ = (0, $8bTPG.computed)(()=>{
            return findLast_1(visible$.value, {
                isDisabled: false
            });
        });
        /**
     * Whether is at the last step.
     *
     * @type {boolean}
     */ var isAtLastStep = (0, $8bTPG.computed)(()=>{
            var last = findLast_1(visible$.value, {
                visible: true
            });
            // @todo:adam !current$.value will never be null or undefined, hardcoded {}
            /* istanbul ignore next: !last not worth the effort */ if (!current$.value || !last) return false;
            return last.index === current$.value.index;
        });
        /**
     * Whether is at the first step.
     *
     * @type {boolean}
     */ var isAtFirstStep = (0, $8bTPG.computed)(()=>{
            return current$.value.index === 0;
        });
        // =============== METHODS ==============
        /**
     * Go to a step and enable it. Optionally enable all steps up to it.
     *
     * @param {string} name* name of step to go to
     * @param {boolean} enableUntil whether steps should be enabled up to the selected step (default: `false`)
     * @returns {void}
     */ var goTo = function goTo(name) {
            var enableUntil = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var step = visible$.value[name];
            step.enable();
            step.select();
            if (enableUntil) (0, $ani5R.nextTick)(()=>{
                enableUntilLastEnabled();
            });
        };
        /**
     * Move to next step and enable it.
     *
     * @returns {void}
     */ var next = ()=>{
            fire('next', next$.value);
            next$.value.enable();
            next$.value.select();
            if (form$.value.options.scrollOnNext && form$.value.$el.scrollIntoView) (0, $ani5R.nextTick)(()=>{
                form$.value.$el.scrollIntoView({
                    behavior: 'smooth'
                });
            });
        };
        /**
     * Move to previous step.
     *
     * @returns {void}
     */ var previous = ()=>{
            fire('previous', previous$.value);
            previous$.value.select();
        };
        /**
     * Mark each [`FormStep`](form-step) as complete.
     *
     * @returns {void}
     */ var complete = ()=>{
            each(steps$.value, (step$)=>{
                step$.complete();
            });
        };
        /**
     * Returns a specific [`FormStep`](form-step) component by index.
     *
     * @param {string} name* name of the step
     * @returns {FormStep|undefined}
     */ var step$ = (name)=>{
            return find_1(visible$.value, {
                name: name
            });
        };
        /**
     * Jump back to first visible step and disable all others.
     *
     * @returns {void}
     */ var reset = ()=>{
            each(steps$.value, (step$)=>{
                step$.uncomplete();
                step$.disable();
            });
            first$.value.enable();
            first$.value.select();
        };
        /**
     * Enables all steps.
     *
     * @returns {void}
     */ var enableAllSteps = ()=>{
            each(steps$.value, (step$)=>{
                step$.enable();
            });
        };
        /**
     * Invokes the form's `submit` event. If the form has any validation errors it will jump to the first step with error.
     *
     * @returns {Promise}
     */ var submit = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*() {
                // Replaced with next because Vue didn't handle component's submit event in FFX
                // let form = form$.value.$el.nodeName === 'FORM' ? form$.value.$el : form$.value.$el.querySelector('form')
                // form.dispatchEvent(new Event('submit'))
                yield form$.value.submit();
                if (invalid.value) {
                    firstInvalid$.value.select();
                    (0, $ani5R.nextTick)(()=>{
                        form$.value.scrollToFirstInvalid();
                    });
                    return;
                }
                //@todo:adam it should not be necessary anymore since submit is async
                /* istanbul ignore next */ unwatchInvalid.value = (0, $8bTPG.watch)(invalid, (isInvalid)=>{
                    if (isInvalid) firstInvalid$.value.select();
                    unwatchInvalid.value();
                });
            });
            return function submit() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * Select a step.
     *
     * @param {FormStep} step$* the [`FormStep`](form-step) component to select
     * @returns {void}
     * @private
     */ var select = (step$)=>{
            var curr$ = current$.value;
            each(elements$.value, (element$)=>{
                element$.deactivate();
            });
            each(steps$.value, (step$)=>{
                step$.deactivate();
            });
            fire('select', step$, curr$);
        };
        /**
     * Enable steps until a certain index.
     *
     * @param {number} index* index of the step
     * @returns {void}
     */ var enableUntil = (index)=>{
            each(steps$.value, (step$)=>{
                /* istanbul ignore else */ if (step$.index <= index && step$.visible) step$.enable();
            });
        };
        /**
     * Enable all steps up to the current step.
     *
     * @returns {void}
     */ var enableUntilCurrent = ()=>{
            enableUntil(current$.value.index);
        };
        /**
     * Enable all steps up to the last enabled.
     *
     * @returns {void}
     */ var enableUntilLastEnabled = ()=>{
            /* istanbul ignore next: not reproducible only for Vue 2 Cli compatibility */ if (!lastEnabled$.value && !first$.value) return;
            enableUntil(lastEnabled$.value !== undefined ? lastEnabled$.value.index : first$.value.index);
        };
        /**
     * Set the component to the parent as if `refs` were used.
     *
     * @param {VNode} $parent parent component
     * @param {function} assignToParent the assignToParent function for recursion
     * @returns {void}
     * @private
     */ var assignToParent = ($parent, assignToParent)=>{
            if ($parent.steps$ !== undefined) form$.value.$set($parent, 'steps$', $this);
            else assignToParent($parent.$parent, assignToParent);
        };
        /**
    * Removes the component from the parent.
    *
    * @param {VNode} $parent parent component
    * @param {function} removeFromParent the removeFromParent function for recursion
    * @private
    */ var removeFromParent = ($parent, removeFromParent)=>{
            if ($parent.steps$ !== undefined) form$.value.$set($parent, 'steps$', null);
            else /* @todo:adam test later */ removeFromParent($parent.$parent, removeFromParent);
        };
        // ============== PROVIDE ===============
        (0, $ani5R.provide)('View', View);
        // ============== WATCHERS ==============
        /* istanbul ignore next: can not reproduce */ (0, $8bTPG.watch)(elements$, (newValue, oldValue)=>{
            var newElements$ = difference_1(keys_1(newValue), keys_1(oldValue));
            each(newElements$, (newElement$)=>{
                elements$.value[newElement$].deactivate();
            });
        }, {
            deep: false,
            lazy: true
        });
        (0, $8bTPG.watch)(steps, ()=>{
            (0, $ani5R.nextTick)(()=>{
                /* istanbul ignore next: nothing happens */ lastEnabled$.value;
                if (current$.value.index === undefined && first$.value) first$.value.select();
            });
        }, {
            deep: true,
            lazy: true
        });
        // Resort steps$Array when steps
        // order changes or a tab is removed
        (0, $8bTPG.watch)(steps, (newValue)=>{
            var newSteps$Array = [];
            each(newValue, (t, name)=>{
                newSteps$Array.push(steps$Array.value[steps$Array.value.map((t$)=>normalize(t$.name)).indexOf(normalize(name))]);
            });
            steps$Array.value = newSteps$Array;
        }, {
            flush: 'post'
        });
        // =============== HOOKS ================
        (0, $ani5R.onBeforeMount)(()=>{
            assignToParent($this.$parent, assignToParent);
        });
        (0, $ani5R.onBeforeUnmount)(()=>{
            removeFromParent($this.$parent, removeFromParent);
        });
        (0, $ani5R.onMounted)(()=>{
            // nextTick is required because elements$
            // only available after form is mounted,
            // which is later than the steps mount
            (0, $ani5R.nextTick)(()=>{
                if (current$.value === undefined || current$.value.index === undefined) {
                    first$.value.enable();
                    first$.value.select();
                }
                enableUntilCurrent();
                // if new steps are shown because of
                // changing conditions the ones before
                // the last active should be enabled
                (0, $8bTPG.watch)(visible$, ()=>{
                    enableUntilLastEnabled();
                }, {
                    flush: 'post'
                });
            });
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            steps: steps,
            elements$: elements$,
            steps$Array: steps$Array,
            events: events,
            listeners: listeners,
            exists: exists,
            classes: classes,
            Templates: Templates,
            template: template,
            steps$: steps$,
            pending: pending,
            debouncing: debouncing,
            invalid: invalid,
            done: done,
            busy: busy,
            visible$: visible$,
            first$: first$,
            last$: last$,
            current$: current$,
            next$: next$,
            previous$: previous$,
            firstInvalid$: firstInvalid$,
            firstNonDone$: firstNonDone$,
            lastEnabled$: lastEnabled$,
            isAtLastStep: isAtLastStep,
            isAtFirstStep: isAtFirstStep,
            goTo: goTo,
            next: next,
            previous: previous,
            complete: complete,
            step$: step$,
            reset: reset,
            enableAllSteps: enableAllSteps,
            submit: submit,
            select: select,
            enableUntil: enableUntil,
            enableUntilCurrent: enableUntilCurrent,
            enableUntilLastEnabled: enableUntilLastEnabled,
            on: on,
            off: off,
            fire: fire
        };
    }
};
var FormStepsControls = {
    name: 'FormStepsControls',
    slots: [
        'previous',
        'next',
        'finish'
    ],
    props: {
        labels: {
            type: Boolean,
            required: false,
            default: true
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== PROVIDE ===============
        (0, $ani5R.provide)('View', View);
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template
        };
    }
};
var FormStepsControl = {
    name: 'FormStepsControl',
    slots: [
        'default'
    ],
    props: {
        type: {
            type: [
                String
            ],
            required: true
        },
        labels: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            private: true
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        var { type, labels } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        // ============== COMPUTED ==============
        /**
     * The label definition of the component.
     *
     * @type {string|function|Component}
     * @private
     */ var baseLabel = (0, $8bTPG.computed)(()=>{
            /* istanbul ignore next: can not tell if returned  */ if (!labels.value) return null;
            var stepLabels = current$ && current$.value ? current$.value.labels : /* istanbul ignore next: failsafe only */ null;
            switch(type.value){
                case 'previous':
                    return stepLabels && stepLabels.previous ? stepLabels.previous : form$.value.translations.vueform.steps.previous;
                case 'next':
                    return stepLabels && stepLabels.next ? stepLabels.next : form$.value.translations.vueform.steps.next;
                case 'finish':
                    return stepLabels && stepLabels.finish ? stepLabels.finish : stepLabels && stepLabels.next ? stepLabels.next : form$.value.translations.vueform.steps.finish;
            }
        });
        var { isLabelComponent, label } = base$18(props, context, {
            component$: form$,
            labelDefinition: baseLabel
        });
        // ============== COMPUTED ==============
        /**
     * The [`FormSteps`](form-steps) component.
     *
     * @type {FormSteps}
     * @private
     */ var steps$ = (0, $8bTPG.computed)(()=>{
            return form$.value.steps$;
        });
        /**
     * The currently active [`FormStep`](form-step) component.
     *
     * @type {FormStep}
     * @private
     */ var current$ = (0, $8bTPG.computed)(()=>{
            return steps$.value ? steps$.value.current$ : /* istanbul ignore next: failsafe only */ undefined;
        });
        /**
     * Whether the control should be visible.
     *
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            var buttons = current$ && current$.value ? current$.value.buttons : /* istanbul ignore next: failsafe only */ null;
            switch(type.value){
                case 'previous':
                    return !buttons ? true : buttons.previous !== false;
                case 'next':
                    return steps$.value && !steps$.value.isAtLastStep && (!buttons || buttons.next !== false);
                case 'finish':
                    return steps$.value && steps$.value.isAtLastStep && (!buttons || buttons.finish !== false);
            }
        });
        /**
     * Whether the control should be disabled.
     *
     * @type {boolean}
     */ var isDisabled = (0, $8bTPG.computed)(()=>{
            switch(type.value){
                case 'previous':
                    return steps$.value && steps$.value.isAtFirstStep;
                case 'next':
                    return current$.value !== undefined && current$.value.index !== undefined && // only disable next because of invalidity
                    // if element validations are triggered on
                    // change, otherwise it might occur that the
                    // step has invalid fields, which values have
                    // changed to valid, but still marked as invalid
                    (current$.value.invalid && form$.value.shouldValidateOnChange || current$.value.busy || form$.value.isLoading);
                case 'finish':
                    // only disable finish because of invalidity
                    // if element validations are triggered on
                    // change, otherwise it might occur that the
                    // form has invalid fields, which values have
                    // changed to valid, but still marked as invalid
                    return steps$.value.invalid && form$.value.shouldValidateOnChange || steps$.value.busy || form$.value.submitting || form$.value.isDisabled || form$.value.isLoading;
            }
        });
        /**
     * Whether the control is in loading state (except for previous).
     *
     * @type {boolean}
     */ var isLoading = (0, $8bTPG.computed)(()=>{
            return type.value === 'previous' ? false : form$.value.isLoading || form$.value.submitting;
        });
        // =============== METHODS ==============
        /**
     * Go to the previous form step.
     *
     * @returns {void}
     */ var previous = ()=>{
            steps$.value.previous();
        };
        /**
     * Complete the current step and go to the next one (async). If the form's [`validateOn`](vueform#option-validate-on) prop or `config.validateOn` contains `'step'` also validates the elements within the step before moving forward (and stay if there's any error).
     *
     * @returns {Promise}
     */ var next = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*() {
                /* istanbul ignore else */ if (form$.value.shouldValidateOnStep) yield current$.value.validate();
                if (current$.value.invalid) {
                    form$.value.scrollToFirstInvalid();
                    return;
                }
                current$.value.complete();
                steps$.value.next();
            });
            return function next() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * Complete the final step and submit the form (async).
     *
     * @returns {Promise}
     */ var finish = /*#__PURE__*/ function() {
            var _ref2 = _asyncToGenerator(function*() {
                steps$.value.fire('finish');
                steps$.value.complete();
                steps$.value.submit();
            });
            return function finish() {
                return _ref2.apply(this, arguments);
            };
        }();
        /**
     * Handles `click` event.
     *
     * @returns {void}
     * @param {Event} e* event object
     * @private
     */ var handleClick = (e)=>{
            switch(type.value){
                case 'previous':
                    previous();
                    break;
                case 'next':
                    next();
                    if (e.key === 'Enter' || e.key === ' ') (0, $ani5R.nextTick)(()=>{
                        (0, $ani5R.nextTick)(()=>{
                            var _current$$value$child;
                            var firstEl$ = current$ === null || current$ === void 0 || (_current$$value$child = current$.value.children$) === null || _current$$value$child === void 0 ? void 0 : _current$$value$child.find((el$1)=>{
                                var _current$$value$eleme;
                                return el$1.name === (current$ === null || current$ === void 0 || (_current$$value$eleme = current$.value.elements) === null || _current$$value$eleme === void 0 ? void 0 : _current$$value$eleme[0]);
                            });
                            if (!firstEl$) return;
                            firstEl$.focus();
                        });
                    });
                    break;
                case 'finish':
                    finish();
                    break;
            }
        };
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            steps$: steps$,
            classes: classes,
            Templates: Templates,
            template: template,
            visible: visible,
            isDisabled: isDisabled,
            isLoading: isLoading,
            current$: current$,
            label: label,
            isLabelComponent: isLabelComponent,
            previous: previous,
            next: next,
            finish: finish,
            handleClick: handleClick
        };
    }
};
var FormStep = {
    name: 'FormStep',
    emits: [
        'activate',
        'inactivate',
        'enable',
        'disable',
        'complete'
    ],
    slots: [
        'default'
    ],
    props: {
        name: {
            type: [
                String,
                Number
            ],
            required: true
        },
        label: {
            type: [
                String,
                Object,
                Function
            ],
            required: false,
            default: null
        },
        labels: {
            type: [
                Object
            ],
            required: false,
            default: ()=>({})
        },
        buttons: {
            type: [
                Object
            ],
            required: false,
            default: ()=>({})
        },
        elements: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[]
        },
        conditions: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[]
        },
        addClass: {
            required: false,
            type: [
                Array,
                Object,
                String
            ],
            default: null
        },
        removeClass: {
            required: false,
            type: [
                Array,
                Object
            ],
            default: null
        },
        replaceClass: {
            required: false,
            type: [
                Object
            ],
            default: null
        },
        overrideClass: {
            required: false,
            type: [
                Array,
                Object,
                String
            ],
            default: null
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        onActivate: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        },
        onInactivate: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        },
        onDisable: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        },
        onEnable: {
            type: [
                Function
            ],
            required: false,
            default: null,
            private: true
        }
    },
    setup (props, context) {
        var { name, label, elements } = (0, $8bTPG.toRefs)(props);
        var $this = (0, $ani5R.getCurrentInstance)().proxy;
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        var { available, conditionList, updateConditions } = base$19(props, context, {
            form$: form$
        });
        var { isLabelComponent, label: stepLabel_ } = base$18(props, context, {
            component$: form$,
            labelDefinition: label
        });
        var { events, listeners, on, off, fire } = base$1h(props, context, {
            form$: form$
        }, {
            events: context.emits
        });
        // ================ DATA ================
        /**
     * The label of the step.
     *
     * @type {string|Component}
     * @default null
     */ var stepLabel = (0, $8bTPG.ref)(stepLabel_.value && typeof stepLabel_.value === 'object' ? (0, $8bTPG.markRaw)(stepLabel_.value) : stepLabel_.value);
        /**
     * Whether the step is active.
     *
     * @type {boolean}
     * @default false
     */ var active = (0, $8bTPG.ref)(false);
        /**
     * Whether the step is disabled.
     *
     * @type {boolean}
     * @default true
     */ var isDisabled = (0, $8bTPG.ref)(true);
        /**
     * Whether the step is completed.
     *
     * @type {boolean}
     * @default false
     */ var completed = (0, $8bTPG.ref)(false);
        // ============== COMPUTED ==============
        /**
     * The form elements' components.
     *
     * @type {object}
     */ var elements$ = (0, $8bTPG.computed)(()=>{
            return form$.value.elements$;
        });
        /**
     * The parent [`FormSteps`](form-steps) component.
     *
     * @type {FormSteps}
     */ var steps$ = (0, $8bTPG.computed)(()=>{
            return form$.value.steps$ || /* istanbul ignore next: failsafe only, step can not exist by itself */ {};
        });
        /**
     * The label definition of the component.
     *
     * @type {string}
     * @private
     */ var baseLabel = (0, $8bTPG.computed)(()=>{
            return label.value;
        });
        /**
     * Index of this step among the other steps which are not hidden by unmet conditions.
     *
     * @type {number}
     */ var index = (0, $8bTPG.computed)(()=>{
            var _steps$$value;
            return Object.keys((steps$ === null || steps$ === void 0 || (_steps$$value = steps$.value) === null || _steps$$value === void 0 ? void 0 : _steps$$value.steps$) || /* istanbul ignore next: failsafe only, step can not exist by itself */ {}).indexOf(name.value);
        });
        /**
     * Whether the step is the first.
     *
     * @type {boolean}
     */ var isFirst = (0, $8bTPG.computed)(()=>{
            return index.value === 0;
        });
        /**
     * Whether the step is the first.
     *
     * @type {boolean}
     */ var isLast = (0, $8bTPG.computed)(()=>{
            return steps$.value.last$.name === name.value;
        });
        /**
     * The elements' components in the step.
     *
     * @type {object}
     */ var children$ = (0, $8bTPG.computed)(()=>{
            return filter_1(elements$.value, (element$, key)=>{
                return elements.value.indexOf(key) !== -1;
            });
        });
        /**
     * Whether the step should be visible.
     *
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            return available.value;
        });
        /**
      * Whether the step has any invalid elements.
      *
      * @type {boolean}
      */ var invalid = (0, $8bTPG.computed)(()=>{
            return some_1(children$.value, {
                available: true,
                invalid: true
            });
        });
        /**
      * Whether the step has any pending elements.
      *
      * @type {boolean}
      */ var pending = (0, $8bTPG.computed)(()=>{
            return some_1(children$.value, {
                available: true,
                pending: true
            });
        });
        /**
      * Whether the step has any debouncing elements.
      *
      * @type {boolean}
      */ var debouncing = (0, $8bTPG.computed)(()=>{
            return some_1(children$.value, {
                available: true,
                debouncing: true
            });
        });
        /**
      * Whether all the elements in the step were already validated at least once.
      *
      * @type {boolean}
      */ var validated = (0, $8bTPG.computed)(()=>{
            return !some_1(children$.value, {
                available: true,
                validated: false
            });
        });
        /**
      * Whether the step has any busy elements.
      *
      * @type {boolean}
      */ var busy = (0, $8bTPG.computed)(()=>{
            return pending.value || debouncing.value;
        });
        /**
      * Whether the step is done (completed, validated has no invalid or pending elements).
      *
      * @type {boolean}
      */ var done = (0, $8bTPG.computed)(()=>{
            return completed.value && validated.value && !invalid.value && !pending.value;
        });
        /**
     * The step's component.
     *
     * @type {FormStep}
     */ var step$ = (0, $8bTPG.computed)(()=>{
            var _form$$value$steps$;
            return (_form$$value$steps$ = form$.value.steps$) === null || _form$$value$steps$ === void 0 ? void 0 : _form$$value$steps$.steps$[name.value];
        });
        // =============== METHODS ==============
        /**
     * Validate all elements within the step (async).
     *
     * @returns {Promise}
     */ var validate = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*() {
                // only skip validation if the elements
                // are validated and none is invalid and
                // elements get revalidated on change
                if (validated.value && !invalid.value && form$.value.shouldValidateOnChange) return;
                yield asyncForEach(children$.value, /*#__PURE__*/ function() {
                    var _ref2 = _asyncToGenerator(function*(element$) {
                        /* istanbul ignore else */ if ((!element$.validated || element$.invalid || !form$.value.shouldValidateOnChange) && element$.available && !element$.isStatic) yield element$.validate();
                    });
                    return function(_x) {
                        return _ref2.apply(this, arguments);
                    };
                }());
            });
            return function validate() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * Activate the step.
     *
     * @returns {void}
     */ var activate = ()=>{
            if (active.value) return;
            active.value = true;
            fire('activate');
        };
        /**
     * Deactivate the step.
     *
     * @returns {void}
     */ var deactivate = ()=>{
            if (!active.value) return;
            active.value = false;
            fire('inactivate');
        };
        /**
     * Enable the step.
     *
     * @returns {void}
     */ var enable = ()=>{
            if (!isDisabled.value) return;
            isDisabled.value = false;
            fire('enable');
        };
        /**
     * Disable the step.
     *
     * @returns {void}
     */ var disable = ()=>{
            if (isDisabled.value) return;
            isDisabled.value = true;
            fire('disable');
        };
        /**
     * Complete the step.
     *
     * @returns {void}
     */ var complete = ()=>{
            if (completed.value) return;
            completed.value = true;
            fire('complete');
        };
        /**
     * Uncomplete the step.
     *
     * @returns {void}
     */ var uncomplete = ()=>{
            completed.value = false;
        };
        /**
     * Deactivate all other steps and set the current one as active.
     *
     * @returns {void}
     */ var select = ()=>{
            var _steps$$value2, _steps$$value3;
            if (isDisabled.value || !((_steps$$value2 = steps$.value) !== null && _steps$$value2 !== void 0 && _steps$$value2.select)) return;
            (_steps$$value3 = steps$.value) === null || _steps$$value3 === void 0 || _steps$$value3.select(step$.value);
            each(children$.value, (element$)=>{
                element$.activate();
            });
            activate();
        };
        /**
      * Apply conditions of the step to its elements.
      *
      * @returns {void}
      * @private
      */ var addChildConditions = ()=>{
            /* istanbul ignore else */ if (conditionList.value.length == 0) return;
            Object.values(children$.value).forEach((element$)=>{
                element$.addConditions('step', conditionList.value);
            });
        };
        /**
      * Remove conditions of the elements of the step.
      *
      * @returns {void}
      * @private
      */ var removeChildConditions = ()=>{
            Object.values(children$.value).forEach((element$)=>{
                element$.removeConditions('step');
            });
        };
        /**
      * Resets conditions of the elements of the step.
      *
      * @returns {void}
      * @private
      */ var resetChildConditions = ()=>{
            removeChildConditions();
            addChildConditions();
        };
        /**
     * Set the component to the parent as if `refs` were used.
     *
     * @param {VNode} $parent parent component
     * @param {function} assignToParent the assignToParent function for recursion
     * @returns {void}
     * @private
     */ var assignToParent = ($parent, assignToParent)=>{
            if ($parent.steps$Array) $parent.steps$Array.push($this);
            else assignToParent($parent.$parent, assignToParent);
        };
        /**
    * Removes the component from the parent.
    *
    * @param {VNode} $parent parent component
    * @param {function} removeFromParent the removeFromParent function for recursion
    * @private
    */ var removeFromParent = ($parent, removeFromParent)=>{
            if ($parent.steps$Array) $parent.steps$Array.splice($parent.steps$Array.map((t$)=>normalize(t$.name)).indexOf(normalize(name.value)), 1);
            else /* @todo:adam test later */ removeFromParent($parent.$parent, removeFromParent);
        };
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(visible, (val)=>{
            // if a revealed step is earlier than the
            // current step, it should be enabled
            if (val && index.value < form$.value.steps$.current$.index) enable();
        });
        (0, $8bTPG.watch)(children$, ()=>{
            /* istanbul ignore else */ if (!active.value) return;
            each(children$.value, (element$)=>{
                element$.activate();
            });
        }, {
            deep: false,
            lazy: true
        });
        (0, $8bTPG.watch)(stepLabel_, ()=>{
            stepLabel.value = stepLabel_.value && typeof stepLabel_.value === 'object' ? (0, $8bTPG.markRaw)(stepLabel_.value) : stepLabel_.value;
        });
        (0, $8bTPG.watch)(conditionList, (n, o)=>{
            if (!(n !== null && n !== void 0 && n.length)) removeChildConditions();
            else addChildConditions();
        });
        // ================ HOOKS ===============
        (0, $ani5R.onMounted)(()=>{
            // nextTick is required because elements$
            // only available after form is mounted,
            // which is later than the steps mount
            (0, $ani5R.nextTick)(()=>{
                addChildConditions();
            });
        });
        (0, $ani5R.onBeforeMount)(()=>{
            assignToParent($this.$parent, assignToParent);
        });
        (0, $ani5R.onBeforeUnmount)(()=>{
            removeChildConditions();
            removeFromParent($this.$parent, removeFromParent);
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            steps$: steps$,
            elements$: elements$,
            active: active,
            isDisabled: isDisabled,
            isFirst: isFirst,
            isLast: isLast,
            completed: completed,
            events: events,
            listeners: listeners,
            children$: children$,
            visible: visible,
            invalid: invalid,
            pending: pending,
            classes: classes,
            Templates: Templates,
            template: template,
            available: available,
            baseLabel: baseLabel,
            debouncing: debouncing,
            validated: validated,
            busy: busy,
            done: done,
            step$: step$,
            isLabelComponent: isLabelComponent,
            stepLabel: stepLabel,
            index: index,
            conditionList: conditionList,
            validate: validate,
            activate: activate,
            deactivate: deactivate,
            enable: enable,
            disable: disable,
            complete: complete,
            uncomplete: uncomplete,
            select: select,
            on: on,
            off: off,
            fire: fire,
            addChildConditions: addChildConditions,
            removeChildConditions: removeChildConditions,
            resetChildConditions: resetChildConditions,
            updateConditions: updateConditions
        };
    }
};
var base$17 = function base(props, context, dependencies) {
    // ============== METHODS ===============
    /**
  * Transforms an element `type` into the element's component name.
  * 
  * @param {string} element* element `type`
  * @returns {string}
  * @private
  */ var component = (element)=>{
        return "".concat(upperFirst_1(camelCase_1(element.type)), "Element");
    };
    return {
        component: component
    };
};
var FormElements = {
    name: 'FormElements',
    slots: [
        'default'
    ],
    props: {
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, Size, View, classesInstance, theme, classes, Templates, template } = base$1a(props, context);
        var { component } = base$17();
        // ============ COMPUTED ============
        /**
     * The form schema.
     * 
     * @type {object}
     * @private
     */ var schema = (0, $8bTPG.computed)(()=>{
            return form$.value.options.schema;
        });
        return {
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            schema: schema,
            component: component
        };
    }
};
var base$16 = function base(props, context, dependencies) {
    // =============== INJECT ===============
    /**
  * The parent element's component.
  * 
  * @type {VueformElement}
  */ var el$1 = (0, $ani5R.inject)('el$');
    return {
        el$: el$1
    };
};
var base$15 = function base(props, context, dependencies) {
    var componentName = context.name;
    // =============== INJECT ===============
    var { form$ } = base$1e();
    var { el$: el$1 } = base$16();
    var { theme } = base$1d();
    var { Size } = base$1c();
    var { View } = base$1b(props, context);
    // ============== COMPUTED ===============
    /**
   * The component instance (self).
   * 
   * @type {VueformComponent}
   */ var component$ = (0, $8bTPG.computed)(()=>{
        return (0, $ani5R.getCurrentInstance)().proxy;
    });
    /**
   * The classes instance (for testing purpose).
   * 
   * @type {MergeClasses}
   * @private
   */ var classesInstance = (0, $8bTPG.computed)(()=>{
        return new MergeClasses({
            component: componentName.value,
            component$: component$,
            theme: theme.value,
            config: form$.value.$vueform.config,
            templates: Templates.value,
            view: View.value,
            merge: [
                form$.value.options,
                el$1.value
            ]
        });
    });
    /**
   * The component's classes.
   * 
   * @type {object}
   */ var classes = (0, $8bTPG.computed)(()=>{
        return classesInstance.value.classes;
    });
    /**
   * The list of templates available to the component.
   * 
   * @type {object}
   * @private
   */ var Templates = (0, $8bTPG.computed)(()=>{
        return el$1.value.Templates;
    });
    /**
   * The component's template.
   * 
   * @type {object}
   */ var template = (0, $8bTPG.computed)(()=>{
        return View.value && Templates.value["".concat(componentName.value, "_").concat(View.value)] ? Templates.value["".concat(componentName.value, "_").concat(View.value)] : Templates.value[componentName.value];
    });
    return {
        el$: el$1,
        form$: form$,
        theme: theme,
        Size: Size,
        View: View,
        classesInstance: classesInstance,
        classes: classes,
        Templates: Templates,
        template: template
    };
};
var ElementLayout = {
    name: 'ElementLayout',
    slots: [
        'field',
        'label',
        'info',
        'description',
        'before',
        'between',
        'after'
    ],
    props: {
        multiple: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        view: {
            type: [
                String
            ],
            required: false,
            default: undefined
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, el$: el$1, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * Whether the element should be visible.
     * 
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            return el$1.value.visible;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            Templates: Templates,
            template: template,
            classes: classes,
            visible: visible
        };
    }
};
var ElementLayoutInline = {
    name: 'ElementLayoutInline',
    slots: [
        'field',
        'label',
        'info',
        'description',
        'before',
        'between',
        'after'
    ],
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { form$, el$: el$1, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * Whether the element should be visible.
     * 
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            return el$1.value.visible;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            Templates: Templates,
            template: template,
            classes: classes,
            visible: visible
        };
    }
};
var ElementLoader = {
    name: 'ElementLoader',
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template
        };
    }
};
var ElementLabelFloating = {
    name: 'ElementLabelFloating',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // =============== INJECT ===============
        var config$ = (0, $ani5R.inject)('config$');
        // ============== COMPUTED ==============
        /**
     * The floating label of the element, defined via `floating` prop.
     *
     * @type {string}
     */ var floating = (0, $8bTPG.computed)(()=>{
            var _form$$value$options$;
            var floating = localize(el$1.value.floating || /* istanbul ignore next: tested, but not covered */ (form$.value.options.floatPlaceholders ? el$1.value.placeholder : null), config$.value, form$.value);
            if (el$1.value.isRequired && ((_form$$value$options$ = form$.value.options.showRequired) === null || _form$$value$options$ === void 0 ? void 0 : _form$$value$options$.indexOf('floating')) !== -1) floating += '*';
            return floating;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            floating: floating
        };
    }
};
var ElementLabel = {
    name: 'ElementLabel',
    slots: [
        'default',
        'info'
    ],
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        var { label, isLabelComponent } = base$18(props, context, {
            labelDefinition: (0, $8bTPG.computed)(()=>{
                return el$1.value.label;
            }),
            component$: el$1
        });
        // ============== COMPUTED ==============
        /**
     * The name of the element.
     *
     * @type {string}
     * @private
     */ var name = (0, $8bTPG.computed)(()=>{
            return el$1.value.fieldId;
        });
        /**
     * The `id` attribute of the container.
     *
     * @type {string}
     */ var id = (0, $8bTPG.computed)(()=>{
            return el$1.value.labelId;
        });
        /**
     * Whether the element has a `label` option, a `#label` slot or `Vueform` component's [`forceLabels`](vueform#force-labels) option is `true`.
     *
     * @type {boolean}
     *
     */ var hasLabel = (0, $8bTPG.computed)(()=>{
            return el$1.value.hasLabel;
        });
        /**
     * Whether the label is provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots.label || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots.label || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo.label);
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            label: label,
            isLabelComponent: isLabelComponent,
            name: name,
            id: id,
            hasLabel: hasLabel,
            isSlot: isSlot
        };
    }
};
function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
var ElementInfo = {
    name: 'ElementInfo',
    slots: [
        'default'
    ],
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // =============== INJECT ===============
        var config$ = (0, $ani5R.inject)('config$');
        // ================ DATA ================
        /**
     * The position of the info.
     *
     * @type {boolean}
     * @default false
     * @private
     */ var position = (0, $8bTPG.ref)(el$1.value.infoPosition);
        // ============== COMPUTED ==============
        /**
     * The info for the element, defined via the element's `info` prop.
     *
     * @type {string}
     */ var info = (0, $8bTPG.computed)(()=>{
            return localize(el$1.value.info, config$.value, form$.value);
        });
        /**
     * The `id` attribute of the container.
     *
     * @type {string}
     */ var id = (0, $8bTPG.computed)(()=>{
            return el$1.value.infoId;
        });
        /**
     * Whether the info is provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots.info || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots.info || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo.info);
        });
        // =============== METHODS ==============
        /**
     * Handles the info hover.
     *
     * @param {Event|object} e
     * @returns {Promise}
     * @private
     */ /* istanbul ignore next: not worth it */ var handleMouseOver = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*(e) {
                if (position.value !== el$1.value.infoPosition) return;
                yield (0, $ani5R.nextTick)();
                var wrapper = e.target.querySelector('div');
                if (!wrapper) return;
                if (!isInViewport(wrapper)) position.value = 'right';
                yield (0, $ani5R.nextTick)();
                if (!isInViewport(wrapper)) position.value = 'top';
                yield (0, $ani5R.nextTick)();
                if (!isInViewport(wrapper)) position.value = 'left';
                yield (0, $ani5R.nextTick)();
                if (!isInViewport(wrapper)) position.value = 'bottom';
            });
            return function handleMouseOver(_x) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            info: info,
            isSlot: isSlot,
            position: position,
            id: id,
            handleMouseOver: handleMouseOver
        };
    }
};
var ElementDescription = {
    name: 'ElementDescription',
    slots: [
        'default'
    ],
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // =============== INJECT ===============
        var config$ = (0, $ani5R.inject)('config$');
        // ============== COMPUTED ==============
        /**
     * The element's description, defined via the element's `description` option.
     *
     * @type {string}
     */ var description = (0, $8bTPG.computed)(()=>{
            return localize(el$1.value.description, config$.value, form$.value);
        });
        /**
     * The `id` attribute of the container.
     *
     * @type {string}
     */ var id = (0, $8bTPG.computed)(()=>{
            return el$1.value.descriptionId;
        });
        /**
     * Whether the description is provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots.description || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots.description || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo.description);
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            description: description,
            isSlot: isSlot,
            id: id
        };
    }
};
var ElementError = {
    name: 'ElementError',
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * The first error of the element.
     * 
     * @type {string}
     */ var error = (0, $8bTPG.computed)(()=>{
            return el$1.value.error;
        });
        /**
     * Whether to show the error.
     * 
     * @type {boolean}
     */ var showError = (0, $8bTPG.computed)(()=>{
            return error.value && el$1.value.displayErrors;
        });
        /**
     * The `id` attribute of the container.
     * 
     * @type {string}
     */ var id = (0, $8bTPG.computed)(()=>{
            return el$1.value.errorId;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            error: error,
            showError: showError,
            id: id
        };
    }
};
var ElementMessage = {
    name: 'ElementMessage',
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * The first message of the element.
     *
     * @type {string}
     */ var message = (0, $8bTPG.computed)(()=>{
            return el$1.value.messageBag ? el$1.value.messageBag.message : /* istanbul ignore next: messageBag itself will always be defined */ null;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            message: message
        };
    }
};
var ElementRequired = {
    name: 'ElementRequired',
    slots: [
        'default'
    ],
    setup (props, context) {
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * Whether the required sign (*) should be visible.
     * 
     * @type {boolean}
     */ var visible = (0, $8bTPG.computed)(()=>{
            var _form$$value$options$;
            return el$1.value.isRequired && ((_form$$value$options$ = form$.value.options.showRequired) === null || _form$$value$options$ === void 0 ? void 0 : _form$$value$options$.indexOf('label')) !== -1;
        });
        /**
     * Whether the required is provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots.required || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots.required || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo.required);
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            visible: visible,
            isSlot: isSlot
        };
    }
};
var ElementText = {
    name: 'ElementText',
    slots: [
        'default'
    ],
    props: {
        type: {
            type: String,
            required: true
        }
    },
    setup (props, context) {
        var { type } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // =============== INJECT ===============
        var config$ = (0, $ani5R.inject)('config$');
        // ============== COMPUTED ==============
        /**
     * The value of the content type.
     *
     * @type {string}
     * @private
     */ var content = (0, $8bTPG.computed)(()=>{
            return localize(el$1.value[type.value], config$.value, form$.value);
        });
        /**
     * Whether the contents are provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots[type.value] || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots[type.value] || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo[type.value]);
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            content: content,
            isSlot: isSlot
        };
    }
};
var DragAndDrop = {
    name: 'DragAndDrop',
    emits: [
        'click',
        'drop'
    ],
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup (props, context) {
        var { disabled } = (0, $8bTPG.toRefs)(props);
        // ============== DEPENDENCIES ==============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ================ DATA ================
        /**
     * Whether the user is currently dragging a file over the drag and drop area.
     * 
     * @type {boolean}
     * @default falyse
     */ var dragging = (0, $8bTPG.ref)(false);
        /**
     * The DOM element of the drag and drop area.
     * 
     * @type {HTMLElement}
     * @default null
     */ var area = (0, $8bTPG.ref)(null);
        // =============== METHODS ==============
        /**
     * Handles `click` event.
     * 
     * @returns {void}
     * @private
     */ var handleClick = ()=>{
            context.emit('click');
        };
        // ================ HOOKS ===============
        (0, $ani5R.onMounted)(()=>{
            // cancelling all default events
            each([
                'drag',
                'dragstart',
                'dragend',
                'dragover',
                'dragenter',
                'dragleave',
                'drop'
            ], (event)=>{
                area.value.addEventListener(event, (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
            // listening for the actual drop event
            area.value.addEventListener('drop', (e)=>{
                if (disabled.value) return;
                context.emit('drop', e);
                dragging.value = false;
            });
            area.value.addEventListener('dragover', (e)=>{
                if (disabled.value) return;
                if (dragging.value !== true) dragging.value = true;
            });
            area.value.addEventListener('dragleave', (e)=>{
                if (disabled.value) return;
                dragging.value = false;
            });
            area.value.addEventListener('dragend', (e)=>{
                if (disabled.value) return;
                dragging.value = false;
            });
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            dragging: dragging,
            area: area,
            handleClick: handleClick
        };
    }
};
var ElementAddon = {
    name: 'ElementAddon',
    slots: [
        'default'
    ],
    props: {
        type: {
            required: true,
            type: String
        }
    },
    setup (props, context) {
        var { type } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { form$, el$: el$1, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // =============== INJECT ===============
        var config$ = (0, $ani5R.inject)('config$');
        // ============== COMPUTED ==============
        /**
     * The addon definition.
     * ponent.
     *
     * @type {string|function|Component}
     * @private
     */ var baseAddon = (0, $8bTPG.computed)(()=>{
            return el$1.value.addons[type.value];
        });
        /**
     * The content of the addon. If the addon is provided ss a `function` this contains the resolved value.
     *
     * @type {string|Component}
     */ var addon = (0, $8bTPG.computed)(()=>{
            var addon = isAddonFunction.value ? baseAddon.value(el$1.value) : baseAddon.value || /* istanbul ignore next: failsafe */ null;
            if (!isAddonComponent.value) addon = localize(addon, config$.value, form$.value);
            return addon;
        });
        /**
    * Whether the addon is provided as a function.
    *
    * @type {boolean}
    * @private
    */ var isAddonFunction = (0, $8bTPG.computed)(()=>{
            return typeof baseAddon.value === 'function' && (!baseAddon.value.prototype || !baseAddon.value.prototype.constructor || baseAddon.value.prototype.constructor && baseAddon.value.prototype.constructor.name !== 'VueComponent');
        });
        /**
    * Whether addon is provided as a Vue component.
    *
    * @type {boolean}
    * @private
    */ var isAddonComponent = (0, $8bTPG.computed)(()=>{
            return isVueComponent(baseAddon.value);
        });
        /**
     * Whether the label is provided as a slot.
     *
     * @type {boolean}
     * @private
     */ var isSlot = (0, $8bTPG.computed)(()=>{
            var _el$$value$slots, _el$$value$$slots, _el$$value$$scopedSlo;
            // @todo:adam last condition is a duplicate of the first one
            return !!((_el$$value$slots = el$1.value.slots) !== null && _el$$value$slots !== void 0 && _el$$value$slots["addon-".concat(type.value)] || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots["addon-".concat(type.value)] || /* istanbul ignore next: Vue2 is not checked */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo["addon-".concat(type.value)] || /* istanbul ignore next */ el$1.value.slots["addon-".concat(type.value)]);
        });
        return {
            el$: el$1,
            form$: form$,
            theme: theme,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            Templates: Templates,
            template: template,
            classes: classes,
            addon: addon,
            isAddonComponent: isAddonComponent,
            isSlot: isSlot
        };
    }
};
var ElementAddonOptions = {
    name: 'ElementAddonOptions',
    emits: [
        'select',
        'open',
        'close'
    ],
    props: {
        options: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[]
        },
        placeholder: {
            type: [
                String,
                Number,
                Object
            ],
            required: false,
            default: ''
        },
        relaxed: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        position: {
            type: [
                String
            ],
            required: false,
            default: 'over'
        },
        aria: {
            type: [
                Object
            ],
            required: false,
            default: ()=>({})
        }
    },
    setup (props, context) {
        var { options, position } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { form$, el$: el$1, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        var { events, listeners, on, off, fire } = base$1h(props, context, {
            form$: form$
        }, {
            events: context.emits
        });
        // ================ DATA ================
        /**
     * Whether the dropdown list is open.
     *
     * @type {boolean}
     */ var isOpen = (0, $8bTPG.ref)(false);
        /**
     * The container div.
     *
     * @type {HTMLElement}
     */ var selector = (0, $8bTPG.ref)(null);
        /**
     * The dropdown container div.
     *
     * @type {HTMLElement}
     */ var dropdown = (0, $8bTPG.ref)(null);
        /**
     * The left position of the dropdown.
     *
     * @type {number|undefined}
     */ var left = (0, $8bTPG.ref)(undefined);
        /**
     * The right position of the dropdown.
     *
     * @type {number|undefined}
     */ var right = (0, $8bTPG.ref)(undefined);
        /**
     * The top position of the dropdown.
     *
     * @type {number|undefined}
     */ var top = (0, $8bTPG.ref)(undefined);
        /**
     * The bottom position of the dropdown.
     *
     * @type {number|undefined}
     */ var bottom = (0, $8bTPG.ref)(undefined);
        /**
     * The current search term.
     *
     * @type {string}
     */ var search = (0, $8bTPG.ref)('');
        /**
     * Store for search timeout.
     *
     * @type {object}
     */ var searchTimeout = (0, $8bTPG.ref)(null);
        /**
     * Store for resize timeout.
     *
     * @type {object}
     */ var resizeTimeout = (0, $8bTPG.ref)(null);
        /**
     * Whether selection on hover is disabled.
     *
     * @type {boolean}
     */ var hoverDisabled = (0, $8bTPG.ref)(false);
        /**
     * Whether the option list is from top to bottom.
     *
     * @type {boolean}
     */ var fullHeight = (0, $8bTPG.ref)(false);
        /**
     * The currently selected option.
     *
     * @type {object}
     */ var selected = (0, $8bTPG.ref)({});
        /**
     * The currently pointed option.
     *
     * @type {object}
     */ var pointed = (0, $8bTPG.ref)({});
        // ============== COMPUTED ==============
        /**
     * The option that should be focused according to current [`search`](#property-search) term.
     *
     * @type {array}
     */ var focused = (0, $8bTPG.computed)(()=>{
            if (!search.value) return {};
            return options.value.find((o)=>o.label.toLowerCase().startsWith(search.value.toString().toLowerCase()));
        });
        /**
     * Additional `style` attribute for the dropdown (position values).
     *
     * @type {object}
     */ var style = (0, $8bTPG.computed)(()=>{
            return {
                left: left.value !== undefined ? "".concat(left.value, "px") : undefined,
                right: right.value !== undefined ? "".concat(right.value, "px") : undefined,
                top: top.value !== undefined ? "".concat(top.value, "px") : undefined,
                bottom: bottom.value !== undefined ? "".concat(bottom.value, "px") : 'auto'
            };
        });
        // =============== METHODS ==============
        /**
     * Closes the dropdown.
     * 
     * @returns {void}
     */ var close = ()=>{
            top.value = undefined;
            bottom.value = undefined;
            fullHeight.value = false;
            isOpen.value = false;
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('keydown', handleKeydown);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll);
            search.value = '';
            context.emit('close');
        };
        /**
     * Opens the dropdown.
     * 
     * @returns {void}
     */ var open = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*() {
                isOpen.value = true;
                yield (0, $ani5R.nextTick)();
                var selectorRect = selector.value.getBoundingClientRect();
                if (selector.value.closest('[dir="rtl"]')) {
                    left.value = undefined;
                    right.value = window.innerWidth - (selectorRect.left + selectorRect.width);
                } else {
                    right.value = undefined;
                    left.value = selectorRect.left;
                }
                resizeDropdown();
                scrollToSelected();
                setTimeout(()=>{
                    document.addEventListener('click', handleClickOutside);
                    document.addEventListener('keydown', handleKeydown);
                    window.addEventListener('resize', handleResize);
                    window.addEventListener('scroll', handleScroll);
                }, 0);
                context.emit('open');
            });
            return function open() {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * Scroll the dropdown to an option.
     * 
     * @param {object} option* an option object form [`options`](#option-options).
     * @returns {void}
     */ var scrollToOption = (option)=>{
            if (fullHeight.value) {
                var selectorRect = selector.value.getBoundingClientRect();
                var optionRect = option.getBoundingClientRect();
                var targetCenterY = selectorRect.top + selectorRect.height / 2;
                var optionCenterY = optionRect.top + optionRect.height / 2;
                var centerDiff = targetCenterY - optionCenterY;
                var newScrollTop = dropdown.value.scrollTop - centerDiff;
                dropdown.value.scrollTop = newScrollTop;
            } else {
                var _optionRect = option.getBoundingClientRect();
                var dropdownRect = dropdown.value.getBoundingClientRect();
                var optionTopWithinDiv = _optionRect.top - dropdownRect.top;
                dropdown.value.scrollTop = optionTopWithinDiv + dropdown.value.scrollTop;
            }
        };
        /**
     * Scroll to the currently selected option (async).
     * 
     * @returns {void}
     */ var scrollToSelected = /*#__PURE__*/ function() {
            var _ref2 = _asyncToGenerator(function*() {
                yield (0, $ani5R.nextTick)();
                var option = document.querySelector("[data-dropdown-for=\"".concat(el$1.value.fieldId, "\"] [data-selected=\"true\"]"));
                if (!option) return;
                scrollToOption(option);
            });
            return function scrollToSelected() {
                return _ref2.apply(this, arguments);
            };
        }();
        /**
     * Resizes the dropdown to best fit into screen.
     * 
     * @returns {void}
     */ var resizeDropdown = ()=>{
            if (dropdown.value.getBoundingClientRect().height >= window.innerHeight - 32) {
                fullHeight.value = true;
                top.value = 16;
                bottom.value = 16;
            } else {
                fullHeight.value = false;
                var selectorRect = selector.value.getBoundingClientRect();
                var newTop = selectorRect.top;
                if (position.value === 'bottom') newTop += selectorRect.height;
                else position.value;
                top.value = newTop;
                if (dropdown.value.getBoundingClientRect().height > window.innerHeight - selector.value.getBoundingClientRect().top - 16) bottom.value = 16;
                else bottom.value = undefined;
            }
        };
        /**
     * Select an option.
     * 
     * @param {object} option* an option object form [`options`](#option-options).
     * @returns {void}
     */ var selectOption = (option)=>{
            selected.value = option;
            fire('select', option);
        };
        /**
     * Removes the selected option.
     * 
     * @returns {void}
     */ var reset = ()=>{
            selected.value = {};
            fire('select', {});
        };
        /**
     * Handles pointing an option (sets [`pointed`](#property-pointed)).
     * 
     * @param {object} option* an option object form [`options`](#option-options).
     * @returns {void}
     */ var handleOptionPoint = (option)=>{
            if (hoverDisabled.value) return;
            pointed.value = option;
        };
        /**
     * Handle the click of an option.
     * 
     * @param {object} option* an option object form [`options`](#option-options).
     * @returns {void}
     */ var handleOptionClick = (option)=>{
            selectOption(option);
            close();
            el$1.value.input.focus();
        };
        /**
     * Handles the click of collapsed element.
     * 
     * @params {Event} event* the Event
     * @returns {void}
     */ var handleSelectorClick = (e)=>{
            open();
        };
        /**
     * Handles the keydown even of the collapsed element when focused (async).
     * 
     * @params {Event} event* the Event
     * @returns {void}
     */ var handleSelectorKeydown = /*#__PURE__*/ function() {
            var _ref3 = _asyncToGenerator(function*(e) {
                if (isOpen.value) return;
                if ([
                    'Enter',
                    ' ',
                    'ArrowDown',
                    'ArrowUp'
                ].indexOf(e.key) !== -1) {
                    e.preventDefault();
                    open();
                    yield (0, $ani5R.nextTick)();
                    var index = selected.value.index !== undefined ? selected.value.index : pointed.value.index || 0;
                    var option = document.querySelector("[data-dropdown-for=\"".concat(el$1.value.fieldId, "\"] [data-index=\"").concat(index, "\"]"));
                    pointed.value = options.value.find((c)=>c.index === index);
                    option.focus();
                }
            });
            return function handleSelectorKeydown(_x) {
                return _ref3.apply(this, arguments);
            };
        }();
        /**
     * Handles clicking outside of the dropdown once opened (closes it).
     * 
     * @params {Event} event* the Event
     * @returns {void}
     */ var handleClickOutside = (e)=>{
            var _dropdown$value;
            if (!((_dropdown$value = dropdown.value) !== null && _dropdown$value !== void 0 && _dropdown$value.contains(e.target))) close();
        };
        /**
     * Handles the keydown event when the dropdown is open.
     * 
     * @params {Event} event* the Event
     * @returns {void}
     */ var handleKeydown = (e)=>{
            var _pointed$value;
            if (e.key === 'Escape') {
                close();
                selector.value.focus();
                return;
            }
            if ([
                'Enter',
                ' '
            ].indexOf(e.key) !== -1 && ((_pointed$value = pointed.value) === null || _pointed$value === void 0 ? void 0 : _pointed$value.index) !== undefined) {
                e.preventDefault();
                selectOption(pointed.value);
                close();
                el$1.value.input.focus();
                return;
            }
            if (e.key === 'Tab') {
                e.preventDefault();
                close();
                el$1.value.input.focus();
                return;
            }
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                var index = pointed.value.index === undefined ? -1 : pointed.value.index;
                var nextIndex = index + 1;
                if (options.value.length < nextIndex + 1) nextIndex = 0;
                hoverDisabled.value = true;
                pointed.value = options.value.find((c)=>c.index === nextIndex);
                var option = document.querySelector("[data-dropdown-for=\"".concat(el$1.value.fieldId, "\"] [data-index=\"").concat(nextIndex, "\"]"));
                scrollToOption(option);
                option.focus();
                setTimeout(()=>{
                    hoverDisabled.value = false;
                }, 2);
                return;
            }
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                var _index = pointed.value.index || 0;
                var prevIndex = _index - 1;
                if (prevIndex < 0) prevIndex = options.value.length - 1;
                hoverDisabled.value = true;
                pointed.value = options.value.find((c)=>c.index === prevIndex);
                var _option = document.querySelector("[data-dropdown-for=\"".concat(el$1.value.fieldId, "\"] [data-index=\"").concat(prevIndex, "\"]"));
                scrollToOption(_option);
                _option.focus();
                setTimeout(()=>{
                    hoverDisabled.value = false;
                }, 0);
                return;
            }
            if (e.key === 'Backspace' && search.value.length) {
                search.value = search.value.slice(0, -1);
                return;
            }
            if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
                search.value += e.key;
                hoverDisabled.value = true;
                if (searchTimeout.value) clearTimeout(searchTimeout.value);
                searchTimeout.value = setTimeout(()=>{
                    search.value = '';
                }, 1000);
                setTimeout(()=>{
                    hoverDisabled.value = false;
                }, 0);
            }
        };
        /**
     * Handles the window resize event (closes the dropdown if open).
     * 
     * @returns {void}
     */ var handleResize = ()=>{
            close();
        };
        /**
     * Handles the window scroll event (resizes the dropdown if needed).
     * 
     * @returns {void}
     */ var handleScroll = ()=>{
            if (resizeTimeout.value) clearTimeout(resizeTimeout.value);
            resizeTimeout.value = setTimeout(()=>{
                resizeDropdown();
            }, 50);
        };
        // =============== HOOKS ================
        (0, $ani5R.onBeforeUnmount)(()=>{
            close();
        });
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(focused, (option)=>{
            if (!option || option.index === undefined) return;
            var optionEl = document.querySelector("[data-dropdown-for=\"".concat(el$1.value.fieldId, "\"] [data-index=\"").concat(option.index, "\"]"));
            scrollToOption(optionEl);
            pointed.value = option;
            optionEl.focus();
        });
        return {
            form$: form$,
            el$: el$1,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            events: events,
            listeners: listeners,
            on: on,
            off: off,
            fire: fire,
            isOpen: isOpen,
            selector: selector,
            dropdown: dropdown,
            left: left,
            right: right,
            top: top,
            bottom: bottom,
            style: style,
            search: search,
            searchTimeout: searchTimeout,
            hoverDisabled: hoverDisabled,
            selected: selected,
            pointed: pointed,
            focused: focused,
            close: close,
            scrollToOption: scrollToOption,
            scrollToSelected: scrollToSelected,
            selectOption: selectOption,
            reset: reset,
            handleOptionPoint: handleOptionPoint,
            handleOptionClick: handleOptionClick,
            handleSelectorClick: handleSelectorClick,
            handleSelectorKeydown: handleSelectorKeydown,
            handleClickOutside: handleClickOutside,
            handleKeydown: handleKeydown,
            handleResize: handleResize
        };
    }
};
var HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var defaults$1 = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};
var english = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var pad = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var int = function(bool) {
    return bool === true ? 1 : 0;
};
function debounce$1(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var arrayify = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};
function toggleClass$1(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function clearNode(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function findParent(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return findParent(node.parentNode, condition);
    return undefined;
}
function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}
var doNothing = function() {
    return undefined;
};
var monthToStr = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var revFormat = {
    D: doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var formats = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return pad(formats.h(date, locale, options));
    },
    H: function(date) {
        return pad(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[int(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return monthToStr(date.getMonth(), true, locale);
    },
    S: function(date) {
        return pad(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return pad(date.getFullYear(), 4);
    },
    d: function(date) {
        return pad(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return pad(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return pad(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};
var createDateFormatter = function(_a) {
    var _b = _a.config, config = _b === void 0 ? defaults$1 : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var createDateParser = function(_a) {
    var _b = _a.config, config = _b === void 0 ? defaults$1 : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || defaults$1).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if (tokenRegex[token] && !escaped) {
                        regexStr += tokenRegex[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: revFormat[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function compareDates(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
var isBetween = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var duration = {
    DAY: 86400000
};
function getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};
var __assign = function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
    var self1 = {
        config: __assign(__assign({}, defaults$1), flatpickr.defaultConfig),
        l10n: english
    };
    self1.parseDate = createDateParser({
        config: self1.config,
        l10n: self1.l10n
    });
    self1._handlers = [];
    self1.pluginElements = [];
    self1.loadedPlugins = [];
    self1._bind = bind;
    self1._setHoursFromDate = setHoursFromDate;
    self1._positionCalendar = positionCalendar;
    self1.changeMonth = changeMonth;
    self1.changeYear = changeYear;
    self1.clear = clear;
    self1.close = close;
    self1.onMouseOver = onMouseOver;
    self1._createElement = createElement;
    self1.createDay = createDay;
    self1.destroy = destroy;
    self1.isEnabled = isEnabled;
    self1.jumpToDate = jumpToDate;
    self1.updateValue = updateValue;
    self1.open = open;
    self1.redraw = redraw;
    self1.set = set;
    self1.setDate = setDate;
    self1.toggle = toggle;
    function setupHelperFunctions() {
        self1.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self1.currentMonth;
                if (yr === void 0) yr = self1.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self1.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self1.element = self1.input = element;
        self1.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self1.isMobile) build();
        bindEvents();
        if (self1.selectedDates.length || self1.config.noCalendar) {
            if (self1.config.enableTime) setHoursFromDate(self1.config.noCalendar ? self1.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self1.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self1.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self1);
    }
    function setCalendarWidth() {
        var config = self1.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self1.calendarContainer !== undefined) {
                self1.calendarContainer.style.visibility = "hidden";
                self1.calendarContainer.style.display = "block";
            }
            if (self1.daysContainer !== undefined) {
                var daysWidth = (self1.days.offsetWidth + 1) * config.showMonths;
                self1.daysContainer.style.width = daysWidth + "px";
                self1.calendarContainer.style.width = daysWidth + (self1.weekWrapper !== undefined ? self1.weekWrapper.offsetWidth : 0) + "px";
                self1.calendarContainer.style.removeProperty("visibility");
                self1.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self1.selectedDates.length === 0) {
            var defaultDate = self1.config.minDate === undefined || compareDates(new Date(), self1.config.minDate) >= 0 ? new Date() : new Date(self1.config.minDate.getTime());
            var defaults = getDefaultHours(self1.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self1.selectedDates = [
                defaultDate
            ];
            self1.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self1._input.value;
        setHoursFromInputs();
        updateValue();
        if (self1._input.value !== prevValue) self1._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * int(amPM === self1.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self1.hourElement === undefined || self1.minuteElement === undefined) return;
        var hours = (parseInt(self1.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self1.minuteElement.value, 10) || 0) % 60, seconds = self1.secondElement !== undefined ? (parseInt(self1.secondElement.value, 10) || 0) % 60 : 0;
        if (self1.amPM !== undefined) hours = ampm2military(hours, self1.amPM.textContent);
        var limitMinHours = self1.config.minTime !== undefined || self1.config.minDate && self1.minDateHasTime && self1.latestSelectedDateObj && compareDates(self1.latestSelectedDateObj, self1.config.minDate, true) === 0;
        var limitMaxHours = self1.config.maxTime !== undefined || self1.config.maxDate && self1.maxDateHasTime && self1.latestSelectedDateObj && compareDates(self1.latestSelectedDateObj, self1.config.maxDate, true) === 0;
        if (self1.config.maxTime !== undefined && self1.config.minTime !== undefined && self1.config.minTime > self1.config.maxTime) {
            var minBound = calculateSecondsSinceMidnight(self1.config.minTime.getHours(), self1.config.minTime.getMinutes(), self1.config.minTime.getSeconds());
            var maxBound = calculateSecondsSinceMidnight(self1.config.maxTime.getHours(), self1.config.maxTime.getMinutes(), self1.config.maxTime.getSeconds());
            var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = parseSeconds(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self1.config.maxTime !== undefined ? self1.config.maxTime : self1.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self1.config.minTime !== undefined ? self1.config.minTime : self1.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self1.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self1.latestSelectedDateObj !== undefined) self1.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self1.hourElement || !self1.minuteElement || self1.isMobile) return;
        self1.hourElement.value = pad(!self1.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
        self1.minuteElement.value = pad(minutes);
        if (self1.amPM !== undefined) self1.amPM.textContent = self1.l10n.amPM[int(hours >= 12)];
        if (self1.secondElement !== undefined) self1.secondElement.value = pad(seconds);
    }
    function onYearInput(event) {
        var eventTarget = getEventTarget(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self1._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self1.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self1.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self1[evt]);
            });
        });
        if (self1.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = debounce$1(onResize, 50);
        self1._debouncedChange = debounce$1(triggerChange, DEBOUNCED_CHANGE_MS);
        if (self1.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self1.daysContainer, "mouseover", function(e) {
            if (self1.config.mode === "range") onMouseOver(getEventTarget(e));
        });
        bind(self1._input, "keydown", onKeyDown);
        if (self1.calendarContainer !== undefined) bind(self1.calendarContainer, "keydown", onKeyDown);
        if (!self1.config.inline && !self1.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self1.config.clickOpens === true) {
            bind(self1._input, "focus", self1.open);
            bind(self1._input, "click", self1.open);
        }
        if (self1.daysContainer !== undefined) {
            bind(self1.monthNav, "click", onMonthNavClick);
            bind(self1.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self1.daysContainer, "click", selectDate);
        }
        if (self1.timeContainer !== undefined && self1.minuteElement !== undefined && self1.hourElement !== undefined) {
            var selText = function(e) {
                return getEventTarget(e).select();
            };
            bind(self1.timeContainer, [
                "increment"
            ], updateTime);
            bind(self1.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self1.timeContainer, "click", timeIncrement);
            bind([
                self1.hourElement,
                self1.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self1.secondElement !== undefined) bind(self1.secondElement, "focus", function() {
                return self1.secondElement && self1.secondElement.select();
            });
            if (self1.amPM !== undefined) bind(self1.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self1.config.allowInput) bind(self1._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self1.parseDate(jumpDate) : self1.latestSelectedDateObj || (self1.config.minDate && self1.config.minDate > self1.now ? self1.config.minDate : self1.config.maxDate && self1.config.maxDate < self1.now ? self1.config.maxDate : self1.now);
        var oldYear = self1.currentYear;
        var oldMonth = self1.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self1.currentYear = jumpTo.getFullYear();
                self1.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self1.config.errorHandler(e);
        }
        if (triggerChange && self1.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self1.currentYear !== oldYear || self1.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self1.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = getEventTarget(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && getEventTarget(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self1.calendarContainer = createElement("div", "flatpickr-calendar");
        self1.calendarContainer.tabIndex = -1;
        if (!self1.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self1.innerContainer = createElement("div", "flatpickr-innerContainer");
            if (self1.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self1.innerContainer.appendChild(weekWrapper);
                self1.weekNumbers = weekNumbers;
                self1.weekWrapper = weekWrapper;
            }
            self1.rContainer = createElement("div", "flatpickr-rContainer");
            self1.rContainer.appendChild(buildWeekdays());
            if (!self1.daysContainer) {
                self1.daysContainer = createElement("div", "flatpickr-days");
                self1.daysContainer.tabIndex = -1;
            }
            buildDays();
            self1.rContainer.appendChild(self1.daysContainer);
            self1.innerContainer.appendChild(self1.rContainer);
            fragment.appendChild(self1.innerContainer);
        }
        if (self1.config.enableTime) fragment.appendChild(buildTime());
        toggleClass$1(self1.calendarContainer, "rangeMode", self1.config.mode === "range");
        toggleClass$1(self1.calendarContainer, "animate", self1.config.animate === true);
        toggleClass$1(self1.calendarContainer, "multiMonth", self1.config.showMonths > 1);
        self1.calendarContainer.appendChild(fragment);
        var customAppend = self1.config.appendTo !== undefined && self1.config.appendTo.nodeType !== undefined;
        if (self1.config.inline || self1.config.static) {
            self1.calendarContainer.classList.add(self1.config.inline ? "inline" : "static");
            if (self1.config.inline) {
                if (!customAppend && self1.element.parentNode) self1.element.parentNode.insertBefore(self1.calendarContainer, self1._input.nextSibling);
                else if (self1.config.appendTo !== undefined) self1.config.appendTo.appendChild(self1.calendarContainer);
            }
            if (self1.config.static) {
                var wrapper = createElement("div", "flatpickr-wrapper");
                if (self1.element.parentNode) self1.element.parentNode.insertBefore(wrapper, self1.element);
                wrapper.appendChild(self1.element);
                if (self1.altInput) wrapper.appendChild(self1.altInput);
                wrapper.appendChild(self1.calendarContainer);
            }
        }
        if (!self1.config.static && !self1.config.inline) (self1.config.appendTo !== undefined ? self1.config.appendTo : window.document.body).appendChild(self1.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self1.formatDate(date, self1.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && compareDates(date, self1.now) === 0) {
            self1.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self1.selectedDateElem = dayElement;
                if (self1.config.mode === "range") {
                    toggleClass$1(dayElement, "startRange", self1.selectedDates[0] && compareDates(date, self1.selectedDates[0], true) === 0);
                    toggleClass$1(dayElement, "endRange", self1.selectedDates[1] && compareDates(date, self1.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self1.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self1.weekNumbers && self1.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self1.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self1.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self1.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self1.config.showMonths - 1;
        var endMonth = delta > 0 ? self1.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self1.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self1.currentMonth;
        var endMonth = delta > 0 ? self1.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self1.currentMonth; m != endMonth; m += loopDelta){
            var month = self1.daysContainer.children[m];
            var startIndex = givenMonth - self1.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self1.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self1.selectedDateElem !== undefined && isInView(self1.selectedDateElem) ? self1.selectedDateElem : self1.todayDateElem !== undefined && isInView(self1.todayDateElem) ? self1.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self1._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self1.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self1.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self1.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self1.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self1.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = createElement("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self1.daysContainer === undefined) return;
        clearNode(self1.daysContainer);
        if (self1.weekNumbers) clearNode(self1.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self1.config.showMonths; i++){
            var d = new Date(self1.currentYear, self1.currentMonth, 1);
            d.setMonth(self1.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self1.daysContainer.appendChild(frag);
        self1.days = self1.daysContainer.firstChild;
        if (self1.config.mode === "range" && self1.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self1.config.showMonths > 1 || self1.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self1.config.minDate !== undefined && self1.currentYear === self1.config.minDate.getFullYear() && month < self1.config.minDate.getMonth()) return false;
            return !(self1.config.maxDate !== undefined && self1.currentYear === self1.config.maxDate.getFullYear() && month > self1.config.maxDate.getMonth());
        };
        self1.monthsDropdownContainer.tabIndex = -1;
        self1.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = createElement("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self1.currentYear, i).getMonth().toString();
            month.textContent = monthToStr(i, self1.config.shorthandCurrentMonth, self1.l10n);
            month.tabIndex = -1;
            if (self1.currentMonth === i) month.selected = true;
            self1.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = createElement("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self1.config.showMonths > 1 || self1.config.monthSelectorType === "static") monthElement = createElement("span", "cur-month");
        else {
            self1.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
            self1.monthsDropdownContainer.setAttribute("aria-label", self1.l10n.monthAriaLabel);
            bind(self1.monthsDropdownContainer, "change", function(e) {
                var target = getEventTarget(e);
                var selectedMonth = parseInt(target.value, 10);
                self1.changeMonth(selectedMonth - self1.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self1.monthsDropdownContainer;
        }
        var yearInput = createNumberInput("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self1.l10n.yearAriaLabel);
        if (self1.config.minDate) yearElement.setAttribute("min", self1.config.minDate.getFullYear().toString());
        if (self1.config.maxDate) {
            yearElement.setAttribute("max", self1.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self1.config.minDate && self1.config.minDate.getFullYear() === self1.config.maxDate.getFullYear();
        }
        var currentMonth = createElement("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        clearNode(self1.monthNav);
        self1.monthNav.appendChild(self1.prevMonthNav);
        if (self1.config.showMonths) {
            self1.yearElements = [];
            self1.monthElements = [];
        }
        for(var m = self1.config.showMonths; m--;){
            var month = buildMonth();
            self1.yearElements.push(month.yearElement);
            self1.monthElements.push(month.monthElement);
            self1.monthNav.appendChild(month.container);
        }
        self1.monthNav.appendChild(self1.nextMonthNav);
    }
    function buildMonthNav() {
        self1.monthNav = createElement("div", "flatpickr-months");
        self1.yearElements = [];
        self1.monthElements = [];
        self1.prevMonthNav = createElement("span", "flatpickr-prev-month");
        self1.prevMonthNav.innerHTML = self1.config.prevArrow;
        self1.nextMonthNav = createElement("span", "flatpickr-next-month");
        self1.nextMonthNav.innerHTML = self1.config.nextArrow;
        buildMonths();
        Object.defineProperty(self1, "_hidePrevMonthArrow", {
            get: function() {
                return self1.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self1.__hidePrevMonthArrow !== bool) {
                    toggleClass$1(self1.prevMonthNav, "flatpickr-disabled", bool);
                    self1.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self1, "_hideNextMonthArrow", {
            get: function() {
                return self1.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self1.__hideNextMonthArrow !== bool) {
                    toggleClass$1(self1.nextMonthNav, "flatpickr-disabled", bool);
                    self1.__hideNextMonthArrow = bool;
                }
            }
        });
        self1.currentYearElement = self1.yearElements[0];
        updateNavigationCurrentMonth();
        return self1.monthNav;
    }
    function buildTime() {
        self1.calendarContainer.classList.add("hasTime");
        if (self1.config.noCalendar) self1.calendarContainer.classList.add("noCalendar");
        var defaults = getDefaultHours(self1.config);
        self1.timeContainer = createElement("div", "flatpickr-time");
        self1.timeContainer.tabIndex = -1;
        var separator = createElement("span", "flatpickr-time-separator", ":");
        var hourInput = createNumberInput("flatpickr-hour", {
            "aria-label": self1.l10n.hourAriaLabel
        });
        self1.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = createNumberInput("flatpickr-minute", {
            "aria-label": self1.l10n.minuteAriaLabel
        });
        self1.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self1.hourElement.tabIndex = self1.minuteElement.tabIndex = -1;
        self1.hourElement.value = pad(self1.latestSelectedDateObj ? self1.latestSelectedDateObj.getHours() : self1.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self1.minuteElement.value = pad(self1.latestSelectedDateObj ? self1.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self1.hourElement.setAttribute("step", self1.config.hourIncrement.toString());
        self1.minuteElement.setAttribute("step", self1.config.minuteIncrement.toString());
        self1.hourElement.setAttribute("min", self1.config.time_24hr ? "0" : "1");
        self1.hourElement.setAttribute("max", self1.config.time_24hr ? "23" : "12");
        self1.hourElement.setAttribute("maxlength", "2");
        self1.minuteElement.setAttribute("min", "0");
        self1.minuteElement.setAttribute("max", "59");
        self1.minuteElement.setAttribute("maxlength", "2");
        self1.timeContainer.appendChild(hourInput);
        self1.timeContainer.appendChild(separator);
        self1.timeContainer.appendChild(minuteInput);
        if (self1.config.time_24hr) self1.timeContainer.classList.add("time24hr");
        if (self1.config.enableSeconds) {
            self1.timeContainer.classList.add("hasSeconds");
            var secondInput = createNumberInput("flatpickr-second");
            self1.secondElement = secondInput.getElementsByTagName("input")[0];
            self1.secondElement.value = pad(self1.latestSelectedDateObj ? self1.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self1.secondElement.setAttribute("step", self1.minuteElement.getAttribute("step"));
            self1.secondElement.setAttribute("min", "0");
            self1.secondElement.setAttribute("max", "59");
            self1.secondElement.setAttribute("maxlength", "2");
            self1.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
            self1.timeContainer.appendChild(secondInput);
        }
        if (!self1.config.time_24hr) {
            self1.amPM = createElement("span", "flatpickr-am-pm", self1.l10n.amPM[int((self1.latestSelectedDateObj ? self1.hourElement.value : self1.config.defaultHour) > 11)]);
            self1.amPM.title = self1.l10n.toggleTitle;
            self1.amPM.tabIndex = -1;
            self1.timeContainer.appendChild(self1.amPM);
        }
        return self1.timeContainer;
    }
    function buildWeekdays() {
        if (!self1.weekdayContainer) self1.weekdayContainer = createElement("div", "flatpickr-weekdays");
        else clearNode(self1.weekdayContainer);
        for(var i = self1.config.showMonths; i--;){
            var container = createElement("div", "flatpickr-weekdaycontainer");
            self1.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self1.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self1.weekdayContainer) return;
        var firstDayOfWeek = self1.l10n.firstDayOfWeek;
        var weekdays = __spreadArrays(self1.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self1.config.showMonths; i--;)self1.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self1.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = createElement("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self1.l10n.weekAbbreviation));
        var weekNumbers = createElement("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self1.currentMonth;
        if (delta < 0 && self1._hidePrevMonthArrow === true || delta > 0 && self1._hideNextMonthArrow === true) return;
        self1.currentMonth += delta;
        if (self1.currentMonth < 0 || self1.currentMonth > 11) {
            self1.currentYear += self1.currentMonth > 11 ? 1 : -1;
            self1.currentMonth = (self1.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self1.input.value = "";
        if (self1.altInput !== undefined) self1.altInput.value = "";
        if (self1.mobileInput !== undefined) self1.mobileInput.value = "";
        self1.selectedDates = [];
        self1.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self1.currentYear = self1._initialDate.getFullYear();
            self1.currentMonth = self1._initialDate.getMonth();
        }
        if (self1.config.enableTime === true) {
            var _a = getDefaultHours(self1.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self1.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self1.isOpen = false;
        if (!self1.isMobile) {
            if (self1.calendarContainer !== undefined) self1.calendarContainer.classList.remove("open");
            if (self1._input !== undefined) self1._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self1.config !== undefined) triggerEvent("onDestroy");
        for(var i = self1._handlers.length; i--;)self1._handlers[i].remove();
        self1._handlers = [];
        if (self1.mobileInput) {
            if (self1.mobileInput.parentNode) self1.mobileInput.parentNode.removeChild(self1.mobileInput);
            self1.mobileInput = undefined;
        } else if (self1.calendarContainer && self1.calendarContainer.parentNode) {
            if (self1.config.static && self1.calendarContainer.parentNode) {
                var wrapper = self1.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self1.calendarContainer.parentNode.removeChild(self1.calendarContainer);
        }
        if (self1.altInput) {
            self1.input.type = "text";
            if (self1.altInput.parentNode) self1.altInput.parentNode.removeChild(self1.altInput);
            delete self1.altInput;
        }
        if (self1.input) {
            self1.input.type = self1.input._type;
            self1.input.classList.remove("flatpickr-input");
            self1.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self1[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self1.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self1.isOpen && !self1.config.inline) {
            var eventTarget_1 = getEventTarget(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self1.input || eventTarget_1 === self1.altInput || self1.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self1.input) || ~e.path.indexOf(self1.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self1.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self1.config.allowInput) self1.setDate(self1._input.value, false, self1.config.altInput ? self1.config.altFormat : self1.config.dateFormat);
                if (self1.timeContainer !== undefined && self1.minuteElement !== undefined && self1.hourElement !== undefined && self1.input.value !== "" && self1.input.value !== undefined) updateTime();
                self1.close();
                if (self1.config && self1.config.mode === "range" && self1.selectedDates.length === 1) self1.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self1.config.minDate && newYear < self1.config.minDate.getFullYear() || self1.config.maxDate && newYear > self1.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self1.currentYear !== newYearNum;
        self1.currentYear = newYearNum || self1.currentYear;
        if (self1.config.maxDate && self1.currentYear === self1.config.maxDate.getFullYear()) self1.currentMonth = Math.min(self1.config.maxDate.getMonth(), self1.currentMonth);
        else if (self1.config.minDate && self1.currentYear === self1.config.minDate.getFullYear()) self1.currentMonth = Math.max(self1.config.minDate.getMonth(), self1.currentMonth);
        if (isNewYear) {
            self1.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self1.parseDate(date, undefined, timeless);
        if (self1.config.minDate && dateToCheck && compareDates(dateToCheck, self1.config.minDate, timeless !== undefined ? timeless : !self1.minDateHasTime) < 0 || self1.config.maxDate && dateToCheck && compareDates(dateToCheck, self1.config.maxDate, timeless !== undefined ? timeless : !self1.maxDateHasTime) > 0) return false;
        if (!self1.config.enable && self1.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self1.config.enable, array = (_a = self1.config.enable) !== null && _a !== void 0 ? _a : self1.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self1.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self1.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self1.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self1._input;
        var valueChanged = self1._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self1.setDate(self1._input.value, true, e.target === self1.altInput ? self1.config.altFormat : self1.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = getEventTarget(e);
        var isInput = self1.config.wrap ? element.contains(eventTarget) : eventTarget === self1._input;
        var allowInput = self1.config.allowInput;
        var allowKeydown = self1.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self1.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self1.setDate(self1._input.value, true, eventTarget === self1.altInput ? self1.config.altFormat : self1.config.dateFormat);
                self1.close();
                return eventTarget.blur();
            } else self1.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self1.timeContainer && self1.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self1.config.allowInput) {
                        e.preventDefault();
                        self1.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self1.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self1.hourElement) self1.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self1.daysContainer && eventTarget.$i !== undefined || eventTarget === self1.input || eventTarget === self1.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self1.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self1.currentYearElement) changeYear(self1.currentYear - delta);
                    else if (self1.config.enableTime) {
                        if (!isTimeObj && self1.hourElement) self1.hourElement.focus();
                        updateTime(e);
                        self1._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self1.hourElement,
                            self1.minuteElement,
                            self1.secondElement,
                            self1.amPM
                        ].concat(self1.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self1._input).focus();
                        }
                    } else if (!self1.config.noCalendar && self1.daysContainer && self1.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self1._input.focus();
                    }
                    break;
            }
        }
        if (self1.amPM !== undefined && eventTarget === self1.amPM) switch(e.key){
            case self1.l10n.amPM[0].charAt(0):
            case self1.l10n.amPM[0].charAt(0).toLowerCase():
                self1.amPM.textContent = self1.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self1.l10n.amPM[1].charAt(0):
            case self1.l10n.amPM[1].charAt(0).toLowerCase():
                self1.amPM.textContent = self1.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self1.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self1.days.firstElementChild.dateObj.getTime(), initialDate = self1.parseDate(self1.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self1.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self1.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += duration.DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self1.rContainer.querySelectorAll("*:nth-child(-n+" + self1.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self1.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self1.isOpen && !self1.config.static && !self1.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self1._positionElement;
        if (self1.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = getEventTarget(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self1.mobileInput !== undefined) {
                self1.mobileInput.focus();
                self1.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self1._input.disabled || self1.config.inline) return;
        var wasOpen = self1.isOpen;
        self1.isOpen = true;
        if (!wasOpen) {
            self1.calendarContainer.classList.add("open");
            self1._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self1.config.enableTime === true && self1.config.noCalendar === true) {
            if (self1.config.allowInput === false && (e === undefined || !self1.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self1.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self1.config["_" + type + "Date"] = self1.parseDate(date, self1.config.dateFormat);
            var inverseDateObj = self1.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self1[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self1.selectedDates) {
                self1.selectedDates = self1.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self1.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self1.daysContainer) {
                redraw();
                if (dateObj !== undefined) self1.currentYearElement[type] = dateObj.getFullYear().toString();
                else self1.currentYearElement.removeAttribute(type);
                self1.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self1.config.parseDate = userConfig.parseDate;
        self1.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self1.config, "enable", {
            get: function() {
                return self1.config._enable;
            },
            set: function(dates) {
                self1.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self1.config, "disable", {
            get: function() {
                return self1.config._disable;
            },
            set: function(dates) {
                self1.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults$1.dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults$1.altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self1.config, "minDate", {
            get: function() {
                return self1.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self1.config, "maxDate", {
            get: function() {
                return self1.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self1.config[type === "min" ? "_minTime" : "_maxTime"] = self1.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self1.config, "minTime", {
            get: function() {
                return self1.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self1.config, "maxTime", {
            get: function() {
                return self1.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self1.config.noCalendar = true;
            self1.config.enableTime = true;
        }
        Object.assign(self1.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self1.config[boolOpts[i]] = self1.config[boolOpts[i]] === true || self1.config[boolOpts[i]] === "true";
        HOOKS.filter(function(hook) {
            return self1.config[hook] !== undefined;
        }).forEach(function(hook) {
            self1.config[hook] = arrayify(self1.config[hook] || []).map(bindToInstance);
        });
        self1.isMobile = !self1.config.disableMobile && !self1.config.inline && self1.config.mode === "single" && !self1.config.disable.length && !self1.config.enable && !self1.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self1.config.plugins.length; i++){
            var pluginConf = self1.config.plugins[i](self1) || {};
            for(var key in pluginConf){
                if (HOOKS.indexOf(key) > -1) self1.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self1.config[key]);
                else if (typeof userConfig[key] === "undefined") self1.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self1.config.altInputClass = getInputElem().className + " " + self1.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self1.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self1.config.locale !== "object" && typeof flatpickr.l10ns[self1.config.locale] === "undefined") self1.config.errorHandler(new Error("flatpickr: invalid locale " + self1.config.locale));
        self1.l10n = __assign(__assign({}, flatpickr.l10ns.default), typeof self1.config.locale === "object" ? self1.config.locale : self1.config.locale !== "default" ? flatpickr.l10ns[self1.config.locale] : undefined);
        tokenRegex.D = "(" + self1.l10n.weekdays.shorthand.join("|") + ")";
        tokenRegex.l = "(" + self1.l10n.weekdays.longhand.join("|") + ")";
        tokenRegex.M = "(" + self1.l10n.months.shorthand.join("|") + ")";
        tokenRegex.F = "(" + self1.l10n.months.longhand.join("|") + ")";
        tokenRegex.K = "(" + self1.l10n.amPM[0] + "|" + self1.l10n.amPM[1] + "|" + self1.l10n.amPM[0].toLowerCase() + "|" + self1.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && flatpickr.defaultConfig.time_24hr === undefined) self1.config.time_24hr = self1.l10n.time_24hr;
        self1.formatDate = createDateFormatter(self1);
        self1.parseDate = createDateParser({
            config: self1.config,
            l10n: self1.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self1.config.position === "function") return void self1.config.position(self1, customPositionElement);
        if (self1.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self1._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self1.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self1.calendarContainer.offsetWidth, configPos = self1.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        toggleClass$1(self1.calendarContainer, "arrowTop", !showOnTop);
        toggleClass$1(self1.calendarContainer, "arrowBottom", showOnTop);
        if (self1.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        toggleClass$1(self1.calendarContainer, "arrowLeft", !isCenter && !isRight);
        toggleClass$1(self1.calendarContainer, "arrowCenter", isCenter);
        toggleClass$1(self1.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        toggleClass$1(self1.calendarContainer, "rightMost", rightMost);
        if (self1.config.static) return;
        self1.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self1.calendarContainer.style.left = left + "px";
            self1.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self1.calendarContainer.style.left = "auto";
            self1.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            toggleClass$1(self1.calendarContainer, "rightMost", false);
            toggleClass$1(self1.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self1.calendarContainer.style.left = centerLeft + "px";
            self1.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self1.config.noCalendar || self1.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self1._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self1.close, 0);
        else self1.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = findParent(getEventTarget(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self1.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self1.currentMonth || selectedDate.getMonth() > self1.currentMonth + self1.config.showMonths - 1) && self1.config.mode !== "range";
        self1.selectedDateElem = target;
        if (self1.config.mode === "single") self1.selectedDates = [
            selectedDate
        ];
        else if (self1.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self1.selectedDates.splice(parseInt(selectedIndex), 1);
            else self1.selectedDates.push(selectedDate);
        } else if (self1.config.mode === "range") {
            if (self1.selectedDates.length === 2) self1.clear(false, false);
            self1.latestSelectedDateObj = selectedDate;
            self1.selectedDates.push(selectedDate);
            if (compareDates(selectedDate, self1.selectedDates[0], true) !== 0) self1.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self1.currentYear !== selectedDate.getFullYear();
            self1.currentYear = selectedDate.getFullYear();
            self1.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self1.config.mode !== "range" && self1.config.showMonths === 1) focusOnDayElem(target);
        else if (self1.selectedDateElem !== undefined && self1.hourElement === undefined) self1.selectedDateElem && self1.selectedDateElem.focus();
        if (self1.hourElement !== undefined) self1.hourElement !== undefined && self1.hourElement.focus();
        if (self1.config.closeOnSelect) {
            var single = self1.config.mode === "single" && !self1.config.enableTime;
            var range = self1.config.mode === "range" && self1.selectedDates.length === 2 && !self1.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self1.config.clickOpens === true) {
                    bind(self1._input, "focus", self1.open);
                    bind(self1._input, "click", self1.open);
                } else {
                    self1._input.removeEventListener("focus", self1.open);
                    self1._input.removeEventListener("click", self1.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self1.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self1.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if (HOOKS.indexOf(option) > -1) self1.config[option] = arrayify(value);
        }
        self1.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self1.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self1.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self1.config.mode){
            case "single":
            case "time":
                dates = [
                    self1.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self1.config.conjunction).map(function(date) {
                    return self1.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self1.l10n.rangeSeparator).map(function(date) {
                    return self1.parseDate(date, format);
                });
                break;
        }
        else self1.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self1.selectedDates = self1.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self1.config.mode === "range") self1.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self1.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self1.clear(triggerChange);
        setSelectedDate(date, format);
        self1.latestSelectedDateObj = self1.selectedDates[self1.selectedDates.length - 1];
        self1.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self1.selectedDates.length === 0) self1.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self1.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self1.parseDate(rule.from, undefined),
                to: self1.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self1.selectedDates = [];
        self1.now = self1.parseDate(self1.config.now) || new Date();
        var preloadedDate = self1.config.defaultDate || ((self1.input.nodeName === "INPUT" || self1.input.nodeName === "TEXTAREA") && self1.input.placeholder && self1.input.value === self1.input.placeholder ? null : self1.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self1.config.dateFormat);
        self1._initialDate = self1.selectedDates.length > 0 ? self1.selectedDates[0] : self1.config.minDate && self1.config.minDate.getTime() > self1.now.getTime() ? self1.config.minDate : self1.config.maxDate && self1.config.maxDate.getTime() < self1.now.getTime() ? self1.config.maxDate : self1.now;
        self1.currentYear = self1._initialDate.getFullYear();
        self1.currentMonth = self1._initialDate.getMonth();
        if (self1.selectedDates.length > 0) self1.latestSelectedDateObj = self1.selectedDates[0];
        if (self1.config.minTime !== undefined) self1.config.minTime = self1.parseDate(self1.config.minTime, "H:i");
        if (self1.config.maxTime !== undefined) self1.config.maxTime = self1.parseDate(self1.config.maxTime, "H:i");
        self1.minDateHasTime = !!self1.config.minDate && (self1.config.minDate.getHours() > 0 || self1.config.minDate.getMinutes() > 0 || self1.config.minDate.getSeconds() > 0);
        self1.maxDateHasTime = !!self1.config.maxDate && (self1.config.maxDate.getHours() > 0 || self1.config.maxDate.getMinutes() > 0 || self1.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self1.input = getInputElem();
        if (!self1.input) {
            self1.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self1.input._type = self1.input.type;
        self1.input.type = "text";
        self1.input.classList.add("flatpickr-input");
        self1._input = self1.input;
        if (self1.config.altInput) {
            self1.altInput = createElement(self1.input.nodeName, self1.config.altInputClass);
            self1._input = self1.altInput;
            self1.altInput.placeholder = self1.input.placeholder;
            self1.altInput.disabled = self1.input.disabled;
            self1.altInput.required = self1.input.required;
            self1.altInput.tabIndex = self1.input.tabIndex;
            self1.altInput.type = "text";
            self1.input.setAttribute("type", "hidden");
            if (!self1.config.static && self1.input.parentNode) self1.input.parentNode.insertBefore(self1.altInput, self1.input.nextSibling);
        }
        if (!self1.config.allowInput) self1._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self1._positionElement = self1.config.positionElement || self1._input;
    }
    function setupMobile() {
        var inputType = self1.config.enableTime ? self1.config.noCalendar ? "time" : "datetime-local" : "date";
        self1.mobileInput = createElement("input", self1.input.className + " flatpickr-mobile");
        self1.mobileInput.tabIndex = 1;
        self1.mobileInput.type = inputType;
        self1.mobileInput.disabled = self1.input.disabled;
        self1.mobileInput.required = self1.input.required;
        self1.mobileInput.placeholder = self1.input.placeholder;
        self1.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self1.selectedDates.length > 0) self1.mobileInput.defaultValue = self1.mobileInput.value = self1.formatDate(self1.selectedDates[0], self1.mobileFormatStr);
        if (self1.config.minDate) self1.mobileInput.min = self1.formatDate(self1.config.minDate, "Y-m-d");
        if (self1.config.maxDate) self1.mobileInput.max = self1.formatDate(self1.config.maxDate, "Y-m-d");
        if (self1.input.getAttribute("step")) self1.mobileInput.step = String(self1.input.getAttribute("step"));
        self1.input.type = "hidden";
        if (self1.altInput !== undefined) self1.altInput.type = "hidden";
        try {
            if (self1.input.parentNode) self1.input.parentNode.insertBefore(self1.mobileInput, self1.input.nextSibling);
        } catch (_a) {}
        bind(self1.mobileInput, "change", function(e) {
            self1.setDate(getEventTarget(e).value, false, self1.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self1.isOpen === true) return self1.close();
        self1.open(e);
    }
    function triggerEvent(event, data) {
        if (self1.config === undefined) return;
        var hooks = self1.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self1.selectedDates, self1.input.value, self1, data);
        if (event === "onChange") {
            self1.input.dispatchEvent(createEvent("change"));
            self1.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self1.selectedDates.length; i++){
            var selectedDate = self1.selectedDates[i];
            if (selectedDate instanceof Date && compareDates(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self1.config.mode !== "range" || self1.selectedDates.length < 2) return false;
        return compareDates(date, self1.selectedDates[0]) >= 0 && compareDates(date, self1.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self1.config.noCalendar || self1.isMobile || !self1.monthNav) return;
        self1.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self1.currentYear, self1.currentMonth, 1);
            d.setMonth(self1.currentMonth + i);
            if (self1.config.showMonths > 1 || self1.config.monthSelectorType === "static") self1.monthElements[i].textContent = monthToStr(d.getMonth(), self1.config.shorthandCurrentMonth, self1.l10n) + " ";
            else self1.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self1._hidePrevMonthArrow = self1.config.minDate !== undefined && (self1.currentYear === self1.config.minDate.getFullYear() ? self1.currentMonth <= self1.config.minDate.getMonth() : self1.currentYear < self1.config.minDate.getFullYear());
        self1._hideNextMonthArrow = self1.config.maxDate !== undefined && (self1.currentYear === self1.config.maxDate.getFullYear() ? self1.currentMonth + 1 > self1.config.maxDate.getMonth() : self1.currentYear > self1.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self1.config.altInput ? self1.config.altFormat : self1.config.dateFormat);
        return self1.selectedDates.map(function(dObj) {
            return self1.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self1.config.mode !== "range" || self1.config.enableTime || arr.indexOf(d) === i;
        }).join(self1.config.mode !== "range" ? self1.config.conjunction : self1.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self1.mobileInput !== undefined && self1.mobileFormatStr) self1.mobileInput.value = self1.latestSelectedDateObj !== undefined ? self1.formatDate(self1.latestSelectedDateObj, self1.mobileFormatStr) : "";
        self1.input.value = getDateStr(self1.config.dateFormat);
        if (self1.altInput !== undefined) self1.altInput.value = getDateStr(self1.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = getEventTarget(e);
        var isPrevMonth = self1.prevMonthNav.contains(eventTarget);
        var isNextMonth = self1.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self1.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self1.changeYear(self1.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self1.changeYear(self1.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
        if (self1.amPM !== undefined && eventTarget === self1.amPM) self1.amPM.textContent = self1.l10n.amPM[int(self1.amPM.textContent === self1.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self1.hourElement, isMinuteElem = input === self1.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self1.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self1.hourElement);
            } else if (newValue > max) {
                newValue = input === self1.hourElement ? newValue - max - int(!self1.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self1.hourElement);
            }
            if (self1.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self1.amPM.textContent = self1.l10n.amPM[int(self1.amPM.textContent === self1.l10n.amPM[0])];
            input.value = pad(newValue);
        }
    }
    init();
    return self1;
}
function _flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return _flatpickr([
            this
        ], config);
    };
}
var flatpickr = function(selector, config) {
    if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return _flatpickr([
        selector
    ], config);
    else return _flatpickr(selector, config);
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
    en: __assign({}, english),
    default: __assign({}, english)
};
flatpickr.localize = function(l10n) {
    flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function(config) {
    flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return _flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = flatpickr;
var DatepickerWrapper = {
    name: 'DatepickerWrapper',
    emits: [
        'change'
    ],
    props: {
        value: {
            required: true
        },
        options: {
            type: [
                Object
            ],
            required: true
        },
        id: {
            type: [
                Number,
                String
            ],
            required: true
        },
        placeholder: {
            type: [
                Number,
                String
            ],
            required: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, context) {
        var { id, options, value } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        var moment = form$.value.$vueform.services.moment;
        var $this = (0, $ani5R.getCurrentInstance)().proxy;
        // ================ DATA ================
        /**
     * The [flatpickr instance](https://flatpickr.js.org/instance-methods-properties-elements).
     * 
     * @type {object}
     * @default null
     */ var datepicker$ = (0, $8bTPG.ref)(null);
        /**
     * The date input DOM element.
     * 
     * @type {HTMLElement}
     */ var input = (0, $8bTPG.ref)(null);
        // ============== COMPUTED ==============
        /**
     * Whether the element containing the datepicker is available.
     * 
     * @type {boolean}
     * @private
     */ var available = (0, $8bTPG.computed)(()=>{
            return el$1.value.available;
        });
        /**
     * The current locale object for flatpickr.
     * 
     * @type {object}
     * @private
     */ var locale = (0, $8bTPG.computed)(()=>{
            var _$this$$vueform$i18n$, _$this$$vueform$i18n$2;
            return ((_$this$$vueform$i18n$ = $this.$vueform.i18n.locales[form$.value.locale$]) === null || _$this$$vueform$i18n$ === void 0 || (_$this$$vueform$i18n$ = _$this$$vueform$i18n$.vueform) === null || _$this$$vueform$i18n$ === void 0 ? void 0 : _$this$$vueform$i18n$.datepicker) || ((_$this$$vueform$i18n$2 = $this.$vueform.i18n.locales[$this.$vueform.i18n.fallbackLocale]) === null || _$this$$vueform$i18n$2 === void 0 || (_$this$$vueform$i18n$2 = _$this$$vueform$i18n$2.vueform) === null || _$this$$vueform$i18n$2 === void 0 ? void 0 : _$this$$vueform$i18n$2.datepicker) || {};
        });
        /**
     * The current `options.mode`.
     * 
     * @type {string}
     */ var mode = (0, $8bTPG.computed)(()=>{
            return options.value.mode || 'single';
        });
        /**
     * The flatpickr configuration object. Can be extended via [`options`](#options) with [flatpickr options](https://flatpickr.js.org/options/).
     * 
     * @type {object}
     */ var config = (0, $8bTPG.computed)(()=>{
            var config = {};
            each(options.value, (val, option)=>{
                if (val !== null && val !== undefined) config[option] = val;
            });
            // Append the form to main form instead of end of the body
            // Update: Experimental removal, because enter was disabled
            // when appended to form config.appendTo = this.form$.$refs.form$
            // according to:
            // https://github.com/flatpickr/flatpickr/issues/1019
            config.static = true;
            return config;
        });
        // =============== METHODS ==============
        /**
     * Emits `change` event.
     * 
     * @param {array|Date} value* the value to emit with change
     * @returns {void}
     * @private
     */ var update = (val)=>{
            context.emit('change', mode.value == 'single' ? val[0] || null : val);
        };
        /**
     * Sets's the datepicker input parent's `id` attribute.
     * 
     * @returns {void}
     * @private
     */ var setDatepickerId = ()=>{
            datepicker$.value.input.parentElement.id = 'datepicker-' + id.value;
        };
        /**
     * Initalizes the flatpickr.
     * 
     * @returns {Promise}
     * @private
     */ var init = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*() {
                if (!input.value) yield (0, $ani5R.nextTick)();
                datepicker$.value = flatpickr(input.value, Object.assign({}, config.value, {
                    onChange: (val)=>{
                        update(val);
                    },
                    onClose: (val)=>{
                        val = mode.value == 'range' && val.length < 2 ? [] : val;
                        update(val);
                    },
                    // creating a date object from a string date provided in displayFormat (to value)
                    parseDate: (dateStr, format)=>{
                        return moment(dateStr, format, true).toDate();
                    },
                    // creating a date string according to displayFormat (to display)
                    formatDate: (date, format)=>{
                        return moment(date).format(format);
                    },
                    ariaDateFormat: 'MMMM D, YYYY',
                    disableMobile: true,
                    locale: locale.value
                }));
                if (datepicker$.value.calendarContainer) classes.value.calendarContainer.forEach((c)=>{
                    datepicker$.value.calendarContainer.classList.add(c);
                });
                setDatepickerId();
                if (value.value !== null) datepicker$.value.setDate(value.value, false);
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(value, (n, o)=>{
            var _datepicker$$value;
            (_datepicker$$value = datepicker$.value) === null || _datepicker$$value === void 0 || _datepicker$$value.setDate(n, false);
        });
        (0, $8bTPG.watch)(id, (n, o)=>{
            setDatepickerId();
        }, {
            immediate: false
        });
        (0, $8bTPG.watch)(options, (n, o)=>{
            if (isEqual_1(n, o)) return;
            init();
        }, {
            deep: true
        });
        (0, $8bTPG.watch)([
            locale,
            available
        ], (n, o)=>{
            init();
        }, {
            deep: true
        });
        // ================ HOOKS ===============
        (0, $ani5R.onMounted)(()=>{
            init();
        });
        // // Required because if static == true the picker does
        // // not close properly when clicking outside of it.
        // document.addEventListener('click', () => {
        //   if(clickedOutsideElement('datepicker-' + this.id)) {
        //     if (this.datepicker$.isOpen) {
        //       this.datepicker$.close()
        //     }
        //   }
        // })
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            datepicker$: datepicker$,
            input: input,
            config: config,
            mode: mode,
            locale: locale,
            update: update,
            init: init
        };
    }
};
var EditorWrapper = {
    name: 'EditorWrapper',
    emits: [
        'input',
        'alert',
        'error',
        'blur'
    ],
    props: {
        value: {
            required: false,
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        name: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        id: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        accept: {
            required: false,
            type: Array,
            default: ()=>[]
        },
        acceptMimes: {
            required: false,
            type: Array,
            default: ()=>[]
        },
        endpoint: {
            required: false,
            type: [
                String,
                Function,
                Promise
            ],
            default: null
        },
        method: {
            required: false,
            type: String,
            default: 'post'
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
        hideTools: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, context) {
        var { value, disabled, acceptMimes, accept, endpoint, method, attrs, placeholder, id } = (0, $8bTPG.toRefs)(props);
        // ============ DEPENDENCIES ============
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ================ DATA ================
        /**
     * The [`Trix`](https://github.com/basecamp/trix) instance.
     * 
     * @type {HTMLElement}
     * @default null
     * @private
     */ var trix$ = (0, $8bTPG.ref)(null);
        // ============== COMPUTED ==============
        /**
     * The [`Trix`](https://github.com/basecamp/trix) instance.
     * 
     * @type {HTMLElement}
     * @default null
     */ var editor$ = (0, $8bTPG.computed)(()=>{
            return trix$.value.$el || trix$.value;
        });
        var resolvedEndpoint = (0, $8bTPG.computed)(()=>{
            if (endpoint.value) return typeof endpoint.value === 'function' ? endpoint.value : form$.value.$vueform.config.endpoints[endpoint.value] || endpoint.value;
            return typeof form$.value.$vueform.config.endpoints.attachment === 'function' ? form$.value.$vueform.config.endpoints.attachment : form$.value.$vueform.config.endpoints.attachment.url;
        });
        var resolvedMethod = (0, $8bTPG.computed)(()=>{
            if (typeof resolvedEndpoint.value === 'function') return null;
            if (endpoint.value && form$.value.$vueform.config.endpoints[endpoint.value]) return form$.value.$vueform.config.endpoints[endpoint.value];
            return method.value || form$.value.$vueform.config.endpoints.attachment.method;
        });
        var options = (0, $8bTPG.computed)(()=>{
            return _objectSpread2$1(_objectSpread2$1({}, attrs.value), {}, {
                placeholder: placeholder.value,
                disabled: disabled.value,
                contentEditable: !disabled.value,
                id: id.value,
                input: "editor-input-".concat(id.value)
            });
        });
        // =============== METHODS ==============
        /**
     * Updates the value of editor.
     * 
     * @param {string} value* the value to update with
     * @returns {void}
     */ var update = (val)=>{
            if (typeof val == 'number') val = String(val);
            if (val === null || val === undefined) val = '';
            if (editor$.value.editor) editor$.value.editor.loadHTML(val);
            else setTimeout(()=>{
                var _editor$$value$editor;
                (_editor$$value$editor = editor$.value.editor) === null || _editor$$value$editor === void 0 || _editor$$value$editor.loadHTML(val);
            }, 0);
        };
        /**
     * Sets an option for editor.
     * 
     * @param {string} key* the option key
     * @param {string} value* the option value
     * @returns {void}
     */ var setOption = (key, val)=>{
            editor$.value[key] = val;
        };
        /**
     * Handles `change` event.
     * 
     * @returns {void}
     * @private
     */ var handleChange = ()=>{
            // If the change is only triggered because of `update`
            // method (which implies an external call) we should
            // not emit any events because that would duplicate the
            // effects of the value change.
            if (editor$.value.value == value.value || !editor$.value.value && !value.value) return;
            context.emit('input', {
                target: {
                    value: editor$.value.value
                }
            });
        };
        /**
     * Handles `fileAccept` event.
     * 
     * @param {Event} e* event
     * @returns {void}
     * @private
     */ var handleFileAccept = (e)=>{
            if (disabled.value) {
                e.preventDefault();
                return;
            }
            if (!e.file) {
                e.preventDefault();
                return;
            }
            if (acceptMimes.value && acceptMimes.value.length && acceptMimes.value.indexOf(e.file.type) === -1) {
                e.preventDefault();
                context.emit('alert', form$.value.__(form$.value.translations.vueform.editor.acceptedMimesError, {
                    mimes: acceptMimes.value.join(', ')
                }));
            }
            var extension = e.file.name.split('.').pop();
            if (accept.value && accept.value.length && accept.value.indexOf(extension) === -1) {
                e.preventDefault();
                context.emit('alert', form$.value.__(form$.value.translations.vueform.editor.acceptedExtensionsError, {
                    extensions: accept.value.join(', ')
                }));
            }
        };
        /**
     * Handles `attachmentAdd` event.
     * 
     * @param {Event} e* event
     * @returns {Promise}
     * @private
     */ var handleAttachmentAdd = /*#__PURE__*/ function() {
            var _ref = _asyncToGenerator(function*(e) {
                if (!e.attachment.file) return;
                var data = new FormData();
                data.append('Content-Type', e.attachment.file.type);
                data.append('file', e.attachment.file);
                var response;
                try {
                    if (typeof resolvedEndpoint.value === 'function') response = yield resolvedEndpoint.value(e.attachment, el$1.value);
                    else {
                        response = yield el$1.value.$vueform.services.axios.request({
                            url: resolvedEndpoint.value,
                            method: resolvedMethod.value,
                            [resolvedMethod.value.toLowerCase() === 'get' ? 'params' : 'data']: data,
                            onUploadProgress: (progress)=>{
                                e.attachment.setUploadProgress(Math.round(progress.loaded * 100 / progress.total));
                            }
                        });
                        response = response.data;
                    }
                    e.attachment.setAttributes({
                        url: response.url,
                        href: response.href
                    });
                } catch (error) {
                    context.emit('error', error);
                }
            });
            return function handleAttachmentAdd(_x) {
                return _ref.apply(this, arguments);
            };
        }();
        /**
     * Handles `blur` event.
     * 
     * @returns {void}
     * @private
     */ var handleBlur = ()=>{
            context.emit('blur');
        };
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(disabled, (val)=>{
            editor$.value.contentEditable = !val;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            resolvedEndpoint: resolvedEndpoint,
            options: options,
            theme: theme,
            classes: classes,
            Templates: Templates,
            template: template,
            trix$: trix$,
            editor$: editor$,
            update: update,
            setOption: setOption,
            handleChange: handleChange,
            handleFileAccept: handleFileAccept,
            handleAttachmentAdd: handleAttachmentAdd,
            handleBlur: handleBlur
        };
    }
};
var base$14 = function base(props, context, dependencies) {
    var { label } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * Whether the element has a [`label`](#option-label) option, a [#label](#slot-label) slot or `Vueform` component's [`forceLabels`](vueform#option-force-labels) option is `true`.
   *
   * @type {boolean}
   *
   */ var hasLabel = (0, $8bTPG.computed)(()=>{
        var _el$$value$$slots, _el$$value$$scopedSlo;
        return !!(form$.value.options.forceLabels || label.value || el$1.value.slots.label || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots.label || /* istanbul ignore next: vue2 */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo.label);
    });
    /**
   * Whether the label is provided as a function.
   *
   * @type {boolean}
   * @private
   */ var isLabelFunction = (0, $8bTPG.computed)(()=>{
        return typeof label.value === 'function' && (!label.value.prototype || !label.value.prototype.constructor || label.value.prototype.constructor && label.value.prototype.constructor.name !== 'VueComponent');
    });
    /**
   * Whether label is provided as a Vue component.
   *
   * @type {boolean}
   * @private
   */ var isLabelComponent = (0, $8bTPG.computed)(()=>{
        return isVueComponent(label.value);
    });
    /**
   * The localized label of the element.
   *
   * @type {string|Component}
   * @private
   */ var Label = (0, $8bTPG.computed)(()=>{
        var Label = isLabelFunction.value ? label.value(el$1.value) : label.value || null;
        /* istanbul ignore else */ if (!isLabelComponent.value) Label = localize(Label, config$.value, form$.value);
        return Label;
    });
    return {
        hasLabel: hasLabel,
        Label: Label
    };
};
var base$13 = function base(props, context, dependencies) {
    var { columns, presets } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var theme = dependencies.theme;
    var hasLabel = dependencies.hasLabel;
    // ================ DATA ================
    var Columns = (0, $8bTPG.ref)(cloneDeep_1(columns.value));
    // ============== COMPUTED ==============
    /**
   * The classes service instance.
   *
   * @type {Columns}
   * @private
   */ var columnsClassesService = (0, $8bTPG.computed)(()=>{
        var config = form$.value.$vueform.config;
        return new form$.value.$vueform.services.columns({
            configPresetColumns: config.usePresets,
            configColumns: config.columns,
            formPresetColumns: form$.value.options.presets,
            formColumns: form$.value.options.columns,
            elementPresetColumns: presets.value,
            elementColumns: Columns.value
        }, hasLabel.value, theme.value.columns, config.presets);
    });
    /**
   * Calculated column sizes and classes for the element.
   *
   * @type {object}
   * @private
   */ var columnsClasses = (0, $8bTPG.computed)(()=>{
        return columnsClassesService.value.classes;
    });
    /**
   * The `cols` property of the Columns service instance.
   *
   * @type {object}
   * @private
   */ var computedCols = (0, $8bTPG.computed)(()=>{
        return columnsClassesService.value.cols;
    });
    // =============== METHODS ==============
    /**
   * Update columns programmatically.
   *
   * @param {number|array} value* the new value for columns option
   * @returns {void}
   * @private
   */ var updateColumns = (v)=>{
        Columns.value = cloneDeep_1(v);
    };
    (0, $8bTPG.watch)(columns, (v)=>{
        Columns.value = cloneDeep_1(v);
    }, {
        immediate: false,
        deep: true
    });
    return {
        computedCols: computedCols,
        columnsClassesService: columnsClassesService,
        columnsClasses: columnsClasses,
        updateColumns: updateColumns
    };
};
var base$12 = function base(props, context, dependencies) {
    var { size, view, views, presets } = (0, $8bTPG.toRefs)(props);
    var componentName = context.name;
    // ============ DEPENDENCIES ============
    var available = dependencies.available;
    var active = dependencies.active;
    var form$ = dependencies.form$;
    var parent = dependencies.parent;
    // ================ DATA ================
    /**
   * Whether the element was hidden programmatically with [`show()`](#method-show) or [`hide()`](#method-hide) methods.
   *
   * @type {boolean}
   * @default false
   */ var hidden = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    /**
   * Whether the element is visible. It's `false` when `available` or `active` is `false` or `hidden` is `true`.
   *
   * @type {boolean}
   */ var visible = (0, $8bTPG.computed)(()=>{
        return available.value && !hidden.value && active.value;
    });
    /**
   * The resolved size of the element and all of its child components.
   *
   * @type {string}
   */ var Size = (0, $8bTPG.computed)(()=>{
        var Size;
        if (size.value) Size = size.value;
        else each(presets.value, (presetName)=>{
            var preset = form$.value.$vueform.config.presets[presetName];
            if (!preset || !preset.size) return;
            Size = preset.size;
        });
        if (!Size) {
            if (parent.value) Size = parent.value.Size;
            else Size = form$.value.Size;
        }
        return Size;
    });
    /**
   * The name of the resolved view for the component and the default view for its child components. Child component views can be overridden with [`views`](#option-views) option. This one should be used to determine the component's view in class functions.
   *
   * @type {string}
   */ var View = (0, $8bTPG.computed)(()=>{
        if (view.value) return view.value;
        return Views.value[componentName.value];
    });
    /**
   * The name of the views for the components.
   *
   * @type {object}
   * @private
   */ var Views = (0, $8bTPG.computed)(()=>{
        var Views = form$.value.Views;
        each(presets.value, (presetName)=>{
            var preset = form$.value.$vueform.config.presets[presetName];
            if (!preset || !preset.views) return;
            Views = Object.assign({}, Views, preset.views);
        });
        Views = Object.assign({}, Views, views.value);
        return Views;
    });
    // =============== METHODS ==============
    /**
   * Hides the element.
   *
   * @returns {void}
   */ var hide = ()=>{
        hidden.value = true;
    };
    /**
   * Shows the element if it was hidden with [`hide()`](#method-hide) method.
   *
   * @returns {void}
   */ var show = ()=>{
        hidden.value = false;
    };
    // ============== PROVIDES ==============
    (0, $ani5R.provide)('Size', Size);
    (0, $ani5R.provide)('View', View);
    (0, $ani5R.provide)('Views', Views);
    return {
        hidden: hidden,
        visible: visible,
        Size: Size,
        View: View,
        Views: Views,
        hide: hide,
        show: show
    };
};
var captcha$1 = function captcha(props, context, dependencies) {
    var { hidden, visible: baseVisible, Size, View, Views, hide, show } = base$12(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var { shouldVerify } = dependencies;
    // =============== METHODS ===============
    var visible = (0, $8bTPG.computed)(()=>{
        return baseVisible.value && shouldVerify.value;
    });
    return {
        hidden: hidden,
        visible: visible,
        Size: Size,
        View: View,
        Views: Views,
        hide: hide,
        show: show
    };
};
var base$11 = function base(props, context, dependencies) {
    var { templates, presets } = (0, $8bTPG.toRefs)(props);
    var componentName = context.name;
    // ============ DEPENDENCIES ============
    var theme = dependencies.theme;
    var View = dependencies.View;
    var form$ = dependencies.form$;
    // ============== COMPUTED ==============
    /**
   * The list of templates available to the element.
   *
   * @type {object}
   * @private
   */ var Templates = (0, $8bTPG.computed)(()=>{
        var presetTemplates = {};
        each(presets ? presets.value : [], (presetName)=>{
            var preset = form$.value.$vueform.config.presets[presetName];
            if (!preset || !preset.templates) return;
            presetTemplates = Object.assign({}, presetTemplates, preset.templates);
        });
        return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, theme.value.templates), presetTemplates), templates ? templates.value : {});
    });
    /**
   * The component's template.
   *
   * @type {object}
   */ var template = (0, $8bTPG.computed)(()=>{
        return View && View.value && Templates.value["".concat(componentName.value, "_").concat(View.value)] ? Templates.value["".concat(componentName.value, "_").concat(View.value)] : Templates.value[componentName.value];
    });
    return {
        Templates: Templates,
        template: template
    };
};
var base$10 = function base(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var el$1 = dependencies.el$;
    // =============== OPTIONS ==============
    var defaultElementSlots = [
        'label',
        'info',
        'required',
        'description',
        'before',
        'between',
        'after'
    ];
    var defaultFieldSlots = [
        'checkbox',
        'radio',
        'option',
        'single-label',
        'multiple-label',
        'tag',
        'no-results',
        'no-options',
        'after-list',
        'before-list',
        'placeholder',
        'group-label',
        'caret',
        'clear',
        'spinner',
        'option',
        'default',
        'addon-before',
        'addon-after'
    ];
    // ============== COMPUTED ==============
    /**
   * Slots of the element.
   *
   * @type {object}
   * @private
   */ var elementSlots = (0, $8bTPG.computed)(()=>{
        var elementSlots = {};
        defaultElementSlots.filter((s)=>options.slots.indexOf(s) !== -1).forEach((s)=>{
            var slot = el$1.value.slots[s] || el$1.value.slots[camelCase_1(s)];
            if (typeof slot === 'object') {
                if (slot.props && (Array.isArray(slot.props) && slot.props.indexOf('el$') === -1 || !Array.isArray(slot.props) && Object.keys(slot.props).indexOf('el$') === -1)) {
                    if (Array.isArray(slot.props)) slot.props.push('el$');
                    else slot.props.el$ = {
                        type: Object,
                        required: true
                    };
                } else if (!slot.props) slot.props = [
                    'el$'
                ];
            }
            elementSlots[s] = slot;
        });
        return elementSlots;
    });
    /**
   * Slots related to the element's field. E.g. an "elementSlot" is something related to the element, like `label`, `description`, etc. A "fieldSlot" is something that related to the field within the element, e.g. `option` or `single-label` for `SelectElement`.
   *
   * @type {object}
   * @private
   */ var fieldSlots = (0, $8bTPG.computed)(()=>{
        var fieldSlots = {};
        defaultFieldSlots.filter((s)=>options.slots.indexOf(s) !== -1).forEach((s)=>{
            var slot = el$1.value.slots[s] || el$1.value.slots[camelCase_1(s)];
            // Add `el$` prop to `default` slot
            if (typeof slot === 'object') {
                if (slot.props && (Array.isArray(slot.props) && slot.props.indexOf('el$') === -1 || !Array.isArray(slot.props) && Object.keys(slot.props).indexOf('el$') === -1)) {
                    if (Array.isArray(slot.props)) slot.props.push('el$');
                    else slot.props.el$ = {
                        type: Object,
                        required: true
                    };
                } else if (!slot.props) slot.props = [
                    'el$'
                ];
            }
            fieldSlots[s] = slot;
        });
        return fieldSlots;
    });
    return {
        elementSlots: elementSlots,
        fieldSlots: fieldSlots
    };
};
var base$$ = function base(props, context, dependencies) {
    var { buttonLabel, buttonType, href, target, loading, onClick, resets, submits } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var isDisabled = dependencies.isDisabled;
    var fieldId = dependencies.fieldId;
    var fire = dependencies.fire;
    var el$1 = dependencies.el$;
    // ============== COMPUTED ==============
    /**
   * Whether the button is in loading state.
   *
   * @type {boolean}
   */ var isLoading = (0, $8bTPG.computed)(()=>{
        if (typeof loading.value === 'function') return loading.value(form$.value, el$1.value);
        if (submits.value && (form$.value.submitting || form$.value.preparing || form$.value.isLoading)) return true;
        return loading.value;
    });
    /**
   * Whether the button's label is a component.
   *
   * @type {boolean}
   * @private
   */ var isButtonLabelComponent = (0, $8bTPG.computed)(()=>{
        return buttonLabel.value !== null && typeof buttonLabel.value === 'object';
    });
    /**
   * Attributes of the button.
   *
   * @type {object}
   * @private
   */ var button = (0, $8bTPG.computed)(()=>{
        var button = {
            id: fieldId.value
        };
        switch(buttonType.value){
            case 'anchor':
                button.href = href.value;
                button.target = target.value;
                break;
            case 'button':
                button.disabled = isDisabled.value;
                break;
        }
        if (isLoading.value) button.tabindex = undefined;
        return button;
    });
    var resolvedButtonLabel = (0, $8bTPG.computed)(()=>{
        return typeof buttonLabel.value === 'function' ? buttonLabel.value(el$1.value) : buttonLabel.value;
    });
    // =============== METHODS ==============
    /**
   * Handles the button's click event.
   *
   * @param {Event} e* event object event
   * @returns {void}
   * @private
   */ var handleClick = (e)=>{
        if (buttonType.value === 'anchor' && !href.value) e.preventDefault();
        if (isDisabled.value || isLoading.value) {
            e.preventDefault();
            return;
        }
        if (resets.value) form$.value.reset();
        if (submits.value) form$.value.submit();
        fire('click', form$.value, el$1.value, e);
    };
    return {
        isButtonLabelComponent: isButtonLabelComponent,
        button: button,
        resolvedButtonLabel: resolvedButtonLabel,
        isLoading: isLoading,
        handleClick: handleClick
    };
};
var base$_ = function base(props, context, dependencies) {
    var { layout, inline } = (0, $8bTPG.toRefs)(props);
    // ============== COMPUTED ==============
    /**
   * The current layout of the element.
   *
   * @type {string|Component}
   * @private
   */ var elementLayout = (0, $8bTPG.computed)(()=>{
        return inline.value || !layout.value ? 'ElementLayoutInline' : layout.value;
    });
    return {
        elementLayout: elementLayout
    };
};
var base$Z = function base(props, context, dependencies) {
    var { id, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var parent = dependencies.parent;
    // ============== COMPUTED ==============
    /**
   * The `id` of the <%field%>. If [`id`](#option-id) is not provided [`path`](#option-path) will be used.
   *
   * @type {string}
   */ var fieldId = (0, $8bTPG.computed)(()=>{
        var _parent$value, _parent$value2;
        return id.value || ((_parent$value = parent.value) !== null && _parent$value !== void 0 && _parent$value.fieldId ? "".concat((_parent$value2 = parent.value) === null || _parent$value2 === void 0 ? void 0 : _parent$value2.fieldId, ".").concat(name.value) : name.value);
    });
    return {
        fieldId: fieldId
    };
};
var base$Y = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { container } = dependencies;
    // =============== METHOD ===============
    /**
   * Focuses the first focusable part of the element.
   *
   * @returns {void}
   * @private
   */ var focus = ()=>{
        var _container$value, _el$querySelector;
        var el = ((_container$value = container.value) === null || _container$value === void 0 ? void 0 : _container$value.$el) || container.value;
        el === null || el === void 0 || (_el$querySelector = el.querySelector("a[href],area[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),iframe,[tabindex],[contentEditable=true],trix-editor")) === null || _el$querySelector === void 0 || _el$querySelector.focus();
    };
    return {
        focus: focus
    };
};
var editor$1 = function editor(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { input } = dependencies;
    // =============== METHOD ===============
    var focus = ()=>{
        input.value.editor$.focus();
    };
    return {
        focus: focus
    };
};
var base$X = function base(props, context, dependencies) {
    var currentInstance = (0, $ani5R.getCurrentInstance)();
    // ============== COMPUTED ==============
    /**
   * The element's component.
   *
   * @type {VueformElement}
   */ var el$1 = (0, $8bTPG.computed)(()=>{
        return currentInstance.proxy;
    });
    // ============== PROVIDES ==============
    /**
   * The element's component.
   *
   * @type {VueformElement}
   */ (0, $ani5R.provide)('el$', el$1);
    return {
        el$: el$1
    };
};
var baseClone = _baseClone;
/** Used to compose bitmasks for cloning. */ var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function clone$1(value) {
    return baseClone(value, CLONE_SYMBOLS_FLAG);
}
var clone_1 = clone$1;
var base$W = function base(props, context, dependencies) {
    var { disabled } = (0, $8bTPG.toRefs)(props);
    var { el$: el$1, form$, path } = dependencies;
    // ================ DATA ================
    /**
   * Helper to store whether the element is disabled via api (with .disable()).
   *
   * @type {boolean|null}
   * @default null
   * @private
   */ var localDisabled = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Whether the element is disabled.
   *
   * @type {boolean}
   */ var isDisabled = (0, $8bTPG.computed)(()=>{
        if (localDisabled.value === true) return true;
        if (localDisabled.value === false) return false;
        if (typeof disabled.value === 'function') return disabled.value(el$1.value, form$.value);
        if (Array.isArray(disabled.value)) return disabled.value.every((condition)=>{
            return form$.value.$vueform.services.condition.check(condition, path.value, form$.value, el$1.value);
        });
        if (typeof disabled.value === 'object' && disabled.value && disabled.value.value !== undefined) return disabled.value.value;
        return disabled.value;
    });
    // =============== METHODS ==============
    /**
   * Disables the element.
   *
   * @returns {void}
   */ var disable = ()=>{
        localDisabled.value = true;
    };
    /**
   * Enables the element even if it is disabled by [`disabled`](#disabled) option.
   *
   * @returns {void}
   */ var enable = ()=>{
        localDisabled.value = false;
    };
    return {
        localDisabled: localDisabled,
        isDisabled: isDisabled,
        disable: disable,
        enable: enable
    };
};
var checkboxgroup$3 = function checkboxgroup(props, context, dependencies) {
    var { disables } = (0, $8bTPG.toRefs)(props);
    var { localDisabled, isDisabled } = base$W(props, context, dependencies);
    // ================ DATA ================
    /**
   * List of option keys to be disabled.
   *
   * @type {array}
   * @default []
   * @private
   */ var disabledItems = (0, $8bTPG.ref)([]);
    // =============== METHODS ==============
    /**
   * Disables one item or more items.
   *
   * @param {array|string|number} values* value(s) to disable
   * @returns {void}
   */ var disable = (values)=>{
        if (!isArray_1(values)) values = [
            values
        ];
        var disablesList = clone_1(disabledItems.value);
        each(values, (item)=>{
            item = String(item);
            /* istanbul ignore else */ if (disablesList.indexOf(item) === -1) disablesList.push(item);
        });
        disabledItems.value = disablesList;
    };
    /**
   * Disables one item or more disabled items.
   *
   * @param {array|string|number} values* value(s) to enable
   * @returns {void}
   */ var enable = (values)=>{
        if (!isArray_1(values)) values = [
            values
        ];
        var disablesList = clone_1(disabledItems.value);
        each(values, (item)=>{
            item = String(item);
            var index = disablesList.indexOf(item);
            /* istanbul ignore else */ if (index !== -1) disablesList.splice(index, 1);
        });
        disabledItems.value = disablesList;
    };
    /**
   * Disables all items.
   *
   * @returns {void}
   */ var disableAll = ()=>{
        localDisabled.value = true;
    };
    /**
   * Enables all items.
   *
   * @returns {void}
   */ var enableAll = ()=>{
        localDisabled.value = false;
        disabledItems.value = [];
    };
    // ================ HOOKS ===============
    disabledItems.value = map_1(disables.value || /* istanbul ignore next: can't fall into this, because it is hardwired to be `[]` if undefined */ [], (d)=>{
        return String(d);
    });
    return {
        disabledItems: disabledItems,
        isDisabled: isDisabled,
        disableAll: disableAll,
        enableAll: enableAll,
        disable: disable,
        enable: enable
    };
};
var button$1 = function button(props, context, dependencies) {
    var { disabled, submits } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    // ============== COMPUTED ==============
    /**
   * Whether the button is disabled.
   *
   * @type {boolean}
   */ var isDisabled = (0, $8bTPG.computed)(()=>{
        if (typeof disabled.value === 'function') return disabled.value(el$1.value, form$.value);
        if (submits.value && (form$.value.invalid && form$.value.shouldValidateOnChange || form$.value.busy || form$.value.isDisabled)) return true;
        return disabled.value;
    });
    return {
        isDisabled: isDisabled
    };
};
var radiogroup$2 = checkboxgroup$3;
var base$V = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fieldId = dependencies.fieldId;
    var invalid = dependencies.invalid;
    var isDisabled = dependencies.isDisabled;
    var busy = dependencies.busy;
    // ============== COMPUTED ==============
    /**
   * The `id` of the related label component.
   *
   * @type {string}
   * @private
   */ var labelId = (0, $8bTPG.computed)(()=>{
        return "".concat(fieldId.value, "__label");
    });
    /**
   * The `id` of the related description component.
   *
   * @type {string}
   * @private
   */ var descriptionId = (0, $8bTPG.computed)(()=>{
        return "".concat(fieldId.value, "__description");
    });
    /**
   * The `id` of the related description component.
   *
   * @type {string}
   * @private
   */ var infoId = (0, $8bTPG.computed)(()=>{
        return "".concat(fieldId.value, "__info");
    });
    /**
   * The `id` of the related error component.
   *
   * @type {string}
   * @private
   */ var errorId = (0, $8bTPG.computed)(()=>{
        return "".concat(fieldId.value, "__error");
    });
    /**
   * The `aria-*` attributes of the input.
   *
   * @type {object}
   */ var aria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-labelledby': labelId.value,
            'aria-describedby': "".concat(descriptionId.value, " ").concat(infoId.value),
            'aria-invalid': invalid.value,
            'aria-errormessage': errorId.value,
            'aria-disabled': isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled.value,
            'aria-busy': busy.value
        };
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria
    };
};
var checkbox$1 = function checkbox(props, context, dependencies) {
    var { text } = (0, $8bTPG.toRefs)(props);
    var { descriptionId, labelId, infoId, errorId } = base$V(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var invalid = dependencies.invalid;
    var isDisabled = dependencies.isDisabled;
    var busy = dependencies.busy;
    // ============== COMPUTED ==============
    var aria = (0, $8bTPG.computed)(()=>{
        var aria = {
            'aria-label': text.value,
            'aria-describedby': "".concat(labelId.value, " ").concat(descriptionId.value, " ").concat(infoId.value),
            'aria-invalid': invalid.value,
            'aria-errormessage': errorId.value,
            'aria-disabled': isDisabled.value,
            'aria-busy': busy.value
        };
        if (!aria['aria-label']) aria['aria-labelledby'] = labelId.value;
        return aria;
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria
    };
};
var checkboxgroup$2 = function checkboxgroup(props, context, dependencies) {
    var { descriptionId, labelId, infoId, errorId } = base$V(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var invalid = dependencies.invalid;
    var isDisabled = dependencies.isDisabled;
    var busy = dependencies.busy;
    // ============== COMPUTED ==============
    var aria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-describedby': "".concat(descriptionId.value, " ").concat(infoId.value),
            'aria-invalid': invalid.value,
            'aria-errormessage': errorId.value,
            'aria-disabled': isDisabled.value,
            'aria-busy': busy.value
        };
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria
    };
};
var button = function button(props, context, dependencies) {
    var { descriptionId, labelId, infoId, errorId } = base$V(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    // ============== COMPUTED ==============
    var aria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-labelledby': labelId.value,
            'aria-describedby': "".concat(descriptionId.value, " ").concat(infoId.value),
            'aria-disabled': isDisabled.value
        };
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria
    };
};
var static_$3 = function static_(props, context, dependencies) {
    var { descriptionId, labelId, infoId, errorId } = base$V(props, context, dependencies);
    // ============== COMPUTED ==============
    var aria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-labelledby': labelId.value,
            'aria-describedby': "".concat(descriptionId.value, " ").concat(infoId.value)
        };
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria
    };
};
var phone$2 = function phone(props, context, dependencies) {
    (0, $8bTPG.toRefs)(props);
    var { descriptionId, labelId, infoId, errorId, aria } = base$V(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    // ============== COMPUTED ==============
    var optionsAria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-label': form$.value.translations.vueform.elements.phone.ariaLabel
        };
    });
    return {
        descriptionId: descriptionId,
        labelId: labelId,
        infoId: infoId,
        errorId: errorId,
        aria: aria,
        optionsAria: optionsAria
    };
};
var radiogroup$1 = checkboxgroup$2;
var radio = checkbox$1;
var toggle$1 = checkbox$1;
var file$4 = checkboxgroup$2;
var createCaseFirst = _createCaseFirst;
/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */ var lowerFirst = createCaseFirst('toLowerCase');
var lowerFirst_1 = lowerFirst;
var base$U = function base(props, context, dependencies) {
    var { name } = (0, $8bTPG.toRefs)(props);
    var currentInstance = (0, $ani5R.getCurrentInstance)();
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    // =============== METHODS ==============
    /**
  * Sets the component to the parent as if `refs` were used.
  * 
  * @param {VNode} $parent parent component
  * @param {function} assignToParent the assignToParent function for recursion
  * @returns {void}
  * @private
  */ var assignToParent = ($parent, assignToParent)=>{
        if ($parent.cells$) form$.value.$set($parent.cells$, name.value, currentInstance.proxy);
        if ($parent.children$Array) $parent.children$Array.push(currentInstance.proxy);
        else if ($parent.elements$) form$.value.$set($parent.elements$, name.value, currentInstance.proxy);
        else assignToParent($parent.$parent, assignToParent);
    };
    /**
  * Removes the component from the parent.
  * 
  * @param {VNode} $parent parent component
  * @param {function} removeFromParent the removeFromParent function for recursion
  * @private
  */ var removeFromParent = ($parent, removeFromParent)=>{
        if ($parent.cells$) form$.value.$delete($parent.cells$, name.value);
        if ($parent.children$Array) $parent.children$Array.splice($parent.children$Array.map((e$)=>normalize(e$.name)).indexOf(normalize(name.value)), 1);
        else if ($parent.elements$) form$.value.$delete($parent.elements$, name.value);
        else removeFromParent($parent.$parent, removeFromParent);
    };
    return {
        assignToParent: assignToParent,
        removeFromParent: removeFromParent
    };
};
var base$T = function base(props, context, dependencies) {
    var instantHooks = [
        'onBeforeCreate',
        'onCreated'
    ];
    var hooks = {
        onBeforeMount: $ani5R.onBeforeMount,
        onMounted: $ani5R.onMounted,
        onBeforeUpdate: $ani5R.onBeforeUpdate,
        onUpdated: $ani5R.onUpdated,
        onBeforeUnmount: $ani5R.onBeforeUnmount,
        onUnmounted: $ani5R.onUnmounted
    };
    var currentInstance = (0, $ani5R.getCurrentInstance)();
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var fire = dependencies.fire;
    var { assignToParent, removeFromParent } = base$U(props, context, {
        form$: form$
    });
    // ================= DATA ================
    /**
   * The ref to the outermost DOM of the element.
   *
   * @type {HTMLElement}
   */ var container = (0, $8bTPG.ref)(null);
    /**
   * Whether the element has been already mounted.
   *
   * @type {boolean}
   * @default true
   */ var mounted = (0, $8bTPG.ref)(false);
    /**
   * Whether the element is hidden internally by core components like tabs or steps. Only intended for reading.
   *
   * @type {boolean}
   * @default true
   * @private
   */ var active = (0, $8bTPG.ref)(true);
    // ============== COMPUTED ==============
    /**
   * Whether the element is static (does not have any data or validation).
   *
   * @type {boolean}
   * @private
   */ var isStatic = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element's value is a file.
   *
   * @type {boolean}
   * @private
   */ var isFileType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element's value is an image.
   *
   * @type {boolean}
   * @private
   */ var isImageType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element's value is an array.
   *
   * @type {boolean}
   * @private
   */ var isArrayType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is a nested object.
   *
   * @type {boolean}
   * @private
   */ var isObjectType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is a nested group.
   *
   * @type {boolean}
   * @private
   */ var isGroupType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is a list.
   *
   * @type {boolean}
   * @private
   */ var isListType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is a matrix.
   *
   * @type {boolean}
   * @private
   */ var isMatrixType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is a grid.
   *
   * @type {boolean}
   * @private
   */ var isGridType = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element should be visible when using `tabs` or `steps`.
   *
   * @type {boolean}
   * @private
   */ var isActive = (0, $8bTPG.computed)(()=>{
        return active.value;
    });
    // ============== METHODS ===============
    /**
   * Sets the `active` property of the element to `true`.
   *
   * @returns {void}
   * @private
   */ var activate = ()=>{
        active.value = true;
    };
    /**
   * Sets the `active` property of the element to `false`.
   *
   * @returns {void}
   * @private
   */ var deactivate = ()=>{
        active.value = false;
    };
    // ================ HOOKS ===============
    (0, $ani5R.onBeforeMount)(()=>{
        assignToParent(currentInstance.proxy.$parent, assignToParent);
    });
    (0, $ani5R.onMounted)(()=>{
        mounted.value = true;
    });
    (0, $ani5R.onBeforeUnmount)(()=>{
        removeFromParent(currentInstance.proxy.$parent, removeFromParent);
    });
    Object.values(instantHooks).forEach((hook)=>{
        fire(lowerFirst_1(hook.replace('on', '')), el$1.value);
    });
    Object.keys(hooks).forEach((hook)=>{
        hooks[hook](()=>{
            fire(lowerFirst_1(hook.replace('on', '')), el$1.value);
        });
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isListType: isListType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var list$4 = function list(props, context, dependencies) {
    var { isStatic, isFileType, isImageType, isObjectType, isGroupType, isMatrixType, isGridType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isArrayType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    var isListType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var checkboxgroup$1 = function checkboxgroup(props, context, dependencies) {
    var { isStatic, isFileType, isImageType, isObjectType, isGroupType, isListType, isMatrixType, isGridType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isArrayType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var object$7 = function object(props, context, dependencies) {
    var { isStatic, isFileType, isArrayType, isImageType, isGroupType, isMatrixType, isGridType, isListType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isObjectType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var group$7 = function group(props, context, dependencies) {
    var { isStatic, isFileType, isArrayType, isImageType, isObjectType, isMatrixType, isGridType, isListType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isGroupType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var matrix$5 = function matrix(props, context, dependencies) {
    var { isStatic, isFileType, isArrayType, isImageType, isObjectType, isGroupType, isListType, isGridType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isMatrixType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var grid$1 = function grid(props, context, dependencies) {
    var { isStatic, isFileType, isArrayType, isImageType, isObjectType, isGroupType, isListType, isMatrixType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isGridType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var file$3 = function file(props, context, dependencies) {
    var { view } = (0, $8bTPG.toRefs)(props);
    var { isStatic, isArrayType, isObjectType, isGroupType, isMatrixType, isGridType, isListType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isFileType = (0, $8bTPG.computed)(()=>{
        return true;
    });
    var isImageType = (0, $8bTPG.computed)(()=>{
        return [
            'gallery',
            'image'
        ].indexOf(view.value) !== -1;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var static_$2 = function static_(props, context, dependencies) {
    var { isArrayType, isFileType, isImageType, isObjectType, isGroupType, isMatrixType, isGridType, isListType, isActive, active, mounted, container, activate, deactivate } = base$T(props, context, dependencies);
    // ============== COMPUTED ==============
    var isStatic = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        isStatic: isStatic,
        isFileType: isFileType,
        isArrayType: isArrayType,
        isImageType: isImageType,
        isObjectType: isObjectType,
        isGroupType: isGroupType,
        isMatrixType: isMatrixType,
        isGridType: isGridType,
        isListType: isListType,
        isActive: isActive,
        active: active,
        mounted: mounted,
        container: container,
        activate: activate,
        deactivate: deactivate
    };
};
var dates$5 = checkboxgroup$1;
var multiselect$5 = checkboxgroup$1;
var tags$5 = checkboxgroup$1;
var base$S = function base(props, context, dependencies) {
    var { name } = (0, $8bTPG.toRefs)(props);
    var currentInstance = (0, $ani5R.getCurrentInstance)();
    // ============ DEPENDENCIES ============
    var { form$ } = dependencies;
    // ============== COMPUTED ==============
    /**
   * The parent component of the element.
   *
   * @type {VNode}
   */ var parent = (0, $8bTPG.computed)(()=>{
        var getParent = (parent, getParent)=>{
            if (parent && (form$.value.$vueform.vueVersion === 3 && parent.$options.name && parent.$options.name.match(/^[a-zA-Z\-]*Element$/) || form$.value.$vueform.vueVersion === 2 && parent.hasOwnProperty('el$') && typeof parent.el$ !== 'function')) return parent.el$;
            else if (parent.$parent) return getParent(parent.$parent, getParent);
            else return null;
        };
        return getParent(form$.value.$vueform.vueVersion === 3 ? currentInstance.parent.proxy : currentInstance.proxy.$parent, getParent);
    });
    /**
   * The path of the element using dot `.` syntax.
   *
   * @type {string}
   */ var path = (0, $8bTPG.computed)(()=>{
        return parent.value && parent.value.path ? parent.value.path + '.' + name.value : name.value;
    });
    /**
   * The path of the element's data using dot `.` syntax.
   *
   * @type {string}
   */ var dataPath = (0, $8bTPG.computed)(()=>{
        return parent.value && parent.value.dataPath ? parent.value.dataPath + '.' + name.value : name.value;
    });
    /**
   * Whether the element is just a container of children but not nested on data level (eg. [`GroupElement`](group-element))
   *
   * @type {boolean}
   * @private
   */ var flat = (0, $8bTPG.computed)(()=>{
        return false;
    });
    return {
        parent: parent,
        path: path,
        dataPath: dataPath,
        flat: flat
    };
};
var group$6 = function group(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { path, parent } = base$S(props, context, dependencies);
    // ============== COMPUTED ==============
    var dataPath = (0, $8bTPG.computed)(()=>{
        return parent.value && parent.value.dataPath ? parent.value.dataPath : null;
    });
    var flat = (0, $8bTPG.computed)(()=>{
        return true;
    });
    return {
        path: path,
        dataPath: dataPath,
        flat: flat,
        parent: parent
    };
};
var static_$1 = function static_(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { path, parent, flat } = base$S(props, context, dependencies);
    // ============== COMPUTED ==============
    return {
        path: path,
        flat: flat,
        parent: parent
    };
};
function resolveDeps(props, context, options) {
    var deps = options.deps || {};
    options = _objectSpread2$1(_objectSpread2$1({}, options), {}, {
        events: context.emits,
        slots: context.slots
    });
    context.features.forEach((feature)=>{
        each(feature(props, context, deps, options), (featureDep, key)=>{
            deps[key] = featureDep;
        });
    });
    return deps;
}
var base$R = function base(props, context) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var deps = resolveDeps(props, context, options);
    (0, $ani5R.onMounted)(()=>{
        if (deps.initWatcher) deps.initWatcher();
        if (deps.initMessageBag) deps.initMessageBag();
        if (deps.initValidation) deps.initValidation();
    });
    return _objectSpread2$1({}, deps);
};
var static_ = function static_(props, context) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var deps = resolveDeps(props, context, options);
    return _objectSpread2$1({}, deps);
};
var multilingual$8 = function multilingual(props, context) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var deps = resolveDeps(props, context, options);
    (0, $ani5R.onMounted)(()=>{
        deps.initWatcher();
        deps.initState();
        deps.initMessageBag();
        deps.initValidation();
    });
    return _objectSpread2$1({}, deps);
};
var location$3 = function location(props, context) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { displayKey } = (0, $8bTPG.toRefs)(props);
    var deps = resolveDeps(props, context, options);
    (0, $ani5R.onMounted)(()=>{
        if (deps.value.value[displayKey.value]) deps.input.value.value = deps.value.value[displayKey.value];
    });
    (0, $ani5R.onMounted)(()=>{
        deps.initWatcher();
        deps.initMessageBag();
        deps.initValidation();
    });
    return _objectSpread2$1({}, deps);
};
var BaseElement = {
    props: {
        name: {
            required: true,
            type: [
                String,
                Number
            ]
        },
        conditions: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        onBeforeCreate: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onCreated: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeMount: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onMounted: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeUpdate: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onUpdated: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onBeforeUnmount: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onUnmounted: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    }
};
var HasView = {
    props: {
        inline: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        layout: {
            required: false,
            type: [
                String,
                Object,
                Boolean
            ],
            default: 'ElementLayout',
            private: true
        },
        addClass: {
            required: false,
            type: [
                Array,
                Object,
                String,
                Function
            ],
            default: null
        },
        removeClass: {
            required: false,
            type: [
                Array,
                Object,
                Function
            ],
            default: null
        },
        replaceClass: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        overrideClass: {
            required: false,
            type: [
                Array,
                Object,
                String,
                Function
            ],
            default: null
        },
        addClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: ()=>({})
        },
        replaceClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: ()=>({})
        },
        removeClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: ()=>({})
        },
        overrideClasses: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: ()=>({})
        },
        presets: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        view: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        views: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        size: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        columns: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            default: null
        },
        templates: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        description: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        info: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        infoPosition: {
            required: false,
            type: [
                String
            ],
            default: 'right'
        },
        label: {
            required: false,
            type: [
                String,
                Object,
                Function
            ],
            localized: true,
            default: null
        },
        before: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: null
        },
        between: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: null
        },
        after: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: null
        },
        slots: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    }
};
var ButtonElement = {
    name: 'ButtonElement',
    mixins: [
        BaseElement,
        HasView
    ],
    emits: [
        'click',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'button',
            private: true
        },
        buttonLabel: {
            required: false,
            type: [
                String,
                Object,
                Function
            ],
            default: null
        },
        buttonType: {
            required: false,
            type: [
                String
            ],
            default: 'button' // button|anchor
        },
        buttonClass: {
            required: false,
            type: [
                String,
                Array,
                Object
            ],
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        loading: {
            required: false,
            type: [
                Function,
                Boolean
            ],
            default: false
        },
        href: {
            required: false,
            type: [
                String
            ],
            default: ''
        },
        target: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        onClick: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        resets: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        submits: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        secondary: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        danger: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        full: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: undefined
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            static_$1,
            base$1h,
            static_$2,
            button$1,
            base$19,
            base$14,
            base$12,
            base$11,
            base$Z,
            base$$,
            base$1f,
            base$13,
            base$10,
            button,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'description',
            'before',
            'between',
            'after',
            'default'
        ];
        return _objectSpread2$1({}, static_(props, context));
    }
};
var base$Q = function base(props, context, dependencies) {
    // ================ DATA ================
    /**
   * The main input field of the element.
   *
   * @type {HTMLElement}
   */ var input = (0, $8bTPG.ref)(null);
    return {
        input: input
    };
};
var select$4 = function select(props, context, dependencies) {
    // ================ DATA ================
    /**
   * The main input field of the element, which can be a [`Multiselect`](https://github.com/vueform/multiselect) component.
   *
   * @type {HTMLElement}
   */ var input = (0, $8bTPG.ref)(null);
    return {
        input: input
    };
};
var multiselect$4 = select$4;
var tags$4 = select$4;
function checkDateFormat(format, date, moment) {
    if (!(date instanceof Date) && moment(date, format).format(format) !== date) console.warn("Wrong formatted date. Expected format: \"".concat(format, "\", received: \"").concat(date, "\""));
}
var getRowKey = (name)=>{
    var parts = name.split('_');
    return parts[parts.length - 2];
};
var getColKey = (name)=>{
    var parts = name.split('_');
    return parts[parts.length - 1];
};
var valueGet = (_ref)=>{
    var { parent, name, form$, dataPath, internalValue, defaultValue } = _ref;
    var value;
    if (parent.value && parent.value.isMatrixType) {
        var row = parent.value.resolvedRows[getRowKey(name.value)];
        var col = parent.value.resolvedColumns[getColKey(name.value)];
        var rowModel = form$.value.isSync ? get_1(form$.value.model, "".concat(parent.value.dataPath, ".").concat(row.value)) : parent.value.value[row.value];
        switch(parent.value.dataType){
            case 'assoc':
                value = rowModel === col.value ? true : null;
                break;
            case 'array':
                value = Array.isArray(rowModel) && rowModel.includes(col.value);
                break;
            default:
                value = rowModel === null || rowModel === void 0 ? void 0 : rowModel[col.value];
        }
    } else if (form$.value.isSync) value = get_1(form$.value.model, dataPath.value);
    else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType || parent.value.isListType)) value = parent.value.value[name.value];
    else value = internalValue === null || internalValue === void 0 ? void 0 : internalValue.value;
    return value !== undefined ? value : (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value) instanceof File ? defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value : cloneDeep_1(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value);
};
var valueSet = (val, _ref)=>{
    var { parent, name, form$, dataPath, internalValue } = _ref;
    if (parent.value && parent.value.isMatrixType) {
        var row = parent.value.resolvedRows[getRowKey(name.value)];
        var col = parent.value.resolvedColumns[getColKey(name.value)];
        var matrixModel = form$.value.isSync ? get_1(form$.value.model, parent.value.dataPath) : parent.value.value;
        var rowModel = matrixModel[row.value];
        var newValue;
        switch(parent.value.dataType){
            case 'assoc':
                var assocValue;
                if (val) assocValue = col.value;
                else if (rowModel === col.value || rowModel && typeof rowModel !== typeof col.value) assocValue = null;
                newValue = _objectSpread2$1({}, matrixModel);
                if (assocValue !== undefined) newValue[row.value] = assocValue;
                break;
            case 'array':
                var arrayValue = [];
                parent.value.resolvedColumns.forEach((column, c)=>{
                    if (Array.isArray(rowModel) && rowModel.includes(column.value) && column.value !== col.value || column.value === col.value && val) arrayValue.push(column.value);
                });
                newValue = _objectSpread2$1(_objectSpread2$1({}, matrixModel), {}, {
                    [row.value]: arrayValue
                });
                break;
            default:
                var newParentValue = {};
                parent.value.resolvedRows.forEach((Row, r)=>{
                    newParentValue[Row.value] = _objectSpread2$1({}, Object.keys(matrixModel[Row.value] || {}).filter((k)=>parent.value.resolvedColumns.map((c)=>String(c.value)).includes(k)).reduce((prev, curr)=>_objectSpread2$1(_objectSpread2$1({}, prev), {}, {
                            [curr]: matrixModel[Row.value][curr]
                        }), {}));
                    if (Row.value === row.value) parent.value.resolvedColumns.forEach((Column, c)=>{
                        newParentValue[row.value][Column.value] = Column.value === col.value ? val : newParentValue[row.value][Column.value];
                    });
                });
                newValue = newParentValue;
        }
        if (form$.value.isSync) form$.value.updateModel(parent.value.dataPath, newValue);
        else parent.value.value = newValue;
    } else if (form$.value.isSync) form$.value.updateModel(dataPath.value, val);
    else if (parent.value && parent.value.isListType) {
        var _newValue = parent.value.value.map((v, k)=>k == name.value ? val : v);
        parent.value.update(_newValue);
    } else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType)) parent.value.value = Object.assign({}, parent.value.value, {
        [name.value]: val
    });
    else internalValue.value = val;
};
var base$P = function base(props, context, dependencies) {
    var _options$value, _options$value2;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { name, type, inputType } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var parent = dependencies.parent;
    var defaultValue = dependencies.defaultValue;
    var dataPath = dependencies.dataPath;
    var form$ = dependencies.form$;
    dependencies.isObject;
    dependencies.isGroup;
    dependencies.isList;
    // ================ DATA =================
    /**
   * The initial value of the element.
   * 
   *
   * @type {any}
   * @private
   */ var initialValue = (0, $8bTPG.ref)(valueGet({
        parent: parent,
        name: name,
        form$: form$,
        dataPath: dataPath
    }));
    // ============== COMPUTED ===============
    /**
   * The store for the value of the element when we're not using external data (form's `v-model`).
   *
   * @type {any}
   * @private
   */ var internalValue = (0, $8bTPG.ref)(defaultValue.value instanceof File ? defaultValue.value : cloneDeep_1(defaultValue.value));
    /**
   * The value of the element.
   *
   * @type {any}
   */ var value = (0, $8bTPG.computed)({
        get: ((_options$value = options.value) === null || _options$value === void 0 ? void 0 : _options$value.get) || function() {
            return valueGet({
                parent: parent,
                name: name,
                form$: form$,
                dataPath: dataPath,
                internalValue: internalValue,
                defaultValue: defaultValue
            });
        },
        set: ((_options$value2 = options.value) === null || _options$value2 === void 0 ? void 0 : _options$value2.set) || function(val) {
            return valueSet(val, {
                parent: parent,
                name: name,
                form$: form$,
                dataPath: dataPath,
                internalValue: internalValue
            });
        }
    });
    /**
   * Intermediary value between element's value and field's `v-model`. It is required when we need to transform the value format between the element and its field.
   *
   * @type {any}
   */ var model = (0, $8bTPG.computed)({
        get () {
            return value.value;
        },
        set (val) {
            value.value = val;
        }
    });
    /**
   * Whether the element has its default value.
   *
   * @type {boolean}
   */ var isDefault = (0, $8bTPG.computed)(()=>{
        return isEqual_1(value.value, defaultValue.value);
    });
    if (options.init === undefined || options.init !== false) // If element's value was undefined initially (not found in v-model/data) then we need to set its value
    {
        if (initialValue.value === undefined) value.value = defaultValue.value instanceof File ? defaultValue.value : cloneDeep_1(defaultValue.value);
    }
    // ============== WATCHERS ===============
    /* istanbul ignore next: type can not be changed on the fly */ (0, $8bTPG.watch)(type, ()=>{
        value.value = defaultValue.value instanceof File ? defaultValue.value : cloneDeep_1(defaultValue.value);
    });
    return {
        initialValue: initialValue,
        internalValue: internalValue,
        value: value,
        model: model,
        isDefault: isDefault
    };
};
var matrix$4 = function matrix(props, context, dependencies) {
    var { name, type, rows } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var { parent, defaultValue, dataPath, form$, isObject, isGroup, isList, hasDynamicRows, computedRows, resolvedRows, resolvedColumns, rowsCount } = dependencies;
    // ================ DATA =================
    var initialValue = (0, $8bTPG.ref)(undefined);
    // If sync
    if (form$.value.isSync) initialValue.value = get_1(form$.value.model, dataPath.value);
    else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType || parent.value.isListType)) initialValue.value = parent.value.value[name.value];
    // ============== COMPUTED ===============
    var internalValue = (0, $8bTPG.ref)(cloneDeep_1(defaultValue.value));
    /**
   * The value of the element.
   *
   * @type {any}
   */ var value = (0, $8bTPG.computed)({
        get: function get() {
            var value;
            // If sync
            if (form$.value.isSync) value = get_1(form$.value.model, dataPath.value);
            else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType || parent.value.isListType)) value = parent.value.value[name.value];
            else value = internalValue.value;
            value = value !== undefined ? value : cloneDeep_1(defaultValue.value);
            if (hasDynamicRows.value) value = Object.values(value);
            return value;
        },
        set: function set(val) {
            // // If sync
            if (form$.value.isSync) form$.value.updateModel(dataPath.value, val);
            else if (parent.value && parent.value.isListType) parent.value.update(parent.value.value.map((v, k)=>k == name.value ? val : v));
            else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType)) parent.value.value = Object.assign({}, parent.value.value, {
                [name.value]: val
            });
            else internalValue.value = val;
        }
    });
    var model = (0, $8bTPG.computed)({
        get () {
            return value.value;
        },
        set (val) {
            value.value = val;
        }
    });
    var isDefault = (0, $8bTPG.computed)(()=>{
        return isEqual_1(value.value, defaultValue.value);
    });
    if (initialValue.value === undefined) value.value = defaultValue.value;
    else value.value = _objectSpread2$1(_objectSpread2$1({}, defaultValue.value), value.value);
    // ============== WATCHERS ===============
    (0, $8bTPG.watch)(type, ()=>{
        value.value = cloneDeep_1(defaultValue.value);
    });
    return {
        initialValue: initialValue,
        internalValue: internalValue,
        value: value,
        model: model,
        isDefault: isDefault
    };
};
var list$3 = function list(props, context, dependencies) {
    var { initialValue, internalValue, value, model, isDefault } = base$P(props, context, dependencies, {
        init: false
    });
    return {
        initialValue: initialValue,
        internalValue: internalValue,
        value: value,
        model: model,
        isDefault: isDefault
    };
};
var object$6 = function object(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { initialValue, internalValue, value, isDefault } = base$P(props, context, dependencies, {
        init: false
    });
    // ============ DEPENDENCIES =============
    var defaultValue = dependencies.defaultValue;
    // ================ HOOKS ================
    /* istanbul ignore else */ if (options.init === undefined || /* istanbul ignore next: init will always be false */ options.init !== false) {
        if (initialValue.value === undefined) value.value = defaultValue.value;
        else value.value = Object.assign({}, defaultValue.value, value.value);
    }
    return {
        internalValue: internalValue,
        value: value,
        isDefault: isDefault
    };
};
var group$5 = function group(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    // ============ DEPENDENCIES =============
    var parent = dependencies.parent;
    var dataPath = dependencies.dataPath;
    var defaultValue = dependencies.defaultValue;
    var children$Array = dependencies.children$Array;
    var form$ = dependencies.form$;
    dependencies.isObject;
    dependencies.isGroup;
    dependencies.isList;
    // ================ DATA =================
    /**
   * The store for the value of the element when we're not using external data (form's `v-model`).
   *
   * @type {any}
   * @private
   */ var internalValue = (0, $8bTPG.ref)(cloneDeep_1(defaultValue.value));
    // ============== COMPUTED ===============
    var value = (0, $8bTPG.computed)(options.value || {
        get () {
            var value;
            if (form$.value.isSync) value = dataPath.value ? get_1(form$.value.model, dataPath.value) || {} : form$.value.model;
            else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType)) value = parent.value.value;
            else value = internalValue.value;
            // Filter out children values that parent has but not among group elements
            var childKeys = children$Array.value.reduce((all, child$)=>{
                /* istanbul ignore else */ if (!child$ || child$.isStatic) return all;
                var keys = [];
                if (!child$.flat) keys.push(child$.name);
                else {
                    var addGroupKeys = (children$Array)=>{
                        children$Array.forEach((child$)=>{
                            if (!child$.isStatic && child$.flat) addGroupKeys(child$.children$Array);
                            else if (!child$.isStatic) keys.push(child$.name);
                        });
                    };
                    addGroupKeys(child$.children$Array);
                }
                return all.concat(keys);
            }, []);
            var tempValue = {};
            childKeys.forEach((key)=>{
                /* istanbul ignore else */ if (value[key] !== undefined) tempValue[key] = value[key];
            });
            value = tempValue;
            return value !== undefined ? value : /* istanbul ignore next: will never reach, internalValue is assigned at the beginning */ cloneDeep_1(defaultValue.value);
        },
        set (val) {
            if (form$.value.isSync) form$.value.updateModel(dataPath.value, val);
            else if (parent.value && (parent.value.isObjectType || parent.value.isGroupType || parent.value.isGridType)) parent.value.value = Object.assign({}, parent.value.value, val);
            else internalValue.value = val;
        }
    });
    var isDefault = (0, $8bTPG.computed)(()=>{
        return isEqual_1(value.value, defaultValue.value);
    });
    return {
        value: value,
        isDefault: isDefault
    };
};
var multilingual$7 = function multilingual(props, context, dependencies) {
    var { value, isDefault } = base$P(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var language = dependencies.language;
    // ============== COMPUTED ===============
    var model = (0, $8bTPG.computed)({
        get () {
            return value.value[language.value];
        },
        set (val) {
            value.value = Object.assign({}, value.value, {
                [language.value]: val
            });
        }
    });
    return {
        value: value,
        model: model,
        isDefault: isDefault
    };
};
var date$3 = function date(props, context, dependencies) {
    var { name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var parent = dependencies.parent;
    var valueDateFormat = dependencies.valueDateFormat;
    var defaultValue = dependencies.defaultValue;
    var dataPath = dependencies.dataPath;
    var form$ = dependencies.form$;
    dependencies.isObject;
    dependencies.isGroup;
    dependencies.isList;
    var moment = form$.value.$vueform.services.moment;
    // ================= PRE =================
    /**
   * The store for the value of the element when we're not using external data (form's `v-model`).
   *
   * @type {any}
   * @private
   */ var internalValue = (0, $8bTPG.ref)(cloneDeep_1(defaultValue.value));
    var { value, initialValue, isDefault } = base$P(props, context, dependencies, {
        value: {
            get () {
                return valueGet({
                    parent: parent,
                    name: name,
                    form$: form$,
                    dataPath: dataPath,
                    internalValue: internalValue,
                    defaultValue: defaultValue
                });
            },
            set (val) {
                // If the value is not a Date object check if it is matching the value format
                if (!isEmpty_1(val) && !(val instanceof Date) && valueDateFormat.value !== false) checkDateFormat(valueDateFormat.value, val, moment);
                val = val && val instanceof Date && valueDateFormat.value !== false ? moment(val).format(valueDateFormat.value) : val;
                return valueSet(val, {
                    parent: parent,
                    name: name,
                    form$: form$,
                    dataPath: dataPath,
                    internalValue: internalValue
                });
            }
        }
    });
    // ============== COMPUTED ===============
    var model = (0, $8bTPG.computed)(()=>{
        return value.value instanceof Date || !value.value ? value.value : moment(value.value, valueDateFormat.value).toDate();
    });
    return {
        value: value,
        model: model,
        initialValue: initialValue,
        internalValue: internalValue,
        isDefault: isDefault
    };
};
var dates$4 = function dates(props, context, dependencies) {
    var { name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var parent = dependencies.parent;
    var valueDateFormat = dependencies.valueDateFormat;
    var defaultValue = dependencies.defaultValue;
    var dataPath = dependencies.dataPath;
    var form$ = dependencies.form$;
    dependencies.isObject;
    dependencies.isGroup;
    dependencies.isList;
    var moment = form$.value.$vueform.services.moment;
    // ================= PRE =================
    /**
   * The store for the value of the element when we're not using external data (form's `v-model`).
   *
   * @type {any}
   * @private
   */ var internalValue = (0, $8bTPG.ref)(cloneDeep_1(defaultValue.value));
    var { value, initialValue, isDefault } = base$P(props, context, dependencies, {
        value: {
            get () {
                return valueGet({
                    parent: parent,
                    name: name,
                    form$: form$,
                    dataPath: dataPath,
                    internalValue: internalValue,
                    defaultValue: defaultValue
                });
            },
            set (val) {
                if (!Array.isArray(val)) val = [
                    val
                ];
                val = val.map((v)=>{
                    if (!isEmpty_1(v) && !(v instanceof Date) && valueDateFormat.value !== false) checkDateFormat(valueDateFormat.value, v, moment);
                    return v && v instanceof Date && valueDateFormat.value !== false ? moment(v).format(valueDateFormat.value) : v;
                });
                return valueSet(val, {
                    parent: parent,
                    name: name,
                    form$: form$,
                    dataPath: dataPath,
                    internalValue: internalValue
                });
            }
        }
    });
    // ============== COMPUTED ===============
    var model = (0, $8bTPG.computed)(()=>{
        return value.value.map((v)=>{
            return v instanceof Date || !v ? v : moment(v, valueDateFormat.value).toDate();
        });
    });
    return {
        value: value,
        model: model,
        initialValue: initialValue,
        internalValue: internalValue,
        isDefault: isDefault
    };
};
var base$O = function base(props, context, dependencies) {
    // ============== COMPUTED ===============
    /**
   * The null value of the element.
   *
   * @type {any}
   * @private
   */ var nullValue = (0, $8bTPG.computed)(()=>{
        return null;
    });
    return {
        nullValue: nullValue
    };
};
var array$1 = function array(props, context, dependencies) {
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return [];
    });
    return {
        nullValue: nullValue
    };
};
var boolean = function boolean(props, context, dependencies) {
    var { falseValue } = (0, $8bTPG.toRefs)(props);
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return falseValue.value;
    });
    return {
        nullValue: nullValue
    };
};
var min = function min(props, context, dependencies) {
    var { min, default: default_ } = (0, $8bTPG.toRefs)(props);
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return default_.value !== undefined && isArray_1(default_.value) ? default_.value.map((v)=>min.value) : min.value;
    });
    return {
        nullValue: nullValue
    };
};
var object$5 = function object(props, context, dependencies) {
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return {};
    });
    return {
        nullValue: nullValue
    };
};
var location$2 = function location(props, context, dependencies) {
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return {
            country: null,
            country_code: null,
            state: null,
            state_code: null,
            city: null,
            zip: null,
            address: null,
            formatted_address: null,
            lat: null,
            lng: null
        };
    });
    return {
        nullValue: nullValue
    };
};
var multilingual$6 = function multilingual(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var languages = dependencies.languages;
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        var value = {};
        each(languages.value, (code)=>{
            value[code] = null;
        });
        return value;
    });
    return {
        nullValue: nullValue
    };
};
var generic = function generic(props, context, dependencies) {
    // ============== COMPUTED ===============
    var nullValue = (0, $8bTPG.computed)(()=>{
        return context.nullValue !== undefined ? context.nullValue : null;
    });
    return {
        nullValue: nullValue
    };
};
var base$N = function base(props, context, dependencies) {
    var { name, floating, placeholder, label, fieldName } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var Label = dependencies.Label;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * The generic name of the element constructed from label / floating or element name.
   *
   * @type {string}
   * @private.
   */ var genericName = (0, $8bTPG.computed)(()=>{
        if (fieldName && fieldName.value) return localize(fieldName.value, config$.value, form$.value);
        else if (label && label.value) return Label.value;
        else if (floating && floating.value) return localize(floating.value, config$.value, form$.value);
        else if (placeholder && placeholder.value && form$.value.options.floatPlaceholders) return localize(placeholder.value, config$.value, form$.value);
        else return upperFirst_1(name.value).replace(/_|-/g, ' ');
    });
    return {
        genericName: genericName
    };
};
var file$2 = function file(props, context, dependencies) {
    var { name, embed, label, fieldName } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var Label = dependencies.Label;
    var filename = dependencies.filename || /* istanbul ignore next: failsafe only */ (0, $8bTPG.ref)(null);
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * The generic name of the element constructed from label / floating, element name or default file name if name is a number.
   *
   * @type {string}
   * @private.
   */ var genericName = (0, $8bTPG.computed)(()=>{
        if (embed.value && filename.value) return filename.value;
        else if (fieldName && fieldName.value) return localize(fieldName.value, config$.value, form$.value);
        else if (label.value) return Label.value;
        else return /^\d+$/.test(name.value) ? form$.value.translations.vueform.elements.file.defaultName : upperFirst_1(name.value).replace(/_|-/g, ' ');
    });
    return {
        genericName: genericName
    };
};
var base$M = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    var nullValue = dependencies.nullValue;
    // ============== COMPUTED ==============
    /**
   * Whether the element has no value filled in.
   *
   * @type {boolean}
   */ var empty = (0, $8bTPG.computed)(()=>{
        return isEqual_1(value.value, nullValue.value) || [
            undefined,
            null,
            ''
        ].indexOf(value.value) !== -1;
    });
    return {
        empty: empty
    };
};
var multilingual$5 = function multilingual(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    var nullValue = dependencies.nullValue;
    var language = dependencies.language;
    // ============== COMPUTED ==============
    var empty = (0, $8bTPG.computed)(()=>{
        return value.value[language.value] == nullValue.value[language.value] || value.value[language.value] === '';
    });
    return {
        empty: empty
    };
};
var array = function array(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    var nullValue = dependencies.nullValue;
    // ============== COMPUTED ==============
    var empty = (0, $8bTPG.computed)(()=>{
        return isEqual_1(value.value, nullValue.value) || [
            undefined,
            null,
            ''
        ].indexOf(value.value) !== -1 || value.value.length == 0;
    });
    return {
        empty: empty
    };
};
var base$L = function base(props, context, dependencies) {
    var { loading } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var pending = dependencies.pending;
    // ============== COMPUTED ==============
    /**
   * Whether the element is in loading state.
   *
   * @type {boolean}
   */ var isLoading = (0, $8bTPG.computed)(()=>{
        return pending.value || loading.value;
    });
    return {
        isLoading: isLoading
    };
};
var base$K = function base(props, context, dependencies) {
    var { floating, placeholder } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    // ============== COMPUTED ==============
    /**
   * Whether the element floating label.
   *
   * @type {boolean}
   */ var hasFloating = (0, $8bTPG.computed)(()=>{
        return !!(!!floating.value || placeholder.value && form$.value.options.floatPlaceholders) && floating.value !== false;
    });
    return {
        hasFloating: hasFloating
    };
};
var base$J = function base(props, context, dependencies) {
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var fire = dependencies.fire;
    var dirt = dependencies.dirt;
    var validate = dependencies.validate;
    var value = dependencies.value;
    // =============== METHODS ===============
    var initWatcher = ()=>{
        (0, $8bTPG.watch)(value, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, el$1.value);
            /* istanbul ignore else */ if (dirt) dirt();
            if (validate && form$.value.shouldValidateOnChange) validate();
        }, {
            immediate: false,
            deep: true
        });
    };
    return {
        initWatcher: initWatcher
    };
};
var multilingual$4 = function multilingual(props, context, dependencies) {
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var fire = dependencies.fire;
    var dirt = dependencies.dirt;
    var value = dependencies.value;
    var language = dependencies.language;
    var validateLanguage = dependencies.validateLanguage;
    // =============== METHODS ===============
    var initWatcher = ()=>{
        (0, $8bTPG.watch)(value, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, el$1.value);
            /* istanbul ignore else */ if (dirt) dirt();
            if (form$.value.shouldValidateOnChange) validateLanguage(language.value);
        }, {
            immediate: false,
            deep: true
        });
    };
    return {
        initWatcher: initWatcher
    };
};
var list$2 = function list(props, context, dependencies) {
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var fire = dependencies.fire;
    var dirt = dependencies.dirt;
    var validateValidators = dependencies.validateValidators;
    var value = dependencies.value;
    // =============== METHODS ===============
    var initWatcher = ()=>{
        (0, $8bTPG.watch)(value, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, el$1.value);
            /* istanbul ignore else */ if (dirt) dirt();
            /* istanbul ignore else */ if (validateValidators && form$.value.shouldValidateOnChange) validateValidators();
        }, {
            immediate: false,
            deep: true
        });
    };
    return {
        initWatcher: initWatcher
    };
};
var object$4 = function object(props, context, dependencies) {
    // ============ DEPENDENCIES =============
    var { form$, fire, value, el$: el$1, dirt, validateValidators } = dependencies;
    // =============== METHODS ===============
    var initWatcher = ()=>{
        (0, $8bTPG.watch)(value, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, el$1.value);
            /* istanbul ignore else */ if (dirt) dirt();
            /* istanbul ignore else */ if (validateValidators && form$.value.shouldValidateOnChange) validateValidators();
        }, {
            immediate: false,
            deep: true
        });
    };
    return {
        initWatcher: initWatcher
    };
};
var location$1 = function location(props, context, dependencies) {
    var { displayKey } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var el$1 = dependencies.el$;
    var fire = dependencies.fire;
    var dirt = dependencies.dirt;
    var validate = dependencies.validate;
    var value = dependencies.value;
    var input = dependencies.input;
    // =============== METHODS ===============
    var initWatcher = ()=>{
        (0, $8bTPG.watch)(value, (n, o)=>{
            if (dataEquals(n, o)) return;
            fire('change', n, o, el$1.value);
            dirt();
            input.value.value = input.value && value.value && value.value[displayKey.value] !== undefined ? value.value[displayKey.value] : '';
            /* istanbul ignore else */ if (validate && form$.value.shouldValidateOnChange) validate();
        }, {
            immediate: false,
            deep: true
        });
    };
    return {
        initWatcher: initWatcher
    };
};
var multifile$5 = list$2;
var group$4 = object$4;
var base$I = function base(props, context, dependencies) {
    var { provider: elementProvider, options, readonly } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var { form$, input, model, nullValue, messageBag, validate, el$: el$1, invalid, isDisabled, resetValidators, resetting, initValidation } = dependencies;
    // ================ DATA ================
    /**
   * The captcha provider instance.
   * @type {object|null}
   */ var Provider = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Whether the captcha should verify.
   *
   * @type {boolean}
   */ var shouldVerify = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && !readonly.value;
    });
    /**
   * The captcha provider name.
   *
   * @type {string}
   * @private
   */ var provider = (0, $8bTPG.computed)(()=>{
        return elementProvider.value || form$.value.options.useProviders.captcha;
    });
    /**
   * The captcha options.
   *
   * @type {object}
   */ var captchaOptions = (0, $8bTPG.computed)(()=>{
        return _objectSpread2$1(_objectSpread2$1({}, form$.value.options.providerOptions[provider.value]), options.value);
    });
    // =============== METHODS ==============
    /**
   * Inits captcha provider.
   *
   * @returns {void}
   */ var initCaptcha = ()=>{
        model.value = nullValue.value;
        Provider.value = new form$.value.options.providers.captcha[provider.value](input.value, captchaOptions.value, el$1.value);
    };
    /**
   * Destroys the captcha provider.
   *
   * @returns {void}
   */ var destroyCaptcha = ()=>{
        resetValidators();
        Provider.value.reset();
        model.value = nullValue.value;
        Provider.value = null;
    };
    // ================ HOOKS ===============
    (0, $ani5R.onMounted)(()=>{
        if (shouldVerify.value) initCaptcha();
    });
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(shouldVerify, /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*(n, o) {
            if (!n) destroyCaptcha();
            else if (n) {
                yield (0, $ani5R.nextTick)();
                initCaptcha();
                initValidation();
            }
        });
        return function(_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        Provider: Provider,
        captchaOptions: captchaOptions,
        shouldVerify: shouldVerify,
        initCaptcha: initCaptcha,
        destroyCaptcha: destroyCaptcha
    };
};
var base$H = function base(props, context, dependencies) {
    var { rules } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var path = dependencies.path;
    var el$1 = dependencies.el$;
    // ================ DATA ================
    /**
   * Helper property used to store the element states.
   *
   * @type {object}
   * @default { dirty: false, validate: true }
   * @private
   */ var state = (0, $8bTPG.ref)({
        dirty: false,
        validated: true
    });
    /**
   * An array containing all the validators of the element.
   *
   * @type {array}
   * @default []
   * @private
   */ var Validators = (0, $8bTPG.ref)([]);
    /**
   * Instance of MessageBag service. Custom errors and messages [can be added](/docs/validating-elements#custom-errors-and-messages).
   *
   * @type {MessageBag}
   * @default MessageBag
   */ var messageBag = (0, $8bTPG.ref)({});
    /**
   * Instance of ValidatorFactory.
   *
   * @type {ValidatorFactory}
   * @default ValidatorFactory
   * @private
   */ var validatorFactory = (0, $8bTPG.reactive)({});
    /**
   * Whether the element is currently being resetet (no validation should happen).
   *
   *
   * @type {boolean}
   * @default false
   * @private
   */ var resetting = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ===============
    /**
   * The element's validation rules.
   *
   * @type {string|array}
   * @private
   */ var validationRules = (0, $8bTPG.computed)(()=>{
        return rules.value;
    });
    /**
   * Whether the element's value was modified.
   *
   * @type {boolean}
   */ var dirty = (0, $8bTPG.computed)(()=>{
        return state.value.dirty;
    });
    /**
   * Whether the element was already validated at least once.
   *
   * @type {boolean}
   */ var validated = (0, $8bTPG.computed)(()=>{
        return state.value.validated;
    });
    /**
   * Whether the element has any failing rules.
   *
   * @type {boolean}
   */ var invalid = (0, $8bTPG.computed)(()=>{
        return some_1(Validators.value, {
            invalid: true
        });
    });
    /**
   * Whether the element has any async rules in progress.
   *
   * @type {boolean}
   */ var pending = (0, $8bTPG.computed)(()=>{
        return some_1(Validators.value, {
            pending: true
        });
    });
    /**
   * Whether the element is `pending`.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return pending.value;
    });
    /**
   * The list of errors of failing rules.
   *
   * @type {array}
   * @private
   */ var validatorErrors = (0, $8bTPG.computed)(()=>{
        var errs = [];
        each(Validators.value, (Validator)=>{
            if (Validator.failing) errs.push(Validator.message);
        });
        return errs;
    });
    /**
   * All the errors of `MessageBag`.
   *
   * @type {array}
   */ var errors = (0, $8bTPG.computed)(()=>{
        return messageBag.value.errors;
    });
    /**
   * The first error of `MessageBag`.
   *
   * @type {string}
   */ var error = (0, $8bTPG.computed)(()=>{
        return messageBag.value.error || null;
    });
    /**
   * Whether the element has errors.
   *
   * @type {boolean}
   */ var isDanger = (0, $8bTPG.computed)(()=>{
        return error.value !== null;
    });
    /**
   * Whether the element has been filled in successfully.
   *
   * @type {boolean}
   */ var isSuccess = (0, $8bTPG.computed)(()=>{
        return validationRules.value && validationRules.value.length > 0 && state.value.validated && !invalid.value || (!validationRules.value || !validationRules.value.length) && dirty.value;
    });
    /**
   * Whether the element is required (has required rule).
   * 
   * @type {boolean}
   */ var isRequired = (0, $8bTPG.computed)(()=>{
        return Validators.value.some((Validator)=>{
            var _Validator$conditions;
            if (Validator.name !== 'required') return;
            if (!((_Validator$conditions = Validator.conditions) !== null && _Validator$conditions !== void 0 && _Validator$conditions.length)) return true;
            return Validator.conditions(form$.value, Validator, el$1.value);
        });
    });
    /**
   * Whether the element should use a custom logic for checking if it is filled when validating.
   * 
   * @type {boolean}
   */ var useCustomFilled = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Whether the element is filled is `useCustomFilled` is `true`.
   * 
   * @type {boolean}
   */ var isFilled = (0, $8bTPG.computed)(()=>{
        return true;
    });
    // =============== METHODS ===============
    /**
   * Checks each validation rule for the element (async).
   *
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*() {
            if (!validationRules.value) return;
            if (form$.value.validation === false) return;
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(function*(Validator) {
                    yield Validator.validate();
                });
                return function(_x) {
                    return _ref2.apply(this, arguments);
                };
            }());
            state.value.validated = true;
        });
        return function validate() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Sets the validators to default state.
   *
   * @returns {void}
   */ var resetValidators = ()=>{
        each(Validators.value, (Validator)=>{
            Validator.reset();
        });
        state.value.validated = !validationRules.value;
    };
    /**
   * Flag the element as dirty.
   *
   * @returns {void}
   * @private
   */ var dirt = ()=>{
        state.value.dirty = true;
    };
    /**
   * Removes the element's `dirty` state.
   *
   * @returns {void}
   */ var clean = ()=>{
        state.value.dirty = false;
    };
    /**
   * Clears the manually added messages from the [`messageBag`](#property-message-bag).
   *
   * @returns {void}
   */ var clearMessages = ()=>{
        /* istanbul ignore else */ if (messageBag.value) messageBag.value.clear();
    };
    /**
   * Initializes MessageBag service.
   *
   * @returns {void}
   * @private
   */ var initMessageBag = ()=>{
        messageBag.value = new form$.value.$vueform.services.messageBag(validatorErrors);
    };
    /**
   * Initializes validators.
   *
   * @returns {void}
   * @private
   */ var initValidation = ()=>{
        /* istanbul ignore else */ if (!validationRules.value) {
            Validators.value = [];
            return;
        }
        // If the element has rules it does not
        // qualify as validated by default
        state.value.validated = false;
        validatorFactory.value = new form$.value.$vueform.services.validation.factory(path.value, form$.value);
        Validators.value = [];
        each(validatorFactory.value.makeAll(validationRules.value), (Validator)=>{
            Validators.value.push(Validator);
        });
    };
    /**
   * Re-initializes validators when rules have changed.
   *
   * @returns {void}
   */ var reinitValidation = ()=>{
        initValidation();
    };
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        busy: busy,
        errors: errors,
        error: error,
        validationRules: validationRules,
        isDanger: isDanger,
        isSuccess: isSuccess,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validate: validate,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var text$2 = function text(props, context, dependencies) {
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, errors, error, validationRules, isDanger, isSuccess, isRequired, useCustomFilled, isFilled, validate, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = base$H(props, context, dependencies);
    // ============== COMPUTED ===============
    /**
   * Whether the element has a validation rule with pending debounce.
   *
   * @type {boolean}
   */ var debouncing = (0, $8bTPG.computed)(()=>{
        return some_1(Validators.value, {
            debouncing: true
        });
    });
    /**
   * Whether the element is `pending` or `debouncing`.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return pending.value || debouncing.value;
    });
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        errors: errors,
        error: error,
        validationRules: validationRules,
        isDanger: isDanger,
        isSuccess: isSuccess,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validate: validate,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var list$1 = function list(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { state, Validators, messageBag, validationRules, dirt, initValidation, resetting, isRequired, useCustomFilled, isFilled } = base$H(props, context, dependencies);
    var form$ = dependencies.form$;
    var children$ = dependencies.children$;
    // ============== COMPUTED ==============
    /**
   * Whether the element's or any of its children's value was modified.
   *
   * @type {boolean}
   */ var dirty = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            dirty: true
        }) || state.value.dirty;
    });
    /**
   * Whether the element and all of its children was already validated at least once.
   *
   * @type {boolean}
   */ var validated = (0, $8bTPG.computed)(()=>{
        return !some_1(children$.value, {
            available: true,
            validated: false
        }) && state.value.validated;
    });
    /**
   * Whether the element or any of its children has any failing rules.
   *
   * @type {boolean}
   */ var invalid = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            invalid: true
        }) || some_1(Validators.value, {
            invalid: true
        });
    });
    /**
   * Whether the element or any of its children has any async rules in progress.
   *
   * @type {boolean}
   */ var pending = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            pending: true
        }) || some_1(Validators.value, {
            pending: true
        });
    });
    /**
   * Whether the element or any of its children have a validation rule with pending debounce.
   *
   * @type {boolean}
   */ var debouncing = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            debouncing: true
        }) || some_1(Validators.value, {
            debouncing: true
        });
    });
    /**
   * Whether the element or any of its children is `pending` or `debouncing`.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            busy: true
        }) || pending.value || debouncing.value;
    });
    var validatorErrors = (0, $8bTPG.computed)(()=>{
        var validatorErrors = [];
        each(Validators.value, (Validator)=>{
            if (Validator.failing) validatorErrors.push(Validator.message);
        });
        return validatorErrors;
    });
    /**
   * The list of errors collected from children.
   *
   * @type {array}
   * @private
   */ var childrenErrors = (0, $8bTPG.computed)(()=>{
        var childrenErrors = [];
        each(children$.value, (element$)=>{
            if (!element$.available || element$.isStatic) return;
            each(element$.errors, (error)=>{
                childrenErrors.push(error);
            });
        });
        return childrenErrors;
    });
    /**
   * The `validatorErrors` concatenated with `childrenErrors`.
   *
   * @type {array}
   * @private
   */ var baseErrors = (0, $8bTPG.computed)(()=>{
        return validatorErrors.value.concat(childrenErrors.value);
    });
    var errors = (0, $8bTPG.computed)(()=>{
        return messageBag.value.errors;
    });
    var error = (0, $8bTPG.computed)(()=>{
        return head_1(validatorErrors.value);
    });
    // =============== METHODS ==============
    /**
   * Checks each validation rule for the element and validates children (async).
   *
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref3 = _asyncToGenerator(function*() {
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            yield validateValidators();
            yield validateChildren();
        });
        return function validate() {
            return _ref3.apply(this, arguments);
        };
    }();
    /**
   * Checks each validation rule for the element (async).
   *
   * @returns {Promise}
   */ var validateValidators = /*#__PURE__*/ function() {
        var _ref4 = _asyncToGenerator(function*() {
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            if (form$.value.validation === false) return;
            yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                var _ref5 = _asyncToGenerator(function*(Validator) {
                    yield Validator.validate();
                });
                return function(_x2) {
                    return _ref5.apply(this, arguments);
                };
            }());
            state.value.validated = true;
        });
        return function validateValidators() {
            return _ref4.apply(this, arguments);
        };
    }();
    /**
   * Validates every child (async).
   *
   * @returns {Promise}
   */ var validateChildren = /*#__PURE__*/ function() {
        var _ref6 = _asyncToGenerator(function*() {
            if (form$.value.validation === false) return;
            yield asyncForEach(children$.value, /*#__PURE__*/ function() {
                var _ref7 = _asyncToGenerator(function*(element$) {
                    /* istanbul ignore else */ if (!element$.isStatic) yield element$.validate();
                });
                return function(_x3) {
                    return _ref7.apply(this, arguments);
                };
            }());
        });
        return function validateChildren() {
            return _ref6.apply(this, arguments);
        };
    }();
    var clean = ()=>{
        each(children$.value, (element$)=>{
            /* istanbul ignore next: checked for console errors, but return can not be checked */ if (element$.isStatic) return;
            element$.clean();
        });
        state.value.dirty = false;
    };
    var clearMessages = ()=>{
        /* istanbul ignore else */ if (messageBag.value) messageBag.value.clear();
        each(children$.value, (element$)=>{
            /* istanbul ignore else */ if (element$.isStatic) return;
            element$.clearMessages();
        });
    };
    var resetValidators = ()=>{
        each(children$.value, (element$)=>{
            /* istanbul ignore next: checked for console errors, but return can not be checked */ if (element$.isStatic) return;
            element$.resetValidators();
        });
        each(Validators.value, (Validator)=>{
            Validator.reset();
        });
        state.value.validated = !validationRules.value;
    };
    var initMessageBag = ()=>{
        messageBag.value = new form$.value.$vueform.services.messageBag(baseErrors);
    };
    var reinitValidation = ()=>{
        initValidation();
        each(children$.value, (element$)=>{
            /* istanbul ignore next: checked for console errors, but return can not be checked */ if (element$.isStatic) return;
            element$.reinitValidation();
        });
    };
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validatorErrors: validatorErrors,
        childrenErrors: childrenErrors,
        errors: errors,
        error: error,
        validationRules: validationRules,
        validate: validate,
        validateValidators: validateValidators,
        validateChildren: validateChildren,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var grid = function grid(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, debouncing, busy, isRequired, useCustomFilled, isFilled, validatorErrors, childrenErrors, errors, validationRules, validate, validateValidators, validateChildren, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = list$1(props, context, dependencies);
    var { form$, children$, isTableView } = dependencies;
    // ============== COMPUTED ==============
    var error = (0, $8bTPG.computed)(()=>{
        return isTableView.value ? head_1(messageBag.value.errors) : head_1(validatorErrors.value);
    });
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validatorErrors: validatorErrors,
        childrenErrors: childrenErrors,
        errors: errors,
        error: error,
        validationRules: validationRules,
        validate: validate,
        validateValidators: validateValidators,
        validateChildren: validateChildren,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var multilingual$3 = function multilingual(props, context, dependencies) {
    var { rules } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var path = dependencies.path;
    var languages = dependencies.languages;
    var language = dependencies.language;
    var value = dependencies.value;
    var { messageBag, clearMessages, resetting, useCustomFilled, isFilled } = text$2(props, context, dependencies);
    // ================ DATA ================
    var state = (0, $8bTPG.ref)({
        dirty: {},
        validated: {}
    });
    var Validators = (0, $8bTPG.ref)({});
    // ============== COMPUTED ===============
    var validationRules = (0, $8bTPG.computed)(()=>{
        var ruleList = {};
        if (!rules.value) return ruleList;
        each(languages.value, (lang)=>{
            ruleList[lang] = isPlainObject_1(rules.value) ? rules.value[lang] || null : rules.value;
        });
        return ruleList;
    });
    /**
   * Whether the element's value has been modified in any language.
   *
   * @type {boolean}
   */ var dirty = (0, $8bTPG.computed)(()=>{
        return some_1(state.value.dirty, (val)=>{
            return val === true;
        });
    });
    /**
   * Whether all the languages have already been validated at least once.
   *
   * @type {boolean}
   */ var validated = (0, $8bTPG.computed)(()=>{
        return !some_1(state.value.validated, (val)=>{
            return val === false;
        });
    });
    /**
   * Whether the element has failing rules in any language.
   *
   * @type {boolean}
   */ var invalid = (0, $8bTPG.computed)(()=>{
        var invalid = false;
        each(Validators.value, (Validators)=>{
            if (some_1(Validators, {
                invalid: true
            })) invalid = true;
        });
        return invalid;
    });
    /**
   * Whether the element has any async rules in progress in any language.
   *
   * @type {boolean}
   */ var pending = (0, $8bTPG.computed)(()=>{
        var pending = false;
        each(Validators.value, (Validators)=>{
            if (some_1(Validators, {
                pending: true
            })) pending = true;
        });
        return pending;
    });
    /**
   * Whether the element has a validation rule with pending debounce in any language.
   *
   * @type {boolean}
   */ var debouncing = (0, $8bTPG.computed)(()=>{
        var debouncing = false;
        each(Validators.value, (Validators)=>{
            if (some_1(Validators, {
                debouncing: true
            })) debouncing = true;
        });
        return debouncing;
    });
    /**
   * Whether the element is `pending` or `debouncing` in any language.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return pending.value || debouncing.value;
    });
    var validatorErrors = (0, $8bTPG.computed)(()=>{
        var errors = [];
        each(Validators.value, (Validators, language)=>{
            each(Validators, (Validator)=>{
                if (Validator.failing) errors.push(Validator.message + ' (' + language + ')');
            });
        });
        return errors;
    });
    var errors = (0, $8bTPG.computed)(()=>{
        return messageBag.value.errors;
    });
    var error = (0, $8bTPG.computed)(()=>{
        var error = null;
        each(Validators.value[language.value], (Validator)=>{
            if (error !== null) return false;
            if (Validator.failing) error = Validator.message;
        });
        var errors = messageBag.value.prepends ? messageBag.value.prepends.errors : [];
        if (error !== null) errors = concat_1(errors, [
            error
        ]);
        errors = concat_1(errors, messageBag.value.appends ? messageBag.value.appends.errors : []);
        return head_1(errors);
    });
    /**
   * Whether the field has errors.
   *
   * @type {boolean}
   */ var isDanger = (0, $8bTPG.computed)(()=>{
        return error.value !== null && error.value !== undefined;
    });
    /**
   * Whether the field has been filled in successfully.
   *
   * @type {boolean}
   */ var isSuccess = (0, $8bTPG.computed)(()=>{
        return validationRules.value[language.value] && validationRules.value[language.value].length > 0 && state.value.validated[language.value] && !some_1(Validators.value[language.value], {
            invalid: true
        }) || (!validationRules.value[language.value] || !validationRules.value[language.value].length) && state.value.dirty[language.value];
    });
    var isRequired = (0, $8bTPG.computed)(()=>{
        var _Validators$value;
        return (_Validators$value = Validators.value) === null || _Validators$value === void 0 || (_Validators$value = _Validators$value[language.value]) === null || _Validators$value === void 0 ? void 0 : _Validators$value.some((Validator)=>{
            var _Validator$conditions2;
            if (Validator.name !== 'required') return;
            if (!((_Validator$conditions2 = Validator.conditions) !== null && _Validator$conditions2 !== void 0 && _Validator$conditions2.length)) return true;
            return Validator.conditions(form$.value, Validator, el$.value);
        });
    });
    // =============== METHODS ===============
    /**
   * Checks each validation rule for the element in every language (async).
   *
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref8 = _asyncToGenerator(function*() {
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            yield asyncForEach(languages.value, /*#__PURE__*/ function() {
                var _ref9 = _asyncToGenerator(function*(lang) {
                    yield validateLanguage(lang);
                });
                return function(_x4) {
                    return _ref9.apply(this, arguments);
                };
            }());
        });
        return function validate() {
            return _ref8.apply(this, arguments);
        };
    }();
    /**
   * Checks each validation rule for the element in a specific language (async).
   *
   * @param {string} lang the language to check (defaults to currently selected language)
   * @returns {Promise}
   */ var validateLanguage = /*#__PURE__*/ function() {
        var _ref10 = _asyncToGenerator(function*() {
            var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : language.value;
            if (form$.value.validation === false) return;
            if (!Validators.value[lang]) return;
            yield asyncForEach(Validators.value[lang], /*#__PURE__*/ function() {
                var _ref11 = _asyncToGenerator(function*(Validator) {
                    yield Validator.validate(value.value[lang]);
                });
                return function(_x5) {
                    return _ref11.apply(this, arguments);
                };
            }());
            state.value.validated[lang] = true;
        });
        return function validateLanguage() {
            return _ref10.apply(this, arguments);
        };
    }();
    var resetValidators = ()=>{
        each(languages.value, (lang)=>{
            each(Validators.value[lang], (Validator)=>{
                Validator.reset();
            });
            each(validationRules.value, (r, lang)=>{
                state.value.validated[lang] = r.length > 0 ? false : true; // @todo:adam missing null check
            });
        });
    };
    var dirt = ()=>{
        state.value.dirty[language.value] = true;
    };
    var clean = ()=>{
        state.value.dirty[language.value] = false;
    };
    /**
   * Inits the default `state` object.
   *
   * @returns {void}
   * @private
   */ var initState = ()=>{
        var dirty = {};
        var validated = {};
        each(languages.value, (lang)=>{
            dirty[lang] = false;
        });
        each(languages.value, (lang)=>{
            validated[lang] = true;
        });
        state.value = {
            dirty: dirty,
            validated: validated
        };
    };
    var initMessageBag = ()=>{
        messageBag.value = new form$.value.$vueform.services.messageBag(validatorErrors);
    };
    var initValidation = ()=>{
        /* istanbul ignore next: can not be null or false */ if (!validationRules.value) return;
        // If the element has rules it does not
        // qualify as validated by default
        each(validationRules.value, (r, lang)=>{
            state.value.validated[lang] = r !== null && r.length > 0 ? false : true;
        });
        var factory = new form$.value.$vueform.services.validation.factory(path.value, form$.value);
        Validators.value = {};
        each(validationRules.value, (languageRules, lang)=>{
            if (languageRules === null) return;
            /* istanbul ignore else */ if (!Validators.value[lang]) Validators.value = Object.assign({}, Validators.value, {
                [lang]: []
            });
            each(factory.makeAll(languageRules), (Validator)=>{
                Validators.value[lang].push(Validator);
            });
        });
    };
    var reinitValidation = ()=>{
        initValidation();
    };
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        errors: errors,
        error: error,
        validationRules: validationRules,
        isDanger: isDanger,
        isSuccess: isSuccess,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validate: validate,
        validateLanguage: validateLanguage,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initState: initState,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var slider$1 = function slider(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, busy, isRequired, useCustomFilled, isFilled, errors, error, validationRules, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = base$H(props, context, dependencies);
    // =============== METHODS ==============
    var validate = /*#__PURE__*/ function() {
        var _ref12 = _asyncToGenerator(function*() {
            if (!validationRules.value) return;
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            if (isArray_1(value.value)) // going through each value of the slider
            // and validate them all for the same field
            yield asyncForEach(value.value, /*#__PURE__*/ function() {
                var _ref13 = _asyncToGenerator(function*(val) {
                    yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                        var _ref14 = _asyncToGenerator(function*(Validator) {
                            yield Validator.validate(val);
                        });
                        return function(_x7) {
                            return _ref14.apply(this, arguments);
                        };
                    }());
                    if (invalid.value) return false;
                });
                return function(_x6) {
                    return _ref13.apply(this, arguments);
                };
            }());
            else yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                var _ref15 = _asyncToGenerator(function*(Validator) {
                    yield Validator.validate(value.value);
                });
                return function(_x8) {
                    return _ref15.apply(this, arguments);
                };
            }());
            state.value.validated = true;
        });
        return function validate() {
            return _ref12.apply(this, arguments);
        };
    }();
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        errors: errors,
        error: error,
        validationRules: validationRules,
        validate: validate,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var file$1 = function file(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var uploading = dependencies.uploading;
    var removing = dependencies.removing;
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, isRequired, useCustomFilled, isFilled, errors, error, validationRules, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = base$H(props, context, dependencies);
    // ============== COMPUTED ==============
    /**
   * Whether the element is `pending`, `debouncing`, `uploading` or `removing`.
   *
   * @type {boolean}
   */ var busy = (0, $8bTPG.computed)(()=>{
        return pending.value || uploading.value || removing.value;
    });
    // =============== METHODS ==============
    /**
   * Checks each validation rule for the element (async). File element will only validate for `min`, `max`, `between`, `size`, `mimetypes`, `mimes`, `dimensions`, `file`, `image`, `gt`, `gte`, `lt` and `lte` rules and only before the temporary files are uploaded.
   *
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref16 = _asyncToGenerator(function*() {
            if (!validationRules.value) return;
            if (form$.value.validation === false) return;
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            var restricted = [
                'min',
                'max',
                'between',
                'size',
                'mimetypes',
                'mimes',
                'dimensions',
                'file',
                'image',
                'gt',
                'gte',
                'lt',
                'lte'
            ];
            yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                var _ref17 = _asyncToGenerator(function*(Validator) {
                    if (!(value.value instanceof File) && !!value.value && restricted.indexOf(Validator.name) !== -1) return;
                    yield Validator.validate();
                });
                return function(_x9) {
                    return _ref17.apply(this, arguments);
                };
            }());
            state.value.validated = true;
        });
        return function validate() {
            return _ref16.apply(this, arguments);
        };
    }();
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        errors: errors,
        error: error,
        validationRules: validationRules,
        validate: validate,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var location = function location(props, context, dependencies) {
    var { displayKey } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, debouncing, busy, isRequired, useCustomFilled, isFilled, errors, error, validationRules, isSuccess, isDanger, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = text$2(props, context, dependencies);
    // =============== METHODS ==============
    /**
   * Checks each validation rule for the element on [`displayKey`](#option-display-key) property of the location object (async).
   *
   * @returns {Promise}
   */ var validate = /*#__PURE__*/ function() {
        var _ref18 = _asyncToGenerator(function*() {
            if (!validationRules.value) return;
            if (form$.value.validation === false) return;
            if (resetting.value) {
                resetting.value = false;
                return;
            }
            yield asyncForEach(Validators.value, /*#__PURE__*/ function() {
                var _ref19 = _asyncToGenerator(function*(Validator) {
                    yield Validator.validate(value.value[displayKey.value]);
                });
                return function(_x10) {
                    return _ref19.apply(this, arguments);
                };
            }());
            state.value.validated = true;
        });
        return function validate() {
            return _ref18.apply(this, arguments);
        };
    }();
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        errors: errors,
        error: error,
        validationRules: validationRules,
        isSuccess: isSuccess,
        isDanger: isDanger,
        validate: validate,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var matrix$3 = function matrix(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { value, dataType } = dependencies;
    var { state, Validators, messageBag, resetting, dirty, validated, invalid, pending, debouncing, busy, isRequired, validatorErrors, childrenErrors, errors, validationRules, validate, validateValidators, validateChildren, dirt, clean, clearMessages, resetValidators, initMessageBag, initValidation, reinitValidation } = object$3(props, context, dependencies);
    // ============== COMPUTED ==============
    var error = (0, $8bTPG.computed)(()=>{
        var _errors$value;
        return (_errors$value = errors.value) === null || _errors$value === void 0 ? void 0 : _errors$value[0];
    });
    var useCustomFilled = (0, $8bTPG.computed)(()=>{
        return true;
    });
    var isFilled = (0, $8bTPG.computed)(()=>{
        switch(dataType.value){
            case 'assoc':
                return Object.values(value.value).every((v)=>v !== null);
            case 'array':
                return Object.values(value.value).every((v)=>v.length);
            case 'object':
                return Object.values(value.value).every((v)=>Object.values(v).every((sv)=>{
                        if (Array.isArray(sv)) return sv.length;
                        else if (sv instanceof File) return sv.name !== '';
                        else if (typeof sv === 'string') return sv.trim() !== '';
                        else return sv !== undefined && sv !== null;
                    }));
        }
    });
    return {
        state: state,
        Validators: Validators,
        messageBag: messageBag,
        resetting: resetting,
        dirty: dirty,
        validated: validated,
        invalid: invalid,
        pending: pending,
        debouncing: debouncing,
        busy: busy,
        isRequired: isRequired,
        useCustomFilled: useCustomFilled,
        isFilled: isFilled,
        validatorErrors: validatorErrors,
        childrenErrors: childrenErrors,
        errors: errors,
        error: error,
        validationRules: validationRules,
        validate: validate,
        validateValidators: validateValidators,
        validateChildren: validateChildren,
        dirt: dirt,
        clean: clean,
        clearMessages: clearMessages,
        resetValidators: resetValidators,
        initMessageBag: initMessageBag,
        initValidation: initValidation,
        reinitValidation: reinitValidation
    };
};
var group$3 = list$1;
var object$3 = list$1;
var base$G = function base(props, context, dependencies) {
    var { default: default_, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var { nullValue, form$, parent } = dependencies;
    // ============== COMPUTED ===============
    /**
   * The default value of the element.
   *
   * @type {any}
   * @private
   */ var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue;
        if (parent && parent.value && parent.value.isMatrixType) {
            var row = parent.value.resolvedRows[getRowKey(name.value)];
            var col = parent.value.resolvedColumns[getColKey(name.value)];
            var rowModel = parent.value.defaultValue[row.value];
            switch(parent.value.dataType){
                case 'assoc':
                    parentDefaultValue = rowModel === col.value ? true : null;
                    break;
                case 'array':
                    parentDefaultValue = Array.isArray(rowModel) && rowModel.includes(col.value);
                    break;
                default:
                    parentDefaultValue = rowModel === null || rowModel === void 0 ? void 0 : rowModel[col.value];
                    break;
            }
        } else if (parent && parent.value) {
            var _parent$value$default;
            parentDefaultValue = (_parent$value$default = parent.value.defaultValue) === null || _parent$value$default === void 0 ? void 0 : _parent$value$default[name.value];
        } else if (form$.value.options.default[name.value] !== undefined) parentDefaultValue = form$.value.options.default[name.value];
        if (parentDefaultValue !== undefined) return parentDefaultValue instanceof File ? new File([
            parentDefaultValue
        ], parentDefaultValue.name, parentDefaultValue) : cloneDeep_1(parentDefaultValue);
        if (default_.value !== undefined) return default_.value instanceof File ? new File([
            default_.value
        ], default_.value.name, default_.value) : cloneDeep_1(default_.value);
        return cloneDeep_1(nullValue.value);
    });
    return {
        defaultValue: defaultValue
    };
};
var text$1 = function text(props, context, dependencies) {
    var { default: default_, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var nullValue = dependencies.nullValue;
    var form$ = dependencies.form$;
    var parent = dependencies.parent;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ===============
    /**
   * The default value of the element.
   *
   * @type {any}
   * @private
   */ var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue;
        if (parent && parent.value && parent.value.isMatrixType) {
            var row = parent.value.resolvedRows[getRowKey(name.value)];
            var col = parent.value.resolvedColumns[getColKey(name.value)];
            var rowModel = parent.value.defaultValue[row.value];
            switch(parent.value.dataType){
                case 'assoc':
                    parentDefaultValue = rowModel === col.value ? true : null;
                    break;
                case 'array':
                    parentDefaultValue = Array.isArray(rowModel) && rowModel.includes(col.value);
                    break;
                default:
                    parentDefaultValue = rowModel === null || rowModel === void 0 ? void 0 : rowModel[col.value];
                    break;
            }
        } else if (parent && parent.value) parentDefaultValue = parent.value.defaultValue[name.value];
        else if (form$.value.options.default[name.value] !== undefined) parentDefaultValue = form$.value.options.default[name.value];
        if (parentDefaultValue !== undefined) return parentDefaultValue instanceof File ? new File([
            parentDefaultValue
        ], parentDefaultValue.name, parentDefaultValue) : isPlainObject_1(parentDefaultValue) ? localize(cloneDeep_1(parentDefaultValue), config$.value, form$.value) : cloneDeep_1(parentDefaultValue);
        /* istanbul ignore else */ if (default_.value !== undefined) /* istanbul ignore next: text can not have File as default */ return default_.value instanceof File ? new File([
            default_.value
        ], default_.value.name, default_.value) : isPlainObject_1(default_.value) ? localize(cloneDeep_1(default_.value), config$.value, form$.value) : cloneDeep_1(default_.value);
        /* istanbul ignore next: text will never fall into this case, because `default_.value` is never undefined but null */ return cloneDeep_1(nullValue.value);
    });
    return {
        defaultValue: defaultValue
    };
};
var object$2 = function object(props, context, dependencies) {
    var { default: default_, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var nullValue = dependencies.nullValue;
    var form$ = dependencies.form$;
    var parent = dependencies.parent;
    // ============== COMPUTED ===============
    var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue;
        if (parent && parent.value) parentDefaultValue = parent.value.defaultValue[name.value];
        else if (form$.value.options.default[name.value]) parentDefaultValue = form$.value.options.default[name.value];
        if (parentDefaultValue !== undefined) return cloneDeep_1(merge_1({}, default_.value || /* istanbul ignore next: `default_.value` will never be undefined, because it is a hardwired `{}` */ nullValue.value, parentDefaultValue));
        if (Object.keys(default_.value).length > 0) return cloneDeep_1(default_.value);
        return cloneDeep_1(nullValue.value);
    });
    return {
        defaultValue: defaultValue
    };
};
var matrix$2 = function matrix(props, context, dependencies) {
    var { name, default: default_ } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var { nullValue, form$, parent, hasDynamicRows, computedRows, resolvedRows, resolvedColumns, rowsCount, dataType, el$: el$1 } = dependencies;
    // ============== COMPUTED ===============
    var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue;
        if (parent && parent.value) parentDefaultValue = parent.value.defaultValue[name.value];
        else if (form$.value.options.default[name.value]) parentDefaultValue = form$.value.options.default[name.value];
        var defaultValue = parentDefaultValue || cloneDeep_1(default_.value);
        if (Object.keys(defaultValue).length) return defaultValue;
        resolvedRows.value.forEach((row, r)=>{
            resolvedColumns.value.forEach((col, c)=>{
                var _defaultValue$row$val;
                switch(dataType.value){
                    case 'assoc':
                        defaultValue[row.value] = defaultValue[row.value] === col.value ? col.value : null;
                        break;
                    case 'array':
                        defaultValue[row.value] = [
                            ...defaultValue[row.value] || [],
                            ...defaultValue[row.value] && defaultValue[row.value].indexOf(col.value) !== -1 ? [
                                col.value
                            ] : []
                        ];
                        break;
                    default:
                        defaultValue[row.value] = _objectSpread2$1(_objectSpread2$1({}, defaultValue[row.value] || {}), {}, {
                            [col.value]: ((_defaultValue$row$val = defaultValue[row.value]) === null || _defaultValue$row$val === void 0 ? void 0 : _defaultValue$row$val[col.value]) || undefined
                        });
                }
            });
        });
        return defaultValue;
    });
    return {
        defaultValue: defaultValue
    };
};
var group$2 = function group(props, context, dependencies) {
    var { default: default_ } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var parent = dependencies.parent;
    // ============== COMPUTED ===============
    var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue = {};
        if (parent && parent.value) parentDefaultValue = parent.value.defaultValue;
        else if (form$.value.options.default) //@todo:adam
        parentDefaultValue = form$.value.options.default;
        return cloneDeep_1(merge_1({}, default_.value, parentDefaultValue));
    });
    return {
        defaultValue: defaultValue
    };
};
var multilingual$2 = function multilingual(props, context, dependencies) {
    var { default: default_, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var nullValue = dependencies.nullValue;
    var form$ = dependencies.form$;
    var parent = dependencies.parent;
    // ============== COMPUTED ===============
    var defaultValue = (0, $8bTPG.computed)(()=>{
        var parentDefaultValue;
        if (parent && parent.value) parentDefaultValue = parent.value.defaultValue[name.value];
        else if (form$.value.options.default[name.value]) parentDefaultValue = form$.value.options.default[name.value];
        if (parentDefaultValue !== undefined) return cloneDeep_1(Object.assign({}, clone_1(nullValue.value), parentDefaultValue));
        if (default_.value === undefined) return clone_1(nullValue.value);
        var def = clone_1(default_.value);
        if (!isPlainObject_1(def)) {
            var tempDefault = {};
            each(nullValue.value, (v, language)=>{
                tempDefault[language] = def;
            });
            def = tempDefault;
        }
        return Object.assign({}, clone_1(nullValue.value), def);
    });
    return {
        defaultValue: defaultValue
    };
};
var base$F = function base(props, context, dependencies) {
    var { readonly } = (0, $8bTPG.toRefs)(props);
    var { el$: el$1, form$, path } = dependencies;
    // ============== COMPUTED ==============
    /**
   * Whether the element is readonly.
   *
   * @type {boolean}
   */ var isReadonly = (0, $8bTPG.computed)(()=>{
        if (typeof readonly.value === 'function') return readonly.value(el$1.value, form$.value);
        if (Array.isArray(readonly.value)) return readonly.value.every((condition)=>{
            return form$.value.$vueform.services.condition.check(condition, path.value, form$.value, el$1.value);
        });
        if (typeof readonly.value === 'object' && readonly.value && readonly.value.value !== undefined) return readonly.value.value;
        return readonly.value;
    });
    return {
        isReadonly: isReadonly
    };
};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy$1(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var _baseSortBy = baseSortBy$1;
var isSymbol = isSymbol_1;
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending$1(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple$1(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity = identity_1, isArray = isArray_1;
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy$1(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
var _baseOrderBy = baseOrderBy$1;
var baseFlatten = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall = _isIterateeCall;
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var sortBy_1 = sortBy;
var base$E = function base(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { submit, formatData, formatLoad: formatLoad1, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var available = dependencies.available;
    var value = dependencies.value;
    var resetValidators = dependencies.resetValidators;
    var defaultValue = dependencies.defaultValue;
    var nullValue = dependencies.nullValue;
    var resetting = dependencies.resetting;
    var isDefault = dependencies.isDefault;
    // =============== PRIVATE ===============
    /**
   * Sets the value of the element.
   *
   *
   * @param {any} val the value to be set
   * @returns {void}
   * @private
   */ var setValue = (val)=>{
        if (options.setValue) return options.setValue(val);
        value.value = val;
    };
    // ============== COMPUTED ===============
    /**
   * The value of the element in `{[name]: value}` value format. This gets merged with the parent component's data.
   *
   * @type {object}
   */ var data = (0, $8bTPG.computed)(()=>{
        return {
            [name.value]: value.value
        };
    });
    /**
   * Same as `data` property except that it only includes the element's value if [`submit`](#option-submit) is not disabled and [`available`](#property-available) is `true` (has no [`conditions`](#option-conditions) or they are fulfilled).
   *
   * @type {object}
   */ var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        return formatData.value ? formatData.value(name.value, value.value, form$.value) : {
            [name.value]: value.value
        };
    });
    // =============== METHODS ===============
    /**
   * Loads value to the element using optional [`formatLoad`](#option-format-load) formatter. This is the method that gets called for each element when loading data to the form with `format: true`.
   *
   * @param {any} value* the value to be loaded
   * @param {boolean} format whether the loaded value should be formatted with [`formatLoad`](#option-format-load) before setting the value of the element (default: `false`)
   * @returns {void}
   */ var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setValue(format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val);
    };
    /**
   * Updates the value of the element similarly to [`load`](#method-load), only that it can\'t format data.
   *
   * @param {any} value* the value to be set
   * @returns {void}
   */ var update = (val)=>{
        setValue(val);
    };
    /**
   * Clears the element's value.
   *
   * @returns {void}
   */ var clear = ()=>{
        setValue(cloneDeep_1(nullValue.value));
    };
    /**
   * Resets the element's value to [`default`](#option-default) (or empty if `default` is not provided). Also resets all the validation state for the element.
   *
   * @returns {void}
   */ var reset = ()=>{
        if (!isDefault.value) resetting.value = true;
        setValue(cloneDeep_1(defaultValue.value));
        resetValidators();
    };
    /**
   * Prepares the element.
   *
   * @returns {Promise}
   * @private
   */ /* istanbul ignore next:@todo:adam missing implementation, but used in code */ var prepare = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*() {});
        return function prepare() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var text = function text(props, context, dependencies) {
    var { submit, formatData, name, forceNumbers } = (0, $8bTPG.toRefs)(props);
    var { load, update, clear, reset, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var available = dependencies.available;
    var value = dependencies.value;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // =============== COMPUTED ==============
    var data = (0, $8bTPG.computed)(()=>{
        var v = value.value;
        if (shouldForceNumbers()) v = stringToNumber(value.value);
        return {
            [name.value]: v
        };
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        var v = value.value;
        if (shouldForceNumbers()) v = stringToNumber(value.value);
        return formatData.value ? formatData.value(name.value, v, form$.value) : {
            [name.value]: v
        };
    });
    // =============== METHODS ===============
    /**
   * Whether the value should be converted to number/float.
   *
   * @returns {boolean}
   * @private
   */ var shouldForceNumbers = ()=>{
        return forceNumbers.value || config$.value.config.forceNumbers && form$.value.options.forceNumbers !== false && forceNumbers.value !== false || form$.value.options.forceNumbers && forceNumbers.value !== false;
    };
    /**
   * Converts string value to number or float.
   *
   * @param {any} str* the string to be converted
   * @returns {number|float|string}
   * @private
   */ var stringToNumber = (str)=>{
        var v = str;
        if (typeof str === 'string') {
            if (/^[-]?\d+([\.,]\d+)?$/.test(str)) v = parseFloat(str.replace(',', '.'));
            else if (/^[-]?\d+$/.test(str)) v = parseInt(str, 10);
        }
        return v;
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var textarea = function textarea(props, context, dependencies) {
    var { data, requestData, load: baseLoad, update: baseUpdate, clear: baseClear, reset: baseReset, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var { autosize } = dependencies;
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        baseLoad(val, format);
        (0, $ani5R.nextTick)(()=>{
            autosize();
        });
    };
    var update = (val)=>{
        baseUpdate(val);
        (0, $ani5R.nextTick)(()=>{
            autosize();
        });
    };
    var clear = ()=>{
        baseClear();
        (0, $ani5R.nextTick)(()=>{
            autosize();
        });
    };
    var reset = ()=>{
        baseReset();
        (0, $ani5R.nextTick)(()=>{
            autosize();
        });
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var select$3 = function select(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { resolveOnLoad, items } = (0, $8bTPG.toRefs)(props);
    var { data, requestData, load, update, clear, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var value = dependencies.value;
    var resetValidators = dependencies.resetValidators;
    var defaultValue = dependencies.defaultValue;
    var updateItems = dependencies.updateItems;
    var resetting = dependencies.resetting;
    var isDefault = dependencies.isDefault;
    // =============== PRIVATE ===============
    var setValue = (val)=>{
        if (options.setValue) return options.setValue(val);
        value.value = val;
    };
    // =============== METHODS ===============
    var reset = ()=>{
        if (!isDefault.value) resetting.value = true;
        setValue(cloneDeep_1(defaultValue.value));
        resetValidators();
        if (typeof items.value === 'string' && resolveOnLoad.value !== false) updateItems();
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var captcha = function captcha(props, context, dependencies) {
    var { data, requestData, load, update, clear: clearBase, reset: resetBase, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var { Provider } = dependencies;
    // =============== METHODS ===============
    var clear = ()=>{
        clearBase();
        if (!Provider.value) return;
        Provider.value.reset();
    };
    var reset = ()=>{
        resetBase();
        if (!Provider.value) return;
        Provider.value.reset();
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var object$1 = function object(props, context, dependencies) {
    var { name, formatLoad: formatLoad1, formatData, submit } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var available = dependencies.available;
    var children$ = dependencies.children$;
    var children$Array = dependencies.children$Array;
    var resetting = dependencies.resetting;
    var isDefault = dependencies.isDefault;
    // ============== COMPUTED ===============
    var data = (0, $8bTPG.computed)(()=>{
        var data = {};
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            data = Object.assign({}, data, element$.data);
        });
        return {
            [name.value]: data
        };
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        var requestData = {};
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            requestData = Object.assign({}, requestData, element$.requestData);
        });
        return formatData.value ? formatData.value(name.value, requestData, form$.value) : {
            [name.value]: requestData
        };
    });
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formatted = format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val;
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            if (!element$.flat && formatted[element$.name] === undefined) {
                element$.clear();
                return;
            }
            element$.load(element$.flat ? formatted : formatted[element$.name], format);
        });
    };
    var update = (val)=>{
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            if (val[element$.name] === undefined && !element$.flat) return;
            element$.update(element$.flat ? val : val[element$.name]);
        });
    };
    var clear = ()=>{
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            element$.clear();
        });
    };
    var reset = ()=>{
        if (!isDefault.value) resetting.value = true;
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            element$.reset();
        });
    };
    var prepare = /*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(function*() {
            yield asyncForEach(children$Array.value, /*#__PURE__*/ function() {
                var _ref3 = _asyncToGenerator(function*(e$) {
                    if (e$.prepare) yield e$.prepare();
                });
                return function(_x) {
                    return _ref3.apply(this, arguments);
                };
            }());
        });
        return function prepare() {
            return _ref2.apply(this, arguments);
        };
    }();
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var group$1 = function group(props, context, dependencies) {
    var { name, formatData, submit } = (0, $8bTPG.toRefs)(props);
    var { load, update, clear, reset, prepare } = object$1(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var children$ = dependencies.children$;
    var available = dependencies.available;
    dependencies.value;
    // ============== COMPUTED ===============
    /**
   * The value of child elements in object. This gets merged with the parent component's data.
   *
   * @type {object}
   */ var data = (0, $8bTPG.computed)(()=>{
        var data = {};
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            data = Object.assign({}, data, element$.data);
        });
        return data;
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        var requestData = {};
        each(children$.value, (element$)=>{
            if (element$.isStatic) return;
            requestData = Object.assign({}, requestData, element$.requestData);
        });
        return formatData.value ? formatData.value(name.value, requestData, form$.value) : requestData;
    });
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var list = function list(props, context, dependencies, options) {
    var { name, storeOrder, formatLoad: formatLoad1, formatData, order, submit, initial, default: default_ } = (0, $8bTPG.toRefs)(props);
    var { update, clear, data } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var el$1 = dependencies.el$;
    var form$ = dependencies.form$;
    var children$ = dependencies.children$;
    var children$Array = dependencies.children$Array;
    var available = dependencies.available;
    var isDisabled = dependencies.isDisabled;
    var value = dependencies.value;
    var orderByName = dependencies.orderByName;
    var refreshOrderStore = dependencies.refreshOrderStore;
    var dataPath = dependencies.dataPath;
    var parent = dependencies.parent;
    var nullValue = dependencies.nullValue;
    var defaultValue = dependencies.defaultValue;
    var fire = dependencies.fire;
    var resetValidators = dependencies.resetValidators;
    var resetting = dependencies.resetting;
    var isDefault = dependencies.isDefault;
    // ================ DATA =================
    var initialValue = (0, $8bTPG.ref)(get_1(form$.value.model, dataPath.value));
    // ============== COMPUTED ===============
    /**
   * Default value of the parent
   *
   * @type {any}
   * @private
   */ var parentDefaultValue = (0, $8bTPG.computed)(()=>{
        return parent && parent.value ? parent.value.defaultValue[name.value] : form$.value.options.default[name.value];
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        var requestData = [];
        each(children$.value, (element$)=>{
            var val = element$.requestData[element$.name];
            if (val !== undefined) requestData.push(val);
        });
        return formatData.value ? formatData.value(name.value, requestData, form$.value) : {
            [name.value]: requestData
        };
    });
    /**
   * Number of children.
   *
   * @type {number}
   * @private
   */ var length = (0, $8bTPG.computed)(()=>{
        return Object.keys(value.value || /* istanbul ignore next: failsafe only */ {}).length;
    });
    // =============== METHODS ===============
    /**
   * Appends a new item.
   *
   * @param {any} value value of the appended element (optional)
   * @returns {number} the index of the appended item
   */ var add = function add() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        var focus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var newValue = storeOrder.value ? Object.assign({}, val || {}, {
            [storeOrder.value]: val ? val[storeOrder.value] : undefined
        }) : val;
        value.value = refreshOrderStore(value.value.concat([
            newValue
        ]));
        // value.value = refreshOrderStore(value.value)
        var index = value.value.length - 1;
        fire('add', index, newValue, value.value, el$1.value);
        if (focus) (0, $ani5R.nextTick)(()=>{
            children$Array.value[children$Array.value.length - 1].focus();
        });
        return index;
    };
    /**
   * Removes an items by its index.
   *
   *
   * @param {number} index* index of items to be removed
   * @returns {void}
   */ var remove = (index)=>{
        value.value = value.value.filter((v, i)=>i !== index);
        refreshOrderStore(value.value);
        fire('remove', index, value.value, el$1.value);
    };
    var load = /*#__PURE__*/ function() {
        var _ref4 = _asyncToGenerator(function*(val) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var values = sortValue(format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val);
            clear();
            yield (0, $ani5R.nextTick)();
            for(var i = 0; i < values.length; i++)add();
            yield (0, $ani5R.nextTick)();
            each(children$.value, (child$, i)=>{
                child$.load(values[i], format);
            });
        });
        return function load(_x2) {
            return _ref4.apply(this, arguments);
        };
    }();
    var reset = ()=>{
        if (!isDefault.value) resetting.value = true;
        value.value = cloneDeep_1(defaultValue.value);
        resetValidators();
        if (!value.value.length && initial.value > 0) {
            for(var i = 0; i < initial.value; i++)add();
            // NextTick is no longer required as validation
            // happens with async/await anyway in children
            // nextTick(() => {
            children$Array.value.forEach((child$)=>{
                child$.reset();
            });
        // })
        }
        (0, $ani5R.nextTick)(()=>{
            refreshOrderStore(value.value);
        });
    };
    var prepare = /*#__PURE__*/ function() {
        var _ref5 = _asyncToGenerator(function*() {
            yield asyncForEach(children$Array.value, /*#__PURE__*/ function() {
                var _ref6 = _asyncToGenerator(function*(e$) {
                    if (e$.prepare) yield e$.prepare();
                });
                return function(_x3) {
                    return _ref6.apply(this, arguments);
                };
            }());
        });
        return function prepare() {
            return _ref5.apply(this, arguments);
        };
    }();
    /**
   * Sorts value when `order` and `orderByName` is defined.
   *
   * @param {array} value value to be sorted
   * @returns {array}
   * @private
   */ var sortValue = (val)=>{
        if (!order.value && !orderByName.value || !val) return val;
        var desc = order.value && typeof order.value === 'string' && order.value.toUpperCase() == 'DESC';
        /* istanbul ignore else */ if (orderByName.value) val = desc ? sortBy_1(val, orderByName.value).reverse() : sortBy_1(val, orderByName.value);
        else if (order.value) val = desc ? val.sort().reverse() : val.sort();
        return val;
    };
    /**
   * Handles the `add` event.
   *
   * @returns {void}
   * @private
   */ var handleAdd = ()=>{
        if (isDisabled.value) return;
        add(undefined, true);
    };
    /**
   * Handles the `remove` event.
   *
   * @param {number} index* index of child to be removed
   * @returns {void}
   * @private
   */ var handleRemove = (index)=>{
        if (isDisabled.value) return;
        remove(index);
    };
    // ================ HOOKS ===============
    if (initialValue.value === undefined && parentDefaultValue.value === undefined && default_.value === undefined) {
        if (initial.value > 0) for(var i = 0; i < initial.value; i++)add();
        else value.value = nullValue.value;
    } else if (initialValue.value === undefined) value.value = defaultValue.value;
    return {
        requestData: requestData,
        data: data,
        length: length,
        add: add,
        remove: remove,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        handleAdd: handleAdd,
        handleRemove: handleRemove,
        prepare: prepare
    };
};
var date$2 = function date(props, context, dependencies) {
    var { formatLoad: formatLoad1 } = (0, $8bTPG.toRefs)(props);
    var { data, requestData, update, clear, reset, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var loadDateFormat = dependencies.loadDateFormat;
    var moment = form$.value.$vueform.services.moment;
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formatted = format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val;
        checkDateFormat(loadDateFormat.value, formatted, moment);
        value.value = formatted instanceof Date || !formatted ? formatted : moment(formatted, loadDateFormat.value).toDate();
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var dates$3 = function dates(props, context, dependencies) {
    var { formatLoad: formatLoad1 } = (0, $8bTPG.toRefs)(props);
    var { data, requestData, update, clear, reset, prepare } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var loadDateFormat = dependencies.loadDateFormat;
    var moment = form$.value.$vueform.services.moment;
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formatted = format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val;
        value.value = map_1(formatted, (v)=>{
            checkDateFormat(loadDateFormat.value, v, moment);
            return v instanceof Date ? v : moment(v, loadDateFormat.value).toDate();
        });
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var multilingual$1 = function multilingual(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { formatLoad: formatLoad1 } = (0, $8bTPG.toRefs)(props);
    var { data, requestData, clear, reset, prepare } = base$E(props, context, dependencies, options);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var language = dependencies.language;
    var nullValue = dependencies.nullValue;
    // =============== PRIVATE ===============
    var setValue = (val)=>{
        if (options.setValue) return options.setValue(val);
        value.value = val;
    };
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formatted = format && formatLoad1.value ? formatLoad1.value(val, form$.value) : val;
        if (!isPlainObject_1(formatted)) throw new Error('Multilingual element requires an object to load');
        setValue(Object.assign({}, clone_1(nullValue.value), formatted));
    };
    var update = (val)=>{
        var updateValue = val;
        if (!isPlainObject_1(updateValue)) updateValue = {
            [language.value]: val
        };
        setValue(Object.assign({}, value.value, updateValue));
    };
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var editor = function editor(props, context, dependencies) {
    var { data, requestData, load, update, clear, reset, prepare } = base$E(props, context, dependencies, {
        setValue: (val)=>{
            value.value = val;
            (0, $ani5R.nextTick)(()=>{
                var _input$value;
                (_input$value = input.value) === null || _input$value === void 0 || _input$value.update(val);
            });
        }
    });
    // ============ DEPENDENCIES =============
    var input = dependencies.input;
    var value = dependencies.value;
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var teditor = function teditor(props, context, dependencies) {
    var { data, requestData, load, update, clear, reset, prepare } = multilingual$1(props, context, dependencies, {
        setValue: (val)=>{
            value.value = val;
            (0, $ani5R.nextTick)(()=>{
                input.value.update(val[language.value]);
            });
        }
    });
    // ============ DEPENDENCIES =============
    var input = dependencies.input;
    var model = dependencies.model;
    var value = dependencies.value;
    var language = dependencies.language;
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(language, ()=>{
        input.value.update(model.value);
    });
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var file = function file(props, context, dependencies) {
    var { load, update, clear, reset, prepare } = base$E(props, context, dependencies);
    var { submit, formatData, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var available = dependencies.available;
    var value = dependencies.value;
    // ============== COMPUTED ===============
    var data = (0, $8bTPG.computed)(()=>{
        var _v;
        var v = value.value;
        if (typeof v === 'object' && (_v = v) !== null && _v !== void 0 && _v.__file__) {
            v = v instanceof File ? v : _objectSpread2$1({}, v);
            delete v.__file__;
        }
        return {
            [name.value]: v
        };
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        var _v2;
        if (!available.value || !submit.value) return {};
        var v = value.value;
        if (typeof v === 'object' && (_v2 = v) !== null && _v2 !== void 0 && _v2.__file__) {
            v = v instanceof File ? v : _objectSpread2$1({}, v);
            delete v.__file__;
        }
        return formatData.value ? formatData.value(name.value, v, form$.value) : {
            [name.value]: v
        };
    });
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var multifile$4 = function multifile(props, context, dependencies) {
    var { length, add, remove, load, update, clear, reset, handleAdd, handleRemove, prepare } = list(props, context, dependencies);
    var { submit, formatData, name } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    var available = dependencies.available;
    var value = dependencies.value;
    var children$ = dependencies.children$;
    // ============== COMPUTED ===============
    var data = (0, $8bTPG.computed)(()=>{
        var val = value.value;
        val = val.map((file)=>{
            if (typeof file === 'object' && file !== null && file !== void 0 && file.__file__) {
                var v = file instanceof File ? file : _objectSpread2$1({}, file);
                delete v.__file__;
                return v;
            }
            return file;
        });
        return {
            [name.value]: val
        };
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        if (!available.value || !submit.value) return {};
        var requestData = [];
        each(children$.value, (element$)=>{
            var val = element$.requestData[element$.name];
            /* istanbul ignore next: failsafe only */ if (val !== undefined) {
                var _val;
                if (typeof val === 'object' && (_val = val) !== null && _val !== void 0 && _val.__file__) {
                    var v = file instanceof File ? file : _objectSpread2$1({}, file);
                    delete v.__file__;
                    val = v;
                }
                requestData.push(val);
            }
        });
        return formatData.value ? formatData.value(name.value, requestData, form$.value) : {
            [name.value]: requestData
        };
    });
    return {
        requestData: requestData,
        data: data,
        length: length,
        add: add,
        remove: remove,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        handleAdd: handleAdd,
        handleRemove: handleRemove,
        prepare: prepare
    };
};
var signature = function signature(props, context, dependencies) {
    var { data, requestData, load, update, clear: clearBase, reset: resetBase } = base$E(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var { mode, clearSignature, typingToImage, drawingToImage, uploaded, setDefaultMode, setDefaultFont, setDefaultColor } = dependencies;
    // ============== COMPUTED ===============
    var clear = ()=>{
        clearBase();
        clearSignature();
    };
    var reset = ()=>{
        clearSignature();
        setDefaultMode(true);
        setDefaultFont(true);
        setDefaultColor();
        resetBase();
    };
    var prepare = /*#__PURE__*/ function() {
        var _ref7 = _asyncToGenerator(function*() {
            if (uploaded.value) return;
            if (mode.value === 'type') yield typingToImage();
            if (mode.value === 'draw') yield drawingToImage();
        });
        return function prepare() {
            return _ref7.apply(this, arguments);
        };
    }();
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare
    };
};
var matrix$1 = function matrix(props, context, dependencies) {
    var { resolveOnLoad, items, name, inputType, rows, canAdd, canRemove, min, max } = (0, $8bTPG.toRefs)(props);
    var { clear: baseClear, reset: baseReset, prepare } = object$1(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var { el$: el$1, form$, available, children$, children$Array, resetting, isDefault, resolvedRows, resolvedColumns, dataType, defaultValue, value, computedRows, rowsCount, hasDynamicRows, fire, allowRemove, allowAdd, grid, resolveComponentName } = dependencies;
    // ============== COMPUTED ===============
    var data = (0, $8bTPG.computed)(()=>{
        return {
            [name.value]: transformData()
        };
    });
    var requestData = (0, $8bTPG.computed)(()=>{
        return {
            [name.value]: transformData(true)
        };
    });
    // =============== METHODS ===============
    var load = function load(val) {
        var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formatted = format && formatLoad.value ? formatLoad.value(val, form$.value) : val;
        setData(formatted, 'load');
    };
    var update = (val)=>{
        setData(val, 'update');
    };
    var clear = ()=>{
        baseClear();
        if (hasDynamicRows.value) rowsCount.value = rows.value;
    };
    var reset = ()=>{
        baseReset();
        if (hasDynamicRows.value) rowsCount.value = rows.value;
        if (grid.value) {
            grid.value.scrollTop = 0;
            grid.value.scrollLeft = 0;
        }
    };
    var add = ()=>{
        var oldValue = _objectSpread2$1({}, value.value);
        rowsCount.value++;
        (0, $ani5R.nextTick)(()=>{
            fire('add', rowsCount.value - 1, value.value, oldValue, el$1.value);
        });
    };
    var remove = (i)=>{
        var oldValue = _objectSpread2$1({}, value.value);
        var newValue = _objectSpread2$1({}, value.value);
        delete newValue[i];
        value.value = Object.values(newValue).reduce((prev, curr, i)=>_objectSpread2$1(_objectSpread2$1({}, prev), {}, {
                [i]: curr
            }), {});
        rowsCount.value--;
        fire('remove', i, value.value, oldValue, el$1.value);
    };
    var handleAdd = ()=>{
        add();
    };
    var handleRemove = (i)=>{
        remove(i);
    };
    var transformData = function transformData() {
        var skipUnavailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var data = {};
        resolvedRows.value.forEach((row, r)=>{
            if (!row.available && skipUnavailable) return;
            var rowValue = dataType.value === 'object' ? {} : dataType.value === 'array' ? [] : null;
            resolvedColumns.value.forEach((column, c)=>{
                var _children$$value$reso;
                if (!column.available && skipUnavailable) return;
                var cellValue = (_children$$value$reso = children$.value[resolveComponentName(r, c)]) === null || _children$$value$reso === void 0 ? void 0 : _children$$value$reso.value;
                switch(dataType.value){
                    case 'array':
                        if (cellValue) rowValue = [
                            ...rowValue || [],
                            column.value
                        ];
                        break;
                    case 'assoc':
                        if (cellValue) rowValue = column.value;
                        break;
                    default:
                        rowValue = _objectSpread2$1(_objectSpread2$1({}, rowValue || {}), {}, {
                            [column.value]: cellValue
                        });
                }
            });
            data[row.value] = rowValue;
        });
        if (hasDynamicRows.value) data = Object.values(data);
        return data;
    };
    var setData = /*#__PURE__*/ function() {
        var _ref8 = _asyncToGenerator(function*(val, action) {
            if (hasDynamicRows.value) {
                rowsCount.value = Object.keys(val).length;
                yield (0, $ani5R.nextTick)();
            }
            el$1.value.resolvedRows.forEach((row, r)=>{
                el$1.value.resolvedColumns.forEach((column, c)=>{
                    var rowValue = val[row.value] || {};
                    var cell$ = children$.value[resolveComponentName(r, c)];
                    switch(dataType.value){
                        case 'assoc':
                            cell$[action](column.value === rowValue);
                            break;
                        case 'array':
                            cell$[action](rowValue.indexOf(column.value) !== -1);
                            break;
                        default:
                            cell$[action](rowValue[column.value]);
                            break;
                    }
                });
            });
        });
        return function setData(_x4, _x5) {
            return _ref8.apply(this, arguments);
        };
    }();
    (0, $8bTPG.watch)(computedRows, (n, o)=>{
        var oldLength = typeof o === 'number' ? o : Object.keys(o).length;
        var newLength = typeof n === 'number' ? n : Object.keys(n).length;
        var dir = oldLength > newLength ? 'decrease' : 'increase';
        var diff = dir === 'increase' ? newLength - oldLength : oldLength - newLength;
        var nextIndex = newLength - 1;
        var lastIndex = oldLength - 1;
        var newValue = _objectSpread2$1({}, value.value);
        if (dir === 'increase') switch(dataType.value){
            case 'assoc':
            case 'array':
                for(var i = 0; i < diff; i++)newValue[nextIndex + i] = cloneDeep_1(defaultValue.value[nextIndex + i]);
                break;
        }
        else {
            for(var _i = 0; _i < diff; _i++)if (newValue[lastIndex - _i] !== undefined) delete newValue[lastIndex - _i];
        }
        value.value = newValue;
    }, {
        flush: 'post'
    });
    return {
        data: data,
        requestData: requestData,
        load: load,
        update: update,
        clear: clear,
        reset: reset,
        prepare: prepare,
        handleAdd: handleAdd,
        handleRemove: handleRemove,
        add: add,
        remove: remove
    };
};
var multiselect$3 = select$3;
var tags$3 = select$3;
var HasChange = {
    props: {
        onChange: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    }
};
var HasData = {
    props: {
        formatData: {
            required: false,
            type: [
                Function
            ],
            default: null
        },
        formatLoad: {
            required: false,
            type: [
                Function
            ],
            default: null
        },
        submit: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        }
    }
};
var HasValidation = {
    props: {
        rules: {
            required: false,
            type: [
                Array,
                String,
                Object
            ],
            default: null
        },
        messages: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        fieldName: {
            required: false,
            type: [
                String
            ],
            '@default': 'name|label'
        },
        displayErrors: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        }
    }
};
var CaptchaElement = {
    name: 'CaptchaElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'captcha',
            private: true
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        default: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        rules: {
            required: false,
            type: [
                Array,
                String,
                Object
            ],
            default: [
                'captcha'
            ]
        },
        size: {
            required: false,
            type: [
                String
            ],
            default: undefined,
            private: true
        },
        fieldName: {
            required: false,
            type: [
                String
            ],
            '@default': 'name|label',
            private: true
        },
        provider: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'config.useProviders.captcha'
        },
        options: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$G,
            base$19,
            base$H,
            base$L,
            base$P,
            base$I,
            base$M,
            captcha,
            base$14,
            base$N,
            captcha$1,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$J,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$D = function base(props, context, dependencies) {
    var { text } = (0, $8bTPG.toRefs)(props);
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    var form$ = (0, $ani5R.inject)('form$');
    // ============== COMPUTED ==============
    /**
   * The localized text of the element.
   *
   * @type {string}
   *
   */ var Text = (0, $8bTPG.computed)(()=>{
        return localize(text.value, config$.value, form$.value) || '';
    });
    return {
        Text: Text
    };
};
var base$C = function base(props, context, dependencies) {
    var { trueValue, falseValue } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var update = dependencies.update;
    // =============== METHODS ==============
    /**
   * Sets the toggle to `on` ([`trueValue`](#option-true-value)).
   *
   * @returns {void}
   */ var check = ()=>{
        update(trueValue.value);
    };
    /**
   * Sets the toggle to `off` ([`falseValue`](#option-false-value)).
   *
   * @returns {void}
   */ var uncheck = ()=>{
        update(falseValue.value);
    };
    return {
        check: check,
        uncheck: uncheck
    };
};
var checkbox = function checkbox(props, context, dependencies) {
    var { trueValue, falseValue } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var update = dependencies.update;
    // =============== METHODS ==============
    /**
   * Checks the checkbox.
   *
   * @returns {void}
   */ var check = ()=>{
        update(trueValue.value);
    };
    /**
   * Unchecks the checkbox.
   *
   * @returns {void}
   */ var uncheck = ()=>{
        update(falseValue.value);
    };
    return {
        check: check,
        uncheck: uncheck
    };
};
var CheckboxElement = {
    name: 'CheckboxElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'checkbox',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Boolean,
                Number
            ],
            default: undefined // falseValue
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        text: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        trueValue: {
            required: false,
            type: [
                Boolean,
                String,
                Number
            ],
            default: true
        },
        falseValue: {
            required: false,
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        standalone: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            boolean,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$G,
            base$19,
            base$H,
            base$P,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            checkbox,
            checkbox$1,
            base$J,
            base$Y,
            base$D
        ];
        context.slots = [
            'default',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$B = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    var resolvedOptions = dependencies.resolvedOptions;
    // =============== METHODS ==============
    /**
   * Toggle's a checkbox's value.
   *
   * @param {string|number} value* value to toggle
   * @returns {void}
   */ var toggle = (val)=>{
        if (value.value.indexOf(String(val)) === -1 && value.value.indexOf(Number(val)) === -1) check(val);
        else uncheck(val);
    };
    /**
   * Checks one or more checkboxes.
   *
   * @param {array|string|number} values* value(s) to check
   * @returns {void}
   */ var check = (values)=>{
        if (!isArray_1(values)) values = [
            values
        ];
        var items = clone_1(value.value);
        each(values, (item)=>{
            /* istanbul ignore else */ if (items.indexOf(String(item)) === -1 && items.indexOf(Number(item)) === -1) items.push(item);
        });
        value.value = items;
    };
    /**
   * Unchecks one or more checkboxes.
   *
   * @param {array|string|number} values* value(s) to check
   * @returns {void}
   */ var uncheck = (values)=>{
        if (!isArray_1(values)) values = [
            values
        ];
        var items = clone_1(value.value);
        each(values, (item)=>{
            var index = items.indexOf(String(item));
            /* istanbul ignore else */ if (index === -1) index = items.indexOf(Number(item));
            /* istanbul ignore else */ if (index !== -1) items.splice(index, 1);
        });
        value.value = items;
    };
    /**
   * Checks all checkboxes.
   *
   * @returns {void}
   */ var checkAll = ()=>{
        check(resolvedOptions.value.map((o)=>o.value));
    };
    /**
   * Unchecks all checkboxes.
   *
   * @returns {void}
   */ var uncheckAll = ()=>{
        uncheck(resolvedOptions.value.map((o)=>o.value));
    };
    return {
        toggle: toggle,
        check: check,
        uncheck: uncheck,
        checkAll: checkAll,
        uncheckAll: uncheckAll
    };
};
var base$A = function base(props, context, dependencies) {
    var { items, valueProp, labelProp, dataKey, searchParam, clearOnRefetch, object } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isNative = dependencies.isNative;
    var disable = dependencies.disable;
    var enable = dependencies.enable;
    var input = dependencies.input;
    var value = dependencies.value;
    var nullValue = dependencies.nullValue;
    var path = dependencies.path;
    var el$1 = dependencies.el$;
    var form$ = dependencies.form$;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ================ DATA ================
    /**
   * Contains the fetched items when using async `items`.
   *
   * @type {array|object}
   * @default null
   * @private
   */ var options = (0, $8bTPG.ref)(null);
    /**
   * Stores watchers for fields from which dynamic values for endpoints are retrieved.
   * 
   * @type {array}
   * @default []
   * @private
   */ var watchers = (0, $8bTPG.ref)([]);
    // ============== COMPUTED ==============
    /**
   * Contains the resolved options.
   *
   * @type {array}
   */ var resolvedOptions = (0, $8bTPG.computed)(()=>{
        if (!isNative.value) return options.value;
        var nativeItems = [];
        each(options.value, (item, key)=>{
            if ([
                null,
                undefined
            ].indexOf(item) !== -1) return;
            if (Array.isArray(options.value) && typeof item === 'object') {
                if (item[valueProp.value] === undefined) console.warn('You must define `value` property for each option when using an array of objects options for select element');
                nativeItems.push({
                    value: item[valueProp.value],
                    label: item[labelProp.value]
                });
            } else if (Array.isArray(options.value)) nativeItems.push({
                value: item,
                label: item
            });
            else nativeItems.push({
                value: key,
                label: item
            });
        });
        return nativeItems.map((o)=>{
            return _objectSpread2$1(_objectSpread2$1({}, o), {}, {
                label: localize(o.label, config$.value, form$.value)
            });
        });
    });
    // =============== METHODS ==============
    /**
   * Fetches & updates select options when using `async` options. Receives [`el$`](#property-el) as first param.
   *
   * @param {boolean} disable* whether the input field should be disabled while fetching options
   * @returns {Promise}
   */ var updateItems = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*() {
            var shouldDisable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!isNative.value) {
                var _input$value;
                // Refresh async function in case it
                // contains variables that have changed
                if (typeof items.value === 'string') options.value = createAsyncOptionsFromUrl();
                yield (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.resolveOptions();
                return;
            }
            if (shouldDisable) disable();
            if (typeof items.value === 'string') yield resolveOptionsFromUrl();
            else if (typeof items.value === 'function') yield resolveOptionsFromFunction();
            else options.value = items.value;
            if (shouldDisable) enable();
        });
        return function updateItems() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Resolves options from url.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptionsFromUrl = /*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(function*() {
            try {
                var _yield$form$$value$$v;
                var url = yield resolveUrlAndSetWatchers(items.value, updateItems);
                var optionList = ((_yield$form$$value$$v = yield form$.value.$vueform.services.axios.get(url)) === null || _yield$form$$value$$v === void 0 ? void 0 : _yield$form$$value$$v.data) || [];
                if (dataKey && dataKey.value && Object.keys(optionList).length) optionList = get_1(optionList, dataKey.value) || [];
                options.value = optionList;
            } catch (e) {
                options.value = [];
                console.warn("Couldn't resolve items from ".concat(items.value), e);
            } finally{
                var _resolvedOptions$valu;
                cleanupValue(((_resolvedOptions$valu = resolvedOptions.value) === null || _resolvedOptions$valu === void 0 ? void 0 : _resolvedOptions$valu.map((o)=>o.value)) || []);
            }
        });
        return function resolveOptionsFromUrl() {
            return _ref2.apply(this, arguments);
        };
    }();
    /**
   * Creates an async function returning options from url.
   *
   * @returns {function}
   * @private
   */ var createAsyncOptionsFromUrl = ()=>{
        return /*#__PURE__*/ function() {
            var _ref3 = _asyncToGenerator(function*(query) {
                var url = yield resolveUrlAndSetWatchers(items.value, updateItems);
                var optionList;
                try {
                    var _yield$form$$value$$v2;
                    optionList = ((_yield$form$$value$$v2 = yield form$.value.$vueform.services.axios.get("".concat(url).concat(url.match(/\?/) ? '&' : '?').concat(searchParam.value, "=").concat(query || ''))) === null || _yield$form$$value$$v2 === void 0 ? void 0 : _yield$form$$value$$v2.data) || [];
                    if (dataKey && dataKey.value && Object.keys(optionList).length) optionList = get_1(optionList, dataKey.value) || [];
                } catch (e) {
                    console.error(e);
                } finally{
                    setTimeout(()=>{
                        var _input$value2;
                        cleanupValue(((_input$value2 = input.value) === null || _input$value2 === void 0 || (_input$value2 = _input$value2.eo) === null || _input$value2 === void 0 ? void 0 : _input$value2.map((o)=>o[valueProp.value])) || []);
                    }, 0);
                }
                return optionList;
            });
            return function(_x) {
                return _ref3.apply(this, arguments);
            };
        }();
    };
    /**
   * Resolves options from function.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptionsFromFunction = /*#__PURE__*/ function() {
        var _ref4 = _asyncToGenerator(function*() {
            try {
                options.value = (yield items.value(el$1.value)) || [];
            } catch (e) {
                options.value = [];
                console.warn("Couldn't resolve items from async function", e);
            }
        });
        return function resolveOptionsFromFunction() {
            return _ref4.apply(this, arguments);
        };
    }();
    /**
   * Resolves items.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptions = /*#__PURE__*/ function() {
        var _ref5 = _asyncToGenerator(function*(n, o) {
            if (typeof items.value === 'function' && isNative.value) yield resolveOptionsFromFunction();
            else if (!isEqual_1(n, o) || n === undefined && o === undefined) {
                if (typeof items.value === 'string' && isNative.value) yield resolveOptionsFromUrl();
                else if (typeof items.value === 'string' && !isNative.value) options.value = createAsyncOptionsFromUrl();
                else options.value = items.value;
            }
        });
        return function resolveOptions(_x2, _x3) {
            return _ref5.apply(this, arguments);
        };
    }();
    /**
   * Removes any value that is not among the newly fetches option list after async resolve.
   * 
   * @returns {void}
   * @param {array} values* the list of option values
   * @private
   */ var cleanupValue = (values)=>{
        if (clearOnRefetch.value) {
            value.value = cloneDeep_1(nullValue.value);
            return;
        }
        if (!Array.isArray(nullValue.value) && value.value && values.indexOf(object.value ? value.value[valueProp.value] : value.value) === -1) value.value = cloneDeep_1(nullValue.value);
        else if (Array.isArray(nullValue.value) && value.value.length) value.value = value.value.filter((v)=>{
            return values.indexOf(v) !== -1;
        });
    };
    /**
   * Resolves the endpoint url with field values and sets watchers for those fields.
   * 
   * @returns {Promise}
   * @param {string} url* the base url potentially containing variable names
   * @param {function} updateItems* the method that triggers item updates
   * @private
   */ var resolveUrlAndSetWatchers = /*#__PURE__*/ function() {
        var _ref6 = _asyncToGenerator(function*(url, updateItems) {
            var regex = /{([^}]+)}/g;
            var resolvedUrl = url;
            if (url.match(regex)) {
                yield (0, $ani5R.nextTick)();
                watchers.value.forEach((unwatch)=>unwatch());
                var match;
                var _loop = function* _loop() {
                    var _match$1$match;
                    var defaultValue = ((_match$1$match = match[1].match(/\|'([^']+)/)) === null || _match$1$match === void 0 ? void 0 : _match$1$match[1]) || '';
                    var elPath = replaceWildcards(match[1].match(/^([^|]+)/)[1], path.value);
                    var el$1 = form$.value.el$(elPath);
                    var elValue = typeof (el$1 === null || el$1 === void 0 ? void 0 : el$1.value) !== 'undefined' && el$1.value !== null && typeof el$1.value === 'object' ? JSON.stringify(el$1.value) : typeof (el$1 === null || el$1 === void 0 ? void 0 : el$1.value) !== 'undefined' && el$1.value !== null ? el$1.value : defaultValue;
                    resolvedUrl = resolvedUrl.replace(match[0], encodeURIComponent(elValue));
                    watchers.value.push((0, $8bTPG.watch)((0, $8bTPG.computed)(()=>el$1 === null || el$1 === void 0 ? void 0 : el$1.value), ()=>{
                        updateItems();
                    }));
                };
                while((match = regex.exec(url)) !== null)yield* _loop();
            }
            return resolvedUrl;
        });
        return function resolveUrlAndSetWatchers(_x4, _x5) {
            return _ref6.apply(this, arguments);
        };
    }();
    return {
        resolveOptions: resolveOptions,
        resolvedOptions: resolvedOptions,
        updateItems: updateItems,
        watchers: watchers,
        cleanupValue: cleanupValue,
        resolveUrlAndSetWatchers: resolveUrlAndSetWatchers
    };
};
var select$2 = function select(props, context, dependencies) {
    var { items } = (0, $8bTPG.toRefs)(props);
    var { resolveOptions, resolvedOptions, updateItems, watchers, cleanupValue, resolveUrlAndSetWatchers } = base$A(props, context, dependencies);
    // ================ HOOKS ===============
    resolveOptions();
    (0, $8bTPG.watch)(items, resolveOptions);
    return {
        resolveOptions: resolveOptions,
        resolvedOptions: resolvedOptions,
        updateItems: updateItems,
        watchers: watchers,
        cleanupValue: cleanupValue,
        resolveUrlAndSetWatchers: resolveUrlAndSetWatchers
    };
};
var checkboxgroup = function checkboxgroup(props, context, dependencies) {
    var { items } = (0, $8bTPG.toRefs)(props);
    var { watchers, cleanupValue, resolveUrlAndSetWatchers } = base$A(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var disableAll = dependencies.disableAll;
    var enableAll = dependencies.enableAll;
    var el$1 = dependencies.el$;
    var form$ = dependencies.form$;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ================ DATA ================
    /**
   * Contains the fetched items when using async `items`.
   *
   * @type {array|object}
   * @default null
   * @private
   */ var options = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Contains the available items. If [`items`](#option-items) are async this contains the resolved items.
   *
   * @type {array}
   */ var resolvedOptions = (0, $8bTPG.computed)(()=>{
        var resolvedOptions = [];
        each(options.value, (item, key)=>{
            if ([
                null,
                undefined
            ].indexOf(item) !== -1) return;
            // [{a:1},{b:2}]
            if (Array.isArray(options.value) && typeof item === 'object') {
                if (item.value === undefined) console.warn('You must define `value` property for each item when using an array of objects options');
                resolvedOptions.push(item);
            } else if (Array.isArray(options.value)) resolvedOptions.push({
                value: item,
                label: item
            });
            else if (typeof item === 'object') resolvedOptions.push(_objectSpread2$1(_objectSpread2$1({}, item), {}, {
                value: key
            }));
            else resolvedOptions.push({
                label: item,
                value: key
            });
        });
        return resolvedOptions.map((o)=>{
            return _objectSpread2$1(_objectSpread2$1({}, o), {}, {
                label: localize(o.label, config$.value, form$.value)
            });
        });
    });
    // =============== METHODS ==============
    /**
   * Fetches & updates items when using `async` items.
   *
   * @param {boolean} disable* whether the input field should be disabled while fetching options
   * @returns {Promise}
   */ var updateItems = /*#__PURE__*/ function() {
        var _ref7 = _asyncToGenerator(function*() {
            var shouldDisable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (shouldDisable) disableAll();
            if (typeof items.value === 'string') yield resolveOptionsFromUrl();
            else yield resolveOptionsFromFunction();
            if (shouldDisable) enableAll();
        });
        return function updateItems() {
            return _ref7.apply(this, arguments);
        };
    }();
    /**
   * Resolves options from url.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptionsFromUrl = /*#__PURE__*/ function() {
        var _ref8 = _asyncToGenerator(function*() {
            try {
                var _yield$form$$value$$v3, _resolvedOptions$valu2;
                var url = yield resolveUrlAndSetWatchers(items.value, updateItems);
                options.value = ((_yield$form$$value$$v3 = yield form$.value.$vueform.services.axios.get(url)) === null || _yield$form$$value$$v3 === void 0 ? void 0 : _yield$form$$value$$v3.data) || [];
                cleanupValue(((_resolvedOptions$valu2 = resolvedOptions.value) === null || _resolvedOptions$valu2 === void 0 ? void 0 : _resolvedOptions$valu2.map((o)=>o.value)) || []);
            } catch (e) {
                options.value = [];
                console.warn("Couldn't resolve items from ".concat(items.value), e);
            }
        });
        return function resolveOptionsFromUrl() {
            return _ref8.apply(this, arguments);
        };
    }();
    /**
   * Resolves options from function. Receives [`el$`](#property-el) as first param.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptionsFromFunction = /*#__PURE__*/ function() {
        var _ref9 = _asyncToGenerator(function*() {
            try {
                options.value = (yield items.value(el$1.value)) || [];
            } catch (e) {
                options.value = [];
                console.warn("Couldn't resolve items from async function", e);
            }
        });
        return function resolveOptionsFromFunction() {
            return _ref9.apply(this, arguments);
        };
    }();
    /**
   * Resolves items.
   *
   * @returns {Promise}
   * @private
   */ var resolveOptions = /*#__PURE__*/ function() {
        var _ref10 = _asyncToGenerator(function*() {
            if (typeof items.value === 'function') yield resolveOptionsFromFunction();
            else if (typeof items.value === 'string') yield resolveOptionsFromUrl();
            else options.value = items.value;
        });
        return function resolveOptions() {
            return _ref10.apply(this, arguments);
        };
    }();
    // ================ HOOKS ===============
    resolveOptions();
    (0, $8bTPG.watch)(items, resolveOptions);
    return {
        resolveOptions: resolveOptions,
        resolvedOptions: resolvedOptions,
        updateItems: updateItems,
        watchers: watchers,
        cleanupValue: cleanupValue,
        resolveUrlAndSetWatchers: resolveUrlAndSetWatchers
    };
};
var radiogroup = checkboxgroup;
var multiselect$2 = select$2;
var tags$2 = select$2;
var CheckboxgroupElement = {
    name: 'CheckboxgroupElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'checkboxgroup',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        items: {
            required: false,
            type: [
                Object,
                Array,
                Function,
                String
            ],
            localized: true,
            default: ()=>({})
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        disables: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        clearOnRefetch: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            array$1,
            base$Z,
            base$1h,
            checkboxgroup$1,
            checkboxgroup$3,
            base$G,
            base$P,
            checkboxgroup,
            base$19,
            base$H,
            base$B,
            base$E,
            base$14,
            base$N,
            base$13,
            base$12,
            base$11,
            base$1f,
            base$10,
            checkboxgroup$2,
            base$J,
            base$Y
        ];
        context.slots = [
            'checkbox',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$z = function base(props, context, dependencies) {
    var { addons, slots } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var el$1 = dependencies.el$;
    var form$ = dependencies.form$;
    // ============== COMPUTED ==============
    var hasAddonBefore = (0, $8bTPG.computed)(()=>{
        var _el$$value$$slots, _el$$value$$scopedSlo;
        return !!(addons.value.before || (_el$$value$$slots = el$1.value.$slots) !== null && _el$$value$$slots !== void 0 && _el$$value$$slots['addon-before'] || /* istanbul ignore next */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo !== void 0 && _el$$value$$scopedSlo['addon-before'] || slots.value['addon-before']);
    });
    var hasAddonAfter = (0, $8bTPG.computed)(()=>{
        var _el$$value$$slots2, _el$$value$$scopedSlo2;
        return !!(addons.value.after || (_el$$value$$slots2 = el$1.value.$slots) !== null && _el$$value$$slots2 !== void 0 && _el$$value$$slots2['addon-after'] || /* istanbul ignore next */ form$.value.$vueform.vueVersion === 2 && (_el$$value$$scopedSlo2 = el$1.value.$scopedSlots) !== null && _el$$value$$scopedSlo2 !== void 0 && _el$$value$$scopedSlo2['addon-after'] || slots.value['addon-after']);
    });
    return {
        hasAddonBefore: hasAddonBefore,
        hasAddonAfter: hasAddonAfter
    };
};
var base$y = function base(props, context, dependencies) {
    var { displayFormat, valueFormat, loadFormat, date, time, seconds, hour24 } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    // =============== PRIVATE ===============
    /**
   * The default date format type.
   *
   * @type {string}
   * @private
   */ var defaultFormat = (0, $8bTPG.computed)(()=>{
        var format;
        if (date.value && time.value && seconds.value && hour24.value) format = 'datetimeSeconds24';
        else if (date.value && time.value && seconds.value && !hour24.value) format = 'datetimeSeconds12';
        else if (date.value && time.value && !seconds.value && hour24.value) format = 'datetime24';
        else if (date.value && time.value && !seconds.value && !hour24.value) format = 'datetime12';
        else if (!date.value && time.value && seconds.value && hour24.value) format = 'timeSeconds24';
        else if (!date.value && time.value && seconds.value && !hour24.value) format = 'timeSeconds12';
        else if (!date.value && time.value && !seconds.value && hour24.value) format = 'time24';
        else if (!date.value && time.value && !seconds.value && !hour24.value) format = 'time12';
        else format = 'date';
        return format;
    });
    /**
   * The default date format for display.
   *
   * @type {string}
   * @private
   */ var defaultDisplayFormat = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.dateFormats[defaultFormat.value];
    });
    /**
   * The default date format for value & load.
   *
   * @type {string}
   * @private
   */ var defaultDataFormat = (0, $8bTPG.computed)(()=>{
        var dataDateFormats = {
            datetimeSeconds24: 'YYYY-MM-DD HH:mm:ss',
            datetimeSeconds12: 'YYYY-MM-DD hh:mm:ss a',
            datetime24: 'YYYY-MM-DD HH:mm',
            datetime12: 'YYYY-MM-DD hh:mm a',
            timeSeconds24: 'HH:mm:ss',
            timeSeconds12: 'hh:mm:ss a',
            time24: 'HH:mm',
            time12: 'hh:mm a',
            date: 'YYYY-MM-DD'
        };
        return dataDateFormats[defaultFormat.value];
    });
    // ============== COMPUTED ===============
    /**
   * The display date format.
   *
   * @type {string}
   * @private
   */ var displayDateFormat = (0, $8bTPG.computed)(()=>{
        return displayFormat.value !== null ? displayFormat.value : defaultDisplayFormat.value;
    });
    /**
   * The format of date value.
   *
   * @type {string}
   * @private
   */ var valueDateFormat = (0, $8bTPG.computed)(()=>{
        return valueFormat.value !== null || valueFormat.value === false ? valueFormat.value : defaultDataFormat.value;
    });
    /**
   * The date format of the data the element being loaded with.
   *
   * @type {string}
   * @private
   */ var loadDateFormat = (0, $8bTPG.computed)(()=>{
        return loadFormat.value !== null ? loadFormat.value : defaultDataFormat.value;
    });
    return {
        displayDateFormat: displayDateFormat,
        valueDateFormat: valueDateFormat,
        loadDateFormat: loadDateFormat
    };
};
var dates$2 = function dates(props, context, dependencies) {
    var { displayFormat, valueFormat, loadFormat } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var form$ = dependencies.form$;
    // =============== PRIVATE ===============
    var defaultFormat = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.dateFormats.date;
    });
    // ============== COMPUTED ===============
    var displayDateFormat = (0, $8bTPG.computed)(()=>{
        return displayFormat.value !== null ? displayFormat.value : defaultFormat.value;
    });
    var valueDateFormat = (0, $8bTPG.computed)(()=>{
        return valueFormat.value !== null || valueFormat.value === false ? valueFormat.value : defaultFormat.value;
    });
    var loadDateFormat = (0, $8bTPG.computed)(()=>{
        return loadFormat.value !== null ? loadFormat.value : defaultFormat.value;
    });
    return {
        displayDateFormat: displayDateFormat,
        valueDateFormat: valueDateFormat,
        loadDateFormat: loadDateFormat
    };
};
var base$x = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    // =============== METHODS ==============
    /**
   * Handles `change` event.
   *
   * @param {string} val* value of the element
   * @returns {void}
   * @private
   */ var handleChange = (val)=>{
        value.value = val;
    };
    return {
        handleChange: handleChange
    };
};
var base$w = function base(props, context, dependencies) {
    var { placeholder } = (0, $8bTPG.toRefs)(props);
    var { el$: el$1 } = dependencies;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    var form$ = (0, $ani5R.inject)('form$');
    // ============== COMPUTED ==============
    /**
   * The localized placeholder of the element.
   *
   * @type {string}
   *
   */ var Placeholder = (0, $8bTPG.computed)(()=>{
        var _form$$value$options$;
        var Placeholder = localize(placeholder.value, config$.value, form$.value);
        if (el$1.value.isRequired && ((_form$$value$options$ = form$.value.options.showRequired) === null || _form$$value$options$ === void 0 ? void 0 : _form$$value$options$.indexOf('placeholder')) !== -1) Placeholder += '*';
        return Placeholder;
    });
    return {
        Placeholder: Placeholder
    };
};
var date$1 = function date(props, context, dependencies) {
    var { disables, min, max, extendOptions, readonly, hour24, seconds, date, time } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var displayDateFormat = dependencies.displayDateFormat;
    var valueDateFormat = dependencies.valueDateFormat;
    var form$ = dependencies.form$;
    var moment = form$.value.$vueform.services.moment;
    // ============== COMPUTED ==============
    /**
   * List of dates to disable.
   *
   * @type {array}
   * @private
   */ var disabledDates = (0, $8bTPG.computed)(()=>{
        /* istanbul ignore next: failsafe only */ if (disables.value === undefined) return [];
        return map_1(disables.value, (disabledDate)=>{
            checkDateFormat(valueDateFormat.value, disabledDate, moment);
            return disabledDate instanceof Date ? disabledDate : moment(disabledDate, valueDateFormat.value, true).toDate();
        });
    });
    /**
   * Earliest selectable date. Can be a string in `[loadFormat](#load-format)` or a Date object.
   *
   * @type {string|Date}
   * @private
   */ var minDate = (0, $8bTPG.computed)(()=>{
        if (!min.value) return null;
        checkDateFormat(valueDateFormat.value, min.value, moment);
        return min.value instanceof Date ? min.value : moment(min.value, valueDateFormat.value, true).toDate();
    });
    /**
   * Latest selectable date. Can be a string in `[loadFormat](#load-format)` or a Date object.
   *
   * @type {string|Date}
   * @private
   */ var maxDate = (0, $8bTPG.computed)(()=>{
        if (!max.value) return null;
        checkDateFormat(valueDateFormat.value, max.value, moment);
        return max.value instanceof Date ? max.value : moment(max.value, valueDateFormat.value, true).toDate();
    });
    /**
   * Default options for date selector.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            dateFormat: displayDateFormat.value,
            minDate: minDate.value,
            maxDate: maxDate.value,
            disable: disabledDates.value,
            clickOpens: !isDisabled.value && !readonly.value,
            time_24hr: hour24.value,
            enableTime: time.value,
            enableSeconds: seconds.value,
            noCalendar: !date.value
        };
    });
    /**
   * Options for date selector. Can be extended via [`extend-options`](#option-extend-options) with [flatpickr options](https://flatpickr.js.org/options/).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    /**
   * Whether date selector has `date` enabled.
   *
   * @type {boolean}
   * @private
   */ var hasDate = (0, $8bTPG.computed)(()=>{
        return true;
    });
    /**
   * Whether date selector has `time` enabled.
   *
   * @type {boolean}
   * @private
   */ var hasTime = (0, $8bTPG.computed)(()=>{
        return false;
    });
    return {
        minDate: minDate,
        maxDate: maxDate,
        disabledDates: disabledDates,
        fieldOptions: fieldOptions,
        hasDate: hasDate,
        hasTime: hasTime
    };
};
var dates$1 = function dates(props, context, dependencies) {
    var { mode, extendOptions, readonly } = (0, $8bTPG.toRefs)(props);
    var { minDate, maxDate, disabledDates } = date$1(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var displayDateFormat = dependencies.displayDateFormat;
    // ============== COMPUTED ==============
    var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            mode: mode.value,
            dateFormat: displayDateFormat.value,
            minDate: minDate.value,
            maxDate: maxDate.value,
            disable: disabledDates.value,
            clickOpens: !isDisabled.value && !readonly.value
        };
    });
    var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    var hasDate = (0, $8bTPG.computed)(()=>{
        return true;
    });
    var hasTime = (0, $8bTPG.computed)(()=>{
        return false;
    });
    return {
        minDate: minDate,
        maxDate: maxDate,
        disabledDates: disabledDates,
        fieldOptions: fieldOptions,
        hasDate: hasDate,
        hasTime: hasTime
    };
};
var select$1 = function select(props, context, dependencies) {
    var { native, extendOptions, labelProp, trackBy, valueProp, search, limit, noOptionsText, noResultsText, caret, object, delay, minChars, resolveOnLoad, filterResults, clearOnSearch, canDeselect, canClear, openDirection, strict, closeOnSelect, closeOnDeselect, autocomplete, groups, groupLabel, groupOptions, groupHideEmpty, inputType, create, appendNewOption, addOptionOn, appendTo, appendToBody, allowAbsent } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var isLoading = dependencies.isLoading;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * Whether native select should be used.
   *
   * @type {string}
   */ var isNative = (0, $8bTPG.computed)(()=>{
        return native.value && !search.value;
    });
    /**
   * Default options for non-native select input.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            mode: 'single',
            searchable: search.value || create.value,
            noOptionsText: noOptionsText.value || form$.value.translations.vueform.multiselect.noOptions,
            noResultsText: noResultsText.value || form$.value.translations.vueform.multiselect.noResults,
            locale: Object.keys(config$.value.i18n.locales).length > 1 ? config$.value.i18n.locale : null,
            //@todo:adam can not be localized on form level
            fallbackLocale: config$.value.i18n.fallbackLocale,
            label: labelProp.value,
            trackBy: trackBy.value,
            valueProp: valueProp.value,
            limit: limit.value,
            caret: caret.value,
            loading: isLoading.value,
            object: object.value,
            delay: delay.value,
            minChars: minChars.value,
            resolveOnLoad: resolveOnLoad.value,
            filterResults: filterResults.value,
            clearOnSearch: clearOnSearch.value,
            canDeselect: canDeselect.value,
            canClear: canClear.value,
            openDirection: openDirection.value,
            strict: strict.value,
            closeOnSelect: closeOnSelect.value,
            closeOnDeselect: closeOnDeselect.value,
            autocomplete: autocomplete.value,
            groups: groups.value,
            groupLabel: groupLabel.value,
            groupOptions: groupOptions.value,
            groupHideEmpty: groupHideEmpty.value,
            inputType: inputType.value,
            createOption: create.value,
            appendNewOption: appendNewOption.value,
            addOptionOn: addOptionOn.value,
            appendTo: appendTo.value,
            appendToBody: appendToBody.value,
            allowAbsent: allowAbsent.value
        };
    });
    /**
   * Options for non-native select input. Can be extended via [`extend-options`](#option-extend-options) with [@vueform/multiselect options](https://github.com/vueform/multiselect#basic-props).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    return {
        fieldOptions: fieldOptions,
        isNative: isNative
    };
};
var multiselect$1 = function multiselect(props, context, dependencies) {
    var { native, extendOptions, labelProp, trackBy, valueProp, search, limit, noOptionsText, noResultsText, caret, object, delay, minChars, resolveOnLoad, filterResults, clearOnSearch, clearOnSelect, canClear, max, openDirection, strict, closeOnSelect, closeOnDeselect, autocomplete, groups, groupLabel, groupOptions, groupHideEmpty, groupSelect, inputType, hideSelected, multipleLabel, multipleLabelMultiple, multipleLabelSingle, create, appendNewOption, addOptionOn, appendTo, appendToBody, allowAbsent } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var isLoading = dependencies.isLoading;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * Whether native multiselect should be used.
   *
   * @type {string}
   */ var isNative = (0, $8bTPG.computed)(()=>{
        return native.value && !search.value;
    });
    /**
   * Default options for non-native multiselect input.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            mode: 'multiple',
            searchable: search.value || create.value,
            noOptionsText: noOptionsText.value || form$.value.translations.vueform.multiselect.noOptions,
            noResultsText: noResultsText.value || form$.value.translations.vueform.multiselect.noResults,
            multipleLabel: multipleLabel.value || ((val, select$)=>{
                return val && val.length > 1 ? multipleLabelMultiple.value ? multipleLabelMultiple.value.replace(':x:', val.length) : form$.value.__(form$.value.translations.vueform.multiselect.multipleLabelMore, {
                    options: val.length
                }) : multipleLabelSingle.value || form$.value.translations.vueform.multiselect.multipleLabelOne;
            }),
            locale: Object.keys(config$.value.i18n.locales).length > 1 ? config$.value.i18n.locale : null,
            //@todo:adam can not be localized on form level
            fallbackLocale: config$.value.i18n.fallbackLocale,
            label: labelProp.value,
            trackBy: trackBy.value,
            valueProp: valueProp.value,
            limit: limit.value,
            caret: caret.value,
            loading: isLoading.value,
            object: object.value,
            delay: delay.value,
            minChars: minChars.value,
            resolveOnLoad: resolveOnLoad.value,
            filterResults: filterResults.value,
            clearOnSearch: clearOnSearch.value,
            clearOnSelect: clearOnSelect.value,
            canClear: canClear.value,
            max: max.value,
            openDirection: openDirection.value,
            strict: strict.value,
            closeOnSelect: closeOnSelect.value,
            closeOnDeselect: closeOnDeselect.value,
            autocomplete: autocomplete.value,
            groups: groups.value,
            groupLabel: groupLabel.value,
            groupOptions: groupOptions.value,
            groupHideEmpty: groupHideEmpty.value,
            groupSelect: groupSelect.value,
            inputType: inputType.value,
            hideSelected: hideSelected.value,
            createOption: create.value,
            appendNewOption: appendNewOption.value,
            addOptionOn: addOptionOn.value,
            appendTo: appendTo.value,
            appendToBody: appendToBody.value,
            allowAbsent: allowAbsent.value
        };
    });
    /**
   * Options for non-native multiselect input. Can be extended via [`extend-options`](#option-extend-options) with [@vueform/multiselect options](https://github.com/vueform/multiselect#basic-props).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    return {
        fieldOptions: fieldOptions,
        isNative: isNative
    };
};
var tags$1 = function tags(props, context, dependencies) {
    var { extendOptions, labelProp, trackBy, valueProp, search, limit, noOptionsText, noResultsText, caret, object, delay, minChars, resolveOnLoad, filterResults, clearOnSearch, clearOnSelect, canClear, max, showOptions, openDirection, strict, closeOnSelect, closeOnDeselect, autocomplete, groups, groupLabel, groupOptions, groupHideEmpty, groupSelect, inputType, hideSelected, create, appendNewOption, addOptionOn, breakTags, appendTo, appendToBody, allowAbsent } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var isLoading = dependencies.isLoading;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ================ DATA ================
    /**
   * Technical prop to be able to use the same template for tags as for select.
   *
   * @type {boolean}
   * @default false
   * @private
   */ var native = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    /**
   * Technical prop to be able to use the same template for tags as for select.
   *
   * @type {boolean}
   * @private
   */ var isNative = (0, $8bTPG.computed)(()=>{
        return false;
    });
    /**
   * Default options for tags input.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            mode: 'tags',
            searchable: search.value || create.value,
            noOptionsText: noOptionsText.value || form$.value.translations.vueform.multiselect.noOptions,
            noResultsText: noResultsText.value || form$.value.translations.vueform.multiselect.noResults,
            locale: Object.keys(config$.value.i18n.locales).length > 1 ? config$.value.i18n.locale : null,
            //@todo:adam can not be localized on form level
            fallbackLocale: config$.value.i18n.fallbackLocale,
            label: labelProp.value,
            trackBy: trackBy.value,
            valueProp: valueProp.value,
            limit: limit.value,
            caret: caret.value,
            loading: isLoading.value,
            object: object.value,
            delay: delay.value,
            minChars: minChars.value,
            resolveOnLoad: resolveOnLoad.value,
            filterResults: filterResults.value,
            clearOnSearch: clearOnSearch.value,
            clearOnSelect: clearOnSelect.value,
            canClear: canClear.value,
            max: max.value,
            showOptions: showOptions.value,
            openDirection: openDirection.value,
            strict: strict.value,
            closeOnSelect: closeOnSelect.value,
            closeOnDeselect: closeOnDeselect.value,
            autocomplete: autocomplete.value,
            groups: groups.value,
            groupLabel: groupLabel.value,
            groupOptions: groupOptions.value,
            groupHideEmpty: groupHideEmpty.value,
            groupSelect: groupSelect.value,
            inputType: inputType.value,
            hideSelected: hideSelected.value,
            createOption: create.value,
            appendNewOption: appendNewOption.value,
            addOptionOn: addOptionOn.value,
            breakTags: breakTags.value,
            appendTo: appendTo.value,
            appendToBody: appendToBody.value,
            allowAbsent: allowAbsent.value
        };
    });
    /**
   * Options for tags input. Can be extended via [`extend-options`](#option-extend-options) with [@vueform/multiselect options](https://github.com/vueform/multiselect#basic-props).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    return {
        native: native,
        fieldOptions: fieldOptions,
        isNative: isNative
    };
};
var slider = function slider(props, context, dependencies) {
    var { min, max, step, tooltips, merge, format, orientation, direction, extendOptions, showTooltip, tooltipPosition, lazy } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    dependencies.labelId;
    // ============== COMPUTED ==============
    /**
   * Default options for slider input.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            min: min.value,
            max: max.value,
            step: step.value,
            tooltips: tooltips.value,
            merge: merge.value,
            format: format.value,
            orientation: orientation.value,
            direction: direction.value,
            disabled: isDisabled.value,
            showTooltip: showTooltip.value,
            tooltipPosition: tooltipPosition.value,
            lazy: lazy.value
        };
    });
    /**
   * Options for slider input. Can be extended via [`extend-options`](#option-extend-options) with [@vueform/slider options](https://github.com/vueform/slider#basic-props).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    return {
        fieldOptions: fieldOptions
    };
};
var toggle = function toggle(props, context, dependencies) {
    var { labels, extendOptions, trueValue, falseValue } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var form$ = dependencies.form$;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * Default options toggle input.
   *
   * @type {object}
   * @private
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        return {
            disabled: isDisabled.value,
            offLabel: labels.value ? localize(labels.value.off, config$.value, form$.value) || '' : /* istanbul ignore next: default is hardcoded {}, will never fall there */ '',
            onLabel: labels.value ? localize(labels.value.on, config$.value, form$.value) || '' : /* istanbul ignore next: default is hardcoded {}, will never fall there */ '',
            trueValue: trueValue.value,
            falseValue: falseValue.value
        };
    });
    /**
   * Options for toggle input. Can be extended via [`extend-options`](#option-extend-options) with [@vueform/toggle options](https://github.com/vueform/toggle#basic-props).
   *
   * @type {object}
   */ var fieldOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next */ {});
    });
    return {
        fieldOptions: fieldOptions
    };
};
var base$v = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var input = dependencies.input;
    // ================ DATA ================
    /**
   * Whether the element is focused.
   *
   * @type {boolean}
   */ var focused = (0, $8bTPG.ref)(false);
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        if (input && input.value && input.value.addEventListener) {
            input.value.addEventListener('focus', ()=>{
                focused.value = true;
            });
            input.value.addEventListener('blur', ()=>{
                focused.value = false;
            });
        }
    });
    return {
        focused: focused
    };
};
var date = function date(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var input = dependencies.input;
    // ================ DATA ================
    /**
   * Whether the element is focused.
   *
   * @type {boolean}
   */ var focused = (0, $8bTPG.ref)(false);
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        input.value.input.addEventListener('focus', ()=>{
            focused.value = true;
        });
        input.value.input.addEventListener('blur', ()=>{
            focused.value = false;
        });
    });
    return {
        focused: focused
    };
};
var select = function select(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var input = dependencies.input;
    var isNative = dependencies.isNative;
    // ================ DATA ================
    /**
   * Whether the element is focused.
   *
   * @type {boolean}
   */ var focused = (0, $8bTPG.ref)(false);
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        if (isNative.value) {
            input.value.addEventListener('focus', ()=>{
                focused.value = true;
            });
            input.value.addEventListener('blur', ()=>{
                focused.value = false;
            });
        } else (0, $8bTPG.watch)((0, $8bTPG.computed)(()=>{
            var _input$value;
            return (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.isActive;
        }), (active)=>{
            focused.value = active;
        });
    });
    return {
        focused: focused
    };
};
var dates = date;
var multiselect = select;
var tags = select;
var DateElement = {
    name: 'DateElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'date',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Date
            ],
            default: null
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        displayFormat: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'locale.vueform.dateFormats.*'
        },
        valueFormat: {
            required: false,
            type: [
                String,
                Boolean
            ],
            default: null,
            '@default': 'locale.vueform.dateFormats.*'
        },
        loadFormat: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'locale.vueform.dateFormats.*'
        },
        date: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        time: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        seconds: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        hour24: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        min: {
            required: false,
            type: [
                String,
                Date
            ],
            default: null
        },
        max: {
            required: false,
            type: [
                String,
                Date
            ],
            default: null
        },
        disables: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            base$y,
            date$1,
            base$G,
            base$19,
            base$H,
            date$3,
            base$M,
            date$2,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$x,
            date,
            base$V,
            base$J,
            base$Y,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var DatesElement = {
    name: 'DatesElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'dates',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        displayFormat: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        valueFormat: {
            required: false,
            type: [
                String,
                Boolean
            ],
            default: null
        },
        loadFormat: {
            required: false,
            type: [
                String,
                Boolean
            ],
            default: null
        },
        mode: {
            required: false,
            type: [
                String
            ],
            default: 'multiple'
        },
        min: {
            required: false,
            type: [
                String,
                Date
            ],
            default: null
        },
        max: {
            required: false,
            type: [
                String,
                Date
            ],
            default: null
        },
        disables: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            array$1,
            base$Z,
            base$K,
            base$1h,
            dates$5,
            base$W,
            base$F,
            base$z,
            dates$2,
            dates$1,
            base$G,
            dates$4,
            base$19,
            base$H,
            base$M,
            dates$3,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$x,
            dates,
            base$V,
            base$J,
            base$Y,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$u = function base(props, context, dependencies) {
    var { embed, auto, methods, urls, uploadTempEndpoint, removeTempEndpoint, removeEndpoint, url, previewUrl, params, softRemove, view } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var isDisabled = dependencies.isDisabled;
    var validate = dependencies.validate;
    var invalid = dependencies.invalid;
    var path = dependencies.path;
    var axios = dependencies.axios;
    var request = dependencies.request;
    var uploading = dependencies.uploading;
    var input = dependencies.input;
    var update = dependencies.update;
    var fire = dependencies.fire;
    dependencies.isImageType;
    var removing = dependencies.removing;
    var handleError = dependencies.handleError;
    var el$1 = dependencies.el$;
    // ================ DATA ================
    /**
   * Whether the file uploader has any errors.
   *
   * @type {boolean}
   * @default false
   */ var hasUploadError = (0, $8bTPG.ref)(false);
    /**
   * The percentage of progress when the file is being temporarily uploaded (0-100).
   *
   * @type {number}
   * @default 0
   */ var progress = (0, $8bTPG.ref)(0);
    /**
   * If the form is submitted and the file is not uploaded yet, the element will enter into `preparing` state and upload the temporary file before submitting the form.
   *
   * @type {boolean}
   * @default false
   */ var preparing = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    /**
   * The HTTP request endpoints.
   *
   * @type {object}
   * @private
   */ var endpoints = (0, $8bTPG.computed)(()=>{
        var configEndpoints = form$.value.$vueform.config.endpoints;
        var propEndpoints = {
            uploadTempFile: uploadTempEndpoint.value,
            removeTempFile: removeTempEndpoint.value,
            removeFile: removeEndpoint.value
        };
        var endpoints = {};
        Object.keys(propEndpoints).forEach((name)=>{
            var endpoint = configEndpoints[name];
            if (endpoint === false) endpoint = (f)=>f;
            if (urls.value[name]) endpoint = {
                url: urls.value[name],
                method: 'POST'
            };
            if (methods.value[name] && typeof endpoint === 'object') endpoint.method = methods.value[name];
            if (typeof propEndpoints[name] === 'string') {
                if (configEndpoints[propEndpoints[name]] !== undefined) endpoint = configEndpoints[propEndpoints[name]];
                else endpoint.url = propEndpoints[name];
            }
            if (propEndpoints[name] === false) endpoint = (f)=>f;
            if (typeof propEndpoints[name] === 'function') endpoint = propEndpoints[name];
            if (typeof propEndpoints[name] === 'object') endpoint = {
                url: propEndpoints[name].url || propEndpoints[name].endpoint || configEndpoints[name].url,
                method: propEndpoints[name].method || configEndpoints[name].method
            };
            endpoints[name] = endpoint;
        });
        return endpoints;
    });
    /**
   * URL to file using the [`url`](#url) option without including the filename. If `url` is not defined it will default to `'/'`.
   *
   * @type {string|boolean}
   * @private
   */ var fileUrl = (0, $8bTPG.computed)(()=>{
        /* istanbul ignore next: will never be undefined, hardcoded `/`, failsafe only */ if (url.value === undefined) return '/';
        if (url.value === false) return '';
        var fileUrl = url.value;
        if (!fileUrl.match(/\/$/)) fileUrl += '/';
        if (!fileUrl.match(/^(http|file)/) && !fileUrl.match(/^\//)) fileUrl = '/' + fileUrl;
        return fileUrl;
    });
    /**
   * URL to file preview image using the [`previewUrl`](#option-preview-url) option without including the filename. If `previewUrl` is not defined it will default to [`url`](#option-url).
   *
   * @type {string}
   * @private
   */ /* istanbul ignore next: private computed, can not cover but tested */ var filePreviewUrl = (0, $8bTPG.computed)(()=>{
        /* istanbul ignore else */ if (previewUrl.value === undefined) return fileUrl.value;
        var filePreviewUrl = previewUrl.value;
        if (!filePreviewUrl.match(/\/$/)) filePreviewUrl += '/';
        if (!filePreviewUrl.match(/^http/) && !filePreviewUrl.match(/^\//)) filePreviewUrl = '/' + filePreviewUrl;
        return filePreviewUrl;
    });
    /**
   * The stage the file is at:
   *
   * * `0`: file not selected
   * * `1`: file selected
   * * `2`: file temporarily uploaded
   * * `3`: file permanently uploaded
   *
   * @type {number}
   */ var stage = (0, $8bTPG.computed)(()=>{
        if (value.value === null) return 0; // file not selected
        if (value.value instanceof File) return 1; // file selected
        if (isObject_1(value.value) && value.value.tmp !== undefined) return 2; // temp uploaded
        if (isString_1(value.value)) return 3; // file uploaded
        return -1;
    });
    /**
   * The original or stored name of the file.
   *
   * @type {string}
   */ var filename = (0, $8bTPG.computed)(()=>{
        switch(stage.value){
            case 1:
                return value.value.name;
            case 2:
                return value.value.originalName;
            case 3:
                return value.value;
            default:
                return null;
        }
    });
    /**
   * The clickable link of the uploaded file.
   *
   * @type {string}
   */ var link = (0, $8bTPG.computed)(()=>{
        if (!uploaded.value) return;
        return fileUrl.value + filename.value;
    });
    /**
   * The preview link of the uploaded file.
   *
   * @type {string}
   */ /* istanbul ignore next: private computed, can not cover but tested */ var previewLink = (0, $8bTPG.computed)(()=>{
        if (!uploaded.value) return;
        return filePreviewUrl.value + filename.value;
    });
    /**
   * The preview of the file when [`view`](#view) is `image` or `gallery`. Equals to the `link` if the file is already uploaded and `base64` if only selected or temporarily uploaded.
   *
   * @type {string}
   */ var preview = (0, $8bTPG.computed)(()=>{
        var _value$value;
        if (view.value === 'file') return null;
        return uploaded.value ? previewLink.value : value.value instanceof File ? URL.createObjectURL(value.value) : ((_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.__file__) instanceof File ? URL.createObjectURL(value.value.__file__) : null;
    });
    /**
   * Whether the file is permanently uploaded.
   *
   * @type {boolean}
   */ var uploaded = (0, $8bTPG.computed)(()=>{
        return stage.value === 3;
    });
    /**
   * Whether the file can be removed.
   *
   * @type {boolean}
   */ var canRemove = (0, $8bTPG.computed)(()=>{
        return stage.value > 0 && !uploading.value && !isDisabled.value && !preparing.value && !removing.value;
    });
    /**
   * Whether temporary file can be uploaded.
   *
   * @type {boolean}
   */ var canUploadTemp = (0, $8bTPG.computed)(()=>{
        return stage.value === 1 && !auto.value && !uploading.value && !isDisabled.value;
    });
    /**
   * Whether file can be selected.
   *
   * @type {boolean}
   */ var canSelect = (0, $8bTPG.computed)(()=>{
        return !embed.value && stage.value == 0;
    });
    // =============== METHODS ==============
    /**
   * Upload temporary file (async).
   *
   * @returns {Promise}
   */ var uploadTemp = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*() {
            if (stage.value !== 1) throw new Error('No file is selected');
            yield validate();
            if (invalid.value) return;
            request.value = axios.value.CancelToken.source();
            try {
                var data = _getFormData(Object.assign({}, params.value, {
                    file: value.value,
                    formKey: form$.value.options.formKey,
                    path: path.value
                }));
                hasUploadError.value = false;
                var response;
                if (typeof endpoints.value.uploadTempFile === 'function') response = yield endpoints.value.uploadTempFile(value.value, el$1.value);
                else {
                    var method = endpoints.value.uploadTempFile.method.toLowerCase();
                    response = yield axios.value.request({
                        url: endpoints.value.uploadTempFile.url,
                        method: method,
                        [method === 'get' ? 'params' : 'data']: data,
                        onUploadProgress: (e)=>{
                            progress.value = Math.round(e.loaded * 100 / e.total);
                        },
                        cancelToken: request.value.token
                    });
                    response = response.data;
                }
                if (response && typeof response === 'object') response.__file__ = value.value;
                update(response);
            } catch (error) {
                progress.value = 0;
                if (!axios.value.isCancel(error)) {
                    hasUploadError.value = true;
                    handleError(error);
                }
                throw new Error(error);
            } finally{
                request.value = null;
            }
        });
        return function uploadTemp() {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * Removes file (async):
   *
   * * in stage `1`: sets the value to `null`
   * * in stage `2`: submits a request to `removeTemp` endpoint (if [`softRemove: false`](#option-soft-remove)) and sets the value to `null`
   * * in stage `3`: submits a request to `remove` endpoint (if [`softRemove: false`](#option-soft-remove)) and sets the value to `null`
   *
   * @returns {Promise}
   */ var remove = /*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(function*() {
            removing.value = true;
            hasUploadError.value = false;
            try {
                if (stage.value === 3 && !softRemove.value) {
                    if (!confirm(form$.value.translations.vueform.elements.file.removeConfirm)) return false;
                    if (typeof endpoints.value.removeFile === 'function') yield endpoints.value.removeFile(value.value, el$1.value);
                    else {
                        var method = endpoints.value.removeFile.method.toLowerCase();
                        yield axios.value.request({
                            method: method,
                            url: endpoints.value.removeFile.url,
                            [method === 'get' ? 'params' : 'data']: Object.assign({}, params.value, {
                                file: value.value,
                                formKey: form$.value.options.formKey,
                                path: path.value
                            })
                        });
                    }
                } else if (stage.value === 2 && !softRemove.value) {
                    if (typeof endpoints.value.removeTempFile === 'function') yield endpoints.value.removeTempFile(value.value, el$1.value);
                    else {
                        var _method = endpoints.value.removeTempFile.method.toLowerCase();
                        yield axios.value.request({
                            method: _method,
                            url: endpoints.value.removeTempFile.url,
                            [_method === 'get' ? 'params' : 'data']: Object.assign({}, params.value, {
                                file: value.value.tmp,
                                formKey: form$.value.options.formKey,
                                path: path.value
                            })
                        });
                    }
                }
            } catch (error) {
                handleError(error);
                return;
            } finally{
                removing.value = false;
            }
            update(null);
            progress.value = 0;
            fire('remove');
        });
        return function remove() {
            return _ref2.apply(this, arguments);
        };
    }();
    /**
   * Prepare the element for submitting the form (async). It will upload temp file if it hasn't been uploaded yet and halts the submit process until it is done without any errors.
   *
   * @returns {Promise}
   * @private
   */ var prepare = /*#__PURE__*/ function() {
        var _ref3 = _asyncToGenerator(function*() {
            // In selected state
            if (stage.value === 1) {
                preparing.value = true;
                try {
                    yield uploadTemp();
                } finally{
                    preparing.value = false;
                }
            }
        });
        return function prepare() {
            return _ref3.apply(this, arguments);
        };
    }();
    /**
   * Handles `change` event.
   *
   * @param {Event} e* event object
   * @returns {Promise}
   * @private
   */ var handleChange = /*#__PURE__*/ function() {
        var _ref4 = _asyncToGenerator(function*(e) {
            //@todo:adam handleChange has to be async and await uploadTemp() and input.value.value should be before update because otherwise it may not exist
            var file = e.target.files[0];
            input.value.value = '';
            update(file || null);
            if (auto.value) yield uploadTemp();
            if (form$.value.shouldValidateOnChange) validate();
        });
        return function handleChange(_x) {
            return _ref4.apply(this, arguments);
        };
    }();
    /**
   * Handles file select button `click` event.
   *
   * @returns {void}
   * @private
   */ var handleClick = ()=>{
        if (isDisabled.value) return;
        input.value.click();
    };
    /**
   * Handles `uploadTemp` event.
   *
   * @returns {void}
   * @private
   */ var handleUploadTemp = ()=>{
        uploadTemp();
    };
    /**
   * Handles `remove` event.
   *
   * @returns {void}
   * @private
   */ var handleRemove = ()=>{
        remove();
    };
    /**
   * Handles `abort` event.
   *
   * @returns {void}
   * @private
   */ var handleAbort = ()=>{
        if (request.value === null) return;
        request.value.cancel();
    };
    if (value.value instanceof File && auto.value) (0, $ani5R.nextTick)(()=>{
        uploadTemp();
    });
    return {
        hasUploadError: hasUploadError,
        progress: progress,
        preparing: preparing,
        endpoints: endpoints,
        fileUrl: fileUrl,
        stage: stage,
        filename: filename,
        link: link,
        preview: preview,
        uploaded: uploaded,
        canRemove: canRemove,
        canUploadTemp: canUploadTemp,
        canSelect: canSelect,
        uploadTemp: uploadTemp,
        remove: remove,
        prepare: prepare,
        handleChange: handleChange,
        handleClick: handleClick,
        handleUploadTemp: handleUploadTemp,
        handleRemove: handleRemove,
        handleAbort: handleAbort
    };
};
var base$t = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    // ================ DATA ================
    /**
   * The axios request when temp is being uploaded.
   *
   * @type {object}
   * @private
   */ var request = (0, $8bTPG.ref)(null);
    /**
   * The form's axios instance.
   *
   * @type {object}
   * @private
   */ var axios = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Whether a temp file is currently being uploaded.
   *
   * @type {boolean}
   * @private
   */ var uploading = (0, $8bTPG.computed)(()=>{
        return request.value !== null;
    });
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        axios.value = form$.value.$vueform.services.axios;
    });
    return {
        request: request,
        axios: axios,
        uploading: uploading
    };
};
function checkFileType(file, accept) {
    if (!accept) return true;
    if (!isArray_1(accept)) {
        accept = accept.split(',');
        each(accept, (one, i)=>{
            accept[i] = one.trim();
        });
    }
    return some_1(accept, (a)=>{
        var universal = a.match(/^([^\/]+)\/\*$/);
        if (universal) return !!new RegExp("^".concat(universal[1], "/")).exec(file.type);
        else if (a == file.type) return true;
        else if (a == ".".concat(file.name.split('.').pop())) return true;
        return false;
    });
}
var base$s = function base(props, context, dependencies) {
    var { accept, auto } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var update = dependencies.update;
    var isDisabled = dependencies.isDisabled;
    var uploadTemp = dependencies.uploadTemp;
    // ============== COMPUTED ==============
    /**
   * Whether `drop` is enabled and browser supports dragging.
   *
   * @type {boolean}
   * @private
   */ var canDrop = (0, $8bTPG.computed)(()=>{
        var div = document.createElement('div');
        return ('draggable' in div || /* istanbul ignore next: failsafe only, can not influence div from outside */ 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window;
    });
    // =============== METHODS ==============
    /**
   * Handles the `drop` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleDrop = (e)=>{
        if (isDisabled.value) return;
        var file = e.dataTransfer.files[0];
        if (!checkFileType(file, accept.value)) return;
        update(file || /* istanbul ignore next: failsafe only */ null);
        if (auto.value) uploadTemp();
        file.value = null;
    };
    return {
        canDrop: canDrop,
        handleDrop: handleDrop
    };
};
var multifile$3 = function multifile(props, context, dependencies) {
    var { accept } = (0, $8bTPG.toRefs)(props);
    var { canDrop } = base$s(props, context, dependencies);
    // ============ DEPENDENCIES =============
    var add = dependencies.add;
    var isDisabled = dependencies.isDisabled;
    var isObject = dependencies.isObject;
    var storeFileName = dependencies.storeFileName;
    // =============== METHODS ==============
    var handleDrop = (e)=>{
        if (!e.dataTransfer || !e.dataTransfer.files || e.dataTransfer.files.length == 0 || isDisabled.value) return;
        each(e.dataTransfer.files, (file)=>{
            if (!checkFileType(file, accept.value)) return;
            add(isObject.value ? {
                [storeFileName.value]: file
            } : file);
        });
    };
    return {
        canDrop: canDrop,
        handleDrop: handleDrop
    };
};
var base$r = function base(props, context, dependencies) {
    // ================ DATA ================
    /**
   * Whether async file removing request is in progress.
   *
   * @type {boolean}
   */ var removing = (0, $8bTPG.ref)(false);
    return {
        removing: removing
    };
};
var base$q = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fire = dependencies.fire;
    dependencies.listeners;
    // =============== METHODS ==============
    /**
   * Handles `error` event.
   *
   * @param {Error} error* the error object containing `response` property
   * @returns {void}
   * @private
   */ var handleError = (error)=>{
        fire('error', error);
    };
    return {
        handleError: handleError
    };
};
var FileElement = {
    name: 'FileElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'remove',
        'error',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'file',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Object
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        onRemove: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onError: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        view: {
            type: [
                String
            ],
            required: false,
            default: 'file'
        },
        drop: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        accept: {
            required: false,
            type: [
                String,
                Array
            ],
            default: null
        },
        clickable: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        url: {
            required: false,
            type: [
                String,
                Boolean
            ],
            default: '/'
        },
        previewUrl: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        auto: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        urls: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        methods: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        uploadTempEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.uploadTempFile'
        },
        removeTempEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.removeTempFile'
        },
        removeEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.removeFile'
        },
        params: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        softRemove: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        embed: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$r,
            base$Z,
            base$1h,
            file$3,
            base$W,
            base$t,
            base$G,
            base$19,
            base$P,
            file$1,
            base$M,
            file,
            base$q,
            base$u,
            base$s,
            base$14,
            file$2,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            file$4,
            base$J,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$p = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var model = dependencies.model;
    // =============== METHODS ==============
    /**
   * Handles `input` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleInput = (e)=>{
        model.value = e.target.value;
    };
    return {
        handleInput: handleInput
    };
};
var phone$1 = function phone(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var { model, input, el$: el$1 } = dependencies;
    // ============== COMPUTED ==============
    /**
   * Handles `input` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleInput = (e)=>{
        if (el$1.value.maskPluginInstalled) {
            model.value = e.target.value;
            return;
        }
        var startsWithPlus = e.target.value.startsWith('+');
        var value = e.target.value.substr(startsWithPlus ? 1 : 0);
        var numbers = value.match(/\d+/g) || [];
        if (numbers.length || startsWithPlus) value = '+';
        value += numbers.join('');
        input.value.value = value;
        model.value = value;
    };
    return {
        handleInput: handleInput
    };
};
var GenericElement = {
    register: false,
    name: 'GenericElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: '',
            private: true
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            default: undefined
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            generic,
            base$Z,
            base$1h,
            base$T,
            base$W,
            text$1,
            base$19,
            text$2,
            base$P,
            base$M,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$v,
            base$V,
            base$J,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var walkCells = (grid, callback)=>{
    var occupied = [];
    grid.forEach((cols, rowIndex)=>{
        occupied[rowIndex] = occupied[rowIndex] || [];
        var paddedColIndex = 0;
        cols.forEach((cell, colIndex)=>{
            while(occupied[rowIndex][paddedColIndex])paddedColIndex++;
            var field = null;
            var colspan = 1;
            var rowspan = 1;
            if (Array.isArray(cell)) {
                field = cell[0] === undefined ? null : cell[0];
                colspan = cell[1] || 1;
                rowspan = cell[2] || 1;
            }
            var rowStart = rowIndex;
            var colStart = paddedColIndex;
            var rowEnd = rowIndex + rowspan - 1;
            var colEnd = paddedColIndex + colspan - 1;
            callback({
                cell: cell,
                field: field,
                rowspan: rowspan,
                colspan: colspan,
                rowIndex: rowIndex,
                colIndex: colIndex,
                paddedColIndex: paddedColIndex,
                rowStart: rowStart,
                colStart: colStart,
                rowEnd: rowEnd,
                colEnd: colEnd
            });
            // Mark all affected cells as occupied
            for(var r = rowIndex; r <= rowEnd; r++){
                occupied[r] = occupied[r] || [];
                for(var c = paddedColIndex; c <= colEnd; c++)occupied[r][c] = true;
            }
            paddedColIndex += colspan;
        });
    });
};
var base$o = function base(props, context, dependencies) {
    var { grid, align: alignProp, valign: valignProp, presets, cols, rows, name, widths, minWidth, maxWidth } = (0, $8bTPG.toRefs)(props);
    (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * The list of cells that should be displayed in the grid.
   *
   * @type {array}
   */ var cells = (0, $8bTPG.computed)(()=>{
        resolvedRows.value;
        var cells = [];
        walkCells(resolvedRows.value, (_ref)=>{
            var { field, colspan, rowspan, colIndex, rowIndex, rowStart, colStart, rowEnd, colEnd } = _ref;
            cells.push(_objectSpread2$1(_objectSpread2$1({}, field), {}, {
                col: colIndex,
                row: rowIndex,
                colStart: colStart,
                rowStart: rowStart,
                colEnd: colEnd,
                rowEnd: rowEnd,
                style: colspan > 1 || rowspan > 1 ? {
                    'grid-area': "".concat(rowStart + 1, " / ").concat(colStart + 1, " / ").concat(rowEnd + 2, " / ").concat(colEnd + 2)
                } : {}
            }));
        });
        return cells;
    });
    /**
   * The cells that should be displayed in a row format.
   *
   * @type {array}
   */ var resolvedRows = (0, $8bTPG.computed)(()=>{
        var resolvedRows = [];
        var rows = grid.value || [];
        if (!rows || !rows.length) rows = [
            ...Array(rows.value)
        ].map((r)=>[
                ...Array(cols.value)
            ].map((c)=>null));
        rows = rows.map((cols)=>cols.map((cell)=>Array.isArray(cell) ? cell : [
                    cell
                ]));
        rows.forEach((cols, r)=>{
            var resolvedCols = [];
            cols.forEach((_ref2, c)=>{
                var [content, colspan, rowspan, align, valign, attrs] = _ref2;
                var col = {
                    content: content,
                    colspan: colspan || 1,
                    rowspan: rowspan || 1,
                    align: align || alignProp.value,
                    valign: valign || valignProp.value,
                    attrs: attrs || {},
                    row: r,
                    col: c,
                    slot: "cell_".concat(r, "_").concat(c)
                };
                if (content && typeof content === 'object') col = _objectSpread2$1(_objectSpread2$1({}, col), {}, {
                    component: "".concat(upperFirst_1(camelCase_1(content.type)), "Element"),
                    name: content.name || resolveComponentName(r, c),
                    schema: _objectSpread2$1(_objectSpread2$1({}, content), {}, {
                        presets: presets.value
                    })
                });
                resolvedCols.push([
                    col,
                    col.colspan,
                    col.rowspan,
                    col.align
                ]);
            });
            resolvedRows.push(resolvedCols);
        });
        return resolvedRows;
    });
    /**
   * The `style` properties that should be added to the grid's DOM element.
   *
   * @type {object}
   */ var gridStyle = (0, $8bTPG.computed)(()=>{
        var colWidths = [];
        for(var c = 0; c < parseInt(cols.value); c++)colWidths.push(widths.value[c] || '1fr');
        return {
            'grid-template-columns': colWidths.join(' '),
            'grid-template-rows': "repeat(".concat(rows.value, ", auto)"),
            'min-width': typeof minWidth.value === 'number' ? "".concat(minWidth.value, "px") : minWidth.value,
            'max-width': typeof maxWidth.value === 'number' ? maxWidth.value > 0 ? "".concat(maxWidth.value, "px") : undefined : maxWidth.value
        };
    });
    /**
   * Whether the element is in table view (has `grid-table` preset).
   *
   * @type {boolean}
   */ var isTableView = (0, $8bTPG.computed)(()=>{
        return presets.value.includes('grid-table');
    });
    // ============== METHODS ===============
    /**
   * Resolves the cell component name based on row and column index.
   *
   * @returns {string}
   * @param {number} rowIndex* the index of the row
   * @param {number} colIndex* the index of the column
   */ var resolveComponentName = (rowIndex, colIndex)=>{
        return "".concat(name.value, "_").concat(rowIndex, "_").concat(colIndex);
    };
    return {
        cells: cells,
        isTableView: isTableView,
        gridStyle: gridStyle,
        resolvedRows: resolvedRows,
        resolveComponentName: resolveComponentName
    };
};
var base$n = function base(props, context, dependencies) {
    // ================ DATA ================
    /**
   * List of child element components.
   *
   * @type {array}
   * @default [array]
   * @private
   */ var children$Array = (0, $8bTPG.ref)([]);
    // ============== COMPUTED ==============
    /**
   * Child element components.
   *
   * @type {object}
   */ var children$ = (0, $8bTPG.computed)(()=>{
        var children$ = {};
        children$Array.value.forEach((e$)=>{
            children$[e$.name] = e$;
        });
        return children$;
    });
    // =============== METHODS ==============
    return {
        children$Array: children$Array,
        children$: children$
    };
};
var object = function object(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var schemaName = options.schemaName || 'schema';
    var { [schemaName]: schema } = (0, $8bTPG.toRefs)(props);
    var { children$Array, children$ } = base$n();
    // ============== COMPUTED ==============
    /**
   * Schema of child elements.
   *
   * @type {object}
   * @private
   */ var children = (0, $8bTPG.computed)(()=>{
        return schema.value;
    });
    // Resort children$Array when children
    // order changes or a child is removed
    /* istanbul ignore else */ if (schema) (0, $8bTPG.watch)(schema, (newValue)=>{
        var newChildren$Array = [];
        each(newValue, (child, name)=>{
            var child$ = children$Array.value[children$Array.value.map((e$)=>normalize(e$.name)).indexOf(normalize(name))];
            if (child$) newChildren$Array.push(child$);
        });
        children$Array.value = newChildren$Array;
    }, {
        flush: 'post',
        deep: true
    });
    return {
        children: children,
        children$Array: children$Array,
        children$: children$
    };
};
var group = object;
var GridElement = {
    name: 'GridElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'group',
            private: true
        },
        default: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        cols: {
            required: false,
            type: [
                Number
            ],
            default: 1
        },
        rows: {
            required: false,
            type: [
                Number
            ],
            default: 1
        },
        grid: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: 'left'
        },
        valign: {
            required: false,
            type: [
                String
            ],
            default: 'baseline'
        },
        widths: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        minWidth: {
            required: false,
            type: [
                String,
                Number
            ],
            default: 0
        },
        maxWidth: {
            required: false,
            type: [
                String,
                Number
            ],
            default: -1
        },
        scrollable: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        colHeader: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        rowHeader: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            group$6,
            base$Z,
            object$5,
            base$1h,
            grid$1,
            group,
            group$2,
            base$14,
            base$o,
            grid,
            group$5,
            base$17,
            group$8,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            group$1,
            base$V,
            group$4,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var GroupElement = {
    name: 'GroupElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'group',
            private: true
        },
        default: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        schema: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            group$6,
            base$Z,
            object$5,
            base$1h,
            group$7,
            group,
            group$2,
            base$14,
            group$3,
            group$5,
            base$17,
            group$8,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            group$1,
            base$V,
            group$4,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var HiddenElement = {
    name: 'HiddenElement',
    mixins: [
        BaseElement,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'hidden',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        meta: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$Q,
            base$S,
            base$O,
            base$N,
            base$Z,
            base$11,
            base$1h,
            base$T,
            base$G,
            base$19,
            base$H,
            base$P,
            base$M,
            base$E,
            base$J,
            base$Y
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
        return typeof obj;
    };
    else _typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var version = "1.15.6";
function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
    capture: false,
    passive: false
};
function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = getParentOrHost(el));
    }
    return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
        }
    }
}
function css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!IE11OrLess) {
            do if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === getWindowScrollingElement()) break;
        parent = getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function index$1(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
    if (el) do {
        var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return getWindowScrollingElement();
}
function extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle$1(callback, ms) {
    return function() {
        if (!_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            _throttleTimeout = setTimeout(function() {
                _throttleTimeout = void 0;
            }, ms);
        }
    };
}
function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var expando = 'Sortable' + new Date().getTime();
function AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                animationStates.push({
                    target: child,
                    rect: getRect(child)
                });
                var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice(indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                css(target, 'transition', '');
                css(target, 'transform', '');
                var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = repaint(target); // repaint
                css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    css(target, 'transition', '');
                    css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function repaint(target) {
    return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
    initializeByDefault: true
};
var PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in defaults)if (defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = defaults[option];
        plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName](_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            _extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var _excluded = [
    "evt"
];
var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, _excluded);
    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
        dragEl: dragEl,
        parentEl: parentEl,
        ghostEl: ghostEl,
        rootEl: rootEl,
        nextEl: nextEl,
        lastDownEl: lastDownEl,
        cloneEl: cloneEl,
        cloneHidden: cloneHidden,
        dragStarted: moved,
        putSortable: putSortable,
        activeSortable: Sortable.active,
        originalEvent: originalEvent,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        hideGhostForTarget: _hideGhostForTarget,
        unhideGhostForTarget: _unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            _dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
        putSortable: putSortable,
        cloneEl: cloneEl,
        targetEl: dragEl,
        rootEl: rootEl,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex
    }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, // For positioning ghost absolutely
ghostRelativeParent, ghostRelativeParentInitialScroll = [], // (left, top)
_silent = false, savedInputChecked = [];
/** @const */ var documentExists = typeof document !== 'undefined', PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'), supportCssPointerEvents = function() {
    if (!documentExists) return;
    // false when <= IE11
    if (IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), _detectDirection = function _detectDirection(el, options) {
    var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    sortables.some(function(sortable) {
        var threshold = sortable[expando].options.emptyInsertThreshold;
        if (!threshold || lastChild(sortable)) return;
        var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, _prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || _typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, 'display', 'none');
}, _unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if (documentExists && !ChromeForAndroid) document.addEventListener('click', function(evt) {
    if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
    }
}, true);
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[expando]._onDragOver(event);
        }
    }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = _extends({}, options);
    // Export instance
    el[expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return _detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && (!Safari || IOS),
        emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    _prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) on(el, 'pointerdown', this._onTapStart);
    else {
        on(el, 'mousedown', this._onTapStart);
        on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        on(el, 'dragover', this);
        on(el, 'dragenter', this);
    }
    sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */ {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        _saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if (dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if (lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        oldIndex = index$1(target);
        oldDraggableIndex = index$1(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                _dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !dragEl && target.parentNode === el) {
            var dragRect = getRect(target);
            rootEl = el;
            dragEl = target;
            parentEl = dragEl.parentNode;
            nextEl = dragEl.nextSibling;
            lastDownEl = target;
            activeGroup = options.group;
            Sortable.dragged = dragEl;
            tapEvt = {
                target: dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            tapDistanceLeft = tapEvt.clientX - dragRect.left;
            tapDistanceTop = tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if (Sortable.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!FireFox && _this.nativeDraggable) dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                _dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                toggleClass(dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                find(dragEl, criteria.trim(), _disableDraggable);
            });
            on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
            on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
            on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                on(ownerDocument, 'mouseup', _this._onDrop);
                on(ownerDocument, 'touchend', _this._onDrop);
                on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if (FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                dragEl.draggable = true;
            }
            pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                if (Sortable.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        dragEl && _disableDraggable(dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        off(ownerDocument, 'touchend', this._disableDelayedDrag);
        off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) on(document, 'pointermove', this._onTouchMove);
            else if (touch) on(document, 'touchmove', this._onTouchMove);
            else on(document, 'mousemove', this._onTouchMove);
        } else {
            on(dragEl, 'dragend', this);
            on(rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) _nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        awaitingDragStarted = false;
        if (rootEl && dragEl) {
            pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) on(document, 'dragover', _checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && toggleClass(dragEl, options.dragClass, false);
            toggleClass(dragEl, options.ghostClass, true);
            Sortable.active = this;
            fallback && this._appendGhost();
            // Drag start event
            _dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if (touchEvt) {
            this._lastX = touchEvt.clientX;
            this._lastY = touchEvt.clientY;
            _hideGhostForTarget();
            var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            dragEl.parentNode[expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[expando]) {
                    var inserted = void 0;
                    inserted = parent[expando]._onDragOver({
                        clientX: touchEvt.clientX,
                        clientY: touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = getParentOrHost(parent));
            _unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if (tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!Sortable.active && !awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if (ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - (lastDx || 0);
                    ghostMatrix.f += dy - (lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                css(ghostEl, 'webkitTransform', cssMatrix);
                css(ghostEl, 'mozTransform', cssMatrix);
                css(ghostEl, 'msTransform', cssMatrix);
                css(ghostEl, 'transform', cssMatrix);
                lastDx = dx;
                lastDy = dy;
                touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if (PositionGhostAbsolutely) {
                // Get relatively positioned parent
                ghostRelativeParent = container;
                while(css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document)ghostRelativeParent = ghostRelativeParent.parentNode;
                if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                    if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                    rect.top += ghostRelativeParent.scrollTop;
                    rect.left += ghostRelativeParent.scrollLeft;
                } else ghostRelativeParent = getWindowScrollingElement();
                ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
            }
            ghostEl = dragEl.cloneNode(true);
            toggleClass(ghostEl, options.ghostClass, false);
            toggleClass(ghostEl, options.fallbackClass, true);
            toggleClass(ghostEl, options.dragClass, true);
            css(ghostEl, 'transition', '');
            css(ghostEl, 'transform', '');
            css(ghostEl, 'box-sizing', 'border-box');
            css(ghostEl, 'margin', 0);
            css(ghostEl, 'top', rect.top);
            css(ghostEl, 'left', rect.left);
            css(ghostEl, 'width', rect.width);
            css(ghostEl, 'height', rect.height);
            css(ghostEl, 'opacity', '0.8');
            css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
            css(ghostEl, 'zIndex', '100000');
            css(ghostEl, 'pointerEvents', 'none');
            Sortable.ghost = ghostEl;
            container.appendChild(ghostEl);
            // Set transform-origin
            css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        pluginEvent('dragStart', this, {
            evt: evt
        });
        if (Sortable.eventCanceled) {
            this._onDrop();
            return;
        }
        pluginEvent('setupClone', this);
        if (!Sortable.eventCanceled) {
            cloneEl = clone(dragEl);
            cloneEl.removeAttribute("id");
            cloneEl.draggable = false;
            cloneEl.style['will-change'] = '';
            this._hideClone();
            toggleClass(cloneEl, this.options.chosenClass, false);
            Sortable.clone = cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = _nextTick(function() {
            pluginEvent('clone', _this);
            if (Sortable.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) rootEl.insertBefore(cloneEl, dragEl);
            _this._hideClone();
            _dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && toggleClass(dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            off(document, 'mouseup', _this._onDrop);
            off(document, 'touchend', _this._onDrop);
            off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, dragEl);
            }
            on(document, 'drop', _this);
            // #1276 fix:
            css(dragEl, 'transform', 'translateZ(0)');
        }
        awaitingDragStarted = true;
        _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
        on(document, 'selectstart', _this);
        moved = true;
        window.getSelection().removeAllRanges();
        if (Safari) css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if (_silent) return;
        function dragOverEvent(name, extra) {
            pluginEvent(name, _this, _objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    toggleClass(dragEl, options.ghostClass, true);
                }
                if (putSortable !== _this && _this !== Sortable.active) putSortable = _this;
                else if (_this === Sortable.active && putSortable) putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === dragEl && !dragEl.animated || target === el && !target.animated) lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            newIndex = index$1(dragEl);
            newDraggableIndex = index$1(dragEl, options.draggable);
            _dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: newIndex,
                newDraggableIndex: newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if (Sortable.eventCanceled) return completedFired;
        if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl // Reverting item into the original list
        ) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = getRect(dragEl);
            dragOverEvent('dragOverValid');
            if (Sortable.eventCanceled) return completedFired;
            if (revert) {
                parentEl = rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!Sortable.eventCanceled) {
                    if (nextEl) rootEl.insertBefore(dragEl, nextEl);
                    else rootEl.appendChild(dragEl);
                }
                return completed(true);
            }
            var elLastChild = lastChild(el, options.draggable);
            if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore(dragEl, elLastChild.nextSibling);
                    else el.appendChild(dragEl);
                    parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = getChild(el, 0, options, true);
                if (firstChild === dragEl) return completed(false);
                target = firstChild;
                targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore(dragEl, firstChild);
                    parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if (lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    pastFirstInvertThresh = false;
                    isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = index$1(dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = parentEl.children[dragIndex];
                    }while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                lastTarget = target;
                lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    _silent = true;
                    setTimeout(_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild(dragEl);
                    else target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    parentEl = dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains(dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        off(document, 'mousemove', this._onTouchMove);
        off(document, 'touchmove', this._onTouchMove);
        off(document, 'pointermove', this._onTouchMove);
        off(document, 'dragover', nearestEmptyInsertDetectEvent);
        off(document, 'mousemove', nearestEmptyInsertDetectEvent);
        off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, 'mouseup', this._onDrop);
        off(ownerDocument, 'touchend', this._onDrop);
        off(ownerDocument, 'pointerup', this._onDrop);
        off(ownerDocument, 'pointercancel', this._onDrop);
        off(ownerDocument, 'touchcancel', this._onDrop);
        off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        newIndex = index$1(dragEl);
        newDraggableIndex = index$1(dragEl, options.draggable);
        pluginEvent('drop', this, {
            evt: evt
        });
        parentEl = dragEl && dragEl.parentNode;
        // Get again after plugin event
        newIndex = index$1(dragEl);
        newDraggableIndex = index$1(dragEl, options.draggable);
        if (Sortable.eventCanceled) {
            this._nulling();
            return;
        }
        awaitingDragStarted = false;
        isCircumstantialInvert = false;
        pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        _cancelNextTick(this.cloneId);
        _cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            off(document, 'drop', this);
            off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if (Safari) css(document.body, 'user-select', '');
        css(dragEl, 'transform', '');
        if (evt) {
            if (moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') // Remove clone(s)
            cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
            if (dragEl) {
                if (this.nativeDraggable) off(dragEl, 'dragend', this);
                _disableDraggable(dragEl);
                dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if (moved && !awaitingDragStarted) toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                toggleClass(dragEl, this.options.chosenClass, false);
                // Drag stop event
                _dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if (rootEl !== parentEl) {
                    if (newIndex >= 0) {
                        // Add event
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: 'add',
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        _dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: 'sort',
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        _dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: parentEl,
                            originalEvent: evt
                        });
                    }
                    putSortable && putSortable.save();
                } else {
                    if (newIndex !== oldIndex) {
                        if (newIndex >= 0) {
                            // drag & drop within the same list
                            _dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                            _dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if (Sortable.active) {
                    /* jshint eqnull:true */ if (newIndex == null || newIndex === -1) {
                        newIndex = oldIndex;
                        newDraggableIndex = oldDraggableIndex;
                    }
                    _dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        pluginEvent('nulling', this);
        rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
        savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if (dragEl) {
                    this._onDragOver(evt);
                    _globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if (closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if (closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') _prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        pluginEvent('destroy', this);
        var el = this.el;
        el[expando] = null;
        off(el, 'mousedown', this._onTapStart);
        off(el, 'touchstart', this._onTapStart);
        off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            off(el, 'dragover', this);
            off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        sortables.splice(sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!cloneHidden) {
            pluginEvent('hideClone', this);
            if (Sortable.eventCanceled) return;
            css(cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && cloneEl.parentNode) cloneEl.parentNode.removeChild(cloneEl);
            cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if (cloneHidden) {
            pluginEvent('showClone', this);
            if (Sortable.eventCanceled) return;
            // show clone at dragEl or original position
            if (dragEl.parentNode == rootEl && !this.options.group.revertClone) rootEl.insertBefore(cloneEl, dragEl);
            else if (nextEl) rootEl.insertBefore(cloneEl, nextEl);
            else rootEl.appendChild(cloneEl);
            if (this.options.group.revertClone) this.animate(dragEl, cloneEl);
            css(cloneEl, 'display', '');
            cloneHidden = false;
        }
    }
};
function _globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function _disableDraggable(el) {
    el.draggable = false;
}
function _unsilent() {
    _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
    var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            pastFirstInvertThresh = true;
            if (!pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - targetMoveDistance) return -lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return _getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function _getInsertDirection(target) {
    if (index$1(dragEl) < index$1(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && savedInputChecked.push(el);
    }
}
function _nextTick(fn) {
    return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if (documentExists) on(document, 'touchmove', function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
        return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle$1,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index$1,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild,
    expando: expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ Sortable.get = function(element) {
    return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ Sortable.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
        PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ Sortable.create = function(el, options) {
    return new Sortable(el, options);
};
// Export
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) on(document, 'touchmove', this._handleFallbackAutoScroll);
                else on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) off(document, 'dragover', this._handleAutoScroll);
            else {
                off(document, 'pointermove', this._handleFallbackAutoScroll);
                off(document, 'touchmove', this._handleFallbackAutoScroll);
                off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            clearPointerElemChangedInterval();
            clearAutoScrolls();
            cancelThrottle();
        },
        nulling: function nulling() {
            touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
            autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
                autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = getParentAutoScrollElement(elem, true);
                if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                    pointerElemChangedInterval && clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    pointerElemChangedInterval = setInterval(function() {
                        var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            clearAutoScrolls();
                        }
                        autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    lastAutoScrollX = x;
                    lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                    clearAutoScrolls();
                    return;
                }
                autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return _extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function clearAutoScrolls() {
    autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
}
function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle$1(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if (scrollRootEl !== rootEl) {
        scrollRootEl = rootEl;
        clearAutoScrolls();
        scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if (scrollEl === true) scrollEl = getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = scrollEl;
    do {
        var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!autoScrolls[i]) autoScrolls[i] = {};
        }
        if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
            autoScrolls[layersOut].el = el;
            autoScrolls[layersOut].vx = vx;
            autoScrolls[layersOut].vy = vy;
            clearInterval(autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function Revert() {}
Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: drop
};
_extends(Revert, {
    pluginName: 'revertOnSpill'
});
function Remove() {}
Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: drop
};
_extends(Remove, {
    pluginName: 'removeOnSpill'
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
var base$m = function base(props, context, dependencies, options) {
    var { sort } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var el$1 = dependencies.el$;
    var isDisabled = dependencies.isDisabled;
    var fire = dependencies.fire;
    var refreshOrderStore = dependencies.refreshOrderStore;
    var value = dependencies.value;
    var sorting = dependencies.sorting;
    var length = dependencies.length;
    var path = dependencies.path;
    var children$Array = dependencies.children$Array;
    // ================ DATA ================
    /**
   * The DOM element containing list items.
   *
   * @type {HTMLElement}
   * @private
   */ var list = (0, $8bTPG.ref)(null);
    /**
   * The `Sortable.js` instance.
   *
   * @type {object}
   * @private
   */ var sortable = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Whether the list is sortable. Can be enabled with [`sort`](#option-sort) option, but it will disabled if [`isDisabled`](#property-is-disabled) is `true`.
   *
   * @type {boolean}
   */ var isSortable = (0, $8bTPG.computed)(()=>{
        return sort.value && !isDisabled.value && length.value && value.value[0] !== undefined;
    });
    // =============== METHODS ==============
    /**
   * Inits Sortable.js.
   *
   * @returns {void}
   * @private
   */ var initSortable = ()=>{
        sortable.value = new Sortable(list.value, {
            handle: "[data-handle]",
            onStart: /* istanbul ignore next: can not imitate dragging */ ()=>{
                sorting.value = true;
            },
            onEnd: handleSort
        });
    };
    /**
   * Destroys Sortable.js.
   *
   * @returns {void}
   * @private
   */ var destroySortable = ()=>{
        var _sortable$value;
        (_sortable$value = sortable.value) === null || _sortable$value === void 0 || _sortable$value.destroy();
        sortable.value = null;
    };
    /**
   * Handles `sort` event.
   *
   * @param {Event} e* Sortable.js event
   * @returns {void}
   * @private
   */ var handleSort = (_ref)=>{
        var { oldIndex, newIndex, item } = _ref;
        sorting.value = false;
        /* istanbul ignore next: can not imitate dragging */ if (oldIndex === newIndex || isDisabled.value) return;
        list.value.children[newIndex].remove();
        list.value.insertBefore(item, list.value.children[oldIndex]);
        var valueClone = cloneDeep_1(value.value);
        valueClone.splice(newIndex, 0, valueClone.splice(oldIndex, 1)[0]);
        value.value = valueClone;
        refreshOrderStore(value.value);
        fire('sort', value.value, oldIndex, newIndex, children$Array.value[newIndex], el$1.value);
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(isSortable, (n, o)=>{
        /* istanbul ignore else */ if (n === true && o === false) initSortable();
        else if (n === false && o === true) destroySortable();
    }, {
        immediate: false,
        flush: 'post'
    });
    // ================ HOOKS ===============
    (0, $ani5R.onMounted)(()=>{
        if (isSortable.value) initSortable();
    });
    (0, $8bTPG.watch)(length, (n)=>{
        var _sortable$value2;
        if (!isSortable.value) return;
        destroySortable();
        initSortable();
        (_sortable$value2 = sortable.value) === null || _sortable$value2 === void 0 || _sortable$value2.sort(Array.from(Array(n).keys()).reduce((a, b, i)=>{
            a.push("".concat(path.value, "-").concat(i));
            return a;
        }, []));
    }, {
        flush: 'post'
    });
    return {
        list: list,
        sortable: sortable,
        isSortable: isSortable,
        handleSort: handleSort,
        initSortable: initSortable,
        destroySortable: destroySortable
    };
};
var base$l = function base(props, context, dependencies) {
    // ================ DATA ================
    /**
   * Whether the list is currently being sorted (an item is dragged).
   *
   * @type {boolean}
   */ var sorting = (0, $8bTPG.ref)(false);
    return {
        sorting: sorting
    };
};
var base$k = function base(props, context, dependencies, options) {
    var { storeOrder, orderBy, order } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    // ================= DATA ===============
    var orderFrom = (0, $8bTPG.ref)(form$.value.$vueform.config.orderFrom);
    // =============== METHODS ==============
    /**
   * Sets the value of `storeOrder` field within a list of items to match the order.
   *
   * @param {array} value* list of items
   * @returns {void}
   * @private
   */ var refreshOrderStore = (value)=>{
        if (storeOrder.value) each(value, (val, index)=>{
            val[storeOrder.value] = order.value && order.value.toUpperCase() === 'DESC' ? value.length - index - (orderFrom.value == 0 ? 1 : 0) : parseInt(index) + orderFrom.value;
        });
        return value;
    };
    /**
   * The name of the child (when using [`object`](#option-object)) by which the items should be ordered.
   *
   * @type {string}
   */ var orderByName = (0, $8bTPG.computed)(()=>{
        return orderBy.value || storeOrder.value;
    });
    (0, $8bTPG.watch)(storeOrder, (n, o)=>{
        // If storeOrder exists, refresh
        if (n) refreshOrderStore(value.value);
        else each(value.value, (val, index)=>{
            val[o] = null;
        });
    }, {
        immediate: false
    });
    return {
        refreshOrderStore: refreshOrderStore,
        orderByName: orderByName
    };
};
var multifile$2 = function multifile(props, context, dependencies, options) {
    var { storeOrder, orderBy } = (0, $8bTPG.toRefs)(props);
    var { refreshOrderStore } = base$k(props, context, dependencies);
    // =============== METHODS ==============
    /**
   * The name of the field (when using [`fields`](#option-fields)) by which the files should be ordered.
   *
   * @type {string}
   */ var orderByName = (0, $8bTPG.computed)(()=>{
        return orderBy.value || storeOrder.value;
    });
    return {
        refreshOrderStore: refreshOrderStore,
        orderByName: orderByName
    };
};
var base$j = function base(props, context, dependencies) {
    var { object, element } = (0, $8bTPG.toRefs)(props);
    // ============== COMPUTED ==============
    /**
   * The schema of a child element.
   *
   * @type {object}
   * @private
   */ var prototype = (0, $8bTPG.computed)(()=>{
        return isObject.value ? Object.assign({}, object.value, {
            type: 'object'
        }) : element.value || {};
    });
    /**
   * Whether children are objects.
   *
   * @type {boolean}
   * @private
   */ var isObject = (0, $8bTPG.computed)(()=>{
        return !!object.value;
    });
    return {
        prototype: prototype,
        isObject: isObject
    };
};
var multifile$1 = function multifile(props, context, dependencies) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { auto, object, file, fields, storeFile, storeOrder, view, clickable, url, previewUrl, uploadTempEndpoint, removeTempEndpoint, removeEndpoint, params, softRemove } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    // =============== PRIVATE ==============
    var type = (0, $8bTPG.computed)(()=>{
        return options.type || 'file';
    });
    // ============== COMPUTED ==============
    /**
   * The `name` of the child element that stores the filename.
   *
   * @type {string}
   * @private
   */ var storeFileName = (0, $8bTPG.computed)(()=>{
        /* istanbul ignore else */ if (storeFile.value) return storeFile.value;
        //@todo:adam unreachable code, storeFile is never undefined
        /* istanbul ignore next: fields.value is hardcoded {} */ return object.value || keys_1(fields.value).length || storeOrder.value ? 'file' : null;
    });
    var isObject = (0, $8bTPG.computed)(()=>{
        return !!object.value || !!storeOrder.value || !!keys_1(fields.value).length;
    });
    var prototype = (0, $8bTPG.computed)(()=>{
        var fileSchema = {
            type: type.value,
            auto: auto.value,
            view: view.value,
            layout: view.value === 'gallery' ? 'ElementLayoutInline' : 'ElementLayout',
            disabled: isDisabled.value,
            clickable: clickable.value,
            url: url.value,
            previewUrl: previewUrl.value,
            uploadTempEndpoint: uploadTempEndpoint.value,
            removeTempEndpoint: removeTempEndpoint.value,
            removeEndpoint: removeEndpoint.value,
            params: params.value,
            softRemove: softRemove.value
        };
        if (!isObject.value) return Object.assign({}, fileSchema, file.value);
        return {
            type: 'object',
            schema: Object.assign({}, // File
            {
                [storeFileName.value]: Object.assign({}, fileSchema, {
                    embed: true
                }, file.value)
            }, // Order
            storeOrder.value ? {
                [storeOrder.value]: {
                    type: 'hidden',
                    meta: true
                }
            } : {}, // Other fields
            fields.value)
        };
    });
    return {
        storeFileName: storeFileName,
        isObject: isObject,
        prototype: prototype
    };
};
var base$i = function base(props, context, dependencies) {
    var { controls, sort, min, max, addText } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var value = dependencies.value;
    var form$ = dependencies.form$;
    // ================ DATA ================
    /**
   * Whether adding new items is allowed. Will return `false` if the element has [`isDisabled: true`](#property-is-disabled) or have reached [`max`](#option-max) items. Can be disabled manually by setting [`controls.add`](#option-controls) to `false`.
   *
   * @type {boolean}
   */ var hasAdd = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && (controls.value.add || controls.value.add === undefined) && (max.value === -1 || max.value > value.value.length);
    });
    /**
   * Whether remove items is allowed. Will return `false` if the element has [`isDisabled: true`](#property-is-disabled) or has <= [`min`](#option-min) items. Can be disabled manually by setting [`controls.remove`](#option-controls) to `false`.
   *
   * @type {boolean}
   */ var hasRemove = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && (controls.value.remove || controls.value.remove === undefined) && (min.value === -1 || min.value < value.value.length);
    });
    /**
   * Whether list items should be sortable. Can be enabled by setting [`sort`](#option-sort) to `true`, but will return `false` if the element has [`isDisabled: true`](#property-is-disabled).
   *
   * @type {boolean}
   */ var hasSort = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && (controls.value.sort || controls.value.sort === undefined) && sort.value;
    });
    /**
   * The label of add button.
   *
   * @type {string}
   */ var addLabel = (0, $8bTPG.computed)(()=>{
        return addText.value || form$.value.translations.vueform.elements.list.add;
    });
    return {
        hasAdd: hasAdd,
        hasRemove: hasRemove,
        hasSort: hasSort,
        addLabel: addLabel
    };
};
var multifile = function multifile(props, context, dependencies) {
    var { controls, sort } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var hasUploading = dependencies.hasUploading;
    // ================ DATA ================
    /**
   * Whether adding new files is allowed. Will return `false` if the element has [`isDisabled: true`](#property-is-disabled). Can be disabled manually by setting [`controls.add`](#option-controls) to `false`.
   *
   * @type {boolean}
   */ var hasAdd = (0, $8bTPG.computed)(()=>{
        return controls.value.add || controls.value.add === undefined;
    });
    /**
   * Whether remove files is allowed. Will return `false` if the element has [`isDisabled: true`](#property-is-disabled) or a temporary file upload is in progress. Can be disabled manually by setting [`controls.remove`](#option-controls) to `false`.
   *
   * @type {boolean}
   */ var hasRemove = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && (controls.value.remove || controls.value.remove === undefined) && !hasUploading.value;
    });
    /**
   * Whether list files should be sortable. Can be enabled by setting [`sort`](#option-sort) to `true`, but will return `false` if the element has [`isDisabled: true`](#property-is-disabled) or a temporary file upload is in progress.
   *
   * @type {boolean}
   */ var hasSort = (0, $8bTPG.computed)(()=>{
        return !isDisabled.value && (controls.value.sort || controls.value.sort === undefined) && sort.value && !hasUploading.value;
    });
    return {
        hasAdd: hasAdd,
        hasRemove: hasRemove,
        hasSort: hasSort
    };
};
var ListElement = {
    name: 'ListElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'add',
        'remove',
        'sort',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'list',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: undefined
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        onAdd: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onRemove: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSort: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        element: {
            required: false,
            type: [
                Object
            ],
            default: null
        },
        object: {
            required: false,
            type: [
                Object
            ],
            default: null
        },
        initial: {
            required: false,
            type: [
                Number
            ],
            default: 1
        },
        min: {
            required: false,
            type: [
                Number
            ],
            default: -1
        },
        max: {
            required: false,
            type: [
                Number
            ],
            default: -1
        },
        addText: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'locale.elements.list.add'
        },
        sort: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        controls: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({
                    add: true,
                    remove: true,
                    sort: true
                })
        },
        storeOrder: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        order: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        orderBy: {
            required: false,
            type: [
                String
            ],
            default: null
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        //@todo:adam useValue and useDefault should be before useOrder
        context.features = [
            base$X,
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            base$Z,
            array$1,
            base$j,
            base$n,
            base$l,
            base$k,
            base$1h,
            list$4,
            base$W,
            base$G,
            base$14,
            base$N,
            base$17,
            list$5,
            list$1,
            list$3,
            base$i,
            array,
            base$13,
            base$12,
            base$11,
            base$1f,
            base$10,
            list,
            base$m,
            base$V,
            list$2,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$h = function base(props, context, dependencies) {
    var options_ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var { provider, extendOptions } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var value = dependencies.value;
    var clear = dependencies.clear;
    var input = dependencies.input;
    // ============== PRIVATE ===============
    /* istanbul ignore next: private */ var inputElement = ()=>{
        return options_.input ? options_.input.value : input.value;
    };
    // ================ DATA ================
    /**
   * The location service that's initialized once the component is mounted.
   *
   * @type {object|null}
   * @default null
   */ var locationService = (0, $8bTPG.ref)(null);
    /**
   * The raw location object of location provider (Google/Algolia).
   *
   * @type {object}
   * @default null
   */ var location = (0, $8bTPG.ref)({});
    // ============== COMPUTED ==============
    //@todo:adam location `provider` should not be google by default but null
    var locationProvider = (0, $8bTPG.computed)(()=>{
        return provider.value || form$.value.$vueform.config.locationProvider;
    });
    /**
   * Default options for location provider. Can be extended with [`extendOptions`](#option-extend-options).
   *
   * @type {object}
   * @default {}
   */ var defaultOptions = (0, $8bTPG.computed)(()=>{
        var providers = {
            google: {
                fields: [
                    'geometry',
                    'formatted_address',
                    'address_components'
                ]
            },
            algolia: {
                type: 'address',
                appId: form$.value.$vueform.config.services.algolia.app_id,
                apiKey: form$.value.$vueform.config.services.algolia.api_key,
                templates: options_.templates || {}
            }
        };
        return providers[locationProvider.value];
    });
    /**
   * Additional options for [Google Places](https://developers.google.com/maps/documentation/javascript/reference/places-widget#AutocompleteOptions) or [Algolia Places](https://community.algolia.com/places/documentation.html#options) depending on the provider.
   *
   * @type {object}
   * @default {}
   * @option
   */ var providerOptions = (0, $8bTPG.computed)(()=>{
        return Object.assign({}, defaultOptions.value, extendOptions.value || /* istanbul ignore next: failsafe only */ {});
    });
    // =============== METHODS ==============
    /**
   * Handles location service's address change.
   *
   * @param {object} data* an object containing address data
   * @param {object} raw* an object containing raw address data (based on provider)
   * @returns {void}
   * @private
   */ var handleAddressChange = (data, raw)=>{
        /* istanbul ignore next */ if (options_.handleAddressChange) {
            options_.handleAddressChange(data, raw);
            return;
        }
        location.value = raw;
        value.value = data;
    };
    /* istanbul ignore next */ /**
   * Handles the blur event of location element.
   * 
   * @returns {void}
   * @private
   */ var handleLocationBlur = ()=>{
        if (inputElement().value.length) inputElement().value = value.value.formatted_address;
        else clear();
    };
    /**
   * Initializes location service. Can be used to re-initialize location service.
   *
   * @returns {void}
   */ var initLocationService = ()=>{
        if (locationService.value) locationService.value.destroy();
        locationService.value = new form$.value.$vueform.services.location[locationProvider.value]();
        locationService.value.init(inputElement(), handleAddressChange, providerOptions.value);
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)([
        locationProvider,
        providerOptions
    ], ()=>{
        initLocationService();
    }, {
        deep: true,
        immediate: false
    });
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        initLocationService();
    });
    return {
        locationService: locationService,
        location: location,
        defaultOptions: defaultOptions,
        providerOptions: providerOptions,
        handleAddressChange: handleAddressChange,
        handleLocationBlur: handleLocationBlur,
        initLocationService: initLocationService
    };
};
var LocationElement = {
    name: 'LocationElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'location',
            private: true
        },
        default: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({
                    country: null,
                    country_code: null,
                    state: null,
                    state_code: null,
                    city: null,
                    zip: null,
                    address: null,
                    formatted_address: null,
                    lat: null,
                    lng: null
                })
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        provider: {
            required: false,
            type: [
                String
            ],
            default: 'google'
        },
        displayKey: {
            required: false,
            type: [
                String
            ],
            default: 'formatted_address'
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            location$2,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            base$G,
            base$P,
            location,
            base$19,
            base$M,
            base$E,
            base$h,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$v,
            base$V,
            location$1,
            base$Y,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, location$3(props, context));
    }
};
var base$g = function base(props, context, dependencies) {
    var { rows, cols, inputType, minWidth, addText, hideRows, items, maxWidth, rowWrap, templateColumns, hideCols, colWrap, gap, canRemove, canAdd, min, max, presets, name } = (0, $8bTPG.toRefs)(props);
    var { el$: el$1, form$, path, hasDynamicRows, resolvedRows, resolvedColumns, rowsCount, value, genericName, isDisabled, isReadonly, defaultValue } = dependencies;
    (0, $ani5R.inject)('config$');
    // ================ DATA ================
    /**
   * The HTML element of the matrix grix.
   * 
   * @type {HTMLElement}
   */ var grid = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    /**
   * Whether rows can be added when rows are dynamic.
   * 
   * @type {boolean}
   */ var allowAdd = (0, $8bTPG.computed)(()=>{
        return hasDynamicRows.value && canAdd.value && (max.value === -1 || max.value > Object.keys(value.value).length);
    });
    /**
   * Whether rows can be removed when rows are dynamic.
   * 
   * @type {boolean}
   */ var allowRemove = (0, $8bTPG.computed)(()=>{
        return hasDynamicRows.value && canRemove.value && (min.value === -1 || min.value < Object.keys(value.value).length);
    });
    /**
   * The label of add button.
   *
   * @type {string}
   */ var addLabel = (0, $8bTPG.computed)(()=>{
        return addText.value || form$.value.translations.vueform.elements.list.add;
    });
    /**
   * Whether row labels should be displayed.
   * 
   * @type {boolean}
   */ var rowsVisible = (0, $8bTPG.computed)(()=>{
        if (hasDynamicRows.value) return false;
        return !hideRows.value;
    });
    /**
   * Whether column headers should be displayed.
   * 
   * @type {boolean}
   */ var colsVisible = (0, $8bTPG.computed)(()=>{
        return !hideCols.value;
    });
    var gridStyle = (0, $8bTPG.computed)(()=>{
        var gridTemplateColumns = templateColumns.value;
        if (typeof templateColumns.value === 'function') gridTemplateColumns = templateColumns.value(el$1.value);
        if (!gridTemplateColumns) {
            gridTemplateColumns = [];
            // Row label column
            if (rowsVisible.value) gridTemplateColumns.push("minmax(min-content, auto)");
            // Cells
            var _min = resolveWidth(minWidth.value, 'min-content');
            var _max = resolveWidth(maxWidth.value, '1fr');
            el$1.value.resolvedColumns.filter((c)=>c.available).forEach((col, i)=>{
                var colMin = resolveWidth(col.minWidth, _min);
                var colMax = resolveWidth(col.maxWidth, _max);
                gridTemplateColumns.push("minmax(".concat(colMin, ", ").concat(colMax, ")"));
            });
            // Remove column
            if (allowRemove.value) gridTemplateColumns.push("minmax(max-content, max-content)");
            gridTemplateColumns = gridTemplateColumns.join(' ');
        }
        return {
            'grid-template-columns': gridTemplateColumns,
            'gap': gap.value !== 0 ? typeof gap.value === 'number' ? "".concat(gap.value, "px") : gap.value : undefined
        };
    });
    /**
   * The component props of the cells.
   * 
   * @type {array}
   */ var cells = (0, $8bTPG.computed)(()=>{
        var rows = [];
        resolvedRows.value.forEach((row, r)=>{
            var cols = [];
            resolvedColumns.value.forEach((col, c)=>{
                cols.push(resolveComponentProps(row, col, r, c));
            });
            rows.push(cols);
        });
        return rows;
    });
    /**
   * The array of cell input types.
   * 
   * @type {array}
   */ var inputTypes = (0, $8bTPG.computed)(()=>{
        return resolvedColumns.value.map((col, c)=>resolveComponentProps({}, col, 0, c)).reduce((prev, curr)=>[
                ...prev,
                curr.type
            ], []);
    });
    // =============== METHODS ==============
    /**
   * Resolves the `width` property to either `px` or plain value,
   *
   * @returns {string}
   * @param {number|string} width* the width to be resolved
   * @param {number|string} def* the default value to be used if width is `undefined`
   * @private
   */ var resolveWidth = (width, def)=>{
        return typeof width === 'number' ? "".concat(width, "px") : width !== undefined ? width : def;
    };
    /**
   * Resolves the cell component type (for `:is`) based on a column object.
   *
   * @returns {string}
   * @param {object} column* the column definition object
   */ var resolveComponentType = (column)=>{
        var element = column.inputType || inputType.value;
        var type = typeof element === 'string' ? element : element.type;
        return "".concat(upperFirst_1(camelCase_1(type)), "Element");
    };
    /**
   * Resolves the cell component name based on row and column index.
   *
   * @returns {string}
   * @param {number} rowIndex* the index of the row
   * @param {number} colIndex* the index of the column
   */ var resolveComponentName = (rowIndex, colIndex)=>{
        return "".concat(path.value.replace(/\./g, '__'), "_").concat(rowIndex, "_").concat(colIndex);
    };
    /**
   * Resolves the cell component properties.
   *
   * @returns {object}
   * @param {object} row* the row definition object
   * @param {object} col* the column definition object
   * @param {number} rowIndex* the index of the row
   * @param {number} colIndex* the index of the column
   */ var resolveComponentProps = (row, col, rowIndex, colIndex)=>{
        var _col$inputType, _inputType$value, _props$items, _col$items;
        var type = resolveColInputType(col);
        var props = {
            fieldName: "".concat(genericName.value, " / ").concat(hasDynamicRows.value ? "#".concat(row.label + 1) : row.label, " / ").concat(col.label),
            displayErrors: false,
            disabled: isDisabled.value,
            readonly: isReadonly.value,
            presets: presets.value
        };
        if (row.conditions || col.conditions) props.conditions = resolveColConditions(row, col);
        switch(type){
            case 'radio':
                props.radioValue = true;
                props.radioName = props.name;
                props.standalone = true;
                break;
            case 'checkbox':
            case 'toggle':
                props.standalone = true;
                break;
            case 'textarea':
                props.rows = 1;
                break;
            case 'select':
            case 'checkboxgroup':
            case 'radiogroup':
                props.items = items.value;
                break;
            case 'tags':
            case 'multiselect':
                props.items = items.value;
                props.closeOnSelect = false;
                props.appendToBody = true;
                props.search = true;
                break;
            default:
                props = _objectSpread2$1(_objectSpread2$1({}, props), resolveColProps(col));
                var _presets = (col === null || col === void 0 || (_col$inputType = col.inputType) === null || _col$inputType === void 0 ? void 0 : _col$inputType.presets) || ((_inputType$value = inputType.value) === null || _inputType$value === void 0 ? void 0 : _inputType$value.presets) || [];
                if (_presets.length) props.presets.push(..._presets);
                if (props.items && !((_props$items = props.items) !== null && _props$items !== void 0 && _props$items.length)) props.items = items.value;
                if ([
                    'radio',
                    'checkbox',
                    'toggle'
                ].includes(props.type)) props.standalone = true;
                if ([
                    'select',
                    'multiselect',
                    'tags'
                ].includes(props.type)) props.appendToBody = true;
                if ([
                    'multiselect',
                    'tags'
                ].includes(props.type)) props.closeOnSelect = false;
        }
        if (items.value.length && !props.items) props.items = items.value;
        if ((_col$items = col.items) !== null && _col$items !== void 0 && _col$items.length && !props.items) props.items = col.items;
        props.name = resolveComponentName(rowIndex, colIndex);
        return props;
    };
    /**
   * Returns the style of a colum based on its index.
   *
   * @returns {object}
   * @param {object} index* the index of the column
   */ var getColStyle = (index)=>{
        var _resolvedColumns$valu;
        if (!index) return;
        var col = ((_resolvedColumns$valu = resolvedColumns.value) === null || _resolvedColumns$valu === void 0 ? void 0 : _resolvedColumns$valu[index - 1]) || {};
        var minW = (col === null || col === void 0 ? void 0 : col.minWidth) || minWidth.value || 0;
        var maxW = (col === null || col === void 0 ? void 0 : col.maxWidth) || maxWidth.value || 0;
        var style = {};
        if (minW) style.minWidth = "".concat(minW, "px");
        if (maxW) style.maxWidth = "".concat(maxW, "px");
        return style;
    };
    /**
   * Resolves the input type of a column.
   *
   * @returns {object|string}
   * @param {object} col* the column definition object
   */ var resolveColInputType = (col)=>{
        return col.inputType || inputType.value;
    };
    /**
   * Resolves the type of the input field of a column.
   *
   * @returns {string}
   * @param {object} col* the column definition object
   */ var resolveColType = (col)=>{
        var _inputType$value2;
        if (col.inputType) {
            var _col$inputType2;
            return ((_col$inputType2 = col.inputType) === null || _col$inputType2 === void 0 ? void 0 : _col$inputType2.type) || col.inputType;
        }
        return ((_inputType$value2 = inputType.value) === null || _inputType$value2 === void 0 ? void 0 : _inputType$value2.type) || inputType.value;
    };
    /**
   * Resolves the properties of the input type if any.
   *
   * @returns {object}
   * @param {object} col* the column definition object
   * @private
   */ var resolveColProps = (col)=>{
        var type = resolveColInputType(col);
        return typeof type === 'object' ? type : {};
    };
    /**
   * Resolves the conditions of a cell based on row and column.
   *
   * @returns {object}
   * @param {object} row* the row definition object
   * @param {object} col* the column definition object
   */ var resolveColConditions = (row, col)=>{
        return [
            ...row.conditions || [],
            ...col.conditions || []
        ];
    };
    (0, $8bTPG.watch)([
        inputType,
        inputTypes
    ], (n, o)=>{
        if (isEqual_1(n[0], o[0]) && isEqual_1(n[1], o[1])) return;
        value.value = cloneDeep_1(defaultValue.value);
    }, {
        flush: 'pre'
    });
    return {
        grid: grid,
        resolveComponentType: resolveComponentType,
        resolveComponentProps: resolveComponentProps,
        resolveComponentName: resolveComponentName,
        getColStyle: getColStyle,
        resolveColInputType: resolveColInputType,
        resolveColConditions: resolveColConditions,
        addLabel: addLabel,
        gridStyle: gridStyle,
        rowsVisible: rowsVisible,
        colsVisible: colsVisible,
        resolveColType: resolveColType,
        allowAdd: allowAdd,
        allowRemove: allowRemove,
        cells: cells,
        inputTypes: inputTypes
    };
};
var base$f = function base(props, context, dependencies) {
    var { rows, cols, inputType } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES =============
    var { form$, el$: el$1, path } = dependencies;
    // =============== INJECTS ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ================ DATA =================
    /**
   * The instances of cells.
   *
   * @type {object}
   */ var cells$ = (0, $8bTPG.ref)({});
    /**
   * The count of current rows when rows are dynamic.
   *
   * @type {number}
   */ var rowsCount = (0, $8bTPG.ref)(typeof rows.value === 'number' ? rows.value : null);
    // =============== COMPUTED ==============
    /**
   * The data structure type of the matrix. Can be: `assoc`, `array` or `object`.
   *
   * @type {array}
   */ var dataType = (0, $8bTPG.computed)(()=>{
        var _inputType$value;
        var type = ((_inputType$value = inputType.value) === null || _inputType$value === void 0 ? void 0 : _inputType$value.type) || inputType.value;
        var assocTypes = [
            'radio'
        ];
        var arrayTypes = [
            'checkbox',
            'toggle'
        ];
        if (resolvedColumns.value.every((c)=>{
            var _c$inputType;
            return assocTypes.includes(((_c$inputType = c.inputType) === null || _c$inputType === void 0 ? void 0 : _c$inputType.type) || c.inputType || type);
        })) return 'assoc';
        if (resolvedColumns.value.every((c)=>{
            var _c$inputType2;
            return arrayTypes.includes(((_c$inputType2 = c.inputType) === null || _c$inputType2 === void 0 ? void 0 : _c$inputType2.type) || c.inputType || type);
        })) return 'array';
        return 'object';
    });
    /**
   * The value of `rows` or `rowsCount` if rows are dynamic.
   *
   * @type {number|array}
   */ var computedRows = (0, $8bTPG.computed)(()=>{
        return typeof rows.value === 'number' ? rowsCount.value === null ? 1 : rowsCount.value : rows.value;
    });
    /**
   * The rows of the matrix to be displayed.
   * 
   * @type {array}
   */ var resolvedRows = (0, $8bTPG.computed)(()=>{
        var resolvedRows = computedRows.value;
        if (typeof resolvedRows === 'number') resolvedRows = [
            ...Array(resolvedRows)
        ].map((r, i)=>({
                value: i,
                label: i
            }));
        if (resolvedRows && typeof resolvedRows === 'object' && !Array.isArray(resolvedRows)) resolvedRows = Object.keys(resolvedRows).map((key)=>({
                value: [
                    key
                ],
                label: resolvedRows[key]
            }));
        return resolvedRows.map((row)=>{
            return typeof row === 'string' || typeof row === 'number' ? {
                value: row,
                label: row
            } : row;
        }).map((r)=>_objectSpread2$1(_objectSpread2$1({}, r), {}, {
                label: localize(r.label, config$.value, form$.value)
            })).map((r)=>_objectSpread2$1(_objectSpread2$1({}, r), {}, {
                available: !r.conditions || !r.conditions.some((condition)=>!form$.value.$vueform.services.condition.check(condition, path.value, form$.value, el$1.value))
            }));
    });
    /**
   * The columns of the matrix to be displayed.
   * 
   * @type {array}
   */ var resolvedColumns = (0, $8bTPG.computed)(()=>{
        var resolvedColumns = cols.value;
        if (cols.value && typeof cols.value === 'object' && !Array.isArray(cols.value)) resolvedColumns = Object.keys(cols.value).map((key)=>({
                value: [
                    key
                ],
                label: cols.value[key]
            }));
        return resolvedColumns.map((col)=>{
            return typeof col === 'string' || typeof col === 'number' ? {
                value: col,
                label: col
            } : col;
        }).map((r)=>_objectSpread2$1(_objectSpread2$1({}, r), {}, {
                label: localize(r.label, config$.value, form$.value)
            })).map((r)=>_objectSpread2$1(_objectSpread2$1({}, r), {}, {
                available: !r.conditions || !r.conditions.some((condition)=>!form$.value.$vueform.services.condition.check(condition, path.value, form$.value, el$1.value))
            }));
    });
    /**
   * Whether the matrix has dynamic rows.
   * 
   * @type {boolean}
   */ var hasDynamicRows = (0, $8bTPG.computed)(()=>{
        return typeof rows.value === 'number';
    });
    // ============== WEATCHERS ==============
    (0, $8bTPG.watch)(rows, (n, o)=>{
        if (typeof n !== 'number') rowsCount.value = null;
        else rowsCount.value = n;
    }, {
        flush: 'pre'
    });
    return {
        hasDynamicRows: hasDynamicRows,
        computedRows: computedRows,
        resolvedRows: resolvedRows,
        resolvedColumns: resolvedColumns,
        rowsCount: rowsCount,
        dataType: dataType,
        cells$: cells$
    };
};
var MatrixElement = {
    name: 'MatrixElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'add',
        'remove',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'object',
            private: true
        },
        default: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        inputType: {
            required: false,
            type: [
                String,
                Object
            ],
            default: 'radio'
        },
        items: {
            // done
            required: false,
            type: [
                Array,
                Object,
                String,
                Function
            ],
            default: ()=>[]
        },
        cols: {
            // done
            required: false,
            type: [
                Array,
                Object
            ],
            default: ()=>[]
        },
        colWrap: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        hideCols: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        stickyCols: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        rows: {
            // done
            required: false,
            type: [
                Array,
                Object,
                Number
            ],
            default: 1
        },
        rowWrap: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        hideRows: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        stickyRows: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        min: {
            // done
            required: false,
            type: [
                Number,
                String
            ],
            default: -1
        },
        max: {
            // done
            required: false,
            type: [
                Number,
                String
            ],
            default: -1
        },
        canAdd: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        canRemove: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        addText: {
            // done
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'locale.elements.list.add'
        },
        minWidth: {
            // done
            required: false,
            type: [
                Number,
                String
            ],
            default: 'min-content'
        },
        maxWidth: {
            // done
            required: false,
            type: [
                Number,
                String
            ],
            default: '1fr'
        },
        gap: {
            // done
            required: false,
            type: [
                String,
                Number
            ],
            default: 16
        },
        padding: {
            // done
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        scrollable: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        templateColumns: {
            // done
            required: false,
            type: [
                String,
                Function
            ],
            default: null
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            base$Z,
            base$1h,
            matrix$5,
            base$f,
            object$5,
            matrix$2,
            matrix$4,
            base$14,
            base$N,
            base$W,
            base$F,
            base$g,
            object,
            base$17,
            object$8,
            matrix$3,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            matrix$1,
            base$V,
            object$4,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$e = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var isDisabled = dependencies.isDisabled;
    var add = dependencies.add;
    var input = dependencies.input;
    var isObject = dependencies.isObject;
    var storeFileName = dependencies.storeFileName;
    var children$ = dependencies.children$;
    // ============== COMPUTED ==============
    /**
   * Whether any of the files are currently being uploaded to the server (initiated by form submit).
   *
   * @type {boolean}
   */ var preparing = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            available: true,
            preparing: true
        });
    });
    /**
   * Whether any of the files are currently being uploaded to the server (initiated by the user).
   *
   * @type {boolean}
   */ var hasUploading = (0, $8bTPG.computed)(()=>{
        return some_1(children$.value, {
            uploading: true
        });
    });
    // =============== METHODS ==============
    /**
   * Handles `change` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleChange = (e)=>{
        if (!e.target || !e.target.files || e.target.files.length == 0 || isDisabled.value) return;
        each(e.target.files, (file)=>{
            add(isObject.value ? {
                [storeFileName.value]: file
            } : file);
        });
        input.value.value = '';
    };
    /**
   * Handles `click` event.
   *
   * @returns {void}
   * @private
   */ var handleClick = ()=>{
        if (isDisabled.value) return;
        input.value.click();
    };
    return {
        preparing: preparing,
        hasUploading: hasUploading,
        handleChange: handleChange,
        handleClick: handleClick
    };
};
var MultifileElement = {
    name: 'MultifileElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'add',
        'remove',
        'sort',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'multifile',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        initial: {
            required: false,
            type: [
                Number
            ],
            default: 0,
            private: true
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        onAdd: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onRemove: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSort: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        view: {
            type: [
                String
            ],
            required: false,
            default: 'file'
        },
        drop: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        sort: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        controls: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({
                    add: true,
                    remove: true,
                    sort: true
                })
        },
        object: {
            required: false,
            type: [
                Boolean
            ],
            default: null
        },
        storeFile: {
            required: false,
            type: [
                String
            ],
            default: 'file'
        },
        fields: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        storeOrder: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        order: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        orderBy: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        file: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        accept: {
            required: false,
            type: [
                String,
                Array
            ],
            default: null
        },
        clickable: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        url: {
            required: false,
            type: [
                String,
                Boolean
            ],
            default: '/'
        },
        previewUrl: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        auto: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        uploadTempEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.uploadTempFile'
        },
        removeTempEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.removeTempFile'
        },
        removeEndpoint: {
            required: false,
            type: [
                Object,
                String,
                Function,
                Boolean,
                Promise
            ],
            default: undefined,
            '@default': 'config.endpoints.removeFile'
        },
        params: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        softRemove: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            base$W,
            array$1,
            base$n,
            base$Q,
            base$l,
            multifile$1,
            base$Z,
            base$1h,
            list$4,
            base$G,
            base$14,
            base$N,
            list$1,
            base$P,
            array,
            base$17,
            base$19,
            base$13,
            base$12,
            base$11,
            base$10,
            multifile$2,
            multifile$4,
            base$e,
            multifile,
            multifile$3,
            base$1f,
            base$m,
            base$V,
            multifile$5,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$d = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fire = dependencies.fire;
    var el$1 = dependencies.el$;
    // =============== METHODS ==============
    /**
   * Handles `select` event.
   *
   * @param {object} option* the selected option object
   * @returns {void}
   * @private
   */ var handleSelect = (option)=>{
        fire('select', option, el$1.value);
    };
    /**
   * Handles `deselect` event.
   *
   * @param {object} option* the deselected option object
   * @returns {void}
   * @private
   */ var handleDeselect = (option)=>{
        fire('deselect', option, el$1.value);
    };
    /**
   * Handles `search-change` event.
   *
   * @param {string} searchQuery* the current search query
   * @returns {void}
   * @private
   */ var handleSearchChange = (searchQuery)=>{
        fire('search-change', searchQuery, el$1.value);
    };
    /**
   * Handles `open` event.
   *
   * @returns {void}
   * @private
   */ var handleOpen = ()=>{
        fire('open', el$1.value);
    };
    /**
   * Handles `close` event.
   *
   * @returns {void}
   * @private
   */ var handleClose = ()=>{
        fire('close', el$1.value);
    };
    /**
   * Handles `clear` event.
   *
   * @returns {void}
   * @private
   */ var handleClear = ()=>{
        fire('clear', el$1.value);
    };
    /**
   * Handles `paste` event.
   *
   * @param {Event} e event
   * @returns {void}
   * @private
   */ var handlePaste = (e)=>{
        fire('paste', e, el$1.value);
    };
    /**
   * Handles `tag` event.
   *
   * @param {string} searchQuery* the current search query
   * @returns {void}
   * @private
   */ /* istanbul ignore next: unimplemented */ var handleTag = (searchQuery)=>{
    // unimplemented
    };
    // =============== HOOKS ================
    return {
        handleSelect: handleSelect,
        handleDeselect: handleDeselect,
        handleSearchChange: handleSearchChange,
        handleOpen: handleOpen,
        handleClose: handleClose,
        handleClear: handleClear,
        handlePaste: handlePaste,
        handleTag: handleTag
    };
};
function spliceMultiple(array, indexes) {
    indexes.sort();
    for(var i = indexes.length - 1; i >= 0; i--)array.splice(indexes[i], 1);
    return array;
}
var base$c = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    // =============== PRIVATE ==============
    /**
   * Whether an option is already selected.
   *
   * @param {object} option* value of the option
   * @returns {boolean}
   * @private
   */ var inValue = (option)=>{
        return value.value.indexOf(option) !== -1;
    };
    // =============== METHODS ==============
    /**
   * Selects one or more options.
   *
   * @param {string|array} options* value(s) of the option(s) to select
   * @returns {void}
   */ var select = (options)=>{
        if (!isArray_1(options)) options = [
            options
        ];
        var val = clone_1(value.value);
        each(options, (option)=>{
            if (inValue(normalize(option))) return;
            val.push(option);
        });
        value.value = val;
    };
    /**
   * Deselects one or more options.
   *
   * @param {string|array} options* value(s) of the option(s) to deselect
   * @returns {void}
   */ var deselect = (options)=>{
        if (!isArray_1(options)) options = [
            options
        ];
        var val = clone_1(value.value);
        var indexes = [];
        each(options, (option)=>{
            var i = value.value.indexOf(option);
            if (i === -1 || indexes.indexOf(i) !== -1) return;
            indexes.push(i);
        });
        value.value = spliceMultiple(val, indexes);
    };
    return {
        select: select,
        deselect: deselect
    };
};
var MultiselectElement = {
    name: 'MultiselectElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'select',
        'deselect',
        'search-change',
        'open',
        'close',
        'clear',
        'paste',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'multiselect',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null,
            native: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        onSelect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onDeselect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSearchChange: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onOpen: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClose: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClear: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onPaste: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        native: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        items: {
            required: false,
            type: [
                Object,
                Array,
                Function,
                String
            ],
            localized: true,
            default: ()=>({})
        },
        labelProp: {
            type: [
                String
            ],
            required: false,
            default: 'label',
            native: false
        },
        valueProp: {
            type: [
                String
            ],
            required: false,
            default: 'value',
            native: false
        },
        dataKey: {
            type: [
                String
            ],
            required: false,
            default: undefined
        },
        searchParam: {
            type: [
                String
            ],
            required: false,
            default: 'query'
        },
        search: {
            required: false,
            type: [
                Boolean
            ],
            default: false,
            native: false
        },
        trackBy: {
            type: [
                String,
                Array
            ],
            required: false,
            default: 'label',
            native: false
        },
        strict: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        multipleLabel: {
            type: [
                Function
            ],
            required: false,
            native: false
        },
        multipleLabelSingle: {
            type: [
                String
            ],
            required: false,
            native: false,
            '@default': 'locale.vueform.multiselect.multipleLabelOne'
        },
        multipleLabelMultiple: {
            type: [
                String
            ],
            required: false,
            native: false,
            '@default': 'locale.vueform.multiselect.multipleLabelMore'
        },
        create: {
            required: false,
            type: [
                Boolean
            ],
            default: false,
            native: false
        },
        appendNewOption: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        addOptionOn: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[
                    'enter'
                ],
            native: false
        },
        allowAbsent: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        object: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        limit: {
            type: [
                Number
            ],
            required: false,
            default: -1,
            native: false
        },
        max: {
            type: [
                Number
            ],
            required: false,
            default: -1,
            native: false
        },
        groups: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        groupLabel: {
            type: [
                String
            ],
            required: false,
            default: 'label',
            native: false
        },
        groupOptions: {
            type: [
                String
            ],
            required: false,
            default: 'items',
            native: false
        },
        groupHideEmpty: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        groupSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        openDirection: {
            type: [
                String
            ],
            required: false,
            default: 'bottom',
            native: false
        },
        appendToBody: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        appendTo: {
            type: [
                String
            ],
            required: false,
            default: undefined,
            native: false
        },
        canClear: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        clearOnSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        closeOnSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        closeOnDeselect: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        clearOnRefetch: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        delay: {
            type: [
                Number
            ],
            required: false,
            default: -1,
            native: false
        },
        minChars: {
            type: [
                Number
            ],
            required: false,
            default: 0,
            native: false
        },
        resolveOnLoad: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        filterResults: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        clearOnSearch: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        hideSelected: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        caret: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        noOptionsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noOptions',
            localized: true,
            native: false
        },
        noResultsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noResults',
            localized: true,
            native: false
        },
        autocomplete: {
            type: [
                String
            ],
            required: false,
            native: false
        },
        inputType: {
            type: [
                String
            ],
            required: false,
            default: 'text',
            native: false
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            multiselect$4,
            base$S,
            array$1,
            base$Z,
            base$K,
            base$1h,
            multiselect$5,
            base$W,
            base$G,
            base$H,
            base$L,
            multiselect$1,
            base$P,
            multiselect$2,
            base$19,
            array,
            multiselect$3,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$d,
            base$c,
            multiselect,
            base$V,
            base$J,
            base$Y,
            base$w
        ];
        context.slots = [
            'option',
            'multiple-label',
            'placeholder',
            'group-label',
            'before-list',
            'after-list',
            'no-results',
            'no-options',
            'caret',
            'spinner',
            'clear',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var ObjectElement = {
    name: 'ObjectElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'remove',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'object',
            private: true
        },
        default: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        schema: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        embed: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        onRemove: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            base$Z,
            object$5,
            base$1h,
            object$7,
            object$2,
            object$6,
            base$14,
            object,
            base$17,
            object$8,
            object$3,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            object$1,
            base$V,
            object$4,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$b = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fire = dependencies.fire;
    var el$1 = dependencies.el$;
    // =============== METHODS ==============
    /**
   * Handles `blur` event.
   *
   * @returns {void}
   * @private
   */ var handleBlur = ()=>{
        fire('blur', el$1.value);
    };
    /**
   * Handles `focus` event.
   *
   * @returns {void}
   * @private
   */ var handleFocus = ()=>{
        fire('focus', el$1.value);
    };
    return {
        handleBlur: handleBlur,
        handleFocus: handleFocus
    };
};
const us = '{+}0 (000) 000-0000';
var countryPhones = [
    {
        // "country": "Afghanistan",
        "c": "AF",
        "n": "+93",
        "p": 0,
        "m": [
            [
                "93",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Albania",
        "c": "AL",
        "n": "+355",
        "p": 1,
        "m": [
            [
                "3554",
                "{+}000 0 000 0000"
            ],
            [
                "355",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Algeria",
        "c": "DZ",
        "n": "+213",
        "p": 2,
        "m": [
            [
                "2131",
                "{+}000 0 000 0000"
            ],
            [
                "2132",
                "{+}000 0 000 0000"
            ],
            [
                "2133",
                "{+}000 0 000 0000"
            ],
            [
                "2134",
                "{+}000 0 000 0000"
            ],
            [
                "213",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "American Samoa",
        "c": "AS",
        "n": "+1",
        "p": 3,
        "m": [
            [
                "1684",
                us
            ]
        ]
    },
    {
        // "country": "Andorra",
        "c": "AD",
        "n": "+376",
        "p": 4,
        "m": [
            [
                "376",
                "{+}000 000 000"
            ]
        ]
    },
    {
        // "country": "Angola",
        "c": "AO",
        "n": "+244",
        "p": 5,
        "m": [
            [
                "2449",
                "{+}000 000 000 0000"
            ],
            [
                "244",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Anguilla",
        "c": "AI",
        "n": "+1",
        "p": 6,
        "m": [
            [
                "1264",
                us
            ]
        ]
    },
    {
        // "country": "Antigua & Barbuda",
        "c": "AG",
        "n": "+1",
        "p": 7,
        "m": [
            [
                "1268",
                us
            ]
        ]
    },
    {
        // "country": "Argentina",
        "c": "AR",
        "n": "+54",
        "p": 8,
        "m": [
            [
                "549",
                "{+}00 0 000 000 0000"
            ],
            [
                "54",
                "{+}00 000 000 0000"
            ]
        ]
    },
    {
        // "country": "Armenia",
        "c": "AM",
        "n": "+374",
        "p": 9,
        "m": [
            [
                "37493",
                "{+}000 00 000 000"
            ],
            [
                "37494",
                "{+}000 00 000 000"
            ],
            [
                "37498",
                "{+}000 00 000 000"
            ],
            [
                "37477",
                "{+}000 00 000 000"
            ],
            [
                "37491",
                "{+}000 00 000 000"
            ],
            [
                "37496",
                "{+}000 00 000 000"
            ],
            [
                "37499",
                "{+}000 00 000 000"
            ],
            [
                "37455",
                "{+}000 00 000 000"
            ],
            [
                "37495",
                "{+}000 00 000 000"
            ],
            [
                "37441",
                "{+}000 00 000 000"
            ],
            [
                "374",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Aruba",
        "c": "AW",
        "n": "+297",
        "p": 10,
        "m": [
            [
                "297",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Ascension Island",
        "c": "AC",
        "n": "+247",
        "p": 11,
        "m": [
            [
                "247",
                "{+}000 0000"
            ]
        ]
    },
    {
        // "country": "Australia",
        "c": "AU",
        "n": "+61",
        "p": 12,
        "m": [
            [
                "61",
                "{+}00 0 0000 0000"
            ],
            [
                "614",
                "{+}00 000 000 000"
            ]
        ]
    },
    {
        // "country": "Austria",
        "c": "AT",
        "n": "+43",
        "p": 13,
        "m": [
            [
                "43",
                "{+}00 0000000[0000]"
            ]
        ]
    },
    {
        // "country": "Azerbaijan",
        "c": "AZ",
        "n": "+994",
        "p": 14,
        "m": [
            [
                "9944",
                "{+}000 00 000 000"
            ],
            [
                "9945",
                "{+}000 00 000 000"
            ],
            [
                "9946",
                "{+}000 00 000 000"
            ],
            [
                "9947",
                "{+}000 00 000 000"
            ],
            [
                "994",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Bahamas",
        "c": "BS",
        "n": "+1",
        "p": 15,
        "m": [
            [
                "1242",
                us
            ]
        ]
    },
    {
        // "country": "Bahrain",
        "c": "BH",
        "n": "+973",
        "p": 16,
        "m": [
            [
                "973",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Bangladesh",
        "c": "BD",
        "n": "+880",
        "p": 17,
        "m": [
            [
                "8801",
                "{+}000 00 0000 0000"
            ],
            [
                "880",
                "{+}000 00 0000 0000[00]"
            ]
        ]
    },
    {
        // "country": "Barbados",
        "c": "BB",
        "n": "+1",
        "p": 18,
        "m": [
            [
                "1246",
                us
            ]
        ]
    },
    {
        // "country": "Belarus",
        "c": "BY",
        "n": "+375",
        "p": 19,
        "m": [
            [
                "375",
                "{+}000 000000000[0]"
            ]
        ]
    },
    {
        // "country": "Belgium",
        "c": "BE",
        "n": "+32",
        "p": 20,
        "m": [
            [
                "324",
                "{+}00 000 00 00 00"
            ],
            [
                "32",
                "{+}00 0 000 00 00"
            ]
        ]
    },
    {
        // "country": "Belize",
        "c": "BZ",
        "n": "+501",
        "p": 21,
        "m": [
            [
                "501",
                "{+}000 000-0000"
            ]
        ]
    },
    {
        // "country": "Benin",
        "c": "BJ",
        "n": "+229",
        "p": 22,
        "m": [
            [
                "229",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Bermuda",
        "c": "BM",
        "n": "+1",
        "p": 23,
        "m": [
            [
                "1441",
                us
            ]
        ]
    },
    {
        // "country": "Bhutan",
        "c": "BT",
        "n": "+975",
        "p": 24,
        "m": [
            [
                "97517",
                "{+}000 00 000000"
            ],
            [
                "975",
                "{+}000 0 00000[0]"
            ]
        ]
    },
    {
        // "country": "Bolivia",
        "c": "BO",
        "n": "+591",
        "p": 25,
        "m": [
            [
                "5916",
                "{+}000 000 000 0000"
            ],
            [
                "5917",
                "{+}000 000 000 0000"
            ],
            [
                "591",
                "{+}000 0 000 0000[0]"
            ]
        ]
    },
    {
        // "country": "Bosnia & Herzegovina",
        "c": "BA",
        "n": "+387",
        "p": 26,
        "m": [
            [
                "3876",
                "{+}000 00 000 000"
            ],
            [
                "387",
                "{+}000 00 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Botswana",
        "c": "BW",
        "n": "+267",
        "p": 27,
        "m": [
            [
                "2677",
                "{+}000 00 000 0000"
            ],
            [
                "267",
                "{+}000 000 000000"
            ]
        ]
    },
    {
        // "country": "Brazil",
        "c": "BR",
        "n": "+55",
        "p": 28,
        "m": [
            [
                "55",
                "{+}00 00 0000 0000[0]"
            ]
        ]
    },
    {
        // "country": "British Indian Ocean Territory",
        "c": "IO",
        "n": "+246",
        "p": 29,
        "m": [
            [
                "246",
                "{+}000 0000"
            ]
        ]
    },
    {
        // "country": "British Virgin Islands",
        "c": "VG",
        "n": "+1",
        "p": 30,
        "m": [
            [
                "1284",
                us
            ]
        ]
    },
    {
        // "country": "Brunei",
        "c": "BN",
        "n": "+673",
        "p": 31,
        "m": [
            [
                "673",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Bulgaria",
        "c": "BG",
        "n": "+359",
        "p": 32,
        "m": [
            [
                "3598",
                "{+}000 00 000 0000"
            ],
            [
                "3599",
                "{+}000 00 000 0000"
            ],
            [
                "359",
                "{+}000 0000000[000]"
            ]
        ]
    },
    {
        // "country": "Burkina Faso",
        "c": "BF",
        "n": "+226",
        "p": 33,
        "m": [
            [
                "226",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Burundi",
        "c": "BI",
        "n": "+257",
        "p": 34,
        "m": [
            [
                "257",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Cambodia",
        "c": "KH",
        "n": "+855",
        "p": 35,
        "m": [
            [
                "855",
                "{+}000 000000000"
            ]
        ]
    },
    {
        // "country": "Cameroon",
        "c": "CM",
        "n": "+237",
        "p": 36,
        "m": [
            [
                "237",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Canada",
        "c": "CA",
        "n": "+1",
        "p": 37,
        "m": [
            [
                "1204",
                us
            ],
            [
                "1226",
                us
            ],
            [
                "1236",
                us
            ],
            [
                "1249",
                us
            ],
            [
                "1250",
                us
            ],
            [
                "1263",
                us
            ],
            [
                "1289",
                us
            ],
            [
                "1306",
                us
            ],
            [
                "1343",
                us
            ],
            [
                "1354",
                us
            ],
            [
                "1365",
                us
            ],
            [
                "1367",
                us
            ],
            [
                "1368",
                us
            ],
            [
                "1403",
                us
            ],
            [
                "1416",
                us
            ],
            [
                "1418",
                us
            ],
            [
                "1431",
                us
            ],
            [
                "1437",
                us
            ],
            [
                "1438",
                us
            ],
            [
                "1450",
                us
            ],
            [
                "1468",
                us
            ],
            [
                "1474",
                us
            ],
            [
                "1506",
                us
            ],
            [
                "1514",
                us
            ],
            [
                "1519",
                us
            ],
            [
                "1548",
                us
            ],
            [
                "1579",
                us
            ],
            [
                "1581",
                us
            ],
            [
                "1584",
                us
            ],
            [
                "1587",
                us
            ],
            [
                "1604",
                us
            ],
            [
                "1613",
                us
            ],
            [
                "1639",
                us
            ],
            [
                "1647",
                us
            ],
            [
                "1672",
                us
            ],
            [
                "1683",
                us
            ],
            [
                "1705",
                us
            ],
            [
                "1709",
                us
            ],
            [
                "1742",
                us
            ],
            [
                "1753",
                us
            ],
            [
                "1778",
                us
            ],
            [
                "1780",
                us
            ],
            [
                "1782",
                us
            ],
            [
                "1807",
                us
            ],
            [
                "1819",
                us
            ],
            [
                "1825",
                us
            ],
            [
                "1867",
                us
            ],
            [
                "1873",
                us
            ],
            [
                "1902",
                us
            ],
            [
                "1905",
                us
            ]
        ]
    },
    {
        // "country": "Cape Verde",
        "c": "CV",
        "n": "+238",
        "p": 38,
        "m": [
            [
                "238",
                "{+}000 0000 000"
            ]
        ]
    },
    {
        // "country": "Caribbean Netherlands",
        "c": "BQ",
        "n": "+599",
        "p": 39,
        "m": [
            [
                "599",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Cayman Islands",
        "c": "KY",
        "n": "+1",
        "p": 40,
        "m": [
            [
                "1345",
                us
            ]
        ]
    },
    {
        // "country": "Central African Republic",
        "c": "CF",
        "n": "+236",
        "p": 41,
        "m": [
            [
                "236",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Chad",
        "c": "TD",
        "n": "+235",
        "p": 42,
        "m": [
            [
                "235",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Chile",
        "c": "CL",
        "n": "+56",
        "p": 43,
        "m": [
            [
                "562",
                "{+}00 0 0000 0000"
            ],
            [
                "569",
                "{+}00 0 0000 0000"
            ],
            [
                "56",
                "{+}00 00 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "China",
        "c": "CN",
        "n": "+86",
        "p": 44,
        "m": [
            [
                "8613",
                "{+}00 000 0000 0000"
            ],
            [
                "8615",
                "{+}00 000 0000 0000"
            ],
            [
                "8618",
                "{+}00 000 0000 0000"
            ],
            [
                "86",
                "{+}00 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Colombia",
        "c": "CO",
        "n": "+57",
        "p": 45,
        "m": [
            [
                "573",
                "{+}00 000 000 0000"
            ],
            [
                "57",
                "{+}00 0 000 0000"
            ]
        ]
    },
    {
        // "country": "Comoros",
        "c": "KM",
        "n": "+269",
        "p": 46,
        "m": [
            [
                "269",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Congo - Brazzaville",
        "c": "CG",
        "n": "+242",
        "p": 47,
        "m": [
            [
                "242",
                "{+}000 00 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Congo - Kinshasa",
        "c": "CD",
        "n": "+243",
        "p": 48,
        "m": [
            [
                "243",
                "{+}000 00 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Cook Islands",
        "c": "CK",
        "n": "+682",
        "p": 49,
        "m": [
            [
                "682",
                "{+}000 00 000"
            ]
        ]
    },
    {
        // "country": "Costa Rica",
        "c": "CR",
        "n": "+506",
        "p": 50,
        "m": [
            [
                "506",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Côte d’Ivoire",
        "c": "CI",
        "n": "+225",
        "p": 51,
        "m": [
            [
                "225",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Croatia",
        "c": "HR",
        "n": "+385",
        "p": 52,
        "m": [
            [
                "385",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Cuba",
        "c": "CU",
        "n": "+53",
        "p": 53,
        "m": [
            [
                "535",
                "{+}00 0 000 0000"
            ],
            [
                "53",
                "{+}00 000000[0000]"
            ]
        ]
    },
    {
        // "country": "Curaçao",
        "c": "CW",
        "n": "+599",
        "p": 54,
        "m": [
            [
                "5999",
                "{+}000 0 000 0000"
            ]
        ]
    },
    {
        // "country": "Cyprus",
        "c": "CY",
        "n": "+357",
        "p": 55,
        "m": [
            [
                "357",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Czechia",
        "c": "CZ",
        "n": "+420",
        "p": 56,
        "m": [
            [
                "4206",
                "{+}000 000 000 000"
            ],
            [
                "4207",
                "{+}000 000 000 000"
            ],
            [
                "420",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Denmark",
        "c": "DK",
        "n": "+45",
        "p": 57,
        "m": [
            [
                "45",
                "{+}00 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Djibouti",
        "c": "DJ",
        "n": "+253",
        "p": 58,
        "m": [
            [
                "253",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Dominica",
        "c": "DM",
        "n": "+1",
        "p": 59,
        "m": [
            [
                "1767",
                us
            ]
        ]
    },
    {
        // "country": "Dominican Republic",
        "c": "DO",
        "n": "+1",
        "p": 60,
        "m": [
            [
                "1809",
                us
            ],
            [
                "1829",
                us
            ],
            [
                "1849",
                us
            ]
        ]
    },
    {
        // "country": "Ecuador",
        "c": "EC",
        "n": "+593",
        "p": 61,
        "m": [
            [
                "593",
                "{+}000 00 0000 000"
            ]
        ]
    },
    {
        // "country": "Egypt",
        "c": "EG",
        "n": "+20",
        "p": 62,
        "m": [
            [
                "2010",
                "{+}00 000 0000 000"
            ],
            [
                "2011",
                "{+}00 000 0000 000"
            ],
            [
                "2012",
                "{+}00 000 0000 000"
            ],
            [
                "2014",
                "{+}00 000 0000 000"
            ],
            [
                "2016",
                "{+}00 000 0000 000"
            ],
            [
                "202",
                "{+}00 0 0000 0000"
            ],
            [
                "203",
                "{+}00 0 0000 0000"
            ],
            [
                "20",
                "{+}00 000 0000 000"
            ]
        ]
    },
    {
        // "country": "El Salvador",
        "c": "SV",
        "n": "+503",
        "p": 63,
        "m": [
            [
                "503",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Equatorial Guinea",
        "c": "GQ",
        "n": "+240",
        "p": 64,
        "m": [
            [
                "240",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Eritrea",
        "c": "ER",
        "n": "+291",
        "p": 65,
        "m": [
            [
                "291",
                "{+}000 0 000 000"
            ]
        ]
    },
    {
        // "country": "Estonia",
        "c": "EE",
        "n": "+372",
        "p": 66,
        "m": [
            [
                "372",
                "{+}000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Eswatini",
        "c": "SZ",
        "n": "+268",
        "p": 67,
        "m": [
            [
                "268",
                "{+}000 00 00 0000"
            ]
        ]
    },
    {
        // "country": "Ethiopia",
        "c": "ET",
        "n": "+251",
        "p": 68,
        "m": [
            [
                "2519",
                "{+}000 000 000 000"
            ],
            [
                "251",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Falkland Islands (Islas Malvinas)",
        "c": "FK",
        "n": "+500",
        "p": 69,
        "m": [
            [
                "500",
                "{+}000 00000"
            ]
        ]
    },
    {
        // "country": "Faroe Islands",
        "c": "FO",
        "n": "+298",
        "p": 70,
        "m": [
            [
                "298",
                "{+}000 000 000"
            ]
        ]
    },
    {
        // "country": "Fiji",
        "c": "FJ",
        "n": "+679",
        "p": 71,
        "m": [
            [
                "679",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Finland",
        "c": "FI",
        "n": "+358",
        "p": 72,
        "m": [
            [
                "358",
                "{+}000 0000[0000000]"
            ]
        ]
    },
    {
        // "country": "France",
        "c": "FR",
        "n": "+33",
        "p": 73,
        "m": [
            [
                "33",
                "{+}00 000 000 000"
            ]
        ]
    },
    {
        // "country": "French Guiana",
        "c": "GF",
        "n": "+594",
        "p": 74,
        "m": [
            [
                "594",
                "{+}000 000 00 00 00"
            ]
        ]
    },
    {
        // "country": "French Polynesia",
        "c": "PF",
        "n": "+689",
        "p": 75,
        "m": [
            [
                "689",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Gabon",
        "c": "GA",
        "n": "+241",
        "p": 76,
        "m": [
            [
                "24106",
                "{+}000 000 00 00 00"
            ],
            [
                "24107",
                "{+}000 000 00 00 00"
            ],
            [
                "241",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Gambia",
        "c": "GM",
        "n": "+220",
        "p": 77,
        "m": [
            [
                "220",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Georgia",
        "c": "GE",
        "n": "+995",
        "p": 78,
        "m": [
            [
                "99532",
                "{+}000 00 000 0000"
            ],
            [
                "995",
                "{+}000 000 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Germany",
        "c": "DE",
        "n": "+49",
        "p": 79,
        "m": [
            [
                "4930",
                "{+}00 00 0000 0000"
            ],
            [
                "4989",
                "{+}00 00 0000 0000"
            ],
            [
                "49",
                "{+}00 000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Ghana",
        "c": "GH",
        "n": "+233",
        "p": 80,
        "m": [
            [
                "233",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Gibraltar",
        "c": "GI",
        "n": "+350",
        "p": 81,
        "m": [
            [
                "350",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Greece",
        "c": "GR",
        "n": "+30",
        "p": 82,
        "m": [
            [
                "3069",
                "{+}00 000 0000 000"
            ],
            [
                "30",
                "{+}00 000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Greenland",
        "c": "GL",
        "n": "+299",
        "p": 83,
        "m": [
            [
                "299",
                "{+}000 00 00 00"
            ]
        ]
    },
    {
        // "country": "Grenada",
        "c": "GD",
        "n": "+1",
        "p": 84,
        "m": [
            [
                "1473",
                us
            ]
        ]
    },
    {
        // "country": "Guadeloupe",
        "c": "GP",
        "n": "+590",
        "p": 85,
        "m": [
            [
                "590",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Guam",
        "c": "GU",
        "n": "+1",
        "p": 86,
        "m": [
            [
                "1671",
                us
            ]
        ]
    },
    {
        // "country": "Guatemala",
        "c": "GT",
        "n": "+502",
        "p": 87,
        "m": [
            [
                "502",
                "{+}000 000 00000"
            ]
        ]
    },
    {
        // "country": "Guinea",
        "c": "GN",
        "n": "+224",
        "p": 88,
        "m": [
            [
                "224",
                "{+}000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Guinea-Bissau",
        "c": "GW",
        "n": "+245",
        "p": 89,
        "m": [
            [
                "245",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Guyana",
        "c": "GY",
        "n": "+592",
        "p": 90,
        "m": [
            [
                "592",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Haiti",
        "c": "HT",
        "n": "+509",
        "p": 91,
        "m": [
            [
                "509",
                "{+}000 00 00 0000"
            ]
        ]
    },
    {
        // "country": "Honduras",
        "c": "HN",
        "n": "+504",
        "p": 92,
        "m": [
            [
                "504",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Hong Kong",
        "c": "HK",
        "n": "+852",
        "p": 93,
        "m": [
            [
                "852",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Hungary",
        "c": "HU",
        "n": "+36",
        "p": 94,
        "m": [
            [
                "361",
                "{+}00 0 000 0000"
            ],
            [
                "3620",
                "{+}00 00 000 0000"
            ],
            [
                "3630",
                "{+}00 00 000 0000"
            ],
            [
                "3670",
                "{+}00 00 000 0000"
            ],
            [
                "36",
                "{+}00 00 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Iceland",
        "c": "IS",
        "n": "+354",
        "p": 95,
        "m": [
            [
                "354",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "India",
        "c": "IN",
        "n": "+91",
        "p": 96,
        "m": [
            [
                "916",
                "{+}00 000 000 0000"
            ],
            [
                "917",
                "{+}00 000 000 0000"
            ],
            [
                "918",
                "{+}00 000 000 0000"
            ],
            [
                "919",
                "{+}00 000 000 0000"
            ],
            [
                "91",
                "{+}00 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Indonesia",
        "c": "ID",
        "n": "+62",
        "p": 97,
        "m": [
            [
                "62361",
                "{+}00 000 000 000"
            ],
            [
                "6221",
                "{+}00 00 0000 0000"
            ],
            [
                "628",
                "{+}00 000 0000 0000"
            ],
            [
                "62",
                "{+}00 00000[000000]"
            ]
        ]
    },
    {
        // "country": "Iran",
        "c": "IR",
        "n": "+98",
        "p": 98,
        "m": [
            [
                "98921",
                "{+}00 00 000 0000"
            ],
            [
                "98951",
                "{+}00 00 000 0000"
            ],
            [
                "989",
                "{+}00 000 000 0000"
            ],
            [
                "98",
                "{+}00 00000000[00]"
            ]
        ]
    },
    {
        // "country": "Iraq",
        "c": "IQ",
        "n": "+964",
        "p": 99,
        "m": [
            [
                "9641",
                "{+}000 0 000 0000[0]"
            ],
            [
                "9647",
                "{+}000 000 000 0000"
            ],
            [
                "964",
                "{+}000 000000[0000]"
            ]
        ]
    },
    {
        // "country": "Ireland",
        "c": "IE",
        "n": "+353",
        "p": 100,
        "m": [
            [
                "3531",
                "{+}000 0 000 0000"
            ],
            [
                "353",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Israel",
        "c": "IL",
        "n": "+972",
        "p": 101,
        "m": [
            [
                "9725",
                "{+}000 00 000 0000"
            ],
            [
                "9727",
                "{+}000 00 000 0000"
            ],
            [
                "972",
                "{+}000 0 000 0000"
            ]
        ]
    },
    {
        // "country": "Italy",
        "c": "IT",
        "n": "+39",
        "p": 102,
        "m": [
            [
                "393",
                "{+}00 000 000 0000"
            ],
            [
                "39",
                "{+}00 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Jamaica",
        "c": "JM",
        "n": "+1",
        "p": 103,
        "m": [
            [
                "1876",
                us
            ]
        ]
    },
    {
        // "country": "Japan",
        "c": "JP",
        "n": "+81",
        "p": 104,
        "m": [
            [
                "8170",
                "{+}00 00 0000 0000"
            ],
            [
                "8180",
                "{+}00 00 0000 0000"
            ],
            [
                "8190",
                "{+}00 00 0000 0000"
            ],
            [
                "81",
                "{+}00 0 0000 0000"
            ]
        ]
    },
    {
        // "country": "Jordan",
        "c": "JO",
        "n": "+962",
        "p": 105,
        "m": [
            [
                "9627",
                "{+}000 000 000 000"
            ],
            [
                "962",
                "{+}000 0 000 0000"
            ]
        ]
    },
    {
        // "country": "Kazakhstan",
        "c": "KZ",
        "n": "+7",
        "p": 106,
        "m": [
            [
                "77",
                "{+}0 000 000 0000"
            ]
        ]
    },
    {
        // "country": "Kenya",
        "c": "KE",
        "n": "+254",
        "p": 107,
        "m": [
            [
                "2541",
                "{+}000 000 000 000"
            ],
            [
                "2547",
                "{+}000 000 000 000"
            ],
            [
                "254",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Kiribati",
        "c": "KI",
        "n": "+686",
        "p": 108,
        "m": [
            [
                "686",
                "{+}000 00 000"
            ]
        ]
    },
    {
        // "country": "Kosovo",
        "c": "XK",
        "n": "+383",
        "p": 109,
        "m": [
            [
                "383",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Kuwait",
        "c": "KW",
        "n": "+965",
        "p": 110,
        "m": [
            [
                "9655",
                "{+}000 000 00000"
            ],
            [
                "9656",
                "{+}000 000 00000"
            ],
            [
                "9659",
                "{+}000 000 00000"
            ],
            [
                "965",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Kyrgyzstan",
        "c": "KG",
        "n": "+996",
        "p": 111,
        "m": [
            [
                "996",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Laos",
        "c": "LA",
        "n": "+856",
        "p": 112,
        "m": [
            [
                "85620",
                "{+}000 00 0000 0000"
            ],
            [
                "85630",
                "{+}000 00 0000 0000"
            ],
            [
                "856",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Latvia",
        "c": "LV",
        "n": "+371",
        "p": 113,
        "m": [
            [
                "3715",
                "{+}000 0 00 00000"
            ],
            [
                "3716",
                "{+}000 0 00 00000"
            ],
            [
                "3717",
                "{+}000 0 00 00000"
            ],
            [
                "371",
                "{+}000 000 00 000"
            ]
        ]
    },
    {
        // "country": "Lebanon",
        "c": "LB",
        "n": "+961",
        "p": 114,
        "m": [
            [
                "96170",
                "{+}000 00 000 000"
            ],
            [
                "96171",
                "{+}000 00 000 000"
            ],
            [
                "96180",
                "{+}000 00 000 000"
            ],
            [
                "96181",
                "{+}000 00 000 000"
            ],
            [
                "96190",
                "{+}000 00 000 000"
            ],
            [
                "96191",
                "{+}000 00 000 000"
            ],
            [
                "961",
                "{+}000 0 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Lesotho",
        "c": "LS",
        "n": "+266",
        "p": 115,
        "m": [
            [
                "266",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Liberia",
        "c": "LR",
        "n": "+231",
        "p": 116,
        "m": [
            [
                "231",
                "{+}000 000000[0000]"
            ]
        ]
    },
    {
        // "country": "Libya",
        "c": "LY",
        "n": "+218",
        "p": 117,
        "m": [
            [
                "218",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Liechtenstein",
        "c": "LI",
        "n": "+423",
        "p": 118,
        "m": [
            [
                "42323",
                "{+}000 00 00000"
            ],
            [
                "42375",
                "{+}000 00 00000"
            ],
            [
                "423",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Lithuania",
        "c": "LT",
        "n": "+370",
        "p": 119,
        "m": [
            [
                "370",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Luxembourg",
        "c": "LU",
        "n": "+352",
        "p": 120,
        "m": [
            [
                "352",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Macao",
        "c": "MO",
        "n": "+853",
        "p": 121,
        "m": [
            [
                "8536",
                "{+}000 000 0000[0]"
            ],
            [
                "853",
                "{+}000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Madagascar",
        "c": "MG",
        "n": "+261",
        "p": 122,
        "m": [
            [
                "261",
                "{+}000 00 00 00000"
            ]
        ]
    },
    {
        // "country": "Malawi",
        "c": "MW",
        "n": "+265",
        "p": 123,
        "m": [
            [
                "265",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Malaysia",
        "c": "MY",
        "n": "+60",
        "p": 124,
        "m": [
            [
                "60",
                "{+}00 0000000[000]"
            ]
        ]
    },
    {
        // "country": "Maldives",
        "c": "MV",
        "n": "+960",
        "p": 125,
        "m": [
            [
                "960",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Mali",
        "c": "ML",
        "n": "+223",
        "p": 126,
        "m": [
            [
                "223",
                "{+}000 00 00 0000"
            ]
        ]
    },
    {
        // "country": "Malta",
        "c": "MT",
        "n": "+356",
        "p": 127,
        "m": [
            [
                "356",
                "{+}000 0000 000[0]"
            ]
        ]
    },
    {
        // "country": "Marshall Islands",
        "c": "MH",
        "n": "+692",
        "p": 128,
        "m": [
            [
                "692",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Martinique",
        "c": "MQ",
        "n": "+596",
        "p": 129,
        "m": [
            [
                "596",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Mauritania",
        "c": "MR",
        "n": "+222",
        "p": 130,
        "m": [
            [
                "222",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Mauritius",
        "c": "MU",
        "n": "+230",
        "p": 131,
        "m": [
            [
                "230",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Mexico",
        "c": "MX",
        "n": "+52",
        "p": 132,
        "m": [
            [
                "52",
                "{+}00 000 000 0000"
            ]
        ]
    },
    {
        // "country": "Micronesia",
        "c": "FM",
        "n": "+691",
        "p": 133,
        "m": [
            [
                "691",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Moldova",
        "c": "MD",
        "n": "+373",
        "p": 134,
        "m": [
            [
                "373",
                "{+}000 000 00 000"
            ]
        ]
    },
    {
        // "country": "Monaco",
        "c": "MC",
        "n": "+377",
        "p": 135,
        "m": [
            [
                "377",
                "{+}000 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Mongolia",
        "c": "MN",
        "n": "+976",
        "p": 136,
        "m": [
            [
                "976",
                "{+}000 00 00 0000"
            ]
        ]
    },
    {
        // "country": "Montenegro",
        "c": "ME",
        "n": "+382",
        "p": 137,
        "m": [
            [
                "382",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Montserrat",
        "c": "MS",
        "n": "+1",
        "p": 138,
        "m": [
            [
                "1664",
                us
            ]
        ]
    },
    {
        // "country": "Morocco",
        "c": "MA",
        "n": "+212",
        "p": 139,
        "m": [
            [
                "212",
                "{+}000 00 000 0000[0]"
            ]
        ]
    },
    {
        // "country": "Mozambique",
        "c": "MZ",
        "n": "+258",
        "p": 140,
        "m": [
            [
                "258",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Myanmar (Burma)",
        "c": "MM",
        "n": "+95",
        "p": 141,
        "m": [
            [
                "95",
                "{+}00 0000000[0000]"
            ]
        ]
    },
    {
        // "country": "Namibia",
        "c": "NA",
        "n": "+264",
        "p": 142,
        "m": [
            [
                "264",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Nauru",
        "c": "NR",
        "n": "+674",
        "p": 143,
        "m": [
            [
                "674",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Nepal",
        "c": "NP",
        "n": "+977",
        "p": 144,
        "m": [
            [
                "977",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Netherlands",
        "c": "NL",
        "n": "+31",
        "p": 145,
        "m": [
            [
                "31",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "New Caledonia",
        "c": "NC",
        "n": "+687",
        "p": 146,
        "m": [
            [
                "687",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "New Zealand",
        "c": "NZ",
        "n": "+64",
        "p": 147,
        "m": [
            [
                "642",
                "{+}00 000 000 000"
            ],
            [
                "64",
                "{+}00 0 000 0000"
            ]
        ]
    },
    {
        // "country": "Nicaragua",
        "c": "NI",
        "n": "+505",
        "p": 148,
        "m": [
            [
                "505",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Niger",
        "c": "NE",
        "n": "+227",
        "p": 149,
        "m": [
            [
                "227",
                "{+}000 00000000[000]"
            ]
        ]
    },
    {
        // "country": "Nigeria",
        "c": "NG",
        "n": "+234",
        "p": 150,
        "m": [
            [
                "234",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Niue",
        "c": "NU",
        "n": "+683",
        "p": 151,
        "m": [
            [
                "683",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Norfolk Island",
        "c": "NF",
        "n": "+672",
        "p": 152,
        "m": [
            [
                "672",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "North Korea",
        "c": "KP",
        "n": "+850",
        "p": 153,
        "m": [
            [
                "850",
                "{+}000 000000[0000000]"
            ]
        ]
    },
    {
        // "country": "North Macedonia",
        "c": "MK",
        "n": "+389",
        "p": 154,
        "m": [
            [
                "389",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Northern Mariana Islands",
        "c": "MP",
        "n": "+1",
        "p": 155,
        "m": [
            [
                "1670",
                us
            ]
        ]
    },
    {
        // "country": "Norway",
        "c": "NO",
        "n": "+47",
        "p": 156,
        "m": [
            [
                "47",
                "{+}00 00 00 00 00"
            ]
        ]
    },
    {
        // "country": "Oman",
        "c": "OM",
        "n": "+968",
        "p": 157,
        "m": [
            [
                "968",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Pakistan",
        "c": "PK",
        "n": "+92",
        "p": 158,
        "m": [
            [
                "923",
                "{+}00 000 0000 000"
            ],
            [
                "92",
                "{+}00 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Palau",
        "c": "PW",
        "n": "+680",
        "p": 159,
        "m": [
            [
                "680",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Palestine",
        "c": "PS",
        "n": "+970",
        "p": 160,
        "m": [
            [
                "970",
                "{+}000 000000[000000]"
            ]
        ]
    },
    {
        // "country": "Panama",
        "c": "PA",
        "n": "+507",
        "p": 161,
        "m": [
            [
                "507",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Papua New Guinea",
        "c": "PG",
        "n": "+675",
        "p": 162,
        "m": [
            [
                "675",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Paraguay",
        "c": "PY",
        "n": "+595",
        "p": 163,
        "m": [
            [
                "595",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Peru",
        "c": "PE",
        "n": "+51",
        "p": 164,
        "m": [
            [
                "51",
                "{+}00 00 000 000"
            ]
        ]
    },
    {
        // "country": "Philippines",
        "c": "PH",
        "n": "+63",
        "p": 165,
        "m": [
            [
                "639",
                "{+}00 000 000 0000"
            ],
            [
                "63",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Poland",
        "c": "PL",
        "n": "+48",
        "p": 166,
        "m": [
            [
                "485",
                "{+}00 000 000 000"
            ],
            [
                "48",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Portugal",
        "c": "PT",
        "n": "+351",
        "p": 167,
        "m": [
            [
                "351",
                "{+}000 000 000 000"
            ]
        ]
    },
    {
        // "country": "Puerto Rico",
        "c": "PR",
        "n": "+1",
        "p": 168,
        "m": [
            [
                "1787",
                us
            ],
            [
                "1939",
                us
            ]
        ]
    },
    {
        // "country": "Qatar",
        "c": "QA",
        "n": "+974",
        "p": 169,
        "m": [
            [
                "974",
                "{+}000 0000 0000"
            ]
        ]
    },
    {
        // "country": "Réunion",
        "c": "RE",
        "n": "+262",
        "p": 170,
        "m": [
            [
                "262",
                "{+}000 00000 0000"
            ]
        ]
    },
    {
        // "country": "Romania",
        "c": "RO",
        "n": "+40",
        "p": 171,
        "m": [
            [
                "407",
                "{+}00 000 000 000"
            ],
            [
                "40",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Russia",
        "c": "RU",
        "n": "+7",
        "p": 172,
        "m": [
            [
                "7",
                "{+}0 000 000 00 00"
            ]
        ]
    },
    {
        // "country": "Rwanda",
        "c": "RW",
        "n": "+250",
        "p": 173,
        "m": [
            [
                "250",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Samoa",
        "c": "WS",
        "n": "+685",
        "p": 174,
        "m": [
            [
                "685",
                "{+}000 00 0000"
            ]
        ]
    },
    {
        // "country": "San Marino",
        "c": "SM",
        "n": "+378",
        "p": 175,
        "m": [
            [
                "378",
                "{+}000 0000 000000"
            ]
        ]
    },
    {
        // "country": "São Tomé & Príncipe",
        "c": "ST",
        "n": "+239",
        "p": 176,
        "m": [
            [
                "239",
                "{+}000 00 00 00"
            ]
        ]
    },
    {
        // "country": "Saudi Arabia",
        "c": "SA",
        "n": "+966",
        "p": 177,
        "m": [
            [
                "96657",
                "{+}000 000 00 0000"
            ],
            [
                "966",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Senegal",
        "c": "SN",
        "n": "+221",
        "p": 178,
        "m": [
            [
                "221",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Serbia",
        "c": "RS",
        "n": "+381",
        "p": 179,
        "m": [
            [
                "3816",
                "{+}000 000 000 000"
            ],
            [
                "3817",
                "{+}000 000 000 000"
            ],
            [
                "381",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Seychelles",
        "c": "SC",
        "n": "+248",
        "p": 180,
        "m": [
            [
                "248",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Sierra Leone",
        "c": "SL",
        "n": "+232",
        "p": 181,
        "m": [
            [
                "232",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Singapore",
        "c": "SG",
        "n": "+65",
        "p": 182,
        "m": [
            [
                "65",
                "{+}00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Sint Maarten",
        "c": "SX",
        "n": "+1",
        "p": 183,
        "m": [
            [
                "1721",
                us
            ]
        ]
    },
    {
        // "country": "Slovakia",
        "c": "SK",
        "n": "+421",
        "p": 184,
        "m": [
            [
                "4219",
                "{+}000 000 000 0000"
            ],
            [
                "421",
                "{+}000 00000000[00]"
            ]
        ]
    },
    {
        // "country": "Slovenia",
        "c": "SI",
        "n": "+386",
        "p": 185,
        "m": [
            [
                "3863",
                "{+}000 00 000 000"
            ],
            [
                "386",
                "{+}000 0000000[00]"
            ]
        ]
    },
    {
        // "country": "Solomon Islands",
        "c": "SB",
        "n": "+677",
        "p": 186,
        "m": [
            [
                "677",
                "{+}000 00000"
            ]
        ]
    },
    {
        // "country": "Somalia",
        "c": "SO",
        "n": "+252",
        "p": 187,
        "m": [
            [
                "252",
                "{+}000 0 000 000"
            ]
        ]
    },
    {
        // "country": "South Africa",
        "c": "ZA",
        "n": "+27",
        "p": 188,
        "m": [
            [
                "276",
                "{+}00 000 000 000"
            ],
            [
                "277",
                "{+}00 000 000 000"
            ],
            [
                "278",
                "{+}00 000 000 000"
            ],
            [
                "27",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "South Korea",
        "c": "KR",
        "n": "+82",
        "p": 189,
        "m": [
            [
                "82",
                "{+}00 00000000[00]"
            ]
        ]
    },
    {
        // "country": "South Sudan",
        "c": "SS",
        "n": "+211",
        "p": 190,
        "m": [
            [
                "211",
                "{+}000 0000000[00]"
            ]
        ]
    },
    {
        // "country": "Spain",
        "c": "ES",
        "n": "+34",
        "p": 191,
        "m": [
            [
                "346",
                "{+}00 000 000 000"
            ],
            [
                "347",
                "{+}00 000 000 000"
            ],
            [
                "34",
                "{+}00 00 000 000"
            ]
        ]
    },
    {
        // "country": "Sri Lanka",
        "c": "LK",
        "n": "+94",
        "p": 192,
        "m": [
            [
                "947",
                "{+}00 000 000 0000"
            ],
            [
                "948",
                "{+}00 000 000 0000"
            ],
            [
                "949",
                "{+}00 000 000 0000"
            ],
            [
                "94",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "St. Barthélemy",
        "c": "BL",
        "n": "+590",
        "p": 193,
        "m": [
            [
                "590",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "St. Helena",
        "c": "SH",
        "n": "+290",
        "p": 194,
        "m": [
            [
                "290",
                "{+}000 0000"
            ]
        ]
    },
    {
        // "country": "St. Kitts & Nevis",
        "c": "KN",
        "n": "+1",
        "p": 195,
        "m": [
            [
                "1869",
                us
            ]
        ]
    },
    {
        // "country": "St. Lucia",
        "c": "LC",
        "n": "+1",
        "p": 196,
        "m": [
            [
                "1758",
                us
            ]
        ]
    },
    {
        // "country": "St. Martin",
        "c": "MF",
        "n": "+590",
        "p": 197,
        "m": [
            [
                "590",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "St. Pierre & Miquelon",
        "c": "PM",
        "n": "+508",
        "p": 198,
        "m": [
            [
                "508",
                "{+}000 00 00 00"
            ]
        ]
    },
    {
        // "country": "St. Vincent & Grenadines",
        "c": "VC",
        "n": "+1",
        "p": 199,
        "m": [
            [
                "1784",
                us
            ]
        ]
    },
    {
        // "country": "Sudan",
        "c": "SD",
        "n": "+249",
        "p": 200,
        "m": [
            [
                "249",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Suriname",
        "c": "SR",
        "n": "+597",
        "p": 201,
        "m": [
            [
                "597",
                "{+}000 000 000"
            ]
        ]
    },
    {
        // "country": "Sweden",
        "c": "SE",
        "n": "+46",
        "p": 202,
        "m": [
            [
                "4613",
                "{+}00 00 00 00 00"
            ],
            [
                "4618",
                "{+}00 00 00 00 00"
            ],
            [
                "467",
                "{+}00 00 000 00 00"
            ],
            [
                "468",
                "{+}00 00 000 00 00"
            ],
            [
                "46",
                "{+}00 0000000[0000]"
            ]
        ]
    },
    {
        // "country": "Switzerland",
        "c": "CH",
        "n": "+41",
        "p": 203,
        "m": [
            [
                "417",
                "{+}00 000 000 000"
            ],
            [
                "41",
                "{+}00 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Syria",
        "c": "SY",
        "n": "+963",
        "p": 204,
        "m": [
            [
                "9639",
                "{+}000 000 000 000"
            ],
            [
                "963",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Taiwan",
        "c": "TW",
        "n": "+886",
        "p": 205,
        "m": [
            [
                "8869",
                "{+}000 000 000 000"
            ],
            [
                "886",
                "{+}000 0 0000 0000"
            ]
        ]
    },
    {
        // "country": "Tajikistan",
        "c": "TJ",
        "n": "+992",
        "p": 206,
        "m": [
            [
                "992",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Tanzania",
        "c": "TZ",
        "n": "+255",
        "p": 207,
        "m": [
            [
                "255",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Thailand",
        "c": "TH",
        "n": "+66",
        "p": 208,
        "m": [
            [
                "6653",
                "{+}00 00 000 000"
            ],
            [
                "6676",
                "{+}00 00 000 000"
            ],
            [
                "662",
                "{+}00 0 000 0000"
            ],
            [
                "666",
                "{+}00 000 000 000"
            ],
            [
                "668",
                "{+}00 000 000 000"
            ],
            [
                "669",
                "{+}00 000 000 000"
            ],
            [
                "66",
                "{+}00 00 000 000"
            ]
        ]
    },
    {
        // "country": "Timor-Leste",
        "c": "TL",
        "n": "+670",
        "p": 209,
        "m": [
            [
                "670",
                "{+}000 000 0000"
            ]
        ]
    },
    {
        // "country": "Togo",
        "c": "TG",
        "n": "+228",
        "p": 210,
        "m": [
            [
                "228",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Tokelau",
        "c": "TK",
        "n": "+690",
        "p": 211,
        "m": [
            [
                "690",
                "{+}000 0000"
            ]
        ]
    },
    {
        // "country": "Tonga",
        "c": "TO",
        "n": "+676",
        "p": 212,
        "m": [
            [
                "676",
                "{+}000 00 000"
            ]
        ]
    },
    {
        // "country": "Trinidad & Tobago",
        "c": "TT",
        "n": "+1",
        "p": 213,
        "m": [
            [
                "1868",
                us
            ]
        ]
    },
    {
        // "country": "Tunisia",
        "c": "TN",
        "n": "+216",
        "p": 214,
        "m": [
            [
                "216",
                "{+}000 00 000 000"
            ]
        ]
    },
    {
        // "country": "Türkiye",
        "c": "TR",
        "n": "+90",
        "p": 215,
        "m": [
            [
                "90",
                "{+}00 000 000 0000"
            ]
        ]
    },
    {
        // "country": "Turkmenistan",
        "c": "TM",
        "n": "+993",
        "p": 216,
        "m": [
            [
                "993",
                "{+}000 0 000 000"
            ]
        ]
    },
    {
        // "country": "Turks & Caicos Islands",
        "c": "TC",
        "n": "+1",
        "p": 217,
        "m": [
            [
                "1649",
                us
            ]
        ]
    },
    {
        // "country": "Tuvalu",
        "c": "TV",
        "n": "+688",
        "p": 218,
        "m": [
            [
                "688",
                "{+}000 00 000"
            ]
        ]
    },
    {
        // "country": "U.S. Virgin Islands",
        "c": "VI",
        "n": "+1",
        "p": 219,
        "m": [
            [
                "1340",
                us
            ]
        ]
    },
    {
        // "country": "Uganda",
        "c": "UG",
        "n": "+256",
        "p": 220,
        "m": [
            [
                "2567",
                "{+}000 000 000 000"
            ],
            [
                "256",
                "{+}000 00 000 000[0]"
            ]
        ]
    },
    {
        // "country": "Ukraine",
        "c": "UA",
        "n": "+380",
        "p": 221,
        "m": [
            [
                "380",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "United Arab Emirates",
        "c": "AE",
        "n": "+971",
        "p": 222,
        "m": [
            [
                "9715",
                "{+}000 00 000 0000"
            ],
            [
                "971",
                "{+}000 0 000 0000"
            ]
        ]
    },
    {
        // "country": "United Kingdom",
        "c": "GB",
        "n": "+44",
        "p": 223,
        "m": [
            [
                "4420",
                "{+}00 00 0000 0000"
            ],
            [
                "447",
                "{+}00 0000 000 000"
            ],
            [
                "44",
                "{+}00 000 000 0000"
            ]
        ]
    },
    {
        // "country": "United States",
        "c": "US",
        "n": "+1",
        "p": 224,
        "m": [
            [
                "1",
                us
            ]
        ]
    },
    {
        // "country": "Uruguay",
        "c": "UY",
        "n": "+598",
        "p": 225,
        "m": [
            [
                "598",
                "{+}000 0 000 00 00"
            ]
        ]
    },
    {
        // "country": "Uzbekistan",
        "c": "UZ",
        "n": "+998",
        "p": 226,
        "m": [
            [
                "998",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Vanuatu",
        "c": "VU",
        "n": "+678",
        "p": 227,
        "m": [
            [
                "678",
                "{+}000 00 0000"
            ]
        ]
    },
    {
        // "country": "Vatican City",
        "c": "VA",
        "n": "+39",
        "p": 228,
        "m": [
            [
                "3906698",
                "{+}00 00 000 00000"
            ],
            [
                "379",
                "{+}000 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Venezuela",
        "c": "VE",
        "n": "+58",
        "p": 229,
        "m": [
            [
                "58",
                "{+}00 000 000 0000"
            ]
        ]
    },
    {
        // "country": "Vietnam",
        "c": "VN",
        "n": "+84",
        "p": 230,
        "m": [
            [
                "843",
                "{+}00 000 000 000"
            ],
            [
                "845",
                "{+}00 000 000 000"
            ],
            [
                "847",
                "{+}00 000 000 000"
            ],
            [
                "849",
                "{+}00 000 000 000"
            ],
            [
                "84",
                "{+}00 00 0000 0000"
            ]
        ]
    },
    {
        // "country": "Wallis & Futuna",
        "c": "WF",
        "n": "+681",
        "p": 231,
        "m": [
            [
                "681",
                "{+}000 00 0000"
            ]
        ]
    },
    {
        // "country": "Yemen",
        "c": "YE",
        "n": "+967",
        "p": 232,
        "m": [
            [
                "9677",
                "{+}000 000 000 000"
            ],
            [
                "967",
                "{+}000 0 000 000"
            ]
        ]
    },
    {
        // "country": "Zambia",
        "c": "ZM",
        "n": "+260",
        "p": 233,
        "m": [
            [
                "2609",
                "{+}000 000 000 000"
            ],
            [
                "260",
                "{+}000 00 000 0000"
            ]
        ]
    },
    {
        // "country": "Zimbabwe",
        "c": "ZW",
        "n": "+263",
        "p": 234,
        "m": [
            [
                "263",
                "{+}000 00 000 00[00]"
            ]
        ]
    }
];
var base$a = function base(props, context, dependencies) {
    var { include, exclude, mask: maskProp } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var { update, focus, value, input, form$, el$: el$1, classes } = dependencies;
    // ================ DATA ================
    /**
   * The country selector `ElementAddonOptions` component.
   *
   * @type {component}
   */ var options$ = (0, $8bTPG.ref)(null);
    /**
   * The placeholder component for `ElementAddonOptions` component.
   *
   * @type {component}
   */ var addonPlaceholder = (0, $8bTPG.ref)((0, $8bTPG.markRaw)({
        props: [
            'option',
            'el$'
        ],
        render () {
            return (0, $ani5R.h)('div', {
                class: classes.value.placeholder,
                style: {
                    backgroundPosition: "0 -".concat(this.option.p * 20 + 20, "px")
                }
            });
        }
    }));
    // ============== COMPUTED ==============
    /**
   * The options to display.
   *
   * @type {array}
   */ var addonOptions = (0, $8bTPG.computed)(()=>{
        return countryPhones.filter((c)=>{
            if (!include.value.length && !exclude.value.length) return true;
            if (include.value.length) return include.value.map((c)=>c.toUpperCase()).indexOf(c.c) !== -1;
            return exclude.value.map((c)=>c.toUpperCase()).indexOf(c.c) === -1;
        }).map((c)=>{
            return _objectSpread2$1(_objectSpread2$1({}, c), {}, {
                value: c.c,
                label: form$.value.translations.vueform.countries[c.c],
                display: (0, $8bTPG.markRaw)({
                    props: [
                        'option',
                        'index',
                        'selected',
                        'pointed',
                        'el$'
                    ],
                    render () {
                        return (0, $ani5R.h)('div', {
                            class: classes.value.option(this.selected || this.pointed)
                        }, [
                            (0, $ani5R.h)('div', {
                                class: classes.value.optionWrapper
                            }, [
                                (0, $ani5R.h)('div', {
                                    class: classes.value.flag,
                                    style: {
                                        backgroundPosition: "0 -".concat(this.option.p * 20 + 20, "px")
                                    }
                                }),
                                (0, $ani5R.h)('div', {
                                    class: classes.value.country
                                }, [
                                    this.option.label,
                                    (0, $ani5R.h)('span', {
                                        class: classes.value.number
                                    }, [
                                        this.option.n
                                    ])
                                ])
                            ])
                        ]);
                    }
                }),
                valueDisplay: (0, $8bTPG.markRaw)({
                    props: [
                        'option',
                        'el$'
                    ],
                    render () {
                        return (0, $ani5R.h)('div', {
                            class: classes.value.flag,
                            style: {
                                backgroundPosition: "0 -".concat(this.option.p * 20 + 20, "px")
                            }
                        });
                    }
                })
            });
        }).sort((a, b)=>a.label.localeCompare(b.label)).map((c, i)=>_objectSpread2$1(_objectSpread2$1({}, c), {}, {
                index: i
            }));
    });
    /**
   * The mask property if [@vueform/plugin-mask](https://github.com/vueform/plugin-mask) is installed (otherwise `undefined`).
   *
   * @type {object|undefined}
   */ var mask = (0, $8bTPG.computed)(()=>{
        if (!maskPluginInstalled.value) return;
        var masks = {};
        var maskLengths = [];
        addonOptions.value.forEach((c)=>c.m.forEach((m)=>{
                if (masks[m[1]] === undefined) masks[m[1]] = [];
                var length = m[0].toString().length;
                if (masks[m[1]][length] === undefined) masks[m[1]][length] = [];
                masks[m[1]][length].push(parseInt(m[0]));
                if (maskLengths.indexOf(length) === -1) maskLengths.push(length);
            }));
        maskLengths.sort().reverse();
        var mask = [];
        maskLengths.forEach((length)=>{
            Object.keys(masks).forEach((m)=>{
                if (masks[m][length]) mask.push({
                    mask: m,
                    startsWith: masks[m][length],
                    placeholder: true
                });
            });
        });
        mask.push({
            mask: '{+}0000000[0000000]',
            startsWith: ''
        });
        return {
            mask: mask
        };
    });
    /**
   * All the available masks for options, where key is the country prefix, value is the mask.
   *
   * @type {object}
   */ var masks = (0, $8bTPG.computed)(()=>{
        return addonOptions.value.reduce((prev, curr)=>{
            return curr.m.reduce((p, c)=>{
                return _objectSpread2$1(_objectSpread2$1({}, p), {}, {
                    [c[0]]: curr.c
                });
            }, _objectSpread2$1({}, prev));
        }, {});
    });
    /**
   * Whether [@vueform/plugin-mask](https://github.com/vueform/plugin-mask) is installed.
   *
   * @type {boolean}
   */ var maskPluginInstalled = (0, $8bTPG.computed)(()=>{
        return !!maskProp;
    });
    /**
   * The type of the HTML input field (`text` if masks are enabled, `tel` otherwise).
   * 
   * @type {string}
   */ var inputType = (0, $8bTPG.computed)(()=>{
        return maskPluginInstalled.value ? 'text' : 'tel';
    });
    // =============== METHODS ==============
    /**
   * Sets country flag according to current input value.
   * 
   * @returns {void}
   */ var setFlag = ()=>{
        var _options$$value$selec;
        if (!value.value) {
            if (Object.keys(options$.value.selected).length) options$.value.reset();
            return;
        }
        if (value.value && !value.value.toString().startsWith('+') || value.value === ((_options$$value$selec = options$.value.selected) === null || _options$$value$selec === void 0 ? void 0 : _options$$value$selec.n)) return;
        var number = value.value.replace('+', '');
        var lengths = [
            7,
            5,
            4,
            3,
            2,
            1
        ].filter((l)=>number.length >= l);
        var country;
        lengths.forEach((l)=>{
            if (country) return;
            country = masks.value[number.slice(0, l)] || undefined;
        });
        if (!country) {
            if (Object.keys(options$.value.selected).length) options$.value.reset();
            return;
        }
        if (country === 'MF') country = 'GP';
        var option = addonOptions.value.find((c)=>c.c === country);
        if (options$.value.selected.index !== option.index) options$.value.selectOption(option);
    };
    /**
   * Handles option select.
   *
   * @param {object} option* the option to select (from `addonOptions`).
   * @returns {void}
   * @private
   */ var handleOptionSelect = (option)=>{
        if (document.activeElement === input.value) {
            context.emit('select', option, el$1.value);
            return;
        }
        if (option.n === undefined) el$1.value.clear();
        else if (maskPluginInstalled.value) {
            var valueMatchesMask = value.value ? option.m.map((m)=>"+".concat(m[0])).find((m)=>{
                return value.value.startsWith(m);
            }) : false;
            if (!valueMatchesMask) el$1.value.update(option.m.length === 1 ? "+".concat(option.m[0][0]) : option.n);
            if (document.activeElement.closest('[data-dropdown-for]')) focus();
        } else el$1.value.update(option.n);
        context.emit('select', option, el$1.value);
    };
    /**
   * Handles dropdown open event (emits `@open` event).
   *
   * @returns {void}
   */ var handleOpen = ()=>{
        context.emit('open', el$1);
    };
    /**
   * Handles dropdown close event (emits `@close` event).
   *
   * @returns {void}
   */ var handleClose = ()=>{
        context.emit('close', el$1);
    };
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        setFlag();
    });
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(value, (n)=>{
        setFlag();
    });
    return {
        options$: options$,
        addonOptions: addonOptions,
        handleOptionSelect: handleOptionSelect,
        addonPlaceholder: addonPlaceholder,
        maskPluginInstalled: maskPluginInstalled,
        inputType: inputType,
        mask: mask,
        handleOpen: handleOpen,
        handleClose: handleClose
    };
};
var base$9 = function base(props, context, dependencies) {
    var { fire, el$: el$1 } = dependencies;
    // =============== METHODS ==============
    /**
   * Handles `keydown` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleKeydown = (e)=>{
        fire('keydown', e, el$1.value);
    };
    /**
   * Handles `keyup` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleKeyup = (e)=>{
        fire('keyup', e, el$1.value);
    };
    /**
   * Handles `keypress` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleKeypress = (e)=>{
        fire('keypress', e, el$1.value);
    };
    return {
        handleKeydown: handleKeydown,
        handleKeyup: handleKeyup,
        handleKeypress: handleKeypress
    };
};
var phone = function phone(props, context, dependencies) {
    var { fire, model, input, el$: el$1 } = dependencies;
    // =============== METHODS ==============
    /**
   * Handles `keydown` event.
   *
   * @param {Event} e* event object
   * @returns {void}
   * @private
   */ var handleKeydown = (e)=>{
        if (el$1.value.maskPluginInstalled) return;
        if ([
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'ArrowLeft',
            'ArrowRight'
        ].indexOf(e.key) !== -1 || e.ctrlKey || e.metaKey) return;
        if (/[0-9]/.test(e.key) && (!model.value || model.value.length < 16)) return;
        if (e.key === '+' && (!model.value || input.value.selectionStart === 0) && (!model.value || model.value.length < 16)) return;
        e.preventDefault();
    };
    return {
        handleKeydown: handleKeydown
    };
};
var PhoneElement = {
    name: 'PhoneElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'select',
        'open',
        'close',
        'blur',
        'focus',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'text',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            localized: true,
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        include: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        exclude: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        unmask: {
            require: false,
            type: [
                Boolean
            ],
            default: false
        },
        allowIncomplete: {
            require: false,
            type: [
                Boolean
            ],
            default: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        autocomplete: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSelect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            text$1,
            base$19,
            text$2,
            base$L,
            base$P,
            base$M,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            phone$1,
            base$v,
            base$b,
            phone$2,
            base$J,
            base$Y,
            phone,
            base$w,
            base$a
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$8 = function base(props, context, dependencies) {
    var { radioName, radioValue } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var update = dependencies.update;
    var nullValue = dependencies.nullValue;
    var fieldId = dependencies.fieldId;
    var path = dependencies.path;
    var form$ = dependencies.form$;
    // ================ DATA ================
    /**
   * The list of listeners.
   *
   * @type {array}
   * @default []
   * @private
   */ var listeners = (0, $8bTPG.ref)([]);
    // ============== COMPUTED ==============
    /**
   * The `name` attribute of the element. If [`id`](#option-id) is not provided [`name`](#option-name) will be used.
   *
   * @type {string}
   */ var inputName = (0, $8bTPG.computed)(()=>{
        //@todo:adam incorrect documentation, id is non-existent in path computed
        return radioName.value || path.value;
    });
    // =============== METHODS ==============
    /**
   * Checks the radio.
   *
   * @returns {void}
   */ var check = ()=>{
        update(radioValue.value);
    };
    /**
   * Unchecks the radio.
   *
   * @returns {void}
   */ var uncheck = ()=>{
        update(nullValue.value);
    };
    /**
   * Watches radio name change.
   *
   * @returns {void}
   * @private
   */ var watchChange = (value, old)=>{
        //@todo:adam queryselectorall should check for name old and not name value
        if (old) form$.value.$el.querySelectorAll("input[name=\"".concat(old, "\"")).forEach((element, i)=>{
            if (listeners.value[i]) element.removeEventListener('change', listeners.value[i]);
        });
        form$.value.$el.querySelectorAll("input[name=\"".concat(value, "\"")).forEach((element)=>{
            var listener = ()=>{
                if (element.id != fieldId.value) update(nullValue.value);
            };
            listeners.value.push(listener);
            element.addEventListener('change', listener);
        });
    };
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        watchChange(inputName.value);
    });
    // ============= WATCHERS ===============
    (0, $8bTPG.watch)(inputName, watchChange);
    return {
        inputName: inputName,
        check: check,
        uncheck: uncheck
    };
};
var RadioElement = {
    name: 'RadioElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'radio',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        radioName: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        radioValue: {
            required: false,
            type: [
                Boolean,
                String,
                Number
            ],
            default: 1
        },
        text: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        standalone: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$O,
            base$G,
            base$19,
            base$H,
            base$P,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$8,
            radio,
            base$J,
            base$Y,
            base$D
        ];
        context.slots = [
            'default',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var RadiogroupElement = {
    name: 'RadiogroupElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'radiogroup',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Boolean
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        items: {
            required: false,
            type: [
                Object,
                Array,
                Function,
                String
            ],
            localized: true,
            default: ()=>({})
        },
        disables: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        clearOnRefetch: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$S,
            base$O,
            base$Z,
            base$1h,
            base$T,
            radiogroup$2,
            base$G,
            base$P,
            radiogroup,
            base$19,
            base$H,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            radiogroup$1,
            base$J,
            base$Y
        ];
        context.slots = [
            'radio',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var SelectElement = {
    name: 'SelectElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'select',
        'deselect',
        'search-change',
        'open',
        'close',
        'clear',
        'paste',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'select',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        onSelect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onDeselect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSearchChange: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onOpen: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClose: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClear: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onPaste: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        native: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        items: {
            required: false,
            type: [
                Object,
                Array,
                Function,
                String
            ],
            localized: true,
            default: ()=>({})
        },
        labelProp: {
            type: [
                String
            ],
            required: false,
            default: 'label'
        },
        valueProp: {
            type: [
                String
            ],
            required: false,
            default: 'value'
        },
        dataKey: {
            type: [
                String
            ],
            required: false,
            default: undefined
        },
        searchParam: {
            type: [
                String
            ],
            required: false,
            default: 'query'
        },
        search: {
            required: false,
            type: [
                Boolean
            ],
            default: false,
            native: false
        },
        trackBy: {
            type: [
                String,
                Array
            ],
            required: false,
            default: undefined,
            native: false
        },
        strict: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        create: {
            required: false,
            type: [
                Boolean
            ],
            default: false,
            native: false
        },
        appendNewOption: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        addOptionOn: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[
                    'enter'
                ],
            native: false
        },
        allowAbsent: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        object: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        limit: {
            type: [
                Number
            ],
            required: false,
            default: -1,
            native: false
        },
        groups: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        groupLabel: {
            type: [
                String
            ],
            required: false,
            default: 'label',
            native: false
        },
        groupOptions: {
            type: [
                String
            ],
            required: false,
            default: 'items',
            native: false
        },
        groupHideEmpty: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        openDirection: {
            type: [
                String
            ],
            required: false,
            default: 'bottom',
            native: false
        },
        appendToBody: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        appendTo: {
            type: [
                String
            ],
            required: false,
            default: undefined,
            native: false
        },
        canDeselect: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        canClear: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        closeOnSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        closeOnDeselect: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        clearOnRefetch: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        delay: {
            type: [
                Number
            ],
            required: false,
            default: -1,
            native: false
        },
        minChars: {
            type: [
                Number
            ],
            required: false,
            default: 0,
            native: false
        },
        resolveOnLoad: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        filterResults: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        clearOnSearch: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        caret: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        truncate: {
            type: [
                Boolean
            ],
            required: false,
            default: true,
            native: false
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        noOptionsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noOptions',
            localized: true,
            native: false
        },
        noResultsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noResults',
            localized: true,
            native: false
        },
        autocomplete: {
            type: [
                String
            ],
            required: false,
            native: false
        },
        inputType: {
            type: [
                String
            ],
            required: false,
            default: 'text',
            native: false
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            select$4,
            base$S,
            base$O,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$G,
            base$H,
            base$L,
            select$1,
            base$P,
            select$2,
            base$19,
            base$M,
            select$3,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$d,
            select,
            base$V,
            base$J,
            base$Y,
            base$w
        ];
        context.slots = [
            'option',
            'single-label',
            'placeholder',
            'group-label',
            'before-list',
            'after-list',
            'no-results',
            'no-options',
            'caret',
            'spinner',
            'clear',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
/*!
 * Signature Pad v5.0.4 | https://github.com/szimek/signature_pad
 * (c) 2024 Szymon Nowak | Released under the MIT license
 */ class Point {
    constructor(x, y, pressure, time){
        if (isNaN(x) || isNaN(y)) throw new Error(`Point is invalid: (${x}, ${y})`);
        this.x = +x;
        this.y = +y;
        this.pressure = pressure || 0;
        this.time = time || Date.now();
    }
    distanceTo(start) {
        return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
    equals(other) {
        return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
    }
    velocityFrom(start) {
        return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
    }
}
class Bezier {
    static fromPoints(points, widths) {
        const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
        const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
        return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
    }
    static calculateControlPoints(s1, s2, s3) {
        const dx1 = s1.x - s2.x;
        const dy1 = s1.y - s2.y;
        const dx2 = s2.x - s3.x;
        const dy2 = s2.y - s3.y;
        const m1 = {
            x: (s1.x + s2.x) / 2.0,
            y: (s1.y + s2.y) / 2.0
        };
        const m2 = {
            x: (s2.x + s3.x) / 2.0,
            y: (s2.y + s3.y) / 2.0
        };
        const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
        const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
        const dxm = m1.x - m2.x;
        const dym = m1.y - m2.y;
        const k = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
        const cm = {
            x: m2.x + dxm * k,
            y: m2.y + dym * k
        };
        const tx = s2.x - cm.x;
        const ty = s2.y - cm.y;
        return {
            c1: new Point(m1.x + tx, m1.y + ty),
            c2: new Point(m2.x + tx, m2.y + ty)
        };
    }
    constructor(startPoint, control2, control1, endPoint, startWidth, endWidth){
        this.startPoint = startPoint;
        this.control2 = control2;
        this.control1 = control1;
        this.endPoint = endPoint;
        this.startWidth = startWidth;
        this.endWidth = endWidth;
    }
    length() {
        const steps = 10;
        let length = 0;
        let px;
        let py;
        for(let i = 0; i <= steps; i += 1){
            const t = i / steps;
            const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
            const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
            if (i > 0) {
                const xdiff = cx - px;
                const ydiff = cy - py;
                length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
            }
            px = cx;
            py = cy;
        }
        return length;
    }
    point(t, start, c1, c2, end) {
        return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
    }
}
class SignatureEventTarget {
    constructor(){
        try {
            this._et = new EventTarget();
        } catch (_a) {
            this._et = document;
        }
    }
    addEventListener(type, listener, options) {
        this._et.addEventListener(type, listener, options);
    }
    dispatchEvent(event) {
        return this._et.dispatchEvent(event);
    }
    removeEventListener(type, callback, options) {
        this._et.removeEventListener(type, callback, options);
    }
}
function throttle(fn, wait = 250) {
    let previous = 0;
    let timeout = null;
    let result;
    let storedContext;
    let storedArgs;
    const later = ()=>{
        previous = Date.now();
        timeout = null;
        result = fn.apply(storedContext, storedArgs);
        if (!timeout) {
            storedContext = null;
            storedArgs = [];
        }
    };
    return function wrapper(...args) {
        const now = Date.now();
        const remaining = wait - (now - previous);
        storedContext = this;
        storedArgs = args;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = fn.apply(storedContext, storedArgs);
            if (!timeout) {
                storedContext = null;
                storedArgs = [];
            }
        } else if (!timeout) timeout = window.setTimeout(later, remaining);
        return result;
    };
}
class SignaturePad extends SignatureEventTarget {
    constructor(canvas, options = {}){
        var _a, _b, _c;
        super();
        this.canvas = canvas;
        this._drawingStroke = false;
        this._isEmpty = true;
        this._lastPoints = [];
        this._data = [];
        this._lastVelocity = 0;
        this._lastWidth = 0;
        this._handleMouseDown = (event)=>{
            if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) return;
            this._strokeBegin(this._pointerEventToSignatureEvent(event));
        };
        this._handleMouseMove = (event)=>{
            if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
                this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
                return;
            }
            this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
        };
        this._handleMouseUp = (event)=>{
            if (this._isLeftButtonPressed(event)) return;
            this._strokeEnd(this._pointerEventToSignatureEvent(event));
        };
        this._handleTouchStart = (event)=>{
            if (event.targetTouches.length !== 1 || this._drawingStroke) return;
            if (event.cancelable) event.preventDefault();
            this._strokeBegin(this._touchEventToSignatureEvent(event));
        };
        this._handleTouchMove = (event)=>{
            if (event.targetTouches.length !== 1) return;
            if (event.cancelable) event.preventDefault();
            if (!this._drawingStroke) {
                this._strokeEnd(this._touchEventToSignatureEvent(event), false);
                return;
            }
            this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
        };
        this._handleTouchEnd = (event)=>{
            if (event.targetTouches.length !== 0) return;
            if (event.cancelable) event.preventDefault();
            this.canvas.removeEventListener('touchmove', this._handleTouchMove);
            this._strokeEnd(this._touchEventToSignatureEvent(event));
        };
        this._handlePointerDown = (event)=>{
            if (!event.isPrimary || !this._isLeftButtonPressed(event) || this._drawingStroke) return;
            event.preventDefault();
            this._strokeBegin(this._pointerEventToSignatureEvent(event));
        };
        this._handlePointerMove = (event)=>{
            if (!event.isPrimary) return;
            if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
                this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
                return;
            }
            event.preventDefault();
            this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
        };
        this._handlePointerUp = (event)=>{
            if (!event.isPrimary || this._isLeftButtonPressed(event)) return;
            event.preventDefault();
            this._strokeEnd(this._pointerEventToSignatureEvent(event));
        };
        this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
        this.minWidth = options.minWidth || 0.5;
        this.maxWidth = options.maxWidth || 2.5;
        this.throttle = (_a = options.throttle) !== null && _a !== void 0 ? _a : 16;
        this.minDistance = (_b = options.minDistance) !== null && _b !== void 0 ? _b : 5;
        this.dotSize = options.dotSize || 0;
        this.penColor = options.penColor || 'black';
        this.backgroundColor = options.backgroundColor || 'rgba(0,0,0,0)';
        this.compositeOperation = options.compositeOperation || 'source-over';
        this.canvasContextOptions = (_c = options.canvasContextOptions) !== null && _c !== void 0 ? _c : {};
        this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
        this._ctx = canvas.getContext('2d', this.canvasContextOptions);
        this.clear();
        this.on();
    }
    clear() {
        const { _ctx: ctx, canvas } = this;
        ctx.fillStyle = this.backgroundColor;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        this._data = [];
        this._reset(this._getPointGroupOptions());
        this._isEmpty = true;
    }
    fromDataURL(dataUrl, options = {}) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            const ratio = options.ratio || window.devicePixelRatio || 1;
            const width = options.width || this.canvas.width / ratio;
            const height = options.height || this.canvas.height / ratio;
            const xOffset = options.xOffset || 0;
            const yOffset = options.yOffset || 0;
            this._reset(this._getPointGroupOptions());
            image.onload = ()=>{
                this._ctx.drawImage(image, xOffset, yOffset, width, height);
                resolve();
            };
            image.onerror = (error)=>{
                reject(error);
            };
            image.crossOrigin = 'anonymous';
            image.src = dataUrl;
            this._isEmpty = false;
        });
    }
    toDataURL(type = 'image/png', encoderOptions) {
        switch(type){
            case 'image/svg+xml':
                if (typeof encoderOptions !== 'object') encoderOptions = undefined;
                return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
            default:
                if (typeof encoderOptions !== 'number') encoderOptions = undefined;
                return this.canvas.toDataURL(type, encoderOptions);
        }
    }
    on() {
        this.canvas.style.touchAction = 'none';
        this.canvas.style.msTouchAction = 'none';
        this.canvas.style.userSelect = 'none';
        const isIOS = /Macintosh/.test(navigator.userAgent) && 'ontouchstart' in document;
        if (window.PointerEvent && !isIOS) this._handlePointerEvents();
        else {
            this._handleMouseEvents();
            if ('ontouchstart' in window) this._handleTouchEvents();
        }
    }
    off() {
        this.canvas.style.touchAction = 'auto';
        this.canvas.style.msTouchAction = 'auto';
        this.canvas.style.userSelect = 'auto';
        this.canvas.removeEventListener('pointerdown', this._handlePointerDown);
        this.canvas.removeEventListener('mousedown', this._handleMouseDown);
        this.canvas.removeEventListener('touchstart', this._handleTouchStart);
        this._removeMoveUpEventListeners();
    }
    _getListenerFunctions() {
        var _a;
        const canvasWindow = window.document === this.canvas.ownerDocument ? window : (_a = this.canvas.ownerDocument.defaultView) !== null && _a !== void 0 ? _a : this.canvas.ownerDocument;
        return {
            addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
            removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
        };
    }
    _removeMoveUpEventListeners() {
        const { removeEventListener } = this._getListenerFunctions();
        removeEventListener('pointermove', this._handlePointerMove);
        removeEventListener('pointerup', this._handlePointerUp);
        removeEventListener('mousemove', this._handleMouseMove);
        removeEventListener('mouseup', this._handleMouseUp);
        removeEventListener('touchmove', this._handleTouchMove);
        removeEventListener('touchend', this._handleTouchEnd);
    }
    isEmpty() {
        return this._isEmpty;
    }
    fromData(pointGroups, { clear = true } = {}) {
        if (clear) this.clear();
        this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
        this._data = this._data.concat(pointGroups);
    }
    toData() {
        return this._data;
    }
    _isLeftButtonPressed(event, only) {
        if (only) return event.buttons === 1;
        return (event.buttons & 1) === 1;
    }
    _pointerEventToSignatureEvent(event) {
        return {
            event: event,
            type: event.type,
            x: event.clientX,
            y: event.clientY,
            pressure: 'pressure' in event ? event.pressure : 0
        };
    }
    _touchEventToSignatureEvent(event) {
        const touch = event.changedTouches[0];
        return {
            event: event,
            type: event.type,
            x: touch.clientX,
            y: touch.clientY,
            pressure: touch.force
        };
    }
    _getPointGroupOptions(group) {
        return {
            penColor: group && 'penColor' in group ? group.penColor : this.penColor,
            dotSize: group && 'dotSize' in group ? group.dotSize : this.dotSize,
            minWidth: group && 'minWidth' in group ? group.minWidth : this.minWidth,
            maxWidth: group && 'maxWidth' in group ? group.maxWidth : this.maxWidth,
            velocityFilterWeight: group && 'velocityFilterWeight' in group ? group.velocityFilterWeight : this.velocityFilterWeight,
            compositeOperation: group && 'compositeOperation' in group ? group.compositeOperation : this.compositeOperation
        };
    }
    _strokeBegin(event) {
        const cancelled = !this.dispatchEvent(new CustomEvent('beginStroke', {
            detail: event,
            cancelable: true
        }));
        if (cancelled) return;
        const { addEventListener } = this._getListenerFunctions();
        switch(event.event.type){
            case 'mousedown':
                addEventListener('mousemove', this._handleMouseMove);
                addEventListener('mouseup', this._handleMouseUp);
                break;
            case 'touchstart':
                addEventListener('touchmove', this._handleTouchMove);
                addEventListener('touchend', this._handleTouchEnd);
                break;
            case 'pointerdown':
                addEventListener('pointermove', this._handlePointerMove);
                addEventListener('pointerup', this._handlePointerUp);
                break;
        }
        this._drawingStroke = true;
        const pointGroupOptions = this._getPointGroupOptions();
        const newPointGroup = Object.assign(Object.assign({}, pointGroupOptions), {
            points: []
        });
        this._data.push(newPointGroup);
        this._reset(pointGroupOptions);
        this._strokeUpdate(event);
    }
    _strokeUpdate(event) {
        if (!this._drawingStroke) return;
        if (this._data.length === 0) {
            this._strokeBegin(event);
            return;
        }
        this.dispatchEvent(new CustomEvent('beforeUpdateStroke', {
            detail: event
        }));
        const point = this._createPoint(event.x, event.y, event.pressure);
        const lastPointGroup = this._data[this._data.length - 1];
        const lastPoints = lastPointGroup.points;
        const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
        const isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
        const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
        if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
            const curve = this._addPoint(point, pointGroupOptions);
            if (!lastPoint) this._drawDot(point, pointGroupOptions);
            else if (curve) this._drawCurve(curve, pointGroupOptions);
            lastPoints.push({
                time: point.time,
                x: point.x,
                y: point.y,
                pressure: point.pressure
            });
        }
        this.dispatchEvent(new CustomEvent('afterUpdateStroke', {
            detail: event
        }));
    }
    _strokeEnd(event, shouldUpdate = true) {
        this._removeMoveUpEventListeners();
        if (!this._drawingStroke) return;
        if (shouldUpdate) this._strokeUpdate(event);
        this._drawingStroke = false;
        this.dispatchEvent(new CustomEvent('endStroke', {
            detail: event
        }));
    }
    _handlePointerEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener('pointerdown', this._handlePointerDown);
    }
    _handleMouseEvents() {
        this._drawingStroke = false;
        this.canvas.addEventListener('mousedown', this._handleMouseDown);
    }
    _handleTouchEvents() {
        this.canvas.addEventListener('touchstart', this._handleTouchStart);
    }
    _reset(options) {
        this._lastPoints = [];
        this._lastVelocity = 0;
        this._lastWidth = (options.minWidth + options.maxWidth) / 2;
        this._ctx.fillStyle = options.penColor;
        this._ctx.globalCompositeOperation = options.compositeOperation;
    }
    _createPoint(x, y, pressure) {
        const rect = this.canvas.getBoundingClientRect();
        return new Point(x - rect.left, y - rect.top, pressure, new Date().getTime());
    }
    _addPoint(point, options) {
        const { _lastPoints } = this;
        _lastPoints.push(point);
        if (_lastPoints.length > 2) {
            if (_lastPoints.length === 3) _lastPoints.unshift(_lastPoints[0]);
            const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
            const curve = Bezier.fromPoints(_lastPoints, widths);
            _lastPoints.shift();
            return curve;
        }
        return null;
    }
    _calculateCurveWidths(startPoint, endPoint, options) {
        const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
        const newWidth = this._strokeWidth(velocity, options);
        const widths = {
            end: newWidth,
            start: this._lastWidth
        };
        this._lastVelocity = velocity;
        this._lastWidth = newWidth;
        return widths;
    }
    _strokeWidth(velocity, options) {
        return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
    }
    _drawCurveSegment(x, y, width) {
        const ctx = this._ctx;
        ctx.moveTo(x, y);
        ctx.arc(x, y, width, 0, 2 * Math.PI, false);
        this._isEmpty = false;
    }
    _drawCurve(curve, options) {
        const ctx = this._ctx;
        const widthDelta = curve.endWidth - curve.startWidth;
        const drawSteps = Math.ceil(curve.length()) * 2;
        ctx.beginPath();
        ctx.fillStyle = options.penColor;
        for(let i = 0; i < drawSteps; i += 1){
            const t = i / drawSteps;
            const tt = t * t;
            const ttt = tt * t;
            const u = 1 - t;
            const uu = u * u;
            const uuu = uu * u;
            let x = uuu * curve.startPoint.x;
            x += 3 * uu * t * curve.control1.x;
            x += 3 * u * tt * curve.control2.x;
            x += ttt * curve.endPoint.x;
            let y = uuu * curve.startPoint.y;
            y += 3 * uu * t * curve.control1.y;
            y += 3 * u * tt * curve.control2.y;
            y += ttt * curve.endPoint.y;
            const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
            this._drawCurveSegment(x, y, width);
        }
        ctx.closePath();
        ctx.fill();
    }
    _drawDot(point, options) {
        const ctx = this._ctx;
        const width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
        ctx.beginPath();
        this._drawCurveSegment(point.x, point.y, width);
        ctx.closePath();
        ctx.fillStyle = options.penColor;
        ctx.fill();
    }
    _fromData(pointGroups, drawCurve, drawDot) {
        for (const group of pointGroups){
            const { points } = group;
            const pointGroupOptions = this._getPointGroupOptions(group);
            if (points.length > 1) for(let j = 0; j < points.length; j += 1){
                const basicPoint = points[j];
                const point = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
                if (j === 0) this._reset(pointGroupOptions);
                const curve = this._addPoint(point, pointGroupOptions);
                if (curve) drawCurve(curve, pointGroupOptions);
            }
            else {
                this._reset(pointGroupOptions);
                drawDot(points[0], pointGroupOptions);
            }
        }
    }
    toSVG({ includeBackgroundColor = false } = {}) {
        const pointGroups = this._data;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const minX = 0;
        const minY = 0;
        const maxX = this.canvas.width / ratio;
        const maxY = this.canvas.height / ratio;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        svg.setAttribute('viewBox', `${minX} ${minY} ${maxX} ${maxY}`);
        svg.setAttribute('width', maxX.toString());
        svg.setAttribute('height', maxY.toString());
        if (includeBackgroundColor && this.backgroundColor) {
            const rect = document.createElement('rect');
            rect.setAttribute('width', '100%');
            rect.setAttribute('height', '100%');
            rect.setAttribute('fill', this.backgroundColor);
            svg.appendChild(rect);
        }
        this._fromData(pointGroups, (curve, { penColor })=>{
            const path = document.createElement('path');
            if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} ` + `C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ` + `${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ` + `${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
                path.setAttribute('d', attr);
                path.setAttribute('stroke-width', (curve.endWidth * 2.25).toFixed(3));
                path.setAttribute('stroke', penColor);
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke-linecap', 'round');
                svg.appendChild(path);
            }
        }, (point, { penColor, dotSize, minWidth, maxWidth })=>{
            const circle = document.createElement('circle');
            const size = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
            circle.setAttribute('r', size.toString());
            circle.setAttribute('cx', point.x.toString());
            circle.setAttribute('cy', point.y.toString());
            circle.setAttribute('fill', penColor);
            svg.appendChild(circle);
        });
        return svg.outerHTML;
    }
}
function debounce(func, wait, onStart) {
    var timeout;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!timeout) onStart();
        else clearTimeout(timeout);
        timeout = setTimeout(()=>{
            timeout = null;
            func.apply(this, args);
        }, wait);
    };
}
function useSignature(props, context, dependencies) {
    var { fonts, colors, modes, accept, maxWidth, height, readonly, maxFontSize, minFontSize, canClear, line, placeholder, autoload, maxSize, canUndo, columns, uploadWidth, uploadHeight, canDrop } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var { el$: el$1, form$, input, isDisabled, value, Placeholder, available } = dependencies;
    // ================ DATA ================
    /**
   * The signature mode selector.
   *
   * @type {ElementAddonOptions}
   */ var mode$ = (0, $8bTPG.ref)(null);
    /**
   * The font style selector.
   *
   * @type {ElementAddonOptions}
   */ var font$ = (0, $8bTPG.ref)(null);
    /**
   * The input field when [`mode`](#property-mode) is `type`.
   *
   * @type {HTMLInputElement}
   */ var input$ = (0, $8bTPG.ref)(null);
    /**
   * The canvas that shows the preview of an uploaded signature when [`mode`](#property-mode) is `upload`.
   *
   * @type {HTMLCanvasElement}
   */ var preview$ = (0, $8bTPG.ref)(null);
    /**
   * The canvas that allows drawning signature when [`mode`](#property-mode) is `draw`.
   *
   * @type {HTMLCanvasElement}
   */ var pad$ = (0, $8bTPG.ref)(null);
    /**
   * The file input field when [`mode`](#property-mode) is `upload` (it's invisible).
   *
   * @type {HTMLInputElement}
   */ var file$ = (0, $8bTPG.ref)(null);
    /**
   * The DOM that contains upload related parts.
   *
   * @type {HTMLElement}
   */ var upload$ = (0, $8bTPG.ref)(null);
    /**
   * The upload button.
   *
   * @type {HTMLElement}
   */ var uploadButton$ = (0, $8bTPG.ref)(null);
    /**
   * The current signature mode (`draw`, `type` or `upload`).
   *
   * @type {string}
   */ var mode = (0, $8bTPG.ref)(null);
    /**
   * The current font family.
   *
   * @type {string}
   */ var fontFamily = (0, $8bTPG.ref)(null);
    /**
   * The current font weight.
   *
   * @type {string}
   */ var fontWeight = (0, $8bTPG.ref)(null);
    /**
   * The current font size.
   *
   * @type {number}
   */ var fontSize = (0, $8bTPG.ref)(maxFontSize.value);
    /**
   * The hex code of the current signature color.
   *
   * @type {string}
   */ var color = (0, $8bTPG.ref)(null);
    /**
   * The input value used when [`mode`](#property-mode) is `type`.
   *
   * @type {string}
   */ var text = (0, $8bTPG.ref)(null);
    /**
   * The [Signature Pad](https://github.com/szimek/signature_pad) instance.
   *
   * @type {object}
   */ var pad = (0, $8bTPG.ref)(null);
    /**
   * The file (image) selected by the user when [`mode`](#property-mode) is `upload`.
   *
   * @type {File}
   */ var image = (0, $8bTPG.ref)(null);
    /**
   * Whether the image preview is already created when [`mode`](#property-mode) is `upload`.
   *
   * @type {boolean}
   */ var created = (0, $8bTPG.ref)(false);
    /**
   * Whether the image preview is being created when [`mode`](#property-mode) is `upload`.
   *
   * @type {boolean}
   */ var creating = (0, $8bTPG.ref)(false);
    /**
   * Whether a file is being dragged over the element when [`mode`](#property-mode) is `upload`.
   *
   * @type {boolean}
   */ var dragging = (0, $8bTPG.ref)(false);
    /**
   * Whether the canvas contains any drawn signature when [`mode`](#property-mode) is `draw`.
   *
   * @type {boolean}
   */ var drawn = (0, $8bTPG.ref)(false);
    /**
   * Whether a signature is currently being drawn when [`mode`](#property-mode) is `draw`.
   *
   * @type {boolean}
   */ var drawing = (0, $8bTPG.ref)(false);
    /**
   * The list of available redos.
   *
   * @type {array}
   */ var redos = (0, $8bTPG.ref)([]);
    /**
   * The number available undos.
   *
   * @type {number}
   */ var undosLeft = (0, $8bTPG.ref)(0);
    /**
   * The current width of the signature element.
   *
   * @type {number}
   */ var width = (0, $8bTPG.ref)(0);
    /**
   * The last width of the element.
   *
   * @type {number}
   */ var lastWidth = (0, $8bTPG.ref)(0);
    /**
   * Whether the mouse is over after starting to draw a signature.
   * 
   * @type {boolean}
   */ var isMouseOver = (0, $8bTPG.ref)(false);
    /**
   * Whether the mouse is over after starting to draw a signature.
   * 
   * @type {number}
   */ var debouncer = (0, $8bTPG.ref)(0);
    // ============== COMPUTED ==============
    /**
   * The available font families.
   *
   * @type {array}
   */ var fontFamilies = (0, $8bTPG.computed)(()=>{
        return fonts.value.map((f)=>f.split('@')[0].replace('!', ''));
    });
    /**
   * The available font weights.
   *
   * @type {array}
   */ var fontWeights = (0, $8bTPG.computed)(()=>{
        return fonts.value.map((f)=>f.split('@')[1] || 400);
    });
    /**
   * Whether a signature (as URL) was loaded to the element.
   *
   * @type {boolean}
   */ var uploaded = (0, $8bTPG.computed)(()=>{
        return typeof value.value === 'string';
    });
    /**
   * Whether the uploaded file is being processed for preview.
   *
   * @type {boolean}
   */ var processing = (0, $8bTPG.computed)(()=>{
        return image.value && !created.value;
    });
    /**
   * Whether `drop` is enabled and browser supports dragging.
   *
   * @type {boolean}
   */ var droppable = (0, $8bTPG.computed)(()=>{
        var div = document.createElement('div');
        return ('draggable' in div || 'ondragstart' in div && 'ondrop' in div) && 'FormData' in window && 'FileReader' in window && canDrop.value;
    });
    /**
   * The list of [`modes`](#option-modes) formatted for mode selector.
   *
   * @type {array}
   */ var resolvedModes = (0, $8bTPG.computed)(()=>{
        return modes.value.filter((m)=>[
                'type',
                'draw',
                'upload'
            ].indexOf(m) !== -1).map((mode, i)=>{
            return {
                label: form$.value.translations.vueform.elements.signature[mode],
                value: mode,
                index: i
            };
        });
    });
    /**
   * The list of [`fonts`](#option-fonts) formatted for fonts selector.
   *
   * @type {array}
   */ var resolvedFonts = (0, $8bTPG.computed)(()=>{
        return fontFamilies.value.map((font, i)=>{
            var _text$value;
            return {
                label: "<div><span style=\"font-family: ".concat(font, "; font-weight: ").concat(fontWeights.value[i], "\" aria-hidden=\"true\">").concat(((_text$value = text.value) === null || _text$value === void 0 ? void 0 : _text$value.trim()) || form$.value.translations.vueform.elements.signature.fontPlaceholder, "</span><span style=\"position: absolute; left: -9999px; opacity: 0;\">").concat(font, "</span></div>"),
                value: i,
                index: i
            };
        });
    });
    /**
   * The list of MIME types formatted for the file input attribute.
   *
   * @type {string}
   */ var fileAccept = (0, $8bTPG.computed)(()=>{
        return accept.value.reduce((prev, curr)=>{
            switch(curr){
                case 'jpg':
                case 'jpeg':
                    prev.push('image/jpeg');
                    break;
                case 'png':
                    prev.push('image/png');
                    break;
                case 'svg':
                    prev.push('image/svg+xml');
                    break;
            }
            return prev;
        }, []).join(', ');
    });
    /**
   * Whether the signature line should be shown.
   *
   * @type {boolean}
   */ var showLine = (0, $8bTPG.computed)(()=>{
        return mode.value !== 'upload' && line.value;
    });
    /**
   * Whether the signature text input should be shown.
   *
   * @type {boolean}
   */ var showInput = (0, $8bTPG.computed)(()=>{
        return !uploaded.value && mode.value === 'type';
    });
    /**
   * Whether the signature placeholder should be shown.
   *
   * @type {boolean}
   */ var showPlaceholder = (0, $8bTPG.computed)(()=>{
        return (!text.value && mode.value === 'type' || !drawn.value && mode.value === 'draw') && placeholder.value !== false;
    });
    /**
   * Whether the upload container should be shown.
   *
   * @type {boolean}
   */ var showUploadContainer = (0, $8bTPG.computed)(()=>{
        return mode.value === 'upload';
    });
    /**
   * Whether the file upload controllers should be shown.
   *
   * @type {boolean}
   */ var showUpload = (0, $8bTPG.computed)(()=>{
        return mode.value === 'upload' && !created.value;
    });
    /**
   * Whether file upload preview should be shown.
   *
   * @type {boolean}
   */ var showPreview = (0, $8bTPG.computed)(()=>{
        return mode.value === 'upload' && created.value;
    });
    /**
   * Whether signature draw pad should be shown.
   *
   * @type {boolean}
   */ var showPad = (0, $8bTPG.computed)(()=>{
        return mode.value === 'draw';
    });
    /**
   * Whether undo and redo buttons should be shown.
   *
   * @type {boolean}
   */ var showUndos = (0, $8bTPG.computed)(()=>{
        return mode.value === 'draw' && (redos.value.length || drawn.value) && !drawing.value && canUndo.value;
    });
    /**
   * Whether color selector should be shown.
   *
   * @type {boolean}
   */ var showColors = (0, $8bTPG.computed)(()=>{
        return (mode.value === 'upload' && created.value || mode.value === 'type' || mode.value === 'draw') && !drawing.value && colors.value.length > 1 && !isMouseOver.value;
    });
    /**
   * Whether mode selector should be shown.
   *
   * @type {boolean}
   */ var showModes = (0, $8bTPG.computed)(()=>{
        return !drawing.value && modes.value.length > 1;
    });
    /**
   * Whether font selector should be shown.
   *
   * @type {boolean}
   */ var showFonts = (0, $8bTPG.computed)(()=>{
        return mode.value === 'type' && resolvedFonts.value.length > 1;
    });
    /**
   * Whether clear button should be shown.
   *
   * @type {boolean}
   */ var showClear = (0, $8bTPG.computed)(()=>{
        return (mode.value === 'type' && text.value || mode.value === 'upload' && created.value || mode.value === 'draw' && drawn.value || uploaded.value) && !isDisabled.value && !readonly.value && !drawing.value && canClear.value;
    });
    /**
   * The tabindex of focusable DOM parts.
   * 
   * @type {number|undefined}
   */ var tabindex = (0, $8bTPG.computed)(()=>{
        return isDisabled.value || readonly.value ? undefined : 0;
    });
    /**
   * The text of the placeholder.
   *
   * @type {string}
   */ var placeholderText = (0, $8bTPG.computed)(()=>{
        return Placeholder.value || form$.value.translations.vueform.elements.signature.placeholder;
    });
    /**
   * The text of the drag and drop area.
   *
   * @type {string}
   */ var dndText = (0, $8bTPG.computed)(()=>{
        return 'Drop an image here or';
    });
    /**
   * The text of the upload button.
   *
   * @type {string}
   */ var uploadButtonText = (0, $8bTPG.computed)(()=>{
        return 'Select image';
    });
    /**
   * The text of the img alt attribute.
   *
   * @type {string}
   */ var imgAltText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.imgAlt;
    });
    /**
   * The text of the img title attribute.
   *
   * @type {string}
   */ var imgTitleText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.imgTitle;
    });
    /**
   * The current text of font selector options.
   *
   * @type {string}
   */ var fontText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.font;
    });
    /**
   * The undo button's title.
   *
   * @type {string}
   */ var undoText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.undo;
    });
    /**
   * The redo button's title.
   *
   * @type {string}
   */ var redoText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.redo;
    });
    /**
   * The aria attributes of the mode selector.
   *
   * @type {object}
   */ var modeSelectorAria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-label': form$.value.translations.vueform.elements.signature.modeSelectorAriaLabel
        };
    });
    /**
   * The aria attributes of the font selector.
   *
   * @type {object}
   */ var fontSelectorAria = (0, $8bTPG.computed)(()=>{
        return {
            'aria-label': form$.value.translations.vueform.elements.signature.fontSelectorAriaLabel
        };
    });
    /**
   * The aria label of the signature wrapper.
   *
   * @type {string}
   */ var wrapperAriaLabel = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.wrapperAriaLabel;
    });
    /**
   * The aria label of the text input field.
   *
   * @type {string}
   */ var inputAriaLabel = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.inputAriaLabel;
    });
    /**
   * The aria label of the signature pad.
   *
   * @type {string}
   */ var padAriaLabel = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.padAriaLabel;
    });
    /**
   * The aria label of the clear button.
   *
   * @type {string}
   */ var clearAriaLabel = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.clearAriaLabel;
    });
    /**
   * The aria label of a color.
   *
   * @type {string}
   */ var colorAriaLabel = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.signature.colorAriaLabel;
    });
    /**
   * The width of signature pad.
   *
   * @type {number}
   */ var padWidth = (0, $8bTPG.computed)(()=>{
        return width.value * 2;
    });
    /**
   * The height of signature pad.
   *
   * @type {number}
   */ var padHeight = (0, $8bTPG.computed)(()=>{
        return height.value * 2;
    });
    /**
   * The style attributes of the signature pad.
   *
   * @type {object}
   */ var padStyle = (0, $8bTPG.computed)(()=>{
        return {
            width: "".concat(width.value, "px"),
            height: "".concat(height.value, "px")
        };
    });
    /**
   * The style attributes of the signature wrapper.
   *
   * @type {object}
   */ var wrapperStyle = (0, $8bTPG.computed)(()=>{
        var style = {
            height: "".concat(height.value, "px")
        };
        if (maxWidth.value !== 'auto') style.maxWidth = "".concat(maxWidth.value, "px");
        return style;
    });
    /**
   * The style attributes of the signature input when [`mode`](#property-mode) is `type`.
   *
   * @type {object}
   */ var inputStyle = (0, $8bTPG.computed)(()=>{
        return {
            fontFamily: fontFamily.value,
            fontWeight: fontWeight.value,
            fontSize: "".concat(fontSize.value, "px"),
            lineHeight: "".concat(fontSize.value, "px"),
            color: color.value,
            '-webkit-font-smoothing': 'auto'
        };
    });
    /**
   * The style attributes of the signature line.
   *
   * @type {object}
   */ var lineStyle = (0, $8bTPG.computed)(()=>{
        return {
            transform: "translateY(calc(".concat(fontSize.value / 2.2, "px))")
        };
    });
    // =============== METHODS ==============
    /**
   * Initalizes the [Signature Pad](https://github.com/szimek/signature_pad).
   *
   * @returns {void}
   */ var initPad = ()=>{
        if (pad.value || !pad$.value || modes.value.indexOf('draw') === -1 && modes.value.length || !available.value) return;
        if (!width.value) setWidth();
        (0, $ani5R.nextTick)(()=>{
            pad.value = new SignaturePad(pad$.value);
            var ctx = pad$.value.getContext('2d');
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.scale(2, 2);
            setDrawColor();
            pad.value.addEventListener('beginStroke', (e)=>{
                if (isDisabled.value || readonly.value) {
                    e.preventDefault();
                    return;
                }
                isMouseOver.value = true;
                drawn.value = true;
                drawing.value = true;
                redos.value = [];
            });
            pad.value.addEventListener('endStroke', ()=>{
                drawing.value = false;
                undosLeft.value++;
                debounceTransform(drawingToImage, 500);
            });
        });
    };
    /**
   * Resizes the signature pad to the current max width and clears any drawings.
   *
   * @returns {void}
   */ var resizePad = ()=>{
        setWidth();
        (0, $ani5R.nextTick)(()=>{
            var ctx = pad$.value.getContext('2d');
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.scale(2, 2);
            clearDrawnSignature();
        });
    };
    /**
   * Sets the element value as Blob from the current drawing.
   *
   * @returns {void}
   */ var drawingToImage = ()=>{
        return new Promise((resolve, reject)=>{
            var originalCanvas = pad$.value;
            var originalCtx = originalCanvas.getContext('2d');
            // Get the image data from the canvas
            var imageData = originalCtx.getImageData(0, 0, originalCanvas.width, originalCanvas.height);
            var data = imageData.data;
            // Find the bounding box of the drawing
            var minX = originalCanvas.width, minY = originalCanvas.height, maxX = 0, maxY = 0;
            for(var y = 0; y < originalCanvas.height; y++)for(var x = 0; x < originalCanvas.width; x++){
                var index = (y * originalCanvas.width + x) * 4;
                if (data[index + 3] > 0) {
                    // alpha channel > 0 means there's a drawn pixel
                    if (x < minX) minX = x;
                    if (y < minY) minY = y;
                    if (x > maxX) maxX = x;
                    if (y > maxY) maxY = y;
                }
            }
            // Check if there is any drawing
            if (minX > maxX || minY > maxY) {
                reject(new Error('No drawing found on the canvas.'));
                return;
            }
            // Create a new canvas for the bounding box of the drawing
            var drawingWidth = maxX - minX + 1;
            var drawingHeight = maxY - minY + 1;
            var drawingCanvas = document.createElement('canvas');
            var drawingCtx = drawingCanvas.getContext('2d');
            drawingCanvas.width = drawingWidth;
            drawingCanvas.height = drawingHeight;
            drawingCtx.putImageData(imageData, -minX, -minY);
            // Create a new canvas for the resized image
            var resizedCanvas = document.createElement('canvas');
            var resizedCtx = resizedCanvas.getContext('2d');
            var resizedWidth = uploadWidth.value;
            var resizedHeight = uploadHeight.value;
            resizedCanvas.width = resizedWidth;
            resizedCanvas.height = resizedHeight;
            // Calculate the new target dimensions while maintaining the aspect ratio
            var targetWidth = drawingWidth;
            var targetHeight = drawingHeight;
            if (targetWidth > resizedWidth || targetHeight > resizedHeight) {
                if (targetWidth / targetHeight > resizedWidth / resizedHeight) {
                    targetWidth = resizedWidth;
                    targetHeight = Math.floor(resizedWidth / drawingWidth * drawingHeight);
                } else {
                    targetHeight = resizedHeight;
                    targetWidth = Math.floor(resizedHeight / drawingHeight * drawingWidth);
                }
            }
            var offsetX = Math.floor((resizedWidth - targetWidth) / 2);
            var offsetY = Math.floor((resizedHeight - targetHeight) / 2);
            // Draw the original canvas content onto the resized canvas with proper scaling
            resizedCtx.drawImage(drawingCanvas, 0, 0, drawingWidth, drawingHeight, offsetX, offsetY, targetWidth, targetHeight);
            // Convert the resized canvas to Blob
            resizedCanvas.toBlob(function(blob) {
                value.value = blob;
                resolve();
                // Clean up the resized canvas
                resizedCanvas.remove();
            }, 'image/png');
        });
    };
    /**
   * Sets the element value as Blob from the currently typed signature.
   *
   * @returns {void}
   */ var typingToImage = ()=>{
        return new Promise((resolve, reject)=>{
            if (!text.value) {
                reject(new Error('No signature was typed.'));
                return;
            }
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            var displayWidth = uploadWidth.value;
            var displayHeight = uploadHeight.value;
            canvas.width = displayWidth;
            canvas.height = displayHeight;
            (0, $ani5R.nextTick)(()=>{
                ctx.clearRect(0, 0, displayWidth, displayHeight);
                // Determine the maximum font size that fits within the canvas
                var fontSize = displayHeight / 2; // Start with a large font size
                ctx.font = "".concat(fontWeight.value, " ").concat(fontSize, "px ").concat(fontFamily.value);
                // Measure the text width and adjust font size to fit within the canvas
                var textWidth = ctx.measureText(text.value).width;
                while(textWidth > displayWidth - 10 && fontSize > 10){
                    // 10px padding
                    fontSize -= 1;
                    ctx.font = "".concat(fontWeight.value, " ").concat(fontSize, "px ").concat(fontFamily.value);
                    textWidth = ctx.measureText(text.value).width;
                }
                ctx.fillStyle = color.value;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(text.value, displayWidth / 2, displayHeight / 2);
                canvas.toBlob(function(blob) {
                    value.value = blob;
                    canvas.remove();
                    resolve();
                }, 'image/png');
            });
        });
    };
    /**
   * Sets the element value as Blob from the currently uploaded signature.
   *
   * @returns {void}
   */ var uploadToImage = ()=>{
        if (!image.value) return;
        var file = image.value;
        var reader = new FileReader();
        creating.value = true;
        reader.onload = function(e) {
            var img = new Image();
            img.onload = function() {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                // Set canvas size to the image size
                canvas.width = img.width;
                canvas.height = img.height;
                // Draw the image on the canvas
                ctx.drawImage(img, 0, 0);
                // Get image data
                var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                var data = imageData.data;
                // Get the selected color
                var colorHex = color.value;
                var colorRGB = hexToRgb(colorHex);
                // Remove the background and change signature color to the selected color
                var threshold = 220;
                for(var i = 0; i < data.length; i += 4){
                    var r = data[i];
                    var g = data[i + 1];
                    var b = data[i + 2];
                    // If the pixel is light, make it transparent
                    if (r > threshold && g > threshold && b > threshold) data[i + 3] = 0;
                    else {
                        // Change the color to the selected color
                        data[i] = colorRGB.r;
                        data[i + 1] = colorRGB.g;
                        data[i + 2] = colorRGB.b;
                    }
                }
                // Put the processed image data back on the canvas
                ctx.putImageData(imageData, 0, 0);
                // Draw the processed image on the main canvas
                var mainCanvas = preview$.value;
                var mainCtx = mainCanvas.getContext('2d');
                // Clear the main canvas
                mainCtx.clearRect(0, 0, mainCanvas.width, mainCanvas.height);
                // Calculate the dimensions to keep aspect ratio within uploadWidth x uploadHeight
                var targetWidth = uploadWidth.value;
                var targetHeight = uploadHeight.value;
                var newWidth = targetWidth;
                var newHeight = newWidth / (img.width / img.height);
                if (newHeight > targetHeight) {
                    newHeight = targetHeight;
                    newWidth = newHeight * (img.width / img.height);
                }
                // Center the image on the main canvas
                var xOffset = (targetWidth - newWidth) / 2;
                var yOffset = (targetHeight - newHeight) / 2;
                // Draw the image on the main canvas
                mainCtx.drawImage(canvas, 0, 0, img.width, img.height, xOffset, yOffset, newWidth, newHeight);
                // Convert the resized canvas to Blob
                mainCanvas.toBlob(function(blob) {
                    value.value = blob;
                    created.value = true;
                    creating.value = false;
                    // Clean up the helper canvas
                    canvas.remove();
                }, 'image/png');
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    };
    /**
   * Undoes the last drawing when [`mode`](#property-mode) is `draw`.
   *
   * @returns {void}
   */ var undo = ()=>{
        if (!pad.value) return;
        var data = pad.value.toData();
        if (!data.length) return;
        redos.value.push(data.pop());
        pad.value.fromData(data);
        if (!data.length) drawn.value = false;
        undosLeft.value = data.length;
        debounceTransform(drawingToImage, 500);
    };
    /**
   * Redoes the last drawing when [`mode`](#property-mode) is `draw`.
   *
   * @returns {void}
   */ var redo = ()=>{
        if (!pad.value || !redos.value.length) return;
        var data = pad.value.toData() || [];
        data.push(redos.value.pop());
        pad.value.fromData(data);
        drawn.value = true;
        setDrawColor();
        undosLeft.value = data.length;
        debounceTransform(drawingToImage, 500);
    };
    /**
   * Clears the signature in all forms (drawn, typed, uploaded, loaded).
   *
   * @returns {void}
   */ var clearSignature = ()=>{
        text.value = null;
        image.value = null;
        created.value = false;
        value.value = null;
        clearDrawnSignature();
    };
    /**
   * Clears the drawn signature.
   *
   * @returns {void}
   */ var clearDrawnSignature = ()=>{
        var _pad$value;
        (_pad$value = pad.value) === null || _pad$value === void 0 || _pad$value.clear();
        drawn.value = false;
        redos.value = [];
    };
    /**
   * Loads Google Fonts dynamically by adding `<link>` tags to `<head>`.
   *
   * @returns {void}
   */ var loadFonts = ()=>{
        fonts.value.forEach((font)=>{
            var parts = font.split('@');
            var skip = parts[0].substr(0, 1) === '!';
            if (!skip) {
                var family = parts[0].replace('!', '').replace(/\s/g, '+');
                var weight = parts[1] || 400;
                var id = "font-".concat(family);
                if (!document.getElementById(id)) {
                    var link = document.createElement('link');
                    link.id = id;
                    link.rel = 'stylesheet';
                    link.href = "https://fonts.googleapis.com/css2?family=".concat(family, ":wght@").concat(weight, "&display=swap");
                    document.head.appendChild(link);
                }
            }
        });
    };
    /**
   * Sets the drawing color of the signature pad.
   *
   * @returns {void}
   */ var setDrawColor = ()=>{
        var { r, g, b } = hexToRgb(color.value);
        pad.value.penColor = "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
        if (drawn.value) pad.value.fromData(pad.value.toData().map((d)=>{
            d.penColor = pad.value.penColor;
            return d;
        }));
    };
    /**
   * Adjusts the typed signature's font size to fit into the input without overflow until [`minSize`](#option-min-size) or [`maxSize`](#option-max-size) is reached.
   *
   * @returns {void}
   */ var adjustFontSize = ()=>{
        if (!text.value) {
            fontSize.value = maxFontSize.value;
            return;
        }
        var ua = navigator.userAgent.toLowerCase();
        var isSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('android') == -1;
        var inputElement = input$.value;
        var styles = window.getComputedStyle(inputElement);
        var textIndent = parseFloat(styles.textIndent);
        var paddingRight = parseFloat(styles.paddingRight);
        var maxWidth = Math.ceil(inputElement.getBoundingClientRect().width) - textIndent;
        var size = fontSize.value;
        while(inputElement.scrollWidth + (isSafari ? paddingRight : 0) - textIndent > maxWidth && size > minFontSize.value){
            size--;
            inputElement.style.fontSize = size + 'px';
        }
        while(inputElement.scrollWidth + (isSafari ? paddingRight : 0) - textIndent <= maxWidth && size < maxFontSize.value){
            inputElement.style.fontSize = size + 1 + 'px';
            if (inputElement.scrollWidth + (isSafari ? paddingRight : 0) - textIndent > maxWidth) {
                inputElement.style.fontSize = size + 'px';
                break;
            }
            size++;
        }
        fontSize.value = size;
    };
    /**
   * Converts a HEX color to RGB.
   *
   * @param {string} hex* the color in HEX format
   * @returns {string}
   */ var hexToRgb = (hex)=>{
        hex = hex.replace(/^#/, '');
        var bigint = parseInt(hex, 16);
        var r = bigint >> 16 & 255;
        var g = bigint >> 8 & 255;
        var b = bigint & 255;
        return {
            r: r,
            g: g,
            b: b
        };
    };
    /**
   * Checks if a file complies with [`accept`](#option-accept) list and throws an alert if not.
   *
   * @param {File} file* the file to check
   * @returns {boolean}
   */ var checkFileExt = (file)=>{
        var accepted = accept.value.indexOf('jpg') !== -1 && accept.value.indexOf('jpeg') === -1 ? accept.value.concat([
            'jpeg'
        ]) : accept.value;
        var valid = file && accepted.indexOf(file === null || file === void 0 ? void 0 : file.name.split('.').pop()) !== -1;
        if (!valid) {
            alert(form$.value.__(form$.value.translations.vueform.elements.signature.unsupportedFormat, {
                extensions: accept.value.join(', ')
            }));
            return false;
        }
        return true;
    };
    /**
   * Checks if a file is under the allowed [`maxSize`](#option-max-size) and throws an alert if not.
   *
   * @param {File} file* the file to check
   * @returns {boolean}
   */ var checkFileSize = (file)=>{
        if (maxSize.value === -1) return true;
        if (file.size / 1024 > maxSize.value) {
            alert(form$.value.__(form$.value.translations.vueform.elements.signature.maxSizeError, {
                max: maxSize.value
            }));
            return false;
        }
        return true;
    };
    /**
   * Sets the [`width`](#property-width) to the current element width.
   *
   * @returns {void}
   */ var setWidth = ()=>{
        width.value = input.value.getBoundingClientRect().width;
    };
    /**
   * Sets the [`lastWidth`](#property-last-width) to the current element width.
   *
   * @returns {void}
   */ var setLastWidth = ()=>{
        lastWidth.value = input.value.getBoundingClientRect().width;
    };
    /**
   * Sets the [`mode`](#property-mode) to the first available mode from [`modes`](#option-modes). If none found, `draw` will be set.
   *
   * @returns {void}
   */ var setDefaultMode = function setDefaultMode() {
        var setDropdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        mode.value = modes.value[0] || 'draw';
        if (setDropdown) mode$.value.selected = resolvedModes.value[0] || {
            label: form$.value.translations.vueform.elements.signature.draw,
            value: 'draw',
            index: 0
        };
    };
    /**
   * Sets the [`fontFamily`](#property-font-family) and [`fontWeight`](#property-font-weight) to the first available from [`fonts`](#option-fonts). If none found, `cursive` and `400` will be set.
   *
   * @returns {void}
   */ var setDefaultFont = function setDefaultFont() {
        var setDropdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        fontFamily.value = fontFamilies.value[0] || 'cursive';
        fontWeight.value = fontWeights.value[0] || 400;
        if (setDropdown) {
            font$.value.selected = {};
            font$.value.pointed = {};
        }
    };
    /**
   * Sets the [`color`](#property-color) to the first available color from [`colors`](#option-colors). If none found, `#000000` will be set.
   *
   * @returns {void}
   */ var setDefaultColor = ()=>{
        color.value = colors.value[0] || '#000000';
    };
    /**
   * Sets the [`fontFamily`](#property-font-family) and [`fontWeight`](#property-font-weight) by the index of a font from [`fonts`](#option-fonts).
   *
   * @param {object} value* the selected font object (from [`resolvedFonts`](#property-resolved-fonts))
   * @returns {void}
   */ var setFont = (value)=>{
        fontFamily.value = fontFamilies.value[value.index];
        fontWeight.value = fontWeights.value[value.index];
    };
    /**
   * Checks the file contstraints and sets the value of [`image`](#property-image) and renders the selected file preview when [`mode`](#property-mode) is `upload`. If file constraints are not met it clears both.
   *
   * @param {File} file* the file to set as image
   * @returns {void}
   */ var setImage = (file)=>{
        if (checkFileExt(file) && checkFileSize(file)) {
            image.value = file;
            uploadToImage(image.value);
        } else {
            image.value = null;
            created.value = false;
        }
    };
    var debounceTransform = function debounceTransform(method) {
        var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
        if (debouncer.value) clearTimeout(debouncer.value);
        debouncer.value = setTimeout(/*#__PURE__*/ _asyncToGenerator(function*() {
            try {
                yield method.call();
            } catch (e) {
                value.value = null;
            }
        }), ms);
    };
    /**
   * Handles the input event of the input field.
   *
   * @param {Event} e the Event object
   * @returns {void}
   */ var handleInput = (e)=>{
        if (isDisabled.value || readonly.value) return;
        text.value = e.target.value;
    };
    /**
   * Handles the mode select.
   *
   * @param {object} value* the selected mode object (from [`resolvedModes`](#property-resolved-modes))
   * @returns {void}
   */ var handleModeSelect = (value)=>{
        if (isDisabled.value || readonly.value) return;
        mode.value = value.value;
        (0, $ani5R.nextTick)(()=>{
            if (mode.value === 'draw') pad$.value.focus();
            else if (mode.value === 'type') input$.value.focus();
            else if (mode.value === 'upload') uploadButton$.value.focus();
        });
    };
    /**
   * Handles the color select.
   *
   * @param {string} value the color to select (HEX)
   * @returns {void}
   */ var handleColorSelect = (value)=>{
        if (isDisabled.value || readonly.value) return;
        color.value = value;
    };
    /**
   * Handles the font select.
   *
   * @param {object} value* the selected font object (from [`resolvedFonts`](#property-resolved-fonts))
   * @returns {void}
   */ var handleFontSelect = (value)=>{
        font$.value.selected = {};
        if (isDisabled.value || readonly.value) return;
        setFont(value);
    };
    /**
   * Handle the clear button action.
   *
   * @returns {void}
   */ var handleClear = ()=>{
        if (isDisabled.value || readonly.value) return;
        if (!uploaded.value) {
            if (mode.value === 'draw') pad$.value.focus();
            else if (mode.value === 'type') input$.value.focus();
            else if (mode.value === 'upload') uploadButton$.value.focus();
        }
        clearSignature();
        isMouseOver.value = false;
    };
    /**
   * Handles the undo button action.
   *
   * @returns {void}
   */ var handleUndo = ()=>{
        if (isDisabled.value || readonly.value) return;
        undo();
        isMouseOver.value = false;
    };
    /**
   * Handles the redo button action.
   *
   * @returns {void}
   */ var handleRedo = ()=>{
        if (isDisabled.value || readonly.value) return;
        redo();
        isMouseOver.value = false;
    };
    /**
   * Handles the file select button action.
   *
   * @returns {void}
   */ var handleSelectClick = ()=>{
        if (isDisabled.value || readonly.value) return;
        file$.value.click();
    };
    /**
   * Handles the file selection.
   *
   * @returns {void}
   */ var handleFileSelect = (event)=>{
        if (isDisabled.value || readonly.value) return;
        var file = event.target.files[0];
        setImage(file);
        file$.value.value = '';
    };
    /**
   * Handles the drop event.
   *
   * @param {Event} e* the Event object
   * @returns {void}
   */ var handleDrop = (e)=>{
        if (isDisabled.value || readonly.value || !droppable.value) return;
        var file = e.dataTransfer.files[0];
        setImage(file);
    };
    /**
   * Handles the mouse leave event of the wrapper.
   * 
   * @returns {void}
   */ var handleMouseLeave = ()=>{
        isMouseOver.value = false;
    };
    /**
   * Handles the window resize event.
   *
   * @returns {void}
   */ var handleResize = ()=>{
        if (lastWidth.value === input.value.getBoundingClientRect().width) return;
        resizePad();
        adjustFontSize();
    };
    /**
   * Handler with debounce for resize event.
   *
   * @returns {void}
   */ var handleResizeDebounce = debounce(handleResize, 200, ()=>{
        setLastWidth();
    });
    // =============== HOOKS ================
    setDefaultMode();
    setDefaultFont();
    setDefaultColor();
    (0, $ani5R.onMounted)(()=>{
        if (autoload.value) loadFonts();
        setWidth();
        // Auto-select default mode
        if (mode$.value) mode$.value.selected = resolvedModes.value[0] || {
            label: form$.value.translations.vueform.elements.signature.draw,
            value: 'draw',
            index: 0
        };
        // Handling drag & drop
        var evts = [
            'drag',
            'dragstart',
            'dragenter',
            'dragleave',
            'dragend'
        ];
        evts.forEach((event)=>{
            input.value.addEventListener(event, (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if ([
                    'dragleave',
                    'dragend'
                ].indexOf(event) === -1) return;
                if (isDisabled.value || !droppable.value) return;
                dragging.value = false;
            });
        });
        input.value.addEventListener('dragover', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (isDisabled.value || !droppable.value) return;
            if (dragging.value !== true) dragging.value = true;
        });
        // listening for the actual drop event
        input.value.addEventListener('drop', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (isDisabled.value || !droppable.value) return;
            handleDrop(e);
            dragging.value = false;
        });
        (0, $ani5R.nextTick)(()=>{
            initPad();
            window.addEventListener('resize', handleResizeDebounce);
        });
        // ============== WATCHERS ==============
        (0, $8bTPG.watch)(maxFontSize, ()=>{
            adjustFontSize();
        }, {
            flush: 'post'
        });
        (0, $8bTPG.watch)(modes, ()=>{
            initPad();
            setDefaultMode(true);
        });
        (0, $8bTPG.watch)(available, ()=>{
            (0, $ani5R.nextTick)(()=>{
                initPad();
            });
        }, {
            flush: 'post'
        });
        (0, $8bTPG.watch)(color, ()=>{
            if (pad.value) setDrawColor();
            if (mode.value === 'upload' && created.value && !creating.value) uploadToImage();
        });
        (0, $8bTPG.watch)(columns, ()=>{
            setLastWidth();
            (0, $ani5R.nextTick)(()=>{
                handleResize();
                if (mode.value === 'upload' && created.value && !creating.value) uploadToImage();
            });
        });
        (0, $8bTPG.watch)(mode, ()=>{
            clearSignature();
        });
        (0, $8bTPG.watch)([
            height,
            maxWidth
        ], ()=>{
            resizePad();
            adjustFontSize();
        }, {
            flush: 'post'
        });
        (0, $8bTPG.watch)([
            text,
            fontFamily
        ], ()=>{
            (0, $ani5R.nextTick)(()=>{
                adjustFontSize();
            });
        }, {
            flush: 'post'
        });
        (0, $8bTPG.watch)(text, ()=>{
            debounceTransform(typingToImage, 1000);
        }, {
            flush: 'post'
        });
        (0, $8bTPG.watch)(fonts, ()=>{
            if (autoload.value) loadFonts();
        });
    });
    (0, $ani5R.onBeforeUnmount)(()=>{
        window.removeEventListener('resize', handleResizeDebounce);
    });
    return {
        mode$: mode$,
        font$: font$,
        input$: input$,
        preview$: preview$,
        pad$: pad$,
        file$: file$,
        upload$: upload$,
        uploadButton$: uploadButton$,
        mode: mode,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        color: color,
        text: text,
        fontSize: fontSize,
        pad: pad,
        image: image,
        created: created,
        creating: creating,
        dragging: dragging,
        drawn: drawn,
        drawing: drawing,
        redos: redos,
        undosLeft: undosLeft,
        width: width,
        lastWidth: lastWidth,
        fontFamilies: fontFamilies,
        fontWeights: fontWeights,
        uploaded: uploaded,
        processing: processing,
        droppable: droppable,
        resolvedModes: resolvedModes,
        resolvedFonts: resolvedFonts,
        fileAccept: fileAccept,
        showLine: showLine,
        showInput: showInput,
        showPlaceholder: showPlaceholder,
        showUploadContainer: showUploadContainer,
        showUpload: showUpload,
        showPreview: showPreview,
        showPad: showPad,
        showUndos: showUndos,
        showColors: showColors,
        showModes: showModes,
        showFonts: showFonts,
        showClear: showClear,
        tabindex: tabindex,
        placeholderText: placeholderText,
        dndText: dndText,
        uploadButtonText: uploadButtonText,
        imgAltText: imgAltText,
        imgTitleText: imgTitleText,
        fontText: fontText,
        undoText: undoText,
        redoText: redoText,
        modeSelectorAria: modeSelectorAria,
        fontSelectorAria: fontSelectorAria,
        wrapperAriaLabel: wrapperAriaLabel,
        inputAriaLabel: inputAriaLabel,
        padAriaLabel: padAriaLabel,
        colorAriaLabel: colorAriaLabel,
        clearAriaLabel: clearAriaLabel,
        padWidth: padWidth,
        padHeight: padHeight,
        padStyle: padStyle,
        wrapperStyle: wrapperStyle,
        inputStyle: inputStyle,
        lineStyle: lineStyle,
        initPad: initPad,
        resizePad: resizePad,
        drawingToImage: drawingToImage,
        typingToImage: typingToImage,
        uploadToImage: uploadToImage,
        undo: undo,
        redo: redo,
        clearSignature: clearSignature,
        clearDrawnSignature: clearDrawnSignature,
        loadFonts: loadFonts,
        setDrawColor: setDrawColor,
        adjustFontSize: adjustFontSize,
        hexToRgb: hexToRgb,
        checkFileExt: checkFileExt,
        checkFileSize: checkFileSize,
        setWidth: setWidth,
        setLastWidth: setLastWidth,
        setDefaultMode: setDefaultMode,
        setDefaultFont: setDefaultFont,
        setDefaultColor: setDefaultColor,
        setFont: setFont,
        handleInput: handleInput,
        handleModeSelect: handleModeSelect,
        handleColorSelect: handleColorSelect,
        handleFontSelect: handleFontSelect,
        handleClear: handleClear,
        handleUndo: handleUndo,
        handleRedo: handleRedo,
        handleSelectClick: handleSelectClick,
        handleFileSelect: handleFileSelect,
        handleDrop: handleDrop,
        handleMouseLeave: handleMouseLeave,
        handleResize: handleResize,
        handleResizeDebounce: handleResizeDebounce
    };
}
var SignatureElement = {
    name: 'SignatureElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'text',
            private: true
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            localized: true,
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        modes: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[
                    'draw',
                    'type',
                    'upload'
                ]
        },
        fonts: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[
                    'Caveat@400',
                    'Sacramento@400',
                    'Dancing Script@400'
                ]
        },
        autoload: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        minFontSize: {
            required: false,
            type: [
                Number
            ],
            default: 10
        },
        maxFontSize: {
            required: false,
            type: [
                Number
            ],
            default: 60
        },
        colors: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[
                    '#000000',
                    '#2558b2',
                    '#f22f30'
                ]
        },
        invertColors: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[
                    '#000000'
                ]
        },
        maxWidth: {
            required: false,
            type: [
                Number,
                String
            ],
            default: 'auto'
        },
        height: {
            required: false,
            type: [
                Number
            ],
            default: 160
        },
        uploadWidth: {
            required: false,
            type: [
                Number
            ],
            default: 480
        },
        uploadHeight: {
            required: false,
            type: [
                Number
            ],
            default: 160
        },
        maxSize: {
            required: false,
            type: [
                Number
            ],
            default: 2048
        },
        accept: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[
                    'jpg',
                    'png',
                    'svg'
                ]
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object,
                Boolean
            ],
            localized: true,
            default: null
        },
        line: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        canClear: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        canUndo: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        canDrop: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$G,
            base$19,
            base$H,
            base$P,
            base$M,
            base$w,
            useSignature,
            signature,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$v,
            base$V,
            base$J,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$7 = function base(props, context, dependencies) {
    var { lazy } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var value = dependencies.value;
    // =============== METHODS ==============
    /**
   * Handles `update` event if not lazy.
   *
   * @param {string} val* value of the element
   * @returns {void}
   * @private
   */ var handleUpdate = (val)=>{
        if (lazy.value) return;
        value.value = val;
    };
    return {
        handleUpdate: handleUpdate
    };
};
var SliderElement = {
    name: 'SliderElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'slider',
            private: true
        },
        default: {
            required: false,
            type: [
                Number,
                Array
            ],
            default: 0
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        min: {
            required: false,
            type: [
                Number
            ],
            default: 0
        },
        max: {
            required: false,
            type: [
                Number
            ],
            default: 100
        },
        step: {
            required: false,
            type: [
                Number
            ],
            default: 1
        },
        tooltips: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        showTooltip: {
            required: false,
            type: [
                String
            ],
            default: 'always'
        },
        tooltipPosition: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        merge: {
            required: false,
            type: [
                Number
            ],
            default: -1
        },
        format: {
            required: false,
            type: [
                Object,
                Function
            ],
            default: null
        },
        orientation: {
            required: false,
            type: [
                String
            ],
            default: 'horizontal'
        },
        direction: {
            required: false,
            type: [
                String
            ],
            default: 'ltr'
        },
        lazy: {
            required: false,
            type: [
                Boolean
            ],
            default: true,
            private: true
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            min,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$G,
            slider,
            base$P,
            slider$1,
            base$19,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$x,
            base$7,
            base$V,
            base$J,
            base$Y
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$6 = function base(props, context, dependencies) {
    var { content } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var { fieldSlots, el$: el$1, form$ } = dependencies;
    // =============== INJECT ===============
    var config$ = (0, $ani5R.inject)('config$');
    // ============== COMPUTED ==============
    /**
   * Determines if HTML content should be rendered for the element.
   *
   * @type {boolean}
   * @private
   */ var isHtml = (0, $8bTPG.computed)(()=>{
        return typeof resolvedContent.value === 'string';
    });
    /**
   * The resolved content if it is a string or a function.
   *
   * @type {any}
   */ var resolvedContent = (0, $8bTPG.computed)(()=>{
        var _content$value, _content$value2;
        var resolvedContent = typeof content.value === 'function' ? content.value(el$1.value) : content.value;
        // Content is multilingual
        if (content.value && typeof content.value === 'object' && !((_content$value = content.value) !== null && _content$value !== void 0 && _content$value.render) && !((_content$value2 = content.value) !== null && _content$value2 !== void 0 && _content$value2.template)) {
            resolvedContent = Object.keys(resolvedContent).reduce((prev, curr)=>_objectSpread2$1(_objectSpread2$1({}, prev), {}, {
                    [curr]: typeof resolvedContent[curr] === 'function' ? resolvedContent[curr](el$1.value) : resolvedContent[curr]
                }), {});
            resolvedContent = localize(resolvedContent, config$.value, form$.value);
        }
        return resolvedContent;
    });
    /**
   * Resolves the content as component.
   *
   * @type {object}
   * @private
   */ var componentContent = (0, $8bTPG.computed)(()=>{
        var _resolvedContent$valu, _resolvedContent$valu2;
        if (!((_resolvedContent$valu = resolvedContent.value) !== null && _resolvedContent$valu !== void 0 && _resolvedContent$valu.render) && !((_resolvedContent$valu2 = resolvedContent.value) !== null && _resolvedContent$valu2 !== void 0 && _resolvedContent$valu2.template)) return resolvedContent.value;
        return resolveComponent(resolvedContent.value);
    });
    /**
   * Resolves the content as slot.
   *
   * @type {object}
   * @private
   */ var slotContent = (0, $8bTPG.computed)(()=>{
        var _fieldSlots$value$def, _fieldSlots$value$def2;
        if (!((_fieldSlots$value$def = fieldSlots.value.default) !== null && _fieldSlots$value$def !== void 0 && _fieldSlots$value$def.render) && !((_fieldSlots$value$def2 = fieldSlots.value.default) !== null && _fieldSlots$value$def2 !== void 0 && _fieldSlots$value$def2.template)) return fieldSlots.value.default;
        return resolveComponent(fieldSlots.value.default);
    });
    /**
   * Adds el$ prop to component.
   * 
   * @param {object} component - the base component
   * @returns {object}
   * @private
   */ var resolveComponent = (component)=>{
        component = _objectSpread2$1({}, component);
        if (!component.props) component.props = [
            'el$'
        ];
        else if (Array.isArray(component.props) && component.props.indexOf('el$') === -1) component.props.push('el$');
        else if (!Array.isArray(component.props) && !component.props.el$) component.props['el$'] = {
            type: Object,
            required: false,
            default: ()=>({})
        };
        return component;
    };
    return {
        isHtml: isHtml,
        componentContent: componentContent,
        slotContent: slotContent,
        resolvedContent: resolvedContent
    };
};
var StaticElement = {
    name: 'StaticElement',
    mixins: [
        BaseElement,
        HasView
    ],
    emits: [
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'static',
            private: true
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        content: {
            required: false,
            type: [
                String,
                Object,
                Function
            ],
            default: ''
        },
        wrap: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        tag: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        allowHtml: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        href: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        target: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        src: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        alt: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        title: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        width: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        height: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        top: {
            required: false,
            type: [
                String,
                Number
            ],
            default: 0
        },
        bottom: {
            required: false,
            type: [
                String,
                Number
            ],
            default: 0
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            static_$1,
            base$1h,
            static_$2,
            base$19,
            base$14,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$Z,
            static_$3,
            base$Y,
            base$6
        ];
        context.slots = [
            'default',
            'label',
            'info',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, static_(props, context));
    }
};
var base$5 = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fire = dependencies.fire;
    var el$1 = dependencies.el$;
    /**
   * Handles `tag` event.
   *
   * @param {string} searchQuery* the current search query.
   * @returns {void}
   * @private
   */ var handleTag = (searchQuery)=>{
        fire('tag', searchQuery, el$1.value);
    };
    return {
        handleTag: handleTag
    };
};
var TagsElement = {
    name: 'TagsElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'select',
        'deselect',
        'search-change',
        'open',
        'close',
        'tag',
        'clear',
        'paste',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'tags',
            private: true
        },
        default: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        onSelect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onDeselect: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onSearchChange: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onOpen: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClose: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onTag: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onClear: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onPaste: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        items: {
            required: false,
            type: [
                Object,
                Array,
                Function,
                String
            ],
            localized: true,
            default: ()=>({})
        },
        labelProp: {
            type: [
                String
            ],
            required: false,
            default: 'label'
        },
        valueProp: {
            type: [
                String
            ],
            required: false,
            default: 'value'
        },
        dataKey: {
            type: [
                String
            ],
            required: false,
            default: undefined
        },
        searchParam: {
            type: [
                String
            ],
            required: false,
            default: 'query'
        },
        search: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        trackBy: {
            type: [
                String,
                Array
            ],
            required: false,
            default: 'label'
        },
        strict: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        breakTags: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        create: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        },
        appendNewOption: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        addOptionOn: {
            type: [
                Array
            ],
            required: false,
            default: ()=>[
                    'enter'
                ]
        },
        allowAbsent: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        object: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        limit: {
            type: [
                Number
            ],
            required: false,
            default: -1
        },
        max: {
            type: [
                Number
            ],
            required: false,
            default: -1
        },
        groups: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        groupLabel: {
            type: [
                String
            ],
            required: false,
            default: 'label'
        },
        groupOptions: {
            type: [
                String
            ],
            required: false,
            default: 'items'
        },
        groupHideEmpty: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        groupSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        openDirection: {
            type: [
                String
            ],
            required: false,
            default: 'bottom'
        },
        appendToBody: {
            type: [
                Boolean
            ],
            required: false,
            default: false,
            native: false
        },
        appendTo: {
            type: [
                String
            ],
            required: false,
            default: undefined,
            native: false
        },
        canClear: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        clearOnSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        closeOnSelect: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        closeOnDeselect: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        clearOnRefetch: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        delay: {
            type: [
                Number
            ],
            required: false,
            default: -1
        },
        minChars: {
            type: [
                Number
            ],
            required: false,
            default: 0
        },
        resolveOnLoad: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        filterResults: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        clearOnSearch: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        hideSelected: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        showOptions: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        caret: {
            type: [
                Boolean
            ],
            required: false,
            default: true
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        noOptionsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noOptions',
            localized: true
        },
        noResultsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: undefined,
            '@default': 'locale.multiselect.noResults',
            localized: true
        },
        autocomplete: {
            type: [
                String
            ],
            required: false
        },
        inputType: {
            type: [
                String
            ],
            required: false,
            default: 'text'
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            tags$4,
            base$S,
            array$1,
            base$Z,
            base$K,
            base$1h,
            tags$5,
            base$W,
            base$G,
            base$H,
            base$L,
            tags$1,
            base$P,
            tags$2,
            base$19,
            array,
            tags$3,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$d,
            base$5,
            base$c,
            tags,
            base$V,
            base$J,
            base$Y,
            base$w
        ];
        context.slots = [
            'tag',
            'option',
            'placeholder',
            'group-label',
            'before-list',
            'after-list',
            'no-results',
            'no-options',
            'caret',
            'spinner',
            'clear',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$4 = function base(props, context, dependencies) {
    var { autogrow } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var input = dependencies.input;
    var value = dependencies.value;
    // =============== METHODS ==============
    /**
   * Updates the height of the input based in its contents when [`autogrow`](#option-autogrow) is enabled.
   *
   * @returns {void}
   */ var autosize = ()=>{
        if (!autogrow.value) return;
        form$.value.$vueform.services.autosize.update(input.value);
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(autogrow, (newValue)=>{
        if (newValue) form$.value.$vueform.services.autosize(input.value);
        else form$.value.$vueform.services.autosize.destroy(input.value);
    });
    (0, $8bTPG.watch)(value, ()=>{
        autosize();
    });
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        if (autogrow.value) (0, $ani5R.nextTick)(()=>{
            form$.value.$vueform.services.autosize(input.value);
        });
    });
    return {
        autosize: autosize
    };
};
var multilingual = function multilingual(props, context, dependencies) {
    var { autosize } = base$4(props, context, dependencies);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        form$.value.on('language', ()=>{
            autosize();
        });
    });
    return {
        autosize: autosize
    };
};
var TextareaElement = {
    name: 'TextareaElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'focus',
        'keydown',
        'keyup',
        'keypress',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'textarea',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            localized: true,
            default: null
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        autogrow: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        rows: {
            required: false,
            type: [
                Number
            ],
            default: 3
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeydown: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeyup: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeypress: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            text$1,
            base$19,
            text$2,
            base$P,
            base$M,
            base$4,
            textarea,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$v,
            base$b,
            base$V,
            base$J,
            base$Y,
            base$9,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var TextElement = {
    name: 'TextElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'focus',
        'keydown',
        'keyup',
        'keypress',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'text',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            localized: true,
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        inputType: {
            required: false,
            type: [
                String
            ],
            default: 'text'
        },
        forceNumbers: {
            required: false,
            type: [
                Boolean
            ],
            default: null
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        autocomplete: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeydown: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeyup: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeypress: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            text$1,
            base$19,
            text$2,
            base$L,
            base$P,
            base$M,
            text,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$v,
            base$b,
            base$V,
            base$J,
            base$Y,
            base$9,
            base$K,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var ToggleElement = {
    name: 'ToggleElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'toggle',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Boolean
            ],
            default: undefined // falseValue
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        text: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        labels: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        trueValue: {
            required: false,
            type: [
                Boolean,
                String,
                Number
            ],
            default: true
        },
        falseValue: {
            required: false,
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        },
        extendOptions: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        align: {
            required: false,
            type: [
                String
            ],
            default: undefined
        },
        standalone: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            boolean,
            base$Z,
            base$1h,
            base$T,
            base$W,
            toggle,
            base$G,
            base$19,
            base$H,
            base$P,
            base$E,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$x,
            base$C,
            toggle$1,
            base$J,
            base$Y,
            base$D
        ];
        context.slots = [
            'default',
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$3 = function base(props, context, dependencies) {
    var { endpoint, method } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    var input = dependencies.input;
    // ================ DATA ================
    /**
   * Whether the editor is focused.
   *
   * @type {boolean}
   */ var focused = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    /**
   * The endpoint that uploads attachment. Can be changed by setting [`endpoint`](#endpoint) option.
   *
   * @type {string}
   * @default `config.endpoints.attachment.url`
   * @private
   */ var editorEndpoint = (0, $8bTPG.computed)(()=>{
        return endpoint.value || form$.value.$vueform.config.endpoints.attachment.url;
    });
    /**
   * The method to use to upload attachment. Can be changed by setting [`method`](#method) option.
   *
   * @type {string}
   * @default `config.endpoints.attachment.method`
   * @private
   */ var editorMethod = (0, $8bTPG.computed)(()=>{
        return method.value || form$.value.$vueform.config.endpoints.attachment.method;
    });
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        input.value.editor$.addEventListener('focus', ()=>{
            focused.value = true;
        });
        input.value.editor$.addEventListener('blur', ()=>{
            focused.value = false;
        });
    });
    return {
        editorEndpoint: editorEndpoint,
        editorMethod: editorMethod,
        focused: focused
    };
};
var base$2 = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var fire = dependencies.fire;
    var listeners = dependencies.listeners;
    // =============== METHODS ==============
    /**
   * Handles `alert` event.
   *
   * @param {string} message* alert message
   * @returns {void}
   * @private
   */ var handleAlert = (message)=>{
        fire('alert', message);
        /* istanbul ignore else */ if (!listeners.value.alert) alert(message);
    };
    return {
        handleAlert: handleAlert
    };
};
var EditorElement = {
    name: 'EditorElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'alert',
        'error',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 'editor',
            private: true
        },
        default: {
            required: false,
            type: [
                String,
                Number,
                Object
            ],
            localized: true,
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        onError: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onAlert: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        accept: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        acceptMimes: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        endpoint: {
            required: false,
            type: [
                String,
                Function,
                Promise
            ],
            default: null,
            '@default': 'config.endpoints.attachment.url'
        },
        method: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'config.endpoints.attachment.method'
        },
        hideTools: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$O,
            base$Z,
            base$1h,
            base$T,
            base$W,
            text$1,
            base$19,
            text$2,
            base$P,
            base$M,
            editor,
            base$14,
            base$N,
            base$12,
            base$11,
            base$3,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$2,
            base$q,
            base$b,
            base$V,
            base$J,
            editor$1,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, base$R(props, context));
    }
};
var base$1 = function base(props, context, dependencies) {
    // ============ DEPENDENCIES ============
    var form$ = dependencies.form$;
    // ============== COMPUTED ===============
    /**
   * The language code of the currently selected language (2 letters).
   *
   * @type {string}
   */ var language = (0, $8bTPG.computed)(()=>{
        return form$.value.selectedLanguage;
    });
    /**
   * Available language codes.
   *
   * @type {array}
   */ var languages = (0, $8bTPG.computed)(()=>{
        return keys_1(form$.value.options.languages);
    });
    return {
        language: language,
        languages: languages
    };
};
var TTextareaElement = {
    name: 'TTextareaElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'focus',
        'keydown',
        'keyup',
        'keypress',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 't-textarea',
            private: true
        },
        default: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: null
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        autogrow: {
            required: false,
            type: [
                Boolean
            ],
            default: true
        },
        rows: {
            required: false,
            type: [
                Number
            ],
            default: 3
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeydown: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeyup: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeypress: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            base$1,
            multilingual$6,
            multilingual$2,
            multilingual$7,
            base$19,
            multilingual$3,
            multilingual$5,
            multilingual$1,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$p,
            multilingual,
            base$v,
            base$b,
            base$V,
            multilingual$4,
            base$Y,
            base$9,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, multilingual$8(props, context));
    }
};
var TTextElement = {
    name: 'TTextElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'focus',
        'keydown',
        'keyup',
        'keypress',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 't-text',
            private: true
        },
        default: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: undefined
        },
        addons: {
            required: false,
            type: [
                Object
            ],
            localized: true,
            default: ()=>({})
        },
        autocomplete: {
            required: false,
            type: [
                String,
                Number
            ],
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        floating: {
            required: false,
            type: [
                String,
                Boolean,
                Object
            ],
            localized: true,
            default: null
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        inputType: {
            required: false,
            type: [
                String
            ],
            default: 'text'
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        readonly: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        loading: {
            type: [
                Boolean
            ],
            required: false,
            default: false
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeydown: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeyup: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onKeypress: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$Z,
            base$K,
            base$1h,
            base$T,
            base$W,
            base$F,
            base$z,
            base$1,
            multilingual$6,
            multilingual$2,
            multilingual$7,
            base$19,
            multilingual$3,
            base$L,
            multilingual$5,
            multilingual$1,
            base$14,
            base$N,
            base$12,
            base$11,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$v,
            base$b,
            base$V,
            multilingual$4,
            base$Y,
            base$9,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after',
            'addon-before',
            'addon-after'
        ];
        return _objectSpread2$1({}, multilingual$8(props, context));
    }
};
var TEditorElement = {
    name: 'TEditorElement',
    mixins: [
        BaseElement,
        HasView,
        HasChange,
        HasData,
        HasValidation
    ],
    emits: [
        'change',
        'blur',
        'alert',
        'error',
        'beforeCreate',
        'created',
        'beforeMount',
        'mounted',
        'beforeUpdate',
        'updated',
        'beforeUnmount',
        'unmounted'
    ],
    props: {
        type: {
            required: false,
            type: [
                String
            ],
            default: 't-editor',
            private: true
        },
        default: {
            required: false,
            type: [
                Object,
                String,
                Number
            ],
            localized: true,
            default: null
        },
        debounce: {
            required: false,
            type: [
                Number
            ],
            default: null
        },
        disabled: {
            required: false,
            type: [
                Boolean,
                Function,
                Array,
                Object
            ],
            default: false
        },
        id: {
            required: false,
            type: [
                String
            ],
            default: null
        },
        placeholder: {
            required: false,
            type: [
                String,
                Object
            ],
            localized: true,
            default: null
        },
        onError: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        onAlert: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        },
        accept: {
            required: false,
            type: [
                Array
            ],
            default: null
        },
        acceptMimes: {
            required: false,
            type: [
                Array
            ],
            default: null
        },
        endpoint: {
            required: false,
            type: [
                String,
                Function,
                Promise
            ],
            default: null,
            '@default': 'config.endpoints.attachment.url'
        },
        method: {
            required: false,
            type: [
                String
            ],
            default: null,
            '@default': 'config.endpoints.attachment.method'
        },
        hideTools: {
            required: false,
            type: [
                Array
            ],
            default: ()=>[]
        },
        onBlur: {
            required: false,
            type: [
                Function
            ],
            default: null,
            private: true
        }
    },
    setup (props, ctx) {
        var context = _objectSpread2$1({}, ctx);
        context.features = [
            base$X,
            base$1e,
            base$1d,
            base$_,
            base$Q,
            base$S,
            base$Z,
            base$1h,
            base$T,
            base$W,
            base$1,
            multilingual$6,
            multilingual$2,
            multilingual$7,
            base$19,
            multilingual$3,
            multilingual$5,
            teditor,
            base$14,
            base$N,
            base$12,
            base$11,
            base$3,
            base$1f,
            base$13,
            base$10,
            base$p,
            base$2,
            base$q,
            base$b,
            base$V,
            multilingual$4,
            base$Y,
            base$w
        ];
        context.slots = [
            'label',
            'info',
            'required',
            'description',
            'before',
            'between',
            'after'
        ];
        return _objectSpread2$1({}, multilingual$8(props, context));
    }
};
var CheckboxgroupCheckbox = {
    name: 'CheckboxgroupCheckbox',
    props: {
        item: {
            type: [
                Object,
                String,
                Number
            ],
            required: true
        },
        value: {
            type: [
                String,
                Number,
                Boolean
            ],
            required: true
        },
        items: {
            type: [
                Object,
                Array
            ],
            required: true
        },
        index: {
            type: [
                Number
            ],
            required: true
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        standalone: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, context) {
        var { value, item } = (0, $8bTPG.toRefs)(props);
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * Whether the checkbox should be disabled.
     * 
     * @type {boolean}
     */ var isDisabled = (0, $8bTPG.computed)(()=>{
            var _item$value;
            return el$1.value.disabledItems.map((i)=>String(i)).indexOf(String(value.value)) !== -1 || el$1.value.isDisabled || !!((_item$value = item.value) !== null && _item$value !== void 0 && _item$value.disabled);
        });
        /**
     * Whether the checkbox is checked.
     * 
     * @type {boolean}
     */ var checked = (0, $8bTPG.computed)(()=>{
            var _el$$value$value, _el$$value$value2;
            return ((_el$$value$value = el$1.value.value) === null || _el$$value$value === void 0 ? void 0 : _el$$value$value.indexOf(String(value.value))) !== -1 || ((_el$$value$value2 = el$1.value.value) === null || _el$$value$value2 === void 0 ? void 0 : _el$$value$value2.indexOf(Number(value.value))) !== -1;
        });
        /**
     * The `id` attribute of the input.
     * 
     * @type {boolean}
     */ var id = (0, $8bTPG.computed)(()=>{
            return "".concat(el$1.value.fieldId, "-").concat(value.value);
        });
        /**
     * The `name` attribute of the input.
     * 
     * @type {boolean}
     */ var name = (0, $8bTPG.computed)(()=>{
            return "".concat(el$1.value.path, "-").concat(value.value);
        });
        // =============== METHODS ==============
        /**
     * Handles `keydown` event.
     * 
     * @param {Event} e* event object 
     * @returns {void}
     * @private
     */ var handleKeydown = (e)=>{
            if ([
                'ArrowRight',
                'ArrowDown'
            ].indexOf(e.key) !== -1) {
                e.preventDefault();
                var next = e.target.nextElementSibling;
                if ((next === null || next === void 0 ? void 0 : next.getAttribute('role')) === 'checkbox') next.focus();
            } else if ([
                'ArrowLeft',
                'ArrowUp'
            ].indexOf(e.key) !== -1) {
                e.preventDefault();
                var previous = e.target.previousElementSibling;
                if ((previous === null || previous === void 0 ? void 0 : previous.getAttribute('role')) === 'checkbox') previous.focus();
            }
        };
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            isDisabled: isDisabled,
            id: id,
            name: name,
            checked: checked,
            handleKeydown: handleKeydown
        };
    }
};
var base = function base(props, context, dependencies) {
    var el$1 = dependencies.el$;
    var form$ = dependencies.form$;
    // ============== COMPUTED ==============
    /**
   * Whether the preview component should be visible.
   * 
   * @type {boolean}
   */ var visible = (0, $8bTPG.computed)(()=>{
        return el$1.value.stage > 0;
    });
    /**
   * Whether the file has link and should be clickable.
   * 
   * @type {boolean}
   */ var hasLink = (0, $8bTPG.computed)(()=>{
        return el$1.value.link && el$1.value.clickable;
    });
    /**
   * Whether the preview has upload error.
   * 
   * @type {boolean}
   */ var hasError = (0, $8bTPG.computed)(()=>{
        return el$1.value.hasUploadError;
    });
    /**
   * The link for the file.
   * 
   * @type {string}
   */ var link = (0, $8bTPG.computed)(()=>{
        return el$1.value.link;
    });
    /**
   * The filename to display.
   * 
   * @type {string}
   */ var filename = (0, $8bTPG.computed)(()=>{
        var filename = el$1.value.filename && typeof el$1.value.filename === 'string' ? el$1.value.filename.split('\\').pop().split('/').pop() : el$1.value.filename;
        if (filename) filename = filename.split('?')[0];
        return filename;
    });
    /**
   * Whether the file should be clickable if it is already permantently uploaded.
   * 
   * @type {boolean}
   */ var clickable = (0, $8bTPG.computed)(()=>{
        return el$1.value.clickable;
    });
    /**
   * Whether the temporary or permanent file is uploaded.
   * 
   * @type {boolean}
   */ var uploaded = (0, $8bTPG.computed)(()=>{
        return el$1.value.stage > 1;
    });
    /**
   * Whether the file is currently uploading.
   * 
   * @type {boolean}
   */ var uploading = (0, $8bTPG.computed)(()=>{
        return el$1.value.uploading;
    });
    /**
   * The percentage of progress when the file is being temporarily uploaded (0-100).
   * 
   * @type {number}
   */ var progress = (0, $8bTPG.computed)(()=>{
        return el$1.value.progress;
    });
    /**
   * Whether the file can be removed. 
   * 
   * @type {boolean}
   */ var canRemove = (0, $8bTPG.computed)(()=>{
        return (el$1.value.canRemove || el$1.value.uploading) && !el$1.value.isDisabled;
    });
    /**
   * Whether temporary file can be uploaded.
   * 
   * @type {boolean}
   */ var canUploadTemp = (0, $8bTPG.computed)(()=>{
        return el$1.value.canUploadTemp;
    });
    /**
   * The text for upload button. Can be also changed in the locale file: `vueform.elements.file.upload`
   * 
   * @type {string}
   */ var uploadText = (0, $8bTPG.computed)(()=>{
        return form$.value.translations.vueform.elements.file.upload;
    });
    /**
   * The `aria-labelledby` attribute of the preview.
   * 
   * @type {string}
   */ var ariaLabelledby = (0, $8bTPG.computed)(()=>{
        return el$1.value.embed ? undefined : el$1.value.labelId;
    });
    // =============== METHODS ==============
    /**
   * Upload the currently selected file as temporary.
   * 
   * @returns {void}
   */ var upload = ()=>{
        el$1.value.uploadTemp();
    };
    /**
   * Remove the file.
   * 
   * @returns {void}
   */ var remove = ()=>{
        if (uploading.value) el$1.value.handleAbort();
        else el$1.value.handleRemove();
    };
    /**
   * Handle the keyup event of the preview.
   * 
   * @param {Event} event* the keyup Event
   * @returns {Promise}
   * @private
   */ var handleKeyup = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(function*(e) {
            switch(e.key){
                case 'Backspace':
                case 'Delete':
                    remove();
                    if (!el$1.value.canSelect) return;
                    yield (0, $ani5R.nextTick)();
                    document.querySelector("#".concat(el$1.value.fieldId)).focus();
                    break;
                case 'Enter':
                    if (el$1.value.auto) return;
                    upload();
                    break;
            }
        });
        return function handleKeyup(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    // =============== HOOKS ================
    return {
        visible: visible,
        hasLink: hasLink,
        hasError: hasError,
        link: link,
        filename: filename,
        clickable: clickable,
        uploaded: uploaded,
        uploading: uploading,
        progress: progress,
        canRemove: canRemove,
        canUploadTemp: canUploadTemp,
        uploadText: uploadText,
        ariaLabelledby: ariaLabelledby,
        upload: upload,
        remove: remove,
        handleKeyup: handleKeyup
    };
};
var FilePreview = {
    name: 'FilePreview',
    props: {
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        }
    },
    setup (props, context) {
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        var { visible, hasLink, hasError, link, filename, clickable, uploaded, uploading, progress, canRemove, canUploadTemp, uploadText, ariaLabelledby, upload, remove, handleKeyup } = base(props, context, {
            el$: el$1,
            form$: form$
        });
        // ============== COMPUTED ==============
        /**
     * The image's preview when [`view`](#option-view) is `image` or `gallery`. Equals to the `link` if the file is already uploaded and `base64` if only selected or temporarily uploaded.
     * 
     * @type {string}
     */ var preview = (0, $8bTPG.computed)(()=>{
            return el$1.value.preview;
        });
        /**
     * The `aria-placeholder` attribute of the preview.
     * 
     * @type {string}
     */ var ariaPlaceholder = (0, $8bTPG.computed)(()=>{
            var text = el$1.value.embed && el$1.value.View !== 'gallery' ? undefined : filename.value;
            if (hasError.value) {
                if (text) text += ', error';
                else text = 'error';
            }
            return text;
        });
        /**
     * The `aria-roledescription` attribute of the preview.
     * 
     * @type {string}
     */ var ariaRoledescription = (0, $8bTPG.computed)(()=>{
            return el$1.value.embed && el$1.value.View !== 'gallery' || uploaded.value || el$1.value.auto ? undefined : uploadText.value;
        });
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            visible: visible,
            hasLink: hasLink,
            hasError: hasError,
            link: link,
            filename: filename,
            clickable: clickable,
            uploaded: uploaded,
            uploading: uploading,
            progress: progress,
            canRemove: canRemove,
            canUploadTemp: canUploadTemp,
            uploadText: uploadText,
            preview: preview,
            ariaLabelledby: ariaLabelledby,
            ariaPlaceholder: ariaPlaceholder,
            ariaRoledescription: ariaRoledescription,
            upload: upload,
            remove: remove,
            handleKeyup: handleKeyup
        };
    }
};
var RadiogroupRadio = {
    name: 'RadiogroupRadio',
    props: {
        item: {
            type: [
                Object,
                String,
                Number
            ],
            required: true
        },
        value: {
            type: [
                String,
                Number,
                Boolean
            ],
            required: true
        },
        items: {
            type: [
                Object,
                Array
            ],
            required: true
        },
        index: {
            type: [
                Number
            ],
            required: true
        },
        attrs: {
            required: false,
            type: [
                Object
            ],
            default: ()=>({})
        },
        standalone: {
            required: false,
            type: [
                Boolean
            ],
            default: false
        }
    },
    setup (props, context) {
        var { value, item } = (0, $8bTPG.toRefs)(props);
        var { el$: el$1, form$, Size, View, classesInstance, classes, Templates, template, theme } = base$15(props, context);
        // ============== COMPUTED ==============
        /**
     * Whether the radio should be disabled.
     * 
     * @type {boolean}
     */ var isDisabled = (0, $8bTPG.computed)(()=>{
            var _item$value;
            return el$1.value.disabledItems.map((i)=>String(i)).indexOf(String(value.value)) !== -1 || el$1.value.isDisabled || !!((_item$value = item.value) !== null && _item$value !== void 0 && _item$value.disabled);
        });
        /**
     * Whether the radio is checked.
     * 
     * @type {boolean}
     */ var checked = (0, $8bTPG.computed)(()=>{
            return el$1.value.value === String(value.value) || el$1.value.value === Number(value.value);
        });
        /**
     * The `id` attribute of the input.
     * 
     * @type {boolean}
     */ var id = (0, $8bTPG.computed)(()=>{
            return "".concat(el$1.value.fieldId, "-").concat(value.value);
        });
        /**
     * The `name` attribute of the input.
     * 
     * @type {boolean}
     */ var name = (0, $8bTPG.computed)(()=>{
            return el$1.value.path;
        });
        // =============== METHODS ==============
        /**
     * Handles `keydown` event.
     * 
     * @param {Event} e* event object 
     * @returns {void}
     * @private
     */ var handleKeydown = (e)=>{
            if ([
                'ArrowRight',
                'ArrowDown'
            ].indexOf(e.key) !== -1) {
                e.preventDefault();
                var next = e.target.nextElementSibling;
                if ((next === null || next === void 0 ? void 0 : next.getAttribute('role')) === 'radio') next.focus();
            } else if ([
                'ArrowLeft',
                'ArrowUp'
            ].indexOf(e.key) !== -1) {
                e.preventDefault();
                var previous = e.target.previousElementSibling;
                if ((previous === null || previous === void 0 ? void 0 : previous.getAttribute('role')) === 'radio') previous.focus();
            }
        };
        return {
            el$: el$1,
            form$: form$,
            Size: Size,
            View: View,
            classesInstance: classesInstance,
            classes: classes,
            Templates: Templates,
            template: template,
            theme: theme,
            isDisabled: isDisabled,
            id: id,
            name: name,
            checked: checked,
            handleKeydown: handleKeydown
        };
    }
};
var index = {
    Vueform: VueformComponent,
    FormErrors: FormErrors,
    FormMessages: FormMessages,
    FormLanguages: FormLanguages,
    FormLanguage: FormLanguage,
    FormTabs: FormTabs,
    FormTab: FormTab,
    FormSteps: FormSteps,
    FormStepsControls: FormStepsControls,
    FormStepsControl: FormStepsControl,
    FormStep: FormStep,
    FormElements: FormElements,
    ElementLayout: ElementLayout,
    ElementLayoutInline: ElementLayoutInline,
    ElementLoader: ElementLoader,
    ElementLabelFloating: ElementLabelFloating,
    ElementLabel: ElementLabel,
    ElementInfo: ElementInfo,
    ElementDescription: ElementDescription,
    ElementError: ElementError,
    ElementMessage: ElementMessage,
    ElementRequired: ElementRequired,
    ElementText: ElementText,
    DragAndDrop: DragAndDrop,
    ElementAddon: ElementAddon,
    ElementAddonOptions: ElementAddonOptions,
    DatepickerWrapper: DatepickerWrapper,
    EditorWrapper: EditorWrapper,
    ButtonElement: ButtonElement,
    CaptchaElement: CaptchaElement,
    CheckboxElement: CheckboxElement,
    CheckboxgroupElement: CheckboxgroupElement,
    DateElement: DateElement,
    DatesElement: DatesElement,
    FileElement: FileElement,
    GenericElement: GenericElement,
    GridElement: GridElement,
    GroupElement: GroupElement,
    HiddenElement: HiddenElement,
    ListElement: ListElement,
    LocationElement: LocationElement,
    MatrixElement: MatrixElement,
    MultifileElement: MultifileElement,
    MultiselectElement: MultiselectElement,
    ObjectElement: ObjectElement,
    PhoneElement: PhoneElement,
    RadioElement: RadioElement,
    RadiogroupElement: RadiogroupElement,
    SelectElement: SelectElement,
    SignatureElement: SignatureElement,
    SliderElement: SliderElement,
    StaticElement: StaticElement,
    TagsElement: TagsElement,
    TextareaElement: TextareaElement,
    TextElement: TextElement,
    ToggleElement: ToggleElement,
    EditorElement: EditorElement,
    TTextareaElement: TTextareaElement,
    TTextElement: TTextElement,
    TEditorElement: TEditorElement,
    CheckboxgroupCheckbox: CheckboxgroupCheckbox,
    FilePreview: FilePreview,
    RadiogroupRadio: RadiogroupRadio
};
var components = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': index,
    Vueform: VueformComponent,
    FormErrors: FormErrors,
    FormMessages: FormMessages,
    FormLanguages: FormLanguages,
    FormLanguage: FormLanguage,
    FormTabs: FormTabs,
    FormTab: FormTab,
    FormSteps: FormSteps,
    FormStepsControls: FormStepsControls,
    FormStepsControl: FormStepsControl,
    FormStep: FormStep,
    FormElements: FormElements,
    ElementLayout: ElementLayout,
    ElementLayoutInline: ElementLayoutInline,
    ElementLoader: ElementLoader,
    ElementLabelFloating: ElementLabelFloating,
    ElementLabel: ElementLabel,
    ElementInfo: ElementInfo,
    ElementDescription: ElementDescription,
    ElementError: ElementError,
    ElementMessage: ElementMessage,
    ElementRequired: ElementRequired,
    ElementText: ElementText,
    DragAndDrop: DragAndDrop,
    ElementAddon: ElementAddon,
    ElementAddonOptions: ElementAddonOptions,
    DatepickerWrapper: DatepickerWrapper,
    EditorWrapper: EditorWrapper,
    ButtonElement: ButtonElement,
    CaptchaElement: CaptchaElement,
    CheckboxElement: CheckboxElement,
    CheckboxgroupElement: CheckboxgroupElement,
    DateElement: DateElement,
    DatesElement: DatesElement,
    FileElement: FileElement,
    GenericElement: GenericElement,
    GridElement: GridElement,
    GroupElement: GroupElement,
    HiddenElement: HiddenElement,
    ListElement: ListElement,
    LocationElement: LocationElement,
    MatrixElement: MatrixElement,
    MultifileElement: MultifileElement,
    MultiselectElement: MultiselectElement,
    ObjectElement: ObjectElement,
    PhoneElement: PhoneElement,
    RadioElement: RadioElement,
    RadiogroupElement: RadiogroupElement,
    SelectElement: SelectElement,
    SignatureElement: SignatureElement,
    SliderElement: SliderElement,
    StaticElement: StaticElement,
    TagsElement: TagsElement,
    TextareaElement: TextareaElement,
    TextElement: TextElement,
    ToggleElement: ToggleElement,
    EditorElement: EditorElement,
    TTextareaElement: TTextareaElement,
    TTextElement: TTextElement,
    TEditorElement: TEditorElement,
    CheckboxgroupCheckbox: CheckboxgroupCheckbox,
    FilePreview: FilePreview,
    RadiogroupRadio: RadiogroupRadio
});
function element(options) {
    var component = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!options.name) throw Error('The `name` attribute must be defined to create a new element');
    options = _objectSpread2$1(_objectSpread2$1({}, options), component);
    var name = options.name;
    var ComponentName = "".concat(upperFirst_1(camelCase_1(name)));
    var emits = [].concat(GenericElement.emits).concat(options.emits || []);
    return _objectSpread2$1({
        name: ComponentName,
        components: options.components || {},
        mixins: [].concat(GenericElement.mixins).concat(options.mixins || []),
        emits: emits,
        props: _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, GenericElement.props), options.props || {}), {}, {
            type: {
                required: false,
                type: [
                    String
                ],
                default: name,
                private: true
            }
        }),
        setup (props, ctx) {
            var context = _objectSpread2$1(_objectSpread2$1({}, ctx), {}, {
                emits: emits,
                name: (0, $8bTPG.ref)(ComponentName),
                nullValue: options.nullValue !== undefined ? options.nullValue : null
            });
            var element = GenericElement.setup(props, context);
            context.element = element;
            var setup = options.setup ? options.setup(props, context) : {};
            return _objectSpread2$1(_objectSpread2$1({}, element), setup);
        }
    }, omit_1(options, [
        'setup',
        'mixins',
        'emits',
        'props'
    ]));
}
function defineConfig(config) {
    return config;
}
var VueformElement = element;
var defineElement = element;
installer(undefined, {
    Vueform: VueformComponent,
    FormElements: FormElements
}, {}, {
    moment: (/*@__PURE__*/$parcel$interopDefault($YChVI))
});
var vueform = installer(undefined, _objectSpread2$1({}, components), _objectSpread2$1({}, rules), {
    moment: (/*@__PURE__*/$parcel$interopDefault($YChVI))
});

});
parcelRegister("1zKtH", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("81tj9")).default);

var $81tj9 = parcelRequire("81tj9");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $81tj9.default);

});
parcelRegister("81tj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $juuss = parcelRequire("juuss");

var $htyv1 = parcelRequire("htyv1");

var $8yOyy = parcelRequire("8yOyy");

var $4iFhx = parcelRequire("4iFhx");

var $lCgfr = parcelRequire("lCgfr");

var $6yYtd = parcelRequire("6yYtd");

var $lISaw = parcelRequire("lISaw");

var $6wIUo = parcelRequire("6wIUo");

var $albzn = parcelRequire("albzn");

var $1YbHN = parcelRequire("1YbHN");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");

var $kq2bQ = parcelRequire("kq2bQ");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $hBrVA.default)(defaultConfig);
    const instance = (0, $cG9HX.default)((0, $hBrVA.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $eFc3n.default).extend(instance, (0, $hBrVA.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $eFc3n.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $2PhsF.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $juuss.default));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $hBrVA.default);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $8yOyy.default);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $4iFhx.default);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $lCgfr.default);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $6yYtd.VERSION);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $lISaw.default);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $6wIUo.default);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $albzn.default);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $1YbHN.default);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $2PhsF.default);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $7hTsj.default);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $htyv1.default)((0, $eFc3n.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $ik8Aj.default).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $kq2bQ.default);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $aace3e920a0f1e4d$export$2e2bcd8739ae039);

var $cG9HX = parcelRequire("cG9HX");

var $ibaza = parcelRequire("ibaza");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== 'object') return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $cG9HX.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : typeof $ibaza !== 'undefined' && $ibaza.nextTick || $aace3e920a0f1e4d$var$_setImmediate;
var // *********************
$aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap
};

});
parcelRegister("cG9HX", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b0f01b05e2607a$export$2e2bcd8739ae039);
'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});

parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hBrVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd0b8e3cbef64068$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $cgfHI = parcelRequire("cgfHI");

var $8zXsW = parcelRequire("8zXsW");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $8zXsW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $9ltoJ.default)(),
            response: new (0, $9ltoJ.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $2PhsF.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $8zXsW.default).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $eFc3n.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $8zXsW.default).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $8zXsW.default).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $eFc3n.default).merge(headers.common, headers[config.method]);
        headers && (0, $eFc3n.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $7hTsj.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $cUzFg.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $cUzFg.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $2PhsF.default)(this.defaults, config);
        const fullPath = (0, $cgfHI.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $iOHZJ.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $2PhsF.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $eFc3n.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $2PhsF.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2f05ec923f2ee7$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4uovm = parcelRequire("4uovm");
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    if ((0, $eFc3n.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $eFc3n.default).isURLSearchParams(params) ? params.toString() : new (0, $4uovm.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("4uovm", function(module, exports) {

$parcel$export(module.exports, "default", () => $344cf8e4292137b6$export$2e2bcd8739ae039);

var $lISaw = parcelRequire("lISaw");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $lISaw.default)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;

});
parcelRegister("lISaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd07b9cb0132c1f6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $bAbs8 = parcelRequire("bAbs8");

var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $eFc3n.default).isPlainObject(thing) || (0, $eFc3n.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $eFc3n.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $eFc3n.default).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $eFc3n.default).toFlatObject((0, $eFc3n.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $bAbs8.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $eFc3n.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $eFc3n.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $eFc3n.default).isSpecCompliantForm(formData);
    if (!(0, $eFc3n.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $eFc3n.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $eFc3n.default).isBlob(value)) throw new (0, $6wIUo.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $eFc3n.default).isArrayBuffer(value) || (0, $eFc3n.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $eFc3n.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $eFc3n.default).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $eFc3n.default).isFileList(value) || (0, $eFc3n.default).endsWith(key, '[]')) && (arr = (0, $eFc3n.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $eFc3n.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $eFc3n.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $eFc3n.default).forEach(value, function each(el, key) {
            const result = !((0, $eFc3n.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $eFc3n.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $eFc3n.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;

});
parcelRegister("6wIUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0139f1d30f4d6bd5$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $eFc3n.default).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $eFc3n.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $eFc3n.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;

});

parcelRegister("bAbs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ebf0c810395e29$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;

});

parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("9ltoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c17f80085c95b1$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $eFc3n.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $96666136aaccd2e5$export$2e2bcd8739ae039);

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $juuss = parcelRequire("juuss");

var $8yOyy = parcelRequire("8yOyy");

var $7hTsj = parcelRequire("7hTsj");

var $ik8Aj = parcelRequire("ik8Aj");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8yOyy.default)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $7hTsj.default).from(config.headers);
    // Transform request data
    config.data = (0, $kgh03.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ik8Aj.default).getAdapter(config.adapter || (0, $juuss.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $kgh03.default).call(config, config.transformResponse, response);
        response.headers = (0, $7hTsj.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $lCgfr.default)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $kgh03.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $7hTsj.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("kgh03", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec027d10dfede142$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $juuss = parcelRequire("juuss");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $juuss.default);
    const context = response || config;
    const headers = (0, $7hTsj.default).from(context.headers);
    let data = context.data;
    (0, $eFc3n.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("juuss", function(module, exports) {

$parcel$export(module.exports, "default", () => $e30871f78dcd7f19$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $49WWV = parcelRequire("49WWV");

var $lISaw = parcelRequire("lISaw");

var $eAUco = parcelRequire("eAUco");

var $bqN51 = parcelRequire("bqN51");

var $htyv1 = parcelRequire("htyv1");
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $eFc3n.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $eFc3n.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $49WWV.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $eFc3n.default).isObject(data);
            if (isObjectPayload && (0, $eFc3n.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $eFc3n.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $htyv1.default)(data)) : data;
            if ((0, $eFc3n.default).isArrayBuffer(data) || (0, $eFc3n.default).isBuffer(data) || (0, $eFc3n.default).isStream(data) || (0, $eFc3n.default).isFile(data) || (0, $eFc3n.default).isBlob(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if ((0, $eFc3n.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $eFc3n.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $eAUco.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $eFc3n.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $lISaw.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $eFc3n.default).isResponse(data) || (0, $eFc3n.default).isReadableStream(data)) return data;
            if (data && (0, $eFc3n.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6wIUo.default).from(e, (0, $6wIUo.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bqN51.default).classes.FormData,
        Blob: (0, $bqN51.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $eFc3n.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;

});
parcelRegister("49WWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3075bac9f30e7782$export$2e2bcd8739ae039);
'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("eAUco", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa000567d8bb5ae2$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $lISaw = parcelRequire("lISaw");

var $bqN51 = parcelRequire("bqN51");
'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $lISaw.default)(data, new (0, $bqN51.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bqN51.default).isNode && (0, $eFc3n.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("bqN51", function(module, exports) {

$parcel$export(module.exports, "default", () => $852831b4a152a7ad$export$2e2bcd8739ae039);

var $lyPzr = parcelRequire("lyPzr");

var $31g1y = parcelRequire("31g1y");
var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$31g1y,
    ...(0, $lyPzr.default)
};

});
parcelRegister("lyPzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb24c6d0b2a74508$export$2e2bcd8739ae039);

var $esdLz = parcelRequire("esdLz");

var $64i7Q = parcelRequire("64i7Q");

var $3YeiC = parcelRequire("3YeiC");
var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $esdLz.default,
        FormData: $64i7Q.default,
        Blob: $3YeiC.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("esdLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85e5bed82430d61$export$2e2bcd8739ae039);

var $4uovm = parcelRequire("4uovm");
'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $4uovm.default);

});

parcelRegister("64i7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b12d255f217052$export$2e2bcd8739ae039);
'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("3YeiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e4211376cea43e6$export$2e2bcd8739ae039);
'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("31g1y", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("htyv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8fe7f388dc4432$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $eFc3n.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $eFc3n.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $eFc3n.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $eFc3n.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $eFc3n.default).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $eFc3n.default).isFormData(formData) && (0, $eFc3n.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $eFc3n.default).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;

});


parcelRegister("7hTsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e5234108b8e954$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $4Ik1V = parcelRequire("4Ik1V");
'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $eFc3n.default).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $eFc3n.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $eFc3n.default).isString(value)) return;
    if ((0, $eFc3n.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $eFc3n.default).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $eFc3n.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $eFc3n.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $eFc3n.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $eFc3n.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $eFc3n.default).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $4Ik1V.default)(header), valueOrRewrite);
        else if ((0, $eFc3n.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $eFc3n.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $eFc3n.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $eFc3n.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $eFc3n.default).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $eFc3n.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            const key = (0, $eFc3n.default).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $eFc3n.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $eFc3n.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $eFc3n.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $eFc3n.default).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $eFc3n.default).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;

});
parcelRegister("4Ik1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $36eacf0f5ae88424$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $eFc3n.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});



parcelRegister("lCgfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("8yOyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b8b72909769bf2$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6wIUo.default).call(this, message == null ? 'canceled' : message, (0, $6wIUo.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $eFc3n.default).inherits($63b8b72909769bf2$var$CanceledError, (0, $6wIUo.default), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;

});

parcelRegister("ik8Aj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d570c100e0cb7a05$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bAbs8 = parcelRequire("bAbs8");

var $8nTSD = parcelRequire("8nTSD");

var $6uoyO = parcelRequire("6uoyO");

var $6wIUo = parcelRequire("6wIUo");
const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $bAbs8.default),
    xhr: (0, $8nTSD.default),
    fetch: (0, $6uoyO.default)
};
(0, $eFc3n.default).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $eFc3n.default).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $eFc3n.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $6wIUo.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $6wIUo.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};

});
parcelRegister("8nTSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $61abd1574bd1dd32$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $49WWV = parcelRequire("49WWV");

var $6wIUo = parcelRequire("6wIUo");

var $8yOyy = parcelRequire("8yOyy");

var $drWk7 = parcelRequire("drWk7");

var $bqN51 = parcelRequire("bqN51");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $l7Q05.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $7hTsj.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $7hTsj.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gyIfz.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6wIUo.default)('Request aborted', (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $49WWV.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6wIUo.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6wIUo.default).ETIMEDOUT : (0, $6wIUo.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $eFc3n.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $eFc3n.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $dKk3V.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $dKk3V.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8yOyy.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $drWk7.default)(_config.url);
        if (protocol && (0, $bqN51.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6wIUo.default)('Unsupported protocol ' + protocol + ':', (0, $6wIUo.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e22576f74b8071$export$2e2bcd8739ae039);

var $6wIUo = parcelRequire("6wIUo");
'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6wIUo.default)('Request failed with status code ' + response.status, [
        (0, $6wIUo.default).ERR_BAD_REQUEST,
        (0, $6wIUo.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("drWk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab09d0d089fc0e$export$2e2bcd8739ae039);
'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("dKk3V", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $a01f222f203440ec$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $a01f222f203440ec$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $a01f222f203440ec$export$5d35863c355a22a9);

var $6eLe3 = parcelRequire("6eLe3");

var $g1MZz = parcelRequire("g1MZz");

var $eFc3n = parcelRequire("eFc3n");
const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6eLe3.default)(50, 250);
    return (0, $g1MZz.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $eFc3n.default).asap(()=>fn(...args));

});
parcelRegister("6eLe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $48a8aeed25ee768a$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;

});

parcelRegister("g1MZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab2be24834f7155$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;

});


parcelRegister("l7Q05", function(module, exports) {

$parcel$export(module.exports, "default", () => $f612969e780f42a0$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $4YUSN = parcelRequire("4YUSN");

var $6D8uh = parcelRequire("6D8uh");

var $cgfHI = parcelRequire("cgfHI");

var $2PhsF = parcelRequire("2PhsF");

var $7hTsj = parcelRequire("7hTsj");

var $iOHZJ = parcelRequire("iOHZJ");
var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $2PhsF.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $7hTsj.default).from(headers);
    newConfig.url = (0, $iOHZJ.default)((0, $cgfHI.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $eFc3n.default).isFormData(data)) {
        if ((0, $bqN51.default).hasStandardBrowserEnv || (0, $bqN51.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bqN51.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $eFc3n.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $4YUSN.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $6D8uh.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("4YUSN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a08e3bf7b3045fa$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bqN51.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bqN51.default).origin), (0, $bqN51.default).navigator && /(msie|trident)/i.test((0, $bqN51.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("6D8uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3cf801f7fd4dc6$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $bqN51 = parcelRequire("bqN51");
var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $bqN51.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $eFc3n.default).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $eFc3n.default).isString(path) && cookie.push('path=' + path);
        (0, $eFc3n.default).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("cgfHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3292b1f9dccb5$export$2e2bcd8739ae039);

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
'use strict';
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $uAxSn.default)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $aFAjA.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("uAxSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $05bf269bfca011f3$export$2e2bcd8739ae039);
'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("aFAjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c49e720f6231ba2$export$2e2bcd8739ae039);
'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("2PhsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ede3a7e8b675d4$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");

var $7hTsj = parcelRequire("7hTsj");
'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $7hTsj.default) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $eFc3n.default).isPlainObject(target) && (0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $eFc3n.default).isPlainObject(source)) return (0, $eFc3n.default).merge({}, source);
        else if ((0, $eFc3n.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $eFc3n.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $eFc3n.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $eFc3n.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $eFc3n.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("6uoyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9898a31eea6843$export$2e2bcd8739ae039);

var $bqN51 = parcelRequire("bqN51");

var $eFc3n = parcelRequire("eFc3n");

var $6wIUo = parcelRequire("6wIUo");

var $c046u = parcelRequire("c046u");

var $eMAze = parcelRequire("eMAze");

var $7hTsj = parcelRequire("7hTsj");

var $dKk3V = parcelRequire("dKk3V");

var $l7Q05 = parcelRequire("l7Q05");

var $gyIfz = parcelRequire("gyIfz");
const $4b9898a31eea6843$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $4b9898a31eea6843$var$isReadableStreamSupported = $4b9898a31eea6843$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $4b9898a31eea6843$var$encodeText = $4b9898a31eea6843$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$supportsRequestStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bqN51.default).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$supportsResponseStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $eFc3n.default).isReadableStream(new Response('').body));
const $4b9898a31eea6843$var$resolvers = {
    stream: $4b9898a31eea6843$var$supportsResponseStream && ((res)=>res.body)
};
$4b9898a31eea6843$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$4b9898a31eea6843$var$resolvers[type] && ($4b9898a31eea6843$var$resolvers[type] = (0, $eFc3n.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $6wIUo.default)(`Response type '${type}' is not supported`, (0, $6wIUo.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4b9898a31eea6843$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $eFc3n.default).isBlob(body)) return body.size;
    if ((0, $eFc3n.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bqN51.default).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $eFc3n.default).isArrayBufferView(body) || (0, $eFc3n.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $eFc3n.default).isURLSearchParams(body)) body = body + '';
    if ((0, $eFc3n.default).isString(body)) return (await $4b9898a31eea6843$var$encodeText(body)).byteLength;
};
const $4b9898a31eea6843$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $eFc3n.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $4b9898a31eea6843$var$getBodyLength(body) : length;
};
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $l7Q05.default)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $c046u.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $4b9898a31eea6843$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $4b9898a31eea6843$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $eFc3n.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $dKk3V.progressEventDecorator)(requestContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onUploadProgress)));
                data = (0, $eMAze.trackStream)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $eFc3n.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $4b9898a31eea6843$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($4b9898a31eea6843$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $eFc3n.default).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $dKk3V.progressEventDecorator)(responseContentLength, (0, $dKk3V.progressEventReducer)((0, $dKk3V.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $eMAze.trackStream)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $4b9898a31eea6843$var$resolvers[(0, $eFc3n.default).findKey($4b9898a31eea6843$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $gyIfz.default)(resolve, reject, {
                data: responseData,
                headers: (0, $7hTsj.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $6wIUo.default)('Network Error', (0, $6wIUo.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $6wIUo.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("c046u", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc8ab02f7e95517$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $6wIUo.default) ? err : new (0, $8yOyy.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $6wIUo.default)(`timeout ${timeout} of ms exceeded`, (0, $6wIUo.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $eFc3n.default).asap(unsubscribe);
        return signal;
    }
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;

});

parcelRegister("eMAze", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $ac31e9e363273572$export$b0119225647bd83);
const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("8zXsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63efb8494987aa98$export$2e2bcd8739ae039);

var $6yYtd = parcelRequire("6yYtd");

var $6wIUo = parcelRequire("6wIUo");
'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $6yYtd.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6wIUo.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6wIUo.default).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6wIUo.default)('options must be an object', (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6wIUo.default)('option ' + opt + ' must be ' + result, (0, $6wIUo.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6wIUo.default)('Unknown option ' + opt, (0, $6wIUo.default).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $4c74d331112ba968$export$a4ad2735b021c132);
const $4c74d331112ba968$export$a4ad2735b021c132 = "1.8.3";

});



parcelRegister("4iFhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3218dd97b5460664$export$2e2bcd8739ae039);

var $8yOyy = parcelRequire("8yOyy");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8yOyy.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7874d702b64e6994$export$2e2bcd8739ae039);
'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("1YbHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $16f479813f4fb9c8$export$2e2bcd8739ae039);

var $eFc3n = parcelRequire("eFc3n");
'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $eFc3n.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("kq2bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;

});



parcelRegister("YChVI", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRequire("ey4ci");
var $dDLnc = parcelRequire("dDLnc");
var $149de073a535e218$exports = {};
/*!
  * vue-scrollto v2.20.0
  * (c) 2019 Randjelovic Igor
  * @license MIT
  */ (function(global, factory) {
    $149de073a535e218$exports = factory();
})($149de073a535e218$exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    /**
   * https://github.com/gre/bezier-easing
   * BezierEasing - use bezier curve for transition easing function
   * by Gaëtan Renaudeau 2014 - 2015 – MIT License
   */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';
    function A(aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }
    function B(aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    }
    function C(aA1) {
        return 3.0 * aA1;
    }
    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    }
    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    function getSlope(aT, aA1, aA2) {
        return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }
    function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) aB = currentT;
            else aA = currentT;
        }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    }
    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for(var i = 0; i < NEWTON_ITERATIONS; ++i){
            var currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) return aGuessT;
            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    }
    function LinearEasing(x) {
        return x;
    }
    var src = function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
        if (mX1 === mY1 && mX2 === mY2) return LinearEasing;
        // Precompute samples table
        var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        for(var i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        function getTForX(aX) {
            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = kSplineTableSize - 1;
            for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
            --currentSample;
            // Interpolate to provide an initial guess for t
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * kSampleStepSize;
            var initialSlope = getSlope(guessForT, mX1, mX2);
            if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            else if (initialSlope === 0.0) return guessForT;
            else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
        return function BezierEasing(x) {
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0) return 0;
            if (x === 1) return 1;
            return calcBezier(getTForX(x), mY1, mY2);
        };
    };
    var easings = {
        ease: [
            0.25,
            0.1,
            0.25,
            1.0
        ],
        linear: [
            0.0,
            0.0,
            1.0,
            1.0
        ],
        'ease-in': [
            0.42,
            0.0,
            1.0,
            1.0
        ],
        'ease-out': [
            0.0,
            0.0,
            0.58,
            1.0
        ],
        'ease-in-out': [
            0.42,
            0.0,
            0.58,
            1.0
        ]
    };
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassive = true;
            }
        });
        window.addEventListener('test', null, opts);
    } catch (e) {}
    var _ = {
        $: function $(selector) {
            if (typeof selector !== 'string') return selector;
            return document.querySelector(selector);
        },
        on: function on(element, events, handler) {
            var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                passive: false
            };
            if (!(events instanceof Array)) events = [
                events
            ];
            for(var i = 0; i < events.length; i++)element.addEventListener(events[i], handler, supportsPassive ? opts : false);
        },
        off: function off(element, events, handler) {
            if (!(events instanceof Array)) events = [
                events
            ];
            for(var i = 0; i < events.length; i++)element.removeEventListener(events[i], handler);
        },
        cumulativeOffset: function cumulativeOffset(element) {
            var top = 0;
            var left = 0;
            do {
                top += element.offsetTop || 0;
                left += element.offsetLeft || 0;
                element = element.offsetParent;
            }while (element);
            return {
                top: top,
                left: left
            };
        }
    };
    var abortEvents = [
        'mousedown',
        'wheel',
        'DOMMouseScroll',
        'mousewheel',
        'keyup',
        'touchmove'
    ];
    var defaults = {
        container: 'body',
        duration: 500,
        lazy: true,
        easing: 'ease',
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    };
    function setDefaults(options) {
        defaults = _extends({}, defaults, options);
    }
    var scroller = function scroller() {
        var element; // element to scroll to
        var container; // container to scroll
        var duration; // duration of the scrolling
        var easing; // easing to be used when scrolling
        var lazy; // checks the target position at each step
        var offset; // offset to be added (subtracted)
        var force; // force scroll, even if element is visible
        var cancelable; // indicates if user can cancel the scroll or not.
        var onStart; // callback when scrolling is started
        var onDone; // callback when scrolling is done
        var onCancel; // callback when scrolling is canceled / aborted
        var x; // scroll on x axis
        var y; // scroll on y axis
        var initialX; // initial X of container
        var targetX; // target X of container
        var initialY; // initial Y of container
        var targetY; // target Y of container
        var diffX; // difference
        var diffY; // difference
        var abort; // is scrolling aborted
        var cumulativeOffsetContainer;
        var cumulativeOffsetElement;
        var abortEv; // event that aborted scrolling
        var abortFn = function abortFn(e) {
            if (!cancelable) return;
            abortEv = e;
            abort = true;
        };
        var easingFn;
        var timeStart; // time when scrolling started
        var timeElapsed; // time elapsed since scrolling started
        var progress; // progress
        function scrollTop(container) {
            var scrollTop = container.scrollTop;
            if (container.tagName.toLowerCase() === 'body') // in firefox body.scrollTop always returns 0
            // thus if we are trying to get scrollTop on a body tag
            // we need to get it from the documentElement
            scrollTop = scrollTop || document.documentElement.scrollTop;
            return scrollTop;
        }
        function scrollLeft(container) {
            var scrollLeft = container.scrollLeft;
            if (container.tagName.toLowerCase() === 'body') // in firefox body.scrollLeft always returns 0
            // thus if we are trying to get scrollLeft on a body tag
            // we need to get it from the documentElement
            scrollLeft = scrollLeft || document.documentElement.scrollLeft;
            return scrollLeft;
        }
        function recalculateTargets() {
            cumulativeOffsetContainer = _.cumulativeOffset(container);
            cumulativeOffsetElement = _.cumulativeOffset(element);
            if (x) {
                targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;
                diffX = targetX - initialX;
            }
            if (y) {
                targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;
                diffY = targetY - initialY;
            }
        }
        function step(timestamp) {
            if (abort) return done();
            if (!timeStart) timeStart = timestamp; // When a site has a lot of media that can be loaded asynchronously,
            // the targetY/targetX may end up in the wrong place during scrolling.
            // So we will check this at each step
            if (!lazy) recalculateTargets();
            timeElapsed = timestamp - timeStart;
            progress = Math.min(timeElapsed / duration, 1);
            progress = easingFn(progress);
            topLeft(container, initialY + diffY * progress, initialX + diffX * progress);
            timeElapsed < duration ? window.requestAnimationFrame(step) : done();
        }
        function done() {
            if (!abort) topLeft(container, targetY, targetX);
            timeStart = false;
            _.off(container, abortEvents, abortFn);
            if (abort && onCancel) onCancel(abortEv, element);
            if (!abort && onDone) onDone(element);
        }
        function topLeft(element, top, left) {
            if (y) element.scrollTop = top;
            if (x) element.scrollLeft = left;
            if (element.tagName.toLowerCase() === 'body') {
                // in firefox body.scrollTop doesn't scroll the page
                // thus if we are trying to scrollTop on a body tag
                // we need to scroll on the documentElement
                if (y) document.documentElement.scrollTop = top;
                if (x) document.documentElement.scrollLeft = left;
            }
        }
        function scrollTo(target, _duration) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (_typeof(_duration) === 'object') options = _duration;
            else if (typeof _duration === 'number') options.duration = _duration;
            element = _.$(target);
            if (!element) return console.warn('[vue-scrollto warn]: Trying to scroll to an element that is not on the page: ' + target);
            container = _.$(options.container || defaults.container);
            duration = options.hasOwnProperty('duration') ? options.duration : defaults.duration;
            lazy = options.hasOwnProperty('lazy') ? options.lazy : defaults.lazy;
            easing = options.easing || defaults.easing;
            offset = options.hasOwnProperty('offset') ? options.offset : defaults.offset;
            force = options.hasOwnProperty('force') ? options.force !== false : defaults.force;
            cancelable = options.hasOwnProperty('cancelable') ? options.cancelable !== false : defaults.cancelable;
            onStart = options.onStart || defaults.onStart;
            onDone = options.onDone || defaults.onDone;
            onCancel = options.onCancel || defaults.onCancel;
            x = options.x === undefined ? defaults.x : options.x;
            y = options.y === undefined ? defaults.y : options.y;
            if (typeof offset === 'function') offset = offset(element, container);
            initialX = scrollLeft(container);
            initialY = scrollTop(container); // calculates cumulative offsets and targetX/Y + diffX/Y
            recalculateTargets();
            abort = false;
            if (!force) {
                // When the container is the default (body) we need to use the viewport
                // height, not the entire body height
                var containerHeight = container.tagName.toLowerCase() === 'body' ? document.documentElement.clientHeight || window.innerHeight : container.offsetHeight;
                var containerTop = initialY;
                var containerBottom = containerTop + containerHeight;
                var elementTop = targetY - offset;
                var elementBottom = elementTop + element.offsetHeight;
                if (elementTop >= containerTop && elementBottom <= containerBottom) {
                    // make sure to call the onDone callback even if there is no need to
                    // scroll the container. Fixes #111 (ref #118)
                    if (onDone) onDone(element);
                    return;
                }
            }
            if (onStart) onStart(element);
            if (!diffY && !diffX) {
                if (onDone) onDone(element);
                return;
            }
            if (typeof easing === 'string') easing = easings[easing] || easings['ease'];
            easingFn = src.apply(src, easing);
            _.on(container, abortEvents, abortFn, {
                passive: true
            });
            window.requestAnimationFrame(step);
            return function() {
                abortEv = null;
                abort = true;
            };
        }
        return scrollTo;
    };
    var _scroller = scroller();
    var bindings = []; // store binding data
    function deleteBinding(el) {
        for(var i = 0; i < bindings.length; ++i)if (bindings[i].el === el) {
            bindings.splice(i, 1);
            return true;
        }
        return false;
    }
    function findBinding(el) {
        for(var i = 0; i < bindings.length; ++i){
            if (bindings[i].el === el) return bindings[i];
        }
    }
    function getBinding(el) {
        var binding = findBinding(el);
        if (binding) return binding;
        bindings.push(binding = {
            el: el,
            binding: {}
        });
        return binding;
    }
    function handleClick(e) {
        var ctx = getBinding(this).binding;
        if (!ctx.value) return;
        e.preventDefault();
        if (typeof ctx.value === 'string') return _scroller(ctx.value);
        _scroller(ctx.value.el || ctx.value.element, ctx.value);
    }
    var directiveHooks = {
        bind: function bind(el, binding) {
            getBinding(el).binding = binding;
            _.on(el, 'click', handleClick);
        },
        unbind: function unbind(el) {
            deleteBinding(el);
            _.off(el, 'click', handleClick);
        },
        update: function update(el, binding) {
            getBinding(el).binding = binding;
        }
    };
    var VueScrollTo = {
        bind: directiveHooks.bind,
        unbind: directiveHooks.unbind,
        update: directiveHooks.update,
        beforeMount: directiveHooks.bind,
        unmounted: directiveHooks.unbind,
        updated: directiveHooks.update,
        scrollTo: _scroller,
        bindings: bindings
    };
    var install = function install(Vue, options) {
        if (options) setDefaults(options);
        Vue.directive('scroll-to', VueScrollTo);
        var properties = Vue.config.globalProperties || Vue.prototype;
        properties.$scrollTo = VueScrollTo.scrollTo;
    };
    if (typeof window !== 'undefined' && window.Vue) {
        window.VueScrollTo = VueScrollTo;
        window.VueScrollTo.setDefaults = setDefaults;
        window.VueScrollTo.scroller = scroller;
        if (window.Vue.use) window.Vue.use(install);
    }
    VueScrollTo.install = install;
    return VueScrollTo;
});


let $7a3585435420ab8e$var$script;



let $7a3585435420ab8e$var$initialize = ()=>{
    $7a3585435420ab8e$var$script = (parcelRequire("2KSIf"));
    if ($7a3585435420ab8e$var$script.__esModule) $7a3585435420ab8e$var$script = $7a3585435420ab8e$var$script.default;
    $7a3585435420ab8e$var$script.render = (parcelRequire("3JpMF")).render;
    (parcelRequire("bON8u")).default($7a3585435420ab8e$var$script);
    $7a3585435420ab8e$var$script.__scopeId = 'data-v-31d8e8';
    $7a3585435420ab8e$var$script.__file = "TicketShop.vue";
};
$7a3585435420ab8e$var$initialize();
var $7a3585435420ab8e$export$2e2bcd8739ae039 = $7a3585435420ab8e$var$script;



var $PEtmm = parcelRequire("PEtmm");
var $6f25fcfe138d84ae$export$2e2bcd8739ae039 = (0, $PEtmm.createStore)({
    state: {
        initialized: false,
        selection: {},
        personData: {},
        ticketFields: {},
        personFields: {},
        loading: true,
        offers: {},
        maxOrderAmounts: {},
        personalize: false,
        personalized: false,
        fullDescription: false,
        onlyNoChipTicketsSelected: false,
        allDataCollected: false,
        couponSwitch: false,
        couponCode: '',
        couponChecked: false,
        couponType: null,
        couponValue: null,
        couponOffers: [],
        couponDiscount: 0,
        couponResponse: null,
        donationSwitch: false,
        donationAmount: null,
        newsletterSignup: false,
        paymentType: '',
        paymentOptions: [],
        paymentCountryRules: null,
        billingCountry: '',
        tender: '',
        terminalId: '',
        ownerData: {},
        currentStep: 0,
        price: 0,
        total: 0,
        checkoutTracked: false,
        doOctoberRequest: ()=>{}
    },
    mutations: {
        init (state, payload1) {
            const settings = payload1.settings;
            this.commit("updateOffers", settings);
            state.personalize = settings.personalize;
            if (state.personalize) {
                state.personalize_fields = settings.personalize_fields;
                state.vue_personalize_fields = settings.vue_personalize_fields;
            }
            state.withCompany = settings.with_company;
            state.paymentOptions = settings.paymentOptions;
            state.doOctoberRequest = payload1.doOctoberRequest;
            state.ownerData = settings.ownerData || {};
            state.withCompany = settings.with_company;
            state.paymentOptions = settings.paymentOptions;
            state.doOctoberRequest = payload1.doOctoberRequest;
            state.ownerData = settings.ownerData || {};
            state.paymentCountryRules = settings.payment_country_rules || null;
            // A coupon handed in by the link the buyer followed (?coupon=CODE, or the
            // embed passing it on). It is applied before anything else may set it.
            const initialCouponCode = payload1.initialCouponCode || null;
            if (settings.stored?.selection) UIkit.modal.confirm(payload1.$t('Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?'), {
                i18n: {
                    ok: payload1.$t('Ja'),
                    cancel: payload1.$t('Nein')
                }
            }).then(()=>{
                // @gotcha The link wins over the cookie store. Its code is the one the
                //   buyer arrived with and whose products are already on screen, while
                //   the store may still carry a code from an earlier visit — restoring
                //   that one would swap the coupon under the buyer without a word.
                const couponKeys = [
                    'couponCode',
                    'couponSwitch',
                    'couponType',
                    'couponValue',
                    'couponDiscount'
                ];
                Object.keys(settings.stored).forEach((key)=>{
                    if (initialCouponCode && couponKeys.includes(key)) return;
                    state[key] = settings.stored[key];
                });
            }, ()=>{
                this.commit("removeCookieStore");
            });
            // @gotcha Only the code travels, never `couponSwitch`. The switch is what the
            //   checkout reads to decide whether to charge a discount, and it is set by the
            //   coupon field once the backend has confirmed the code — a link carrying an
            //   expired or mistyped code would otherwise make the checkout complain about an
            //   invalid coupon the buyer never entered. A shop with coupons switched off
            //   ignores the parameter altogether.
            if (initialCouponCode && settings.coupons_enabled) state.couponCode = initialCouponCode;
            state.initialized = true;
            state.personData = {};
        },
        updateOffers (state, payload1) {
            Object.keys(payload1.offers).forEach((offerId)=>{
                if (typeof state.offers[offerId] == 'undefined' || payload1.offers[offerId].coupon_highlight) {
                    state.offers[offerId] = payload1.offers[offerId];
                    state.offers[offerId].amount = 0;
                }
            });
            state.maxOrderAmounts = payload1.maxOrderAmounts;
        },
        removeCookieStore (state) {
            state.doOctoberRequest('onForgetStore');
        },
        addTicket (state, payload1) {
            state.selection[payload1.ticketId] = state.selection[payload1.ticketId] ? state.selection[payload1.ticketId] : {
                ticket: state.offers[payload1.ticketId]
            };
            state.selection[payload1.ticketId].amount = payload1.amount;
            state.selection[payload1.ticketId].option = payload1.option;
            if (state.selection[payload1.ticketId].amount == 0) delete state.selection[payload1.ticketId];
            else if (state.personalize) {
                state.allDataCollected = false;
                if (typeof state.offers[payload1.ticketId].no_chip == 'undefined') {
                    state.selection[payload1.ticketId].persons = state.selection[payload1.ticketId].persons ? state.selection[payload1.ticketId].persons : [];
                    const personAmount = Object.keys(state.selection[payload1.ticketId].persons).length;
                    if (personAmount > payload1.amount) state.selection[payload1.ticketId].persons.splice(payload1.amount - 1, personAmount - payload1.amount);
                    for(let i = 0; i < payload1.amount; i++)// @gotcha Leeres Objekt, KEIN Feld vorbelegen — auch nicht
                    //   mit ''. PersonalizeTicketForm schreibt dieses Objekt im
                    //   mounted-Hook per form$.update() ins Formular, und die
                    //   globale Vueform-Config steht auf validateOn:'change'.
                    //   Ein geschriebener Wert zaehlt als Aenderung, das Feld
                    //   wird also sofort validiert. Der frueher hier stehende
                    //   Seed {firstname: ''} liess dadurch "Vorname muss
                    //   ausgefuellt werden." erscheinen, bevor der Kaeufer den
                    //   Schritt ueberhaupt gesehen hatte — und zwar NUR bei
                    //   diesem einen Feld, weil nur dieser Schluessel existierte.
                    state.selection[payload1.ticketId].persons[i] = state.selection[payload1.ticketId].persons[i] ? state.selection[payload1.ticketId].persons[i] : {};
                }
            }
            this.commit("updatePrice");
            state.onlyNoChipTicketsSelected = true;
            for(let ticketId in state.selection)if (typeof state.offers[ticketId].no_chip == 'undefined') state.onlyNoChipTicketsSelected = false;
        },
        nullTicket (state) {
            if (state.selection[payload.ticketId] === undefined) return;
            delete state.selection[payload.ticketId];
            this.commit("updatePrice");
            const commitWhat = !Object.keys(state.selection).length ? "removeCookieStore" : "updateSession";
            this.commit(commitWhat);
        },
        updatePrice (state) {
            if (!Object.keys(state.selection).length) // An emptied cart ends the purchase — the next one gets its own checkout
            // event. Checked here because every way of changing the cart passes through.
            state.checkoutTracked = false;
            state.price = 0;
            state.total = 0;
            state.couponDiscount = 0;
            Object.keys(state.selection).forEach((selectionTicketId)=>{
                const selection = state.selection[selectionTicketId];
                let ticketPrice = selection.ticket.price * selection.amount;
                state.price += ticketPrice;
                if (state.couponValue && (state.couponOffers.length == 0 || state.couponOffers.includes(parseInt(selectionTicketId)))) {
                    if (state.couponType == 'absolute') state.couponDiscount = Math.min(state.couponDiscount + ticketPrice, state.couponValue);
                    if (state.couponType == 'relative') state.couponDiscount += Math.min(ticketPrice, (0.01 * state.couponValue * ticketPrice).toFixed(2));
                }
            });
            state.total = state.price - state.couponDiscount;
            if (state.donationSwitch && state.donationAmount && parseInt(state.donationAmount)) state.total += Math.abs(parseInt(state.donationAmount));
        },
        removeTicket (state, payload1) {
            if (state.selection[payload1.ticketId].persons[payload1.index]) state.selection[payload1.ticketId].persons.splice(payload1.index, 1);
            state.selection[payload1.ticketId].amount--;
            if (!state.selection[payload1.ticketId].amount) delete state.selection[payload1.ticketId];
            this.commit("updatePrice");
            if (!Object.keys(state.selection).length) this.commit("removeCookieStore");
            else this.commit("updateSession");
        },
        updateSession (state) {
            const data = {
                selection: state.selection,
                personData: state.personData,
                paymentType: state.paymentType,
                currentStep: state.currentStep,
                personalized: state.personalized,
                onlyNoChipTicketsSelected: state.onlyNoChipTicketsSelected,
                couponCode: state.couponCode,
                couponSwitch: state.couponSwitch,
                couponType: state.couponType,
                couponValue: state.couponValue,
                couponDiscount: state.couponDiscount,
                donationSwitch: state.donationSwitch,
                donationAmount: state.donationAmount,
                newsletterSignup: state.newsletterSignup,
                allDataCollected: state.allDataCollected,
                price: state.price,
                total: state.total,
                checkoutTracked: state.checkoutTracked
            };
            state.doOctoberRequest('onStore', {
                data: JSON.stringify(data)
            });
        },
        emitScroll () {
            window.setTimeout(()=>{
                window.top.postMessage({
                    scrollTop: true
                }, '*');
            }, 500);
        }
    }
});
function $6f25fcfe138d84ae$var$getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


var $7573617dde41bbef$exports = {};
'use strict';

$7573617dde41bbef$exports = (parcelRequire("1M2zR"));


var $a55250be4b09786f$exports = {};
$a55250be4b09786f$exports = JSON.parse('{"Tickets":"Tickets","Ticket w\xe4hlen":"Choose ticket","Tickets ausw\xe4hlen":"Choose Tickets","Tickets ausgew\xe4hlt":"selected","Alle Arten":"All kind","Ticketarten":"Ticket types","f\xfcr":"for","Ja":"Yes","Nein":"No","Checkout":"Checkout","Nicht mehr verf\xfcgbar":"No more available","Noch nicht verf\xfcgbar":"Not yet available","Required":"Required","Empf\xe4nger bestimmen":"set recipient","Zusammenfassung":"Summary","Pers\xf6nliche Daten":"Personal Data","Zahlungsart ausw\xe4hlen":"Choose the method of payment","Die Zahlungsarten erscheinen, sobald ein Land ausgew\xe4hlt ist.":"Payment methods appear once a country is selected.","F\xfcr das gew\xe4hlte Land ist keine Zahlungsart verf\xfcgbar.":"No payment method is available for the selected country.","Weiter":"Next","Zur\xfcck":"Back","Vorkasse":"Prepayment","Vorname":"First name","Nachname":"Last name","Stra\xdfe und Hausnummer":"Street and house number","Firma":"Company","USt-Id":"VAT-ID","PLZ":"ZIP","Ort":"City","Email":"E-Mail","E-Mail":"Email","Land":"Country","Empf\xe4nger":"Recipient","Anzahl":"Number","Art":"Kind","Enthaltene MwSt.":"Complete VAT.","Preis":"Price","Zahlungsweise":"method of payment","Gesamt":"Total","Total":"Total","Jetzt kaufen":"Buy now","Jetzt kostenlos bestellen":"Order now for free","Einkaufsliste":"Order Summary","Dies ist keine E-Mail-Adresse!":"This is not an E-Mail-Address!","Nichts gefunden":"Nothing found","Personalisieren":"Personalize","Personalisierung":"Personalization","Personalisiere die Tickets":"Personalize the tickets","Rechnungsdaten":"Billing Details","Ich habe die":"I have read and accepted the","AGB":"the terms and conditions.","gelesen und akzeptiert.":"","Datenschutzerkl\xe4rung":"Data protection.","Vielen Dank f\xfcr Deine Bestellung. Du solltest in k\xfcrze eine Best\xe4tigungsmail von uns erhalten. Bitte schau auch im SPAM Ordner nach.":"Thank you for your order. You should receive a confirmation email from us shortly. Please also check the spam folder.","Entschuldigung, es gab einen Fehler bei der \xdcbermittlung:":"Sorry, there was a submission error:","Entschuldigung, der Server meldet einen Fehler. Bitte versuche es sp\xe4ter noch einmal.":"Sorry, the server reports an error. Please try again later.","Bitte versuche es sp\xe4ter noch einmal.":"Please try again later.","Teilnehmerdaten":"Participant details","Entschuldigung. Die Anzahl der gew\xfcnschten Tickets ist derzeit nicht verf\xfcgbar.":"Sorry. The number of tickets requested is currently not available.","Beim Abschluss der Bestellung ist ein Fehler aufgetreten:":"An error occurred while completing the order:","Bitte \xfcberpr\xfcfe die AGBs":"Please subject to our general terms and privacy policy","Geimpft/Genesen":"Vaccinated/recovered","Weder Geimpft noch Genesen":"Neither vaccinated nor recovered","Keine Angabe":"Not specified","Weitere Angaben":"Other information","Ticket entfernen":"Remove ticket","Ticket entfernen?":"Do you really want to remove the ticket?","Wir haben Ihre Eingaben gespeichert, m\xf6chten Sie diese verwenden?":"We have saved your entries, do you want to use them?","Keine g\xfcltige E-Mail-Adresse":"No valid email-Address","Tage":"Days","Mi":"Wed","Do":"Thu","Fr":"Fri","Sa":"Sat","So":"Sun","Mo":"Mon","Karteninhaber":"Cardholder name","Kreditkartennummer":"Credit card numbr","Verfallsdatum":"Expiry date","Bezahlen":"Pay","Zahlung gesichert und bereitgestellt von":"Payment secured and powered by","OpenPaymentBeforeUnload":"Are you sure you want to close this tab? You order will be completely lost.","Der eingegebene Gutschein-Code ist nicht g\xfcltig.":"The entered coupon code is not valid.","Der eingegebene Gutschein-Code erfordert ein anderes Produkt.":"The entered coupon code requires a different product.","Ich habe einen Gutschein-Code":"I have a coupon code","Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert.":"No payment method was defined in project settings!","Gutschein-Code":"Coupon / code","Coupon-Code nicht gefunden oder nicht mehr g\xfcltig.":"Coupon / code not found or no longer valid.","Code wurde gefunden!":"Code was found!","Der Rabatt wird vor Kaufabschluss angezeigt.":"The discount will be shown during checkout.","Es werden zus\xe4tzliche Produkte angezeigt.":"Additional products are displayed.","Die Pr\xfcfung des Gutscheins erfolgt im n\xe4chsten Schritt":"The coupon will be checked in the next step","Ich m\xf6chte einen Betrag spenden":"I want to make a donation","Welcher Betrag soll gespendet werden?":"What amount do you want to donate?","Wir freuen uns \xfcber eine freiwillige Spende.":"We appreciate your voluntary donation.","Anderer Betrag":"Other amount","Andere":"Other","Spende":"Donation","Gutschein":"Coupon","Gutschein gilt nur f\xfcr bestimmte Produkte":"Coupon affects only certain products","Falls Du einen Coupon / Code hast, kannst Du diesen hier eingeben":"If you have a coupon / code, you can enter it here","Jetzt pr\xfcfen":"Check now","L\xe4dt..":"Loading..","Oh nein! Ein Fehler trat auf":"Something went wrong.","Leider gab es Probleme bei der Verarbeitung der Bestellung. Bitte versuche es sp\xe4ter nochmal.":"Unfortunately there was a problem while processing your order. Please try again later.","Dieser Shop wurde nicht gefunden.":"This shop was not found.","Dieser Shop ist zurzeit nicht aktiv.":"This shop is currently not active.","Fehler":"Error","Aktuell gibt es keine Produkte in diesem Shop.":"There are currently no products in this shop.","Bestellung bezahlt":"Order is paid","Bestellung nicht gefunden":"Order status","Leider konnten wir Deine Bestellung nicht finden.":"Thank you for your order! For technical reasons we currently cannot determine the status of your order. You should receive a confirmation email from us shortly.","Bestellung eingegangen":"Order received","Die Bestellung ist bei uns eingegangen. Du solltest in K\xfcrze eine E-Mail von uns mit Zahlungsinformationen erhalten.":"We have received your order. You will soon get an e-mail from us with payment information.","Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstm\xf6glich bei Dir per E-Mail.":"Your payment was successful. Thank you! We will get in touch with you by e-mail.","Bestellung abgebrochen":"Order cancelled","Leider wurde Deine Bestellung abgebrochen. Versuche es gern sp\xe4ter nochmal.":"Unfortunately your order was cancelled. Please try again later.","Status Deiner Bestellung":"Your order is currently in state","Direktverkauf":"Direct-Sale","Vor-Ort Ticketshop":"On-Site Ticket Shop","Eingeloggt als:":"Logged in as:","Ausloggen":"Log out","Mehr erfahren":"Read more","Coupon-Tickets":"Coupon Tickets","Alle Tickets anzeigen":"Show all tickets","Bitte ausw\xe4hlen":"Please choose","Ticket direkt an K\xe4ufer:In schicken":"Send ticket directly to client","CheckPopup":"Please enable in your browser that the Mollie payment window can be opened as a pop-up. Try disabling pop-up blockers or similir tools.","Wir haben gemerkt, dass Du schon mal Eingaben vorgenommen hast, m\xf6chtest Du diese verwenden?":"We noticed that you have already entered information. Would you like to use it?","Cookie-Einstellungen":"Cookie settings","Reduzierte Produkte sind hervorgehoben.":"Reduced items are highlighted.","Beinhaltet":"Contains","Ich m\xf6chte auf dem Laufenden bleiben":"I want to stay up to date","PDF drucken \xfcber":"Print PDF via","Label drucken \xfcber":"Print label via","Download (in neuem Tab \xf6ffnen)":"Download (open in new tab)","PDF drucken":"Print PDF","Label drucken":"Print label","PDF herunterladen":"Download PDF","Label herunterladen":"Download label","\u2026 wird gedruckt":"\u2026 printing","\u2713 gedruckt":"\u2713 printed","Fehler \u2014 bitte erneut versuchen":"Error \u2014 please try again","Einen Coupon / Code hier eingeben":"Enter a coupon / code here","Vielen Dank f\xfcr die Bestellung!":"Thank you for your order!","In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.":"You should receive a confirmation email shortly. Please also check your spam folder.","Vielen Dank f\xfcr die Bestellung! In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.":"Thank you for your order! You should receive a confirmation email shortly. Please also check your spam folder.","Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?":"We found previously entered data. Would you like to use it?","Zahlungsart":"Payment method","Terminal ausw\xe4hlen":"Select terminal","Bestellung in Abwicklung":"Order in progress","Bestellnummer":"Order number","Warte auf Zahlung":"Waiting for payment","Bestellung wird verarbeitet":"Processing order","Bitte Karte am Terminal halten. Diese Seite aktualisiert sich automatisch.":"Please hold the card to the terminal. This page will update automatically.","Die Bestellung wird gerade verarbeitet, bitte einen Moment warten.":"The order is being processed, please wait a moment.","Test-Bezahlung im Mollie-Dashboard \xf6ffnen":"Open test payment in the Mollie dashboard","Bestellung abbrechen":"Cancel order","Bestellung erfolgreich":"Order successful","Rechnung herunterladen":"Download invoice","Cashless-Zahlung \u2014 der Beleg kommt vom Terminal des Cashless-Anbieters. festiware erstellt f\xfcr diesen Verkauf keinen eigenen Kassenbeleg.":"Cashless payment \u2014 the receipt is issued by the cashless provider\'s terminal. festiware does not create its own receipt for this sale.","TSE aktuell offline":"TSE currently offline","Verkauf erfasst und Ticket g\xfcltig \u2014 die Fiskaly-Signatur wird automatisch nachgeholt, sobald die TSE wieder erreichbar ist. Bitte das Problem zeitnah von der Administration beheben lassen (\xa7146a AO).":"Sale recorded and ticket valid \u2014 the Fiskaly signature will be added automatically as soon as the TSE is reachable again. Please have the administration fix the issue promptly (\xa7146a AO).","Tickets drucken":"Print tickets","Es wurden keine Ticket-PDFs erzeugt.":"No ticket PDFs were generated.","Ticket":"Ticket","Neue Bestellung":"New order","Test-Zahlung Mollie":"Mollie test payment","Pop-up wurde blockiert. Bitte den folgenden Link \xf6ffnen:":"Pop-up was blocked. Please open the following link:","Alternativ im Mollie-Dashboard unter \\"Umsatz\\" die offene Zahlung manuell auf bezahlt setzen.":"Alternatively, manually mark the open payment as paid in the Mollie dashboard under \\"Transactions\\".","Schlie\xdfen":"Close","Produkte durchsuchen":"Search products","Keine Produkte gefunden":"No products found","Suche zur\xfccksetzen":"Clear search","Suche schlie\xdfen":"Close search","Produkt":"product","Produkte":"products"}');


var $348b38fcd088c1d1$exports = {};
$348b38fcd088c1d1$exports = JSON.parse('{"Ticket":"Ticket","Tickets":"Tickets","Ticket w\xe4hlen":"Ticket w\xe4hlen","Tickets ausw\xe4hlen":"Tickets ausw\xe4hlen","Tickets ausgew\xe4hlt":"ausgew\xe4hlt","Alle Arten":"Alle Arten","Ticketarten":"Ticket types","Ja":"Ja","Nein":"Nein","f\xfcr":"f\xfcr","Checkout":"Kasse","Nicht mehr verf\xfcgbar":"Nicht mehr verf\xfcgbar","Noch nicht verf\xfcgbar":"Noch nicht verf\xfcgbar","Required":"Ben\xf6tigt","Empf\xe4nger bestimmen":"Empf\xe4nger bestimmen","Zusammenfassung":"Zusammenfassung","Pers\xf6nliche Daten":"Pers\xf6nliche Daten","Zahlungsart ausw\xe4hlen":"Zahlungsart ausw\xe4hlen","Die Zahlungsarten erscheinen, sobald ein Land ausgew\xe4hlt ist.":"Die Zahlungsarten erscheinen, sobald ein Land ausgew\xe4hlt ist.","F\xfcr das gew\xe4hlte Land ist keine Zahlungsart verf\xfcgbar.":"F\xfcr das gew\xe4hlte Land ist keine Zahlungsart verf\xfcgbar.","Weiter":"Weiter","Zur\xfcck":"Zur\xfcck","Vorkasse":"Vorkasse","Vorname":"Vorname","Nachname":"Nachname","Stra\xdfe und Hausnummer":"Stra\xdfe und Hausnummer","Firma":"Firma","USt-Id":"USt-Id","Email":"E-Mail","E-Mail":"E-Mail","PLZ":"PLZ","Ort":"Ort","Land":"Land","Empf\xe4nger":"Empf\xe4nger","Anzahl":"Anzahl","Art":"Art","Enthaltene MwSt.":"Enthaltene MwSt.","Preis":"Preis","Zahlungsweise":"Zahlungsweise","Gesamt":"Gesamt","Total":"Gesamt","Jetzt kaufen":"Jetzt kostenpflichtig kaufen","Jetzt kostenlos bestellen":"Jetzt kostenlos bestellen","Einkaufsliste":"Einkaufsliste","Dies ist keine E-Mail-Adresse!":"Dies ist keine E-Mail-Adresse!","Nichts gefunden":"Nichts gefunden","Personalisieren":"Personalisieren","Personalisierung":"Personalisierung","Personalisiere die Tickets":"Personalisiere die Tickets","Ich habe die":"Ich habe die","AGB":"AGB","gelesen und akzeptiert.":"gelesen und akzeptiert.","Datenschutzerkl\xe4rung":"Datenschutzerkl\xe4rung","Vielen Dank f\xfcr die Bestellung! In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.":"Vielen Dank f\xfcr die Bestellung! In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.","Entschuldigung, es gab einen Fehler bei der \xdcbermittlung:":"Entschuldigung, es gab einen Fehler bei der \xdcbermittlung:","Entschuldigung, der Server meldet einen Fehler. Bitte versuche es sp\xe4ter noch einmal.":"Entschuldigung, der Server meldet einen Fehler. Bitte versuche es sp\xe4ter noch einmal.","Bitte versuche es sp\xe4ter noch einmal.":"Bitte versuche es sp\xe4ter noch einmal.","Teilnehmerdaten":"Teilnehmerdaten","Entschuldigung. Die Anzahl der gew\xfcnschten Tickets ist derzeit nicht verf\xfcgbar.":"Entschuldigung. Die Anzahl der gew\xfcnschten Tickets ist derzeit nicht verf\xfcgbar.","Beim Abschluss der Bestellung ist ein Fehler aufgetreten:":"Beim Abschluss der Bestellung ist ein Fehler aufgetreten:","Bitte \xfcberpr\xfcfe die AGBs":"Bitte \xfcberpr\xfcfe die AGBs und Datenschutzerkl\xe4rung","Geimpft/Genesen":"Geimpft/Genesen","Weder Geimpft noch Genesen":"Weder Geimpft noch Genesen","Keine Angabe":"Keine Angabe","Ticket entfernen":"Ticket entfernen","Ticket entfernen?":"Soll das Ticket wirklich entfernt werden?","Es wurden bereits Eingaben gespeichert. Sollen diese verwendet werden?":"Es wurden bereits Eingaben gespeichert. Sollen diese verwendet werden?","Keine g\xfcltige E-Mail-Adresse":"Keine g\xfcltige E-Mail-Adresse","Tage":"Tage","Mi":"Mi","Do":"Do","Fr":"Fr","Sa":"Sa","So":"So","Mo":"Mo","Karteninhaber":"Karteninhaber","Kreditkartennummer":"Kreditkartennummer","Verfallsdatum":"Verfallsdatum","Bezahlen":"Bezahlen","Zahlung gesichert und bereitgestellt von":"Zahlung gesichert und bereitgestellt von","OpenPaymentBeforeUnload":"Sicher, dass das Fenster geschlossen werden soll? Die Bestellung wird unwiderruflich abgebrochen.","Der eingegebene Gutschein-Code ist nicht g\xfcltig.":"Der eingegebene Gutschein-Code ist nicht g\xfcltig.","Ich habe einen Gutschein-Code":"Ich habe einen Gutschein-Code","Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert.":"Es wurde keine Zahlungsmethode in den Projekteinstellungen definiert!","Gutschein-Code":"Gutschein / Code","Die Pr\xfcfung des Gutscheins erfolgt im n\xe4chsten Schritt":"Die Pr\xfcfung des Gutscheins erfolgt im n\xe4chsten Schritt","Coupon-Code nicht gefunden oder nicht mehr g\xfcltig.":"Gutschein / Code nicht gefunden oder nicht mehr g\xfcltig.","Ich m\xf6chte einen Betrag spenden":"Ich m\xf6chte einen Betrag spenden","Welcher Betrag soll gespendet werden?":"Welcher Betrag soll gespendet werden?","Wir freuen uns \xfcber eine freiwillige Spende.":"Wir freuen uns \xfcber eine freiwillige Spende.","Anderer Betrag":"Anderer Betrag","Andere":"Andere","Spende":"Spende","Gutschein":"Gutschein","Gutschein gilt nur f\xfcr bestimmte Produkte":"Gutschein gilt nur f\xfcr bestimmte Produkte","Einen Coupon / Code hier eingeben":"Einen Gutschein / Code hier eingeben","Oh nein! Ein Fehler trat auf":"Da ist etwas schiefgelaufen.","Dieser Shop wurde nicht gefunden.":"Dieser Shop wurde nicht gefunden.","Dieser Shop ist zurzeit nicht aktiv.":"Dieser Shop ist zurzeit nicht aktiv.","Fehler":"Fehler","Aktuell gibt es keine Produkte in diesem Shop.":"Aktuell gibt es keine Produkte in diesem Shop.","Bestellung bezahlt":"Bestellung bezahlt","Bestellung nicht gefunden":"Bestellstatus","Leider konnte die Bestellung nicht gefunden werden.":"Leider konnte die Bestellung nicht gefunden werden. Aktuell kann aus technischen Gr\xfcnden kein Status zu dieser Bestellung ermittelt werden. In K\xfcrze sollte eine E-Mail mit allen Infos eingehen.","Bestellung eingegangen":"Bestellung eingegangen","Die Bestellung ist bei uns eingegangen. In K\xfcrze sollte eine E-Mail mit Zahlungsinformationen eingehen.":"Die Bestellung ist bei uns eingegangen. In K\xfcrze sollte eine E-Mail mit Zahlungsinformationen eingehen.","Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstm\xf6glich bei Dir per E-Mail.":"Die Bezahlung war erfolgreich. Vielen Dank! Wir melden uns schnellstm\xf6glich bei Dir per E-Mail.","Bestellung abgebrochen":"Bestellung abgebrochen","Leider wurde die Bestellung abgebrochen. Bitte gern sp\xe4ter nochmal versuchen.":"Leider wurde die Bestellung abgebrochen. Bitte gern sp\xe4ter nochmal versuchen.","Status der Bestellung":"Die Bestellung befindet sich im Status","Direktverkauf":"Direktverkauf","Vor-Ort Ticketshop":"Vor-Ort Ticketshop","Eingeloggt als:":"Eingeloggt als:","Ausloggen":"Ausloggen","Mehr erfahren":"Mehr erfahren","Coupon-Tickets":"Coupon-Tickets","Alle Tickets anzeigen":"Alle Tickets anzeigen","Bitte ausw\xe4hlen":"Bitte ausw\xe4hlen","Ticket direkt an K\xe4ufer:In schicken":"Ticket direkt an K\xe4ufer:In schicken","CheckPopup":"Bitte im Browser aktivieren, dass das Mollie Zahlungsfenster als Popup ge\xf6ffnet werden darf. Gegebenenfalls Popup-Blocker o.\xe4. deaktivieren.","Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?":"Es wurden bereits Eingaben vorgenommen. Sollen diese verwendet werden?","Reduzierte Produkte sind hervorgehoben.":"Reduzierte Produkte sind hervorgehoben.","Beinhaltet":"Beinhaltet","Ich m\xf6chte auf dem Laufenden bleiben":"Ich m\xf6chte auf dem Laufenden bleiben","Vielen Dank f\xfcr die Bestellung!":"Vielen Dank f\xfcr die Bestellung!","In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.":"In K\xfcrze sollte eine Best\xe4tigungsmail eingehen. Bitte auch den Spam-Ordner \xfcberpr\xfcfen.","PDF drucken \xfcber":"PDF drucken \xfcber","Label drucken \xfcber":"Label drucken \xfcber","Download (in neuem Tab \xf6ffnen)":"Download (in neuem Tab \xf6ffnen)","PDF drucken":"PDF drucken","Label drucken":"Label drucken","PDF herunterladen":"PDF herunterladen","Label herunterladen":"Label herunterladen","\u2026 wird gedruckt":"\u2026 wird gedruckt","\u2713 gedruckt":"\u2713 gedruckt","Fehler \u2014 bitte erneut versuchen":"Fehler \u2014 bitte erneut versuchen","Produkte durchsuchen":"Produkte durchsuchen","Keine Produkte gefunden":"Keine Produkte gefunden","Suche zur\xfccksetzen":"Suche zur\xfccksetzen","Suche schlie\xdfen":"Suche schlie\xdfen","Produkt":"Produkt","Produkte":"Produkte"}');


var $3b7be1ea1c2d1789$export$2e2bcd8739ae039 = (0, $7573617dde41bbef$exports.createI18n)({
    locale: localStorage.getItem("lang") || "de",
    messages: {
        en: (0, (/*@__PURE__*/$parcel$interopDefault($a55250be4b09786f$exports))),
        de: (0, (/*@__PURE__*/$parcel$interopDefault($348b38fcd088c1d1$exports)))
    },
    silentTranslationWarn: true,
    fallbackLocale: 'de'
});



var $2fn8G = parcelRequire("2fn8G");
const $2fb7a96a62e612b1$var$nativeMap = Array.prototype.map;
const $2fb7a96a62e612b1$var$nativeIsArray = Array.isArray;
const $2fb7a96a62e612b1$var$toString = Object.prototype.toString;
function $2fb7a96a62e612b1$export$bbcc4adf8f845287(obj) {
    return typeof obj === 'undefined' || obj === null;
}
function $2fb7a96a62e612b1$export$19248e3074bce54f(obj) {
    return !!(obj === '' || obj && obj.charCodeAt && obj.substr);
}
function $2fb7a96a62e612b1$export$cbeebb6d055bddc(obj) {
    return $2fb7a96a62e612b1$var$nativeIsArray ? $2fb7a96a62e612b1$var$nativeIsArray(obj) : $2fb7a96a62e612b1$var$toString.call(obj) === '[object Array]';
}
function $2fb7a96a62e612b1$export$a5e988a92bd8082c(obj) {
    return obj && $2fb7a96a62e612b1$var$toString.call(obj) === '[object Object]';
}
function $2fb7a96a62e612b1$export$5531554035767dc2(object, defs) {
    let key;
    object = object || {};
    defs = defs || {};
    // Iterate over object non-prototype properties:
    for(key in defs){
        // eslint-disable-next-line no-prototype-builtins
        if (defs.hasOwnProperty(key)) // Replace values with defaults only if undefined (allow empty/zero values):
        {
            if (object[key] == null) object[key] = defs[key];
        }
    }
    return object;
}
function $2fb7a96a62e612b1$export$cc236b5a14429687(obj, iterator, context) {
    if (!obj) return [];
    // Use native .map method if it exists:
    if ($2fb7a96a62e612b1$var$nativeMap && obj.map === $2fb7a96a62e612b1$var$nativeMap) return obj.map(iterator, context);
    const results = [];
    let i = 0;
    let j = 0;
    // Fallback for native .map:
    for(i = 0, j = obj.length; i < j; i++)// @ts-ignore
    results[i] = iterator.call(context, obj[i], i, obj);
    return results;
}


const $3f640c3bf29916d8$var$lib = {
    settings: {
        currency: {
            symbol: '$',
            format: '%s%v',
            decimal: '.',
            thousand: ',',
            precision: 2,
            grouping: 3 // digit grouping (not implemented yet)
        },
        number: {
            precision: 0,
            grouping: 3,
            thousand: ',',
            decimal: '.'
        }
    }
};
function $3f640c3bf29916d8$export$58de211e433c0dd(val, base = 0) {
    val = Math.round(Math.abs(val));
    return isNaN(val) ? base : val;
}
function $3f640c3bf29916d8$export$8ee360f1c9af3a26(format) {
    const defaults = $3f640c3bf29916d8$var$lib.settings.currency.format;
    // Allow function as format parameter (should return string or object):
    if (typeof format === 'function') format = format();
    // Format can be a string, in which case `value` ("%v") must be present:
    if ((0, $2fb7a96a62e612b1$export$19248e3074bce54f)(format) && format.match('%v')) // Create and return positive, negative and zero formats:
    return {
        pos: format,
        neg: format.replace('-', '').replace('%v', '-%v'),
        zero: format
    };
    else if (!format || !format.pos || !format.pos.match('%v')) // If defaults is a string, casts it to an object for faster checking next time:
    return !(0, $2fb7a96a62e612b1$export$19248e3074bce54f)(defaults) ? defaults : $3f640c3bf29916d8$var$lib.settings.currency.format = {
        pos: defaults,
        neg: defaults.replace('%v', '-%v'),
        zero: defaults
    };
    // Otherwise, assume format was fine:
    return format;
}
const $3f640c3bf29916d8$export$743c5b758cf1947c = function(value, decimal) {
    // Recursively unformat arrays:
    if ((0, $2fb7a96a62e612b1$export$cbeebb6d055bddc)(value)) return (0, $2fb7a96a62e612b1$export$cc236b5a14429687)(value, function(val) {
        return $3f640c3bf29916d8$export$743c5b758cf1947c(val, decimal);
    });
    // Fails silently (need decent errors):
    value = value || 0;
    // Return the value as-is if it's already a number:
    if (typeof value === 'number') return value;
    // Default decimal point comes from settings, but could be set to eg. "," in opts:
    decimal = decimal || $3f640c3bf29916d8$var$lib.settings.number.decimal;
    // Build regex to strip out everything except digits, decimal point and minus sign:
    // @ts-ignore
    const regex = new RegExp('[^0-9-' + decimal + ']', [
        'g'
    ]);
    const unformatted = parseFloat(('' + value).replace(/\((?=\d+)(.*)\)/, '-$1') // replace bracketed values with negatives
    .replace(regex, '') // strip out any cruft
    .replace(decimal, '.') // make sure decimal point is standard
    );
    // This will fail silently which may cause trouble, let's wait and see:
    return !isNaN(unformatted) ? unformatted : 0;
};
const $3f640c3bf29916d8$export$a81f732198733497 = function(value, precision) {
    precision = $3f640c3bf29916d8$export$58de211e433c0dd(precision, $3f640c3bf29916d8$var$lib.settings.number.precision);
    const exponentialForm = Number($3f640c3bf29916d8$export$743c5b758cf1947c(value) + 'e' + precision);
    const rounded = Math.round(exponentialForm);
    const finalResult = Number(rounded + 'e-' + precision).toFixed(precision);
    return finalResult;
};
const $3f640c3bf29916d8$export$f5dd818bff069720 = function(number, precision, thousand, decimal, avoidEmptyDecimals) {
    // Resursively format arrays:
    if ((0, $2fb7a96a62e612b1$export$cbeebb6d055bddc)(number)) return (0, $2fb7a96a62e612b1$export$cc236b5a14429687)(number, function(val) {
        return $3f640c3bf29916d8$export$f5dd818bff069720(val, precision, thousand, decimal, avoidEmptyDecimals);
    });
    // Clean up number:
    number = $3f640c3bf29916d8$export$743c5b758cf1947c(number);
    // Build options object from second param (if object) or all params, extending defaults:
    const opts = (0, $2fb7a96a62e612b1$export$5531554035767dc2)((0, $2fb7a96a62e612b1$export$a5e988a92bd8082c)(precision) ? precision : {
        precision: precision,
        thousand: thousand,
        decimal: decimal
    }, $3f640c3bf29916d8$var$lib.settings.number);
    // Clean up precision
    const usePrecision = $3f640c3bf29916d8$export$58de211e433c0dd(opts.precision);
    // Do some calc:
    const negative = number < 0 ? '-' : '';
    const base = parseInt($3f640c3bf29916d8$export$a81f732198733497(Math.abs(number || 0), usePrecision), 10) + '';
    const mod = base.length > 3 ? base.length % 3 : 0;
    let precisionString = '';
    if (usePrecision) {
        // default behaviour
        // 1234.56 and avoidEmptyDecimals whatever   => 1234.56
        // 1234.00 and avoidEmptyDecimals undefined  => 1234.00
        precisionString = opts.decimal + $3f640c3bf29916d8$export$a81f732198733497(Math.abs(number), usePrecision).split('.')[1];
        // 1234.00 and avoidEmptyDecimals == ''    => 1234
        // 1234.00 and avoidEmptyDecimals == '##'  => 1234.##
        if (avoidEmptyDecimals !== undefined && parseInt($3f640c3bf29916d8$export$a81f732198733497(Math.abs(number || 0), 1), 10) === number) precisionString = avoidEmptyDecimals === '' ? '' : opts.decimal + avoidEmptyDecimals;
    }
    // Format the number:
    return negative + (mod ? base.substr(0, mod) + opts.thousand : '') + base.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + opts.thousand) + precisionString;
};
const $3f640c3bf29916d8$export$a17b3c2052469c69 = function(number, symbol, precision, thousand, decimal, format, avoidEmptyDecimals) {
    // Resursively format arrays:
    if ((0, $2fb7a96a62e612b1$export$cbeebb6d055bddc)(number)) return (0, $2fb7a96a62e612b1$export$cc236b5a14429687)(number, function(val) {
        return $3f640c3bf29916d8$export$a17b3c2052469c69(val, symbol, precision, thousand, decimal, format, avoidEmptyDecimals);
    });
    // Clean up number:
    number = $3f640c3bf29916d8$export$743c5b758cf1947c(number);
    // Build options object from second param (if object) or all params, extending defaults:
    const opts = (0, $2fb7a96a62e612b1$export$5531554035767dc2)((0, $2fb7a96a62e612b1$export$a5e988a92bd8082c)(symbol) ? symbol : {
        symbol: symbol,
        precision: precision,
        thousand: thousand,
        decimal: decimal,
        format: format,
        avoidEmptyDecimals: avoidEmptyDecimals
    }, $3f640c3bf29916d8$var$lib.settings.currency);
    // Check format (returns object with pos, neg and zero):
    const formats = $3f640c3bf29916d8$export$8ee360f1c9af3a26(opts.format);
    // Choose which format to use for this value:
    const useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
    // Return with currency symbol added:
    return useFormat.replace('%s', opts.symbol).replace('%v', $3f640c3bf29916d8$export$f5dd818bff069720(Math.abs(number), $3f640c3bf29916d8$export$58de211e433c0dd(opts.precision), opts.thousand, opts.decimal, opts.avoidEmptyDecimals));
};


function $fdb0bbdbc5657c38$export$2e2bcd8739ae039(value, options) {
    let result = 0.0;
    const isNegative = String(value).charAt(0) === '-';
    if (isNegative) value = String(value).slice(1);
    const amount = parseFloat(value);
    if (!isNaN(amount)) result = amount;
    let formatConfig = '%s%v';
    if (options.symbolPosition === 'front') formatConfig = options.symbolSpacing ? '%s %v' : '%s%v';
    else formatConfig = options.symbolSpacing ? '%v %s' : '%v%s';
    if (options.fractionCount > 0) value = (0, $3f640c3bf29916d8$export$a81f732198733497)(value, options.fractionCount);
    // @ts-ignore
    result = (0, $3f640c3bf29916d8$export$a17b3c2052469c69)(value, {
        format: formatConfig,
        symbol: options.symbol,
        precision: options.fractionCount,
        thousand: options.thousandsSeparator,
        decimal: options.fractionSeparator
    });
    if (isNegative) // @ts-ignore
    result = '-' + result;
    return result;
}


// Needed for testing only
var $a0101318ea96f0f1$export$2e2bcd8739ae039 = {
    "vueform": {
        "elements": {
            "list": {
                "add": "+ Addieren",
                "remove": "&times;"
            },
            "file": {
                "defaultName": "File",
                "dndTitle": "File hochladen",
                "dndDescription": "File ablegen oder zum Hochladen hier klicken",
                "removeConfirm": "Durch das Entfernen Files wird diese endg\xfcltig gel\xf6scht. Sind Sie sicher, dass Sie fortfahren?",
                "select": "File ausw\xe4hlen",
                "upload": "Hochladen"
            },
            "multifile": {
                "uploadButton": "Files hochladen",
                "dndTitle": "Files hochladen",
                "dndDescription": "File ablegen oder zum Hochladen hier klicken"
            },
            "gallery": {
                "uploadButton": "Bilder hochladen",
                "dndTitle": "Bilder hochladen",
                "dndDescription": "Bild ablegen oder zum Hochladen hier klicken"
            },
            "phone": {
                "ariaLabel": "Select a country"
            }
        },
        "steps": {
            "finish": "Beenden",
            "next": "N\xe4chste",
            "previous": "Fr\xfcher"
        },
        "editor": {
            "acceptedMimesError": "Accepted mimes are: :mimes",
            "acceptedExtensionsError": "Accepted extenions are: :extensions",
            "acceptedMimes": "Akzeptierte mimes sind: :mimes",
            "acceptedExtensions": "Akzeptierte extenions sind: :extensions"
        },
        "datepicker": {
            "weekdays": {
                "shorthand": [
                    "So",
                    "Mo",
                    "Di",
                    "Mi",
                    "Do",
                    "Fr",
                    "Sa"
                ],
                "longhand": [
                    "Sonntag",
                    "Montag",
                    "Dienstag",
                    "Mittwoch",
                    "Donnerstag",
                    "Freitag",
                    "Samstag"
                ]
            },
            "months": {
                "shorthand": [
                    "Jan",
                    "Feb",
                    "M\xe4r",
                    "Apr",
                    "Mai",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Dez"
                ],
                "longhand": [
                    "Januar",
                    "Februar",
                    "M\xe4rz",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember"
                ]
            },
            "daysInMonth": [
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ],
            "firstDayOfWeek": 1,
            "ordinal": function() {
                return '';
            },
            "rangeSeparator": " bis ",
            "weekAbbreviation": "KW",
            "scrollTitle": "Zum \xc4ndern scrollen",
            "toggleTitle": "Zum Umschalten klicken",
            "amPM": [
                "AM",
                "PM"
            ],
            "yearAriaLabel": "Year",
            "monthAriaLabel": "Month",
            "hourAriaLabel": "Hour",
            "minuteAriaLabel": "Minute"
        },
        "dateFormats": {
            "datetimeSeconds24": "DD.MM.YYYY HH:mm:ss",
            "datetimeSeconds12": "DD.MM.YYYY hh:mm:ss a",
            "datetime24": "DD.MM.YYYY HH:mm",
            "datetime12": "DD.MM.YYYY hh:mm a",
            "timeSeconds24": "HH:mm:ss",
            "timeSeconds12": "hh:mm:ss a",
            "time24": "HH:mm",
            "time12": "hh:mm a",
            "date": "DD.MM.YYYY"
        },
        "multiselect": {
            "multipleLabelOne": "1 option ausgew\xe4hlt",
            "multipleLabelMore": ":options optionen ausgew\xe4hlt",
            "noResults": "Keine Optionen gefunden",
            "noOptions": "Liste ist leer."
        },
        "defaultMessage": "Ung\xfcltiges Feld",
        "a11y": {
            "file": {
                "description": "Press Backspace to remove"
            },
            "list": {
                "remove": "Remove item button"
            }
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albanien",
            "DZ": "Algerien",
            "AS": "Amerikanisch-Samoa",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AG": "Antigua und Barbuda",
            "AR": "Argentinien",
            "AM": "Armenien",
            "AW": "Aruba",
            "AC": "Ascension Island",
            "AU": "Australien",
            "AT": "\xd6sterreich",
            "AZ": "Aserbaidschan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesch",
            "BB": "Barbados",
            "BY": "Wei\xdfrussland",
            "BE": "Belgien",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivien",
            "BA": "Bosnien und Herzegowina",
            "BW": "Botswana",
            "BR": "Brasilien",
            "IO": "Britisches Territorium im Indischen Ozean",
            "VG": "Britische Jungferninseln",
            "BN": "Brunei",
            "BG": "Bulgarien",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Kambodscha",
            "CM": "Kamerun",
            "CA": "Kanada",
            "CV": "Kap Verde",
            "BQ": "Karibische Niederlande",
            "KY": "Kaimaninseln",
            "CF": "Zentralafrikanische Republik",
            "TD": "Tschad",
            "CL": "Chile",
            "CN": "China",
            "CO": "Kolumbien",
            "KM": "Komoren",
            "CG": "Kongo-Brazzaville",
            "CD": "Kongo-Kinshasa",
            "CK": "Cookinseln",
            "CR": "Costa Rica",
            "CI": "Elfenbeink\xfcste",
            "HR": "Kroatien",
            "CU": "Kuba",
            "CW": "Cura\xe7ao",
            "CY": "Zypern",
            "CZ": "Tschechien",
            "DK": "D\xe4nemark",
            "DJ": "Dschibuti",
            "DM": "Dominica",
            "DO": "Dominikanische Republik",
            "EC": "Ecuador",
            "EG": "\xc4gypten",
            "SV": "El Salvador",
            "GQ": "\xc4quatorialguinea",
            "ER": "Eritrea",
            "EE": "Estland",
            "SZ": "Eswatini",
            "ET": "\xc4thiopien",
            "FK": "Falklandinseln",
            "FO": "F\xe4r\xf6er",
            "FJ": "Fidschi",
            "FI": "Finnland",
            "FR": "Frankreich",
            "GF": "Franz\xf6sisch-Guayana",
            "PF": "Franz\xf6sisch-Polynesien",
            "GA": "Gabun",
            "GM": "Gambia",
            "GE": "Georgien",
            "DE": "Deutschland",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Griechenland",
            "GL": "Gr\xf6nland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HN": "Honduras",
            "HK": "Hongkong",
            "HU": "Ungarn",
            "IS": "Island",
            "IN": "Indien",
            "ID": "Indonesien",
            "IR": "Iran",
            "IQ": "Irak",
            "IE": "Irland",
            "IL": "Israel",
            "IT": "Italien",
            "JM": "Jamaika",
            "JP": "Japan",
            "JO": "Jordanien",
            "KZ": "Kasachstan",
            "KE": "Kenia",
            "KI": "Kiribati",
            "XK": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kirgisistan",
            "LA": "Laos",
            "LV": "Lettland",
            "LB": "Libanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libyen",
            "LI": "Liechtenstein",
            "LT": "Litauen",
            "LU": "Luxemburg",
            "MO": "Macao",
            "MG": "Madagaskar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Malediven",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshallinseln",
            "MQ": "Martinique",
            "MR": "Mauretanien",
            "MU": "Mauritius",
            "MX": "Mexiko",
            "FM": "Mikronesien",
            "MD": "Moldawien",
            "MC": "Monaco",
            "MN": "Mongolei",
            "ME": "Montenegro",
            "MS": "Montserrat",
            "MA": "Marokko",
            "MZ": "Mosambik",
            "MM": "Myanmar",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Niederlande",
            "NC": "Neukaledonien",
            "NZ": "Neuseeland",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolkinsel",
            "KP": "Nordkorea",
            "MK": "Nordmazedonien",
            "MP": "N\xf6rdliche Marianen",
            "NO": "Norwegen",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Pal\xe4stina",
            "PA": "Panama",
            "PG": "Papua-Neuguinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Philippinen",
            "PL": "Polen",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Katar",
            "RE": "R\xe9union",
            "RO": "Rum\xe4nien",
            "RU": "Russland",
            "RW": "Ruanda",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "S\xe3o Tom\xe9 und Pr\xedncipe",
            "SA": "Saudi-Arabien",
            "SN": "Senegal",
            "RS": "Serbien",
            "SC": "Seychellen",
            "SL": "Sierra Leone",
            "SG": "Singapur",
            "SX": "Sint Maarten",
            "SK": "Slowakei",
            "SI": "Slowenien",
            "SB": "Salomonen",
            "SO": "Somalia",
            "ZA": "S\xfcdafrika",
            "KR": "S\xfcdkorea",
            "SS": "S\xfcdsudan",
            "ES": "Spanien",
            "LK": "Sri Lanka",
            "BL": "Saint-Barth\xe9lemy",
            "SH": "St. Helena",
            "KN": "St. Kitts und Nevis",
            "LC": "St. Lucia",
            "MF": "St. Martin",
            "PM": "St. Pierre und Miquelon",
            "VC": "St. Vincent und die Grenadinen",
            "SD": "Sudan",
            "SR": "Suriname",
            "SE": "Schweden",
            "CH": "Schweiz",
            "SY": "Syrien",
            "TW": "Taiwan",
            "TJ": "Tadschikistan",
            "TZ": "Tansania",
            "TH": "Thailand",
            "TL": "Osttimor",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad und Tobago",
            "TN": "Tunesien",
            "TR": "T\xfcrkei",
            "TM": "Turkmenistan",
            "TC": "Turks- und Caicosinseln",
            "TV": "Tuvalu",
            "VI": "Amerikanische Jungferninseln",
            "UG": "Uganda",
            "UA": "Ukraine",
            "AE": "Vereinigte Arabische Emirate",
            "GB": "Vereinigtes K\xf6nigreich",
            "US": "Vereinigte Staaten",
            "UY": "Uruguay",
            "UZ": "Usbekistan",
            "VU": "Vanuatu",
            "VA": "Vatikanstadt",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "WF": "Wallis und Futuna",
            "YE": "Jemen",
            "ZM": "Sambia",
            "ZW": "Simbabwe"
        }
    },
    "validation": {
        "accepted": ":attribute muss akzeptiert werden.",
        "active_url": ":attribute ist keine g\xfcltige Internet-Adresse.",
        "after": ":attribute muss ein Datum nach :date sein.",
        "after_or_equal": ":attribute muss ein Datum nach :date oder gleich :date sein.",
        "alpha": ":attribute darf nur aus Buchstaben bestehen.",
        "alpha_dash": ":attribute darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.",
        "alpha_num": ":attribute darf nur aus Buchstaben und Zahlen bestehen.",
        "array": ":attribute muss ein Array sein.",
        "before": ":attribute muss ein Datum vor :date sein.",
        "before_or_equal": ":attribute muss ein Datum vor :date oder gleich :date sein.",
        "between": {
            "numeric": ":attribute muss zwischen :min & :max liegen.",
            "file": ":attribute muss zwischen :min & :max Kilobytes gro\xdf sein.",
            "string": ":attribute muss zwischen :min & :max Zeichen lang sein.",
            "array": ":attribute muss zwischen :min & :max Elemente haben."
        },
        "boolean": ":attribute muss entweder true oder false sein.",
        "captcha": "Please verify that you are not a robot.",
        "completed": "Please fill in a valid phone number.",
        "confirmed": ":attribute stimmt nicht mit der Best\xe4tigung \xfcberein.",
        "date": ":attribute muss ein g\xfcltiges Datum sein.",
        "date_format": ":attribute entspricht nicht dem g\xfcltigen Format f\xfcr :format.",
        "date_equals": ":attribute muss ein Datum gleich :date sein.",
        "different": ":attribute und :other m\xfcssen sich unterscheiden.",
        "digits": ":attribute muss :digits Stellen haben.",
        "digits_between": ":attribute muss zwischen :min und :max Stellen haben.",
        "dimensions": ":attribute hat ung\xfcltige Bildabmessungen.",
        "distinct": ":attribute beinhaltet einen bereits vorhandenen Wert.",
        "email": ":attribute muss eine g\xfcltige E-Mail-Adresse sein.",
        "exists": "Der gew\xe4hlte Wert f\xfcr :attribute ist ung\xfcltig.",
        "file": ":attribute muss eine Datei sein.",
        "filled": ":attribute muss ausgef\xfcllt sein.",
        "gt": {
            "numeric": ":attribute muss gr\xf6\xdfer als :value sein.",
            "file": ":attribute muss gr\xf6\xdfer als :value Kilobytes sein.",
            "string": ":attribute muss l\xe4nger als :value Zeichen sein.",
            "array": ":attribute muss mehr als :value Elemente haben."
        },
        "gte": {
            "numeric": ":attribute muss gr\xf6\xdfer oder gleich :value sein.",
            "file": ":attribute muss gr\xf6\xdfer oder gleich :value Kilobytes sein.",
            "string": ":attribute muss mindestens :value Zeichen lang sein.",
            "array": ":attribute muss mindestens :value Elemente haben."
        },
        "image": ":attribute muss ein Bild sein.",
        "in": "Der gew\xe4hlte Wert f\xfcr :attribute ist ung\xfcltig.",
        "in_array": "Der gew\xe4hlte Wert f\xfcr :attribute kommt nicht in :other vor.",
        "integer": ":attribute muss eine ganze Zahl sein.",
        "ip": ":attribute muss eine g\xfcltige IP-Adresse sein.",
        "ipv4": ":attribute muss eine g\xfcltige IPv4-Adresse sein.",
        "ipv6": ":attribute muss eine g\xfcltige IPv6-Adresse sein.",
        "json": ":attribute muss ein g\xfcltiger JSON-String sein.",
        "lt": {
            "numeric": ":attribute muss kleiner als :value sein.",
            "file": ":attribute muss kleiner als :value Kilobytes sein.",
            "string": ":attribute muss k\xfcrzer als :value Zeichen sein.",
            "array": ":attribute muss weniger als :value Elemente haben."
        },
        "lte": {
            "numeric": ":attribute muss kleiner oder gleich :value sein.",
            "file": ":attribute muss kleiner oder gleich :value Kilobytes sein.",
            "string": ":attribute darf maximal :value Zeichen lang sein.",
            "array": ":attribute darf maximal :value Elemente haben."
        },
        "max": {
            "numeric": ":attribute darf maximal :max sein.",
            "file": ":attribute darf maximal :max Kilobytes gro\xdf sein.",
            "string": ":attribute darf maximal :max Zeichen haben.",
            "array": ":attribute darf maximal :max Elemente haben."
        },
        "mimes": ":attribute muss den Dateityp :values haben.",
        "mimetypes": ":attribute muss den Dateityp :values haben.",
        "min": {
            "numeric": ":attribute muss mindestens :min sein.",
            "file": ":attribute muss mindestens :min Kilobytes gro\xdf sein.",
            "string": ":attribute muss mindestens :min Zeichen lang sein.",
            "array": ":attribute muss mindestens :min Elemente haben."
        },
        "not_in": "Der gew\xe4hlte Wert f\xfcr :attribute ist ung\xfcltig.",
        "not_regex": ":attribute hat ein ung\xfcltiges Format.",
        "numeric": ":attribute muss eine Zahl sein.",
        "present": ":attribute muss vorhanden sein.",
        "regex": ":attribute Format ist ung\xfcltig.",
        "required": ":attribute muss ausgef\xfcllt werden.",
        "required_if": ":attribute muss ausgef\xfcllt werden, wenn :other den Wert :value hat.",
        "required_unless": ":attribute muss ausgef\xfcllt werden, wenn :other nicht den Wert :values hat.",
        "required_with": ":attribute muss ausgef\xfcllt werden, wenn :values ausgef\xfcllt wurde.",
        "required_with_all": ":attribute muss ausgef\xfcllt werden, wenn :values ausgef\xfcllt wurde.",
        "required_without": ":attribute muss ausgef\xfcllt werden, wenn :values nicht ausgef\xfcllt wurde.",
        "required_without_all": ":attribute muss ausgef\xfcllt werden, wenn keines der Felder :values ausgef\xfcllt wurde.",
        "same": ":attribute und :other m\xfcssen \xfcbereinstimmen.",
        "size": {
            "numeric": ":attribute muss gleich :size sein.",
            "file": ":attribute muss :size Kilobyte gro\xdf sein.",
            "string": ":attribute muss :size Zeichen lang sein.",
            "array": ":attribute muss genau :size Elemente haben."
        },
        "string": ":attribute muss ein String sein.",
        "timezone": ":attribute muss eine g\xfcltige Zeitzone sein.",
        "unique": ":attribute ist bereits vergeben.",
        "uploaded": ":attribute konnte nicht hochgeladen werden.",
        "url": ":attribute muss eine URL sein.",
        "uuid": ":attribute muss ein UUID sein.",
        "remote": "Das Feld :attribute ist ung\xfcltig."
    }
};


// Needed for testing only
var $f2dccf0e4346ab80$export$2e2bcd8739ae039 = {
    "vueform": {
        "elements": {
            "list": {
                "add": "+ Add",
                "remove": "&times;"
            },
            "file": {
                "defaultName": "File",
                "dndTitle": "Upload file",
                "dndDescription": "Drop file or click here to upload",
                "removeConfirm": "By removing the file it will be permanently deleted. Are you sure to continue?",
                "select": "Select file",
                "upload": "Upload"
            },
            "multifile": {
                "uploadButton": "Upload files",
                "dndTitle": "Upload files",
                "dndDescription": "Drop files or click here to upload"
            },
            "gallery": {
                "uploadButton": "Upload images",
                "dndTitle": "Upload images",
                "dndDescription": "Drop images or click here to upload"
            },
            "phone": {
                "ariaLabel": "Select a country"
            },
            "signature": {
                "type": "Type",
                "draw": "Draw",
                "upload": "Upload",
                "font": "Select typeface",
                "fontPlaceholder": "Your Name",
                "placeholder": "Sign here",
                "unsupportedFormat": "Unsupported file format. Accepted extenions are: :extensions"
            }
        },
        "steps": {
            "finish": "Finish",
            "next": "Next",
            "previous": "Previous"
        },
        "editor": {
            "acceptedMimesError": "Accepted mimes are: :mimes",
            "acceptedExtensionsError": "Accepted extenions are: :extensions"
        },
        "datepicker": {
            "weekdays": {
                "shorthand": [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                "longhand": [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ]
            },
            "months": {
                "shorthand": [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                "longhand": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ]
            },
            "daysInMonth": [
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ],
            "firstDayOfWeek": 0,
            "ordinal": function(nth) {
                var s = nth % 100;
                if (s > 3 && s < 21) return "th";
                switch(s % 10){
                    case 1:
                        return "st";
                    case 2:
                        return "nd";
                    case 3:
                        return "rd";
                    default:
                        return "th";
                }
            },
            "rangeSeparator": " to ",
            "weekAbbreviation": "Wk",
            "scrollTitle": "Scroll to increment",
            "toggleTitle": "Click to toggle",
            "amPM": [
                "AM",
                "PM"
            ],
            "yearAriaLabel": "Year",
            "monthAriaLabel": "Month",
            "hourAriaLabel": "Hour",
            "minuteAriaLabel": "Minute"
        },
        "dateFormats": {
            "datetimeSeconds24": "YYYY-MM-DD HH:mm:ss",
            "datetimeSeconds12": "YYYY-MM-DD hh:mm:ss a",
            "datetime24": "YYYY-MM-DD HH:mm",
            "datetime12": "YYYY-MM-DD hh:mm a",
            "timeSeconds24": "HH:mm:ss",
            "timeSeconds12": "hh:mm:ss a",
            "time24": "HH:mm",
            "time12": "hh:mm a",
            "date": "YYYY-MM-DD"
        },
        "multiselect": {
            "multipleLabelOne": "1 option selected",
            "multipleLabelMore": ":options options selected",
            "noResults": "No options found",
            "noOptions": "The list is empty"
        },
        "defaultMessage": "Invalid field",
        "a11y": {
            "file": {
                "description": "Press Backspace to remove"
            },
            "list": {
                "remove": "Remove item button"
            }
        },
        "countries": {
            "AF": "Afghanistan",
            "AL": "Albania",
            "DZ": "Algeria",
            "AS": "American Samoa",
            "AD": "Andorra",
            "AO": "Angola",
            "AI": "Anguilla",
            "AG": "Antigua & Barbuda",
            "AR": "Argentina",
            "AM": "Armenia",
            "AW": "Aruba",
            "AC": "Ascension Island",
            "AU": "Australia",
            "AT": "Austria",
            "AZ": "Azerbaijan",
            "BS": "Bahamas",
            "BH": "Bahrain",
            "BD": "Bangladesh",
            "BB": "Barbados",
            "BY": "Belarus",
            "BE": "Belgium",
            "BZ": "Belize",
            "BJ": "Benin",
            "BM": "Bermuda",
            "BT": "Bhutan",
            "BO": "Bolivia",
            "BA": "Bosnia & Herzegovina",
            "BW": "Botswana",
            "BR": "Brazil",
            "IO": "British Indian Ocean Territory",
            "VG": "British Virgin Islands",
            "BN": "Brunei",
            "BG": "Bulgaria",
            "BF": "Burkina Faso",
            "BI": "Burundi",
            "KH": "Cambodia",
            "CM": "Cameroon",
            "CA": "Canada",
            "CV": "Cape Verde",
            "BQ": "Caribbean Netherlands",
            "KY": "Cayman Islands",
            "CF": "Central African Republic",
            "TD": "Chad",
            "CL": "Chile",
            "CN": "China",
            "CO": "Colombia",
            "KM": "Comoros",
            "CG": "Congo - Brazzaville",
            "CD": "Congo - Kinshasa",
            "CK": "Cook Islands",
            "CR": "Costa Rica",
            "CI": "C\xf4te d\u2019Ivoire",
            "HR": "Croatia",
            "CU": "Cuba",
            "CW": "Cura\xe7ao",
            "CY": "Cyprus",
            "CZ": "Czechia",
            "DK": "Denmark",
            "DJ": "Djibouti",
            "DM": "Dominica",
            "DO": "Dominican Republic",
            "EC": "Ecuador",
            "EG": "Egypt",
            "SV": "El Salvador",
            "GQ": "Equatorial Guinea",
            "ER": "Eritrea",
            "EE": "Estonia",
            "SZ": "Eswatini",
            "ET": "Ethiopia",
            "FK": "Falkland Islands (Islas Malvinas)",
            "FO": "Faroe Islands",
            "FJ": "Fiji",
            "FI": "Finland",
            "FR": "France",
            "GF": "French Guiana",
            "PF": "French Polynesia",
            "GA": "Gabon",
            "GM": "Gambia",
            "GE": "Georgia",
            "DE": "Germany",
            "GH": "Ghana",
            "GI": "Gibraltar",
            "GR": "Greece",
            "GL": "Greenland",
            "GD": "Grenada",
            "GP": "Guadeloupe",
            "GU": "Guam",
            "GT": "Guatemala",
            "GN": "Guinea",
            "GW": "Guinea-Bissau",
            "GY": "Guyana",
            "HT": "Haiti",
            "HN": "Honduras",
            "HK": "Hong Kong",
            "HU": "Hungary",
            "IS": "Iceland",
            "IN": "India",
            "ID": "Indonesia",
            "IR": "Iran",
            "IQ": "Iraq",
            "IE": "Ireland",
            "IL": "Israel",
            "IT": "Italy",
            "JM": "Jamaica",
            "JP": "Japan",
            "JO": "Jordan",
            "KZ": "Kazakhstan",
            "KE": "Kenya",
            "KI": "Kiribati",
            "XK": "Kosovo",
            "KW": "Kuwait",
            "KG": "Kyrgyzstan",
            "LA": "Laos",
            "LV": "Latvia",
            "LB": "Lebanon",
            "LS": "Lesotho",
            "LR": "Liberia",
            "LY": "Libya",
            "LI": "Liechtenstein",
            "LT": "Lithuania",
            "LU": "Luxembourg",
            "MO": "Macao",
            "MG": "Madagascar",
            "MW": "Malawi",
            "MY": "Malaysia",
            "MV": "Maldives",
            "ML": "Mali",
            "MT": "Malta",
            "MH": "Marshall Islands",
            "MQ": "Martinique",
            "MR": "Mauritania",
            "MU": "Mauritius",
            "MX": "Mexico",
            "FM": "Micronesia",
            "MD": "Moldova",
            "MC": "Monaco",
            "MN": "Mongolia",
            "ME": "Montenegro",
            "MS": "Montserrat",
            "MA": "Morocco",
            "MZ": "Mozambique",
            "MM": "Myanmar (Burma)",
            "NA": "Namibia",
            "NR": "Nauru",
            "NP": "Nepal",
            "NL": "Netherlands",
            "NC": "New Caledonia",
            "NZ": "New Zealand",
            "NI": "Nicaragua",
            "NE": "Niger",
            "NG": "Nigeria",
            "NU": "Niue",
            "NF": "Norfolk Island",
            "KP": "North Korea",
            "MK": "North Macedonia",
            "MP": "Northern Mariana Islands",
            "NO": "Norway",
            "OM": "Oman",
            "PK": "Pakistan",
            "PW": "Palau",
            "PS": "Palestine",
            "PA": "Panama",
            "PG": "Papua New Guinea",
            "PY": "Paraguay",
            "PE": "Peru",
            "PH": "Philippines",
            "PL": "Poland",
            "PT": "Portugal",
            "PR": "Puerto Rico",
            "QA": "Qatar",
            "RE": "R\xe9union",
            "RO": "Romania",
            "RU": "Russia",
            "RW": "Rwanda",
            "WS": "Samoa",
            "SM": "San Marino",
            "ST": "S\xe3o Tom\xe9 & Pr\xedncipe",
            "SA": "Saudi Arabia",
            "SN": "Senegal",
            "RS": "Serbia",
            "SC": "Seychelles",
            "SL": "Sierra Leone",
            "SG": "Singapore",
            "SX": "Sint Maarten",
            "SK": "Slovakia",
            "SI": "Slovenia",
            "SB": "Solomon Islands",
            "SO": "Somalia",
            "ZA": "South Africa",
            "KR": "South Korea",
            "SS": "South Sudan",
            "ES": "Spain",
            "LK": "Sri Lanka",
            "BL": "St. Barth\xe9lemy",
            "SH": "St. Helena",
            "KN": "St. Kitts & Nevis",
            "LC": "St. Lucia",
            "MF": "St. Martin",
            "PM": "St. Pierre & Miquelon",
            "VC": "St. Vincent & Grenadines",
            "SD": "Sudan",
            "SR": "Suriname",
            "SE": "Sweden",
            "CH": "Switzerland",
            "SY": "Syria",
            "TW": "Taiwan",
            "TJ": "Tajikistan",
            "TZ": "Tanzania",
            "TH": "Thailand",
            "TL": "Timor-Leste",
            "TG": "Togo",
            "TK": "Tokelau",
            "TO": "Tonga",
            "TT": "Trinidad & Tobago",
            "TN": "Tunisia",
            "TR": "T\xfcrkiye",
            "TM": "Turkmenistan",
            "TC": "Turks & Caicos Islands",
            "TV": "Tuvalu",
            "VI": "U.S. Virgin Islands",
            "UG": "Uganda",
            "UA": "Ukraine",
            "AE": "United Arab Emirates",
            "GB": "United Kingdom",
            "US": "United States",
            "UY": "Uruguay",
            "UZ": "Uzbekistan",
            "VU": "Vanuatu",
            "VA": "Vatican City",
            "VE": "Venezuela",
            "VN": "Vietnam",
            "WF": "Wallis & Futuna",
            "YE": "Yemen",
            "ZM": "Zambia",
            "ZW": "Zimbabwe"
        }
    },
    "validation": {
        "accepted": "The :attribute must be accepted.",
        "active_url": "The :attribute is not a valid URL.",
        "after": "The :attribute must be a date after :date.",
        "after_or_equal": "The :attribute must be a date after or equal to :date.",
        "alpha": "The :attribute may only contain letters.",
        "alpha_dash": "The :attribute may only contain letters, numbers, dashes and underscores.",
        "alpha_num": "The :attribute may only contain letters and numbers.",
        "array": "The :attribute must be an array.",
        "before": "The :attribute must be a date before :date.",
        "before_or_equal": "The :attribute must be a date before or equal to :date.",
        "between": {
            "numeric": "The :attribute must be between :min and :max.",
            "file": "The :attribute must be between :min and :max kilobytes.",
            "string": "The :attribute must be between :min and :max characters.",
            "array": "The :attribute must have between :min and :max items."
        },
        "boolean": "The :attribute field must be true or false.",
        "captcha": "Please verify that you are not a robot.",
        "completed": "Please fill in a valid phone number.",
        "confirmed": "The :attribute confirmation does not match.",
        "date": "The :attribute is not a valid date.",
        "date_format": "The :attribute does not match the format :format.",
        "date_equals": "The :attribute must be equal to :date.",
        "different": "The :attribute and :other must be different.",
        "digits": "The :attribute must be :digits digits.",
        "digits_between": "The :attribute must be between :min and :max digits.",
        "dimensions": "The :attribute has invalid image dimensions.",
        "distinct": "The :attribute field has a duplicate value.",
        "email": "The :attribute must be a valid email address.",
        "exists": "The selected :attribute is invalid.",
        "file": "The :attribute must be a file.",
        "filled": "The :attribute field must have a value.",
        "gt": {
            "numeric": "The :attribute must be greater than :value.",
            "file": "The :attribute must be greater than :value kilobytes.",
            "string": "The :attribute must be greater than :value characters.",
            "array": "The :attribute must have more than :value items."
        },
        "gte": {
            "numeric": "The :attribute must be greater than or equal :value.",
            "file": "The :attribute must be greater than or equal :value kilobytes.",
            "string": "The :attribute must be greater than or equal :value characters.",
            "array": "The :attribute must have :value items or more."
        },
        "image": "The :attribute must be an image.",
        "in": "The selected :attribute is invalid.",
        "in_array": "The :attribute field does not exist in :other.",
        "integer": "The :attribute must be an integer.",
        "ip": "The :attribute must be a valid IP address.",
        "ipv4": "The :attribute must be a valid IPv4 address.",
        "ipv6": "The :attribute must be a valid IPv6 address.",
        "json": "The :attribute must be a valid JSON string.",
        "lt": {
            "numeric": "The :attribute must be less than :value.",
            "file": "The :attribute must be less than :value kilobytes.",
            "string": "The :attribute must be less than :value characters.",
            "array": "The :attribute must have less than :value items."
        },
        "lte": {
            "numeric": "The :attribute must be less than or equal :value.",
            "file": "The :attribute must be less than or equal :value kilobytes.",
            "string": "The :attribute must be less than or equal :value characters.",
            "array": "The :attribute must not have more than :value items."
        },
        "max": {
            "numeric": "The :attribute may not be greater than :max.",
            "file": "The :attribute may not be greater than :max kilobytes.",
            "string": "The :attribute may not be greater than :max characters.",
            "array": "The :attribute may not have more than :max items."
        },
        "mimes": "The :attribute must be a file of type: :values.",
        "mimetypes": "The :attribute must be a file of type: :values.",
        "min": {
            "numeric": "The :attribute must be at least :min.",
            "file": "The :attribute must be at least :min kilobytes.",
            "string": "The :attribute must be at least :min characters.",
            "array": "The :attribute must have at least :min items."
        },
        "not_in": "The selected :attribute is invalid.",
        "not_regex": "The :attribute format is invalid.",
        "numeric": "The :attribute must be a number.",
        "present": "The :attribute field must be present.",
        "regex": "The :attribute format is invalid.",
        "required": "The :attribute field is required.",
        "required_if": "The :attribute field is required when :other is :value.",
        "required_unless": "The :attribute field is required unless :other is in :values.",
        "required_with": "The :attribute field is required when :values is present.",
        "required_with_all": "The :attribute field is required when :values are present.",
        "required_without": "The :attribute field is required when :values is not present.",
        "required_without_all": "The :attribute field is required when none of :values are present.",
        "same": "The :attribute and :other must match.",
        "size": {
            "numeric": "The :attribute must be :size.",
            "file": "The :attribute must be :size kilobytes.",
            "string": "The :attribute must be :size characters.",
            "array": "The :attribute must contain :size items."
        },
        "string": "The :attribute must be a string.",
        "timezone": "The :attribute must be a valid zone.",
        "unique": "The :attribute has already been taken.",
        "uploaded": "The :attribute failed to upload.",
        "url": "The :attribute format is invalid.",
        "uuid": "The :attribute must be a valid UUID.",
        "remote": "The :attribute field is invalid."
    }
};


var $d393eac6b2a61824$export$2e2bcd8739ae039 = {
    "festiware": {
        'repeater': {
            'is_owner_person': 'Ist Ansprechperson',
            'is_owner_person_hint': '<div class="uk-alert uk-alert-primary uk-margin-remove-bottom">Hinweis: Die n\xf6tigen Angaben zur Ansprechperson werden hier verwendet. Falls diese noch nicht eingegeben wurden, werden sie in einem n\xe4chsten Schritt erfragt.</div>',
            'add': "Person hinzuf\xfcgen",
            'change_owner_person': '<div class="uk-flex"><div class="uk-width-small"><i uk-icon="icon:warning; ratio:2"></i></div><div>Achtung: Eine \xc4nderung der Ansprechperson hat zur Folge, dass dieses Formular nach dem Speichern nicht mehr aufgerufen werden kann!</div>',
            'bulk_upload': {
                'toggle': 'Personen aus CSV-/Excel-Datei importieren',
                'button': 'Liste hochladen',
                'template': 'Vorlage herunterladen',
                'template_filename': 'import-vorlage',
                'hint': "Mehrere Personen aus einer CSV- oder Excel-Datei \xfcbernehmen, statt sie einzeln einzugeben.",
                'phone_hint': "Telefonnummern mit f\xfchrender 0 (z. B. 0160 1234567) oder mit L\xe4ndervorwahl (z. B. +49 160 1234567) angeben \u2014 Leerzeichen sind erlaubt. Damit Excel das + oder die f\xfchrende 0 nicht entfernt, die Telefonspalte als Text formatieren oder die Datei als CSV speichern.",
                'imported': ":count Zeile(n) \xfcbernommen. Bitte die Angaben pr\xfcfen und das Formular absenden.",
                'unmatched': 'Nicht zugeordnete Spalten: :columns.',
                'unmatched_values': 'Spalte \u201E:field": Die Werte :values passen zu keiner Auswahlm\xf6glichkeit und bleiben leer. Erlaubt sind: :options.',
                'limit': ":skipped Zeile(n) wurden nicht hinzugef\xfcgt \u2014 die maximale Anzahl (:max) ist erreicht.",
                'limit_full': "Die maximale Anzahl (:max) ist bereits erreicht. Es wurden keine Zeilen hinzugef\xfcgt.",
                'empty': "Die Datei enth\xe4lt keine verwertbaren Zeilen.",
                'error': 'Die Datei konnte nicht gelesen werden. Bitte eine CSV- oder Excel-Datei verwenden.',
                'progress_reading': "Datei wird gelesen \u2026",
                'progress_importing': "Importiere Personen \u2026 (:done von :total)"
            }
        },
        'use_stored_data': 'Im Formular wurden bereits Eingaben vorgenommen. Soll fortgefahren werden?',
        'yes': 'Ja',
        'no': 'Nein',
        'update_success_default': 'Die Angaben wurden erfolgreich gespeichert.',
        'selfie': {
            'select': "Bild w\xe4hlen",
            'camera': 'Mit Kamera aufnehmen',
            'camera_starting': "Kamera wird gestartet \u2026",
            'camera_label': 'Kamera',
            'capture': 'Foto aufnehmen',
            'cancel': 'Abbrechen',
            'confirm': "Ausschnitt \xfcbernehmen",
            'discard': 'Verwerfen',
            'zoom': 'Zoom',
            'reset': "Zur\xfccksetzen",
            'ratio': "Seitenverh\xe4ltnis:",
            'hint': "Bild verschieben (ziehen) und zoomen \u2014 dieser Ausschnitt wird gespeichert.",
            'camera_not_ready': 'Die Kamera liefert noch kein Bild. Bitte kurz warten und erneut versuchen.',
            'camera_denied': "Der Kamerazugriff wurde abgelehnt. Bitte im Browser f\xfcr diese Seite erlauben.",
            'camera_missing': 'Es wurde keine Kamera gefunden.',
            'camera_busy': "Die Kamera ist belegt \u2014 bitte andere Programme schlie\xdfen, die sie nutzen.",
            'camera_failed': 'Die Kamera konnte nicht gestartet werden.',
            'crop_failed': 'Der Bildausschnitt konnte nicht erzeugt werden.'
        },
        'calendar': {
            'text': 'Den immer aktuellen Stand der Termine zum Abonnieren in einer Kalender-App gibt es unter folgendem Link:',
            'link': 'Kalender-Abonnement URL'
        },
        'errors': {
            'owner_person_not_defined': 'Es wurde keine Ansprechperson angegeben. Bitte passe die Angabe bei den Personen-Feldern entsprechend an.',
            'update_request_target_missing': "Die zu bearbeitende Gruppe konnte nicht eindeutig zugeordnet werden. Bitte das Formular \xfcber die jeweilige Gruppe im Portal erneut \xf6ffnen oder den Veranstalter kontaktieren.",
            'not_valid_for_group': "F\xfcr diese Gruppe besteht keine Bearbeitungsberechtigung. Bitte das Formular \xfcber die zugeh\xf6rige Gruppe im Portal \xf6ffnen oder den Veranstalter kontaktieren.",
            'person_deactivated': "Der Zugang zum Portal wurde deaktiviert. Die Angaben k\xf6nnen nicht mehr ge\xe4ndert werden. Bitte den Veranstalter kontaktieren, falls das ein Irrtum ist.",
            'events_maximum_selection_exceeded': "Es wurden mehr Termine ausgew\xe4hlt als zul\xe4ssig. Bitte die Auswahl reduzieren und erneut speichern.",
            'tab_hint': 'Es gibt noch fehlende Angaben bei',
            'tab_hint_buttons': {
                'ok': 'Verstanden'
            },
            'generic_error': "Ein Fehler ist aufgetreten. Bitte versuche es sp\xe4ter erneut."
        },
        'tabs': {
            'scrollLeft': 'Tabs nach links scrollen',
            'scrollRight': 'Tabs nach rechts scrollen',
            'offscreenErrors': 'Fehler',
            'errorBadge': 'Fehler',
            'save': 'Speichern',
            'saving': "Speichern\u2026"
        },
        'steps': {
            'scrollLeft': 'Schritte nach links scrollen',
            'scrollRight': 'Schritte nach rechts scrollen',
            'offscreenErrors': 'Fehler',
            'errorBadge': 'Fehler'
        },
        'no_visible_fields': "Aktuell sind keine Felder zur Bearbeitung verf\xfcgbar.",
        'uploading_files': "Upload von :count Datei(en). Bitte warten\u2026",
        'upload_failed': 'Der Upload ist fehlgeschlagen. Bitte versuche es erneut.',
        'events': {
            'no_events': "Keine Termine verf\xfcgbar",
            'not_available': "Nicht mehr verf\xfcgbar",
            'free_slots': ":count freie Pl\xe4tze",
            'only_one_place': "Ereignisse k\xf6nnen nur an einem Ort ausgew\xe4hlt werden, nicht an mehreren.",
            'maximum_reached': "Die maximale Anzahl an Ereignissen wurde bereits ausgew\xe4hlt.",
            'minimum_not_met': "Bitte w\xe4hle mindestens :min Termine aus, bevor du speicherst.",
            'selection_hint_exact': "W\xe4hle genau :min Termine aus (:selected ausgew\xe4hlt)",
            'selection_hint_min': "W\xe4hle mindestens :min Termine aus (:selected ausgew\xe4hlt)",
            'selection_hint_max': "W\xe4hle h\xf6chstens :max Termine aus (:selected ausgew\xe4hlt)",
            'selection_hint_range': "W\xe4hle zwischen :min und :max Termine aus (:selected ausgew\xe4hlt)",
            'date': 'Datum',
            'datetime': 'Datum & Uhrzeit',
            'duration': 'Dauer',
            'save': 'Speichern'
        }
    },
    "validation": {
        "phoneNumber": "Dies ist kein g\xfcltiges Telefonnummer-Format.",
        "dateText": "Bitte ein vollst\xe4ndiges Datum im Format TT.MM.JJJJ eingeben."
    },
    "vueform": {
        "elements": {
            "list": {
                "add": "+ Hinzuf\xfcgen"
            },
            "file": {
                "defaultName": "Datei",
                "dndTitle": "Datei hochladen",
                "dndDescription": "Datei hier hineinziehen oder zum Hochladen hier klicken",
                "removeConfirm": "Durch das Entfernen der Datei wird diese endg\xfcltig gel\xf6scht. Bist du sicher, dass du fortfahren m\xf6chtest?",
                "select": "Datei ausw\xe4hlen",
                "upload": "Hochladen"
            },
            "multifile": {
                "uploadButton": "Dateien hochladen",
                "dndTitle": "Dateien hochladen",
                "dndDescription": "Dateien hier hineinziehen oder zum Hochladen hier klicken"
            }
        },
        "phone": {
            "ariaLabel": "Land ausw\xe4hlen"
        },
        "steps": {
            "finish": "Beenden",
            "next": "Weiter",
            "previous": "Zur\xfcck"
        },
        "multiselect": {
            "multipleLabelOne": "1 Option ausgew\xe4hlt",
            "multipleLabelMore": ":options Optionen ausgew\xe4hlt",
            "noResults": "Keine Optionen gefunden",
            "noOptions": "Liste ist leer."
        }
    }
};


var $7940c4cd1df46200$export$2e2bcd8739ae039 = {
    "festiware": {
        'repeater': {
            'is_owner_person': 'Is contact person',
            'is_owner_person_hint': '<div class="uk-alert uk-alert-primary uk-margin-remove-bottom">Please note that the necessary personal information is taken from the contact form. If you have not yet entered it, you may be asked for it in the next step.</div>',
            'add': 'Add person',
            'change_owner_person': '<div class="uk-flex"><div class="uk-width-small"><i uk-icon="icon:warning; ratio:2"></i></div><div>Please note that changing the contact person means that you will no longer be able to access this form after saving!</div>',
            'bulk_upload': {
                'toggle': 'Import people from a CSV/Excel file',
                'button': 'Upload list',
                'template': 'Download template',
                'template_filename': 'import-template',
                'hint': 'Add several people from a CSV or Excel file instead of entering them one by one.',
                'phone_hint': "Enter phone numbers with a leading 0 (e.g. 0160 1234567) or with a country code (e.g. +49 160 1234567) \u2014 spaces are allowed. To keep Excel from stripping the + or the leading 0, format the phone column as text or save the file as CSV.",
                'imported': ':count row(s) added. Please check the details and submit the form.',
                'unmatched': 'Unmatched columns: :columns.',
                'unmatched_values': "Column \u201C:field\u201D: the values :values match no available option and remain empty. Allowed: :options.",
                'limit': ":skipped row(s) were not added \u2014 the maximum number (:max) has been reached.",
                'limit_full': 'The maximum number (:max) has already been reached. No rows were added.',
                'empty': 'The file contains no usable rows.',
                'error': 'The file could not be read. Please use a CSV or Excel file.',
                'progress_reading': "Reading file \u2026",
                'progress_importing': "Importing people \u2026 (:done of :total)"
            }
        },
        'use_stored_data': 'We noticed that you have already started the form. Do you want to continue?',
        'yes': 'Yes',
        'no': 'No',
        'update_success_default': 'Your details have been saved successfully.',
        'selfie': {
            'select': 'Choose image',
            'camera': 'Capture with camera',
            'camera_starting': "Starting camera \u2026",
            'camera_label': 'Camera',
            'capture': 'Take photo',
            'cancel': 'Cancel',
            'confirm': 'Use this crop',
            'discard': 'Discard',
            'zoom': 'Zoom',
            'reset': 'Reset',
            'ratio': 'Aspect ratio:',
            'hint': "Drag to move and zoom the image \u2014 this crop is what gets stored.",
            'camera_not_ready': 'The camera is not delivering an image yet. Please wait a moment and try again.',
            'camera_denied': 'Camera access was denied. Please allow it for this page in the browser.',
            'camera_missing': 'No camera was found.',
            'camera_busy': "The camera is in use \u2014 please close other programs using it.",
            'camera_failed': 'The camera could not be started.',
            'crop_failed': 'The image crop could not be created.'
        },
        'calendar': {
            'text': 'You can subscribe to your always up-to-date appointments in your calendar app via the following link:',
            'link': 'Calendar Subscription URL'
        },
        'errors': {
            'owner_person_not_defined': 'No contact person was specified. Please adjust the information in the person fields accordingly.',
            'update_request_target_missing': 'The group to be edited could not be identified. Please reopen the form from the specific group in the portal, or contact the organiser.',
            'not_valid_for_group': 'This group cannot be edited with the current login. Please open the form from the relevant group in the portal, or contact the organiser.',
            'person_deactivated': 'Access to the portal has been deactivated, so these details can no longer be changed. Please contact the organiser if this is a mistake.',
            'events_maximum_selection_exceeded': 'More dates were selected than allowed. Please reduce the selection and save again.',
            'tab_hint': 'There is still missing information for',
            'tab_hint_buttons': {
                'ok': 'Got it'
            },
            'generic_error': 'An error occurred. Please try again later.'
        },
        'tabs': {
            'scrollLeft': 'Scroll tabs left',
            'scrollRight': 'Scroll tabs right',
            'offscreenErrors': 'Errors',
            'errorBadge': 'Error',
            'save': 'Save',
            'saving': "Saving\u2026"
        },
        'steps': {
            'scrollLeft': 'Scroll steps left',
            'scrollRight': 'Scroll steps right',
            'offscreenErrors': 'Errors',
            'errorBadge': 'Error'
        },
        'no_visible_fields': 'No fields are currently available for editing.',
        'uploading_files': "Uploading :count file(s). Please wait\u2026",
        'upload_failed': 'Upload failed. Please try again.',
        'events': {
            'no_events': 'No events available',
            'not_available': 'No longer available',
            'free_slots': ':count free slots',
            'only_one_place': 'You can only select events in one location, not multiple.',
            'maximum_reached': 'You have already selected the maximum number of events.',
            'minimum_not_met': 'Please select at least :min events before saving.',
            'selection_hint_exact': 'Select exactly :min events (:selected selected)',
            'selection_hint_min': 'Select at least :min events (:selected selected)',
            'selection_hint_max': 'Select at most :max events (:selected selected)',
            'selection_hint_range': 'Select between :min and :max events (:selected selected)',
            'date': 'Date',
            'datetime': 'Date & Time',
            'duration': 'Duration',
            'save': 'Save'
        }
    },
    "validation": {
        "phoneNumber": "This is not a valid phone number format.",
        "dateText": "Please enter a complete date in the format DD.MM.YYYY."
    }
};


/*!
 * Vueform v1.12.4 (https://github.com/vueform/vueform)
 * Copyright (c) 2025 Adam Berecz <adam@vueform.com>
 * Licensed under the MIT License
 */ parcelRequire("ey4ci");
var $8bTPG = parcelRequire("8bTPG");
var $ani5R = parcelRequire("ani5R");
var $X5A94 = parcelRequire("X5A94");
var $dDLnc = parcelRequire("dDLnc");
var $741c336afc2dfa06$var$script$2e = {
    data () {
        return {
            merge: true,
            defaultClasses: {
                form: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$12(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormElements = (0, $ani5R.resolveComponent)("FormElements");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("form", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.form),
        onSubmit: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.submit && _ctx.submit(...args), [
            "prevent"
        ]))
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "empty", {
            classes: _ctx.classes
        }, ()=>[
                _ctx.showMessages ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormMessages"), {
                    key: 0
                })) : (0, $ani5R.createCommentVNode)("v-if", true),
                _ctx.showErrors ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormErrors"), {
                    key: 1
                })) : (0, $ani5R.createCommentVNode)("v-if", true),
                _ctx.showLanguages ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormLanguages"), {
                    key: 2
                })) : (0, $ani5R.createCommentVNode)("v-if", true),
                _ctx.showTabs ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormTabs"), {
                    key: 3
                })) : (0, $ani5R.createCommentVNode)("v-if", true),
                _ctx.showSteps ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormSteps"), {
                    key: 4
                })) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createVNode)(_component_FormElements, null, {
                    default: (0, $ani5R.withCtx)(()=>[
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default")
                        ]),
                    _: 3 /* FORWARDED */ 
                }),
                _ctx.showStepsControls ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)("FormStepsControls"), {
                    key: 5
                })) : (0, $ani5R.createCommentVNode)("v-if", true)
            ])
    ], 34 /* CLASS, NEED_HYDRATION */ );
}
$741c336afc2dfa06$var$script$2e.render = $741c336afc2dfa06$var$render$12;
$741c336afc2dfa06$var$script$2e.__file = "themes/blank/templates/Vueform.vue";
var $741c336afc2dfa06$export$ed7e61590dca72bb = {
    name: 'Vueform',
    render: $741c336afc2dfa06$var$script$2e.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                form: ''
            }
        };
    }
};
$741c336afc2dfa06$export$ed7e61590dca72bb.__file = "themes/vueform/templates/Vueform.vue";
var $741c336afc2dfa06$var$script$2c = {
    name: 'FormErrors',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                error: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$N = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$11(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.errors, (error, key, index)=>{
            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.error),
                innerHTML: error,
                key: index
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$N);
        }), 128 /* KEYED_FRAGMENT */ ))
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$2c.render = $741c336afc2dfa06$var$render$11;
$741c336afc2dfa06$var$script$2c.__file = "themes/blank/templates/FormErrors.vue";
var $741c336afc2dfa06$export$db5ae436ef8b64fb = {
    name: 'FormErrors',
    render: $741c336afc2dfa06$var$script$2c.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-errors',
                container_sm: 'vf-errors-sm',
                container_md: '',
                container_lg: 'vf-errors-lg',
                error: '',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
function $741c336afc2dfa06$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') return;
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $741c336afc2dfa06$var$css_248z$12 = ".vf-errors {\n  background: var(--vf-bg-danger);\n  color: var(--vf-color-danger);\n  border-radius: var(--vf-radius-input);\n  margin-bottom: var(--vf-gutter);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  padding: 0.5rem 0.75rem;\n}\n\n.vf-errors.vf-errors-sm {\n  border-radius: var(--vf-radius-input-sm);\n  margin-bottom: var(--vf-gutter-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n  padding: 0.5rem 0.75rem;\n}\n\n.vf-errors.vf-errors-lg {\n  border-radius: var(--vf-radius-input-lg);\n  margin-bottom: var(--vf-gutter-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n  padding: 0.75rem 1rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$12);
$741c336afc2dfa06$export$db5ae436ef8b64fb.__file = "themes/vueform/templates/FormErrors.vue";
var $741c336afc2dfa06$var$script$2a = {
    name: 'FormMessages',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                message: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$M = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$10(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.messages, (message, key, index)=>{
            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.message),
                innerHTML: message,
                key: index
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$M);
        }), 128 /* KEYED_FRAGMENT */ ))
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$2a.render = $741c336afc2dfa06$var$render$10;
$741c336afc2dfa06$var$script$2a.__file = "themes/blank/templates/FormMessages.vue";
var $741c336afc2dfa06$export$420782b57eb3768d = {
    name: 'FormMessages',
    render: $741c336afc2dfa06$var$script$2a.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-messages',
                container_sm: 'vf-messages-sm',
                container_md: '',
                container_lg: 'vf-messages-lg',
                message: '',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$11 = ".vf-messages {\n  background: var(--vf-bg-success);\n  color: var(--vf-color-success);\n  border-radius: var(--vf-radius-input);\n  margin-bottom: var(--vf-gutter);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  padding: 0.5rem 0.75rem;\n}\n\n.vf-messages.vf-messages-sm {\n  border-radius: var(--vf-radius-input-sm);\n  margin-bottom: var(--vf-gutter-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n  padding: 0.5rem 0.75rem;\n}\n\n.vf-messages.vf-messages-lg {\n  border-radius: var(--vf-radius-input-lg);\n  margin-bottom: var(--vf-gutter-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n  padding: 0.75rem 1rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$11);
$741c336afc2dfa06$export$420782b57eb3768d.__file = "themes/vueform/templates/FormMessages.vue";
var $741c336afc2dfa06$var$script$28 = {
    name: 'FormLanguages',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$$(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormLanguage = (0, $ani5R.resolveComponent)("FormLanguage");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.languages, (lang, code, key)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_FormLanguage, {
                        language: lang,
                        code: code,
                        key: key,
                        onSelect: _ctx.handleSelect
                    }, null, 8 /* PROPS */ , [
                        "language",
                        "code",
                        "onSelect"
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$28.render = $741c336afc2dfa06$var$render$$;
$741c336afc2dfa06$var$script$28.__file = "themes/blank/templates/FormLanguages.vue";
var $741c336afc2dfa06$export$eb43f6d3822e5083 = {
    name: 'FormLanguages',
    render: $741c336afc2dfa06$var$script$28.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-languages',
                container_sm: 'vf-languages-sm',
                container_md: '',
                container_lg: 'vf-languages-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$10 = ".vf-languages {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 var(--vf-gutter-lg) 0;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-languages.vf-languages-sm {\n  margin: 0 0 var(--vf-gutter) 0;\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-languages.vf-languages-lg {\n  margin: 0 0 var(--vf-gutter-lg) 0;\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$10);
$741c336afc2dfa06$export$eb43f6d3822e5083.__file = "themes/vueform/templates/FormLanguages.vue";
var $741c336afc2dfa06$var$script$26 = {
    name: 'FormLanguage',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$_(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("a", {
            href: "#",
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
            onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.select && _ctx.select(...args), [
                "prevent"
            ]))
        }, (0, $X5A94.toDisplayString)(_ctx.language), 3 /* TEXT, CLASS */ )
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$26.render = $741c336afc2dfa06$var$render$_;
$741c336afc2dfa06$var$script$26.__file = "themes/blank/templates/FormLanguage.vue";
var $741c336afc2dfa06$export$80cb34e9dc8672f2 = {
    name: 'FormLanguage',
    render: $741c336afc2dfa06$var$script$26.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-language',
                wrapper: 'vf-language-wrapper',
                wrapper_sm: 'vf-language-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-language-wrapper-lg',
                wrapper_active: 'vf-language-wrapper-active',
                wrapper_inactive: '',
                $wrapper: (classes, { selected: selected, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        selected ? classes.wrapper_active : classes.wrapper_inactive
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$$ = ".vf-language {\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n}\n\n.vf-language-wrapper {\n  padding: 0.5rem 1rem;\n  display: block;\n  margin-left: 1px;\n  margin-right: 1px;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  color: var(--vf-color-input);\n  text-align: center;\n}\n\n.vf-language-wrapper:hover {\n  text-decoration: none;\n}\n\n.vf-language-wrapper.vf-language-wrapper-sm {\n  padding: 0.375rem 0.875rem;\n}\n\n.vf-language-wrapper.vf-language-wrapper-lg {\n  padding: 0.5rem 1rem;\n}\n\n.vf-language-wrapper.vf-language-wrapper-active {\n  border-color: var(--vf-primary);\n}\n\n.vf-language-wrapper.vf-language-wrapper-invalid {\n  border-color: var(--vf-danger);\n  color: var(--vf-color-danger);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$$);
$741c336afc2dfa06$export$80cb34e9dc8672f2.__file = "themes/vueform/templates/FormLanguage.vue";
var $741c336afc2dfa06$var$script$24 = {
    name: 'FormTabs',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$Z(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormTab = (0, $ani5R.resolveComponent)("FormTab");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("ul", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        role: "tablist"
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.tabs, (tab, name, i)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_FormTab, (0, $ani5R.mergeProps)({
                        ref_for: true
                    }, tab, {
                        name: name,
                        index: i,
                        key: name
                    }), null, 16 /* FULL_PROPS */ , [
                        "name",
                        "index"
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$24.render = $741c336afc2dfa06$var$render$Z;
$741c336afc2dfa06$var$script$24.__file = "themes/blank/templates/FormTabs.vue";
var $741c336afc2dfa06$export$94264bf497c2a832 = {
    name: 'FormTabs',
    render: $741c336afc2dfa06$var$script$24.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-tabs',
                container_sm: 'vf-tabs-sm',
                container_md: '',
                container_lg: 'vf-tabs-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$_ = ".vf-tabs {\n  display: flex;\n  align-items: flex-end;\n  list-style: none;\n  padding: 0;\n  margin: 0 0 var(--vf-gutter) 0;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-tabs.vf-tabs-sm {\n  margin: 0 0 var(--vf-gutter) 0;\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-tabs.vf-tabs-lg {\n  margin: 0 0 var(--vf-gutter-lg) 0;\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$_);
$741c336afc2dfa06$export$94264bf497c2a832.__file = "themes/vueform/templates/FormTabs.vue";
var $741c336afc2dfa06$var$script$22 = {
    name: 'FormTab',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$L = [
    "aria-selected"
];
const $741c336afc2dfa06$var$_hoisted_2$u = {
    key: 0
};
const $741c336afc2dfa06$var$_hoisted_3$j = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$Y(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
            tabindex: "0",
            role: "tab",
            "aria-selected": _ctx.active,
            onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.select && _ctx.select(...args), [
                "prevent"
            ])),
            onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.select && _ctx.select(...args), [
                "prevent"
            ]), [
                "enter",
                "space"
            ]))
        }, [
            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, $ani5R.createCommentVNode)(" If label is a component "),
                    _ctx.isLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $741c336afc2dfa06$var$_hoisted_2$u, [
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.tabLabel), {
                            form$: _ctx.form$
                        }, null, 8 /* PROPS */ , [
                            "form$"
                        ]))
                    ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" If label is HTML "),
                        (0, $ani5R.createElementVNode)("span", {
                            innerHTML: _ctx.tabLabel
                        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_3$j)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ])
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_1$L)
    ], 2 /* CLASS */ )), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$22.render = $741c336afc2dfa06$var$render$Y;
$741c336afc2dfa06$var$script$22.__file = "themes/blank/templates/FormTab.vue";
var $741c336afc2dfa06$export$13ab89165168320c = {
    name: 'FormTab',
    render: $741c336afc2dfa06$var$script$22.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-tab',
                wrapper: 'vf-tab-wrapper',
                wrapper_active: 'vf-tab-wrapper-active',
                wrapper_inactive: '',
                wrapper_valid: '',
                wrapper_invalid: 'vf-tab-wrapper-invalid',
                wrapper_sm: 'vf-tab-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-tab-wrapper-lg',
                $container: (classes, {})=>[
                        classes.container
                    ],
                $wrapper: (classes, { active: active, invalid: invalid, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        active ? classes.wrapper_active : classes.wrapper_inactive,
                        invalid ? classes.wrapper_invalid : classes.wrapper_valid
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$Z = ".vf-tab-wrapper {\n  padding: 0.5rem 1rem;\n  display: block;\n  margin-left: 1px;\n  margin-right: 1px;\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  color: var(--vf-color-input);\n}\n\n.vf-tab-wrapper:hover {\n  text-decoration: none;\n}\n\n.vf-tab-wrapper.vf-tab-wrapper-sm {\n  padding: 0.375rem 0.875rem;\n}\n\n.vf-tab-wrapper.vf-tab-wrapper-lg {\n  padding: 0.5rem 1rem;\n}\n\n.vf-tab-wrapper.vf-tab-wrapper-active {\n  border-color: var(--vf-primary);\n}\n\n.vf-tab-wrapper.vf-tab-wrapper-invalid {\n  border-color: var(--vf-danger);\n  color: var(--vf-color-danger);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$Z);
$741c336afc2dfa06$export$13ab89165168320c.__file = "themes/vueform/templates/FormTab.vue";
var $741c336afc2dfa06$var$script$20 = {
    name: 'FormSteps',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$X(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormStep = (0, $ani5R.resolveComponent)("FormStep");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("ul", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
            role: "tablist"
        }, [
            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.steps, (step, name)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_FormStep, (0, $ani5R.mergeProps)({
                            ref_for: true
                        }, step, {
                            name: name,
                            key: name
                        }), null, 16 /* FULL_PROPS */ , [
                            "name"
                        ]);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ])
        ], 2 /* CLASS */ )
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$20.render = $741c336afc2dfa06$var$render$X;
$741c336afc2dfa06$var$script$20.__file = "themes/blank/templates/FormSteps.vue";
var $741c336afc2dfa06$export$a07225db3abc2706 = {
    name: 'FormSteps',
    render: $741c336afc2dfa06$var$script$20.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-steps-container',
                container_sm: 'vf-steps-container-sm',
                container_md: '',
                container_lg: 'vf-steps-container-lg',
                wrapper: 'vf-steps-wrapper',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$Y = ".vf-steps-container {\n  width: 100%;\n  position: relative;\n  margin: 0 0 var(--vf-gutter-lg) 0;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-steps-container:before {\n  content: \" \";\n  display: inline-block;\n  background: var(--vf-bg-passive);\n  position: absolute;\n  top: 0.375rem;\n  left: 0.125rem;\n  right: 0.125rem;\n  height: 0.25rem;\n}\n\n.vf-steps-container.vf-steps-container-sm {\n  margin: 0 0 var(--vf-gutter) 0;\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-steps-container.vf-steps-container-lg {\n  margin: 0 0 var(--vf-gutter-lg) 0;\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-steps-wrapper {\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  padding: 0;\n  overflow-x: auto;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$Y);
$741c336afc2dfa06$export$a07225db3abc2706.__file = "themes/vueform/templates/FormSteps.vue";
var $741c336afc2dfa06$var$script$1_ = {
    name: 'FormStepsControls',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$W(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormStepsControl = (0, $ani5R.resolveComponent)("FormStepsControl");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createVNode)(_component_FormStepsControl, {
            type: "previous",
            labels: _ctx.labels
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "previous")
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "labels"
        ]),
        (0, $ani5R.createVNode)(_component_FormStepsControl, {
            type: "next",
            labels: _ctx.labels
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "next")
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "labels"
        ]),
        (0, $ani5R.createVNode)(_component_FormStepsControl, {
            type: "finish",
            labels: _ctx.labels
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "finish")
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "labels"
        ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1_.render = $741c336afc2dfa06$var$render$W;
$741c336afc2dfa06$var$script$1_.__file = "themes/blank/templates/FormStepsControls.vue";
var $741c336afc2dfa06$export$26925c1ff00111f9 = {
    name: 'FormStepsControls',
    render: $741c336afc2dfa06$var$script$1_.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-steps-controls',
                container_sm: 'vf-steps-controls-sm',
                container_md: '',
                container_lg: 'vf-steps-controls-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$X = ".vf-steps-controls {\n  display: flex;\n  justify-content: space-between;\n  margin: var(--vf-gutter-lg) 0 0 0;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-steps-controls.vf-steps-controls-sm {\n  margin: var(--vf-gutter) 0 0 0;\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-md);\n}\n\n.vf-steps-controls.vf-steps-controls-lg {\n  margin: var(--vf-gutter-lg) 0 0 0;\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$X);
$741c336afc2dfa06$export$26925c1ff00111f9.__file = "themes/vueform/templates/FormStepsControls.vue";
var $741c336afc2dfa06$var$script$1Y = {
    name: 'FormStepsControl',
    data () {
        return {
            merge: true,
            defaultClasses: {
                button: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$K = [
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$t = [
    "innerHTML",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_3$i = [
    "disabled"
];
function $741c336afc2dfa06$var$render$V(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createCommentVNode)(" If label is a component "),
        _ctx.visible && _ctx.label && _ctx.isLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", {
            key: 0,
            disabled: _ctx.isDisabled,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.button),
            onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                "prevent"
            ])),
            onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                "prevent"
            ]), [
                "enter",
                "space"
            ]))
        }, [
            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.label), {
                step$: _ctx.current$
            }, null, 8 /* PROPS */ , [
                "step$"
            ]))
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_1$K)) : _ctx.visible && _ctx.label ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createCommentVNode)(" If label is HTML "),
            (0, $ani5R.createElementVNode)("button", {
                innerHTML: _ctx.label,
                disabled: _ctx.isDisabled,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.button),
                onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                    "prevent"
                ])),
                onKeypress: _cache[3] || (_cache[3] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                    "prevent"
                ]), [
                    "enter",
                    "space"
                ]))
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_2$t)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : _ctx.visible ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 2
        }, [
            (0, $ani5R.createCommentVNode)(" If label is a slot "),
            (0, $ani5R.createElementVNode)("button", {
                disabled: _ctx.isDisabled,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.button),
                onClick: _cache[4] || (_cache[4] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                    "prevent"
                ])),
                onKeypress: _cache[5] || (_cache[5] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                    "prevent"
                ]), [
                    "enter",
                    "space"
                ]))
            }, [
                (0, $ani5R.renderSlot)(_ctx.$slots, "default")
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_3$i)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ );
}
$741c336afc2dfa06$var$script$1Y.render = $741c336afc2dfa06$var$render$V;
$741c336afc2dfa06$var$script$1Y.__file = "themes/blank/templates/FormStepsControl.vue";
var $741c336afc2dfa06$export$ff4b910aa71d5221 = {
    name: 'FormStepsControl',
    render: $741c336afc2dfa06$var$script$1Y.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                button: 'vf-btn',
                button_previous: '',
                button_previous_enabled: 'vf-btn-secondary',
                button_previous_disabled: 'vf-btn-secondary vf-btn-disabled',
                button_next: '',
                button_next_enabled: 'vf-btn-primary',
                button_next_disabled: 'vf-btn-primary vf-btn-disabled',
                button_next_loading: 'vf-btn-loading vf-btn-loading-primary',
                button_finish: '',
                button_finish_enabled: 'vf-btn-primary',
                button_finish_disabled: 'vf-btn-primary vf-btn-disabled',
                button_finish_loading: 'vf-btn-loading vf-btn-loading-primary',
                button_sm: 'vf-btn-sm',
                button_md: '',
                button_lg: 'vf-btn-lg',
                $button: (classes, { isDisabled: isDisabled, isLoading: isLoading, type: type, Size: Size })=>[
                        classes.button,
                        classes[`button_${Size}`],
                        classes[`button_${type}`],
                        isDisabled ? classes[`button_${type}_disabled`] : classes[`button_${type}_enabled`],
                        isLoading ? classes[`button_${type}_loading`] : null
                    ]
            }
        };
    }
};
$741c336afc2dfa06$export$ff4b910aa71d5221.__file = "themes/vueform/templates/FormStepsControl.vue";
var $741c336afc2dfa06$var$script$1W = {
    name: 'FormStep',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$J = [
    "tabindex",
    "aria-selected"
];
const $741c336afc2dfa06$var$_hoisted_2$s = {
    key: 0
};
const $741c336afc2dfa06$var$_hoisted_3$h = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$U(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.visible ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
        key: 0,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("a", {
            href: "",
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
            tabindex: _ctx.isDisabled ? -1 : 0,
            role: "tab",
            "aria-selected": _ctx.active,
            onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.select && _ctx.select(...args), [
                "prevent"
            ])),
            onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.select && _ctx.select(...args), [
                "prevent"
            ]), [
                "enter",
                "space"
            ]))
        }, [
            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, $ani5R.createCommentVNode)(" If label is a component "),
                    _ctx.isLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $741c336afc2dfa06$var$_hoisted_2$s, [
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.stepLabel), {
                            form$: _ctx.form$
                        }, null, 8 /* PROPS */ , [
                            "form$"
                        ]))
                    ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" If label is HTML "),
                        (0, $ani5R.createElementVNode)("span", {
                            innerHTML: _ctx.stepLabel
                        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_3$h)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ])
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_1$J)
    ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$1W.render = $741c336afc2dfa06$var$render$U;
$741c336afc2dfa06$var$script$1W.__file = "themes/blank/templates/FormStep.vue";
var $741c336afc2dfa06$export$38affa45b0acd77f = {
    name: 'FormStep',
    render: $741c336afc2dfa06$var$script$1W.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-step',
                wrapper: '',
                container_active: 'vf-step-active',
                container_inactive: '',
                container_invalid: 'vf-step-invalid',
                container_valid: '',
                container_disabled: 'vf-step-disabled',
                container_enabled: '',
                container_completed: 'vf-step-completed',
                container_incompleted: '',
                container_pending: 'vf-step-pending',
                $container: (classes, { active: active, isDisabled: isDisabled, completed: completed, invalid: invalid, pending: pending })=>[
                        classes.container,
                        active ? classes.container_active : classes.container_inactive,
                        isDisabled ? classes.container_disabled : classes.container_enabled,
                        completed ? classes.container_completed : classes.container_incompleted,
                        invalid ? classes.container_invalid : classes.container_valid,
                        pending ? classes.container_pending : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$W = ".vf-step {\n  display: block;\n  position: relative;\n  white-space: nowrap;\n  flex: 1 1;\n  text-align: center;\n  padding: 1.25rem 0.625rem 0;\n}\n\n.vf-step a {\n  text-decoration: none !important;\n  color: inherit;\n}\n\n.vf-step a:hover, .vf-step a:focus, .vf-step a:active {\n  text-decoration: none !important;\n  color: inherit;\n}\n\n.vf-step a:before {\n  content: \" \";\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  position: absolute;\n  background: var(--vf-primary);\n  border-radius: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0px;\n}\n\n.vf-step a:after {\n  content: \" \";\n  display: inline-block;\n  width: 0.5rem;\n  height: 0.5rem;\n  position: absolute;\n  background: #FFFFFF;\n  border-radius: 50%;\n  left: calc(50% - 0.25rem);\n  transform: scale(0);\n  top: 0.25rem;\n  transition: transform 0.3s ease-in-out;\n}\n\n.vf-step:first-of-type {\n  padding-left: 0;\n  text-align: left;\n}\n\n.vf-step:first-of-type:before {\n  display: none;\n}\n\n.vf-step:first-of-type:after {\n  left: 0;\n}\n\n.vf-step:first-of-type a:before {\n  left: 0;\n  transform: none;\n}\n\n.vf-step:first-of-type a:after {\n  left: 0.25rem;\n  transform: scale(0);\n}\n\n.vf-step:last-of-type {\n  padding-right: 0;\n  text-align: right;\n}\n\n.vf-step:last-of-type:after {\n  display: none;\n}\n\n.vf-step:last-of-type:before {\n  right: 0;\n}\n\n.vf-step:last-of-type a:before {\n  right: 0;\n  left: auto;\n  left: initial;\n  transform: none;\n}\n\n.vf-step:last-of-type a:after {\n  left: auto;\n  left: initial;\n  transform: scale(0);\n  right: 0.25rem;\n}\n\n.vf-step.vf-step-disabled:before {\n  background: var(--vf-bg-passive);\n  left: -100%;\n}\n\n.vf-step.vf-step-disabled a {\n  color: var(--vf-color-passive);\n}\n\n.vf-step.vf-step-disabled a:before {\n  background: var(--vf-bg-passive);\n}\n\n.vf-step.vf-step-completed + .vf-step:not(.vf-step-completed):before {\n  content: \" \";\n  display: inline-block;\n  background: var(--vf-primary);\n  position: absolute;\n  top: 0.375rem;\n  left: 0px;\n  right: 50%;\n  height: 0.25rem;\n}\n\n.vf-step.vf-step-completed + .vf-step:last-of-type:before {\n  right: 0px;\n}\n\n.vf-step.vf-step-completed:before {\n  content: \" \";\n  display: inline-block;\n  background: var(--vf-primary);\n  position: absolute;\n  top: 0.375rem;\n  left: 0px;\n  right: 0px;\n  height: 0.25rem;\n}\n\n.vf-step.vf-step-completed a:after {\n  mask-image: url('data:image/svg+xml;utf8,<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"check\" class=\"svg-inline--fa fa-check fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"white\" d=\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\"></path></svg>');\n  -webkit-mask-image: url('data:image/svg+xml;utf8,<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"check\" class=\"svg-inline--fa fa-check fa-w-16\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path fill=\"white\" d=\"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z\"></path></svg>');\n  mask-size: 0.5rem 0.5rem;\n  -webkit-mask-size: 0.5rem 0.5rem;\n  mask-position: 0 0;\n  -webkit-mask-position: 0 0;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  background-color: var(--vf-color-on-primary);\n  border-radius: 0;\n  transform: scale(1);\n}\n\n.vf-step.vf-step-active a:after {\n  mask-image: none;\n  -webkit-mask-image: none;\n  background-color: var(--vf-color-on-primary);\n  top: 0.25rem;\n  transform: scale(1);\n  border-radius: 50%;\n}\n\n.vf-step.vf-step-invalid a {\n  color: var(--vf-bg-btn-danger);\n}\n\n.vf-step.vf-step-invalid a:before {\n  background-color: var(--vf-bg-btn-danger);\n}\n\n.vf-step.vf-step-invalid a:after {\n  mask-image: url('data:image/svg+xml;utf8,<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"exclamation\" class=\"svg-inline--fa fa-exclamation fa-w-6\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\"><path fill=\"white\" d=\"M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z\"></path></svg>');\n  -webkit-mask-image: url('data:image/svg+xml;utf8,<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"exclamation\" class=\"svg-inline--fa fa-exclamation fa-w-6\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 512\"><path fill=\"white\" d=\"M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z\"></path></svg>');\n  mask-size: 0.5rem 0.5rem;\n  -webkit-mask-size: 0.5rem 0.5rem;\n  mask-position: 0 0;\n  -webkit-mask-position: 0 0;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  background-color: var(--vf-color-btn-danger);\n  width: 0.5rem;\n  height: 0.5rem;\n  top: 0.25rem;\n  border-radius: 0;\n}\n\n.vf-step.vf-step-invalid.vf-step-active a:after {\n  mask-image: none;\n  -webkit-mask-image: none;\n  background-color: var(--vf-color-on-primary);\n  transform: scale(1);\n  border-radius: 50%;\n}\n\n.vf-step.vf-step-pending a:after {\n  animation: 1s linear infinite step-loading;\n  background: var(--vf-color-btn-danger);\n  top: 0.25rem;\n  border-radius: 50%;\n}\n\n@keyframes step-loading {\n  0% {\n    transform: scale(0.5);\n  }\n\n  20% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(0.5);\n  }\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$W);
$741c336afc2dfa06$export$38affa45b0acd77f.__file = "themes/vueform/templates/FormStep.vue";
var $741c336afc2dfa06$var$script$1U = {
    name: 'FormElements',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$T(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.schema, (element, name)=>{
                    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.component(element)), (0, $ani5R.mergeProps)({
                        ref_for: true
                    }, element, {
                        name: name,
                        key: name
                    }), null, 16 /* FULL_PROPS */ , [
                        "name"
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1U.render = $741c336afc2dfa06$var$render$T;
$741c336afc2dfa06$var$script$1U.__file = "themes/blank/templates/FormElements.vue";
var $741c336afc2dfa06$export$fda5023bf27e64f = {
    name: 'FormElements',
    render: $741c336afc2dfa06$var$script$1U.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-row',
                container_sm: 'vf-row-sm',
                container_md: '',
                container_lg: 'vf-row-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$V = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$V);
$741c336afc2dfa06$export$fda5023bf27e64f.__file = "themes/vueform/templates/FormElements.vue";
var $741c336afc2dfa06$var$script$1S = {
    name: 'ElementLayout',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                outerWrapper: '',
                innerContainer: '',
                innerWrapperBefore: '',
                innerWrapper: '',
                innerWrapperAfter: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$S(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementLabel = (0, $ani5R.resolveComponent)("ElementLabel");
    const _component_ElementText = (0, $ani5R.resolveComponent)("ElementText");
    const _component_ElementDescription = (0, $ani5R.resolveComponent)("ElementDescription");
    const _component_ElementError = (0, $ani5R.resolveComponent)("ElementError");
    const _component_ElementMessage = (0, $ani5R.resolveComponent)("ElementMessage");
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.outerWrapper)
        }, [
            (0, $ani5R.createVNode)(_component_ElementLabel, null, {
                default: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, "label")
                    ]),
                info: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, "info")
                    ]),
                required: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, "required")
                    ]),
                _: 3 /* FORWARDED */ 
            }),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.innerContainer)
            }, [
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.innerWrapperBefore)
                }, [
                    (0, $ani5R.createVNode)(_component_ElementText, {
                        type: "before"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "before")
                            ]),
                        _: 3 /* FORWARDED */ 
                    })
                ], 2 /* CLASS */ ),
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.innerWrapper)
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "element")
                ], 2 /* CLASS */ ),
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.innerWrapperAfter)
                }, [
                    (0, $ani5R.createVNode)(_component_ElementText, {
                        type: "between"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "between")
                            ]),
                        _: 3 /* FORWARDED */ 
                    }),
                    (0, $ani5R.createVNode)(_component_ElementDescription, null, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "description")
                            ]),
                        _: 3 /* FORWARDED */ 
                    }),
                    (0, $ani5R.createVNode)(_component_ElementError),
                    (0, $ani5R.createVNode)(_component_ElementMessage),
                    (0, $ani5R.createVNode)(_component_ElementText, {
                        type: "after"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "after")
                            ]),
                        _: 3 /* FORWARDED */ 
                    })
                ], 2 /* CLASS */ )
            ], 2 /* CLASS */ )
        ], 2 /* CLASS */ )
    ], 2 /* CLASS */ )), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$1S.render = $741c336afc2dfa06$var$render$S;
$741c336afc2dfa06$var$script$1S.__file = "themes/blank/templates/ElementLayout.vue";
var $741c336afc2dfa06$export$57539cf15ccc3ae4 = {
    name: 'ElementLayout',
    render: $741c336afc2dfa06$var$script$1S.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-layout',
                container_sm: 'vf-element-layout-sm',
                container_md: '',
                container_lg: 'vf-element-layout-lg',
                container_error: 'vf-element-layout-error',
                outerWrapper: 'vf-element-layout-outer-wrapper',
                innerContainer: 'vf-layout-inner-container',
                innerWrapperBefore: 'vf-layout-inner-wrapper-before',
                innerWrapper: 'vf-layout-inner-wrapper',
                innerWrapperAfter: 'vf-layout-inner-wrapper-after',
                $container: (classes, { el$: el$, Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`],
                        el$.columnsClasses.container,
                        el$.classes.container,
                        !el$.isStatic && el$.errors && !!el$.errors.length ? classes.container_error : null
                    ],
                $innerContainer: (classes, { el$: el$ })=>[
                        classes.innerContainer,
                        el$.columnsClasses.innerContainer
                    ],
                $innerWrapper: (classes, { el$: el$ })=>[
                        classes.innerWrapper,
                        el$.columnsClasses.wrapper
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$U = "/* Some styles are contained in Vueform.vue */\n\n.vf-element-layout {\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-element-layout.vf-element-layout-sm {\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-element-layout.vf-element-layout-lg {\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-layout-inner-container {\n  flex: 1 1 0%;\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.vf-layout-inner-container .vf-layout-inner-wrapper,\n.vf-layout-inner-container .vf-layout-inner-wrapper-before,\n.vf-layout-inner-container .vf-layout-inner-wrapper-after {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.vf-layout-inner-wrapper-before,\n.vf-layout-inner-wrapper-after {\n  grid-column: span 12/span 12;\n  padding-left: var(--vf-gutter);\n  padding-right: var(--vf-gutter);\n}\n\n.vf-element-layout-outer-wrapper {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$U);
$741c336afc2dfa06$export$57539cf15ccc3ae4.__file = "themes/vueform/templates/ElementLayout.vue";
var $741c336afc2dfa06$var$script$1Q = {
    name: 'ElementLayoutInline',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$R(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementLabel = (0, $ani5R.resolveComponent)("ElementLabel");
    const _component_ElementText = (0, $ani5R.resolveComponent)("ElementText");
    const _component_ElementDescription = (0, $ani5R.resolveComponent)("ElementDescription");
    const _component_ElementError = (0, $ani5R.resolveComponent)("ElementError");
    const _component_ElementMessage = (0, $ani5R.resolveComponent)("ElementMessage");
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createVNode)(_component_ElementLabel, null, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "label")
                ]),
            _: 3 /* FORWARDED */ 
        }),
        (0, $ani5R.createVNode)(_component_ElementText, {
            type: "before"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "before")
                ]),
            _: 3 /* FORWARDED */ 
        }),
        (0, $ani5R.renderSlot)(_ctx.$slots, "element"),
        (0, $ani5R.createVNode)(_component_ElementText, {
            type: "between"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "between")
                ]),
            _: 3 /* FORWARDED */ 
        }),
        (0, $ani5R.createVNode)(_component_ElementDescription, null, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "description")
                ]),
            _: 3 /* FORWARDED */ 
        }),
        (0, $ani5R.createVNode)(_component_ElementError),
        (0, $ani5R.createVNode)(_component_ElementMessage),
        (0, $ani5R.createVNode)(_component_ElementText, {
            type: "after"
        }, {
            default: (0, $ani5R.withCtx)(()=>[
                    (0, $ani5R.renderSlot)(_ctx.$slots, "after")
                ]),
            _: 3 /* FORWARDED */ 
        })
    ], 2 /* CLASS */ )), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$1Q.render = $741c336afc2dfa06$var$render$R;
$741c336afc2dfa06$var$script$1Q.__file = "themes/blank/templates/ElementLayoutInline.vue";
var $741c336afc2dfa06$export$ec8b469fb4e5fc87 = {
    name: 'ElementLayoutInline',
    render: $741c336afc2dfa06$var$script$1Q.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-inline-layout',
                container_error: 'has-error',
                $container: (classes, { el$: el$ })=>[
                        classes.container,
                        !el$.isStatic && el$.errors && !!el$.errors.length ? classes.container_error : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$T = ".vf-inline-layout {\n  display: flex;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$T);
$741c336afc2dfa06$export$ec8b469fb4e5fc87.__file = "themes/vueform/templates/ElementLayoutInline.vue";
var $741c336afc2dfa06$var$script$1O = {
    name: 'ElementLoader',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                loader: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$Q(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("span", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.loader)
        }, null, 2 /* CLASS */ )
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1O.render = $741c336afc2dfa06$var$render$Q;
$741c336afc2dfa06$var$script$1O.__file = "themes/blank/templates/ElementLoader.vue";
var $741c336afc2dfa06$export$c3871e8da9e453bc = {
    name: 'ElementLoader',
    render: $741c336afc2dfa06$var$script$1O.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-loader-container',
                loader: 'vf-element-loader',
                loader_sm: 'vf-element-loader-sm',
                loader_md: '',
                loader_lg: 'vf-element-loader-lg',
                $loader: (classes, { Size: Size })=>[
                        classes.loader,
                        classes[`loader_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$S = ".vf-element-loader-container {\n  position: relative;\n  z-index: 1;\n  order: 1;\n}\n\n.vf-element-loader {\n  position: absolute;\n  width: 1rem;\n  height: 1rem;\n  display: block;\n  right: var(--vf-px-input);\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.vf-element-loader:before, .vf-element-loader:after {\n  position: absolute;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -0.5rem 0 0 -0.5rem;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 100%;\n  border-color: var(--vf-primary) transparent transparent;\n  border-style: solid;\n  border-width: 2px;\n  box-shadow: 0 0 0 1px transparent;\n  box-sizing: border-box;\n}\n\n.vf-element-loader:before {\n  animation: vf-element-loader 2.4s infinite cubic-bezier(0.41, 0.26, 0.2, 0.62);\n}\n\n.vf-element-loader:after {\n  animation: vf-element-loader 2.4s infinite cubic-bezier(0.51, 0.09, 0.21, 0.8);\n}\n\n.vf-element-loader.vf-element-loader-sm {\n  right: var(--vf-px-input-sm);\n}\n\n.vf-element-loader.vf-element-loader-lg {\n  right: var(--vf-px-input-lg);\n}\n\n@keyframes vf-element-loader {\n  from {\n    transform: rotate(0);\n  }\n\n  to {\n    transform: rotate(2turn);\n  }\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$S);
$741c336afc2dfa06$export$c3871e8da9e453bc.__file = "themes/vueform/templates/ElementLoader.vue";
var $741c336afc2dfa06$var$script$1M = {
    name: 'ElementLabelFloating',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                label: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$I = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$P(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("span", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.label),
            innerHTML: _ctx.floating
        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$I)
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1M.render = $741c336afc2dfa06$var$render$P;
$741c336afc2dfa06$var$script$1M.__file = "themes/blank/templates/ElementLabelFloating.vue";
var $741c336afc2dfa06$export$75fd03dc25d1123c = {
    name: 'ElementLabelFloating',
    render: $741c336afc2dfa06$var$script$1M.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-floating-wrapper',
                label: 'vf-floating-label',
                label_enabled: '',
                label_disabled: 'vf-floating-label-disabled',
                label_danger: 'vf-floating-label-danger',
                label_success: 'vf-floating-label-success',
                label_focused: 'vf-floating-label-focus',
                label_sm: 'vf-floating-label-sm',
                label_md: '',
                label_lg: 'vf-floating-label-lg',
                label_invisible: '',
                label_visible: 'vf-floating-label-visible',
                $label: (classes, { visible: visible, Size: Size, el$: el$ })=>[
                        classes.label,
                        classes[`label_${Size}`],
                        visible ? classes.label_visible : classes.label_invisible,
                        el$.focused ? classes.label_focused : null,
                        !el$.isDisabled && !el$.isDanger && !el$.isSuccess ? classes.label_enabled : null,
                        el$.isDisabled ? classes.label_disabled : null,
                        el$.isDanger ? classes.label_danger : null,
                        el$.isSuccess ? classes.label_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$R = ".vf-floating-wrapper {\n  position: relative;\n}\n\n.vf-floating-label {\n  position: absolute;\n  z-index: 1;\n  left: var(--vf-px-input);\n  font-size: 0.6875rem;\n  background-color: var(--vf-bg-input);\n  padding: 0 1px;\n  line-height: 1px;\n  transition-property: box-shadow, color, background-color, border-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n  opacity: 0;\n  visibility: hidden;\n  white-space: nowrap;\n  color: var(--vf-color-floating);\n  margin-top: var(--vf-floating-top);\n}\n\n.vf-floating-label.vf-floating-label-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.vf-floating-label.vf-floating-label-sm {\n  left: var(--vf-px-input-sm);\n  margin-top: var(--vf-floating-top-sm);\n}\n\n.vf-floating-label.vf-floating-label-lg {\n  left: var(--vf-px-input-lg);\n  margin-top: var(--vf-floating-top-lg);\n  background-color: transparent !important;\n}\n\n.vf-floating-label.vf-floating-label-disabled {\n  background-color: var(--vf-bg-disabled);\n}\n\n.vf-floating-label.vf-floating-label-focus {\n  background-color: var(--vf-bg-input-focus);\n  color: var(--vf-color-floating-focus);\n}\n\n.vf-floating-label.vf-floating-label-danger {\n  background-color: var(--vf-bg-input-danger);\n  color: var(--vf-color-floating-danger);\n}\n\n.vf-floating-label.vf-floating-label-success {\n  background-color: var(--vf-bg-input-success);\n  color: var(--vf-color-floating-success);\n}\n\n.vf-input-group .vf-floating-label {\n  top: calc(var(--vf-border-width-input-t) * -1);\n}\n\n[dir=rtl] .vf-floating-label {\n  left: auto;\n  right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-floating-label.vf-floating-label-sm {\n  left: auto;\n  right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-floating-label.vf-floating-label-lg {\n  left: auto;\n  right: var(--vf-px-input-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$R);
$741c336afc2dfa06$export$75fd03dc25d1123c.__file = "themes/vueform/templates/ElementLabelFloating.vue";
var $741c336afc2dfa06$var$script$1K = {
    name: 'ElementLabel',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$H = [
    "for",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_2$r = [
    "for",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_3$g = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_4$c = [
    "for",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_5$7 = [
    "for",
    "id"
];
function $741c336afc2dfa06$var$render$O(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementInfo = (0, $ani5R.resolveComponent)("ElementInfo");
    const _component_ElementRequired = (0, $ani5R.resolveComponent)("ElementRequired");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createCommentVNode)(" If label is a component "),
        _ctx.label && _ctx.isLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
            for: _ctx.name,
            id: _ctx.id
        }, [
            (0, $ani5R.createElementVNode)("span", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
            }, [
                _ctx.isLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.label), {
                    key: 0
                })) : (0, $ani5R.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */ ),
            (0, $ani5R.createVNode)(_component_ElementInfo, null, {
                default: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, "info")
                    ]),
                _: 3 /* FORWARDED */ 
            }),
            (0, $ani5R.createVNode)(_component_ElementRequired, null, {
                default: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, "required")
                    ]),
                _: 3 /* FORWARDED */ 
            })
        ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$H)) : _ctx.label ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createCommentVNode)(" If label is HTML "),
            (0, $ani5R.createElementVNode)("label", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
                for: _ctx.name,
                id: _ctx.id
            }, [
                (0, $ani5R.createElementVNode)("span", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    innerHTML: _ctx.label
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$g),
                (0, $ani5R.createVNode)(_component_ElementInfo, null, {
                    default: (0, $ani5R.withCtx)(()=>[
                            (0, $ani5R.renderSlot)(_ctx.$slots, "info")
                        ]),
                    _: 3 /* FORWARDED */ 
                }),
                (0, $ani5R.createVNode)(_component_ElementRequired, null, {
                    default: (0, $ani5R.withCtx)(()=>[
                            (0, $ani5R.renderSlot)(_ctx.$slots, "required")
                        ]),
                    _: 3 /* FORWARDED */ 
                })
            ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$r)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 2
        }, [
            (0, $ani5R.createCommentVNode)(" If label is a slot "),
            (0, $ani5R.createElementVNode)("label", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
                for: _ctx.name,
                id: _ctx.id
            }, [
                (0, $ani5R.createElementVNode)("span", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "default")
                ], 2 /* CLASS */ ),
                (0, $ani5R.createVNode)(_component_ElementInfo, null, {
                    default: (0, $ani5R.withCtx)(()=>[
                            (0, $ani5R.renderSlot)(_ctx.$slots, "info")
                        ]),
                    _: 3 /* FORWARDED */ 
                }),
                (0, $ani5R.createVNode)(_component_ElementRequired, null, {
                    default: (0, $ani5R.withCtx)(()=>[
                            (0, $ani5R.renderSlot)(_ctx.$slots, "required")
                        ]),
                    _: 3 /* FORWARDED */ 
                })
            ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_4$c)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : _ctx.hasLabel ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 3
        }, [
            (0, $ani5R.createCommentVNode)(" If labels are forced but has no value "),
            (0, $ani5R.createElementVNode)("label", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
                for: _ctx.name,
                id: _ctx.id
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_5$7)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ );
}
$741c336afc2dfa06$var$script$1K.render = $741c336afc2dfa06$var$render$O;
$741c336afc2dfa06$var$script$1K.__file = "themes/blank/templates/ElementLabel.vue";
var $741c336afc2dfa06$export$596b151e191dc0da = {
    name: 'ElementLabel',
    render: $741c336afc2dfa06$var$script$1K.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-label',
                container_sm: 'vf-label-sm',
                container_md: '',
                container_lg: 'vf-label-lg',
                container_horizontal_sm: 'vf-horizontal-label-sm',
                container_horizontal_md: 'vf-horizontal-label',
                container_horizontal_lg: 'vf-horizontal-label-lg',
                container_vertical_sm: 'vf-vertical-label-sm',
                container_vertical_md: 'vf-vertical-label',
                container_vertical_lg: 'vf-vertical-label-lg',
                wrapper: '',
                $container: (classes, { el$: el$, Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`],
                        !el$.inline ? el$.columnsClasses.label : null,
                        el$.computedCols.default.label < 12 ? classes[`container_horizontal_${Size}`] : classes[`container_vertical_${Size}`],
                        ...Object.keys(el$.computedCols).length > 1 ? (el$.$vueform.config.breakpoints || [
                            'sm',
                            'md',
                            'lg',
                            'xl',
                            '2xl'
                        ]).map((breakpoint)=>{
                            if (!el$.computedCols[breakpoint]?.label) return null;
                            return el$.computedCols[breakpoint].label < 12 ? classes[`container_horizontal_${Size}`].map((c)=>`vf-${breakpoint}:${c}`).join(' ') : classes[`container_vertical_${Size}`].map((c)=>`vf-${breakpoint}:${c}`).join(' ');
                        }) : []
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$Q = "/* Styles can be found at scss/_label.scss */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$Q);
$741c336afc2dfa06$export$596b151e191dc0da.__file = "themes/vueform/templates/ElementLabel.vue";
var $741c336afc2dfa06$var$script$1I = {
    name: 'ElementInfo',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                content: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$G = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_2$q = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$N(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.info || _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
        key: 0,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        onMouseover: _cache[0] || (_cache[0] = (...args)=>_ctx.handleMouseOver && _ctx.handleMouseOver(...args))
    }, [
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
            id: _ctx.id
        }, [
            _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                key: 0,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.content)
            }, [
                (0, $ani5R.renderSlot)(_ctx.$slots, "default")
            ], 2 /* CLASS */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                key: 1,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.content),
                innerHTML: _ctx.info
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$q))
        ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$G)
    ], 34 /* CLASS, NEED_HYDRATION */ )) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$1I.render = $741c336afc2dfa06$var$render$N;
$741c336afc2dfa06$var$script$1I.__file = "themes/blank/templates/ElementInfo.vue";
var $741c336afc2dfa06$export$2b84339f145c8f12 = {
    name: 'ElementInfo',
    render: $741c336afc2dfa06$var$script$1I.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-info',
                wrapper: 'vf-element-info-wrapper',
                wrapper_left: 'vf-element-info-wrapper-left',
                wrapper_right: 'vf-element-info-wrapper-right',
                wrapper_top: 'vf-element-info-wrapper-top',
                wrapper_bottom: 'vf-element-info-wrapper-bottom',
                content: 'vf-element-info-content',
                $wrapper: (classes, { position: position })=>[
                        classes.wrapper,
                        classes[`wrapper_${position}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$P = ".vf-element-info {\n  margin-left: 0.25rem;\n  position: relative;\n  top: 1px;\n  cursor: pointer;\n}\n\n.vf-element-info:before {\n  content: \"\";\n  mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='15px' height='14px' viewBox='0 0 15 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M7.40520349,0.18129431 C11.1501134,0.18129431 14.1864373,3.21871306 14.1864373,6.96252814 C14.1864373,10.7085329 11.1501134,13.743762 7.40520349,13.743762 C3.6602936,13.743762 0.62396966,10.7085329 0.62396966,6.96252814 C0.62396966,3.21871306 3.6602936,0.18129431 7.40520349,0.18129431 Z M7.40520349,3.18909964 C6.77093148,3.18909964 6.25676873,3.70326238 6.25676873,4.3375344 C6.25676873,4.97180642 6.77093148,5.48596916 7.40520349,5.48596916 C8.03947551,5.48596916 8.55363825,4.97180642 8.55363825,4.3375344 C8.55363825,3.70326238 8.03947551,3.18909964 7.40520349,3.18909964 Z M8.93644984,10.1343956 L8.93644984,9.47814714 C8.93644984,9.29694183 8.78953094,9.15002293 8.60832562,9.15002293 L8.28020141,9.15002293 L8.28020141,6.41565445 C8.28020141,6.23444913 8.13328251,6.08753023 7.95207719,6.08753023 L6.20208136,6.08753023 C6.02087604,6.08753023 5.87395714,6.23444913 5.87395714,6.41565445 L5.87395714,7.07190288 C5.87395714,7.2531082 6.02087604,7.4000271 6.20208136,7.4000271 L6.53020558,7.4000271 L6.53020558,9.15002293 L6.20208136,9.15002293 C6.02087604,9.15002293 5.87395714,9.29694183 5.87395714,9.47814714 L5.87395714,10.1343956 C5.87395714,10.3156009 6.02087604,10.4625198 6.20208136,10.4625198 L8.60832562,10.4625198 C8.78953094,10.4625198 8.93644984,10.3156009 8.93644984,10.1343956 Z' id='info-circle' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='15px' height='14px' viewBox='0 0 15 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M7.40520349,0.18129431 C11.1501134,0.18129431 14.1864373,3.21871306 14.1864373,6.96252814 C14.1864373,10.7085329 11.1501134,13.743762 7.40520349,13.743762 C3.6602936,13.743762 0.62396966,10.7085329 0.62396966,6.96252814 C0.62396966,3.21871306 3.6602936,0.18129431 7.40520349,0.18129431 Z M7.40520349,3.18909964 C6.77093148,3.18909964 6.25676873,3.70326238 6.25676873,4.3375344 C6.25676873,4.97180642 6.77093148,5.48596916 7.40520349,5.48596916 C8.03947551,5.48596916 8.55363825,4.97180642 8.55363825,4.3375344 C8.55363825,3.70326238 8.03947551,3.18909964 7.40520349,3.18909964 Z M8.93644984,10.1343956 L8.93644984,9.47814714 C8.93644984,9.29694183 8.78953094,9.15002293 8.60832562,9.15002293 L8.28020141,9.15002293 L8.28020141,6.41565445 C8.28020141,6.23444913 8.13328251,6.08753023 7.95207719,6.08753023 L6.20208136,6.08753023 C6.02087604,6.08753023 5.87395714,6.23444913 5.87395714,6.41565445 L5.87395714,7.07190288 C5.87395714,7.2531082 6.02087604,7.4000271 6.20208136,7.4000271 L6.53020558,7.4000271 L6.53020558,9.15002293 L6.20208136,9.15002293 C6.02087604,9.15002293 5.87395714,9.29694183 5.87395714,9.47814714 L5.87395714,10.1343956 C5.87395714,10.3156009 6.02087604,10.4625198 6.20208136,10.4625198 L8.60832562,10.4625198 C8.78953094,10.4625198 8.93644984,10.3156009 8.93644984,10.1343956 Z' id='info-circle' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-bg-passive);\n  width: 0.875rem;\n  height: 0.875rem;\n  display: inline-block;\n}\n\n.vf-element-info:hover .vf-element-info-wrapper {\n  opacity: 1;\n  visibility: visible;\n}\n\n.vf-element-info-wrapper {\n  position: absolute;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.3s;\n  z-index: 1000;\n  width: 12.5rem;\n}\n\n.vf-element-info-wrapper.vf-element-info-wrapper-left {\n  top: -0.5625rem;\n  right: 1.375rem;\n}\n\n.vf-element-info-wrapper.vf-element-info-wrapper-right {\n  top: -0.5625rem;\n  left: 1.375rem;\n}\n\n.vf-element-info-wrapper.vf-element-info-wrapper-top {\n  bottom: 1.375rem;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.vf-element-info-wrapper.vf-element-info-wrapper-bottom {\n  top: 1.375rem;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.vf-element-info-content {\n  background: rgba(0, 0, 0, 0.85);\n  color: #FFFFFF;\n  border-radius: var(--vf-radius-small);\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  padding: 0.3125rem 0.625rem;\n  font-style: normal;\n  display: inline-block;\n  position: relative;\n}\n\n.vf-element-info-content:after {\n  right: 100%;\n  top: 0.625rem;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(0, 0, 0, 0);\n  border-right-color: rgba(0, 0, 0, 0.85);\n  border-width: 5px;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$P);
$741c336afc2dfa06$export$2b84339f145c8f12.__file = "themes/vueform/templates/ElementInfo.vue";
var $741c336afc2dfa06$var$script$1G = {
    name: 'ElementDescription',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$F = [
    "innerHTML",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_2$p = [
    "id"
];
function $741c336afc2dfa06$var$render$M(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createCommentVNode)(" If description is HTML "),
        _ctx.description ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
            innerHTML: _ctx.description,
            id: _ctx.id
        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$F)) : _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createCommentVNode)(" If description is a slot "),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
                id: _ctx.id
            }, [
                (0, $ani5R.renderSlot)(_ctx.$slots, "default")
            ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$p)
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ );
}
$741c336afc2dfa06$var$script$1G.render = $741c336afc2dfa06$var$render$M;
$741c336afc2dfa06$var$script$1G.__file = "themes/blank/templates/ElementDescription.vue";
var $741c336afc2dfa06$export$21ebc6dfdf589803 = {
    name: 'ElementDescription',
    render: $741c336afc2dfa06$var$script$1G.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-description',
                container_sm: 'vf-description-sm',
                container_md: '',
                container_lg: 'vf-description-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$O = ".vf-description {\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  color: var(--vf-color-muted);\n  margin-top: 0.25rem;\n}\n\n.vf-description.vf-description-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  margin-top: 0.125rem;\n}\n\n.vf-description.vf-description-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$O);
$741c336afc2dfa06$export$21ebc6dfdf589803.__file = "themes/vueform/templates/ElementDescription.vue";
var $741c336afc2dfa06$var$script$1E = {
    name: 'ElementError',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$E = [
    "id",
    "innerHTML"
];
function $741c336afc2dfa06$var$render$L(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.showError ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        key: 0,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        id: _ctx.id,
        "aria-live": "assertive",
        innerHTML: _ctx.error
    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$E)) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$1E.render = $741c336afc2dfa06$var$render$L;
$741c336afc2dfa06$var$script$1E.__file = "themes/blank/templates/ElementError.vue";
var $741c336afc2dfa06$export$473043e13ed2e0dd = {
    name: 'ElementError',
    render: $741c336afc2dfa06$var$script$1E.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-error',
                container_sm: 'vf-element-error-sm',
                container_md: '',
                container_lg: 'vf-element-error-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$N = ".vf-element-error {\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  color: var(--vf-color-danger);\n  margin-top: 0.25rem;\n}\n\n.vf-element-error.vf-element-error-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  margin-top: 0.125rem;\n}\n\n.vf-element-error.vf-element-error-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$N);
$741c336afc2dfa06$export$473043e13ed2e0dd.__file = "themes/vueform/templates/ElementError.vue";
var $741c336afc2dfa06$var$script$1C = {
    name: 'ElementMessage',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$D = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$K(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.message ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        key: 0,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        innerHTML: _ctx.message
    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$D)) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$1C.render = $741c336afc2dfa06$var$render$K;
$741c336afc2dfa06$var$script$1C.__file = "themes/blank/templates/ElementMessage.vue";
var $741c336afc2dfa06$export$446a47ef83e6389d = {
    name: 'ElementMessage',
    render: $741c336afc2dfa06$var$script$1C.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-message',
                container_sm: 'vf-element-message-sm',
                container_md: '',
                container_lg: 'vf-element-message-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$M = ".vf-element-message {\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  color: var(--vf-color-success);\n  margin-top: 0.25rem;\n}\n\n.vf-element-message.vf-element-message-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  margin-top: 0.125rem;\n}\n\n.vf-element-message.vf-element-message-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$M);
$741c336afc2dfa06$export$446a47ef83e6389d.__file = "themes/vueform/templates/ElementMessage.vue";
var $741c336afc2dfa06$var$script$1A = {
    name: 'ElementRequired',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$J(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.visible ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        key: 0,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                _cache[0] || (_cache[0] = (0, $ani5R.createTextVNode)("*"))
            ])
    ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$1A.render = $741c336afc2dfa06$var$render$J;
$741c336afc2dfa06$var$script$1A.__file = "themes/blank/templates/ElementRequired.vue";
var $741c336afc2dfa06$export$94f2ad7da0af4e7 = {
    name: 'ElementRequired',
    render: $741c336afc2dfa06$var$script$1A.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-element-required'
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$L = "";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$L);
$741c336afc2dfa06$export$94f2ad7da0af4e7.__file = "themes/vueform/templates/ElementRequired.vue";
var $741c336afc2dfa06$var$script$1y = {
    name: 'ElementText',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$C = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$I(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createCommentVNode)(" If content is HTML "),
        _ctx.content ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
            innerHTML: _ctx.content
        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$C)) : _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createCommentVNode)(" If content is a slot "),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
            }, [
                (0, $ani5R.renderSlot)(_ctx.$slots, "default")
            ], 2 /* CLASS */ )
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ );
}
$741c336afc2dfa06$var$script$1y.render = $741c336afc2dfa06$var$render$I;
$741c336afc2dfa06$var$script$1y.__file = "themes/blank/templates/ElementText.vue";
var $741c336afc2dfa06$export$f535379b10321bef = {
    name: 'ElementText',
    render: $741c336afc2dfa06$var$script$1y.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                container_before: '',
                container_between: '',
                container_after: '',
                $container: (classes, { type: type })=>[
                        classes.container,
                        classes[`container_${type}`]
                    ]
            }
        };
    }
};
$741c336afc2dfa06$export$f535379b10321bef.__file = "themes/vueform/templates/ElementText.vue";
var $741c336afc2dfa06$var$script$1w = {
    name: 'ElementAddon',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$B = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$H(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
        (0, $ani5R.createCommentVNode)(" If addon is a component "),
        _ctx.addon && _ctx.isAddonComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
            }, [
                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.addon)))
            ], 2 /* CLASS */ )
        ], 2 /* CLASS */ )) : _ctx.addon ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            (0, $ani5R.createCommentVNode)(" If addon is HTML "),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
            }, [
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    innerHTML: _ctx.addon
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$B)
            ], 2 /* CLASS */ )
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : _ctx.isSlot ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 2
        }, [
            (0, $ani5R.createCommentVNode)(" If addon is a slot "),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
            }, [
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "default")
                ], 2 /* CLASS */ )
            ], 2 /* CLASS */ )
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ );
}
$741c336afc2dfa06$var$script$1w.render = $741c336afc2dfa06$var$render$H;
$741c336afc2dfa06$var$script$1w.__file = "themes/blank/templates/ElementAddon.vue";
var $741c336afc2dfa06$export$f69753cc2f1f809e = {
    name: 'ElementAddon',
    render: $741c336afc2dfa06$var$script$1w.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-addon',
                container_before: 'vf-addon-before',
                container_after: 'vf-addon-after',
                container_sm: 'vf-addon-sm',
                container_md: '',
                container_lg: 'vf-addon-lg',
                container_before_sm: '',
                container_before_md: '',
                container_before_lg: '',
                container_after_sm: '',
                container_after_md: '',
                container_after_lg: '',
                wrapper: 'vf-addon-wrapper',
                $container: (classes, { type: type, Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`],
                        classes[`container_${type}`],
                        classes[`container_${type}_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$K = ".vf-addon {\n  background: var(--vf-bg-addon);\n  color: var(--vf-color-addon);\n  border-radius: var(--vf-radius-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 0%;\n}\n\n.vf-addon.vf-addon-before {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  padding: 0 var(--vf-space-addon) 0 var(--vf-px-input);\n}\n\n.vf-addon.vf-addon-before.vf-addon-sm {\n  padding: 0 var(--vf-space-addon-sm) 0 var(--vf-px-input-sm);\n}\n\n.vf-addon.vf-addon-before.vf-addon-lg {\n  padding: 0 var(--vf-space-addon-lg) 0 var(--vf-px-input-lg);\n}\n\n.vf-addon.vf-addon-after {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 0 var(--vf-px-input) 0 var(--vf-space-addon);\n  order: 2;\n}\n\n.vf-addon.vf-addon-after.vf-addon-sm {\n  padding: 0 var(--vf-px-input-sm) 0 var(--vf-space-addon-sm);\n}\n\n.vf-addon.vf-addon-after.vf-addon-lg {\n  padding: 0 var(--vf-px-input-lg) 0 var(--vf-space-addon-lg);\n}\n\n.vf-addon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$K);
$741c336afc2dfa06$export$f69753cc2f1f809e.__file = "themes/vueform/templates/ElementAddon.vue";
var $741c336afc2dfa06$var$script$1u = {
    name: 'ElementAddonOptions',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                caret: '',
                dropdown: '',
                option: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$A = [
    "aria-expanded",
    "aria-controls",
    "tabindex"
];
const $741c336afc2dfa06$var$_hoisted_2$o = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_3$f = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_4$b = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_5$6 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_6$5 = [
    "data-dropdown-for",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_7$3 = [
    "onMouseover",
    "onClick"
];
const $741c336afc2dfa06$var$_hoisted_8$2 = [
    "innerHTML",
    "data-index",
    "data-selected",
    "tabindex",
    "aria-selected"
];
const $741c336afc2dfa06$var$_hoisted_9$2 = [
    "innerHTML",
    "data-index",
    "data-selected",
    "tabindex",
    "aria-selected"
];
function $741c336afc2dfa06$var$render$G(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("div", (0, $ani5R.mergeProps)({
            class: _ctx.classes.wrapper,
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.handleSelectorClick && _ctx.handleSelectorClick(...args)),
            onKeydown: _cache[1] || (_cache[1] = (...args)=>_ctx.handleSelectorKeydown && _ctx.handleSelectorKeydown(...args))
        }, _ctx.aria, {
            "aria-expanded": _ctx.isOpen,
            "aria-haspopup": "listbox",
            "aria-controls": `dropdown-${_ctx.el$.fieldId}`,
            role: "button",
            tabindex: _ctx.el$.isDisabled || _ctx.el$.isReadonly ? undefined : 0,
            ref: "selector"
        }), [
            Object.keys(_ctx.selected).length ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 0
            }, [
                _ctx.selected.valueDisplay && typeof _ctx.selected.valueDisplay === 'object' && [
                    _ctx.selected.valueDisplay.render || _ctx.selected.valueDisplay.template
                ] ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.selected.valueDisplay), {
                    key: 0,
                    el$: _ctx.el$,
                    option: _ctx.selected
                }, null, 8 /* PROPS */ , [
                    "el$",
                    "option"
                ])) : _ctx.selected.valueDisplay && typeof _ctx.selected.valueDisplay === 'function' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    innerHTML: _ctx.selected.valueDisplay(_ctx.selected, _ctx.el$)
                }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_2$o)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 2,
                    innerHTML: _ctx.selected.label
                }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_3$f))
            ], 64 /* STABLE_FRAGMENT */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 1
            }, [
                _ctx.placeholder && typeof _ctx.placeholder === 'object' && [
                    _ctx.placeholder.render || _ctx.placeholder.template
                ] ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.placeholder), {
                    key: 0,
                    el$: _ctx.el$,
                    option: _ctx.selected
                }, null, 8 /* PROPS */ , [
                    "el$",
                    "option"
                ])) : _ctx.placeholder && typeof _ctx.placeholder === 'function' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    innerHTML: _ctx.placeholder(_ctx.selected, _ctx.el$)
                }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_4$b)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 2,
                    innerHTML: _ctx.placeholder
                }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_5$6))
            ], 64 /* STABLE_FRAGMENT */ )),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.caret)
            }, null, 2 /* CLASS */ ),
            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.Teleport), {
                to: "body"
            }, [
                _ctx.isOpen ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    "data-dropdown-for": _ctx.el$.fieldId,
                    id: `dropdown-${_ctx.el$.fieldId}`,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.dropdown),
                    style: (0, $X5A94.normalizeStyle)(_ctx.style),
                    ref: "dropdown",
                    role: "listbox",
                    tabindex: "-1"
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.options, (option, index)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.optionWrapper),
                            key: option.value,
                            onMouseover: ($event)=>_ctx.handleOptionPoint(option),
                            onClick: ($event)=>_ctx.handleOptionClick(option)
                        }, [
                            option.display && typeof option.display === 'object' && [
                                option.display.render || option.display.template
                            ] ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(option.display), {
                                key: 0,
                                el$: _ctx.el$,
                                option: option,
                                index: index,
                                selected: _ctx.selected.index === option.index,
                                pointed: _ctx.pointed.index === option.index,
                                "data-index": option.index,
                                "data-selected": _ctx.selected.index === option.index,
                                role: "option",
                                tabindex: _ctx.pointed.index === option.index ? 0 : -1,
                                "aria-selected": _ctx.selected.index === option.index
                            }, null, 8 /* PROPS */ , [
                                "el$",
                                "option",
                                "index",
                                "selected",
                                "pointed",
                                "data-index",
                                "data-selected",
                                "tabindex",
                                "aria-selected"
                            ])) : option.display && typeof option.display === 'function' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 1,
                                innerHTML: option.display(option, index, _ctx.selected.index === option.index, _ctx.pointed.index === option.index, _ctx.el$),
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.option(option, index, _ctx.el$)),
                                "data-index": option.index,
                                "data-selected": _ctx.selected.index === option.index,
                                role: "option",
                                tabindex: _ctx.pointed.index === option.index ? 0 : -1,
                                "aria-selected": _ctx.selected.index === option.index
                            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_8$2)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 2,
                                innerHTML: option.label,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.option(option, index, _ctx.el$)),
                                "data-index": option.index,
                                "data-selected": _ctx.selected.index === option.index,
                                role: "option",
                                tabindex: _ctx.pointed.index === option.index ? 0 : -1,
                                "aria-selected": _ctx.selected.index === option.index
                            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_9$2))
                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_7$3);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 14 /* CLASS, STYLE, PROPS */ , $741c336afc2dfa06$var$_hoisted_6$5)) : (0, $ani5R.createCommentVNode)("v-if", true)
            ]))
        ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$A)
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1u.render = $741c336afc2dfa06$var$render$G;
$741c336afc2dfa06$var$script$1u.__file = "themes/blank/templates/ElementAddonOptions.vue";
var $741c336afc2dfa06$export$ea88e214de7ca5ac = {
    name: 'ElementAddonOptions',
    render: $741c336afc2dfa06$var$script$1u.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-addon-options',
                container_sm: 'vf-addon-options-sm',
                container_md: '',
                container_lg: 'vf-addon-options-lg',
                container_disabled: 'vf-addon-options-disabled',
                wrapper: 'vf-addon-options-wrapper',
                wrapper_relaxed: 'vf-addon-options-wrapper-relaxed',
                caret: 'vf-addon-options-caret',
                dropdown: 'vf-addon-options-dropdown',
                option: 'vf-addon-options-option',
                option_active: 'vf-addon-options-option-active',
                $container: (classes, { Size: Size, el$: el$ })=>[
                        classes.container,
                        classes[`container_${Size}`],
                        el$.isDisabled || el$.readonly ? classes.container_disabled : null
                    ],
                $wrapper: (classes, { relaxed: relaxed })=>[
                        classes.wrapper,
                        relaxed ? classes.wrapper_relaxed : classes.wrapper_default
                    ],
                $option: (classes, { selected: selected, pointed: pointed })=>(option)=>[
                            classes.option,
                            selected.index === option.index || pointed.index === option.index ? classes.option_active : null
                        ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$J = ".vf-addon-options {\n  display: flex;\n  align-items: center;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-addon-options.vf-addon-options-sm {\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-addon-options.vf-addon-options-lg {\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-addon-options.vf-addon-options-disabled {\n  opacity: 0.5;\n  cursor: initial;\n  pointer-events: none;\n}\n\n.vf-addon-options-wrapper {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  padding: 4px 4px;\n  cursor: pointer;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n  outline: none;\n}\n\n.vf-addon-options-wrapper:hover, .vf-addon-options-wrapper:focus {\n  background: var(--vf-bg-selected);\n}\n\n.vf-addon-options-wrapper.vf-addon-options-wrapper-relaxed {\n  padding: 6px 12px;\n}\n\n.vf-addon-options-caret {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  background-color: var(--vf-bg-icon);\n  color: var(--vf-color-input);\n  width: 0.625rem;\n  height: 1rem;\n  padding: 1px 0;\n  margin-left: 0.5rem;\n}\n\n.vf-addon-options-dropdown {\n  background-color: var(--vf-bg-input);\n  border-width: var(--vf-border-width-dropdown);\n  border-style: solid;\n  border-color: var(--vf-border-color-input);\n  box-shadow: var(--vf-shadow-dropdown);\n  color: var(--vf-color-input);\n  position: fixed;\n  z-index: 1002;\n  overflow-x: scroll;\n  max-height: calc(100vh - 2rem);\n}\n\n.vf-addon-options-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0.3125rem 0.75rem;\n  white-space: nowrap;\n}\n\n.vf-addon-options-option-active {\n  background: var(--vf-bg-selected);\n}\n\n[dir=rtl] .vf-addon-options-caret {\n  margin-left: 0;\n  margin-right: 0.5rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$J);
$741c336afc2dfa06$export$ea88e214de7ca5ac.__file = "themes/vueform/templates/ElementAddonOptions.vue";
var $741c336afc2dfa06$var$script$1s = {
    name: 'ButtonElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                button: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$z = [
    "tabindex",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$n = [
    "innerHTML",
    "tabindex",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_3$e = [
    "tabindex",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_4$a = [
    "tabindex"
];
const $741c336afc2dfa06$var$_hoisted_5$5 = [
    "innerHTML",
    "tabindex"
];
const $741c336afc2dfa06$var$_hoisted_6$4 = [
    "tabindex"
];
function $741c336afc2dfa06$var$render$F(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createCommentVNode)(" Use `button` tag "),
                _ctx.buttonType === 'button' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 0
                }, [
                    (0, $ani5R.createCommentVNode)(" Use it as a component "),
                    _ctx.buttonLabel && _ctx.isButtonLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("button", (0, $ani5R.mergeProps)({
                        key: 0
                    }, {
                        ..._ctx.button,
                        ..._ctx.aria
                    }, {
                        tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                        disabled: _ctx.isDisabled,
                        class: _ctx.classes.button,
                        onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                            "prevent"
                        ]))
                    }), [
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.buttonLabel)))
                    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$z)) : _ctx.buttonLabel ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" Use it as HTML "),
                        (0, $ani5R.createElementVNode)("button", (0, $ani5R.mergeProps)({
                            ..._ctx.button,
                            ..._ctx.aria
                        }, {
                            innerHTML: _ctx.resolvedButtonLabel,
                            tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                            class: _ctx.classes.button,
                            disabled: _ctx.isDisabled,
                            onClick: _cache[1] || (_cache[1] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                                "prevent"
                            ]))
                        }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_2$n)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 2
                    }, [
                        (0, $ani5R.createCommentVNode)(" Use it as slot "),
                        (0, $ani5R.createElementVNode)("button", (0, $ani5R.mergeProps)({
                            ..._ctx.button,
                            ..._ctx.aria
                        }, {
                            tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                            class: _ctx.classes.button,
                            disabled: _ctx.isDisabled,
                            onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                                "prevent"
                            ]))
                        }), [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                                el$: _ctx.el$
                            }, ()=>[
                                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.default), {
                                        el$: _ctx.el$
                                    }, null, 8 /* PROPS */ , [
                                        "el$"
                                    ]))
                                ])
                        ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_3$e)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ], 64 /* STABLE_FRAGMENT */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 1
                }, [
                    (0, $ani5R.createCommentVNode)(" Use `anchor` tag "),
                    (0, $ani5R.createCommentVNode)(" Use it as a component "),
                    _ctx.buttonLabel && _ctx.isButtonLabelComponent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", (0, $ani5R.mergeProps)({
                        key: 0
                    }, {
                        ..._ctx.button,
                        ..._ctx.aria
                    }, {
                        tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                        class: _ctx.classes.button,
                        onClick: _cache[3] || (_cache[3] = (...args)=>_ctx.handleClick && _ctx.handleClick(...args))
                    }), [
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.buttonLabel)))
                    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_4$a)) : _ctx.buttonLabel ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" Use it as HTML "),
                        (0, $ani5R.createElementVNode)("a", (0, $ani5R.mergeProps)({
                            ..._ctx.button,
                            ..._ctx.aria
                        }, {
                            innerHTML: _ctx.resolvedButtonLabel,
                            tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                            class: _ctx.classes.button,
                            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.handleClick && _ctx.handleClick(...args))
                        }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_5$5)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 2
                    }, [
                        (0, $ani5R.createCommentVNode)(" Use it as slot "),
                        (0, $ani5R.createElementVNode)("a", (0, $ani5R.mergeProps)({
                            ..._ctx.button,
                            ..._ctx.aria
                        }, {
                            tabindex: _ctx.isDisabled || _ctx.isLoading ? -1 : undefined,
                            class: _ctx.classes.button,
                            onClick: _cache[5] || (_cache[5] = (...args)=>_ctx.handleClick && _ctx.handleClick(...args))
                        }), [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                                el$: _ctx.el$
                            }, ()=>[
                                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.default), {
                                        el$: _ctx.el$
                                    }, null, 8 /* PROPS */ , [
                                        "el$"
                                    ]))
                                ])
                        ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_6$4)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ], 64 /* STABLE_FRAGMENT */ ))
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1s.render = $741c336afc2dfa06$var$render$F;
$741c336afc2dfa06$var$script$1s.__file = "themes/blank/templates/elements/ButtonElement.vue";
var $741c336afc2dfa06$export$4dbe6dbd7e2997f = {
    name: 'ButtonElement',
    render: $741c336afc2dfa06$var$script$1s.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                button: 'vf-btn',
                button_enabled: '',
                button_disabled: 'vf-btn-disabled',
                button_loading: 'vf-btn-loading',
                button_loading_primary: 'vf-btn-loading-primary',
                button_loading_secondary: 'vf-btn-loading-secondary',
                button_loading_danger: 'vf-btn-loading-danger',
                button_primary: 'vf-btn-primary',
                button_secondary: 'vf-btn-secondary',
                button_danger: 'vf-btn-danger',
                button_full: 'vf-btn-full',
                button_not_full: '',
                button_left: 'vf-btn-left',
                button_center: 'vf-btn-center',
                button_right: 'vf-btn-right',
                button_sm: 'vf-btn-sm',
                button_md: '',
                button_lg: 'vf-btn-lg',
                $button: (classes, { isDisabled: isDisabled, isLoading: isLoading, buttonClass: buttonClass, Size: Size, danger: danger, secondary: secondary, full: full, align: align })=>[
                        classes.button,
                        danger ? classes.button_danger : null,
                        secondary ? classes.button_secondary : null,
                        !danger && !secondary ? classes.button_primary : null,
                        classes[`button_${Size}`],
                        isDisabled ? classes.button_disabled : null,
                        !isDisabled && !isLoading ? classes.button_enabled : null,
                        isLoading ? classes.button_loading : null,
                        isLoading && danger ? classes.button_loading_danger : null,
                        isLoading && secondary ? classes.button_loading_secondary : null,
                        isLoading && !secondary && !danger ? classes.button_loading_primary : null,
                        full ? classes.button_full : classes.button_not_full,
                        align === 'left' ? classes.button_left : null,
                        align === 'center' ? classes.button_center : null,
                        align === 'right' ? classes.button_right : null,
                        buttonClass
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$I = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$I);
$741c336afc2dfa06$export$4dbe6dbd7e2997f.__file = "themes/vueform/templates/elements/ButtonElement.vue";
var $741c336afc2dfa06$var$script$1q = {
    name: 'CaptchaElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                captcha: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$y = [
    "id"
];
function $741c336afc2dfa06$var$render$E(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                _ctx.shouldVerify ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.createElementVNode)("div", {
                        id: _ctx.fieldId,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.captcha),
                        ref: "input"
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$y)
                ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1q.render = $741c336afc2dfa06$var$render$E;
$741c336afc2dfa06$var$script$1q.__file = "themes/blank/templates/elements/CaptchaElement.vue";
var $741c336afc2dfa06$export$99689467e8d9e87e = {
    name: 'CaptchaElement',
    render: $741c336afc2dfa06$var$script$1q.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                captcha: ''
            }
        };
    }
};
$741c336afc2dfa06$export$99689467e8d9e87e.__file = "themes/vueform/templates/elements/CaptchaElement.vue";
var $741c336afc2dfa06$var$script$1o = {
    name: 'CheckboxElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$x = [
    "name",
    "id",
    "true-value",
    "false-value",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$m = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$D(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("label", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event)
                    }, _ctx.aria, {
                        class: _ctx.classes.input,
                        name: _ctx.path,
                        id: _ctx.fieldId,
                        "true-value": _ctx.trueValue,
                        "false-value": _ctx.falseValue,
                        disabled: _ctx.isDisabled,
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$x), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            _ctx.value
                        ]
                    ]),
                    (0, $ani5R.createCommentVNode)(" If label is HTML "),
                    _ctx.Text ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                        innerHTML: _ctx.Text
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$m)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" If label is slot "),
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.text)
                        }, [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                                el$: _ctx.el$
                            }, ()=>[
                                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.default), {
                                        el$: _ctx.el$
                                    }, null, 8 /* PROPS */ , [
                                        "el$"
                                    ]))
                                ])
                        ], 2 /* CLASS */ )
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1o.render = $741c336afc2dfa06$var$render$D;
$741c336afc2dfa06$var$script$1o.__file = "themes/blank/templates/elements/CheckboxElement.vue";
var $741c336afc2dfa06$export$bdbc55f88cb186c4 = {
    name: 'CheckboxElement',
    render: $741c336afc2dfa06$var$script$1o.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-contains-link',
                wrapper: 'vf-checkbox-wrapper',
                wrapper_sm: 'vf-checkbox-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkbox-wrapper-lg',
                wrapper_left: 'vf-checkbox-wrapper-left',
                wrapper_right: 'vf-checkbox-wrapper-right',
                input: 'vf-checkbox',
                input_enabled: '',
                input_disabled: '',
                input_danger: 'vf-checkbox-danger',
                input_sm: 'vf-checkbox-sm',
                input_md: '',
                input_lg: 'vf-checkbox-lg',
                input_left: 'vf-checkbox-left',
                input_right: 'vf-checkbox-right',
                input_standalone: 'vf-checkbox-standalone',
                text: 'vf-checkbox-text',
                text_left: 'vf-checkbox-text-left',
                text_right: 'vf-checkbox-text-right',
                $wrapper: (classes, { Size: Size, align: align })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        align === 'left' ? classes.wrapper_left : null,
                        align === 'right' ? classes.wrapper_right : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isDanger: isDanger, align: align, standalone: standalone })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        align === 'left' ? classes.input_left : null,
                        align === 'right' ? classes.input_right : null,
                        standalone ? classes.input_standalone : null
                    ],
                $text: (classes, { align: align })=>[
                        classes.text,
                        align === 'left' ? classes.text_left : null,
                        align === 'right' ? classes.text_right : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$H = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$H);
$741c336afc2dfa06$export$bdbc55f88cb186c4.__file = "themes/vueform/templates/elements/CheckboxElement.vue";
var $741c336afc2dfa06$var$script$1m = {
    name: 'CheckboxgroupElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$w = [
    "aria-labelledby"
];
function $741c336afc2dfa06$var$render$C(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CheckboxgroupCheckbox = (0, $ani5R.resolveComponent)("CheckboxgroupCheckbox");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    "aria-labelledby": _ctx.labelId,
                    role: "group"
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedOptions, (item, index, key)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_CheckboxgroupCheckbox, {
                            items: _ctx.resolvedOptions,
                            index: index,
                            item: item,
                            value: item.value,
                            key: key,
                            attrs: _ctx.aria
                        }, {
                            default: (0, $ani5R.withCtx)((scope)=>[
                                    (0, $ani5R.renderSlot)(_ctx.$slots, "checkbox", (0, $ani5R.mergeProps)({
                                        ref_for: true
                                    }, scope, {
                                        el$: _ctx.el$
                                    }), ()=>[
                                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.checkbox), (0, $ani5R.mergeProps)({
                                                ref_for: true
                                            }, scope, {
                                                el$: _ctx.el$
                                            }), null, 16 /* FULL_PROPS */ , [
                                                "el$"
                                            ]))
                                        ])
                                ]),
                            _: 2 /* DYNAMIC */ 
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                            "items",
                            "index",
                            "item",
                            "value",
                            "attrs"
                        ]);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$w)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1m.render = $741c336afc2dfa06$var$render$C;
$741c336afc2dfa06$var$script$1m.__file = "themes/blank/templates/elements/CheckboxgroupElement.vue";
var $741c336afc2dfa06$export$7eafe581c398e33d = {
    name: 'CheckboxgroupElement',
    render: $741c336afc2dfa06$var$script$1m.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkboxgroup-view-default',
                wrapper: 'vf-checkboxgroup-wrapper',
                wrapper_sm: 'vf-checkboxgroup-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkboxgroup-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$G = ".vf-checkboxgroup-wrapper {\n  cursor: pointer;\n}\n\n.vf-checkboxgroup-wrapper .vf-checkbox-container {\n  padding-top: 0;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$G);
$741c336afc2dfa06$export$7eafe581c398e33d.__file = "themes/vueform/templates/elements/CheckboxgroupElement.vue";
var $741c336afc2dfa06$export$5839f83b449473f8 = {
    name: 'CheckboxgroupElement_tabs',
    render: $741c336afc2dfa06$var$script$1m.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkboxgroup-view-tabs',
                wrapper: 'vf-checkboxgroup-tabs-wrapper',
                wrapper_sm: 'vf-checkboxgroup-tabs-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkboxgroup-tabs-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$F = ".vf-checkboxgroup-tabs-wrapper {\n  display: grid;\n  grid-auto-flow: column;\n  box-shadow: var(--vf-shadow-input);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-checkboxgroup-tabs-wrapper.vf-checkboxgroup-tabs-wrapper-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-checkboxgroup-tabs-wrapper.vf-checkboxgroup-tabs-wrapper-lg {\n  border-radius: var(--vf-radius-large-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$F);
$741c336afc2dfa06$export$5839f83b449473f8.__file = "themes/vueform/templates/elements/CheckboxgroupElement_tabs.vue";
var $741c336afc2dfa06$export$dddd0f2901295e2 = {
    name: 'CheckboxgroupElement_blocks',
    render: $741c336afc2dfa06$var$script$1m.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkboxgroup-view-blocks',
                wrapper: 'vf-checkboxgroup-blocks-wrapper',
                wrapper_sm: 'vf-checkboxgroup-blocks-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkboxgroup-blocks-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$E = ".vf-checkboxgroup-blocks-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-shadow: var(--vf-shadow-input);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-checkboxgroup-blocks-wrapper.vf-checkboxgroup-blocks-wrapper-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-checkboxgroup-blocks-wrapper.vf-checkboxgroup-blocks-wrapper-lg {\n  border-radius: var(--vf-radius-large-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$E);
$741c336afc2dfa06$export$dddd0f2901295e2.__file = "themes/vueform/templates/elements/CheckboxgroupElement_blocks.vue";
var $741c336afc2dfa06$var$script$1i = {
    name: 'DateElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                inputWrapper: '',
                input: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$B(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddon = (0, $ani5R.resolveComponent)("ElementAddon");
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_DatepickerWrapper = (0, $ani5R.resolveComponent)("DatepickerWrapper");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputContainer)
                }, [
                    _ctx.hasAddonBefore ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 0,
                        type: "before"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-before", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-before']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasAddonAfter ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 1,
                        type: "after"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-after", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-after']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                        key: 2,
                        visible: !_ctx.empty
                    }, null, 8 /* PROPS */ , [
                        "visible"
                    ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.inputWrapper)
                    }, [
                        (0, $ani5R.createVNode)(_component_DatepickerWrapper, {
                            value: _ctx.model,
                            options: _ctx.fieldOptions,
                            id: _ctx.fieldId,
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.input),
                            placeholder: _ctx.Placeholder,
                            disabled: _ctx.isDisabled,
                            readonly: _ctx.isReadonly,
                            attrs: _ctx.aria,
                            onChange: _ctx.handleChange,
                            ref: "input"
                        }, null, 8 /* PROPS */ , [
                            "value",
                            "options",
                            "id",
                            "class",
                            "placeholder",
                            "disabled",
                            "readonly",
                            "attrs",
                            "onChange"
                        ])
                    ], 2 /* CLASS */ )
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1i.render = $741c336afc2dfa06$var$render$B;
$741c336afc2dfa06$var$script$1i.__file = "themes/blank/templates/elements/DateElement.vue";
var $741c336afc2dfa06$export$1e68ee11416672d8 = {
    name: 'DateElement',
    render: $741c336afc2dfa06$var$script$1i.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                inputWrapper: 'vf-datepicker-wrapper',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$D = "/* Some styles are contained in Vueform.vue & DatepickerWrapper.vue */\n\n.vf-datepicker-wrapper {\n  display: block;\n  width: 100%;\n  height: 100%;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$D);
$741c336afc2dfa06$export$1e68ee11416672d8.__file = "themes/vueform/templates/elements/DateElement.vue";
var $741c336afc2dfa06$var$script$1g = {
    name: 'DatesElement',
    render: $741c336afc2dfa06$var$script$1i.render,
    staticRenderFns: $741c336afc2dfa06$var$script$1i.staticRenderFns,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
$741c336afc2dfa06$var$script$1g.__file = "themes/blank/templates/elements/DatesElement.vue";
var $741c336afc2dfa06$export$7348cb1e714208cc = {
    name: 'DatesElement',
    render: $741c336afc2dfa06$var$script$1g.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                inputWrapper: 'vf-datepicker-wrapper',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$C = "/* Some styles are contained in Vueform.vue & DatepickerWrapper.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$C);
$741c336afc2dfa06$export$7348cb1e714208cc.__file = "themes/vueform/templates/elements/DatesElement.vue";
var $741c336afc2dfa06$var$script$1e = {
    name: 'FileElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                button: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$v = [
    "aria-labelledby",
    "aria-placeholder"
];
const $741c336afc2dfa06$var$_hoisted_2$l = [
    "id",
    "accept"
];
function $741c336afc2dfa06$var$render$A(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DragAndDrop = (0, $ani5R.resolveComponent)("DragAndDrop");
    const _component_FilePreview = (0, $ani5R.resolveComponent)("FilePreview");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createCommentVNode)(" Drag n drop "),
                _ctx.drop && _ctx.canDrop && _ctx.canSelect ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_DragAndDrop, {
                    key: 0,
                    title: _ctx.form$.translations.vueform.elements[_ctx.type].dndTitle,
                    description: _ctx.form$.translations.vueform.elements[_ctx.type].dndDescription,
                    disabled: _ctx.isDisabled,
                    onClick: _ctx.handleClick,
                    onDrop: _ctx.handleDrop
                }, null, 8 /* PROPS */ , [
                    "title",
                    "description",
                    "disabled",
                    "onClick",
                    "onDrop"
                ])) : _ctx.canSelect ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 1
                }, [
                    (0, $ani5R.createCommentVNode)(" Upload button "),
                    (0, $ani5R.createElementVNode)("div", (0, $ani5R.mergeProps)(_ctx.aria, {
                        class: _ctx.classes.button,
                        "aria-labelledby": _ctx.labelId,
                        "aria-placeholder": _ctx.form$.translations.vueform.elements[_ctx.type].select,
                        onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                            "prevent"
                        ])),
                        onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                            "enter",
                            "space"
                        ])),
                        role: "button",
                        tabindex: "0"
                    }), (0, $X5A94.toDisplayString)(_ctx.form$.translations.vueform.elements[_ctx.type].select), 17 /* TEXT, FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$v)
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Hidden file input "),
                _ctx.canSelect && !_ctx.isDisabled && !_ctx.preparing ? (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", {
                    key: 2,
                    id: _ctx.fieldId,
                    type: "file",
                    accept: _ctx.accept,
                    onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.handleChange && _ctx.handleChange(...args)),
                    ref: "input"
                }, null, 40 /* PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_2$l)), [
                    [
                        (0, $dDLnc.vShow),
                        false
                    ]
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Preview "),
                (0, $ani5R.renderSlot)(_ctx.$slots, "preview", {}, ()=>[
                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_FilePreview, {
                            key: _ctx.view,
                            attrs: _ctx.aria
                        }, null, 8 /* PROPS */ , [
                            "attrs"
                        ]))
                    ])
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1e.render = $741c336afc2dfa06$var$render$A;
$741c336afc2dfa06$var$script$1e.__file = "themes/blank/templates/elements/FileElement.vue";
var $741c336afc2dfa06$export$552520729baa4d41 = {
    name: 'FileElement',
    render: $741c336afc2dfa06$var$script$1e.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-file vf-text-type',
                container_removing: 'vf-file-removing',
                button: 'vf-btn vf-btn-secondary',
                button_enabled: '',
                button_disabled: 'vf-btn-disabled',
                button_sm: 'vf-btn-sm',
                button_md: '',
                button_lg: 'vf-btn-lg',
                assertiveText: 'vf-assertive-text',
                $container: (classes, { removing: removing })=>[
                        classes.container,
                        removing ? classes.container_removing : null
                    ],
                $button: (classes, { isDisabled: isDisabled, preparing: preparing, Size: Size })=>[
                        classes.button,
                        classes[`button_${Size}`],
                        !isDisabled && !preparing ? classes.button_enabled : null,
                        isDisabled || preparing ? classes.button_disabled : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$B = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$B);
$741c336afc2dfa06$export$552520729baa4d41.__file = "themes/vueform/templates/elements/FileElement.vue";
var $741c336afc2dfa06$var$script$1c = {
    name: 'GridElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$u = [
    "aria-labelledby"
];
const $741c336afc2dfa06$var$_hoisted_2$k = [
    "data-col",
    "data-row",
    "data-col-start",
    "data-col-end",
    "data-row-start",
    "data-row-end"
];
const $741c336afc2dfa06$var$_hoisted_3$d = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$z(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        multiple: true,
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.grid),
                    style: (0, $X5A94.normalizeStyle)(_ctx.gridStyle),
                    role: "group",
                    "aria-labelledby": _ctx.labelId
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.cells, (cell, c)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
                            class: _ctx.classes.cell(cell),
                            style: cell.style,
                            ref_for: true
                        }, cell.attrs, {
                            "data-col": cell.col,
                            "data-row": cell.row,
                            "data-col-start": cell.colStart,
                            "data-col-end": cell.colEnd,
                            "data-row-start": cell.rowStart,
                            "data-row-end": cell.rowEnd
                        }), [
                            cell.schema ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 0,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.fieldWrapper(cell))
                            }, [
                                (0, $ani5R.renderSlot)(_ctx.$slots, cell.slot, {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(cell.component), (0, $ani5R.mergeProps)({
                                            name: cell.name,
                                            key: cell.name,
                                            ref_for: true
                                        }, cell.schema), null, 16 /* FULL_PROPS */ , [
                                            "name"
                                        ]))
                                    ])
                            ], 2 /* CLASS */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 1,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.textWrapper(cell))
                            }, [
                                (0, $ani5R.renderSlot)(_ctx.$slots, cell.slot, {}, ()=>[
                                        cell.content ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                            key: 0,
                                            class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                                            innerHTML: cell.content
                                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$d)) : (0, $ani5R.createCommentVNode)("v-if", true)
                                    ])
                            ], 2 /* CLASS */ ))
                        ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_2$k);
                    }), 256 /* UNKEYED_FRAGMENT */ ))
                ], 14 /* CLASS, STYLE, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$u)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1c.render = $741c336afc2dfa06$var$render$z;
$741c336afc2dfa06$var$script$1c.__file = "themes/blank/templates/elements/GridElement.vue";
var $741c336afc2dfa06$export$cfb3877ce19bb838 = {
    name: 'GridElement',
    render: $741c336afc2dfa06$var$script$1c.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-grid-container',
                container_scrollable: 'vf-grid-container-scrollable',
                grid: 'vf-grid',
                grid_sm: 'vf-grid-sm',
                grid_md: '',
                grid_lg: 'vf-grid-lg',
                cell: 'vf-grid-cell',
                fieldWrapper: 'vf-grid-field-wrapper',
                fieldWrapper_sm: 'vf-grid-field-wrapper-sm',
                fieldWrapper_md: '',
                fieldWrapper_lg: 'vf-grid-field-wrapper-lg',
                fieldWrapper_left: 'vf-grid-field-wrapper-left',
                fieldWrapper_center: 'vf-grid-field-wrapper-center',
                fieldWrapper_right: 'vf-grid-field-wrapper-right',
                fieldWrapper_top: 'vf-grid-field-wrapper-top',
                fieldWrapper_middle: 'vf-grid-field-wrapper-middle',
                fieldWrapper_bottom: 'vf-grid-field-wrapper-bottom',
                fieldWrapper_baseline: 'vf-grid-field-wrapper-baseline',
                textWrapper: 'vf-grid-text-wrapper',
                textWrapper_sm: 'vf-grid-text-wrapper-sm',
                textWrapper_md: '',
                textWrapper_lg: 'vf-grid-text-wrapper-lg',
                textWrapper_left: 'vf-grid-text-wrapper-left',
                textWrapper_center: 'vf-grid-text-wrapper-center',
                textWrapper_right: 'vf-grid-text-wrapper-right',
                textWrapper_justify: 'vf-grid-text-wrapper-justify',
                textWrapper_top: 'vf-grid-text-wrapper-top',
                textWrapper_middle: 'vf-grid-text-wrapper-middle',
                textWrapper_bottom: 'vf-grid-text-wrapper-bottom',
                textWrapper_baseline: 'vf-grid-text-wrapper-baseline',
                text: 'vf-grid-text',
                $container: (classes, { scrollable: scrollable })=>[
                        classes.container,
                        scrollable ? classes.container_scrollable : null
                    ],
                $grid: (classes, { Size: Size, align: align })=>[
                        classes.grid,
                        classes[`grid_${Size}`]
                    ],
                $cell: (classes, {})=>()=>[
                            classes.cell
                        ],
                $fieldWrapper: (classes, { Size: Size })=>({ schema: schema, align: align, valign: valign, rowIndex: rowIndex, colIndex: colIndex })=>[
                            classes.fieldWrapper,
                            classes[`fieldWrapper_${Size}`],
                            classes[`fieldWrapper_${align}`],
                            classes[`fieldWrapper_${valign}`]
                        ],
                $textWrapper: (classes, { Size: Size })=>({ align: align, valign: valign, rowIndex: rowIndex, colIndex: colIndex })=>[
                            classes.textWrapper,
                            classes[`textWrapper_${Size}`],
                            classes[`textWrapper_${align}`],
                            classes[`textWrapper_${valign}`]
                        ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$A = "/* Some styles are contained in _table.scss */\n\n.vf-grid-container-scrollable {\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n.vf-grid {\n  display: grid;\n  -moz-column-gap: min(8.3333333333%, var(--vf-gutter));\n       column-gap: min(8.3333333333%, var(--vf-gutter));\n  row-gap: var(--vf-gutter);\n}\n\n.vf-grid-sm {\n  -moz-column-gap: min(8.3333333333%, var(--vf-gutter-sm));\n       column-gap: min(8.3333333333%, var(--vf-gutter-sm));\n  row-gap: var(--vf-gutter-sm);\n}\n\n.vf-grid-lg {\n  -moz-column-gap: min(8.3333333333%, var(--vf-gutter-lg));\n       column-gap: min(8.3333333333%, var(--vf-gutter-lg));\n  row-gap: var(--vf-gutter-lg);\n}\n\n.vf-grid-cell {\n  position: relative;\n}\n\n.vf-grid-field-wrapper {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  min-height: var(--vf-min-height-input);\n}\n\n.vf-grid-field-wrapper-sm {\n  min-height: var(--vf-min-height-input-sm);\n}\n\n.vf-grid-field-wrapper-lg {\n  min-height: var(--vf-min-height-input-lg);\n}\n\n.vf-grid-field-wrapper-left {\n  text-align: left;\n}\n\n.vf-grid-field-wrapper-center {\n  text-align: center;\n}\n\n.vf-grid-field-wrapper-right {\n  text-align: right;\n}\n\n.vf-grid-field-wrapper-top {\n  align-items: flex-start;\n}\n\n.vf-grid-field-wrapper-middle {\n  align-items: center;\n}\n\n.vf-grid-field-wrapper-bottom {\n  align-items: flex-end;\n}\n\n.vf-grid-field-wrapper-baseline {\n  align-items: stretch;\n}\n\n.vf-grid-text-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  min-height: var(--vf-min-height-input);\n  padding: var(--vf-py-input) var(--vf-px-input);\n  overflow-wrap: break-word;\n}\n\n.vf-grid-text-wrapper-sm {\n  min-height: var(--vf-min-height-input-sm);\n  padding: var(--vf-py-input-sm) var(--vf-px-input-sm);\n}\n\n.vf-grid-text-wrapper-lg {\n  min-height: var(--vf-min-height-input-lg);\n  padding: var(--vf-py-input-lg) var(--vf-px-input-lg);\n}\n\n.vf-grid-text-wrapper-left {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.vf-grid-text-wrapper-center {\n  justify-content: center;\n  text-align: center;\n}\n\n.vf-grid-text-wrapper-right {\n  justify-content: flex-end;\n  text-align: right;\n}\n\n.vf-grid-text-wrapper-justify {\n  justify-content: stretch;\n  text-align: justify;\n}\n\n.vf-grid-text-wrapper-top {\n  align-items: start;\n}\n\n.vf-grid-text-wrapper-middle {\n  align-items: center;\n}\n\n.vf-grid-text-wrapper-bottom {\n  align-items: end;\n}\n\n.vf-grid-text-wrapper-baseline {\n  align-items: stretch;\n}\n\n.vf-grid-text {\n  width: 100%;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$A);
$741c336afc2dfa06$export$cfb3877ce19bb838.__file = "themes/vueform/templates/elements/GridElement.vue";
var $741c336afc2dfa06$var$script$1a = {
    name: 'GroupElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$t = [
    "aria-labelledby"
];
function $741c336afc2dfa06$var$render$y(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        multiple: true,
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    role: "group",
                    "aria-labelledby": _ctx.labelId
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.children, (element, name)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.component(element)), (0, $ani5R.mergeProps)({
                                    ref_for: true
                                }, element, {
                                    name: name,
                                    key: name
                                }), null, 16 /* FULL_PROPS */ , [
                                    "name"
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$t)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$1a.render = $741c336afc2dfa06$var$render$y;
$741c336afc2dfa06$var$script$1a.__file = "themes/blank/templates/elements/GroupElement.vue";
var $741c336afc2dfa06$export$e705959c834cb9fc = {
    name: 'GroupElement',
    render: $741c336afc2dfa06$var$script$1a.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: 'vf-row',
                wrapper_sm: 'vf-row-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-row-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$z = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$z);
$741c336afc2dfa06$export$e705959c834cb9fc.__file = "themes/vueform/templates/elements/GroupElement.vue";
var $741c336afc2dfa06$var$script$18 = {
    name: 'HiddenElement',
    data () {
        return {
            merge: true,
            defaultClasses: {}
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$s = {
    key: 0,
    ref: "container"
};
const $741c336afc2dfa06$var$_hoisted_2$j = [
    "name",
    "id"
];
function $741c336afc2dfa06$var$render$x(_ctx, _cache, $props, $setup, $data, $options) {
    return !_ctx.meta ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", $741c336afc2dfa06$var$_hoisted_1$s, [
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event),
            type: "hidden",
            name: _ctx.name,
            id: _ctx.fieldId,
            ref: "input"
        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_2$j), [
            [
                (0, $dDLnc.vModelText),
                _ctx.value
            ]
        ])
    ], 512 /* NEED_PATCH */ )) : (0, $ani5R.createCommentVNode)("v-if", true);
}
$741c336afc2dfa06$var$script$18.render = $741c336afc2dfa06$var$render$x;
$741c336afc2dfa06$var$script$18.__file = "themes/blank/templates/elements/HiddenElement.vue";
var $741c336afc2dfa06$export$6f15c4bf3859313a = {
    name: 'HiddenElement',
    render: $741c336afc2dfa06$var$script$18.render,
    data () {
        return {
            merge: true,
            defaultClasses: {}
        };
    }
};
$741c336afc2dfa06$export$6f15c4bf3859313a.__file = "themes/vueform/templates/elements/HiddenElement.vue";
var $741c336afc2dfa06$var$script$16 = {
    name: 'ListElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                list: '',
                listItem: '',
                handle: '',
                handleIcon: '',
                remove: '',
                removeIcon: '',
                add: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$r = [
    "aria-labelledby"
];
const $741c336afc2dfa06$var$_hoisted_2$i = [
    "data-id"
];
const $741c336afc2dfa06$var$_hoisted_3$c = [
    "aria-roledescription",
    "id",
    "onClick",
    "onKeypress"
];
const $741c336afc2dfa06$var$_hoisted_4$9 = [
    "id",
    "innerHTML"
];
function $741c336afc2dfa06$var$render$w(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createCommentVNode)(" Sorting container "),
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.list),
                    role: "list",
                    "aria-labelledby": _ctx.labelId,
                    ref: "list"
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.value, (val, i)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            key: i,
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.listItem),
                            role: "listitem",
                            "data-id": `${_ctx.path}-${i}`
                        }, [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                                index: i
                            }, ()=>[
                                    _ctx.prototype.type ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.component(_ctx.prototype)), (0, $ani5R.mergeProps)({
                                        key: 0,
                                        ref_for: true
                                    }, _ctx.prototype, {
                                        name: i,
                                        key: i
                                    }), null, 16 /* FULL_PROPS */ , [
                                        "name"
                                    ])) : (0, $ani5R.createCommentVNode)("v-if", true)
                                ]),
                            (0, $ani5R.createCommentVNode)(" Sort handle "),
                            _ctx.hasSort ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                key: 0,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.handle),
                                "data-handle": ""
                            }, [
                                (0, $ani5R.createElementVNode)("span", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.handleIcon)
                                }, null, 2 /* CLASS */ )
                            ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                            (0, $ani5R.createCommentVNode)(" Remove button "),
                            _ctx.hasRemove ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 1,
                                "aria-roledescription": _ctx.form$.translations.vueform.a11y.list.remove,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.remove),
                                id: `${_ctx.path}-${i}-remove-button`,
                                onClick: (0, $dDLnc.withModifiers)(($event)=>_ctx.handleRemove(i), [
                                    "prevent"
                                ]),
                                onKeypress: (0, $dDLnc.withKeys)(($event)=>_ctx.handleRemove(i), [
                                    "space",
                                    "enter"
                                ]),
                                role: "button",
                                tabindex: "0"
                            }, [
                                (0, $ani5R.createElementVNode)("span", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.removeIcon)
                                }, null, 2 /* CLASS */ )
                            ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_3$c)) : (0, $ani5R.createCommentVNode)("v-if", true)
                        ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$i);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$r),
                (0, $ani5R.createCommentVNode)(" Add button "),
                _ctx.hasAdd ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.add),
                    id: `${_ctx.fieldId}-add-button`,
                    onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleAdd && _ctx.handleAdd(...args), [
                        "prevent"
                    ])),
                    onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.handleAdd && _ctx.handleAdd(...args), [
                        "enter",
                        "space"
                    ])),
                    innerHTML: _ctx.addLabel,
                    role: "button",
                    tabindex: "0"
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_4$9)) : (0, $ani5R.createCommentVNode)("v-if", true)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$16.render = $741c336afc2dfa06$var$render$w;
$741c336afc2dfa06$var$script$16.__file = "themes/blank/templates/elements/ListElement.vue";
var $741c336afc2dfa06$export$fe925c804ebb00b7 = {
    name: 'ListElement',
    render: $741c336afc2dfa06$var$script$16.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                list: 'vf-rowset',
                list_sm: 'vf-rowset-sm',
                list_md: '',
                list_lg: 'vf-rowset-lg',
                list_disabled: 'vf-list-disabled',
                list_sorting: 'vf-list-sorting',
                listItem: 'vf-row',
                listItem_sm: 'vf-row-sm',
                listItem_md: '',
                listItem_lg: 'vf-row-lg',
                handle: 'vf-list-handle',
                handle_sm: 'vf-list-handle-sm',
                handle_md: '',
                handle_lg: 'vf-list-handle-lg',
                handleIcon: 'vf-list-handle-icon',
                remove: 'vf-list-remove',
                removeIcon: 'vf-list-remove-icon',
                add: 'vf-btn vf-btn-primary vf-btn-small vf-btn-list-add',
                add_sm: 'vf-btn-small-sm vf-btn-list-add-sm',
                add_md: '',
                add_lg: 'vf-btn-small-lg vf-btn-list-add-lg',
                $list: (classes, { isDisabled: isDisabled, sorting: sorting, Size: Size })=>[
                        classes.list,
                        classes[`list_${Size}`],
                        isDisabled ? classes.list_disabled : null,
                        sorting ? classes.list_sorting : null
                    ],
                $listItem: (classes, { Size: Size })=>[
                        classes.listItem,
                        classes[`listItem_${Size}`]
                    ],
                $handle: (classes, { Size: Size })=>[
                        classes.handle,
                        classes[`handle_${Size}`]
                    ],
                $add: (classes, { Size: Size })=>[
                        classes.add,
                        classes[`add_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$y = "/* Some styles are contained in Vueform.vue */\n\n.vf-rowset > .vf-row {\n  position: relative;\n}\n\n.vf-rowset > .vf-row:hover > .vf-list-remove, .vf-rowset > .vf-row:hover > .vf-list-handle {\n  visibility: visible;\n  opacity: 1;\n}\n\n.vf-rowset.vf-list-sorting > div:hover .vf-list-handle, .vf-rowset.vf-list-sorting > div:hover .vf-list-remove {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.vf-list-remove, .vf-list-handle {\n  opacity: 0;\n  transition: 0.3s;\n}\n\n.vf-list-remove span, .vf-list-handle span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center center;\n}\n\n.vf-list-remove {\n  position: absolute;\n  left: 0;\n  transform: translateX(-50%) translateY(-50%);\n  top: 0;\n  z-index: 999;\n  background-color: var(--vf-bg-passive);\n  border-radius: 999px;\n  transition: 0.15s;\n}\n\n.vf-list-remove:hover {\n  filter: brightness(0.9);\n}\n\n.vf-list-remove:focus {\n  opacity: 1;\n}\n\n.vf-list-remove-icon {\n  display: flex;\n  width: 1.125rem;\n  height: 1.125rem;\n  align-items: center;\n  justify-content: center;\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-list-handle {\n  position: absolute;\n  left: 0;\n  transform: translateX(-100%);\n  top: 0;\n  cursor: grab;\n  z-index: 999;\n}\n\n.vf-list-handle:active {\n  cursor: grabbing;\n}\n\n.vf-list-handle-icon {\n  width: var(--vf-min-height-input);\n  height: var(--vf-min-height-input);\n  mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='11px' height='9px' viewBox='0 0 11 9' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Ebars%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M10.0418527,0.894571939 L0.309709821,0.894571939 C0.235791888,0.894571939 0.17578125,0.834156736 0.17578125,0.759740479 L0.17578125,0.220414636 C0.17578125,0.145998379 0.235791888,0.0855831754 0.309709821,0.0855831754 L10.0418527,0.0855831754 C10.1157706,0.0855831754 10.1757812,0.145998379 10.1757812,0.220414636 L10.1757812,0.759740479 C10.1757812,0.834156736 10.1157706,0.894571939 10.0418527,0.894571939 Z M10.0418527,4.8049452 L0.309709821,4.8049452 C0.235791888,4.8049452 0.17578125,4.74453 0.17578125,4.67011374 L0.17578125,4.1307879 C0.17578125,4.05637164 0.235791888,3.99595644 0.309709821,3.99595644 L10.0418527,3.99595644 C10.1157706,3.99595644 10.1757812,4.05637164 10.1757812,4.1307879 L10.1757812,4.67011374 C10.1757812,4.74453 10.1157706,4.8049452 10.0418527,4.8049452 Z M10.0418527,8.80953919 L0.309709821,8.80953919 C0.235791888,8.80953919 0.17578125,8.74912399 0.17578125,8.67470773 L0.17578125,8.13538189 C0.17578125,8.06096563 0.235791888,8.00055043 0.309709821,8.00055043 L10.0418527,8.00055043 C10.1157706,8.00055043 10.1757812,8.06096563 10.1757812,8.13538189 L10.1757812,8.67470773 C10.1757812,8.74912399 10.1157706,8.80953919 10.0418527,8.80953919 Z' id='bars' fill='currentColor' %3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='11px' height='9px' viewBox='0 0 11 9' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Ebars%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M10.0418527,0.894571939 L0.309709821,0.894571939 C0.235791888,0.894571939 0.17578125,0.834156736 0.17578125,0.759740479 L0.17578125,0.220414636 C0.17578125,0.145998379 0.235791888,0.0855831754 0.309709821,0.0855831754 L10.0418527,0.0855831754 C10.1157706,0.0855831754 10.1757812,0.145998379 10.1757812,0.220414636 L10.1757812,0.759740479 C10.1757812,0.834156736 10.1157706,0.894571939 10.0418527,0.894571939 Z M10.0418527,4.8049452 L0.309709821,4.8049452 C0.235791888,4.8049452 0.17578125,4.74453 0.17578125,4.67011374 L0.17578125,4.1307879 C0.17578125,4.05637164 0.235791888,3.99595644 0.309709821,3.99595644 L10.0418527,3.99595644 C10.1157706,3.99595644 10.1757812,4.05637164 10.1757812,4.1307879 L10.1757812,4.67011374 C10.1757812,4.74453 10.1157706,4.8049452 10.0418527,4.8049452 Z M10.0418527,8.80953919 L0.309709821,8.80953919 C0.235791888,8.80953919 0.17578125,8.74912399 0.17578125,8.67470773 L0.17578125,8.13538189 C0.17578125,8.06096563 0.235791888,8.00055043 0.309709821,8.00055043 L10.0418527,8.00055043 C10.1157706,8.00055043 10.1757812,8.06096563 10.1757812,8.13538189 L10.1757812,8.67470773 C10.1757812,8.74912399 10.1157706,8.80953919 10.0418527,8.80953919 Z' id='bars' fill='currentColor' %3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  mask-size: 0.7rem 0.7rem;\n  -webkit-mask-size: 0.7rem 0.7rem;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-list-handle-sm .vf-list-handle-icon {\n  width: var(--vf-min-height-input-sm);\n  height: var(--vf-min-height-input-sm);\n}\n\n.vf-list-handle-lg .vf-list-handle-icon {\n  width: var(--vf-min-height-input-lg);\n  height: var(--vf-min-height-input-lg);\n}\n\n.vf-btn-list-add {\n  margin-top: var(--vf-gutter);\n}\n\n.vf-btn-list-add.vf-btn-list-add-sm {\n  margin-top: var(--vf-gutter-sm);\n}\n\n.vf-btn-list-add.vf-btn-list-add-lg {\n  margin-top: var(--vf-gutter-lg);\n}\n\n.sortable-ghost {\n  opacity: 0.6;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$y);
$741c336afc2dfa06$export$fe925c804ebb00b7.__file = "themes/vueform/templates/elements/ListElement.vue";
var $741c336afc2dfa06$var$script$14 = {
    name: 'LocationElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$q = [
    "name",
    "id",
    "placeholder",
    "disabled",
    "readonly",
    "aria-labelledby"
];
function $741c336afc2dfa06$var$render$v(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddon = (0, $ani5R.resolveComponent)("ElementAddon");
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputContainer)
                }, [
                    _ctx.hasAddonBefore ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 0,
                        type: "before"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-before", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-before']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasAddonAfter ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 1,
                        type: "after"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-after", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-after']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                        key: 2,
                        visible: !_ctx.empty
                    }, null, 8 /* PROPS */ , [
                        "visible"
                    ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        type: "search",
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        class: _ctx.classes.input,
                        placeholder: _ctx.Placeholder,
                        disabled: _ctx.isDisabled,
                        readonly: _ctx.isReadonly,
                        "aria-labelledby": _ctx.labelId,
                        autocomplete: "off"
                    }, _ctx.attrs, {
                        ref: "input",
                        onBlur: _cache[0] || (_cache[0] = (...args)=>_ctx.handleLocationBlur && _ctx.handleLocationBlur(...args))
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$q)
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$14.render = $741c336afc2dfa06$var$render$v;
$741c336afc2dfa06$var$script$14.__file = "themes/blank/templates/elements/LocationElement.vue";
var $741c336afc2dfa06$export$af6f82ac48d2952d = {
    name: 'LocationElement',
    render: $741c336afc2dfa06$var$script$14.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$x = "/* Google */\n\n.pac-container {\n  border-color: var(--vf-border-color-input);\n  background: var(--vf-bg-input);\n}\n\n.pac-item {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  border-color: var(--vf-border-color-input);\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  cursor: pointer;\n}\n\n.pac-item > span:last-of-type {\n  font-size: 0.75rem;\n  color: var(--vf-color-muted);\n}\n\n.pac-item:hover, .pac-item.pac-item-selected {\n  background: var(--vf-bg-selected);\n}\n\n.pac-item-query {\n  font-size: 0.875rem;\n  line-height: 1;\n  margin-right: 0.25rem;\n  padding-right: 0.25rem;\n  color: var(--vf-color-input);\n}\n\n.pac-icon-marker {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 384 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 384 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z'%3e%3c/path%3e%3c/svg%3e\");\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background: var(--vf-bg-icon);\n  width: 0.875rem;\n  width: 0.875rem;\n  margin-right: 0.75rem;\n  margin-top: 0;\n  padding-top: 1px;\n  padding-bottom: 1px;\n  box-sizing: content-box;\n  flex-shrink: 0;\n}\n\n.pac-logo:after {\n  margin-left: 0.625rem;\n  margin-right: 0.625rem;\n  margin-bottom: 0.625rem;\n}\n\n.pac-icon, .hdpi .pac-icon {\n  background-image: none;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$x);
$741c336afc2dfa06$export$af6f82ac48d2952d.__file = "themes/vueform/templates/elements/LocationElement.vue";
var $741c336afc2dfa06$var$script$12 = {
    name: 'MatrixElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$p = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_2$h = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_3$b = [
    "aria-roledescription",
    "id",
    "onClick",
    "onKeypress"
];
const $741c336afc2dfa06$var$_hoisted_4$8 = [
    "id",
    "innerHTML"
];
function $741c336afc2dfa06$var$render$u(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.grid),
                    style: (0, $X5A94.normalizeStyle)(_ctx.gridStyle),
                    ref: "grid"
                }, [
                    (0, $ani5R.createCommentVNode)(" Header row "),
                    (0, $ani5R.createCommentVNode)(" First empty column "),
                    _ctx.rowsVisible && _ctx.colsVisible ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.headerFirst)
                    }, null, 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createCommentVNode)(" Column headers "),
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedColumns, (col, c)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
                            _ctx.colsVisible ? (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 0,
                                innerHTML: col.label,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.header)
                            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$p)), [
                                [
                                    (0, $dDLnc.vShow),
                                    col.available
                                ]
                            ]) : (0, $ani5R.createCommentVNode)("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */ );
                    }), 256 /* UNKEYED_FRAGMENT */ )),
                    (0, $ani5R.createCommentVNode)(" Remove column "),
                    _ctx.allowRemove && _ctx.colsVisible ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 1,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.headerRemove)
                    }, null, 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createCommentVNode)(" Content rows "),
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedRows, (row, r)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, [
                            (0, $ani5R.createCommentVNode)(" Row label "),
                            _ctx.rowsVisible ? (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 0,
                                innerHTML: row.label,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.rowLabel)
                            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$h)), [
                                [
                                    (0, $dDLnc.vShow),
                                    row.available
                                ]
                            ]) : (0, $ani5R.createCommentVNode)("v-if", true),
                            (0, $ani5R.createCommentVNode)(" Input cells "),
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedColumns, (col, c)=>{
                                return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.cell)
                                }, [
                                    (0, $ani5R.createElementVNode)("div", {
                                        class: (0, $X5A94.normalizeClass)(_ctx.classes.cellWrapper(_ctx.resolveColType(col), _ctx.resolveComponentName(r, c)))
                                    }, [
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.resolveComponentType(col)), (0, $ani5R.mergeProps)({
                                            ref_for: true
                                        }, _ctx.cells[r][c], {
                                            key: _ctx.cells[r][c].name
                                        }), null, 16 /* FULL_PROPS */ ))
                                    ], 2 /* CLASS */ )
                                ], 2 /* CLASS */ )), [
                                    [
                                        (0, $dDLnc.vShow),
                                        row.available && col.available
                                    ]
                                ]);
                            }), 256 /* UNKEYED_FRAGMENT */ )),
                            (0, $ani5R.createCommentVNode)(" Remove column "),
                            _ctx.allowRemove ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 1,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.rowRemove)
                            }, [
                                (0, $ani5R.createElementVNode)("div", {
                                    "aria-roledescription": _ctx.form$.translations.vueform.a11y.list.remove,
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.remove),
                                    id: `${_ctx.path}-${r}-remove-button`,
                                    onClick: (0, $dDLnc.withModifiers)(($event)=>_ctx.handleRemove(r), [
                                        "prevent"
                                    ]),
                                    onKeypress: (0, $dDLnc.withKeys)(($event)=>_ctx.handleRemove(r), [
                                        "space",
                                        "enter"
                                    ]),
                                    role: "button",
                                    tabindex: "0"
                                }, [
                                    (0, $ani5R.createElementVNode)("span", {
                                        class: (0, $X5A94.normalizeClass)(_ctx.classes.removeIcon)
                                    }, null, 2 /* CLASS */ )
                                ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_3$b)
                            ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */ );
                    }), 256 /* UNKEYED_FRAGMENT */ ))
                ], 6 /* CLASS, STYLE */ ),
                (0, $ani5R.createCommentVNode)(" Add button "),
                _ctx.allowAdd ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.add),
                    id: `${_ctx.fieldId}-add-button`,
                    onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleAdd && _ctx.handleAdd(...args), [
                        "prevent"
                    ])),
                    onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.handleAdd && _ctx.handleAdd(...args), [
                        "enter",
                        "space"
                    ])),
                    innerHTML: _ctx.addLabel,
                    role: "button",
                    tabindex: "0"
                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_4$8)) : (0, $ani5R.createCommentVNode)("v-if", true)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$12.render = $741c336afc2dfa06$var$render$u;
$741c336afc2dfa06$var$script$12.__file = "themes/blank/templates/elements/MatrixElement.vue";
var $741c336afc2dfa06$export$75126afba5fd227f = {
    name: 'MatrixElement',
    render: $741c336afc2dfa06$var$script$12.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-matrix-container',
                grid: 'vf-matrix-grid',
                grid_scrollable: 'is-scrollable',
                headerFirst: 'vf-matrix-header-first',
                header: 'vf-matrix-header',
                header_padding: 'has-padding',
                header_sticky: 'is-sticky',
                header_not_sticky: 'is-not-sticky',
                header_wrap: 'is-wrap',
                header_nowrap: 'is-nowrap',
                header_sm: 'vf-matrix-header-sm',
                header_md: '',
                header_lg: 'vf-matrix-header-lg',
                headerRemove: 'vf-matrix-header-remove',
                rowLabel: 'vf-matrix-row-label',
                rowLabel_sticky: 'is-sticky',
                rowLabel_not_sticky: 'is-not-sticky',
                rowLabel_wrap: 'is-wrap',
                rowLabel_nowrap: 'is-nowrap',
                cell: 'vf-matrix-cell',
                cell_sm: 'vf-matrix-cell-sm',
                cell_md: '',
                cell_lg: 'vf-matrix-cell-lg',
                cellWrapper: 'vf-matrix-cell-wrapper',
                cellWrapper_padding: 'has-padding',
                cellWrapper_centered: 'is-centered',
                cellWrapper_error: 'has-error',
                cellWrapper_success: 'has-success',
                rowRemove: 'vf-matrix-row-remove',
                remove: 'vf-matrix-remove',
                removeIcon: 'vf-matrix-remove-icon',
                add: 'vf-btn vf-btn-primary vf-btn-small vf-matrix-add',
                add_sm: 'vf-btn-small-sm vf-matrix-add-sm',
                add_md: '',
                add_lg: 'vf-btn-small-lg vf-matrix-add-lg',
                $grid: (classes, { scrollable: scrollable })=>[
                        classes.grid,
                        scrollable ? classes.grid_scrollable : null
                    ],
                $header: (classes, { Size: Size, padding: padding, stickyCols: stickyCols, colWrap: colWrap })=>[
                        classes.header,
                        classes[`header_${Size}`],
                        padding ? classes.header_padding : null,
                        stickyCols ? classes.header_sticky : null,
                        colWrap ? classes.header_wrap : classes.header_nowrap
                    ],
                $rowLabel: (classes, { stickyRows: stickyRows, rowWrap: rowWrap })=>[
                        classes.rowLabel,
                        stickyRows ? classes.rowLabel_sticky : null,
                        rowWrap ? classes.rowLabel_wrap : classes.rowLabel_nowrap
                    ],
                $cell: (classes, { Size: Size })=>[
                        classes.cell,
                        classes[`cell_${Size}`]
                    ],
                $cellWrapper: (classes, { padding: padding, centered: centered, cells$: cells$ })=>(type, name)=>[
                            classes.cellWrapper,
                            padding ? classes.cellWrapper_padding : null,
                            [
                                'radio',
                                'checkbox',
                                'toggle'
                            ].includes(type) ? classes.cellWrapper_centered : null,
                            cells$[name]?.error ? classes.cellWrapper_error : null,
                            cells$[name]?.isSuccess ? classes.cellWrapper_success : null
                        ],
                $add: (classes, { Size: Size })=>[
                        classes.add,
                        classes[`add_${Size}`]
                    ],
                $remove: (classes, { removeHover: removeHover })=>[
                        classes.remove,
                        removeHover ? classes.remove_hover : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$w = "/* Some styles are contained in _table.scss */\n\n.vf-matrix-grid {\n  display: grid;\n}\n\n.vf-matrix-grid.is-scrollable {\n  overflow: auto;\n}\n\n.vf-matrix-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: var(--vf-min-height-input);\n}\n\n.vf-matrix-header.has-padding {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.vf-matrix-header.is-sticky {\n  position: sticky;\n  top: 0;\n  -webkit-backdrop-filter: blur(64px);\n          backdrop-filter: blur(64px);\n  z-index: 1;\n}\n\n.vf-matrix-header.is-nowrap {\n  white-space: nowrap;\n}\n\n.vf-matrix-header.vf-matrix-header-sm {\n  min-height: var(--vf-min-height-input-sm);\n}\n\n.vf-matrix-header.vf-matrix-header-lg {\n  min-height: var(--vf-min-height-input-lg);\n}\n\n.vf-matrix-row-label {\n  display: flex;\n  align-items: center;\n  padding-right: 0.5rem;\n}\n\n.vf-matrix-row-label.is-sticky {\n  position: sticky;\n  left: 0;\n  -webkit-backdrop-filter: blur(64px);\n          backdrop-filter: blur(64px);\n  z-index: 1;\n}\n\n.vf-matrix-row-label.is-nowrap {\n  white-space: nowrap;\n}\n\n.vf-matrix-cell {\n  display: grid;\n  align-items: center;\n  min-height: var(--vf-min-height-input);\n}\n\n.vf-matrix-cell.vf-matrix-cell-sm {\n  min-height: var(--vf-min-height-input-sm);\n}\n\n.vf-matrix-cell.vf-matrix-cell-lg {\n  min-height: var(--vf-min-height-input-lg);\n}\n\n.vf-matrix-cell-wrapper {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  align-items: center;\n}\n\n.vf-matrix-cell-wrapper.has-padding {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.vf-matrix-cell-wrapper.is-centered {\n  justify-content: center;\n}\n\n.vf-matrix-row-remove {\n  position: sticky;\n  right: 0;\n  -webkit-backdrop-filter: blur(64px);\n          backdrop-filter: blur(64px);\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n}\n\n.vf-matrix-remove {\n  width: 1rem;\n  height: 1rem;\n  padding: 0.125rem;\n  box-sizing: content-box;\n  background-color: var(--vf-bg-passive);\n  border-radius: 999px;\n  transition: 0.15s;\n}\n\n.vf-matrix-remove:hover {\n  filter: brightness(0.9);\n}\n\n.vf-matrix-remove-icon {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-matrix-add {\n  margin-top: var(--vf-gutter);\n}\n\n.vf-matrix-add.vf-matrix-add-sm {\n  margin-top: var(--vf-gutter-sm);\n}\n\n.vf-matrix-add.vf-matrix-add-lg {\n  margin-top: var(--vf-gutter-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$w);
$741c336afc2dfa06$export$75126afba5fd227f.__file = "themes/vueform/templates/elements/MatrixElement.vue";
var $741c336afc2dfa06$var$script$10 = {
    name: 'MultifileElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                list: '',
                listItem: '',
                handle: '',
                handleIcon: '',
                dnd: '',
                button: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$o = [
    "aria-labelledby",
    "aria-placeholder"
];
const $741c336afc2dfa06$var$_hoisted_2$g = [
    "id",
    "accept",
    "disabled"
];
function $741c336afc2dfa06$var$render$t(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DragAndDrop = (0, $ani5R.resolveComponent)("DragAndDrop");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        multiple: true,
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createCommentVNode)(" Drag n drop "),
                _ctx.drop && _ctx.canDrop && _ctx.hasAdd ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_DragAndDrop, {
                    key: 0,
                    title: _ctx.form$.translations.vueform.elements[_ctx.type].dndTitle,
                    description: _ctx.form$.translations.vueform.elements[_ctx.type].dndDescription,
                    disabled: _ctx.isDisabled,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.dnd),
                    onClick: _ctx.handleClick,
                    onDrop: _ctx.handleDrop
                }, null, 8 /* PROPS */ , [
                    "title",
                    "description",
                    "disabled",
                    "class",
                    "onClick",
                    "onDrop"
                ])) : _ctx.hasAdd ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 1
                }, [
                    (0, $ani5R.createCommentVNode)(" Upload button "),
                    (0, $ani5R.createElementVNode)("div", (0, $ani5R.mergeProps)(_ctx.aria, {
                        class: _ctx.classes.button,
                        "aria-labelledby": _ctx.labelId,
                        "aria-placeholder": _ctx.form$.translations.vueform.elements.multifile.uploadButton,
                        onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                            "prevent"
                        ])),
                        onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
                            "enter",
                            "space"
                        ])),
                        role: "button",
                        tabindex: "0"
                    }), (0, $X5A94.toDisplayString)(_ctx.form$.translations.vueform.elements.multifile.uploadButton), 17 /* TEXT, FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$o)
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Actual input field "),
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                    multiple: "",
                    id: _ctx.fieldId,
                    type: "file",
                    onChange: _cache[2] || (_cache[2] = (...args)=>_ctx.handleChange && _ctx.handleChange(...args)),
                    accept: _ctx.accept,
                    disabled: _ctx.isDisabled,
                    ref: "input"
                }, null, 40 /* PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_2$g), [
                    [
                        (0, $dDLnc.vShow),
                        false
                    ]
                ]),
                (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.list),
                    key: `${_ctx.fieldId}-${_ctx.length}`,
                    ref: "list"
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.value, (val, i)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                            key: i,
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.listItem)
                        }, [
                            _ctx.prototype.type ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.component(_ctx.prototype)), (0, $ani5R.mergeProps)({
                                key: 0,
                                ref_for: true
                            }, _ctx.prototype, {
                                disabled: !_ctx.hasRemove,
                                embed: true,
                                name: i,
                                onRemove: ($event)=>_ctx.remove(i)
                            }), null, 16 /* FULL_PROPS */ , [
                                "disabled",
                                "name",
                                "onRemove"
                            ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                            (0, $ani5R.createCommentVNode)(" Sort handle "),
                            _ctx.hasSort ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                key: 1,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.handle),
                                "data-handle": ""
                            }, [
                                (0, $ani5R.createElementVNode)("span", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.handleIcon)
                                }, null, 2 /* CLASS */ )
                            ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                        ], 2 /* CLASS */ );
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 2 /* CLASS */ )), [
                    [
                        (0, $dDLnc.vShow),
                        !_ctx.empty
                    ]
                ])
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$10.render = $741c336afc2dfa06$var$render$t;
$741c336afc2dfa06$var$script$10.__file = "themes/blank/templates/elements/MultifileElement.vue";
var $741c336afc2dfa06$export$b8306f5161ddcf9b = {
    name: 'MultifileElement',
    render: $741c336afc2dfa06$var$script$10.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                list: 'vf-multifile-list',
                list_sm: 'vf-multifile-list-sm',
                list_md: '',
                list_lg: 'vf-multifile-list-lg',
                list_file: 'vf-multifile-list-file',
                list_file_sm: '',
                list_file_md: '',
                list_file_lg: '',
                list_image: 'vf-multifile-list-image',
                list_image_sm: 'vf-multifile-list-image-sm',
                list_image_md: '',
                list_image_lg: 'vf-multifile-list-image-lg',
                list_gallery: 'vf-multifile-list-gallery',
                list_gallery_sm: 'vf-multifile-list-gallery-sm',
                list_gallery_md: '',
                list_gallery_lg: 'vf-multifile-list-gallery-lg',
                list_disabled: 'vf-multifile-list-disabled',
                list_sorting: 'vf-multifile-list-sorting',
                listItem: '',
                handle: '',
                handle_file: 'vf-multifile-handle-file',
                handle_file_sm: 'vf-multifile-handle-file-sm',
                handle_file_md: '',
                handle_file_lg: 'vf-multifile-handle-file-lg',
                handle_image: 'vf-multifile-handle-image',
                handle_image_sm: 'vf-multifile-handle-image-sm',
                handle_image_md: '',
                handle_image_lg: 'vf-multifile-handle-image-lg',
                handle_gallery: 'vf-multifile-handle-gallery',
                handle_gallery_sm: '',
                handle_gallery_md: '',
                handle_gallery_lg: '',
                handleIcon: '',
                handleIcon_file: 'vf-multifile-handle-icon-file',
                handleIcon_image: 'vf-multifile-handle-icon-image',
                handleIcon_gallery: 'vf-multifile-handle-icon-gallery',
                dnd: '',
                button: 'vf-btn vf-btn-secondary',
                button_enabled: '',
                button_disabled: 'vf-btn-disabled',
                button_sm: 'vf-btn-sm',
                button_md: '',
                button_lg: 'vf-btn-lg',
                $list: (classes, { isDisabled: isDisabled, sorting: sorting, view: view, Size: Size })=>[
                        classes.list,
                        classes[`list_${Size}`],
                        isDisabled ? classes.list_disabled : null,
                        sorting ? classes.list_sorting : null,
                        classes[`list_${view}`],
                        classes[`list_${view}_${Size}`]
                    ],
                $handle: (classes, { view: view, Size: Size })=>[
                        classes.handle,
                        classes[`handle_${view}`],
                        classes[`handle_${view}_${Size}`]
                    ],
                $handleIcon: (classes, { view: view })=>[
                        classes.handleIcon,
                        classes[`handleIcon_${view}`]
                    ],
                $button: (classes, { isDisabled: isDisabled, preparing: preparing, Size: Size })=>[
                        classes.button,
                        classes[`button_${Size}`],
                        !isDisabled && !preparing ? classes.button_enabled : null,
                        isDisabled || preparing ? classes.button_disabled : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$v = "/* Some styles are contained in Vueform.vue */\n\n.vf-multifile-list {\n  margin-top: var(--vf-gutter);\n}\n\n.vf-multifile-list.vf-multifile-list-sm {\n  margin-top: var(--vf-gutter-sm);\n}\n\n.vf-multifile-list.vf-multifile-list-lg {\n  margin-top: var(--vf-gutter-lg);\n}\n\n.vf-multifile-list-file,\n.vf-multifile-list-image {\n  display: grid;\n}\n\n.vf-multifile-list-file > .vf-row,\n.vf-multifile-list-image > .vf-row {\n  position: relative;\n}\n\n.vf-multifile-list-file > .vf-row:hover .vf-multifile-handle-file,\n.vf-multifile-list-file > .vf-row:hover .vf-multifile-handle-image,\n.vf-multifile-list-image > .vf-row:hover .vf-multifile-handle-file,\n.vf-multifile-list-image > .vf-row:hover .vf-multifile-handle-image {\n  visibility: visible;\n  opacity: 1;\n}\n\n.vf-multifile-list-file.vf-multifile-list-sorting > div:hover .vf-multifile-handle-file,\n.vf-multifile-list-file.vf-multifile-list-sorting > div:hover .vf-multifile-handle-image,\n.vf-multifile-list-image.vf-multifile-list-sorting > div:hover .vf-multifile-handle-file,\n.vf-multifile-list-image.vf-multifile-list-sorting > div:hover .vf-multifile-handle-image {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.vf-multifile-list-file {\n  row-gap: calc(var(--vf-gutter) / 2);\n}\n\n.vf-multifile-list-file.vf-multifile-list-file-sm {\n  row-gap: calc(var(--vf-gutter-sm) / 2);\n}\n\n.vf-multifile-list-file.vf-multifile-list-file-lg {\n  row-gap: calc(var(--vf-gutter-lg) / 2);\n}\n\n.vf-multifile-list-image {\n  row-gap: calc(var(--vf-gutter) / 2);\n}\n\n.vf-multifile-list-image.vf-multifile-list-image-sm {\n  row-gap: calc(var(--vf-gutter-sm) / 2);\n}\n\n.vf-multifile-list-image.vf-multifile-list-image-lg {\n  row-gap: calc(var(--vf-gutter-lg) / 2);\n}\n\n.vf-multifile-list-gallery {\n  display: flex;\n  flex-wrap: wrap;\n  gap: calc(var(--vf-gutter) / 2);\n}\n\n.vf-multifile-list-gallery.vf-multifile-list-sorting > div:hover .vf-multifile-handle-gallery {\n  visibility: hidden;\n  opacity: 0;\n}\n\n.vf-multifile-list-gallery > div {\n  position: relative;\n}\n\n.vf-multifile-list-gallery > div:hover .vf-multifile-handle-gallery {\n  visibility: visible;\n  opacity: 1;\n}\n\n.vf-multifile-handle-file,\n.vf-multifile-handle-image {\n  position: absolute;\n  left: var(--vf-gutter);\n  transform: translateX(-100%);\n  top: 0;\n  cursor: grab;\n  visibility: hidden;\n  opacity: 0;\n  transition: 0.3s;\n}\n\n.vf-multifile-handle-file:active,\n.vf-multifile-handle-image:active {\n  cursor: grabbing;\n}\n\n.vf-multifile-handle-icon-file,\n.vf-multifile-handle-icon-image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: var(--vf-min-height-input);\n  height: var(--vf-min-height-input);\n  mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='11px' height='9px' viewBox='0 0 11 9' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Ebars%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M10.0418527,0.894571939 L0.309709821,0.894571939 C0.235791888,0.894571939 0.17578125,0.834156736 0.17578125,0.759740479 L0.17578125,0.220414636 C0.17578125,0.145998379 0.235791888,0.0855831754 0.309709821,0.0855831754 L10.0418527,0.0855831754 C10.1157706,0.0855831754 10.1757812,0.145998379 10.1757812,0.220414636 L10.1757812,0.759740479 C10.1757812,0.834156736 10.1157706,0.894571939 10.0418527,0.894571939 Z M10.0418527,4.8049452 L0.309709821,4.8049452 C0.235791888,4.8049452 0.17578125,4.74453 0.17578125,4.67011374 L0.17578125,4.1307879 C0.17578125,4.05637164 0.235791888,3.99595644 0.309709821,3.99595644 L10.0418527,3.99595644 C10.1157706,3.99595644 10.1757812,4.05637164 10.1757812,4.1307879 L10.1757812,4.67011374 C10.1757812,4.74453 10.1157706,4.8049452 10.0418527,4.8049452 Z M10.0418527,8.80953919 L0.309709821,8.80953919 C0.235791888,8.80953919 0.17578125,8.74912399 0.17578125,8.67470773 L0.17578125,8.13538189 C0.17578125,8.06096563 0.235791888,8.00055043 0.309709821,8.00055043 L10.0418527,8.00055043 C10.1157706,8.00055043 10.1757812,8.06096563 10.1757812,8.13538189 L10.1757812,8.67470773 C10.1757812,8.74912399 10.1157706,8.80953919 10.0418527,8.80953919 Z' id='bars' fill='currentColor' %3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='11px' height='9px' viewBox='0 0 11 9' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Ebars%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M10.0418527,0.894571939 L0.309709821,0.894571939 C0.235791888,0.894571939 0.17578125,0.834156736 0.17578125,0.759740479 L0.17578125,0.220414636 C0.17578125,0.145998379 0.235791888,0.0855831754 0.309709821,0.0855831754 L10.0418527,0.0855831754 C10.1157706,0.0855831754 10.1757812,0.145998379 10.1757812,0.220414636 L10.1757812,0.759740479 C10.1757812,0.834156736 10.1157706,0.894571939 10.0418527,0.894571939 Z M10.0418527,4.8049452 L0.309709821,4.8049452 C0.235791888,4.8049452 0.17578125,4.74453 0.17578125,4.67011374 L0.17578125,4.1307879 C0.17578125,4.05637164 0.235791888,3.99595644 0.309709821,3.99595644 L10.0418527,3.99595644 C10.1157706,3.99595644 10.1757812,4.05637164 10.1757812,4.1307879 L10.1757812,4.67011374 C10.1757812,4.74453 10.1157706,4.8049452 10.0418527,4.8049452 Z M10.0418527,8.80953919 L0.309709821,8.80953919 C0.235791888,8.80953919 0.17578125,8.74912399 0.17578125,8.67470773 L0.17578125,8.13538189 C0.17578125,8.06096563 0.235791888,8.00055043 0.309709821,8.00055043 L10.0418527,8.00055043 C10.1157706,8.00055043 10.1757812,8.06096563 10.1757812,8.13538189 L10.1757812,8.67470773 C10.1757812,8.74912399 10.1157706,8.80953919 10.0418527,8.80953919 Z' id='bars' fill='currentColor' %3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  mask-size: 0.7rem 0.7rem;\n  -webkit-mask-size: 0.7rem 0.7rem;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  background-color: currentColor;\n}\n\n.vf-multifile-handle-file.vf-multifile-handle-file-sm .vf-multifile-handle-icon-file {\n  width: var(--vf-min-height-input-sm);\n  height: var(--vf-min-height-input-sm);\n}\n\n.vf-multifile-handle-file.vf-multifile-handle-file-lg .vf-multifile-handle-icon-file {\n  width: var(--vf-min-height-input-lg);\n  height: var(--vf-min-height-input-lg);\n}\n\n.vf-multifile-handle-image.vf-multifile-handle-image-sm .vf-multifile-handle-icon-image {\n  width: var(--vf-min-height-input-sm);\n  height: var(--vf-min-height-input-sm);\n}\n\n.vf-multifile-handle-image.vf-multifile-handle-image-lg .vf-multifile-handle-icon-image {\n  width: var(--vf-min-height-input-lg);\n  height: var(--vf-min-height-input-lg);\n}\n\n.vf-multifile-handle-gallery {\n  position: absolute;\n  cursor: grab;\n  visibility: hidden;\n  opacity: 0;\n  transition: 0.3s;\n  border-radius: 999px;\n  left: 0.1875rem;\n  top: 0.1875rem;\n  transform: none;\n  background: var(--vf-gray-200);\n}\n\n.vf-multifile-handle-gallery:active {\n  cursor: grabbing;\n}\n\n.vf-multifile-handle-gallery:hover {\n  background-color: var(--vf-gray-300);\n}\n\n.vf-multifile-handle-icon-gallery {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-repeat: no-repeat;\n  background-position: center center;\n  width: 1rem;\n  height: 1rem;\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='12px' height='13px' viewBox='0 0 12 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='%236B7280' fill-rule='evenodd'%3E%3Cpath d='M7.93929644,10.4886534 L6.22140503,12.2179202 C6.11156489,12.3277374 5.93349525,12.3277374 5.82363223,12.2179202 L4.10576371,10.4886534 C3.99594646,10.3788132 3.99594646,10.2007436 4.10576371,10.0909263 L4.27147376,9.92521629 C4.381291,9.81537616 4.55938354,9.81537616 4.66922367,9.92521629 L5.62409352,10.89137 L5.64753097,10.89137 L5.64753097,6.67528507 L1.43144605,6.67528507 L1.43144605,6.69872252 L2.39762264,7.65359237 C2.50746277,7.76340962 2.50746277,7.94150215 2.39762264,8.05134228 L2.2318897,8.21705233 C2.12207245,8.32686958 1.94400281,8.32686958 1.83416268,8.21705233 L0.104918753,6.49916092 C-0.0048984896,6.38932079 -0.0048984896,6.21125115 0.104918753,6.10138813 L1.83418557,4.38349671 C1.9440257,4.27367947 2.12209534,4.27367947 2.23193547,4.38349671 L2.39766841,4.54922966 C2.50750855,4.6590469 2.50750855,4.83713943 2.39766841,4.94697956 L1.43144605,5.90184942 L1.43144605,5.92528686 L5.64753097,5.92528686 L5.64753097,1.70920194 L5.62409352,1.70920194 L4.66922367,2.67537853 C4.55940642,2.78521867 4.38131389,2.78521867 4.27147376,2.67537853 L4.10576371,2.50964559 C3.99594646,2.39982835 3.99592358,2.2217587 4.10576371,2.11191857 L5.82365512,0.382651762 C5.93349525,0.272834518 6.11156489,0.272834518 6.22142791,0.382651762 L7.93931933,2.11191857 C8.04913657,2.2217587 8.04913657,2.39982835 7.93931933,2.50966848 L7.77358638,2.67540142 C7.66376914,2.78524155 7.48567661,2.78524155 7.37583648,2.67540142 L6.42096662,1.70920194 L6.39752918,1.70920194 L6.39752918,5.92528686 L10.6136141,5.92528686 L10.6136141,5.90184942 L9.64743751,4.94697956 C9.53759737,4.83716232 9.53759737,4.65906979 9.64743751,4.54922966 L9.81317045,4.3835196 C9.92298769,4.27370236 10.1010573,4.27370236 10.2108975,4.3835196 L11.9401643,6.10141102 C12.0500044,6.21125115 12.0499815,6.38932079 11.9401643,6.49918381 L10.2108975,8.21707522 C10.1010573,8.32689246 9.92298769,8.32689246 9.81317045,8.21707522 L9.64743751,8.05136517 C9.53759737,7.94154792 9.53759737,7.76345539 9.64743751,7.65361526 L10.6136141,6.69872252 L10.6136141,6.67528507 L6.39752918,6.67528507 L6.39752918,10.89137 L6.42096662,10.89137 L7.37583648,9.9251934 C7.48565372,9.81535327 7.66374625,9.81535327 7.77358638,9.9251934 L7.93929644,10.0909263 C8.04911368,10.2007207 8.04911368,10.3787903 7.93929644,10.4886534 Z' id='arrows' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='12px' height='13px' viewBox='0 0 12 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='%236B7280' fill-rule='evenodd'%3E%3Cpath d='M7.93929644,10.4886534 L6.22140503,12.2179202 C6.11156489,12.3277374 5.93349525,12.3277374 5.82363223,12.2179202 L4.10576371,10.4886534 C3.99594646,10.3788132 3.99594646,10.2007436 4.10576371,10.0909263 L4.27147376,9.92521629 C4.381291,9.81537616 4.55938354,9.81537616 4.66922367,9.92521629 L5.62409352,10.89137 L5.64753097,10.89137 L5.64753097,6.67528507 L1.43144605,6.67528507 L1.43144605,6.69872252 L2.39762264,7.65359237 C2.50746277,7.76340962 2.50746277,7.94150215 2.39762264,8.05134228 L2.2318897,8.21705233 C2.12207245,8.32686958 1.94400281,8.32686958 1.83416268,8.21705233 L0.104918753,6.49916092 C-0.0048984896,6.38932079 -0.0048984896,6.21125115 0.104918753,6.10138813 L1.83418557,4.38349671 C1.9440257,4.27367947 2.12209534,4.27367947 2.23193547,4.38349671 L2.39766841,4.54922966 C2.50750855,4.6590469 2.50750855,4.83713943 2.39766841,4.94697956 L1.43144605,5.90184942 L1.43144605,5.92528686 L5.64753097,5.92528686 L5.64753097,1.70920194 L5.62409352,1.70920194 L4.66922367,2.67537853 C4.55940642,2.78521867 4.38131389,2.78521867 4.27147376,2.67537853 L4.10576371,2.50964559 C3.99594646,2.39982835 3.99592358,2.2217587 4.10576371,2.11191857 L5.82365512,0.382651762 C5.93349525,0.272834518 6.11156489,0.272834518 6.22142791,0.382651762 L7.93931933,2.11191857 C8.04913657,2.2217587 8.04913657,2.39982835 7.93931933,2.50966848 L7.77358638,2.67540142 C7.66376914,2.78524155 7.48567661,2.78524155 7.37583648,2.67540142 L6.42096662,1.70920194 L6.39752918,1.70920194 L6.39752918,5.92528686 L10.6136141,5.92528686 L10.6136141,5.90184942 L9.64743751,4.94697956 C9.53759737,4.83716232 9.53759737,4.65906979 9.64743751,4.54922966 L9.81317045,4.3835196 C9.92298769,4.27370236 10.1010573,4.27370236 10.2108975,4.3835196 L11.9401643,6.10141102 C12.0500044,6.21125115 12.0499815,6.38932079 11.9401643,6.49918381 L10.2108975,8.21707522 C10.1010573,8.32689246 9.92298769,8.32689246 9.81317045,8.21707522 L9.64743751,8.05136517 C9.53759737,7.94154792 9.53759737,7.76345539 9.64743751,7.65361526 L10.6136141,6.69872252 L10.6136141,6.67528507 L6.39752918,6.67528507 L6.39752918,10.89137 L6.42096662,10.89137 L7.37583648,9.9251934 C7.48565372,9.81535327 7.66374625,9.81535327 7.77358638,9.9251934 L7.93929644,10.0909263 C8.04911368,10.2007207 8.04911368,10.3787903 7.93929644,10.4886534 Z' id='arrows' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  background-color: var(--vf-gray-600);\n}\n\n.sortable-ghost {\n  opacity: 0.6;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$v);
$741c336afc2dfa06$export$b8306f5161ddcf9b.__file = "themes/vueform/templates/elements/MultifileElement.vue";
function $741c336afc2dfa06$var$isNullish$1(val) {
    return val === null || val === undefined;
}
function $741c336afc2dfa06$var$useData(props, context, dep) {
    const { object: object, valueProp: valueProp, mode: mode } = (0, $8bTPG.toRefs)(props);
    const $this = (0, $ani5R.getCurrentInstance)().proxy;
    // ============ DEPENDENCIES ============
    const iv = dep.iv;
    // =============== METHODS ==============
    const update = (val, triggerInput = true)=>{
        // Setting object(s) as internal value
        iv.value = makeInternal(val);
        // Setting object(s) or plain value as external 
        // value based on `option` setting
        const externalVal = makeExternal(val);
        context.emit('change', externalVal, $this);
        if (triggerInput) {
            context.emit('input', externalVal);
            context.emit('update:modelValue', externalVal);
        }
    };
    // no export
    const makeExternal = (val)=>{
        // If external value should be object
        // no transformation is required
        if (object.value) return val;
        // No need to transform if empty value
        if ($741c336afc2dfa06$var$isNullish$1(val)) return val;
        // If external should be plain transform
        // value object to plain values
        return !Array.isArray(val) ? val[valueProp.value] : val.map((v)=>v[valueProp.value]);
    };
    // no export
    const makeInternal = (val)=>{
        if ($741c336afc2dfa06$var$isNullish$1(val)) return mode.value === 'single' ? {} : [];
        return val;
    };
    return {
        update: update
    };
}
// Polyfill for Vue <3.3 for getters only
// https://vuejs.org/api/reactivity-utilities.html#toref
function $741c336afc2dfa06$var$toRef(get) {
    return (0, $8bTPG.customRef)(()=>({
            get: get,
            set: /* istanbul ignore next */ ()=>{}
        }));
}
function $741c336afc2dfa06$var$useValue$3(props, context) {
    const { value: value, modelValue: modelValue, mode: mode, valueProp: valueProp } = (0, $8bTPG.toRefs)(props);
    // ================ DATA ================
    // internalValue
    const iv = (0, $8bTPG.ref)(mode.value !== 'single' ? [] : {});
    // ============== COMPUTED ==============
    /* istanbul ignore next */ // externalValue
    const ev = $741c336afc2dfa06$var$toRef(()=>{
        return modelValue.value !== undefined ? modelValue.value : value.value;
    });
    const plainValue = (0, $8bTPG.computed)(()=>{
        return mode.value === 'single' ? iv.value[valueProp.value] : iv.value.map((v)=>v[valueProp.value]);
    });
    const textValue = $741c336afc2dfa06$var$toRef(()=>{
        return mode.value !== 'single' ? iv.value.map((v)=>v[valueProp.value]).join(',') : iv.value[valueProp.value];
    });
    return {
        iv: iv,
        internalValue: iv,
        ev: ev,
        externalValue: ev,
        textValue: textValue,
        plainValue: plainValue
    };
}
function $741c336afc2dfa06$var$useSearch(props, context, dep) {
    const { regex: regex } = (0, $8bTPG.toRefs)(props);
    const $this = (0, $ani5R.getCurrentInstance)().proxy;
    // ============ DEPENDENCIES ============
    const isOpen = dep.isOpen;
    const open = dep.open;
    // ================ DATA ================
    const search = (0, $8bTPG.ref)(null);
    // =============== METHODS ==============
    const clearSearch = ()=>{
        search.value = '';
    };
    const handleSearchInput = (e)=>{
        search.value = e.target.value;
    };
    const handleKeypress = (e)=>{
        if (regex.value) {
            let regexp = regex.value;
            if (typeof regexp === 'string') regexp = new RegExp(regexp);
            if (!e.key.match(regexp)) e.preventDefault();
        }
    };
    const handlePaste = (e)=>{
        if (regex.value) {
            let clipboardData = e.clipboardData || /* istanbul ignore next */ window.clipboardData;
            let pastedData = clipboardData.getData('Text');
            let regexp = regex.value;
            if (typeof regexp === 'string') regexp = new RegExp(regexp);
            if (!pastedData.split('').every((c)=>!!c.match(regexp))) e.preventDefault();
        }
        context.emit('paste', e, $this);
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(search, (val)=>{
        if (!isOpen.value && val) open();
        context.emit('search-change', val, $this);
    });
    return {
        search: search,
        clearSearch: clearSearch,
        handleSearchInput: handleSearchInput,
        handleKeypress: handleKeypress,
        handlePaste: handlePaste
    };
}
function $741c336afc2dfa06$var$usePointer$1(props, context, dep) {
    const { groupSelect: groupSelect, mode: mode, groups: groups, disabledProp: disabledProp } = (0, $8bTPG.toRefs)(props);
    // ================ DATA ================
    const pointer = (0, $8bTPG.ref)(null);
    // =============== METHODS ==============
    const setPointer = (option)=>{
        if (option === undefined || option !== null && option[disabledProp.value]) return;
        if (groups.value && option && option.group && (mode.value === 'single' || !groupSelect.value)) return;
        pointer.value = option;
    };
    const clearPointer = ()=>{
        setPointer(null);
    };
    return {
        pointer: pointer,
        setPointer: setPointer,
        clearPointer: clearPointer
    };
}
function $741c336afc2dfa06$var$normalize(str, strict = true) {
    return strict ? String(str).toLowerCase().trim() : String(str).toLowerCase().normalize('NFD').trim().replace(/æ/g, 'ae').replace(/œ/g, 'oe').replace(/ø/g, 'o').replace(/\p{Diacritic}/gu, '');
}
function $741c336afc2dfa06$var$isObject(variable) {
    return Object.prototype.toString.call(variable) === '[object Object]';
}
function $741c336afc2dfa06$var$arraysEqual$1(array1, array2) {
    if (array1.length !== array2.length) return false;
    const array2Sorted = array2.slice().sort();
    return array1.slice().sort().every(function(value, index) {
        return value === array2Sorted[index];
    });
}
/* istanbul ignore next */ const $741c336afc2dfa06$var$objectsEqual = (obj1, obj2)=>{
    // If both are strictly equal, return true
    if (obj1 === obj2) return true;
    // If either is not an object or is null, return false (handles primitive types and null)
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
    // Get the keys of both objects
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    // If they have a different number of keys, they're not equal
    if (keys1.length !== keys2.length) return false;
    // Compare each key-value pair recursively
    for (let key of keys1){
        // Check if both objects have the same key
        if (!keys2.includes(key)) return false;
        // Recursively compare the values
        if (!$741c336afc2dfa06$var$objectsEqual(obj1[key], obj2[key])) return false;
    }
    return true;
};
var $741c336afc2dfa06$var$objectsEqual$1 = $741c336afc2dfa06$var$objectsEqual;
function $741c336afc2dfa06$var$useOptions(props, context, dep) {
    const { options: options, mode: mode, trackBy: trackBy_, limit: limit, hideSelected: hideSelected, createTag: createTag, createOption: createOption_, label: label, appendNewTag: appendNewTag, appendNewOption: appendNewOption_, multipleLabel: multipleLabel, object: object, loading: loading, delay: delay, resolveOnLoad: resolveOnLoad, minChars: minChars, filterResults: filterResults, clearOnSearch: clearOnSearch, clearOnSelect: clearOnSelect, valueProp: valueProp, allowAbsent: allowAbsent, groupLabel: groupLabel, canDeselect: canDeselect, max: max, strict: strict, closeOnSelect: closeOnSelect, closeOnDeselect: closeOnDeselect, groups: groupped, reverse: reverse, infinite: infinite, groupOptions: groupOptions, groupHideEmpty: groupHideEmpty, groupSelect: groupSelect, onCreate: onCreate, disabledProp: disabledProp, searchStart: searchStart, searchFilter: searchFilter } = (0, $8bTPG.toRefs)(props);
    const $this = (0, $ani5R.getCurrentInstance)().proxy;
    // ============ DEPENDENCIES ============
    const iv = dep.iv;
    const ev = dep.ev;
    const search = dep.search;
    const clearSearch = dep.clearSearch;
    const update = dep.update;
    const pointer = dep.pointer;
    const setPointer = dep.setPointer;
    const clearPointer = dep.clearPointer;
    const focus = dep.focus;
    const deactivate = dep.deactivate;
    const close = dep.close;
    const localize = dep.localize;
    // ================ DATA ================
    // no export
    // appendedOptions
    const ap = (0, $8bTPG.ref)([]);
    // no export
    // resolvedOptions
    const ro = (0, $8bTPG.ref)([]);
    const resolving = (0, $8bTPG.ref)(false);
    // no export
    const searchWatcher = (0, $8bTPG.ref)(null);
    const offset = (0, $8bTPG.ref)(infinite.value && limit.value === -1 ? 10 : limit.value);
    // ============== COMPUTED ==============
    const resolvedOptions = (0, $8bTPG.computed)({
        get: ()=>ro.value,
        set: (v)=>ro.value = v
    });
    // no export
    const createOption = $741c336afc2dfa06$var$toRef(()=>{
        return createTag.value || createOption_.value || false;
    });
    // no export
    const appendNewOption = $741c336afc2dfa06$var$toRef(()=>{
        if (appendNewTag.value !== undefined) return appendNewTag.value;
        else if (appendNewOption_.value !== undefined) return appendNewOption_.value;
        return true;
    });
    // no export
    // extendedOptions
    const eo = (0, $8bTPG.computed)(()=>{
        if (groupped.value) {
            let groups = eg.value || /* istanbul ignore next */ [];
            let eo = [];
            groups.forEach((group)=>{
                optionsToArray(group[groupOptions.value]).forEach((option)=>{
                    eo.push(Object.assign({}, option, group[disabledProp.value] ? {
                        [disabledProp.value]: true
                    } : {}));
                });
            });
            return eo;
        } else {
            let eo = optionsToArray(ro.value || /* istanbul ignore next */ []);
            if (ap.value.length) eo = eo.concat(ap.value);
            return eo;
        }
    });
    // preFilteredOptions
    const pfo = (0, $8bTPG.computed)(()=>{
        let options = eo.value;
        if (reverse.value) options = options.reverse();
        if (createdOption.value.length) options = createdOption.value.concat(options);
        return filterOptions(options);
    });
    // filteredOptions
    const fo = (0, $8bTPG.computed)(()=>{
        let options = pfo.value;
        if (offset.value > 0) options = options.slice(0, offset.value);
        return options;
    });
    // no export
    // extendedGroups
    const eg = (0, $8bTPG.computed)(()=>{
        if (!groupped.value) return [];
        let eg = [];
        let groups = ro.value || /* istanbul ignore next */ [];
        if (ap.value.length) eg.push({
            [groupLabel.value]: ' ',
            [groupOptions.value]: [
                ...ap.value
            ],
            __CREATE__: true
        });
        return eg.concat(groups);
    });
    // preFilteredGroups
    const pfg = (0, $8bTPG.computed)(()=>{
        let groups = [
            ...eg.value
        ].map((g)=>({
                ...g
            }));
        if (createdOption.value.length) {
            if (groups[0] && groups[0].__CREATE__) groups[0][groupOptions.value] = [
                ...createdOption.value,
                ...groups[0][groupOptions.value]
            ];
            else groups = [
                {
                    [groupLabel.value]: ' ',
                    [groupOptions.value]: [
                        ...createdOption.value
                    ],
                    __CREATE__: true
                }
            ].concat(groups);
        }
        return groups;
    });
    // filteredGroups
    const fg = (0, $8bTPG.computed)(()=>{
        if (!groupped.value) return [];
        let options = pfg.value;
        return filterGroups((options || /* istanbul ignore next */ []).map((group, index)=>{
            const arrayOptions = optionsToArray(group[groupOptions.value]);
            return {
                ...group,
                index: index,
                group: true,
                [groupOptions.value]: filterOptions(arrayOptions, false).map((o)=>Object.assign({}, o, group[disabledProp.value] ? {
                        [disabledProp.value]: true
                    } : {})),
                __VISIBLE__: filterOptions(arrayOptions).map((o)=>Object.assign({}, o, group[disabledProp.value] ? {
                        [disabledProp.value]: true
                    } : {}))
            };
        // Difference between __VISIBLE__ and {groupOptions}: visible does not contain selected options when hideSelected=true
        }));
    });
    const hasSelected = (0, $8bTPG.computed)(()=>{
        switch(mode.value){
            case 'single':
                return !$741c336afc2dfa06$var$isNullish$1(iv.value[valueProp.value]);
            case 'multiple':
            case 'tags':
                return !$741c336afc2dfa06$var$isNullish$1(iv.value) && iv.value.length > 0;
        }
    });
    const multipleLabelText = (0, $8bTPG.computed)(()=>{
        return multipleLabel.value !== undefined ? multipleLabel.value(iv.value, $this) : iv.value && iv.value.length > 1 ? `${iv.value.length} options selected` : `1 option selected`;
    });
    const noOptions = $741c336afc2dfa06$var$toRef(()=>{
        return !eo.value.length && !resolving.value && !createdOption.value.length;
    });
    const noResults = $741c336afc2dfa06$var$toRef(()=>{
        return eo.value.length > 0 && fo.value.length == 0 && (search.value && groupped.value || !groupped.value);
    });
    // no export
    const createdOption = (0, $8bTPG.computed)(()=>{
        if (createOption.value === false || !search.value) return [];
        if (getOptionByTrackBy(search.value) !== -1) return [];
        return [
            {
                [valueProp.value]: search.value,
                [trackBy.value[0]]: search.value,
                [label.value]: search.value,
                __CREATE__: true
            }
        ];
    });
    const trackBy = (0, $8bTPG.computed)(()=>{
        return trackBy_.value ? Array.isArray(trackBy_.value) ? trackBy_.value : [
            trackBy_.value
        ] : [
            label.value
        ];
    });
    // no export
    const nullValue = $741c336afc2dfa06$var$toRef(()=>{
        switch(mode.value){
            case 'single':
                return null;
            case 'multiple':
            case 'tags':
                return [];
        }
    });
    const busy = $741c336afc2dfa06$var$toRef(()=>{
        return loading.value || resolving.value;
    });
    // =============== METHODS ==============
    /**
   * @param {array|object|string|number} option 
   */ const select = (option)=>{
        if (typeof option !== 'object') option = getOption(option);
        switch(mode.value){
            case 'single':
                update(option);
                break;
            case 'multiple':
            case 'tags':
                update(iv.value.concat(option));
                break;
        }
        context.emit('select', finalValue(option), option, $this);
    };
    const deselect = (option)=>{
        if (typeof option !== 'object') option = getOption(option);
        switch(mode.value){
            case 'single':
                clear();
                break;
            case 'tags':
            case 'multiple':
                update(Array.isArray(option) ? iv.value.filter((v)=>option.map((o)=>o[valueProp.value]).indexOf(v[valueProp.value]) === -1) : iv.value.filter((v)=>v[valueProp.value] != option[valueProp.value]));
                break;
        }
        context.emit('deselect', finalValue(option), option, $this);
    };
    // no export
    const finalValue = (option)=>{
        return object.value ? option : option[valueProp.value];
    };
    const remove = (option)=>{
        deselect(option);
    };
    const handleTagRemove = (option, e)=>{
        if (e.button !== 0) {
            e.preventDefault();
            return;
        }
        remove(option);
    };
    const clear = ()=>{
        update(nullValue.value);
        context.emit('clear', $this);
    };
    const isSelected = (option)=>{
        if (option.group !== undefined) return mode.value === 'single' ? false : areAllSelected(option[groupOptions.value]) && option[groupOptions.value].length;
        switch(mode.value){
            case 'single':
                return !$741c336afc2dfa06$var$isNullish$1(iv.value) && (iv.value[valueProp.value] == option[valueProp.value] || typeof iv.value[valueProp.value] === 'object' && typeof option[valueProp.value] === 'object' && $741c336afc2dfa06$var$objectsEqual$1(iv.value[valueProp.value], option[valueProp.value]));
            case 'tags':
            case 'multiple':
                return !$741c336afc2dfa06$var$isNullish$1(iv.value) && iv.value.map((o)=>o[valueProp.value]).indexOf(option[valueProp.value]) !== -1;
        }
    };
    const isDisabled = (option)=>{
        return option[disabledProp.value] === true;
    };
    const isMax = ()=>{
        if (max === undefined || max.value === -1 || !hasSelected.value && max.value > 0) return false;
        return iv.value.length >= max.value;
    };
    const handleOptionClick = (option)=>{
        if (isDisabled(option)) return;
        if (onCreate.value && !isSelected(option) && option.__CREATE__) {
            option = {
                ...option
            };
            delete option.__CREATE__;
            option = onCreate.value(option, $this);
            if (option instanceof Promise) {
                resolving.value = true;
                option.then((result)=>{
                    resolving.value = false;
                    handleOptionSelect(result);
                });
                return;
            }
        }
        handleOptionSelect(option);
    };
    const handleOptionSelect = (option)=>{
        if (option.__CREATE__) {
            option = {
                ...option
            };
            delete option.__CREATE__;
        }
        switch(mode.value){
            case 'single':
                if (option && isSelected(option)) {
                    if (canDeselect.value) deselect(option);
                    if (closeOnDeselect.value) {
                        clearPointer();
                        close();
                    }
                    return;
                }
                if (option) handleOptionAppend(option);
                /* istanbul ignore else */ if (clearOnSelect.value) clearSearch();
                if (closeOnSelect.value) {
                    clearPointer();
                    close();
                }
                if (option) select(option);
                break;
            case 'multiple':
                if (option && isSelected(option)) {
                    deselect(option);
                    if (closeOnDeselect.value) {
                        clearPointer();
                        close();
                    }
                    return;
                }
                if (isMax()) {
                    context.emit('max', $this);
                    return;
                }
                if (option) {
                    handleOptionAppend(option);
                    select(option);
                }
                if (clearOnSelect.value) clearSearch();
                if (hideSelected.value) clearPointer();
                if (closeOnSelect.value) close();
                break;
            case 'tags':
                if (option && isSelected(option)) {
                    deselect(option);
                    if (closeOnDeselect.value) {
                        clearPointer();
                        close();
                    }
                    return;
                }
                if (isMax()) {
                    context.emit('max', $this);
                    return;
                }
                if (option) handleOptionAppend(option);
                if (clearOnSelect.value) clearSearch();
                if (option) select(option);
                if (hideSelected.value) clearPointer();
                if (closeOnSelect.value) close();
                break;
        }
        if (!closeOnSelect.value) focus();
    };
    const handleGroupClick = (group)=>{
        if (isDisabled(group) || mode.value === 'single' || !groupSelect.value) return;
        switch(mode.value){
            case 'multiple':
            case 'tags':
                if (areAllEnabledSelected(group[groupOptions.value])) deselect(group[groupOptions.value]);
                else select(group[groupOptions.value].filter((o)=>iv.value.map((v)=>v[valueProp.value]).indexOf(o[valueProp.value]) === -1).filter((o)=>!o[disabledProp.value]).filter((o, k)=>iv.value.length + 1 + k <= max.value || max.value === -1));
                if (hideSelected.value && pointer.value) // Refresh pointer because pointer.__VISIBLE__ are not reactive #354
                setPointer(fg.value.filter((g)=>!g[disabledProp.value])[pointer.value.index]);
                break;
        }
        if (closeOnSelect.value) deactivate();
    };
    const handleOptionAppend = (option)=>{
        if (getOption(option[valueProp.value]) === undefined && createOption.value) {
            context.emit('tag', option[valueProp.value], $this);
            context.emit('option', option[valueProp.value], $this);
            context.emit('create', option[valueProp.value], $this);
            if (appendNewOption.value) appendOption(option);
            clearSearch();
        }
    };
    const selectAll = ()=>{
        if (mode.value === 'single') return;
        select(fo.value.filter((o)=>!o.disabled && !isSelected(o)));
    };
    // no export
    const areAllEnabledSelected = (options)=>{
        return options.find((o)=>!isSelected(o) && !o[disabledProp.value]) === undefined;
    };
    // no export
    const areAllSelected = (options)=>{
        return options.find((o)=>!isSelected(o)) === undefined;
    };
    const getOption = (val)=>{
        return eo.value[eo.value.map((o)=>String(o[valueProp.value])).indexOf(String(val))];
    };
    // no export
    const getOptionByTrackBy = (val)=>{
        return eo.value.findIndex((o)=>{
            return trackBy.value.some((track)=>{
                return (parseInt(o[track]) == o[track] ? parseInt(o[track]) : o[track]) === (parseInt(val) == val ? parseInt(val) : val);
            });
        });
    };
    // no export
    const shouldHideOption = (option)=>{
        return [
            'tags',
            'multiple'
        ].indexOf(mode.value) !== -1 && hideSelected.value && isSelected(option);
    };
    // no export
    const appendOption = (option)=>{
        ap.value.push(option);
    };
    // no export
    const filterGroups = (groups)=>{
        // If the search has value we need to filter among 
        // the ones that are visible to the user to avoid
        // displaying groups which technically have options
        // based on search but that option is already selected.
        return groupHideEmpty.value ? groups.filter((g)=>search.value ? g.__VISIBLE__.length : g[groupOptions.value].length) : groups.filter((g)=>search.value ? g.__VISIBLE__.length : true);
    };
    // no export
    const filterOptions = (options, excludeHideSelected = true)=>{
        let fo = options;
        if (search.value && filterResults.value) {
            let filter = searchFilter.value;
            if (!filter) filter = (option, query, $this)=>{
                return trackBy.value.some((track)=>{
                    let target = $741c336afc2dfa06$var$normalize(localize(option[track]), strict.value);
                    return searchStart.value ? target.startsWith($741c336afc2dfa06$var$normalize(query, strict.value)) : target.indexOf($741c336afc2dfa06$var$normalize(query, strict.value)) !== -1;
                });
            };
            fo = fo.filter((o)=>{
                return filter(o, search.value, $this);
            });
        }
        if (hideSelected.value && excludeHideSelected) fo = fo.filter((option)=>!shouldHideOption(option));
        return fo;
    };
    // no export
    const optionsToArray = (options)=>{
        let uo = options;
        // Transforming an object to an array of objects
        if ($741c336afc2dfa06$var$isObject(uo)) uo = Object.keys(uo).map((key)=>{
            let val = uo[key];
            return {
                [valueProp.value]: key,
                [trackBy.value[0]]: val,
                [label.value]: val
            };
        });
        // Transforming an plain arrays to an array of objects
        /* istanbul ignore else */ if (uo && Array.isArray(uo)) uo = uo.map((val)=>{
            return typeof val === 'object' ? val : {
                [valueProp.value]: val,
                [trackBy.value[0]]: val,
                [label.value]: val
            };
        });
        else uo = [];
        return uo;
    };
    // no export
    const initInternalValue = ()=>{
        if (!$741c336afc2dfa06$var$isNullish$1(ev.value)) iv.value = makeInternal(ev.value);
    };
    const resolveOptions = (callback)=>{
        resolving.value = true;
        return new Promise((resolve, reject)=>{
            options.value(search.value, $this).then((response)=>{
                ro.value = response || [];
                if (typeof callback == 'function') callback(response);
                resolving.value = false;
            }).catch((e)=>{
                console.error(e);
                ro.value = [];
                resolving.value = false;
            }).finally(()=>{
                resolve();
            });
        });
    };
    // no export
    const refreshLabels = ()=>{
        if (!hasSelected.value) return;
        if (mode.value === 'single') {
            let option = getOption(iv.value[valueProp.value]);
            /* istanbul ignore else */ if (option !== undefined) {
                let newLabel = option[label.value];
                iv.value[label.value] = newLabel;
                if (object.value) ev.value[label.value] = newLabel;
            }
        } else iv.value.forEach((val, i)=>{
            let option = getOption(iv.value[i][valueProp.value]);
            /* istanbul ignore else */ if (option !== undefined) {
                let newLabel = option[label.value];
                iv.value[i][label.value] = newLabel;
                if (object.value) ev.value[i][label.value] = newLabel;
            }
        });
    };
    const refreshOptions = (callback)=>{
        resolveOptions(callback);
    };
    // no export
    const makeInternal = (val)=>{
        if ($741c336afc2dfa06$var$isNullish$1(val)) return mode.value === 'single' ? {} : [];
        if (object.value) return val;
        // If external should be plain transform value object to plain values
        return mode.value === 'single' ? getOption(val) || (allowAbsent.value ? {
            [label.value]: val,
            [valueProp.value]: val,
            [trackBy.value[0]]: val
        } : {}) : val.filter((v)=>!!getOption(v) || allowAbsent.value).map((v)=>getOption(v) || {
                [label.value]: v,
                [valueProp.value]: v,
                [trackBy.value[0]]: v
            });
    };
    // no export
    const initSearchWatcher = ()=>{
        searchWatcher.value = (0, $8bTPG.watch)(search, (query)=>{
            if (query.length < minChars.value || !query && minChars.value !== 0) return;
            resolving.value = true;
            if (clearOnSearch.value) ro.value = [];
            setTimeout(()=>{
                if (query != search.value) return;
                options.value(search.value, $this).then((response)=>{
                    if (query == search.value || !search.value) {
                        ro.value = response;
                        pointer.value = fo.value.filter((o)=>o[disabledProp.value] !== true)[0] || null;
                        resolving.value = false;
                    }
                }).catch(/* istanbul ignore next */ (e)=>{
                    console.error(e);
                });
            }, delay.value);
        }, {
            flush: 'sync'
        });
    };
    // ================ HOOKS ===============
    if (mode.value !== 'single' && !$741c336afc2dfa06$var$isNullish$1(ev.value) && !Array.isArray(ev.value)) throw new Error(`v-model must be an array when using "${mode.value}" mode`);
    if (options && typeof options.value == 'function') {
        if (resolveOnLoad.value) resolveOptions(initInternalValue);
        else if (object.value == true) initInternalValue();
    } else {
        ro.value = options.value;
        initInternalValue();
    }
    // ============== WATCHERS ==============
    if (delay.value > -1) initSearchWatcher();
    (0, $8bTPG.watch)(delay, (value, old)=>{
        /* istanbul ignore else */ if (searchWatcher.value) searchWatcher.value();
        if (value >= 0) initSearchWatcher();
    });
    (0, $8bTPG.watch)(ev, (newValue)=>{
        if ($741c336afc2dfa06$var$isNullish$1(newValue)) {
            update(makeInternal(newValue), false);
            return;
        }
        switch(mode.value){
            case 'single':
                if (object.value ? newValue[valueProp.value] != iv.value[valueProp.value] : newValue != iv.value[valueProp.value]) update(makeInternal(newValue), false);
                break;
            case 'multiple':
            case 'tags':
                if (!$741c336afc2dfa06$var$arraysEqual$1(object.value ? newValue.map((o)=>o[valueProp.value]) : newValue, iv.value.map((o)=>o[valueProp.value]))) update(makeInternal(newValue), false);
                break;
        }
    }, {
        deep: true
    });
    (0, $8bTPG.watch)(options, (n, o)=>{
        if (typeof props.options === 'function') {
            if (resolveOnLoad.value && (!o || n && n.toString() !== o.toString())) resolveOptions();
        } else {
            ro.value = props.options;
            if (!Object.keys(iv.value).length) initInternalValue();
            refreshLabels();
        }
    });
    (0, $8bTPG.watch)(label, refreshLabels);
    (0, $8bTPG.watch)(limit, (n, o)=>{
        offset.value = infinite.value && n === -1 ? 10 : n;
    });
    return {
        resolvedOptions: resolvedOptions,
        pfo: pfo,
        fo: fo,
        filteredOptions: fo,
        hasSelected: hasSelected,
        multipleLabelText: multipleLabelText,
        eo: eo,
        extendedOptions: eo,
        eg: eg,
        extendedGroups: eg,
        fg: fg,
        filteredGroups: fg,
        noOptions: noOptions,
        noResults: noResults,
        resolving: resolving,
        busy: busy,
        offset: offset,
        select: select,
        deselect: deselect,
        remove: remove,
        selectAll: selectAll,
        clear: clear,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isMax: isMax,
        getOption: getOption,
        handleOptionClick: handleOptionClick,
        handleGroupClick: handleGroupClick,
        handleTagRemove: handleTagRemove,
        refreshOptions: refreshOptions,
        resolveOptions: resolveOptions,
        refreshLabels: refreshLabels
    };
}
function $741c336afc2dfa06$var$usePointer(props, context, dep) {
    const { valueProp: valueProp, showOptions: showOptions, searchable: searchable, groupLabel: groupLabel, groups: groupped, mode: mode, groupSelect: groupSelect, disabledProp: disabledProp, groupOptions: groupOptions } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const fo = dep.fo;
    const fg = dep.fg;
    const handleOptionClick = dep.handleOptionClick;
    const handleGroupClick = dep.handleGroupClick;
    const search = dep.search;
    const pointer = dep.pointer;
    const setPointer = dep.setPointer;
    const clearPointer = dep.clearPointer;
    const multiselect = dep.multiselect;
    const isOpen = dep.isOpen;
    // ============== COMPUTED ==============
    // no export
    const options = (0, $8bTPG.computed)(()=>{
        return fo.value.filter((o)=>!o[disabledProp.value]);
    });
    const groups = (0, $8bTPG.computed)(()=>{
        return fg.value.filter((g)=>!g[disabledProp.value]);
    });
    const canPointGroups = $741c336afc2dfa06$var$toRef(()=>{
        return mode.value !== 'single' && groupSelect.value;
    });
    const isPointerGroup = $741c336afc2dfa06$var$toRef(()=>{
        return pointer.value && pointer.value.group;
    });
    const currentGroup = (0, $8bTPG.computed)(()=>{
        return getParentGroup(pointer.value);
    });
    const prevGroup = (0, $8bTPG.computed)(()=>{
        const group = isPointerGroup.value ? pointer.value : /* istanbul ignore next */ getParentGroup(pointer.value);
        const groupIndex = groups.value.map((g)=>g[groupLabel.value]).indexOf(group[groupLabel.value]);
        let prevGroup = groups.value[groupIndex - 1];
        if (prevGroup === undefined) prevGroup = lastGroup.value;
        return prevGroup;
    });
    const nextGroup = (0, $8bTPG.computed)(()=>{
        let nextIndex = groups.value.map((g)=>g.label).indexOf(isPointerGroup.value ? pointer.value[groupLabel.value] : getParentGroup(pointer.value)[groupLabel.value]) + 1;
        if (groups.value.length <= nextIndex) nextIndex = 0;
        return groups.value[nextIndex];
    });
    const lastGroup = (0, $8bTPG.computed)(()=>{
        return [
            ...groups.value
        ].slice(-1)[0];
    });
    const currentGroupFirstEnabledOption = (0, $8bTPG.computed)(()=>{
        return pointer.value.__VISIBLE__.filter((o)=>!o[disabledProp.value])[0];
    });
    const currentGroupPrevEnabledOption = (0, $8bTPG.computed)(()=>{
        const options = currentGroup.value.__VISIBLE__.filter((o)=>!o[disabledProp.value]);
        return options[options.map((o)=>o[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1];
    });
    const currentGroupNextEnabledOption = (0, $8bTPG.computed)(()=>{
        const options = getParentGroup(pointer.value).__VISIBLE__.filter((o)=>!o[disabledProp.value]);
        return options[options.map((o)=>o[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1];
    });
    const prevGroupLastEnabledOption = (0, $8bTPG.computed)(()=>{
        return [
            ...prevGroup.value.__VISIBLE__.filter((o)=>!o[disabledProp.value])
        ].slice(-1)[0];
    });
    const lastGroupLastEnabledOption = (0, $8bTPG.computed)(()=>{
        return [
            ...lastGroup.value.__VISIBLE__.filter((o)=>!o[disabledProp.value])
        ].slice(-1)[0];
    });
    // =============== METHODS ==============
    const isPointed = (option)=>{
        return !!pointer.value && (!option.group && pointer.value[valueProp.value] === option[valueProp.value] || option.group !== undefined && pointer.value[groupLabel.value] === option[groupLabel.value]) ? true : undefined;
    };
    const setPointerFirst = ()=>{
        setPointer(options.value[0] || null);
    };
    const selectPointer = ()=>{
        if (!pointer.value || pointer.value[disabledProp.value] === true) return;
        if (isPointerGroup.value) handleGroupClick(pointer.value);
        else handleOptionClick(pointer.value);
    };
    const forwardPointer = ()=>{
        if (pointer.value === null) setPointer((groupped.value && canPointGroups.value ? !groups.value[0].__CREATE__ ? groups.value[0] : options.value[0] : options.value[0]) || null);
        else if (groupped.value && canPointGroups.value) {
            let nextPointer = isPointerGroup.value ? currentGroupFirstEnabledOption.value : currentGroupNextEnabledOption.value;
            if (nextPointer === undefined) {
                nextPointer = nextGroup.value;
                if (nextPointer.__CREATE__) nextPointer = nextPointer[groupOptions.value][0];
            }
            setPointer(nextPointer || /* istanbul ignore next */ null);
        } else {
            let next = options.value.map((o)=>o[valueProp.value]).indexOf(pointer.value[valueProp.value]) + 1;
            if (options.value.length <= next) next = 0;
            setPointer(options.value[next] || null);
        }
        (0, $ani5R.nextTick)(()=>{
            adjustWrapperScrollToPointer();
        });
    };
    const backwardPointer = ()=>{
        if (pointer.value === null) {
            let prevPointer = options.value[options.value.length - 1];
            if (groupped.value && canPointGroups.value) {
                prevPointer = lastGroupLastEnabledOption.value;
                if (prevPointer === undefined) prevPointer = lastGroup.value;
            }
            setPointer(prevPointer || null);
        } else if (groupped.value && canPointGroups.value) {
            let prevPointer = isPointerGroup.value ? prevGroupLastEnabledOption.value : currentGroupPrevEnabledOption.value;
            if (prevPointer === undefined) {
                prevPointer = isPointerGroup.value ? prevGroup.value : currentGroup.value;
                if (prevPointer.__CREATE__) {
                    prevPointer = prevGroupLastEnabledOption.value;
                    if (prevPointer === undefined) prevPointer = prevGroup.value;
                }
            }
            setPointer(prevPointer || /* istanbul ignore next */ null);
        } else {
            let prevIndex = options.value.map((o)=>o[valueProp.value]).indexOf(pointer.value[valueProp.value]) - 1;
            if (prevIndex < 0) prevIndex = options.value.length - 1;
            setPointer(options.value[prevIndex] || null);
        }
        (0, $ani5R.nextTick)(()=>{
            adjustWrapperScrollToPointer();
        });
    };
    const getParentGroup = (option)=>{
        return groups.value.find((group)=>{
            return group.__VISIBLE__.map((o)=>o[valueProp.value]).indexOf(option[valueProp.value]) !== -1;
        });
    };
    // no export
    /* istanbul ignore next */ const adjustWrapperScrollToPointer = ()=>{
        let pointedOption = multiselect.value.querySelector(`[data-pointed]`);
        if (!pointedOption) return;
        let wrapper = pointedOption.parentElement.parentElement;
        if (groupped.value) wrapper = isPointerGroup.value ? pointedOption.parentElement.parentElement.parentElement : pointedOption.parentElement.parentElement.parentElement.parentElement;
        if (pointedOption.offsetTop + pointedOption.offsetHeight > wrapper.clientHeight + wrapper.scrollTop) wrapper.scrollTop = pointedOption.offsetTop + pointedOption.offsetHeight - wrapper.clientHeight;
        if (pointedOption.offsetTop < wrapper.scrollTop) wrapper.scrollTop = pointedOption.offsetTop;
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(search, (val)=>{
        if (searchable.value) {
            if (val.length && showOptions.value) setPointerFirst();
            else clearPointer();
        }
    });
    (0, $8bTPG.watch)(isOpen, (val)=>{
        if (val && multiselect && multiselect.value) {
            let firstSelected = multiselect.value.querySelectorAll(`[data-selected]`)[0];
            if (!firstSelected) return;
            let wrapper = firstSelected.parentElement.parentElement;
            (0, $ani5R.nextTick)(()=>{
                // Removed because of #406
                /* istanbul ignore next */ // if (wrapper.scrollTop > 0) {
                //   return
                // }
                wrapper.scrollTop = firstSelected.offsetTop;
            });
        }
    });
    return {
        pointer: pointer,
        canPointGroups: canPointGroups,
        isPointed: isPointed,
        setPointerFirst: setPointerFirst,
        selectPointer: selectPointer,
        forwardPointer: forwardPointer,
        backwardPointer: backwardPointer
    };
}
function $741c336afc2dfa06$var$getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}
function $741c336afc2dfa06$var$isElement(node) {
    var OwnElement = $741c336afc2dfa06$var$getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $741c336afc2dfa06$var$isHTMLElement(node) {
    var OwnElement = $741c336afc2dfa06$var$getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $741c336afc2dfa06$var$isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = $741c336afc2dfa06$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
var $741c336afc2dfa06$var$max = Math.max;
var $741c336afc2dfa06$var$min = Math.min;
var $741c336afc2dfa06$var$round = Math.round;
function $741c336afc2dfa06$var$getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}
function $741c336afc2dfa06$var$isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test($741c336afc2dfa06$var$getUAString());
}
function $741c336afc2dfa06$var$getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && $741c336afc2dfa06$var$isHTMLElement(element)) {
        scaleX = element.offsetWidth > 0 ? $741c336afc2dfa06$var$round(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? $741c336afc2dfa06$var$round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = $741c336afc2dfa06$var$isElement(element) ? $741c336afc2dfa06$var$getWindow(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !$741c336afc2dfa06$var$isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}
function $741c336afc2dfa06$var$getWindowScroll(node) {
    var win = $741c336afc2dfa06$var$getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}
function $741c336afc2dfa06$var$getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}
function $741c336afc2dfa06$var$getNodeScroll(node) {
    if (node === $741c336afc2dfa06$var$getWindow(node) || !$741c336afc2dfa06$var$isHTMLElement(node)) return $741c336afc2dfa06$var$getWindowScroll(node);
    else return $741c336afc2dfa06$var$getHTMLElementScroll(node);
}
function $741c336afc2dfa06$var$getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}
function $741c336afc2dfa06$var$getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (($741c336afc2dfa06$var$isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function $741c336afc2dfa06$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return $741c336afc2dfa06$var$getBoundingClientRect($741c336afc2dfa06$var$getDocumentElement(element)).left + $741c336afc2dfa06$var$getWindowScroll(element).scrollLeft;
}
function $741c336afc2dfa06$var$getComputedStyle$1(element) {
    return $741c336afc2dfa06$var$getWindow(element).getComputedStyle(element);
}
function $741c336afc2dfa06$var$isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = $741c336afc2dfa06$var$getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function $741c336afc2dfa06$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = $741c336afc2dfa06$var$round(rect.width) / element.offsetWidth || 1;
    var scaleY = $741c336afc2dfa06$var$round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.
function $741c336afc2dfa06$var$getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = $741c336afc2dfa06$var$isHTMLElement(offsetParent);
    var offsetParentIsScaled = $741c336afc2dfa06$var$isHTMLElement(offsetParent) && $741c336afc2dfa06$var$isElementScaled(offsetParent);
    var documentElement = $741c336afc2dfa06$var$getDocumentElement(offsetParent);
    var rect = $741c336afc2dfa06$var$getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ($741c336afc2dfa06$var$getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        $741c336afc2dfa06$var$isScrollParent(documentElement)) scroll = $741c336afc2dfa06$var$getNodeScroll(offsetParent);
        if ($741c336afc2dfa06$var$isHTMLElement(offsetParent)) {
            offsets = $741c336afc2dfa06$var$getBoundingClientRect(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = $741c336afc2dfa06$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
// means it doesn't take into account transforms.
function $741c336afc2dfa06$var$getLayoutRect(element) {
    var clientRect = $741c336afc2dfa06$var$getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}
function $741c336afc2dfa06$var$getParentNode(element) {
    if ($741c336afc2dfa06$var$getNodeName(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ($741c336afc2dfa06$var$isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    $741c336afc2dfa06$var$getDocumentElement(element) // fallback
    );
}
function $741c336afc2dfa06$var$getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf($741c336afc2dfa06$var$getNodeName(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ($741c336afc2dfa06$var$isHTMLElement(node) && $741c336afc2dfa06$var$isScrollParent(node)) return node;
    return $741c336afc2dfa06$var$getScrollParent($741c336afc2dfa06$var$getParentNode(node));
}
/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/ function $741c336afc2dfa06$var$listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = $741c336afc2dfa06$var$getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = $741c336afc2dfa06$var$getWindow(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], $741c336afc2dfa06$var$isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($741c336afc2dfa06$var$listScrollParents($741c336afc2dfa06$var$getParentNode(target)));
}
function $741c336afc2dfa06$var$isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf($741c336afc2dfa06$var$getNodeName(element)) >= 0;
}
function $741c336afc2dfa06$var$getTrueOffsetParent(element) {
    if (!$741c336afc2dfa06$var$isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    $741c336afc2dfa06$var$getComputedStyle$1(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $741c336afc2dfa06$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test($741c336afc2dfa06$var$getUAString());
    var isIE = /Trident/i.test($741c336afc2dfa06$var$getUAString());
    if (isIE && $741c336afc2dfa06$var$isHTMLElement(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = $741c336afc2dfa06$var$getComputedStyle$1(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = $741c336afc2dfa06$var$getParentNode(element);
    if ($741c336afc2dfa06$var$isShadowRoot(currentNode)) currentNode = currentNode.host;
    while($741c336afc2dfa06$var$isHTMLElement(currentNode) && [
        'html',
        'body'
    ].indexOf($741c336afc2dfa06$var$getNodeName(currentNode)) < 0){
        var css = $741c336afc2dfa06$var$getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $741c336afc2dfa06$var$getOffsetParent(element) {
    var window1 = $741c336afc2dfa06$var$getWindow(element);
    var offsetParent = $741c336afc2dfa06$var$getTrueOffsetParent(element);
    while(offsetParent && $741c336afc2dfa06$var$isTableElement(offsetParent) && $741c336afc2dfa06$var$getComputedStyle$1(offsetParent).position === 'static')offsetParent = $741c336afc2dfa06$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ($741c336afc2dfa06$var$getNodeName(offsetParent) === 'html' || $741c336afc2dfa06$var$getNodeName(offsetParent) === 'body' && $741c336afc2dfa06$var$getComputedStyle$1(offsetParent).position === 'static')) return window1;
    return offsetParent || $741c336afc2dfa06$var$getContainingBlock(element) || window1;
}
var $741c336afc2dfa06$var$top = 'top';
var $741c336afc2dfa06$var$bottom = 'bottom';
var $741c336afc2dfa06$var$right = 'right';
var $741c336afc2dfa06$var$left = 'left';
var $741c336afc2dfa06$var$auto = 'auto';
var $741c336afc2dfa06$var$basePlacements = [
    $741c336afc2dfa06$var$top,
    $741c336afc2dfa06$var$bottom,
    $741c336afc2dfa06$var$right,
    $741c336afc2dfa06$var$left
];
var $741c336afc2dfa06$var$start = 'start';
var $741c336afc2dfa06$var$end = 'end';
var $741c336afc2dfa06$var$clippingParents = 'clippingParents';
var $741c336afc2dfa06$var$viewport = 'viewport';
var $741c336afc2dfa06$var$popper = 'popper';
var $741c336afc2dfa06$var$reference = 'reference';
var $741c336afc2dfa06$var$variationPlacements = /*#__PURE__*/ $741c336afc2dfa06$var$basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $741c336afc2dfa06$var$start,
        placement + "-" + $741c336afc2dfa06$var$end
    ]);
}, []);
var $741c336afc2dfa06$var$placements = /*#__PURE__*/ [].concat($741c336afc2dfa06$var$basePlacements, [
    $741c336afc2dfa06$var$auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $741c336afc2dfa06$var$start,
        placement + "-" + $741c336afc2dfa06$var$end
    ]);
}, []); // modifiers that need to read the DOM
var $741c336afc2dfa06$var$beforeRead = 'beforeRead';
var $741c336afc2dfa06$var$read = 'read';
var $741c336afc2dfa06$var$afterRead = 'afterRead'; // pure-logic modifiers
var $741c336afc2dfa06$var$beforeMain = 'beforeMain';
var $741c336afc2dfa06$var$main = 'main';
var $741c336afc2dfa06$var$afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $741c336afc2dfa06$var$beforeWrite = 'beforeWrite';
var $741c336afc2dfa06$var$write = 'write';
var $741c336afc2dfa06$var$afterWrite = 'afterWrite';
var $741c336afc2dfa06$var$modifierPhases = [
    $741c336afc2dfa06$var$beforeRead,
    $741c336afc2dfa06$var$read,
    $741c336afc2dfa06$var$afterRead,
    $741c336afc2dfa06$var$beforeMain,
    $741c336afc2dfa06$var$main,
    $741c336afc2dfa06$var$afterMain,
    $741c336afc2dfa06$var$beforeWrite,
    $741c336afc2dfa06$var$write,
    $741c336afc2dfa06$var$afterWrite
];
function $741c336afc2dfa06$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $741c336afc2dfa06$var$orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = $741c336afc2dfa06$var$order(modifiers); // order based on phase
    return $741c336afc2dfa06$var$modifierPhases.reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}
function $741c336afc2dfa06$var$debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}
function $741c336afc2dfa06$var$mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}
function $741c336afc2dfa06$var$getViewportRect(element, strategy) {
    var win = $741c336afc2dfa06$var$getWindow(element);
    var html = $741c336afc2dfa06$var$getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = $741c336afc2dfa06$var$isLayoutViewport();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + $741c336afc2dfa06$var$getWindowScrollBarX(element),
        y: y
    };
}
// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function $741c336afc2dfa06$var$getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = $741c336afc2dfa06$var$getDocumentElement(element);
    var winScroll = $741c336afc2dfa06$var$getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = $741c336afc2dfa06$var$max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = $741c336afc2dfa06$var$max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + $741c336afc2dfa06$var$getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;
    if ($741c336afc2dfa06$var$getComputedStyle$1(body || html).direction === 'rtl') x += $741c336afc2dfa06$var$max(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $741c336afc2dfa06$var$contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && $741c336afc2dfa06$var$isShadowRoot(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}
function $741c336afc2dfa06$var$rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function $741c336afc2dfa06$var$getInnerBoundingClientRect(element, strategy) {
    var rect = $741c336afc2dfa06$var$getBoundingClientRect(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $741c336afc2dfa06$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === $741c336afc2dfa06$var$viewport ? $741c336afc2dfa06$var$rectToClientRect($741c336afc2dfa06$var$getViewportRect(element, strategy)) : $741c336afc2dfa06$var$isElement(clippingParent) ? $741c336afc2dfa06$var$getInnerBoundingClientRect(clippingParent, strategy) : $741c336afc2dfa06$var$rectToClientRect($741c336afc2dfa06$var$getDocumentRect($741c336afc2dfa06$var$getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $741c336afc2dfa06$var$getClippingParents(element) {
    var clippingParents = $741c336afc2dfa06$var$listScrollParents($741c336afc2dfa06$var$getParentNode(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf($741c336afc2dfa06$var$getComputedStyle$1(element).position) >= 0;
    var clipperElement = canEscapeClipping && $741c336afc2dfa06$var$isHTMLElement(element) ? $741c336afc2dfa06$var$getOffsetParent(element) : element;
    if (!$741c336afc2dfa06$var$isElement(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return $741c336afc2dfa06$var$isElement(clippingParent) && $741c336afc2dfa06$var$contains(clippingParent, clipperElement) && $741c336afc2dfa06$var$getNodeName(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents
function $741c336afc2dfa06$var$getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $741c336afc2dfa06$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $741c336afc2dfa06$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = $741c336afc2dfa06$var$max(rect.top, accRect.top);
        accRect.right = $741c336afc2dfa06$var$min(rect.right, accRect.right);
        accRect.bottom = $741c336afc2dfa06$var$min(rect.bottom, accRect.bottom);
        accRect.left = $741c336afc2dfa06$var$max(rect.left, accRect.left);
        return accRect;
    }, $741c336afc2dfa06$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}
function $741c336afc2dfa06$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $741c336afc2dfa06$var$getVariation(placement) {
    return placement.split('-')[1];
}
function $741c336afc2dfa06$var$getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}
function $741c336afc2dfa06$var$computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? $741c336afc2dfa06$var$getBasePlacement(placement) : null;
    var variation = placement ? $741c336afc2dfa06$var$getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case $741c336afc2dfa06$var$top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case $741c336afc2dfa06$var$bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case $741c336afc2dfa06$var$right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case $741c336afc2dfa06$var$left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? $741c336afc2dfa06$var$getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case $741c336afc2dfa06$var$start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case $741c336afc2dfa06$var$end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
        }
    }
    return offsets;
}
function $741c336afc2dfa06$var$getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function $741c336afc2dfa06$var$mergePaddingObject(paddingObject) {
    return Object.assign({}, $741c336afc2dfa06$var$getFreshSideObject(), paddingObject);
}
function $741c336afc2dfa06$var$expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}
function $741c336afc2dfa06$var$detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? $741c336afc2dfa06$var$clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? $741c336afc2dfa06$var$viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? $741c336afc2dfa06$var$popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = $741c336afc2dfa06$var$mergePaddingObject(typeof padding !== 'number' ? padding : $741c336afc2dfa06$var$expandToHashMap(padding, $741c336afc2dfa06$var$basePlacements));
    var altContext = elementContext === $741c336afc2dfa06$var$popper ? $741c336afc2dfa06$var$reference : $741c336afc2dfa06$var$popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = $741c336afc2dfa06$var$getClippingRect($741c336afc2dfa06$var$isElement(element) ? element : element.contextElement || $741c336afc2dfa06$var$getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = $741c336afc2dfa06$var$getBoundingClientRect(state.elements.reference);
    var popperOffsets = $741c336afc2dfa06$var$computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = $741c336afc2dfa06$var$rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === $741c336afc2dfa06$var$popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === $741c336afc2dfa06$var$popper && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                $741c336afc2dfa06$var$right,
                $741c336afc2dfa06$var$bottom
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                $741c336afc2dfa06$var$top,
                $741c336afc2dfa06$var$bottom
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}
var $741c336afc2dfa06$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $741c336afc2dfa06$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $741c336afc2dfa06$var$popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $741c336afc2dfa06$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $741c336afc2dfa06$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: $741c336afc2dfa06$var$isElement(reference) ? $741c336afc2dfa06$var$listScrollParents(reference) : reference.contextElement ? $741c336afc2dfa06$var$listScrollParents(reference.contextElement) : [],
                    popper: $741c336afc2dfa06$var$listScrollParents(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = $741c336afc2dfa06$var$orderModifiers($741c336afc2dfa06$var$mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$741c336afc2dfa06$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: $741c336afc2dfa06$var$getCompositeRect(reference, $741c336afc2dfa06$var$getOffsetParent(popper), state.options.strategy === 'fixed'),
                    popper: $741c336afc2dfa06$var$getLayoutRect(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: $741c336afc2dfa06$var$debounce(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$741c336afc2dfa06$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $741c336afc2dfa06$var$passive = {
    passive: true
};
function $741c336afc2dfa06$var$effect$1(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window1 = $741c336afc2dfa06$var$getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $741c336afc2dfa06$var$passive);
    });
    if (resize) window1.addEventListener('resize', instance.update, $741c336afc2dfa06$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $741c336afc2dfa06$var$passive);
        });
        if (resize) window1.removeEventListener('resize', instance.update, $741c336afc2dfa06$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $741c336afc2dfa06$var$effect$1,
    data: {}
};
function $741c336afc2dfa06$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = $741c336afc2dfa06$var$computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $741c336afc2dfa06$var$popperOffsets,
    data: {}
};
var $741c336afc2dfa06$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $741c336afc2dfa06$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: $741c336afc2dfa06$var$round(x * dpr) / dpr || 0,
        y: $741c336afc2dfa06$var$round(y * dpr) / dpr || 0
    };
}
function $741c336afc2dfa06$var$mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = $741c336afc2dfa06$var$left;
    var sideY = $741c336afc2dfa06$var$top;
    var win = window;
    if (adaptive) {
        var offsetParent = $741c336afc2dfa06$var$getOffsetParent(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === $741c336afc2dfa06$var$getWindow(popper)) {
            offsetParent = $741c336afc2dfa06$var$getDocumentElement(popper);
            if ($741c336afc2dfa06$var$getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === $741c336afc2dfa06$var$top || (placement === $741c336afc2dfa06$var$left || placement === $741c336afc2dfa06$var$right) && variation === $741c336afc2dfa06$var$end) {
            sideY = $741c336afc2dfa06$var$bottom;
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === $741c336afc2dfa06$var$left || (placement === $741c336afc2dfa06$var$top || placement === $741c336afc2dfa06$var$bottom) && variation === $741c336afc2dfa06$var$end) {
            sideX = $741c336afc2dfa06$var$right;
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $741c336afc2dfa06$var$unsetSides);
    var _ref4 = roundOffsets === true ? $741c336afc2dfa06$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, $741c336afc2dfa06$var$getWindow(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $741c336afc2dfa06$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: $741c336afc2dfa06$var$getBasePlacement(state.placement),
        variation: $741c336afc2dfa06$var$getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $741c336afc2dfa06$var$mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $741c336afc2dfa06$var$mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $741c336afc2dfa06$var$computeStyles,
    data: {}
};
// and applies them to the HTMLElements such as popper and arrow
function $741c336afc2dfa06$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!$741c336afc2dfa06$var$isHTMLElement(element) || !$741c336afc2dfa06$var$getNodeName(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $741c336afc2dfa06$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!$741c336afc2dfa06$var$isHTMLElement(element) || !$741c336afc2dfa06$var$getNodeName(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $741c336afc2dfa06$var$applyStyles,
    effect: $741c336afc2dfa06$var$effect,
    requires: [
        'computeStyles'
    ]
};
var $741c336afc2dfa06$var$defaultModifiers = [
    $741c336afc2dfa06$var$eventListeners,
    $741c336afc2dfa06$var$popperOffsets$1,
    $741c336afc2dfa06$var$computeStyles$1,
    $741c336afc2dfa06$var$applyStyles$1
];
var $741c336afc2dfa06$var$createPopper = /*#__PURE__*/ $741c336afc2dfa06$var$popperGenerator({
    defaultModifiers: $741c336afc2dfa06$var$defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules
function $741c336afc2dfa06$var$getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $741c336afc2dfa06$var$within(min$1, value, max$1) {
    return $741c336afc2dfa06$var$max(min$1, $741c336afc2dfa06$var$min(value, max$1));
}
function $741c336afc2dfa06$var$withinMaxClamp(min, value, max) {
    var v = $741c336afc2dfa06$var$within(min, value, max);
    return v > max ? max : v;
}
function $741c336afc2dfa06$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = $741c336afc2dfa06$var$detectOverflow(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = $741c336afc2dfa06$var$getBasePlacement(state.placement);
    var variation = $741c336afc2dfa06$var$getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = $741c336afc2dfa06$var$getMainAxisFromPlacement(basePlacement);
    var altAxis = $741c336afc2dfa06$var$getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? $741c336afc2dfa06$var$top : $741c336afc2dfa06$var$left;
        var altSide = mainAxis === 'y' ? $741c336afc2dfa06$var$bottom : $741c336afc2dfa06$var$right;
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min$1 = offset + overflow[mainSide];
        var max$1 = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === $741c336afc2dfa06$var$start ? referenceRect[len] : popperRect[len];
        var maxLen = variation === $741c336afc2dfa06$var$start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? $741c336afc2dfa06$var$getLayoutRect(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : $741c336afc2dfa06$var$getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = $741c336afc2dfa06$var$within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && $741c336afc2dfa06$var$getOffsetParent(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = $741c336afc2dfa06$var$within(tether ? $741c336afc2dfa06$var$min(min$1, tetherMin) : min$1, offset, tether ? $741c336afc2dfa06$var$max(max$1, tetherMax) : max$1);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? $741c336afc2dfa06$var$top : $741c336afc2dfa06$var$left;
        var _altSide = mainAxis === 'x' ? $741c336afc2dfa06$var$bottom : $741c336afc2dfa06$var$right;
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            $741c336afc2dfa06$var$top,
            $741c336afc2dfa06$var$left
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? $741c336afc2dfa06$var$withinMaxClamp(_tetherMin, _offset, _tetherMax) : $741c336afc2dfa06$var$within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $741c336afc2dfa06$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};
var $741c336afc2dfa06$var$hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $741c336afc2dfa06$var$getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $741c336afc2dfa06$var$hash$1[matched];
    });
}
var $741c336afc2dfa06$var$hash = {
    start: 'end',
    end: 'start'
};
function $741c336afc2dfa06$var$getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $741c336afc2dfa06$var$hash[matched];
    });
}
function $741c336afc2dfa06$var$computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? $741c336afc2dfa06$var$placements : _options$allowedAutoP;
    var variation = $741c336afc2dfa06$var$getVariation(placement);
    var placements$1 = variation ? flipVariations ? $741c336afc2dfa06$var$variationPlacements : $741c336afc2dfa06$var$variationPlacements.filter(function(placement) {
        return $741c336afc2dfa06$var$getVariation(placement) === variation;
    }) : $741c336afc2dfa06$var$basePlacements;
    var allowedPlacements = placements$1.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements$1;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = $741c336afc2dfa06$var$detectOverflow(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[$741c336afc2dfa06$var$getBasePlacement(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}
function $741c336afc2dfa06$var$getExpandedFallbackPlacements(placement) {
    if ($741c336afc2dfa06$var$getBasePlacement(placement) === $741c336afc2dfa06$var$auto) return [];
    var oppositePlacement = $741c336afc2dfa06$var$getOppositePlacement(placement);
    return [
        $741c336afc2dfa06$var$getOppositeVariationPlacement(placement),
        oppositePlacement,
        $741c336afc2dfa06$var$getOppositeVariationPlacement(oppositePlacement)
    ];
}
function $741c336afc2dfa06$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = $741c336afc2dfa06$var$getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        $741c336afc2dfa06$var$getOppositePlacement(preferredPlacement)
    ] : $741c336afc2dfa06$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat($741c336afc2dfa06$var$getBasePlacement(placement) === $741c336afc2dfa06$var$auto ? $741c336afc2dfa06$var$computeAutoPlacement(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = $741c336afc2dfa06$var$getBasePlacement(placement);
        var isStartVariation = $741c336afc2dfa06$var$getVariation(placement) === $741c336afc2dfa06$var$start;
        var isVertical = [
            $741c336afc2dfa06$var$top,
            $741c336afc2dfa06$var$bottom
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = $741c336afc2dfa06$var$detectOverflow(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? $741c336afc2dfa06$var$right : $741c336afc2dfa06$var$left : isStartVariation ? $741c336afc2dfa06$var$bottom : $741c336afc2dfa06$var$top;
        if (referenceRect[len] > popperRect[len]) mainVariationSide = $741c336afc2dfa06$var$getOppositePlacement(mainVariationSide);
        var altVariationSide = $741c336afc2dfa06$var$getOppositePlacement(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $741c336afc2dfa06$var$flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $741c336afc2dfa06$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};
function $741c336afc2dfa06$var$useDropdown(props, context, dep) {
    const { disabled: disabled, appendTo: appendTo, appendToBody: appendToBody, openDirection: openDirection } = (0, $8bTPG.toRefs)(props);
    const $this = (0, $ani5R.getCurrentInstance)().proxy;
    // ============ DEPENDENCIES ============
    const multiselect = dep.multiselect;
    const dropdown = dep.dropdown;
    // ================ DATA ================
    const isOpen = (0, $8bTPG.ref)(false);
    const popper = (0, $8bTPG.ref)(null);
    const forcedPlacement = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    const appended = $741c336afc2dfa06$var$toRef(()=>{
        return appendTo.value || appendToBody.value;
    });
    const placement = $741c336afc2dfa06$var$toRef(()=>{
        return openDirection.value === 'top' && forcedPlacement.value === 'bottom' || openDirection.value === 'bottom' && forcedPlacement.value !== 'top' ? 'bottom' : 'top';
    });
    // =============== METHODS ==============
    const open = ()=>{
        if (isOpen.value || disabled.value) return;
        isOpen.value = true;
        context.emit('open', $this);
        if (appended.value) (0, $ani5R.nextTick)(()=>{
            updatePopper();
        });
    };
    const close = ()=>{
        if (!isOpen.value) return;
        isOpen.value = false;
        context.emit('close', $this);
    };
    const updatePopper = ()=>{
        if (!popper.value) return;
        let borderTopWidth = parseInt(window.getComputedStyle(dropdown.value).borderTopWidth.replace('px', ''));
        let borderBottomWidth = parseInt(window.getComputedStyle(dropdown.value).borderBottomWidth.replace('px', ''));
        popper.value.setOptions((options)=>({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    {
                        name: 'offset',
                        options: {
                            offset: [
                                0,
                                (placement.value === 'top' ? borderTopWidth : borderBottomWidth) * -1
                            ]
                        }
                    }
                ]
            }));
        popper.value.update();
    };
    /* istanbul ignore next: UI feature */ const hasFixedParent = (element)=>{
        while(element && element !== document.body){
            const style = getComputedStyle(element);
            if (style.position === 'fixed') return true;
            element = element.parentElement;
        }
        return false;
    };
    (0, $ani5R.onMounted)(()=>{
        if (!appended.value) return;
        /* istanbul ignore next: popper mock */ popper.value = $741c336afc2dfa06$var$createPopper(multiselect.value, dropdown.value, {
            strategy: hasFixedParent(multiselect.value) ? /* istanbul ignore next: UI feature */ 'fixed' : undefined,
            placement: openDirection.value,
            modifiers: [
                $741c336afc2dfa06$var$preventOverflow$1,
                $741c336afc2dfa06$var$flip$1,
                {
                    name: 'sameWidth',
                    enabled: true,
                    phase: 'beforeWrite',
                    requires: [
                        'computeStyles'
                    ],
                    fn: ({ state: state })=>{
                        state.styles.popper.width = `${state.rects.reference.width}px`;
                    },
                    effect: ({ state: state })=>{
                        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
                    }
                },
                {
                    name: 'toggleClass',
                    enabled: true,
                    phase: 'write',
                    fn ({ state: state }) {
                        forcedPlacement.value = state.placement;
                    }
                }
            ]
        });
    });
    (0, $ani5R.onBeforeUnmount)(()=>{
        if (!appended.value || !popper.value) return;
        popper.value.destroy();
        popper.value = null;
    });
    return {
        popper: popper,
        isOpen: isOpen,
        open: open,
        close: close,
        placement: placement,
        updatePopper: updatePopper
    };
}
function $741c336afc2dfa06$var$useMultiselect(props, context, dep) {
    const { searchable: searchable, disabled: disabled, clearOnBlur: clearOnBlur } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const input = dep.input;
    const open = dep.open;
    const close = dep.close;
    const clearSearch = dep.clearSearch;
    const isOpen = dep.isOpen;
    const wrapper = dep.wrapper;
    const tags = dep.tags;
    // ================ DATA ================
    const isActive = (0, $8bTPG.ref)(false);
    const mouseClicked = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    const tabindex = $741c336afc2dfa06$var$toRef(()=>{
        return searchable.value || disabled.value ? -1 : 0;
    });
    // =============== METHODS ==============
    const blur = ()=>{
        if (searchable.value) input.value.blur();
        wrapper.value.blur();
    };
    const focus = ()=>{
        if (searchable.value && !disabled.value) input.value.focus();
    };
    const activate = (shouldOpen = true)=>{
        if (disabled.value) return;
        isActive.value = true;
        if (shouldOpen) open();
    };
    const deactivate = ()=>{
        isActive.value = false;
        setTimeout(()=>{
            if (!isActive.value) {
                close();
                if (clearOnBlur.value) clearSearch();
            }
        }, 1);
    };
    const handleFocusIn = (e)=>{
        if (e.target.closest('[data-tags]') && e.target.nodeName !== 'INPUT' || e.target.closest('[data-clear]')) return;
        activate(mouseClicked.value);
    };
    const handleFocusOut = ()=>{
        deactivate();
    };
    const handleCaretClick = ()=>{
        deactivate();
        blur();
    };
    /* istanbul ignore next */ const handleMousedown = (e)=>{
        mouseClicked.value = true;
        if (isOpen.value && (e.target.isEqualNode(wrapper.value) || e.target.isEqualNode(tags.value))) setTimeout(()=>{
            deactivate();
        }, 0);
        else if (!isOpen.value && (document.activeElement.isEqualNode(wrapper.value) || document.activeElement.isEqualNode(input.value))) activate();
        setTimeout(()=>{
            mouseClicked.value = false;
        }, 0);
    };
    return {
        tabindex: tabindex,
        isActive: isActive,
        mouseClicked: mouseClicked,
        blur: blur,
        focus: focus,
        activate: activate,
        deactivate: deactivate,
        handleFocusIn: handleFocusIn,
        handleFocusOut: handleFocusOut,
        handleCaretClick: handleCaretClick,
        handleMousedown: handleMousedown
    };
}
function $741c336afc2dfa06$var$useKeyboard(props, context, dep) {
    const { mode: mode, addTagOn: addTagOn, openDirection: openDirection, searchable: searchable, showOptions: showOptions, valueProp: valueProp, groups: groupped, addOptionOn: addOptionOn_, createTag: createTag, createOption: createOption_, reverse: reverse } = (0, $8bTPG.toRefs)(props);
    const $this = (0, $ani5R.getCurrentInstance)().proxy;
    // ============ DEPENDENCIES ============
    const iv = dep.iv;
    const update = dep.update;
    const deselect = dep.deselect;
    const search = dep.search;
    const setPointer = dep.setPointer;
    const selectPointer = dep.selectPointer;
    const backwardPointer = dep.backwardPointer;
    const forwardPointer = dep.forwardPointer;
    const multiselect = dep.multiselect;
    const wrapper = dep.wrapper;
    const tags = dep.tags;
    const isOpen = dep.isOpen;
    const open = dep.open;
    const blur = dep.blur;
    const fo = dep.fo;
    // ============== COMPUTED ==============
    // no export
    const createOption = $741c336afc2dfa06$var$toRef(()=>{
        return createTag.value || createOption_.value || false;
    });
    // no export
    const addOptionOn = $741c336afc2dfa06$var$toRef(()=>{
        if (addTagOn.value !== undefined) return addTagOn.value;
        else if (addOptionOn_.value !== undefined) return addOptionOn_.value;
        return [
            'enter'
        ];
    });
    // =============== METHODS ==============
    // no export
    const preparePointer = ()=>{
        // When options are hidden and creating tags is allowed
        // no pointer will be set (because options are hidden).
        // In such case we need to set the pointer manually to the 
        // first option, which equals to the option created from
        // the search value.
        if (mode.value === 'tags' && !showOptions.value && createOption.value && searchable.value && !groupped.value) setPointer(fo.value[fo.value.map((o)=>o[valueProp.value]).indexOf(search.value)]);
    };
    const handleKeydown = (e)=>{
        context.emit('keydown', e, $this);
        let tagList;
        let activeIndex;
        if ([
            'ArrowLeft',
            'ArrowRight',
            'Enter'
        ].indexOf(e.key) !== -1 && mode.value === 'tags') {
            tagList = [
                ...multiselect.value.querySelectorAll(`[data-tags] > *`)
            ].filter((e)=>e !== tags.value);
            activeIndex = tagList.findIndex((e)=>e === document.activeElement);
        }
        switch(e.key){
            case 'Backspace':
                if (mode.value === 'single') return;
                if (searchable.value && [
                    null,
                    ''
                ].indexOf(search.value) === -1) return;
                if (iv.value.length === 0) return;
                let deselectables = iv.value.filter((v)=>!v.disabled && v.remove !== false);
                if (deselectables.length) deselect(deselectables[deselectables.length - 1]);
                break;
            case 'Enter':
                e.preventDefault();
                if (e.keyCode === 229) // ignore IME confirmation
                return;
                if (activeIndex !== -1 && activeIndex !== undefined) {
                    update([
                        ...iv.value
                    ].filter((v, k)=>k !== activeIndex));
                    if (activeIndex === tagList.length - 1) {
                        if (tagList.length - 1) tagList[tagList.length - 2].focus();
                        else if (searchable.value) tags.value.querySelector('input').focus();
                        else wrapper.value.focus();
                    }
                    return;
                }
                if (addOptionOn.value.indexOf('enter') === -1 && createOption.value) return;
                preparePointer();
                selectPointer();
                break;
            case ' ':
                if (!createOption.value && !searchable.value) {
                    e.preventDefault();
                    preparePointer();
                    selectPointer();
                    return;
                }
                if (!createOption.value) return false;
                if (addOptionOn.value.indexOf('space') === -1 && createOption.value) return;
                e.preventDefault();
                preparePointer();
                selectPointer();
                break;
            case 'Tab':
            case ';':
            case ',':
                if (addOptionOn.value.indexOf(e.key.toLowerCase()) === -1 || !createOption.value) return;
                preparePointer();
                selectPointer();
                e.preventDefault();
                break;
            case 'Escape':
                blur();
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (!showOptions.value) return;
                /* istanbul ignore else */ if (!isOpen.value) open();
                backwardPointer();
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (!showOptions.value) return;
                /* istanbul ignore else */ if (!isOpen.value) open();
                forwardPointer();
                break;
            case 'ArrowLeft':
                if (searchable.value && tags.value && tags.value.querySelector('input').selectionStart || e.shiftKey || mode.value !== 'tags' || !iv.value || !iv.value.length) return;
                e.preventDefault();
                if (activeIndex === -1) tagList[tagList.length - 1].focus();
                else if (activeIndex > 0) tagList[activeIndex - 1].focus();
                break;
            case 'ArrowRight':
                if (activeIndex === -1 || e.shiftKey || mode.value !== 'tags' || !iv.value || !iv.value.length) return;
                e.preventDefault();
                /* istanbul ignore else */ if (tagList.length > activeIndex + 1) tagList[activeIndex + 1].focus();
                else if (searchable.value) tags.value.querySelector('input').focus();
                else if (!searchable.value) wrapper.value.focus();
                break;
        }
    };
    const handleKeyup = (e)=>{
        context.emit('keyup', e, $this);
    };
    return {
        handleKeydown: handleKeydown,
        handleKeyup: handleKeyup,
        preparePointer: preparePointer
    };
}
function $741c336afc2dfa06$var$useClasses$2(props, context, dependencies) {
    const { classes: classes_, disabled: disabled, showOptions: showOptions, breakTags: breakTags } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const isOpen = dependencies.isOpen;
    const isPointed = dependencies.isPointed;
    const isSelected = dependencies.isSelected;
    const isDisabled = dependencies.isDisabled;
    const isActive = dependencies.isActive;
    const canPointGroups = dependencies.canPointGroups;
    const resolving = dependencies.resolving;
    const fo = dependencies.fo;
    const placement = dependencies.placement;
    // ============== COMPUTED ==============
    const classes = $741c336afc2dfa06$var$toRef(()=>({
            container: 'multiselect',
            containerDisabled: 'is-disabled',
            containerOpen: 'is-open',
            containerOpenTop: 'is-open-top',
            containerActive: 'is-active',
            wrapper: 'multiselect-wrapper',
            singleLabel: 'multiselect-single-label',
            singleLabelText: 'multiselect-single-label-text',
            multipleLabel: 'multiselect-multiple-label',
            search: 'multiselect-search',
            tags: 'multiselect-tags',
            tag: 'multiselect-tag',
            tagWrapper: 'multiselect-tag-wrapper',
            tagWrapperBreak: 'multiselect-tag-wrapper-break',
            tagDisabled: 'is-disabled',
            tagRemove: 'multiselect-tag-remove',
            tagRemoveIcon: 'multiselect-tag-remove-icon',
            tagsSearchWrapper: 'multiselect-tags-search-wrapper',
            tagsSearch: 'multiselect-tags-search',
            tagsSearchCopy: 'multiselect-tags-search-copy',
            placeholder: 'multiselect-placeholder',
            caret: 'multiselect-caret',
            caretOpen: 'is-open',
            clear: 'multiselect-clear',
            clearIcon: 'multiselect-clear-icon',
            spinner: 'multiselect-spinner',
            inifinite: 'multiselect-inifite',
            inifiniteSpinner: 'multiselect-inifite-spinner',
            dropdown: 'multiselect-dropdown',
            dropdownTop: 'is-top',
            dropdownHidden: 'is-hidden',
            options: 'multiselect-options',
            optionsTop: 'is-top',
            group: 'multiselect-group',
            groupLabel: 'multiselect-group-label',
            groupLabelPointable: 'is-pointable',
            groupLabelPointed: 'is-pointed',
            groupLabelSelected: 'is-selected',
            groupLabelDisabled: 'is-disabled',
            groupLabelSelectedPointed: 'is-selected is-pointed',
            groupLabelSelectedDisabled: 'is-selected is-disabled',
            groupOptions: 'multiselect-group-options',
            option: 'multiselect-option',
            optionPointed: 'is-pointed',
            optionSelected: 'is-selected',
            optionDisabled: 'is-disabled',
            optionSelectedPointed: 'is-selected is-pointed',
            optionSelectedDisabled: 'is-selected is-disabled',
            noOptions: 'multiselect-no-options',
            noResults: 'multiselect-no-results',
            fakeInput: 'multiselect-fake-input',
            assist: 'multiselect-assistive-text',
            spacer: 'multiselect-spacer',
            ...classes_.value
        }));
    const showDropdown = $741c336afc2dfa06$var$toRef(()=>{
        return !!(isOpen.value && showOptions.value && (!resolving.value || resolving.value && fo.value.length));
    });
    const classList = (0, $8bTPG.computed)(()=>{
        const c = classes.value;
        return {
            container: [
                c.container
            ].concat(disabled.value ? c.containerDisabled : []).concat(showDropdown.value && placement.value === 'top' ? c.containerOpenTop : []).concat(showDropdown.value && placement.value !== 'top' ? c.containerOpen : []).concat(isActive.value ? c.containerActive : []),
            wrapper: c.wrapper,
            spacer: c.spacer,
            singleLabel: c.singleLabel,
            singleLabelText: c.singleLabelText,
            multipleLabel: c.multipleLabel,
            search: c.search,
            tags: c.tags,
            tag: [
                c.tag
            ].concat(disabled.value ? c.tagDisabled : []),
            tagWrapper: [
                c.tagWrapper,
                breakTags.value ? c.tagWrapperBreak : null
            ],
            tagDisabled: c.tagDisabled,
            tagRemove: c.tagRemove,
            tagRemoveIcon: c.tagRemoveIcon,
            tagsSearchWrapper: c.tagsSearchWrapper,
            tagsSearch: c.tagsSearch,
            tagsSearchCopy: c.tagsSearchCopy,
            placeholder: c.placeholder,
            caret: [
                c.caret
            ].concat(isOpen.value ? c.caretOpen : []),
            clear: c.clear,
            clearIcon: c.clearIcon,
            spinner: c.spinner,
            inifinite: c.inifinite,
            inifiniteSpinner: c.inifiniteSpinner,
            dropdown: [
                c.dropdown
            ].concat(placement.value === 'top' ? c.dropdownTop : []).concat(!isOpen.value || !showOptions.value || !showDropdown.value ? c.dropdownHidden : []),
            options: [
                c.options
            ].concat(placement.value === 'top' ? c.optionsTop : []),
            group: c.group,
            groupLabel: (g)=>{
                let groupLabel = [
                    c.groupLabel
                ];
                if (isPointed(g)) groupLabel.push(isSelected(g) ? c.groupLabelSelectedPointed : c.groupLabelPointed);
                else if (isSelected(g) && canPointGroups.value) groupLabel.push(isDisabled(g) ? c.groupLabelSelectedDisabled : c.groupLabelSelected);
                else if (isDisabled(g)) groupLabel.push(c.groupLabelDisabled);
                if (canPointGroups.value) groupLabel.push(c.groupLabelPointable);
                return groupLabel;
            },
            groupOptions: c.groupOptions,
            option: (o, g)=>{
                let option = [
                    c.option
                ];
                if (isPointed(o)) option.push(isSelected(o) ? c.optionSelectedPointed : c.optionPointed);
                else if (isSelected(o)) option.push(isDisabled(o) ? c.optionSelectedDisabled : c.optionSelected);
                else if (isDisabled(o) || g && isDisabled(g)) option.push(c.optionDisabled);
                return option;
            },
            noOptions: c.noOptions,
            noResults: c.noResults,
            assist: c.assist,
            fakeInput: c.fakeInput
        };
    });
    return {
        classList: classList,
        showDropdown: showDropdown
    };
}
function $741c336afc2dfa06$var$useScroll(props, context, dep) {
    const { limit: limit, infinite: infinite } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const isOpen = dep.isOpen;
    const offset = dep.offset;
    const search = dep.search;
    const pfo = dep.pfo;
    const eo = dep.eo;
    // ================ DATA ================
    // no export
    const observer = (0, $8bTPG.ref)(null);
    const infiniteLoader = (0, $8bTPG.shallowRef)(null);
    // ============== COMPUTED ==============
    const hasMore = $741c336afc2dfa06$var$toRef(()=>{
        return offset.value < pfo.value.length;
    });
    // =============== METHODS ==============
    // no export
    /* istanbul ignore next */ const handleIntersectionObserver = (entries)=>{
        const { isIntersecting: isIntersecting, target: target } = entries[0];
        if (isIntersecting) {
            const parent = target.offsetParent;
            const scrollTop = parent.scrollTop;
            offset.value += limit.value == -1 ? 10 : limit.value;
            (0, $ani5R.nextTick)(()=>{
                parent.scrollTop = scrollTop;
            });
        }
    };
    const observe = ()=>{
        /* istanbul ignore else */ if (isOpen.value && offset.value < pfo.value.length) observer.value.observe(infiniteLoader.value);
        else if (!isOpen.value && observer.value) observer.value.disconnect();
    };
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(isOpen, ()=>{
        if (!infinite.value) return;
        observe();
    });
    (0, $8bTPG.watch)(search, ()=>{
        if (!infinite.value) return;
        offset.value = limit.value;
        observe();
    }, {
        flush: 'post'
    });
    (0, $8bTPG.watch)(eo, ()=>{
        if (!infinite.value) return;
        observe();
    }, {
        immediate: false,
        flush: 'post'
    });
    // ================ HOOKS ===============
    (0, $ani5R.onMounted)(()=>{
        /* istanbul ignore else */ if (window && window.IntersectionObserver) observer.value = new IntersectionObserver(handleIntersectionObserver);
    });
    return {
        hasMore: hasMore,
        infiniteLoader: infiniteLoader
    };
}
function $741c336afc2dfa06$var$useA11y(props, context, dep) {
    const { placeholder: placeholder, id: id, valueProp: valueProp, label: labelProp, mode: mode, groupLabel: groupLabel, aria: aria, searchable: searchable } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const pointer = dep.pointer;
    const iv = dep.iv;
    const hasSelected = dep.hasSelected;
    const multipleLabelText = dep.multipleLabelText;
    // ================ DATA ================
    const label = (0, $8bTPG.ref)(null);
    // ============== COMPUTED ==============
    const ariaAssist = $741c336afc2dfa06$var$toRef(()=>`${id.value ? id.value + '-' : ''}assist`);
    const ariaControls = $741c336afc2dfa06$var$toRef(()=>`${id.value ? id.value + '-' : ''}multiselect-options`);
    const ariaActiveDescendant = $741c336afc2dfa06$var$toRef(()=>{
        if (pointer.value) {
            let texts = id.value ? `${id.value}-` : '';
            texts += `${pointer.value.group ? 'multiselect-group' : 'multiselect-option'}-`;
            texts += pointer.value.group ? pointer.value.index : pointer.value[valueProp.value];
            return texts;
        }
    });
    const ariaPlaceholder = $741c336afc2dfa06$var$toRef(()=>{
        return placeholder.value;
    });
    const ariaMultiselectable = $741c336afc2dfa06$var$toRef(()=>{
        return mode.value !== 'single';
    });
    const ariaLabel = (0, $8bTPG.computed)(()=>{
        if (mode.value === 'single' && hasSelected.value) return iv.value[labelProp.value];
        if (mode.value === 'multiple' && hasSelected.value) return multipleLabelText.value;
        if (mode.value === 'tags' && hasSelected.value) return iv.value.map((v)=>v[labelProp.value]).join(', ');
        return '';
    });
    const arias = (0, $8bTPG.computed)(()=>{
        let arias = {
            ...aria.value
        };
        // Need to add manually because focusing
        // the input won't read the selected value
        if (searchable.value) {
            arias['aria-labelledby'] = arias['aria-labelledby'] ? `${ariaAssist.value} ${arias['aria-labelledby']}` : ariaAssist.value;
            if (ariaLabel.value && arias['aria-label']) arias['aria-label'] = `${ariaLabel.value}, ${arias['aria-label']}`;
        }
        return arias;
    });
    // =============== METHODS ==============
    const ariaOptionId = (option)=>`${id.value ? id.value + '-' : ''}multiselect-option-${option[valueProp.value]}`;
    const ariaGroupId = (option)=>`${id.value ? id.value + '-' : ''}multiselect-group-${option.index}`;
    const ariaOptionLabel = (label)=>`${label}`;
    const ariaGroupLabel = (label)=>`${label}`;
    const ariaTagLabel = (label)=>`${label} \u{274E}`;
    // =============== HOOKS ================
    (0, $ani5R.onMounted)(()=>{
        /* istanbul ignore next */ if (id.value && document && document.querySelector) {
            let forTag = document.querySelector(`[for="${id.value}"]`);
            label.value = forTag ? forTag.innerText : null;
        }
    });
    return {
        arias: arias,
        ariaLabel: ariaLabel,
        ariaAssist: ariaAssist,
        ariaControls: ariaControls,
        ariaPlaceholder: ariaPlaceholder,
        ariaMultiselectable: ariaMultiselectable,
        ariaActiveDescendant: ariaActiveDescendant,
        ariaOptionId: ariaOptionId,
        ariaOptionLabel: ariaOptionLabel,
        ariaGroupId: ariaGroupId,
        ariaGroupLabel: ariaGroupLabel,
        ariaTagLabel: ariaTagLabel
    };
}
function $741c336afc2dfa06$var$useI18n(props, context, dep) {
    const { locale: locale, fallbackLocale: fallbackLocale } = (0, $8bTPG.toRefs)(props);
    // =============== METHODS ==============
    const localize = (target)=>{
        if (!target || typeof target !== 'object') return target;
        if (target && target[locale.value]) return target[locale.value];
        else if (target && locale.value && target[locale.value.toUpperCase()]) return target[locale.value.toUpperCase()];
        else if (target && target[fallbackLocale.value]) return target[fallbackLocale.value];
        else if (target && fallbackLocale.value && target[fallbackLocale.value.toUpperCase()]) return target[fallbackLocale.value.toUpperCase()];
        else if (target && Object.keys(target)[0]) return target[Object.keys(target)[0]];
        else return '';
    };
    return {
        localize: localize
    };
}
function $741c336afc2dfa06$var$useRefs(props, context, dep) {
    // ================ DATA ================
    const multiselect = (0, $8bTPG.shallowRef)(null);
    const wrapper = (0, $8bTPG.shallowRef)(null);
    const tags = (0, $8bTPG.shallowRef)(null);
    const input = (0, $8bTPG.shallowRef)(null);
    const dropdown = (0, $8bTPG.shallowRef)(null);
    return {
        multiselect: multiselect,
        wrapper: wrapper,
        tags: tags,
        input: input,
        dropdown: dropdown
    };
}
function $741c336afc2dfa06$var$resolveDeps(props, context, features, deps = {}) {
    features.forEach((composable)=>{
        deps = {
            ...deps,
            ...composable(props, context, deps)
        };
    });
    return deps;
}
var $741c336afc2dfa06$var$script$_ = {
    name: 'Multiselect',
    emits: [
        'paste',
        'open',
        'close',
        'select',
        'deselect',
        'input',
        'search-change',
        'tag',
        'option',
        'update:modelValue',
        'change',
        'clear',
        'keydown',
        'keyup',
        'max',
        'create'
    ],
    props: {
        value: {
            required: false
        },
        modelValue: {
            required: false
        },
        options: {
            type: [
                Array,
                Object,
                Function
            ],
            required: false,
            default: ()=>[]
        },
        id: {
            type: [
                String,
                Number
            ],
            required: false,
            default: undefined
        },
        name: {
            type: [
                String,
                Number
            ],
            required: false,
            default: 'multiselect'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: false,
            default: 'label'
        },
        trackBy: {
            type: [
                String,
                Array
            ],
            required: false,
            default: undefined
        },
        valueProp: {
            type: String,
            required: false,
            default: 'value'
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        mode: {
            type: String,
            required: false,
            default: 'single'
        },
        searchable: {
            type: Boolean,
            required: false,
            default: false
        },
        limit: {
            type: Number,
            required: false,
            default: -1
        },
        hideSelected: {
            type: Boolean,
            required: false,
            default: true
        },
        createTag: {
            type: Boolean,
            required: false,
            default: undefined
        },
        createOption: {
            type: Boolean,
            required: false,
            default: undefined
        },
        appendNewTag: {
            type: Boolean,
            required: false,
            default: undefined
        },
        appendNewOption: {
            type: Boolean,
            required: false,
            default: undefined
        },
        addTagOn: {
            type: Array,
            required: false,
            default: undefined
        },
        addOptionOn: {
            type: Array,
            required: false,
            default: undefined
        },
        caret: {
            type: Boolean,
            required: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        noOptionsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: 'The list is empty'
        },
        noResultsText: {
            type: [
                String,
                Object
            ],
            required: false,
            default: 'No results found'
        },
        multipleLabel: {
            type: Function,
            required: false,
            default: undefined
        },
        object: {
            type: Boolean,
            required: false,
            default: false
        },
        delay: {
            type: Number,
            required: false,
            default: -1
        },
        minChars: {
            type: Number,
            required: false,
            default: 0
        },
        resolveOnLoad: {
            type: Boolean,
            required: false,
            default: true
        },
        filterResults: {
            type: Boolean,
            required: false,
            default: true
        },
        clearOnSearch: {
            type: Boolean,
            required: false,
            default: false
        },
        clearOnSelect: {
            type: Boolean,
            required: false,
            default: true
        },
        canDeselect: {
            type: Boolean,
            required: false,
            default: true
        },
        canClear: {
            type: Boolean,
            required: false,
            default: true
        },
        max: {
            type: Number,
            required: false,
            default: -1
        },
        showOptions: {
            type: Boolean,
            required: false,
            default: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        openDirection: {
            type: String,
            required: false,
            default: 'bottom'
        },
        nativeSupport: {
            type: Boolean,
            required: false,
            default: false
        },
        classes: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        strict: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnSelect: {
            type: Boolean,
            required: false,
            default: true
        },
        closeOnDeselect: {
            type: Boolean,
            required: false,
            default: false
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined
        },
        groups: {
            type: Boolean,
            required: false,
            default: false
        },
        groupLabel: {
            type: String,
            required: false,
            default: 'label'
        },
        groupOptions: {
            type: String,
            required: false,
            default: 'options'
        },
        groupHideEmpty: {
            type: Boolean,
            required: false,
            default: false
        },
        groupSelect: {
            type: Boolean,
            required: false,
            default: true
        },
        inputType: {
            type: String,
            required: false,
            default: 'text'
        },
        attrs: {
            required: false,
            type: Object,
            default: ()=>({})
        },
        onCreate: {
            required: false,
            type: Function,
            default: undefined
        },
        disabledProp: {
            type: String,
            required: false,
            default: 'disabled'
        },
        searchStart: {
            type: Boolean,
            required: false,
            default: false
        },
        reverse: {
            type: Boolean,
            required: false,
            default: false
        },
        regex: {
            type: [
                Object,
                String,
                RegExp
            ],
            required: false,
            default: undefined
        },
        rtl: {
            type: Boolean,
            required: false,
            default: false
        },
        infinite: {
            type: Boolean,
            required: false,
            default: false
        },
        aria: {
            required: false,
            type: Object,
            default: ()=>({})
        },
        clearOnBlur: {
            required: false,
            type: Boolean,
            default: true
        },
        locale: {
            required: false,
            type: String,
            default: null
        },
        fallbackLocale: {
            required: false,
            type: String,
            default: 'en'
        },
        searchFilter: {
            required: false,
            type: Function,
            default: null
        },
        allowAbsent: {
            required: false,
            type: Boolean,
            default: false
        },
        appendToBody: {
            required: false,
            type: Boolean,
            default: false
        },
        closeOnScroll: {
            required: false,
            type: Boolean,
            default: false
        },
        breakTags: {
            required: false,
            type: Boolean,
            default: false
        },
        appendTo: {
            required: false,
            type: String,
            default: undefined
        }
    },
    setup (props, context) {
        return $741c336afc2dfa06$var$resolveDeps(props, context, [
            $741c336afc2dfa06$var$useRefs,
            $741c336afc2dfa06$var$useI18n,
            $741c336afc2dfa06$var$useValue$3,
            $741c336afc2dfa06$var$usePointer$1,
            $741c336afc2dfa06$var$useDropdown,
            $741c336afc2dfa06$var$useSearch,
            $741c336afc2dfa06$var$useData,
            $741c336afc2dfa06$var$useMultiselect,
            $741c336afc2dfa06$var$useOptions,
            $741c336afc2dfa06$var$useScroll,
            $741c336afc2dfa06$var$usePointer,
            $741c336afc2dfa06$var$useKeyboard,
            $741c336afc2dfa06$var$useClasses$2,
            $741c336afc2dfa06$var$useA11y
        ]);
    },
    beforeMount () {
        if (this.$root.constructor && this.$root.constructor.version && this.$root.constructor.version.match(/^2\./) || this.vueVersionMs === 2) {
            if (!this.$options.components.Teleport) this.$options.components.Teleport = {
                render () {
                    return this.$slots.default ? this.$slots.default[0] : null;
                }
            };
        }
    }
};
const $741c336afc2dfa06$var$_hoisted_1$n = [
    "id",
    "dir"
];
const $741c336afc2dfa06$var$_hoisted_2$f = [
    "tabindex",
    "aria-controls",
    "aria-placeholder",
    "aria-expanded",
    "aria-activedescendant",
    "aria-multiselectable",
    "role"
];
const $741c336afc2dfa06$var$_hoisted_3$a = [
    "type",
    "modelValue",
    "value",
    "autocomplete",
    "id",
    "aria-controls",
    "aria-placeholder",
    "aria-expanded",
    "aria-activedescendant",
    "aria-multiselectable"
];
const $741c336afc2dfa06$var$_hoisted_4$7 = [
    "onKeyup",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_5$4 = [
    "onClick"
];
const $741c336afc2dfa06$var$_hoisted_6$3 = [
    "type",
    "modelValue",
    "value",
    "id",
    "autocomplete",
    "aria-controls",
    "aria-placeholder",
    "aria-expanded",
    "aria-activedescendant",
    "aria-multiselectable"
];
const $741c336afc2dfa06$var$_hoisted_7$2 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_8$1 = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_9$1 = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_10$1 = [
    "id",
    "aria-label",
    "aria-selected"
];
const $741c336afc2dfa06$var$_hoisted_11$1 = [
    "data-pointed",
    "onMouseenter",
    "onClick"
];
const $741c336afc2dfa06$var$_hoisted_12$1 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_13$1 = [
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_14 = [
    "data-pointed",
    "data-selected",
    "onMouseenter",
    "onClick",
    "id",
    "aria-selected",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_15 = [
    "data-pointed",
    "data-selected",
    "onMouseenter",
    "onClick",
    "id",
    "aria-selected",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_16 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_17 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_18 = [
    "value"
];
const $741c336afc2dfa06$var$_hoisted_19 = [
    "name",
    "value"
];
const $741c336afc2dfa06$var$_hoisted_20 = [
    "name",
    "value"
];
const $741c336afc2dfa06$var$_hoisted_21 = [
    "id"
];
function $741c336afc2dfa06$var$render$s(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        ref: "multiselect",
        class: (0, $X5A94.normalizeClass)(_ctx.classList.container),
        id: $props.searchable ? undefined : $props.id,
        dir: $props.rtl ? 'rtl' : undefined,
        onFocusin: _cache[12] || (_cache[12] = (...args)=>_ctx.handleFocusIn && _ctx.handleFocusIn(...args)),
        onFocusout: _cache[13] || (_cache[13] = (...args)=>_ctx.handleFocusOut && _ctx.handleFocusOut(...args)),
        onKeyup: _cache[14] || (_cache[14] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args)),
        onKeydown: _cache[15] || (_cache[15] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args))
    }, [
        (0, $ani5R.createElementVNode)("div", (0, $ani5R.mergeProps)({
            class: _ctx.classList.wrapper,
            onMousedown: _cache[9] || (_cache[9] = (...args)=>_ctx.handleMousedown && _ctx.handleMousedown(...args)),
            ref: "wrapper",
            tabindex: _ctx.tabindex,
            "aria-controls": !$props.searchable ? _ctx.ariaControls : undefined,
            "aria-placeholder": !$props.searchable ? _ctx.ariaPlaceholder : undefined,
            "aria-expanded": !$props.searchable ? _ctx.isOpen : undefined,
            "aria-activedescendant": !$props.searchable ? _ctx.ariaActiveDescendant : undefined,
            "aria-multiselectable": !$props.searchable ? _ctx.ariaMultiselectable : undefined,
            role: !$props.searchable ? 'combobox' : undefined
        }, !$props.searchable ? _ctx.arias : {}), [
            (0, $ani5R.createCommentVNode)(" Search "),
            $props.mode !== 'tags' && $props.searchable && !$props.disabled ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", (0, $ani5R.mergeProps)({
                key: 0,
                type: $props.inputType,
                modelValue: _ctx.search,
                value: _ctx.search,
                class: _ctx.classList.search,
                autocomplete: $props.autocomplete,
                id: $props.searchable ? $props.id : undefined,
                onInput: _cache[0] || (_cache[0] = (...args)=>_ctx.handleSearchInput && _ctx.handleSearchInput(...args)),
                onKeypress: _cache[1] || (_cache[1] = (...args)=>_ctx.handleKeypress && _ctx.handleKeypress(...args)),
                onPaste: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handlePaste && _ctx.handlePaste(...args), [
                    "stop"
                ])),
                ref: "input",
                "aria-controls": _ctx.ariaControls,
                "aria-placeholder": _ctx.ariaPlaceholder,
                "aria-expanded": _ctx.isOpen,
                "aria-activedescendant": _ctx.ariaActiveDescendant,
                "aria-multiselectable": _ctx.ariaMultiselectable,
                role: "combobox"
            }, {
                ...$props.attrs,
                ..._ctx.arias
            }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_3$a)) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Tags (with search) "),
            $props.mode == 'tags' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                key: 1,
                class: (0, $X5A94.normalizeClass)(_ctx.classList.tags),
                "data-tags": ""
            }, [
                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.iv, (option, i, key)=>{
                    return (0, $ani5R.renderSlot)(_ctx.$slots, "tag", {
                        option: option,
                        handleTagRemove: _ctx.handleTagRemove,
                        disabled: $props.disabled
                    }, ()=>[
                            ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                class: (0, $X5A94.normalizeClass)([
                                    _ctx.classList.tag,
                                    option.disabled ? _ctx.classList.tagDisabled : null
                                ]),
                                tabindex: "-1",
                                onKeyup: (0, $dDLnc.withKeys)(($event)=>_ctx.handleTagRemove(option, $event), [
                                    "enter"
                                ]),
                                key: key,
                                "aria-label": _ctx.ariaTagLabel(_ctx.localize(option[$props.label]))
                            }, [
                                (0, $ani5R.createElementVNode)("span", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classList.tagWrapper)
                                }, (0, $X5A94.toDisplayString)(_ctx.localize(option[$props.label])), 3 /* TEXT, CLASS */ ),
                                !$props.disabled && !option.disabled ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                                    key: 0,
                                    class: (0, $X5A94.normalizeClass)(_ctx.classList.tagRemove),
                                    onClick: (0, $dDLnc.withModifiers)(($event)=>_ctx.handleTagRemove(option, $event), [
                                        "stop"
                                    ])
                                }, [
                                    (0, $ani5R.createElementVNode)("span", {
                                        class: (0, $X5A94.normalizeClass)(_ctx.classList.tagRemoveIcon)
                                    }, null, 2 /* CLASS */ )
                                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_5$4)) : (0, $ani5R.createCommentVNode)("v-if", true)
                            ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_4$7))
                        ]);
                }), 256 /* UNKEYED_FRAGMENT */ )),
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classList.tagsSearchWrapper),
                    ref: "tags"
                }, [
                    (0, $ani5R.createCommentVNode)(" Used for measuring search width "),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.tagsSearchCopy)
                    }, (0, $X5A94.toDisplayString)(_ctx.search), 3 /* TEXT, CLASS */ ),
                    (0, $ani5R.createCommentVNode)(" Actual search input "),
                    $props.searchable && !$props.disabled ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", (0, $ani5R.mergeProps)({
                        key: 0,
                        type: $props.inputType,
                        modelValue: _ctx.search,
                        value: _ctx.search,
                        class: _ctx.classList.tagsSearch,
                        id: $props.searchable ? $props.id : undefined,
                        autocomplete: $props.autocomplete,
                        onInput: _cache[3] || (_cache[3] = (...args)=>_ctx.handleSearchInput && _ctx.handleSearchInput(...args)),
                        onKeypress: _cache[4] || (_cache[4] = (...args)=>_ctx.handleKeypress && _ctx.handleKeypress(...args)),
                        onPaste: _cache[5] || (_cache[5] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handlePaste && _ctx.handlePaste(...args), [
                            "stop"
                        ])),
                        ref: "input",
                        "aria-controls": _ctx.ariaControls,
                        "aria-placeholder": _ctx.ariaPlaceholder,
                        "aria-expanded": _ctx.isOpen,
                        "aria-activedescendant": _ctx.ariaActiveDescendant,
                        "aria-multiselectable": _ctx.ariaMultiselectable,
                        role: "combobox"
                    }, {
                        ...$props.attrs,
                        ..._ctx.arias
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_6$3)) : (0, $ani5R.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ )
            ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Single label "),
            $props.mode == 'single' && _ctx.hasSelected && !_ctx.search && _ctx.iv ? (0, $ani5R.renderSlot)(_ctx.$slots, "singlelabel", {
                key: 2,
                value: _ctx.iv
            }, ()=>[
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.singleLabel)
                    }, [
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.singleLabelText)
                        }, (0, $X5A94.toDisplayString)(_ctx.localize(_ctx.iv[$props.label])), 3 /* TEXT, CLASS */ )
                    ], 2 /* CLASS */ )
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Multiple label "),
            $props.mode == 'multiple' && _ctx.hasSelected && !_ctx.search ? (0, $ani5R.renderSlot)(_ctx.$slots, "multiplelabel", {
                key: 3,
                values: _ctx.iv
            }, ()=>[
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.multipleLabel),
                        innerHTML: _ctx.multipleLabelText
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_7$2)
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Placeholder "),
            $props.placeholder && !_ctx.hasSelected && !_ctx.search ? (0, $ani5R.renderSlot)(_ctx.$slots, "placeholder", {
                key: 4
            }, ()=>[
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.placeholder),
                        "aria-hidden": "true"
                    }, (0, $X5A94.toDisplayString)($props.placeholder), 3 /* TEXT, CLASS */ )
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Spinner "),
            $props.loading || _ctx.resolving ? (0, $ani5R.renderSlot)(_ctx.$slots, "spinner", {
                key: 5
            }, ()=>[
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.spinner),
                        "aria-hidden": "true"
                    }, null, 2 /* CLASS */ )
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Clear "),
            _ctx.hasSelected && !$props.disabled && $props.canClear && !_ctx.busy ? (0, $ani5R.renderSlot)(_ctx.$slots, "clear", {
                key: 6,
                clear: _ctx.clear
            }, ()=>[
                    (0, $ani5R.createElementVNode)("span", {
                        "aria-hidden": "true",
                        tabindex: "0",
                        role: "button",
                        "data-clear": "",
                        "aria-roledescription": "\u274E",
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.clear),
                        onClick: _cache[6] || (_cache[6] = (...args)=>_ctx.clear && _ctx.clear(...args)),
                        onKeyup: _cache[7] || (_cache[7] = (0, $dDLnc.withKeys)((...args)=>_ctx.clear && _ctx.clear(...args), [
                            "enter"
                        ]))
                    }, [
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.clearIcon)
                        }, null, 2 /* CLASS */ )
                    ], 34 /* CLASS, NEED_HYDRATION */ )
                ]) : (0, $ani5R.createCommentVNode)("v-if", true),
            (0, $ani5R.createCommentVNode)(" Caret "),
            $props.caret && $props.showOptions ? (0, $ani5R.renderSlot)(_ctx.$slots, "caret", {
                key: 7,
                handleCaretClick: _ctx.handleCaretClick,
                isOpen: _ctx.isOpen
            }, ()=>[
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.caret),
                        onClick: _cache[8] || (_cache[8] = (...args)=>_ctx.handleCaretClick && _ctx.handleCaretClick(...args)),
                        "aria-hidden": "true"
                    }, null, 2 /* CLASS */ )
                ]) : (0, $ani5R.createCommentVNode)("v-if", true)
        ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_2$f),
        (0, $ani5R.createCommentVNode)(" Options "),
        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.Teleport), {
            to: $props.appendTo || 'body',
            disabled: !$props.appendToBody && !$props.appendTo
        }, [
            (0, $ani5R.createElementVNode)("div", {
                id: $props.id ? `${$props.id}-dropdown` : undefined,
                class: (0, $X5A94.normalizeClass)(_ctx.classList.dropdown),
                tabindex: "-1",
                ref: "dropdown",
                onFocusin: _cache[10] || (_cache[10] = (...args)=>_ctx.handleFocusIn && _ctx.handleFocusIn(...args)),
                onFocusout: _cache[11] || (_cache[11] = (...args)=>_ctx.handleFocusOut && _ctx.handleFocusOut(...args))
            }, [
                (0, $ani5R.renderSlot)(_ctx.$slots, "beforelist", {
                    options: _ctx.fo
                }),
                (0, $ani5R.createElementVNode)("ul", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classList.options),
                    id: _ctx.ariaControls,
                    role: "listbox"
                }, [
                    $props.groups ? ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 0
                    }, (0, $ani5R.renderList)(_ctx.fg, (group, i, key)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.group),
                            key: key,
                            id: _ctx.ariaGroupId(group),
                            "aria-label": _ctx.ariaGroupLabel(_ctx.localize(group[$props.groupLabel])),
                            "aria-selected": _ctx.isSelected(group),
                            role: "option"
                        }, [
                            !group.__CREATE__ ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                key: 0,
                                class: (0, $X5A94.normalizeClass)(_ctx.classList.groupLabel(group)),
                                "data-pointed": _ctx.isPointed(group),
                                onMouseenter: ($event)=>_ctx.setPointer(group, i),
                                onClick: ($event)=>_ctx.handleGroupClick(group)
                            }, [
                                (0, $ani5R.renderSlot)(_ctx.$slots, "grouplabel", {
                                    group: group,
                                    isSelected: _ctx.isSelected,
                                    isPointed: _ctx.isPointed
                                }, ()=>[
                                        (0, $ani5R.createElementVNode)("span", {
                                            innerHTML: _ctx.localize(group[$props.groupLabel])
                                        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_12$1)
                                    ])
                            ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_11$1)) : (0, $ani5R.createCommentVNode)("v-if", true),
                            (0, $ani5R.createElementVNode)("ul", {
                                class: (0, $X5A94.normalizeClass)(_ctx.classList.groupOptions),
                                "aria-label": _ctx.ariaGroupLabel(_ctx.localize(group[$props.groupLabel])),
                                role: "group"
                            }, [
                                ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(group.__VISIBLE__, (option, i, key)=>{
                                    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                                        class: (0, $X5A94.normalizeClass)(_ctx.classList.option(option, group)),
                                        "data-pointed": _ctx.isPointed(option),
                                        "data-selected": _ctx.isSelected(option) || undefined,
                                        key: key,
                                        onMouseenter: ($event)=>_ctx.setPointer(option),
                                        onClick: ($event)=>_ctx.handleOptionClick(option),
                                        id: _ctx.ariaOptionId(option),
                                        "aria-selected": _ctx.isSelected(option),
                                        "aria-label": _ctx.ariaOptionLabel(_ctx.localize(option[$props.label])),
                                        role: "option"
                                    }, [
                                        (0, $ani5R.renderSlot)(_ctx.$slots, "option", {
                                            option: option,
                                            isSelected: _ctx.isSelected,
                                            isPointed: _ctx.isPointed,
                                            search: _ctx.search
                                        }, ()=>[
                                                (0, $ani5R.createElementVNode)("span", null, (0, $X5A94.toDisplayString)(_ctx.localize(option[$props.label])), 1 /* TEXT */ )
                                            ])
                                    ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_14);
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_13$1)
                        ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_10$1);
                    }), 128 /* KEYED_FRAGMENT */ )) : ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, (0, $ani5R.renderList)(_ctx.fo, (option, i, key)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("li", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.option(option)),
                            "data-pointed": _ctx.isPointed(option),
                            "data-selected": _ctx.isSelected(option) || undefined,
                            key: key,
                            onMouseenter: ($event)=>_ctx.setPointer(option),
                            onClick: ($event)=>_ctx.handleOptionClick(option),
                            id: _ctx.ariaOptionId(option),
                            "aria-selected": _ctx.isSelected(option),
                            "aria-label": _ctx.ariaOptionLabel(_ctx.localize(option[$props.label])),
                            role: "option"
                        }, [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "option", {
                                option: option,
                                isSelected: _ctx.isSelected,
                                isPointed: _ctx.isPointed,
                                search: _ctx.search
                            }, ()=>[
                                    (0, $ani5R.createElementVNode)("span", null, (0, $X5A94.toDisplayString)(_ctx.localize(option[$props.label])), 1 /* TEXT */ )
                                ])
                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_15);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_9$1),
                _ctx.noOptions ? (0, $ani5R.renderSlot)(_ctx.$slots, "nooptions", {
                    key: 0
                }, ()=>[
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.noOptions),
                            innerHTML: _ctx.localize($props.noOptionsText)
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_16)
                    ]) : (0, $ani5R.createCommentVNode)("v-if", true),
                _ctx.noResults ? (0, $ani5R.renderSlot)(_ctx.$slots, "noresults", {
                    key: 1
                }, ()=>[
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classList.noResults),
                            innerHTML: _ctx.localize($props.noResultsText)
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_17)
                    ]) : (0, $ani5R.createCommentVNode)("v-if", true),
                $props.infinite && _ctx.hasMore ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 2,
                    class: (0, $X5A94.normalizeClass)(_ctx.classList.inifinite),
                    ref: "infiniteLoader"
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "infinite", {}, ()=>[
                            (0, $ani5R.createElementVNode)("span", {
                                class: (0, $X5A94.normalizeClass)(_ctx.classList.inifiniteSpinner)
                            }, null, 2 /* CLASS */ )
                        ])
                ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.renderSlot)(_ctx.$slots, "afterlist", {
                    options: _ctx.fo
                })
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_8$1)
        ], 8 /* PROPS */ , [
            "to",
            "disabled"
        ])),
        (0, $ani5R.createCommentVNode)(" Hacky input element to show HTML5 required warning "),
        $props.required ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classList.fakeInput),
            tabindex: "-1",
            value: _ctx.textValue,
            required: ""
        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_18)) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Native input support "),
        $props.nativeSupport ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 1
        }, [
            $props.mode == 'single' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", {
                key: 0,
                type: "hidden",
                name: $props.name,
                value: _ctx.plainValue !== undefined ? _ctx.plainValue : ''
            }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_19)) : ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                key: 1
            }, (0, $ani5R.renderList)(_ctx.plainValue, (v, i)=>{
                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", {
                    type: "hidden",
                    name: `${$props.name}[]`,
                    value: v,
                    key: i
                }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_20);
            }), 128 /* KEYED_FRAGMENT */ ))
        ], 64 /* STABLE_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Screen reader assistive text "),
        $props.searchable && _ctx.hasSelected ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 2,
            class: (0, $X5A94.normalizeClass)(_ctx.classList.assist),
            id: _ctx.ariaAssist,
            "aria-hidden": "true"
        }, (0, $X5A94.toDisplayString)(_ctx.ariaLabel), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_21)) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Create height for empty input "),
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classList.spacer)
        }, null, 2 /* CLASS */ )
    ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_1$n);
}
$741c336afc2dfa06$var$script$_.render = $741c336afc2dfa06$var$render$s;
$741c336afc2dfa06$var$script$_.__file = "node_modules/@vueform/multiselect/src/Multiselect.vue";
var $741c336afc2dfa06$var$script$Z = {
    name: 'MultiselectElement',
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: '',
                inputWrapper: '',
                select: {
                    container: '',
                    containerDisabled: '',
                    containerOpen: '',
                    containerOpenTop: '',
                    containerActive: '',
                    multipleLabel: '',
                    search: '',
                    placeholder: '',
                    caret: '',
                    caretOpen: '',
                    clear: '',
                    clearIcon: '',
                    spinner: '',
                    dropdown: '',
                    dropdownTop: '',
                    dropdownHidden: '',
                    options: '',
                    optionsTop: '',
                    group: '',
                    groupLabel: '',
                    groupLabelPointable: '',
                    groupLabelPointed: '',
                    groupLabelSelected: '',
                    groupLabelDisabled: '',
                    groupLabelSelectedPointed: '',
                    groupLabelSelectedDisabled: '',
                    groupOptions: '',
                    option: '',
                    optionPointed: '',
                    optionSelected: '',
                    optionDisabled: '',
                    optionSelectedPointed: '',
                    optionSelectedDisabled: '',
                    noOptions: '',
                    noResults: '',
                    fakeInput: '',
                    spacer: ''
                }
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$m = [
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$e = [
    "value"
];
function $741c336afc2dfa06$var$render$r(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_Multiselect = (0, $ani5R.resolveComponent)("Multiselect");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                    key: 0,
                    visible: !_ctx.empty
                }, null, 8 /* PROPS */ , [
                    "visible"
                ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Native select "),
                _ctx.isNative ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputWrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", (0, $ani5R.mergeProps)({
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event),
                        class: _ctx.classes.input,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        multiple: true,
                        disabled: _ctx.isDisabled
                    }, {
                        ..._ctx.attrs,
                        ..._ctx.aria
                    }, {
                        ref: "input"
                    }), [
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedOptions, (option, index)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                value: option.value,
                                key: index
                            }, (0, $X5A94.toDisplayString)(option.label), 9 /* TEXT, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$e);
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$m), [
                        [
                            (0, $dDLnc.vModelSelect),
                            _ctx.value
                        ]
                    ]),
                    _ctx.placeholder && _ctx.empty && !_ctx.isDisabled && _ctx.type == 'select' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.inputPlaceholder)
                    }, (0, $X5A94.toDisplayString)(_ctx.Placeholder), 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 2
                }, [
                    (0, $ani5R.createCommentVNode)(" @vueform/multiselect copmonent "),
                    (0, $ani5R.createVNode)(_component_Multiselect, (0, $ani5R.mergeProps)(_ctx.fieldOptions, {
                        modelValue: _ctx.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.value = $event),
                        classes: _ctx.classes.select,
                        id: _ctx.fieldId,
                        name: _ctx.name,
                        options: _ctx.resolvedOptions,
                        disabled: _ctx.isDisabled,
                        placeholder: _ctx.Placeholder,
                        attrs: _ctx.attrs,
                        aria: _ctx.aria,
                        locale: _ctx.form$.locale$,
                        onSelect: _ctx.handleSelect,
                        onDeselect: _ctx.handleDeselect,
                        onSearchChange: _ctx.handleSearchChange,
                        onTag: _ctx.handleTag,
                        onOpen: _ctx.handleOpen,
                        onClose: _ctx.handleClose,
                        onClear: _ctx.handleClear,
                        onPaste: _ctx.handlePaste,
                        ref: "input"
                    }), (0, $ani5R.createSlots)({
                        _: 2 /* DYNAMIC */ 
                    }, [
                        (0, $ani5R.renderList)({
                            option: 'option',
                            noresults: 'no-results',
                            nooptions: 'no-options',
                            afterlist: 'after-list',
                            beforelist: 'before-list',
                            placeholder: 'placeholder',
                            grouplabel: 'group-label',
                            caret: 'caret',
                            clear: 'clear',
                            spinner: 'spinner',
                            default: 'default'
                        }, (slotName, slotKey)=>{
                            return {
                                name: slotKey,
                                fn: (0, $ani5R.withCtx)((props)=>[
                                        (0, $ani5R.renderSlot)(_ctx.$slots, slotName, (0, $ani5R.mergeProps)(props, {
                                            el$: _ctx.el$
                                        }), ()=>[
                                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots[slotName]), (0, $ani5R.mergeProps)(props, {
                                                    el$: _ctx.el$
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "el$"
                                                ]))
                                            ])
                                    ])
                            };
                        }),
                        _ctx.fieldOptions.mode == 'multiple' ? {
                            name: "multiplelabel",
                            fn: (0, $ani5R.withCtx)(({ values: values })=>[
                                    (0, $ani5R.renderSlot)(_ctx.$slots, "multiple-label", {
                                        values: values,
                                        el$: _ctx.el$
                                    }, ()=>[
                                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['multiple-label']), {
                                                values: values,
                                                el$: _ctx.el$
                                            }, null, 8 /* PROPS */ , [
                                                "values",
                                                "el$"
                                            ]))
                                        ])
                                ]),
                            key: "0"
                        } : undefined
                    ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */ , [
                        "modelValue",
                        "classes",
                        "id",
                        "name",
                        "options",
                        "disabled",
                        "placeholder",
                        "attrs",
                        "aria",
                        "locale",
                        "onSelect",
                        "onDeselect",
                        "onSearchChange",
                        "onTag",
                        "onOpen",
                        "onClose",
                        "onClear",
                        "onPaste"
                    ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$Z.render = $741c336afc2dfa06$var$render$r;
$741c336afc2dfa06$var$script$Z.__file = "themes/blank/templates/elements/MultiselectElement.vue";
var $741c336afc2dfa06$export$f04bd98b66887a8c = {
    name: 'MultiselectElement',
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    render: $741c336afc2dfa06$var$script$Z.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                input: 'vf-input vf-native-multiselect',
                input_enabled: '',
                input_disabled: '',
                input_success: 'vf-input-success',
                input_danger: 'vf-input-danger',
                input_sm: 'vf-input-sm',
                input_md: '',
                input_lg: 'vf-input-lg',
                inputWrapper: 'vf-native-multiselect-wrapper',
                select: {
                    multipleLabel: 'vf-multiselect-multiple-label',
                    multipleLabel_sm: 'vf-multiselect-multiple-label-sm',
                    multipleLabel_md: '',
                    multipleLabel_lg: 'vf-multiselect-multiple-label-lg',
                    multipleLabel_noClear: 'vf-multiselect-multiple-label-no-clear',
                    multipleLabel_noCaret: 'vf-multiselect-multiple-label-no-caret',
                    container: 'vf-multiselect',
                    container_enabled: '',
                    container_disabled: 'vf-multiselect-disabled',
                    container_success: 'vf-multiselect-success',
                    container_danger: 'vf-multiselect-danger',
                    container_sm: 'vf-multiselect-sm',
                    container_md: '',
                    container_lg: 'vf-multiselect-lg',
                    containerDisabled: '',
                    containerOpen: 'vf-multiselect-open',
                    containerOpenTop: 'vf-multiselect-open-top',
                    containerActive: 'vf-multiselect-active',
                    containerActive_enabled: '',
                    wrapper: 'vf-multiselect-wrapper',
                    wrapper_sm: 'vf-multiselect-wrapper-sm',
                    wrapper_md: '',
                    wrapper_lg: 'vf-multiselect-wrapper-lg',
                    search: 'vf-multiselect-search',
                    search_sm: 'vf-multiselect-search-sm',
                    search_md: '',
                    search_lg: 'vf-multiselect-search-lg',
                    placeholder: 'vf-multiselect-placeholder',
                    placeholder_sm: 'vf-multiselect-placeholder-sm',
                    placeholder_md: '',
                    placeholder_lg: 'vf-multiselect-placeholder-lg',
                    caret: 'vf-multiselect-caret',
                    caret_sm: 'vf-multiselect-caret-sm',
                    caret_md: '',
                    caret_lg: 'vf-multiselect-caret-lg',
                    caretOpen: 'vf-multiselect-caret-open',
                    clear: 'vf-multiselect-clear',
                    clear_sm: 'vf-multiselect-clear-sm',
                    clear_md: '',
                    clear_lg: 'vf-multiselect-clear-lg',
                    clearIcon: 'vf-multiselect-clear-icon',
                    spinner: 'vf-multiselect-spinner',
                    spinner_sm: 'vf-multiselect-spinner-sm',
                    spinner_md: '',
                    spinner_lg: 'vf-multiselect-spinner-lg',
                    infinite: 'vf-multiselect-infinite',
                    infinite_sm: 'vf-multiselect-infinite-sm',
                    infinite_md: '',
                    infinite_lg: 'vf-multiselect-infinite-lg',
                    infiniteSpinner: 'vf-multiselect-infinite-spinner',
                    dropdown: 'vf-multiselect-dropdown',
                    dropdown_sm: 'vf-multiselect-dropdown-sm',
                    dropdown_md: '',
                    dropdown_lg: 'vf-multiselect-dropdown-lg',
                    dropdownTop: 'vf-multiselect-dropdown-top',
                    dropdownTop_sm: 'vf-multiselect-dropdown-top-sm',
                    dropdownTop_md: '',
                    dropdownTop_lg: 'vf-multiselect-dropdown-top-lg',
                    dropdownHidden: 'vf-multiselect-dropdown-hidden',
                    options: 'vf-multiselect-options',
                    optionsTop: 'vf-multiselect-options-top',
                    group: 'vf-multiselect-group',
                    groupLabel: 'vf-multiselect-group-label',
                    groupLabel_sm: 'vf-multiselect-group-label-sm',
                    groupLabel_md: '',
                    groupLabel_lg: 'vf-multiselect-group-label-lg',
                    groupLabelPointable: 'vf-multiselect-group-label-pointable',
                    groupLabelPointed: 'vf-multiselect-group-label-pointed',
                    groupLabelSelected: 'vf-multiselect-group-label-selected',
                    groupLabelDisabled: 'vf-multiselect-group-label-disabled',
                    groupLabelSelectedPointed: 'vf-multiselect-group-label-selected vf-multiselect-group-label-pointed',
                    groupLabelSelectedDisabled: 'vf-multiselect-group-label-selected vf-multiselect-group-label-disabled',
                    groupOptions: 'vf-multiselect-group-options',
                    option: 'vf-multiselect-option',
                    option_sm: 'vf-multiselect-option-sm',
                    option_md: '',
                    option_lg: 'vf-multiselect-option-lg',
                    optionPointed: 'vf-multiselect-option-pointed',
                    optionSelected: 'vf-multiselect-option-selected',
                    optionDisabled: 'vf-multiselect-option-disabled',
                    optionSelectedPointed: 'vf-multiselect-option-selected vf-multiselect-option-pointed',
                    optionSelectedDisabled: 'vf-multiselect-option-selected vf-multiselect-option-disabled',
                    noOptions: 'vf-multiselect-no-options',
                    noOptions_sm: 'vf-multiselect-no-options-sm',
                    noOptions_md: '',
                    noOptions_lg: 'vf-multiselect-no-options-lg',
                    noResults: 'vf-multiselect-no-results',
                    noResults_sm: 'vf-multiselect-no-results-sm',
                    noResults_md: '',
                    noResults_lg: 'vf-multiselect-no-results-lg',
                    fakeInput: 'vf-multiselect-fake-input',
                    assist: 'vf-assistive-text',
                    spacer: 'vf-multiselect-spacer',
                    spacer_sm: 'vf-multiselect-spacer-sm',
                    spacer_md: '',
                    spacer_lg: 'vf-multiselect-spacer-lg',
                    $container: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.container,
                            classes.select[`container_${Size}`],
                            isDisabled ? classes.select.container_disabled : null,
                            !isDisabled && !isSuccess && !isDanger ? classes.select.container_enabled : null,
                            !isDisabled && isDanger ? classes.select.container_danger : null,
                            !isDisabled && isSuccess ? classes.select.container_success : null
                        ],
                    $containerActive: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.containerActive,
                            classes.select[`container_${Size}`],
                            !isDisabled && !isSuccess && !isDanger ? classes.select.containerActive_enabled : null
                        ],
                    $wrapper: (classes, { Size: Size })=>[
                            classes.select.wrapper,
                            classes.select[`wrapper_${Size}`]
                        ],
                    $search: (classes, { Size: Size })=>[
                            classes.select.search,
                            classes.select[`search_${Size}`]
                        ],
                    $placeholder: (classes, { Size: Size })=>[
                            classes.select.placeholder,
                            classes.select[`placeholder_${Size}`]
                        ],
                    $caret: (classes, { Size: Size })=>[
                            classes.select.caret,
                            classes.select[`caret_${Size}`]
                        ],
                    $clear: (classes, { Size: Size })=>[
                            classes.select.clear,
                            classes.select[`clear_${Size}`]
                        ],
                    $spinner: (classes, { Size: Size })=>[
                            classes.select.spinner,
                            classes.select[`spinner_${Size}`]
                        ],
                    $infinite: (classes, { Size: Size })=>[
                            classes.select.infinite,
                            classes.select[`infinite_${Size}`]
                        ],
                    $dropdown: (classes, { Size: Size })=>[
                            classes.select.dropdown,
                            classes.select[`dropdown_${Size}`]
                        ],
                    $dropdownTop: (classes, { Size: Size })=>[
                            classes.select.dropdownTop,
                            classes.select[`dropdownTop_${Size}`]
                        ],
                    $groupLabel: (classes, { Size: Size })=>[
                            classes.select.groupLabel,
                            classes.select[`groupLabel_${Size}`]
                        ],
                    $option: (classes, { Size: Size })=>[
                            classes.select.option,
                            classes.select[`option_${Size}`]
                        ],
                    $spacer: (classes, { Size: Size })=>[
                            classes.select.spacer,
                            classes.select[`spacer_${Size}`]
                        ],
                    $noOptions: (classes, { Size: Size })=>[
                            classes.select.noOptions,
                            classes.select[`noOptions_${Size}`]
                        ],
                    $noResults: (classes, { Size: Size })=>[
                            classes.select.noResults,
                            classes.select[`noResults_${Size}`]
                        ],
                    $multipleLabel: (classes, { Size: Size, canClear: canClear, caret: caret })=>[
                            classes.select.multipleLabel,
                            classes.select[`multipleLabel_${Size}`],
                            !canClear ? classes.select[`multipleLabel_noClear`] : null,
                            !caret ? classes.select[`multipleLabel_noCaret`] : null
                        ]
                },
                $input: (classes, { isDisabled: isDisabled, Size: Size, isDanger: isDanger, isSuccess: isSuccess })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.input_enabled : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$u = "/* Some styles are contained in Vueform.vue & SelectElement.vue */\n\n.vf-multiselect-multiple-label {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  background: transparent;\n  padding-left: var(--vf-px-input);\n  padding-right: calc(var(--vf-px-input) * 2.5 + 20px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-caret, .vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-clear {\n  padding-right: calc(var(--vf-px-input) * 1.5 + 10px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-right: var(--vf-px-input);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: calc(var(--vf-px-input-sm) * 1.5 + 20px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-caret, .vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-clear {\n  padding-right: calc(var(--vf-px-input-sm) * 1.5 + 10px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-right: var(--vf-px-input-sm);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: calc(var(--vf-px-input-lg) * 2.5 + 20px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-caret, .vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-clear {\n  padding-right: calc(var(--vf-px-input-lg) * 1.5 + 10px);\n}\n\n.vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-right: var(--vf-px-input-lg);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-multiple-label,\n.vf-floating-wrapper ~ div .vf-multiselect-multiple-label {\n  padding-top: calc(var(--vf-py-input) + var(--vf-floating-top) / 2);\n  padding-bottom: calc(var(--vf-py-input) - var(--vf-floating-top) / 2);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-multiple-label-sm,\n.vf-floating-wrapper ~ div .vf-multiselect-multiple-label-sm {\n  padding-top: calc(var(--vf-py-input-sm) + var(--vf-floating-top-sm) / 2);\n  padding-bottom: calc(var(--vf-py-input-sm) - var(--vf-floating-top-sm) / 2);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-multiple-label-lg,\n.vf-floating-wrapper ~ div .vf-multiselect-multiple-label-lg {\n  padding-top: calc(var(--vf-py-input-lg) + var(--vf-floating-top-lg) / 2);\n  padding-bottom: calc(var(--vf-py-input-lg) - var(--vf-floating-top-lg) / 2);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label {\n  padding-left: calc(var(--vf-px-input) * 2.5 + 20px);\n  padding-right: var(--vf-px-input);\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-caret, [dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-clear {\n  padding-left: calc(var(--vf-px-input) * 1.5 + 10px);\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-left: var(--vf-px-input);\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm {\n  padding-left: calc(var(--vf-px-input-sm) * 2.5 + 20px);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-caret, [dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-clear {\n  padding-left: calc(var(--vf-px-input-sm) * 1.5 + 10px);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-sm.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg {\n  padding-left: calc(var(--vf-px-input-lg) * 2.5 + 20px);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-caret, [dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-clear {\n  padding-left: calc(var(--vf-px-input-lg) * 1.5 + 10px);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-multiple-label.vf-multiselect-multiple-label-lg.vf-multiselect-multiple-label-no-caret.vf-multiselect-multiple-label-no-clear {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: var(--vf-px-input-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$u);
$741c336afc2dfa06$export$f04bd98b66887a8c.__file = "themes/vueform/templates/elements/MultiselectElement.vue";
var $741c336afc2dfa06$var$script$X = {
    name: 'ObjectElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$l = [
    "aria-labelledby"
];
function $741c336afc2dfa06$var$render$q(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        multiple: true,
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    role: "group",
                    "aria-labelledby": _ctx.labelId
                }, [
                    (0, $ani5R.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.children, (element, name)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.component(element)), (0, $ani5R.mergeProps)({
                                    ref_for: true
                                }, element, {
                                    embed: _ctx.embed,
                                    name: name,
                                    key: name,
                                    onRemove: _cache[0] || (_cache[0] = (e)=>_ctx.$emit('remove', e))
                                }), null, 16 /* FULL_PROPS */ , [
                                    "embed",
                                    "name"
                                ]);
                            }), 128 /* KEYED_FRAGMENT */ ))
                        ])
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$l)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$X.render = $741c336afc2dfa06$var$render$q;
$741c336afc2dfa06$var$script$X.__file = "themes/blank/templates/elements/ObjectElement.vue";
var $741c336afc2dfa06$export$971f1d98c37594d0 = {
    name: 'ObjectElement',
    render: $741c336afc2dfa06$var$script$X.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: 'vf-row',
                wrapper_sm: 'vf-row-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-row-lg',
                wrapper_embed: 'vf-row-embed',
                $wrapper: (classes, { Size: Size, embed: embed })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        embed ? classes.wrapper_embed : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$t = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$t);
$741c336afc2dfa06$export$971f1d98c37594d0.__file = "themes/vueform/templates/elements/ObjectElement.vue";
var $741c336afc2dfa06$var$script$V = {
    name: 'PhoneElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$k = [
    "value",
    "type",
    "name",
    "id",
    "placeholder",
    "autocomplete",
    "disabled",
    "readonly"
];
function $741c336afc2dfa06$var$render$p(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddonOptions = (0, $ani5R.resolveComponent)("ElementAddonOptions");
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_ElementLoader = (0, $ani5R.resolveComponent)("ElementLoader");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputContainer)
                }, [
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.optionsWrapper)
                    }, [
                        (0, $ani5R.createVNode)(_component_ElementAddonOptions, {
                            options: _ctx.addonOptions,
                            placeholder: _ctx.addonPlaceholder,
                            aria: _ctx.optionsAria,
                            onSelect: _ctx.handleOptionSelect,
                            onOpen: _ctx.handleOpen,
                            onClose: _ctx.handleClose,
                            ref: "options$"
                        }, null, 8 /* PROPS */ , [
                            "options",
                            "placeholder",
                            "aria",
                            "onSelect",
                            "onOpen",
                            "onClose"
                        ])
                    ], 2 /* CLASS */ ),
                    _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                        key: 0,
                        visible: !_ctx.empty
                    }, null, 8 /* PROPS */ , [
                        "visible"
                    ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLoader, {
                        key: 1
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        value: _ctx.model,
                        type: _ctx.inputType,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        class: _ctx.classes.input,
                        placeholder: _ctx.Placeholder,
                        autocomplete: _ctx.autocomplete,
                        disabled: _ctx.isDisabled,
                        readonly: _ctx.isReadonly
                    }, {
                        ..._ctx.attrs,
                        ..._ctx.aria
                    }, {
                        onKeydown: _cache[0] || (_cache[0] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args)),
                        onInput: _cache[1] || (_cache[1] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                        onSelect: _cache[2] || (_cache[2] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                        onBlur: _cache[3] || (_cache[3] = (...args)=>_ctx.handleBlur && _ctx.handleBlur(...args)),
                        onFocus: _cache[4] || (_cache[4] = (...args)=>_ctx.handleFocus && _ctx.handleFocus(...args)),
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$k)
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$V.render = $741c336afc2dfa06$var$render$p;
$741c336afc2dfa06$var$script$V.__file = "themes/blank/templates/elements/PhoneElement.vue";
var $741c336afc2dfa06$export$62c4233b2e939e6a = {
    name: 'PhoneElement',
    render: $741c336afc2dfa06$var$script$V.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                optionsWrapper: 'vf-phone-options-wrapper',
                optionsWrapper_sm: 'vf-phone-options-wrapper-sm',
                optionsWrapper_md: '',
                optionsWrapper_lg: 'vf-phone-options-wrapper-lg',
                optionWrapper: '',
                option: 'vf-phone-option',
                option_active: 'vf-phone-option-active',
                optionWrapper: 'vf-phone-option-wrapper',
                flag: 'vf-phone-flag',
                country: 'vf-phone-country',
                number: 'vf-phone-number',
                placeholder: 'vf-phone-flag vf-phone-flag-placeholder',
                $optionsWrapper: (classes, { Size: Size })=>[
                        classes.optionsWrapper,
                        classes[`optionsWrapper_${Size}`]
                    ],
                $option: (classes)=>(active)=>[
                            classes.option,
                            active ? classes.option_active : null
                        ],
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$s = "/* Some styles are contained in Vueform.vue */\n\n.vf-phone-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 0.3125rem 0.75rem;\n  white-space: nowrap;\n}\n\n.vf-phone-option-active {\n  background: var(--vf-bg-selected);\n}\n\n.vf-phone-options-wrapper {\n  display: flex;\n  align-items: center;\n  margin-left: var(--vf-px-input);\n}\n\n.vf-phone-options-wrapper.vf-phone-options-wrapper-sm {\n  margin-left: var(--vf-px-input-sm);\n}\n\n.vf-phone-options-wrapper.vf-phone-options-wrapper-lg {\n  margin-left: var(--vf-px-input-lg);\n}\n\n.vf-phone-option-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.vf-phone-flag {\n  background: no-repeat 0 0;\n  background-image: url(\"data:image/png;base64,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\");\n  background-size: 24px 4716px;\n  width: 24px;\n  height: 16px;\n  overflow: hidden;\n}\n\n.vf-phone-flag-placeholder {\n  opacity: 0.6;\n}\n\n.vf-phone-country {\n  margin-left: 0.75rem;\n  font-weight: 600;\n  font-size: 15px;\n  display: flex;\n}\n\n.vf-phone-number {\n  margin-left: 0.5rem;\n  color: var(--vf-color-muted);\n}\n\n[dir=rtl] .vf-addon-options-wrapper {\n  margin-left: 0;\n  margin-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-addon-options-wrapper.vf-addon-options-wrapper-sm {\n  margin-left: 0;\n  margin-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-addon-options-wrapper.vf-addon-options-wrapper-lg {\n  margin-left: 0;\n  margin-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-phone-country {\n  margin-left: 0;\n  margin-right: 0.75rem;\n}\n\n[dir=rtl] .vf-phone-number {\n  margin-left: 0;\n  margin-right: 0.5rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$s);
$741c336afc2dfa06$export$62c4233b2e939e6a.__file = "themes/vueform/templates/elements/PhoneElement.vue";
var $741c336afc2dfa06$var$script$T = {
    name: 'RadioElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$j = [
    "value",
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$d = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$o(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("label", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        type: "radio",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event)
                    }, _ctx.aria, {
                        value: _ctx.radioValue,
                        class: _ctx.classes.input,
                        name: _ctx.inputName,
                        id: _ctx.fieldId,
                        disabled: _ctx.isDisabled,
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$j), [
                        [
                            (0, $dDLnc.vModelRadio),
                            _ctx.value
                        ]
                    ]),
                    (0, $ani5R.createCommentVNode)(" If label is HTML "),
                    _ctx.Text ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                        innerHTML: _ctx.Text
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$d)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                        key: 1
                    }, [
                        (0, $ani5R.createCommentVNode)(" If label is slot "),
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.text)
                        }, [
                            (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                                el$: _ctx.el$
                            }, ()=>[
                                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.default), {
                                        el$: _ctx.el$
                                    }, null, 8 /* PROPS */ , [
                                        "el$"
                                    ]))
                                ])
                        ], 2 /* CLASS */ )
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$T.render = $741c336afc2dfa06$var$render$o;
$741c336afc2dfa06$var$script$T.__file = "themes/blank/templates/elements/RadioElement.vue";
var $741c336afc2dfa06$export$57897effe54831b9 = {
    name: 'RadioElement',
    render: $741c336afc2dfa06$var$script$T.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: 'vf-radio-wrapper',
                wrapper_sm: 'vf-radio-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radio-wrapper-lg',
                wrapper_left: 'vf-radio-wrapper-left',
                wrapper_right: 'vf-radio-wrapper-right',
                input: 'vf-radio',
                input_enabled: '',
                input_disabled: '',
                input_danger: 'vf-radio-danger',
                input_sm: 'vf-radio-sm',
                input_md: '',
                input_lg: 'vf-radio-lg',
                input_left: 'vf-radio-left',
                input_right: 'vf-radio-right',
                input_standalone: 'vf-radio-standalone',
                text: 'vf-radio-text',
                text_left: 'vf-radio-text-left',
                text_right: 'vf-radio-text-right',
                $wrapper: (classes, { Size: Size, align: align })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        align === 'left' ? classes.wrapper_left : null,
                        align === 'right' ? classes.wrapper_right : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isDanger: isDanger, align: align, standalone: standalone })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        align === 'left' ? classes.input_left : null,
                        align === 'right' ? classes.input_right : null,
                        standalone ? classes.input_standalone : null
                    ],
                $text: (classes, { align: align })=>[
                        classes.text,
                        align === 'left' ? classes.text_left : null,
                        align === 'right' ? classes.text_right : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$r = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$r);
$741c336afc2dfa06$export$57897effe54831b9.__file = "themes/vueform/templates/elements/RadioElement.vue";
var $741c336afc2dfa06$var$script$R = {
    name: 'RadiogroupElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$i = [
    "aria-labelledby"
];
function $741c336afc2dfa06$var$render$n(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_RadiogroupRadio = (0, $ani5R.resolveComponent)("RadiogroupRadio");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    "aria-labelledby": _ctx.labelId,
                    role: "radiogroup"
                }, [
                    ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedOptions, (item, index, key)=>{
                        return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_RadiogroupRadio, {
                            items: _ctx.resolvedOptions,
                            index: index,
                            item: item,
                            value: item.value,
                            key: key,
                            attrs: _ctx.aria
                        }, {
                            default: (0, $ani5R.withCtx)((scope)=>[
                                    (0, $ani5R.renderSlot)(_ctx.$slots, "radio", (0, $ani5R.mergeProps)({
                                        ref_for: true
                                    }, scope, {
                                        el$: _ctx.el$
                                    }), ()=>[
                                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.radio), (0, $ani5R.mergeProps)({
                                                ref_for: true
                                            }, scope, {
                                                el$: _ctx.el$
                                            }), null, 16 /* FULL_PROPS */ , [
                                                "el$"
                                            ]))
                                        ])
                                ]),
                            _: 2 /* DYNAMIC */ 
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                            "items",
                            "index",
                            "item",
                            "value",
                            "attrs"
                        ]);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$i)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$R.render = $741c336afc2dfa06$var$render$n;
$741c336afc2dfa06$var$script$R.__file = "themes/blank/templates/elements/RadiogroupElement.vue";
var $741c336afc2dfa06$export$ad7960f6da4e3648 = {
    name: 'RadiogroupElement',
    render: $741c336afc2dfa06$var$script$R.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radiogroup-view-default',
                wrapper: 'vf-radiogroup-wrapper',
                wrapper_sm: 'vf-radiogroup-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radiogroup-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$q = ".vf-radiogroup-wrapper {\n  cursor: pointer;\n}\n\n.vf-radiogroup-wrapper .vf-radio-container {\n  padding-top: 0;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$q);
$741c336afc2dfa06$export$ad7960f6da4e3648.__file = "themes/vueform/templates/elements/RadiogroupElement.vue";
var $741c336afc2dfa06$export$d5bfde599cb8c352 = {
    name: 'RadiogroupElement',
    render: $741c336afc2dfa06$var$script$R.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radiogroup-view-tabs',
                wrapper: 'vf-radiogroup-tabs-wrapper',
                wrapper_sm: 'vf-radiogroup-tabs-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radiogroup-tabs-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$p = ".vf-radiogroup-tabs-wrapper {\n  display: grid;\n  grid-auto-flow: column;\n  box-shadow: var(--vf-shadow-input);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-radiogroup-tabs-wrapper.vf-radiogroup-tabs-wrapper-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-radiogroup-tabs-wrapper.vf-radiogroup-tabs-wrapper-lg {\n  border-radius: var(--vf-radius-large-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$p);
$741c336afc2dfa06$export$d5bfde599cb8c352.__file = "themes/vueform/templates/elements/RadiogroupElement_tabs.vue";
var $741c336afc2dfa06$export$7d298c97ad4eee23 = {
    name: 'RadiogroupElement',
    render: $741c336afc2dfa06$var$script$R.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radiogroup-view-blocks',
                wrapper: 'vf-radiogroup-blocks-wrapper',
                wrapper_sm: 'vf-radiogroup-blocks-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radiogroup-blocks-wrapper-lg',
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$o = ".vf-radiogroup-blocks-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-shadow: var(--vf-shadow-input);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-radiogroup-blocks-wrapper.vf-radiogroup-blocks-wrapper-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-radiogroup-blocks-wrapper.vf-radiogroup-blocks-wrapper-lg {\n  border-radius: var(--vf-radius-large-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$o);
$741c336afc2dfa06$export$7d298c97ad4eee23.__file = "themes/vueform/templates/elements/RadiogroupElement_blocks.vue";
var $741c336afc2dfa06$var$script$N = {
    name: 'SelectElement',
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: '',
                inputWrapper: '',
                inputPlaceholder: '',
                inputCaret: '',
                select: {
                    container: '',
                    containerDisabled: '',
                    containerOpen: '',
                    containerOpenTop: '',
                    containerActive: '',
                    singleLabel: '',
                    singleLabelText: '',
                    search: '',
                    placeholder: '',
                    caret: '',
                    caretOpen: '',
                    clear: '',
                    clearIcon: '',
                    spinner: '',
                    dropdown: '',
                    dropdownTop: '',
                    dropdownHidden: '',
                    options: '',
                    optionsTop: '',
                    group: '',
                    groupLabel: '',
                    groupLabelPointable: '',
                    groupLabelPointed: '',
                    groupLabelSelected: '',
                    groupLabelDisabled: '',
                    groupLabelSelectedPointed: '',
                    groupLabelSelectedDisabled: '',
                    groupOptions: '',
                    option: '',
                    optionPointed: '',
                    optionSelected: '',
                    optionDisabled: '',
                    optionSelectedPointed: '',
                    optionSelectedDisabled: '',
                    noOptions: '',
                    noResults: '',
                    fakeInput: '',
                    spacer: ''
                }
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$h = [
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$c = [
    "value"
];
function $741c336afc2dfa06$var$render$m(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_Multiselect = (0, $ani5R.resolveComponent)("Multiselect");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                    key: 0,
                    visible: !_ctx.empty
                }, null, 8 /* PROPS */ , [
                    "visible"
                ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Native select "),
                _ctx.isNative ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputWrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("select", (0, $ani5R.mergeProps)({
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event),
                        class: _ctx.classes.input,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        disabled: _ctx.isDisabled
                    }, {
                        ..._ctx.attrs,
                        ..._ctx.aria
                    }, {
                        ref: "input"
                    }), [
                        ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.resolvedOptions, (option, index)=>{
                            return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("option", {
                                value: option.value,
                                key: index
                            }, (0, $X5A94.toDisplayString)(option.label), 9 /* TEXT, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$c);
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$h), [
                        [
                            (0, $dDLnc.vModelSelect),
                            _ctx.value
                        ]
                    ]),
                    _ctx.placeholder && _ctx.empty && !_ctx.isDisabled && _ctx.type == 'select' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.inputPlaceholder)
                    }, (0, $X5A94.toDisplayString)(_ctx.Placeholder), 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.inputCaret)
                    }, null, 2 /* CLASS */ )
                ], 2 /* CLASS */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 2
                }, [
                    (0, $ani5R.createCommentVNode)(" @vueform/multiselect copmonent "),
                    (0, $ani5R.createVNode)(_component_Multiselect, (0, $ani5R.mergeProps)(_ctx.fieldOptions, {
                        modelValue: _ctx.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>_ctx.value = $event),
                        classes: _ctx.classes.select,
                        id: _ctx.fieldId,
                        name: _ctx.name,
                        options: _ctx.resolvedOptions,
                        disabled: _ctx.isDisabled,
                        placeholder: _ctx.Placeholder,
                        attrs: _ctx.attrs,
                        aria: _ctx.aria,
                        locale: _ctx.form$.locale$,
                        onSelect: _ctx.handleSelect,
                        onDeselect: _ctx.handleDeselect,
                        onSearchChange: _ctx.handleSearchChange,
                        onTag: _ctx.handleTag,
                        onOpen: _ctx.handleOpen,
                        onClose: _ctx.handleClose,
                        onClear: _ctx.handleClear,
                        onPaste: _ctx.handlePaste,
                        ref: "input"
                    }), (0, $ani5R.createSlots)({
                        _: 2 /* DYNAMIC */ 
                    }, [
                        (0, $ani5R.renderList)({
                            option: 'option',
                            noresults: 'no-results',
                            nooptions: 'no-options',
                            afterlist: 'after-list',
                            beforelist: 'before-list',
                            placeholder: 'placeholder',
                            grouplabel: 'group-label',
                            caret: 'caret',
                            clear: 'clear',
                            spinner: 'spinner',
                            default: 'default'
                        }, (slotName, slotKey)=>{
                            return {
                                name: slotKey,
                                fn: (0, $ani5R.withCtx)((props)=>[
                                        (0, $ani5R.renderSlot)(_ctx.$slots, slotName, (0, $ani5R.mergeProps)(props, {
                                            el$: _ctx.el$
                                        }), ()=>[
                                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots[slotName]), (0, $ani5R.mergeProps)(props, {
                                                    el$: _ctx.el$
                                                }), null, 16 /* FULL_PROPS */ , [
                                                    "el$"
                                                ]))
                                            ])
                                    ])
                            };
                        }),
                        _ctx.fieldOptions.mode == 'single' ? {
                            name: "singlelabel",
                            fn: (0, $ani5R.withCtx)(({ value: value })=>[
                                    (0, $ani5R.renderSlot)(_ctx.$slots, "single-label", {
                                        value: value,
                                        el$: _ctx.el$
                                    }, ()=>[
                                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['single-label']), {
                                                value: value,
                                                el$: _ctx.el$
                                            }, null, 8 /* PROPS */ , [
                                                "value",
                                                "el$"
                                            ]))
                                        ])
                                ]),
                            key: "0"
                        } : undefined
                    ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */ , [
                        "modelValue",
                        "classes",
                        "id",
                        "name",
                        "options",
                        "disabled",
                        "placeholder",
                        "attrs",
                        "aria",
                        "locale",
                        "onSelect",
                        "onDeselect",
                        "onSearchChange",
                        "onTag",
                        "onOpen",
                        "onClose",
                        "onClear",
                        "onPaste"
                    ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$N.render = $741c336afc2dfa06$var$render$m;
$741c336afc2dfa06$var$script$N.__file = "themes/blank/templates/elements/SelectElement.vue";
var $741c336afc2dfa06$export$db1b0f09a5df5a00 = {
    name: 'SelectElement',
    render: $741c336afc2dfa06$var$script$N.render,
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                input: 'vf-input vf-native-select',
                input_enabled: '',
                input_disabled: '',
                input_success: 'vf-input-success',
                input_danger: 'vf-input-danger',
                input_sm: 'vf-input-sm',
                input_md: '',
                input_lg: 'vf-input-lg',
                inputWrapper: 'vf-native-select-wrapper',
                inputWrapper_sm: 'vf-native-select-wrapper-sm',
                inputWrapper_md: '',
                inputWrapper_lg: 'vf-native-select-wrapper-lg',
                inputPlaceholder: 'vf-native-select-placeholder',
                inputPlaceholder_sm: 'vf-native-select-placeholder-sm',
                inputPlaceholder_md: '',
                inputPlaceholder_lg: 'vf-native-select-placeholder-lg',
                inputCaret: 'vf-native-select-caret',
                inputCaret_sm: 'vf-native-select-caret-sm',
                inputCaret_md: '',
                inputCaret_lg: 'vf-native-select-caret-lg',
                select: {
                    singleLabel: 'vf-multiselect-single-label',
                    singleLabel_sm: 'vf-multiselect-single-label-sm',
                    singleLabel_md: '',
                    singleLabel_lg: 'vf-multiselect-single-label-lg',
                    singleLabel_noClear: 'vf-multiselect-single-label-no-clear',
                    singleLabel_noCaret: 'vf-multiselect-single-label-no-caret',
                    singleLabelText: 'vf-multiselect-single-label-text',
                    singleLabelText_truncate: 'vf-multiselect-single-label-text-truncate',
                    container: 'vf-multiselect',
                    container_enabled: '',
                    container_disabled: 'vf-multiselect-disabled',
                    container_success: 'vf-multiselect-success',
                    container_danger: 'vf-multiselect-danger',
                    container_sm: 'vf-multiselect-sm',
                    container_md: '',
                    container_lg: 'vf-multiselect-lg',
                    containerDisabled: '',
                    containerOpen: 'vf-multiselect-open',
                    containerOpenTop: 'vf-multiselect-open-top',
                    containerActive: 'vf-multiselect-active',
                    containerActive_enabled: '',
                    wrapper: 'vf-multiselect-wrapper',
                    wrapper_sm: 'vf-multiselect-wrapper-sm',
                    wrapper_md: '',
                    wrapper_lg: 'vf-multiselect-wrapper-lg',
                    search: 'vf-multiselect-search',
                    search_sm: 'vf-multiselect-search-sm',
                    search_md: '',
                    search_lg: 'vf-multiselect-search-lg',
                    placeholder: 'vf-multiselect-placeholder',
                    placeholder_sm: 'vf-multiselect-placeholder-sm',
                    placeholder_md: '',
                    placeholder_lg: 'vf-multiselect-placeholder-lg',
                    caret: 'vf-multiselect-caret',
                    caret_sm: 'vf-multiselect-caret-sm',
                    caret_md: '',
                    caret_lg: 'vf-multiselect-caret-lg',
                    caretOpen: 'vf-multiselect-caret-open',
                    clear: 'vf-multiselect-clear',
                    clear_sm: 'vf-multiselect-clear-sm',
                    clear_md: '',
                    clear_lg: 'vf-multiselect-clear-lg',
                    clearIcon: 'vf-multiselect-clear-icon',
                    spinner: 'vf-multiselect-spinner',
                    spinner_sm: 'vf-multiselect-spinner-sm',
                    spinner_md: '',
                    spinner_lg: 'vf-multiselect-spinner-lg',
                    infinite: 'vf-multiselect-infinite',
                    infinite_sm: 'vf-multiselect-infinite-sm',
                    infinite_md: '',
                    infinite_lg: 'vf-multiselect-infinite-lg',
                    infiniteSpinner: 'vf-multiselect-infinite-spinner',
                    dropdown: 'vf-multiselect-dropdown',
                    dropdown_sm: 'vf-multiselect-dropdown-sm',
                    dropdown_md: '',
                    dropdown_lg: 'vf-multiselect-dropdown-lg',
                    dropdownTop: 'vf-multiselect-dropdown-top',
                    dropdownTop_sm: 'vf-multiselect-dropdown-top-sm',
                    dropdownTop_md: '',
                    dropdownTop_lg: 'vf-multiselect-dropdown-top-lg',
                    dropdownHidden: 'vf-multiselect-dropdown-hidden',
                    options: 'vf-multiselect-options',
                    optionsTop: 'vf-multiselect-options-top',
                    group: 'vf-multiselect-group',
                    groupLabel: 'vf-multiselect-group-label',
                    groupLabel_sm: 'vf-multiselect-group-label-sm',
                    groupLabel_md: '',
                    groupLabel_lg: 'vf-multiselect-group-label-lg',
                    groupLabelPointable: 'vf-multiselect-group-label-pointable',
                    groupLabelPointed: 'vf-multiselect-group-label-pointed',
                    groupLabelSelected: 'vf-multiselect-group-label-selected',
                    groupLabelDisabled: 'vf-multiselect-group-label-disabled',
                    groupLabelSelectedPointed: 'vf-multiselect-group-label-selected vf-multiselect-group-label-pointed',
                    groupLabelSelectedDisabled: 'vf-multiselect-group-label-selected vf-multiselect-group-label-disabled',
                    groupOptions: 'vf-multiselect-group-options',
                    option: 'vf-multiselect-option',
                    option_sm: 'vf-multiselect-option-sm',
                    option_md: '',
                    option_lg: 'vf-multiselect-option-lg',
                    optionPointed: 'vf-multiselect-option-pointed',
                    optionSelected: 'vf-multiselect-option-selected',
                    optionDisabled: 'vf-multiselect-option-disabled',
                    optionSelectedPointed: 'vf-multiselect-option-selected vf-multiselect-option-pointed',
                    optionSelectedDisabled: 'vf-multiselect-option-selected vf-multiselect-option-disabled',
                    noOptions: 'vf-multiselect-no-options',
                    noOptions_sm: 'vf-multiselect-no-options-sm',
                    noOptions_md: '',
                    noOptions_lg: 'vf-multiselect-no-options-lg',
                    noResults: 'vf-multiselect-no-results',
                    noResults_sm: 'vf-multiselect-no-results-sm',
                    noResults_md: '',
                    noResults_lg: 'vf-multiselect-no-results-lg',
                    fakeInput: 'vf-multiselect-fake-input',
                    assist: 'vf-assistive-text',
                    spacer: 'vf-multiselect-spacer',
                    spacer_sm: 'vf-multiselect-spacer-sm',
                    spacer_md: '',
                    spacer_lg: 'vf-multiselect-spacer-lg',
                    $container: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.container,
                            classes.select[`container_${Size}`],
                            isDisabled ? classes.select.container_disabled : null,
                            !isDisabled && !isSuccess && !isDanger ? classes.select.container_enabled : null,
                            !isDisabled && isDanger ? classes.select.container_danger : null,
                            !isDisabled && isSuccess ? classes.select.container_success : null
                        ],
                    $containerActive: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.containerActive,
                            classes.select[`container_${Size}`],
                            !isDisabled && !isSuccess && !isDanger ? classes.select.containerActive_enabled : null
                        ],
                    $wrapper: (classes, { Size: Size })=>[
                            classes.select.wrapper,
                            classes.select[`wrapper_${Size}`]
                        ],
                    $search: (classes, { Size: Size })=>[
                            classes.select.search,
                            classes.select[`search_${Size}`]
                        ],
                    $placeholder: (classes, { Size: Size })=>[
                            classes.select.placeholder,
                            classes.select[`placeholder_${Size}`]
                        ],
                    $caret: (classes, { Size: Size })=>[
                            classes.select.caret,
                            classes.select[`caret_${Size}`]
                        ],
                    $clear: (classes, { Size: Size })=>[
                            classes.select.clear,
                            classes.select[`clear_${Size}`]
                        ],
                    $spinner: (classes, { Size: Size })=>[
                            classes.select.spinner,
                            classes.select[`spinner_${Size}`]
                        ],
                    $infinite: (classes, { Size: Size })=>[
                            classes.select.infinite,
                            classes.select[`infinite_${Size}`]
                        ],
                    $dropdown: (classes, { Size: Size })=>[
                            classes.select.dropdown,
                            classes.select[`dropdown_${Size}`]
                        ],
                    $dropdownTop: (classes, { Size: Size })=>[
                            classes.select.dropdownTop,
                            classes.select[`dropdownTop_${Size}`]
                        ],
                    $groupLabel: (classes, { Size: Size })=>[
                            classes.select.groupLabel,
                            classes.select[`groupLabel_${Size}`]
                        ],
                    $option: (classes, { Size: Size })=>[
                            classes.select.option,
                            classes.select[`option_${Size}`]
                        ],
                    $spacer: (classes, { Size: Size })=>[
                            classes.select.spacer,
                            classes.select[`spacer_${Size}`]
                        ],
                    $noOptions: (classes, { Size: Size })=>[
                            classes.select.noOptions,
                            classes.select[`noOptions_${Size}`]
                        ],
                    $noResults: (classes, { Size: Size })=>[
                            classes.select.noResults,
                            classes.select[`noResults_${Size}`]
                        ],
                    $singleLabel: (classes, { Size: Size, canClear: canClear, caret: caret })=>[
                            classes.select.singleLabel,
                            classes.select[`singleLabel_${Size}`],
                            !canClear ? classes.select[`singleLabel_noClear`] : null,
                            !caret ? classes.select[`singleLabel_noCaret`] : null
                        ],
                    $singleLabelText: (classes, { truncate: truncate })=>[
                            classes.select.singleLabelText,
                            truncate ? classes.select[`singleLabelText_truncate`] : null
                        ]
                },
                $input: (classes, { isDisabled: isDisabled, Size: Size, isDanger: isDanger, isSuccess: isSuccess, caret: caret })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.input_enabled : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ],
                $inputWrapper: (classes, { Size: Size })=>[
                        classes.inputWrapper,
                        classes[`inputWrapper_${Size}`]
                    ],
                $inputPlaceholder: (classes, { Size: Size })=>[
                        classes.inputPlaceholder,
                        classes[`inputPlaceholder_${Size}`]
                    ],
                $inputCaret: (classes, { Size: Size })=>[
                        classes.inputCaret,
                        classes[`inputCaret_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$n = ".vf-native-select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.vf-native-select::-webkit-search-decoration, .vf-native-select::-webkit-search-cancel-button, .vf-native-select::-webkit-search-results-button, .vf-native-select::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\n.vf-input.vf-native-select {\n  padding-right: calc(var(--vf-px-input) * 2);\n}\n\n.vf-input-sm.vf-native-select {\n  padding-right: calc(var(--vf-px-input-sm) * 2);\n}\n\n.vf-input-lg.vf-native-select {\n  padding-right: calc(var(--vf-px-input-lg) * 2);\n}\n\n.vf-native-select-wrapper {\n  position: relative;\n}\n\n.vf-native-select-wrapper.vf-native-select-wrapper-sm:before {\n  width: var(--vf-min-height-input-sm);\n  height: var(--vf-min-height-input-sm);\n}\n\n.vf-native-select-wrapper.vf-native-select-wrapper-lg:before {\n  width: var(--vf-min-height-input-lg);\n  height: var(--vf-min-height-input-lg);\n}\n\n.vf-native-select-placeholder {\n  position: absolute;\n  top: 0;\n  left: var(--vf-px-input);\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  margin-left: 1px;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  color: var(--vf-color-placeholder);\n  cursor: default;\n  pointer-events: none;\n}\n\n.vf-native-select-placeholder.vf-native-select-placeholder-sm {\n  left: var(--vf-px-input-sm);\n}\n\n.vf-native-select-placeholder.vf-native-select-placeholder-lg {\n  left: var(--vf-px-input-lg);\n}\n\n.vf-native-select-caret {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  background-color: var(--vf-bg-icon);\n  position: absolute;\n  right: 0;\n  top: 50%;\n  width: 0.625rem;\n  height: 1rem;\n  padding: 1px 0;\n  box-sizing: content-box;\n  display: inline-block;\n  pointer-events: none;\n  transform: translateY(-50%);\n  transition: transform 150ms ease-in-out;\n  margin-right: var(--vf-px-input);\n}\n\n.vf-native-select-caret.vf-native-select-caret-sm {\n  margin-right: var(--vf-px-input-sm);\n}\n\n.vf-native-select-caret.vf-native-select-caret-lg {\n  margin-right: var(--vf-px-input-lg);\n}\n\n/* @vueform/multiselect styles */\n\n.vf-multiselect {\n  position: relative;\n  display: flex;\n  width: 100%;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: flex-end;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n  transition: box-shadow 0.2s ease-in-out, color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  background-color: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  border-color: var(--vf-border-color-input);\n  box-shadow: var(--vf-shadow-input);\n  min-height: var(--vf-min-height-input);\n  border-radius: var(--vf-radius-input);\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-style: solid;\n}\n\n.vf-multiselect.vf-multiselect-open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-multiselect.vf-multiselect-open-top {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-multiselect.vf-multiselect-disabled {\n  cursor: default;\n  background-color: var(--vf-bg-disabled);\n  color: var(--vf-color-disabled);\n  pointer-events: none;\n}\n\n.vf-multiselect.vf-multiselect-success {\n  background-color: var(--vf-bg-input-success);\n  color: var(--vf-color-input-success);\n  border-color: var(--vf-border-color-input-success);\n}\n\n.vf-multiselect.vf-multiselect-danger {\n  background-color: var(--vf-bg-input-danger);\n  color: var(--vf-color-input-danger);\n  border-color: var(--vf-border-color-input-danger);\n}\n\n.vf-multiselect:hover {\n  box-shadow: var(--vf-shadow-input-hover);\n}\n\n.vf-multiselect:hover:not(.vf-multiselect-success):not(.vf-multiselect-danger) {\n  background-color: var(--vf-bg-input-hover);\n  color: var(--vf-color-input-hover);\n  border-color: var(--vf-border-color-input-hover);\n}\n\n.vf-multiselect.vf-multiselect-active {\n  box-shadow: var(--vf-shadow-input-focus);\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-multiselect.vf-multiselect-active:not(.vf-multiselect-success):not(.vf-multiselect-danger) {\n  border-color: var(--vf-border-color-input-focus);\n  background-color: var(--vf-bg-input-focus);\n  color: var(--vf-color-input-focus);\n}\n\n.vf-multiselect.vf-multiselect-sm {\n  min-height: var(--vf-min-height-input-sm);\n  border-radius: var(--vf-radius-input-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-multiselect.vf-multiselect-lg {\n  min-height: var(--vf-min-height-input-lg);\n  border-radius: var(--vf-radius-input-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-multiselect-wrapper {\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  box-sizing: border-box;\n  cursor: pointer;\n  outline: none;\n  min-height: calc(var(--vf-min-height-input) - var(--vf-border-width-input-t) - var(--vf-border-width-input-b));\n}\n\n.vf-multiselect-wrapper.vf-multiselect-wrapper-sm {\n  min-height: calc(var(--vf-min-height-input-sm) - var(--vf-border-width-input-t) - var(--vf-border-width-input-b));\n}\n\n.vf-multiselect-wrapper.vf-multiselect-wrapper-lg {\n  min-height: calc(var(--vf-min-height-input-lg) - var(--vf-border-width-input-t) - var(--vf-border-width-input-b));\n}\n\n.vf-multiselect-single-label,\n.vf-multiselect-placeholder {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  pointer-events: none;\n  background: transparent;\n  box-sizing: border-box;\n  max-width: 100%;\n  padding-left: var(--vf-px-input);\n  padding-right: calc(var(--vf-px-input) * 2.5 + 20px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-no-caret, .vf-multiselect-single-label.vf-multiselect-single-label-no-clear {\n  padding-right: calc(var(--vf-px-input) * 1.5 + 10px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-right: var(--vf-px-input);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-sm {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: calc(var(--vf-px-input-sm) * 2.5 + 20px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-caret, .vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-clear {\n  padding-right: calc(var(--vf-px-input-sm) * 1.5 + 10px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-right: var(--vf-px-input-sm);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-lg {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: calc(var(--vf-px-input-lg) * 2.5 + 20px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-caret, .vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-clear {\n  padding-right: calc(var(--vf-px-input-lg) * 1.5 + 10px);\n}\n\n.vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-right: var(--vf-px-input-lg);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-single-label,\n.vf-floating-wrapper ~ div .vf-multiselect-single-label {\n  padding-top: calc(var(--vf-py-input) + var(--vf-floating-top) / 2);\n  padding-bottom: calc(var(--vf-py-input) - var(--vf-floating-top) / 2);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-single-label-sm,\n.vf-floating-wrapper ~ div .vf-multiselect-single-label-sm {\n  padding-top: calc(var(--vf-py-input-sm) + var(--vf-floating-top-sm) / 2);\n  padding-bottom: calc(var(--vf-py-input-sm) - var(--vf-floating-top-sm) / 2);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-single-label-lg,\n.vf-floating-wrapper ~ div .vf-multiselect-single-label-lg {\n  padding-top: calc(var(--vf-py-input-lg) + var(--vf-floating-top-lg) / 2);\n  padding-bottom: calc(var(--vf-py-input-lg) - var(--vf-floating-top-lg) / 2);\n}\n\n.vf-multiselect-placeholder {\n  color: var(--vf-color-placeholder);\n}\n\n.vf-multiselect-placeholder.vf-multiselect-placeholder-sm {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: calc(var(--vf-px-input-sm) * 2.5 + 20px);\n}\n\n.vf-multiselect-placeholder.vf-multiselect-placeholder-lg {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: calc(var(--vf-px-input-lg) * 2.5 + 20px);\n}\n\n.vf-multiselect-single-label-text {\n  overflow: hidden;\n  display: block;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\n.vf-multiselect-single-label-text-truncate {\n  text-overflow: ellipsis;\n}\n\n.vf-multiselect-search {\n  width: 100%;\n  height: 100%; /* for FF */\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  outline: none;\n  box-sizing: border-box;\n  border: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  font-family: inherit;\n  background: transparent;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  border-radius: var(--vf-radius-input);\n  padding-left: var(--vf-px-input);\n  padding-right: calc(var(--vf-px-input) * 2.5 + 20px);\n  color: var(--vf-color-input);\n}\n\n.vf-multiselect-search::-webkit-search-decoration, .vf-multiselect-search::-webkit-search-cancel-button, .vf-multiselect-search::-webkit-search-results-button, .vf-multiselect-search::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\n.vf-multiselect-search.vf-multiselect-search-sm {\n  border-radius: var(--vf-radius-input-sm);\n  padding-left: var(--vf-px-input-sm);\n  padding-right: calc(var(--vf-px-input-sm) * 2.5 + 20px);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-multiselect-search.vf-multiselect-search-lg {\n  border-radius: var(--vf-radius-input-lg);\n  padding-left: var(--vf-px-input-lg);\n  padding-right: calc(var(--vf-px-input-lg) * 2.5 + 20px);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-search-lg,\n.vf-floating-wrapper ~ div .vf-multiselect-search-lg,\n.vf-floating-wrapper ~ span .vf-multiselect-search-lg {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: var(--vf-px-input-lg);\n  padding-top: calc(var(--vf-py-input-lg) + var(--vf-floating-top-lg) / 2);\n  padding-bottom: calc(var(--vf-py-input-lg) - var(--vf-floating-top-lg) / 2);\n}\n\n.vf-multiselect-spinner {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-primary);\n  width: 1rem;\n  height: 1rem;\n  margin: 0 var(--vf-px-input) 0 0;\n  animation: multiselect-spin 1s linear infinite;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.vf-multiselect-spinner.vf-multiselect-spinner-sm {\n  margin: 0 var(--vf-px-input-sm) 0 0;\n}\n\n.vf-multiselect-spinner.vf-multiselect-spinner-lg {\n  margin: 0 var(--vf-px-input-lg) 0 0;\n}\n\n.vf-multiselect-inifite {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  height: var(--vf-min-height-input);\n}\n\n.vf-multiselect-inifite.vf-multiselect-inifite-sm {\n  height: var(--vf-min-height-input-sm);\n}\n\n.vf-multiselect-inifite.vf-multiselect-inifite-lg {\n  height: var(--vf-min-height-input-lg);\n}\n\n.vf-multiselect-inifite-spinner {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-primary);\n  width: 1rem;\n  height: 1rem;\n  animation: multiselect-spin 1s linear infinite;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.vf-multiselect-clear {\n  margin: 0 var(--vf-px-input) 0 0px;\n  position: relative;\n  opacity: 1;\n  transition: 0.3s;\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n}\n\n.vf-multiselect-clear:hover .vf-multiselect-clear-icon {\n  opacity: 1;\n}\n\n.vf-multiselect-clear.vf-multiselect-clear-sm {\n  margin: 0 var(--vf-px-input-sm) 0 0px;\n}\n\n.vf-multiselect-clear.vf-multiselect-clear-lg {\n  margin: 0 var(--vf-px-input-lg) 0 0px;\n}\n\n.vf-multiselect-clear-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-bg-icon);\n  width: 0.625rem;\n  height: 1.125rem;\n  display: inline-block;\n  transition: 0.3s;\n  opacity: 0.5;\n}\n\n.vf-multiselect-caret {\n  transform: rotate(0deg);\n  transition: 0.3s transform;\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-bg-icon);\n  width: 0.625rem;\n  height: 1.125rem;\n  margin: 0 var(--vf-px-input) 0 0;\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 0;\n  pointer-events: none;\n}\n\n.vf-multiselect-caret.vf-multiselect-caret-open {\n  transform: rotate(180deg);\n  pointer-events: auto;\n}\n\n.vf-multiselect-caret.vf-multiselect-caret-sm {\n  margin: 0 var(--vf-px-input-sm) 0 0;\n}\n\n.vf-multiselect-caret.vf-multiselect-caret-lg {\n  margin: 0 var(--vf-px-input-lg) 0 0;\n}\n\n.vf-multiselect-dropdown {\n  position: absolute;\n  left: calc(var(--vf-border-width-input-l) * -1);\n  right: calc(var(--vf-border-width-input-r) * -1);\n  bottom: 0;\n  transform: translateY(100%);\n  border-width: var(--vf-border-width-dropdown);\n  border-style: solid;\n  border-color: var(--vf-border-color-input);\n  margin-top: calc(var(--vf-border-width-input-t) * -1);\n  max-height: 15rem;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  z-index: 999;\n  background: var(--vf-bg-input);\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--vf-radius-input);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  outline: none;\n  box-shadow: var(--vf-shadow-dropdown);\n}\n\n.vf-multiselect-dropdown.vf-multiselect-dropdown-top {\n  transform: translateY(-100%);\n  top: 0;\n  margin-top: 0;\n  bottom: auto;\n  border-radius: var(--vf-radius-input);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-multiselect-dropdown.vf-multiselect-dropdown-hidden {\n  display: none;\n}\n\nv .vf-multiselect-dropdown.vf-multiselect-dropdown-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\nv .vf-multiselect-dropdown.vf-multiselect-dropdown-sm.vf-multiselect-dropdown-top-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-multiselect-dropdown.vf-multiselect-dropdown-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-multiselect-dropdown.vf-multiselect-dropdown-lg.vf-multiselect-dropdown-top-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-multiselect-options {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  color: var(--vf-color-input);\n}\n\n.vf-multiselect-group {\n  padding: 0;\n  margin: 0;\n}\n\n.vf-multiselect-group-label {\n  font-weight: 600;\n  color: #374151;\n  cursor: default;\n  display: flex;\n  box-sizing: border-box;\n  text-decoration: none;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  padding: calc(var(--vf-py-input) * 0.5) var(--vf-px-input);\n  color: var(--vf-color-input);\n  background: var(--vf-bg-selected);\n  filter: brightness(0.9);\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-pointable {\n  cursor: pointer;\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-pointed {\n  filter: brightness(0.95);\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-selected {\n  background: var(--vf-primary-darker);\n  color: var(--vf-color-on-primary);\n  filter: brightness(1);\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-disabled {\n  background: var(--vf-bg-disabled);\n  color: var(--vf-color-disabled);\n  cursor: not-allowed;\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-selected.vf-multiselect-group-label-pointed {\n  opacity: 0.9;\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-selected.vf-multiselect-group-label-disabled {\n  opacity: 0.5;\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  padding: calc(var(--vf-py-input-sm) * 0.5) var(--vf-px-input-sm);\n}\n\n.vf-multiselect-group-label.vf-multiselect-group-label-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n  padding: calc(var(--vf-py-input-lg) * 0.5) var(--vf-px-input-lg);\n}\n\n.vf-multiselect-group-options {\n  padding: 0;\n  margin: 0;\n}\n\n.vf-multiselect-option {\n  padding: calc(var(--vf-py-input) + var(--vf-border-width-input-t)) var(--vf-px-input) calc(var(--vf-py-input) + var(--vf-border-width-input-t));\n  cursor: pointer;\n  display: flex;\n  box-sizing: border-box;\n  text-decoration: none;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n}\n\n.vf-multiselect-option.vf-multiselect-option-pointed {\n  background: var(--vf-bg-selected);\n  color: var(--vf-color-input);\n}\n\n.vf-multiselect-option.vf-multiselect-option-selected {\n  background: var(--vf-primary);\n  color: var(--vf-color-on-primary);\n}\n\n.vf-multiselect-option.vf-multiselect-option-disabled {\n  background: var(--vf-bg-disabled);\n  color: var(--vf-color-disabled);\n  cursor: not-allowed;\n}\n\n.vf-multiselect-option.vf-multiselect-option-selected.vf-multiselect-option-pointed {\n  opacity: 0.9;\n}\n\n.vf-multiselect-option.vf-multiselect-option-selected.vf-multiselect-option-disabled {\n  opacity: 0.5;\n}\n\n.vf-multiselect-option.vf-multiselect-option-sm {\n  padding: calc(var(--vf-py-input-sm) + var(--vf-border-width-input-t)) var(--vf-px-input-sm) calc(var(--vf-py-input-sm) + var(--vf-border-width-input-t));\n}\n\n.vf-multiselect-option.vf-multiselect-option-lg {\n  padding: calc(var(--vf-py-input-lg) + var(--vf-border-width-input-t)) var(--vf-px-input-lg) calc(var(--vf-py-input-lg) + var(--vf-border-width-input-t));\n}\n\n.vf-multiselect-no-options,\n.vf-multiselect-no-results {\n  padding: var(--vf-py-input) var(--vf-px-input);\n  color: var(--vf-color-muted);\n}\n\n.vf-multiselect-no-options.vf-multiselect-no-options-sm {\n  padding: var(--vf-py-input-sm) var(--vf-px-input-sm);\n}\n\n.vf-multiselect-no-options.vf-multiselect-no-options-lg {\n  padding: var(--vf-py-input-lg) var(--vf-px-input-lg);\n}\n\n.vf-multiselect-no-results.vf-multiselect-no-results-sm {\n  padding: var(--vf-py-input-sm) var(--vf-px-input-sm);\n}\n\n.vf-multiselect-no-results.vf-multiselect-no-results-lg {\n  padding: var(--vf-py-input-lg) var(--vf-px-input-lg);\n}\n\n.vf-multiselect-fake-input {\n  background: transparent;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  width: 100%;\n  height: 1px;\n  border: 0;\n  padding: 0;\n  font-size: 0;\n  outline: none;\n}\n\n.vf-multiselect-fake-input:active, .vf-multiselect-fake-input:focus {\n  outline: none;\n}\n\n.vf-multiselect-spacer {\n  display: none;\n}\n\n[dir=rtl] .vf-input.vf-native-select {\n  padding-right: var(--vf-px-input);\n  padding-left: calc(var(--vf-px-input) * 2);\n}\n\n[dir=rtl] .vf-input-sm.vf-native-select {\n  padding-right: var(--vf-px-input);\n  padding-left: calc(var(--vf-px-input-sm) * 2);\n}\n\n[dir=rtl] .vf-input-lg.vf-native-select {\n  padding-right: var(--vf-px-input);\n  padding-left: calc(var(--vf-px-input-lg) * 2);\n}\n\n[dir=rtl] .vf-native-select-placeholder {\n  left: auto;\n  right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-native-select-caret {\n  right: auto;\n  left: 0;\n  margin-right: 0;\n  margin-left: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-native-select-caret.vf-native-select-caret-sm {\n  margin-right: 0;\n  margin-left: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-native-select-caret.vf-native-select-caret-lg {\n  margin-right: 0;\n  margin-left: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-single-label {\n  padding-left: calc(var(--vf-px-input) * 4);\n  padding-right: var(--vf-px-input);\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-no-caret, [dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-no-clear {\n  padding-left: calc(var(--vf-px-input) * 2);\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-left: var(--vf-px-input);\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-sm {\n  padding-left: calc(var(--vf-px-input-sm) * 4);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-caret, [dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-clear {\n  padding-left: calc(var(--vf-px-input-sm) * 2);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-sm.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-lg {\n  padding-left: calc(var(--vf-px-input-lg) * 4);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-caret, [dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-clear {\n  padding-left: calc(var(--vf-px-input-lg) * 2);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-single-label.vf-multiselect-single-label-lg.vf-multiselect-single-label-no-caret.vf-multiselect-single-label-no-clear {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-placeholder {\n  padding-left: var(--vf-min-height-input);\n  padding-right: var(--vf-px-input);\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .vf-multiselect-placeholder.vf-multiselect-placeholder-sm {\n  padding-left: calc(1.25rem + var(--vf-px-input-sm) * 3);\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-placeholder.vf-multiselect-placeholder-lg {\n  padding-left: calc(1.25rem + var(--vf-px-input-lg) * 3);\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-search {\n  padding-left: 0;\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-search.vf-multiselect-search-sm {\n  padding-left: 0;\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-search.vf-multiselect-search-lg {\n  padding-left: 0;\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-spinner {\n  margin: 0 0 0 var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-caret {\n  margin: 0 0 0 var(--vf-px-input);\n}\n\n[dir=rtl] .vf-multiselect-clear {\n  padding: 0 0 0 var(--vf-px-input);\n}\n\n@keyframes multiselect-spin {\n  from {\n    transform: rotate(0);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$n);
$741c336afc2dfa06$export$db1b0f09a5df5a00.__file = "themes/vueform/templates/elements/SelectElement.vue";
var $741c336afc2dfa06$var$script$L = {
    name: 'SignatureElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$g = [
    "tabindex",
    "aria-label",
    "id"
];
const $741c336afc2dfa06$var$_hoisted_2$b = [
    "src",
    "alt",
    "title"
];
const $741c336afc2dfa06$var$_hoisted_3$9 = [
    "title",
    "tabindex",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_4$6 = [
    "title",
    "tabindex",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_5$3 = [
    "value",
    "disabled",
    "readonly",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_6$2 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_7$1 = [
    "tabindex",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_8 = [
    "accept"
];
const $741c336afc2dfa06$var$_hoisted_9 = [
    "width",
    "height"
];
const $741c336afc2dfa06$var$_hoisted_10 = [
    "width",
    "height",
    "tabindex",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_11 = [
    "tabindex",
    "aria-label",
    "aria-selected",
    "onClick",
    "onKeydown"
];
const $741c336afc2dfa06$var$_hoisted_12 = [
    "fill"
];
const $741c336afc2dfa06$var$_hoisted_13 = [
    "tabindex",
    "aria-label"
];
function $741c336afc2dfa06$var$render$l(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddonOptions = (0, $ani5R.resolveComponent)("ElementAddonOptions");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    style: (0, $X5A94.normalizeStyle)(_ctx.wrapperStyle),
                    tabindex: _ctx.isDisabled ? undefined : 0,
                    "aria-label": _ctx.wrapperAriaLabel,
                    id: _ctx.id,
                    onKeydown: _cache[11] || (_cache[11] = (0, $dDLnc.withKeys)((...args)=>_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args), [
                        "tab",
                        "escape"
                    ])),
                    onMouseleave: _cache[12] || (_cache[12] = (...args)=>_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)),
                    ref: "input"
                }, [
                    (0, $ani5R.createCommentVNode)(" Line "),
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("hr", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.line),
                        style: (0, $X5A94.normalizeStyle)(_ctx.lineStyle),
                        "aria-hidden": "true"
                    }, null, 6 /* CLASS, STYLE */ ), [
                        [
                            (0, $dDLnc.vShow),
                            _ctx.showLine
                        ]
                    ]),
                    (0, $ani5R.createCommentVNode)(" Loaded preview "),
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.loadedWrapper)
                    }, [
                        (0, $ani5R.createElementVNode)("img", {
                            src: _ctx.value,
                            alt: _ctx.imgAltText,
                            title: _ctx.imgTitleText,
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.loadedImg)
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$b)
                    ], 2 /* CLASS */ ), [
                        [
                            (0, $dDLnc.vShow),
                            _ctx.uploaded
                        ]
                    ]),
                    (0, $ani5R.createCommentVNode)(" Not loaded actions "),
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.innerWrapper)
                    }, [
                        (0, $ani5R.createCommentVNode)(" Actions "),
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.actions)
                        }, [
                            (0, $ani5R.createCommentVNode)(" Mode "),
                            (0, $ani5R.withDirectives)((0, $ani5R.createVNode)(_component_ElementAddonOptions, {
                                options: _ctx.resolvedModes,
                                placeholder: '',
                                position: "bottom",
                                relaxed: "",
                                aria: _ctx.modeSelectorAria,
                                onSelect: _ctx.handleModeSelect,
                                ref: "mode$"
                            }, null, 8 /* PROPS */ , [
                                "options",
                                "aria",
                                "onSelect"
                            ]), [
                                [
                                    (0, $dDLnc.vShow),
                                    _ctx.showModes
                                ]
                            ]),
                            (0, $ani5R.createCommentVNode)(" Fonts "),
                            (0, $ani5R.withDirectives)((0, $ani5R.createVNode)(_component_ElementAddonOptions, {
                                options: _ctx.resolvedFonts,
                                placeholder: _ctx.fontText,
                                position: "bottom",
                                relaxed: "",
                                aria: _ctx.fontSelectorAria,
                                onSelect: _ctx.handleFontSelect,
                                ref: "font$"
                            }, null, 8 /* PROPS */ , [
                                "options",
                                "placeholder",
                                "aria",
                                "onSelect"
                            ]), [
                                [
                                    (0, $dDLnc.vShow),
                                    _ctx.showFonts
                                ]
                            ]),
                            (0, $ani5R.createCommentVNode)(" Undos "),
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.undosWrapper)
                            }, [
                                (0, $ani5R.createCommentVNode)(" Undo "),
                                (0, $ani5R.createElementVNode)("div", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.undo),
                                    title: _ctx.undoText,
                                    role: "button",
                                    tabindex: _ctx.undosLeft ? _ctx.tabindex : undefined,
                                    "aria-label": _ctx.undoText,
                                    onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleUndo && _ctx.handleUndo(...args), [
                                        "stop"
                                    ])),
                                    onKeydown: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleUndo && _ctx.handleUndo(...args), [
                                        "prevent"
                                    ]), [
                                        "space",
                                        "enter"
                                    ]))
                                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_3$9),
                                (0, $ani5R.createCommentVNode)(" Redo "),
                                (0, $ani5R.createElementVNode)("div", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.redo),
                                    title: _ctx.redoText,
                                    role: "button",
                                    tabindex: _ctx.redos.length ? _ctx.tabindex : undefined,
                                    "aria-label": _ctx.redoText,
                                    onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleRedo && _ctx.handleRedo(...args), [
                                        "stop"
                                    ])),
                                    onKeydown: _cache[3] || (_cache[3] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleRedo && _ctx.handleRedo(...args), [
                                        "prevent"
                                    ]), [
                                        "space",
                                        "enter"
                                    ]))
                                }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_4$6)
                            ], 2 /* CLASS */ ), [
                                [
                                    (0, $dDLnc.vShow),
                                    _ctx.showUndos
                                ]
                            ])
                        ], 2 /* CLASS */ ),
                        (0, $ani5R.createCommentVNode)(" Input "),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                            value: _ctx.text,
                            type: "text",
                            spellcheck: "false",
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.input),
                            disabled: _ctx.isDisabled,
                            readonly: _ctx.isReadonly,
                            style: (0, $X5A94.normalizeStyle)(_ctx.inputStyle),
                            "aria-label": _ctx.inputAriaLabel,
                            onInput: _cache[4] || (_cache[4] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                            onSelect: _cache[5] || (_cache[5] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                            ref: "input$"
                        }, null, 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_5$3), [
                            [
                                (0, $dDLnc.vShow),
                                _ctx.showInput
                            ]
                        ]),
                        (0, $ani5R.createCommentVNode)(" Placeholder "),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.placeholder),
                            innerHTML: _ctx.placeholderText
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_6$2), [
                            [
                                (0, $dDLnc.vShow),
                                _ctx.showPlaceholder
                            ]
                        ]),
                        (0, $ani5R.createCommentVNode)(" Upload container "),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadContainer),
                            ref: "upload$"
                        }, [
                            (0, $ani5R.createCommentVNode)(" File upload "),
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadWrapper)
                            }, [
                                (0, $ani5R.createCommentVNode)(" DnD text "),
                                _ctx.droppable ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                                    key: 0,
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.dndText)
                                }, (0, $X5A94.toDisplayString)(_ctx.dndText), 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                                (0, $ani5R.createCommentVNode)(" Select button "),
                                (0, $ani5R.createElementVNode)("div", {
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadButton),
                                    tabindex: _ctx.tabindex,
                                    role: "button",
                                    "aria-label": _ctx.uploadButtonText,
                                    onClick: _cache[6] || (_cache[6] = (...args)=>_ctx.handleSelectClick && _ctx.handleSelectClick(...args)),
                                    onKeydown: _cache[7] || (_cache[7] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleSelectClick && _ctx.handleSelectClick(...args), [
                                        "prevent"
                                    ]), [
                                        "space",
                                        "enter"
                                    ])),
                                    ref: "uploadButton$"
                                }, (0, $X5A94.toDisplayString)(_ctx.uploadButtonText), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_7$1),
                                (0, $ani5R.createCommentVNode)(" Hidden file input "),
                                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                                    type: "file",
                                    accept: _ctx.fileAccept,
                                    onChange: _cache[8] || (_cache[8] = (...args)=>_ctx.handleFileSelect && _ctx.handleFileSelect(...args)),
                                    ref: "file$"
                                }, null, 40 /* PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_8), [
                                    [
                                        (0, $dDLnc.vShow),
                                        false
                                    ]
                                ])
                            ], 2 /* CLASS */ ), [
                                [
                                    (0, $dDLnc.vShow),
                                    _ctx.showUpload
                                ]
                            ]),
                            (0, $ani5R.createCommentVNode)(" Preview "),
                            (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("canvas", {
                                width: _ctx.uploadWidth,
                                height: _ctx.uploadHeight,
                                class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadPreview),
                                ref: "preview$"
                            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_9), [
                                [
                                    (0, $dDLnc.vShow),
                                    _ctx.showPreview
                                ]
                            ])
                        ], 2 /* CLASS */ ), [
                            [
                                (0, $dDLnc.vShow),
                                _ctx.showUploadContainer
                            ]
                        ]),
                        (0, $ani5R.createCommentVNode)(" Pad "),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("canvas", {
                            width: _ctx.padWidth,
                            height: _ctx.padHeight,
                            style: (0, $X5A94.normalizeStyle)(_ctx.padStyle),
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.pad),
                            tabindex: _ctx.tabindex,
                            "aria-label": _ctx.padAriaLabel,
                            ref: "pad$"
                        }, null, 14 /* CLASS, STYLE, PROPS */ , $741c336afc2dfa06$var$_hoisted_10), [
                            [
                                (0, $dDLnc.vShow),
                                _ctx.showPad
                            ]
                        ]),
                        (0, $ani5R.createCommentVNode)(" Colors "),
                        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.colors),
                            role: "listbox"
                        }, [
                            ((0, $ani5R.openBlock)(true), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), null, (0, $ani5R.renderList)(_ctx.colors, (c)=>{
                                return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("svg", {
                                    width: "12",
                                    height: "12",
                                    class: (0, $X5A94.normalizeClass)(_ctx.classes.color(c)),
                                    role: "option",
                                    tabindex: _ctx.tabindex,
                                    "aria-label": `${_ctx.colorAriaLabel} ${c}`,
                                    "aria-selected": c === _ctx.color,
                                    onClick: ($event)=>_ctx.handleColorSelect(c),
                                    onKeydown: (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)(($event)=>_ctx.handleColorSelect(c), [
                                        "prevent"
                                    ]), [
                                        "space",
                                        "enter"
                                    ])
                                }, [
                                    (0, $ani5R.createElementVNode)("circle", {
                                        cx: "6",
                                        cy: "6",
                                        r: "6",
                                        fill: c
                                    }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_12)
                                ], 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_11);
                            }), 256 /* UNKEYED_FRAGMENT */ ))
                        ], 2 /* CLASS */ ), [
                            [
                                (0, $dDLnc.vShow),
                                _ctx.showColors
                            ]
                        ])
                    ], 2 /* CLASS */ ), [
                        [
                            (0, $dDLnc.vShow),
                            !_ctx.uploaded
                        ]
                    ]),
                    (0, $ani5R.createCommentVNode)(" Clear "),
                    _ctx.showClear ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.clearWrapper)
                    }, [
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.clear),
                            tabindex: _ctx.tabindex,
                            role: "button",
                            "aria-label": _ctx.clearAriaLabel,
                            onClick: _cache[9] || (_cache[9] = (...args)=>_ctx.handleClear && _ctx.handleClear(...args)),
                            onKeydown: _cache[10] || (_cache[10] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleClear && _ctx.handleClear(...args), [
                                "prevent"
                            ]), [
                                "enter",
                                "space"
                            ]))
                        }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_13)
                    ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                ], 46 /* CLASS, STYLE, PROPS, NEED_HYDRATION */ , $741c336afc2dfa06$var$_hoisted_1$g)
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$L.render = $741c336afc2dfa06$var$render$l;
$741c336afc2dfa06$var$script$L.__file = "themes/blank/templates/elements/SignatureElement.vue";
var $741c336afc2dfa06$export$64c8f8ba610cf318 = {
    name: 'SignatureElement',
    render: $741c336afc2dfa06$var$script$L.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: 'vf-signature',
                wrapper_sm: 'vf-signature-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-signature-lg',
                wrapper_disabled: 'vf-signature-disabled',
                wrapper_enabled: '',
                wrapper_readonly: 'vf-signature-readonly',
                line: 'vf-signature-line',
                loadedWrapper: 'vf-signature-loaded-wrapper',
                loadedWrapper_disabled: 'vf-signature-loaded-wrapper-disabled',
                loadedWrapper_enabled: '',
                loadedImg: 'vf-signature-loaded-img',
                innerWrapper: 'vf-signature-inner-wrapper',
                innerWrapper_disabled: 'vf-signature-inner-wrapper-disabled',
                innerWrapper_enabled: '',
                input: 'vf-signature-input',
                input_invert: 'vf-signature-input-invert',
                placeholder: 'vf-signature-placeholder',
                uploadContainer: 'vf-signature-upload-container',
                uploadContainer_dragging: 'vf-signature-upload-container-dragging',
                uploadContainer_not_dragging: '',
                uploadWrapper: 'vf-signature-upload-wrapper',
                uploadWrapper_processing: 'vf-signature-upload-wrapper-processing',
                dndText: 'vf-signature-dnd-text',
                uploadButton: 'vf-btn vf-btn-secondary',
                uploadPreview: 'vf-signature-upload-preview',
                pad: 'vf-signature-pad',
                pad_invert: 'vf-signature-pad-invert',
                colors: 'vf-signature-colors',
                color: 'vf-signature-color',
                color_invert: 'vf-signature-color-invert',
                color_active: 'vf-signature-color-active',
                color_inactive: '',
                actions: 'vf-signature-actions',
                undosWrapper: 'vf-signature-undos-wrapper',
                undo: 'vf-signature-undo',
                undo_enabled: '',
                undo_disabled: 'vf-signature-undo-disabled',
                redo: 'vf-signature-redo',
                redo_enabled: '',
                redo_disabled: 'vf-signature-redo-disabled',
                clearWrapper: 'vf-signature-clear-wrapper',
                clear: 'vf-signature-clear',
                $wrapper: (classes, { isDisabled: isDisabled, readonly: readonly, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        isDisabled ? classes.wrapper_disabled : classes.wrapper_enabled,
                        readonly ? classes.wrapper_readonly : null
                    ],
                $loadedWrapper: (classes, { isDisabled: isDisabled })=>[
                        classes.loadedWrapper,
                        isDisabled ? classes.loadedWrapper_disabled : classes.loadedWrapper_enabled
                    ],
                $innerWrapper: (classes, { isDisabled: isDisabled })=>[
                        classes.innerWrapper,
                        isDisabled ? classes.innerWrapper_disabled : classes.innerWrapper_enabled
                    ],
                $input: (classes, { invertColors: invertColors, color: color })=>[
                        classes.input,
                        invertColors.indexOf(color) !== -1 ? classes.input_invert : null
                    ],
                $uploadContainer: (classes, { dragging: dragging })=>[
                        classes.uploadContainer,
                        dragging ? classes.uploadContainer_dragging : classes.uploadContainer_not_dragging
                    ],
                $uploadWrapper: (classes, { processing: processing })=>[
                        classes.uploadWrapper,
                        processing ? classes.uploadWrapper_processing : null
                    ],
                $pad: (classes, { invertColors: invertColors, color: color })=>[
                        classes.pad,
                        invertColors.indexOf(color) !== -1 ? classes.pad_invert : null
                    ],
                $color: (classes, { color: color, invertColors: invertColors, mode: mode })=>(c)=>[
                            classes.color,
                            c === color ? classes.color_active : classes.color_inactive,
                            invertColors.indexOf(c) !== -1 && mode !== 'upload' ? classes.color_invert : null
                        ],
                $undo: (classes, { undosLeft: undosLeft })=>[
                        classes.undo,
                        undosLeft ? classes.undo_enabled : classes.undo_disabled
                    ],
                $redo: (classes, { redos: redos })=>[
                        classes.redo,
                        redos.length ? classes.redo_enabled : classes.redo_disabled
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$m = ".vf-signature {\n  position: relative;\n  font-family: inherit;\n  transition-property: box-shadow, color, background-color, border-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n  border-style: solid;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  background-color: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  border-color: var(--vf-border-color-input);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-signature:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n  border-color: var(--vf-border-color-input-focus);\n}\n\n.vf-signature.vf-signature-sm {\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-signature.vf-signature-lg {\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n  border-radius: var(--vf-radius-large-lg);\n}\n\n.vf-signature.vf-signature-disabled {\n  background-color: var(--vf-bg-disabled);\n  color: var(--vf-color-disabled);\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.vf-signature.vf-signature-readonly {\n  pointer-events: none;\n}\n\n.vf-signature-line {\n  position: absolute;\n  top: 50%;\n  left: 1.5rem;\n  right: 1.5rem;\n  border-color: var(--vf-border-color-signature-hr);\n}\n\n.vf-signature-loaded-wrapper {\n  position: absolute;\n  left: 2.25rem;\n  right: 2.25rem;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vf-signature-loaded-wrapper.vf-signature-loaded-wrapper-disabled {\n  opacity: 0.5;\n}\n\n.vf-signature-inner-wrapper.vf-signature-inner-wrapper-disabled {\n  opacity: 0.5;\n}\n\n.vf-signature-input {\n  background: transparent;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  transform: translateY(-50%);\n  padding: 0 2.25rem 0 0;\n  text-align: center;\n  text-indent: 2.25rem;\n  transition-property: box-shadow, color, background-color, border-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n  height: 8.5rem;\n}\n\n.vf-signature-placeholder {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 50%;\n  transform: translateY(50%);\n  pointer-events: none;\n  color: var(--vf-color-placeholder);\n  text-align: center;\n}\n\n.vf-signature-upload-container {\n  position: absolute;\n  left: 2.25rem;\n  right: 2.25rem;\n  bottom: 50%;\n  transform: translateY(50%);\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n}\n\n.vf-signature-upload-container.vf-signature-upload-container-dragging {\n  opacity: 0.5;\n}\n\n.vf-signature-upload-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.vf-signature-upload-wrapper.vf-signature-upload-wrapper-processing {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.vf-signature-dnd-text {\n  color: var(--vf-text-700);\n}\n\n.vf-signature-upload-preview {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.vf-signature-pad {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n}\n\n.vf-signature-colors {\n  position: absolute;\n  bottom: 1.25rem;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n}\n\n.vf-signature-color {\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n  cursor: pointer;\n  outline: none;\n  border-radius: 50%;\n}\n\n.vf-signature-color:hover, .vf-signature-color.vf-signature-color-active {\n  transform: scale(1.4);\n}\n\n.vf-signature-color:focus-visible {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-signature-actions {\n  position: absolute;\n  top: 0.5rem;\n  left: 0.75rem;\n  right: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  opacity: 0.5;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 200ms;\n  z-index: 1;\n}\n\n.vf-signature-actions:hover {\n  opacity: 1;\n}\n\n.vf-signature-undos-wrapper {\n  position: absolute;\n  right: 0.75rem;\n  top: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n}\n\n.vf-signature-undo,\n.vf-signature-redo {\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-bg-icon);\n  cursor: pointer;\n  width: 0.75rem;\n  height: 0.75rem;\n}\n\n.vf-signature-undo:focus-visible,\n.vf-signature-redo:focus-visible {\n  opacity: 0.8;\n}\n\n.vf-signature-undo {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\n.vf-signature-undo.vf-signature-undo-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.vf-signature-redo {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\n.vf-signature-redo.vf-signature-redo-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.vf-signature-clear-wrapper {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 1rem;\n  font-size: 14px;\n}\n\n.vf-signature-clear {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-color-input);\n  width: 0.75rem;\n  height: 1rem;\n  padding: 1px 0;\n  box-sizing: content-box;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.vf-signature-clear:focus-visible {\n  opacity: 0.8;\n}\n\n.dark .vf-signature-input-invert,\n.dark .vf-signature-pad-invert,\n.dark .vf-signature-color-invert {\n  filter: invert(1);\n}\n\n.dark .vf-signature-dnd-text {\n  color: var(--vf-dark-200);\n}\n\n.dark .vf-signature-undo,\n.dark .vf-signature-redo {\n  background: var(--vf-dark-300);\n}\n\n[dir=rtl] .vf-signature-input {\n  padding: 0 0 0 2.25rem;\n}\n\n[dir=rtl] .vf-signature-undos-wrapper {\n  right: auto;\n  left: 0.75rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$m);
$741c336afc2dfa06$export$64c8f8ba610cf318.__file = "themes/vueform/templates/elements/SignatureElement.vue";
function $741c336afc2dfa06$var$isNullish(val) {
    return [
        null,
        undefined,
        false
    ].indexOf(val) !== -1;
}
function $741c336afc2dfa06$var$useValue$2(props, context, dependencies) {
    const { value: baseValue, modelValue: modelValue, min: min } = (0, $8bTPG.toRefs)(props);
    // ================ DATA ================
    /* istanbul ignore next */ let value = modelValue && modelValue.value !== undefined ? modelValue : baseValue;
    const initialValue = (0, $8bTPG.ref)(value.value);
    // ================ HOOKS ===============
    if ($741c336afc2dfa06$var$isNullish(value.value)) value = (0, $8bTPG.ref)(min.value);
    if (Array.isArray(value.value) && value.value.length == 0) throw new Error('Slider v-model must not be an empty array');
    return {
        value: value,
        initialValue: initialValue
    };
}
function $741c336afc2dfa06$var$useClasses$1(props, context, dependencies) {
    const { classes: classes_, showTooltip: showTooltip, tooltipPosition: tooltipPosition, orientation: orientation } = (0, $8bTPG.toRefs)(props);
    // ============== COMPUTED ==============
    const classes = (0, $8bTPG.computed)(()=>({
            target: 'slider-target',
            focused: 'slider-focused',
            tooltipFocus: 'slider-tooltip-focus',
            tooltipDrag: 'slider-tooltip-drag',
            ltr: 'slider-ltr',
            rtl: 'slider-rtl',
            horizontal: 'slider-horizontal',
            vertical: 'slider-vertical',
            textDirectionRtl: 'slider-txt-dir-rtl',
            textDirectionLtr: 'slider-txt-dir-ltr',
            base: 'slider-base',
            connects: 'slider-connects',
            connect: 'slider-connect',
            origin: 'slider-origin',
            handle: 'slider-handle',
            handleLower: 'slider-handle-lower',
            handleUpper: 'slider-handle-upper',
            touchArea: 'slider-touch-area',
            tooltip: 'slider-tooltip',
            tooltipTop: 'slider-tooltip-top',
            tooltipBottom: 'slider-tooltip-bottom',
            tooltipLeft: 'slider-tooltip-left',
            tooltipRight: 'slider-tooltip-right',
            tooltipHidden: 'slider-tooltip-hidden',
            active: 'slider-active',
            draggable: 'slider-draggable',
            tap: 'slider-state-tap',
            drag: 'slider-state-drag',
            // Unimplemented
            pips: 'slider-pips',
            pipsHorizontal: 'slider-pips-horizontal',
            pipsVertical: 'slider-pips-vertical',
            marker: 'slider-marker',
            markerHorizontal: 'slider-marker-horizontal',
            markerVertical: 'slider-marker-vertical',
            markerNormal: 'slider-marker-normal',
            markerLarge: 'slider-marker-large',
            markerSub: 'slider-marker-sub',
            value: 'slider-value',
            valueHorizontal: 'slider-value-horizontal',
            valueVertical: 'slider-value-vertical',
            valueNormal: 'slider-value-normal',
            valueLarge: 'slider-value-large',
            valueSub: 'slider-value-sub',
            ...classes_.value
        }));
    const classList = (0, $8bTPG.computed)(()=>{
        const classList = {
            ...classes.value
        };
        Object.keys(classList).forEach((className)=>{
            classList[className] = Array.isArray(classList[className]) ? classList[className].filter((c)=>c !== null).join(' ') : classList[className];
        });
        if (showTooltip.value !== 'always') classList.target += ` ${showTooltip.value === 'drag' ? classList.tooltipDrag : classList.tooltipFocus}`;
        if (orientation.value === 'horizontal') classList.tooltip += tooltipPosition.value === 'bottom' ? ` ${classList.tooltipBottom}` : ` ${classList.tooltipTop}`;
        if (orientation.value === 'vertical') classList.tooltip += tooltipPosition.value === 'right' ? ` ${classList.tooltipRight}` : ` ${classList.tooltipLeft}`;
        return classList;
    });
    return {
        classList: classList
    };
}
var $741c336afc2dfa06$var$wNumb = {
    exports: {}
};
(function(module, exports) {
    (function(factory) {
        // Node/CommonJS
        module.exports = factory();
    })(function() {
        var FormatOptions = [
            "decimals",
            "thousand",
            "mark",
            "prefix",
            "suffix",
            "encoder",
            "decoder",
            "negativeBefore",
            "negative",
            "edit",
            "undo"
        ];
        // General
        // Reverse a string
        function strReverse(a) {
            return a.split("").reverse().join("");
        }
        // Check if a string starts with a specified prefix.
        function strStartsWith(input, match) {
            return input.substring(0, match.length) === match;
        }
        // Check is a string ends in a specified suffix.
        function strEndsWith(input, match) {
            return input.slice(-1 * match.length) === match;
        }
        // Throw an error if formatting options are incompatible.
        function throwEqualError(F, a, b) {
            if ((F[a] || F[b]) && F[a] === F[b]) throw new Error(a);
        }
        // Check if a number is finite and not NaN
        function isValidNumber(input) {
            return typeof input === "number" && isFinite(input);
        }
        // Provide rounding-accurate toFixed method.
        // Borrowed: http://stackoverflow.com/a/21323330/775265
        function toFixed(value, exp) {
            value = value.toString().split("e");
            value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));
            value = value.toString().split("e");
            return (+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))).toFixed(exp);
        }
        // Formatting
        // Accept a number as input, output formatted string.
        function formatTo(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
            var originalInput = input, inputIsNegative, inputPieces, inputBase, inputDecimals = "", output = "";
            // Apply user encoder to the input.
            // Expected outcome: number.
            if (encoder) input = encoder(input);
            // Stop if no valid number was provided, the number is infinite or NaN.
            if (!isValidNumber(input)) return false;
            // Rounding away decimals might cause a value of -0
            // when using very small ranges. Remove those cases.
            if (decimals !== false && parseFloat(input.toFixed(decimals)) === 0) input = 0;
            // Formatting is done on absolute numbers,
            // decorated by an optional negative symbol.
            if (input < 0) {
                inputIsNegative = true;
                input = Math.abs(input);
            }
            // Reduce the number of decimals to the specified option.
            if (decimals !== false) input = toFixed(input, decimals);
            // Transform the number into a string, so it can be split.
            input = input.toString();
            // Break the number on the decimal separator.
            if (input.indexOf(".") !== -1) {
                inputPieces = input.split(".");
                inputBase = inputPieces[0];
                if (mark) inputDecimals = mark + inputPieces[1];
            } else // If it isn't split, the entire number will do.
            inputBase = input;
            // Group numbers in sets of three.
            if (thousand) {
                inputBase = strReverse(inputBase).match(/.{1,3}/g);
                inputBase = strReverse(inputBase.join(strReverse(thousand)));
            }
            // If the number is negative, prefix with negation symbol.
            if (inputIsNegative && negativeBefore) output += negativeBefore;
            // Prefix the number
            if (prefix) output += prefix;
            // Normal negative option comes after the prefix. Defaults to '-'.
            if (inputIsNegative && negative) output += negative;
            // Append the actual number.
            output += inputBase;
            output += inputDecimals;
            // Apply the suffix.
            if (suffix) output += suffix;
            // Run the output through a user-specified post-formatter.
            if (edit) output = edit(output, originalInput);
            // All done.
            return output;
        }
        // Accept a sting as input, output decoded number.
        function formatFrom(decimals, thousand, mark, prefix, suffix, encoder, decoder, negativeBefore, negative, edit, undo, input) {
            var inputIsNegative, output = "";
            // User defined pre-decoder. Result must be a non empty string.
            if (undo) input = undo(input);
            // Test the input. Can't be empty.
            if (!input || typeof input !== "string") return false;
            // If the string starts with the negativeBefore value: remove it.
            // Remember is was there, the number is negative.
            if (negativeBefore && strStartsWith(input, negativeBefore)) {
                input = input.replace(negativeBefore, "");
                inputIsNegative = true;
            }
            // Repeat the same procedure for the prefix.
            if (prefix && strStartsWith(input, prefix)) input = input.replace(prefix, "");
            // And again for negative.
            if (negative && strStartsWith(input, negative)) {
                input = input.replace(negative, "");
                inputIsNegative = true;
            }
            // Remove the suffix.
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/slice
            if (suffix && strEndsWith(input, suffix)) input = input.slice(0, -1 * suffix.length);
            // Remove the thousand grouping.
            if (thousand) input = input.split(thousand).join("");
            // Set the decimal separator back to period.
            if (mark) input = input.replace(mark, ".");
            // Prepend the negative symbol.
            if (inputIsNegative) output += "-";
            // Add the number
            output += input;
            // Trim all non-numeric characters (allow '.' and '-');
            output = output.replace(/[^0-9\.\-.]/g, "");
            // The value contains no parse-able number.
            if (output === "") return false;
            // Covert to number.
            output = Number(output);
            // Run the user-specified post-decoder.
            if (decoder) output = decoder(output);
            // Check is the output is valid, otherwise: return false.
            if (!isValidNumber(output)) return false;
            return output;
        }
        // Framework
        // Validate formatting options
        function validate(inputOptions) {
            var i, optionName, optionValue, filteredOptions = {};
            if (inputOptions["suffix"] === undefined) inputOptions["suffix"] = inputOptions["postfix"];
            for(i = 0; i < FormatOptions.length; i += 1){
                optionName = FormatOptions[i];
                optionValue = inputOptions[optionName];
                if (optionValue === undefined) {
                    // Only default if negativeBefore isn't set.
                    if (optionName === "negative" && !filteredOptions.negativeBefore) filteredOptions[optionName] = "-";
                    else if (optionName === "mark" && filteredOptions.thousand !== ".") filteredOptions[optionName] = ".";
                    else filteredOptions[optionName] = false;
                // Floating points in JS are stable up to 7 decimals.
                } else if (optionName === "decimals") {
                    if (optionValue >= 0 && optionValue < 8) filteredOptions[optionName] = optionValue;
                    else throw new Error(optionName);
                // These options, when provided, must be functions.
                } else if (optionName === "encoder" || optionName === "decoder" || optionName === "edit" || optionName === "undo") {
                    if (typeof optionValue === "function") filteredOptions[optionName] = optionValue;
                    else throw new Error(optionName);
                // Other options are strings.
                } else {
                    if (typeof optionValue === "string") filteredOptions[optionName] = optionValue;
                    else throw new Error(optionName);
                }
            }
            // Some values can't be extracted from a
            // string if certain combinations are present.
            throwEqualError(filteredOptions, "mark", "thousand");
            throwEqualError(filteredOptions, "prefix", "negative");
            throwEqualError(filteredOptions, "prefix", "negativeBefore");
            return filteredOptions;
        }
        // Pass all options as function arguments
        function passAll(options, method, input) {
            var i, args = [];
            // Add all options in order of FormatOptions
            for(i = 0; i < FormatOptions.length; i += 1)args.push(options[FormatOptions[i]]);
            // Append the input, then call the method, presenting all
            // options as arguments.
            args.push(input);
            return method.apply("", args);
        }
        function wNumb(options) {
            if (!(this instanceof wNumb)) return new wNumb(options);
            if (typeof options !== "object") return;
            options = validate(options);
            // Call 'formatTo' with proper arguments.
            this.to = function(input) {
                return passAll(options, formatTo, input);
            };
            // Call 'formatFrom' with proper arguments.
            this.from = function(input) {
                return passAll(options, formatFrom, input);
            };
        }
        return wNumb;
    });
})($741c336afc2dfa06$var$wNumb);
var $741c336afc2dfa06$var$wnumb = $741c336afc2dfa06$var$wNumb.exports;
function $741c336afc2dfa06$var$useTooltip(props, context, dependencies) {
    const { format: format, step: step } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const value = dependencies.value;
    const classList = dependencies.classList;
    // ============== COMPUTED ==============
    // no export
    const tooltipFormat = (0, $8bTPG.computed)(()=>{
        if (!format || !format.value) return $741c336afc2dfa06$var$wnumb({
            decimals: step.value >= 0 ? 0 : 2
        });
        if (typeof format.value == 'function') return {
            to: format.value
        };
        return $741c336afc2dfa06$var$wnumb({
            ...format.value
        });
    });
    const tooltipsFormat = (0, $8bTPG.computed)(()=>{
        return Array.isArray(value.value) ? value.value.map((v)=>tooltipFormat.value) : tooltipFormat.value;
    });
    // =============== METHODS ==============
    /* istanbul ignore next */ const tooltipsMerge = (slider, threshold, separator)=>{
        var textIsRtl = getComputedStyle(slider).direction === 'rtl';
        var isRtl = slider.noUiSlider.options.direction === 'rtl';
        var isVertical = slider.noUiSlider.options.orientation === 'vertical';
        var tooltips = slider.noUiSlider.getTooltips();
        var origins = slider.noUiSlider.getOrigins();
        // Move tooltips into the origin element. The default stylesheet handles this.
        tooltips.forEach(function(tooltip, index) {
            if (tooltip) origins[index].appendChild(tooltip);
        });
        slider.noUiSlider.on('update', function(values, handle, unencoded, tap, positions) {
            var pools = [
                []
            ];
            var poolPositions = [
                []
            ];
            var poolValues = [
                []
            ];
            var atPool = 0;
            // Assign the first tooltip to the first pool, if the tooltip is configured
            if (tooltips[0]) {
                pools[0][0] = 0;
                poolPositions[0][0] = positions[0];
                poolValues[0][0] = tooltipFormat.value.to(parseFloat(values[0]));
            }
            for(var i = 1; i < values.length; i++){
                if (!tooltips[i] || values[i] - values[i - 1] > threshold) {
                    atPool++;
                    pools[atPool] = [];
                    poolValues[atPool] = [];
                    poolPositions[atPool] = [];
                }
                if (tooltips[i]) {
                    pools[atPool].push(i);
                    poolValues[atPool].push(tooltipFormat.value.to(parseFloat(values[i])));
                    poolPositions[atPool].push(positions[i]);
                }
            }
            pools.forEach(function(pool, poolIndex) {
                var handlesInPool = pool.length;
                for(var j = 0; j < handlesInPool; j++){
                    var handleNumber = pool[j];
                    if (j === handlesInPool - 1) {
                        var offset = 0;
                        poolPositions[poolIndex].forEach(function(value) {
                            offset += 1000 - value;
                        });
                        var direction = isVertical ? 'bottom' : 'right';
                        var last = isRtl ? 0 : handlesInPool - 1;
                        var lastOffset = 1000 - poolPositions[poolIndex][last];
                        offset = (textIsRtl && !isVertical ? 100 : 0) + offset / handlesInPool - lastOffset;
                        // Center this tooltip over the affected handles
                        tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
                        tooltips[handleNumber].style.display = 'block';
                        tooltips[handleNumber].style[direction] = offset + '%';
                        classList.value.tooltipHidden.split(' ').forEach((c)=>{
                            if (tooltips[handleNumber].classList.contains(c)) tooltips[handleNumber].classList.remove(c);
                        });
                    } else {
                        // Hide this tooltip
                        tooltips[handleNumber].style.display = 'none';
                        classList.value.tooltipHidden.split(' ').forEach((c)=>{
                            tooltips[handleNumber].classList.add(c);
                        });
                    }
                }
            });
        });
    };
    return {
        tooltipFormat: tooltipFormat,
        tooltipsFormat: tooltipsFormat,
        tooltipsMerge: tooltipsMerge
    };
}
var $741c336afc2dfa06$var$PipsMode;
(function(PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})($741c336afc2dfa06$var$PipsMode || ($741c336afc2dfa06$var$PipsMode = {}));
var $741c336afc2dfa06$var$PipsType;
(function(PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})($741c336afc2dfa06$var$PipsType || ($741c336afc2dfa06$var$PipsType = {}));
//region Helper Methods
function $741c336afc2dfa06$var$isValidFormatter(entry) {
    return $741c336afc2dfa06$var$isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function $741c336afc2dfa06$var$isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function $741c336afc2dfa06$var$removeElement(el) {
    el.parentElement.removeChild(el);
}
function $741c336afc2dfa06$var$isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function $741c336afc2dfa06$var$preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function $741c336afc2dfa06$var$unique(array) {
    return array.filter(function(a) {
        return !this[a] ? this[a] = true : false;
    }, {});
}
// Round a value to the closest 'to'.
function $741c336afc2dfa06$var$closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function $741c336afc2dfa06$var$offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = $741c336afc2dfa06$var$getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) pageOffset.x = 0;
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function $741c336afc2dfa06$var$isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function $741c336afc2dfa06$var$addClassFor(element, className, duration) {
    if (duration > 0) {
        $741c336afc2dfa06$var$addClass(element, className);
        setTimeout(function() {
            $741c336afc2dfa06$var$removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function $741c336afc2dfa06$var$limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function $741c336afc2dfa06$var$asArray(a) {
    return Array.isArray(a) ? a : [
        a
    ];
}
// Counts decimals
function $741c336afc2dfa06$var$countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function $741c336afc2dfa06$var$addClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.add(className);
    else el.className += " " + className;
}
// http://youmightnotneedjquery.com/#remove_class
function $741c336afc2dfa06$var$removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function $741c336afc2dfa06$var$hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function $741c336afc2dfa06$var$getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? doc.documentElement.scrollLeft : doc.body.scrollLeft;
    var y = supportPageOffset ? window.pageYOffset : isCSS1Compat ? doc.documentElement.scrollTop : doc.body.scrollTop;
    return {
        x: x,
        y: y
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function $741c336afc2dfa06$var$getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
    } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
    };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function $741c336afc2dfa06$var$getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */ try {
        var opts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassive = true;
            }
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    } catch (e) {}
    /* eslint-enable */ return supportsPassive;
}
function $741c336afc2dfa06$var$getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function $741c336afc2dfa06$var$subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function $741c336afc2dfa06$var$fromPercentage(range, value, startRange) {
    return value * 100 / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function $741c336afc2dfa06$var$toPercentage(range, value) {
    return $741c336afc2dfa06$var$fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function $741c336afc2dfa06$var$isPercentage(range, value) {
    return value * (range[1] - range[0]) / 100 + range[0];
}
function $741c336afc2dfa06$var$getJ(value, arr) {
    var j = 1;
    while(value >= arr[j])j += 1;
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function $741c336afc2dfa06$var$toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) return 100;
    var j = $741c336afc2dfa06$var$getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + $741c336afc2dfa06$var$toPercentage([
        va,
        vb
    ], value) / $741c336afc2dfa06$var$subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function $741c336afc2dfa06$var$fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) return xVal.slice(-1)[0];
    var j = $741c336afc2dfa06$var$getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return $741c336afc2dfa06$var$isPercentage([
        va,
        vb
    ], (value - pa) * $741c336afc2dfa06$var$subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function $741c336afc2dfa06$var$getStep(xPct, xSteps, snap, value) {
    if (value === 100) return value;
    var j = $741c336afc2dfa06$var$getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) return b;
        return a;
    }
    if (!xSteps[j - 1]) return value;
    return xPct[j - 1] + $741c336afc2dfa06$var$closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var $741c336afc2dfa06$var$Spectrum = /** @class */ function() {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [
            singleStep || false
        ];
        this.xNumSteps = [
            false
        ];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function(index) {
            ordered.push([
                $741c336afc2dfa06$var$asArray(entry[index]),
                index
            ]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function(a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for(index = 0; index < ordered.length; index++)this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for(index = 0; index < this.xNumSteps.length; index++)this.handleStepPoint(index, this.xNumSteps[index]);
    }
    Spectrum.prototype.getDistance = function(value) {
        var distances = [];
        for(var index = 0; index < this.xNumSteps.length - 1; index++)distances[index] = $741c336afc2dfa06$var$fromPercentage(this.xVal, value, index);
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function(value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) while(value > this.xPct[xPct_index + 1])xPct_index++;
        else if (value === this.xPct[this.xPct.length - 1]) xPct_index = this.xPct.length - 2;
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) xPct_index++;
        if (distances === null) distances = [];
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        else start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        // Do until the complete distance across ranges is calculated
        while(rest_rel_distance > 0){
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            } else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = distances[xPct_index + range_counter] * range_pct / 100 * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) range_counter--;
            } else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) range_counter++;
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function(value) {
        value = $741c336afc2dfa06$var$toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function(value) {
        return $741c336afc2dfa06$var$fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function(value) {
        value = $741c336afc2dfa06$var$getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function(value, isDown, size) {
        var j = $741c336afc2dfa06$var$getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || isDown && value === this.xPct[j - 1]) j = Math.max(j - 1, 1);
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function(value) {
        var j = $741c336afc2dfa06$var$getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2]
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1]
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j]
            }
        };
    };
    Spectrum.prototype.countStepDecimals = function() {
        var stepDecimals = this.xNumSteps.map($741c336afc2dfa06$var$countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function(value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function(index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") percentage = 0;
        else if (index === "max") percentage = 100;
        else percentage = parseFloat(index);
        // Check for correct input.
        if (!$741c336afc2dfa06$var$isNumeric(percentage) || !$741c336afc2dfa06$var$isNumeric(value[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) this.xSteps[0] = value1;
        } else this.xSteps.push(isNaN(value1) ? false : value1);
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function(i, n) {
        // Ignore 'false' stepping.
        if (!n) return;
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] = $741c336afc2dfa06$var$fromPercentage([
            this.xVal[i],
            this.xVal[i + 1]
        ], n, 0) / $741c336afc2dfa06$var$subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}();
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */ //region Defaults
var $741c336afc2dfa06$var$defaultFormatter = {
    to: function(value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number
};
var $741c336afc2dfa06$var$cssClasses = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub"
};
// Namespaces of internal event listeners
var $741c336afc2dfa06$var$INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria"
};
//endregion
function $741c336afc2dfa06$var$testStep(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'step' is not numeric.");
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function $741c336afc2dfa06$var$testKeyboardPageMultiplier(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    parsed.keyboardPageMultiplier = entry;
}
function $741c336afc2dfa06$var$testKeyboardMultiplier(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    parsed.keyboardMultiplier = entry;
}
function $741c336afc2dfa06$var$testKeyboardDefaultStep(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    parsed.keyboardDefaultStep = entry;
}
function $741c336afc2dfa06$var$testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) throw new Error("noUiSlider: 'range' is not an object.");
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    parsed.spectrum = new $741c336afc2dfa06$var$Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function $741c336afc2dfa06$var$testStart(parsed, entry) {
    entry = $741c336afc2dfa06$var$asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) throw new Error("noUiSlider: 'start' option is incorrect.");
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function $741c336afc2dfa06$var$testSnap(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function $741c336afc2dfa06$var$testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function $741c336afc2dfa06$var$testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    parsed.animationDuration = entry;
}
function $741c336afc2dfa06$var$testConnect(parsed, entry) {
    var connect = [
        false
    ];
    var i;
    // Map legacy options
    if (entry === "lower") entry = [
        true,
        false
    ];
    else if (entry === "upper") entry = [
        false,
        true
    ];
    // Handle boolean options
    if (entry === true || entry === false) {
        for(i = 1; i < parsed.handles; i++)connect.push(entry);
        connect.push(false);
    } else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    else connect = entry;
    parsed.connect = connect;
}
function $741c336afc2dfa06$var$testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch(entry){
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function $741c336afc2dfa06$var$testMargin(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'margin' option must be numeric.");
    // Issue #582
    if (entry === 0) return;
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function $741c336afc2dfa06$var$testLimit(parsed, entry) {
    if (!$741c336afc2dfa06$var$isNumeric(entry)) throw new Error("noUiSlider: 'limit' option must be numeric.");
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
}
function $741c336afc2dfa06$var$testPadding(parsed, entry) {
    var index;
    if (!$741c336afc2dfa06$var$isNumeric(entry) && !Array.isArray(entry)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(entry) && !(entry.length === 2 || $741c336afc2dfa06$var$isNumeric(entry[0]) || $741c336afc2dfa06$var$isNumeric(entry[1]))) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    if (entry === 0) return;
    if (!Array.isArray(entry)) entry = [
        entry,
        entry
    ];
    // 'getDistance' returns false for invalid values.
    parsed.padding = [
        parsed.spectrum.getDistance(entry[0]),
        parsed.spectrum.getDistance(entry[1])
    ];
    for(index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++){
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
}
function $741c336afc2dfa06$var$testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch(entry){
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function $741c336afc2dfa06$var$testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var invertConnects = entry.indexOf("invert-connects") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        // Use margin to enforce fixed state
        $741c336afc2dfa06$var$testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (invertConnects && parsed.handles !== 2) throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    if (unconstrained && (parsed.margin || parsed.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained,
        invertConnects: invertConnects
    };
}
function $741c336afc2dfa06$var$testTooltips(parsed, entry) {
    if (entry === false) return;
    if (entry === true || $741c336afc2dfa06$var$isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for(var i = 0; i < parsed.handles; i++)parsed.tooltips.push(entry);
    } else {
        entry = $741c336afc2dfa06$var$asArray(entry);
        if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        entry.forEach(function(formatter) {
            if (typeof formatter !== "boolean" && !$741c336afc2dfa06$var$isValidPartialFormatter(formatter)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        });
        parsed.tooltips = entry;
    }
}
function $741c336afc2dfa06$var$testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
    parsed.handleAttributes = entry;
}
function $741c336afc2dfa06$var$testAriaFormat(parsed, entry) {
    if (!$741c336afc2dfa06$var$isValidPartialFormatter(entry)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    parsed.ariaFormat = entry;
}
function $741c336afc2dfa06$var$testFormat(parsed, entry) {
    if (!$741c336afc2dfa06$var$isValidFormatter(entry)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    parsed.format = entry;
}
function $741c336afc2dfa06$var$testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    parsed.keyboardSupport = entry;
}
function $741c336afc2dfa06$var$testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function $741c336afc2dfa06$var$testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    parsed.cssPrefix = entry;
}
function $741c336afc2dfa06$var$testCssClasses(parsed, entry) {
    if (typeof entry !== "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function(key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    } else parsed.cssClasses = entry;
}
// Test all developer settings and parse to assumption-safe values.
function $741c336afc2dfa06$var$testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: $741c336afc2dfa06$var$defaultFormatter,
        format: $741c336afc2dfa06$var$defaultFormatter
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: {
            r: false,
            t: $741c336afc2dfa06$var$testStep
        },
        keyboardPageMultiplier: {
            r: false,
            t: $741c336afc2dfa06$var$testKeyboardPageMultiplier
        },
        keyboardMultiplier: {
            r: false,
            t: $741c336afc2dfa06$var$testKeyboardMultiplier
        },
        keyboardDefaultStep: {
            r: false,
            t: $741c336afc2dfa06$var$testKeyboardDefaultStep
        },
        start: {
            r: true,
            t: $741c336afc2dfa06$var$testStart
        },
        connect: {
            r: true,
            t: $741c336afc2dfa06$var$testConnect
        },
        direction: {
            r: true,
            t: $741c336afc2dfa06$var$testDirection
        },
        snap: {
            r: false,
            t: $741c336afc2dfa06$var$testSnap
        },
        animate: {
            r: false,
            t: $741c336afc2dfa06$var$testAnimate
        },
        animationDuration: {
            r: false,
            t: $741c336afc2dfa06$var$testAnimationDuration
        },
        range: {
            r: true,
            t: $741c336afc2dfa06$var$testRange
        },
        orientation: {
            r: false,
            t: $741c336afc2dfa06$var$testOrientation
        },
        margin: {
            r: false,
            t: $741c336afc2dfa06$var$testMargin
        },
        limit: {
            r: false,
            t: $741c336afc2dfa06$var$testLimit
        },
        padding: {
            r: false,
            t: $741c336afc2dfa06$var$testPadding
        },
        behaviour: {
            r: true,
            t: $741c336afc2dfa06$var$testBehaviour
        },
        ariaFormat: {
            r: false,
            t: $741c336afc2dfa06$var$testAriaFormat
        },
        format: {
            r: false,
            t: $741c336afc2dfa06$var$testFormat
        },
        tooltips: {
            r: false,
            t: $741c336afc2dfa06$var$testTooltips
        },
        keyboardSupport: {
            r: true,
            t: $741c336afc2dfa06$var$testKeyboardSupport
        },
        documentElement: {
            r: false,
            t: $741c336afc2dfa06$var$testDocumentElement
        },
        cssPrefix: {
            r: true,
            t: $741c336afc2dfa06$var$testCssPrefix
        },
        cssClasses: {
            r: true,
            t: $741c336afc2dfa06$var$testCssClasses
        },
        handleAttributes: {
            r: false,
            t: $741c336afc2dfa06$var$testHandleAttributes
        }
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: $741c336afc2dfa06$var$cssClasses,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) options.ariaFormat = options.format;
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function(name) {
        // If the option isn't set, but it is required, throw an error.
        if (!$741c336afc2dfa06$var$isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) throw new Error("noUiSlider: '" + name + "' is required.");
            return;
        }
        tests[name].t(parsed, !$741c336afc2dfa06$var$isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        [
            "left",
            "top"
        ],
        [
            "right",
            "bottom"
        ]
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function $741c336afc2dfa06$var$scope(target, options, originalOptions) {
    var actions = $741c336afc2dfa06$var$getActions();
    var supportsTouchActionNone = $741c336afc2dfa06$var$getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && $741c336afc2dfa06$var$getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_ConnectBase;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    var scope_ConnectsInverted = false;
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) $741c336afc2dfa06$var$addClass(div, className);
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function(event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function(attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) $741c336afc2dfa06$var$addClass(handle, options.cssClasses.handleLower);
        else if (handleNumber === options.handles - 1) $741c336afc2dfa06$var$addClass(handle, options.cssClasses.handleUpper);
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) return false;
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        scope_ConnectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for(var i = 0; i < options.handles; i++){
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.ltr);
        else $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.rtl);
        if (options.ort === 0) $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.horizontal);
        else $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.vertical);
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.textDirectionRtl);
        else $741c336afc2dfa06$var$addClass(addTarget, options.cssClasses.textDirectionLtr);
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) return false;
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        } else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function(handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        } else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function(handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + $741c336afc2dfa06$var$INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function(tooltip) {
                if (tooltip) $741c336afc2dfa06$var$removeElement(tooltip);
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + $741c336afc2dfa06$var$INTERNAL_EVENT_NS.tooltips, function(values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) return;
            if (scope_Tooltips[handleNumber] === false) return;
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + $741c336afc2dfa06$var$INTERNAL_EVENT_NS.aria);
        bindEvent("update" + $741c336afc2dfa06$var$INTERNAL_EVENT_NS.aria, function(values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function(index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === $741c336afc2dfa06$var$PipsMode.Range || pips.mode === $741c336afc2dfa06$var$PipsMode.Steps) return scope_Spectrum.xVal;
        if (pips.mode === $741c336afc2dfa06$var$PipsMode.Count) {
            if (pips.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while(interval--)values[interval] = interval * spread;
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === $741c336afc2dfa06$var$PipsMode.Positions) // Map all percentages to on-range values.
        return mapToRange(pips.values, pips.stepped);
        if (pips.mode === $741c336afc2dfa06$var$PipsMode.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) return pips.values.map(function(value) {
                // Convert to percentage, apply step, return to value.
                return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
            });
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function(value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = $741c336afc2dfa06$var$unique(group.slice().sort(function(a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function(current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === $741c336afc2dfa06$var$PipsMode.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) step = scope_Spectrum.xNumSteps[index];
            // Default to a 'full' step.
            if (!step) step = high - low;
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) high = low;
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for(i = low; i <= high; i = safeIncrement(i, step)){
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for(q = 1; q <= realSteps; q += 1){
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [
                        scope_Spectrum.fromStepping(pctPos),
                        0
                    ];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? $741c336afc2dfa06$var$PipsType.LargeValue : isSteps ? $741c336afc2dfa06$var$PipsType.SmallValue : $741c336afc2dfa06$var$PipsType.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) type = 0;
                if (!(i === high && ignoreLast)) // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                indexes[newPct.toFixed(5)] = [
                    i,
                    type
                ];
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {}, _a[$741c336afc2dfa06$var$PipsType.None] = "", _a[$741c336afc2dfa06$var$PipsType.NoValue] = options.cssClasses.valueNormal, _a[$741c336afc2dfa06$var$PipsType.LargeValue] = options.cssClasses.valueLarge, _a[$741c336afc2dfa06$var$PipsType.SmallValue] = options.cssClasses.valueSub, _a);
        var markerSizeClasses = (_b = {}, _b[$741c336afc2dfa06$var$PipsType.None] = "", _b[$741c336afc2dfa06$var$PipsType.NoValue] = options.cssClasses.markerNormal, _b[$741c336afc2dfa06$var$PipsType.LargeValue] = options.cssClasses.markerLarge, _b[$741c336afc2dfa06$var$PipsType.SmallValue] = options.cssClasses.markerSub, _b);
        var valueOrientationClasses = [
            options.cssClasses.valueHorizontal,
            options.cssClasses.valueVertical
        ];
        var markerOrientationClasses = [
            options.cssClasses.markerHorizontal,
            options.cssClasses.markerVertical
        ];
        $741c336afc2dfa06$var$addClass(element, options.cssClasses.pips);
        $741c336afc2dfa06$var$addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === $741c336afc2dfa06$var$PipsType.None) return;
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > $741c336afc2dfa06$var$PipsType.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function(offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            $741c336afc2dfa06$var$removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function(value) {
                return String(Math.round(value));
            }
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = "offset" + [
            "Width",
            "Height"
        ][options.ort];
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function(event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) return false;
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) return false;
            // Stop if an active 'tap' transition is taking place.
            if ($741c336afc2dfa06$var$hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) return false;
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) return false;
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) return false;
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) e.preventDefault();
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function(eventName) {
            element.addEventListener(eventName, method, supportsPassive ? {
                passive: true
            } : false);
            methods.push([
                eventName,
                method
            ]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) pointer = true;
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) return false;
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function(checkTouch) {
                var target = checkTouch.target;
                return target === eventTarget || eventTarget.contains(target) || e.composed && e.composedPath().shift() === eventTarget;
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) return false;
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            } else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) return false;
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || $741c336afc2dfa06$var$getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [
            x,
            y
        ];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - $741c336afc2dfa06$var$offset(scope_Base, options.ort);
        var proposal = location * 100 / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = $741c336afc2dfa06$var$limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function(handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) return;
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" && event.target.nodeName === "HTML" && event.relatedTarget === null) eventEnd(event, data);
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) return eventEnd(event, data);
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = movement * 100 / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            $741c336afc2dfa06$var$removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function(c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            $741c336afc2dfa06$var$removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", $741c336afc2dfa06$var$preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function(handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) return;
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            $741c336afc2dfa06$var$addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice()
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) $741c336afc2dfa06$var$addClass(scope_Target, options.cssClasses.drag);
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", $741c336afc2dfa06$var$preventDefault, false);
        }
        data.handleNumbers.forEach(function(handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) return;
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) $741c336afc2dfa06$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        } else eventStart(event, {
            handleNumbers: [
                handleNumber
            ]
        });
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function(targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(scope_Self, value);
            });
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) return false;
        var horizontalKeys = [
            "Left",
            "Right"
        ];
        var verticalKeys = [
            "Down",
            "Up"
        ];
        var largeStepKeys = [
            "PageDown",
            "PageUp"
        ];
        var edgeKeys = [
            "Home",
            "End"
        ];
        if (options.dir && !options.ort) // On an right-to-left slider, the left and right keys act inverted
        horizontalKeys.reverse();
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) return true;
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) return false;
            // No step set, use the default of 10% of the sub-range
            if (step === false) step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            if (isLargeUp || isLargeDown) step *= options.keyboardPageMultiplier;
            else step *= options.keyboardMultiplier;
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        } else if (isMax) // End key
        to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        else // Home key
        to = options.spectrum.xVal[0];
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) scope_Handles.forEach(function(handle, index) {
            // These events are only bound to the visual handle
            // element, not the 'real' origin element.
            attachEvent(actions.start, handle.children[0], eventStart, {
                handleNumbers: [
                    index
                ]
            });
        });
        // Attach the tap event to the slider base.
        if (behaviour.tap) attachEvent(actions.start, scope_Base, eventTap, {});
        // Fire hover events
        if (behaviour.hover) attachEvent(actions.move, scope_Base, eventHover, {
            hover: true
        });
        // Make the range draggable.
        if (behaviour.drag) scope_Connects.forEach(function(connect, index) {
            if (connect === false || index === 0 || index === scope_Connects.length - 1) return;
            var handleBefore = scope_Handles[index - 1];
            var handleAfter = scope_Handles[index];
            var eventHolders = [
                connect
            ];
            var handlesToDrag = [
                handleBefore,
                handleAfter
            ];
            var handleNumbersToDrag = [
                index - 1,
                index
            ];
            $741c336afc2dfa06$var$addClass(connect, options.cssClasses.draggable);
            // When the range is fixed, the entire range can
            // be dragged by the handles. The handle in the first
            // origin will propagate the start event upward,
            // but it needs to be bound manually on the other.
            if (behaviour.fixed) {
                eventHolders.push(handleBefore.children[0]);
                eventHolders.push(handleAfter.children[0]);
            }
            if (behaviour.dragAll) {
                handlesToDrag = scope_Handles;
                handleNumbersToDrag = scope_HandleNumbers;
            }
            eventHolders.forEach(function(eventHolder) {
                attachEvent(actions.start, eventHolder, eventStart, {
                    handles: handlesToDrag,
                    handleNumbers: handleNumbersToDrag,
                    connect: connect
                });
            });
        });
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") scope_Handles.forEach(function(a, index) {
            fireEvent("update", index);
        });
    }
    function isInternalNamespace(namespace) {
        return namespace === $741c336afc2dfa06$var$INTERNAL_EVENT_NS.aria || namespace === $741c336afc2dfa06$var$INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function(bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) // only delete protected internal event if intentional
            {
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) delete scope_Events[bind];
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function(targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) scope_Events[targetEvent].forEach(function(callback) {
                callback.call(// Use the slider public API as the scope ('this')
                scope_Self, // Return values as array, so arg_1[arg_2] is always valid.
                scope_Values.map(options.format.to), // Handle index, 0 or 1
                handleNumber, // Un-formatted slider values
                scope_Values.slice(), // Event is fired by tap, true or false
                tap || false, // Left offset of the handle, in relation to the slider
                scope_Locations.slice(), // add the slider public API to an accessible parameter when this is unavailable
                scope_Self);
            });
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) to = scope_Spectrum.getStep(to);
        // Limit percentage to the 0 - 100 range
        to = $741c336afc2dfa06$var$limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) return false;
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [
            !upward,
            upward
        ];
        var f = [
            upward,
            !upward
        ];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) handleNumbers.reverse();
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) handleNumbers.forEach(function(handleNumber, o) {
            var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
            // Stop if one of the handles can't move.
            if (to === false) proposal = 0;
            else {
                proposal = to - proposals[handleNumber];
                proposals[handleNumber] = to;
            }
        });
        else b = f = [
            true
        ];
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function(handleNumber, o) {
            state = setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function(handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) fireEvent("drag", firstHandle);
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        // sanity check for at least 2 handles (e.g. during setup)
        if (options.events.invertConnects && scope_Locations.length > 1) {
            // check if handles passed each other, but don't match the ConnectsInverted state
            var handlesAreInOrder = scope_Locations.every(function(position, index, locations) {
                return index === 0 || position >= locations[index - 1];
            });
            if (scope_ConnectsInverted !== !handlesAreInOrder) {
                // invert connects when handles pass each other
                invertConnects();
                // invertConnects already updates all connect elements
                return;
            }
        }
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
        if (scope_ConnectsInverted) {
            // When connects are inverted, we also have to update adjacent connects
            updateConnect(handleNumber - 1);
            updateConnect(handleNumber + 2);
        }
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function(handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        if (to === false) return false;
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) return;
        // Create a copy of locations, so we can sort them for the local scope logic
        var locations = scope_Locations.slice();
        if (scope_ConnectsInverted) locations.sort(function(a, b) {
            return a - b;
        });
        var l = 0;
        var h = 100;
        if (index !== 0) l = locations[index - 1];
        if (index !== scope_Connects.length - 1) h = locations[index];
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] = translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) return scope_Locations[handleNumber];
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") to = String(to);
        to = options.format.from(to);
        if (to !== false) to = scope_Spectrum.toStepping(to);
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) return scope_Locations[handleNumber];
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = $741c336afc2dfa06$var$asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) $741c336afc2dfa06$var$addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function(handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for(; i < scope_HandleNumbers.length; ++i)scope_HandleNumbers.forEach(function(handleNumber) {
            setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
        });
        setZindex();
        scope_HandleNumbers.forEach(function(handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) fireEvent("set", handleNumber);
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) fireEvent("set", handleNumber);
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) unencoded = false;
        if (unencoded) // return a copy of the raw values
        return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) return values[0];
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent($741c336afc2dfa06$var$INTERNAL_EVENT_NS.aria);
        removeEvent($741c336afc2dfa06$var$INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function(key) {
            $741c336afc2dfa06$var$removeClass(scope_Target, options.cssClasses[key]);
        });
        while(scope_Target.firstChild)scope_Target.removeChild(scope_Target.firstChild);
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) return [
            value - nearbySteps.stepBefore.startValue || null,
            nearbySteps.stepAfter.startValue - value || null
        ];
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) increment = nearbySteps.stepAfter.startValue - value;
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) decrement = nearbySteps.thisStep.step;
        else if (nearbySteps.stepBefore.step === false) decrement = false;
        else decrement = value - nearbySteps.stepBefore.highestStep;
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) increment = null;
        else if (location === 0) decrement = null;
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) increment = Number(increment.toFixed(stepDecimals));
        if (decrement !== null && decrement !== false) decrement = Number(decrement.toFixed(stepDecimals));
        return [
            decrement,
            increment
        ];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips",
            "connect"
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function(name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) originalOptions[name] = optionsToUpdate[name];
        });
        var newOptions = $741c336afc2dfa06$var$testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function(name) {
            if (optionsToUpdate[name] !== undefined) options[name] = newOptions[name];
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) pips(options.pips);
        else removePips();
        // Update tooltips, removes existing.
        if (options.tooltips) tooltips();
        else removeTooltips();
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet($741c336afc2dfa06$var$isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        // Update connects only if it was set
        if (optionsToUpdate.connect) updateConnectOption();
    }
    function updateConnectOption() {
        // IE supported way of removing children including event handlers
        while(scope_ConnectBase.firstChild)scope_ConnectBase.removeChild(scope_ConnectBase.firstChild);
        // Adding new connects according to the new connect options
        for(var i = 0; i <= options.handles; i++){
            scope_Connects[i] = addConnect(scope_ConnectBase, options.connect[i]);
            updateConnect(i);
        }
        // re-adding drag events for the new connect elements
        // to ignore the other events we have to negate the 'if (!behaviour.fixed)' check
        bindSliderEvents({
            drag: options.events.drag,
            fixed: true
        });
    }
    // Invert options for connect handles
    function invertConnects() {
        scope_ConnectsInverted = !scope_ConnectsInverted;
        $741c336afc2dfa06$var$testConnect(options, // inverse the connect boolean array
        options.connect.map(function(b) {
            return !b;
        }));
        updateConnectOption();
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) pips(options.pips);
        if (options.tooltips) tooltips();
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function(upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function() {
            return scope_Locations.slice();
        },
        getTooltips: function() {
            return scope_Tooltips;
        },
        getOrigins: function() {
            return scope_Handles;
        },
        pips: pips
    };
    return scope_Self;
}
// Run the standard initializer
function $741c336afc2dfa06$var$initialize(target, originalOptions) {
    if (!target || !target.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + target);
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
    // Test the options and create the slider environment;
    var options = $741c336afc2dfa06$var$testOptions(originalOptions);
    var api = $741c336afc2dfa06$var$scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}
var $741c336afc2dfa06$var$nouislider = {
    // Exposed for unit testing, don't use this in your application.
    __spectrum: $741c336afc2dfa06$var$Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: $741c336afc2dfa06$var$cssClasses,
    create: $741c336afc2dfa06$var$initialize
};
function $741c336afc2dfa06$var$arraysEqual(array1, array2) {
    // couldn't reproduce
    /* istanbul ignore next */ if (!Array.isArray(array1) || !Array.isArray(array2)) return false;
    const array2Sorted = array2.slice().sort();
    return array1.length === array2.length && array1.slice().sort().every(function(value, index) {
        return value === array2Sorted[index];
    });
}
function $741c336afc2dfa06$var$useSlider(props, context, dependencies) {
    const { orientation: orientation, direction: direction, tooltips: tooltips, step: step, min: min, max: max, merge: merge, id: id, disabled: disabled, options: options, classes: classes, format: format, lazy: lazy, ariaLabelledby: ariaLabelledby, aria: aria } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const value = dependencies.value;
    const initialValue = dependencies.initialValue;
    const tooltipsFormat = dependencies.tooltipsFormat;
    const tooltipsMerge = dependencies.tooltipsMerge;
    const tooltipFormat = dependencies.tooltipFormat;
    const classList = dependencies.classList;
    // ================ DATA ================
    const slider = (0, $8bTPG.ref)(null);
    const slider$ = (0, $8bTPG.ref)(null);
    // no export
    const inited = (0, $8bTPG.ref)(false);
    // ============== COMPUTED ==============
    // no export
    const defaultOptions = (0, $8bTPG.computed)(()=>{
        let defaultOptions = {
            cssPrefix: '',
            cssClasses: classList.value,
            orientation: orientation.value,
            direction: direction.value,
            tooltips: tooltips.value ? tooltipsFormat.value : false,
            connect: 'lower',
            start: $741c336afc2dfa06$var$isNullish(value.value) ? min.value : value.value,
            range: {
                'min': min.value,
                'max': max.value
            }
        };
        if (step.value > 0) defaultOptions.step = step.value;
        if (Array.isArray(value.value)) defaultOptions.connect = true;
        if (ariaLabelledby && ariaLabelledby.value || aria && Object.keys(aria.value).length) {
            let handles = Array.isArray(value.value) ? value.value : [
                value.value
            ];
            defaultOptions.handleAttributes = handles.map((h)=>Object.assign({}, aria.value, ariaLabelledby && ariaLabelledby.value ? {
                    'aria-labelledby': ariaLabelledby.value
                } : {}));
        }
        if (format.value) defaultOptions.ariaFormat = tooltipFormat.value;
        return defaultOptions;
    });
    const sliderProps = (0, $8bTPG.computed)(()=>{
        let sliderProps = {
            id: id && id.value ? id.value : undefined
        };
        if (disabled.value) sliderProps.disabled = true;
        return sliderProps;
    });
    const isRange = (0, $8bTPG.computed)(()=>{
        return Array.isArray(value.value);
    });
    // =============== METHODS ==============
    const reset = ()=>{
        updateValue(initialValue.value);
    };
    // no export
    const getSliderValue = ()=>{
        let sliderValue = slider$.value.get();
        return Array.isArray(sliderValue) ? sliderValue.map((v)=>parseFloat(v)) : parseFloat(sliderValue);
    };
    const update = (val, triggerChange = true)=>{
        slider$.value.set(val, triggerChange);
    };
    // no export
    const updateValue = (val)=>{
        context.emit('input', val);
        context.emit('update:modelValue', val);
        context.emit('update', val);
    };
    const init = ()=>{
        slider$.value = $741c336afc2dfa06$var$nouislider.create(slider.value, Object.assign({}, defaultOptions.value, options.value));
        if (tooltips.value && isRange.value && merge.value >= 0) tooltipsMerge(slider.value, merge.value, ' - ');
        slider$.value.on('set', ()=>{
            const sliderValue = getSliderValue();
            context.emit('change', sliderValue);
            context.emit('set', sliderValue);
            /* istanbul ignore else */ if (lazy.value) updateValue(sliderValue);
        });
        slider$.value.on('update', ()=>{
            if (!inited.value) return;
            const sliderValue = getSliderValue();
            if (isRange.value && $741c336afc2dfa06$var$arraysEqual(value.value, sliderValue) || !isRange.value && value.value == sliderValue) {
                context.emit('update', sliderValue);
                // Required because set event is not
                // triggered even though it should be
                return;
            }
            if (!lazy.value) updateValue(sliderValue);
        });
        /* istanbul ignore next */ slider$.value.on('start', ()=>{
            context.emit('start', getSliderValue());
        });
        /* istanbul ignore next */ slider$.value.on('end', ()=>{
            context.emit('end', getSliderValue());
        });
        /* istanbul ignore next */ slider$.value.on('slide', ()=>{
            context.emit('slide', getSliderValue());
        });
        /* istanbul ignore next */ slider$.value.on('drag', ()=>{
            context.emit('drag', getSliderValue());
        });
        slider.value.querySelectorAll('[data-handle]').forEach((handle)=>{
            handle.onblur = ()=>{
                /* istanbul ignore next */ if (!slider.value) return;
                classList.value.focused.split(' ').forEach((c)=>{
                    slider.value.classList.remove(c);
                });
            };
            handle.onfocus = ()=>{
                classList.value.focused.split(' ').forEach((c)=>{
                    slider.value.classList.add(c);
                });
            };
        });
        inited.value = true;
    };
    const destroy = ()=>{
        slider$.value.off();
        slider$.value.destroy();
        slider$.value = null;
    };
    const refresh = (n, o)=>{
        inited.value = false;
        destroy();
        init();
    };
    // ================ HOOKS ===============
    (0, $ani5R.onMounted)(init);
    (0, $ani5R.onUnmounted)(destroy);
    // ============== WATCHERS ==============
    (0, $8bTPG.watch)(isRange, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(min, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(max, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(step, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(orientation, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(direction, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(tooltips, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(merge, refresh, {
        immediate: false
    });
    (0, $8bTPG.watch)(format, refresh, {
        immediate: false,
        deep: true
    });
    (0, $8bTPG.watch)(options, refresh, {
        immediate: false,
        deep: true
    });
    (0, $8bTPG.watch)(classes, refresh, {
        immediate: false,
        deep: true
    });
    (0, $8bTPG.watch)(value, (value, old)=>{
        // If old was 0, null, undefined, '', false
        if (!old) return;
        if (// If both old and new has multiple handles
        // and the number of handles decreased
        typeof old === 'object' && typeof value === 'object' && value && Object.keys(old) > Object.keys(value) || // If the old had multiple handles but
        // if it decreased to single
        typeof old === 'object' && typeof value !== 'object' || // Or has no value at all
        $741c336afc2dfa06$var$isNullish(value)) refresh();
    }, {
        immediate: false
    });
    (0, $8bTPG.watch)(value, (newValue)=>{
        if ($741c336afc2dfa06$var$isNullish(newValue)) {
            update(min.value, false);
            return;
        }
        let sliderValue = getSliderValue();
        // couldn't reproduce
        /* istanbul ignore next */ if (isRange.value && !Array.isArray(sliderValue)) sliderValue = [
            sliderValue
        ];
        if (isRange.value && !$741c336afc2dfa06$var$arraysEqual(newValue, sliderValue) || !isRange.value && newValue != sliderValue) update(newValue, false);
    }, {
        deep: true
    });
    return {
        slider: slider,
        slider$: slider$,
        isRange: isRange,
        sliderProps: sliderProps,
        init: init,
        destroy: destroy,
        refresh: refresh,
        update: update,
        reset: reset
    };
}
/* istanbul ignore next */ const $741c336afc2dfa06$var$valueProps$1 = {
    value: {
        validator: function(p) {
            return (p)=>typeof p === 'number' || p instanceof Array || p === null || p === undefined || p === false;
        },
        required: false
    },
    modelValue: {
        validator: function(p) {
            return (p)=>typeof p === 'number' || p instanceof Array || p === null || p === undefined || p === false;
        },
        required: false
    }
};
var $741c336afc2dfa06$var$script$J = {
    name: 'Slider',
    emits: [
        'input',
        'update:modelValue',
        'start',
        'slide',
        'drag',
        'update',
        'change',
        'set',
        'end'
    ],
    props: {
        ...$741c336afc2dfa06$var$valueProps$1,
        id: {
            type: [
                String,
                Number
            ],
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        min: {
            type: Number,
            required: false,
            default: 0
        },
        max: {
            type: Number,
            required: false,
            default: 100
        },
        step: {
            type: Number,
            required: false,
            default: 1
        },
        orientation: {
            type: String,
            required: false,
            default: 'horizontal'
        },
        direction: {
            type: String,
            required: false,
            default: 'ltr'
        },
        tooltips: {
            type: Boolean,
            required: false,
            default: true
        },
        options: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        merge: {
            type: Number,
            required: false,
            default: -1
        },
        format: {
            type: [
                Object,
                Function,
                Boolean
            ],
            required: false,
            default: null
        },
        classes: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        showTooltip: {
            type: String,
            required: false,
            default: 'always'
        },
        tooltipPosition: {
            type: String,
            required: false,
            default: null
        },
        lazy: {
            type: Boolean,
            required: false,
            default: true
        },
        ariaLabelledby: {
            type: String,
            required: false,
            default: undefined
        },
        aria: {
            required: false,
            type: Object,
            default: ()=>({})
        }
    },
    setup (props, context) {
        // no export
        const value = $741c336afc2dfa06$var$useValue$2(props);
        const classes = $741c336afc2dfa06$var$useClasses$1(props);
        const tooltip = $741c336afc2dfa06$var$useTooltip(props, context, {
            value: value.value,
            classList: classes.classList
        });
        const slider = $741c336afc2dfa06$var$useSlider(props, context, {
            value: value.value,
            initialValue: value.initialValue,
            tooltipFormat: tooltip.tooltipFormat,
            tooltipsFormat: tooltip.tooltipsFormat,
            tooltipsMerge: tooltip.tooltipsMerge,
            classList: classes.classList
        });
        return {
            ...classes,
            ...tooltip,
            ...slider
        };
    }
};
function $741c336afc2dfa06$var$render$k(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)(_ctx.sliderProps, {
        ref: "slider"
    }), null, 16 /* FULL_PROPS */ );
}
$741c336afc2dfa06$var$script$J.render = $741c336afc2dfa06$var$render$k;
$741c336afc2dfa06$var$script$J.__file = "node_modules/@vueform/slider/src/Slider.vue";
var $741c336afc2dfa06$var$script$I = {
    name: 'SliderElement',
    components: {
        Slider: $741c336afc2dfa06$var$script$J
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                slider: {
                    target: '',
                    focused: '',
                    tooltipFocus: '',
                    tooltipDrag: '',
                    ltr: '',
                    rtl: '',
                    horizontal: '',
                    vertical: '',
                    textDirectionRtl: '',
                    textDirectionLtr: '',
                    base: '',
                    connects: '',
                    connect: '',
                    origin: '',
                    handle: '',
                    touchArea: '',
                    tooltip: '',
                    tooltipTop: '',
                    tooltipBottom: '',
                    tooltipLeft: '',
                    tooltipRight: '',
                    tooltipHidden: '',
                    active: '',
                    draggable: '',
                    tap: '',
                    drag: ''
                }
            }
        };
    }
};
function $741c336afc2dfa06$var$render$j(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slider = (0, $ani5R.resolveComponent)("Slider");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.createCommentVNode)(" @vueform/slider component "),
                    (0, $ani5R.createVNode)(_component_Slider, (0, $ani5R.mergeProps)({
                        value: _ctx.value,
                        modelValue: _ctx.value
                    }, _ctx.fieldOptions, {
                        aria: _ctx.aria,
                        classes: _ctx.classes.slider,
                        id: _ctx.fieldId,
                        ref: "input",
                        onUpdate: _ctx.handleUpdate,
                        onChange: _ctx.handleChange
                    }), null, 16 /* FULL_PROPS */ , [
                        "value",
                        "modelValue",
                        "aria",
                        "classes",
                        "id",
                        "onUpdate",
                        "onChange"
                    ])
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$I.render = $741c336afc2dfa06$var$render$j;
$741c336afc2dfa06$var$script$I.__file = "themes/blank/templates/elements/SliderElement.vue";
var $741c336afc2dfa06$export$f1da352a13861d9 = {
    name: 'SliderElement',
    render: $741c336afc2dfa06$var$script$I.render,
    components: {
        Slider: $741c336afc2dfa06$var$script$J
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: 'vf-slider-wrapper',
                wrapper_sm: 'vf-slider-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-slider-wrapper-lg',
                slider: {
                    target: 'vf-slider-target',
                    target_sm: 'vf-slider-target-sm',
                    target_md: 'vf-slider-target-md',
                    target_lg: 'vf-slider-target-lg',
                    focused: 'vf-slider-focused',
                    tooltipFocus: 'vf-slider-tooltip-focus',
                    tooltipDrag: 'vf-slider-tooltip-drag',
                    ltr: 'vf-slider-ltr',
                    rtl: 'vf-slider-rtl',
                    horizontal: 'vf-slider-horizontal',
                    horizontal_sm: 'vf-slider-horizontal-sm',
                    horizontal_md: 'vf-slider-horizontal-md',
                    horizontal_lg: 'vf-slider-horizontal-lg',
                    vertical: 'vf-slider-vertical',
                    vertical_sm: 'vf-slider-vertical-sm',
                    vertical_md: 'vf-slider-vertical-md',
                    vertical_lg: 'vf-slider-vertical-lg',
                    textDirectionRtl: 'vf-slider-txt-dir-rtl',
                    textDirectionLtr: 'vf-slider-txt-dir-ltr',
                    base: 'vf-slider-base',
                    base_sm: 'vf-slider-base-sm',
                    base_md: 'vf-slider-base-md',
                    base_lg: 'vf-slider-base-lg',
                    connects: 'vf-slider-connects',
                    connects_sm: 'vf-slider-connects-sm',
                    connects_md: 'vf-slider-connects-md',
                    connects_lg: 'vf-slider-connects-lg',
                    connect: 'vf-slider-connect',
                    connect_sm: 'vf-slider-connect-sm',
                    connect_md: 'vf-slider-connect-md',
                    connect_lg: 'vf-slider-connect-lg',
                    origin: 'vf-slider-origin',
                    handle: 'vf-slider-handle',
                    handle_sm: 'vf-slider-handle-sm',
                    handle_md: 'vf-slider-handle-md',
                    handle_lg: 'vf-slider-handle-lg',
                    handleUpper: 'vf-handle-upper',
                    handleLower: 'vf-handle-lower',
                    touchArea: 'vf-slider-touch-area',
                    tooltip: 'vf-slider-tooltip',
                    tooltip_sm: 'vf-slider-tooltip-sm',
                    tooltip_md: 'vf-slider-tooltip-md',
                    tooltip_lg: 'vf-slider-tooltip-lg',
                    tooltipTop: 'vf-slider-tooltip-top',
                    tooltipTop_sm: 'vf-slider-tooltip-top-sm',
                    tooltipTop_md: 'vf-slider-tooltip-top-md',
                    tooltipTop_lg: 'vf-slider-tooltip-top-lg',
                    tooltipBottom: 'vf-slider-tooltip-bottom',
                    tooltipBottom_sm: 'vf-slider-tooltip-bottom-sm',
                    tooltipBottom_md: 'vf-slider-tooltip-bottom-md',
                    tooltipBottom_lg: 'vf-slider-tooltip-bottom-lg',
                    tooltipLeft: 'vf-slider-tooltip-left',
                    tooltipLeft_sm: 'vf-slider-tooltip-left-sm',
                    tooltipLeft_md: 'vf-slider-tooltip-left-md',
                    tooltipLeft_lg: 'vf-slider-tooltip-left-lg',
                    tooltipRight: 'vf-slider-tooltip-right',
                    tooltipRight_sm: 'vf-slider-tooltip-right-sm',
                    tooltipRight_md: 'vf-slider-tooltip-right-md',
                    tooltipRight_lg: 'vf-slider-tooltip-right-lg',
                    tooltipHidden: 'vf-slider-tooltip-hidden',
                    active: 'vf-slider-active',
                    draggable: 'vf-slider-draggable',
                    tap: 'vf-slider-state-tap',
                    drag: 'vf-slider-state-drag',
                    $slider: (classes, { Size: Size })=>[
                            classes.slider.slider,
                            classes.slider[`slider_${Size}`]
                        ],
                    $horizontal: (classes, { Size: Size })=>[
                            classes.slider.horizontal,
                            classes.slider[`horizontal_${Size}`]
                        ],
                    $vertical: (classes, { Size: Size })=>[
                            classes.slider.vertical,
                            classes.slider[`vertical_${Size}`]
                        ],
                    $base: (classes, { Size: Size })=>[
                            classes.slider.base,
                            classes.slider[`base_${Size}`]
                        ],
                    $connects: (classes, { Size: Size })=>[
                            classes.slider.connects,
                            classes.slider[`connects_${Size}`]
                        ],
                    $connect: (classes, { Size: Size })=>[
                            classes.slider.connect,
                            classes.slider[`connect_${Size}`]
                        ],
                    $handle: (classes, { Size: Size })=>[
                            classes.slider.handle,
                            classes.slider[`handle_${Size}`]
                        ],
                    $tooltip: (classes, { Size: Size })=>[
                            classes.slider.tooltip,
                            classes.slider[`tooltip_${Size}`]
                        ],
                    $tooltipTop: (classes, { Size: Size })=>[
                            classes.slider.tooltipTop,
                            classes.slider[`tooltipTop_${Size}`]
                        ],
                    $tooltipBottom: (classes, { Size: Size })=>[
                            classes.slider.tooltipBottom,
                            classes.slider[`tooltipBottom_${Size}`]
                        ],
                    $tooltipLeft: (classes, { Size: Size })=>[
                            classes.slider.tooltipLeft,
                            classes.slider[`tooltipLeft_${Size}`]
                        ],
                    $tooltipRight: (classes, { Size: Size })=>[
                            classes.slider.tooltipRight,
                            classes.slider[`tooltipRight_${Size}`]
                        ]
                },
                $wrapper: (classes, { Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$l = ".vf-slider-wrapper {\n  margin-top: calc((var(--vf-min-height-input) - var(--vf-slider-height)) / 2);\n}\n\n.vf-slider-wrapper.vf-slider-wrapper-sm {\n  margin-top: calc((var(--vf-min-height-input-sm) - var(--vf-slider-height)) / 2);\n  margin-bottom: 0.25rem;\n}\n\n.vf-slider-wrapper.vf-slider-wrapper-lg {\n  margin-top: calc((var(--vf-min-height-input-lg) - var(--vf-slider-height)) / 2);\n}\n\n/* @vueform/slider styles */\n\n.vf-slider-target,\n.vf-slider-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-user-select: none;\n  touch-action: none;\n  -moz-user-select: none;\n  user-select: none;\n  box-sizing: border-box;\n}\n\n.vf-slider-target {\n  position: relative;\n  margin: calc((var(--vf-line-height) - var(--vf-slider-height)) / 2) 0;\n}\n\n.vf-slider-target[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vf-slider-target.vf-slider-target-sm {\n  margin: calc((var(--vf-line-height-sm) - var(--vf-slider-height-sm)) / 2) 0;\n}\n\n.vf-slider-target.vf-slider-target-lg {\n  margin: calc((var(--vf-line-height-lg) - var(--vf-slider-height-lg)) / 2) 0;\n}\n\n.vf-slider-target.vf-slider-horizontal {\n  height: var(--vf-slider-height);\n}\n\n.vf-slider-target.vf-slider-horizontal.vf-slider-horizontal-sm {\n  height: var(--vf-slider-height-sm);\n}\n\n.vf-slider-target.vf-slider-horizontal.vf-slider-horizontal-lg {\n  height: var(--vf-slider-height-lg);\n}\n\n.vf-slider-target.vf-slider-vertical {\n  width: var(--vf-slider-height);\n  height: var(--vf-slider-height-vertical);\n}\n\n.vf-slider-target.vf-slider-vertical.vf-slider-vertical-sm {\n  width: var(--vf-slider-height-sm);\n  height: var(--vf-slider-height-vertical-sm);\n}\n\n.vf-slider-target.vf-slider-vertical.vf-slider-vertical-lg {\n  width: var(--vf-slider-height-lg);\n  height: var(--vf-slider-height-vertical-lg);\n}\n\n.vf-slider-target.vf-slider-state-drag * {\n  cursor: inherit !important;\n}\n\n.vf-slider-base,\n.vf-slider-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.vf-slider-base {\n  box-shadow: var(--vf-shadow-input);\n  background-color: var(--vf-bg-passive);\n  border-radius: var(--vf-radius-slider);\n  z-index: 1;\n}\n\n.vf-slider-base.vf-slider-base-sm {\n  border-radius: var(--vf-radius-slider-sm);\n}\n\n.vf-slider-base.vf-slider-base-lg {\n  border-radius: var(--vf-radius-slider-lg);\n}\n\n.vf-slider-connects {\n  overflow: hidden;\n  z-index: 0;\n  border-radius: var(--vf-radius-slider);\n}\n\n.vf-slider-connects.vf-slider-connects-sm {\n  border-radius: var(--vf-radius-slider-sm);\n}\n\n.vf-slider-connects.vf-slider-connects-lg {\n  border-radius: var(--vf-radius-slider-lg);\n}\n\n.vf-slider-connect,\n.vf-slider-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n\n.vf-slider-connect {\n  background: var(--vf-primary);\n  border-radius: var(--vf-radius-slider);\n  cursor: pointer;\n}\n\n.vf-slider-connect.vf-slider-connect-sm {\n  border-radius: var(--vf-radius-slider-sm);\n}\n\n.vf-slider-connect.vf-slider-connect-lg {\n  border-radius: var(--vf-radius-slider-lg);\n}\n\n[disabled] .vf-slider-connect {\n  background: var(--vf-slider-connect-bg-disabled);\n}\n\n.vf-slider-txt-dir-rtl.vf-slider-horizontal .vf-slider-origin {\n  left: 0;\n  right: auto;\n}\n\n.vf-slider-vertical .vf-slider-origin {\n  top: -100%;\n  width: 0;\n}\n\n.vf-slider-horizontal .vf-slider-origin {\n  height: 0;\n}\n\n.vf-slider-state-tap .vf-slider-connect,\n.vf-slider-state-tap .vf-slider-origin {\n  transition: transform 0.3s;\n}\n\n.vf-slider-handle {\n  backface-visibility: hidden;\n  position: absolute;\n  width: var(--vf-slider-handle-size);\n  height: var(--vf-slider-handle-size);\n  background-color: var(--vf-bg-slider-handle);\n  border-radius: 999px;\n  box-shadow: var(--vf-shadow-handles);\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n  cursor: grab;\n  transition: box-shadow 0.2s ease-in-out, color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n}\n\n.vf-slider-handle:focus {\n  box-shadow: var(--vf-shadow-handles-focus);\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-slider-handle:hover {\n  box-shadow: var(--vf-shadow-handles-hover);\n}\n\n.vf-slider-handle.vf-slider-handle-sm {\n  height: var(--vf-slider-handle-size-sm);\n  width: var(--vf-slider-handle-size-sm);\n}\n\n.vf-slider-handle.vf-slider-handle-lg {\n  height: var(--vf-slider-handle-size-lg);\n  width: var(--vf-slider-handle-size-lg);\n}\n\n.vf-slider-horizontal .vf-slider-handle {\n  top: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 * -1);\n  right: calc(var(--vf-slider-handle-size) / 2 * -1);\n}\n\n.vf-slider-horizontal .vf-slider-handle.vf-slider-handle-sm {\n  top: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 * -1);\n  right: calc(var(--vf-slider-handle-size-sm) / 2 * -1);\n}\n\n.vf-slider-horizontal .vf-slider-handle.vf-slider-handle-lg {\n  top: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 * -1);\n  right: calc(var(--vf-slider-handle-size-lg) / 2 * -1);\n}\n\n.vf-slider-horizontal.vf-slider-txt-dir-rtl .vf-slider-handle {\n  left: calc(var(--vf-slider-handle-width) / 2 * -1);\n  right: auto;\n}\n\n.vf-slider-horizontal.vf-slider-txt-dir-rtl .vf-slider-handle.vf-slider-handle-sm {\n  left: calc(var(--vf-slider-handle-width-sm) / 2 * -1);\n}\n\n.vf-slider-horizontal.vf-slider-txt-dir-rtl .vf-slider-handle.vf-slider-handle-lg {\n  left: calc(var(--vf-slider-handle-width-lg) / 2 * -1);\n}\n\n.vf-slider-vertical {\n  width: var(--vf-slider-height);\n  height: var(--vf-slider-vertical-height);\n}\n\n.vf-slider-vertical .vf-slider-handle {\n  bottom: calc(var(--vf-slider-handle-size) / 2 * -1);\n  right: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 * -1);\n}\n\n.vf-slider-vertical .vf-slider-handle.vf-slider-handle-sm {\n  bottom: calc(var(--vf-slider-handle-size-sm) / 2 * -1);\n  right: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 * -1);\n}\n\n.vf-slider-vertical .vf-slider-handle.vf-slider-handle-lg {\n  bottom: calc(var(--vf-slider-handle-size-lg) / 2 * -1);\n  right: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 * -1);\n}\n\n.vf-slider-touch-area {\n  height: 100%;\n  width: 100%;\n}\n\n.vf-slider-tooltip {\n  position: absolute;\n  display: block;\n  font-weight: 600;\n  white-space: nowrap;\n  min-width: 1.25rem;\n  text-align: center;\n  border: 1px solid var(--vf-border-color-slider-tooltip);\n  background: var(--vf-primary);\n  color: var(--vf-color-on-primary);\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  padding: var(--vf-py-slider-tooltip) var(--vf-px-slider-tooltip);\n  border-radius: var(--vf-radius-small);\n}\n\n.vf-slider-tooltip.vf-slider-tooltip-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  padding: var(--vf-py-slider-tooltip-sm) var(--vf-px-slider-tooltip-sm);\n  border-radius: var(--vf-radius-small-sm);\n}\n\n.vf-slider-tooltip.vf-slider-tooltip-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n  padding: var(--vf-py-slider-tooltip-lg) var(--vf-px-slider-tooltip-lg);\n  border-radius: var(--vf-radius-small-lg);\n}\n\n.vf-slider-tooltip-focus .vf-slider-tooltip,\n.vf-slider-tooltip-drag .vf-slider-tooltip {\n  display: none !important;\n}\n\n.vf-slider-tooltip-focus.vf-slider-focused .vf-slider-tooltip:not(.vf-slider-tooltip-hidden),\n.vf-slider-tooltip-drag.vf-slider-state-drag .vf-slider-tooltip:not(.vf-slider-tooltip-hidden),\n.vf-slider-tooltip-drag .vf-slider-active .vf-slider-tooltip {\n  display: block !important;\n}\n\n[disabled].vf-slider-target,\n[disabled].vf-slider-handle,\n[disabled] .vf-slider-handle {\n  cursor: not-allowed;\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top {\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: calc(var(--vf-slider-handle-size) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  width: 0;\n  height: 0;\n  transform: translate(-50%);\n  bottom: calc(var(--vf-slider-tooltip-arrow-size) * -2);\n  border: var(--vf-slider-tooltip-arrow-size) solid transparent;\n  border-top-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top.vf-slider-tooltip-top-sm {\n  bottom: calc(var(--vf-slider-handle-size-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top.vf-slider-tooltip-top-sm:before {\n  bottom: calc(var(--vf-slider-tooltip-arrow-size-sm) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-sm) solid transparent;\n  border-top-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top.vf-slider-tooltip-top-lg {\n  bottom: calc(var(--vf-slider-handle-size-lg) + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-top.vf-slider-tooltip-top-lg:before {\n  bottom: calc(var(--vf-slider-tooltip-arrow-size-lg) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-lg) solid transparent;\n  border-top-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-top {\n  bottom: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-top.vf-slider-tooltip-top-sm {\n  bottom: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-top.vf-slider-tooltip-top-lg {\n  bottom: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom {\n  transform: translate(-50%, 0);\n  left: 50%;\n  top: calc(var(--vf-slider-handle-size) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom:before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  width: 0;\n  height: 0;\n  transform: translate(-50%);\n  top: calc(var(--vf-slider-tooltip-arrow-size) * -2);\n  border: var(--vf-slider-tooltip-arrow-size) solid transparent;\n  border-bottom-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-sm {\n  top: calc(var(--vf-slider-handle-size-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-sm:before {\n  top: calc(var(--vf-slider-tooltip-arrow-size-sm) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-sm) solid transparent;\n  border-bottom-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-lg {\n  top: calc(var(--vf-slider-handle-size-lg) + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-horizontal .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-lg:before {\n  top: calc(var(--vf-slider-tooltip-arrow-size-lg) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-lg) solid transparent;\n  border-bottom-color: inherit;\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-bottom {\n  top: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 + var(--vf-slider-height) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-sm {\n  top: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 + var(--vf-slider-height-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip-bottom.vf-slider-tooltip-bottom-lg {\n  top: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 + var(--vf-slider-height-lg) + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left {\n  transform: translate(0, -50%);\n  top: 50%;\n  right: calc(var(--vf-slider-handle-size) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 0;\n  height: 0;\n  transform: translateY(-50%);\n  right: calc(var(--vf-slider-tooltip-arrow-size) * -2);\n  border: var(--vf-slider-tooltip-arrow-size) solid transparent;\n  border-left-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left.vf-slider-tooltip-left-sm {\n  right: calc(var(--vf-slider-handle-size-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left.vf-slider-tooltip-left-sm:before {\n  right: calc(var(--vf-slider-tooltip-arrow-size-sm) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-sm) solid transparent;\n  border-left-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left.vf-slider-tooltip-left-lg {\n  right: calc(var(--vf-slider-handle-siz-lg) + var(--vf-slider-tooltip-distanc-lg));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-left.vf-slider-tooltip-left-lg:before {\n  right: calc(var(--vf-slider-tooltip-arrow-size-sm) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-sm) solid transparent;\n  border-left-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-left {\n  right: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 + var(--vf-slider-height) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-left.vf-slider-tooltip-left-sm {\n  right: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 + var(--vf-slider-height-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-left.vf-slider-tooltip-left-lg {\n  right: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 + var(--vf-slider-height-lg) + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right {\n  transform: translate(0, -50%);\n  top: 50%;\n  left: calc(var(--vf-slider-handle-size) + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: 0;\n  height: 0;\n  transform: translateY(-50%);\n  left: calc(var(--vf-slider-tooltip-arrow-size) * -2);\n  border: var(--vf-slider-tooltip-arrow-size) solid transparent;\n  border-right-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right.vf-slider-tooltip-right-sm {\n  left: calc(var(--vf-slider-handle-size-sm) + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right.vf-slider-tooltip-right-sm:before {\n  left: calc(var(--vf-slider-tooltip-arrow-size-sm) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-sm) solid transparent;\n  border-right-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right.vf-slider-tooltip-right-lg {\n  left: calc(var(--vf-slider-handle-size-lg) + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-vertical .vf-slider-tooltip-right.vf-slider-tooltip-right-lg:before {\n  left: calc(var(--vf-slider-tooltip-arrow-size-lg) * -2);\n  border: var(--vf-slider-tooltip-arrow-size-lg) solid transparent;\n  border-right-color: inherit;\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-right {\n  left: calc((var(--vf-slider-handle-size) - var(--vf-slider-height)) / 2 + var(--vf-slider-tooltip-distance));\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-right.vf-slider-tooltip-right-sm {\n  left: calc((var(--vf-slider-handle-size-sm) - var(--vf-slider-height-sm)) / 2 + var(--vf-slider-tooltip-distance-sm));\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip-right.vf-slider-tooltip-right-lg {\n  left: calc((var(--vf-slider-handle-size-lg) - var(--vf-slider-height-lg)) / 2 + var(--vf-slider-tooltip-distance-lg));\n}\n\n.vf-slider-horizontal .vf-slider-origin > .vf-slider-tooltip {\n  transform: translate(50%, 0);\n  left: auto;\n}\n\n.vf-slider-vertical .vf-slider-origin > .vf-slider-tooltip {\n  transform: translate(0, 50%);\n  top: auto;\n}\n\n.vf-slider-active {\n  cursor: grabbing;\n}\n\n.vf-slider-draggable {\n  cursor: ew-resize;\n}\n\n.vf-slider-vertical .vf-slider-draggable {\n  cursor: ns-resize;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$l);
$741c336afc2dfa06$export$f1da352a13861d9.__file = "themes/vueform/templates/elements/SliderElement.vue";
var $741c336afc2dfa06$var$script$G = {
    name: 'StaticElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                content: '',
                tag: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$f = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_2$a = [
    "href",
    "target",
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_3$8 = [
    "href",
    "target"
];
const $741c336afc2dfa06$var$_hoisted_4$5 = [
    "href",
    "target"
];
const $741c336afc2dfa06$var$_hoisted_5$2 = [
    "src",
    "alt",
    "title",
    "width",
    "height"
];
const $741c336afc2dfa06$var$_hoisted_6$1 = [
    "src",
    "alt",
    "title",
    "width",
    "height"
];
const $741c336afc2dfa06$var$_hoisted_7 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$i(_ctx, _cache, $props, $setup, $data, $options) {
    return _ctx.wrap ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        key: 0,
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createCommentVNode)(" If content is HTML "),
                _ctx.isHtml && (_ctx.resolvedContent || [
                    'img',
                    'hr'
                ].indexOf(_ctx.tag) !== -1) ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 0
                }, [
                    !_ctx.tag && _ctx.allowHtml ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
                        key: 0,
                        class: _ctx.classes.content,
                        innerHTML: _ctx.resolvedContent
                    }, _ctx.attrs), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$f)) : (0, $ani5R.createCommentVNode)("v-if", true),
                    !_ctx.tag && !_ctx.allowHtml ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
                        key: 1,
                        class: _ctx.classes.content
                    }, _ctx.attrs), (0, $X5A94.toDisplayString)(_ctx.content), 17 /* TEXT, FULL_PROPS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.tag === 'a' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 2,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.tag)
                    }, [
                        _ctx.allowHtml ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", (0, $ani5R.mergeProps)({
                            key: 0,
                            href: _ctx.href,
                            target: _ctx.target
                        }, _ctx.attrs, {
                            innerHTML: _ctx.resolvedContent
                        }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_2$a)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", (0, $ani5R.mergeProps)({
                            key: 1,
                            href: _ctx.href,
                            target: _ctx.target
                        }, _ctx.attrs), (0, $X5A94.toDisplayString)(_ctx.resolvedContent), 17 /* TEXT, FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_3$8))
                    ], 2 /* CLASS */ )) : _ctx.tag === 'hr' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 3,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.tag)
                    }, [
                        (0, $ani5R.createElementVNode)("hr", (0, $X5A94.normalizeProps)((0, $ani5R.guardReactiveProps)(_ctx.attrs)), null, 16 /* FULL_PROPS */ )
                    ], 2 /* CLASS */ )) : _ctx.tag === 'img' ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 4,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.tag)
                    }, [
                        _ctx.href ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                            key: 0,
                            href: _ctx.href,
                            target: _ctx.target
                        }, [
                            (0, $ani5R.createElementVNode)("img", (0, $ani5R.mergeProps)({
                                src: _ctx.src,
                                alt: _ctx.alt,
                                title: _ctx.title,
                                width: _ctx.width,
                                height: _ctx.height
                            }, _ctx.attrs), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_5$2)
                        ], 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_4$5)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("img", (0, $ani5R.mergeProps)({
                            key: 1,
                            src: _ctx.src,
                            alt: _ctx.alt,
                            title: _ctx.title,
                            width: _ctx.width,
                            height: _ctx.height
                        }, _ctx.attrs), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_6$1))
                    ], 2 /* CLASS */ )) : _ctx.tag ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                        key: 5,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.tag)
                    }, [
                        _ctx.allowHtml ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.tag), (0, $ani5R.mergeProps)({
                            key: 0,
                            innerHTML: _ctx.resolvedContent
                        }, _ctx.attrs), null, 16 /* FULL_PROPS */ , [
                            "innerHTML"
                        ])) : ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.tag), (0, $X5A94.normalizeProps)((0, $ani5R.mergeProps)({
                            key: 1
                        }, _ctx.attrs)), {
                            default: (0, $ani5R.withCtx)(()=>[
                                    (0, $ani5R.createTextVNode)((0, $X5A94.toDisplayString)(_ctx.resolvedContent), 1 /* TEXT */ )
                                ]),
                            _: 1 /* STABLE */ 
                        }, 16 /* FULL_PROPS */ ))
                    ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                ], 64 /* STABLE_FRAGMENT */ )) : _ctx.resolvedContent ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 1
                }, [
                    (0, $ani5R.createCommentVNode)(" If content is component "),
                    ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.componentContent), {
                        el$: _ctx.el$
                    }, null, 8 /* PROPS */ , [
                        "el$"
                    ]))
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 2
                }, [
                    (0, $ani5R.createCommentVNode)(" If content is a slot "),
                    (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                        el$: _ctx.el$
                    }, ()=>[
                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.slotContent), {
                                el$: _ctx.el$
                            }, null, 8 /* PROPS */ , [
                                "el$"
                            ]))
                        ])
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ ))
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ )) : _ctx.content && _ctx.isHtml ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        key: 1,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.content),
        innerHTML: _ctx.resolvedContent
    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_7)) : _ctx.content ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.componentContent), {
        key: 2,
        ref: "container"
    }, null, 512 /* NEED_PATCH */ )) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        key: 3,
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        ref: "container"
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
            el$: _ctx.el$
        }, ()=>[
                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.slotContent), {
                    el$: _ctx.el$
                }, null, 8 /* PROPS */ , [
                    "el$"
                ]))
            ])
    ], 2 /* CLASS */ ));
}
$741c336afc2dfa06$var$script$G.render = $741c336afc2dfa06$var$render$i;
$741c336afc2dfa06$var$script$G.__file = "themes/blank/templates/elements/StaticElement.vue";
var $741c336afc2dfa06$export$5f9c2763a5c20d1 = {
    name: 'StaticElement',
    render: $741c336afc2dfa06$var$script$G.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-contains-link',
                content: 'vf-static',
                content_sm: 'vf-static-sm',
                content_md: '',
                content_lg: 'vf-static-lg',
                content_top_1: 'vf-static-tag-top-1',
                content_top_2: 'vf-static-tag-top-2',
                content_top_3: 'vf-static-tag-top-3',
                content_bottom_1: 'vf-static-tag-bottom-1',
                content_bottom_2: 'vf-static-tag-bottom-2',
                content_bottom_3: 'vf-static-tag-bottom-3',
                tag: 'vf-static-tag',
                tag_sm: 'vf-static-tag-sm',
                tag_md: '',
                tag_lg: 'vf-static-tag-lg',
                tag_top_1: 'vf-static-tag-top-1',
                tag_top_2: 'vf-static-tag-top-2',
                tag_top_3: 'vf-static-tag-top-3',
                tag_bottom_1: 'vf-static-tag-bottom-1',
                tag_bottom_2: 'vf-static-tag-bottom-2',
                tag_bottom_3: 'vf-static-tag-bottom-3',
                tag_left: 'vf-static-tag-left',
                tag_center: 'vf-static-tag-center',
                tag_right: 'vf-static-tag-right',
                tag_p: 'vf-static-tag-p',
                tag_h1: 'vf-static-tag-h1',
                tag_h2: 'vf-static-tag-h2',
                tag_h3: 'vf-static-tag-h3',
                tag_h4: 'vf-static-tag-h4',
                tag_blockquote: 'vf-static-tag-blockquote',
                tag_a: 'vf-static-tag-a',
                tag_hr: 'vf-static-tag-hr',
                tag_img: 'vf-static-tag-img',
                $content: (classes, { Size: Size, top: top, bottom: bottom })=>[
                        classes.content,
                        classes[`content_${Size}`],
                        top >= 1 ? classes[`content_top_${top}`] : null,
                        bottom >= 1 ? classes[`content_bottom_${bottom}`] : null
                    ],
                $tag: (classes, { Size: Size, tag: tag, align: align, top: top, bottom: bottom })=>[
                        classes.tag,
                        classes[`tag_${Size}`],
                        classes[`tag_${tag}`],
                        align === 'left' ? classes.tag_left : null,
                        align === 'center' ? classes.tag_center : null,
                        align === 'right' ? classes.tag_right : null,
                        top >= 1 ? classes[`tag_top_${top}`] : null,
                        bottom >= 1 ? classes[`tag_bottom_${bottom}`] : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$k = "/* Styles contained in scss/_static.scss */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$k);
$741c336afc2dfa06$export$5f9c2763a5c20d1.__file = "themes/vueform/templates/elements/StaticElement.vue";
var $741c336afc2dfa06$var$script$E = {
    name: 'TagsElement',
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                select: {
                    container: '',
                    containerDisabled: '',
                    containerOpen: '',
                    containerOpenTop: '',
                    containerActive: '',
                    search: '',
                    tags: '',
                    tag: '',
                    tagDisabled: '',
                    tagRemove: '',
                    tagRemoveIcon: '',
                    tagsSearchWrapper: '',
                    tagsSearch: '',
                    tagsSearchCopy: '',
                    placeholder: '',
                    caret: '',
                    caretOpen: '',
                    clear: '',
                    clearIcon: '',
                    spinner: '',
                    dropdown: '',
                    dropdownTop: '',
                    dropdownHidden: '',
                    options: '',
                    optionsTop: '',
                    group: '',
                    groupLabel: '',
                    groupLabelPointable: '',
                    groupLabelPointed: '',
                    groupLabelSelected: '',
                    groupLabelDisabled: '',
                    groupLabelSelectedPointed: '',
                    groupLabelSelectedDisabled: '',
                    groupOptions: '',
                    option: '',
                    optionPointed: '',
                    optionSelected: '',
                    optionDisabled: '',
                    optionSelectedPointed: '',
                    optionSelectedDisabled: '',
                    noOptions: '',
                    noResults: '',
                    fakeInput: '',
                    spacer: ''
                }
            }
        };
    }
};
function $741c336afc2dfa06$var$render$h(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_Multiselect = (0, $ani5R.resolveComponent)("Multiselect");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                    key: 0,
                    visible: !_ctx.empty
                }, null, 8 /* PROPS */ , [
                    "visible"
                ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" @vueform/multiselect copmonent "),
                (0, $ani5R.createVNode)(_component_Multiselect, (0, $ani5R.mergeProps)(_ctx.fieldOptions, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.value = $event),
                    classes: _ctx.classes.select,
                    id: _ctx.fieldId,
                    name: _ctx.name,
                    options: _ctx.resolvedOptions,
                    disabled: _ctx.isDisabled,
                    placeholder: _ctx.Placeholder,
                    attrs: _ctx.attrs,
                    aria: _ctx.aria,
                    locale: _ctx.form$.locale$,
                    onSelect: _ctx.handleSelect,
                    onDeselect: _ctx.handleDeselect,
                    onSearchChange: _ctx.handleSearchChange,
                    onTag: _ctx.handleTag,
                    onOpen: _ctx.handleOpen,
                    onClose: _ctx.handleClose,
                    onClear: _ctx.handleClear,
                    onPaste: _ctx.handlePaste,
                    ref: "input"
                }), (0, $ani5R.createSlots)({
                    _: 2 /* DYNAMIC */ 
                }, [
                    (0, $ani5R.renderList)({
                        option: 'option',
                        noresults: 'no-results',
                        nooptions: 'no-options',
                        afterlist: 'after-list',
                        beforelist: 'before-list',
                        placeholder: 'placeholder',
                        grouplabel: 'group-label',
                        caret: 'caret',
                        clear: 'clear',
                        spinner: 'spinner',
                        default: 'default'
                    }, (slotName, slotKey)=>{
                        return {
                            name: slotKey,
                            fn: (0, $ani5R.withCtx)((props)=>[
                                    (0, $ani5R.renderSlot)(_ctx.$slots, slotName, (0, $ani5R.mergeProps)(props, {
                                        el$: _ctx.el$
                                    }), ()=>[
                                            ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots[slotName]), (0, $ani5R.mergeProps)(props, {
                                                el$: _ctx.el$
                                            }), null, 16 /* FULL_PROPS */ , [
                                                "el$"
                                            ]))
                                        ])
                                ])
                        };
                    }),
                    _ctx.fieldOptions.mode == 'tags' ? {
                        name: "tag",
                        fn: (0, $ani5R.withCtx)(({ option: option, handleTagRemove: handleTagRemove, disabled: disabled })=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "tag", {
                                    option: option,
                                    handleTagRemove: handleTagRemove,
                                    disabled: disabled,
                                    el$: _ctx.el$
                                }, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.tag), {
                                            option: option,
                                            handleTagRemove: handleTagRemove,
                                            disabled: disabled,
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "option",
                                            "handleTagRemove",
                                            "disabled",
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        key: "0"
                    } : undefined
                ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */ , [
                    "modelValue",
                    "classes",
                    "id",
                    "name",
                    "options",
                    "disabled",
                    "placeholder",
                    "attrs",
                    "aria",
                    "locale",
                    "onSelect",
                    "onDeselect",
                    "onSearchChange",
                    "onTag",
                    "onOpen",
                    "onClose",
                    "onClear",
                    "onPaste"
                ])
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$E.render = $741c336afc2dfa06$var$render$h;
$741c336afc2dfa06$var$script$E.__file = "themes/blank/templates/elements/TagsElement.vue";
var $741c336afc2dfa06$export$751fafeae41a8f96 = {
    name: 'TagsElement',
    render: $741c336afc2dfa06$var$script$E.render,
    components: {
        Multiselect: $741c336afc2dfa06$var$script$_
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                select: {
                    tags: 'vf-multiselect-tags',
                    tags_sm: 'vf-multiselect-tags-sm',
                    tags_md: '',
                    tags_lg: 'vf-multiselect-tags-lg',
                    tag: 'vf-multiselect-tag',
                    tag_sm: 'vf-multiselect-tag-sm',
                    tag_md: '',
                    tag_lg: 'vf-multiselect-tag-lg',
                    tagDisabled: 'vf-multiselect-tag-disabled',
                    tagDisabled_sm: '',
                    tagDisabled_md: '',
                    tagDisabled_lg: '',
                    tagWrapper: 'vf-multiselect-tag-wrapper',
                    tagWrapperBreak: 'vf-multiselect-tag-wrapper-break',
                    tagRemove: 'vf-multiselect-tag-remove',
                    tagRemove_sm: 'vf-multiselect-tag-remove-sm',
                    tagRemove_md: '',
                    tagRemove_lg: 'vf-multiselect-tag-remove-lg',
                    tagRemoveIcon: 'vf-multiselect-tag-remove-icon',
                    tagsSearchWrapper: 'vf-multiselect-tags-search-wrapper',
                    tagsSearchWrapper_sm: '',
                    tagsSearchWrapper_md: '',
                    tagsSearchWrapper_lg: '',
                    tagsSearch: 'vf-multiselect-tags-search',
                    tagsSearch_sm: 'vf-multiselect-tags-search-sm',
                    tagsSearch_md: '',
                    tagsSearch_lg: 'vf-multiselect-tags-search-lg',
                    tagsSearchCopy: 'vf-multiselect-tags-search-copy',
                    container: 'vf-multiselect',
                    container_enabled: '',
                    container_disabled: 'vf-multiselect-disabled',
                    container_success: 'vf-multiselect-success',
                    container_danger: 'vf-multiselect-danger',
                    container_sm: 'vf-multiselect-sm',
                    container_md: '',
                    container_lg: 'vf-multiselect-lg',
                    containerDisabled: '',
                    containerOpen: 'vf-multiselect-open',
                    containerOpenTop: 'vf-multiselect-open-top',
                    containerActive: 'vf-multiselect-active',
                    containerActive_enabled: '',
                    wrapper: 'vf-multiselect-wrapper',
                    wrapper_sm: 'vf-multiselect-wrapper-sm',
                    wrapper_md: '',
                    wrapper_lg: 'vf-multiselect-wrapper-lg',
                    search: 'vf-multiselect-search',
                    search_sm: 'vf-multiselect-search-sm',
                    search_md: '',
                    search_lg: 'vf-multiselect-search-lg',
                    placeholder: 'vf-multiselect-placeholder',
                    placeholder_sm: 'vf-multiselect-placeholder-sm',
                    placeholder_md: '',
                    placeholder_lg: 'vf-multiselect-placeholder-lg',
                    caret: 'vf-multiselect-caret',
                    caret_sm: 'vf-multiselect-caret-sm',
                    caret_md: '',
                    caret_lg: 'vf-multiselect-caret-lg',
                    caretOpen: 'vf-multiselect-caret-open',
                    clear: 'vf-multiselect-clear',
                    clear_sm: 'vf-multiselect-clear-sm',
                    clear_md: '',
                    clear_lg: 'vf-multiselect-clear-lg',
                    clearIcon: 'vf-multiselect-clear-icon',
                    spinner: 'vf-multiselect-spinner',
                    spinner_sm: 'vf-multiselect-spinner-sm',
                    spinner_md: '',
                    spinner_lg: 'vf-multiselect-spinner-lg',
                    infinite: 'vf-multiselect-infinite',
                    infinite_sm: 'vf-multiselect-infinite-sm',
                    infinite_md: '',
                    infinite_lg: 'vf-multiselect-infinite-lg',
                    infiniteSpinner: 'vf-multiselect-infinite-spinner',
                    dropdown: 'vf-multiselect-dropdown',
                    dropdown_sm: 'vf-multiselect-dropdown-sm',
                    dropdown_md: '',
                    dropdown_lg: 'vf-multiselect-dropdown-lg',
                    dropdownTop: 'vf-multiselect-dropdown-top',
                    dropdownTop_sm: 'vf-multiselect-dropdown-top-sm',
                    dropdownTop_md: '',
                    dropdownTop_lg: 'vf-multiselect-dropdown-top-lg',
                    dropdownHidden: 'vf-multiselect-dropdown-hidden',
                    options: 'vf-multiselect-options',
                    optionsTop: 'vf-multiselect-options-top',
                    group: 'vf-multiselect-group',
                    groupLabel: 'vf-multiselect-group-label',
                    groupLabel_sm: 'vf-multiselect-group-label-sm',
                    groupLabel_md: '',
                    groupLabel_lg: 'vf-multiselect-group-label-lg',
                    groupLabelPointable: 'vf-multiselect-group-label-pointable',
                    groupLabelPointed: 'vf-multiselect-group-label-pointed',
                    groupLabelSelected: 'vf-multiselect-group-label-selected',
                    groupLabelDisabled: 'vf-multiselect-group-label-disabled',
                    groupLabelSelectedPointed: 'vf-multiselect-group-label-selected vf-multiselect-group-label-pointed',
                    groupLabelSelectedDisabled: 'vf-multiselect-group-label-selected vf-multiselect-group-label-disabled',
                    groupOptions: 'vf-multiselect-group-options',
                    option: 'vf-multiselect-option',
                    option_sm: 'vf-multiselect-option-sm',
                    option_md: '',
                    option_lg: 'vf-multiselect-option-lg',
                    optionPointed: 'vf-multiselect-option-pointed',
                    optionSelected: 'vf-multiselect-option-selected',
                    optionDisabled: 'vf-multiselect-option-disabled',
                    optionSelectedPointed: 'vf-multiselect-option-selected vf-multiselect-option-pointed',
                    optionSelectedDisabled: 'vf-multiselect-option-selected vf-multiselect-option-disabled',
                    noOptions: 'vf-multiselect-no-options',
                    noOptions_sm: 'vf-multiselect-no-options-sm',
                    noOptions_md: '',
                    noOptions_lg: 'vf-multiselect-no-options-lg',
                    noResults: 'vf-multiselect-no-results',
                    noResults_sm: 'vf-multiselect-no-results-sm',
                    noResults_md: '',
                    noResults_lg: 'vf-multiselect-no-results-lg',
                    fakeInput: 'vf-multiselect-fake-input',
                    assist: 'vf-assistive-text',
                    spacer: 'vf-multiselect-spacer',
                    spacer_sm: 'vf-multiselect-spacer-sm',
                    spacer_md: '',
                    spacer_lg: 'vf-multiselect-spacer-lg',
                    $container: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.container,
                            classes.select[`container_${Size}`],
                            isDisabled ? classes.select.container_disabled : null,
                            !isDisabled && !isSuccess && !isDanger ? classes.select.container_enabled : null,
                            !isDisabled && isDanger ? classes.select.container_danger : null,
                            !isDisabled && isSuccess ? classes.select.container_success : null
                        ],
                    $containerActive: (classes, { Size: Size, isDanger: isDanger, isSuccess: isSuccess, isDisabled: isDisabled })=>[
                            classes.select.containerActive,
                            classes.select[`container_${Size}`],
                            !isDisabled && !isSuccess && !isDanger ? classes.select.containerActive_enabled : null
                        ],
                    $wrapper: (classes, { Size: Size })=>[
                            classes.select.wrapper,
                            classes.select[`wrapper_${Size}`]
                        ],
                    $search: (classes, { Size: Size })=>[
                            classes.select.search,
                            classes.select[`search_${Size}`]
                        ],
                    $placeholder: (classes, { Size: Size })=>[
                            classes.select.placeholder,
                            classes.select[`placeholder_${Size}`]
                        ],
                    $caret: (classes, { Size: Size })=>[
                            classes.select.caret,
                            classes.select[`caret_${Size}`]
                        ],
                    $clear: (classes, { Size: Size })=>[
                            classes.select.clear,
                            classes.select[`clear_${Size}`]
                        ],
                    $spinner: (classes, { Size: Size })=>[
                            classes.select.spinner,
                            classes.select[`spinner_${Size}`]
                        ],
                    $infinite: (classes, { Size: Size })=>[
                            classes.select.infinite,
                            classes.select[`infinite_${Size}`]
                        ],
                    $dropdown: (classes, { Size: Size })=>[
                            classes.select.dropdown,
                            classes.select[`dropdown_${Size}`]
                        ],
                    $dropdownTop: (classes, { Size: Size })=>[
                            classes.select.dropdownTop,
                            classes.select[`dropdownTop_${Size}`]
                        ],
                    $groupLabel: (classes, { Size: Size })=>[
                            classes.select.groupLabel,
                            classes.select[`groupLabel_${Size}`]
                        ],
                    $option: (classes, { Size: Size })=>[
                            classes.select.option,
                            classes.select[`option_${Size}`]
                        ],
                    $spacer: (classes, { Size: Size })=>[
                            classes.select.spacer,
                            classes.select[`spacer_${Size}`]
                        ],
                    $noOptions: (classes, { Size: Size })=>[
                            classes.select.noOptions,
                            classes.select[`noOptions_${Size}`]
                        ],
                    $noResults: (classes, { Size: Size })=>[
                            classes.select.noResults,
                            classes.select[`noResults_${Size}`]
                        ],
                    $tags: (classes, { Size: Size })=>[
                            classes.select.tags,
                            classes.select[`tags_${Size}`]
                        ],
                    $tag: (classes, { Size: Size })=>[
                            classes.select.tag,
                            classes.select[`tag_${Size}`]
                        ],
                    $tagDisabled: (classes, { Size: Size })=>[
                            classes.select.tagDisabled,
                            classes.select[`tagDisabled_${Size}`]
                        ],
                    $tagRemove: (classes, { Size: Size })=>[
                            classes.select.tagRemove,
                            classes.select[`tagRemove_${Size}`]
                        ],
                    $tagsSearchWrapper: (classes, { Size: Size })=>[
                            classes.select.tagsSearchWrapper,
                            classes.select[`tagsSearchWrapper_${Size}`]
                        ],
                    $tagsSearch: (classes, { Size: Size })=>[
                            classes.select.tagsSearch,
                            classes.select[`tagsSearch_${Size}`]
                        ]
                },
                $input: (classes, { isDisabled: isDisabled, Size: Size, isDanger: isDanger, isSuccess: isSuccess })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.input_enabled : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ],
                $inputWrapper: (classes, { Size: Size })=>[
                        classes.inputWrapper,
                        classes[`inputWrapper_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$j = "/* Some styles are contained in SelectElement.vue */\n\n.vf-multiselect-tags {\n  flex-grow: 1;\n  flex-shrink: 1;\n  display: flex;\n  flex-wrap: wrap;\n  margin: var(--vf-space-tags) 0 0;\n  padding-left: var(--vf-py-input);\n  align-items: center;\n  min-width: 0;\n}\n\n.vf-multiselect-tags.vf-multiselect-tags-sm {\n  padding-left: var(--vf-py-input-sm);\n}\n\n.vf-multiselect-tags.vf-multiselect-tags-lg {\n  padding-left: var(--vf-py-input-lg);\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-tags,\n.vf-floating-wrapper ~ div .vf-multiselect-tags {\n  padding-left: var(--vf-px-input);\n  margin: calc(var(--vf-space-tags) + var(--vf-floating-top) + 0.34375rem - 1px) 0 0;\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-tags-sm,\n.vf-floating-wrapper ~ div .vf-multiselect-tags-sm {\n  padding-left: var(--vf-px-input-sm);\n  margin: calc(var(--vf-space-tags-sm) + var(--vf-floating-top-sm) + 0.34375rem - 1px) 0 0;\n}\n\n.vf-floating-wrapper ~ .vf-multiselect-tags-lg,\n.vf-floating-wrapper ~ div .vf-multiselect-tags-lg {\n  padding-left: var(--vf-px-input-lg);\n  margin: calc(var(--vf-space-tags-lg) + var(--vf-floating-top-lg) + 0.34375rem - 1px) 0 0;\n}\n\n.vf-multiselect-tag {\n  background: var(--vf-bg-tag);\n  color: var(--vf-color-tag);\n  border-style: solid;\n  border-width: var(--vf-border-width-tag);\n  border-color: var(--vf-border-color-tag);\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  font-weight: 600;\n  padding: var(--vf-py-tag) 0 var(--vf-py-tag) var(--vf-px-tag);\n  border-radius: var(--vf-radius-tag);\n  margin-right: var(--vf-space-tags);\n  margin-bottom: var(--vf-space-tags);\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.vf-multiselect-tag.vf-multiselect-tag-disabled {\n  padding-right: var(--vf-px-tag);\n  opacity: 0.5;\n}\n\n.vf-multiselect-tag.vf-multiselect-tag-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  border-radius: var(--vf-radius-tag-sm);\n  padding: var(--vf-py-tag-sm) 0 var(--vf-py-tag-sm) var(--vf-px-tag-sm);\n}\n\n.vf-multiselect-tag.vf-multiselect-tag-sm.vf-multiselect-tag-disabled {\n  padding-right: var(--vf-px-tag-sm);\n}\n\n.vf-multiselect-tag.vf-multiselect-tag-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n  border-radius: var(--vf-radius-tag-lg);\n  padding: var(--vf-py-tag-lg) 0 var(--vf-py-tag-lg) var(--vf-px-tag-lg);\n}\n\n.vf-multiselect-tag.vf-multiselect-tag-lg.vf-multiselect-tag-disabled {\n  padding-right: var(--vf-px-tag-lg);\n}\n\n.vf-multiselect-tag-wrapper {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.vf-multiselect-tag-wrapper-break {\n  white-space: normal;\n  word-break: break-all;\n}\n\n.vf-multiselect-tag-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  margin: 0 0.125rem;\n  border-radius: var(--vf-radius-tag);\n}\n\n.vf-multiselect-tag-remove:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.vf-multiselect-tag-remove.vf-multiselect-tag-remove-sm {\n  border-radius: var(--vf-radius-tag-sm);\n}\n\n.vf-multiselect-tag-remove.vf-multiselect-tag-remove-lg {\n  border-radius: var(--vf-radius-tag-lg);\n}\n\n.vf-multiselect-tag-remove-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-position: center;\n  -webkit-mask-position: center;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: currentColor;\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n}\n\n.vf-multiselect-tags-search-wrapper {\n  display: inline-block;\n  position: relative;\n  margin: 0 var(--vf-space-tags) var(--vf-space-tags);\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  max-width: 100%;\n}\n\n.vf-multiselect-tags-search-copy {\n  visibility: hidden;\n  white-space: pre-wrap;\n  display: inline-block;\n  height: 1px;\n  width: 100%;\n}\n\n.vf-multiselect-tags-search {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  outline: none;\n  padding: 0;\n  font-size: inherit;\n  font-family: inherit;\n  box-sizing: border-box;\n  width: 100%;\n  appearance: none;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  background-color: transparent;\n  padding-right: 0.5rem;\n}\n\n.vf-multiselect-tags-search::-webkit-search-decoration, .vf-multiselect-tags-search::-webkit-search-cancel-button, .vf-multiselect-tags-search::-webkit-search-results-button, .vf-multiselect-tags-search::-webkit-search-results-decoration {\n  -webkit-appearance: none;\n}\n\n.vf-multiselect-tags-search.vf-multiselect-tags-search-sm {\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-multiselect-tags-search.vf-multiselect-tags-search-lg {\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n[dir=rtl] .vf-multiselect-tags {\n  padding-left: 0;\n  padding-right: var(--vf-py-input);\n}\n\n[dir=rtl] .vf-multiselect-tags.vf-multiselect-tags-sm {\n  padding-right: var(--vf-py-input-sm);\n}\n\n[dir=rtl] .vf-multiselect-tags.vf-multiselect-tags-lg {\n  padding-right: var(--vf-py-input-lg);\n}\n\n[dir=rtl] .vf-floating-wrapper ~ .vf-multiselect-tags,\n[dir=rtl] .vf-floating-wrapper ~ div .vf-multiselect-tags {\n  padding-left: 0;\n  padding-right: var(--vf-px-input);\n}\n\n[dir=rtl] .vf-floating-wrapper ~ .vf-multiselect-tags-sm,\n[dir=rtl] .vf-floating-wrapper ~ div .vf-multiselect-tags-sm {\n  padding-left: 0;\n  padding-right: var(--vf-px-input-sm);\n}\n\n[dir=rtl] .vf-floating-wrapper ~ .vf-multiselect-tags-lg,\n[dir=rtl] .vf-floating-wrapper ~ div .vf-multiselect-tags-lg {\n  padding-left: 0;\n  padding-right: var(--vf-px-input-lg);\n}\n\n[dir=rtl] .vf-multiselect-tag {\n  padding: var(--vf-py-tag) var(--vf-px-tag) var(--vf-py-tag) 0;\n  margin-right: 0;\n  margin-left: var(--vf-space-tags);\n}\n\n[dir=rtl] .vf-multiselect-tag.is-disabled {\n  padding-left: ar(--vf-px-tag);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$j);
$741c336afc2dfa06$export$751fafeae41a8f96.__file = "themes/vueform/templates/elements/TagsElement.vue";
var $741c336afc2dfa06$var$script$C = {
    name: 'TextareaElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$e = [
    "value",
    "name",
    "id",
    "placeholder",
    "disabled",
    "readonly",
    "rows",
    "data-autogrow"
];
function $741c336afc2dfa06$var$render$g(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddon = (0, $ani5R.resolveComponent)("ElementAddon");
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_ElementLoader = (0, $ani5R.resolveComponent)("ElementLoader");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputContainer)
                }, [
                    _ctx.hasAddonBefore ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 0,
                        type: "before"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-before", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-before']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasAddonAfter ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 1,
                        type: "after"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-after", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-after']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                        key: 2,
                        visible: !_ctx.empty
                    }, null, 8 /* PROPS */ , [
                        "visible"
                    ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.withDirectives)((0, $ani5R.createVNode)(_component_ElementLoader, null, null, 512 /* NEED_PATCH */ ), [
                        [
                            (0, $dDLnc.vShow),
                            _ctx.pending
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("textarea", (0, $ani5R.mergeProps)({
                        value: _ctx.model,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        class: _ctx.classes.input,
                        placeholder: _ctx.Placeholder,
                        disabled: _ctx.isDisabled,
                        readonly: _ctx.isReadonly,
                        rows: _ctx.rows
                    }, {
                        ..._ctx.attrs,
                        ..._ctx.aria
                    }, {
                        "data-autogrow": _ctx.autogrow || undefined,
                        onKeydown: _cache[0] || (_cache[0] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args)),
                        onKeyup: _cache[1] || (_cache[1] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args)),
                        onKeypress: _cache[2] || (_cache[2] = (...args)=>_ctx.handleKeypress && _ctx.handleKeypress(...args)),
                        onInput: _cache[3] || (_cache[3] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                        onBlur: _cache[4] || (_cache[4] = (...args)=>_ctx.handleBlur && _ctx.handleBlur(...args)),
                        onFocus: _cache[5] || (_cache[5] = (...args)=>_ctx.handleFocus && _ctx.handleFocus(...args)),
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$e)
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$C.render = $741c336afc2dfa06$var$render$g;
$741c336afc2dfa06$var$script$C.__file = "themes/blank/templates/elements/TextareaElement.vue";
var $741c336afc2dfa06$export$a99fd9ae898251f3 = {
    name: 'TextareaElement',
    render: $741c336afc2dfa06$var$script$C.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group vf-input-group-textarea',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$i = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$i);
$741c336afc2dfa06$export$a99fd9ae898251f3.__file = "themes/vueform/templates/elements/TextareaElement.vue";
var $741c336afc2dfa06$var$script$A = {
    name: 'TextElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$d = [
    "value",
    "type",
    "name",
    "id",
    "placeholder",
    "autocomplete",
    "disabled",
    "readonly"
];
function $741c336afc2dfa06$var$render$f(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ElementAddon = (0, $ani5R.resolveComponent)("ElementAddon");
    const _component_ElementLabelFloating = (0, $ani5R.resolveComponent)("ElementLabelFloating");
    const _component_ElementLoader = (0, $ani5R.resolveComponent)("ElementLoader");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.inputContainer)
                }, [
                    _ctx.hasAddonBefore ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 0,
                        type: "before"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-before", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-before']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasAddonAfter ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementAddon, {
                        key: 1,
                        type: "after"
                    }, {
                        default: (0, $ani5R.withCtx)(()=>[
                                (0, $ani5R.renderSlot)(_ctx.$slots, "addon-after", {}, ()=>[
                                        ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots['addon-after']), {
                                            el$: _ctx.el$
                                        }, null, 8 /* PROPS */ , [
                                            "el$"
                                        ]))
                                    ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.hasFloating && !_ctx.empty ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLabelFloating, {
                        key: 2,
                        visible: !_ctx.empty
                    }, null, 8 /* PROPS */ , [
                        "visible"
                    ])) : (0, $ani5R.createCommentVNode)("v-if", true),
                    _ctx.isLoading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)(_component_ElementLoader, {
                        key: 3
                    })) : (0, $ani5R.createCommentVNode)("v-if", true),
                    (0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        value: _ctx.model,
                        type: _ctx.inputType,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        class: _ctx.classes.input,
                        placeholder: _ctx.Placeholder,
                        autocomplete: _ctx.autocomplete,
                        disabled: _ctx.isDisabled,
                        readonly: _ctx.isReadonly
                    }, {
                        ..._ctx.attrs,
                        ..._ctx.aria
                    }, {
                        onKeydown: _cache[0] || (_cache[0] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args)),
                        onKeyup: _cache[1] || (_cache[1] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args)),
                        onKeypress: _cache[2] || (_cache[2] = (...args)=>_ctx.handleKeypress && _ctx.handleKeypress(...args)),
                        onInput: _cache[3] || (_cache[3] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                        onSelect: _cache[4] || (_cache[4] = (...args)=>_ctx.handleInput && _ctx.handleInput(...args)),
                        onBlur: _cache[5] || (_cache[5] = (...args)=>_ctx.handleBlur && _ctx.handleBlur(...args)),
                        onFocus: _cache[6] || (_cache[6] = (...args)=>_ctx.handleFocus && _ctx.handleFocus(...args)),
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$d)
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$A.render = $741c336afc2dfa06$var$render$f;
$741c336afc2dfa06$var$script$A.__file = "themes/blank/templates/elements/TextElement.vue";
var $741c336afc2dfa06$export$764077542c4bf9bd = {
    name: 'TextElement',
    render: $741c336afc2dfa06$var$script$A.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$h = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$h);
$741c336afc2dfa06$export$764077542c4bf9bd.__file = "themes/vueform/templates/elements/TextElement.vue";
function $741c336afc2dfa06$var$useValue$1(props, context, dependencies) {
    const { value: value, modelValue: modelValue, falseValue: falseValue, trueValue: trueValue, disabled: disabled } = (0, $8bTPG.toRefs)(props);
    /* istanbul ignore next */ const externalValue = modelValue && modelValue.value !== undefined ? modelValue : value;
    // ============== COMPUTED ==============
    const checked = (0, $8bTPG.computed)(()=>{
        return externalValue.value === trueValue.value;
    });
    // =============== METHODS ==============
    // no export
    const update = (val)=>{
        context.emit('input', val);
        context.emit('update:modelValue', val);
        context.emit('change', val);
    };
    const check = ()=>{
        update(trueValue.value);
    };
    const uncheck = ()=>{
        update(falseValue.value);
    };
    const handleInput = (val)=>{
        update(val.target.checked ? trueValue.value : falseValue.value);
    };
    const handleClick = ()=>{
        if (disabled.value) return;
        checked.value ? uncheck() : check();
    };
    // ================ HOOKS ===============
    if ([
        null,
        undefined,
        false,
        0,
        '0',
        'off'
    ].indexOf(externalValue.value) !== -1 && [
        falseValue.value,
        trueValue.value
    ].indexOf(externalValue.value) === -1) uncheck();
    if ([
        true,
        1,
        '1',
        'on'
    ].indexOf(externalValue.value) !== -1 && [
        falseValue.value,
        trueValue.value
    ].indexOf(externalValue.value) === -1) check();
    return {
        externalValue: externalValue,
        checked: checked,
        update: update,
        check: check,
        uncheck: uncheck,
        handleInput: handleInput,
        handleClick: handleClick
    };
}
function $741c336afc2dfa06$var$useValue(props, context, dependencies) {
    const { trueValue: trueValue, falseValue: falseValue, onLabel: onLabel, offLabel: offLabel } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const checked = dependencies.checked;
    const update = dependencies.update;
    // ============== COMPUTED ==============
    const label = (0, $8bTPG.computed)(()=>{
        let label = checked.value ? onLabel.value : offLabel.value;
        if (!label) label = '&nbsp;';
        return label;
    });
    // =============== METHODS ==============
    const toggle = ()=>{
        update(checked.value ? falseValue.value : trueValue.value);
    };
    const on = ()=>{
        update(trueValue.value);
    };
    const off = ()=>{
        update(falseValue.value);
    };
    return {
        label: label,
        toggle: toggle,
        on: on,
        off: off
    };
}
function $741c336afc2dfa06$var$useClasses(props, context, dependencies) {
    const refs = (0, $8bTPG.toRefs)(props);
    const disabled = refs.disabled;
    // ============ DEPENDENCIES ============
    const checked = dependencies.checked;
    // ============== COMPUTED ==============
    const classes = (0, $8bTPG.computed)(()=>({
            container: 'toggle-container',
            toggle: 'toggle',
            toggleOn: 'toggle-on',
            toggleOff: 'toggle-off',
            toggleOnDisabled: 'toggle-on-disabled',
            toggleOffDisabled: 'toggle-off-disabled',
            handle: 'toggle-handle',
            handleOn: 'toggle-handle-on',
            handleOff: 'toggle-handle-off',
            handleOnDisabled: 'toggle-handle-on-disabled',
            handleOffDisabled: 'toggle-handle-off-disabled',
            label: 'toggle-label',
            ...refs.classes.value
        }));
    const classList = (0, $8bTPG.computed)(()=>{
        return {
            container: classes.value.container,
            toggle: [
                classes.value.toggle,
                disabled.value ? checked.value ? classes.value.toggleOnDisabled : classes.value.toggleOffDisabled : checked.value ? classes.value.toggleOn : classes.value.toggleOff
            ],
            handle: [
                classes.value.handle,
                disabled.value ? checked.value ? classes.value.handleOnDisabled : classes.value.handleOffDisabled : checked.value ? classes.value.handleOn : classes.value.handleOff
            ],
            label: classes.value.label
        };
    });
    return {
        classList: classList
    };
}
function $741c336afc2dfa06$var$useStyle(props, context, dependencies) {
    const { disabled: disabled } = (0, $8bTPG.toRefs)(props);
    // ============ DEPENDENCIES ============
    const check = dependencies.check;
    const uncheck = dependencies.uncheck;
    const checked = dependencies.checked;
    // =============== METHODS ==============
    const handleSpace = ()=>{
        if (disabled.value) return;
        checked.value ? uncheck() : check();
    };
    return {
        handleSpace: handleSpace
    };
}
/* istanbul ignore next */ const $741c336afc2dfa06$var$valueProps = {
    value: {
        validator: function(p) {
            return (p)=>[
                    'number',
                    'string',
                    'boolean'
                ].indexOf(typeof p) !== -1 || p === null || p === undefined;
        },
        required: false
    },
    modelValue: {
        validator: function(p) {
            return (p)=>[
                    'number',
                    'string',
                    'boolean'
                ].indexOf(typeof p) !== -1 || p === null || p === undefined;
        },
        required: false
    }
};
var $741c336afc2dfa06$var$script$y = {
    name: 'Toggle',
    emits: [
        'input',
        'update:modelValue',
        'change'
    ],
    props: {
        ...$741c336afc2dfa06$var$valueProps,
        id: {
            type: [
                String,
                Number
            ],
            required: false,
            default: 'toggle'
        },
        name: {
            type: [
                String,
                Number
            ],
            required: false,
            default: 'toggle'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        falseValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            required: false,
            default: false
        },
        trueValue: {
            type: [
                String,
                Number,
                Boolean
            ],
            required: false,
            default: true
        },
        onLabel: {
            type: [
                String,
                Object
            ],
            required: false,
            default: ''
        },
        offLabel: {
            type: [
                String,
                Object
            ],
            required: false,
            default: ''
        },
        classes: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        labelledby: {
            type: String,
            required: false
        },
        describedby: {
            type: String,
            required: false
        },
        aria: {
            required: false,
            type: Object,
            default: ()=>({})
        }
    },
    setup (props, context) {
        const value = $741c336afc2dfa06$var$useValue$1(props, context);
        const toggle = $741c336afc2dfa06$var$useValue(props, context, {
            checked: value.checked,
            update: value.update
        });
        const classes = $741c336afc2dfa06$var$useClasses(props, context, {
            checked: value.checked
        });
        const keyboard = $741c336afc2dfa06$var$useStyle(props, context, {
            check: value.check,
            uncheck: value.uncheck,
            checked: value.checked
        });
        return {
            ...value,
            ...classes,
            ...toggle,
            ...keyboard
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$c = [
    "tabindex",
    "aria-checked",
    "aria-describedby",
    "aria-labelledby"
];
const $741c336afc2dfa06$var$_hoisted_2$9 = [
    "id",
    "name",
    "value",
    "checked",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_3$7 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_4$4 = [
    "checked"
];
function $741c336afc2dfa06$var$render$e(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
        class: _ctx.classList.container,
        tabindex: $props.disabled ? undefined : 0,
        "aria-checked": _ctx.checked,
        "aria-describedby": $props.describedby,
        "aria-labelledby": $props.labelledby,
        role: "switch"
    }, $props.aria, {
        onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)((...args)=>_ctx.handleSpace && _ctx.handleSpace(...args), [
            "prevent"
        ]), [
            "space"
        ]))
    }), [
        (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
            type: "checkbox",
            id: $props.id,
            name: $props.name,
            value: $props.trueValue,
            checked: _ctx.checked,
            disabled: $props.disabled
        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_2$9), [
            [
                (0, $dDLnc.vShow),
                false
            ]
        ]),
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classList.toggle),
            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.handleClick && _ctx.handleClick(...args))
        }, [
            (0, $ani5R.createElementVNode)("span", {
                class: (0, $X5A94.normalizeClass)(_ctx.classList.handle)
            }, null, 2 /* CLASS */ ),
            (0, $ani5R.renderSlot)(_ctx.$slots, "label", {
                checked: _ctx.checked,
                classList: _ctx.classList
            }, ()=>[
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classList.label),
                        innerHTML: _ctx.label
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$7)
                ]),
            $props.required ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", {
                key: 0,
                type: "checkbox",
                style: {
                    appearance: 'none',
                    height: '1px',
                    margin: '0',
                    padding: '0',
                    fontSize: '0',
                    background: 'transparent',
                    position: 'absolute',
                    width: '100%',
                    bottom: '0',
                    outline: 'none'
                },
                checked: _ctx.checked,
                "aria-hidden": "true",
                tabindex: "-1",
                required: ""
            }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_4$4)) : (0, $ani5R.createCommentVNode)("v-if", true)
        ], 2 /* CLASS */ )
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$c);
}
$741c336afc2dfa06$var$script$y.render = $741c336afc2dfa06$var$render$e;
$741c336afc2dfa06$var$script$y.__file = "node_modules/@vueform/toggle/src/Toggle.vue";
var $741c336afc2dfa06$var$script$x = {
    name: 'ToggleElement',
    components: {
        Toggle: $741c336afc2dfa06$var$script$y
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                toggle: {
                    container: '',
                    toggle: '',
                    toggleOn: '',
                    toggleOff: '',
                    toggleOnDisabled: '',
                    toggleOffDisabled: '',
                    handle: '',
                    handleOn: '',
                    handleOff: '',
                    handleOnDisabled: '',
                    handleOffDisabled: '',
                    label: ''
                },
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$b = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$d(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Toggle = (0, $ani5R.resolveComponent)("Toggle");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.createCommentVNode)(" @vueform/toggle component "),
                    (0, $ani5R.createVNode)(_component_Toggle, (0, $ani5R.mergeProps)({
                        value: _ctx.value,
                        modelValue: _ctx.value
                    }, _ctx.fieldOptions, {
                        classes: _ctx.classes.toggle,
                        name: _ctx.name,
                        id: _ctx.fieldId,
                        aria: _ctx.aria,
                        onInput: _ctx.handleChange,
                        ref: "input"
                    }), null, 16 /* FULL_PROPS */ , [
                        "value",
                        "modelValue",
                        "classes",
                        "name",
                        "id",
                        "aria",
                        "onInput"
                    ]),
                    !_ctx.standalone && _ctx.Text ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 0,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                        innerHTML: _ctx.Text
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_1$b)) : !_ctx.standalone ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                        key: 1,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text)
                    }, [
                        (0, $ani5R.renderSlot)(_ctx.$slots, "default", {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.fieldSlots.default), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ )
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$x.render = $741c336afc2dfa06$var$render$d;
$741c336afc2dfa06$var$script$x.__file = "themes/blank/templates/elements/ToggleElement.vue";
var $741c336afc2dfa06$export$1285efb30d257f44 = {
    name: 'ToggleElement',
    render: $741c336afc2dfa06$var$script$x.render,
    components: {
        Toggle: $741c336afc2dfa06$var$script$y
    },
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-contains-link',
                wrapper: 'vf-toggle-wrapper',
                wrapper_left: 'vf-toggle-wrapper-left',
                wrapper_right: 'vf-toggle-wrapper-right',
                text: 'vf-toggle-text',
                text_sm: 'vf-toggle-text-sm',
                text_md: '',
                text_lg: 'vf-toggle-text-lg',
                text_left: 'vf-toggle-text-left',
                text_right: 'vf-toggle-text-right',
                toggle: {
                    container: 'vf-toggle-container',
                    container_enabled: '',
                    container_disabled: 'vf-toggle-container-disabled',
                    toggle: 'vf-toggle',
                    toggle_sm: 'vf-toggle-sm',
                    toggle_md: '',
                    toggle_lg: 'vf-toggle-lg',
                    toggleOn: 'vf-toggle-on',
                    toggleOff: 'vf-toggle-off',
                    toggleOnDisabled: 'vf-toggle-on-disabled',
                    toggleOffDisabled: 'vf-toggle-off-disabled',
                    handle: 'vf-toggle-handle',
                    handle_sm: 'vf-toggle-handle-sm',
                    handle_md: '',
                    handle_lg: 'vf-toggle-handle-lg',
                    handleOn: 'vf-toggle-handle-on',
                    handleOff: 'vf-toggle-handle-off',
                    handleOnDisabled: 'vf-toggle-handle-on-disabled',
                    handleOffDisabled: 'vf-toggle-handle-off-disabled',
                    label: 'vf-toggle-label',
                    label_sm: 'vf-toggle-label-sm',
                    label_md: '',
                    label_lg: 'vf-toggle-label-lg',
                    $container: (classes, { Size: Size, isDisabled: isDisabled })=>[
                            classes.toggle.container,
                            classes.toggle[`container_${Size}`],
                            !isDisabled ? classes.toggle.container_enabled : classes.toggle.container_disabled
                        ],
                    $toggle: (classes, { Size: Size })=>[
                            classes.toggle.toggle,
                            classes.toggle[`toggle_${Size}`]
                        ],
                    $handle: (classes, { Size: Size })=>[
                            classes.toggle.handle,
                            classes.toggle[`handle_${Size}`]
                        ],
                    $label: (classes, { Size: Size })=>[
                            classes.toggle.label,
                            classes.toggle[`label_${Size}`]
                        ]
                },
                $text: (classes, { Size: Size, align: align })=>[
                        classes.text,
                        classes[`text_${Size}`],
                        align === 'left' ? classes.text_left : null,
                        align === 'right' ? classes.text_right : null
                    ],
                $wrapper: (classes, { align: align })=>[
                        classes.wrapper,
                        align === 'left' ? classes.wrapper_left : null,
                        align === 'right' ? classes.wrapper_right : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$g = ".vf-toggle-wrapper {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.vf-toggle-text {\n  margin-left: var(--vf-space-checkbox);\n}\n\n.vf-toggle-text.vf-toggle-text-sm {\n  margin-left: var(--vf-space-checkbox-sm);\n}\n\n.vf-toggle-text.vf-toggle-text-lg {\n  margin-left: var(--vf-space-checkbox-lg);\n}\n\n/* @vueform/toggle styles */\n\n.vf-toggle-container {\n  display: inline-block;\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n  border-radius: 9999px;\n  transition: box-shadow 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n  box-shadow: var(--vf-shadow-handles);\n}\n\n.vf-toggle-container:hover:not(.vf-toggle-container-disabled) {\n  box-shadow: var(--vf-shadow-handles-hover);\n}\n\n.vf-toggle-container:focus {\n  box-shadow: var(--vf-shadow-handles-focus);\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-toggle-container.vf-toggle-container-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vf-toggle {\n  display: flex;\n  border-radius: 999px;\n  position: relative;\n  cursor: pointer;\n  transition: 0.3s all;\n  align-items: center;\n  box-sizing: content-box;\n  border-width: var(--vf-border-width-toggle);\n  border-style: solid;\n  font-size: 0.75rem;\n  width: var(--vf-toggle-width);\n  height: var(--vf-toggle-height);\n  line-height: 1;\n}\n\n.vf-toggle.vf-toggle-sm {\n  width: var(--vf-toggle-width-sm);\n  height: var(--vf-toggle-height-sm);\n  font-size: 0.75rem;\n}\n\n.vf-toggle.vf-toggle-lg {\n  width: var(--vf-toggle-width-lg);\n  height: var(--vf-toggle-height-lg);\n  font-size: 0.8125rem;\n}\n\n.vf-toggle-on {\n  background: var(--vf-primary);\n  border-color: var(--vf-primary);\n  justify-content: flex-start;\n  color: var(--vf-color-on-primary);\n}\n\n.vf-toggle-off {\n  background: var(--vf-bg-passive);\n  border-color: var(--vf-bg-passive);\n  justify-content: flex-end;\n  color: var(--vf-color-passive);\n}\n\n.vf-toggle-on-disabled {\n  background: var(--vf-primary);\n  border-color: var(--vf-primary);\n  justify-content: flex-start;\n  color: var(--vf-color-on-primary);\n}\n\n.vf-toggle-off-disabled {\n  background: var(--vf-bg-passive);\n  border-color: var(--vf-bg-passive);\n  justify-content: flex-end;\n  color: var(--vf-color-passive);\n}\n\n.vf-toggle-handle {\n  display: inline-block;\n  background: var(--vf-bg-toggle-handle);\n  width: var(--vf-toggle-height);\n  height: var(--vf-toggle-height);\n  top: 0;\n  border-radius: 50%;\n  position: absolute;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.vf-toggle-handle.vf-toggle-handle-sm {\n  width: var(--vf-toggle-height-sm);\n  height: var(--vf-toggle-height-sm);\n}\n\n.vf-toggle-handle.vf-toggle-handle-lg {\n  width: var(--vf-toggle-height-lg);\n  height: var(--vf-toggle-height-lg);\n}\n\n.vf-toggle-handle-on {\n  left: 100%;\n  transform: translateX(-100%);\n}\n\n.vf-toggle-handle-off {\n  left: 0%;\n}\n\n.vf-toggle-handle-on-disabled {\n  left: 100%;\n  transform: translateX(-100%);\n  background: var(--vf-bg-toggle-handle);\n}\n\n.vf-toggle-handle-off-disabled {\n  left: 0%;\n  background: var(--vf-bg-toggle-handle);\n}\n\n.vf-toggle-label {\n  text-align: center;\n  width: calc(var(--vf-toggle-width) - var(--vf-toggle-height));\n  box-sizing: border-box;\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\n.vf-toggle-label.vf-toggle-label-sm {\n  width: calc(var(--vf-toggle-width-sm) - var(--vf-toggle-height-sm));\n}\n\n.vf-toggle-label.vf-toggle-label-lg {\n  width: calc(var(--vf-toggle-width-lg) - var(--vf-toggle-height-lg));\n}\n\nbody:not([dir=rtl]) .vf-toggle-wrapper-right {\n  justify-content: flex-end;\n}\n\nbody:not([dir=rtl]) .vf-toggle-text-right {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox);\n  order: -1;\n}\n\nbody:not([dir=rtl]) .vf-toggle-text-right.vf-toggle-text-sm {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox-sm);\n}\n\nbody:not([dir=rtl]) .vf-toggle-text-right.vf-toggle-text-lg {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox-lg);\n}\n\nbody[dir=rtl] .vf-toggle-wrapper-left {\n  justify-content: flex-end;\n}\n\nbody[dir=rtl] .vf-toggle-text {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox);\n}\n\nbody[dir=rtl] .vf-toggle-text.vf-toggle-text-sm {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox-sm);\n}\n\nbody[dir=rtl] .vf-toggle-text.vf-toggle-text-lg {\n  margin-left: 0;\n  margin-right: var(--vf-space-checkbox-lg);\n}\n\nbody[dir=rtl] .vf-toggle-text.vf-toggle-text-left {\n  margin-right: 0;\n  margin-left: var(--vf-space-checkbox);\n  order: -1;\n}\n\nbody[dir=rtl] .vf-toggle-text.vf-toggle-text-left.vf-toggle-text-sm {\n  margin-right: 0;\n  margin-left: var(--vf-space-checkbox-sm);\n}\n\nbody[dir=rtl] .vf-toggle-text.vf-toggle-text-left.vf-toggle-text-lg {\n  margin-right: 0;\n  margin-left: var(--vf-space-checkbox-lg);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$g);
$741c336afc2dfa06$export$1285efb30d257f44.__file = "themes/vueform/templates/elements/ToggleElement.vue";
var $741c336afc2dfa06$var$script$v = {
    name: 'EditorElement',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$c(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EditorWrapper = (0, $ani5R.resolveComponent)("EditorWrapper");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(_ctx.elementLayout), {
        ref: "container"
    }, (0, $ani5R.createSlots)({
        element: (0, $ani5R.withCtx)(()=>[
                (0, $ani5R.createVNode)(_component_EditorWrapper, {
                    value: _ctx.model,
                    placeholder: _ctx.Placeholder,
                    id: _ctx.fieldId,
                    accept: _ctx.accept,
                    "accept-mimes": _ctx.acceptMimes,
                    endpoint: _ctx.editorEndpoint,
                    method: _ctx.editorMethod,
                    disabled: _ctx.isDisabled,
                    "hide-tools": _ctx.hideTools,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.input),
                    attrs: _ctx.aria,
                    onInput: _ctx.handleInput,
                    onAlert: _ctx.handleAlert,
                    onError: _ctx.handleError,
                    onBlur: _ctx.handleBlur,
                    ref: "input"
                }, null, 8 /* PROPS */ , [
                    "value",
                    "placeholder",
                    "id",
                    "accept",
                    "accept-mimes",
                    "endpoint",
                    "method",
                    "disabled",
                    "hide-tools",
                    "class",
                    "attrs",
                    "onInput",
                    "onAlert",
                    "onError",
                    "onBlur"
                ])
            ]),
        _: 2 /* DYNAMIC */ 
    }, [
        (0, $ani5R.renderList)(_ctx.elementSlots, (component, slot)=>{
            return {
                name: slot,
                fn: (0, $ani5R.withCtx)(()=>[
                        (0, $ani5R.renderSlot)(_ctx.$slots, slot, {
                            el$: _ctx.el$
                        }, ()=>[
                                ((0, $ani5R.openBlock)(), (0, $ani5R.createBlock)((0, $ani5R.resolveDynamicComponent)(component), {
                                    el$: _ctx.el$
                                }, null, 8 /* PROPS */ , [
                                    "el$"
                                ]))
                            ])
                    ])
            };
        })
    ]), 1536 /* NEED_PATCH, DYNAMIC_SLOTS */ );
}
$741c336afc2dfa06$var$script$v.render = $741c336afc2dfa06$var$render$c;
$741c336afc2dfa06$var$script$v.__file = "themes/blank/templates/elements/EditorElement.vue";
var $741c336afc2dfa06$export$3205440989aad267 = {
    name: 'EditorElement',
    render: $741c336afc2dfa06$var$script$v.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                input: 'vf-editor',
                input_enabled: '',
                input_disabled: 'vf-editor-disabled',
                input_success: 'vf-editor-success',
                input_danger: 'vf-editor-danger',
                input_focused: 'vf-editor-focused',
                input_sm: 'vf-editor-sm',
                input_md: '',
                input_lg: 'vf-editor-lg',
                $input: (classes, { isDisabled: isDisabled, focused: focused, Size: Size, isSuccess: isSuccess, isDanger: isDanger })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.input_default : null,
                        !isDisabled && focused ? classes.input_focused : null,
                        !isDisabled && isSuccess ? classes.input_success : null,
                        !isDisabled && isDanger ? classes.input_danger : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$f = ".vf-editor {\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n  border-style: solid;\n  transition: box-shadow 0.2s ease-in-out, color 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  background-color: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  border-color: var(--vf-border-color-input);\n  box-shadow: var(--vf-shadow-input);\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-radius: var(--vf-radius-input);\n}\n\n.vf-editor.vf-editor-disabled {\n  background-color: var(--vf-bg-disabled);\n  color: var(--vf-color-disabled);\n}\n\n.vf-editor.vf-editor-success {\n  background-color: var(--vf-bg-input-success);\n  color: var(--vf-color-input-success);\n  border-color: var(--vf-border-color-input-success);\n}\n\n.vf-editor.vf-editor-danger {\n  background-color: var(--vf-bg-input-danger);\n  color: var(--vf-color-input-danger);\n  border-color: var(--vf-border-color-input-danger);\n}\n\n.vf-editor:hover:not(.vf-editor-disabled) {\n  box-shadow: var(--vf-shadow-input-hover);\n}\n\n.vf-editor:hover:not(.vf-editor-disabled):not(.vf-editor-success):not(.vf-editor-danger) {\n  background-color: var(--vf-bg-input-hover);\n  color: var(--vf-color-input-hover);\n  border-color: var(--vf-border-color-input-hover);\n}\n\n.vf-editor.vf-editor-focused {\n  box-shadow: var(--vf-shadow-input-focus);\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n  border-color: var(--vf-border-color-input-focus);\n}\n\n.vf-editor.vf-editor-focused:not(.vf-editor-success):not(.vf-editor-danger), .vf-editor.vf-editor-focused:not(.vf-editor-disabled):not(.vf-editor-success):not(.vf-editor-danger) {\n  background-color: var(--vf-bg-input-focus);\n  color: var(--vf-color-input-focus);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$f);
$741c336afc2dfa06$export$3205440989aad267.__file = "themes/vueform/templates/elements/EditorElement.vue";
var $741c336afc2dfa06$var$script$t = {
    name: 'TTextareaElement',
    render: $741c336afc2dfa06$var$script$C.render,
    staticRenderFns: $741c336afc2dfa06$var$script$C.staticRenderFns,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
$741c336afc2dfa06$var$script$t.__file = "themes/blank/templates/elements/TTextareaElement.vue";
var $741c336afc2dfa06$export$58a0c31fb0c39075 = {
    name: 'TTextareaElement',
    render: $741c336afc2dfa06$var$script$t.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group vf-input-group-textarea',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$e = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$e);
$741c336afc2dfa06$export$58a0c31fb0c39075.__file = "themes/vueform/templates/elements/TTextareaElement.vue";
var $741c336afc2dfa06$var$script$r = {
    name: 'TTextElement',
    render: $741c336afc2dfa06$var$script$A.render,
    staticRenderFns: $741c336afc2dfa06$var$script$A.staticRenderFns,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                inputContainer: '',
                input: ''
            }
        };
    }
};
$741c336afc2dfa06$var$script$r.__file = "themes/blank/templates/elements/TTextElement.vue";
var $741c336afc2dfa06$export$cfc874e59e6fa643 = {
    name: 'TTextElement',
    render: $741c336afc2dfa06$var$script$r.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                inputContainer: 'vf-input-group',
                inputContainer_sm: 'vf-input-group-sm',
                inputContainer_md: '',
                inputContainer_lg: 'vf-input-group-lg',
                inputContainer_default: '',
                inputContainer_disabled: 'vf-input-group-disabled',
                inputContainer_focused: 'vf-input-group-focused',
                inputContainer_success: 'vf-input-group-success',
                inputContainer_danger: 'vf-input-group-danger',
                input: 'vf-input-field',
                input_sm: '',
                input_md: '',
                input_lg: '',
                input_enabled: '',
                input_disabled: '',
                input_focused: '',
                input_success: '',
                input_danger: '',
                $inputContainer: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.inputContainer,
                        classes[`inputContainer_${Size}`],
                        isDisabled ? classes.inputContainer_disabled : null,
                        !isDisabled && !isSuccess && !isDanger ? classes.inputContainer_default : null,
                        !isDisabled && focused ? classes.inputContainer_focused : null,
                        !isDisabled && isSuccess ? classes.inputContainer_success : null,
                        !isDisabled && isDanger ? classes.inputContainer_danger : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size, isSuccess: isSuccess, isDanger: isDanger, focused: focused })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && focused && !isSuccess && !isDanger ? classes.input_focused : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$d = "/* Some styles are contained in Vueform.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$d);
$741c336afc2dfa06$export$cfc874e59e6fa643.__file = "themes/vueform/templates/elements/TTextElement.vue";
var $741c336afc2dfa06$var$script$p = {
    name: 'TEditorElement',
    render: $741c336afc2dfa06$var$script$v.render,
    staticRenderFns: $741c336afc2dfa06$var$script$v.staticRenderFns,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: ''
            }
        };
    }
};
$741c336afc2dfa06$var$script$p.__file = "themes/blank/templates/elements/TEditorElement.vue";
var $741c336afc2dfa06$export$21f5918a7e7c135e = {
    name: 'TEditorElement',
    render: $741c336afc2dfa06$var$script$p.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-text-type',
                input: 'vf-editor',
                input_enabled: '',
                input_disabled: 'vf-editor-disabled',
                input_success: 'vf-editor-success',
                input_danger: 'vf-editor-danger',
                input_focused: 'vf-editor-focused',
                input_focused_success: 'vf-editor-focused-success',
                input_focused_danger: 'vf-editor-focused-danger',
                input_sm: 'vf-editor-sm',
                input_md: '',
                input_lg: 'vf-editor-lg',
                $input: (classes, { isDisabled: isDisabled, focused: focused, Size: Size, isSuccess: isSuccess, isDanger: isDanger })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : null,
                        !isDisabled && !isSuccess && !isDanger && !focused ? classes.input_enabled : null,
                        !isDisabled && isDanger ? classes.input_danger : null,
                        !isDisabled && isSuccess ? classes.input_success : null,
                        focused && !isDanger && !isSuccess ? classes.input_focused : null,
                        focused && isSuccess ? classes.input_focused_success : null,
                        focused && isDanger ? classes.input_focused_danger : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$c = "/* Some styles are contained in EditorElement.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$c);
$741c336afc2dfa06$export$21f5918a7e7c135e.__file = "themes/vueform/templates/elements/TEditorElement.vue";
var $741c336afc2dfa06$var$script$n = {
    name: 'CheckboxgroupCheckbox',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$a = [
    "value",
    "name",
    "id",
    "disabled",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_2$8 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$b(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.model = $event)
                }, _ctx.attrs, {
                    value: _ctx.value,
                    class: _ctx.classes.input,
                    name: _ctx.name,
                    id: _ctx.id,
                    disabled: _ctx.isDisabled,
                    "aria-label": _ctx.item.label
                }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$a), [
                    [
                        (0, $dDLnc.vModelCheckbox),
                        _ctx.el$.model
                    ]
                ]),
                (0, $ani5R.createElementVNode)("span", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                    innerHTML: _ctx.item.label
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$8)
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$n.render = $741c336afc2dfa06$var$render$b;
$741c336afc2dfa06$var$script$n.__file = "themes/blank/templates/elements/partials/CheckboxgroupCheckbox.vue";
var $741c336afc2dfa06$export$a3a0586dceeb64b8 = {
    name: 'CheckboxgroupCheckbox',
    render: $741c336afc2dfa06$var$script$n.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkbox-container',
                input: 'vf-checkbox',
                input_enabled: '',
                input_disabled: '',
                input_sm: 'vf-checkbox-sm',
                input_md: '',
                input_lg: 'vf-checkbox-lg',
                text: 'vf-checkbox-text',
                $input: (classes, { isDisabled: isDisabled, Size: Size })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$b = "/* Some styles are contained in Vueform.vue & CheckboxgroupElement.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$b);
$741c336afc2dfa06$export$a3a0586dceeb64b8.__file = "themes/vueform/templates/elements/partials/CheckboxgroupCheckbox.vue";
var $741c336afc2dfa06$var$script$l = {
    name: 'CheckboxgroupCheckbox_tabs',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$9 = [
    "aria-checked"
];
const $741c336afc2dfa06$var$_hoisted_2$7 = [
    "title"
];
const $741c336afc2dfa06$var$_hoisted_3$6 = [
    "value",
    "id",
    "name",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_4$3 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$a(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", (0, $ani5R.mergeProps)(_ctx.attrs, {
        class: _ctx.classes.container,
        tabindex: "0",
        role: "checkbox",
        "aria-checked": _ctx.checked,
        onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)(($event)=>_ctx.el$.toggle(_ctx.value), [
            "prevent"
        ]), [
            "space"
        ])),
        onKeydown: _cache[2] || (_cache[2] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args))
    }), [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    title: _ctx.item.label
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.model = $event),
                        value: _ctx.value,
                        id: _ctx.id,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.input),
                        name: _ctx.name,
                        disabled: _ctx.isDisabled
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$6), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            _ctx.el$.model
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                        innerHTML: `${_ctx.item.label}`
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_4$3)
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$7)
            ])
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$9);
}
$741c336afc2dfa06$var$script$l.render = $741c336afc2dfa06$var$render$a;
$741c336afc2dfa06$var$script$l.__file = "themes/blank/templates/elements/partials/CheckboxgroupCheckbox_tabs.vue";
var $741c336afc2dfa06$export$3f39e34e5e3a5101 = {
    name: 'CheckboxgroupCheckbox_tabs',
    render: $741c336afc2dfa06$var$script$l.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkbox-tabs-container',
                wrapper: 'vf-checkbox-tabs',
                wrapper_not_last: 'vf-checkbox-tabs-not-last',
                wrapper_first: 'vf-checkbox-tabs-first',
                wrapper_first_sm: 'vf-checkbox-tabs-first-sm',
                wrapper_first_md: '',
                wrapper_first_lg: 'vf-checkbox-tabs-first-lg',
                wrapper_last: 'vf-checkbox-tabs-last',
                wrapper_last_sm: 'vf-checkbox-tabs-last-sm',
                wrapper_last_md: '',
                wrapper_last_lg: 'vf-checkbox-tabs-last-lg',
                wrapper_selected: 'vf-checkbox-tabs-selected',
                wrapper_unselected: 'vf-checkbox-tabs-unselected',
                wrapper_disabled: 'vf-checkbox-tabs-disabled',
                wrapper_sm: 'vf-checkbox-tabs-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkbox-tabs-lg',
                input: 'vf-checkbox-tabs-input',
                text: '',
                $wrapper: (classes, { index: index, items: items, el$: el$, value: value, isDisabled: isDisabled, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        index < Object.keys(items).length - 1 ? classes.wrapper_not_last : null,
                        index === 0 ? classes.wrapper_first : null,
                        index === 0 ? classes[`wrapper_first_${Size}`] : null,
                        index === Object.keys(items).length - 1 ? classes.wrapper_last : null,
                        index === Object.keys(items).length - 1 ? classes[`wrapper_last_${Size}`] : null,
                        el$.value?.indexOf(value) !== -1 ? classes.wrapper_selected : classes.wrapper_unselected,
                        isDisabled ? classes.wrapper_disabled : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$a = "/* Some styles are contained in Vueform.vue & CheckboxgroupElement.vue */\n\n.vf-checkbox-tabs-container {\n  display: flex;\n  cursor: pointer;\n}\n\n.vf-checkbox-tabs {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-style: solid;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-color: var(--vf-border-color-input);\n  padding: var(--vf-py-group-tabs) var(--vf-px-group-tabs);\n  width: 100%;\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-not-last {\n  border-right: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-first {\n  border-radius: var(--vf-radius-input);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-first.vf-checkbox-tabs-first-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-first.vf-checkbox-tabs-first-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-last {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-last.vf-checkbox-tabs-last-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-last.vf-checkbox-tabs-last-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-selected {\n  background-color: var(--vf-primary);\n  border-color: rgba(0, 0, 0, 0.15);\n  color: var(--vf-color-on-primary);\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-unselected {\n  border-color: var(--vf-border-color-input);\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-unselected:hover:not(.vf-radio-tabs-disabled) {\n  background-color: var(--vf-bg-input-hover);\n  color: var(--vf-color-input-hover);\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-disabled {\n  opacity: 0.5;\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-sm {\n  padding: var(--vf-py-group-tabs-sm) var(--vf-px-group-tabs-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-checkbox-tabs.vf-checkbox-tabs-lg {\n  padding: var(--vf-py-group-tabs-lg) var(--vf-px-group-tabs-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-checkbox-tabs-input {\n  display: none;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$a);
$741c336afc2dfa06$export$3f39e34e5e3a5101.__file = "themes/vueform/templates/elements/partials/CheckboxgroupCheckbox_tabs.vue";
var $741c336afc2dfa06$var$script$j = {
    name: 'CheckboxgroupCheckbox_tabs',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text_wrapper: '',
                text: '',
                description: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$8 = [
    "value",
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2$6 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_3$5 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$9(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.model = $event)
                    }, _ctx.attrs, {
                        value: _ctx.value,
                        class: _ctx.classes.input,
                        name: _ctx.name,
                        id: _ctx.id,
                        disabled: _ctx.isDisabled
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$8), [
                        [
                            (0, $dDLnc.vModelCheckbox),
                            _ctx.el$.model
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text_wrapper)
                    }, [
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                            innerHTML: _ctx.item.label
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$6),
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.description),
                            innerHTML: _ctx.item.description
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$5)
                    ], 2 /* CLASS */ )
                ], 2 /* CLASS */ )
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$j.render = $741c336afc2dfa06$var$render$9;
$741c336afc2dfa06$var$script$j.__file = "themes/blank/templates/elements/partials/CheckboxgroupCheckbox_blocks.vue";
var $741c336afc2dfa06$export$58ae585cad4f8e08 = {
    name: 'CheckboxgroupCheckbox_blocks',
    render: $741c336afc2dfa06$var$script$j.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-checkbox-blocks-container',
                container_sm: 'vf-checkbox-blocks-container-sm',
                container_md: '',
                container_lg: 'vf-checkbox-blocks-container-lg',
                wrapper: 'vf-checkbox-blocks',
                wrapper_not_last: 'vf-checkbox-blocks-not-last',
                wrapper_first: 'vf-checkbox-blocks-first',
                wrapper_first_sm: 'vf-checkbox-blocks-first-sm',
                wrapper_first_md: '',
                wrapper_first_lg: 'vf-checkbox-blocks-first-lg',
                wrapper_last: 'vf-checkbox-blocks-last',
                wrapper_last_sm: 'vf-checkbox-blocks-last-sm',
                wrapper_last_md: '',
                wrapper_last_lg: 'vf-checkbox-blocks-last-lg',
                wrapper_selected: 'vf-checkbox-blocks-selected',
                wrapper_unselected: 'vf-checkbox-blocks-unselected',
                wrapper_disabled: 'vf-checkbox-blocks-disabled',
                wrapper_sm: 'vf-checkbox-blocks-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-checkbox-blocks-lg',
                input: 'vf-checkbox',
                input_enabled: '',
                input_disabled: '',
                input_sm: 'vf-checkbox-sm',
                input_md: '',
                input_lg: 'vf-checkbox-lg',
                text_wrapper: 'vf-checkbox-blocks-text-wrapper',
                text: 'vf-checkbox-blocks-text',
                description: 'vf-checkbox-blocks-description',
                description_sm: 'vf-checkbox-blocks-description-sm',
                description_md: '',
                description_lg: 'vf-checkbox-blocks-description-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ],
                $wrapper: (classes, { index: index, items: items, el$: el$, value: value, isDisabled: isDisabled, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        index < Object.keys(items).length - 1 ? classes.wrapper_not_last : null,
                        index === 0 ? classes.wrapper_first : null,
                        index === 0 ? classes[`wrapper_first_${Size}`] : null,
                        index === Object.keys(items).length - 1 ? classes.wrapper_last : null,
                        index === Object.keys(items).length - 1 ? classes[`wrapper_last_${Size}`] : null,
                        el$.value && el$.value?.indexOf(value) !== -1 ? classes.wrapper_selected : classes.wrapper_unselected,
                        isDisabled ? classes.wrapper_disabled : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled
                    ],
                $description: (classes, { Size: Size })=>[
                        classes.description,
                        classes[`description_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$9 = "/* Some styles are contained in Vueform.vue & CheckboxgroupElement.vue */\n\n.vf-checkbox-blocks-container {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-checkbox-blocks-container .vf-checkbox {\n  margin-top: 0;\n}\n\n.vf-checkbox-blocks-container.vf-checkbox-blocks-container-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-checkbox-blocks-container.vf-checkbox-blocks-container-lg {\n  border-radius: var(--vf-radius-large-lg);\n}\n\n.vf-checkbox-blocks {\n  display: flex;\n  align-items: center;\n  border-style: solid;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-color: var(--vf-border-color-input);\n  width: 100%;\n  padding: var(--vf-py-group-blocks) var(--vf-px-group-blocks);\n  color: var(--vf-color-input);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n  background: var(--vf-bg-input);\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-not-last {\n  border-bottom-width: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-first {\n  border-radius: var(--vf-radius-large);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-first.vf-checkbox-blocks-first-sm {\n  border-radius: var(--vf-radius-large-sm);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-first.vf-checkbox-blocks-first-lg {\n  border-radius: var(--vf-radius-large-lg);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-last {\n  border-radius: var(--vf-radius-large);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-last.vf-checkbox-blocks-last-sm {\n  border-radius: var(--vf-radius-large-sm);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-last.vf-checkbox-blocks-last-lg {\n  border-radius: var(--vf-radius-large-lg);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-selected {\n  background-color: var(--vf-bg-selected);\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-disabled {\n  opacity: 0.5;\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-sm {\n  padding: var(--vf-py-group-blocks-sm) var(--vf-px-group-blocks-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-checkbox-blocks.vf-checkbox-blocks-lg {\n  padding: var(--vf-py-group-blocks-lg) var(--vf-px-group-blocks-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-checkbox-blocks-text-wrapper {\n  margin-left: 0.5rem;\n}\n\n.vf-checkbox-blocks-description {\n  color: var(--vf-color-muted);\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  margin-top: -0.125rem;\n}\n\n.vf-checkbox-blocks-description.vf-checkbox-blocks-description-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  margin-top: -0.125rem;\n}\n\n.vf-checkbox-blocks-description.vf-checkbox-blocks-description-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n  margin-top: -0.125rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$9);
$741c336afc2dfa06$export$58ae585cad4f8e08.__file = "themes/vueform/templates/elements/partials/CheckboxgroupCheckbox_blocks.vue";
var $741c336afc2dfa06$var$script$h = {
    name: 'DragAndDrop',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                icon: '',
                title: '',
                description: ''
            }
        };
    }
};
function $741c336afc2dfa06$var$render$8(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container),
        onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.handleClick && _ctx.handleClick(...args), [
            "prevent"
        ])),
        ref: "area"
    }, [
        (0, $ani5R.createElementVNode)("span", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.icon)
        }, null, 2 /* CLASS */ ),
        _ctx.title ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.title)
        }, (0, $X5A94.toDisplayString)(_ctx.title), 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
        _ctx.description ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
            key: 1,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.description)
        }, (0, $X5A94.toDisplayString)(_ctx.description), 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$h.render = $741c336afc2dfa06$var$render$8;
$741c336afc2dfa06$var$script$h.__file = "themes/blank/templates/elements/partials/DragAndDrop.vue";
var $741c336afc2dfa06$export$a4c936d95bae1613 = {
    name: 'DragAndDrop',
    render: $741c336afc2dfa06$var$script$h.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-dnd',
                container_sm: 'vf-dnd-sm',
                container_md: '',
                container_lg: 'vf-dnd-lg',
                container_inactive: '',
                container_active: 'is-active',
                container_enabled: '',
                container_disabled: 'is-disabled',
                icon: 'vf-dnd-icon-upload',
                title: 'vf-dnd-title',
                description: 'vf-dnd-description',
                $container: (classes, { dragging: dragging, disabled: disabled, Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`],
                        dragging ? classes.container_active : classes.container_inactive,
                        disabled ? classes.container_disabled : classes.container_enabled
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$8 = ".vf-dnd {\n  background-color: #FFFFFF;\n  transition: 0.3s;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-style: dashed;\n  border-color: var(--vf-border-color-input);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-weight: inherit;\n  line-height: inherit;\n  color: inherit;\n  font-size: inherit;\n  box-sizing: border-box;\n  cursor: pointer;\n  text-align: center;\n  position: relative;\n  transition: 0.3s;\n  background-color: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  border-radius: var(--vf-radius-large);\n  box-shadow: var(--vf-shadow-input);\n  text-align: center;\n}\n\n.vf-dnd.vf-dnd-sm {\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-dnd.is-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vf-dnd.is-active {\n  border-color: var(--vf-primary);\n}\n\n.vf-dnd-icon-upload {\n  display: flex;\n  width: 2.25rem;\n  height: 2rem;\n  align-items: center;\n  justify-content: center;\n  background: var(--vf-primary);\n  mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='36px' height='32px' viewBox='0 0 36 32' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M35.0499042,20.6125054 C35.656165,21.1750041 35.9999142,21.9687644 35.9999142,22.8000002 L35.9999142,28.9999976 C35.9999142,30.6562437 34.6561674,31.9999905 32.9999213,31.9999905 L2.99999285,31.9999905 C1.3437468,31.9999905 0,30.6562437 0,28.9999976 L0,22.8000002 C0,21.9687644 0.34374918,21.1750041 0.950009942,20.6125054 L6.86247143,15.0687564 C7.01249549,14.9313056 7.24998271,14.9375311 7.39372016,15.0875552 L8.24998033,16.0000286 C8.38749221,16.1500527 8.3812056,16.3875399 8.23124258,16.5312773 L4.52501363,20.0062446 L11.7374598,20.0062446 L13.737455,24.0062351 L22.2624591,24.0062351 L24.2624544,20.0062446 L31.4811871,20.0062446 L27.7749582,16.5312773 C27.6249341,16.3875399 27.612422,16.1500527 27.7561594,16.0000286 L28.606194,15.0875552 C28.7499315,14.9375311 28.9874187,14.925019 29.1374427,15.0687564 L35.0499042,20.6125054 Z M33.9999189,28.9999976 L33.9999189,23.0000119 C33.9999189,22.4500254 33.5499078,22.0000143 32.9999213,22.0000143 L25.4999392,22.0000143 L23.499944,26.0000048 L12.4999702,26.0000048 L10.499975,22.0000143 L2.99999285,22.0000143 C2.45000637,22.0000143 1.99999523,22.4500254 1.99999523,23.0000119 L1.99999523,28.9999976 C1.99999523,29.5499841 2.45000637,29.9999952 2.99999285,29.9999952 L32.9999213,29.9999952 C33.5499078,29.9999952 33.9999189,29.5499841 33.9999189,28.9999976 Z M25.999938,8.00004768 C27.7811838,8.00004768 28.6686939,10.1562925 27.4186968,11.4125151 L19.4187159,19.4124961 C18.6374678,20.1937442 17.368733,20.1937442 16.5874849,19.4124961 L8.58750394,11.4125151 C7.32499474,10.1562925 8.22495598,8.00004768 9.99997616,8.00004768 L13.9999666,8.00004768 L13.9999666,1.50006318 C13.9999666,0.675052941 14.6749528,6.67572021e-05 15.499963,6.67572021e-05 L20.4999511,6.67572021e-05 C21.3249614,6.67572021e-05 21.9999475,0.675052941 21.9999475,1.50006318 L21.9999475,8.00004768 L25.999938,8.00004768 Z M17.9999571,18.0000238 L25.999938,10.0000429 L19.9999523,10.0000429 L19.9999523,2.00006199 L15.9999619,2.00006199 L15.9999619,10.0000429 L9.99997616,10.0000429 L17.9999571,18.0000238 Z' id='inbox-in' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='36px' height='32px' viewBox='0 0 36 32' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M35.0499042,20.6125054 C35.656165,21.1750041 35.9999142,21.9687644 35.9999142,22.8000002 L35.9999142,28.9999976 C35.9999142,30.6562437 34.6561674,31.9999905 32.9999213,31.9999905 L2.99999285,31.9999905 C1.3437468,31.9999905 0,30.6562437 0,28.9999976 L0,22.8000002 C0,21.9687644 0.34374918,21.1750041 0.950009942,20.6125054 L6.86247143,15.0687564 C7.01249549,14.9313056 7.24998271,14.9375311 7.39372016,15.0875552 L8.24998033,16.0000286 C8.38749221,16.1500527 8.3812056,16.3875399 8.23124258,16.5312773 L4.52501363,20.0062446 L11.7374598,20.0062446 L13.737455,24.0062351 L22.2624591,24.0062351 L24.2624544,20.0062446 L31.4811871,20.0062446 L27.7749582,16.5312773 C27.6249341,16.3875399 27.612422,16.1500527 27.7561594,16.0000286 L28.606194,15.0875552 C28.7499315,14.9375311 28.9874187,14.925019 29.1374427,15.0687564 L35.0499042,20.6125054 Z M33.9999189,28.9999976 L33.9999189,23.0000119 C33.9999189,22.4500254 33.5499078,22.0000143 32.9999213,22.0000143 L25.4999392,22.0000143 L23.499944,26.0000048 L12.4999702,26.0000048 L10.499975,22.0000143 L2.99999285,22.0000143 C2.45000637,22.0000143 1.99999523,22.4500254 1.99999523,23.0000119 L1.99999523,28.9999976 C1.99999523,29.5499841 2.45000637,29.9999952 2.99999285,29.9999952 L32.9999213,29.9999952 C33.5499078,29.9999952 33.9999189,29.5499841 33.9999189,28.9999976 Z M25.999938,8.00004768 C27.7811838,8.00004768 28.6686939,10.1562925 27.4186968,11.4125151 L19.4187159,19.4124961 C18.6374678,20.1937442 17.368733,20.1937442 16.5874849,19.4124961 L8.58750394,11.4125151 C7.32499474,10.1562925 8.22495598,8.00004768 9.99997616,8.00004768 L13.9999666,8.00004768 L13.9999666,1.50006318 C13.9999666,0.675052941 14.6749528,6.67572021e-05 15.499963,6.67572021e-05 L20.4999511,6.67572021e-05 C21.3249614,6.67572021e-05 21.9999475,0.675052941 21.9999475,1.50006318 L21.9999475,8.00004768 L25.999938,8.00004768 Z M17.9999571,18.0000238 L25.999938,10.0000429 L19.9999523,10.0000429 L19.9999523,2.00006199 L15.9999619,2.00006199 L15.9999619,10.0000429 L9.99997616,10.0000429 L17.9999571,18.0000238 Z' id='inbox-in' fill='currentColor'%3E%3C/path%3E%3C/g%3E%3C/svg%3E\");\n  mask-size: cover;\n  -webkit-mask-size: cover;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n}\n\n.vf-dnd-title {\n  font-weight: 600;\n  margin-top: 0.75rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$8);
$741c336afc2dfa06$export$a4c936d95bae1613.__file = "themes/vueform/templates/elements/partials/DragAndDrop.vue";
var $741c336afc2dfa06$var$script$f = {
    name: 'FilePreview',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                file: '',
                filenameLink: '',
                filenameStatic: '',
                actions: '',
                percent: '',
                upload: '',
                progressBar: '',
                progress: '',
                warning: '',
                warningIcon: '',
                uploaded: '',
                uploadedIcon: '',
                remove: '',
                removeIcon: '',
                assistiveText: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$7 = [
    "aria-labelledby",
    "aria-placeholder",
    "aria-describedby"
];
const $741c336afc2dfa06$var$_hoisted_2$5 = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_3$4 = [
    "href"
];
function $741c336afc2dfa06$var$render$7(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
        class: _ctx.classes.container
    }, _ctx.attrs, {
        tabindex: "0",
        role: "button",
        "aria-labelledby": _ctx.ariaLabelledby,
        "aria-placeholder": _ctx.ariaPlaceholder,
        "aria-describedby": `${_ctx.el$.fieldId}-file-description`,
        onKeyup: _cache[3] || (_cache[3] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args))
    }), [
        (0, $ani5R.createElementVNode)("span", {
            id: `${_ctx.el$.fieldId}-file-description`,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.assistiveText),
            "aria-hidden": ""
        }, (0, $X5A94.toDisplayString)(_ctx.form$.translations.vueform.a11y.file.description), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$5),
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.file)
            }, [
                (0, $ani5R.createCommentVNode)(" Filename "),
                _ctx.hasLink && _ctx.clickable ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                    key: 0,
                    href: _ctx.link,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.filenameLink),
                    target: "_blank",
                    rel: "nofollow noopener"
                }, (0, $X5A94.toDisplayString)(_ctx.filename), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$4)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.filenameStatic)
                }, (0, $X5A94.toDisplayString)(_ctx.filename), 3 /* TEXT, CLASS */ ))
            ], 2 /* CLASS */ ),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.actions)
            }, [
                (0, $ani5R.createCommentVNode)(" Remove "),
                _ctx.canRemove ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.remove),
                    onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.remove && _ctx.remove(...args), [
                        "prevent"
                    ])),
                    onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.remove && _ctx.remove(...args), [
                        "enter",
                        "space"
                    ])),
                    "aria-roledescription": "\u274E",
                    role: "button",
                    tabindex: "0"
                }, [
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.removeIcon)
                    }, null, 2 /* CLASS */ )
                ], 34 /* CLASS, NEED_HYDRATION */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Progress "),
                _ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.percent)
                }, (0, $X5A94.toDisplayString)(_ctx.progress) + "%", 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Error "),
                _ctx.hasError ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                    key: 2,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.warning)
                }, [
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.warningIcon)
                    }, null, 2 /* CLASS */ )
                ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Upload button "),
                _ctx.canUploadTemp ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 3,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.upload),
                    onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.upload && _ctx.upload(...args), [
                        "prevent"
                    ])),
                    tabindex: "-1"
                }, (0, $X5A94.toDisplayString)(_ctx.uploadText), 3 /* TEXT, CLASS */ )) : _ctx.el$.stage > 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 4
                }, [
                    (0, $ani5R.createCommentVNode)(" Success "),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.uploaded)
                    }, [
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadedIcon)
                        }, null, 2 /* CLASS */ )
                    ], 2 /* CLASS */ )
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */ )
        ], 2 /* CLASS */ ),
        _ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.progressBar)
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.progress),
                style: (0, $X5A94.normalizeStyle)({
                    width: _ctx.progress + '%'
                })
            }, null, 6 /* CLASS, STYLE */ )
        ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$7)), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$f.render = $741c336afc2dfa06$var$render$7;
$741c336afc2dfa06$var$script$f.__file = "themes/blank/templates/elements/partials/FilePreview.vue";
var $741c336afc2dfa06$export$a127194569a41afb = {
    name: 'FilePreview',
    render: $741c336afc2dfa06$var$script$f.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-file-preview',
                container_sm: 'vf-file-preview-sm',
                container_md: '',
                container_lg: 'vf-file-preview-lg',
                wrapper: 'vf-file-preview-wrapper',
                file: 'vf-file-preview-file',
                filenameLink: 'vf-file-preview-filename-link',
                filenameStatic: 'vf-file-preview-filename',
                actions: 'vf-file-preview-actions',
                percent: 'vf-file-preview-percent',
                upload: 'vf-file-preview-upload',
                progressBar: 'vf-file-preview-progress-bar',
                progress: 'vf-file-preview-progress',
                warning: 'vf-file-preview-warning',
                warningIcon: 'vf-file-preview-warning-icon',
                uploaded: 'vf-file-preview-uploaded',
                uploadedIcon: 'vf-file-preview-uploaded-icon',
                remove: 'vf-file-preview-remove',
                removeIcon: 'vf-file-preview-remove-icon',
                assistiveText: 'vf-assistive-text',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$7 = ".vf-file-preview {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  min-height: var(--vf-min-height-input);\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  position: relative;\n}\n\n.vf-file-preview:hover .vf-file-preview-uploaded,\n.vf-file-preview:hover .vf-file-preview-warning,\n.vf-file-preview:hover .vf-file-preview-percent {\n  display: none;\n}\n\n.vf-file-preview:hover .vf-file-preview-remove {\n  display: inline-block;\n}\n\n.vf-file-preview.vf-file-preview-sm {\n  padding-top: calc(var(--vf-py-input-sm) + var(--vf-border-width-input-t));\n  min-height: var(--vf-min-height-input-sm);\n}\n\n.vf-file-preview.vf-file-preview-lg {\n  padding-top: calc(var(--vf-py-input-lg) + var(--vf-border-width-input-t));\n  min-height: var(--vf-min-height-input-lg);\n}\n\n.vf-file-preview-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.vf-file-preview-file {\n  display: flex;\n  align-items: center;\n}\n\n.vf-file-preview-filename-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.vf-file-preview-filename-link:hover, .vf-file-preview-filename-link:focus, .vf-file-preview-filename-link:active {\n  color: inherit;\n}\n\n.vf-file-preview-filename-link:hover {\n  text-decoration: underline;\n}\n\n.vf-file-preview-actions {\n  display: flex;\n  align-items: center;\n}\n\n.vf-file-preview-upload {\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n  white-space: nowrap;\n  padding: 0.0625rem 0.4375rem;\n  background: var(--vf-primary);\n  color: var(--vf-color-on-primary);\n  border-radius: var(--vf-radius-small);\n  text-decoration: none;\n  transition: 0.15s;\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n}\n\n.vf-file-preview-upload:hover {\n  transform: scale(1.05);\n}\n\n.vf-file-preview-upload:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-file-preview-percent {\n  font-size: 0.875rem;\n  color: var(--vf-color-muted);\n  margin-left: 0.375rem;\n}\n\n.vf-file-preview-progress-bar {\n  margin-top: 0.625rem;\n  border-radius: 0;\n  height: 0.1875rem;\n  background: var(--vf-bg-passive);\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.vf-file-preview-progress {\n  border-radius: 0;\n  height: 100%;\n  background: var(--vf-primary);\n  transition: 0.6s ease;\n}\n\n.vf-file-preview-warning,\n.vf-file-preview-uploaded,\n.vf-file-preview-remove {\n  display: flex;\n  width: 1rem;\n  height: 1rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n}\n\n.vf-file-preview-warning-icon,\n.vf-file-preview-uploaded-icon,\n.vf-file-preview-remove-icon {\n  width: 100%;\n  height: 100%;\n  display: block;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n}\n\n.vf-file-preview-remove {\n  display: none;\n  margin-left: 0.375rem;\n  background-color: var(--vf-bg-passive);\n  transition: 0.15s;\n}\n\n.vf-file-preview-remove:hover {\n  filter: brightness(0.9);\n}\n\n.vf-file-preview-remove-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-file-preview-uploaded {\n  background-color: var(--vf-bg-success);\n}\n\n.vf-file-preview-uploaded-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-success);\n}\n\n.vf-file-preview-warning {\n  background-color: var(--vf-bg-danger);\n}\n\n.vf-file-preview-warning-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-danger);\n}\n\n.vf-file-removing .vf-file-preview {\n  opacity: 0.6;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$7);
$741c336afc2dfa06$export$a127194569a41afb.__file = "themes/vueform/templates/elements/partials/FilePreview.vue";
var $741c336afc2dfa06$var$script$d = {
    name: 'FilePreview_image',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                image: '',
                img: '',
                file: '',
                filenameLink: '',
                filenameStatic: '',
                actions: '',
                percent: '',
                upload: '',
                progressBar: '',
                progress: '',
                warning: '',
                warningIcon: '',
                uploaded: '',
                uploadedIcon: '',
                remove: '',
                removeIcon: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$6 = [
    "aria-labelledby",
    "aria-placeholder",
    "aria-describedby"
];
const $741c336afc2dfa06$var$_hoisted_2$4 = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_3$3 = [
    "href"
];
const $741c336afc2dfa06$var$_hoisted_4$2 = [
    "src",
    "alt",
    "title"
];
const $741c336afc2dfa06$var$_hoisted_5$1 = [
    "src",
    "alt",
    "title"
];
const $741c336afc2dfa06$var$_hoisted_6 = [
    "href"
];
function $741c336afc2dfa06$var$render$6(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
        class: _ctx.classes.container,
        tabindex: "0",
        role: "button"
    }, _ctx.attrs, {
        "aria-labelledby": _ctx.ariaLabelledby,
        "aria-placeholder": _ctx.ariaPlaceholder,
        "aria-describedby": `${_ctx.el$.fieldId}-file-description`,
        onKeyup: _cache[4] || (_cache[4] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args))
    }), [
        (0, $ani5R.createElementVNode)("span", {
            id: `${_ctx.el$.fieldId}-file-description`,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.assistiveText),
            "aria-hidden": ""
        }, (0, $X5A94.toDisplayString)(_ctx.form$.translations.vueform.a11y.file.description), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$4),
        (0, $ani5R.createElementVNode)("div", {
            class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
        }, [
            (0, $ani5R.createCommentVNode)(" Image "),
            _ctx.uploaded && _ctx.hasLink && _ctx.clickable ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                key: 0,
                href: _ctx.link,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.image),
                target: "_blank",
                rel: "nofollow noopener"
            }, [
                (0, $ani5R.createElementVNode)("img", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.img),
                    src: _ctx.preview,
                    alt: _ctx.filename,
                    title: _ctx.filename,
                    "aria-hidden": "true"
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_4$2)
            ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$3)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                key: 1,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.image)
            }, [
                (0, $ani5R.createElementVNode)("img", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.img),
                    src: _ctx.preview,
                    alt: _ctx.filename,
                    title: _ctx.filename,
                    "aria-hidden": "true"
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_5$1)
            ], 2 /* CLASS */ )),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.file)
            }, [
                (0, $ani5R.createCommentVNode)(" Filename "),
                _ctx.hasLink && _ctx.clickable ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
                    key: 0,
                    href: _ctx.link,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.filenameLink),
                    target: "_blank",
                    rel: "nofollow noopener"
                }, (0, $X5A94.toDisplayString)(_ctx.filename), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_6)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.filenameStatic)
                }, (0, $X5A94.toDisplayString)(_ctx.filename), 3 /* TEXT, CLASS */ ))
            ], 2 /* CLASS */ ),
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.actions)
            }, [
                (0, $ani5R.createCommentVNode)(" Remove "),
                _ctx.canRemove ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 0,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.remove),
                    onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.remove && _ctx.remove(...args), [
                        "prevent"
                    ])),
                    onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.remove && _ctx.remove(...args), [
                        "enter",
                        "space"
                    ])),
                    "aria-roledescription": "\u274E",
                    role: "button",
                    tabindex: "0"
                }, [
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.removeIcon)
                    }, null, 2 /* CLASS */ )
                ], 34 /* CLASS, NEED_HYDRATION */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Progress "),
                _ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 1,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.percent)
                }, (0, $X5A94.toDisplayString)(_ctx.progress) + "%", 3 /* TEXT, CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Error "),
                _ctx.hasError ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
                    key: 2,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.warning)
                }, [
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.warningIcon)
                    }, null, 2 /* CLASS */ )
                ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
                (0, $ani5R.createCommentVNode)(" Upload button "),
                _ctx.canUploadTemp ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                    key: 3,
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.upload),
                    onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.upload && _ctx.upload(...args), [
                        "prevent"
                    ])),
                    onKeypress: _cache[3] || (_cache[3] = (0, $dDLnc.withKeys)((...args)=>_ctx.upload && _ctx.upload(...args), [
                        "enter",
                        "space"
                    ])),
                    tabindex: "-1",
                    role: "button"
                }, (0, $X5A94.toDisplayString)(_ctx.uploadText), 35 /* TEXT, CLASS, NEED_HYDRATION */ )) : _ctx.el$.stage > 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
                    key: 4
                }, [
                    (0, $ani5R.createCommentVNode)(" Success "),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.uploaded)
                    }, [
                        (0, $ani5R.createElementVNode)("span", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadedIcon)
                        }, null, 2 /* CLASS */ )
                    ], 2 /* CLASS */ )
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */ )
        ], 2 /* CLASS */ ),
        _ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.progressBar)
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.progress),
                style: (0, $X5A94.normalizeStyle)({
                    width: _ctx.progress + '%'
                })
            }, null, 6 /* CLASS, STYLE */ )
        ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$6)), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$d.render = $741c336afc2dfa06$var$render$6;
$741c336afc2dfa06$var$script$d.__file = "themes/blank/templates/elements/partials/FilePreview_image.vue";
var $741c336afc2dfa06$export$5af9d3946b4cde3c = {
    name: 'ImagePreview',
    render: $741c336afc2dfa06$var$script$d.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-file-preview-image',
                wrapper: 'vf-file-preview-image-wrapper',
                image: 'vf-file-preview-image-image',
                image_link: '',
                image_static: '',
                image_sm: 'vf-file-preview-image-image-sm',
                image_md: '',
                image_lg: 'vf-file-preview-image-image-lg',
                img: 'vf-file-preview-image-img',
                img_sm: 'vf-file-preview-image-img-sm',
                img_md: '',
                img_lg: 'vf-file-preview-image-img-lg',
                file: 'vf-file-preview-image-file',
                filenameLink: 'vf-file-preview-image-filename-link',
                filenameStatic: 'vf-file-preview-image-filename',
                actions: 'vf-file-preview-image-actions',
                percent: 'vf-file-preview-image-percent',
                upload: 'vf-file-preview-image-upload',
                progressBar: 'vf-file-preview-image-progress-bar',
                progressBar_sm: 'vf-file-preview-image-progress-bar-sm',
                progressBar_md: '',
                progressBar_lg: 'vf-file-preview-image-progress-bar-lg',
                progress: 'vf-file-preview-image-progress',
                warning: 'vf-file-preview-image-warning',
                warningIcon: 'vf-file-preview-image-warning-icon',
                uploaded: 'vf-file-preview-image-uploaded',
                uploadedIcon: 'vf-file-preview-image-uploaded-icon',
                remove: 'vf-file-preview-image-remove',
                removeIcon: 'vf-file-preview-image-remove-icon',
                assistiveText: 'vf-assistive-text',
                $image: (classes, { hasLink: hasLink, Size: Size })=>[
                        classes.image,
                        classes[`image_${Size}`],
                        hasLink ? classes.image_link : classes.image_static
                    ],
                $img: (classes, { Size: Size })=>[
                        classes.img,
                        classes[`img_${Size}`]
                    ],
                $progressBar: (classes, { Size: Size })=>[
                        classes.progressBar,
                        classes[`progressBar_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$6 = ".vf-file-preview-image {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n  position: relative;\n}\n\n.vf-file-preview-image:hover .vf-file-preview-image-uploaded,\n.vf-file-preview-image:hover .vf-file-preview-image-warning,\n.vf-file-preview-image:hover .vf-file-preview-image-percent {\n  display: none;\n}\n\n.vf-file-preview-image:hover .vf-file-preview-image-remove {\n  display: inline-block;\n}\n\n.vf-file-preview-image-image {\n  display: flex;\n  align-items: center;\n  flex: 0 0 auto;\n  background: var(--vf-bg-passive);\n  border-radius: var(--vf-radius-image);\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n  box-shadow: var(--vf-shadow-input);\n}\n\n.vf-file-preview-image-image:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-file-preview-image-image.vf-file-preview-image-image-sm {\n  border-radius: var(--vf-radius-image-sm);\n}\n\n.vf-file-preview-image-image.vf-file-preview-image-image-lg {\n  border-radius: var(--vf-radius-image-lg);\n}\n\n.vf-file-preview-image-img {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: var(--vf-min-height-input);\n  height: var(--vf-min-height-input);\n  border-radius: var(--vf-radius-image);\n  border: 0;\n}\n\n.vf-file-preview-image-img[src=\"\"], .vf-file-preview-image-img[src=\"data:\"], .vf-file-preview-image-img:not([src]) {\n  opacity: 0;\n}\n\n.vf-file-preview-image-img.vf-file-preview-image-img-sm {\n  width: var(--vf-min-height-input-sm);\n  height: var(--vf-min-height-input-sm);\n  border-radius: var(--vf-radius-image-sm);\n}\n\n.vf-file-preview-image-img.vf-file-preview-image-img-lg {\n  width: var(--vf-min-height-input-lg);\n  height: var(--vf-min-height-input-lg);\n  border-radius: var(--vf-radius-image-lg);\n}\n\n.vf-file-preview-image-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.vf-file-preview-image-file {\n  display: flex;\n  align-items: center;\n  margin-left: 0.625rem;\n  flex: 1 1 auto;\n}\n\n.vf-file-preview-image-filename-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.vf-file-preview-image-filename-link:hover, .vf-file-preview-image-filename-link:focus, .vf-file-preview-image-filename-link:active {\n  color: inherit;\n}\n\n.vf-file-preview-image-filename-link:hover {\n  text-decoration: underline;\n}\n\n.vf-file-preview-image-actions {\n  display: flex;\n  align-items: center;\n}\n\n.vf-file-preview-image-upload {\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n  white-space: nowrap;\n  padding: 0.0625rem 0.4375rem;\n  background: var(--vf-primary);\n  color: var(--vf-color-on-primary);\n  border-radius: var(--vf-radius-small);\n  text-decoration: none;\n  transition: 0.15s;\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n}\n\n.vf-file-preview-image-upload:hover {\n  transform: scale(1.05);\n}\n\n.vf-file-preview-image-upload:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-file-preview-image-percent {\n  font-size: 0.875rem;\n  color: var(--vf-color-muted);\n  margin-left: 0.375rem;\n}\n\n.vf-file-preview-image-progress-bar {\n  margin-top: 0.625rem;\n  border-radius: 0;\n  height: 0.1875rem;\n  background: var(--vf-bg-passive);\n  position: absolute;\n  bottom: 0;\n  left: calc(var(--vf-min-height-input) + 0.625rem);\n  right: 0;\n}\n\n.vf-file-preview-image-progress-bar.vf-file-preview-image-progress-bar-sm {\n  left: calc(var(--vf-min-height-input-sm) + 0.625rem);\n}\n\n.vf-file-preview-image-progress-bar.vf-file-preview-image-progress-bar-lg {\n  left: calc(var(--vf-min-height-input-lg) + 0.625rem);\n}\n\n.vf-file-preview-image-progress {\n  border-radius: 0;\n  display: block;\n  height: 100%;\n  background: var(--vf-primary);\n  transition: 0.6s ease;\n}\n\n.vf-file-preview-image-warning,\n.vf-file-preview-image-uploaded,\n.vf-file-preview-image-remove {\n  display: flex;\n  width: 1rem;\n  height: 1rem;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n}\n\n.vf-file-preview-image-warning-icon,\n.vf-file-preview-image-uploaded-icon,\n.vf-file-preview-image-remove-icon {\n  width: 100%;\n  height: 100%;\n  display: block;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n}\n\n.vf-file-preview-image-remove {\n  display: none;\n  margin-left: 0.375rem;\n  background-color: var(--vf-bg-passive);\n  transition: 0.15s;\n}\n\n.vf-file-preview-image-remove:hover {\n  filter: brightness(0.9);\n}\n\n.vf-file-preview-image-remove-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-file-preview-image-uploaded {\n  background-color: var(--vf-bg-success);\n}\n\n.vf-file-preview-image-uploaded-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-success);\n}\n\n.vf-file-preview-image-warning {\n  background-color: var(--vf-bg-danger);\n}\n\n.vf-file-preview-image-warning-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-danger);\n}\n\n.vf-file-removing .vf-file-preview-image {\n  opacity: 0.6;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$6);
$741c336afc2dfa06$export$5af9d3946b4cde3c.__file = "themes/vueform/templates/elements/partials/FilePreview_image.vue";
var $741c336afc2dfa06$var$script$b = {
    name: 'FilePreview_gallery',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                image: '',
                img: '',
                overlay: '',
                upload: '',
                progressBar: '',
                progress: '',
                warning: '',
                warningIcon: '',
                uploaded: '',
                uploadedIcon: '',
                remove: '',
                removeIcon: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$5 = [
    "aria-labelledby",
    "aria-placeholder",
    "aria-role",
    "aria-describedby"
];
const $741c336afc2dfa06$var$_hoisted_2$3 = [
    "id"
];
const $741c336afc2dfa06$var$_hoisted_3$2 = [
    "href"
];
const $741c336afc2dfa06$var$_hoisted_4$1 = [
    "src",
    "alt",
    "title"
];
const $741c336afc2dfa06$var$_hoisted_5 = [
    "src",
    "alt",
    "title"
];
function $741c336afc2dfa06$var$render$5(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.withDirectives)(((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", (0, $ani5R.mergeProps)({
        class: _ctx.classes.container,
        tabindex: "0",
        role: "button"
    }, _ctx.attrs, {
        "aria-labelledby": _ctx.ariaLabelledby,
        "aria-placeholder": _ctx.ariaPlaceholder,
        "aria-role": _ctx.ariaRoledescription,
        "aria-describedby": `${_ctx.el$.fieldId}-file-description`,
        onKeyup: _cache[4] || (_cache[4] = (...args)=>_ctx.handleKeyup && _ctx.handleKeyup(...args))
    }), [
        (0, $ani5R.createElementVNode)("span", {
            id: `${_ctx.el$.fieldId}-file-description`,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.assistiveText),
            "aria-hidden": ""
        }, (0, $X5A94.toDisplayString)(_ctx.form$.translations.vueform.a11y.file.description), 11 /* TEXT, CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$3),
        (0, $ani5R.createCommentVNode)(" Image  "),
        _ctx.uploaded && _ctx.hasLink && _ctx.clickable ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("a", {
            key: 0,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.image),
            href: _ctx.link,
            target: "_blank",
            rel: "nofollow noopener"
        }, [
            (0, $ani5R.createElementVNode)("img", {
                src: _ctx.preview,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.img),
                alt: _ctx.filename,
                title: _ctx.filename,
                "aria-hidden": "true"
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_4$1)
        ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$2)) : ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 1,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.image)
        }, [
            (0, $ani5R.createElementVNode)("img", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.img),
                src: _ctx.preview,
                alt: _ctx.filename,
                title: _ctx.filename,
                "aria-hidden": "true"
            }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_5)
        ], 2 /* CLASS */ )),
        (0, $ani5R.createCommentVNode)(" Overlay "),
        !_ctx.uploaded && !_ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 2,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.overlay)
        }, [
            _ctx.canUploadTemp ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
                key: 0,
                class: (0, $X5A94.normalizeClass)(_ctx.classes.upload),
                onClick: _cache[0] || (_cache[0] = (0, $dDLnc.withModifiers)((...args)=>_ctx.upload && _ctx.upload(...args), [
                    "prevent"
                ])),
                onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((...args)=>_ctx.upload && _ctx.upload(...args), [
                    "enter",
                    "space"
                ])),
                tabindex: "-1",
                role: "button"
            }, (0, $X5A94.toDisplayString)(_ctx.uploadText), 35 /* TEXT, CLASS, NEED_HYDRATION */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
        ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Error "),
        _ctx.hasError ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("span", {
            key: 3,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.warning)
        }, [
            (0, $ani5R.createElementVNode)("span", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.warningIcon)
            }, null, 2 /* CLASS */ )
        ], 2 /* CLASS */ )) : _ctx.el$.stage > 1 ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)((0, $ani5R.Fragment), {
            key: 4
        }, [
            (0, $ani5R.createCommentVNode)(" Success "),
            (0, $ani5R.createElementVNode)("span", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.uploaded)
            }, [
                (0, $ani5R.createElementVNode)("span", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.uploadedIcon)
                }, null, 2 /* CLASS */ )
            ], 2 /* CLASS */ )
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Remove "),
        _ctx.canRemove ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 5,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.remove),
            onClick: _cache[2] || (_cache[2] = (0, $dDLnc.withModifiers)((...args)=>_ctx.remove && _ctx.remove(...args), [
                "prevent"
            ])),
            onKeypress: _cache[3] || (_cache[3] = (0, $dDLnc.withKeys)((...args)=>_ctx.remove && _ctx.remove(...args), [
                "enter",
                "space"
            ])),
            "aria-roledescription": "\u274E",
            role: "button",
            tabindex: "0"
        }, [
            (0, $ani5R.createElementVNode)("span", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.removeIcon)
            }, null, 2 /* CLASS */ )
        ], 34 /* CLASS, NEED_HYDRATION */ )) : (0, $ani5R.createCommentVNode)("v-if", true),
        (0, $ani5R.createCommentVNode)(" Progress "),
        _ctx.uploading ? ((0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
            key: 6,
            class: (0, $X5A94.normalizeClass)(_ctx.classes.progressBar)
        }, [
            (0, $ani5R.createElementVNode)("div", {
                class: (0, $X5A94.normalizeClass)(_ctx.classes.progress),
                style: (0, $X5A94.normalizeStyle)({
                    width: _ctx.progress + '%'
                })
            }, null, 6 /* CLASS, STYLE */ )
        ], 2 /* CLASS */ )) : (0, $ani5R.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$5)), [
        [
            (0, $dDLnc.vShow),
            _ctx.visible
        ]
    ]);
}
$741c336afc2dfa06$var$script$b.render = $741c336afc2dfa06$var$render$5;
$741c336afc2dfa06$var$script$b.__file = "themes/blank/templates/elements/partials/FilePreview_gallery.vue";
var $741c336afc2dfa06$export$cd9118d548d34ced = {
    name: 'GalleryPreview',
    render: $741c336afc2dfa06$var$script$b.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-file-preview-gallery',
                container_sm: 'vf-file-preview-gallery-sm',
                container_md: '',
                container_lg: 'vf-file-preview-gallery-lg',
                image: 'vf-file-preview-gallery-image',
                image_sm: 'vf-file-preview-gallery-image-sm',
                image_md: '',
                image_lg: 'vf-file-preview-gallery-image-lg',
                image_link: '',
                image_static: '',
                img: 'vf-file-preview-gallery-img',
                img_sm: 'vf-file-preview-gallery-img-sm',
                img_md: '',
                img_lg: 'vf-file-preview-gallery-img-lg',
                overlay: 'vf-file-preview-gallery-overlay',
                overlay_sm: 'vf-file-preview-gallery-overlay-sm',
                overlay_md: '',
                overlay_lg: 'vf-file-preview-gallery-overlay-lg',
                upload: 'vf-file-preview-gallery-upload',
                progressBar: 'vf-file-preview-gallery-progress-bar',
                progress: 'vf-file-preview-gallery-progress',
                warning: 'vf-file-preview-gallery-warning',
                warningIcon: 'vf-file-preview-gallery-warning-icon',
                uploaded: 'vf-file-preview-gallery-uploaded',
                uploadedIcon: 'vf-file-preview-gallery-uploaded-icon',
                remove: 'vf-file-preview-gallery-remove',
                removeIcon: 'vf-file-preview-gallery-remove-icon',
                assistiveText: 'vf-assistive-text',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ],
                $image: (classes, { Size: Size })=>[
                        classes.image,
                        classes[`image_${Size}`]
                    ],
                $img: (classes, { Size: Size })=>[
                        classes.img,
                        classes[`img_${Size}`]
                    ],
                $overlay: (classes, { Size: Size })=>[
                        classes.overlay,
                        classes[`overlay_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$5 = ".vf-file-preview-gallery {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  transition: 0.2s background;\n  width: var(--vf-gallery-size);\n  height: var(--vf-gallery-size);\n  position: relative;\n}\n\n.vf-file-preview-gallery:hover .vf-file-preview-gallery-overlay {\n  opacity: 1;\n  visibility: visible;\n}\n\n.vf-file-preview-gallery:hover .vf-file-preview-gallery-remove {\n  opacity: 1;\n  visibility: visible;\n}\n\n.vf-file-preview-gallery.vf-file-preview-gallery-sm {\n  width: var(--vf-gallery-size-sm);\n  height: var(--vf-gallery-size-sm);\n}\n\n.vf-file-preview-gallery.vf-file-preview-gallery-lg {\n  width: var(--vf-gallery-size-lg);\n  height: var(--vf-gallery-size-lg);\n}\n\n.vf-file-preview-gallery-overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.5);\n  transition: 0.3s;\n  opacity: 0;\n  visibility: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  padding: 0.75rem;\n  border-radius: var(--vf-radius-gallery);\n}\n\n.vf-file-preview-gallery-overlay.vf-file-preview-gallery-overlay-sm {\n  border-radius: var(--vf-radius-gallery-sm);\n}\n\n.vf-file-preview-gallery-overlay.vf-file-preview-gallery-overlay-lg {\n  border-radius: var(--vf-radius-gallery-lg);\n}\n\n.vf-file-preview-gallery-upload {\n  font-size: 0.75rem;\n  white-space: nowrap;\n  background: #FFFFFF;\n  padding: 0.0625rem 0.4375rem;\n  background: var(--vf-primary);\n  color: var(--vf-color-on-primary);\n  border-radius: var(--vf-radius-small);\n  text-decoration: none;\n  transition: 0.15s;\n  outline: 0px solid var(--vf-ring-color);\n  outline-offset: 0;\n}\n\n.vf-file-preview-gallery-upload:hover {\n  transform: scale(1.05);\n}\n\n.vf-file-preview-gallery-upload:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color);\n}\n\n.vf-file-preview-gallery-image {\n  width: 100%;\n  height: 100%;\n  font-size: 0;\n  background: var(--vf-bg-passive);\n  border-radius: var(--vf-radius-gallery);\n  outline: none;\n}\n\n.vf-file-preview-gallery-image.vf-file-preview-gallery-image-sm {\n  border-radius: var(--vf-radius-gallery-sm);\n}\n\n.vf-file-preview-gallery-image.vf-file-preview-gallery-image-lg {\n  border-radius: var(--vf-radius-gallery-lg);\n}\n\n.vf-file-preview-gallery-img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: var(--vf-radius-gallery);\n}\n\n.vf-file-preview-gallery-img[src=\"\"], .vf-file-preview-gallery-img[src=\"data:\"], .vf-file-preview-gallery-img:not([src]) {\n  opacity: 0;\n}\n\n.vf-file-preview-gallery-img.vf-file-preview-gallery-img-sm {\n  border-radius: var(--vf-radius-gallery-sm);\n}\n\n.vf-file-preview-gallery-img.vf-file-preview-gallery-img-lg {\n  border-radius: var(--vf-radius-gallery-lg);\n}\n\n.vf-file-preview-gallery-progress-bar {\n  border-radius: 0;\n  height: 0.1875rem;\n  position: absolute;\n  left: 0.1875rem;\n  bottom: 0.1875rem;\n  z-index: 1;\n  background: #FFFFFF;\n  right: 0.1875rem;\n}\n\n.vf-file-preview-gallery-progress {\n  border-radius: 0;\n  height: 100%;\n  background: var(--vf-primary);\n  transition: 0.6s ease;\n}\n\n.vf-file-preview-gallery-remove,\n.vf-file-preview-gallery-uploaded,\n.vf-file-preview-gallery-warning {\n  display: flex;\n  width: 1rem;\n  height: 1rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.vf-file-preview-gallery-remove-icon,\n.vf-file-preview-gallery-uploaded-icon,\n.vf-file-preview-gallery-warning-icon {\n  width: 100%;\n  height: 100%;\n  display: block;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n}\n\n.vf-file-preview-gallery-remove {\n  position: absolute;\n  right: 0.1875rem;\n  top: 0.1875rem;\n  opacity: 0;\n  visibility: hidden;\n  background-color: var(--vf-bg-passive);\n  border-radius: 999px;\n  transition: 0.15s;\n}\n\n.vf-file-preview-gallery-remove:hover {\n  filter: brightness(0.9);\n}\n\n.vf-file-preview-gallery-remove-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.75rem 0.75rem;\n  -webkit-mask-size: 0.75rem 0.75rem;\n  background-color: var(--vf-color-passive);\n}\n\n.vf-file-preview-gallery-uploaded {\n  position: absolute;\n  right: 0.1875rem;\n  bottom: 0.1875rem;\n  border-radius: 999px;\n  background-color: var(--vf-bg-success);\n}\n\n.vf-file-preview-gallery-uploaded-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-success);\n}\n\n.vf-file-preview-gallery-warning {\n  position: absolute;\n  right: 0.1875rem;\n  bottom: 0.1875rem;\n  border-radius: 999px;\n  background-color: var(--vf-bg-danger);\n}\n\n.vf-file-preview-gallery-warning-icon {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 192 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z'%3E%3C/path%3E%3C/svg%3E\");\n  mask-size: 0.625rem 0.625rem;\n  -webkit-mask-size: 0.625rem 0.625rem;\n  background-color: var(--vf-color-danger);\n}\n\n.vf-file-removing .vf-file-preview-gallery {\n  opacity: 0.6;\n}\n\n.is-sorting .vf-file-preview-gallery:hover .vf-file-preview-gallery-overlay, .vf-gallery.is-disabled .vf-file-preview-gallery:hover .vf-file-preview-gallery-overlay {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.is-sorting .vf-file-preview-gallery:hover .vf-file-preview-gallery-remove, .vf-gallery.is-disabled .vf-file-preview-gallery:hover .vf-file-preview-gallery-remove {\n  opacity: 0;\n  visibility: hidden;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$5);
$741c336afc2dfa06$export$cd9118d548d34ced.__file = "themes/vueform/templates/elements/partials/FilePreview_gallery.vue";
var $741c336afc2dfa06$var$script$9 = {
    name: 'RadiogroupRadio',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$4 = [
    "value",
    "name",
    "id",
    "disabled",
    "aria-label"
];
const $741c336afc2dfa06$var$_hoisted_2$2 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$4(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.value = $event)
                }, _ctx.attrs, {
                    value: _ctx.value,
                    class: _ctx.classes.input,
                    name: _ctx.name,
                    id: _ctx.id,
                    disabled: _ctx.isDisabled,
                    "aria-label": _ctx.item.label
                }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$4), [
                    [
                        (0, $dDLnc.vModelRadio),
                        _ctx.el$.value
                    ]
                ]),
                (0, $ani5R.createElementVNode)("span", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                    innerHTML: _ctx.item.label
                }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$2)
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$9.render = $741c336afc2dfa06$var$render$4;
$741c336afc2dfa06$var$script$9.__file = "themes/blank/templates/elements/partials/RadiogroupRadio.vue";
var $741c336afc2dfa06$export$970323dfa517db7c = {
    name: 'RadiogroupRadio',
    render: $741c336afc2dfa06$var$script$9.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radio-container',
                input: 'vf-radio',
                input_enabled: '',
                input_disabled: '',
                input_sm: 'vf-radio-sm',
                input_md: '',
                input_lg: 'vf-radio-lg',
                text: 'vf-radio-text',
                $input: (classes, { isDisabled: isDisabled, Size: Size })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$4 = "/* Some styles are contained in Vueform.vue & RadiogroupElement.vue */";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$4);
$741c336afc2dfa06$export$970323dfa517db7c.__file = "themes/vueform/templates/elements/partials/RadiogroupRadio.vue";
var $741c336afc2dfa06$var$script$7 = {
    name: 'RadiogroupRadio_tabs',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$3 = [
    "aria-checked"
];
const $741c336afc2dfa06$var$_hoisted_2$1 = [
    "title"
];
const $741c336afc2dfa06$var$_hoisted_3$1 = [
    "value",
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_4 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$3(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", (0, $ani5R.mergeProps)(_ctx.attrs, {
        class: _ctx.classes.container,
        tabindex: "0",
        role: "radio",
        "aria-checked": _ctx.checked,
        onKeypress: _cache[1] || (_cache[1] = (0, $dDLnc.withKeys)((0, $dDLnc.withModifiers)(($event)=>_ctx.el$.update(_ctx.value), [
            "prevent"
        ]), [
            "space"
        ])),
        onKeydown: _cache[2] || (_cache[2] = (...args)=>_ctx.handleKeydown && _ctx.handleKeydown(...args))
    }), [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper),
                    title: _ctx.item.label
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", {
                        type: "radio",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.model = $event),
                        value: _ctx.value,
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.input),
                        name: _ctx.name,
                        id: _ctx.id,
                        disabled: _ctx.isDisabled
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3$1), [
                        [
                            (0, $dDLnc.vModelRadio),
                            _ctx.el$.model
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("span", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                        innerHTML: `${_ctx.item.label}`
                    }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_4)
                ], 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2$1)
            ])
    ], 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$3);
}
$741c336afc2dfa06$var$script$7.render = $741c336afc2dfa06$var$render$3;
$741c336afc2dfa06$var$script$7.__file = "themes/blank/templates/elements/partials/RadiogroupRadio_tabs.vue";
var $741c336afc2dfa06$export$6bc195358ee4baf2 = {
    name: 'RadiogroupRadio_tabs',
    render: $741c336afc2dfa06$var$script$7.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radio-tabs-container',
                wrapper: 'vf-radio-tabs',
                wrapper_not_last: 'vf-radio-tabs-not-last',
                wrapper_first: 'vf-radio-tabs-first',
                wrapper_first_sm: 'vf-radio-tabs-first-sm',
                wrapper_first_md: '',
                wrapper_first_lg: 'vf-radio-tabs-first-lg',
                wrapper_last: 'vf-radio-tabs-last',
                wrapper_last_sm: 'vf-radio-tabs-last-sm',
                wrapper_last_md: '',
                wrapper_last_lg: 'vf-radio-tabs-last-lg',
                wrapper_selected: 'vf-radio-tabs-selected',
                wrapper_unselected: 'vf-radio-tabs-unselected',
                wrapper_disabled: 'vf-radio-tabs-disabled',
                wrapper_sm: 'vf-radio-tabs-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radio-tabs-lg',
                input: 'vf-radio-tabs-input',
                text: '',
                $wrapper: (classes, { index: index, items: items, el$: el$, value: value, isDisabled: isDisabled, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        index < Object.keys(items).length - 1 ? classes.wrapper_not_last : null,
                        index === 0 ? classes.wrapper_first : null,
                        index === Object.keys(items).length - 1 ? classes.wrapper_last : null,
                        el$.value == value ? classes.wrapper_selected : classes.wrapper_unselected,
                        isDisabled ? classes.wrapper_disabled : null
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$3 = "/* Some styles are contained in Vueform.vue & RadiogroupElement.vue */\n\n.vf-radio-tabs-container {\n  display: flex;\n  cursor: pointer;\n}\n\n.vf-radio-tabs {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-style: solid;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-color: var(--vf-border-color-input);\n  padding: var(--vf-py-group-tabs) var(--vf-px-group-tabs);\n  width: 100%;\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-radio-tabs.vf-radio-tabs-not-last {\n  border-right: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-first {\n  border-radius: var(--vf-radius-input);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-first.vf-radio-tabs-first-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-first.vf-radio-tabs-first-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-last {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-last.vf-radio-tabs-last-sm {\n  border-radius: var(--vf-radius-input-sm);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-last.vf-radio-tabs-last-lg {\n  border-radius: var(--vf-radius-input-lg);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.vf-radio-tabs.vf-radio-tabs-selected {\n  background-color: var(--vf-primary);\n  border-color: rgba(0, 0, 0, 0.15);\n  color: var(--vf-color-on-primary);\n}\n\n.vf-radio-tabs.vf-radio-tabs-unselected {\n  border-color: var(--vf-border-color-input);\n}\n\n.vf-radio-tabs.vf-radio-tabs-unselected:hover:not(.vf-radio-tabs-disabled) {\n  background-color: var(--vf-bg-input-hover);\n  color: var(--vf-color-input-hover);\n}\n\n.vf-radio-tabs.vf-radio-tabs-disabled {\n  opacity: 0.5;\n}\n\n.vf-radio-tabs.vf-radio-tabs-sm {\n  padding: var(--vf-py-group-tabs-sm) var(--vf-px-group-tabs-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-radio-tabs.vf-radio-tabs-lg {\n  padding: var(--vf-py-group-tabs-lg) var(--vf-px-group-tabs-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-radio-tabs-input {\n  display: none;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$3);
$741c336afc2dfa06$export$6bc195358ee4baf2.__file = "themes/vueform/templates/elements/partials/RadiogroupRadio_tabs.vue";
var $741c336afc2dfa06$var$script$5 = {
    name: 'RadiogroupRadio_tabs',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
                input: '',
                text_wrapper: '',
                text: '',
                description: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$2 = [
    "value",
    "name",
    "id",
    "disabled"
];
const $741c336afc2dfa06$var$_hoisted_2 = [
    "innerHTML"
];
const $741c336afc2dfa06$var$_hoisted_3 = [
    "innerHTML"
];
function $741c336afc2dfa06$var$render$2(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("label", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.renderSlot)(_ctx.$slots, "default", (0, $ani5R.mergeProps)({
            name: _ctx.name
        }, {
            classes: _ctx.classes,
            isDisabled: _ctx.isDisabled,
            id: _ctx.id,
            item: _ctx.item,
            value: _ctx.value,
            items: _ctx.items,
            index: _ctx.index
        }), ()=>[
                (0, $ani5R.createElementVNode)("div", {
                    class: (0, $X5A94.normalizeClass)(_ctx.classes.wrapper)
                }, [
                    (0, $ani5R.withDirectives)((0, $ani5R.createElementVNode)("input", (0, $ani5R.mergeProps)({
                        type: "radio",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.el$.model = $event)
                    }, _ctx.attrs, {
                        value: _ctx.value,
                        class: _ctx.classes.input,
                        name: _ctx.name,
                        id: _ctx.id,
                        disabled: _ctx.isDisabled
                    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$2), [
                        [
                            (0, $dDLnc.vModelRadio),
                            _ctx.el$.model
                        ]
                    ]),
                    (0, $ani5R.createElementVNode)("div", {
                        class: (0, $X5A94.normalizeClass)(_ctx.classes.text_wrapper)
                    }, [
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.text),
                            innerHTML: _ctx.item.label
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_2),
                        (0, $ani5R.createElementVNode)("div", {
                            class: (0, $X5A94.normalizeClass)(_ctx.classes.description),
                            innerHTML: _ctx.item.description
                        }, null, 10 /* CLASS, PROPS */ , $741c336afc2dfa06$var$_hoisted_3)
                    ], 2 /* CLASS */ )
                ], 2 /* CLASS */ )
            ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$5.render = $741c336afc2dfa06$var$render$2;
$741c336afc2dfa06$var$script$5.__file = "themes/blank/templates/elements/partials/RadiogroupRadio_blocks.vue";
var $741c336afc2dfa06$export$2a40e3c673e9086b = {
    name: 'RadiogroupRadio_blocks',
    render: $741c336afc2dfa06$var$script$5.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: 'vf-radio-blocks-container',
                container_sm: 'vf-radio-blocks-container-sm',
                container_md: '',
                container_lg: 'vf-radio-blocks-container-lg',
                wrapper: 'vf-radio-blocks',
                wrapper_not_last: 'vf-radio-blocks-not-last',
                wrapper_first: 'vf-radio-blocks-first',
                wrapper_first_sm: 'vf-radio-blocks-first-sm',
                wrapper_first_md: '',
                wrapper_first_lg: 'vf-radio-blocks-first-lg',
                wrapper_last: 'vf-radio-blocks-last',
                wrapper_last_sm: 'vf-radio-blocks-last-sm',
                wrapper_last_md: '',
                wrapper_last_lg: 'vf-radio-blocks-last-lg',
                wrapper_selected: 'vf-radio-blocks-selected',
                wrapper_unselected: 'vf-radio-blocks-unselected',
                wrapper_disabled: 'vf-radio-blocks-disabled',
                wrapper_sm: 'vf-radio-blocks-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-radio-blocks-lg',
                input: 'vf-radio',
                input_enabled: '',
                input_disabled: '',
                input_sm: 'vf-radio-sm',
                input_md: '',
                input_lg: 'vf-radio-lg',
                text_wrapper: 'vf-radio-blocks-text-wrapper',
                text: 'vf-radio-blocks-text',
                description: 'vf-radio-blocks-description',
                description_sm: 'vf-radio-blocks-description-sm',
                description_md: '',
                description_lg: 'vf-radio-blocks-description-lg',
                $container: (classes, { Size: Size })=>[
                        classes.container,
                        classes[`container_${Size}`]
                    ],
                $wrapper: (classes, { index: index, items: items, el$: el$, value: value, isDisabled: isDisabled, Size: Size })=>[
                        classes.wrapper,
                        classes[`wrapper_${Size}`],
                        index < Object.keys(items).length - 1 ? classes.wrapper_not_last : null,
                        index === 0 ? classes.wrapper_first : null,
                        index === 0 ? classes[`wrapper_first_${Size}`] : null,
                        index === Object.keys(items).length - 1 ? classes.wrapper_last : null,
                        index === Object.keys(items).length - 1 ? classes[`wrapper_last_${Size}`] : null,
                        el$.value == value ? classes.wrapper_selected : classes.wrapper_unselected,
                        isDisabled ? classes.wrapper_disabled : null
                    ],
                $input: (classes, { isDisabled: isDisabled, Size: Size })=>[
                        classes.input,
                        classes[`input_${Size}`],
                        isDisabled ? classes.input_disabled : classes.input_enabled
                    ],
                $description: (classes, { Size: Size })=>[
                        classes.description,
                        classes[`description_${Size}`]
                    ]
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$2 = "/* Some styles are contained in Vueform.vue & RadiogroupElement.vue */\n\n.vf-radio-blocks-container {\n  display: flex;\n  align-items: flex-start;\n  cursor: pointer;\n  background: var(--vf-bg-input);\n  border-radius: var(--vf-radius-large);\n}\n\n.vf-radio-blocks-container .vf-radio {\n  margin-top: 0;\n}\n\n.vf-radio-blocks-container.vf-radio-blocks-container-sm {\n  border-radius: var(--vf-radius-large-sm);\n}\n\n.vf-radio-blocks-container.vf-radio-blocks-container-lg {\n  border-radius: var(--vf-radius-large-lg);\n}\n\n.vf-radio-blocks {\n  display: flex;\n  align-items: center;\n  border-style: solid;\n  border-width: var(--vf-border-width-input-t) var(--vf-border-width-input-r) var(--vf-border-width-input-b) var(--vf-border-width-input-l);\n  border-color: var(--vf-border-color-input);\n  width: 100%;\n  padding: var(--vf-py-group-blocks) var(--vf-px-group-blocks);\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  font-size: var(--vf-font-size);\n  line-height: var(--vf-line-height);\n  letter-spacing: var(--vf-letter-spacing);\n}\n\n.vf-radio-blocks.vf-radio-blocks-not-last {\n  border-bottom-width: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-first {\n  border-radius: var(--vf-radius-large);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-first.vf-radio-blocks-first-sm {\n  border-radius: var(--vf-radius-large-sm);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-first.vf-radio-blocks-first-lg {\n  border-radius: var(--vf-radius-large-lg);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-last {\n  border-radius: var(--vf-radius-large);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-last.vf-radio-blocks-last-sm {\n  border-radius: var(--vf-radius-large-sm);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-last.vf-radio-blocks-last-lg {\n  border-radius: var(--vf-radius-large-lg);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.vf-radio-blocks.vf-radio-blocks-selected {\n  background-color: var(--vf-bg-selected);\n}\n\n.vf-radio-blocks.vf-radio-blocks-disabled {\n  opacity: 0.5;\n}\n\n.vf-radio-blocks.vf-radio-blocks-sm {\n  padding: var(--vf-py-group-blocks-sm) var(--vf-px-group-blocks-sm);\n  font-size: var(--vf-font-size-sm);\n  line-height: var(--vf-line-height-sm);\n  letter-spacing: var(--vf-letter-spacing-sm);\n}\n\n.vf-radio-blocks.vf-radio-blocks-lg {\n  padding: var(--vf-py-group-blocks-lg) var(--vf-px-group-blocks-lg);\n  font-size: var(--vf-font-size-lg);\n  line-height: var(--vf-line-height-lg);\n  letter-spacing: var(--vf-letter-spacing-lg);\n}\n\n.vf-radio-blocks-text-wrapper {\n  margin-left: 0.5rem;\n}\n\n.vf-radio-blocks-description {\n  color: var(--vf-color-muted);\n  font-size: var(--vf-font-size-small);\n  line-height: var(--vf-line-height-small);\n  letter-spacing: var(--vf-letter-spacing-small);\n  margin-top: -0.125rem;\n}\n\n.vf-radio-blocks-description.vf-radio-blocks-description-sm {\n  font-size: var(--vf-font-size-small-sm);\n  line-height: var(--vf-line-height-small-sm);\n  letter-spacing: var(--vf-letter-spacing-small-sm);\n  margin-top: -0.125rem;\n}\n\n.vf-radio-blocks-description.vf-radio-blocks-description-lg {\n  font-size: var(--vf-font-size-small-lg);\n  line-height: var(--vf-line-height-small-lg);\n  letter-spacing: var(--vf-letter-spacing-small-lg);\n  margin-top: -0.125rem;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$2);
$741c336afc2dfa06$export$2a40e3c673e9086b.__file = "themes/vueform/templates/elements/partials/RadiogroupRadio_blocks.vue";
var $741c336afc2dfa06$var$script$3 = {
    name: 'DatepickerWrapper',
    data () {
        return {
            merge: true,
            defaultClasses: {
                datepicker: '',
                calendarContainer: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1$1 = [
    "id",
    "placeholder"
];
function $741c336afc2dfa06$var$render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("input", (0, $ani5R.mergeProps)({
        type: "text",
        class: _ctx.classes.datepicker,
        id: _ctx.id,
        placeholder: _ctx.placeholder
    }, _ctx.attrs, {
        ref: "input"
    }), null, 16 /* FULL_PROPS */ , $741c336afc2dfa06$var$_hoisted_1$1);
}
$741c336afc2dfa06$var$script$3.render = $741c336afc2dfa06$var$render$1;
$741c336afc2dfa06$var$script$3.__file = "themes/blank/templates/wrappers/DatepickerWrapper.vue";
var $741c336afc2dfa06$export$f26058492132933c = {
    name: 'DatepickerWrapper',
    render: $741c336afc2dfa06$var$script$3.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                datepicker: '',
                calendarContainer: 'flatpickr-calendar-container'
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z$1 = ".flatpickr-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.flatpickr-calendar {\n  background: transparent;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  box-sizing: border-box;\n  touch-action: manipulation;\n  box-shadow: 0 3px 13px rgba(0, 0, 0, 0.08);\n  color: var(--vf-color-input);\n}\n\n.flatpickr-calendar.open,\n.flatpickr-calendar.inline {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n}\n\n.flatpickr-calendar.open {\n  display: inline-block;\n  z-index: 999;\n}\n\n.flatpickr-calendar.animate.open {\n  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.flatpickr-calendar.inline {\n  display: block;\n  position: relative;\n  top: 2px;\n}\n\n.flatpickr-calendar.rightMost {\n  left: auto;\n  right: 0;\n}\n\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n  box-shadow: none !important;\n}\n\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n  box-shadow: -2px 0 0 var(--vf-bg-selected), 5px 0 0 var(--vf-bg-selected);\n}\n\n.flatpickr-calendar .hasWeeks .dayContainer,\n.flatpickr-calendar .hasTime .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-left: 0;\n}\n\n.flatpickr-calendar.hasTime .flatpickr-time {\n  height: 40px;\n  border-top: 1px solid var(--vf-border-color-input);\n}\n\n.flatpickr-calendar.hasTime .flatpickr-innerContainer {\n  border-bottom: 0;\n}\n\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  height: auto;\n}\n\n.flatpickr-calendar:before,\n.flatpickr-calendar:after {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  left: 22px;\n}\n\n.flatpickr-calendar.rightMost:before,\n.flatpickr-calendar.arrowRight:before,\n.flatpickr-calendar.rightMost:after,\n.flatpickr-calendar.arrowRight:after {\n  left: auto;\n  right: 22px;\n}\n\n.flatpickr-calendar.arrowCenter:before,\n.flatpickr-calendar.arrowCenter:after {\n  left: 50%;\n  right: 50%;\n}\n\n.flatpickr-calendar:before {\n  border-width: 5px;\n  margin: 0 -5px;\n  box-sizing: border-box;\n}\n\n.flatpickr-calendar:after {\n  border-width: 4px;\n  margin: 0 -4px;\n  box-sizing: border-box;\n}\n\n.flatpickr-calendar.arrowTop:before,\n.flatpickr-calendar.arrowTop:after {\n  bottom: 100%;\n}\n\n.flatpickr-calendar.arrowTop:before {\n  border-bottom-color: var(--vf-bg-date-head);\n  box-sizing: border-box;\n}\n\n.flatpickr-calendar.arrowTop:after {\n  border-bottom-color: var(--vf-bg-date-head);\n  box-sizing: border-box;\n}\n\n.flatpickr-calendar.arrowBottom:before,\n.flatpickr-calendar.arrowBottom:after {\n  top: 100%;\n}\n\n.flatpickr-calendar.arrowBottom:before {\n  border-top-color: var(--vf-bg-date-head);\n}\n\n.flatpickr-calendar.arrowBottom:after {\n  border-top-color: var(--vf-bg-date-head);\n}\n\n.flatpickr-calendar:focus {\n  outline: 0;\n}\n\n.flatpickr-wrapper {\n  position: relative;\n  display: flex;\n}\n\n.flatpickr-months {\n  display: flex;\n}\n\n.flatpickr-months .flatpickr-month {\n  border-radius: 5px 5px 0 0;\n  background: var(--vf-bg-date-head);\n  color: var(--vf-color-date-head);\n  fill: var(--vf-color-date-head);\n  height: 34px;\n  line-height: 1;\n  text-align: center;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  overflow: hidden;\n  flex: 1;\n}\n\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  text-decoration: none;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  height: 34px;\n  padding: 10px;\n  z-index: 1;\n  color: var(--vf-color-date-head);\n  fill: var(--vf-color-date-head);\n}\n\n.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,\n.flatpickr-months .flatpickr-next-month.flatpickr-disabled {\n  display: none;\n}\n\n.flatpickr-months .flatpickr-prev-month i,\n.flatpickr-months .flatpickr-next-month i {\n  position: relative;\n}\n\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n  left: 0;\n}\n\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n  right: 0;\n}\n\n.flatpickr-months .flatpickr-prev-month:hover,\n.flatpickr-months .flatpickr-next-month:hover {\n  color: var(--vf-color-date-head);\n}\n\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  opacity: 1;\n}\n\n.flatpickr-months .flatpickr-prev-month svg,\n.flatpickr-months .flatpickr-next-month svg {\n  width: 14px;\n  height: 14px;\n  opacity: 0.7;\n  display: block;\n}\n\n.flatpickr-months .flatpickr-prev-month svg path,\n.flatpickr-months .flatpickr-next-month svg path {\n  transition: fill 0.1s;\n  fill: inherit;\n}\n\n.numInputWrapper {\n  position: relative;\n  height: auto;\n}\n\n.numInputWrapper input,\n.numInputWrapper span {\n  display: inline-block;\n}\n\n.numInputWrapper input {\n  width: 100%;\n}\n\n.numInputWrapper input::-ms-clear {\n  display: none;\n}\n\n.numInputWrapper input::-webkit-outer-spin-button,\n.numInputWrapper input::-webkit-inner-spin-button {\n  margin: 0;\n  -webkit-appearance: none;\n}\n\n.numInputWrapper span {\n  position: absolute;\n  right: 0;\n  width: 14px;\n  padding: 0 4px 0 2px;\n  height: 50%;\n  line-height: 50%;\n  opacity: 0;\n  cursor: pointer;\n  border: 1px solid var(--vf-border-color-input);\n  box-sizing: border-box;\n}\n\n.numInputWrapper span:hover {\n  background: var(--vf-bg-selected);\n}\n\n.numInputWrapper span:active {\n  background: var(--vf-bg-selected);\n}\n\n.numInputWrapper span:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n}\n\n.numInputWrapper span.arrowUp {\n  top: 0;\n  border-bottom: 0;\n}\n\n.numInputWrapper span.arrowUp:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid var(--vf-color-input);\n  top: 26%;\n  box-sizing: border-box;\n}\n\n.numInputWrapper span.arrowDown {\n  top: 50%;\n}\n\n.numInputWrapper span.arrowDown:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid var(--vf-color-input);\n  top: 40%;\n  box-sizing: border-box;\n}\n\n.numInputWrapper span svg {\n  width: inherit;\n  height: auto;\n}\n\n.numInputWrapper span svg path {\n  fill: var(--vf-color-input);\n}\n\n.numInputWrapper:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.numInputWrapper:hover span {\n  opacity: 1;\n}\n\n.flatpickr-current-month {\n  font-size: 135%;\n  line-height: inherit;\n  font-weight: 300;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 7.48px 0 0 0;\n  line-height: 1;\n  height: 34px;\n  display: inline-block;\n  text-align: center;\n  transform: translate3d(0px, 0px, 0px);\n}\n\n.flatpickr-current-month span.cur-month {\n  font-family: inherit;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  margin-left: 0.5ch;\n  padding: 0;\n}\n\n.flatpickr-current-month span.cur-month:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.flatpickr-current-month .numInputWrapper {\n  width: 6ch;\n  width: 7ch\\0 ;\n  display: inline-block;\n}\n\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: var(--vf-color-date-head);\n}\n\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: var(--vf-color-date-head);\n}\n\n.flatpickr-current-month input.cur-year {\n  background: transparent;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: text;\n  padding: 0 0 0 0.5ch;\n  margin: 0;\n  display: inline-block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  line-height: inherit;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  vertical-align: initial;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.flatpickr-current-month input.cur-year:focus {\n  outline: 0;\n}\n\n.flatpickr-current-month input.cur-year[disabled],\n.flatpickr-current-month input.cur-year[disabled]:hover {\n  font-size: 100%;\n  color: var(--vf-gray-300);\n  background: transparent;\n  pointer-events: none;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months {\n  appearance: menulist;\n  background: var(--vf-bg-date-head);\n  border: none;\n  border-radius: 0;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 300;\n  height: auto;\n  line-height: inherit;\n  margin: -1px 0 0 0;\n  outline: none;\n  padding: 0 0 0 0.5ch;\n  position: relative;\n  vertical-align: initial;\n  -webkit-box-sizing: border-box;\n  -webkit-appearance: menulist;\n  -moz-appearance: menulist;\n  width: auto;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months:focus,\n.flatpickr-current-month .flatpickr-monthDropdown-months:active {\n  outline: none;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n  background-color: var(--vf-bg-date-head);\n  outline: none;\n  padding: 0;\n}\n\n.flatpickr-weekdays {\n  background: var(--vf-bg-date-head);\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  height: 28px;\n}\n\n.flatpickr-weekdays .flatpickr-weekdaycontainer {\n  display: flex;\n  flex: 1;\n}\n\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 90%;\n  background: var(--vf-bg-date-head);\n  color: var(--vf-color-date-head);\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  flex: 1;\n  font-weight: bolder;\n}\n\n.dayContainer,\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  width: 307.875px;\n  background-color: var(--vf-bg-input);\n}\n\n.flatpickr-days:focus {\n  outline: 0;\n}\n\n.dayContainer {\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  box-sizing: border-box;\n  display: inline-block;\n  display: flex;\n  flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  justify-content: space-around;\n  transform: translate3d(0px, 0px, 0px);\n  opacity: 1;\n}\n\n.dayContainer + .dayContainer {\n  box-shadow: -1px 0 0 var(--vf-gray-200);\n}\n\n.flatpickr-day {\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 150px;\n  box-sizing: border-box;\n  cursor: pointer;\n  font-weight: 400;\n  width: 14.2857143%;\n  flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 38px;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  justify-content: center;\n  text-align: center;\n}\n\n.flatpickr-day.inRange,\n.flatpickr-day.prevMonthDay.inRange,\n.flatpickr-day.nextMonthDay.inRange,\n.flatpickr-day.today.inRange,\n.flatpickr-day.prevMonthDay.today.inRange,\n.flatpickr-day.nextMonthDay.today.inRange,\n.flatpickr-day:hover,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.nextMonthDay:hover,\n.flatpickr-day:focus,\n.flatpickr-day.prevMonthDay:focus,\n.flatpickr-day.nextMonthDay:focus {\n  cursor: pointer;\n  outline: 0;\n  background: var(--vf-bg-selected);\n  border-color: var(--vf-bg-selected);\n}\n\n.flatpickr-day.today {\n  border-color: var(--vf-bg-selected);\n}\n\n.flatpickr-day.today:hover,\n.flatpickr-day.today:focus {\n  border-color: var(--vf-bg-selected);\n  background: var(--vf-bg-selected);\n}\n\n.flatpickr-day.selected,\n.flatpickr-day.startRange,\n.flatpickr-day.endRange,\n.flatpickr-day.selected.inRange,\n.flatpickr-day.startRange.inRange,\n.flatpickr-day.endRange.inRange,\n.flatpickr-day.selected:focus,\n.flatpickr-day.startRange:focus,\n.flatpickr-day.endRange:focus,\n.flatpickr-day.selected:hover,\n.flatpickr-day.startRange:hover,\n.flatpickr-day.endRange:hover,\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.startRange.prevMonthDay,\n.flatpickr-day.endRange.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay,\n.flatpickr-day.startRange.nextMonthDay,\n.flatpickr-day.endRange.nextMonthDay {\n  background: var(--vf-primary);\n  box-shadow: none;\n  color: #fff;\n  border-color: var(--vf-primary);\n}\n\n.flatpickr-day.selected.startRange,\n.flatpickr-day.startRange.startRange,\n.flatpickr-day.endRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n\n.flatpickr-day.selected.endRange,\n.flatpickr-day.startRange.endRange,\n.flatpickr-day.endRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)),\n.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  box-shadow: -10px 0 0 var(--vf-primary);\n}\n\n.flatpickr-day.selected.startRange.endRange,\n.flatpickr-day.startRange.startRange.endRange,\n.flatpickr-day.endRange.startRange.endRange {\n  border-radius: 50px;\n}\n\n.flatpickr-day.inRange {\n  border-radius: 0;\n  box-shadow: -5px 0 0 var(--vf-bg-selected), 5px 0 0 var(--vf-bg-selected);\n}\n\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.flatpickr-disabled:hover,\n.flatpickr-day.prevMonthDay,\n.flatpickr-day.nextMonthDay,\n.flatpickr-day.notAllowed,\n.flatpickr-day.notAllowed.prevMonthDay,\n.flatpickr-day.notAllowed.nextMonthDay {\n  color: var(--vf-color-disabled);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.flatpickr-disabled:hover {\n  cursor: not-allowed;\n  color: var(--vf-color-disabled);\n}\n\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  box-shadow: -5px 0 0 var(--vf-primary), 5px 0 0 var(--vf-primary);\n}\n\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n\n.rangeMode .flatpickr-day {\n  margin-top: 1px;\n}\n\n.flatpickr-weekwrapper {\n  float: left;\n}\n\n.flatpickr-weekwrapper .flatpickr-weeks {\n  padding: 0 12px;\n}\n\n.flatpickr-weekwrapper .flatpickr-weekday {\n  float: none;\n  width: 100%;\n  line-height: 28px;\n}\n\n.flatpickr-weekwrapper span.flatpickr-day,\n.flatpickr-weekwrapper span.flatpickr-day:hover {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: var(--vf-gray-300);\n  background: transparent;\n  cursor: default;\n  border: none;\n}\n\n.flatpickr-innerContainer {\n  display: block;\n  display: flex;\n  box-sizing: border-box;\n  overflow: hidden;\n  background: var(--vf-bg-input);\n}\n\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n  background: var(--vf-bg-input);\n  border-radius: 0 0 5px 5px;\n  color: var(--vf-color-input);\n}\n\n.flatpickr-time:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.flatpickr-time .numInputWrapper {\n  flex: 1;\n  width: 40%;\n  height: 40px;\n  float: left;\n}\n\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: var(--vf-color-input);\n  box-sizing: border-box;\n}\n\n.flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-color: var(--vf-color-input);\n  box-sizing: border-box;\n}\n\n.flatpickr-time.hasSeconds .numInputWrapper {\n  width: 26%;\n}\n\n.flatpickr-time.time24hr .numInputWrapper {\n  width: 49%;\n}\n\n.flatpickr-time input {\n  background: transparent;\n  box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: inherit;\n  line-height: inherit;\n  font-size: 14px;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n  color: var(--vf-color-input);\n  background: var(--vf-bg-input);\n}\n\n.flatpickr-time input.flatpickr-hour {\n  font-weight: bold;\n}\n\n.flatpickr-time input.flatpickr-minute,\n.flatpickr-time input.flatpickr-second {\n  font-weight: 400;\n}\n\n.flatpickr-time input:focus {\n  outline: 0;\n  border: 0;\n}\n\n.flatpickr-time .flatpickr-time-separator,\n.flatpickr-time .flatpickr-am-pm {\n  height: inherit;\n  float: left;\n  line-height: inherit;\n  font-weight: bold;\n  width: 2%;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  align-self: center;\n  background: var(--vf-bg-input);\n}\n\n.flatpickr-time .flatpickr-am-pm {\n  outline: 0;\n  width: 18%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 400;\n}\n\n.flatpickr-time input:hover,\n.flatpickr-time .flatpickr-am-pm:hover,\n.flatpickr-time input:focus,\n.flatpickr-time .flatpickr-am-pm:focus {\n  background: var(--vf-bg-selected);\n}\n\n.flatpickr-input[readonly] {\n  cursor: pointer;\n}\n\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\nspan.flatpickr-day.selected {\n  font-weight: bold;\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z$1);
$741c336afc2dfa06$export$f26058492132933c.__file = "themes/vueform/templates/wrappers/DatepickerWrapper.vue";
/*
Trix 2.1.12
Copyright © 2024 37signals, LLC
 */ var $741c336afc2dfa06$var$t = "2.1.12";
const $741c336afc2dfa06$var$e = "[data-trix-attachment]", $741c336afc2dfa06$var$i = {
    preview: {
        presentation: "gallery",
        caption: {
            name: !0,
            size: !0
        }
    },
    file: {
        caption: {
            size: !0
        }
    }
}, $741c336afc2dfa06$var$n = {
    default: {
        tagName: "div",
        parse: !1
    },
    quote: {
        tagName: "blockquote",
        nestable: !0
    },
    heading1: {
        tagName: "h1",
        terminal: !0,
        breakOnReturn: !0,
        group: !1
    },
    code: {
        tagName: "pre",
        terminal: !0,
        htmlAttributes: [
            "language"
        ],
        text: {
            plaintext: !0
        }
    },
    bulletList: {
        tagName: "ul",
        parse: !1
    },
    bullet: {
        tagName: "li",
        listAttribute: "bulletList",
        group: !1,
        nestable: !0,
        test (t) {
            return $741c336afc2dfa06$var$r(t.parentNode) === $741c336afc2dfa06$var$n[this.listAttribute].tagName;
        }
    },
    numberList: {
        tagName: "ol",
        parse: !1
    },
    number: {
        tagName: "li",
        listAttribute: "numberList",
        group: !1,
        nestable: !0,
        test (t) {
            return $741c336afc2dfa06$var$r(t.parentNode) === $741c336afc2dfa06$var$n[this.listAttribute].tagName;
        }
    },
    attachmentGallery: {
        tagName: "div",
        exclusive: !0,
        terminal: !0,
        parse: !1,
        group: !1
    }
}, $741c336afc2dfa06$var$r = (t)=>{
    var e;
    return null == t || null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase();
}, $741c336afc2dfa06$var$o = navigator.userAgent.match(/android\s([0-9]+.*Chrome)/i), $741c336afc2dfa06$var$s = $741c336afc2dfa06$var$o && parseInt($741c336afc2dfa06$var$o[1]);
var $741c336afc2dfa06$var$a = {
    composesExistingText: /Android.*Chrome/.test(navigator.userAgent),
    recentAndroid: $741c336afc2dfa06$var$s && $741c336afc2dfa06$var$s > 12,
    samsungAndroid: $741c336afc2dfa06$var$s && navigator.userAgent.match(/Android.*SM-/),
    forcesObjectResizing: /Trident.*rv:11/.test(navigator.userAgent),
    supportsInputEvents: "undefined" != typeof InputEvent && [
        "data",
        "getTargetRanges",
        "inputType"
    ].every((t)=>t in InputEvent.prototype)
}, $741c336afc2dfa06$var$l = {
    ADD_ATTR: [
        "language"
    ],
    SAFE_FOR_XML: !1,
    RETURN_DOM: !0
}, $741c336afc2dfa06$var$c = {
    attachFiles: "Attach Files",
    bold: "Bold",
    bullets: "Bullets",
    byte: "Byte",
    bytes: "Bytes",
    captionPlaceholder: "Add a caption\u2026",
    code: "Code",
    heading1: "Heading",
    indent: "Increase Level",
    italic: "Italic",
    link: "Link",
    numbers: "Numbers",
    outdent: "Decrease Level",
    quote: "Quote",
    redo: "Redo",
    remove: "Remove",
    strike: "Strikethrough",
    undo: "Undo",
    unlink: "Unlink",
    url: "URL",
    urlPlaceholder: "Enter a URL\u2026",
    GB: "GB",
    KB: "KB",
    MB: "MB",
    PB: "PB",
    TB: "TB"
};
const $741c336afc2dfa06$var$u = [
    $741c336afc2dfa06$var$c.bytes,
    $741c336afc2dfa06$var$c.KB,
    $741c336afc2dfa06$var$c.MB,
    $741c336afc2dfa06$var$c.GB,
    $741c336afc2dfa06$var$c.TB,
    $741c336afc2dfa06$var$c.PB
];
var $741c336afc2dfa06$var$h = {
    prefix: "IEC",
    precision: 2,
    formatter (t) {
        switch(t){
            case 0:
                return "0 ".concat($741c336afc2dfa06$var$c.bytes);
            case 1:
                return "1 ".concat($741c336afc2dfa06$var$c.byte);
            default:
                let e;
                "SI" === this.prefix ? e = 1e3 : "IEC" === this.prefix && (e = 1024);
                const i = Math.floor(Math.log(t) / Math.log(e)), n = (t / Math.pow(e, i)).toFixed(this.precision).replace(/0*$/, "").replace(/\.$/, "");
                return "".concat(n, " ").concat($741c336afc2dfa06$var$u[i]);
        }
    }
};
const $741c336afc2dfa06$var$d = "\ufeff", $741c336afc2dfa06$var$g = "\xa0", $741c336afc2dfa06$var$m = function(t) {
    for(const e in t){
        const i = t[e];
        this[e] = i;
    }
    return this;
}, $741c336afc2dfa06$var$p = document.documentElement, $741c336afc2dfa06$var$f = $741c336afc2dfa06$var$p.matches, $741c336afc2dfa06$var$b = function(t) {
    let { onElement: e, matchingSelector: i, withCallback: n, inPhase: r, preventDefault: o, times: s } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const a = e || $741c336afc2dfa06$var$p, l = i, c = "capturing" === r, u = function(t) {
        null != s && 0 == --s && u.destroy();
        const e = $741c336afc2dfa06$var$y(t.target, {
            matchingSelector: l
        });
        null != e && (null == n || n.call(e, t, e), o && t.preventDefault());
    };
    return u.destroy = ()=>a.removeEventListener(t, u, c), a.addEventListener(t, u, c), u;
}, $741c336afc2dfa06$var$v = function(t) {
    let { onElement: e, bubbles: i, cancelable: n, attributes: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const o = null != e ? e : $741c336afc2dfa06$var$p;
    i = !1 !== i, n = !1 !== n;
    const s = document.createEvent("Events");
    return s.initEvent(t, i, n), null != r && $741c336afc2dfa06$var$m.call(s, r), o.dispatchEvent(s);
}, $741c336afc2dfa06$var$A = function(t, e) {
    if (1 === (null == t ? void 0 : t.nodeType)) return $741c336afc2dfa06$var$f.call(t, e);
}, $741c336afc2dfa06$var$y = function(t) {
    let { matchingSelector: e, untilNode: i } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    for(; t && t.nodeType !== Node.ELEMENT_NODE;)t = t.parentNode;
    if (null != t) {
        if (null == e) return t;
        if (t.closest && null == i) return t.closest(e);
        for(; t && t !== i;){
            if ($741c336afc2dfa06$var$A(t, e)) return t;
            t = t.parentNode;
        }
    }
}, $741c336afc2dfa06$var$x = (t)=>document.activeElement !== t && $741c336afc2dfa06$var$C(t, document.activeElement), $741c336afc2dfa06$var$C = function(t, e) {
    if (t && e) for(; e;){
        if (e === t) return !0;
        e = e.parentNode;
    }
}, $741c336afc2dfa06$var$E = function(t) {
    var e;
    if (null === (e = t) || void 0 === e || !e.parentNode) return;
    let i = 0;
    for(t = t.previousSibling; t;)i++, t = t.previousSibling;
    return i;
}, $741c336afc2dfa06$var$S = (t)=>{
    var e;
    return null == t || null === (e = t.parentNode) || void 0 === e ? void 0 : e.removeChild(t);
}, $741c336afc2dfa06$var$R = function(t) {
    let { onlyNodesOfType: e, usingFilter: i, expandEntityReferences: n } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const r = (()=>{
        switch(e){
            case "element":
                return NodeFilter.SHOW_ELEMENT;
            case "text":
                return NodeFilter.SHOW_TEXT;
            case "comment":
                return NodeFilter.SHOW_COMMENT;
            default:
                return NodeFilter.SHOW_ALL;
        }
    })();
    return document.createTreeWalker(t, r, null != i ? i : null, !0 === n);
}, $741c336afc2dfa06$var$k = (t)=>{
    var e;
    return null == t || null === (e = t.tagName) || void 0 === e ? void 0 : e.toLowerCase();
}, $741c336afc2dfa06$var$T = function(t) {
    let e, i, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    "object" == typeof t ? (n = t, t = n.tagName) : n = {
        attributes: n
    };
    const r = document.createElement(t);
    if (null != n.editable && (null == n.attributes && (n.attributes = {}), n.attributes.contenteditable = n.editable), n.attributes) for(e in n.attributes)i = n.attributes[e], r.setAttribute(e, i);
    if (n.style) for(e in n.style)i = n.style[e], r.style[e] = i;
    if (n.data) for(e in n.data)i = n.data[e], r.dataset[e] = i;
    return n.className && n.className.split(" ").forEach((t)=>{
        r.classList.add(t);
    }), n.textContent && (r.textContent = n.textContent), n.childNodes && [].concat(n.childNodes).forEach((t)=>{
        r.appendChild(t);
    }), r;
};
let $741c336afc2dfa06$var$w;
const $741c336afc2dfa06$var$L = function() {
    if (null != $741c336afc2dfa06$var$w) return $741c336afc2dfa06$var$w;
    $741c336afc2dfa06$var$w = [];
    for(const t in $741c336afc2dfa06$var$n){
        const e = $741c336afc2dfa06$var$n[t];
        e.tagName && $741c336afc2dfa06$var$w.push(e.tagName);
    }
    return $741c336afc2dfa06$var$w;
}, $741c336afc2dfa06$var$D = (t)=>$741c336afc2dfa06$var$I(null == t ? void 0 : t.firstChild), $741c336afc2dfa06$var$N = function(t) {
    let { strict: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        strict: !0
    };
    return e ? $741c336afc2dfa06$var$I(t) : $741c336afc2dfa06$var$I(t) || !$741c336afc2dfa06$var$I(t.firstChild) && function(t) {
        return $741c336afc2dfa06$var$L().includes($741c336afc2dfa06$var$k(t)) && !$741c336afc2dfa06$var$L().includes($741c336afc2dfa06$var$k(t.firstChild));
    }(t);
}, $741c336afc2dfa06$var$I = (t)=>$741c336afc2dfa06$var$O(t) && "block" === (null == t ? void 0 : t.data), $741c336afc2dfa06$var$O = (t)=>(null == t ? void 0 : t.nodeType) === Node.COMMENT_NODE, $741c336afc2dfa06$var$F = function(t) {
    let { name: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (t) return $741c336afc2dfa06$var$B(t) ? t.data === $741c336afc2dfa06$var$d ? !e || t.parentNode.dataset.trixCursorTarget === e : void 0 : $741c336afc2dfa06$var$F(t.firstChild);
}, $741c336afc2dfa06$var$P = (t)=>$741c336afc2dfa06$var$A(t, $741c336afc2dfa06$var$e), $741c336afc2dfa06$var$M = (t)=>$741c336afc2dfa06$var$B(t) && "" === (null == t ? void 0 : t.data), $741c336afc2dfa06$var$B = (t)=>(null == t ? void 0 : t.nodeType) === Node.TEXT_NODE, $741c336afc2dfa06$var$_ = {
    level2Enabled: !0,
    getLevel () {
        return this.level2Enabled && $741c336afc2dfa06$var$a.supportsInputEvents ? 2 : 0;
    },
    pickFiles (t) {
        const e = $741c336afc2dfa06$var$T("input", {
            type: "file",
            multiple: !0,
            hidden: !0,
            id: this.fileInputId
        });
        e.addEventListener("change", ()=>{
            t(e.files), $741c336afc2dfa06$var$S(e);
        }), $741c336afc2dfa06$var$S(document.getElementById(this.fileInputId)), document.body.appendChild(e), e.click();
    }
};
var $741c336afc2dfa06$var$j = {
    removeBlankTableCells: !1,
    tableCellSeparator: " | ",
    tableRowSeparator: "\n"
}, $741c336afc2dfa06$var$W = {
    bold: {
        tagName: "strong",
        inheritable: !0,
        parser (t) {
            const e = window.getComputedStyle(t);
            return "bold" === e.fontWeight || e.fontWeight >= 600;
        }
    },
    italic: {
        tagName: "em",
        inheritable: !0,
        parser: (t)=>"italic" === window.getComputedStyle(t).fontStyle
    },
    href: {
        groupTagName: "a",
        parser (t) {
            const i = "a:not(".concat($741c336afc2dfa06$var$e, ")"), n = t.closest(i);
            if (n) return n.getAttribute("href");
        }
    },
    strike: {
        tagName: "del",
        inheritable: !0
    },
    frozen: {
        style: {
            backgroundColor: "highlight"
        }
    }
}, $741c336afc2dfa06$var$U = {
    getDefaultHTML: ()=>'<div class="trix-button-row">\n      <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-bold" data-trix-attribute="bold" data-trix-key="b" title="'.concat($741c336afc2dfa06$var$c.bold, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.bold, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="').concat($741c336afc2dfa06$var$c.italic, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.italic, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-strike" data-trix-attribute="strike" title="').concat($741c336afc2dfa06$var$c.strike, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.strike, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-link" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="').concat($741c336afc2dfa06$var$c.link, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.link, '</button>\n      </span>\n\n      <span class="trix-button-group trix-button-group--block-tools" data-trix-button-group="block-tools">\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-heading-1" data-trix-attribute="heading1" title="').concat($741c336afc2dfa06$var$c.heading1, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.heading1, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-quote" data-trix-attribute="quote" title="').concat($741c336afc2dfa06$var$c.quote, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.quote, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-code" data-trix-attribute="code" title="').concat($741c336afc2dfa06$var$c.code, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.code, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="').concat($741c336afc2dfa06$var$c.bullets, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.bullets, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="').concat($741c336afc2dfa06$var$c.numbers, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.numbers, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-decrease-nesting-level" data-trix-action="decreaseNestingLevel" title="').concat($741c336afc2dfa06$var$c.outdent, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.outdent, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-increase-nesting-level" data-trix-action="increaseNestingLevel" title="').concat($741c336afc2dfa06$var$c.indent, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.indent, '</button>\n      </span>\n\n      <span class="trix-button-group trix-button-group--file-tools" data-trix-button-group="file-tools">\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-attach" data-trix-action="attachFiles" title="').concat($741c336afc2dfa06$var$c.attachFiles, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.attachFiles, '</button>\n      </span>\n\n      <span class="trix-button-group-spacer"></span>\n\n      <span class="trix-button-group trix-button-group--history-tools" data-trix-button-group="history-tools">\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-undo" data-trix-action="undo" data-trix-key="z" title="').concat($741c336afc2dfa06$var$c.undo, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.undo, '</button>\n        <button type="button" class="trix-button trix-button--icon trix-button--icon-redo" data-trix-action="redo" data-trix-key="shift+z" title="').concat($741c336afc2dfa06$var$c.redo, '" tabindex="-1">').concat($741c336afc2dfa06$var$c.redo, '</button>\n      </span>\n    </div>\n\n    <div class="trix-dialogs" data-trix-dialogs>\n      <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">\n        <div class="trix-dialog__link-fields">\n          <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="').concat($741c336afc2dfa06$var$c.urlPlaceholder, '" aria-label="').concat($741c336afc2dfa06$var$c.url, '" data-trix-validate-href required data-trix-input>\n          <div class="trix-button-group">\n            <input type="button" class="trix-button trix-button--dialog" value="').concat($741c336afc2dfa06$var$c.link, '" data-trix-method="setAttribute">\n            <input type="button" class="trix-button trix-button--dialog" value="').concat($741c336afc2dfa06$var$c.unlink, '" data-trix-method="removeAttribute">\n          </div>\n        </div>\n      </div>\n    </div>')
};
const $741c336afc2dfa06$var$V = {
    interval: 5e3
};
var $741c336afc2dfa06$var$z = Object.freeze({
    __proto__: null,
    attachments: $741c336afc2dfa06$var$i,
    blockAttributes: $741c336afc2dfa06$var$n,
    browser: $741c336afc2dfa06$var$a,
    css: {
        attachment: "attachment",
        attachmentCaption: "attachment__caption",
        attachmentCaptionEditor: "attachment__caption-editor",
        attachmentMetadata: "attachment__metadata",
        attachmentMetadataContainer: "attachment__metadata-container",
        attachmentName: "attachment__name",
        attachmentProgress: "attachment__progress",
        attachmentSize: "attachment__size",
        attachmentToolbar: "attachment__toolbar",
        attachmentGallery: "attachment-gallery"
    },
    dompurify: $741c336afc2dfa06$var$l,
    fileSize: $741c336afc2dfa06$var$h,
    input: $741c336afc2dfa06$var$_,
    keyNames: {
        8: "backspace",
        9: "tab",
        13: "return",
        27: "escape",
        37: "left",
        39: "right",
        46: "delete",
        68: "d",
        72: "h",
        79: "o"
    },
    lang: $741c336afc2dfa06$var$c,
    parser: $741c336afc2dfa06$var$j,
    textAttributes: $741c336afc2dfa06$var$W,
    toolbar: $741c336afc2dfa06$var$U,
    undo: $741c336afc2dfa06$var$V
});
class $741c336afc2dfa06$var$q {
    static proxyMethod(t) {
        const { name: e, toMethod: i, toProperty: n, optional: r } = $741c336afc2dfa06$var$H(t);
        this.prototype[e] = function() {
            let t, o;
            var s, a;
            i ? o = r ? null === (s = this[i]) || void 0 === s ? void 0 : s.call(this) : this[i]() : n && (o = this[n]);
            return r ? (t = null === (a = o) || void 0 === a ? void 0 : a[e], t ? $741c336afc2dfa06$var$J.call(t, o, arguments) : void 0) : (t = o[e], $741c336afc2dfa06$var$J.call(t, o, arguments));
        };
    }
}
const $741c336afc2dfa06$var$H = function(t) {
    const e = t.match($741c336afc2dfa06$var$K);
    if (!e) throw new Error("can't parse @proxyMethod expression: ".concat(t));
    const i = {
        name: e[4]
    };
    return null != e[2] ? i.toMethod = e[1] : i.toProperty = e[1], null != e[3] && (i.optional = !0), i;
}, { apply: $741c336afc2dfa06$var$J } = Function.prototype, $741c336afc2dfa06$var$K = new RegExp("^(.+?)(\\(\\))?(\\?)?\\.(.+?)$");
var $741c336afc2dfa06$var$G, $741c336afc2dfa06$var$Y, $741c336afc2dfa06$var$$;
class $741c336afc2dfa06$var$X extends $741c336afc2dfa06$var$q {
    static box() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return t instanceof this ? t : this.fromUCS2String(null == t ? void 0 : t.toString());
    }
    static fromUCS2String(t) {
        return new this(t, $741c336afc2dfa06$var$et(t));
    }
    static fromCodepoints(t) {
        return new this($741c336afc2dfa06$var$it(t), t);
    }
    constructor(t, e){
        super(...arguments), this.ucs2String = t, this.codepoints = e, this.length = this.codepoints.length, this.ucs2Length = this.ucs2String.length;
    }
    offsetToUCS2Offset(t) {
        return $741c336afc2dfa06$var$it(this.codepoints.slice(0, Math.max(0, t))).length;
    }
    offsetFromUCS2Offset(t) {
        return $741c336afc2dfa06$var$et(this.ucs2String.slice(0, Math.max(0, t))).length;
    }
    slice() {
        return this.constructor.fromCodepoints(this.codepoints.slice(...arguments));
    }
    charAt(t) {
        return this.slice(t, t + 1);
    }
    isEqualTo(t) {
        return this.constructor.box(t).ucs2String === this.ucs2String;
    }
    toJSON() {
        return this.ucs2String;
    }
    getCacheKey() {
        return this.ucs2String;
    }
    toString() {
        return this.ucs2String;
    }
}
const $741c336afc2dfa06$var$Z = 1 === (null === ($741c336afc2dfa06$var$G = Array.from) || void 0 === $741c336afc2dfa06$var$G ? void 0 : $741c336afc2dfa06$var$G.call(Array, "\uD83D\uDC7C").length), $741c336afc2dfa06$var$Q = null != (null === ($741c336afc2dfa06$var$Y = " ".codePointAt) || void 0 === $741c336afc2dfa06$var$Y ? void 0 : $741c336afc2dfa06$var$Y.call(" ", 0)), $741c336afc2dfa06$var$tt = " \uD83D\uDC7C" === (null === ($741c336afc2dfa06$var$$ = String.fromCodePoint) || void 0 === $741c336afc2dfa06$var$$ ? void 0 : $741c336afc2dfa06$var$$.call(String, 32, 128124));
let $741c336afc2dfa06$var$et, $741c336afc2dfa06$var$it;
$741c336afc2dfa06$var$et = $741c336afc2dfa06$var$Z && $741c336afc2dfa06$var$Q ? (t)=>Array.from(t).map((t)=>t.codePointAt(0)) : function(t) {
    const e = [];
    let i = 0;
    const { length: n } = t;
    for(; i < n;){
        let r = t.charCodeAt(i++);
        if (55296 <= r && r <= 56319 && i < n) {
            const e = t.charCodeAt(i++);
            56320 == (64512 & e) ? r = ((1023 & r) << 10) + (1023 & e) + 65536 : i--;
        }
        e.push(r);
    }
    return e;
}, $741c336afc2dfa06$var$it = $741c336afc2dfa06$var$tt ? (t)=>String.fromCodePoint(...Array.from(t || [])) : function(t) {
    return (()=>{
        const e = [];
        return Array.from(t).forEach((t)=>{
            let i = "";
            t > 65535 && (t -= 65536, i += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e.push(i + String.fromCharCode(t));
        }), e;
    })().join("");
};
let $741c336afc2dfa06$var$nt = 0;
class $741c336afc2dfa06$var$rt extends $741c336afc2dfa06$var$q {
    static fromJSONString(t) {
        return this.fromJSON(JSON.parse(t));
    }
    constructor(){
        super(...arguments), this.id = ++$741c336afc2dfa06$var$nt;
    }
    hasSameConstructorAs(t) {
        return this.constructor === (null == t ? void 0 : t.constructor);
    }
    isEqualTo(t) {
        return this === t;
    }
    inspect() {
        const t = [], e = this.contentsForInspection() || {};
        for(const i in e){
            const n = e[i];
            t.push("".concat(i, "=").concat(n));
        }
        return "#<".concat(this.constructor.name, ":").concat(this.id).concat(t.length ? " ".concat(t.join(", ")) : "", ">");
    }
    contentsForInspection() {}
    toJSONString() {
        return JSON.stringify(this);
    }
    toUTF16String() {
        return $741c336afc2dfa06$var$X.box(this);
    }
    getCacheKey() {
        return this.id.toString();
    }
}
const $741c336afc2dfa06$var$ot = function() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    if (t.length !== e.length) return !1;
    for(let i = 0; i < t.length; i++){
        if (t[i] !== e[i]) return !1;
    }
    return !0;
}, $741c336afc2dfa06$var$st = function(t) {
    const e = t.slice(0);
    for(var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)n[r - 1] = arguments[r];
    return e.splice(...n), e;
}, $741c336afc2dfa06$var$at = /[\u05BE\u05C0\u05C3\u05D0-\u05EA\u05F0-\u05F4\u061B\u061F\u0621-\u063A\u0640-\u064A\u066D\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D5\u06E5\u06E6\u200F\u202B\u202E\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE72\uFE74\uFE76-\uFEFC]/, $741c336afc2dfa06$var$lt = function() {
    const t = $741c336afc2dfa06$var$T("input", {
        dir: "auto",
        name: "x",
        dirName: "x.dir"
    }), e = $741c336afc2dfa06$var$T("textarea", {
        dir: "auto",
        name: "y",
        dirName: "y.dir"
    }), i = $741c336afc2dfa06$var$T("form");
    i.appendChild(t), i.appendChild(e);
    const n = function() {
        try {
            return new FormData(i).has(e.dirName);
        } catch (t) {
            return !1;
        }
    }(), r = function() {
        try {
            return t.matches(":dir(ltr),:dir(rtl)");
        } catch (t) {
            return !1;
        }
    }();
    return n ? function(t) {
        return e.value = t, new FormData(i).get(e.dirName);
    } : r ? function(e) {
        return t.value = e, t.matches(":dir(rtl)") ? "rtl" : "ltr";
    } : function(t) {
        const e = t.trim().charAt(0);
        return $741c336afc2dfa06$var$at.test(e) ? "rtl" : "ltr";
    };
}();
let $741c336afc2dfa06$var$ct = null, $741c336afc2dfa06$var$ut = null, $741c336afc2dfa06$var$ht = null, $741c336afc2dfa06$var$dt = null;
const $741c336afc2dfa06$var$gt = ()=>($741c336afc2dfa06$var$ct || ($741c336afc2dfa06$var$ct = $741c336afc2dfa06$var$bt().concat($741c336afc2dfa06$var$pt())), $741c336afc2dfa06$var$ct), $741c336afc2dfa06$var$mt = (t)=>$741c336afc2dfa06$var$n[t], $741c336afc2dfa06$var$pt = ()=>($741c336afc2dfa06$var$ut || ($741c336afc2dfa06$var$ut = Object.keys($741c336afc2dfa06$var$n)), $741c336afc2dfa06$var$ut), $741c336afc2dfa06$var$ft = (t)=>$741c336afc2dfa06$var$W[t], $741c336afc2dfa06$var$bt = ()=>($741c336afc2dfa06$var$ht || ($741c336afc2dfa06$var$ht = Object.keys($741c336afc2dfa06$var$W)), $741c336afc2dfa06$var$ht), $741c336afc2dfa06$var$vt = function(t, e) {
    $741c336afc2dfa06$var$At(t).textContent = e.replace(/%t/g, t);
}, $741c336afc2dfa06$var$At = function(t) {
    const e = document.createElement("style");
    e.setAttribute("type", "text/css"), e.setAttribute("data-tag-name", t.toLowerCase());
    const i = $741c336afc2dfa06$var$yt();
    return i && e.setAttribute("nonce", i), document.head.insertBefore(e, document.head.firstChild), e;
}, $741c336afc2dfa06$var$yt = function() {
    const t = $741c336afc2dfa06$var$xt("trix-csp-nonce") || $741c336afc2dfa06$var$xt("csp-nonce");
    if (t) {
        const { nonce: e, content: i } = t;
        return "" == e ? i : e;
    }
}, $741c336afc2dfa06$var$xt = (t)=>document.head.querySelector("meta[name=".concat(t, "]")), $741c336afc2dfa06$var$Ct = {
    "application/x-trix-feature-detection": "test"
}, $741c336afc2dfa06$var$Et = function(t) {
    const e = t.getData("text/plain"), i = t.getData("text/html");
    if (!e || !i) return null == e ? void 0 : e.length;
    {
        const { body: t } = (new DOMParser).parseFromString(i, "text/html");
        if (t.textContent === e) return !t.querySelector("*");
    }
}, $741c336afc2dfa06$var$St = /Mac|^iP/.test(navigator.platform) ? (t)=>t.metaKey : (t)=>t.ctrlKey;
const $741c336afc2dfa06$var$Rt = (t)=>setTimeout(t, 1), $741c336afc2dfa06$var$kt = function() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const e = {};
    for(const i in t){
        const n = t[i];
        e[i] = n;
    }
    return e;
}, $741c336afc2dfa06$var$Tt = function() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (Object.keys(t).length !== Object.keys(e).length) return !1;
    for(const i in t){
        if (t[i] !== e[i]) return !1;
    }
    return !0;
}, $741c336afc2dfa06$var$wt = function(t) {
    if (null != t) return Array.isArray(t) || (t = [
        t,
        t
    ]), [
        $741c336afc2dfa06$var$Nt(t[0]),
        $741c336afc2dfa06$var$Nt(null != t[1] ? t[1] : t[0])
    ];
}, $741c336afc2dfa06$var$Lt = function(t) {
    if (null == t) return;
    const [e, i] = $741c336afc2dfa06$var$wt(t);
    return $741c336afc2dfa06$var$It(e, i);
}, $741c336afc2dfa06$var$Dt = function(t, e) {
    if (null == t || null == e) return;
    const [i, n] = $741c336afc2dfa06$var$wt(t), [r, o] = $741c336afc2dfa06$var$wt(e);
    return $741c336afc2dfa06$var$It(i, r) && $741c336afc2dfa06$var$It(n, o);
}, $741c336afc2dfa06$var$Nt = function(t) {
    return "number" == typeof t ? t : $741c336afc2dfa06$var$kt(t);
}, $741c336afc2dfa06$var$It = function(t, e) {
    return "number" == typeof t ? t === e : $741c336afc2dfa06$var$Tt(t, e);
};
class $741c336afc2dfa06$var$Ot extends $741c336afc2dfa06$var$q {
    constructor(){
        super(...arguments), this.update = this.update.bind(this), this.selectionManagers = [];
    }
    start() {
        this.started || (this.started = !0, document.addEventListener("selectionchange", this.update, !0));
    }
    stop() {
        if (this.started) return this.started = !1, document.removeEventListener("selectionchange", this.update, !0);
    }
    registerSelectionManager(t) {
        if (!this.selectionManagers.includes(t)) return this.selectionManagers.push(t), this.start();
    }
    unregisterSelectionManager(t) {
        if (this.selectionManagers = this.selectionManagers.filter((e)=>e !== t), 0 === this.selectionManagers.length) return this.stop();
    }
    notifySelectionManagersOfSelectionChange() {
        return this.selectionManagers.map((t)=>t.selectionDidChange());
    }
    update() {
        this.notifySelectionManagersOfSelectionChange();
    }
    reset() {
        this.update();
    }
}
const $741c336afc2dfa06$var$Ft = new $741c336afc2dfa06$var$Ot, $741c336afc2dfa06$var$Pt = function() {
    const t = window.getSelection();
    if (t.rangeCount > 0) return t;
}, $741c336afc2dfa06$var$Mt = function() {
    var t;
    const e = null === (t = $741c336afc2dfa06$var$Pt()) || void 0 === t ? void 0 : t.getRangeAt(0);
    if (e && !$741c336afc2dfa06$var$_t(e)) return e;
}, $741c336afc2dfa06$var$Bt = function(t) {
    const e = window.getSelection();
    return e.removeAllRanges(), e.addRange(t), $741c336afc2dfa06$var$Ft.update();
}, $741c336afc2dfa06$var$_t = (t)=>$741c336afc2dfa06$var$jt(t.startContainer) || $741c336afc2dfa06$var$jt(t.endContainer), $741c336afc2dfa06$var$jt = (t)=>!Object.getPrototypeOf(t), $741c336afc2dfa06$var$Wt = (t)=>t.replace(new RegExp("".concat($741c336afc2dfa06$var$d), "g"), "").replace(new RegExp("".concat($741c336afc2dfa06$var$g), "g"), " "), $741c336afc2dfa06$var$Ut = new RegExp("[^\\S".concat($741c336afc2dfa06$var$g, "]")), $741c336afc2dfa06$var$Vt = (t)=>t.replace(new RegExp("".concat($741c336afc2dfa06$var$Ut.source), "g"), " ").replace(/\ {2,}/g, " "), $741c336afc2dfa06$var$zt = function(t, e) {
    if (t.isEqualTo(e)) return [
        "",
        ""
    ];
    const i = $741c336afc2dfa06$var$qt(t, e), { length: n } = i.utf16String;
    let r;
    if (n) {
        const { offset: o } = i, s = t.codepoints.slice(0, o).concat(t.codepoints.slice(o + n));
        r = $741c336afc2dfa06$var$qt(e, $741c336afc2dfa06$var$X.fromCodepoints(s));
    } else r = $741c336afc2dfa06$var$qt(e, t);
    return [
        i.utf16String.toString(),
        r.utf16String.toString()
    ];
}, $741c336afc2dfa06$var$qt = function(t, e) {
    let i = 0, n = t.length, r = e.length;
    for(; i < n && t.charAt(i).isEqualTo(e.charAt(i));)i++;
    for(; n > i + 1 && t.charAt(n - 1).isEqualTo(e.charAt(r - 1));)n--, r--;
    return {
        utf16String: t.slice(i, n),
        offset: i
    };
};
class $741c336afc2dfa06$var$Ht extends $741c336afc2dfa06$var$rt {
    static fromCommonAttributesOfObjects() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        if (!t.length) return new this;
        let e = $741c336afc2dfa06$var$Yt(t[0]), i = e.getKeys();
        return t.slice(1).forEach((t)=>{
            i = e.getKeysCommonToHash($741c336afc2dfa06$var$Yt(t)), e = e.slice(i);
        }), e;
    }
    static box(t) {
        return $741c336afc2dfa06$var$Yt(t);
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        super(...arguments), this.values = $741c336afc2dfa06$var$Gt(t);
    }
    add(t, e) {
        return this.merge($741c336afc2dfa06$var$Jt(t, e));
    }
    remove(t) {
        return new $741c336afc2dfa06$var$Ht($741c336afc2dfa06$var$Gt(this.values, t));
    }
    get(t) {
        return this.values[t];
    }
    has(t) {
        return t in this.values;
    }
    merge(t) {
        return new $741c336afc2dfa06$var$Ht($741c336afc2dfa06$var$Kt(this.values, $741c336afc2dfa06$var$$t(t)));
    }
    slice(t) {
        const e = {};
        return Array.from(t).forEach((t)=>{
            this.has(t) && (e[t] = this.values[t]);
        }), new $741c336afc2dfa06$var$Ht(e);
    }
    getKeys() {
        return Object.keys(this.values);
    }
    getKeysCommonToHash(t) {
        return t = $741c336afc2dfa06$var$Yt(t), this.getKeys().filter((e)=>this.values[e] === t.values[e]);
    }
    isEqualTo(t) {
        return $741c336afc2dfa06$var$ot(this.toArray(), $741c336afc2dfa06$var$Yt(t).toArray());
    }
    isEmpty() {
        return 0 === this.getKeys().length;
    }
    toArray() {
        if (!this.array) {
            const t = [];
            for(const e in this.values){
                const i = this.values[e];
                t.push(t.push(e, i));
            }
            this.array = t.slice(0);
        }
        return this.array;
    }
    toObject() {
        return $741c336afc2dfa06$var$Gt(this.values);
    }
    toJSON() {
        return this.toObject();
    }
    contentsForInspection() {
        return {
            values: JSON.stringify(this.values)
        };
    }
}
const $741c336afc2dfa06$var$Jt = function(t, e) {
    const i = {};
    return i[t] = e, i;
}, $741c336afc2dfa06$var$Kt = function(t, e) {
    const i = $741c336afc2dfa06$var$Gt(t);
    for(const t in e){
        const n = e[t];
        i[t] = n;
    }
    return i;
}, $741c336afc2dfa06$var$Gt = function(t, e) {
    const i = {};
    return Object.keys(t).sort().forEach((n)=>{
        n !== e && (i[n] = t[n]);
    }), i;
}, $741c336afc2dfa06$var$Yt = function(t) {
    return t instanceof $741c336afc2dfa06$var$Ht ? t : new $741c336afc2dfa06$var$Ht(t);
}, $741c336afc2dfa06$var$$t = function(t) {
    return t instanceof $741c336afc2dfa06$var$Ht ? t.values : t;
};
class $741c336afc2dfa06$var$Xt {
    static groupObjects() {
        let t, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], { depth: i, asTree: n } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        n && null == i && (i = 0);
        const r = [];
        return Array.from(e).forEach((e)=>{
            var o;
            if (t) {
                var s, a, l;
                if (null !== (s = e.canBeGrouped) && void 0 !== s && s.call(e, i) && null !== (a = (l = t[t.length - 1]).canBeGroupedWith) && void 0 !== a && a.call(l, e, i)) return void t.push(e);
                r.push(new this(t, {
                    depth: i,
                    asTree: n
                })), t = null;
            }
            null !== (o = e.canBeGrouped) && void 0 !== o && o.call(e, i) ? t = [
                e
            ] : r.push(e);
        }), t && r.push(new this(t, {
            depth: i,
            asTree: n
        })), r;
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], { depth: e, asTree: i } = arguments.length > 1 ? arguments[1] : void 0;
        this.objects = t, i && (this.depth = e, this.objects = this.constructor.groupObjects(this.objects, {
            asTree: i,
            depth: this.depth + 1
        }));
    }
    getObjects() {
        return this.objects;
    }
    getDepth() {
        return this.depth;
    }
    getCacheKey() {
        const t = [
            "objectGroup"
        ];
        return Array.from(this.getObjects()).forEach((e)=>{
            t.push(e.getCacheKey());
        }), t.join("/");
    }
}
class $741c336afc2dfa06$var$Zt extends $741c336afc2dfa06$var$q {
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        super(...arguments), this.objects = {}, Array.from(t).forEach((t)=>{
            const e = JSON.stringify(t);
            null == this.objects[e] && (this.objects[e] = t);
        });
    }
    find(t) {
        const e = JSON.stringify(t);
        return this.objects[e];
    }
}
class $741c336afc2dfa06$var$Qt {
    constructor(t){
        this.reset(t);
    }
    add(t) {
        const e = $741c336afc2dfa06$var$te(t);
        this.elements[e] = t;
    }
    remove(t) {
        const e = $741c336afc2dfa06$var$te(t), i = this.elements[e];
        if (i) return delete this.elements[e], i;
    }
    reset() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return this.elements = {}, Array.from(t).forEach((t)=>{
            this.add(t);
        }), t;
    }
}
const $741c336afc2dfa06$var$te = (t)=>t.dataset.trixStoreKey;
class $741c336afc2dfa06$var$ee extends $741c336afc2dfa06$var$q {
    isPerforming() {
        return !0 === this.performing;
    }
    hasPerformed() {
        return !0 === this.performed;
    }
    hasSucceeded() {
        return this.performed && this.succeeded;
    }
    hasFailed() {
        return this.performed && !this.succeeded;
    }
    getPromise() {
        return this.promise || (this.promise = new Promise((t, e)=>(this.performing = !0, this.perform((i, n)=>{
                this.succeeded = i, this.performing = !1, this.performed = !0, this.succeeded ? t(n) : e(n);
            })))), this.promise;
    }
    perform(t) {
        return t(!1);
    }
    release() {
        var t, e;
        null === (t = this.promise) || void 0 === t || null === (e = t.cancel) || void 0 === e || e.call(t), this.promise = null, this.performing = null, this.performed = null, this.succeeded = null;
    }
}
$741c336afc2dfa06$var$ee.proxyMethod("getPromise().then"), $741c336afc2dfa06$var$ee.proxyMethod("getPromise().catch");
class $741c336afc2dfa06$var$ie extends $741c336afc2dfa06$var$q {
    constructor(t){
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        super(...arguments), this.object = t, this.options = e, this.childViews = [], this.rootView = this;
    }
    getNodes() {
        return this.nodes || (this.nodes = this.createNodes()), this.nodes.map((t)=>t.cloneNode(!0));
    }
    invalidate() {
        var t;
        return this.nodes = null, this.childViews = [], null === (t = this.parentView) || void 0 === t ? void 0 : t.invalidate();
    }
    invalidateViewForObject(t) {
        var e;
        return null === (e = this.findViewForObject(t)) || void 0 === e ? void 0 : e.invalidate();
    }
    findOrCreateCachedChildView(t, e, i) {
        let n = this.getCachedViewForObject(e);
        return n ? this.recordChildView(n) : (n = this.createChildView(...arguments), this.cacheViewForObject(n, e)), n;
    }
    createChildView(t, e) {
        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e instanceof $741c336afc2dfa06$var$Xt && (i.viewClass = t, t = $741c336afc2dfa06$var$ne);
        const n = new t(e, i);
        return this.recordChildView(n);
    }
    recordChildView(t) {
        return t.parentView = this, t.rootView = this.rootView, this.childViews.push(t), t;
    }
    getAllChildViews() {
        let t = [];
        return this.childViews.forEach((e)=>{
            t.push(e), t = t.concat(e.getAllChildViews());
        }), t;
    }
    findElement() {
        return this.findElementForObject(this.object);
    }
    findElementForObject(t) {
        const e = null == t ? void 0 : t.id;
        if (e) return this.rootView.element.querySelector("[data-trix-id='".concat(e, "']"));
    }
    findViewForObject(t) {
        for (const e of this.getAllChildViews())if (e.object === t) return e;
    }
    getViewCache() {
        return this.rootView !== this ? this.rootView.getViewCache() : this.isViewCachingEnabled() ? (this.viewCache || (this.viewCache = {}), this.viewCache) : void 0;
    }
    isViewCachingEnabled() {
        return !1 !== this.shouldCacheViews;
    }
    enableViewCaching() {
        this.shouldCacheViews = !0;
    }
    disableViewCaching() {
        this.shouldCacheViews = !1;
    }
    getCachedViewForObject(t) {
        var e;
        return null === (e = this.getViewCache()) || void 0 === e ? void 0 : e[t.getCacheKey()];
    }
    cacheViewForObject(t, e) {
        const i = this.getViewCache();
        i && (i[e.getCacheKey()] = t);
    }
    garbageCollectCachedViews() {
        const t = this.getViewCache();
        if (t) {
            const e = this.getAllChildViews().concat(this).map((t)=>t.object.getCacheKey());
            for(const i in t)e.includes(i) || delete t[i];
        }
    }
}
class $741c336afc2dfa06$var$ne extends $741c336afc2dfa06$var$ie {
    constructor(){
        super(...arguments), this.objectGroup = this.object, this.viewClass = this.options.viewClass, delete this.options.viewClass;
    }
    getChildViews() {
        return this.childViews.length || Array.from(this.objectGroup.getObjects()).forEach((t)=>{
            this.findOrCreateCachedChildView(this.viewClass, t, this.options);
        }), this.childViews;
    }
    createNodes() {
        const t = this.createContainerElement();
        return this.getChildViews().forEach((e)=>{
            Array.from(e.getNodes()).forEach((e)=>{
                t.appendChild(e);
            });
        }), [
            t
        ];
    }
    createContainerElement() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.objectGroup.getDepth();
        return this.getChildViews()[0].createContainerElement(t);
    }
}
/*! @license DOMPurify 3.2.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.3/LICENSE */ const { entries: $741c336afc2dfa06$var$re, setPrototypeOf: $741c336afc2dfa06$var$oe, isFrozen: $741c336afc2dfa06$var$se, getPrototypeOf: $741c336afc2dfa06$var$ae, getOwnPropertyDescriptor: $741c336afc2dfa06$var$le } = Object;
let { freeze: $741c336afc2dfa06$var$ce, seal: $741c336afc2dfa06$var$ue, create: $741c336afc2dfa06$var$he } = Object, { apply: $741c336afc2dfa06$var$de, construct: $741c336afc2dfa06$var$ge } = "undefined" != typeof Reflect && Reflect;
$741c336afc2dfa06$var$ce || ($741c336afc2dfa06$var$ce = function(t) {
    return t;
}), $741c336afc2dfa06$var$ue || ($741c336afc2dfa06$var$ue = function(t) {
    return t;
}), $741c336afc2dfa06$var$de || ($741c336afc2dfa06$var$de = function(t, e, i) {
    return t.apply(e, i);
}), $741c336afc2dfa06$var$ge || ($741c336afc2dfa06$var$ge = function(t, e) {
    return new t(...e);
});
const $741c336afc2dfa06$var$me = $741c336afc2dfa06$var$Te(Array.prototype.forEach), $741c336afc2dfa06$var$pe = $741c336afc2dfa06$var$Te(Array.prototype.pop), $741c336afc2dfa06$var$fe = $741c336afc2dfa06$var$Te(Array.prototype.push), $741c336afc2dfa06$var$be = $741c336afc2dfa06$var$Te(String.prototype.toLowerCase), $741c336afc2dfa06$var$ve = $741c336afc2dfa06$var$Te(String.prototype.toString), $741c336afc2dfa06$var$Ae = $741c336afc2dfa06$var$Te(String.prototype.match), $741c336afc2dfa06$var$ye = $741c336afc2dfa06$var$Te(String.prototype.replace), $741c336afc2dfa06$var$xe = $741c336afc2dfa06$var$Te(String.prototype.indexOf), $741c336afc2dfa06$var$Ce = $741c336afc2dfa06$var$Te(String.prototype.trim), $741c336afc2dfa06$var$Ee = $741c336afc2dfa06$var$Te(Object.prototype.hasOwnProperty), $741c336afc2dfa06$var$Se = $741c336afc2dfa06$var$Te(RegExp.prototype.test), $741c336afc2dfa06$var$Re = ($741c336afc2dfa06$var$ke = TypeError, function() {
    for(var t = arguments.length, e = new Array(t), i = 0; i < t; i++)e[i] = arguments[i];
    return $741c336afc2dfa06$var$ge($741c336afc2dfa06$var$ke, e);
});
var $741c336afc2dfa06$var$ke;
function $741c336afc2dfa06$var$Te(t) {
    return function(e) {
        for(var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)n[r - 1] = arguments[r];
        return $741c336afc2dfa06$var$de(t, e, n);
    };
}
function $741c336afc2dfa06$var$we(t, e) {
    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $741c336afc2dfa06$var$be;
    $741c336afc2dfa06$var$oe && $741c336afc2dfa06$var$oe(t, null);
    let n = e.length;
    for(; n--;){
        let r = e[n];
        if ("string" == typeof r) {
            const t = i(r);
            t !== r && ($741c336afc2dfa06$var$se(e) || (e[n] = t), r = t);
        }
        t[r] = !0;
    }
    return t;
}
function $741c336afc2dfa06$var$Le(t) {
    for(let e = 0; e < t.length; e++)$741c336afc2dfa06$var$Ee(t, e) || (t[e] = null);
    return t;
}
function $741c336afc2dfa06$var$De(t) {
    const e = $741c336afc2dfa06$var$he(null);
    for (const [i, n] of $741c336afc2dfa06$var$re(t))$741c336afc2dfa06$var$Ee(t, i) && (Array.isArray(n) ? e[i] = $741c336afc2dfa06$var$Le(n) : n && "object" == typeof n && n.constructor === Object ? e[i] = $741c336afc2dfa06$var$De(n) : e[i] = n);
    return e;
}
function $741c336afc2dfa06$var$Ne(t, e) {
    for(; null !== t;){
        const i = $741c336afc2dfa06$var$le(t, e);
        if (i) {
            if (i.get) return $741c336afc2dfa06$var$Te(i.get);
            if ("function" == typeof i.value) return $741c336afc2dfa06$var$Te(i.value);
        }
        t = $741c336afc2dfa06$var$ae(t);
    }
    return function() {
        return null;
    };
}
const $741c336afc2dfa06$var$Ie = $741c336afc2dfa06$var$ce([
    "a",
    "abbr",
    "acronym",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "decorator",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "element",
    "em",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meter",
    "nav",
    "nobr",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "select",
    "shadow",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
]), $741c336afc2dfa06$var$Oe = $741c336afc2dfa06$var$ce([
    "svg",
    "a",
    "altglyph",
    "altglyphdef",
    "altglyphitem",
    "animatecolor",
    "animatemotion",
    "animatetransform",
    "circle",
    "clippath",
    "defs",
    "desc",
    "ellipse",
    "filter",
    "font",
    "g",
    "glyph",
    "glyphref",
    "hkern",
    "image",
    "line",
    "lineargradient",
    "marker",
    "mask",
    "metadata",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialgradient",
    "rect",
    "stop",
    "style",
    "switch",
    "symbol",
    "text",
    "textpath",
    "title",
    "tref",
    "tspan",
    "view",
    "vkern"
]), $741c336afc2dfa06$var$Fe = $741c336afc2dfa06$var$ce([
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence"
]), $741c336afc2dfa06$var$Pe = $741c336afc2dfa06$var$ce([
    "animate",
    "color-profile",
    "cursor",
    "discard",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignobject",
    "hatch",
    "hatchpath",
    "mesh",
    "meshgradient",
    "meshpatch",
    "meshrow",
    "missing-glyph",
    "script",
    "set",
    "solidcolor",
    "unknown",
    "use"
]), $741c336afc2dfa06$var$Me = $741c336afc2dfa06$var$ce([
    "math",
    "menclose",
    "merror",
    "mfenced",
    "mfrac",
    "mglyph",
    "mi",
    "mlabeledtr",
    "mmultiscripts",
    "mn",
    "mo",
    "mover",
    "mpadded",
    "mphantom",
    "mroot",
    "mrow",
    "ms",
    "mspace",
    "msqrt",
    "mstyle",
    "msub",
    "msup",
    "msubsup",
    "mtable",
    "mtd",
    "mtext",
    "mtr",
    "munder",
    "munderover",
    "mprescripts"
]), $741c336afc2dfa06$var$Be = $741c336afc2dfa06$var$ce([
    "maction",
    "maligngroup",
    "malignmark",
    "mlongdiv",
    "mscarries",
    "mscarry",
    "msgroup",
    "mstack",
    "msline",
    "msrow",
    "semantics",
    "annotation",
    "annotation-xml",
    "mprescripts",
    "none"
]), $741c336afc2dfa06$var$_e = $741c336afc2dfa06$var$ce([
    "#text"
]), $741c336afc2dfa06$var$je = $741c336afc2dfa06$var$ce([
    "accept",
    "action",
    "align",
    "alt",
    "autocapitalize",
    "autocomplete",
    "autopictureinpicture",
    "autoplay",
    "background",
    "bgcolor",
    "border",
    "capture",
    "cellpadding",
    "cellspacing",
    "checked",
    "cite",
    "class",
    "clear",
    "color",
    "cols",
    "colspan",
    "controls",
    "controlslist",
    "coords",
    "crossorigin",
    "datetime",
    "decoding",
    "default",
    "dir",
    "disabled",
    "disablepictureinpicture",
    "disableremoteplayback",
    "download",
    "draggable",
    "enctype",
    "enterkeyhint",
    "face",
    "for",
    "headers",
    "height",
    "hidden",
    "high",
    "href",
    "hreflang",
    "id",
    "inputmode",
    "integrity",
    "ismap",
    "kind",
    "label",
    "lang",
    "list",
    "loading",
    "loop",
    "low",
    "max",
    "maxlength",
    "media",
    "method",
    "min",
    "minlength",
    "multiple",
    "muted",
    "name",
    "nonce",
    "noshade",
    "novalidate",
    "nowrap",
    "open",
    "optimum",
    "pattern",
    "placeholder",
    "playsinline",
    "popover",
    "popovertarget",
    "popovertargetaction",
    "poster",
    "preload",
    "pubdate",
    "radiogroup",
    "readonly",
    "rel",
    "required",
    "rev",
    "reversed",
    "role",
    "rows",
    "rowspan",
    "spellcheck",
    "scope",
    "selected",
    "shape",
    "size",
    "sizes",
    "span",
    "srclang",
    "start",
    "src",
    "srcset",
    "step",
    "style",
    "summary",
    "tabindex",
    "title",
    "translate",
    "type",
    "usemap",
    "valign",
    "value",
    "width",
    "wrap",
    "xmlns",
    "slot"
]), $741c336afc2dfa06$var$We = $741c336afc2dfa06$var$ce([
    "accent-height",
    "accumulate",
    "additive",
    "alignment-baseline",
    "amplitude",
    "ascent",
    "attributename",
    "attributetype",
    "azimuth",
    "basefrequency",
    "baseline-shift",
    "begin",
    "bias",
    "by",
    "class",
    "clip",
    "clippathunits",
    "clip-path",
    "clip-rule",
    "color",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "cx",
    "cy",
    "d",
    "dx",
    "dy",
    "diffuseconstant",
    "direction",
    "display",
    "divisor",
    "dur",
    "edgemode",
    "elevation",
    "end",
    "exponent",
    "fill",
    "fill-opacity",
    "fill-rule",
    "filter",
    "filterunits",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyph-name",
    "glyphref",
    "gradientunits",
    "gradienttransform",
    "height",
    "href",
    "id",
    "image-rendering",
    "in",
    "in2",
    "intercept",
    "k",
    "k1",
    "k2",
    "k3",
    "k4",
    "kerning",
    "keypoints",
    "keysplines",
    "keytimes",
    "lang",
    "lengthadjust",
    "letter-spacing",
    "kernelmatrix",
    "kernelunitlength",
    "lighting-color",
    "local",
    "marker-end",
    "marker-mid",
    "marker-start",
    "markerheight",
    "markerunits",
    "markerwidth",
    "maskcontentunits",
    "maskunits",
    "max",
    "mask",
    "media",
    "method",
    "mode",
    "min",
    "name",
    "numoctaves",
    "offset",
    "operator",
    "opacity",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "paint-order",
    "path",
    "pathlength",
    "patterncontentunits",
    "patterntransform",
    "patternunits",
    "points",
    "preservealpha",
    "preserveaspectratio",
    "primitiveunits",
    "r",
    "rx",
    "ry",
    "radius",
    "refx",
    "refy",
    "repeatcount",
    "repeatdur",
    "restart",
    "result",
    "rotate",
    "scale",
    "seed",
    "shape-rendering",
    "slope",
    "specularconstant",
    "specularexponent",
    "spreadmethod",
    "startoffset",
    "stddeviation",
    "stitchtiles",
    "stop-color",
    "stop-opacity",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke",
    "stroke-width",
    "style",
    "surfacescale",
    "systemlanguage",
    "tabindex",
    "tablevalues",
    "targetx",
    "targety",
    "transform",
    "transform-origin",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "textlength",
    "type",
    "u1",
    "u2",
    "unicode",
    "values",
    "viewbox",
    "visibility",
    "version",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "width",
    "word-spacing",
    "wrap",
    "writing-mode",
    "xchannelselector",
    "ychannelselector",
    "x",
    "x1",
    "x2",
    "xmlns",
    "y",
    "y1",
    "y2",
    "z",
    "zoomandpan"
]), $741c336afc2dfa06$var$Ue = $741c336afc2dfa06$var$ce([
    "accent",
    "accentunder",
    "align",
    "bevelled",
    "close",
    "columnsalign",
    "columnlines",
    "columnspan",
    "denomalign",
    "depth",
    "dir",
    "display",
    "displaystyle",
    "encoding",
    "fence",
    "frame",
    "height",
    "href",
    "id",
    "largeop",
    "length",
    "linethickness",
    "lspace",
    "lquote",
    "mathbackground",
    "mathcolor",
    "mathsize",
    "mathvariant",
    "maxsize",
    "minsize",
    "movablelimits",
    "notation",
    "numalign",
    "open",
    "rowalign",
    "rowlines",
    "rowspacing",
    "rowspan",
    "rspace",
    "rquote",
    "scriptlevel",
    "scriptminsize",
    "scriptsizemultiplier",
    "selection",
    "separator",
    "separators",
    "stretchy",
    "subscriptshift",
    "supscriptshift",
    "symmetric",
    "voffset",
    "width",
    "xmlns"
]), $741c336afc2dfa06$var$Ve = $741c336afc2dfa06$var$ce([
    "xlink:href",
    "xml:id",
    "xlink:title",
    "xml:space",
    "xmlns:xlink"
]), $741c336afc2dfa06$var$ze = $741c336afc2dfa06$var$ue(/\{\{[\w\W]*|[\w\W]*\}\}/gm), $741c336afc2dfa06$var$qe = $741c336afc2dfa06$var$ue(/<%[\w\W]*|[\w\W]*%>/gm), $741c336afc2dfa06$var$He = $741c336afc2dfa06$var$ue(/\$\{[\w\W]*}/gm), $741c336afc2dfa06$var$Je = $741c336afc2dfa06$var$ue(/^data-[\-\w.\u00B7-\uFFFF]+$/), $741c336afc2dfa06$var$Ke = $741c336afc2dfa06$var$ue(/^aria-[\-\w]+$/), $741c336afc2dfa06$var$Ge = $741c336afc2dfa06$var$ue(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), $741c336afc2dfa06$var$Ye = $741c336afc2dfa06$var$ue(/^(?:\w+script|data):/i), $741c336afc2dfa06$var$$e = $741c336afc2dfa06$var$ue(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), $741c336afc2dfa06$var$Xe = $741c336afc2dfa06$var$ue(/^html$/i), $741c336afc2dfa06$var$Ze = $741c336afc2dfa06$var$ue(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $741c336afc2dfa06$var$Qe = Object.freeze({
    __proto__: null,
    ARIA_ATTR: $741c336afc2dfa06$var$Ke,
    ATTR_WHITESPACE: $741c336afc2dfa06$var$$e,
    CUSTOM_ELEMENT: $741c336afc2dfa06$var$Ze,
    DATA_ATTR: $741c336afc2dfa06$var$Je,
    DOCTYPE_NAME: $741c336afc2dfa06$var$Xe,
    ERB_EXPR: $741c336afc2dfa06$var$qe,
    IS_ALLOWED_URI: $741c336afc2dfa06$var$Ge,
    IS_SCRIPT_OR_DATA: $741c336afc2dfa06$var$Ye,
    MUSTACHE_EXPR: $741c336afc2dfa06$var$ze,
    TMPLIT_EXPR: $741c336afc2dfa06$var$He
});
const $741c336afc2dfa06$var$ti = 1, $741c336afc2dfa06$var$ei = 3, $741c336afc2dfa06$var$ii = 7, $741c336afc2dfa06$var$ni = 8, $741c336afc2dfa06$var$ri = 9, $741c336afc2dfa06$var$oi = function() {
    return "undefined" == typeof window ? null : window;
};
var $741c336afc2dfa06$var$si = function t() {
    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $741c336afc2dfa06$var$oi();
    const i = (e)=>t(e);
    if (i.version = "3.2.3", i.removed = [], !e || !e.document || e.document.nodeType !== $741c336afc2dfa06$var$ri) return i.isSupported = !1, i;
    let { document: n } = e;
    const r = n, o = r.currentScript, { DocumentFragment: s, HTMLTemplateElement: a, Node: l, Element: c, NodeFilter: u, NamedNodeMap: h = e.NamedNodeMap || e.MozNamedAttrMap, HTMLFormElement: d, DOMParser: g, trustedTypes: m } = e, p = c.prototype, f = $741c336afc2dfa06$var$Ne(p, "cloneNode"), b = $741c336afc2dfa06$var$Ne(p, "remove"), v = $741c336afc2dfa06$var$Ne(p, "nextSibling"), A = $741c336afc2dfa06$var$Ne(p, "childNodes"), y = $741c336afc2dfa06$var$Ne(p, "parentNode");
    if ("function" == typeof a) {
        const t = n.createElement("template");
        t.content && t.content.ownerDocument && (n = t.content.ownerDocument);
    }
    let x, C = "";
    const { implementation: E, createNodeIterator: S, createDocumentFragment: R, getElementsByTagName: k } = n, { importNode: T } = r;
    let w = {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
    i.isSupported = "function" == typeof $741c336afc2dfa06$var$re && "function" == typeof y && E && void 0 !== E.createHTMLDocument;
    const { MUSTACHE_EXPR: L, ERB_EXPR: D, TMPLIT_EXPR: N, DATA_ATTR: I, ARIA_ATTR: O, IS_SCRIPT_OR_DATA: F, ATTR_WHITESPACE: P, CUSTOM_ELEMENT: M } = $741c336afc2dfa06$var$Qe;
    let { IS_ALLOWED_URI: B } = $741c336afc2dfa06$var$Qe, _ = null;
    const j = $741c336afc2dfa06$var$we({}, [
        ...$741c336afc2dfa06$var$Ie,
        ...$741c336afc2dfa06$var$Oe,
        ...$741c336afc2dfa06$var$Fe,
        ...$741c336afc2dfa06$var$Me,
        ...$741c336afc2dfa06$var$_e
    ]);
    let W = null;
    const U = $741c336afc2dfa06$var$we({}, [
        ...$741c336afc2dfa06$var$je,
        ...$741c336afc2dfa06$var$We,
        ...$741c336afc2dfa06$var$Ue,
        ...$741c336afc2dfa06$var$Ve
    ]);
    let V = Object.seal($741c336afc2dfa06$var$he(null, {
        tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
        },
        attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1
        }
    })), z = null, q = null, H = !0, J = !0, K = !1, G = !0, Y = !1, $ = !0, X = !1, Z = !1, Q = !1, tt = !1, et = !1, it = !1, nt = !0, rt = !1, ot = !0, st = !1, at = {}, lt = null;
    const ct = $741c336afc2dfa06$var$we({}, [
        "annotation-xml",
        "audio",
        "colgroup",
        "desc",
        "foreignobject",
        "head",
        "iframe",
        "math",
        "mi",
        "mn",
        "mo",
        "ms",
        "mtext",
        "noembed",
        "noframes",
        "noscript",
        "plaintext",
        "script",
        "style",
        "svg",
        "template",
        "thead",
        "title",
        "video",
        "xmp"
    ]);
    let ut = null;
    const ht = $741c336afc2dfa06$var$we({}, [
        "audio",
        "video",
        "img",
        "source",
        "image",
        "track"
    ]);
    let dt = null;
    const gt = $741c336afc2dfa06$var$we({}, [
        "alt",
        "class",
        "for",
        "id",
        "label",
        "name",
        "pattern",
        "placeholder",
        "role",
        "summary",
        "title",
        "value",
        "style",
        "xmlns"
    ]), mt = "http://www.w3.org/1998/Math/MathML", pt = "http://www.w3.org/2000/svg", ft = "http://www.w3.org/1999/xhtml";
    let bt = ft, vt = !1, At = null;
    const yt = $741c336afc2dfa06$var$we({}, [
        mt,
        pt,
        ft
    ], $741c336afc2dfa06$var$ve);
    let xt = $741c336afc2dfa06$var$we({}, [
        "mi",
        "mo",
        "mn",
        "ms",
        "mtext"
    ]), Ct = $741c336afc2dfa06$var$we({}, [
        "annotation-xml"
    ]);
    const Et = $741c336afc2dfa06$var$we({}, [
        "title",
        "style",
        "font",
        "a",
        "script"
    ]);
    let St = null;
    const Rt = [
        "application/xhtml+xml",
        "text/html"
    ];
    let kt = null, Tt = null;
    const wt = n.createElement("form"), Lt = function(t) {
        return t instanceof RegExp || t instanceof Function;
    }, Dt = function() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if (!Tt || Tt !== t) {
            if (t && "object" == typeof t || (t = {}), t = $741c336afc2dfa06$var$De(t), St = -1 === Rt.indexOf(t.PARSER_MEDIA_TYPE) ? "text/html" : t.PARSER_MEDIA_TYPE, kt = "application/xhtml+xml" === St ? $741c336afc2dfa06$var$ve : $741c336afc2dfa06$var$be, _ = $741c336afc2dfa06$var$Ee(t, "ALLOWED_TAGS") ? $741c336afc2dfa06$var$we({}, t.ALLOWED_TAGS, kt) : j, W = $741c336afc2dfa06$var$Ee(t, "ALLOWED_ATTR") ? $741c336afc2dfa06$var$we({}, t.ALLOWED_ATTR, kt) : U, At = $741c336afc2dfa06$var$Ee(t, "ALLOWED_NAMESPACES") ? $741c336afc2dfa06$var$we({}, t.ALLOWED_NAMESPACES, $741c336afc2dfa06$var$ve) : yt, dt = $741c336afc2dfa06$var$Ee(t, "ADD_URI_SAFE_ATTR") ? $741c336afc2dfa06$var$we($741c336afc2dfa06$var$De(gt), t.ADD_URI_SAFE_ATTR, kt) : gt, ut = $741c336afc2dfa06$var$Ee(t, "ADD_DATA_URI_TAGS") ? $741c336afc2dfa06$var$we($741c336afc2dfa06$var$De(ht), t.ADD_DATA_URI_TAGS, kt) : ht, lt = $741c336afc2dfa06$var$Ee(t, "FORBID_CONTENTS") ? $741c336afc2dfa06$var$we({}, t.FORBID_CONTENTS, kt) : ct, z = $741c336afc2dfa06$var$Ee(t, "FORBID_TAGS") ? $741c336afc2dfa06$var$we({}, t.FORBID_TAGS, kt) : {}, q = $741c336afc2dfa06$var$Ee(t, "FORBID_ATTR") ? $741c336afc2dfa06$var$we({}, t.FORBID_ATTR, kt) : {}, at = !!$741c336afc2dfa06$var$Ee(t, "USE_PROFILES") && t.USE_PROFILES, H = !1 !== t.ALLOW_ARIA_ATTR, J = !1 !== t.ALLOW_DATA_ATTR, K = t.ALLOW_UNKNOWN_PROTOCOLS || !1, G = !1 !== t.ALLOW_SELF_CLOSE_IN_ATTR, Y = t.SAFE_FOR_TEMPLATES || !1, $ = !1 !== t.SAFE_FOR_XML, X = t.WHOLE_DOCUMENT || !1, tt = t.RETURN_DOM || !1, et = t.RETURN_DOM_FRAGMENT || !1, it = t.RETURN_TRUSTED_TYPE || !1, Q = t.FORCE_BODY || !1, nt = !1 !== t.SANITIZE_DOM, rt = t.SANITIZE_NAMED_PROPS || !1, ot = !1 !== t.KEEP_CONTENT, st = t.IN_PLACE || !1, B = t.ALLOWED_URI_REGEXP || $741c336afc2dfa06$var$Ge, bt = t.NAMESPACE || ft, xt = t.MATHML_TEXT_INTEGRATION_POINTS || xt, Ct = t.HTML_INTEGRATION_POINTS || Ct, V = t.CUSTOM_ELEMENT_HANDLING || {}, t.CUSTOM_ELEMENT_HANDLING && Lt(t.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (V.tagNameCheck = t.CUSTOM_ELEMENT_HANDLING.tagNameCheck), t.CUSTOM_ELEMENT_HANDLING && Lt(t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (V.attributeNameCheck = t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), t.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (V.allowCustomizedBuiltInElements = t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Y && (J = !1), et && (tt = !0), at && (_ = $741c336afc2dfa06$var$we({}, $741c336afc2dfa06$var$_e), W = [], !0 === at.html && ($741c336afc2dfa06$var$we(_, $741c336afc2dfa06$var$Ie), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$je)), !0 === at.svg && ($741c336afc2dfa06$var$we(_, $741c336afc2dfa06$var$Oe), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$We), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$Ve)), !0 === at.svgFilters && ($741c336afc2dfa06$var$we(_, $741c336afc2dfa06$var$Fe), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$We), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$Ve)), !0 === at.mathMl && ($741c336afc2dfa06$var$we(_, $741c336afc2dfa06$var$Me), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$Ue), $741c336afc2dfa06$var$we(W, $741c336afc2dfa06$var$Ve))), t.ADD_TAGS && (_ === j && (_ = $741c336afc2dfa06$var$De(_)), $741c336afc2dfa06$var$we(_, t.ADD_TAGS, kt)), t.ADD_ATTR && (W === U && (W = $741c336afc2dfa06$var$De(W)), $741c336afc2dfa06$var$we(W, t.ADD_ATTR, kt)), t.ADD_URI_SAFE_ATTR && $741c336afc2dfa06$var$we(dt, t.ADD_URI_SAFE_ATTR, kt), t.FORBID_CONTENTS && (lt === ct && (lt = $741c336afc2dfa06$var$De(lt)), $741c336afc2dfa06$var$we(lt, t.FORBID_CONTENTS, kt)), ot && (_["#text"] = !0), X && $741c336afc2dfa06$var$we(_, [
                "html",
                "head",
                "body"
            ]), _.table && ($741c336afc2dfa06$var$we(_, [
                "tbody"
            ]), delete z.tbody), t.TRUSTED_TYPES_POLICY) {
                if ("function" != typeof t.TRUSTED_TYPES_POLICY.createHTML) throw $741c336afc2dfa06$var$Re('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if ("function" != typeof t.TRUSTED_TYPES_POLICY.createScriptURL) throw $741c336afc2dfa06$var$Re('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                x = t.TRUSTED_TYPES_POLICY, C = x.createHTML("");
            } else void 0 === x && (x = function(t, e) {
                if ("object" != typeof t || "function" != typeof t.createPolicy) return null;
                let i = null;
                const n = "data-tt-policy-suffix";
                e && e.hasAttribute(n) && (i = e.getAttribute(n));
                const r = "dompurify" + (i ? "#" + i : "");
                try {
                    return t.createPolicy(r, {
                        createHTML: (t)=>t,
                        createScriptURL: (t)=>t
                    });
                } catch (t) {
                    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
                }
            }(m, o)), null !== x && "string" == typeof C && (C = x.createHTML(""));
            $741c336afc2dfa06$var$ce && $741c336afc2dfa06$var$ce(t), Tt = t;
        }
    }, Nt = $741c336afc2dfa06$var$we({}, [
        ...$741c336afc2dfa06$var$Oe,
        ...$741c336afc2dfa06$var$Fe,
        ...$741c336afc2dfa06$var$Pe
    ]), It = $741c336afc2dfa06$var$we({}, [
        ...$741c336afc2dfa06$var$Me,
        ...$741c336afc2dfa06$var$Be
    ]), Ot = function(t) {
        $741c336afc2dfa06$var$fe(i.removed, {
            element: t
        });
        try {
            y(t).removeChild(t);
        } catch (e) {
            b(t);
        }
    }, Ft = function(t, e) {
        try {
            $741c336afc2dfa06$var$fe(i.removed, {
                attribute: e.getAttributeNode(t),
                from: e
            });
        } catch (t) {
            $741c336afc2dfa06$var$fe(i.removed, {
                attribute: null,
                from: e
            });
        }
        if (e.removeAttribute(t), "is" === t) {
            if (tt || et) try {
                Ot(e);
            } catch (t) {}
            else try {
                e.setAttribute(t, "");
            } catch (t) {}
        }
    }, Pt = function(t) {
        let e = null, i = null;
        if (Q) t = "<remove></remove>" + t;
        else {
            const e = $741c336afc2dfa06$var$Ae(t, /^[\r\n\t ]+/);
            i = e && e[0];
        }
        "application/xhtml+xml" === St && bt === ft && (t = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + t + "</body></html>");
        const r = x ? x.createHTML(t) : t;
        if (bt === ft) try {
            e = (new g).parseFromString(r, St);
        } catch (t) {}
        if (!e || !e.documentElement) {
            e = E.createDocument(bt, "template", null);
            try {
                e.documentElement.innerHTML = vt ? C : r;
            } catch (t) {}
        }
        const o = e.body || e.documentElement;
        return t && i && o.insertBefore(n.createTextNode(i), o.childNodes[0] || null), bt === ft ? k.call(e, X ? "html" : "body")[0] : X ? e.documentElement : o;
    }, Mt = function(t) {
        return S.call(t.ownerDocument || t, t, u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION, null);
    }, Bt = function(t) {
        return t instanceof d && ("string" != typeof t.nodeName || "string" != typeof t.textContent || "function" != typeof t.removeChild || !(t.attributes instanceof h) || "function" != typeof t.removeAttribute || "function" != typeof t.setAttribute || "string" != typeof t.namespaceURI || "function" != typeof t.insertBefore || "function" != typeof t.hasChildNodes);
    }, _t = function(t) {
        return "function" == typeof l && t instanceof l;
    };
    function jt(t, e, n) {
        $741c336afc2dfa06$var$me(t, (t)=>{
            t.call(i, e, n, Tt);
        });
    }
    const Wt = function(t) {
        let e = null;
        if (jt(w.beforeSanitizeElements, t, null), Bt(t)) return Ot(t), !0;
        const n = kt(t.nodeName);
        if (jt(w.uponSanitizeElement, t, {
            tagName: n,
            allowedTags: _
        }), t.hasChildNodes() && !_t(t.firstElementChild) && $741c336afc2dfa06$var$Se(/<[/\w]/g, t.innerHTML) && $741c336afc2dfa06$var$Se(/<[/\w]/g, t.textContent)) return Ot(t), !0;
        if (t.nodeType === $741c336afc2dfa06$var$ii) return Ot(t), !0;
        if ($ && t.nodeType === $741c336afc2dfa06$var$ni && $741c336afc2dfa06$var$Se(/<[/\w]/g, t.data)) return Ot(t), !0;
        if (!_[n] || z[n]) {
            if (!z[n] && Vt(n)) {
                if (V.tagNameCheck instanceof RegExp && $741c336afc2dfa06$var$Se(V.tagNameCheck, n)) return !1;
                if (V.tagNameCheck instanceof Function && V.tagNameCheck(n)) return !1;
            }
            if (ot && !lt[n]) {
                const e = y(t) || t.parentNode, i = A(t) || t.childNodes;
                if (i && e) for(let n = i.length - 1; n >= 0; --n){
                    const r = f(i[n], !0);
                    r.__removalCount = (t.__removalCount || 0) + 1, e.insertBefore(r, v(t));
                }
            }
            return Ot(t), !0;
        }
        return t instanceof c && !function(t) {
            let e = y(t);
            e && e.tagName || (e = {
                namespaceURI: bt,
                tagName: "template"
            });
            const i = $741c336afc2dfa06$var$be(t.tagName), n = $741c336afc2dfa06$var$be(e.tagName);
            return !!At[t.namespaceURI] && (t.namespaceURI === pt ? e.namespaceURI === ft ? "svg" === i : e.namespaceURI === mt ? "svg" === i && ("annotation-xml" === n || xt[n]) : Boolean(Nt[i]) : t.namespaceURI === mt ? e.namespaceURI === ft ? "math" === i : e.namespaceURI === pt ? "math" === i && Ct[n] : Boolean(It[i]) : t.namespaceURI === ft ? !(e.namespaceURI === pt && !Ct[n]) && !(e.namespaceURI === mt && !xt[n]) && !It[i] && (Et[i] || !Nt[i]) : !("application/xhtml+xml" !== St || !At[t.namespaceURI]));
        }(t) ? (Ot(t), !0) : "noscript" !== n && "noembed" !== n && "noframes" !== n || !$741c336afc2dfa06$var$Se(/<\/no(script|embed|frames)/i, t.innerHTML) ? (Y && t.nodeType === $741c336afc2dfa06$var$ei && (e = t.textContent, $741c336afc2dfa06$var$me([
            L,
            D,
            N
        ], (t)=>{
            e = $741c336afc2dfa06$var$ye(e, t, " ");
        }), t.textContent !== e && ($741c336afc2dfa06$var$fe(i.removed, {
            element: t.cloneNode()
        }), t.textContent = e)), jt(w.afterSanitizeElements, t, null), !1) : (Ot(t), !0);
    }, Ut = function(t, e, i) {
        if (nt && ("id" === e || "name" === e) && (i in n || i in wt)) return !1;
        if (J && !q[e] && $741c336afc2dfa06$var$Se(I, e)) ;
        else if (H && $741c336afc2dfa06$var$Se(O, e)) ;
        else if (!W[e] || q[e]) {
            if (!(Vt(t) && (V.tagNameCheck instanceof RegExp && $741c336afc2dfa06$var$Se(V.tagNameCheck, t) || V.tagNameCheck instanceof Function && V.tagNameCheck(t)) && (V.attributeNameCheck instanceof RegExp && $741c336afc2dfa06$var$Se(V.attributeNameCheck, e) || V.attributeNameCheck instanceof Function && V.attributeNameCheck(e)) || "is" === e && V.allowCustomizedBuiltInElements && (V.tagNameCheck instanceof RegExp && $741c336afc2dfa06$var$Se(V.tagNameCheck, i) || V.tagNameCheck instanceof Function && V.tagNameCheck(i)))) return !1;
        } else if (dt[e]) ;
        else if ($741c336afc2dfa06$var$Se(B, $741c336afc2dfa06$var$ye(i, P, ""))) ;
        else if ("src" !== e && "xlink:href" !== e && "href" !== e || "script" === t || 0 !== $741c336afc2dfa06$var$xe(i, "data:") || !ut[t]) {
            if (K && !$741c336afc2dfa06$var$Se(F, $741c336afc2dfa06$var$ye(i, P, ""))) ;
            else if (i) return !1;
        }
        return !0;
    }, Vt = function(t) {
        return "annotation-xml" !== t && $741c336afc2dfa06$var$Ae(t, M);
    }, zt = function(t) {
        jt(w.beforeSanitizeAttributes, t, null);
        const { attributes: e } = t;
        if (!e || Bt(t)) return;
        const n = {
            attrName: "",
            attrValue: "",
            keepAttr: !0,
            allowedAttributes: W,
            forceKeepAttr: void 0
        };
        let r = e.length;
        for(; r--;){
            const o = e[r], { name: s, namespaceURI: a, value: l } = o, c = kt(s);
            let u = "value" === s ? l : $741c336afc2dfa06$var$Ce(l);
            if (n.attrName = c, n.attrValue = u, n.keepAttr = !0, n.forceKeepAttr = void 0, jt(w.uponSanitizeAttribute, t, n), u = n.attrValue, !rt || "id" !== c && "name" !== c || (Ft(s, t), u = "user-content-" + u), $ && $741c336afc2dfa06$var$Se(/((--!?|])>)|<\/(style|title)/i, u)) {
                Ft(s, t);
                continue;
            }
            if (n.forceKeepAttr) continue;
            if (Ft(s, t), !n.keepAttr) continue;
            if (!G && $741c336afc2dfa06$var$Se(/\/>/i, u)) {
                Ft(s, t);
                continue;
            }
            Y && $741c336afc2dfa06$var$me([
                L,
                D,
                N
            ], (t)=>{
                u = $741c336afc2dfa06$var$ye(u, t, " ");
            });
            const h = kt(t.nodeName);
            if (Ut(h, c, u)) {
                if (x && "object" == typeof m && "function" == typeof m.getAttributeType) {
                    if (a) ;
                    else switch(m.getAttributeType(h, c)){
                        case "TrustedHTML":
                            u = x.createHTML(u);
                            break;
                        case "TrustedScriptURL":
                            u = x.createScriptURL(u);
                    }
                }
                try {
                    a ? t.setAttributeNS(a, s, u) : t.setAttribute(s, u), Bt(t) ? Ot(t) : $741c336afc2dfa06$var$pe(i.removed);
                } catch (t) {}
            }
        }
        jt(w.afterSanitizeAttributes, t, null);
    }, qt = function t(e) {
        let i = null;
        const n = Mt(e);
        for(jt(w.beforeSanitizeShadowDOM, e, null); i = n.nextNode();)jt(w.uponSanitizeShadowNode, i, null), Wt(i), zt(i), i.content instanceof s && t(i.content);
        jt(w.afterSanitizeShadowDOM, e, null);
    };
    return i.sanitize = function(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = null, o = null, a = null, c = null;
        if (vt = !t, vt && (t = "\x3c!--\x3e"), "string" != typeof t && !_t(t)) {
            if ("function" != typeof t.toString) throw $741c336afc2dfa06$var$Re("toString is not a function");
            if ("string" != typeof (t = t.toString())) throw $741c336afc2dfa06$var$Re("dirty is not a string, aborting");
        }
        if (!i.isSupported) return t;
        if (Z || Dt(e), i.removed = [], "string" == typeof t && (st = !1), st) {
            if (t.nodeName) {
                const e = kt(t.nodeName);
                if (!_[e] || z[e]) throw $741c336afc2dfa06$var$Re("root node is forbidden and cannot be sanitized in-place");
            }
        } else if (t instanceof l) n = Pt("\x3c!----\x3e"), o = n.ownerDocument.importNode(t, !0), o.nodeType === $741c336afc2dfa06$var$ti && "BODY" === o.nodeName || "HTML" === o.nodeName ? n = o : n.appendChild(o);
        else {
            if (!tt && !Y && !X && -1 === t.indexOf("<")) return x && it ? x.createHTML(t) : t;
            if (n = Pt(t), !n) return tt ? null : it ? C : "";
        }
        n && Q && Ot(n.firstChild);
        const u = Mt(st ? t : n);
        for(; a = u.nextNode();)Wt(a), zt(a), a.content instanceof s && qt(a.content);
        if (st) return t;
        if (tt) {
            if (et) for(c = R.call(n.ownerDocument); n.firstChild;)c.appendChild(n.firstChild);
            else c = n;
            return (W.shadowroot || W.shadowrootmode) && (c = T.call(r, c, !0)), c;
        }
        let h = X ? n.outerHTML : n.innerHTML;
        return X && _["!doctype"] && n.ownerDocument && n.ownerDocument.doctype && n.ownerDocument.doctype.name && $741c336afc2dfa06$var$Se($741c336afc2dfa06$var$Xe, n.ownerDocument.doctype.name) && (h = "<!DOCTYPE " + n.ownerDocument.doctype.name + ">\n" + h), Y && $741c336afc2dfa06$var$me([
            L,
            D,
            N
        ], (t)=>{
            h = $741c336afc2dfa06$var$ye(h, t, " ");
        }), x && it ? x.createHTML(h) : h;
    }, i.setConfig = function() {
        Dt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Z = !0;
    }, i.clearConfig = function() {
        Tt = null, Z = !1;
    }, i.isValidAttribute = function(t, e, i) {
        Tt || Dt({});
        const n = kt(t), r = kt(e);
        return Ut(n, r, i);
    }, i.addHook = function(t, e) {
        "function" == typeof e && $741c336afc2dfa06$var$fe(w[t], e);
    }, i.removeHook = function(t) {
        return $741c336afc2dfa06$var$pe(w[t]);
    }, i.removeHooks = function(t) {
        w[t] = [];
    }, i.removeAllHooks = function() {
        w = {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    }, i;
}();
$741c336afc2dfa06$var$si.addHook("uponSanitizeAttribute", function(t, e) {
    /^data-trix-/.test(e.attrName) && (e.forceKeepAttr = !0);
});
const $741c336afc2dfa06$var$ai = "style href src width height language class".split(" "), $741c336afc2dfa06$var$li = "javascript:".split(" "), $741c336afc2dfa06$var$ci = "script iframe form noscript".split(" ");
class $741c336afc2dfa06$var$ui extends $741c336afc2dfa06$var$q {
    static setHTML(t, e) {
        const i = new this(e).sanitize(), n = i.getHTML ? i.getHTML() : i.outerHTML;
        t.innerHTML = n;
    }
    static sanitize(t, e) {
        const i = new this(t, e);
        return i.sanitize(), i;
    }
    constructor(t){
        let { allowedAttributes: e, forbiddenProtocols: i, forbiddenElements: n } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        super(...arguments), this.allowedAttributes = e || $741c336afc2dfa06$var$ai, this.forbiddenProtocols = i || $741c336afc2dfa06$var$li, this.forbiddenElements = n || $741c336afc2dfa06$var$ci, this.body = $741c336afc2dfa06$var$hi(t);
    }
    sanitize() {
        return this.sanitizeElements(), this.normalizeListElementNesting(), $741c336afc2dfa06$var$si.setConfig($741c336afc2dfa06$var$l), this.body = $741c336afc2dfa06$var$si.sanitize(this.body), this.body;
    }
    getHTML() {
        return this.body.innerHTML;
    }
    getBody() {
        return this.body;
    }
    sanitizeElements() {
        const t = $741c336afc2dfa06$var$R(this.body), e = [];
        for(; t.nextNode();){
            const i = t.currentNode;
            switch(i.nodeType){
                case Node.ELEMENT_NODE:
                    this.elementIsRemovable(i) ? e.push(i) : this.sanitizeElement(i);
                    break;
                case Node.COMMENT_NODE:
                    e.push(i);
            }
        }
        return e.forEach((t)=>$741c336afc2dfa06$var$S(t)), this.body;
    }
    sanitizeElement(t) {
        return t.hasAttribute("href") && this.forbiddenProtocols.includes(t.protocol) && t.removeAttribute("href"), Array.from(t.attributes).forEach((e)=>{
            let { name: i } = e;
            this.allowedAttributes.includes(i) || 0 === i.indexOf("data-trix") || t.removeAttribute(i);
        }), t;
    }
    normalizeListElementNesting() {
        return Array.from(this.body.querySelectorAll("ul,ol")).forEach((t)=>{
            const e = t.previousElementSibling;
            e && "li" === $741c336afc2dfa06$var$k(e) && e.appendChild(t);
        }), this.body;
    }
    elementIsRemovable(t) {
        if ((null == t ? void 0 : t.nodeType) === Node.ELEMENT_NODE) return this.elementIsForbidden(t) || this.elementIsntSerializable(t);
    }
    elementIsForbidden(t) {
        return this.forbiddenElements.includes($741c336afc2dfa06$var$k(t));
    }
    elementIsntSerializable(t) {
        return "false" === t.getAttribute("data-trix-serialize") && !$741c336afc2dfa06$var$P(t);
    }
}
const $741c336afc2dfa06$var$hi = function() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    t = t.replace(/<\/html[^>]*>[^]*$/i, "</html>");
    const e = document.implementation.createHTMLDocument("");
    return e.documentElement.innerHTML = t, Array.from(e.head.querySelectorAll("style")).forEach((t)=>{
        e.body.appendChild(t);
    }), e.body;
}, { css: $741c336afc2dfa06$var$di } = $741c336afc2dfa06$var$z;
class $741c336afc2dfa06$var$gi extends $741c336afc2dfa06$var$ie {
    constructor(){
        super(...arguments), this.attachment = this.object, this.attachment.uploadProgressDelegate = this, this.attachmentPiece = this.options.piece;
    }
    createContentNodes() {
        return [];
    }
    createNodes() {
        let t;
        const e = t = $741c336afc2dfa06$var$T({
            tagName: "figure",
            className: this.getClassName(),
            data: this.getData(),
            editable: !1
        }), i = this.getHref();
        return i && (t = $741c336afc2dfa06$var$T({
            tagName: "a",
            editable: !1,
            attributes: {
                href: i,
                tabindex: -1
            }
        }), e.appendChild(t)), this.attachment.hasContent() ? $741c336afc2dfa06$var$ui.setHTML(t, this.attachment.getContent()) : this.createContentNodes().forEach((e)=>{
            t.appendChild(e);
        }), t.appendChild(this.createCaptionElement()), this.attachment.isPending() && (this.progressElement = $741c336afc2dfa06$var$T({
            tagName: "progress",
            attributes: {
                class: $741c336afc2dfa06$var$di.attachmentProgress,
                value: this.attachment.getUploadProgress(),
                max: 100
            },
            data: {
                trixMutable: !0,
                trixStoreKey: [
                    "progressElement",
                    this.attachment.id
                ].join("/")
            }
        }), e.appendChild(this.progressElement)), [
            $741c336afc2dfa06$var$mi("left"),
            e,
            $741c336afc2dfa06$var$mi("right")
        ];
    }
    createCaptionElement() {
        const t = $741c336afc2dfa06$var$T({
            tagName: "figcaption",
            className: $741c336afc2dfa06$var$di.attachmentCaption
        }), e = this.attachmentPiece.getCaption();
        if (e) t.classList.add("".concat($741c336afc2dfa06$var$di.attachmentCaption, "--edited")), t.textContent = e;
        else {
            let e, i;
            const n = this.getCaptionConfig();
            if (n.name && (e = this.attachment.getFilename()), n.size && (i = this.attachment.getFormattedFilesize()), e) {
                const i = $741c336afc2dfa06$var$T({
                    tagName: "span",
                    className: $741c336afc2dfa06$var$di.attachmentName,
                    textContent: e
                });
                t.appendChild(i);
            }
            if (i) {
                e && t.appendChild(document.createTextNode(" "));
                const n = $741c336afc2dfa06$var$T({
                    tagName: "span",
                    className: $741c336afc2dfa06$var$di.attachmentSize,
                    textContent: i
                });
                t.appendChild(n);
            }
        }
        return t;
    }
    getClassName() {
        const t = [
            $741c336afc2dfa06$var$di.attachment,
            "".concat($741c336afc2dfa06$var$di.attachment, "--").concat(this.attachment.getType())
        ], e = this.attachment.getExtension();
        return e && t.push("".concat($741c336afc2dfa06$var$di.attachment, "--").concat(e)), t.join(" ");
    }
    getData() {
        const t = {
            trixAttachment: JSON.stringify(this.attachment),
            trixContentType: this.attachment.getContentType(),
            trixId: this.attachment.id
        }, { attributes: e } = this.attachmentPiece;
        return e.isEmpty() || (t.trixAttributes = JSON.stringify(e)), this.attachment.isPending() && (t.trixSerialize = !1), t;
    }
    getHref() {
        if (!$741c336afc2dfa06$var$pi(this.attachment.getContent(), "a")) return this.attachment.getHref();
    }
    getCaptionConfig() {
        var t;
        const e = this.attachment.getType(), n = $741c336afc2dfa06$var$kt(null === (t = $741c336afc2dfa06$var$i[e]) || void 0 === t ? void 0 : t.caption);
        return "file" === e && (n.name = !0), n;
    }
    findProgressElement() {
        var t;
        return null === (t = this.findElement()) || void 0 === t ? void 0 : t.querySelector("progress");
    }
    attachmentDidChangeUploadProgress() {
        const t = this.attachment.getUploadProgress(), e = this.findProgressElement();
        e && (e.value = t);
    }
}
const $741c336afc2dfa06$var$mi = (t)=>$741c336afc2dfa06$var$T({
        tagName: "span",
        textContent: $741c336afc2dfa06$var$d,
        data: {
            trixCursorTarget: t,
            trixSerialize: !1
        }
    }), $741c336afc2dfa06$var$pi = function(t, e) {
    const i = $741c336afc2dfa06$var$T("div");
    return $741c336afc2dfa06$var$ui.setHTML(i, t || ""), i.querySelector(e);
};
class $741c336afc2dfa06$var$fi extends $741c336afc2dfa06$var$gi {
    constructor(){
        super(...arguments), this.attachment.previewDelegate = this;
    }
    createContentNodes() {
        return this.image = $741c336afc2dfa06$var$T({
            tagName: "img",
            attributes: {
                src: ""
            },
            data: {
                trixMutable: !0
            }
        }), this.refresh(this.image), [
            this.image
        ];
    }
    createCaptionElement() {
        const t = super.createCaptionElement(...arguments);
        return t.textContent || t.setAttribute("data-trix-placeholder", $741c336afc2dfa06$var$c.captionPlaceholder), t;
    }
    refresh(t) {
        var e;
        t || (t = null === (e = this.findElement()) || void 0 === e ? void 0 : e.querySelector("img"));
        if (t) return this.updateAttributesForImage(t);
    }
    updateAttributesForImage(t) {
        const e = this.attachment.getURL(), i = this.attachment.getPreviewURL();
        if (t.src = i || e, i === e) t.removeAttribute("data-trix-serialized-attributes");
        else {
            const i = JSON.stringify({
                src: e
            });
            t.setAttribute("data-trix-serialized-attributes", i);
        }
        const n = this.attachment.getWidth(), r = this.attachment.getHeight();
        null != n && (t.width = n), null != r && (t.height = r);
        const o = [
            "imageElement",
            this.attachment.id,
            t.src,
            t.width,
            t.height
        ].join("/");
        t.dataset.trixStoreKey = o;
    }
    attachmentDidChangeAttributes() {
        return this.refresh(this.image), this.refresh();
    }
}
class $741c336afc2dfa06$var$bi extends $741c336afc2dfa06$var$ie {
    constructor(){
        super(...arguments), this.piece = this.object, this.attributes = this.piece.getAttributes(), this.textConfig = this.options.textConfig, this.context = this.options.context, this.piece.attachment ? this.attachment = this.piece.attachment : this.string = this.piece.toString();
    }
    createNodes() {
        let t = this.attachment ? this.createAttachmentNodes() : this.createStringNodes();
        const e = this.createElement();
        if (e) {
            const i = function(t) {
                for(; null !== (e = t) && void 0 !== e && e.firstElementChild;){
                    var e;
                    t = t.firstElementChild;
                }
                return t;
            }(e);
            Array.from(t).forEach((t)=>{
                i.appendChild(t);
            }), t = [
                e
            ];
        }
        return t;
    }
    createAttachmentNodes() {
        const t = this.attachment.isPreviewable() ? $741c336afc2dfa06$var$fi : $741c336afc2dfa06$var$gi;
        return this.createChildView(t, this.piece.attachment, {
            piece: this.piece
        }).getNodes();
    }
    createStringNodes() {
        var t;
        if (null !== (t = this.textConfig) && void 0 !== t && t.plaintext) return [
            document.createTextNode(this.string)
        ];
        {
            const t = [], e = this.string.split("\n");
            for(let i = 0; i < e.length; i++){
                const n = e[i];
                if (i > 0) {
                    const e = $741c336afc2dfa06$var$T("br");
                    t.push(e);
                }
                if (n.length) {
                    const e = document.createTextNode(this.preserveSpaces(n));
                    t.push(e);
                }
            }
            return t;
        }
    }
    createElement() {
        let t, e, i;
        const n = {};
        for(e in this.attributes){
            i = this.attributes[e];
            const o = $741c336afc2dfa06$var$ft(e);
            if (o) {
                if (o.tagName) {
                    var r;
                    const e = $741c336afc2dfa06$var$T(o.tagName);
                    r ? (r.appendChild(e), r = e) : t = r = e;
                }
                if (o.styleProperty && (n[o.styleProperty] = i), o.style) for(e in o.style)i = o.style[e], n[e] = i;
            }
        }
        if (Object.keys(n).length) for(e in t || (t = $741c336afc2dfa06$var$T("span")), n)i = n[e], t.style[e] = i;
        return t;
    }
    createContainerElement() {
        for(const t in this.attributes){
            const e = this.attributes[t], i = $741c336afc2dfa06$var$ft(t);
            if (i && i.groupTagName) {
                const n = {};
                return n[t] = e, $741c336afc2dfa06$var$T(i.groupTagName, n);
            }
        }
    }
    preserveSpaces(t) {
        return this.context.isLast && (t = t.replace(/\ $/, $741c336afc2dfa06$var$g)), t = t.replace(/(\S)\ {3}(\S)/g, "$1 ".concat($741c336afc2dfa06$var$g, " $2")).replace(/\ {2}/g, "".concat($741c336afc2dfa06$var$g, " ")).replace(/\ {2}/g, " ".concat($741c336afc2dfa06$var$g)), (this.context.isFirst || this.context.followsWhitespace) && (t = t.replace(/^\ /, $741c336afc2dfa06$var$g)), t;
    }
}
class $741c336afc2dfa06$var$vi extends $741c336afc2dfa06$var$ie {
    constructor(){
        super(...arguments), this.text = this.object, this.textConfig = this.options.textConfig;
    }
    createNodes() {
        const t = [], e = $741c336afc2dfa06$var$Xt.groupObjects(this.getPieces()), i = e.length - 1;
        for(let r = 0; r < e.length; r++){
            const o = e[r], s = {};
            0 === r && (s.isFirst = !0), r === i && (s.isLast = !0), $741c336afc2dfa06$var$Ai(n) && (s.followsWhitespace = !0);
            const a = this.findOrCreateCachedChildView($741c336afc2dfa06$var$bi, o, {
                textConfig: this.textConfig,
                context: s
            });
            t.push(...Array.from(a.getNodes() || []));
            var n = o;
        }
        return t;
    }
    getPieces() {
        return Array.from(this.text.getPieces()).filter((t)=>!t.hasAttribute("blockBreak"));
    }
}
const $741c336afc2dfa06$var$Ai = (t)=>/\s$/.test(null == t ? void 0 : t.toString()), { css: $741c336afc2dfa06$var$yi } = $741c336afc2dfa06$var$z;
class $741c336afc2dfa06$var$xi extends $741c336afc2dfa06$var$ie {
    constructor(){
        super(...arguments), this.block = this.object, this.attributes = this.block.getAttributes();
    }
    createNodes() {
        const t = [
            document.createComment("block")
        ];
        if (this.block.isEmpty()) t.push($741c336afc2dfa06$var$T("br"));
        else {
            var e;
            const i = null === (e = $741c336afc2dfa06$var$mt(this.block.getLastAttribute())) || void 0 === e ? void 0 : e.text, n = this.findOrCreateCachedChildView($741c336afc2dfa06$var$vi, this.block.text, {
                textConfig: i
            });
            t.push(...Array.from(n.getNodes() || [])), this.shouldAddExtraNewlineElement() && t.push($741c336afc2dfa06$var$T("br"));
        }
        if (this.attributes.length) return t;
        {
            let e;
            const { tagName: i } = $741c336afc2dfa06$var$n.default;
            this.block.isRTL() && (e = {
                dir: "rtl"
            });
            const r = $741c336afc2dfa06$var$T({
                tagName: i,
                attributes: e
            });
            return t.forEach((t)=>r.appendChild(t)), [
                r
            ];
        }
    }
    createContainerElement(t) {
        const e = {};
        let i;
        const n = this.attributes[t], { tagName: r, htmlAttributes: o = [] } = $741c336afc2dfa06$var$mt(n);
        if (0 === t && this.block.isRTL() && Object.assign(e, {
            dir: "rtl"
        }), "attachmentGallery" === n) {
            const t = this.block.getBlockBreakPosition();
            i = "".concat($741c336afc2dfa06$var$yi.attachmentGallery, " ").concat($741c336afc2dfa06$var$yi.attachmentGallery, "--").concat(t);
        }
        return Object.entries(this.block.htmlAttributes).forEach((t)=>{
            let [i, n] = t;
            o.includes(i) && (e[i] = n);
        }), $741c336afc2dfa06$var$T({
            tagName: r,
            className: i,
            attributes: e
        });
    }
    shouldAddExtraNewlineElement() {
        return /\n\n$/.test(this.block.toString());
    }
}
class $741c336afc2dfa06$var$Ci extends $741c336afc2dfa06$var$ie {
    static render(t) {
        const e = $741c336afc2dfa06$var$T("div"), i = new this(t, {
            element: e
        });
        return i.render(), i.sync(), e;
    }
    constructor(){
        super(...arguments), this.element = this.options.element, this.elementStore = new $741c336afc2dfa06$var$Qt, this.setDocument(this.object);
    }
    setDocument(t) {
        t.isEqualTo(this.document) || (this.document = this.object = t);
    }
    render() {
        if (this.childViews = [], this.shadowElement = $741c336afc2dfa06$var$T("div"), !this.document.isEmpty()) {
            const t = $741c336afc2dfa06$var$Xt.groupObjects(this.document.getBlocks(), {
                asTree: !0
            });
            Array.from(t).forEach((t)=>{
                const e = this.findOrCreateCachedChildView($741c336afc2dfa06$var$xi, t);
                Array.from(e.getNodes()).map((t)=>this.shadowElement.appendChild(t));
            });
        }
    }
    isSynced() {
        return $741c336afc2dfa06$var$Si(this.shadowElement, this.element);
    }
    sync() {
        const t = this.createDocumentFragmentForSync();
        for(; this.element.lastChild;)this.element.removeChild(this.element.lastChild);
        return this.element.appendChild(t), this.didSync();
    }
    didSync() {
        return this.elementStore.reset($741c336afc2dfa06$var$Ei(this.element)), $741c336afc2dfa06$var$Rt(()=>this.garbageCollectCachedViews());
    }
    createDocumentFragmentForSync() {
        const t = document.createDocumentFragment();
        return Array.from(this.shadowElement.childNodes).forEach((e)=>{
            t.appendChild(e.cloneNode(!0));
        }), Array.from($741c336afc2dfa06$var$Ei(t)).forEach((t)=>{
            const e = this.elementStore.remove(t);
            e && t.parentNode.replaceChild(e, t);
        }), t;
    }
}
const $741c336afc2dfa06$var$Ei = (t)=>t.querySelectorAll("[data-trix-store-key]"), $741c336afc2dfa06$var$Si = (t, e)=>$741c336afc2dfa06$var$Ri(t.innerHTML) === $741c336afc2dfa06$var$Ri(e.innerHTML), $741c336afc2dfa06$var$Ri = (t)=>t.replace(/&nbsp;/g, " ");
function $741c336afc2dfa06$var$wi(t, e, i) {
    return (e = $741c336afc2dfa06$var$Li(e)) in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function $741c336afc2dfa06$var$Li(t) {
    var e = function(t, e) {
        if ("object" != typeof t || null === t) return t;
        var i = t[Symbol.toPrimitive];
        if (void 0 !== i) {
            var n = i.call(t, e || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == typeof e ? e : String(e);
}
function $741c336afc2dfa06$var$Di(t, e) {
    return $741c336afc2dfa06$var$Oi(t, $741c336afc2dfa06$var$Ii(t, e, "get"));
}
function $741c336afc2dfa06$var$Ni(t, e, i) {
    return $741c336afc2dfa06$var$Fi(t, $741c336afc2dfa06$var$Ii(t, e, "set"), i), i;
}
function $741c336afc2dfa06$var$Ii(t, e, i) {
    if (!e.has(t)) throw new TypeError("attempted to " + i + " private field on non-instance");
    return e.get(t);
}
function $741c336afc2dfa06$var$Oi(t, e) {
    return e.get ? e.get.call(t) : e.value;
}
function $741c336afc2dfa06$var$Fi(t, e, i) {
    if (e.set) e.set.call(t, i);
    else {
        if (!e.writable) throw new TypeError("attempted to set read only private field");
        e.value = i;
    }
}
function $741c336afc2dfa06$var$Pi(t, e, i) {
    if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
    return i;
}
function $741c336afc2dfa06$var$Mi(t, e) {
    if (e.has(t)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $741c336afc2dfa06$var$Bi(t, e, i) {
    $741c336afc2dfa06$var$Mi(t, e), e.set(t, i);
}
class $741c336afc2dfa06$var$_i extends $741c336afc2dfa06$var$rt {
    static registerType(t, e) {
        e.type = t, this.types[t] = e;
    }
    static fromJSON(t) {
        const e = this.types[t.type];
        if (e) return e.fromJSON(t);
    }
    constructor(t){
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        super(...arguments), this.attributes = $741c336afc2dfa06$var$Ht.box(e);
    }
    copyWithAttributes(t) {
        return new this.constructor(this.getValue(), t);
    }
    copyWithAdditionalAttributes(t) {
        return this.copyWithAttributes(this.attributes.merge(t));
    }
    copyWithoutAttribute(t) {
        return this.copyWithAttributes(this.attributes.remove(t));
    }
    copy() {
        return this.copyWithAttributes(this.attributes);
    }
    getAttribute(t) {
        return this.attributes.get(t);
    }
    getAttributesHash() {
        return this.attributes;
    }
    getAttributes() {
        return this.attributes.toObject();
    }
    hasAttribute(t) {
        return this.attributes.has(t);
    }
    hasSameStringValueAsPiece(t) {
        return t && this.toString() === t.toString();
    }
    hasSameAttributesAsPiece(t) {
        return t && (this.attributes === t.attributes || this.attributes.isEqualTo(t.attributes));
    }
    isBlockBreak() {
        return !1;
    }
    isEqualTo(t) {
        return super.isEqualTo(...arguments) || this.hasSameConstructorAs(t) && this.hasSameStringValueAsPiece(t) && this.hasSameAttributesAsPiece(t);
    }
    isEmpty() {
        return 0 === this.length;
    }
    isSerializable() {
        return !0;
    }
    toJSON() {
        return {
            type: this.constructor.type,
            attributes: this.getAttributes()
        };
    }
    contentsForInspection() {
        return {
            type: this.constructor.type,
            attributes: this.attributes.inspect()
        };
    }
    canBeGrouped() {
        return this.hasAttribute("href");
    }
    canBeGroupedWith(t) {
        return this.getAttribute("href") === t.getAttribute("href");
    }
    getLength() {
        return this.length;
    }
    canBeConsolidatedWith(t) {
        return !1;
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$_i, "types", {});
class $741c336afc2dfa06$var$ji extends $741c336afc2dfa06$var$ee {
    constructor(t){
        super(...arguments), this.url = t;
    }
    perform(t) {
        const e = new Image;
        e.onload = ()=>(e.width = this.width = e.naturalWidth, e.height = this.height = e.naturalHeight, t(!0, e)), e.onerror = ()=>t(!1), e.src = this.url;
    }
}
class $741c336afc2dfa06$var$Wi extends $741c336afc2dfa06$var$rt {
    static attachmentForFile(t) {
        const e = new this(this.attributesForFile(t));
        return e.setFile(t), e;
    }
    static attributesForFile(t) {
        return new $741c336afc2dfa06$var$Ht({
            filename: t.name,
            filesize: t.size,
            contentType: t.type
        });
    }
    static fromJSON(t) {
        return new this(t);
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        super(t), this.releaseFile = this.releaseFile.bind(this), this.attributes = $741c336afc2dfa06$var$Ht.box(t), this.didChangeAttributes();
    }
    getAttribute(t) {
        return this.attributes.get(t);
    }
    hasAttribute(t) {
        return this.attributes.has(t);
    }
    getAttributes() {
        return this.attributes.toObject();
    }
    setAttributes() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const e = this.attributes.merge(t);
        var i, n, r, o;
        if (!this.attributes.isEqualTo(e)) return this.attributes = e, this.didChangeAttributes(), null === (i = this.previewDelegate) || void 0 === i || null === (n = i.attachmentDidChangeAttributes) || void 0 === n || n.call(i, this), null === (r = this.delegate) || void 0 === r || null === (o = r.attachmentDidChangeAttributes) || void 0 === o ? void 0 : o.call(r, this);
    }
    didChangeAttributes() {
        if (this.isPreviewable()) return this.preloadURL();
    }
    isPending() {
        return null != this.file && !(this.getURL() || this.getHref());
    }
    isPreviewable() {
        return this.attributes.has("previewable") ? this.attributes.get("previewable") : $741c336afc2dfa06$var$Wi.previewablePattern.test(this.getContentType());
    }
    getType() {
        return this.hasContent() ? "content" : this.isPreviewable() ? "preview" : "file";
    }
    getURL() {
        return this.attributes.get("url");
    }
    getHref() {
        return this.attributes.get("href");
    }
    getFilename() {
        return this.attributes.get("filename") || "";
    }
    getFilesize() {
        return this.attributes.get("filesize");
    }
    getFormattedFilesize() {
        const t = this.attributes.get("filesize");
        return "number" == typeof t ? $741c336afc2dfa06$var$h.formatter(t) : "";
    }
    getExtension() {
        var t;
        return null === (t = this.getFilename().match(/\.(\w+)$/)) || void 0 === t ? void 0 : t[1].toLowerCase();
    }
    getContentType() {
        return this.attributes.get("contentType");
    }
    hasContent() {
        return this.attributes.has("content");
    }
    getContent() {
        return this.attributes.get("content");
    }
    getWidth() {
        return this.attributes.get("width");
    }
    getHeight() {
        return this.attributes.get("height");
    }
    getFile() {
        return this.file;
    }
    setFile(t) {
        if (this.file = t, this.isPreviewable()) return this.preloadFile();
    }
    releaseFile() {
        this.releasePreloadedFile(), this.file = null;
    }
    getUploadProgress() {
        return null != this.uploadProgress ? this.uploadProgress : 0;
    }
    setUploadProgress(t) {
        var e, i;
        if (this.uploadProgress !== t) return this.uploadProgress = t, null === (e = this.uploadProgressDelegate) || void 0 === e || null === (i = e.attachmentDidChangeUploadProgress) || void 0 === i ? void 0 : i.call(e, this);
    }
    toJSON() {
        return this.getAttributes();
    }
    getCacheKey() {
        return [
            super.getCacheKey(...arguments),
            this.attributes.getCacheKey(),
            this.getPreviewURL()
        ].join("/");
    }
    getPreviewURL() {
        return this.previewURL || this.preloadingURL;
    }
    setPreviewURL(t) {
        var e, i, n, r;
        if (t !== this.getPreviewURL()) return this.previewURL = t, null === (e = this.previewDelegate) || void 0 === e || null === (i = e.attachmentDidChangeAttributes) || void 0 === i || i.call(e, this), null === (n = this.delegate) || void 0 === n || null === (r = n.attachmentDidChangePreviewURL) || void 0 === r ? void 0 : r.call(n, this);
    }
    preloadURL() {
        return this.preload(this.getURL(), this.releaseFile);
    }
    preloadFile() {
        if (this.file) return this.fileObjectURL = URL.createObjectURL(this.file), this.preload(this.fileObjectURL);
    }
    releasePreloadedFile() {
        this.fileObjectURL && (URL.revokeObjectURL(this.fileObjectURL), this.fileObjectURL = null);
    }
    preload(t, e) {
        if (t && t !== this.getPreviewURL()) {
            this.preloadingURL = t;
            return new $741c336afc2dfa06$var$ji(t).then((i)=>{
                let { width: n, height: r } = i;
                return this.getWidth() && this.getHeight() || this.setAttributes({
                    width: n,
                    height: r
                }), this.preloadingURL = null, this.setPreviewURL(t), null == e ? void 0 : e();
            }).catch(()=>(this.preloadingURL = null, null == e ? void 0 : e()));
        }
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$Wi, "previewablePattern", /^image(\/(gif|png|webp|jpe?g)|$)/);
class $741c336afc2dfa06$var$Ui extends $741c336afc2dfa06$var$_i {
    static fromJSON(t) {
        return new this($741c336afc2dfa06$var$Wi.fromJSON(t.attachment), t.attributes);
    }
    constructor(t){
        super(...arguments), this.attachment = t, this.length = 1, this.ensureAttachmentExclusivelyHasAttribute("href"), this.attachment.hasContent() || this.removeProhibitedAttributes();
    }
    ensureAttachmentExclusivelyHasAttribute(t) {
        this.hasAttribute(t) && (this.attachment.hasAttribute(t) || this.attachment.setAttributes(this.attributes.slice([
            t
        ])), this.attributes = this.attributes.remove(t));
    }
    removeProhibitedAttributes() {
        const t = this.attributes.slice($741c336afc2dfa06$var$Ui.permittedAttributes);
        t.isEqualTo(this.attributes) || (this.attributes = t);
    }
    getValue() {
        return this.attachment;
    }
    isSerializable() {
        return !this.attachment.isPending();
    }
    getCaption() {
        return this.attributes.get("caption") || "";
    }
    isEqualTo(t) {
        var e;
        return super.isEqualTo(t) && this.attachment.id === (null == t || null === (e = t.attachment) || void 0 === e ? void 0 : e.id);
    }
    toString() {
        return "\uFFFC";
    }
    toJSON() {
        const t = super.toJSON(...arguments);
        return t.attachment = this.attachment, t;
    }
    getCacheKey() {
        return [
            super.getCacheKey(...arguments),
            this.attachment.getCacheKey()
        ].join("/");
    }
    toConsole() {
        return JSON.stringify(this.toString());
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$Ui, "permittedAttributes", [
    "caption",
    "presentation"
]), $741c336afc2dfa06$var$_i.registerType("attachment", $741c336afc2dfa06$var$Ui);
class $741c336afc2dfa06$var$Vi extends $741c336afc2dfa06$var$_i {
    static fromJSON(t) {
        return new this(t.string, t.attributes);
    }
    constructor(t){
        super(...arguments), this.string = ((t)=>t.replace(/\r\n?/g, "\n"))(t), this.length = this.string.length;
    }
    getValue() {
        return this.string;
    }
    toString() {
        return this.string.toString();
    }
    isBlockBreak() {
        return "\n" === this.toString() && !0 === this.getAttribute("blockBreak");
    }
    toJSON() {
        const t = super.toJSON(...arguments);
        return t.string = this.string, t;
    }
    canBeConsolidatedWith(t) {
        return t && this.hasSameConstructorAs(t) && this.hasSameAttributesAsPiece(t);
    }
    consolidateWith(t) {
        return new this.constructor(this.toString() + t.toString(), this.attributes);
    }
    splitAtOffset(t) {
        let e, i;
        return 0 === t ? (e = null, i = this) : t === this.length ? (e = this, i = null) : (e = new this.constructor(this.string.slice(0, t), this.attributes), i = new this.constructor(this.string.slice(t), this.attributes)), [
            e,
            i
        ];
    }
    toConsole() {
        let { string: t } = this;
        return t.length > 15 && (t = t.slice(0, 14) + "\u2026"), JSON.stringify(t.toString());
    }
}
$741c336afc2dfa06$var$_i.registerType("string", $741c336afc2dfa06$var$Vi);
class $741c336afc2dfa06$var$zi extends $741c336afc2dfa06$var$rt {
    static box(t) {
        return t instanceof this ? t : new this(t);
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        super(...arguments), this.objects = t.slice(0), this.length = this.objects.length;
    }
    indexOf(t) {
        return this.objects.indexOf(t);
    }
    splice() {
        for(var t = arguments.length, e = new Array(t), i = 0; i < t; i++)e[i] = arguments[i];
        return new this.constructor($741c336afc2dfa06$var$st(this.objects, ...e));
    }
    eachObject(t) {
        return this.objects.map((e, i)=>t(e, i));
    }
    insertObjectAtIndex(t, e) {
        return this.splice(e, 0, t);
    }
    insertSplittableListAtIndex(t, e) {
        return this.splice(e, 0, ...t.objects);
    }
    insertSplittableListAtPosition(t, e) {
        const [i, n] = this.splitObjectAtPosition(e);
        return new this.constructor(i).insertSplittableListAtIndex(t, n);
    }
    editObjectAtIndex(t, e) {
        return this.replaceObjectAtIndex(e(this.objects[t]), t);
    }
    replaceObjectAtIndex(t, e) {
        return this.splice(e, 1, t);
    }
    removeObjectAtIndex(t) {
        return this.splice(t, 1);
    }
    getObjectAtIndex(t) {
        return this.objects[t];
    }
    getSplittableListInRange(t) {
        const [e, i, n] = this.splitObjectsAtRange(t);
        return new this.constructor(e.slice(i, n + 1));
    }
    selectSplittableList(t) {
        const e = this.objects.filter((e)=>t(e));
        return new this.constructor(e);
    }
    removeObjectsInRange(t) {
        const [e, i, n] = this.splitObjectsAtRange(t);
        return new this.constructor(e).splice(i, n - i + 1);
    }
    transformObjectsInRange(t, e) {
        const [i, n, r] = this.splitObjectsAtRange(t), o = i.map((t, i)=>n <= i && i <= r ? e(t) : t);
        return new this.constructor(o);
    }
    splitObjectsAtRange(t) {
        let e, [i, n, r] = this.splitObjectAtPosition($741c336afc2dfa06$var$Hi(t));
        return [i, e] = new this.constructor(i).splitObjectAtPosition($741c336afc2dfa06$var$Ji(t) + r), [
            i,
            n,
            e - 1
        ];
    }
    getObjectAtPosition(t) {
        const { index: e } = this.findIndexAndOffsetAtPosition(t);
        return this.objects[e];
    }
    splitObjectAtPosition(t) {
        let e, i;
        const { index: n, offset: r } = this.findIndexAndOffsetAtPosition(t), o = this.objects.slice(0);
        if (null != n) {
            if (0 === r) e = n, i = 0;
            else {
                const t = this.getObjectAtIndex(n), [s, a] = t.splitAtOffset(r);
                o.splice(n, 1, s, a), e = n + 1, i = s.getLength() - r;
            }
        } else e = o.length, i = 0;
        return [
            o,
            e,
            i
        ];
    }
    consolidate() {
        const t = [];
        let e = this.objects[0];
        return this.objects.slice(1).forEach((i)=>{
            var n, r;
            null !== (n = (r = e).canBeConsolidatedWith) && void 0 !== n && n.call(r, i) ? e = e.consolidateWith(i) : (t.push(e), e = i);
        }), e && t.push(e), new this.constructor(t);
    }
    consolidateFromIndexToIndex(t, e) {
        const i = this.objects.slice(0).slice(t, e + 1), n = new this.constructor(i).consolidate().toArray();
        return this.splice(t, i.length, ...n);
    }
    findIndexAndOffsetAtPosition(t) {
        let e, i = 0;
        for(e = 0; e < this.objects.length; e++){
            const n = i + this.objects[e].getLength();
            if (i <= t && t < n) return {
                index: e,
                offset: t - i
            };
            i = n;
        }
        return {
            index: null,
            offset: null
        };
    }
    findPositionAtIndexAndOffset(t, e) {
        let i = 0;
        for(let n = 0; n < this.objects.length; n++){
            const r = this.objects[n];
            if (n < t) i += r.getLength();
            else if (n === t) {
                i += e;
                break;
            }
        }
        return i;
    }
    getEndPosition() {
        return null == this.endPosition && (this.endPosition = 0, this.objects.forEach((t)=>this.endPosition += t.getLength())), this.endPosition;
    }
    toString() {
        return this.objects.join("");
    }
    toArray() {
        return this.objects.slice(0);
    }
    toJSON() {
        return this.toArray();
    }
    isEqualTo(t) {
        return super.isEqualTo(...arguments) || $741c336afc2dfa06$var$qi(this.objects, null == t ? void 0 : t.objects);
    }
    contentsForInspection() {
        return {
            objects: "[".concat(this.objects.map((t)=>t.inspect()).join(", "), "]")
        };
    }
}
const $741c336afc2dfa06$var$qi = function(t) {
    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    if (t.length !== e.length) return !1;
    let i = !0;
    for(let n = 0; n < t.length; n++){
        const r = t[n];
        i && !r.isEqualTo(e[n]) && (i = !1);
    }
    return i;
}, $741c336afc2dfa06$var$Hi = (t)=>t[0], $741c336afc2dfa06$var$Ji = (t)=>t[1];
class $741c336afc2dfa06$var$Ki extends $741c336afc2dfa06$var$rt {
    static textForAttachmentWithAttributes(t, e) {
        return new this([
            new $741c336afc2dfa06$var$Ui(t, e)
        ]);
    }
    static textForStringWithAttributes(t, e) {
        return new this([
            new $741c336afc2dfa06$var$Vi(t, e)
        ]);
    }
    static fromJSON(t) {
        return new this(Array.from(t).map((t)=>$741c336afc2dfa06$var$_i.fromJSON(t)));
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        super(...arguments);
        const e = t.filter((t)=>!t.isEmpty());
        this.pieceList = new $741c336afc2dfa06$var$zi(e);
    }
    copy() {
        return this.copyWithPieceList(this.pieceList);
    }
    copyWithPieceList(t) {
        return new this.constructor(t.consolidate().toArray());
    }
    copyUsingObjectMap(t) {
        const e = this.getPieces().map((e)=>t.find(e) || e);
        return new this.constructor(e);
    }
    appendText(t) {
        return this.insertTextAtPosition(t, this.getLength());
    }
    insertTextAtPosition(t, e) {
        return this.copyWithPieceList(this.pieceList.insertSplittableListAtPosition(t.pieceList, e));
    }
    removeTextAtRange(t) {
        return this.copyWithPieceList(this.pieceList.removeObjectsInRange(t));
    }
    replaceTextAtRange(t, e) {
        return this.removeTextAtRange(e).insertTextAtPosition(t, e[0]);
    }
    moveTextFromRangeToPosition(t, e) {
        if (t[0] <= e && e <= t[1]) return;
        const i = this.getTextAtRange(t), n = i.getLength();
        return t[0] < e && (e -= n), this.removeTextAtRange(t).insertTextAtPosition(i, e);
    }
    addAttributeAtRange(t, e, i) {
        const n = {};
        return n[t] = e, this.addAttributesAtRange(n, i);
    }
    addAttributesAtRange(t, e) {
        return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, (e)=>e.copyWithAdditionalAttributes(t)));
    }
    removeAttributeAtRange(t, e) {
        return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, (e)=>e.copyWithoutAttribute(t)));
    }
    setAttributesAtRange(t, e) {
        return this.copyWithPieceList(this.pieceList.transformObjectsInRange(e, (e)=>e.copyWithAttributes(t)));
    }
    getAttributesAtPosition(t) {
        var e;
        return (null === (e = this.pieceList.getObjectAtPosition(t)) || void 0 === e ? void 0 : e.getAttributes()) || {};
    }
    getCommonAttributes() {
        const t = Array.from(this.pieceList.toArray()).map((t)=>t.getAttributes());
        return $741c336afc2dfa06$var$Ht.fromCommonAttributesOfObjects(t).toObject();
    }
    getCommonAttributesAtRange(t) {
        return this.getTextAtRange(t).getCommonAttributes() || {};
    }
    getExpandedRangeForAttributeAtOffset(t, e) {
        let i, n = i = e;
        const r = this.getLength();
        for(; n > 0 && this.getCommonAttributesAtRange([
            n - 1,
            i
        ])[t];)n--;
        for(; i < r && this.getCommonAttributesAtRange([
            e,
            i + 1
        ])[t];)i++;
        return [
            n,
            i
        ];
    }
    getTextAtRange(t) {
        return this.copyWithPieceList(this.pieceList.getSplittableListInRange(t));
    }
    getStringAtRange(t) {
        return this.pieceList.getSplittableListInRange(t).toString();
    }
    getStringAtPosition(t) {
        return this.getStringAtRange([
            t,
            t + 1
        ]);
    }
    startsWithString(t) {
        return this.getStringAtRange([
            0,
            t.length
        ]) === t;
    }
    endsWithString(t) {
        const e = this.getLength();
        return this.getStringAtRange([
            e - t.length,
            e
        ]) === t;
    }
    getAttachmentPieces() {
        return this.pieceList.toArray().filter((t)=>!!t.attachment);
    }
    getAttachments() {
        return this.getAttachmentPieces().map((t)=>t.attachment);
    }
    getAttachmentAndPositionById(t) {
        let e = 0;
        for (const n of this.pieceList.toArray()){
            var i;
            if ((null === (i = n.attachment) || void 0 === i ? void 0 : i.id) === t) return {
                attachment: n.attachment,
                position: e
            };
            e += n.length;
        }
        return {
            attachment: null,
            position: null
        };
    }
    getAttachmentById(t) {
        const { attachment: e } = this.getAttachmentAndPositionById(t);
        return e;
    }
    getRangeOfAttachment(t) {
        const e = this.getAttachmentAndPositionById(t.id), i = e.position;
        if (t = e.attachment) return [
            i,
            i + 1
        ];
    }
    updateAttributesForAttachment(t, e) {
        const i = this.getRangeOfAttachment(e);
        return i ? this.addAttributesAtRange(t, i) : this;
    }
    getLength() {
        return this.pieceList.getEndPosition();
    }
    isEmpty() {
        return 0 === this.getLength();
    }
    isEqualTo(t) {
        var e;
        return super.isEqualTo(t) || (null == t || null === (e = t.pieceList) || void 0 === e ? void 0 : e.isEqualTo(this.pieceList));
    }
    isBlockBreak() {
        return 1 === this.getLength() && this.pieceList.getObjectAtIndex(0).isBlockBreak();
    }
    eachPiece(t) {
        return this.pieceList.eachObject(t);
    }
    getPieces() {
        return this.pieceList.toArray();
    }
    getPieceAtPosition(t) {
        return this.pieceList.getObjectAtPosition(t);
    }
    contentsForInspection() {
        return {
            pieceList: this.pieceList.inspect()
        };
    }
    toSerializableText() {
        const t = this.pieceList.selectSplittableList((t)=>t.isSerializable());
        return this.copyWithPieceList(t);
    }
    toString() {
        return this.pieceList.toString();
    }
    toJSON() {
        return this.pieceList.toJSON();
    }
    toConsole() {
        return JSON.stringify(this.pieceList.toArray().map((t)=>JSON.parse(t.toConsole())));
    }
    getDirection() {
        return $741c336afc2dfa06$var$lt(this.toString());
    }
    isRTL() {
        return "rtl" === this.getDirection();
    }
}
class $741c336afc2dfa06$var$Gi extends $741c336afc2dfa06$var$rt {
    static fromJSON(t) {
        return new this($741c336afc2dfa06$var$Ki.fromJSON(t.text), t.attributes, t.htmlAttributes);
    }
    constructor(t, e, i){
        super(...arguments), this.text = $741c336afc2dfa06$var$Yi(t || new $741c336afc2dfa06$var$Ki), this.attributes = e || [], this.htmlAttributes = i || {};
    }
    isEmpty() {
        return this.text.isBlockBreak();
    }
    isEqualTo(t) {
        return !!super.isEqualTo(t) || this.text.isEqualTo(null == t ? void 0 : t.text) && $741c336afc2dfa06$var$ot(this.attributes, null == t ? void 0 : t.attributes) && $741c336afc2dfa06$var$Tt(this.htmlAttributes, null == t ? void 0 : t.htmlAttributes);
    }
    copyWithText(t) {
        return new $741c336afc2dfa06$var$Gi(t, this.attributes, this.htmlAttributes);
    }
    copyWithoutText() {
        return this.copyWithText(null);
    }
    copyWithAttributes(t) {
        return new $741c336afc2dfa06$var$Gi(this.text, t, this.htmlAttributes);
    }
    copyWithoutAttributes() {
        return this.copyWithAttributes(null);
    }
    copyUsingObjectMap(t) {
        const e = t.find(this.text);
        return e ? this.copyWithText(e) : this.copyWithText(this.text.copyUsingObjectMap(t));
    }
    addAttribute(t) {
        const e = this.attributes.concat($741c336afc2dfa06$var$en(t));
        return this.copyWithAttributes(e);
    }
    addHTMLAttribute(t, e) {
        const i = Object.assign({}, this.htmlAttributes, {
            [t]: e
        });
        return new $741c336afc2dfa06$var$Gi(this.text, this.attributes, i);
    }
    removeAttribute(t) {
        const { listAttribute: e } = $741c336afc2dfa06$var$mt(t), i = $741c336afc2dfa06$var$rn($741c336afc2dfa06$var$rn(this.attributes, t), e);
        return this.copyWithAttributes(i);
    }
    removeLastAttribute() {
        return this.removeAttribute(this.getLastAttribute());
    }
    getLastAttribute() {
        return $741c336afc2dfa06$var$nn(this.attributes);
    }
    getAttributes() {
        return this.attributes.slice(0);
    }
    getAttributeLevel() {
        return this.attributes.length;
    }
    getAttributeAtLevel(t) {
        return this.attributes[t - 1];
    }
    hasAttribute(t) {
        return this.attributes.includes(t);
    }
    hasAttributes() {
        return this.getAttributeLevel() > 0;
    }
    getLastNestableAttribute() {
        return $741c336afc2dfa06$var$nn(this.getNestableAttributes());
    }
    getNestableAttributes() {
        return this.attributes.filter((t)=>$741c336afc2dfa06$var$mt(t).nestable);
    }
    getNestingLevel() {
        return this.getNestableAttributes().length;
    }
    decreaseNestingLevel() {
        const t = this.getLastNestableAttribute();
        return t ? this.removeAttribute(t) : this;
    }
    increaseNestingLevel() {
        const t = this.getLastNestableAttribute();
        if (t) {
            const e = this.attributes.lastIndexOf(t), i = $741c336afc2dfa06$var$st(this.attributes, e + 1, 0, ...$741c336afc2dfa06$var$en(t));
            return this.copyWithAttributes(i);
        }
        return this;
    }
    getListItemAttributes() {
        return this.attributes.filter((t)=>$741c336afc2dfa06$var$mt(t).listAttribute);
    }
    isListItem() {
        var t;
        return null === (t = $741c336afc2dfa06$var$mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.listAttribute;
    }
    isTerminalBlock() {
        var t;
        return null === (t = $741c336afc2dfa06$var$mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.terminal;
    }
    breaksOnReturn() {
        var t;
        return null === (t = $741c336afc2dfa06$var$mt(this.getLastAttribute())) || void 0 === t ? void 0 : t.breakOnReturn;
    }
    findLineBreakInDirectionFromPosition(t, e) {
        const i = this.toString();
        let n;
        switch(t){
            case "forward":
                n = i.indexOf("\n", e);
                break;
            case "backward":
                n = i.slice(0, e).lastIndexOf("\n");
        }
        if (-1 !== n) return n;
    }
    contentsForInspection() {
        return {
            text: this.text.inspect(),
            attributes: this.attributes
        };
    }
    toString() {
        return this.text.toString();
    }
    toJSON() {
        return {
            text: this.text,
            attributes: this.attributes,
            htmlAttributes: this.htmlAttributes
        };
    }
    getDirection() {
        return this.text.getDirection();
    }
    isRTL() {
        return this.text.isRTL();
    }
    getLength() {
        return this.text.getLength();
    }
    canBeConsolidatedWith(t) {
        return !this.hasAttributes() && !t.hasAttributes() && this.getDirection() === t.getDirection();
    }
    consolidateWith(t) {
        const e = $741c336afc2dfa06$var$Ki.textForStringWithAttributes("\n"), i = this.getTextWithoutBlockBreak().appendText(e);
        return this.copyWithText(i.appendText(t.text));
    }
    splitAtOffset(t) {
        let e, i;
        return 0 === t ? (e = null, i = this) : t === this.getLength() ? (e = this, i = null) : (e = this.copyWithText(this.text.getTextAtRange([
            0,
            t
        ])), i = this.copyWithText(this.text.getTextAtRange([
            t,
            this.getLength()
        ]))), [
            e,
            i
        ];
    }
    getBlockBreakPosition() {
        return this.text.getLength() - 1;
    }
    getTextWithoutBlockBreak() {
        return $741c336afc2dfa06$var$Qi(this.text) ? this.text.getTextAtRange([
            0,
            this.getBlockBreakPosition()
        ]) : this.text.copy();
    }
    canBeGrouped(t) {
        return this.attributes[t];
    }
    canBeGroupedWith(t, e) {
        const i = t.getAttributes(), r = i[e], o = this.attributes[e];
        return o === r && !(!1 === $741c336afc2dfa06$var$mt(o).group && !(()=>{
            if (!$741c336afc2dfa06$var$dt) {
                $741c336afc2dfa06$var$dt = [];
                for(const t in $741c336afc2dfa06$var$n){
                    const { listAttribute: e } = $741c336afc2dfa06$var$n[t];
                    null != e && $741c336afc2dfa06$var$dt.push(e);
                }
            }
            return $741c336afc2dfa06$var$dt;
        })().includes(i[e + 1])) && (this.getDirection() === t.getDirection() || t.isEmpty());
    }
}
const $741c336afc2dfa06$var$Yi = function(t) {
    return t = $741c336afc2dfa06$var$$i(t), t = $741c336afc2dfa06$var$Zi(t);
}, $741c336afc2dfa06$var$$i = function(t) {
    let e = !1;
    const i = t.getPieces();
    let n = i.slice(0, i.length - 1);
    const r = i[i.length - 1];
    return r ? (n = n.map((t)=>t.isBlockBreak() ? (e = !0, $741c336afc2dfa06$var$tn(t)) : t), e ? new $741c336afc2dfa06$var$Ki([
        ...n,
        r
    ]) : t) : t;
}, $741c336afc2dfa06$var$Xi = $741c336afc2dfa06$var$Ki.textForStringWithAttributes("\n", {
    blockBreak: !0
}), $741c336afc2dfa06$var$Zi = function(t) {
    return $741c336afc2dfa06$var$Qi(t) ? t : t.appendText($741c336afc2dfa06$var$Xi);
}, $741c336afc2dfa06$var$Qi = function(t) {
    const e = t.getLength();
    if (0 === e) return !1;
    return t.getTextAtRange([
        e - 1,
        e
    ]).isBlockBreak();
}, $741c336afc2dfa06$var$tn = (t)=>t.copyWithoutAttribute("blockBreak"), $741c336afc2dfa06$var$en = function(t) {
    const { listAttribute: e } = $741c336afc2dfa06$var$mt(t);
    return e ? [
        e,
        t
    ] : [
        t
    ];
}, $741c336afc2dfa06$var$nn = (t)=>t.slice(-1)[0], $741c336afc2dfa06$var$rn = function(t, e) {
    const i = t.lastIndexOf(e);
    return -1 === i ? t : $741c336afc2dfa06$var$st(t, i, 1);
};
class $741c336afc2dfa06$var$on extends $741c336afc2dfa06$var$rt {
    static fromJSON(t) {
        return new this(Array.from(t).map((t)=>$741c336afc2dfa06$var$Gi.fromJSON(t)));
    }
    static fromString(t, e) {
        const i = $741c336afc2dfa06$var$Ki.textForStringWithAttributes(t, e);
        return new this([
            new $741c336afc2dfa06$var$Gi(i)
        ]);
    }
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        super(...arguments), 0 === t.length && (t = [
            new $741c336afc2dfa06$var$Gi
        ]), this.blockList = $741c336afc2dfa06$var$zi.box(t);
    }
    isEmpty() {
        const t = this.getBlockAtIndex(0);
        return 1 === this.blockList.length && t.isEmpty() && !t.hasAttributes();
    }
    copy() {
        const t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).consolidateBlocks ? this.blockList.consolidate().toArray() : this.blockList.toArray();
        return new this.constructor(t);
    }
    copyUsingObjectsFromDocument(t) {
        const e = new $741c336afc2dfa06$var$Zt(t.getObjects());
        return this.copyUsingObjectMap(e);
    }
    copyUsingObjectMap(t) {
        const e = this.getBlocks().map((e)=>t.find(e) || e.copyUsingObjectMap(t));
        return new this.constructor(e);
    }
    copyWithBaseBlockAttributes() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        const e = this.getBlocks().map((e)=>{
            const i = t.concat(e.getAttributes());
            return e.copyWithAttributes(i);
        });
        return new this.constructor(e);
    }
    replaceBlock(t, e) {
        const i = this.blockList.indexOf(t);
        return -1 === i ? this : new this.constructor(this.blockList.replaceObjectAtIndex(e, i));
    }
    insertDocumentAtRange(t, e) {
        const { blockList: i } = t;
        e = $741c336afc2dfa06$var$wt(e);
        let [n] = e;
        const { index: r, offset: o } = this.locationFromPosition(n);
        let s = this;
        const a = this.getBlockAtPosition(n);
        return $741c336afc2dfa06$var$Lt(e) && a.isEmpty() && !a.hasAttributes() ? s = new this.constructor(s.blockList.removeObjectAtIndex(r)) : a.getBlockBreakPosition() === o && n++, s = s.removeTextAtRange(e), new this.constructor(s.blockList.insertSplittableListAtPosition(i, n));
    }
    mergeDocumentAtRange(t, e) {
        let i, n;
        e = $741c336afc2dfa06$var$wt(e);
        const [r] = e, o = this.locationFromPosition(r), s = this.getBlockAtIndex(o.index).getAttributes(), a = t.getBaseBlockAttributes(), l = s.slice(-a.length);
        if ($741c336afc2dfa06$var$ot(a, l)) {
            const e = s.slice(0, -a.length);
            i = t.copyWithBaseBlockAttributes(e);
        } else i = t.copy({
            consolidateBlocks: !0
        }).copyWithBaseBlockAttributes(s);
        const c = i.getBlockCount(), u = i.getBlockAtIndex(0);
        if ($741c336afc2dfa06$var$ot(s, u.getAttributes())) {
            const t = u.getTextWithoutBlockBreak();
            if (n = this.insertTextAtRange(t, e), c > 1) {
                i = new this.constructor(i.getBlocks().slice(1));
                const e = r + t.getLength();
                n = n.insertDocumentAtRange(i, e);
            }
        } else n = this.insertDocumentAtRange(i, e);
        return n;
    }
    insertTextAtRange(t, e) {
        e = $741c336afc2dfa06$var$wt(e);
        const [i] = e, { index: n, offset: r } = this.locationFromPosition(i), o = this.removeTextAtRange(e);
        return new this.constructor(o.blockList.editObjectAtIndex(n, (e)=>e.copyWithText(e.text.insertTextAtPosition(t, r))));
    }
    removeTextAtRange(t) {
        let e;
        t = $741c336afc2dfa06$var$wt(t);
        const [i, n] = t;
        if ($741c336afc2dfa06$var$Lt(t)) return this;
        const [r, o] = Array.from(this.locationRangeFromRange(t)), s = r.index, a = r.offset, l = this.getBlockAtIndex(s), c = o.index, u = o.offset, h = this.getBlockAtIndex(c);
        if (n - i == 1 && l.getBlockBreakPosition() === a && h.getBlockBreakPosition() !== u && "\n" === h.text.getStringAtPosition(u)) e = this.blockList.editObjectAtIndex(c, (t)=>t.copyWithText(t.text.removeTextAtRange([
                u,
                u + 1
            ])));
        else {
            let t;
            const i = l.text.getTextAtRange([
                0,
                a
            ]), n = h.text.getTextAtRange([
                u,
                h.getLength()
            ]), r = i.appendText(n);
            t = s !== c && 0 === a && l.getAttributeLevel() >= h.getAttributeLevel() ? h.copyWithText(r) : l.copyWithText(r);
            const o = c + 1 - s;
            e = this.blockList.splice(s, o, t);
        }
        return new this.constructor(e);
    }
    moveTextFromRangeToPosition(t, e) {
        let i;
        t = $741c336afc2dfa06$var$wt(t);
        const [n, r] = t;
        if (n <= e && e <= r) return this;
        let o = this.getDocumentAtRange(t), s = this.removeTextAtRange(t);
        const a = n < e;
        a && (e -= o.getLength());
        const [l, ...c] = o.getBlocks();
        return 0 === c.length ? (i = l.getTextWithoutBlockBreak(), a && (e += 1)) : i = l.text, s = s.insertTextAtRange(i, e), 0 === c.length ? s : (o = new this.constructor(c), e += i.getLength(), s.insertDocumentAtRange(o, e));
    }
    addAttributeAtRange(t, e, i) {
        let { blockList: n } = this;
        return this.eachBlockAtRange(i, (i, r, o)=>n = n.editObjectAtIndex(o, function() {
                return $741c336afc2dfa06$var$mt(t) ? i.addAttribute(t, e) : r[0] === r[1] ? i : i.copyWithText(i.text.addAttributeAtRange(t, e, r));
            })), new this.constructor(n);
    }
    addAttribute(t, e) {
        let { blockList: i } = this;
        return this.eachBlock((n, r)=>i = i.editObjectAtIndex(r, ()=>n.addAttribute(t, e))), new this.constructor(i);
    }
    removeAttributeAtRange(t, e) {
        let { blockList: i } = this;
        return this.eachBlockAtRange(e, function(e, n, r) {
            $741c336afc2dfa06$var$mt(t) ? i = i.editObjectAtIndex(r, ()=>e.removeAttribute(t)) : n[0] !== n[1] && (i = i.editObjectAtIndex(r, ()=>e.copyWithText(e.text.removeAttributeAtRange(t, n))));
        }), new this.constructor(i);
    }
    updateAttributesForAttachment(t, e) {
        const i = this.getRangeOfAttachment(e), [n] = Array.from(i), { index: r } = this.locationFromPosition(n), o = this.getTextAtIndex(r);
        return new this.constructor(this.blockList.editObjectAtIndex(r, (i)=>i.copyWithText(o.updateAttributesForAttachment(t, e))));
    }
    removeAttributeForAttachment(t, e) {
        const i = this.getRangeOfAttachment(e);
        return this.removeAttributeAtRange(t, i);
    }
    setHTMLAttributeAtPosition(t, e, i) {
        const n = this.getBlockAtPosition(t), r = n.addHTMLAttribute(e, i);
        return this.replaceBlock(n, r);
    }
    insertBlockBreakAtRange(t) {
        let e;
        t = $741c336afc2dfa06$var$wt(t);
        const [i] = t, { offset: n } = this.locationFromPosition(i), r = this.removeTextAtRange(t);
        return 0 === n && (e = [
            new $741c336afc2dfa06$var$Gi
        ]), new this.constructor(r.blockList.insertSplittableListAtPosition(new $741c336afc2dfa06$var$zi(e), i));
    }
    applyBlockAttributeAtRange(t, e, i) {
        const n = this.expandRangeToLineBreaksAndSplitBlocks(i);
        let r = n.document;
        i = n.range;
        const o = $741c336afc2dfa06$var$mt(t);
        if (o.listAttribute) {
            r = r.removeLastListAttributeAtRange(i, {
                exceptAttributeName: t
            });
            const e = r.convertLineBreaksToBlockBreaksInRange(i);
            r = e.document, i = e.range;
        } else r = o.exclusive ? r.removeBlockAttributesAtRange(i) : o.terminal ? r.removeLastTerminalAttributeAtRange(i) : r.consolidateBlocksAtRange(i);
        return r.addAttributeAtRange(t, e, i);
    }
    removeLastListAttributeAtRange(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { blockList: i } = this;
        return this.eachBlockAtRange(t, function(t, n, r) {
            const o = t.getLastAttribute();
            o && $741c336afc2dfa06$var$mt(o).listAttribute && o !== e.exceptAttributeName && (i = i.editObjectAtIndex(r, ()=>t.removeAttribute(o)));
        }), new this.constructor(i);
    }
    removeLastTerminalAttributeAtRange(t) {
        let { blockList: e } = this;
        return this.eachBlockAtRange(t, function(t, i, n) {
            const r = t.getLastAttribute();
            r && $741c336afc2dfa06$var$mt(r).terminal && (e = e.editObjectAtIndex(n, ()=>t.removeAttribute(r)));
        }), new this.constructor(e);
    }
    removeBlockAttributesAtRange(t) {
        let { blockList: e } = this;
        return this.eachBlockAtRange(t, function(t, i, n) {
            t.hasAttributes() && (e = e.editObjectAtIndex(n, ()=>t.copyWithoutAttributes()));
        }), new this.constructor(e);
    }
    expandRangeToLineBreaksAndSplitBlocks(t) {
        let e;
        t = $741c336afc2dfa06$var$wt(t);
        let [i, n] = t;
        const r = this.locationFromPosition(i), o = this.locationFromPosition(n);
        let s = this;
        const a = s.getBlockAtIndex(r.index);
        if (r.offset = a.findLineBreakInDirectionFromPosition("backward", r.offset), null != r.offset && (e = s.positionFromLocation(r), s = s.insertBlockBreakAtRange([
            e,
            e + 1
        ]), o.index += 1, o.offset -= s.getBlockAtIndex(r.index).getLength(), r.index += 1), r.offset = 0, 0 === o.offset && o.index > r.index) o.index -= 1, o.offset = s.getBlockAtIndex(o.index).getBlockBreakPosition();
        else {
            const t = s.getBlockAtIndex(o.index);
            "\n" === t.text.getStringAtRange([
                o.offset - 1,
                o.offset
            ]) ? o.offset -= 1 : o.offset = t.findLineBreakInDirectionFromPosition("forward", o.offset), o.offset !== t.getBlockBreakPosition() && (e = s.positionFromLocation(o), s = s.insertBlockBreakAtRange([
                e,
                e + 1
            ]));
        }
        return i = s.positionFromLocation(r), n = s.positionFromLocation(o), {
            document: s,
            range: t = $741c336afc2dfa06$var$wt([
                i,
                n
            ])
        };
    }
    convertLineBreaksToBlockBreaksInRange(t) {
        t = $741c336afc2dfa06$var$wt(t);
        let [e] = t;
        const i = this.getStringAtRange(t).slice(0, -1);
        let n = this;
        return i.replace(/.*?\n/g, function(t) {
            e += t.length, n = n.insertBlockBreakAtRange([
                e - 1,
                e
            ]);
        }), {
            document: n,
            range: t
        };
    }
    consolidateBlocksAtRange(t) {
        t = $741c336afc2dfa06$var$wt(t);
        const [e, i] = t, n = this.locationFromPosition(e).index, r = this.locationFromPosition(i).index;
        return new this.constructor(this.blockList.consolidateFromIndexToIndex(n, r));
    }
    getDocumentAtRange(t) {
        t = $741c336afc2dfa06$var$wt(t);
        const e = this.blockList.getSplittableListInRange(t).toArray();
        return new this.constructor(e);
    }
    getStringAtRange(t) {
        let e;
        const i = t = $741c336afc2dfa06$var$wt(t);
        return i[i.length - 1] !== this.getLength() && (e = -1), this.getDocumentAtRange(t).toString().slice(0, e);
    }
    getBlockAtIndex(t) {
        return this.blockList.getObjectAtIndex(t);
    }
    getBlockAtPosition(t) {
        const { index: e } = this.locationFromPosition(t);
        return this.getBlockAtIndex(e);
    }
    getTextAtIndex(t) {
        var e;
        return null === (e = this.getBlockAtIndex(t)) || void 0 === e ? void 0 : e.text;
    }
    getTextAtPosition(t) {
        const { index: e } = this.locationFromPosition(t);
        return this.getTextAtIndex(e);
    }
    getPieceAtPosition(t) {
        const { index: e, offset: i } = this.locationFromPosition(t);
        return this.getTextAtIndex(e).getPieceAtPosition(i);
    }
    getCharacterAtPosition(t) {
        const { index: e, offset: i } = this.locationFromPosition(t);
        return this.getTextAtIndex(e).getStringAtRange([
            i,
            i + 1
        ]);
    }
    getLength() {
        return this.blockList.getEndPosition();
    }
    getBlocks() {
        return this.blockList.toArray();
    }
    getBlockCount() {
        return this.blockList.length;
    }
    getEditCount() {
        return this.editCount;
    }
    eachBlock(t) {
        return this.blockList.eachObject(t);
    }
    eachBlockAtRange(t, e) {
        let i, n;
        t = $741c336afc2dfa06$var$wt(t);
        const [r, o] = t, s = this.locationFromPosition(r), a = this.locationFromPosition(o);
        if (s.index === a.index) return i = this.getBlockAtIndex(s.index), n = [
            s.offset,
            a.offset
        ], e(i, n, s.index);
        for(let t = s.index; t <= a.index; t++)if (i = this.getBlockAtIndex(t), i) {
            switch(t){
                case s.index:
                    n = [
                        s.offset,
                        i.text.getLength()
                    ];
                    break;
                case a.index:
                    n = [
                        0,
                        a.offset
                    ];
                    break;
                default:
                    n = [
                        0,
                        i.text.getLength()
                    ];
            }
            e(i, n, t);
        }
    }
    getCommonAttributesAtRange(t) {
        t = $741c336afc2dfa06$var$wt(t);
        const [e] = t;
        if ($741c336afc2dfa06$var$Lt(t)) return this.getCommonAttributesAtPosition(e);
        {
            const e = [], i = [];
            return this.eachBlockAtRange(t, function(t, n) {
                if (n[0] !== n[1]) return e.push(t.text.getCommonAttributesAtRange(n)), i.push($741c336afc2dfa06$var$sn(t));
            }), $741c336afc2dfa06$var$Ht.fromCommonAttributesOfObjects(e).merge($741c336afc2dfa06$var$Ht.fromCommonAttributesOfObjects(i)).toObject();
        }
    }
    getCommonAttributesAtPosition(t) {
        let e, i;
        const { index: n, offset: r } = this.locationFromPosition(t), o = this.getBlockAtIndex(n);
        if (!o) return {};
        const s = $741c336afc2dfa06$var$sn(o), a = o.text.getAttributesAtPosition(r), l = o.text.getAttributesAtPosition(r - 1), c = Object.keys($741c336afc2dfa06$var$W).filter((t)=>$741c336afc2dfa06$var$W[t].inheritable);
        for(e in l)i = l[e], (i === a[e] || c.includes(e)) && (s[e] = i);
        return s;
    }
    getRangeOfCommonAttributeAtPosition(t, e) {
        const { index: i, offset: n } = this.locationFromPosition(e), r = this.getTextAtIndex(i), [o, s] = Array.from(r.getExpandedRangeForAttributeAtOffset(t, n)), a = this.positionFromLocation({
            index: i,
            offset: o
        }), l = this.positionFromLocation({
            index: i,
            offset: s
        });
        return $741c336afc2dfa06$var$wt([
            a,
            l
        ]);
    }
    getBaseBlockAttributes() {
        let t = this.getBlockAtIndex(0).getAttributes();
        for(let e = 1; e < this.getBlockCount(); e++){
            const i = this.getBlockAtIndex(e).getAttributes(), n = Math.min(t.length, i.length);
            t = (()=>{
                const e = [];
                for(let r = 0; r < n && i[r] === t[r]; r++)e.push(i[r]);
                return e;
            })();
        }
        return t;
    }
    getAttachmentById(t) {
        for (const e of this.getAttachments())if (e.id === t) return e;
    }
    getAttachmentPieces() {
        let t = [];
        return this.blockList.eachObject((e)=>{
            let { text: i } = e;
            return t = t.concat(i.getAttachmentPieces());
        }), t;
    }
    getAttachments() {
        return this.getAttachmentPieces().map((t)=>t.attachment);
    }
    getRangeOfAttachment(t) {
        let e = 0;
        const i = this.blockList.toArray();
        for(let n = 0; n < i.length; n++){
            const { text: r } = i[n], o = r.getRangeOfAttachment(t);
            if (o) return $741c336afc2dfa06$var$wt([
                e + o[0],
                e + o[1]
            ]);
            e += r.getLength();
        }
    }
    getLocationRangeOfAttachment(t) {
        const e = this.getRangeOfAttachment(t);
        return this.locationRangeFromRange(e);
    }
    getAttachmentPieceForAttachment(t) {
        for (const e of this.getAttachmentPieces())if (e.attachment === t) return e;
    }
    findRangesForBlockAttribute(t) {
        let e = 0;
        const i = [];
        return this.getBlocks().forEach((n)=>{
            const r = n.getLength();
            n.hasAttribute(t) && i.push([
                e,
                e + r
            ]), e += r;
        }), i;
    }
    findRangesForTextAttribute(t) {
        let { withValue: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = 0, n = [];
        const r = [];
        return this.getPieces().forEach((o)=>{
            const s = o.getLength();
            (function(i) {
                return e ? i.getAttribute(t) === e : i.hasAttribute(t);
            })(o) && (n[1] === i ? n[1] = i + s : r.push(n = [
                i,
                i + s
            ])), i += s;
        }), r;
    }
    locationFromPosition(t) {
        const e = this.blockList.findIndexAndOffsetAtPosition(Math.max(0, t));
        if (null != e.index) return e;
        {
            const t = this.getBlocks();
            return {
                index: t.length - 1,
                offset: t[t.length - 1].getLength()
            };
        }
    }
    positionFromLocation(t) {
        return this.blockList.findPositionAtIndexAndOffset(t.index, t.offset);
    }
    locationRangeFromPosition(t) {
        return $741c336afc2dfa06$var$wt(this.locationFromPosition(t));
    }
    locationRangeFromRange(t) {
        if (!(t = $741c336afc2dfa06$var$wt(t))) return;
        const [e, i] = Array.from(t), n = this.locationFromPosition(e), r = this.locationFromPosition(i);
        return $741c336afc2dfa06$var$wt([
            n,
            r
        ]);
    }
    rangeFromLocationRange(t) {
        let e;
        t = $741c336afc2dfa06$var$wt(t);
        const i = this.positionFromLocation(t[0]);
        return $741c336afc2dfa06$var$Lt(t) || (e = this.positionFromLocation(t[1])), $741c336afc2dfa06$var$wt([
            i,
            e
        ]);
    }
    isEqualTo(t) {
        return this.blockList.isEqualTo(null == t ? void 0 : t.blockList);
    }
    getTexts() {
        return this.getBlocks().map((t)=>t.text);
    }
    getPieces() {
        const t = [];
        return Array.from(this.getTexts()).forEach((e)=>{
            t.push(...Array.from(e.getPieces() || []));
        }), t;
    }
    getObjects() {
        return this.getBlocks().concat(this.getTexts()).concat(this.getPieces());
    }
    toSerializableDocument() {
        const t = [];
        return this.blockList.eachObject((e)=>t.push(e.copyWithText(e.text.toSerializableText()))), new this.constructor(t);
    }
    toString() {
        return this.blockList.toString();
    }
    toJSON() {
        return this.blockList.toJSON();
    }
    toConsole() {
        return JSON.stringify(this.blockList.toArray().map((t)=>JSON.parse(t.text.toConsole())));
    }
}
const $741c336afc2dfa06$var$sn = function(t) {
    const e = {}, i = t.getLastAttribute();
    return i && (e[i] = !0), e;
}, $741c336afc2dfa06$var$an = function(t) {
    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return {
        string: t = $741c336afc2dfa06$var$Wt(t),
        attributes: e,
        type: "string"
    };
}, $741c336afc2dfa06$var$ln = (t, e)=>{
    try {
        return JSON.parse(t.getAttribute("data-trix-".concat(e)));
    } catch (t) {
        return {};
    }
};
class $741c336afc2dfa06$var$cn extends $741c336afc2dfa06$var$q {
    static parse(t, e) {
        const i = new this(t, e);
        return i.parse(), i;
    }
    constructor(t){
        let { referenceElement: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        super(...arguments), this.html = t, this.referenceElement = e, this.blocks = [], this.blockElements = [], this.processedElements = [];
    }
    getDocument() {
        return $741c336afc2dfa06$var$on.fromJSON(this.blocks);
    }
    parse() {
        try {
            this.createHiddenContainer(), $741c336afc2dfa06$var$ui.setHTML(this.containerElement, this.html);
            const t = $741c336afc2dfa06$var$R(this.containerElement, {
                usingFilter: $741c336afc2dfa06$var$gn
            });
            for(; t.nextNode();)this.processNode(t.currentNode);
            return this.translateBlockElementMarginsToNewlines();
        } finally{
            this.removeHiddenContainer();
        }
    }
    createHiddenContainer() {
        return this.referenceElement ? (this.containerElement = this.referenceElement.cloneNode(!1), this.containerElement.removeAttribute("id"), this.containerElement.setAttribute("data-trix-internal", ""), this.containerElement.style.display = "none", this.referenceElement.parentNode.insertBefore(this.containerElement, this.referenceElement.nextSibling)) : (this.containerElement = $741c336afc2dfa06$var$T({
            tagName: "div",
            style: {
                display: "none"
            }
        }), document.body.appendChild(this.containerElement));
    }
    removeHiddenContainer() {
        return $741c336afc2dfa06$var$S(this.containerElement);
    }
    processNode(t) {
        switch(t.nodeType){
            case Node.TEXT_NODE:
                if (!this.isInsignificantTextNode(t)) return this.appendBlockForTextNode(t), this.processTextNode(t);
                break;
            case Node.ELEMENT_NODE:
                return this.appendBlockForElement(t), this.processElement(t);
        }
    }
    appendBlockForTextNode(t) {
        const e = t.parentNode;
        if (e === this.currentBlockElement && this.isBlockElement(t.previousSibling)) return this.appendStringWithAttributes("\n");
        if (e === this.containerElement || this.isBlockElement(e)) {
            var i;
            const t = this.getBlockAttributes(e), n = this.getBlockHTMLAttributes(e);
            $741c336afc2dfa06$var$ot(t, null === (i = this.currentBlock) || void 0 === i ? void 0 : i.attributes) || (this.currentBlock = this.appendBlockForAttributesWithElement(t, e, n), this.currentBlockElement = e);
        }
    }
    appendBlockForElement(t) {
        const e = this.isBlockElement(t), i = $741c336afc2dfa06$var$C(this.currentBlockElement, t);
        if (e && !this.isBlockElement(t.firstChild)) {
            if (!this.isInsignificantTextNode(t.firstChild) || !this.isBlockElement(t.firstElementChild)) {
                const e = this.getBlockAttributes(t), n = this.getBlockHTMLAttributes(t);
                if (t.firstChild) {
                    if (i && $741c336afc2dfa06$var$ot(e, this.currentBlock.attributes)) return this.appendStringWithAttributes("\n");
                    this.currentBlock = this.appendBlockForAttributesWithElement(e, t, n), this.currentBlockElement = t;
                }
            }
        } else if (this.currentBlockElement && !i && !e) {
            const e = this.findParentBlockElement(t);
            if (e) return this.appendBlockForElement(e);
            this.currentBlock = this.appendEmptyBlock(), this.currentBlockElement = null;
        }
    }
    findParentBlockElement(t) {
        let { parentElement: e } = t;
        for(; e && e !== this.containerElement;){
            if (this.isBlockElement(e) && this.blockElements.includes(e)) return e;
            e = e.parentElement;
        }
        return null;
    }
    processTextNode(t) {
        let e = t.data;
        var i;
        $741c336afc2dfa06$var$un(t.parentNode) || (e = $741c336afc2dfa06$var$Vt(e), $741c336afc2dfa06$var$fn(null === (i = t.previousSibling) || void 0 === i ? void 0 : i.textContent) && (e = $741c336afc2dfa06$var$mn(e)));
        return this.appendStringWithAttributes(e, this.getTextAttributes(t.parentNode));
    }
    processElement(t) {
        let e;
        if ($741c336afc2dfa06$var$P(t)) {
            if (e = $741c336afc2dfa06$var$ln(t, "attachment"), Object.keys(e).length) {
                const i = this.getTextAttributes(t);
                this.appendAttachmentWithAttributes(e, i), t.innerHTML = "";
            }
            return this.processedElements.push(t);
        }
        switch($741c336afc2dfa06$var$k(t)){
            case "br":
                return this.isExtraBR(t) || this.isBlockElement(t.nextSibling) || this.appendStringWithAttributes("\n", this.getTextAttributes(t)), this.processedElements.push(t);
            case "img":
                e = {
                    url: t.getAttribute("src"),
                    contentType: "image"
                };
                const i = ((t)=>{
                    const e = t.getAttribute("width"), i = t.getAttribute("height"), n = {};
                    return e && (n.width = parseInt(e, 10)), i && (n.height = parseInt(i, 10)), n;
                })(t);
                for(const t in i){
                    const n = i[t];
                    e[t] = n;
                }
                return this.appendAttachmentWithAttributes(e, this.getTextAttributes(t)), this.processedElements.push(t);
            case "tr":
                if (this.needsTableSeparator(t)) return this.appendStringWithAttributes($741c336afc2dfa06$var$j.tableRowSeparator);
                break;
            case "td":
                if (this.needsTableSeparator(t)) return this.appendStringWithAttributes($741c336afc2dfa06$var$j.tableCellSeparator);
        }
    }
    appendBlockForAttributesWithElement(t, e) {
        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        this.blockElements.push(e);
        const n = function() {
            return {
                text: [],
                attributes: arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                htmlAttributes: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}
            };
        }(t, i);
        return this.blocks.push(n), n;
    }
    appendEmptyBlock() {
        return this.appendBlockForAttributesWithElement([], null);
    }
    appendStringWithAttributes(t, e) {
        return this.appendPiece($741c336afc2dfa06$var$an(t, e));
    }
    appendAttachmentWithAttributes(t, e) {
        return this.appendPiece(function(t) {
            return {
                attachment: t,
                attributes: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                type: "attachment"
            };
        }(t, e));
    }
    appendPiece(t) {
        return 0 === this.blocks.length && this.appendEmptyBlock(), this.blocks[this.blocks.length - 1].text.push(t);
    }
    appendStringToTextAtIndex(t, e) {
        const { text: i } = this.blocks[e], n = i[i.length - 1];
        if ("string" !== (null == n ? void 0 : n.type)) return i.push($741c336afc2dfa06$var$an(t));
        n.string += t;
    }
    prependStringToTextAtIndex(t, e) {
        const { text: i } = this.blocks[e], n = i[0];
        if ("string" !== (null == n ? void 0 : n.type)) return i.unshift($741c336afc2dfa06$var$an(t));
        n.string = t + n.string;
    }
    getTextAttributes(t) {
        let e;
        const i = {};
        for(const n in $741c336afc2dfa06$var$W){
            const r = $741c336afc2dfa06$var$W[n];
            if (r.tagName && $741c336afc2dfa06$var$y(t, {
                matchingSelector: r.tagName,
                untilNode: this.containerElement
            })) i[n] = !0;
            else if (r.parser) {
                if (e = r.parser(t), e) {
                    let o = !1;
                    for (const i of this.findBlockElementAncestors(t))if (r.parser(i) === e) {
                        o = !0;
                        break;
                    }
                    o || (i[n] = e);
                }
            } else r.styleProperty && (e = t.style[r.styleProperty], e && (i[n] = e));
        }
        if ($741c336afc2dfa06$var$P(t)) {
            const n = $741c336afc2dfa06$var$ln(t, "attributes");
            for(const t in n)e = n[t], i[t] = e;
        }
        return i;
    }
    getBlockAttributes(t) {
        const e = [];
        for(; t && t !== this.containerElement;){
            for(const r in $741c336afc2dfa06$var$n){
                const o = $741c336afc2dfa06$var$n[r];
                var i;
                if (!1 !== o.parse) {
                    if ($741c336afc2dfa06$var$k(t) === o.tagName) (null !== (i = o.test) && void 0 !== i && i.call(o, t) || !o.test) && (e.push(r), o.listAttribute && e.push(o.listAttribute));
                }
            }
            t = t.parentNode;
        }
        return e.reverse();
    }
    getBlockHTMLAttributes(t) {
        const e = {}, i = Object.values($741c336afc2dfa06$var$n).find((e)=>e.tagName === $741c336afc2dfa06$var$k(t));
        return ((null == i ? void 0 : i.htmlAttributes) || []).forEach((i)=>{
            t.hasAttribute(i) && (e[i] = t.getAttribute(i));
        }), e;
    }
    findBlockElementAncestors(t) {
        const e = [];
        for(; t && t !== this.containerElement;){
            const i = $741c336afc2dfa06$var$k(t);
            $741c336afc2dfa06$var$L().includes(i) && e.push(t), t = t.parentNode;
        }
        return e;
    }
    isBlockElement(t) {
        if ((null == t ? void 0 : t.nodeType) === Node.ELEMENT_NODE && !$741c336afc2dfa06$var$P(t) && !$741c336afc2dfa06$var$y(t, {
            matchingSelector: "td",
            untilNode: this.containerElement
        })) return $741c336afc2dfa06$var$L().includes($741c336afc2dfa06$var$k(t)) || "block" === window.getComputedStyle(t).display;
    }
    isInsignificantTextNode(t) {
        if ((null == t ? void 0 : t.nodeType) !== Node.TEXT_NODE) return;
        if (!$741c336afc2dfa06$var$pn(t.data)) return;
        const { parentNode: e, previousSibling: i, nextSibling: n } = t;
        return $741c336afc2dfa06$var$hn(e.previousSibling) && !this.isBlockElement(e.previousSibling) || $741c336afc2dfa06$var$un(e) ? void 0 : !i || this.isBlockElement(i) || !n || this.isBlockElement(n);
    }
    isExtraBR(t) {
        return "br" === $741c336afc2dfa06$var$k(t) && this.isBlockElement(t.parentNode) && t.parentNode.lastChild === t;
    }
    needsTableSeparator(t) {
        if ($741c336afc2dfa06$var$j.removeBlankTableCells) {
            var e;
            const i = null === (e = t.previousSibling) || void 0 === e ? void 0 : e.textContent;
            return i && /\S/.test(i);
        }
        return t.previousSibling;
    }
    translateBlockElementMarginsToNewlines() {
        const t = this.getMarginOfDefaultBlockElement();
        for(let e = 0; e < this.blocks.length; e++){
            const i = this.getMarginOfBlockElementAtIndex(e);
            i && (i.top > 2 * t.top && this.prependStringToTextAtIndex("\n", e), i.bottom > 2 * t.bottom && this.appendStringToTextAtIndex("\n", e));
        }
    }
    getMarginOfBlockElementAtIndex(t) {
        const e = this.blockElements[t];
        if (e && e.textContent && !$741c336afc2dfa06$var$L().includes($741c336afc2dfa06$var$k(e)) && !this.processedElements.includes(e)) return $741c336afc2dfa06$var$dn(e);
    }
    getMarginOfDefaultBlockElement() {
        const t = $741c336afc2dfa06$var$T($741c336afc2dfa06$var$n.default.tagName);
        return this.containerElement.appendChild(t), $741c336afc2dfa06$var$dn(t);
    }
}
const $741c336afc2dfa06$var$un = function(t) {
    const { whiteSpace: e } = window.getComputedStyle(t);
    return [
        "pre",
        "pre-wrap",
        "pre-line"
    ].includes(e);
}, $741c336afc2dfa06$var$hn = (t)=>t && !$741c336afc2dfa06$var$fn(t.textContent), $741c336afc2dfa06$var$dn = function(t) {
    const e = window.getComputedStyle(t);
    if ("block" === e.display) return {
        top: parseInt(e.marginTop),
        bottom: parseInt(e.marginBottom)
    };
}, $741c336afc2dfa06$var$gn = function(t) {
    return "style" === $741c336afc2dfa06$var$k(t) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
}, $741c336afc2dfa06$var$mn = (t)=>t.replace(new RegExp("^".concat($741c336afc2dfa06$var$Ut.source, "+")), ""), $741c336afc2dfa06$var$pn = (t)=>new RegExp("^".concat($741c336afc2dfa06$var$Ut.source, "*$")).test(t), $741c336afc2dfa06$var$fn = (t)=>/\s$/.test(t), $741c336afc2dfa06$var$bn = [
    "contenteditable",
    "data-trix-id",
    "data-trix-store-key",
    "data-trix-mutable",
    "data-trix-placeholder",
    "tabindex"
], $741c336afc2dfa06$var$vn = "data-trix-serialized-attributes", $741c336afc2dfa06$var$An = "[".concat($741c336afc2dfa06$var$vn, "]"), $741c336afc2dfa06$var$yn = new RegExp("\x3c!--block--\x3e", "g"), $741c336afc2dfa06$var$xn = {
    "application/json": function(t) {
        let e;
        if (t instanceof $741c336afc2dfa06$var$on) e = t;
        else {
            if (!(t instanceof HTMLElement)) throw new Error("unserializable object");
            e = $741c336afc2dfa06$var$cn.parse(t.innerHTML).getDocument();
        }
        return e.toSerializableDocument().toJSONString();
    },
    "text/html": function(t) {
        let e;
        if (t instanceof $741c336afc2dfa06$var$on) e = $741c336afc2dfa06$var$Ci.render(t);
        else {
            if (!(t instanceof HTMLElement)) throw new Error("unserializable object");
            e = t.cloneNode(!0);
        }
        return Array.from(e.querySelectorAll("[data-trix-serialize=false]")).forEach((t)=>{
            $741c336afc2dfa06$var$S(t);
        }), $741c336afc2dfa06$var$bn.forEach((t)=>{
            Array.from(e.querySelectorAll("[".concat(t, "]"))).forEach((e)=>{
                e.removeAttribute(t);
            });
        }), Array.from(e.querySelectorAll($741c336afc2dfa06$var$An)).forEach((t)=>{
            try {
                const e = JSON.parse(t.getAttribute($741c336afc2dfa06$var$vn));
                t.removeAttribute($741c336afc2dfa06$var$vn);
                for(const i in e){
                    const n = e[i];
                    t.setAttribute(i, n);
                }
            } catch (t) {}
        }), e.innerHTML.replace($741c336afc2dfa06$var$yn, "");
    }
};
var $741c336afc2dfa06$var$Cn = Object.freeze({
    __proto__: null
});
class $741c336afc2dfa06$var$En extends $741c336afc2dfa06$var$q {
    constructor(t, e){
        super(...arguments), this.attachmentManager = t, this.attachment = e, this.id = this.attachment.id, this.file = this.attachment.file;
    }
    remove() {
        return this.attachmentManager.requestRemovalOfAttachment(this.attachment);
    }
}
$741c336afc2dfa06$var$En.proxyMethod("attachment.getAttribute"), $741c336afc2dfa06$var$En.proxyMethod("attachment.hasAttribute"), $741c336afc2dfa06$var$En.proxyMethod("attachment.setAttribute"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getAttributes"), $741c336afc2dfa06$var$En.proxyMethod("attachment.setAttributes"), $741c336afc2dfa06$var$En.proxyMethod("attachment.isPending"), $741c336afc2dfa06$var$En.proxyMethod("attachment.isPreviewable"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getURL"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getHref"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getFilename"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getFilesize"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getFormattedFilesize"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getExtension"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getContentType"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getFile"), $741c336afc2dfa06$var$En.proxyMethod("attachment.setFile"), $741c336afc2dfa06$var$En.proxyMethod("attachment.releaseFile"), $741c336afc2dfa06$var$En.proxyMethod("attachment.getUploadProgress"), $741c336afc2dfa06$var$En.proxyMethod("attachment.setUploadProgress");
class $741c336afc2dfa06$var$Sn extends $741c336afc2dfa06$var$q {
    constructor(){
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        super(...arguments), this.managedAttachments = {}, Array.from(t).forEach((t)=>{
            this.manageAttachment(t);
        });
    }
    getAttachments() {
        const t = [];
        for(const e in this.managedAttachments){
            const i = this.managedAttachments[e];
            t.push(i);
        }
        return t;
    }
    manageAttachment(t) {
        return this.managedAttachments[t.id] || (this.managedAttachments[t.id] = new $741c336afc2dfa06$var$En(this, t)), this.managedAttachments[t.id];
    }
    attachmentIsManaged(t) {
        return t.id in this.managedAttachments;
    }
    requestRemovalOfAttachment(t) {
        var e, i;
        if (this.attachmentIsManaged(t)) return null === (e = this.delegate) || void 0 === e || null === (i = e.attachmentManagerDidRequestRemovalOfAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    unmanageAttachment(t) {
        const e = this.managedAttachments[t.id];
        return delete this.managedAttachments[t.id], e;
    }
}
class $741c336afc2dfa06$var$Rn {
    constructor(t){
        this.composition = t, this.document = this.composition.document;
        const e = this.composition.getSelectedRange();
        this.startPosition = e[0], this.endPosition = e[1], this.startLocation = this.document.locationFromPosition(this.startPosition), this.endLocation = this.document.locationFromPosition(this.endPosition), this.block = this.document.getBlockAtIndex(this.endLocation.index), this.breaksOnReturn = this.block.breaksOnReturn(), this.previousCharacter = this.block.text.getStringAtPosition(this.endLocation.offset - 1), this.nextCharacter = this.block.text.getStringAtPosition(this.endLocation.offset);
    }
    shouldInsertBlockBreak() {
        return this.block.hasAttributes() && this.block.isListItem() && !this.block.isEmpty() ? 0 !== this.startLocation.offset : this.breaksOnReturn && "\n" !== this.nextCharacter;
    }
    shouldBreakFormattedBlock() {
        return this.block.hasAttributes() && !this.block.isListItem() && (this.breaksOnReturn && "\n" === this.nextCharacter || "\n" === this.previousCharacter);
    }
    shouldDecreaseListLevel() {
        return this.block.hasAttributes() && this.block.isListItem() && this.block.isEmpty();
    }
    shouldPrependListItem() {
        return this.block.isListItem() && 0 === this.startLocation.offset && !this.block.isEmpty();
    }
    shouldRemoveLastBlockAttribute() {
        return this.block.hasAttributes() && !this.block.isListItem() && this.block.isEmpty();
    }
}
class $741c336afc2dfa06$var$kn extends $741c336afc2dfa06$var$q {
    constructor(){
        super(...arguments), this.document = new $741c336afc2dfa06$var$on, this.attachments = [], this.currentAttributes = {}, this.revision = 0;
    }
    setDocument(t) {
        var e, i;
        if (!t.isEqualTo(this.document)) return this.document = t, this.refreshAttachments(), this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidChangeDocument) || void 0 === i ? void 0 : i.call(e, t);
    }
    getSnapshot() {
        return {
            document: this.document,
            selectedRange: this.getSelectedRange()
        };
    }
    loadSnapshot(t) {
        var e, i, n, r;
        let { document: o, selectedRange: s } = t;
        return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionWillLoadSnapshot) || void 0 === i || i.call(e), this.setDocument(null != o ? o : new $741c336afc2dfa06$var$on), this.setSelection(null != s ? s : [
            0,
            0
        ]), null === (n = this.delegate) || void 0 === n || null === (r = n.compositionDidLoadSnapshot) || void 0 === r ? void 0 : r.call(n);
    }
    insertText(t) {
        let { updatePosition: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            updatePosition: !0
        };
        const i = this.getSelectedRange();
        this.setDocument(this.document.insertTextAtRange(t, i));
        const n = i[0], r = n + t.getLength();
        return e && this.setSelection(r), this.notifyDelegateOfInsertionAtRange([
            n,
            r
        ]);
    }
    insertBlock() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $741c336afc2dfa06$var$Gi;
        const e = new $741c336afc2dfa06$var$on([
            t
        ]);
        return this.insertDocument(e);
    }
    insertDocument() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $741c336afc2dfa06$var$on;
        const e = this.getSelectedRange();
        this.setDocument(this.document.insertDocumentAtRange(t, e));
        const i = e[0], n = i + t.getLength();
        return this.setSelection(n), this.notifyDelegateOfInsertionAtRange([
            i,
            n
        ]);
    }
    insertString(t, e) {
        const i = this.getCurrentTextAttributes(), n = $741c336afc2dfa06$var$Ki.textForStringWithAttributes(t, i);
        return this.insertText(n, e);
    }
    insertBlockBreak() {
        const t = this.getSelectedRange();
        this.setDocument(this.document.insertBlockBreakAtRange(t));
        const e = t[0], i = e + 1;
        return this.setSelection(i), this.notifyDelegateOfInsertionAtRange([
            e,
            i
        ]);
    }
    insertLineBreak() {
        const t = new $741c336afc2dfa06$var$Rn(this);
        if (t.shouldDecreaseListLevel()) return this.decreaseListLevel(), this.setSelection(t.startPosition);
        if (t.shouldPrependListItem()) {
            const e = new $741c336afc2dfa06$var$on([
                t.block.copyWithoutText()
            ]);
            return this.insertDocument(e);
        }
        return t.shouldInsertBlockBreak() ? this.insertBlockBreak() : t.shouldRemoveLastBlockAttribute() ? this.removeLastBlockAttribute() : t.shouldBreakFormattedBlock() ? this.breakFormattedBlock(t) : this.insertString("\n");
    }
    insertHTML(t) {
        const e = $741c336afc2dfa06$var$cn.parse(t).getDocument(), i = this.getSelectedRange();
        this.setDocument(this.document.mergeDocumentAtRange(e, i));
        const n = i[0], r = n + e.getLength() - 1;
        return this.setSelection(r), this.notifyDelegateOfInsertionAtRange([
            n,
            r
        ]);
    }
    replaceHTML(t) {
        const e = $741c336afc2dfa06$var$cn.parse(t).getDocument().copyUsingObjectsFromDocument(this.document), i = this.getLocationRange({
            strict: !1
        }), n = this.document.rangeFromLocationRange(i);
        return this.setDocument(e), this.setSelection(n);
    }
    insertFile(t) {
        return this.insertFiles([
            t
        ]);
    }
    insertFiles(t) {
        const e = [];
        return Array.from(t).forEach((t)=>{
            var i;
            if (null !== (i = this.delegate) && void 0 !== i && i.compositionShouldAcceptFile(t)) {
                const i = $741c336afc2dfa06$var$Wi.attachmentForFile(t);
                e.push(i);
            }
        }), this.insertAttachments(e);
    }
    insertAttachment(t) {
        return this.insertAttachments([
            t
        ]);
    }
    insertAttachments(t) {
        let e = new $741c336afc2dfa06$var$Ki;
        return Array.from(t).forEach((t)=>{
            var n;
            const r = t.getType(), o = null === (n = $741c336afc2dfa06$var$i[r]) || void 0 === n ? void 0 : n.presentation, s = this.getCurrentTextAttributes();
            o && (s.presentation = o);
            const a = $741c336afc2dfa06$var$Ki.textForAttachmentWithAttributes(t, s);
            e = e.appendText(a);
        }), this.insertText(e);
    }
    shouldManageDeletingInDirection(t) {
        const e = this.getLocationRange();
        if ($741c336afc2dfa06$var$Lt(e)) {
            if ("backward" === t && 0 === e[0].offset) return !0;
            if (this.shouldManageMovingCursorInDirection(t)) return !0;
        } else if (e[0].index !== e[1].index) return !0;
        return !1;
    }
    deleteInDirection(t) {
        let e, i, n, { length: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const o = this.getLocationRange();
        let s = this.getSelectedRange();
        const a = $741c336afc2dfa06$var$Lt(s);
        if (a ? i = "backward" === t && 0 === o[0].offset : n = o[0].index !== o[1].index, i && this.canDecreaseBlockAttributeLevel()) {
            const t = this.getBlock();
            if (t.isListItem() ? this.decreaseListLevel() : this.decreaseBlockAttributeLevel(), this.setSelection(s[0]), t.isEmpty()) return !1;
        }
        return a && (s = this.getExpandedRangeInDirection(t, {
            length: r
        }), "backward" === t && (e = this.getAttachmentAtRange(s))), e ? (this.editAttachment(e), !1) : (this.setDocument(this.document.removeTextAtRange(s)), this.setSelection(s[0]), !i && !n && void 0);
    }
    moveTextFromRange(t) {
        const [e] = Array.from(this.getSelectedRange());
        return this.setDocument(this.document.moveTextFromRangeToPosition(t, e)), this.setSelection(e);
    }
    removeAttachment(t) {
        const e = this.document.getRangeOfAttachment(t);
        if (e) return this.stopEditingAttachment(), this.setDocument(this.document.removeTextAtRange(e)), this.setSelection(e[0]);
    }
    removeLastBlockAttribute() {
        const [t, e] = Array.from(this.getSelectedRange()), i = this.document.getBlockAtPosition(e);
        return this.removeCurrentAttribute(i.getLastAttribute()), this.setSelection(t);
    }
    insertPlaceholder() {
        return this.placeholderPosition = this.getPosition(), this.insertString(" ");
    }
    selectPlaceholder() {
        if (null != this.placeholderPosition) return this.setSelectedRange([
            this.placeholderPosition,
            this.placeholderPosition + 1
        ]), this.getSelectedRange();
    }
    forgetPlaceholder() {
        this.placeholderPosition = null;
    }
    hasCurrentAttribute(t) {
        const e = this.currentAttributes[t];
        return null != e && !1 !== e;
    }
    toggleCurrentAttribute(t) {
        const e = !this.currentAttributes[t];
        return e ? this.setCurrentAttribute(t, e) : this.removeCurrentAttribute(t);
    }
    canSetCurrentAttribute(t) {
        return $741c336afc2dfa06$var$mt(t) ? this.canSetCurrentBlockAttribute(t) : this.canSetCurrentTextAttribute(t);
    }
    canSetCurrentTextAttribute(t) {
        const e = this.getSelectedDocument();
        if (e) {
            for (const t of Array.from(e.getAttachments()))if (!t.hasContent()) return !1;
            return !0;
        }
    }
    canSetCurrentBlockAttribute(t) {
        const e = this.getBlock();
        if (e) return !e.isTerminalBlock();
    }
    setCurrentAttribute(t, e) {
        return $741c336afc2dfa06$var$mt(t) ? this.setBlockAttribute(t, e) : (this.setTextAttribute(t, e), this.currentAttributes[t] = e, this.notifyDelegateOfCurrentAttributesChange());
    }
    setHTMLAtributeAtPosition(t, e, i) {
        var n;
        const r = this.document.getBlockAtPosition(t), o = null === (n = $741c336afc2dfa06$var$mt(r.getLastAttribute())) || void 0 === n ? void 0 : n.htmlAttributes;
        if (r && null != o && o.includes(e)) {
            const n = this.document.setHTMLAttributeAtPosition(t, e, i);
            this.setDocument(n);
        }
    }
    setTextAttribute(t, e) {
        const i = this.getSelectedRange();
        if (!i) return;
        const [n, r] = Array.from(i);
        if (n !== r) return this.setDocument(this.document.addAttributeAtRange(t, e, i));
        if ("href" === t) {
            const t = $741c336afc2dfa06$var$Ki.textForStringWithAttributes(e, {
                href: e
            });
            return this.insertText(t);
        }
    }
    setBlockAttribute(t, e) {
        const i = this.getSelectedRange();
        if (this.canSetCurrentAttribute(t)) return this.setDocument(this.document.applyBlockAttributeAtRange(t, e, i)), this.setSelection(i);
    }
    removeCurrentAttribute(t) {
        return $741c336afc2dfa06$var$mt(t) ? (this.removeBlockAttribute(t), this.updateCurrentAttributes()) : (this.removeTextAttribute(t), delete this.currentAttributes[t], this.notifyDelegateOfCurrentAttributesChange());
    }
    removeTextAttribute(t) {
        const e = this.getSelectedRange();
        if (e) return this.setDocument(this.document.removeAttributeAtRange(t, e));
    }
    removeBlockAttribute(t) {
        const e = this.getSelectedRange();
        if (e) return this.setDocument(this.document.removeAttributeAtRange(t, e));
    }
    canDecreaseNestingLevel() {
        var t;
        return (null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getNestingLevel()) > 0;
    }
    canIncreaseNestingLevel() {
        var t;
        const e = this.getBlock();
        if (e) {
            if (null === (t = $741c336afc2dfa06$var$mt(e.getLastNestableAttribute())) || void 0 === t || !t.listAttribute) return e.getNestingLevel() > 0;
            {
                const t = this.getPreviousBlock();
                if (t) return function() {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    return $741c336afc2dfa06$var$ot((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).slice(0, t.length), t);
                }(t.getListItemAttributes(), e.getListItemAttributes());
            }
        }
    }
    decreaseNestingLevel() {
        const t = this.getBlock();
        if (t) return this.setDocument(this.document.replaceBlock(t, t.decreaseNestingLevel()));
    }
    increaseNestingLevel() {
        const t = this.getBlock();
        if (t) return this.setDocument(this.document.replaceBlock(t, t.increaseNestingLevel()));
    }
    canDecreaseBlockAttributeLevel() {
        var t;
        return (null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getAttributeLevel()) > 0;
    }
    decreaseBlockAttributeLevel() {
        var t;
        const e = null === (t = this.getBlock()) || void 0 === t ? void 0 : t.getLastAttribute();
        if (e) return this.removeCurrentAttribute(e);
    }
    decreaseListLevel() {
        let [t] = Array.from(this.getSelectedRange());
        const { index: e } = this.document.locationFromPosition(t);
        let i = e;
        const n = this.getBlock().getAttributeLevel();
        let r = this.document.getBlockAtIndex(i + 1);
        for(; r && r.isListItem() && !(r.getAttributeLevel() <= n);)i++, r = this.document.getBlockAtIndex(i + 1);
        t = this.document.positionFromLocation({
            index: e,
            offset: 0
        });
        const o = this.document.positionFromLocation({
            index: i,
            offset: 0
        });
        return this.setDocument(this.document.removeLastListAttributeAtRange([
            t,
            o
        ]));
    }
    updateCurrentAttributes() {
        const t = this.getSelectedRange({
            ignoreLock: !0
        });
        if (t) {
            const e = this.document.getCommonAttributesAtRange(t);
            if (Array.from($741c336afc2dfa06$var$gt()).forEach((t)=>{
                e[t] || this.canSetCurrentAttribute(t) || (e[t] = !1);
            }), !$741c336afc2dfa06$var$Tt(e, this.currentAttributes)) return this.currentAttributes = e, this.notifyDelegateOfCurrentAttributesChange();
        }
    }
    getCurrentAttributes() {
        return $741c336afc2dfa06$var$m.call({}, this.currentAttributes);
    }
    getCurrentTextAttributes() {
        const t = {};
        for(const e in this.currentAttributes){
            const i = this.currentAttributes[e];
            !1 !== i && $741c336afc2dfa06$var$ft(e) && (t[e] = i);
        }
        return t;
    }
    freezeSelection() {
        return this.setCurrentAttribute("frozen", !0);
    }
    thawSelection() {
        return this.removeCurrentAttribute("frozen");
    }
    hasFrozenSelection() {
        return this.hasCurrentAttribute("frozen");
    }
    setSelection(t) {
        var e;
        const i = this.document.locationRangeFromRange(t);
        return null === (e = this.delegate) || void 0 === e ? void 0 : e.compositionDidRequestChangingSelectionToLocationRange(i);
    }
    getSelectedRange() {
        const t = this.getLocationRange();
        if (t) return this.document.rangeFromLocationRange(t);
    }
    setSelectedRange(t) {
        const e = this.document.locationRangeFromRange(t);
        return this.getSelectionManager().setLocationRange(e);
    }
    getPosition() {
        const t = this.getLocationRange();
        if (t) return this.document.positionFromLocation(t[0]);
    }
    getLocationRange(t) {
        return this.targetLocationRange ? this.targetLocationRange : this.getSelectionManager().getLocationRange(t) || $741c336afc2dfa06$var$wt({
            index: 0,
            offset: 0
        });
    }
    withTargetLocationRange(t, e) {
        let i;
        this.targetLocationRange = t;
        try {
            i = e();
        } finally{
            this.targetLocationRange = null;
        }
        return i;
    }
    withTargetRange(t, e) {
        const i = this.document.locationRangeFromRange(t);
        return this.withTargetLocationRange(i, e);
    }
    withTargetDOMRange(t, e) {
        const i = this.createLocationRangeFromDOMRange(t, {
            strict: !1
        });
        return this.withTargetLocationRange(i, e);
    }
    getExpandedRangeInDirection(t) {
        let { length: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, [i, n] = Array.from(this.getSelectedRange());
        return "backward" === t ? e ? i -= e : i = this.translateUTF16PositionFromOffset(i, -1) : e ? n += e : n = this.translateUTF16PositionFromOffset(n, 1), $741c336afc2dfa06$var$wt([
            i,
            n
        ]);
    }
    shouldManageMovingCursorInDirection(t) {
        if (this.editingAttachment) return !0;
        const e = this.getExpandedRangeInDirection(t);
        return null != this.getAttachmentAtRange(e);
    }
    moveCursorInDirection(t) {
        let e, i;
        if (this.editingAttachment) i = this.document.getRangeOfAttachment(this.editingAttachment);
        else {
            const n = this.getSelectedRange();
            i = this.getExpandedRangeInDirection(t), e = !$741c336afc2dfa06$var$Dt(n, i);
        }
        if ("backward" === t ? this.setSelectedRange(i[0]) : this.setSelectedRange(i[1]), e) {
            const t = this.getAttachmentAtRange(i);
            if (t) return this.editAttachment(t);
        }
    }
    expandSelectionInDirection(t) {
        let { length: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const i = this.getExpandedRangeInDirection(t, {
            length: e
        });
        return this.setSelectedRange(i);
    }
    expandSelectionForEditing() {
        if (this.hasCurrentAttribute("href")) return this.expandSelectionAroundCommonAttribute("href");
    }
    expandSelectionAroundCommonAttribute(t) {
        const e = this.getPosition(), i = this.document.getRangeOfCommonAttributeAtPosition(t, e);
        return this.setSelectedRange(i);
    }
    selectionContainsAttachments() {
        var t;
        return (null === (t = this.getSelectedAttachments()) || void 0 === t ? void 0 : t.length) > 0;
    }
    selectionIsInCursorTarget() {
        return this.editingAttachment || this.positionIsCursorTarget(this.getPosition());
    }
    positionIsCursorTarget(t) {
        const e = this.document.locationFromPosition(t);
        if (e) return this.locationIsCursorTarget(e);
    }
    positionIsBlockBreak(t) {
        var e;
        return null === (e = this.document.getPieceAtPosition(t)) || void 0 === e ? void 0 : e.isBlockBreak();
    }
    getSelectedDocument() {
        const t = this.getSelectedRange();
        if (t) return this.document.getDocumentAtRange(t);
    }
    getSelectedAttachments() {
        var t;
        return null === (t = this.getSelectedDocument()) || void 0 === t ? void 0 : t.getAttachments();
    }
    getAttachments() {
        return this.attachments.slice(0);
    }
    refreshAttachments() {
        const t = this.document.getAttachments(), { added: e, removed: i } = function() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            const i = [], n = [], r = new Set;
            t.forEach((t)=>{
                r.add(t);
            });
            const o = new Set;
            return e.forEach((t)=>{
                o.add(t), r.has(t) || i.push(t);
            }), t.forEach((t)=>{
                o.has(t) || n.push(t);
            }), {
                added: i,
                removed: n
            };
        }(this.attachments, t);
        return this.attachments = t, Array.from(i).forEach((t)=>{
            var e, i;
            t.delegate = null, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidRemoveAttachment) || void 0 === i || i.call(e, t);
        }), (()=>{
            const t = [];
            return Array.from(e).forEach((e)=>{
                var i, n;
                e.delegate = this, t.push(null === (i = this.delegate) || void 0 === i || null === (n = i.compositionDidAddAttachment) || void 0 === n ? void 0 : n.call(i, e));
            }), t;
        })();
    }
    attachmentDidChangeAttributes(t) {
        var e, i;
        return this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidEditAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    attachmentDidChangePreviewURL(t) {
        var e, i;
        return this.revision++, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidChangeAttachmentPreviewURL) || void 0 === i ? void 0 : i.call(e, t);
    }
    editAttachment(t, e) {
        var i, n;
        if (t !== this.editingAttachment) return this.stopEditingAttachment(), this.editingAttachment = t, null === (i = this.delegate) || void 0 === i || null === (n = i.compositionDidStartEditingAttachment) || void 0 === n ? void 0 : n.call(i, this.editingAttachment, e);
    }
    stopEditingAttachment() {
        var t, e;
        this.editingAttachment && (null === (t = this.delegate) || void 0 === t || null === (e = t.compositionDidStopEditingAttachment) || void 0 === e || e.call(t, this.editingAttachment), this.editingAttachment = null);
    }
    updateAttributesForAttachment(t, e) {
        return this.setDocument(this.document.updateAttributesForAttachment(t, e));
    }
    removeAttributeForAttachment(t, e) {
        return this.setDocument(this.document.removeAttributeForAttachment(t, e));
    }
    breakFormattedBlock(t) {
        let { document: e } = t;
        const { block: i } = t;
        let n = t.startPosition, r = [
            n - 1,
            n
        ];
        i.getBlockBreakPosition() === t.startLocation.offset ? (i.breaksOnReturn() && "\n" === t.nextCharacter ? n += 1 : e = e.removeTextAtRange(r), r = [
            n,
            n
        ]) : "\n" === t.nextCharacter ? "\n" === t.previousCharacter ? r = [
            n - 1,
            n + 1
        ] : (r = [
            n,
            n + 1
        ], n += 1) : t.startLocation.offset - 1 != 0 && (n += 1);
        const o = new $741c336afc2dfa06$var$on([
            i.removeLastAttribute().copyWithoutText()
        ]);
        return this.setDocument(e.insertDocumentAtRange(o, r)), this.setSelection(n);
    }
    getPreviousBlock() {
        const t = this.getLocationRange();
        if (t) {
            const { index: e } = t[0];
            if (e > 0) return this.document.getBlockAtIndex(e - 1);
        }
    }
    getBlock() {
        const t = this.getLocationRange();
        if (t) return this.document.getBlockAtIndex(t[0].index);
    }
    getAttachmentAtRange(t) {
        const e = this.document.getDocumentAtRange(t);
        if (e.toString() === "".concat("\uFFFC", "\n")) return e.getAttachments()[0];
    }
    notifyDelegateOfCurrentAttributesChange() {
        var t, e;
        return null === (t = this.delegate) || void 0 === t || null === (e = t.compositionDidChangeCurrentAttributes) || void 0 === e ? void 0 : e.call(t, this.currentAttributes);
    }
    notifyDelegateOfInsertionAtRange(t) {
        var e, i;
        return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionDidPerformInsertionAtRange) || void 0 === i ? void 0 : i.call(e, t);
    }
    translateUTF16PositionFromOffset(t, e) {
        const i = this.document.toUTF16String(), n = i.offsetFromUCS2Offset(t);
        return i.offsetToUCS2Offset(n + e);
    }
}
$741c336afc2dfa06$var$kn.proxyMethod("getSelectionManager().getPointRange"), $741c336afc2dfa06$var$kn.proxyMethod("getSelectionManager().setLocationRangeFromPointRange"), $741c336afc2dfa06$var$kn.proxyMethod("getSelectionManager().createLocationRangeFromDOMRange"), $741c336afc2dfa06$var$kn.proxyMethod("getSelectionManager().locationIsCursorTarget"), $741c336afc2dfa06$var$kn.proxyMethod("getSelectionManager().selectionIsExpanded"), $741c336afc2dfa06$var$kn.proxyMethod("delegate?.getSelectionManager");
class $741c336afc2dfa06$var$Tn extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(...arguments), this.composition = t, this.undoEntries = [], this.redoEntries = [];
    }
    recordUndoEntry(t) {
        let { context: e, consolidatable: i } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        const n = this.undoEntries.slice(-1)[0];
        if (!i || !$741c336afc2dfa06$var$wn(n, t, e)) {
            const i = this.createEntry({
                description: t,
                context: e
            });
            this.undoEntries.push(i), this.redoEntries = [];
        }
    }
    undo() {
        const t = this.undoEntries.pop();
        if (t) {
            const e = this.createEntry(t);
            return this.redoEntries.push(e), this.composition.loadSnapshot(t.snapshot);
        }
    }
    redo() {
        const t = this.redoEntries.pop();
        if (t) {
            const e = this.createEntry(t);
            return this.undoEntries.push(e), this.composition.loadSnapshot(t.snapshot);
        }
    }
    canUndo() {
        return this.undoEntries.length > 0;
    }
    canRedo() {
        return this.redoEntries.length > 0;
    }
    createEntry() {
        let { description: t, context: e } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return {
            description: null == t ? void 0 : t.toString(),
            context: JSON.stringify(e),
            snapshot: this.composition.getSnapshot()
        };
    }
}
const $741c336afc2dfa06$var$wn = (t, e, i)=>(null == t ? void 0 : t.description) === (null == e ? void 0 : e.toString()) && (null == t ? void 0 : t.context) === JSON.stringify(i), $741c336afc2dfa06$var$Ln = "attachmentGallery";
class $741c336afc2dfa06$var$Dn {
    constructor(t){
        this.document = t.document, this.selectedRange = t.selectedRange;
    }
    perform() {
        return this.removeBlockAttribute(), this.applyBlockAttribute();
    }
    getSnapshot() {
        return {
            document: this.document,
            selectedRange: this.selectedRange
        };
    }
    removeBlockAttribute() {
        return this.findRangesOfBlocks().map((t)=>this.document = this.document.removeAttributeAtRange($741c336afc2dfa06$var$Ln, t));
    }
    applyBlockAttribute() {
        let t = 0;
        this.findRangesOfPieces().forEach((e)=>{
            e[1] - e[0] > 1 && (e[0] += t, e[1] += t, "\n" !== this.document.getCharacterAtPosition(e[1]) && (this.document = this.document.insertBlockBreakAtRange(e[1]), e[1] < this.selectedRange[1] && this.moveSelectedRangeForward(), e[1]++, t++), 0 !== e[0] && "\n" !== this.document.getCharacterAtPosition(e[0] - 1) && (this.document = this.document.insertBlockBreakAtRange(e[0]), e[0] < this.selectedRange[0] && this.moveSelectedRangeForward(), e[0]++, t++), this.document = this.document.applyBlockAttributeAtRange($741c336afc2dfa06$var$Ln, !0, e));
        });
    }
    findRangesOfBlocks() {
        return this.document.findRangesForBlockAttribute($741c336afc2dfa06$var$Ln);
    }
    findRangesOfPieces() {
        return this.document.findRangesForTextAttribute("presentation", {
            withValue: "gallery"
        });
    }
    moveSelectedRangeForward() {
        this.selectedRange[0] += 1, this.selectedRange[1] += 1;
    }
}
const $741c336afc2dfa06$var$Nn = function(t) {
    const e = new $741c336afc2dfa06$var$Dn(t);
    return e.perform(), e.getSnapshot();
}, $741c336afc2dfa06$var$In = [
    $741c336afc2dfa06$var$Nn
];
class $741c336afc2dfa06$var$On {
    constructor(t, e, i){
        this.insertFiles = this.insertFiles.bind(this), this.composition = t, this.selectionManager = e, this.element = i, this.undoManager = new $741c336afc2dfa06$var$Tn(this.composition), this.filters = $741c336afc2dfa06$var$In.slice(0);
    }
    loadDocument(t) {
        return this.loadSnapshot({
            document: t,
            selectedRange: [
                0,
                0
            ]
        });
    }
    loadHTML() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        const e = $741c336afc2dfa06$var$cn.parse(t, {
            referenceElement: this.element
        }).getDocument();
        return this.loadDocument(e);
    }
    loadJSON(t) {
        let { document: e, selectedRange: i } = t;
        return e = $741c336afc2dfa06$var$on.fromJSON(e), this.loadSnapshot({
            document: e,
            selectedRange: i
        });
    }
    loadSnapshot(t) {
        return this.undoManager = new $741c336afc2dfa06$var$Tn(this.composition), this.composition.loadSnapshot(t);
    }
    getDocument() {
        return this.composition.document;
    }
    getSelectedDocument() {
        return this.composition.getSelectedDocument();
    }
    getSnapshot() {
        return this.composition.getSnapshot();
    }
    toJSON() {
        return this.getSnapshot();
    }
    deleteInDirection(t) {
        return this.composition.deleteInDirection(t);
    }
    insertAttachment(t) {
        return this.composition.insertAttachment(t);
    }
    insertAttachments(t) {
        return this.composition.insertAttachments(t);
    }
    insertDocument(t) {
        return this.composition.insertDocument(t);
    }
    insertFile(t) {
        return this.composition.insertFile(t);
    }
    insertFiles(t) {
        return this.composition.insertFiles(t);
    }
    insertHTML(t) {
        return this.composition.insertHTML(t);
    }
    insertString(t) {
        return this.composition.insertString(t);
    }
    insertText(t) {
        return this.composition.insertText(t);
    }
    insertLineBreak() {
        return this.composition.insertLineBreak();
    }
    getSelectedRange() {
        return this.composition.getSelectedRange();
    }
    getPosition() {
        return this.composition.getPosition();
    }
    getClientRectAtPosition(t) {
        const e = this.getDocument().locationRangeFromRange([
            t,
            t + 1
        ]);
        return this.selectionManager.getClientRectAtLocationRange(e);
    }
    expandSelectionInDirection(t) {
        return this.composition.expandSelectionInDirection(t);
    }
    moveCursorInDirection(t) {
        return this.composition.moveCursorInDirection(t);
    }
    setSelectedRange(t) {
        return this.composition.setSelectedRange(t);
    }
    activateAttribute(t) {
        let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        return this.composition.setCurrentAttribute(t, e);
    }
    attributeIsActive(t) {
        return this.composition.hasCurrentAttribute(t);
    }
    canActivateAttribute(t) {
        return this.composition.canSetCurrentAttribute(t);
    }
    deactivateAttribute(t) {
        return this.composition.removeCurrentAttribute(t);
    }
    setHTMLAtributeAtPosition(t, e, i) {
        this.composition.setHTMLAtributeAtPosition(t, e, i);
    }
    canDecreaseNestingLevel() {
        return this.composition.canDecreaseNestingLevel();
    }
    canIncreaseNestingLevel() {
        return this.composition.canIncreaseNestingLevel();
    }
    decreaseNestingLevel() {
        if (this.canDecreaseNestingLevel()) return this.composition.decreaseNestingLevel();
    }
    increaseNestingLevel() {
        if (this.canIncreaseNestingLevel()) return this.composition.increaseNestingLevel();
    }
    canRedo() {
        return this.undoManager.canRedo();
    }
    canUndo() {
        return this.undoManager.canUndo();
    }
    recordUndoEntry(t) {
        let { context: e, consolidatable: i } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.undoManager.recordUndoEntry(t, {
            context: e,
            consolidatable: i
        });
    }
    redo() {
        if (this.canRedo()) return this.undoManager.redo();
    }
    undo() {
        if (this.canUndo()) return this.undoManager.undo();
    }
}
class $741c336afc2dfa06$var$Fn {
    constructor(t){
        this.element = t;
    }
    findLocationFromContainerAndOffset(t, e) {
        let { strict: i } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            strict: !0
        }, n = 0, r = !1;
        const o = {
            index: 0,
            offset: 0
        }, s = this.findAttachmentElementParentForNode(t);
        s && (t = s.parentNode, e = $741c336afc2dfa06$var$E(s));
        const a = $741c336afc2dfa06$var$R(this.element, {
            usingFilter: $741c336afc2dfa06$var$_n
        });
        for(; a.nextNode();){
            const s = a.currentNode;
            if (s === t && $741c336afc2dfa06$var$B(t)) {
                $741c336afc2dfa06$var$F(s) || (o.offset += e);
                break;
            }
            if (s.parentNode === t) {
                if (n++ === e) break;
            } else if (!$741c336afc2dfa06$var$C(t, s) && n > 0) break;
            $741c336afc2dfa06$var$N(s, {
                strict: i
            }) ? (r && o.index++, o.offset = 0, r = !0) : o.offset += $741c336afc2dfa06$var$Pn(s);
        }
        return o;
    }
    findContainerAndOffsetFromLocation(t) {
        let e, i;
        if (0 === t.index && 0 === t.offset) {
            for(e = this.element, i = 0; e.firstChild;)if (e = e.firstChild, $741c336afc2dfa06$var$D(e)) {
                i = 1;
                break;
            }
            return [
                e,
                i
            ];
        }
        let [n, r] = this.findNodeAndOffsetFromLocation(t);
        if (n) {
            if ($741c336afc2dfa06$var$B(n)) 0 === $741c336afc2dfa06$var$Pn(n) ? (e = n.parentNode.parentNode, i = $741c336afc2dfa06$var$E(n.parentNode), $741c336afc2dfa06$var$F(n, {
                name: "right"
            }) && i++) : (e = n, i = t.offset - r);
            else {
                if (e = n.parentNode, !$741c336afc2dfa06$var$N(n.previousSibling) && !$741c336afc2dfa06$var$D(e)) for(; n === e.lastChild && (n = e, e = e.parentNode, !$741c336afc2dfa06$var$D(e)););
                i = $741c336afc2dfa06$var$E(n), 0 !== t.offset && i++;
            }
            return [
                e,
                i
            ];
        }
    }
    findNodeAndOffsetFromLocation(t) {
        let e, i, n = 0;
        for (const r of this.getSignificantNodesForIndex(t.index)){
            const o = $741c336afc2dfa06$var$Pn(r);
            if (t.offset <= n + o) {
                if ($741c336afc2dfa06$var$B(r)) {
                    if (e = r, i = n, t.offset === i && $741c336afc2dfa06$var$F(e)) break;
                } else e || (e = r, i = n);
            }
            if (n += o, n > t.offset) break;
        }
        return [
            e,
            i
        ];
    }
    findAttachmentElementParentForNode(t) {
        for(; t && t !== this.element;){
            if ($741c336afc2dfa06$var$P(t)) return t;
            t = t.parentNode;
        }
    }
    getSignificantNodesForIndex(t) {
        const e = [], i = $741c336afc2dfa06$var$R(this.element, {
            usingFilter: $741c336afc2dfa06$var$Mn
        });
        let n = !1;
        for(; i.nextNode();){
            const o = i.currentNode;
            var r;
            if ($741c336afc2dfa06$var$I(o)) {
                if (null != r ? r++ : r = 0, r === t) n = !0;
                else if (n) break;
            } else n && e.push(o);
        }
        return e;
    }
}
const $741c336afc2dfa06$var$Pn = function(t) {
    if (t.nodeType === Node.TEXT_NODE) {
        if ($741c336afc2dfa06$var$F(t)) return 0;
        return t.textContent.length;
    }
    return "br" === $741c336afc2dfa06$var$k(t) || $741c336afc2dfa06$var$P(t) ? 1 : 0;
}, $741c336afc2dfa06$var$Mn = function(t) {
    return $741c336afc2dfa06$var$Bn(t) === NodeFilter.FILTER_ACCEPT ? $741c336afc2dfa06$var$_n(t) : NodeFilter.FILTER_REJECT;
}, $741c336afc2dfa06$var$Bn = function(t) {
    return $741c336afc2dfa06$var$M(t) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
}, $741c336afc2dfa06$var$_n = function(t) {
    return $741c336afc2dfa06$var$P(t.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
};
class $741c336afc2dfa06$var$jn {
    createDOMRangeFromPoint(t) {
        let e, { x: i, y: n } = t;
        if (document.caretPositionFromPoint) {
            const { offsetNode: t, offset: r } = document.caretPositionFromPoint(i, n);
            return e = document.createRange(), e.setStart(t, r), e;
        }
        if (document.caretRangeFromPoint) return document.caretRangeFromPoint(i, n);
        if (document.body.createTextRange) {
            const t = $741c336afc2dfa06$var$Mt();
            try {
                const t = document.body.createTextRange();
                t.moveToPoint(i, n), t.select();
            } catch (t) {}
            return e = $741c336afc2dfa06$var$Mt(), $741c336afc2dfa06$var$Bt(t), e;
        }
    }
    getClientRectsForDOMRange(t) {
        const e = Array.from(t.getClientRects());
        return [
            e[0],
            e[e.length - 1]
        ];
    }
}
class $741c336afc2dfa06$var$Wn extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(...arguments), this.didMouseDown = this.didMouseDown.bind(this), this.selectionDidChange = this.selectionDidChange.bind(this), this.element = t, this.locationMapper = new $741c336afc2dfa06$var$Fn(this.element), this.pointMapper = new $741c336afc2dfa06$var$jn, this.lockCount = 0, $741c336afc2dfa06$var$b("mousedown", {
            onElement: this.element,
            withCallback: this.didMouseDown
        });
    }
    getLocationRange() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return !1 === t.strict ? this.createLocationRangeFromDOMRange($741c336afc2dfa06$var$Mt()) : t.ignoreLock ? this.currentLocationRange : this.lockedLocationRange ? this.lockedLocationRange : this.currentLocationRange;
    }
    setLocationRange(t) {
        if (this.lockedLocationRange) return;
        t = $741c336afc2dfa06$var$wt(t);
        const e = this.createDOMRangeFromLocationRange(t);
        e && ($741c336afc2dfa06$var$Bt(e), this.updateCurrentLocationRange(t));
    }
    setLocationRangeFromPointRange(t) {
        t = $741c336afc2dfa06$var$wt(t);
        const e = this.getLocationAtPoint(t[0]), i = this.getLocationAtPoint(t[1]);
        this.setLocationRange([
            e,
            i
        ]);
    }
    getClientRectAtLocationRange(t) {
        const e = this.createDOMRangeFromLocationRange(t);
        if (e) return this.getClientRectsForDOMRange(e)[1];
    }
    locationIsCursorTarget(t) {
        const e = Array.from(this.findNodeAndOffsetFromLocation(t))[0];
        return $741c336afc2dfa06$var$F(e);
    }
    lock() {
        0 == this.lockCount++ && (this.updateCurrentLocationRange(), this.lockedLocationRange = this.getLocationRange());
    }
    unlock() {
        if (0 == --this.lockCount) {
            const { lockedLocationRange: t } = this;
            if (this.lockedLocationRange = null, null != t) return this.setLocationRange(t);
        }
    }
    clearSelection() {
        var t;
        return null === (t = $741c336afc2dfa06$var$Pt()) || void 0 === t ? void 0 : t.removeAllRanges();
    }
    selectionIsCollapsed() {
        var t;
        return !0 === (null === (t = $741c336afc2dfa06$var$Mt()) || void 0 === t ? void 0 : t.collapsed);
    }
    selectionIsExpanded() {
        return !this.selectionIsCollapsed();
    }
    createLocationRangeFromDOMRange(t, e) {
        if (null == t || !this.domRangeWithinElement(t)) return;
        const i = this.findLocationFromContainerAndOffset(t.startContainer, t.startOffset, e);
        if (!i) return;
        const n = t.collapsed ? void 0 : this.findLocationFromContainerAndOffset(t.endContainer, t.endOffset, e);
        return $741c336afc2dfa06$var$wt([
            i,
            n
        ]);
    }
    didMouseDown() {
        return this.pauseTemporarily();
    }
    pauseTemporarily() {
        let t;
        this.paused = !0;
        const e = ()=>{
            if (this.paused = !1, clearTimeout(i), Array.from(t).forEach((t)=>{
                t.destroy();
            }), $741c336afc2dfa06$var$C(document, this.element)) return this.selectionDidChange();
        }, i = setTimeout(e, 200);
        t = [
            "mousemove",
            "keydown"
        ].map((t)=>$741c336afc2dfa06$var$b(t, {
                onElement: document,
                withCallback: e
            }));
    }
    selectionDidChange() {
        if (!this.paused && !$741c336afc2dfa06$var$x(this.element)) return this.updateCurrentLocationRange();
    }
    updateCurrentLocationRange(t) {
        var e, i;
        if ((null != t ? t : t = this.createLocationRangeFromDOMRange($741c336afc2dfa06$var$Mt())) && !$741c336afc2dfa06$var$Dt(t, this.currentLocationRange)) return this.currentLocationRange = t, null === (e = this.delegate) || void 0 === e || null === (i = e.locationRangeDidChange) || void 0 === i ? void 0 : i.call(e, this.currentLocationRange.slice(0));
    }
    createDOMRangeFromLocationRange(t) {
        const e = this.findContainerAndOffsetFromLocation(t[0]), i = $741c336afc2dfa06$var$Lt(t) ? e : this.findContainerAndOffsetFromLocation(t[1]) || e;
        if (null != e && null != i) {
            const t = document.createRange();
            return t.setStart(...Array.from(e || [])), t.setEnd(...Array.from(i || [])), t;
        }
    }
    getLocationAtPoint(t) {
        const e = this.createDOMRangeFromPoint(t);
        var i;
        if (e) return null === (i = this.createLocationRangeFromDOMRange(e)) || void 0 === i ? void 0 : i[0];
    }
    domRangeWithinElement(t) {
        return t.collapsed ? $741c336afc2dfa06$var$C(this.element, t.startContainer) : $741c336afc2dfa06$var$C(this.element, t.startContainer) && $741c336afc2dfa06$var$C(this.element, t.endContainer);
    }
}
$741c336afc2dfa06$var$Wn.proxyMethod("locationMapper.findLocationFromContainerAndOffset"), $741c336afc2dfa06$var$Wn.proxyMethod("locationMapper.findContainerAndOffsetFromLocation"), $741c336afc2dfa06$var$Wn.proxyMethod("locationMapper.findNodeAndOffsetFromLocation"), $741c336afc2dfa06$var$Wn.proxyMethod("pointMapper.createDOMRangeFromPoint"), $741c336afc2dfa06$var$Wn.proxyMethod("pointMapper.getClientRectsForDOMRange");
var $741c336afc2dfa06$var$Un = Object.freeze({
    __proto__: null,
    Attachment: $741c336afc2dfa06$var$Wi,
    AttachmentManager: $741c336afc2dfa06$var$Sn,
    AttachmentPiece: $741c336afc2dfa06$var$Ui,
    Block: $741c336afc2dfa06$var$Gi,
    Composition: $741c336afc2dfa06$var$kn,
    Document: $741c336afc2dfa06$var$on,
    Editor: $741c336afc2dfa06$var$On,
    HTMLParser: $741c336afc2dfa06$var$cn,
    HTMLSanitizer: $741c336afc2dfa06$var$ui,
    LineBreakInsertion: $741c336afc2dfa06$var$Rn,
    LocationMapper: $741c336afc2dfa06$var$Fn,
    ManagedAttachment: $741c336afc2dfa06$var$En,
    Piece: $741c336afc2dfa06$var$_i,
    PointMapper: $741c336afc2dfa06$var$jn,
    SelectionManager: $741c336afc2dfa06$var$Wn,
    SplittableList: $741c336afc2dfa06$var$zi,
    StringPiece: $741c336afc2dfa06$var$Vi,
    Text: $741c336afc2dfa06$var$Ki,
    UndoManager: $741c336afc2dfa06$var$Tn
}), $741c336afc2dfa06$var$Vn = Object.freeze({
    __proto__: null,
    ObjectView: $741c336afc2dfa06$var$ie,
    AttachmentView: $741c336afc2dfa06$var$gi,
    BlockView: $741c336afc2dfa06$var$xi,
    DocumentView: $741c336afc2dfa06$var$Ci,
    PieceView: $741c336afc2dfa06$var$bi,
    PreviewableAttachmentView: $741c336afc2dfa06$var$fi,
    TextView: $741c336afc2dfa06$var$vi
});
const { lang: $741c336afc2dfa06$var$zn, css: $741c336afc2dfa06$var$qn, keyNames: $741c336afc2dfa06$var$Hn } = $741c336afc2dfa06$var$z, $741c336afc2dfa06$var$Jn = function(t) {
    return function() {
        const e = t.apply(this, arguments);
        e.do(), this.undos || (this.undos = []), this.undos.push(e.undo);
    };
};
class $741c336afc2dfa06$var$Kn extends $741c336afc2dfa06$var$q {
    constructor(t, e, i){
        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        super(...arguments), $741c336afc2dfa06$var$wi(this, "makeElementMutable", $741c336afc2dfa06$var$Jn(()=>({
                do: ()=>{
                    this.element.dataset.trixMutable = !0;
                },
                undo: ()=>delete this.element.dataset.trixMutable
            }))), $741c336afc2dfa06$var$wi(this, "addToolbar", $741c336afc2dfa06$var$Jn(()=>{
            const t = $741c336afc2dfa06$var$T({
                tagName: "div",
                className: $741c336afc2dfa06$var$qn.attachmentToolbar,
                data: {
                    trixMutable: !0
                },
                childNodes: $741c336afc2dfa06$var$T({
                    tagName: "div",
                    className: "trix-button-row",
                    childNodes: $741c336afc2dfa06$var$T({
                        tagName: "span",
                        className: "trix-button-group trix-button-group--actions",
                        childNodes: $741c336afc2dfa06$var$T({
                            tagName: "button",
                            className: "trix-button trix-button--remove",
                            textContent: $741c336afc2dfa06$var$zn.remove,
                            attributes: {
                                title: $741c336afc2dfa06$var$zn.remove
                            },
                            data: {
                                trixAction: "remove"
                            }
                        })
                    })
                })
            });
            return this.attachment.isPreviewable() && t.appendChild($741c336afc2dfa06$var$T({
                tagName: "div",
                className: $741c336afc2dfa06$var$qn.attachmentMetadataContainer,
                childNodes: $741c336afc2dfa06$var$T({
                    tagName: "span",
                    className: $741c336afc2dfa06$var$qn.attachmentMetadata,
                    childNodes: [
                        $741c336afc2dfa06$var$T({
                            tagName: "span",
                            className: $741c336afc2dfa06$var$qn.attachmentName,
                            textContent: this.attachment.getFilename(),
                            attributes: {
                                title: this.attachment.getFilename()
                            }
                        }),
                        $741c336afc2dfa06$var$T({
                            tagName: "span",
                            className: $741c336afc2dfa06$var$qn.attachmentSize,
                            textContent: this.attachment.getFormattedFilesize()
                        })
                    ]
                })
            })), $741c336afc2dfa06$var$b("click", {
                onElement: t,
                withCallback: this.didClickToolbar
            }), $741c336afc2dfa06$var$b("click", {
                onElement: t,
                matchingSelector: "[data-trix-action]",
                withCallback: this.didClickActionButton
            }), $741c336afc2dfa06$var$v("trix-attachment-before-toolbar", {
                onElement: this.element,
                attributes: {
                    toolbar: t,
                    attachment: this.attachment
                }
            }), {
                do: ()=>this.element.appendChild(t),
                undo: ()=>$741c336afc2dfa06$var$S(t)
            };
        })), $741c336afc2dfa06$var$wi(this, "installCaptionEditor", $741c336afc2dfa06$var$Jn(()=>{
            const t = $741c336afc2dfa06$var$T({
                tagName: "textarea",
                className: $741c336afc2dfa06$var$qn.attachmentCaptionEditor,
                attributes: {
                    placeholder: $741c336afc2dfa06$var$zn.captionPlaceholder
                },
                data: {
                    trixMutable: !0
                }
            });
            t.value = this.attachmentPiece.getCaption();
            const e = t.cloneNode();
            e.classList.add("trix-autoresize-clone"), e.tabIndex = -1;
            const i = function() {
                e.value = t.value, t.style.height = e.scrollHeight + "px";
            };
            $741c336afc2dfa06$var$b("input", {
                onElement: t,
                withCallback: i
            }), $741c336afc2dfa06$var$b("input", {
                onElement: t,
                withCallback: this.didInputCaption
            }), $741c336afc2dfa06$var$b("keydown", {
                onElement: t,
                withCallback: this.didKeyDownCaption
            }), $741c336afc2dfa06$var$b("change", {
                onElement: t,
                withCallback: this.didChangeCaption
            }), $741c336afc2dfa06$var$b("blur", {
                onElement: t,
                withCallback: this.didBlurCaption
            });
            const n = this.element.querySelector("figcaption"), r = n.cloneNode();
            return {
                do: ()=>{
                    if (n.style.display = "none", r.appendChild(t), r.appendChild(e), r.classList.add("".concat($741c336afc2dfa06$var$qn.attachmentCaption, "--editing")), n.parentElement.insertBefore(r, n), i(), this.options.editCaption) return $741c336afc2dfa06$var$Rt(()=>t.focus());
                },
                undo () {
                    $741c336afc2dfa06$var$S(r), n.style.display = null;
                }
            };
        })), this.didClickToolbar = this.didClickToolbar.bind(this), this.didClickActionButton = this.didClickActionButton.bind(this), this.didKeyDownCaption = this.didKeyDownCaption.bind(this), this.didInputCaption = this.didInputCaption.bind(this), this.didChangeCaption = this.didChangeCaption.bind(this), this.didBlurCaption = this.didBlurCaption.bind(this), this.attachmentPiece = t, this.element = e, this.container = i, this.options = n, this.attachment = this.attachmentPiece.attachment, "a" === $741c336afc2dfa06$var$k(this.element) && (this.element = this.element.firstChild), this.install();
    }
    install() {
        this.makeElementMutable(), this.addToolbar(), this.attachment.isPreviewable() && this.installCaptionEditor();
    }
    uninstall() {
        var t;
        let e = this.undos.pop();
        for(this.savePendingCaption(); e;)e(), e = this.undos.pop();
        null === (t = this.delegate) || void 0 === t || t.didUninstallAttachmentEditor(this);
    }
    savePendingCaption() {
        if (null != this.pendingCaption) {
            const r = this.pendingCaption;
            var t, e, i, n;
            if (this.pendingCaption = null, r) null === (t = this.delegate) || void 0 === t || null === (e = t.attachmentEditorDidRequestUpdatingAttributesForAttachment) || void 0 === e || e.call(t, {
                caption: r
            }, this.attachment);
            else null === (i = this.delegate) || void 0 === i || null === (n = i.attachmentEditorDidRequestRemovingAttributeForAttachment) || void 0 === n || n.call(i, "caption", this.attachment);
        }
    }
    didClickToolbar(t) {
        return t.preventDefault(), t.stopPropagation();
    }
    didClickActionButton(t) {
        var e;
        if ("remove" === t.target.getAttribute("data-trix-action")) return null === (e = this.delegate) || void 0 === e ? void 0 : e.attachmentEditorDidRequestRemovalOfAttachment(this.attachment);
    }
    didKeyDownCaption(t) {
        var e, i;
        if ("return" === $741c336afc2dfa06$var$Hn[t.keyCode]) return t.preventDefault(), this.savePendingCaption(), null === (e = this.delegate) || void 0 === e || null === (i = e.attachmentEditorDidRequestDeselectingAttachment) || void 0 === i ? void 0 : i.call(e, this.attachment);
    }
    didInputCaption(t) {
        this.pendingCaption = t.target.value.replace(/\s/g, " ").trim();
    }
    didChangeCaption(t) {
        return this.savePendingCaption();
    }
    didBlurCaption(t) {
        return this.savePendingCaption();
    }
}
class $741c336afc2dfa06$var$Gn extends $741c336afc2dfa06$var$q {
    constructor(t, i){
        super(...arguments), this.didFocus = this.didFocus.bind(this), this.didBlur = this.didBlur.bind(this), this.didClickAttachment = this.didClickAttachment.bind(this), this.element = t, this.composition = i, this.documentView = new $741c336afc2dfa06$var$Ci(this.composition.document, {
            element: this.element
        }), $741c336afc2dfa06$var$b("focus", {
            onElement: this.element,
            withCallback: this.didFocus
        }), $741c336afc2dfa06$var$b("blur", {
            onElement: this.element,
            withCallback: this.didBlur
        }), $741c336afc2dfa06$var$b("click", {
            onElement: this.element,
            matchingSelector: "a[contenteditable=false]",
            preventDefault: !0
        }), $741c336afc2dfa06$var$b("mousedown", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$e,
            withCallback: this.didClickAttachment
        }), $741c336afc2dfa06$var$b("click", {
            onElement: this.element,
            matchingSelector: "a".concat($741c336afc2dfa06$var$e),
            preventDefault: !0
        });
    }
    didFocus(t) {
        var e;
        const i = ()=>{
            var t, e;
            if (!this.focused) return this.focused = !0, null === (t = this.delegate) || void 0 === t || null === (e = t.compositionControllerDidFocus) || void 0 === e ? void 0 : e.call(t);
        };
        return (null === (e = this.blurPromise) || void 0 === e ? void 0 : e.then(i)) || i();
    }
    didBlur(t) {
        this.blurPromise = new Promise((t)=>$741c336afc2dfa06$var$Rt(()=>{
                var e, i;
                $741c336afc2dfa06$var$x(this.element) || (this.focused = null, null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidBlur) || void 0 === i || i.call(e));
                return this.blurPromise = null, t();
            }));
    }
    didClickAttachment(t, e) {
        var i, n;
        const r = this.findAttachmentForElement(e), o = !!$741c336afc2dfa06$var$y(t.target, {
            matchingSelector: "figcaption"
        });
        return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerDidSelectAttachment) || void 0 === n ? void 0 : n.call(i, r, {
            editCaption: o
        });
    }
    getSerializableElement() {
        return this.isEditingAttachment() ? this.documentView.shadowElement : this.element;
    }
    render() {
        var t, e, i, n, r, o;
        (this.revision !== this.composition.revision && (this.documentView.setDocument(this.composition.document), this.documentView.render(), this.revision = this.composition.revision), this.canSyncDocumentView() && !this.documentView.isSynced()) && (null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillSyncDocumentView) || void 0 === n || n.call(i), this.documentView.sync(), null === (r = this.delegate) || void 0 === r || null === (o = r.compositionControllerDidSyncDocumentView) || void 0 === o || o.call(r));
        return null === (t = this.delegate) || void 0 === t || null === (e = t.compositionControllerDidRender) || void 0 === e ? void 0 : e.call(t);
    }
    rerenderViewForObject(t) {
        return this.invalidateViewForObject(t), this.render();
    }
    invalidateViewForObject(t) {
        return this.documentView.invalidateViewForObject(t);
    }
    isViewCachingEnabled() {
        return this.documentView.isViewCachingEnabled();
    }
    enableViewCaching() {
        return this.documentView.enableViewCaching();
    }
    disableViewCaching() {
        return this.documentView.disableViewCaching();
    }
    refreshViewCache() {
        return this.documentView.garbageCollectCachedViews();
    }
    isEditingAttachment() {
        return !!this.attachmentEditor;
    }
    installAttachmentEditorForAttachment(t, e) {
        var i;
        if ((null === (i = this.attachmentEditor) || void 0 === i ? void 0 : i.attachment) === t) return;
        const n = this.documentView.findElementForObject(t);
        if (!n) return;
        this.uninstallAttachmentEditor();
        const r = this.composition.document.getAttachmentPieceForAttachment(t);
        this.attachmentEditor = new $741c336afc2dfa06$var$Kn(r, n, this.element, e), this.attachmentEditor.delegate = this;
    }
    uninstallAttachmentEditor() {
        var t;
        return null === (t = this.attachmentEditor) || void 0 === t ? void 0 : t.uninstall();
    }
    didUninstallAttachmentEditor() {
        return this.attachmentEditor = null, this.render();
    }
    attachmentEditorDidRequestUpdatingAttributesForAttachment(t, e) {
        var i, n;
        return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillUpdateAttachment) || void 0 === n || n.call(i, e), this.composition.updateAttributesForAttachment(t, e);
    }
    attachmentEditorDidRequestRemovingAttributeForAttachment(t, e) {
        var i, n;
        return null === (i = this.delegate) || void 0 === i || null === (n = i.compositionControllerWillUpdateAttachment) || void 0 === n || n.call(i, e), this.composition.removeAttributeForAttachment(t, e);
    }
    attachmentEditorDidRequestRemovalOfAttachment(t) {
        var e, i;
        return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidRequestRemovalOfAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    attachmentEditorDidRequestDeselectingAttachment(t) {
        var e, i;
        return null === (e = this.delegate) || void 0 === e || null === (i = e.compositionControllerDidRequestDeselectingAttachment) || void 0 === i ? void 0 : i.call(e, t);
    }
    canSyncDocumentView() {
        return !this.isEditingAttachment();
    }
    findAttachmentForElement(t) {
        return this.composition.document.getAttachmentById(parseInt(t.dataset.trixId, 10));
    }
}
class $741c336afc2dfa06$var$Yn extends $741c336afc2dfa06$var$q {
}
const $741c336afc2dfa06$var$$n = "data-trix-mutable", $741c336afc2dfa06$var$Xn = "[".concat($741c336afc2dfa06$var$$n, "]"), $741c336afc2dfa06$var$Zn = {
    attributes: !0,
    childList: !0,
    characterData: !0,
    characterDataOldValue: !0,
    subtree: !0
};
class $741c336afc2dfa06$var$Qn extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(t), this.didMutate = this.didMutate.bind(this), this.element = t, this.observer = new window.MutationObserver(this.didMutate), this.start();
    }
    start() {
        return this.reset(), this.observer.observe(this.element, $741c336afc2dfa06$var$Zn);
    }
    stop() {
        return this.observer.disconnect();
    }
    didMutate(t) {
        var e, i;
        if (this.mutations.push(...Array.from(this.findSignificantMutations(t) || [])), this.mutations.length) return null === (e = this.delegate) || void 0 === e || null === (i = e.elementDidMutate) || void 0 === i || i.call(e, this.getMutationSummary()), this.reset();
    }
    reset() {
        this.mutations = [];
    }
    findSignificantMutations(t) {
        return t.filter((t)=>this.mutationIsSignificant(t));
    }
    mutationIsSignificant(t) {
        if (this.nodeIsMutable(t.target)) return !1;
        for (const e of Array.from(this.nodesModifiedByMutation(t)))if (this.nodeIsSignificant(e)) return !0;
        return !1;
    }
    nodeIsSignificant(t) {
        return t !== this.element && !this.nodeIsMutable(t) && !$741c336afc2dfa06$var$M(t);
    }
    nodeIsMutable(t) {
        return $741c336afc2dfa06$var$y(t, {
            matchingSelector: $741c336afc2dfa06$var$Xn
        });
    }
    nodesModifiedByMutation(t) {
        const e = [];
        switch(t.type){
            case "attributes":
                t.attributeName !== $741c336afc2dfa06$var$$n && e.push(t.target);
                break;
            case "characterData":
                e.push(t.target.parentNode), e.push(t.target);
                break;
            case "childList":
                e.push(...Array.from(t.addedNodes || [])), e.push(...Array.from(t.removedNodes || []));
        }
        return e;
    }
    getMutationSummary() {
        return this.getTextMutationSummary();
    }
    getTextMutationSummary() {
        const { additions: t, deletions: e } = this.getTextChangesFromCharacterData(), i = this.getTextChangesFromChildList();
        Array.from(i.additions).forEach((e)=>{
            Array.from(t).includes(e) || t.push(e);
        }), e.push(...Array.from(i.deletions || []));
        const n = {}, r = t.join("");
        r && (n.textAdded = r);
        const o = e.join("");
        return o && (n.textDeleted = o), n;
    }
    getMutationsByType(t) {
        return Array.from(this.mutations).filter((e)=>e.type === t);
    }
    getTextChangesFromChildList() {
        let t, e;
        const i = [], n = [];
        Array.from(this.getMutationsByType("childList")).forEach((t)=>{
            i.push(...Array.from(t.addedNodes || [])), n.push(...Array.from(t.removedNodes || []));
        });
        0 === i.length && 1 === n.length && $741c336afc2dfa06$var$I(n[0]) ? (t = [], e = [
            "\n"
        ]) : (t = $741c336afc2dfa06$var$tr(i), e = $741c336afc2dfa06$var$tr(n));
        const r = t.filter((t, i)=>t !== e[i]).map($741c336afc2dfa06$var$Wt), o = e.filter((e, i)=>e !== t[i]).map($741c336afc2dfa06$var$Wt);
        return {
            additions: r,
            deletions: o
        };
    }
    getTextChangesFromCharacterData() {
        let t, e;
        const i = this.getMutationsByType("characterData");
        if (i.length) {
            const n = i[0], r = i[i.length - 1], o = function(t, e) {
                let i, n;
                return t = $741c336afc2dfa06$var$X.box(t), (e = $741c336afc2dfa06$var$X.box(e)).length < t.length ? [n, i] = $741c336afc2dfa06$var$zt(t, e) : [i, n] = $741c336afc2dfa06$var$zt(e, t), {
                    added: i,
                    removed: n
                };
            }($741c336afc2dfa06$var$Wt(n.oldValue), $741c336afc2dfa06$var$Wt(r.target.data));
            t = o.added, e = o.removed;
        }
        return {
            additions: t ? [
                t
            ] : [],
            deletions: e ? [
                e
            ] : []
        };
    }
}
const $741c336afc2dfa06$var$tr = function() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
    const e = [];
    for (const i of Array.from(t))switch(i.nodeType){
        case Node.TEXT_NODE:
            e.push(i.data);
            break;
        case Node.ELEMENT_NODE:
            "br" === $741c336afc2dfa06$var$k(i) ? e.push("\n") : e.push(...Array.from($741c336afc2dfa06$var$tr(i.childNodes) || []));
    }
    return e;
};
class $741c336afc2dfa06$var$er extends $741c336afc2dfa06$var$ee {
    constructor(t){
        super(...arguments), this.file = t;
    }
    perform(t) {
        const e = new FileReader;
        return e.onerror = ()=>t(!1), e.onload = ()=>{
            e.onerror = null;
            try {
                e.abort();
            } catch (t) {}
            return t(!0, this.file);
        }, e.readAsArrayBuffer(this.file);
    }
}
class $741c336afc2dfa06$var$ir {
    constructor(t){
        this.element = t;
    }
    shouldIgnore(t) {
        return !!$741c336afc2dfa06$var$a.samsungAndroid && (this.previousEvent = this.event, this.event = t, this.checkSamsungKeyboardBuggyModeStart(), this.checkSamsungKeyboardBuggyModeEnd(), this.buggyMode);
    }
    checkSamsungKeyboardBuggyModeStart() {
        this.insertingLongTextAfterUnidentifiedChar() && $741c336afc2dfa06$var$nr(this.element.innerText, this.event.data) && (this.buggyMode = !0, this.event.preventDefault());
    }
    checkSamsungKeyboardBuggyModeEnd() {
        this.buggyMode && "insertText" !== this.event.inputType && (this.buggyMode = !1);
    }
    insertingLongTextAfterUnidentifiedChar() {
        var t;
        return this.isBeforeInputInsertText() && this.previousEventWasUnidentifiedKeydown() && (null === (t = this.event.data) || void 0 === t ? void 0 : t.length) > 50;
    }
    isBeforeInputInsertText() {
        return "beforeinput" === this.event.type && "insertText" === this.event.inputType;
    }
    previousEventWasUnidentifiedKeydown() {
        var t, e;
        return "keydown" === (null === (t = this.previousEvent) || void 0 === t ? void 0 : t.type) && "Unidentified" === (null === (e = this.previousEvent) || void 0 === e ? void 0 : e.key);
    }
}
const $741c336afc2dfa06$var$nr = (t, e)=>$741c336afc2dfa06$var$or(t) === $741c336afc2dfa06$var$or(e), $741c336afc2dfa06$var$rr = new RegExp("(".concat("\uFFFC", "|").concat($741c336afc2dfa06$var$d, "|").concat($741c336afc2dfa06$var$g, "|\\s)+"), "g"), $741c336afc2dfa06$var$or = (t)=>t.replace($741c336afc2dfa06$var$rr, " ").trim();
class $741c336afc2dfa06$var$sr extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(...arguments), this.element = t, this.mutationObserver = new $741c336afc2dfa06$var$Qn(this.element), this.mutationObserver.delegate = this, this.flakyKeyboardDetector = new $741c336afc2dfa06$var$ir(this.element);
        for(const t in this.constructor.events)$741c336afc2dfa06$var$b(t, {
            onElement: this.element,
            withCallback: this.handlerFor(t)
        });
    }
    elementDidMutate(t) {}
    editorWillSyncDocumentView() {
        return this.mutationObserver.stop();
    }
    editorDidSyncDocumentView() {
        return this.mutationObserver.start();
    }
    requestRender() {
        var t, e;
        return null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidRequestRender) || void 0 === e ? void 0 : e.call(t);
    }
    requestReparse() {
        var t, e;
        return null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidRequestReparse) || void 0 === e || e.call(t), this.requestRender();
    }
    attachFiles(t) {
        const e = Array.from(t).map((t)=>new $741c336afc2dfa06$var$er(t));
        return Promise.all(e).then((t)=>{
            this.handleInput(function() {
                var e, i;
                return null === (e = this.delegate) || void 0 === e || e.inputControllerWillAttachFiles(), null === (i = this.responder) || void 0 === i || i.insertFiles(t), this.requestRender();
            });
        });
    }
    handlerFor(t) {
        return (e)=>{
            e.defaultPrevented || this.handleInput(()=>{
                if (!$741c336afc2dfa06$var$x(this.element)) {
                    if (this.flakyKeyboardDetector.shouldIgnore(e)) return;
                    this.eventName = t, this.constructor.events[t].call(this, e);
                }
            });
        };
    }
    handleInput(t) {
        try {
            var e;
            null === (e = this.delegate) || void 0 === e || e.inputControllerWillHandleInput(), t.call(this);
        } finally{
            var i;
            null === (i = this.delegate) || void 0 === i || i.inputControllerDidHandleInput();
        }
    }
    createLinkHTML(t, e) {
        const i = document.createElement("a");
        return i.href = t, i.textContent = e || t, i.outerHTML;
    }
}
var $741c336afc2dfa06$var$ar;
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$sr, "events", {});
const { browser: $741c336afc2dfa06$var$lr, keyNames: $741c336afc2dfa06$var$cr } = $741c336afc2dfa06$var$z;
let $741c336afc2dfa06$var$ur = 0;
class $741c336afc2dfa06$var$hr extends $741c336afc2dfa06$var$sr {
    constructor(){
        super(...arguments), this.resetInputSummary();
    }
    setInputSummary() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        this.inputSummary.eventName = this.eventName;
        for(const e in t){
            const i = t[e];
            this.inputSummary[e] = i;
        }
        return this.inputSummary;
    }
    resetInputSummary() {
        this.inputSummary = {};
    }
    reset() {
        return this.resetInputSummary(), $741c336afc2dfa06$var$Ft.reset();
    }
    elementDidMutate(t) {
        var e, i;
        return this.isComposing() ? null === (e = this.delegate) || void 0 === e || null === (i = e.inputControllerDidAllowUnhandledInput) || void 0 === i ? void 0 : i.call(e) : this.handleInput(function() {
            return this.mutationIsSignificant(t) && (this.mutationIsExpected(t) ? this.requestRender() : this.requestReparse()), this.reset();
        });
    }
    mutationIsExpected(t) {
        let { textAdded: e, textDeleted: i } = t;
        if (this.inputSummary.preferDocument) return !0;
        const n = null != e ? e === this.inputSummary.textAdded : !this.inputSummary.textAdded, r = null != i ? this.inputSummary.didDelete : !this.inputSummary.didDelete, o = [
            "\n",
            " \n"
        ].includes(e) && !n, s = "\n" === i && !r;
        if (o && !s || s && !o) {
            const t = this.getSelectedRange();
            if (t) {
                var a;
                const i = o ? e.replace(/\n$/, "").length || -1 : (null == e ? void 0 : e.length) || 1;
                if (null !== (a = this.responder) && void 0 !== a && a.positionIsBlockBreak(t[1] + i)) return !0;
            }
        }
        return n && r;
    }
    mutationIsSignificant(t) {
        var e;
        const i = Object.keys(t).length > 0, n = "" === (null === (e = this.compositionInput) || void 0 === e ? void 0 : e.getEndData());
        return i || !n;
    }
    getCompositionInput() {
        if (this.isComposing()) return this.compositionInput;
        this.compositionInput = new $741c336afc2dfa06$var$fr(this);
    }
    isComposing() {
        return this.compositionInput && !this.compositionInput.isEnded();
    }
    deleteInDirection(t, e) {
        var i;
        return !1 !== (null === (i = this.responder) || void 0 === i ? void 0 : i.deleteInDirection(t)) ? this.setInputSummary({
            didDelete: !0
        }) : e ? (e.preventDefault(), this.requestRender()) : void 0;
    }
    serializeSelectionToDataTransfer(t) {
        var e;
        if (!function(t) {
            if (null == t || !t.setData) return !1;
            for(const e in $741c336afc2dfa06$var$Ct){
                const i = $741c336afc2dfa06$var$Ct[e];
                try {
                    if (t.setData(e, i), !t.getData(e) === i) return !1;
                } catch (t) {
                    return !1;
                }
            }
            return !0;
        }(t)) return;
        const i = null === (e = this.responder) || void 0 === e ? void 0 : e.getSelectedDocument().toSerializableDocument();
        return t.setData("application/x-trix-document", JSON.stringify(i)), t.setData("text/html", $741c336afc2dfa06$var$Ci.render(i).innerHTML), t.setData("text/plain", i.toString().replace(/\n$/, "")), !0;
    }
    canAcceptDataTransfer(t) {
        const e = {};
        return Array.from((null == t ? void 0 : t.types) || []).forEach((t)=>{
            e[t] = !0;
        }), e.Files || e["application/x-trix-document"] || e["text/html"] || e["text/plain"];
    }
    getPastedHTMLUsingHiddenElement(t) {
        const e = this.getSelectedRange(), i = {
            position: "absolute",
            left: "".concat(window.pageXOffset, "px"),
            top: "".concat(window.pageYOffset, "px"),
            opacity: 0
        }, n = $741c336afc2dfa06$var$T({
            style: i,
            tagName: "div",
            editable: !0
        });
        return document.body.appendChild(n), n.focus(), requestAnimationFrame(()=>{
            const i = n.innerHTML;
            return $741c336afc2dfa06$var$S(n), this.setSelectedRange(e), t(i);
        });
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$hr, "events", {
    keydown (t) {
        this.isComposing() || this.resetInputSummary(), this.inputSummary.didInput = !0;
        const e = $741c336afc2dfa06$var$cr[t.keyCode];
        if (e) {
            var i;
            let n = this.keys;
            [
                "ctrl",
                "alt",
                "shift",
                "meta"
            ].forEach((e)=>{
                var i;
                t["".concat(e, "Key")] && ("ctrl" === e && (e = "control"), n = null === (i = n) || void 0 === i ? void 0 : i[e]);
            }), null != (null === (i = n) || void 0 === i ? void 0 : i[e]) && (this.setInputSummary({
                keyName: e
            }), $741c336afc2dfa06$var$Ft.reset(), n[e].call(this, t));
        }
        if ($741c336afc2dfa06$var$St(t)) {
            const e = String.fromCharCode(t.keyCode).toLowerCase();
            if (e) {
                var n;
                const i = [
                    "alt",
                    "shift"
                ].map((e)=>{
                    if (t["".concat(e, "Key")]) return e;
                }).filter((t)=>t);
                i.push(e), null !== (n = this.delegate) && void 0 !== n && n.inputControllerDidReceiveKeyboardCommand(i) && t.preventDefault();
            }
        }
    },
    keypress (t) {
        if (null != this.inputSummary.eventName) return;
        if (t.metaKey) return;
        if (t.ctrlKey && !t.altKey) return;
        const e = $741c336afc2dfa06$var$mr(t);
        var i, n;
        return e ? (null === (i = this.delegate) || void 0 === i || i.inputControllerWillPerformTyping(), null === (n = this.responder) || void 0 === n || n.insertString(e), this.setInputSummary({
            textAdded: e,
            didDelete: this.selectionIsExpanded()
        })) : void 0;
    },
    textInput (t) {
        const { data: e } = t, { textAdded: i } = this.inputSummary;
        if (i && i !== e && i.toUpperCase() === e) {
            var n;
            const t = this.getSelectedRange();
            return this.setSelectedRange([
                t[0],
                t[1] + i.length
            ]), null === (n = this.responder) || void 0 === n || n.insertString(e), this.setInputSummary({
                textAdded: e
            }), this.setSelectedRange(t);
        }
    },
    dragenter (t) {
        t.preventDefault();
    },
    dragstart (t) {
        var e, i;
        return this.serializeSelectionToDataTransfer(t.dataTransfer), this.draggedRange = this.getSelectedRange(), null === (e = this.delegate) || void 0 === e || null === (i = e.inputControllerDidStartDrag) || void 0 === i ? void 0 : i.call(e);
    },
    dragover (t) {
        if (this.draggedRange || this.canAcceptDataTransfer(t.dataTransfer)) {
            t.preventDefault();
            const n = {
                x: t.clientX,
                y: t.clientY
            };
            var e, i;
            if (!$741c336afc2dfa06$var$Tt(n, this.draggingPoint)) return this.draggingPoint = n, null === (e = this.delegate) || void 0 === e || null === (i = e.inputControllerDidReceiveDragOverPoint) || void 0 === i ? void 0 : i.call(e, this.draggingPoint);
        }
    },
    dragend (t) {
        var e, i;
        null === (e = this.delegate) || void 0 === e || null === (i = e.inputControllerDidCancelDrag) || void 0 === i || i.call(e), this.draggedRange = null, this.draggingPoint = null;
    },
    drop (t) {
        var e, i;
        t.preventDefault();
        const n = null === (e = t.dataTransfer) || void 0 === e ? void 0 : e.files, r = t.dataTransfer.getData("application/x-trix-document"), o = {
            x: t.clientX,
            y: t.clientY
        };
        if (null === (i = this.responder) || void 0 === i || i.setLocationRangeFromPointRange(o), null != n && n.length) this.attachFiles(n);
        else if (this.draggedRange) {
            var s, a;
            null === (s = this.delegate) || void 0 === s || s.inputControllerWillMoveText(), null === (a = this.responder) || void 0 === a || a.moveTextFromRange(this.draggedRange), this.draggedRange = null, this.requestRender();
        } else if (r) {
            var l;
            const t = $741c336afc2dfa06$var$on.fromJSONString(r);
            null === (l = this.responder) || void 0 === l || l.insertDocument(t), this.requestRender();
        }
        this.draggedRange = null, this.draggingPoint = null;
    },
    cut (t) {
        var e, i;
        if (null !== (e = this.responder) && void 0 !== e && e.selectionIsExpanded() && (this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault(), null === (i = this.delegate) || void 0 === i || i.inputControllerWillCutText(), this.deleteInDirection("backward"), t.defaultPrevented)) return this.requestRender();
    },
    copy (t) {
        var e;
        null !== (e = this.responder) && void 0 !== e && e.selectionIsExpanded() && this.serializeSelectionToDataTransfer(t.clipboardData) && t.preventDefault();
    },
    paste (t) {
        const e = t.clipboardData || t.testClipboardData, i = {
            clipboard: e
        };
        if (!e || $741c336afc2dfa06$var$pr(t)) return void this.getPastedHTMLUsingHiddenElement((t)=>{
            var e, n, r;
            return i.type = "text/html", i.html = t, null === (e = this.delegate) || void 0 === e || e.inputControllerWillPaste(i), null === (n = this.responder) || void 0 === n || n.insertHTML(i.html), this.requestRender(), null === (r = this.delegate) || void 0 === r ? void 0 : r.inputControllerDidPaste(i);
        });
        const n = e.getData("URL"), r = e.getData("text/html"), o = e.getData("public.url-name");
        if (n) {
            var s, a, l;
            let t;
            i.type = "text/html", t = o ? $741c336afc2dfa06$var$Vt(o).trim() : n, i.html = this.createLinkHTML(n, t), null === (s = this.delegate) || void 0 === s || s.inputControllerWillPaste(i), this.setInputSummary({
                textAdded: t,
                didDelete: this.selectionIsExpanded()
            }), null === (a = this.responder) || void 0 === a || a.insertHTML(i.html), this.requestRender(), null === (l = this.delegate) || void 0 === l || l.inputControllerDidPaste(i);
        } else if ($741c336afc2dfa06$var$Et(e)) {
            var c, u, h;
            i.type = "text/plain", i.string = e.getData("text/plain"), null === (c = this.delegate) || void 0 === c || c.inputControllerWillPaste(i), this.setInputSummary({
                textAdded: i.string,
                didDelete: this.selectionIsExpanded()
            }), null === (u = this.responder) || void 0 === u || u.insertString(i.string), this.requestRender(), null === (h = this.delegate) || void 0 === h || h.inputControllerDidPaste(i);
        } else if (r) {
            var d, g, m;
            i.type = "text/html", i.html = r, null === (d = this.delegate) || void 0 === d || d.inputControllerWillPaste(i), null === (g = this.responder) || void 0 === g || g.insertHTML(i.html), this.requestRender(), null === (m = this.delegate) || void 0 === m || m.inputControllerDidPaste(i);
        } else if (Array.from(e.types).includes("Files")) {
            var p, f;
            const t = null === (p = e.items) || void 0 === p || null === (p = p[0]) || void 0 === p || null === (f = p.getAsFile) || void 0 === f ? void 0 : f.call(p);
            if (t) {
                var b, v, A;
                const e = $741c336afc2dfa06$var$dr(t);
                !t.name && e && (t.name = "pasted-file-".concat(++$741c336afc2dfa06$var$ur, ".").concat(e)), i.type = "File", i.file = t, null === (b = this.delegate) || void 0 === b || b.inputControllerWillAttachFiles(), null === (v = this.responder) || void 0 === v || v.insertFile(i.file), this.requestRender(), null === (A = this.delegate) || void 0 === A || A.inputControllerDidPaste(i);
            }
        }
        t.preventDefault();
    },
    compositionstart (t) {
        return this.getCompositionInput().start(t.data);
    },
    compositionupdate (t) {
        return this.getCompositionInput().update(t.data);
    },
    compositionend (t) {
        return this.getCompositionInput().end(t.data);
    },
    beforeinput (t) {
        this.inputSummary.didInput = !0;
    },
    input (t) {
        return this.inputSummary.didInput = !0, t.stopPropagation();
    }
}), $741c336afc2dfa06$var$wi($741c336afc2dfa06$var$hr, "keys", {
    backspace (t) {
        var e;
        return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
    },
    delete (t) {
        var e;
        return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
    },
    return (t) {
        var e, i;
        return this.setInputSummary({
            preferDocument: !0
        }), null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i ? void 0 : i.insertLineBreak();
    },
    tab (t) {
        var e, i;
        null !== (e = this.responder) && void 0 !== e && e.canIncreaseNestingLevel() && (null === (i = this.responder) || void 0 === i || i.increaseNestingLevel(), this.requestRender(), t.preventDefault());
    },
    left (t) {
        var e;
        if (this.selectionIsInCursorTarget()) return t.preventDefault(), null === (e = this.responder) || void 0 === e ? void 0 : e.moveCursorInDirection("backward");
    },
    right (t) {
        var e;
        if (this.selectionIsInCursorTarget()) return t.preventDefault(), null === (e = this.responder) || void 0 === e ? void 0 : e.moveCursorInDirection("forward");
    },
    control: {
        d (t) {
            var e;
            return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("forward", t);
        },
        h (t) {
            var e;
            return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), this.deleteInDirection("backward", t);
        },
        o (t) {
            var e, i;
            return t.preventDefault(), null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i || i.insertString("\n", {
                updatePosition: !1
            }), this.requestRender();
        }
    },
    shift: {
        return (t) {
            var e, i;
            null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i || i.insertString("\n"), this.requestRender(), t.preventDefault();
        },
        tab (t) {
            var e, i;
            null !== (e = this.responder) && void 0 !== e && e.canDecreaseNestingLevel() && (null === (i = this.responder) || void 0 === i || i.decreaseNestingLevel(), this.requestRender(), t.preventDefault());
        },
        left (t) {
            if (this.selectionIsInCursorTarget()) return t.preventDefault(), this.expandSelectionInDirection("backward");
        },
        right (t) {
            if (this.selectionIsInCursorTarget()) return t.preventDefault(), this.expandSelectionInDirection("forward");
        }
    },
    alt: {
        backspace (t) {
            var e;
            return this.setInputSummary({
                preferDocument: !1
            }), null === (e = this.delegate) || void 0 === e ? void 0 : e.inputControllerWillPerformTyping();
        }
    },
    meta: {
        backspace (t) {
            var e;
            return this.setInputSummary({
                preferDocument: !1
            }), null === (e = this.delegate) || void 0 === e ? void 0 : e.inputControllerWillPerformTyping();
        }
    }
}), $741c336afc2dfa06$var$hr.proxyMethod("responder?.getSelectedRange"), $741c336afc2dfa06$var$hr.proxyMethod("responder?.setSelectedRange"), $741c336afc2dfa06$var$hr.proxyMethod("responder?.expandSelectionInDirection"), $741c336afc2dfa06$var$hr.proxyMethod("responder?.selectionIsInCursorTarget"), $741c336afc2dfa06$var$hr.proxyMethod("responder?.selectionIsExpanded");
const $741c336afc2dfa06$var$dr = (t)=>{
    var e;
    return null === (e = t.type) || void 0 === e || null === (e = e.match(/\/(\w+)$/)) || void 0 === e ? void 0 : e[1];
}, $741c336afc2dfa06$var$gr = !(null === ($741c336afc2dfa06$var$ar = " ".codePointAt) || void 0 === $741c336afc2dfa06$var$ar || !$741c336afc2dfa06$var$ar.call(" ", 0)), $741c336afc2dfa06$var$mr = function(t) {
    if (t.key && $741c336afc2dfa06$var$gr && t.key.codePointAt(0) === t.keyCode) return t.key;
    {
        let e;
        if (null === t.which ? e = t.keyCode : 0 !== t.which && 0 !== t.charCode && (e = t.charCode), null != e && "escape" !== $741c336afc2dfa06$var$cr[e]) return $741c336afc2dfa06$var$X.fromCodepoints([
            e
        ]).toString();
    }
}, $741c336afc2dfa06$var$pr = function(t) {
    const e = t.clipboardData;
    if (e) {
        if (e.types.includes("text/html")) {
            for (const t of e.types){
                const i = /^CorePasteboardFlavorType/.test(t), n = /^dyn\./.test(t) && e.getData(t);
                if (i || n) return !0;
            }
            return !1;
        }
        {
            const t = e.types.includes("com.apple.webarchive"), i = e.types.includes("com.apple.flat-rtfd");
            return t || i;
        }
    }
};
class $741c336afc2dfa06$var$fr extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(...arguments), this.inputController = t, this.responder = this.inputController.responder, this.delegate = this.inputController.delegate, this.inputSummary = this.inputController.inputSummary, this.data = {};
    }
    start(t) {
        if (this.data.start = t, this.isSignificant()) {
            var e, i;
            if ("keypress" === this.inputSummary.eventName && this.inputSummary.textAdded) null === (i = this.responder) || void 0 === i || i.deleteInDirection("left");
            this.selectionIsExpanded() || (this.insertPlaceholder(), this.requestRender()), this.range = null === (e = this.responder) || void 0 === e ? void 0 : e.getSelectedRange();
        }
    }
    update(t) {
        if (this.data.update = t, this.isSignificant()) {
            const t = this.selectPlaceholder();
            t && (this.forgetPlaceholder(), this.range = t);
        }
    }
    end(t) {
        var e, i, n, r;
        return this.data.end = t, this.isSignificant() ? (this.forgetPlaceholder(), this.canApplyToDocument() ? (this.setInputSummary({
            preferDocument: !0,
            didInput: !1
        }), null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i || i.setSelectedRange(this.range), null === (n = this.responder) || void 0 === n || n.insertString(this.data.end), null === (r = this.responder) || void 0 === r ? void 0 : r.setSelectedRange(this.range[0] + this.data.end.length)) : null != this.data.start || null != this.data.update ? (this.requestReparse(), this.inputController.reset()) : void 0) : this.inputController.reset();
    }
    getEndData() {
        return this.data.end;
    }
    isEnded() {
        return null != this.getEndData();
    }
    isSignificant() {
        return !$741c336afc2dfa06$var$lr.composesExistingText || this.inputSummary.didInput;
    }
    canApplyToDocument() {
        var t, e;
        return 0 === (null === (t = this.data.start) || void 0 === t ? void 0 : t.length) && (null === (e = this.data.end) || void 0 === e ? void 0 : e.length) > 0 && this.range;
    }
}
$741c336afc2dfa06$var$fr.proxyMethod("inputController.setInputSummary"), $741c336afc2dfa06$var$fr.proxyMethod("inputController.requestRender"), $741c336afc2dfa06$var$fr.proxyMethod("inputController.requestReparse"), $741c336afc2dfa06$var$fr.proxyMethod("responder?.selectionIsExpanded"), $741c336afc2dfa06$var$fr.proxyMethod("responder?.insertPlaceholder"), $741c336afc2dfa06$var$fr.proxyMethod("responder?.selectPlaceholder"), $741c336afc2dfa06$var$fr.proxyMethod("responder?.forgetPlaceholder");
class $741c336afc2dfa06$var$br extends $741c336afc2dfa06$var$sr {
    constructor(){
        super(...arguments), this.render = this.render.bind(this);
    }
    elementDidMutate() {
        var t, e;
        return this.scheduledRender ? this.composing ? null === (t = this.delegate) || void 0 === t || null === (e = t.inputControllerDidAllowUnhandledInput) || void 0 === e ? void 0 : e.call(t) : void 0 : this.reparse();
    }
    scheduleRender() {
        return this.scheduledRender ? this.scheduledRender : this.scheduledRender = requestAnimationFrame(this.render);
    }
    render() {
        var t, e;
        (cancelAnimationFrame(this.scheduledRender), this.scheduledRender = null, this.composing) || null === (e = this.delegate) || void 0 === e || e.render();
        null === (t = this.afterRender) || void 0 === t || t.call(this), this.afterRender = null;
    }
    reparse() {
        var t;
        return null === (t = this.delegate) || void 0 === t ? void 0 : t.reparse();
    }
    insertString() {
        var t;
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", i = arguments.length > 1 ? arguments[1] : void 0;
        return null === (t = this.delegate) || void 0 === t || t.inputControllerWillPerformTyping(), this.withTargetDOMRange(function() {
            var t;
            return null === (t = this.responder) || void 0 === t ? void 0 : t.insertString(e, i);
        });
    }
    toggleAttributeIfSupported(t) {
        var e;
        if ($741c336afc2dfa06$var$gt().includes(t)) return null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformFormatting(t), this.withTargetDOMRange(function() {
            var e;
            return null === (e = this.responder) || void 0 === e ? void 0 : e.toggleCurrentAttribute(t);
        });
    }
    activateAttributeIfSupported(t, e) {
        var i;
        if ($741c336afc2dfa06$var$gt().includes(t)) return null === (i = this.delegate) || void 0 === i || i.inputControllerWillPerformFormatting(t), this.withTargetDOMRange(function() {
            var i;
            return null === (i = this.responder) || void 0 === i ? void 0 : i.setCurrentAttribute(t, e);
        });
    }
    deleteInDirection(t) {
        let { recordUndoEntry: e } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            recordUndoEntry: !0
        };
        var i;
        e && (null === (i = this.delegate) || void 0 === i || i.inputControllerWillPerformTyping());
        const n = ()=>{
            var e;
            return null === (e = this.responder) || void 0 === e ? void 0 : e.deleteInDirection(t);
        }, r = this.getTargetDOMRange({
            minLength: this.composing ? 1 : 2
        });
        return r ? this.withTargetDOMRange(r, n) : n();
    }
    withTargetDOMRange(t, e) {
        var i;
        return "function" == typeof t && (e = t, t = this.getTargetDOMRange()), t ? null === (i = this.responder) || void 0 === i ? void 0 : i.withTargetDOMRange(t, e.bind(this)) : ($741c336afc2dfa06$var$Ft.reset(), e.call(this));
    }
    getTargetDOMRange() {
        var t, e;
        let { minLength: i } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            minLength: 0
        };
        const n = null === (t = (e = this.event).getTargetRanges) || void 0 === t ? void 0 : t.call(e);
        if (n && n.length) {
            const t = $741c336afc2dfa06$var$vr(n[0]);
            if (0 === i || t.toString().length >= i) return t;
        }
    }
    withEvent(t, e) {
        let i;
        this.event = t;
        try {
            i = e.call(this);
        } finally{
            this.event = null;
        }
        return i;
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$br, "events", {
    keydown (t) {
        if ($741c336afc2dfa06$var$St(t)) {
            var e;
            const i = $741c336afc2dfa06$var$Er(t);
            null !== (e = this.delegate) && void 0 !== e && e.inputControllerDidReceiveKeyboardCommand(i) && t.preventDefault();
        } else {
            let e = t.key;
            t.altKey && (e += "+Alt"), t.shiftKey && (e += "+Shift");
            const i = this.constructor.keys[e];
            if (i) return this.withEvent(t, i);
        }
    },
    paste (t) {
        var e;
        let i;
        const n = null === (e = t.clipboardData) || void 0 === e ? void 0 : e.getData("URL");
        var r, o, s, a, l, c;
        return $741c336afc2dfa06$var$xr(t) ? (t.preventDefault(), this.attachFiles(t.clipboardData.files)) : $741c336afc2dfa06$var$Cr(t) ? (t.preventDefault(), i = {
            type: "text/plain",
            string: t.clipboardData.getData("text/plain")
        }, null === (r = this.delegate) || void 0 === r || r.inputControllerWillPaste(i), null === (o = this.responder) || void 0 === o || o.insertString(i.string), this.render(), null === (s = this.delegate) || void 0 === s ? void 0 : s.inputControllerDidPaste(i)) : n ? (t.preventDefault(), i = {
            type: "text/html",
            html: this.createLinkHTML(n)
        }, null === (a = this.delegate) || void 0 === a || a.inputControllerWillPaste(i), null === (l = this.responder) || void 0 === l || l.insertHTML(i.html), this.render(), null === (c = this.delegate) || void 0 === c ? void 0 : c.inputControllerDidPaste(i)) : void 0;
    },
    beforeinput (t) {
        const e = this.constructor.inputTypes[t.inputType], i = (n = t, !(!/iPhone|iPad/.test(navigator.userAgent) || n.inputType && "insertParagraph" !== n.inputType));
        var n;
        e && (this.withEvent(t, e), i || this.scheduleRender()), i && this.render();
    },
    input (t) {
        $741c336afc2dfa06$var$Ft.reset();
    },
    dragstart (t) {
        var e, i;
        null !== (e = this.responder) && void 0 !== e && e.selectionContainsAttachments() && (t.dataTransfer.setData("application/x-trix-dragging", !0), this.dragging = {
            range: null === (i = this.responder) || void 0 === i ? void 0 : i.getSelectedRange(),
            point: $741c336afc2dfa06$var$Sr(t)
        });
    },
    dragenter (t) {
        $741c336afc2dfa06$var$Ar(t) && t.preventDefault();
    },
    dragover (t) {
        if (this.dragging) {
            t.preventDefault();
            const i = $741c336afc2dfa06$var$Sr(t);
            var e;
            if (!$741c336afc2dfa06$var$Tt(i, this.dragging.point)) return this.dragging.point = i, null === (e = this.responder) || void 0 === e ? void 0 : e.setLocationRangeFromPointRange(i);
        } else $741c336afc2dfa06$var$Ar(t) && t.preventDefault();
    },
    drop (t) {
        var e, i;
        if (this.dragging) return t.preventDefault(), null === (e = this.delegate) || void 0 === e || e.inputControllerWillMoveText(), null === (i = this.responder) || void 0 === i || i.moveTextFromRange(this.dragging.range), this.dragging = null, this.scheduleRender();
        if ($741c336afc2dfa06$var$Ar(t)) {
            var n;
            t.preventDefault();
            const e = $741c336afc2dfa06$var$Sr(t);
            return null === (n = this.responder) || void 0 === n || n.setLocationRangeFromPointRange(e), this.attachFiles(t.dataTransfer.files);
        }
    },
    dragend () {
        var t;
        this.dragging && (null === (t = this.responder) || void 0 === t || t.setSelectedRange(this.dragging.range), this.dragging = null);
    },
    compositionend (t) {
        this.composing && (this.composing = !1, $741c336afc2dfa06$var$a.recentAndroid || this.scheduleRender());
    }
}), $741c336afc2dfa06$var$wi($741c336afc2dfa06$var$br, "keys", {
    ArrowLeft () {
        var t, e;
        if (null !== (t = this.responder) && void 0 !== t && t.shouldManageMovingCursorInDirection("backward")) return this.event.preventDefault(), null === (e = this.responder) || void 0 === e ? void 0 : e.moveCursorInDirection("backward");
    },
    ArrowRight () {
        var t, e;
        if (null !== (t = this.responder) && void 0 !== t && t.shouldManageMovingCursorInDirection("forward")) return this.event.preventDefault(), null === (e = this.responder) || void 0 === e ? void 0 : e.moveCursorInDirection("forward");
    },
    Backspace () {
        var t, e, i;
        if (null !== (t = this.responder) && void 0 !== t && t.shouldManageDeletingInDirection("backward")) return this.event.preventDefault(), null === (e = this.delegate) || void 0 === e || e.inputControllerWillPerformTyping(), null === (i = this.responder) || void 0 === i || i.deleteInDirection("backward"), this.render();
    },
    Tab () {
        var t, e;
        if (null !== (t = this.responder) && void 0 !== t && t.canIncreaseNestingLevel()) return this.event.preventDefault(), null === (e = this.responder) || void 0 === e || e.increaseNestingLevel(), this.render();
    },
    "Tab+Shift" () {
        var t, e;
        if (null !== (t = this.responder) && void 0 !== t && t.canDecreaseNestingLevel()) return this.event.preventDefault(), null === (e = this.responder) || void 0 === e || e.decreaseNestingLevel(), this.render();
    }
}), $741c336afc2dfa06$var$wi($741c336afc2dfa06$var$br, "inputTypes", {
    deleteByComposition () {
        return this.deleteInDirection("backward", {
            recordUndoEntry: !1
        });
    },
    deleteByCut () {
        return this.deleteInDirection("backward");
    },
    deleteByDrag () {
        return this.event.preventDefault(), this.withTargetDOMRange(function() {
            var t;
            this.deleteByDragRange = null === (t = this.responder) || void 0 === t ? void 0 : t.getSelectedRange();
        });
    },
    deleteCompositionText () {
        return this.deleteInDirection("backward", {
            recordUndoEntry: !1
        });
    },
    deleteContent () {
        return this.deleteInDirection("backward");
    },
    deleteContentBackward () {
        return this.deleteInDirection("backward");
    },
    deleteContentForward () {
        return this.deleteInDirection("forward");
    },
    deleteEntireSoftLine () {
        return this.deleteInDirection("forward");
    },
    deleteHardLineBackward () {
        return this.deleteInDirection("backward");
    },
    deleteHardLineForward () {
        return this.deleteInDirection("forward");
    },
    deleteSoftLineBackward () {
        return this.deleteInDirection("backward");
    },
    deleteSoftLineForward () {
        return this.deleteInDirection("forward");
    },
    deleteWordBackward () {
        return this.deleteInDirection("backward");
    },
    deleteWordForward () {
        return this.deleteInDirection("forward");
    },
    formatBackColor () {
        return this.activateAttributeIfSupported("backgroundColor", this.event.data);
    },
    formatBold () {
        return this.toggleAttributeIfSupported("bold");
    },
    formatFontColor () {
        return this.activateAttributeIfSupported("color", this.event.data);
    },
    formatFontName () {
        return this.activateAttributeIfSupported("font", this.event.data);
    },
    formatIndent () {
        var t;
        if (null !== (t = this.responder) && void 0 !== t && t.canIncreaseNestingLevel()) return this.withTargetDOMRange(function() {
            var t;
            return null === (t = this.responder) || void 0 === t ? void 0 : t.increaseNestingLevel();
        });
    },
    formatItalic () {
        return this.toggleAttributeIfSupported("italic");
    },
    formatJustifyCenter () {
        return this.toggleAttributeIfSupported("justifyCenter");
    },
    formatJustifyFull () {
        return this.toggleAttributeIfSupported("justifyFull");
    },
    formatJustifyLeft () {
        return this.toggleAttributeIfSupported("justifyLeft");
    },
    formatJustifyRight () {
        return this.toggleAttributeIfSupported("justifyRight");
    },
    formatOutdent () {
        var t;
        if (null !== (t = this.responder) && void 0 !== t && t.canDecreaseNestingLevel()) return this.withTargetDOMRange(function() {
            var t;
            return null === (t = this.responder) || void 0 === t ? void 0 : t.decreaseNestingLevel();
        });
    },
    formatRemove () {
        this.withTargetDOMRange(function() {
            for(const i in null === (t = this.responder) || void 0 === t ? void 0 : t.getCurrentAttributes()){
                var t, e;
                null === (e = this.responder) || void 0 === e || e.removeCurrentAttribute(i);
            }
        });
    },
    formatSetBlockTextDirection () {
        return this.activateAttributeIfSupported("blockDir", this.event.data);
    },
    formatSetInlineTextDirection () {
        return this.activateAttributeIfSupported("textDir", this.event.data);
    },
    formatStrikeThrough () {
        return this.toggleAttributeIfSupported("strike");
    },
    formatSubscript () {
        return this.toggleAttributeIfSupported("sub");
    },
    formatSuperscript () {
        return this.toggleAttributeIfSupported("sup");
    },
    formatUnderline () {
        return this.toggleAttributeIfSupported("underline");
    },
    historyRedo () {
        var t;
        return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerWillPerformRedo();
    },
    historyUndo () {
        var t;
        return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerWillPerformUndo();
    },
    insertCompositionText () {
        return this.composing = !0, this.insertString(this.event.data);
    },
    insertFromComposition () {
        return this.composing = !1, this.insertString(this.event.data);
    },
    insertFromDrop () {
        const t = this.deleteByDragRange;
        var e;
        if (t) return this.deleteByDragRange = null, null === (e = this.delegate) || void 0 === e || e.inputControllerWillMoveText(), this.withTargetDOMRange(function() {
            var e;
            return null === (e = this.responder) || void 0 === e ? void 0 : e.moveTextFromRange(t);
        });
    },
    insertFromPaste () {
        const { dataTransfer: t } = this.event, e = {
            dataTransfer: t
        }, i = t.getData("URL"), n = t.getData("text/html");
        if (i) {
            var r;
            let n;
            this.event.preventDefault(), e.type = "text/html";
            const o = t.getData("public.url-name");
            n = o ? $741c336afc2dfa06$var$Vt(o).trim() : i, e.html = this.createLinkHTML(i, n), null === (r = this.delegate) || void 0 === r || r.inputControllerWillPaste(e), this.withTargetDOMRange(function() {
                var t;
                return null === (t = this.responder) || void 0 === t ? void 0 : t.insertHTML(e.html);
            }), this.afterRender = ()=>{
                var t;
                return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
            };
        } else if ($741c336afc2dfa06$var$Et(t)) {
            var o;
            e.type = "text/plain", e.string = t.getData("text/plain"), null === (o = this.delegate) || void 0 === o || o.inputControllerWillPaste(e), this.withTargetDOMRange(function() {
                var t;
                return null === (t = this.responder) || void 0 === t ? void 0 : t.insertString(e.string);
            }), this.afterRender = ()=>{
                var t;
                return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
            };
        } else if ($741c336afc2dfa06$var$yr(this.event)) {
            var s;
            e.type = "File", e.file = t.files[0], null === (s = this.delegate) || void 0 === s || s.inputControllerWillPaste(e), this.withTargetDOMRange(function() {
                var t;
                return null === (t = this.responder) || void 0 === t ? void 0 : t.insertFile(e.file);
            }), this.afterRender = ()=>{
                var t;
                return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
            };
        } else if (n) {
            var a;
            this.event.preventDefault(), e.type = "text/html", e.html = n, null === (a = this.delegate) || void 0 === a || a.inputControllerWillPaste(e), this.withTargetDOMRange(function() {
                var t;
                return null === (t = this.responder) || void 0 === t ? void 0 : t.insertHTML(e.html);
            }), this.afterRender = ()=>{
                var t;
                return null === (t = this.delegate) || void 0 === t ? void 0 : t.inputControllerDidPaste(e);
            };
        }
    },
    insertFromYank () {
        return this.insertString(this.event.data);
    },
    insertLineBreak () {
        return this.insertString("\n");
    },
    insertLink () {
        return this.activateAttributeIfSupported("href", this.event.data);
    },
    insertOrderedList () {
        return this.toggleAttributeIfSupported("number");
    },
    insertParagraph () {
        var t;
        return null === (t = this.delegate) || void 0 === t || t.inputControllerWillPerformTyping(), this.withTargetDOMRange(function() {
            var t;
            return null === (t = this.responder) || void 0 === t ? void 0 : t.insertLineBreak();
        });
    },
    insertReplacementText () {
        const t = this.event.dataTransfer.getData("text/plain"), e = this.event.getTargetRanges()[0];
        this.withTargetDOMRange(e, ()=>{
            this.insertString(t, {
                updatePosition: !1
            });
        });
    },
    insertText () {
        var t;
        return this.insertString(this.event.data || (null === (t = this.event.dataTransfer) || void 0 === t ? void 0 : t.getData("text/plain")));
    },
    insertTranspose () {
        return this.insertString(this.event.data);
    },
    insertUnorderedList () {
        return this.toggleAttributeIfSupported("bullet");
    }
});
const $741c336afc2dfa06$var$vr = function(t) {
    const e = document.createRange();
    return e.setStart(t.startContainer, t.startOffset), e.setEnd(t.endContainer, t.endOffset), e;
}, $741c336afc2dfa06$var$Ar = (t)=>{
    var e;
    return Array.from((null === (e = t.dataTransfer) || void 0 === e ? void 0 : e.types) || []).includes("Files");
}, $741c336afc2dfa06$var$yr = (t)=>{
    var e;
    return (null === (e = t.dataTransfer.files) || void 0 === e ? void 0 : e[0]) && !$741c336afc2dfa06$var$xr(t) && !((t)=>{
        let { dataTransfer: e } = t;
        return e.types.includes("Files") && e.types.includes("text/html") && e.getData("text/html").includes("urn:schemas-microsoft-com:office:office");
    })(t);
}, $741c336afc2dfa06$var$xr = function(t) {
    const e = t.clipboardData;
    if (e) return Array.from(e.types).filter((t)=>t.match(/file/i)).length === e.types.length && e.files.length >= 1;
}, $741c336afc2dfa06$var$Cr = function(t) {
    const e = t.clipboardData;
    if (e) return e.types.includes("text/plain") && 1 === e.types.length;
}, $741c336afc2dfa06$var$Er = function(t) {
    const e = [];
    return t.altKey && e.push("alt"), t.shiftKey && e.push("shift"), e.push(t.key), e;
}, $741c336afc2dfa06$var$Sr = (t)=>({
        x: t.clientX,
        y: t.clientY
    }), $741c336afc2dfa06$var$Rr = "[data-trix-attribute]", $741c336afc2dfa06$var$kr = "[data-trix-action]", $741c336afc2dfa06$var$Tr = "".concat($741c336afc2dfa06$var$Rr, ", ").concat($741c336afc2dfa06$var$kr), $741c336afc2dfa06$var$wr = "[data-trix-dialog]", $741c336afc2dfa06$var$Lr = "".concat($741c336afc2dfa06$var$wr, "[data-trix-active]"), $741c336afc2dfa06$var$Dr = "".concat($741c336afc2dfa06$var$wr, " [data-trix-method]"), $741c336afc2dfa06$var$Nr = "".concat($741c336afc2dfa06$var$wr, " [data-trix-input]"), $741c336afc2dfa06$var$Ir = (t, e)=>(e || (e = $741c336afc2dfa06$var$Fr(t)), t.querySelector("[data-trix-input][name='".concat(e, "']"))), $741c336afc2dfa06$var$Or = (t)=>t.getAttribute("data-trix-action"), $741c336afc2dfa06$var$Fr = (t)=>t.getAttribute("data-trix-attribute") || t.getAttribute("data-trix-dialog-attribute");
class $741c336afc2dfa06$var$Pr extends $741c336afc2dfa06$var$q {
    constructor(t){
        super(t), this.didClickActionButton = this.didClickActionButton.bind(this), this.didClickAttributeButton = this.didClickAttributeButton.bind(this), this.didClickDialogButton = this.didClickDialogButton.bind(this), this.didKeyDownDialogInput = this.didKeyDownDialogInput.bind(this), this.element = t, this.attributes = {}, this.actions = {}, this.resetDialogInputs(), $741c336afc2dfa06$var$b("mousedown", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$kr,
            withCallback: this.didClickActionButton
        }), $741c336afc2dfa06$var$b("mousedown", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$Rr,
            withCallback: this.didClickAttributeButton
        }), $741c336afc2dfa06$var$b("click", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$Tr,
            preventDefault: !0
        }), $741c336afc2dfa06$var$b("click", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$Dr,
            withCallback: this.didClickDialogButton
        }), $741c336afc2dfa06$var$b("keydown", {
            onElement: this.element,
            matchingSelector: $741c336afc2dfa06$var$Nr,
            withCallback: this.didKeyDownDialogInput
        });
    }
    didClickActionButton(t, e) {
        var i;
        null === (i = this.delegate) || void 0 === i || i.toolbarDidClickButton(), t.preventDefault();
        const n = $741c336afc2dfa06$var$Or(e);
        var r;
        return this.getDialog(n) ? this.toggleDialog(n) : null === (r = this.delegate) || void 0 === r ? void 0 : r.toolbarDidInvokeAction(n, e);
    }
    didClickAttributeButton(t, e) {
        var i;
        null === (i = this.delegate) || void 0 === i || i.toolbarDidClickButton(), t.preventDefault();
        const n = $741c336afc2dfa06$var$Fr(e);
        var r;
        this.getDialog(n) ? this.toggleDialog(n) : null === (r = this.delegate) || void 0 === r || r.toolbarDidToggleAttribute(n);
        return this.refreshAttributeButtons();
    }
    didClickDialogButton(t, e) {
        const i = $741c336afc2dfa06$var$y(e, {
            matchingSelector: $741c336afc2dfa06$var$wr
        });
        return this[e.getAttribute("data-trix-method")].call(this, i);
    }
    didKeyDownDialogInput(t, e) {
        if (13 === t.keyCode) {
            t.preventDefault();
            const i = e.getAttribute("name"), n = this.getDialog(i);
            this.setAttribute(n);
        }
        if (27 === t.keyCode) return t.preventDefault(), this.hideDialog();
    }
    updateActions(t) {
        return this.actions = t, this.refreshActionButtons();
    }
    refreshActionButtons() {
        return this.eachActionButton((t, e)=>{
            t.disabled = !1 === this.actions[e];
        });
    }
    eachActionButton(t) {
        return Array.from(this.element.querySelectorAll($741c336afc2dfa06$var$kr)).map((e)=>t(e, $741c336afc2dfa06$var$Or(e)));
    }
    updateAttributes(t) {
        return this.attributes = t, this.refreshAttributeButtons();
    }
    refreshAttributeButtons() {
        return this.eachAttributeButton((t, e)=>(t.disabled = !1 === this.attributes[e], this.attributes[e] || this.dialogIsVisible(e) ? (t.setAttribute("data-trix-active", ""), t.classList.add("trix-active")) : (t.removeAttribute("data-trix-active"), t.classList.remove("trix-active"))));
    }
    eachAttributeButton(t) {
        return Array.from(this.element.querySelectorAll($741c336afc2dfa06$var$Rr)).map((e)=>t(e, $741c336afc2dfa06$var$Fr(e)));
    }
    applyKeyboardCommand(t) {
        const e = JSON.stringify(t.sort());
        for (const t of Array.from(this.element.querySelectorAll("[data-trix-key]"))){
            const i = t.getAttribute("data-trix-key").split("+");
            if (JSON.stringify(i.sort()) === e) return $741c336afc2dfa06$var$v("mousedown", {
                onElement: t
            }), !0;
        }
        return !1;
    }
    dialogIsVisible(t) {
        const e = this.getDialog(t);
        if (e) return e.hasAttribute("data-trix-active");
    }
    toggleDialog(t) {
        return this.dialogIsVisible(t) ? this.hideDialog() : this.showDialog(t);
    }
    showDialog(t) {
        var e, i;
        this.hideDialog(), null === (e = this.delegate) || void 0 === e || e.toolbarWillShowDialog();
        const n = this.getDialog(t);
        n.setAttribute("data-trix-active", ""), n.classList.add("trix-active"), Array.from(n.querySelectorAll("input[disabled]")).forEach((t)=>{
            t.removeAttribute("disabled");
        });
        const r = $741c336afc2dfa06$var$Fr(n);
        if (r) {
            const e = $741c336afc2dfa06$var$Ir(n, t);
            e && (e.value = this.attributes[r] || "", e.select());
        }
        return null === (i = this.delegate) || void 0 === i ? void 0 : i.toolbarDidShowDialog(t);
    }
    setAttribute(t) {
        var e;
        const i = $741c336afc2dfa06$var$Fr(t), n = $741c336afc2dfa06$var$Ir(t, i);
        return !n.willValidate || (n.setCustomValidity(""), n.checkValidity() && this.isSafeAttribute(n)) ? (null === (e = this.delegate) || void 0 === e || e.toolbarDidUpdateAttribute(i, n.value), this.hideDialog()) : (n.setCustomValidity("Invalid value"), n.setAttribute("data-trix-validate", ""), n.classList.add("trix-validate"), n.focus());
    }
    isSafeAttribute(t) {
        return !t.hasAttribute("data-trix-validate-href") || $741c336afc2dfa06$var$si.isValidAttribute("a", "href", t.value);
    }
    removeAttribute(t) {
        var e;
        const i = $741c336afc2dfa06$var$Fr(t);
        return null === (e = this.delegate) || void 0 === e || e.toolbarDidRemoveAttribute(i), this.hideDialog();
    }
    hideDialog() {
        const t = this.element.querySelector($741c336afc2dfa06$var$Lr);
        var e;
        if (t) return t.removeAttribute("data-trix-active"), t.classList.remove("trix-active"), this.resetDialogInputs(), null === (e = this.delegate) || void 0 === e ? void 0 : e.toolbarDidHideDialog(((t)=>t.getAttribute("data-trix-dialog"))(t));
    }
    resetDialogInputs() {
        Array.from(this.element.querySelectorAll($741c336afc2dfa06$var$Nr)).forEach((t)=>{
            t.setAttribute("disabled", "disabled"), t.removeAttribute("data-trix-validate"), t.classList.remove("trix-validate");
        });
    }
    getDialog(t) {
        return this.element.querySelector("[data-trix-dialog=".concat(t, "]"));
    }
}
class $741c336afc2dfa06$var$Mr extends $741c336afc2dfa06$var$Yn {
    constructor(t){
        let { editorElement: e, document: i, html: n } = t;
        super(...arguments), this.editorElement = e, this.selectionManager = new $741c336afc2dfa06$var$Wn(this.editorElement), this.selectionManager.delegate = this, this.composition = new $741c336afc2dfa06$var$kn, this.composition.delegate = this, this.attachmentManager = new $741c336afc2dfa06$var$Sn(this.composition.getAttachments()), this.attachmentManager.delegate = this, this.inputController = 2 === $741c336afc2dfa06$var$_.getLevel() ? new $741c336afc2dfa06$var$br(this.editorElement) : new $741c336afc2dfa06$var$hr(this.editorElement), this.inputController.delegate = this, this.inputController.responder = this.composition, this.compositionController = new $741c336afc2dfa06$var$Gn(this.editorElement, this.composition), this.compositionController.delegate = this, this.toolbarController = new $741c336afc2dfa06$var$Pr(this.editorElement.toolbarElement), this.toolbarController.delegate = this, this.editor = new $741c336afc2dfa06$var$On(this.composition, this.selectionManager, this.editorElement), i ? this.editor.loadDocument(i) : this.editor.loadHTML(n);
    }
    registerSelectionManager() {
        return $741c336afc2dfa06$var$Ft.registerSelectionManager(this.selectionManager);
    }
    unregisterSelectionManager() {
        return $741c336afc2dfa06$var$Ft.unregisterSelectionManager(this.selectionManager);
    }
    render() {
        return this.compositionController.render();
    }
    reparse() {
        return this.composition.replaceHTML(this.editorElement.innerHTML);
    }
    compositionDidChangeDocument(t) {
        if (this.notifyEditorElement("document-change"), !this.handlingInput) return this.render();
    }
    compositionDidChangeCurrentAttributes(t) {
        return this.currentAttributes = t, this.toolbarController.updateAttributes(this.currentAttributes), this.updateCurrentActions(), this.notifyEditorElement("attributes-change", {
            attributes: this.currentAttributes
        });
    }
    compositionDidPerformInsertionAtRange(t) {
        this.pasting && (this.pastedRange = t);
    }
    compositionShouldAcceptFile(t) {
        return this.notifyEditorElement("file-accept", {
            file: t
        });
    }
    compositionDidAddAttachment(t) {
        const e = this.attachmentManager.manageAttachment(t);
        return this.notifyEditorElement("attachment-add", {
            attachment: e
        });
    }
    compositionDidEditAttachment(t) {
        this.compositionController.rerenderViewForObject(t);
        const e = this.attachmentManager.manageAttachment(t);
        return this.notifyEditorElement("attachment-edit", {
            attachment: e
        }), this.notifyEditorElement("change");
    }
    compositionDidChangeAttachmentPreviewURL(t) {
        return this.compositionController.invalidateViewForObject(t), this.notifyEditorElement("change");
    }
    compositionDidRemoveAttachment(t) {
        const e = this.attachmentManager.unmanageAttachment(t);
        return this.notifyEditorElement("attachment-remove", {
            attachment: e
        });
    }
    compositionDidStartEditingAttachment(t, e) {
        return this.attachmentLocationRange = this.composition.document.getLocationRangeOfAttachment(t), this.compositionController.installAttachmentEditorForAttachment(t, e), this.selectionManager.setLocationRange(this.attachmentLocationRange);
    }
    compositionDidStopEditingAttachment(t) {
        this.compositionController.uninstallAttachmentEditor(), this.attachmentLocationRange = null;
    }
    compositionDidRequestChangingSelectionToLocationRange(t) {
        if (!this.loadingSnapshot || this.isFocused()) return this.requestedLocationRange = t, this.compositionRevisionWhenLocationRangeRequested = this.composition.revision, this.handlingInput ? void 0 : this.render();
    }
    compositionWillLoadSnapshot() {
        this.loadingSnapshot = !0;
    }
    compositionDidLoadSnapshot() {
        this.compositionController.refreshViewCache(), this.render(), this.loadingSnapshot = !1;
    }
    getSelectionManager() {
        return this.selectionManager;
    }
    attachmentManagerDidRequestRemovalOfAttachment(t) {
        return this.removeAttachment(t);
    }
    compositionControllerWillSyncDocumentView() {
        return this.inputController.editorWillSyncDocumentView(), this.selectionManager.lock(), this.selectionManager.clearSelection();
    }
    compositionControllerDidSyncDocumentView() {
        return this.inputController.editorDidSyncDocumentView(), this.selectionManager.unlock(), this.updateCurrentActions(), this.notifyEditorElement("sync");
    }
    compositionControllerDidRender() {
        this.requestedLocationRange && (this.compositionRevisionWhenLocationRangeRequested === this.composition.revision && this.selectionManager.setLocationRange(this.requestedLocationRange), this.requestedLocationRange = null, this.compositionRevisionWhenLocationRangeRequested = null), this.renderedCompositionRevision !== this.composition.revision && (this.runEditorFilters(), this.composition.updateCurrentAttributes(), this.notifyEditorElement("render")), this.renderedCompositionRevision = this.composition.revision;
    }
    compositionControllerDidFocus() {
        return this.isFocusedInvisibly() && this.setLocationRange({
            index: 0,
            offset: 0
        }), this.toolbarController.hideDialog(), this.notifyEditorElement("focus");
    }
    compositionControllerDidBlur() {
        return this.notifyEditorElement("blur");
    }
    compositionControllerDidSelectAttachment(t, e) {
        return this.toolbarController.hideDialog(), this.composition.editAttachment(t, e);
    }
    compositionControllerDidRequestDeselectingAttachment(t) {
        const e = this.attachmentLocationRange || this.composition.document.getLocationRangeOfAttachment(t);
        return this.selectionManager.setLocationRange(e[1]);
    }
    compositionControllerWillUpdateAttachment(t) {
        return this.editor.recordUndoEntry("Edit Attachment", {
            context: t.id,
            consolidatable: !0
        });
    }
    compositionControllerDidRequestRemovalOfAttachment(t) {
        return this.removeAttachment(t);
    }
    inputControllerWillHandleInput() {
        this.handlingInput = !0, this.requestedRender = !1;
    }
    inputControllerDidRequestRender() {
        this.requestedRender = !0;
    }
    inputControllerDidHandleInput() {
        if (this.handlingInput = !1, this.requestedRender) return this.requestedRender = !1, this.render();
    }
    inputControllerDidAllowUnhandledInput() {
        return this.notifyEditorElement("change");
    }
    inputControllerDidRequestReparse() {
        return this.reparse();
    }
    inputControllerWillPerformTyping() {
        return this.recordTypingUndoEntry();
    }
    inputControllerWillPerformFormatting(t) {
        return this.recordFormattingUndoEntry(t);
    }
    inputControllerWillCutText() {
        return this.editor.recordUndoEntry("Cut");
    }
    inputControllerWillPaste(t) {
        return this.editor.recordUndoEntry("Paste"), this.pasting = !0, this.notifyEditorElement("before-paste", {
            paste: t
        });
    }
    inputControllerDidPaste(t) {
        return t.range = this.pastedRange, this.pastedRange = null, this.pasting = null, this.notifyEditorElement("paste", {
            paste: t
        });
    }
    inputControllerWillMoveText() {
        return this.editor.recordUndoEntry("Move");
    }
    inputControllerWillAttachFiles() {
        return this.editor.recordUndoEntry("Drop Files");
    }
    inputControllerWillPerformUndo() {
        return this.editor.undo();
    }
    inputControllerWillPerformRedo() {
        return this.editor.redo();
    }
    inputControllerDidReceiveKeyboardCommand(t) {
        return this.toolbarController.applyKeyboardCommand(t);
    }
    inputControllerDidStartDrag() {
        this.locationRangeBeforeDrag = this.selectionManager.getLocationRange();
    }
    inputControllerDidReceiveDragOverPoint(t) {
        return this.selectionManager.setLocationRangeFromPointRange(t);
    }
    inputControllerDidCancelDrag() {
        this.selectionManager.setLocationRange(this.locationRangeBeforeDrag), this.locationRangeBeforeDrag = null;
    }
    locationRangeDidChange(t) {
        return this.composition.updateCurrentAttributes(), this.updateCurrentActions(), this.attachmentLocationRange && !$741c336afc2dfa06$var$Dt(this.attachmentLocationRange, t) && this.composition.stopEditingAttachment(), this.notifyEditorElement("selection-change");
    }
    toolbarDidClickButton() {
        if (!this.getLocationRange()) return this.setLocationRange({
            index: 0,
            offset: 0
        });
    }
    toolbarDidInvokeAction(t, e) {
        return this.invokeAction(t, e);
    }
    toolbarDidToggleAttribute(t) {
        if (this.recordFormattingUndoEntry(t), this.composition.toggleCurrentAttribute(t), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarDidUpdateAttribute(t, e) {
        if (this.recordFormattingUndoEntry(t), this.composition.setCurrentAttribute(t, e), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarDidRemoveAttribute(t) {
        if (this.recordFormattingUndoEntry(t), this.composition.removeCurrentAttribute(t), this.render(), !this.selectionFrozen) return this.editorElement.focus();
    }
    toolbarWillShowDialog(t) {
        return this.composition.expandSelectionForEditing(), this.freezeSelection();
    }
    toolbarDidShowDialog(t) {
        return this.notifyEditorElement("toolbar-dialog-show", {
            dialogName: t
        });
    }
    toolbarDidHideDialog(t) {
        return this.thawSelection(), this.editorElement.focus(), this.notifyEditorElement("toolbar-dialog-hide", {
            dialogName: t
        });
    }
    freezeSelection() {
        if (!this.selectionFrozen) return this.selectionManager.lock(), this.composition.freezeSelection(), this.selectionFrozen = !0, this.render();
    }
    thawSelection() {
        if (this.selectionFrozen) return this.composition.thawSelection(), this.selectionManager.unlock(), this.selectionFrozen = !1, this.render();
    }
    canInvokeAction(t) {
        var e;
        return !!this.actionIsExternal(t) || !(null === (e = this.actions[t]) || void 0 === e || null === (e = e.test) || void 0 === e || !e.call(this));
    }
    invokeAction(t, e) {
        var i;
        return this.actionIsExternal(t) ? this.notifyEditorElement("action-invoke", {
            actionName: t,
            invokingElement: e
        }) : null === (i = this.actions[t]) || void 0 === i || null === (i = i.perform) || void 0 === i ? void 0 : i.call(this);
    }
    actionIsExternal(t) {
        return /^x-./.test(t);
    }
    getCurrentActions() {
        const t = {};
        for(const e in this.actions)t[e] = this.canInvokeAction(e);
        return t;
    }
    updateCurrentActions() {
        const t = this.getCurrentActions();
        if (!$741c336afc2dfa06$var$Tt(t, this.currentActions)) return this.currentActions = t, this.toolbarController.updateActions(this.currentActions), this.notifyEditorElement("actions-change", {
            actions: this.currentActions
        });
    }
    runEditorFilters() {
        let t = this.composition.getSnapshot();
        if (Array.from(this.editor.filters).forEach((e)=>{
            const { document: i, selectedRange: n } = t;
            t = e.call(this.editor, t) || {}, t.document || (t.document = i), t.selectedRange || (t.selectedRange = n);
        }), e = t, i = this.composition.getSnapshot(), !$741c336afc2dfa06$var$Dt(e.selectedRange, i.selectedRange) || !e.document.isEqualTo(i.document)) return this.composition.loadSnapshot(t);
        var e, i;
    }
    updateInputElement() {
        const t = function(t, e) {
            const i = $741c336afc2dfa06$var$xn[e];
            if (i) return i(t);
            throw new Error("unknown content type: ".concat(e));
        }(this.compositionController.getSerializableElement(), "text/html");
        return this.editorElement.setFormValue(t);
    }
    notifyEditorElement(t, e) {
        switch(t){
            case "document-change":
                this.documentChangedSinceLastRender = !0;
                break;
            case "render":
                this.documentChangedSinceLastRender && (this.documentChangedSinceLastRender = !1, this.notifyEditorElement("change"));
                break;
            case "change":
            case "attachment-add":
            case "attachment-edit":
            case "attachment-remove":
                this.updateInputElement();
        }
        return this.editorElement.notify(t, e);
    }
    removeAttachment(t) {
        return this.editor.recordUndoEntry("Delete Attachment"), this.composition.removeAttachment(t), this.render();
    }
    recordFormattingUndoEntry(t) {
        const e = $741c336afc2dfa06$var$mt(t), i = this.selectionManager.getLocationRange();
        if (e || !$741c336afc2dfa06$var$Lt(i)) return this.editor.recordUndoEntry("Formatting", {
            context: this.getUndoContext(),
            consolidatable: !0
        });
    }
    recordTypingUndoEntry() {
        return this.editor.recordUndoEntry("Typing", {
            context: this.getUndoContext(this.currentAttributes),
            consolidatable: !0
        });
    }
    getUndoContext() {
        for(var t = arguments.length, e = new Array(t), i = 0; i < t; i++)e[i] = arguments[i];
        return [
            this.getLocationContext(),
            this.getTimeContext(),
            ...Array.from(e)
        ];
    }
    getLocationContext() {
        const t = this.selectionManager.getLocationRange();
        return $741c336afc2dfa06$var$Lt(t) ? t[0].index : t;
    }
    getTimeContext() {
        return $741c336afc2dfa06$var$V.interval > 0 ? Math.floor((new Date).getTime() / $741c336afc2dfa06$var$V.interval) : 0;
    }
    isFocused() {
        var t;
        return this.editorElement === (null === (t = this.editorElement.ownerDocument) || void 0 === t ? void 0 : t.activeElement);
    }
    isFocusedInvisibly() {
        return this.isFocused() && !this.getLocationRange();
    }
    get actions() {
        return this.constructor.actions;
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$Mr, "actions", {
    undo: {
        test () {
            return this.editor.canUndo();
        },
        perform () {
            return this.editor.undo();
        }
    },
    redo: {
        test () {
            return this.editor.canRedo();
        },
        perform () {
            return this.editor.redo();
        }
    },
    link: {
        test () {
            return this.editor.canActivateAttribute("href");
        }
    },
    increaseNestingLevel: {
        test () {
            return this.editor.canIncreaseNestingLevel();
        },
        perform () {
            return this.editor.increaseNestingLevel() && this.render();
        }
    },
    decreaseNestingLevel: {
        test () {
            return this.editor.canDecreaseNestingLevel();
        },
        perform () {
            return this.editor.decreaseNestingLevel() && this.render();
        }
    },
    attachFiles: {
        test: ()=>!0,
        perform () {
            return $741c336afc2dfa06$var$_.pickFiles(this.editor.insertFiles);
        }
    }
}), $741c336afc2dfa06$var$Mr.proxyMethod("getSelectionManager().setLocationRange"), $741c336afc2dfa06$var$Mr.proxyMethod("getSelectionManager().getLocationRange");
var $741c336afc2dfa06$var$Br = Object.freeze({
    __proto__: null,
    AttachmentEditorController: $741c336afc2dfa06$var$Kn,
    CompositionController: $741c336afc2dfa06$var$Gn,
    Controller: $741c336afc2dfa06$var$Yn,
    EditorController: $741c336afc2dfa06$var$Mr,
    InputController: $741c336afc2dfa06$var$sr,
    Level0InputController: $741c336afc2dfa06$var$hr,
    Level2InputController: $741c336afc2dfa06$var$br,
    ToolbarController: $741c336afc2dfa06$var$Pr
}), $741c336afc2dfa06$var$_r = Object.freeze({
    __proto__: null,
    MutationObserver: $741c336afc2dfa06$var$Qn,
    SelectionChangeObserver: $741c336afc2dfa06$var$Ot
}), $741c336afc2dfa06$var$jr = Object.freeze({
    __proto__: null,
    FileVerificationOperation: $741c336afc2dfa06$var$er,
    ImagePreloadOperation: $741c336afc2dfa06$var$ji
});
$741c336afc2dfa06$var$vt("trix-toolbar", "%t {\n  display: block;\n}\n\n%t {\n  white-space: nowrap;\n}\n\n%t [data-trix-dialog] {\n  display: none;\n}\n\n%t [data-trix-dialog][data-trix-active] {\n  display: block;\n}\n\n%t [data-trix-dialog] [data-trix-validate]:invalid {\n  background-color: #ffdddd;\n}");
class $741c336afc2dfa06$var$Wr extends HTMLElement {
    connectedCallback() {
        "" === this.innerHTML && (this.innerHTML = $741c336afc2dfa06$var$U.getDefaultHTML());
    }
}
let $741c336afc2dfa06$var$Ur = 0;
const $741c336afc2dfa06$var$Vr = function(t) {
    if (!t.hasAttribute("contenteditable")) return t.setAttribute("contenteditable", ""), function(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return e.times = 1, $741c336afc2dfa06$var$b(t, e);
    }("focus", {
        onElement: t,
        withCallback: ()=>$741c336afc2dfa06$var$zr(t)
    });
}, $741c336afc2dfa06$var$zr = function(t) {
    return $741c336afc2dfa06$var$qr(t), $741c336afc2dfa06$var$Hr();
}, $741c336afc2dfa06$var$qr = function(t) {
    var e, i;
    if (null !== (e = (i = document).queryCommandSupported) && void 0 !== e && e.call(i, "enableObjectResizing")) return document.execCommand("enableObjectResizing", !1, !1), $741c336afc2dfa06$var$b("mscontrolselect", {
        onElement: t,
        preventDefault: !0
    });
}, $741c336afc2dfa06$var$Hr = function(t) {
    var e, i;
    if (null !== (e = (i = document).queryCommandSupported) && void 0 !== e && e.call(i, "DefaultParagraphSeparator")) {
        const { tagName: t } = $741c336afc2dfa06$var$n.default;
        if ([
            "div",
            "p"
        ].includes(t)) return document.execCommand("DefaultParagraphSeparator", !1, t);
    }
}, $741c336afc2dfa06$var$Jr = $741c336afc2dfa06$var$a.forcesObjectResizing ? {
    display: "inline",
    width: "auto"
} : {
    display: "inline-block",
    width: "1px"
};
$741c336afc2dfa06$var$vt("trix-editor", "%t {\n    display: block;\n}\n\n%t:empty::before {\n    content: attr(placeholder);\n    color: graytext;\n    cursor: text;\n    pointer-events: none;\n    white-space: pre-line;\n}\n\n%t a[contenteditable=false] {\n    cursor: text;\n}\n\n%t img {\n    max-width: 100%;\n    height: auto;\n}\n\n%t ".concat($741c336afc2dfa06$var$e, " figcaption textarea {\n    resize: none;\n}\n\n%t ").concat($741c336afc2dfa06$var$e, " figcaption textarea.trix-autoresize-clone {\n    position: absolute;\n    left: -9999px;\n    max-height: 0px;\n}\n\n%t ").concat($741c336afc2dfa06$var$e, " figcaption[data-trix-placeholder]:empty::before {\n    content: attr(data-trix-placeholder);\n    color: graytext;\n}\n\n%t [data-trix-cursor-target] {\n    display: ").concat($741c336afc2dfa06$var$Jr.display, " !important;\n    width: ").concat($741c336afc2dfa06$var$Jr.width, " !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    border: none !important;\n}\n\n%t [data-trix-cursor-target=left] {\n    vertical-align: top !important;\n    margin-left: -1px !important;\n}\n\n%t [data-trix-cursor-target=right] {\n    vertical-align: bottom !important;\n    margin-right: -1px !important;\n}"));
var $741c336afc2dfa06$var$Kr = new WeakMap, $741c336afc2dfa06$var$Gr = new WeakSet;
class $741c336afc2dfa06$var$Yr {
    constructor(t){
        var e, i;
        $741c336afc2dfa06$var$Mi(e = this, i = $741c336afc2dfa06$var$Gr), i.add(e), $741c336afc2dfa06$var$Bi(this, $741c336afc2dfa06$var$Kr, {
            writable: !0,
            value: void 0
        }), this.element = t, $741c336afc2dfa06$var$Ni(this, $741c336afc2dfa06$var$Kr, t.attachInternals());
    }
    connectedCallback() {
        $741c336afc2dfa06$var$Pi(this, $741c336afc2dfa06$var$Gr, $741c336afc2dfa06$var$$r).call(this);
    }
    disconnectedCallback() {}
    get labels() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).labels;
    }
    get disabled() {
        var t;
        return null === (t = this.element.inputElement) || void 0 === t ? void 0 : t.disabled;
    }
    set disabled(t) {
        this.element.toggleAttribute("disabled", t);
    }
    get required() {
        return this.element.hasAttribute("required");
    }
    set required(t) {
        this.element.toggleAttribute("required", t), $741c336afc2dfa06$var$Pi(this, $741c336afc2dfa06$var$Gr, $741c336afc2dfa06$var$$r).call(this);
    }
    get validity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).validity;
    }
    get validationMessage() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).validationMessage;
    }
    get willValidate() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).willValidate;
    }
    setFormValue(t) {
        $741c336afc2dfa06$var$Pi(this, $741c336afc2dfa06$var$Gr, $741c336afc2dfa06$var$$r).call(this);
    }
    checkValidity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).checkValidity();
    }
    reportValidity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).reportValidity();
    }
    setCustomValidity(t) {
        $741c336afc2dfa06$var$Pi(this, $741c336afc2dfa06$var$Gr, $741c336afc2dfa06$var$$r).call(this, t);
    }
}
function $741c336afc2dfa06$var$$r() {
    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    const { required: e, value: i } = this.element, n = e && !i, r = !!t, o = $741c336afc2dfa06$var$T("input", {
        required: e
    }), s = t || o.validationMessage;
    $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Kr).setValidity({
        valueMissing: n,
        customError: r
    }, s);
}
var $741c336afc2dfa06$var$Xr = new WeakMap, $741c336afc2dfa06$var$Zr = new WeakMap, $741c336afc2dfa06$var$Qr = new WeakMap;
class $741c336afc2dfa06$var$to {
    constructor(t){
        $741c336afc2dfa06$var$Bi(this, $741c336afc2dfa06$var$Xr, {
            writable: !0,
            value: void 0
        }), $741c336afc2dfa06$var$Bi(this, $741c336afc2dfa06$var$Zr, {
            writable: !0,
            value: (t)=>{
                t.defaultPrevented || t.target === this.element.form && this.element.reset();
            }
        }), $741c336afc2dfa06$var$Bi(this, $741c336afc2dfa06$var$Qr, {
            writable: !0,
            value: (t)=>{
                if (t.defaultPrevented) return;
                if (this.element.contains(t.target)) return;
                const e = $741c336afc2dfa06$var$y(t.target, {
                    matchingSelector: "label"
                });
                e && Array.from(this.labels).includes(e) && this.element.focus();
            }
        }), this.element = t;
    }
    connectedCallback() {
        $741c336afc2dfa06$var$Ni(this, $741c336afc2dfa06$var$Xr, function(t) {
            if (t.hasAttribute("aria-label") || t.hasAttribute("aria-labelledby")) return;
            const e = function() {
                const e = Array.from(t.labels).map((e)=>{
                    if (!e.contains(t)) return e.textContent;
                }).filter((t)=>t), i = e.join(" ");
                return i ? t.setAttribute("aria-label", i) : t.removeAttribute("aria-label");
            };
            return e(), $741c336afc2dfa06$var$b("focus", {
                onElement: t,
                withCallback: e
            });
        }(this.element)), window.addEventListener("reset", $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Zr), !1), window.addEventListener("click", $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Qr), !1);
    }
    disconnectedCallback() {
        var t;
        null === (t = $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Xr)) || void 0 === t || t.destroy(), window.removeEventListener("reset", $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Zr), !1), window.removeEventListener("click", $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$Qr), !1);
    }
    get labels() {
        const t = [];
        this.element.id && this.element.ownerDocument && t.push(...Array.from(this.element.ownerDocument.querySelectorAll("label[for='".concat(this.element.id, "']")) || []));
        const e = $741c336afc2dfa06$var$y(this.element, {
            matchingSelector: "label"
        });
        return e && [
            this.element,
            null
        ].includes(e.control) && t.push(e), t;
    }
    get disabled() {
        return console.warn("This browser does not support the [disabled] attribute for trix-editor elements."), !1;
    }
    set disabled(t) {
        console.warn("This browser does not support the [disabled] attribute for trix-editor elements.");
    }
    get required() {
        return console.warn("This browser does not support the [required] attribute for trix-editor elements."), !1;
    }
    set required(t) {
        console.warn("This browser does not support the [required] attribute for trix-editor elements.");
    }
    get validity() {
        return console.warn("This browser does not support the validity property for trix-editor elements."), null;
    }
    get validationMessage() {
        return console.warn("This browser does not support the validationMessage property for trix-editor elements."), "";
    }
    get willValidate() {
        return console.warn("This browser does not support the willValidate property for trix-editor elements."), !1;
    }
    setFormValue(t) {}
    checkValidity() {
        return console.warn("This browser does not support checkValidity() for trix-editor elements."), !0;
    }
    reportValidity() {
        return console.warn("This browser does not support reportValidity() for trix-editor elements."), !0;
    }
    setCustomValidity(t) {
        console.warn("This browser does not support setCustomValidity(validationMessage) for trix-editor elements.");
    }
}
var $741c336afc2dfa06$var$eo = new WeakMap;
class $741c336afc2dfa06$var$io extends HTMLElement {
    constructor(){
        super(), $741c336afc2dfa06$var$Bi(this, $741c336afc2dfa06$var$eo, {
            writable: !0,
            value: void 0
        }), $741c336afc2dfa06$var$Ni(this, $741c336afc2dfa06$var$eo, this.constructor.formAssociated ? new $741c336afc2dfa06$var$Yr(this) : new $741c336afc2dfa06$var$to(this));
    }
    get trixId() {
        return this.hasAttribute("trix-id") ? this.getAttribute("trix-id") : (this.setAttribute("trix-id", ++$741c336afc2dfa06$var$Ur), this.trixId);
    }
    get labels() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).labels;
    }
    get disabled() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).disabled;
    }
    set disabled(t) {
        $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).disabled = t;
    }
    get required() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).required;
    }
    set required(t) {
        $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).required = t;
    }
    get validity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).validity;
    }
    get validationMessage() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).validationMessage;
    }
    get willValidate() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).willValidate;
    }
    get type() {
        return this.localName;
    }
    get toolbarElement() {
        var t;
        if (this.hasAttribute("toolbar")) return null === (t = this.ownerDocument) || void 0 === t ? void 0 : t.getElementById(this.getAttribute("toolbar"));
        if (this.parentNode) {
            const t = "trix-toolbar-".concat(this.trixId);
            this.setAttribute("toolbar", t);
            const e = $741c336afc2dfa06$var$T("trix-toolbar", {
                id: t
            });
            return this.parentNode.insertBefore(e, this), e;
        }
    }
    get form() {
        var t;
        return null === (t = this.inputElement) || void 0 === t ? void 0 : t.form;
    }
    get inputElement() {
        var t;
        if (this.hasAttribute("input")) return null === (t = this.ownerDocument) || void 0 === t ? void 0 : t.getElementById(this.getAttribute("input"));
        if (this.parentNode) {
            const t = "trix-input-".concat(this.trixId);
            this.setAttribute("input", t);
            const e = $741c336afc2dfa06$var$T("input", {
                type: "hidden",
                id: t
            });
            return this.parentNode.insertBefore(e, this.nextElementSibling), e;
        }
    }
    get editor() {
        var t;
        return null === (t = this.editorController) || void 0 === t ? void 0 : t.editor;
    }
    get name() {
        var t;
        return null === (t = this.inputElement) || void 0 === t ? void 0 : t.name;
    }
    get value() {
        var t;
        return null === (t = this.inputElement) || void 0 === t ? void 0 : t.value;
    }
    set value(t) {
        var e;
        this.defaultValue = t, null === (e = this.editor) || void 0 === e || e.loadHTML(this.defaultValue);
    }
    notify(t, e) {
        if (this.editorController) return $741c336afc2dfa06$var$v("trix-".concat(t), {
            onElement: this,
            attributes: e
        });
    }
    setFormValue(t) {
        this.inputElement && (this.inputElement.value = t, $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).setFormValue(t));
    }
    connectedCallback() {
        this.hasAttribute("data-trix-internal") || ($741c336afc2dfa06$var$Vr(this), function(t) {
            if (!t.hasAttribute("role")) t.setAttribute("role", "textbox");
        }(this), this.editorController || ($741c336afc2dfa06$var$v("trix-before-initialize", {
            onElement: this
        }), this.editorController = new $741c336afc2dfa06$var$Mr({
            editorElement: this,
            html: this.defaultValue = this.value
        }), requestAnimationFrame(()=>$741c336afc2dfa06$var$v("trix-initialize", {
                onElement: this
            }))), this.editorController.registerSelectionManager(), $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).connectedCallback(), function(t) {
            if (!document.querySelector(":focus") && t.hasAttribute("autofocus") && document.querySelector("[autofocus]") === t) t.focus();
        }(this));
    }
    disconnectedCallback() {
        var t;
        null === (t = this.editorController) || void 0 === t || t.unregisterSelectionManager(), $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).disconnectedCallback();
    }
    checkValidity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).checkValidity();
    }
    reportValidity() {
        return $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).reportValidity();
    }
    setCustomValidity(t) {
        $741c336afc2dfa06$var$Di(this, $741c336afc2dfa06$var$eo).setCustomValidity(t);
    }
    formDisabledCallback(t) {
        this.inputElement && (this.inputElement.disabled = t), this.toggleAttribute("contenteditable", !t);
    }
    formResetCallback() {
        this.reset();
    }
    reset() {
        this.value = this.defaultValue;
    }
}
$741c336afc2dfa06$var$wi($741c336afc2dfa06$var$io, "formAssociated", "ElementInternals" in window);
const $741c336afc2dfa06$var$no = {
    VERSION: $741c336afc2dfa06$var$t,
    config: $741c336afc2dfa06$var$z,
    core: $741c336afc2dfa06$var$Cn,
    models: $741c336afc2dfa06$var$Un,
    views: $741c336afc2dfa06$var$Vn,
    controllers: $741c336afc2dfa06$var$Br,
    observers: $741c336afc2dfa06$var$_r,
    operations: $741c336afc2dfa06$var$jr,
    elements: Object.freeze({
        __proto__: null,
        TrixEditorElement: $741c336afc2dfa06$var$io,
        TrixToolbarElement: $741c336afc2dfa06$var$Wr
    }),
    filters: Object.freeze({
        __proto__: null,
        Filter: $741c336afc2dfa06$var$Dn,
        attachmentGalleryFilter: $741c336afc2dfa06$var$Nn
    })
};
Object.assign($741c336afc2dfa06$var$no, $741c336afc2dfa06$var$Un), window.Trix = $741c336afc2dfa06$var$no, setTimeout(function() {
    customElements.get("trix-toolbar") || customElements.define("trix-toolbar", $741c336afc2dfa06$var$Wr), customElements.get("trix-editor") || customElements.define("trix-editor", $741c336afc2dfa06$var$io);
}, 0);
var $741c336afc2dfa06$var$script$1 = {
    name: 'EditorWrapper',
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: ''
            }
        };
    }
};
const $741c336afc2dfa06$var$_hoisted_1 = [
    "id",
    "value"
];
function $741c336afc2dfa06$var$render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_trix_editor = (0, $ani5R.resolveComponent)("trix-editor");
    return (0, $ani5R.openBlock)(), (0, $ani5R.createElementBlock)("div", {
        class: (0, $X5A94.normalizeClass)(_ctx.classes.container)
    }, [
        (0, $ani5R.createElementVNode)("input", {
            id: `editor-input-${_ctx.id}`,
            value: _ctx.value,
            type: "hidden"
        }, null, 8 /* PROPS */ , $741c336afc2dfa06$var$_hoisted_1),
        (0, $ani5R.createVNode)(_component_trix_editor, (0, $ani5R.mergeProps)(_ctx.options, {
            onTrixChange: _ctx.handleChange,
            onTrixBlur: _ctx.handleBlur,
            onTrixFileAccept: _ctx.handleFileAccept,
            onTrixAttachmentAdd: _ctx.handleAttachmentAdd,
            ref: "trix$"
        }), null, 16 /* FULL_PROPS */ , [
            "onTrixChange",
            "onTrixBlur",
            "onTrixFileAccept",
            "onTrixAttachmentAdd"
        ])
    ], 2 /* CLASS */ );
}
$741c336afc2dfa06$var$script$1.render = $741c336afc2dfa06$var$render;
$741c336afc2dfa06$var$script$1.__file = "themes/blank/templates/wrappers/EditorWrapper.vue";
var $741c336afc2dfa06$export$c0ee4c2a5005a714 = {
    name: 'EditorWrapper',
    render: $741c336afc2dfa06$var$script$1.render,
    data () {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                container_hideBold: 'vf-editor-hide-bold',
                container_hideItalic: 'vf-editor-hide-italic',
                container_hideStrike: 'vf-editor-hide-strike',
                container_hideLink: 'vf-editor-hide-link',
                container_hideHeading: 'vf-editor-hide-heading',
                container_hideQuote: 'vf-editor-hide-quote',
                container_hideCode: 'vf-editor-hide-code',
                container_hideBulletList: 'vf-editor-hide-bullet-list',
                container_hideNumberList: 'vf-editor-hide-number-list',
                container_hideDecreaseNesting: 'vf-editor-hide-decrease-nesting',
                container_hideIncreaseNesting: 'vf-editor-hide-increase-nesting',
                container_hideAttach: 'vf-editor-hide-attach',
                container_hideUndo: 'vf-editor-hide-undo',
                container_hideRedo: 'vf-editor-hide-redo',
                $container: (classes, { hideTools: hideTools })=>[
                        classes.container
                    ].concat(hideTools.map((t)=>classes[`container_hide${t.split('-').map((s)=>s.charAt(0).toUpperCase() + s.slice(1)).join('')}`]))
            }
        };
    }
};
var $741c336afc2dfa06$var$css_248z = "@charset \"UTF-8\";\n\ntrix-toolbar {\n  padding: 0.5rem 0.375rem;\n  border-radius: 0.25rem;\n  flex-wrap: wrap;\n}\n\ntrix-toolbar .trix-button-row {\n  display: block;\n  margin-bottom: -0.25rem;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  overflow-x: auto;\n}\n\ntrix-toolbar .trix-button-group {\n  display: inline;\n}\n\ntrix-toolbar .trix-button-group-spacer {\n  display: hidden;\n  flex-grow: 1;\n}\n\ntrix-toolbar .trix-button {\n  position: relative;\n  margin-bottom: 0.25rem;\n  color: var(--vf-bg-icon);\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  outline: none;\n  border-radius: 0.25rem;\n  white-space: nowrap;\n  float: left;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\ntrix-toolbar .trix-button.trix-active {\n  background-color: var(--vf-bg-selected);\n  filter: brightness(0.9);\n}\n\ntrix-toolbar .trix-button:not(.trix-active):hover {\n  background-color: var(--vf-bg-selected);\n}\n\ntrix-toolbar .trix-button--icon {\n  width: 2.5rem;\n  height: 1.5rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  text-indent: -9999px;\n}\n\ntrix-toolbar .trix-button--icon::before {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  display: inline-block;\n  content: \"\";\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  background-color: var(--vf-bg-icon);\n  top: 0.125rem;\n  bottom: 0.125rem;\n  margin-top: 0.125rem;\n  margin-bottom: 0.125rem;\n}\n\ntrix-toolbar .trix-button--icon.trix-active::before {\n  opacity: 1;\n}\n\ntrix-toolbar .trix-button--icon:disabled::before {\n  opacity: 0.4;\n}\n\ntrix-toolbar .trix-button--icon-attach::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M67.508 468.467c-58.005-58.013-58.016-151.92 0-209.943l225.011-225.04c44.643-44.645 117.279-44.645 161.92 0 44.743 44.749 44.753 117.186 0 161.944l-189.465 189.49c-31.41 31.413-82.518 31.412-113.926.001-31.479-31.482-31.49-82.453 0-113.944L311.51 110.491c4.687-4.687 12.286-4.687 16.972 0l16.967 16.971c4.685 4.686 4.685 12.283 0 16.969L184.983 304.917c-12.724 12.724-12.73 33.328 0 46.058 12.696 12.697 33.356 12.699 46.054-.001l189.465-189.489c25.987-25.989 25.994-68.06.001-94.056-25.931-25.934-68.119-25.932-94.049 0l-225.01 225.039c-39.249 39.252-39.258 102.795-.001 142.057 39.285 39.29 102.885 39.287 142.162-.028A739446.174 739446.174 0 0 1 439.497 238.49c4.686-4.687 12.282-4.684 16.969.004l16.967 16.971c4.685 4.686 4.689 12.279.004 16.965a755654.128 755654.128 0 0 0-195.881 195.996c-58.034 58.092-152.004 58.093-210.048.041z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M67.508 468.467c-58.005-58.013-58.016-151.92 0-209.943l225.011-225.04c44.643-44.645 117.279-44.645 161.92 0 44.743 44.749 44.753 117.186 0 161.944l-189.465 189.49c-31.41 31.413-82.518 31.412-113.926.001-31.479-31.482-31.49-82.453 0-113.944L311.51 110.491c4.687-4.687 12.286-4.687 16.972 0l16.967 16.971c4.685 4.686 4.685 12.283 0 16.969L184.983 304.917c-12.724 12.724-12.73 33.328 0 46.058 12.696 12.697 33.356 12.699 46.054-.001l189.465-189.489c25.987-25.989 25.994-68.06.001-94.056-25.931-25.934-68.119-25.932-94.049 0l-225.01 225.039c-39.249 39.252-39.258 102.795-.001 142.057 39.285 39.29 102.885 39.287 142.162-.028A739446.174 739446.174 0 0 1 439.497 238.49c4.686-4.687 12.282-4.684 16.969.004l16.967 16.971c4.685 4.686 4.689 12.279.004 16.965a755654.128 755654.128 0 0 0-195.881 195.996c-58.034 58.092-152.004 58.093-210.048.041z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-bold::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 384 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 384 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-italic::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-link::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M314.222 197.78c51.091 51.091 54.377 132.287 9.75 187.16-6.242 7.73-2.784 3.865-84.94 86.02-54.696 54.696-143.266 54.745-197.99 0-54.711-54.69-54.734-143.255 0-197.99 32.773-32.773 51.835-51.899 63.409-63.457 7.463-7.452 20.331-2.354 20.486 8.192a173.31 173.31 0 0 0 4.746 37.828c.966 4.029-.272 8.269-3.202 11.198L80.632 312.57c-32.755 32.775-32.887 85.892 0 118.8 32.775 32.755 85.892 32.887 118.8 0l75.19-75.2c32.718-32.725 32.777-86.013 0-118.79a83.722 83.722 0 0 0-22.814-16.229c-4.623-2.233-7.182-7.25-6.561-12.346 1.356-11.122 6.296-21.885 14.815-30.405l4.375-4.375c3.625-3.626 9.177-4.594 13.76-2.294 12.999 6.524 25.187 15.211 36.025 26.049zM470.958 41.04c-54.724-54.745-143.294-54.696-197.99 0-82.156 82.156-78.698 78.29-84.94 86.02-44.627 54.873-41.341 136.069 9.75 187.16 10.838 10.838 23.026 19.525 36.025 26.049 4.582 2.3 10.134 1.331 13.76-2.294l4.375-4.375c8.52-8.519 13.459-19.283 14.815-30.405.621-5.096-1.938-10.113-6.561-12.346a83.706 83.706 0 0 1-22.814-16.229c-32.777-32.777-32.718-86.065 0-118.79l75.19-75.2c32.908-32.887 86.025-32.755 118.8 0 32.887 32.908 32.755 86.025 0 118.8l-45.848 45.84c-2.93 2.929-4.168 7.169-3.202 11.198a173.31 173.31 0 0 1 4.746 37.828c.155 10.546 13.023 15.644 20.486 8.192 11.574-11.558 30.636-30.684 63.409-63.457 54.733-54.735 54.71-143.3-.001-197.991z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M314.222 197.78c51.091 51.091 54.377 132.287 9.75 187.16-6.242 7.73-2.784 3.865-84.94 86.02-54.696 54.696-143.266 54.745-197.99 0-54.711-54.69-54.734-143.255 0-197.99 32.773-32.773 51.835-51.899 63.409-63.457 7.463-7.452 20.331-2.354 20.486 8.192a173.31 173.31 0 0 0 4.746 37.828c.966 4.029-.272 8.269-3.202 11.198L80.632 312.57c-32.755 32.775-32.887 85.892 0 118.8 32.775 32.755 85.892 32.887 118.8 0l75.19-75.2c32.718-32.725 32.777-86.013 0-118.79a83.722 83.722 0 0 0-22.814-16.229c-4.623-2.233-7.182-7.25-6.561-12.346 1.356-11.122 6.296-21.885 14.815-30.405l4.375-4.375c3.625-3.626 9.177-4.594 13.76-2.294 12.999 6.524 25.187 15.211 36.025 26.049zM470.958 41.04c-54.724-54.745-143.294-54.696-197.99 0-82.156 82.156-78.698 78.29-84.94 86.02-44.627 54.873-41.341 136.069 9.75 187.16 10.838 10.838 23.026 19.525 36.025 26.049 4.582 2.3 10.134 1.331 13.76-2.294l4.375-4.375c8.52-8.519 13.459-19.283 14.815-30.405.621-5.096-1.938-10.113-6.561-12.346a83.706 83.706 0 0 1-22.814-16.229c-32.777-32.777-32.718-86.065 0-118.79l75.19-75.2c32.908-32.887 86.025-32.755 118.8 0 32.887 32.908 32.755 86.025 0 118.8l-45.848 45.84c-2.93 2.929-4.168 7.169-3.202 11.198a173.31 173.31 0 0 1 4.746 37.828c.155 10.546 13.023 15.644 20.486 8.192 11.574-11.558 30.636-30.684 63.409-63.457 54.733-54.735 54.71-143.3-.001-197.991z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-strike::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-quote::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z'%3e%3c/path%3e%3c/svg%3e\");\n  top: 0.25rem;\n  bottom: 0.25rem;\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\ntrix-toolbar .trix-button--icon-heading-1::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-toolbar .trix-button--icon-code::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 640 304' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M165.9%2c291.3 L209.4%2c244.9 C214%2c240 213.7%2c232.2 208.6%2c227.7 L118%2c148 L208.6%2c68.3 C213.7%2c63.8 214.1%2c56 209.4%2c51.1 L165.9%2c4.7 C161.4%2c-0.1 153.8%2c-0.4 148.9%2c4.2 L4.8%2c139.2 C-0.3%2c143.9 -0.3%2c152 4.8%2c156.7 L148.9%2c291.8 C153.8%2c296.4 161.4%2c296.2 165.9%2c291.3 Z M493.1%2c291.9 L637.2%2c156.8 C642.3%2c152.1 642.3%2c144 637.2%2c139.3 L493.1%2c4.1 C488.3%2c-0.4 480.7%2c-0.2 476.1%2c4.6 L432.6%2c51 C428%2c55.9 428.3%2c63.7 433.4%2c68.2 L524%2c148 L433.4%2c227.7 C428.3%2c232.2 427.9%2c240 432.6%2c244.9 L476.1%2c291.3 C480.6%2c296.2 488.2%2c296.4 493.1%2c291.9 Z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 640 304' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M165.9%2c291.3 L209.4%2c244.9 C214%2c240 213.7%2c232.2 208.6%2c227.7 L118%2c148 L208.6%2c68.3 C213.7%2c63.8 214.1%2c56 209.4%2c51.1 L165.9%2c4.7 C161.4%2c-0.1 153.8%2c-0.4 148.9%2c4.2 L4.8%2c139.2 C-0.3%2c143.9 -0.3%2c152 4.8%2c156.7 L148.9%2c291.8 C153.8%2c296.4 161.4%2c296.2 165.9%2c291.3 Z M493.1%2c291.9 L637.2%2c156.8 C642.3%2c152.1 642.3%2c144 637.2%2c139.3 L493.1%2c4.1 C488.3%2c-0.4 480.7%2c-0.2 476.1%2c4.6 L432.6%2c51 C428%2c55.9 428.3%2c63.7 433.4%2c68.2 L524%2c148 L433.4%2c227.7 C428.3%2c232.2 427.9%2c240 432.6%2c244.9 L476.1%2c291.3 C480.6%2c296.2 488.2%2c296.4 493.1%2c291.9 Z'%3e%3c/path%3e%3c/svg%3e\");\n  top: 0.375rem;\n  bottom: 0.375rem;\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\ntrix-toolbar .trix-button--icon-bullet-list::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z'%3e%3c/path%3e%3c/svg%3e\");\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\ntrix-toolbar .trix-button--icon-number-list::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z'%3e%3c/path%3e%3c/svg%3e\");\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\ntrix-toolbar .trix-button--icon-undo::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z'%3e%3c/path%3e%3c/svg%3e\");\n  top: 0.25rem;\n  bottom: 0.25rem;\n}\n\ntrix-toolbar .trix-button--icon-redo::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 512 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z'%3e%3c/path%3e%3c/svg%3e\");\n  top: 0.25rem;\n  bottom: 0.25rem;\n}\n\ntrix-toolbar .trix-button--icon-decrease-nesting-level::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 448 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M100.682584%2c116.695158 L4.68258422%2c212.695158 C-1.56086141%2c218.942698 -1.56086141%2c229.067619 4.68258422%2c235.315158 L100.682584%2c331.315158 C110.722584%2c341.335158 127.992584%2c334.215158 127.992584%2c319.995158 L127.992584%2c127.995158 C127.992584%2c113.685158 110.662584%2c106.695158 100.682584%2c116.695158 Z M432%2c384 L16%2c384 C7.163444%2c384 1.082166e-15%2c391.163444 0%2c400 L0%2c432 C1.082166e-15%2c440.836556 7.163444%2c448 16%2c448 L432%2c448 C440.836556%2c448 448%2c440.836556 448%2c432 L448%2c400 C448%2c391.163444 440.836556%2c384 432%2c384 Z M204.83%2c256 C201.426459%2c255.997344 198.161555%2c257.348219 195.754887%2c259.754887 C193.348219%2c262.161555 191.997344%2c265.426459 192%2c268.83 L192%2c307.17 C191.997344%2c310.573541 193.348219%2c313.838445 195.754887%2c316.245113 C198.161555%2c318.651781 201.426459%2c320.002656 204.83%2c320 L435.17%2c320 C438.573541%2c320.002656 441.838445%2c318.651781 444.245113%2c316.245113 C446.651781%2c313.838445 448.002656%2c310.573541 448%2c307.17 L448%2c268.83 C448.002656%2c265.426459 446.651781%2c262.161555 444.245113%2c259.754887 C441.838445%2c257.348219 438.573541%2c255.997344 435.17%2c256 L204.83%2c256 Z M435.17%2c128 L204.83%2c128 C201.426459%2c127.997344 198.161555%2c129.348219 195.754887%2c131.754887 C193.348219%2c134.161555 191.997344%2c137.426459 192%2c140.83 L192%2c179.17 C191.997344%2c182.573541 193.348219%2c185.838445 195.754887%2c188.245113 C198.161555%2c190.651781 201.426459%2c192.002656 204.83%2c192 L435.17%2c192 C438.573541%2c192.002656 441.838445%2c190.651781 444.245113%2c188.245113 C446.651781%2c185.838445 448.002656%2c182.573541 448%2c179.17 L448%2c140.83 C448.002656%2c137.426459 446.651781%2c134.161555 444.245113%2c131.754887 C441.838445%2c129.348219 438.573541%2c127.997344 435.17%2c128 Z M432%2c0 L16%2c0 C7.163444%2c0 1.082166e-15%2c7.163444 0%2c16 L0%2c48 C1.082166e-15%2c56.836556 7.163444%2c64 16%2c64 L432%2c64 C440.836556%2c64 448%2c56.836556 448%2c48 L448%2c16 C448%2c7.163444 440.836556%2c0 432%2c0 Z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 448 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M100.682584%2c116.695158 L4.68258422%2c212.695158 C-1.56086141%2c218.942698 -1.56086141%2c229.067619 4.68258422%2c235.315158 L100.682584%2c331.315158 C110.722584%2c341.335158 127.992584%2c334.215158 127.992584%2c319.995158 L127.992584%2c127.995158 C127.992584%2c113.685158 110.662584%2c106.695158 100.682584%2c116.695158 Z M432%2c384 L16%2c384 C7.163444%2c384 1.082166e-15%2c391.163444 0%2c400 L0%2c432 C1.082166e-15%2c440.836556 7.163444%2c448 16%2c448 L432%2c448 C440.836556%2c448 448%2c440.836556 448%2c432 L448%2c400 C448%2c391.163444 440.836556%2c384 432%2c384 Z M204.83%2c256 C201.426459%2c255.997344 198.161555%2c257.348219 195.754887%2c259.754887 C193.348219%2c262.161555 191.997344%2c265.426459 192%2c268.83 L192%2c307.17 C191.997344%2c310.573541 193.348219%2c313.838445 195.754887%2c316.245113 C198.161555%2c318.651781 201.426459%2c320.002656 204.83%2c320 L435.17%2c320 C438.573541%2c320.002656 441.838445%2c318.651781 444.245113%2c316.245113 C446.651781%2c313.838445 448.002656%2c310.573541 448%2c307.17 L448%2c268.83 C448.002656%2c265.426459 446.651781%2c262.161555 444.245113%2c259.754887 C441.838445%2c257.348219 438.573541%2c255.997344 435.17%2c256 L204.83%2c256 Z M435.17%2c128 L204.83%2c128 C201.426459%2c127.997344 198.161555%2c129.348219 195.754887%2c131.754887 C193.348219%2c134.161555 191.997344%2c137.426459 192%2c140.83 L192%2c179.17 C191.997344%2c182.573541 193.348219%2c185.838445 195.754887%2c188.245113 C198.161555%2c190.651781 201.426459%2c192.002656 204.83%2c192 L435.17%2c192 C438.573541%2c192.002656 441.838445%2c190.651781 444.245113%2c188.245113 C446.651781%2c185.838445 448.002656%2c182.573541 448%2c179.17 L448%2c140.83 C448.002656%2c137.426459 446.651781%2c134.161555 444.245113%2c131.754887 C441.838445%2c129.348219 438.573541%2c127.997344 435.17%2c128 Z M432%2c0 L16%2c0 C7.163444%2c0 1.082166e-15%2c7.163444 0%2c16 L0%2c48 C1.082166e-15%2c56.836556 7.163444%2c64 16%2c64 L432%2c64 C440.836556%2c64 448%2c56.836556 448%2c48 L448%2c16 C448%2c7.163444 440.836556%2c0 432%2c0 Z'%3e%3c/path%3e%3c/svg%3e\");\n  margin-bottom: 0;\n}\n\ntrix-toolbar .trix-button--icon-increase-nesting-level::before {\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 448 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 448 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z'%3e%3c/path%3e%3c/svg%3e\");\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\ntrix-toolbar .trix-dialogs {\n  position: relative;\n}\n\ntrix-toolbar .trix-dialog {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 1rem 0.625rem;\n  background-color: var(--vf-bg-input);\n  box-shadow: 0 0px 15px 0px rgba(0, 0, 0, 0.3);\n  margin-top: 0.375rem;\n  border-radius: 0.25rem;\n  z-index: 2;\n}\n\ntrix-toolbar .trix-input--dialog {\n  padding: 0.375rem 0.75rem;\n  border: 1px solid var(--vf-border-color-input);\n  border-radius: 0.25rem;\n  margin-right: 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n}\n\ntrix-toolbar .trix-input--dialog:focus {\n  outline: var(--vf-ring-width) solid var(--vf-ring-color) !important;\n}\n\ntrix-toolbar .trix-input--dialog.validate:invalid {\n  border-color: var(--vf-color-danger);\n}\n\ntrix-toolbar .trix-button--dialog {\n  padding: 0.5rem;\n  border-left-width: 1px;\n  border-color: var(--vf-border-color-input);\n  background-color: transparent;\n  border-radius: 0;\n}\n\ntrix-toolbar .trix-button--dialog:not(.trix-active):hover {\n  background-color: transparent;\n}\n\ntrix-toolbar .trix-button--dialog:first-of-type {\n  border: 0;\n}\n\ntrix-toolbar .trix-dialog--link {\n  max-width: 36rem;\n}\n\ntrix-toolbar .trix-dialog__link-fields {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\ntrix-toolbar .trix-dialog__link-fields .trix-input {\n  flex: 1 1 0%;\n}\n\ntrix-toolbar .trix-dialog__link-fields .trix-button-group {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\ntrix-editor {\n  padding-left: var(--vf-px-input);\n  padding-right: var(--vf-px-input);\n  padding-bottom: var(--vf-py-input);\n  border-radius: var(--vf-radius-large);\n  outline: none;\n  min-height: 6rem;\n}\n\ntrix-editor:empty:not(:focus)::before {\n  color: var(--vf-color-placeholder);\n}\n\ntrix-editor [data-trix-mutable]:not(.attachment__caption-editor) {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n}\n\ntrix-editor [data-trix-mutable]::-moz-selection,\ntrix-editor [data-trix-cursor-target]::-moz-selection,\ntrix-editor [data-trix-mutable] ::-moz-selection {\n  background-image: none;\n}\n\ntrix-editor [data-trix-mutable]::-moz-selection, trix-editor [data-trix-cursor-target]::-moz-selection, trix-editor [data-trix-mutable] ::-moz-selection {\n  background-image: none;\n}\n\ntrix-editor [data-trix-mutable]::selection,\ntrix-editor [data-trix-cursor-target]::selection,\ntrix-editor [data-trix-mutable] ::selection {\n  background-image: none;\n}\n\ntrix-editor [data-trix-mutable].attachment__caption-editor:focus::-moz-selection {\n  background: highlight;\n}\n\ntrix-editor [data-trix-mutable].attachment__caption-editor:focus::selection {\n  background: highlight;\n}\n\ntrix-editor [data-trix-mutable].attachment.attachment--file {\n  background-color: var(--vf-bg-selected);\n}\n\ntrix-editor [data-trix-mutable].attachment img {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\ntrix-editor .attachment {\n  position: relative;\n}\n\ntrix-editor .attachment:hover {\n  cursor: default;\n}\n\ntrix-editor .attachment--preview .attachment__caption:hover {\n  cursor: text;\n}\n\ntrix-editor .attachment__progress {\n  position: absolute;\n  z-index: 1;\n  height: 1.25rem;\n  top: 50%;\n  left: 0;\n  transform: translateY(-0.625rem);\n  width: 100%;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  opacity: 0.2;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\ntrix-editor .attachment__progress[value=\"100\"] {\n  opacity: 0;\n}\n\ntrix-editor .attachment__caption-editor {\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: center;\n  vertical-align: top;\n  width: 100%;\n  border-width: 0;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  outline: 0;\n  background: var(--vf-bg-input);\n  color: var(--vf-color-input);\n  font-family: inherit;\n}\n\ntrix-editor .attachment__toolbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  transform: translateY(-50%);\n  text-align: center;\n  width: 100%;\n}\n\ntrix-editor .trix-button-group {\n  display: inline-flex;\n}\n\ntrix-editor .trix-button {\n  position: relative;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  margin: 0;\n  background-color: transparent;\n  color: var(--vf-bg-icon);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  white-space: nowrap;\n  border-radius: 0;\n  border-width: 0;\n  outline: 0;\n  cursor: pointer;\n}\n\ntrix-editor .trix-button--remove {\n  display: inline-block;\n  overflow-x: hidden;\n  padding: 0;\n  background-color: var(--vf-bg-input);\n  line-height: 1.75rem;\n  border-color: var(--vf-color-selected);\n  border-radius: 9999px;\n  border-width: 1px;\n  border-style: solid;\n  outline: 0;\n  text-indent: -9999px;\n  width: 24px;\n  height: 24px;\n}\n\ntrix-editor .trix-button--remove:hover {\n  background-color: var(--vf-bg-selected);\n}\n\ntrix-editor .trix-button--remove::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0.125rem;\n  right: 0.125rem;\n  bottom: 0.125rem;\n  left: 0.125rem;\n  background-color: var(--vf-color-input);\n  opacity: 0.7;\n  background-position: center;\n  background-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-repeat: no-repeat;\n  mask-position: center center;\n  -webkit-mask-position: center center;\n  mask-size: contain;\n  -webkit-mask-size: contain;\n  mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'%3e%3c/path%3e%3c/svg%3e\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 320 512' fill='currentColor' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'%3e%3c/path%3e%3c/svg%3e\");\n}\n\ntrix-editor .attachment__metadata-container {\n  position: relative;\n}\n\ntrix-editor .attachment__metadata {\n  position: absolute;\n  top: 1rem;\n  left: 50%;\n  padding-top: 0.125rem;\n  padding-bottom: 0.125rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  background-color: #000000;\n  opacity: 0.7;\n  transform: translateX(-50%);\n  color: #ffffff;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border-radius: 0.25rem;\n}\n\ntrix-editor .attachment__metadata .attachment__name {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: bottom;\n  white-space: nowrap;\n  max-width: 100%;\n}\n\ntrix-editor .attachment__metadata .attachment__size {\n  margin-left: 0.25rem;\n  white-space: nowrap;\n}\n\n.trix-content h1,\ntrix-editor h1 {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.trix-content a,\ntrix-editor a {\n  color: var(--vf-primary);\n}\n\n.trix-content ul,\ntrix-editor ul {\n  padding-left: 2.5rem;\n  list-style-type: disc;\n}\n\n.trix-content [dir=rtl] ul,\ntrix-editor [dir=rtl] ul {\n  padding-right: 2.5rem;\n  list-style-type: disc;\n}\n\n.trix-content ol,\ntrix-editor ol {\n  padding-left: 2.5rem;\n  list-style-type: decimal;\n}\n\n.trix-content [dir=rtl] ol,\ntrix-editor [dir=rtl] ol {\n  padding-right: 2.5rem;\n  list-style-type: decimal;\n}\n\n.trix-content blockquote,\ntrix-editor blockquote {\n  padding-left: 0.625rem;\n  border-left-width: 4px;\n  border-color: var(--vf-gray-300);\n  border-left-style: solid;\n  margin: 0;\n}\n\n.trix-content [dir=rtl] blockquote,\n.trix-content blockquote[dir=rtl],\ntrix-editor [dir=rtl] blockquote,\ntrix-editor blockquote[dir=rtl] {\n  padding-left: 0.625rem;\n  border-left-width: 4px;\n  border-color: var(--vf-gray-300);\n}\n\n.trix-content pre,\ntrix-editor pre {\n  display: inline-block;\n  overscroll-behavior-x: auto;\n  padding: 0.5rem;\n  background-color: var(--vf-gray-50);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  vertical-align: top;\n  white-space: pre;\n  width: 100%;\n}\n\n.trix-content img,\ntrix-editor img {\n  max-width: 100%;\n  height: auto;\n}\n\n.trix-content .attachment__caption,\ntrix-editor .attachment__caption {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  text-align: center;\n}\n\n.trix-content .attachment__caption .attachment__name + .attachment__size::before,\ntrix-editor .attachment__caption .attachment__name + .attachment__size::before {\n  content: \" \xb7 \";\n}\n\n.trix-content * {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.trix-content .attachment {\n  display: inline-block;\n  position: relative;\n  max-width: 100%;\n}\n\n.trix-content .attachment a {\n  text-decoration: none;\n}\n\n.trix-content .attachment--preview {\n  text-align: center;\n  width: 100%;\n}\n\n.trix-content .attachment--preview .attachment__caption {\n  color: var(--vf-gray-500);\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.trix-content .attachment--file {\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  margin: 0.125rem;\n  margin-top: 0;\n  color: var(--vf-gray-700);\n  line-height: 1;\n  border-radius: 0.25rem;\n  border-width: 1px;\n  border-color: var(--vf-gray-300);\n}\n\n.trix-content .attachment-gallery {\n  display: flex;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.trix-content .attachment-gallery .attachment {\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 33.333333%;\n}\n\n.trix-content .attachment-gallery.attachment-gallery--2 .attachment, .trix-content .attachment-gallery.attachment-gallery--4 .attachment {\n  width: 50%;\n}\n\n.trix-content .attachment__progress {\n  display: none;\n}\n\n.vf-editor-sm trix-editor {\n  padding-left: var(--vf-px-input-sm);\n  padding-right: var(--vf-px-input-sm);\n  padding-bottom: var(--vf-py-input-sm);\n  border-radius: var(--vf-radius-large-sm);\n  min-height: 5rem;\n}\n\n.vf-editor-sm .trix-content h1,\n.vf-editor-sm trix-editor h1 {\n  font-size: 1.625rem;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.vf-editor-sm trix-toolbar {\n  padding: var(--vf-py-input-sm) var(--vf-py-input-sm);\n}\n\n.vf-editor-sm trix-toolbar .trix-button--icon {\n  width: 2.25rem;\n}\n\n.vf-editor-lg trix-editor {\n  padding-left: var(--vf-px-input-lg);\n  padding-right: var(--vf-px-input-lg);\n  padding-bottom: var(--vf-py-input-lg);\n  border-radius: var(--vf-radius-large-lg);\n}\n\n.vf-editor-disabled trix-toolbar {\n  pointer-events: none;\n}\n\n.vf-editor-hide-bold .trix-button--icon-bold {\n  display: none;\n}\n\n.vf-editor-hide-italic .trix-button--icon-italic {\n  display: none;\n}\n\n.vf-editor-hide-strike .trix-button--icon-strike {\n  display: none;\n}\n\n.vf-editor-hide-link .trix-button--icon-link {\n  display: none;\n}\n\n.vf-editor-hide-heading .trix-button--icon-heading-1 {\n  display: none;\n}\n\n.vf-editor-hide-quote .trix-button--icon-quote {\n  display: none;\n}\n\n.vf-editor-hide-code .trix-button--icon-code {\n  display: none;\n}\n\n.vf-editor-hide-bullet-list .trix-button--icon-bullet-list {\n  display: none;\n}\n\n.vf-editor-hide-number-list .trix-button--icon-number-list {\n  display: none;\n}\n\n.vf-editor-hide-decrease-nesting .trix-button--icon-decrease-nesting-level {\n  display: none;\n}\n\n.vf-editor-hide-increase-nesting .trix-button--icon-increase-nesting-level {\n  display: none;\n}\n\n.vf-editor-hide-attach .trix-button--icon-attach {\n  display: none;\n}\n\n.vf-editor-hide-undo .trix-button--icon-undo {\n  display: none;\n}\n\n.vf-editor-hide-redo .trix-button--icon-redo {\n  display: none;\n}\n\n.dark .trix-content blockquote,\n.dark trix-editor blockquote {\n  border-color: var(--vf-dark-700);\n}\n\n.dark .trix-content pre,\n.dark trix-editor pre {\n  background-color: var(--vf-dark-900);\n}";
$741c336afc2dfa06$var$styleInject($741c336afc2dfa06$var$css_248z);
$741c336afc2dfa06$export$c0ee4c2a5005a714.__file = "themes/vueform/templates/wrappers/EditorWrapper.vue";
function $741c336afc2dfa06$export$53b3c91859018cd4(breakpoint, size) {
    switch(breakpoint){
        case 'default':
            return "vf-col-".concat(size);
        default:
            return "vf-col-".concat(breakpoint, "-").concat(size);
    }
}
var $741c336afc2dfa06$export$188d75d71883854a = {};
var $741c336afc2dfa06$export$7afd9c1079ecedf7 = {
    'matrix-table': {
        addClasses: {
            MatrixElement: {
                container: 'vf-matrix-table',
                cellWrapper_stretch: 'is-stretch'
            }
        },
        overrideClasses: {
            MatrixElement: {
                $cellWrapper: (classes, _ref)=>{
                    var { padding: padding, centered: centered, cells$: cells$ } = _ref;
                    return (type, name)=>{
                        var _cells$$name, _cells$$name2;
                        var isStandalone = [
                            'radio',
                            'checkbox',
                            'toggle'
                        ].includes(type);
                        return [
                            classes.cellWrapper,
                            padding ? classes.cellWrapper_padding : null,
                            isStandalone ? classes.cellWrapper_centered : null,
                            !isStandalone ? classes.cellWrapper_stretch : null,
                            (_cells$$name = cells$[name]) !== null && _cells$$name !== void 0 && _cells$$name.error ? classes.cellWrapper_error : null,
                            (_cells$$name2 = cells$[name]) !== null && _cells$$name2 !== void 0 && _cells$$name2.isSuccess ? classes.cellWrapper_success : null
                        ];
                    };
                }
            }
        }
    },
    'grid-table': {
        addClasses: {
            GridElement: {
                container: 'vf-grid-table'
            },
            ToggleElement: {
                wrapper_sm: 'vf-toggle-wrapper-sm',
                wrapper_md: '',
                wrapper_lg: 'vf-toggle-wrapper-lg'
            }
        },
        overrideClasses: {
            GridElement: {
                $cell: (classes, _ref2)=>{
                    var { colHeader: colHeader, rowHeader: rowHeader } = _ref2;
                    return (_ref3)=>{
                        var { colStart: colStart, rowStart: rowStart } = _ref3;
                        return [
                            classes.cell,
                            rowHeader && colStart === 0 || colHeader && rowStart === 0 ? 'form-bg-table-header form-color-table-header' : null
                        ];
                    };
                }
            },
            ToggleElement: {
                $wrapper: (classes, _ref4)=>{
                    var { align: align, Size: Size } = _ref4;
                    return [
                        classes.wrapper,
                        classes["wrapper_".concat(Size)],
                        align === 'left' ? classes.wrapper_left : null,
                        align === 'right' ? classes.wrapper_right : null
                    ];
                }
            }
        }
    }
};
/**
 * =========
 * Templates
 * =========
 */ var $741c336afc2dfa06$export$2e2bcd8739ae039 = {
    templates: {
        Vueform: $741c336afc2dfa06$export$ed7e61590dca72bb,
        FormErrors: $741c336afc2dfa06$export$db5ae436ef8b64fb,
        FormMessages: $741c336afc2dfa06$export$420782b57eb3768d,
        FormLanguages: $741c336afc2dfa06$export$eb43f6d3822e5083,
        FormLanguage: $741c336afc2dfa06$export$80cb34e9dc8672f2,
        FormTabs: $741c336afc2dfa06$export$94264bf497c2a832,
        FormTab: $741c336afc2dfa06$export$13ab89165168320c,
        FormSteps: $741c336afc2dfa06$export$a07225db3abc2706,
        FormStepsControls: $741c336afc2dfa06$export$26925c1ff00111f9,
        FormStepsControl: $741c336afc2dfa06$export$ff4b910aa71d5221,
        FormStep: $741c336afc2dfa06$export$38affa45b0acd77f,
        FormElements: $741c336afc2dfa06$export$fda5023bf27e64f,
        ElementLayout: $741c336afc2dfa06$export$57539cf15ccc3ae4,
        ElementLayoutInline: $741c336afc2dfa06$export$ec8b469fb4e5fc87,
        ElementLoader: $741c336afc2dfa06$export$c3871e8da9e453bc,
        ElementLabelFloating: $741c336afc2dfa06$export$75fd03dc25d1123c,
        ElementLabel: $741c336afc2dfa06$export$596b151e191dc0da,
        ElementInfo: $741c336afc2dfa06$export$2b84339f145c8f12,
        ElementDescription: $741c336afc2dfa06$export$21ebc6dfdf589803,
        ElementError: $741c336afc2dfa06$export$473043e13ed2e0dd,
        ElementMessage: $741c336afc2dfa06$export$446a47ef83e6389d,
        ElementRequired: $741c336afc2dfa06$export$94f2ad7da0af4e7,
        ElementText: $741c336afc2dfa06$export$f535379b10321bef,
        ElementAddon: $741c336afc2dfa06$export$f69753cc2f1f809e,
        ElementAddonOptions: $741c336afc2dfa06$export$ea88e214de7ca5ac,
        ButtonElement: $741c336afc2dfa06$export$4dbe6dbd7e2997f,
        CaptchaElement: $741c336afc2dfa06$export$99689467e8d9e87e,
        CheckboxElement: $741c336afc2dfa06$export$bdbc55f88cb186c4,
        CheckboxgroupElement: $741c336afc2dfa06$export$7eafe581c398e33d,
        CheckboxgroupElement_tabs: $741c336afc2dfa06$export$5839f83b449473f8,
        CheckboxgroupElement_blocks: $741c336afc2dfa06$export$dddd0f2901295e2,
        DateElement: $741c336afc2dfa06$export$1e68ee11416672d8,
        DatesElement: $741c336afc2dfa06$export$7348cb1e714208cc,
        FileElement: $741c336afc2dfa06$export$552520729baa4d41,
        GridElement: $741c336afc2dfa06$export$cfb3877ce19bb838,
        GroupElement: $741c336afc2dfa06$export$e705959c834cb9fc,
        HiddenElement: $741c336afc2dfa06$export$6f15c4bf3859313a,
        ListElement: $741c336afc2dfa06$export$fe925c804ebb00b7,
        LocationElement: $741c336afc2dfa06$export$af6f82ac48d2952d,
        MatrixElement: $741c336afc2dfa06$export$75126afba5fd227f,
        MultifileElement: $741c336afc2dfa06$export$b8306f5161ddcf9b,
        MultiselectElement: $741c336afc2dfa06$export$f04bd98b66887a8c,
        ObjectElement: $741c336afc2dfa06$export$971f1d98c37594d0,
        PhoneElement: $741c336afc2dfa06$export$62c4233b2e939e6a,
        RadioElement: $741c336afc2dfa06$export$57897effe54831b9,
        RadiogroupElement: $741c336afc2dfa06$export$ad7960f6da4e3648,
        RadiogroupElement_tabs: $741c336afc2dfa06$export$d5bfde599cb8c352,
        RadiogroupElement_blocks: $741c336afc2dfa06$export$7d298c97ad4eee23,
        SelectElement: $741c336afc2dfa06$export$db1b0f09a5df5a00,
        SignatureElement: $741c336afc2dfa06$export$64c8f8ba610cf318,
        SliderElement: $741c336afc2dfa06$export$f1da352a13861d9,
        StaticElement: $741c336afc2dfa06$export$5f9c2763a5c20d1,
        TagsElement: $741c336afc2dfa06$export$751fafeae41a8f96,
        TextareaElement: $741c336afc2dfa06$export$a99fd9ae898251f3,
        TextElement: $741c336afc2dfa06$export$764077542c4bf9bd,
        ToggleElement: $741c336afc2dfa06$export$1285efb30d257f44,
        EditorElement: $741c336afc2dfa06$export$3205440989aad267,
        TTextareaElement: $741c336afc2dfa06$export$58a0c31fb0c39075,
        TTextElement: $741c336afc2dfa06$export$cfc874e59e6fa643,
        TEditorElement: $741c336afc2dfa06$export$21f5918a7e7c135e,
        CheckboxgroupCheckbox: $741c336afc2dfa06$export$a3a0586dceeb64b8,
        CheckboxgroupCheckbox_tabs: $741c336afc2dfa06$export$3f39e34e5e3a5101,
        CheckboxgroupCheckbox_blocks: $741c336afc2dfa06$export$58ae585cad4f8e08,
        DragAndDrop: $741c336afc2dfa06$export$a4c936d95bae1613,
        FilePreview: $741c336afc2dfa06$export$a127194569a41afb,
        FilePreview_image: $741c336afc2dfa06$export$5af9d3946b4cde3c,
        FilePreview_gallery: $741c336afc2dfa06$export$cd9118d548d34ced,
        RadiogroupRadio: $741c336afc2dfa06$export$970323dfa517db7c,
        RadiogroupRadio_tabs: $741c336afc2dfa06$export$6bc195358ee4baf2,
        RadiogroupRadio_blocks: $741c336afc2dfa06$export$2a40e3c673e9086b,
        DatepickerWrapper: $741c336afc2dfa06$export$f26058492132933c,
        EditorWrapper: $741c336afc2dfa06$export$c0ee4c2a5005a714
    },
    classes: $741c336afc2dfa06$export$188d75d71883854a,
    columns: $741c336afc2dfa06$export$53b3c91859018cd4,
    presets: $741c336afc2dfa06$export$7afd9c1079ecedf7
};



var $2fn8G = parcelRequire("2fn8G");
var $51198c658aa3baa7$exports = {};
parcelRequire("ey4ci");
var $ani5R = parcelRequire("ani5R");
parcelRequire("1zKtH");
var $81tj9 = parcelRequire("81tj9");
var $826b59d2f611d30b$export$2e2bcd8739ae039 = (0, $81tj9.default);



var $2fn8G = parcelRequire("2fn8G");
const $51198c658aa3baa7$var$staticSelectsPlugin = {
    apply: 'SelectElement',
    props: {
        staticType: {
            required: false,
            type: String
        }
    },
    setup (props, context, component) {
        if (props.staticType === 'country') {
            let result = [];
            let hasAutoFill = false;
            component.resolvedOptions = async ()=>{
                let locale = (0, $ani5R.inject)('form$').value.locale$ || (0, $ani5R.inject)('config$').value.i18n.locale;
                result = (await (0, $826b59d2f611d30b$export$2e2bcd8739ae039).get('/getcountries/' + locale)).data;
                return result;
            };
            // Very dirty hack to handle autofill
            component.on('search-change', async (search, el$)=>{
                window.setTimeout(()=>{
                    if (hasAutoFill) {
                        const searchResult = result.find((country)=>country.label.toLowerCase() === search.toLowerCase());
                        if (searchResult) el$.update(searchResult.value);
                        el$.$refs.input.deactivate();
                    }
                }, 20);
            });
            document.addEventListener('animationstart', function(e) {
                if (e.animationName === 'autofill-detect') hasAutoFill = true;
            });
        }
        return component;
    }
};
$51198c658aa3baa7$exports = {
    // Same guard as newform's dateValidator (see the long comment there): Vueform's
    // built-in `date` rule feeds the raw value into a strtotime port that starts with
    // `while (str.length)`, so an empty date field throws instead of validating and
    // takes the submit/step handler down with it. Sentry FEW-FRONTEND-VUE-6Z.
    dateValidator: class extends (0, $2fn8G.date) {
        check(value) {
            if (value === null || value === undefined || value === '') return true;
            return super.check(value);
        }
    },
    phoneValidator: class extends (0, $2fn8G.Validator) {
        check() {
            return !this.element$.invalid;
        }
    },
    emailValidator: class extends (0, $2fn8G.Validator) {
        check() {
            if (!this.element$.model && !this.element$.rules.includes('required')) return true;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(this.element$.model).toLowerCase());
        }
    },
    staticSelectsPlugin: $51198c658aa3baa7$var$staticSelectsPlugin
};


function $4760d656fca54e3b$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function $4760d656fca54e3b$var$mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if ($4760d656fca54e3b$var$isObject(target) && $4760d656fca54e3b$var$isObject(source)) {
        for(const key in source)if ($4760d656fca54e3b$var$isObject(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            $4760d656fca54e3b$var$mergeDeep(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    return $4760d656fca54e3b$var$mergeDeep(target, ...sources);
}
const $4760d656fca54e3b$var$de = $4760d656fca54e3b$var$mergeDeep((0, $a0101318ea96f0f1$export$2e2bcd8739ae039), (0, $d393eac6b2a61824$export$2e2bcd8739ae039));
const $4760d656fca54e3b$var$en = $4760d656fca54e3b$var$mergeDeep((0, $f2dccf0e4346ab80$export$2e2bcd8739ae039), (0, $7940c4cd1df46200$export$2e2bcd8739ae039));
$4760d656fca54e3b$var$de.validation.phoneNumber = "Dies ist kein g\xfcltiges Telefonnummer-Format.";
$4760d656fca54e3b$var$en.validation.phoneNumber = 'This is not a valid phone number format.';
var $4760d656fca54e3b$export$2e2bcd8739ae039 = (0, $2fn8G.defineConfig)({
    showRequired: [
        'label',
        'placeholder',
        'floating'
    ],
    validateOn: 'change',
    displayMessages: true,
    theme: (0, $741c336afc2dfa06$export$2e2bcd8739ae039),
    locales: {
        de: $4760d656fca54e3b$var$de,
        en: $4760d656fca54e3b$var$en
    },
    locale: 'de',
    plugins: [
        (0, $51198c658aa3baa7$exports.staticSelectsPlugin)
    ],
    rules: {
        phoneNumber: (0, $51198c658aa3baa7$exports.phoneValidator),
        email: (0, $51198c658aa3baa7$exports.emailValidator),
        // Overrides Vueform's built-in rule of the same name — see plugins.js.
        date: (0, $51198c658aa3baa7$exports.dateValidator)
    },
    endpoints: {
        url: false,
        removeFile: false,
        uploadTempFile: (file, el$)=>el$.form$.providers.doOctoberRequest('onSubmitFile', {
                file: file
            }, true),
        removeTempFile: (file, el$)=>el$.form$.providers.doOctoberRequest('onDeleteFile', {
                id: el$.value
            })
    }
});


//import "vanilla-cookieconsent/dist/cookieconsent.css";
var $f08f3d50fc0396da$exports = {};

$parcel$export($f08f3d50fc0396da$exports, "acceptCategory", () => $f08f3d50fc0396da$export$f733614a75aede52);
$parcel$export($f08f3d50fc0396da$exports, "acceptedCategory", () => $f08f3d50fc0396da$export$d57953daf19d40f0);
$parcel$export($f08f3d50fc0396da$exports, "acceptService", () => $f08f3d50fc0396da$export$954bc960519baaed);
$parcel$export($f08f3d50fc0396da$exports, "acceptedService", () => $f08f3d50fc0396da$export$c6d040ca60661d88);
$parcel$export($f08f3d50fc0396da$exports, "validCookie", () => $f08f3d50fc0396da$export$26b2c20fc8da53a0);
$parcel$export($f08f3d50fc0396da$exports, "eraseCookies", () => $f08f3d50fc0396da$export$6dde6a4e31d2b3a6);
$parcel$export($f08f3d50fc0396da$exports, "show", () => $f08f3d50fc0396da$export$57bf213be019eeb0);
$parcel$export($f08f3d50fc0396da$exports, "hide", () => $f08f3d50fc0396da$export$fe8985bb6374093c);
$parcel$export($f08f3d50fc0396da$exports, "showPreferences", () => $f08f3d50fc0396da$export$535e69674d40eb20);
$parcel$export($f08f3d50fc0396da$exports, "hidePreferences", () => $f08f3d50fc0396da$export$5b3a895f6cbac580);
$parcel$export($f08f3d50fc0396da$exports, "validConsent", () => $f08f3d50fc0396da$export$3bdcc4c9b3764a39);
$parcel$export($f08f3d50fc0396da$exports, "setLanguage", () => $f08f3d50fc0396da$export$4b6bf64406ec64af);
$parcel$export($f08f3d50fc0396da$exports, "getUserPreferences", () => $f08f3d50fc0396da$export$ae3f5fa351e2f57a);
$parcel$export($f08f3d50fc0396da$exports, "loadScript", () => $f08f3d50fc0396da$export$2cb99e4be0dc4646);
$parcel$export($f08f3d50fc0396da$exports, "setCookieData", () => $f08f3d50fc0396da$export$3cbc67a40c3171bd);
$parcel$export($f08f3d50fc0396da$exports, "getCookie", () => $f08f3d50fc0396da$export$4be65e66cfa2648a);
$parcel$export($f08f3d50fc0396da$exports, "getConfig", () => $f08f3d50fc0396da$export$44487a86467333c3);
$parcel$export($f08f3d50fc0396da$exports, "run", () => $f08f3d50fc0396da$export$889ea624f2cb2c57);
$parcel$export($f08f3d50fc0396da$exports, "reset", () => $f08f3d50fc0396da$export$aad8462122ac592b);
/*!
* CookieConsent 3.1.0
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/ const $f08f3d50fc0396da$var$e = 'opt-in', $f08f3d50fc0396da$var$t = 'opt-out', $f08f3d50fc0396da$var$o = 'show--consent', $f08f3d50fc0396da$var$n = 'show--preferences', $f08f3d50fc0396da$var$a = 'disable--interaction', $f08f3d50fc0396da$var$s = 'data-category', $f08f3d50fc0396da$var$c = 'div', $f08f3d50fc0396da$var$r = 'button', $f08f3d50fc0396da$var$i = 'aria-hidden', $f08f3d50fc0396da$var$l = 'btn-group', $f08f3d50fc0396da$var$d = 'click', $f08f3d50fc0396da$var$f = 'data-role', $f08f3d50fc0396da$var$_ = 'consentModal', $f08f3d50fc0396da$var$u = 'preferencesModal';
class $f08f3d50fc0396da$var$p {
    constructor(){
        this.t = {
            mode: $f08f3d50fc0396da$var$e,
            revision: 0,
            autoShow: !0,
            lazyHtmlGeneration: !0,
            autoClearCookies: !0,
            manageScriptTags: !0,
            hideFromBots: !0,
            cookie: {
                name: 'cc_cookie',
                expiresAfterDays: 182,
                domain: '',
                path: '/',
                secure: !0,
                sameSite: 'Lax'
            }
        }, this.o = {
            i: {},
            l: '',
            _: {},
            u: {},
            p: {},
            m: [],
            v: !1,
            h: null,
            C: null,
            S: null,
            M: '',
            D: !0,
            T: !1,
            k: !1,
            A: !1,
            N: !1,
            H: [],
            V: !1,
            I: !0,
            L: [],
            j: !1,
            F: '',
            P: !1,
            O: [],
            R: [],
            B: [],
            $: [],
            G: !1,
            J: !1,
            U: !1,
            q: [],
            K: [],
            W: [],
            X: {},
            Y: {},
            Z: {},
            ee: {},
            te: {},
            oe: []
        }, this.ne = {
            ae: {},
            se: {}
        }, this.ce = {}, this.re = {
            ie: 'cc:onFirstConsent',
            le: 'cc:onConsent',
            de: 'cc:onChange',
            fe: 'cc:onModalShow',
            _e: 'cc:onModalHide',
            ue: 'cc:onModalReady'
        };
    }
}
const $f08f3d50fc0396da$var$g = new $f08f3d50fc0396da$var$p, $f08f3d50fc0396da$var$m = (e, t)=>e.indexOf(t), $f08f3d50fc0396da$var$b = (e, t)=>-1 !== $f08f3d50fc0396da$var$m(e, t), $f08f3d50fc0396da$var$v = (e)=>Array.isArray(e), $f08f3d50fc0396da$var$y = (e)=>'string' == typeof e, $f08f3d50fc0396da$var$h = (e)=>!!e && 'object' == typeof e && !$f08f3d50fc0396da$var$v(e), $f08f3d50fc0396da$var$C = (e)=>'function' == typeof e, $f08f3d50fc0396da$var$w = (e)=>Object.keys(e), $f08f3d50fc0396da$var$S = (e)=>Array.from(new Set(e)), $f08f3d50fc0396da$var$x = ()=>document.activeElement, $f08f3d50fc0396da$var$M = (e)=>e.preventDefault(), $f08f3d50fc0396da$var$D = (e, t)=>e.querySelectorAll(t), $f08f3d50fc0396da$var$T = (e)=>e.dispatchEvent(new Event('change')), $f08f3d50fc0396da$var$k = (e)=>{
    const t = document.createElement(e);
    return e === $f08f3d50fc0396da$var$r && (t.type = e), t;
}, $f08f3d50fc0396da$var$E = (e, t, o)=>e.setAttribute(t, o), $f08f3d50fc0396da$var$A = (e, t, o)=>{
    e.removeAttribute(o ? 'data-' + t : t);
}, $f08f3d50fc0396da$var$N = (e, t, o)=>e.getAttribute(o ? 'data-' + t : t), $f08f3d50fc0396da$var$H = (e, t)=>e.appendChild(t), $f08f3d50fc0396da$var$V = (e, t)=>e.classList.add(t), $f08f3d50fc0396da$var$I = (e, t)=>$f08f3d50fc0396da$var$V(e, 'cm__' + t), $f08f3d50fc0396da$var$L = (e, t)=>$f08f3d50fc0396da$var$V(e, 'pm__' + t), $f08f3d50fc0396da$var$j = (e, t)=>e.classList.remove(t), $f08f3d50fc0396da$var$F = (e)=>{
    if ('object' != typeof e) return e;
    if (e instanceof Date) return new Date(e.getTime());
    let t = Array.isArray(e) ? [] : {};
    for(let o in e){
        let n = e[o];
        t[o] = $f08f3d50fc0396da$var$F(n);
    }
    return t;
}, $f08f3d50fc0396da$var$P = ()=>{
    const e = {}, { O: t, X: o, Y: n } = $f08f3d50fc0396da$var$g.o;
    for (const a of t)e[a] = $f08f3d50fc0396da$var$$(n[a], $f08f3d50fc0396da$var$w(o[a]));
    return e;
}, $f08f3d50fc0396da$var$O = (e, t)=>dispatchEvent(new CustomEvent(e, {
        detail: t
    })), $f08f3d50fc0396da$var$R = (e, t, o, n)=>{
    e.addEventListener(t, o), n && $f08f3d50fc0396da$var$g.o.m.push({
        pe: e,
        ge: t,
        me: o
    });
}, $f08f3d50fc0396da$var$B = ()=>{
    const e = $f08f3d50fc0396da$var$g.t.cookie.expiresAfterDays;
    return $f08f3d50fc0396da$var$C(e) ? e($f08f3d50fc0396da$var$g.o.F) : e;
}, $f08f3d50fc0396da$var$$ = (e, t)=>{
    const o = e || [], n = t || [];
    return o.filter((e)=>!$f08f3d50fc0396da$var$b(n, e)).concat(n.filter((e)=>!$f08f3d50fc0396da$var$b(o, e)));
}, $f08f3d50fc0396da$var$G = (e)=>{
    $f08f3d50fc0396da$var$g.o.R = $f08f3d50fc0396da$var$S(e), $f08f3d50fc0396da$var$g.o.F = (()=>{
        let e = 'custom';
        const { R: t, O: o, B: n } = $f08f3d50fc0396da$var$g.o, a = t.length;
        return a === o.length ? e = 'all' : a === n.length && (e = 'necessary'), e;
    })();
}, $f08f3d50fc0396da$var$J = (e, t, o, n)=>{
    const a = 'accept-', { show: s, showPreferences: c, hide: r, hidePreferences: i, acceptCategory: l } = t, f = e || document, _ = (e)=>$f08f3d50fc0396da$var$D(f, `[data-cc="${e}"]`), u = (e, t)=>{
        $f08f3d50fc0396da$var$M(e), l(t), i(), r();
    }, p = _('show-preferencesModal'), m = _('show-consentModal'), b = _(a + 'all'), v = _(a + 'necessary'), y = _(a + 'custom'), h = $f08f3d50fc0396da$var$g.t.lazyHtmlGeneration;
    for (const e of p)$f08f3d50fc0396da$var$E(e, 'aria-haspopup', 'dialog'), $f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, (e)=>{
        $f08f3d50fc0396da$var$M(e), c();
    }), h && ($f08f3d50fc0396da$var$R(e, 'mouseenter', (e)=>{
        $f08f3d50fc0396da$var$M(e), $f08f3d50fc0396da$var$g.o.N || o(t, n);
    }, !0), $f08f3d50fc0396da$var$R(e, 'focus', ()=>{
        $f08f3d50fc0396da$var$g.o.N || o(t, n);
    }));
    for (let e of m)$f08f3d50fc0396da$var$E(e, 'aria-haspopup', 'dialog'), $f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, (e)=>{
        $f08f3d50fc0396da$var$M(e), s(!0);
    }, !0);
    for (let e of b)$f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, (e)=>{
        u(e, 'all');
    }, !0);
    for (let e of y)$f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, (e)=>{
        u(e);
    }, !0);
    for (let e of v)$f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, (e)=>{
        u(e, []);
    }, !0);
}, $f08f3d50fc0396da$var$U = (e, t)=>{
    e && (t && (e.tabIndex = -1), e.focus(), t && e.removeAttribute('tabindex'));
}, $f08f3d50fc0396da$var$z = (e, t)=>{
    const o = (n)=>{
        n.target.removeEventListener('transitionend', o), 'opacity' === n.propertyName && '1' === getComputedStyle(e).opacity && $f08f3d50fc0396da$var$U(((e)=>1 === e ? $f08f3d50fc0396da$var$g.ne.be : $f08f3d50fc0396da$var$g.ne.ve)(t));
    };
    $f08f3d50fc0396da$var$R(e, 'transitionend', o);
};
let $f08f3d50fc0396da$var$q;
const $f08f3d50fc0396da$var$K = (e)=>{
    clearTimeout($f08f3d50fc0396da$var$q), e ? $f08f3d50fc0396da$var$V($f08f3d50fc0396da$var$g.ne.ye, $f08f3d50fc0396da$var$a) : $f08f3d50fc0396da$var$q = setTimeout(()=>{
        $f08f3d50fc0396da$var$j($f08f3d50fc0396da$var$g.ne.ye, $f08f3d50fc0396da$var$a);
    }, 500);
}, $f08f3d50fc0396da$var$Q = [
    'M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5',
    'M 3.572 13.406 L 8.281 18.115 L 20.428 5.885',
    'M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 '
], $f08f3d50fc0396da$var$W = (e = 0, t = 1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${$f08f3d50fc0396da$var$Q[e]}"/></svg>`, $f08f3d50fc0396da$var$X = (e)=>{
    const t = $f08f3d50fc0396da$var$g.ne, o = $f08f3d50fc0396da$var$g.o;
    ((e)=>{
        const n = e === t.he, a = o.i.disablePageInteraction ? t.ye : n ? t.Ce : t.ye;
        $f08f3d50fc0396da$var$R(a, 'keydown', (t)=>{
            if ('Tab' !== t.key || !(n ? o.k && !o.A : o.A)) return;
            const a = $f08f3d50fc0396da$var$x(), s = n ? o.q : o.K;
            0 !== s.length && (t.shiftKey ? a !== s[0] && e.contains(a) || ($f08f3d50fc0396da$var$M(t), $f08f3d50fc0396da$var$U(s[1])) : a !== s[1] && e.contains(a) || ($f08f3d50fc0396da$var$M(t), $f08f3d50fc0396da$var$U(s[0])));
        }, !0);
    })(e);
}, $f08f3d50fc0396da$var$Y = [
    '[href]',
    $f08f3d50fc0396da$var$r,
    'input',
    'details',
    '[tabindex]'
].map((e)=>e + ':not([tabindex="-1"])').join(','), $f08f3d50fc0396da$var$Z = (e)=>{
    const { o: t, ne: o } = $f08f3d50fc0396da$var$g, n = (e, t)=>{
        const o = $f08f3d50fc0396da$var$D(e, $f08f3d50fc0396da$var$Y);
        t[0] = o[0], t[1] = o[o.length - 1];
    };
    1 === e && t.T && n(o.he, t.q), 2 === e && t.N && n(o.we, t.K);
}, $f08f3d50fc0396da$var$ee = (e, t, o)=>{
    const { de: n, le: a, ie: s, _e: c, ue: r, fe: i } = $f08f3d50fc0396da$var$g.ce, l = $f08f3d50fc0396da$var$g.re;
    if (t) {
        const n = {
            modalName: t
        };
        return e === l.fe ? $f08f3d50fc0396da$var$C(i) && i(n) : e === l._e ? $f08f3d50fc0396da$var$C(c) && c(n) : (n.modal = o, $f08f3d50fc0396da$var$C(r) && r(n)), $f08f3d50fc0396da$var$O(e, n);
    }
    const d = {
        cookie: $f08f3d50fc0396da$var$g.o.p
    };
    e === l.ie ? $f08f3d50fc0396da$var$C(s) && s($f08f3d50fc0396da$var$F(d)) : e === l.le ? $f08f3d50fc0396da$var$C(a) && a($f08f3d50fc0396da$var$F(d)) : (d.changedCategories = $f08f3d50fc0396da$var$g.o.L, d.changedServices = $f08f3d50fc0396da$var$g.o.ee, $f08f3d50fc0396da$var$C(n) && n($f08f3d50fc0396da$var$F(d))), $f08f3d50fc0396da$var$O(e, $f08f3d50fc0396da$var$F(d));
}, $f08f3d50fc0396da$var$te = (e, t)=>{
    try {
        return e();
    } catch (e) {
        return !t && console.warn('CookieConsent:', e), !1;
    }
}, $f08f3d50fc0396da$var$oe = (e)=>{
    const { Y: t, ee: o, O: n, X: a, oe: c, p: r, L: i } = $f08f3d50fc0396da$var$g.o;
    for (const e of n){
        const n = o[e] || t[e] || [];
        for (const o of n){
            const n = a[e][o];
            if (!n) continue;
            const { onAccept: s, onReject: c } = n;
            !n.Se && $f08f3d50fc0396da$var$b(t[e], o) ? (n.Se = !0, $f08f3d50fc0396da$var$C(s) && s()) : n.Se && !$f08f3d50fc0396da$var$b(t[e], o) && (n.Se = !1, $f08f3d50fc0396da$var$C(c) && c());
        }
    }
    if (!$f08f3d50fc0396da$var$g.t.manageScriptTags) return;
    const l = c, d = e || r.categories || [], f = (e, n)=>{
        if (n >= e.length) return;
        const a = c[n];
        if (a.xe) return f(e, n + 1);
        const r = a.Me, l = a.De, _ = a.Te, u = $f08f3d50fc0396da$var$b(d, l), p = !!_ && $f08f3d50fc0396da$var$b(t[l], _);
        if (!_ && !a.ke && u || !_ && a.ke && !u && $f08f3d50fc0396da$var$b(i, l) || _ && !a.ke && p || _ && a.ke && !p && $f08f3d50fc0396da$var$b(o[l] || [], _)) {
            a.xe = !0;
            const t = $f08f3d50fc0396da$var$N(r, 'type', !0);
            $f08f3d50fc0396da$var$A(r, 'type', !!t), $f08f3d50fc0396da$var$A(r, $f08f3d50fc0396da$var$s);
            let o = $f08f3d50fc0396da$var$N(r, 'src', !0);
            o && $f08f3d50fc0396da$var$A(r, 'src', !0);
            const c = $f08f3d50fc0396da$var$k('script');
            c.textContent = r.innerHTML;
            for (const { nodeName: e } of r.attributes)$f08f3d50fc0396da$var$E(c, e, r[e] || $f08f3d50fc0396da$var$N(r, e));
            t && (c.type = t), o ? c.src = o : o = r.src;
            const i = !!o && (!t || [
                'text/javascript',
                'module'
            ].includes(t));
            if (i && (c.onload = c.onerror = ()=>{
                f(e, ++n);
            }), r.replaceWith(c), i) return;
        }
        f(e, ++n);
    };
    f(l, 0);
}, $f08f3d50fc0396da$var$ne = 'bottom', $f08f3d50fc0396da$var$ae = 'left', $f08f3d50fc0396da$var$se = 'center', $f08f3d50fc0396da$var$ce = 'right', $f08f3d50fc0396da$var$re = 'inline', $f08f3d50fc0396da$var$ie = 'wide', $f08f3d50fc0396da$var$le = 'pm--', $f08f3d50fc0396da$var$de = [
    'middle',
    'top',
    $f08f3d50fc0396da$var$ne
], $f08f3d50fc0396da$var$fe = [
    $f08f3d50fc0396da$var$ae,
    $f08f3d50fc0396da$var$se,
    $f08f3d50fc0396da$var$ce
], $f08f3d50fc0396da$var$_e = {
    box: {
        Ee: [
            $f08f3d50fc0396da$var$ie,
            $f08f3d50fc0396da$var$re
        ],
        Ae: $f08f3d50fc0396da$var$de,
        Ne: $f08f3d50fc0396da$var$fe,
        He: $f08f3d50fc0396da$var$ne,
        Ve: $f08f3d50fc0396da$var$ce
    },
    cloud: {
        Ee: [
            $f08f3d50fc0396da$var$re
        ],
        Ae: $f08f3d50fc0396da$var$de,
        Ne: $f08f3d50fc0396da$var$fe,
        He: $f08f3d50fc0396da$var$ne,
        Ve: $f08f3d50fc0396da$var$se
    },
    bar: {
        Ee: [
            $f08f3d50fc0396da$var$re
        ],
        Ae: $f08f3d50fc0396da$var$de.slice(1),
        Ne: [],
        He: $f08f3d50fc0396da$var$ne,
        Ve: ''
    }
}, $f08f3d50fc0396da$var$ue = {
    box: {
        Ee: [],
        Ae: [],
        Ne: [],
        He: '',
        Ve: ''
    },
    bar: {
        Ee: [
            $f08f3d50fc0396da$var$ie
        ],
        Ae: [],
        Ne: [
            $f08f3d50fc0396da$var$ae,
            $f08f3d50fc0396da$var$ce
        ],
        He: '',
        Ve: $f08f3d50fc0396da$var$ae
    }
}, $f08f3d50fc0396da$var$pe = (e)=>{
    const t = $f08f3d50fc0396da$var$g.o.i.guiOptions, o = t && t.consentModal, n = t && t.preferencesModal;
    0 === e && $f08f3d50fc0396da$var$ge($f08f3d50fc0396da$var$g.ne.he, $f08f3d50fc0396da$var$_e, o, 'cm--', 'box', 'cm'), 1 === e && $f08f3d50fc0396da$var$ge($f08f3d50fc0396da$var$g.ne.we, $f08f3d50fc0396da$var$ue, n, $f08f3d50fc0396da$var$le, 'box', 'pm');
}, $f08f3d50fc0396da$var$ge = (e, t, o, n, a, s)=>{
    e.className = s;
    const c = o && o.layout, r = o && o.position, i = o && o.flipButtons, l = !o || !1 !== o.equalWeightButtons, d = c && c.split(' ') || [], f = d[0], _ = d[1], u = f in t ? f : a, p = t[u], m = $f08f3d50fc0396da$var$b(p.Ee, _) && _, v = r && r.split(' ') || [], y = v[0], h = n === $f08f3d50fc0396da$var$le ? v[0] : v[1], C = $f08f3d50fc0396da$var$b(p.Ae, y) ? y : p.He, w = $f08f3d50fc0396da$var$b(p.Ne, h) ? h : p.Ve, S = (t)=>{
        t && $f08f3d50fc0396da$var$V(e, n + t);
    };
    S(u), S(m), S(C), S(w), i && S('flip');
    const x = s + '__btn--secondary';
    if ('cm' === s) {
        const { Ie: e, Le: t } = $f08f3d50fc0396da$var$g.ne;
        e && (l ? $f08f3d50fc0396da$var$j(e, x) : $f08f3d50fc0396da$var$V(e, x)), t && (l ? $f08f3d50fc0396da$var$j(t, x) : $f08f3d50fc0396da$var$V(t, x));
    } else {
        const { je: e } = $f08f3d50fc0396da$var$g.ne;
        e && (l ? $f08f3d50fc0396da$var$j(e, x) : $f08f3d50fc0396da$var$V(e, x));
    }
}, $f08f3d50fc0396da$var$me = (e, t)=>{
    const o = $f08f3d50fc0396da$var$g.o, n = $f08f3d50fc0396da$var$g.ne, { hide: a, hidePreferences: s, acceptCategory: _ } = e, p = (e)=>{
        _(e), s(), a();
    }, m = o.u && o.u.preferencesModal;
    if (!m) return;
    const b = m.title, v = m.closeIconLabel, C = m.acceptAllBtn, S = m.acceptNecessaryBtn, x = m.savePreferencesBtn, M = m.sections || [], D = C || S || x;
    if (n.Fe) n.Pe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$L(n.Pe, 'body');
    else {
        n.Fe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$V(n.Fe, 'pm-wrapper');
        const e = $f08f3d50fc0396da$var$k('div');
        $f08f3d50fc0396da$var$V(e, 'pm-overlay'), $f08f3d50fc0396da$var$H(n.Fe, e), $f08f3d50fc0396da$var$R(e, $f08f3d50fc0396da$var$d, s), n.we = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$V(n.we, 'pm'), $f08f3d50fc0396da$var$E(n.we, 'role', 'dialog'), $f08f3d50fc0396da$var$E(n.we, $f08f3d50fc0396da$var$i, !0), $f08f3d50fc0396da$var$E(n.we, 'aria-modal', !0), $f08f3d50fc0396da$var$E(n.we, 'aria-labelledby', 'pm__title'), $f08f3d50fc0396da$var$R(n.ye, 'keydown', (e)=>{
            27 === e.keyCode && s();
        }, !0), n.Oe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$L(n.Oe, 'header'), n.Re = $f08f3d50fc0396da$var$k('h2'), $f08f3d50fc0396da$var$L(n.Re, 'title'), n.Re.id = 'pm__title', n.Be = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$L(n.Be, 'close-btn'), $f08f3d50fc0396da$var$E(n.Be, 'aria-label', m.closeIconLabel || ''), $f08f3d50fc0396da$var$R(n.Be, $f08f3d50fc0396da$var$d, s), n.$e = $f08f3d50fc0396da$var$k('span'), n.$e.innerHTML = $f08f3d50fc0396da$var$W(), $f08f3d50fc0396da$var$H(n.Be, n.$e), n.Ge = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$L(n.Ge, 'body'), n.Je = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$L(n.Je, 'footer');
        var T = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
        $f08f3d50fc0396da$var$V(T, 'btns');
        var A = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), N = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
        $f08f3d50fc0396da$var$L(A, $f08f3d50fc0396da$var$l), $f08f3d50fc0396da$var$L(N, $f08f3d50fc0396da$var$l), $f08f3d50fc0396da$var$H(n.Je, A), $f08f3d50fc0396da$var$H(n.Je, N), $f08f3d50fc0396da$var$H(n.Oe, n.Re), $f08f3d50fc0396da$var$H(n.Oe, n.Be), n.ve = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$E(n.ve, 'tabIndex', -1), $f08f3d50fc0396da$var$H(n.we, n.ve), $f08f3d50fc0396da$var$H(n.we, n.Oe), $f08f3d50fc0396da$var$H(n.we, n.Ge), D && $f08f3d50fc0396da$var$H(n.we, n.Je), $f08f3d50fc0396da$var$H(n.Fe, n.we);
    }
    let I;
    b && (n.Re.innerHTML = b, v && $f08f3d50fc0396da$var$E(n.Be, 'aria-label', v)), M.forEach((e, t)=>{
        const a = e.title, s = e.description, l = e.linkedCategory, f = l && o.P[l], _ = e.cookieTable, u = _ && _.body, p = _ && _.caption, g = u && u.length > 0, b = !!f, v = b && o.X[l], C = $f08f3d50fc0396da$var$h(v) && $f08f3d50fc0396da$var$w(v) || [], S = b && (!!s || !!g || $f08f3d50fc0396da$var$w(v).length > 0);
        var x = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
        if ($f08f3d50fc0396da$var$L(x, 'section'), S || s) {
            var M = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
            $f08f3d50fc0396da$var$L(M, 'section-desc-wrapper');
        }
        let D = C.length;
        if (S && D > 0) {
            const e = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
            $f08f3d50fc0396da$var$L(e, 'section-services');
            for (const t of C){
                const o = v[t], n = o && o.label || t, a = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), s = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), r = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), i = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
                $f08f3d50fc0396da$var$L(a, 'service'), $f08f3d50fc0396da$var$L(i, 'service-title'), $f08f3d50fc0396da$var$L(s, 'service-header'), $f08f3d50fc0396da$var$L(r, 'service-icon');
                const d = $f08f3d50fc0396da$var$be(n, t, f, !0, l);
                i.innerHTML = n, $f08f3d50fc0396da$var$H(s, r), $f08f3d50fc0396da$var$H(s, i), $f08f3d50fc0396da$var$H(a, s), $f08f3d50fc0396da$var$H(a, d), $f08f3d50fc0396da$var$H(e, a);
            }
            $f08f3d50fc0396da$var$H(M, e);
        }
        if (a) {
            var T = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), A = $f08f3d50fc0396da$var$k(b ? $f08f3d50fc0396da$var$r : $f08f3d50fc0396da$var$c);
            if ($f08f3d50fc0396da$var$L(T, 'section-title-wrapper'), $f08f3d50fc0396da$var$L(A, 'section-title'), A.innerHTML = a, $f08f3d50fc0396da$var$H(T, A), b) {
                const e = $f08f3d50fc0396da$var$k('span');
                e.innerHTML = $f08f3d50fc0396da$var$W(2, 3.5), $f08f3d50fc0396da$var$L(e, 'section-arrow'), $f08f3d50fc0396da$var$H(T, e), x.className += '--toggle';
                const t = $f08f3d50fc0396da$var$be(a, l, f);
                let o = m.serviceCounterLabel;
                if (D > 0 && $f08f3d50fc0396da$var$y(o)) {
                    let e = $f08f3d50fc0396da$var$k('span');
                    $f08f3d50fc0396da$var$L(e, 'badge'), $f08f3d50fc0396da$var$L(e, 'service-counter'), $f08f3d50fc0396da$var$E(e, $f08f3d50fc0396da$var$i, !0), $f08f3d50fc0396da$var$E(e, 'data-servicecounter', D), o && (o = o.split('|'), o = o.length > 1 && D > 1 ? o[1] : o[0], $f08f3d50fc0396da$var$E(e, 'data-counterlabel', o)), e.innerHTML = D + (o ? ' ' + o : ''), $f08f3d50fc0396da$var$H(A, e);
                }
                if (S) {
                    $f08f3d50fc0396da$var$L(x, 'section--expandable');
                    var N = l + '-desc';
                    $f08f3d50fc0396da$var$E(A, 'aria-expanded', !1), $f08f3d50fc0396da$var$E(A, 'aria-controls', N);
                }
                $f08f3d50fc0396da$var$H(T, t);
            } else $f08f3d50fc0396da$var$E(A, 'role', 'heading'), $f08f3d50fc0396da$var$E(A, 'aria-level', '3');
            $f08f3d50fc0396da$var$H(x, T);
        }
        if (s) {
            var F = $f08f3d50fc0396da$var$k('p');
            $f08f3d50fc0396da$var$L(F, 'section-desc'), F.innerHTML = s, $f08f3d50fc0396da$var$H(M, F);
        }
        if (S && ($f08f3d50fc0396da$var$E(M, $f08f3d50fc0396da$var$i, 'true'), M.id = N, ((e, t, o)=>{
            $f08f3d50fc0396da$var$R(A, $f08f3d50fc0396da$var$d, ()=>{
                t.classList.contains('is-expanded') ? ($f08f3d50fc0396da$var$j(t, 'is-expanded'), $f08f3d50fc0396da$var$E(o, 'aria-expanded', 'false'), $f08f3d50fc0396da$var$E(e, $f08f3d50fc0396da$var$i, 'true')) : ($f08f3d50fc0396da$var$V(t, 'is-expanded'), $f08f3d50fc0396da$var$E(o, 'aria-expanded', 'true'), $f08f3d50fc0396da$var$E(e, $f08f3d50fc0396da$var$i, 'false'));
            });
        })(M, x, A), g)) {
            const e = $f08f3d50fc0396da$var$k('table'), o = $f08f3d50fc0396da$var$k('thead'), a = $f08f3d50fc0396da$var$k('tbody');
            if (p) {
                const t = $f08f3d50fc0396da$var$k('caption');
                $f08f3d50fc0396da$var$L(t, 'table-caption'), t.innerHTML = p, e.appendChild(t);
            }
            $f08f3d50fc0396da$var$L(e, 'section-table'), $f08f3d50fc0396da$var$L(o, 'table-head'), $f08f3d50fc0396da$var$L(a, 'table-body');
            const s = _.headers, r = $f08f3d50fc0396da$var$w(s), i = n.Ue.createDocumentFragment(), l = $f08f3d50fc0396da$var$k('tr');
            for (const e of r){
                const o = s[e], n = $f08f3d50fc0396da$var$k('th');
                n.id = 'cc__row-' + o + t, $f08f3d50fc0396da$var$E(n, 'scope', 'col'), $f08f3d50fc0396da$var$L(n, 'table-th'), n.innerHTML = o, $f08f3d50fc0396da$var$H(i, n);
            }
            $f08f3d50fc0396da$var$H(l, i), $f08f3d50fc0396da$var$H(o, l);
            const d = n.Ue.createDocumentFragment();
            for (const e of u){
                const o = $f08f3d50fc0396da$var$k('tr');
                $f08f3d50fc0396da$var$L(o, 'table-tr');
                for (const n of r){
                    const a = s[n], r = e[n], i = $f08f3d50fc0396da$var$k('td'), l = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
                    $f08f3d50fc0396da$var$L(i, 'table-td'), $f08f3d50fc0396da$var$E(i, 'data-column', a), $f08f3d50fc0396da$var$E(i, 'headers', 'cc__row-' + a + t), l.insertAdjacentHTML('beforeend', r), $f08f3d50fc0396da$var$H(i, l), $f08f3d50fc0396da$var$H(o, i);
                }
                $f08f3d50fc0396da$var$H(d, o);
            }
            $f08f3d50fc0396da$var$H(a, d), $f08f3d50fc0396da$var$H(e, o), $f08f3d50fc0396da$var$H(e, a), $f08f3d50fc0396da$var$H(M, e);
        }
        (S || s) && $f08f3d50fc0396da$var$H(x, M);
        const P = n.Pe || n.Ge;
        b ? (I || (I = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$L(I, 'section-toggles')), I.appendChild(x)) : I = null, $f08f3d50fc0396da$var$H(P, I || x);
    }), C && (n.ze || (n.ze = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$L(n.ze, 'btn'), $f08f3d50fc0396da$var$E(n.ze, $f08f3d50fc0396da$var$f, 'all'), $f08f3d50fc0396da$var$H(A, n.ze), $f08f3d50fc0396da$var$R(n.ze, $f08f3d50fc0396da$var$d, ()=>p('all'))), n.ze.innerHTML = C), S && (n.je || (n.je = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$L(n.je, 'btn'), $f08f3d50fc0396da$var$E(n.je, $f08f3d50fc0396da$var$f, 'necessary'), $f08f3d50fc0396da$var$H(A, n.je), $f08f3d50fc0396da$var$R(n.je, $f08f3d50fc0396da$var$d, ()=>p([]))), n.je.innerHTML = S), x && (n.qe || (n.qe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$L(n.qe, 'btn'), $f08f3d50fc0396da$var$L(n.qe, 'btn--secondary'), $f08f3d50fc0396da$var$E(n.qe, $f08f3d50fc0396da$var$f, 'save'), $f08f3d50fc0396da$var$H(N, n.qe), $f08f3d50fc0396da$var$R(n.qe, $f08f3d50fc0396da$var$d, ()=>p())), n.qe.innerHTML = x), n.Pe && (n.we.replaceChild(n.Pe, n.Ge), n.Ge = n.Pe), $f08f3d50fc0396da$var$pe(1), o.N || (o.N = !0, $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.ue, $f08f3d50fc0396da$var$u, n.we), t(e), $f08f3d50fc0396da$var$H(n.Ce, n.Fe), $f08f3d50fc0396da$var$X(n.we), setTimeout(()=>$f08f3d50fc0396da$var$V(n.Fe, 'cc--anim'), 100)), $f08f3d50fc0396da$var$Z(2);
};
function $f08f3d50fc0396da$var$be(e, t, o, n, a) {
    const c = $f08f3d50fc0396da$var$g.o, r = $f08f3d50fc0396da$var$g.ne, l = $f08f3d50fc0396da$var$k('label'), f = $f08f3d50fc0396da$var$k('input'), _ = $f08f3d50fc0396da$var$k('span'), u = $f08f3d50fc0396da$var$k('span'), p = $f08f3d50fc0396da$var$k('span'), m = $f08f3d50fc0396da$var$k('span'), v = $f08f3d50fc0396da$var$k('span');
    if (m.innerHTML = $f08f3d50fc0396da$var$W(1, 3), v.innerHTML = $f08f3d50fc0396da$var$W(0, 3), f.type = 'checkbox', $f08f3d50fc0396da$var$V(l, 'section__toggle-wrapper'), $f08f3d50fc0396da$var$V(f, 'section__toggle'), $f08f3d50fc0396da$var$V(m, 'toggle__icon-on'), $f08f3d50fc0396da$var$V(v, 'toggle__icon-off'), $f08f3d50fc0396da$var$V(_, 'toggle__icon'), $f08f3d50fc0396da$var$V(u, 'toggle__icon-circle'), $f08f3d50fc0396da$var$V(p, 'toggle__label'), $f08f3d50fc0396da$var$E(_, $f08f3d50fc0396da$var$i, 'true'), n ? ($f08f3d50fc0396da$var$V(l, 'toggle-service'), $f08f3d50fc0396da$var$E(f, $f08f3d50fc0396da$var$s, a), r.se[a][t] = f) : r.ae[t] = f, n ? ((e)=>{
        $f08f3d50fc0396da$var$R(f, 'change', ()=>{
            const t = r.se[e], o = r.ae[e];
            c.Z[e] = [];
            for(let o in t){
                const n = t[o];
                n.checked && c.Z[e].push(n.value);
            }
            o.checked = c.Z[e].length > 0;
        });
    })(a) : ((e)=>{
        $f08f3d50fc0396da$var$R(f, $f08f3d50fc0396da$var$d, ()=>{
            const t = r.se[e], o = f.checked;
            c.Z[e] = [];
            for(let n in t)t[n].checked = o, o && c.Z[e].push(n);
        });
    })(t), f.value = t, p.textContent = e.replace(/<.*>.*<\/.*>/gm, ''), $f08f3d50fc0396da$var$H(u, v), $f08f3d50fc0396da$var$H(u, m), $f08f3d50fc0396da$var$H(_, u), c.D) (o.readOnly || o.enabled) && (f.checked = !0);
    else if (n) {
        const e = c.Y[a];
        f.checked = o.readOnly || $f08f3d50fc0396da$var$b(e, t);
    } else $f08f3d50fc0396da$var$b(c.R, t) && (f.checked = !0);
    return o.readOnly && (f.disabled = !0), $f08f3d50fc0396da$var$H(l, f), $f08f3d50fc0396da$var$H(l, _), $f08f3d50fc0396da$var$H(l, p), l;
}
const $f08f3d50fc0396da$var$ve = ()=>{
    const e = $f08f3d50fc0396da$var$k('span');
    return $f08f3d50fc0396da$var$g.ne.Ke || ($f08f3d50fc0396da$var$g.ne.Ke = e), e;
}, $f08f3d50fc0396da$var$ye = (e, t)=>{
    const o = $f08f3d50fc0396da$var$g.o, n = $f08f3d50fc0396da$var$g.ne, { hide: a, showPreferences: s, acceptCategory: u } = e, p = o.u && o.u.consentModal;
    if (!p) return;
    const m = p.acceptAllBtn, b = p.acceptNecessaryBtn, v = p.showPreferencesBtn, y = p.closeIconLabel, h = p.footer, C = p.label, w = p.title, S = (e)=>{
        a(), u(e);
    };
    if (!n.Qe) {
        n.Qe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), n.he = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), n.We = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), n.Xe = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), n.Ye = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$V(n.Qe, 'cm-wrapper'), $f08f3d50fc0396da$var$V(n.he, 'cm'), $f08f3d50fc0396da$var$I(n.We, 'body'), $f08f3d50fc0396da$var$I(n.Xe, 'texts'), $f08f3d50fc0396da$var$I(n.Ye, 'btns'), $f08f3d50fc0396da$var$E(n.he, 'role', 'dialog'), $f08f3d50fc0396da$var$E(n.he, 'aria-modal', 'true'), $f08f3d50fc0396da$var$E(n.he, $f08f3d50fc0396da$var$i, 'false'), $f08f3d50fc0396da$var$E(n.he, 'aria-describedby', 'cm__desc'), C ? $f08f3d50fc0396da$var$E(n.he, 'aria-label', C) : w && $f08f3d50fc0396da$var$E(n.he, 'aria-labelledby', 'cm__title');
        const e = 'box', t = o.i.guiOptions, a = t && t.consentModal, s = (a && a.layout || e).split(' ')[0] === e;
        w && y && s && (n.Le || (n.Le = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), n.Le.innerHTML = $f08f3d50fc0396da$var$W(), $f08f3d50fc0396da$var$I(n.Le, 'btn'), $f08f3d50fc0396da$var$I(n.Le, 'btn--close'), $f08f3d50fc0396da$var$R(n.Le, $f08f3d50fc0396da$var$d, ()=>{
            S([]);
        }), $f08f3d50fc0396da$var$H(n.We, n.Le)), $f08f3d50fc0396da$var$E(n.Le, 'aria-label', y)), $f08f3d50fc0396da$var$H(n.We, n.Xe), (m || b || v) && $f08f3d50fc0396da$var$H(n.We, n.Ye), n.be = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$E(n.be, 'tabIndex', -1), $f08f3d50fc0396da$var$H(n.he, n.be), $f08f3d50fc0396da$var$H(n.he, n.We), $f08f3d50fc0396da$var$H(n.Qe, n.he);
    }
    w && (n.Ze || (n.Ze = $f08f3d50fc0396da$var$k('h2'), n.Ze.className = n.Ze.id = 'cm__title', $f08f3d50fc0396da$var$H(n.Xe, n.Ze)), n.Ze.innerHTML = w);
    let x = p.description;
    if (x && (o.V && (x = x.replace('{{revisionMessage}}', o.I ? '' : p.revisionMessage || '')), n.et || (n.et = $f08f3d50fc0396da$var$k('p'), n.et.className = n.et.id = 'cm__desc', $f08f3d50fc0396da$var$H(n.Xe, n.et)), n.et.innerHTML = x), m && (n.tt || (n.tt = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$H(n.tt, $f08f3d50fc0396da$var$ve()), $f08f3d50fc0396da$var$I(n.tt, 'btn'), $f08f3d50fc0396da$var$E(n.tt, $f08f3d50fc0396da$var$f, 'all'), $f08f3d50fc0396da$var$R(n.tt, $f08f3d50fc0396da$var$d, ()=>{
        S('all');
    })), n.tt.firstElementChild.innerHTML = m), b && (n.Ie || (n.Ie = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$H(n.Ie, $f08f3d50fc0396da$var$ve()), $f08f3d50fc0396da$var$I(n.Ie, 'btn'), $f08f3d50fc0396da$var$E(n.Ie, $f08f3d50fc0396da$var$f, 'necessary'), $f08f3d50fc0396da$var$R(n.Ie, $f08f3d50fc0396da$var$d, ()=>{
        S([]);
    })), n.Ie.firstElementChild.innerHTML = b), v && (n.ot || (n.ot = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$r), $f08f3d50fc0396da$var$H(n.ot, $f08f3d50fc0396da$var$ve()), $f08f3d50fc0396da$var$I(n.ot, 'btn'), $f08f3d50fc0396da$var$I(n.ot, 'btn--secondary'), $f08f3d50fc0396da$var$E(n.ot, $f08f3d50fc0396da$var$f, 'show'), $f08f3d50fc0396da$var$R(n.ot, 'mouseenter', ()=>{
        o.N || $f08f3d50fc0396da$var$me(e, t);
    }), $f08f3d50fc0396da$var$R(n.ot, $f08f3d50fc0396da$var$d, s)), n.ot.firstElementChild.innerHTML = v), n.nt || (n.nt = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$I(n.nt, $f08f3d50fc0396da$var$l), m && $f08f3d50fc0396da$var$H(n.nt, n.tt), b && $f08f3d50fc0396da$var$H(n.nt, n.Ie), (m || b) && $f08f3d50fc0396da$var$H(n.We, n.nt), $f08f3d50fc0396da$var$H(n.Ye, n.nt)), n.ot && !n.st && (n.st = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), n.Ie && n.tt ? ($f08f3d50fc0396da$var$I(n.st, $f08f3d50fc0396da$var$l), $f08f3d50fc0396da$var$H(n.st, n.ot), $f08f3d50fc0396da$var$H(n.Ye, n.st)) : ($f08f3d50fc0396da$var$H(n.nt, n.ot), $f08f3d50fc0396da$var$I(n.nt, $f08f3d50fc0396da$var$l + '--uneven'))), h) {
        if (!n.ct) {
            let e = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), t = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c);
            n.ct = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), $f08f3d50fc0396da$var$I(e, 'footer'), $f08f3d50fc0396da$var$I(t, 'links'), $f08f3d50fc0396da$var$I(n.ct, 'link-group'), $f08f3d50fc0396da$var$H(t, n.ct), $f08f3d50fc0396da$var$H(e, t), $f08f3d50fc0396da$var$H(n.he, e);
        }
        n.ct.innerHTML = h;
    }
    $f08f3d50fc0396da$var$pe(0), o.T || (o.T = !0, $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.ue, $f08f3d50fc0396da$var$_, n.he), t(e), $f08f3d50fc0396da$var$H(n.Ce, n.Qe), $f08f3d50fc0396da$var$X(n.he), setTimeout(()=>$f08f3d50fc0396da$var$V(n.Qe, 'cc--anim'), 100)), $f08f3d50fc0396da$var$Z(1), $f08f3d50fc0396da$var$J(n.We, e, $f08f3d50fc0396da$var$me, t);
}, $f08f3d50fc0396da$var$he = (e)=>{
    if (!$f08f3d50fc0396da$var$y(e)) return null;
    if (e in $f08f3d50fc0396da$var$g.o._) return e;
    let t = e.slice(0, 2);
    return t in $f08f3d50fc0396da$var$g.o._ ? t : null;
}, $f08f3d50fc0396da$var$Ce = ()=>$f08f3d50fc0396da$var$g.o.l || $f08f3d50fc0396da$var$g.o.i.language.default, $f08f3d50fc0396da$var$we = (e)=>{
    e && ($f08f3d50fc0396da$var$g.o.l = e);
}, $f08f3d50fc0396da$var$Se = async (e)=>{
    const t = $f08f3d50fc0396da$var$g.o;
    let o = $f08f3d50fc0396da$var$he(e) ? e : $f08f3d50fc0396da$var$Ce(), n = t._[o];
    if ($f08f3d50fc0396da$var$y(n) ? n = await (async (e)=>{
        try {
            const t = await fetch(e);
            return await t.json();
        } catch (e) {
            return console.error(e), !1;
        }
    })(n) : $f08f3d50fc0396da$var$C(n) && (n = await n()), !n) throw `Could not load translation for the '${o}' language`;
    return t.u = n, $f08f3d50fc0396da$var$we(o), !0;
}, $f08f3d50fc0396da$var$xe = ()=>{
    let e = $f08f3d50fc0396da$var$g.o.i.language.rtl, t = $f08f3d50fc0396da$var$g.ne.Ce;
    e && t && ($f08f3d50fc0396da$var$v(e) || (e = [
        e
    ]), $f08f3d50fc0396da$var$b(e, $f08f3d50fc0396da$var$g.o.l) ? $f08f3d50fc0396da$var$V(t, 'cc--rtl') : $f08f3d50fc0396da$var$j(t, 'cc--rtl'));
}, $f08f3d50fc0396da$var$Me = ()=>{
    const e = $f08f3d50fc0396da$var$g.ne;
    if (e.Ce) return;
    e.Ce = $f08f3d50fc0396da$var$k($f08f3d50fc0396da$var$c), e.Ce.id = 'cc-main', e.Ce.setAttribute('data-nosnippet', ''), $f08f3d50fc0396da$var$xe();
    let t = $f08f3d50fc0396da$var$g.o.i.root;
    t && $f08f3d50fc0396da$var$y(t) && (t = document.querySelector(t)), (t || e.Ue.body).appendChild(e.Ce);
}, $f08f3d50fc0396da$var$De = (e)=>$f08f3d50fc0396da$var$te(()=>localStorage.removeItem(e)), $f08f3d50fc0396da$var$Te = (e, t)=>{
    if (t instanceof RegExp) return e.filter((e)=>t.test(e));
    {
        const o = $f08f3d50fc0396da$var$m(e, t);
        return o > -1 ? [
            e[o]
        ] : [];
    }
}, $f08f3d50fc0396da$var$ke = (e)=>{
    const { hostname: t, protocol: o } = location, { name: n, path: a, domain: s, sameSite: c, useLocalStorage: r, secure: i } = $f08f3d50fc0396da$var$g.t.cookie, l = e ? (()=>{
        const e = $f08f3d50fc0396da$var$g.o.S, t = e ? new Date - e : 0;
        return 864e5 * $f08f3d50fc0396da$var$B() - t;
    })() : 864e5 * $f08f3d50fc0396da$var$B(), d = new Date;
    d.setTime(d.getTime() + l), $f08f3d50fc0396da$var$g.o.p.expirationTime = d.getTime();
    const f = JSON.stringify($f08f3d50fc0396da$var$g.o.p);
    let _ = n + '=' + encodeURIComponent(f) + (0 !== l ? '; expires=' + d.toUTCString() : '') + '; Path=' + a + '; SameSite=' + c;
    $f08f3d50fc0396da$var$b(t, '.') && (_ += '; Domain=' + s), i && 'https:' === o && (_ += '; Secure'), r ? ((e, t)=>{
        $f08f3d50fc0396da$var$te(()=>localStorage.setItem(e, t));
    })(n, f) : document.cookie = _, $f08f3d50fc0396da$var$g.o.p;
}, $f08f3d50fc0396da$var$Ee = (e, t, o)=>{
    if (0 === e.length) return;
    const n = o || $f08f3d50fc0396da$var$g.t.cookie.domain, a = t || $f08f3d50fc0396da$var$g.t.cookie.path, s = 'www.' === n.slice(0, 4), c = s && n.substring(4), r = (e, t)=>{
        t && '.' !== t.slice(0, 1) && (t = '.' + t), document.cookie = e + '=; path=' + a + (t ? '; domain=' + t : '') + '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    };
    for (const t of e)r(t, o), o || r(t, n), s && r(t, c);
}, $f08f3d50fc0396da$var$Ae = (e)=>{
    const t = e || $f08f3d50fc0396da$var$g.t.cookie.name, o = $f08f3d50fc0396da$var$g.t.cookie.useLocalStorage;
    var n;
    return ((e, t)=>{
        let o;
        return o = $f08f3d50fc0396da$var$te(()=>JSON.parse(t ? e : decodeURIComponent(e)), !0) || {}, o;
    })(o ? (n = t, $f08f3d50fc0396da$var$te(()=>localStorage.getItem(n)) || '') : $f08f3d50fc0396da$var$Ne(t, !0), o);
}, $f08f3d50fc0396da$var$Ne = (e, t)=>{
    const o = document.cookie.match('(^|;)\\s*' + e + '\\s*=\\s*([^;]+)');
    return o ? t ? o.pop() : e : '';
}, $f08f3d50fc0396da$var$He = (e)=>{
    const t = document.cookie.split(/;\s*/), o = [];
    for (const n of t){
        let t = n.split('=')[0];
        e ? $f08f3d50fc0396da$var$te(()=>{
            e.test(t) && o.push(t);
        }) : o.push(t);
    }
    return o;
}, $f08f3d50fc0396da$export$f733614a75aede52 = (o, n = [])=>{
    ((e, t)=>{
        const { O: o, R: n, B: a, N: s, Z: c, $: r, X: i } = $f08f3d50fc0396da$var$g.o;
        let l = [];
        if (e) {
            $f08f3d50fc0396da$var$v(e) ? l.push(...e) : $f08f3d50fc0396da$var$y(e) && (l = 'all' === e ? o : [
                e
            ]);
            for (const e of o)c[e] = $f08f3d50fc0396da$var$b(l, e) ? $f08f3d50fc0396da$var$w(i[e]) : [];
        } else l = [
            ...n,
            ...r
        ], s && (l = (()=>{
            const e = $f08f3d50fc0396da$var$g.ne.ae;
            if (!e) return [];
            let t = [];
            for(let o in e)e[o].checked && t.push(o);
            return t;
        })());
        l = l.filter((e)=>!$f08f3d50fc0396da$var$b(o, e) || !$f08f3d50fc0396da$var$b(t, e)), l.push(...a), $f08f3d50fc0396da$var$G(l);
    })(o, n), (()=>{
        const e = $f08f3d50fc0396da$var$g.o, { Z: t, B: o, Y: n, X: a, O: s } = e, c = s;
        e.te = $f08f3d50fc0396da$var$F(n);
        for (const s of c){
            const c = a[s], r = $f08f3d50fc0396da$var$w(c), i = t[s] && t[s].length > 0, l = $f08f3d50fc0396da$var$b(o, s);
            if (0 !== r.length) {
                if (n[s] = [], l) n[s].push(...r);
                else if (i) {
                    const e = t[s];
                    n[s].push(...e);
                } else n[s] = e.Z[s];
                n[s] = $f08f3d50fc0396da$var$S(n[s]);
            }
        }
    })(), (()=>{
        const o = $f08f3d50fc0396da$var$g.o;
        o.L = $f08f3d50fc0396da$var$g.t.mode === $f08f3d50fc0396da$var$t && o.D ? $f08f3d50fc0396da$var$$(o.$, o.R) : $f08f3d50fc0396da$var$$(o.R, o.p.categories);
        let n = o.L.length > 0, a = !1;
        for (const e of o.O)o.ee[e] = $f08f3d50fc0396da$var$$(o.Y[e], o.te[e]), o.ee[e].length > 0 && (a = !0);
        const s = $f08f3d50fc0396da$var$g.ne.ae;
        for(const e in s)s[e].checked = $f08f3d50fc0396da$var$b(o.R, e);
        for (const e of o.O){
            const t = $f08f3d50fc0396da$var$g.ne.se[e], n = o.Y[e];
            for(const e in t)t[e].checked = $f08f3d50fc0396da$var$b(n, e);
        }
        o.C || (o.C = new Date), o.M || (o.M = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (e)=>(e ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> e / 4).toString(16))), o.p = {
            categories: $f08f3d50fc0396da$var$F(o.R),
            revision: $f08f3d50fc0396da$var$g.t.revision,
            data: o.h,
            consentTimestamp: o.C.toISOString(),
            consentId: o.M,
            services: $f08f3d50fc0396da$var$F(o.Y),
            languageCode: $f08f3d50fc0396da$var$g.o.l
        }, o.S && (o.p.lastConsentTimestamp = o.S.toISOString());
        let c = !1;
        const r = n || a;
        (o.D || r) && (o.D && (o.D = !1, c = !0), o.S = o.S ? new Date : o.C, o.p.lastConsentTimestamp = o.S.toISOString(), $f08f3d50fc0396da$var$ke(), $f08f3d50fc0396da$var$g.t.autoClearCookies && (c || r) && ((e)=>{
            const t = $f08f3d50fc0396da$var$g.o, o = $f08f3d50fc0396da$var$He(), n = ((e)=>{
                const t = $f08f3d50fc0396da$var$g.o;
                return (e ? t.O : t.L).filter((e)=>{
                    const o = t.P[e];
                    return !!o && !o.readOnly && !!o.autoClear;
                });
            })(e);
            for(const e in t.ee)for (const n of t.ee[e]){
                const a = t.X[e][n].cookies;
                if (!$f08f3d50fc0396da$var$b(t.Y[e], n) && a) for (const e of a){
                    const t = $f08f3d50fc0396da$var$Te(o, e.name);
                    $f08f3d50fc0396da$var$Ee(t, e.path, e.domain);
                }
            }
            for (const a of n){
                const n = t.P[a].autoClear, s = n && n.cookies || [], c = $f08f3d50fc0396da$var$b(t.L, a), r = !$f08f3d50fc0396da$var$b(t.R, a), i = c && r;
                if (e ? r : i) {
                    n.reloadPage && i && (t.j = !0);
                    for (const e of s){
                        const t = $f08f3d50fc0396da$var$Te(o, e.name);
                        $f08f3d50fc0396da$var$Ee(t, e.path, e.domain);
                    }
                }
            }
        })(c), $f08f3d50fc0396da$var$oe()), c && ($f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.ie), $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.le), $f08f3d50fc0396da$var$g.t.mode === $f08f3d50fc0396da$var$e) || (r && $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.de), o.j && (o.j = !1, location.reload()));
    })();
}, $f08f3d50fc0396da$export$d57953daf19d40f0 = (e)=>{
    const t = $f08f3d50fc0396da$var$g.o.D ? [] : $f08f3d50fc0396da$var$g.o.R;
    return $f08f3d50fc0396da$var$b(t, e);
}, $f08f3d50fc0396da$export$954bc960519baaed = (e, t)=>{
    const { O: o, X: n } = $f08f3d50fc0396da$var$g.o;
    if (!(e && t && $f08f3d50fc0396da$var$y(t) && $f08f3d50fc0396da$var$b(o, t) && 0 !== $f08f3d50fc0396da$var$w(n[t]).length)) return !1;
    ((e, t)=>{
        const o = $f08f3d50fc0396da$var$g.o, { X: n, Z: a, N: s } = o, c = $f08f3d50fc0396da$var$g.ne.se[t] || {}, r = $f08f3d50fc0396da$var$g.ne.ae[t] || {}, i = $f08f3d50fc0396da$var$w(n[t]);
        if (a[t] = [], $f08f3d50fc0396da$var$y(e)) {
            if ('all' === e) {
                if (a[t].push(...i), s) for(let e in c)c[e].checked = !0, $f08f3d50fc0396da$var$T(c[e]);
            } else if ($f08f3d50fc0396da$var$b(i, e) && a[t].push(e), s) for(let t in c)c[t].checked = e === t, $f08f3d50fc0396da$var$T(c[t]);
        } else if ($f08f3d50fc0396da$var$v(e)) for (let o of i){
            const n = $f08f3d50fc0396da$var$b(e, o);
            n && a[t].push(o), s && (c[o].checked = n, $f08f3d50fc0396da$var$T(c[o]));
        }
        const l = 0 === a[t].length;
        o.R = l ? o.R.filter((e)=>e !== t) : $f08f3d50fc0396da$var$S([
            ...o.R,
            t
        ]), s && (r.checked = !l, $f08f3d50fc0396da$var$T(r));
    })(e, t), $f08f3d50fc0396da$export$f733614a75aede52();
}, $f08f3d50fc0396da$export$c6d040ca60661d88 = (e, t)=>{
    const o = $f08f3d50fc0396da$var$g.o.D ? [] : $f08f3d50fc0396da$var$g.o.Y[t] || [];
    return $f08f3d50fc0396da$var$b(o, e);
}, $f08f3d50fc0396da$export$26b2c20fc8da53a0 = (e)=>'' !== $f08f3d50fc0396da$var$Ne(e, !0), $f08f3d50fc0396da$export$6dde6a4e31d2b3a6 = (e, t, o)=>{
    let n = [];
    const a = (e)=>{
        if ($f08f3d50fc0396da$var$y(e)) {
            let t = $f08f3d50fc0396da$var$Ne(e);
            '' !== t && n.push(t);
        } else n.push(...$f08f3d50fc0396da$var$He(e));
    };
    if ($f08f3d50fc0396da$var$v(e)) for (let t of e)a(t);
    else a(e);
    $f08f3d50fc0396da$var$Ee(n, t, o);
}, $f08f3d50fc0396da$export$57bf213be019eeb0 = (e)=>{
    const { ne: t, o: n } = $f08f3d50fc0396da$var$g;
    if (!n.k) {
        if (!n.T) {
            if (!e) return;
            $f08f3d50fc0396da$var$ye($f08f3d50fc0396da$var$Ge, $f08f3d50fc0396da$var$Me);
        }
        n.k = !0, n.J = $f08f3d50fc0396da$var$x(), n.v && $f08f3d50fc0396da$var$K(!0), $f08f3d50fc0396da$var$z(t.he, 1), $f08f3d50fc0396da$var$V(t.ye, $f08f3d50fc0396da$var$o), $f08f3d50fc0396da$var$E(t.he, $f08f3d50fc0396da$var$i, 'false'), setTimeout(()=>{
            $f08f3d50fc0396da$var$U($f08f3d50fc0396da$var$g.ne.be);
        }, 100), $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.fe, $f08f3d50fc0396da$var$_);
    }
}, $f08f3d50fc0396da$export$fe8985bb6374093c = ()=>{
    const { ne: e, o: t, re: n } = $f08f3d50fc0396da$var$g;
    t.k && (t.k = !1, t.v && $f08f3d50fc0396da$var$K(), $f08f3d50fc0396da$var$U(e.Ke, !0), $f08f3d50fc0396da$var$j(e.ye, $f08f3d50fc0396da$var$o), $f08f3d50fc0396da$var$E(e.he, $f08f3d50fc0396da$var$i, 'true'), $f08f3d50fc0396da$var$U(t.J), t.J = null, $f08f3d50fc0396da$var$ee(n._e, $f08f3d50fc0396da$var$_));
}, $f08f3d50fc0396da$export$535e69674d40eb20 = ()=>{
    const e = $f08f3d50fc0396da$var$g.o;
    e.A || (e.N || $f08f3d50fc0396da$var$me($f08f3d50fc0396da$var$Ge, $f08f3d50fc0396da$var$Me), e.A = !0, e.k ? e.U = $f08f3d50fc0396da$var$x() : e.J = $f08f3d50fc0396da$var$x(), $f08f3d50fc0396da$var$z($f08f3d50fc0396da$var$g.ne.we, 2), $f08f3d50fc0396da$var$V($f08f3d50fc0396da$var$g.ne.ye, $f08f3d50fc0396da$var$n), $f08f3d50fc0396da$var$E($f08f3d50fc0396da$var$g.ne.we, $f08f3d50fc0396da$var$i, 'false'), setTimeout(()=>{
        $f08f3d50fc0396da$var$U($f08f3d50fc0396da$var$g.ne.ve);
    }, 100), $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re.fe, $f08f3d50fc0396da$var$u));
}, $f08f3d50fc0396da$export$5b3a895f6cbac580 = ()=>{
    const e = $f08f3d50fc0396da$var$g.o;
    e.A && (e.A = !1, (()=>{
        const e = $f08f3d50fc0396da$export$3bdcc4c9b3764a39(), t = $f08f3d50fc0396da$var$g.o.P, o = $f08f3d50fc0396da$var$g.ne.ae, n = $f08f3d50fc0396da$var$g.ne.se, a = (e)=>$f08f3d50fc0396da$var$b($f08f3d50fc0396da$var$g.o.$, e);
        for(const s in o){
            const c = !!t[s].readOnly;
            o[s].checked = c || (e ? $f08f3d50fc0396da$export$d57953daf19d40f0(s) : a(s));
            for(const t in n[s])n[s][t].checked = c || (e ? $f08f3d50fc0396da$export$c6d040ca60661d88(t, s) : a(s));
        }
    })(), $f08f3d50fc0396da$var$U($f08f3d50fc0396da$var$g.ne.$e, !0), $f08f3d50fc0396da$var$j($f08f3d50fc0396da$var$g.ne.ye, $f08f3d50fc0396da$var$n), $f08f3d50fc0396da$var$E($f08f3d50fc0396da$var$g.ne.we, $f08f3d50fc0396da$var$i, 'true'), e.k ? ($f08f3d50fc0396da$var$U(e.U), e.U = null) : ($f08f3d50fc0396da$var$U(e.J), e.J = null), $f08f3d50fc0396da$var$ee($f08f3d50fc0396da$var$g.re._e, $f08f3d50fc0396da$var$u));
};
var $f08f3d50fc0396da$var$Ge = {
    show: $f08f3d50fc0396da$export$57bf213be019eeb0,
    hide: $f08f3d50fc0396da$export$fe8985bb6374093c,
    showPreferences: $f08f3d50fc0396da$export$535e69674d40eb20,
    hidePreferences: $f08f3d50fc0396da$export$5b3a895f6cbac580,
    acceptCategory: $f08f3d50fc0396da$export$f733614a75aede52
};
const $f08f3d50fc0396da$export$4b6bf64406ec64af = async (e, t)=>{
    if (!$f08f3d50fc0396da$var$he(e)) return !1;
    const o = $f08f3d50fc0396da$var$g.o;
    return !(e === $f08f3d50fc0396da$var$Ce() && !0 !== t || !await $f08f3d50fc0396da$var$Se(e) || ($f08f3d50fc0396da$var$we(e), o.T && $f08f3d50fc0396da$var$ye($f08f3d50fc0396da$var$Ge, $f08f3d50fc0396da$var$Me), o.N && $f08f3d50fc0396da$var$me($f08f3d50fc0396da$var$Ge, $f08f3d50fc0396da$var$Me), $f08f3d50fc0396da$var$xe(), 0));
}, $f08f3d50fc0396da$export$ae3f5fa351e2f57a = ()=>{
    const { F: e, Y: t } = $f08f3d50fc0396da$var$g.o, { accepted: o, rejected: n } = (()=>{
        const { D: e, R: t, O: o } = $f08f3d50fc0396da$var$g.o;
        return {
            accepted: t,
            rejected: e ? [] : o.filter((e)=>!$f08f3d50fc0396da$var$b(t, e))
        };
    })();
    return $f08f3d50fc0396da$var$F({
        acceptType: e,
        acceptedCategories: o,
        rejectedCategories: n,
        acceptedServices: t,
        rejectedServices: $f08f3d50fc0396da$var$P()
    });
}, $f08f3d50fc0396da$export$2cb99e4be0dc4646 = (e, t)=>{
    let o = document.querySelector('script[src="' + e + '"]');
    return new Promise((n)=>{
        if (o) return n(!0);
        if (o = $f08f3d50fc0396da$var$k('script'), $f08f3d50fc0396da$var$h(t)) for(const e in t)$f08f3d50fc0396da$var$E(o, e, t[e]);
        o.onload = ()=>n(!0), o.onerror = ()=>{
            o.remove(), n(!1);
        }, o.src = e, $f08f3d50fc0396da$var$H(document.head, o);
    });
}, $f08f3d50fc0396da$export$3cbc67a40c3171bd = (e)=>{
    let t, o = e.value, n = e.mode, a = !1;
    const s = $f08f3d50fc0396da$var$g.o;
    if ('update' === n) {
        s.h = t = $f08f3d50fc0396da$export$4be65e66cfa2648a('data');
        const e = typeof t == typeof o;
        if (e && 'object' == typeof t) {
            !t && (t = {});
            for(let e in o)t[e] !== o[e] && (t[e] = o[e], a = !0);
        } else !e && t || t === o || (t = o, a = !0);
    } else t = o, a = !0;
    return a && (s.h = t, s.p.data = t, $f08f3d50fc0396da$var$ke(!0)), a;
}, $f08f3d50fc0396da$export$4be65e66cfa2648a = (e, t)=>{
    const o = $f08f3d50fc0396da$var$Ae(t);
    return e ? o[e] : o;
}, $f08f3d50fc0396da$export$44487a86467333c3 = (e)=>{
    const t = $f08f3d50fc0396da$var$g.t, o = $f08f3d50fc0396da$var$g.o.i;
    return e ? t[e] || o[e] : {
        ...t,
        ...o,
        cookie: {
            ...t.cookie
        }
    };
}, $f08f3d50fc0396da$export$3bdcc4c9b3764a39 = ()=>!$f08f3d50fc0396da$var$g.o.D, $f08f3d50fc0396da$export$889ea624f2cb2c57 = async (e)=>{
    const { o: o, t: n, re: a } = $f08f3d50fc0396da$var$g, c = window;
    if (!c._ccRun) {
        if (c._ccRun = !0, ((e)=>{
            const { ne: o, t: n, o: a } = $f08f3d50fc0396da$var$g, c = n, r = a, { cookie: i } = c, l = $f08f3d50fc0396da$var$g.ce, d = e.cookie, f = e.categories, _ = $f08f3d50fc0396da$var$w(f) || [], u = navigator, p = document;
            o.Ue = p, o.ye = p.documentElement, i.domain = location.hostname, r.i = e, r.P = f, r.O = _, r._ = e.language.translations, r.v = !!e.disablePageInteraction, l.ie = e.onFirstConsent, l.le = e.onConsent, l.de = e.onChange, l._e = e.onModalHide, l.fe = e.onModalShow, l.ue = e.onModalReady;
            const { mode: m, autoShow: v, lazyHtmlGeneration: y, autoClearCookies: C, revision: S, manageScriptTags: x, hideFromBots: M } = e;
            m === $f08f3d50fc0396da$var$t && (c.mode = m), 'boolean' == typeof C && (c.autoClearCookies = C), 'boolean' == typeof x && (c.manageScriptTags = x), 'number' == typeof S && S >= 0 && (c.revision = S, r.V = !0), 'boolean' == typeof v && (c.autoShow = v), 'boolean' == typeof y && (c.lazyHtmlGeneration = y), !1 === M && (c.hideFromBots = !1), !0 === c.hideFromBots && u && (r.G = u.userAgent && /bot|crawl|spider|slurp|teoma/i.test(u.userAgent) || u.webdriver), $f08f3d50fc0396da$var$h(d) && (c.cookie = {
                ...i,
                ...d
            }), c.autoClearCookies, r.V, c.manageScriptTags, ((e)=>{
                const { P: t, X: o, Y: n, Z: a, B: s } = $f08f3d50fc0396da$var$g.o;
                for (let c of e){
                    const e = t[c], r = e.services || {}, i = $f08f3d50fc0396da$var$h(r) && $f08f3d50fc0396da$var$w(r) || [];
                    o[c] = {}, n[c] = [], a[c] = [], e.readOnly && (s.push(c), n[c] = i), $f08f3d50fc0396da$var$g.ne.se[c] = {};
                    for (let e of i){
                        const t = r[e];
                        t.Se = !1, o[c][e] = t;
                    }
                }
            })(_), (()=>{
                if (!$f08f3d50fc0396da$var$g.t.manageScriptTags) return;
                const e = $f08f3d50fc0396da$var$g.o, t = $f08f3d50fc0396da$var$D(document, 'script[' + $f08f3d50fc0396da$var$s + ']');
                for (const o of t){
                    let t = $f08f3d50fc0396da$var$N(o, $f08f3d50fc0396da$var$s), n = o.dataset.service || '', a = !1;
                    if (t && '!' === t.charAt(0) && (t = t.slice(1), a = !0), '!' === n.charAt(0) && (n = n.slice(1), a = !0), $f08f3d50fc0396da$var$b(e.O, t) && (e.oe.push({
                        Me: o,
                        xe: !1,
                        ke: a,
                        De: t,
                        Te: n
                    }), n)) {
                        const o = e.X[t];
                        o[n] || (o[n] = {
                            Se: !1
                        });
                    }
                }
            })(), $f08f3d50fc0396da$var$we((()=>{
                const e = $f08f3d50fc0396da$var$g.o.i.language.autoDetect;
                if (e) {
                    const t = {
                        browser: navigator.language,
                        document: document.documentElement.lang
                    }, o = $f08f3d50fc0396da$var$he(t[e]);
                    if (o) return o;
                }
                return $f08f3d50fc0396da$var$Ce();
            })());
        })(e), o.G) return;
        (()=>{
            const e = $f08f3d50fc0396da$var$g.o, o = $f08f3d50fc0396da$var$g.t, n = $f08f3d50fc0396da$var$Ae(), { categories: a, services: s, consentId: c, consentTimestamp: r, lastConsentTimestamp: i, data: l, revision: d } = n, f = $f08f3d50fc0396da$var$v(a);
            e.p = n, e.M = c;
            const _ = !!c && $f08f3d50fc0396da$var$y(c);
            e.C = r, e.C && (e.C = new Date(r)), e.S = i, e.S && (e.S = new Date(i)), e.h = void 0 !== l ? l : null, e.V && _ && d !== o.revision && (e.I = !1), e.D = !(_ && e.I && e.C && e.S && f), o.cookie.useLocalStorage && !e.D && (e.D = (new Date).getTime() > (n.expirationTime || 0), e.D && $f08f3d50fc0396da$var$De(o.cookie.name)), e.D, (()=>{
                const e = $f08f3d50fc0396da$var$g.o;
                for (const o of e.O){
                    const n = e.P[o];
                    if (n.readOnly || n.enabled) {
                        e.$.push(o);
                        const n = e.X[o] || {};
                        for(let a in n)e.Z[o].push(a), e.i.mode === $f08f3d50fc0396da$var$t && e.Y[o].push(a);
                    }
                }
            })(), e.D ? o.mode === $f08f3d50fc0396da$var$t && (e.R = [
                ...e.$
            ]) : (e.Y = {
                ...e.Y,
                ...s
            }, e.Z = {
                ...e.Y
            }, $f08f3d50fc0396da$var$G([
                ...e.B,
                ...a
            ]));
        })();
        const i = $f08f3d50fc0396da$export$3bdcc4c9b3764a39();
        if (!await $f08f3d50fc0396da$var$Se()) return !1;
        if ($f08f3d50fc0396da$var$J(null, r = $f08f3d50fc0396da$var$Ge, $f08f3d50fc0396da$var$me, $f08f3d50fc0396da$var$Me), $f08f3d50fc0396da$var$g.o.D && $f08f3d50fc0396da$var$ye(r, $f08f3d50fc0396da$var$Me), $f08f3d50fc0396da$var$g.t.lazyHtmlGeneration || $f08f3d50fc0396da$var$me(r, $f08f3d50fc0396da$var$Me), n.autoShow && !i && $f08f3d50fc0396da$export$57bf213be019eeb0(!0), i) return $f08f3d50fc0396da$var$oe(), $f08f3d50fc0396da$var$ee(a.le);
        n.mode === $f08f3d50fc0396da$var$t && $f08f3d50fc0396da$var$oe(o.$);
    }
    var r;
}, $f08f3d50fc0396da$export$aad8462122ac592b = (e)=>{
    const { Ce: t, ye: s } = $f08f3d50fc0396da$var$g.ne, { name: c, path: r, domain: i, useLocalStorage: l } = $f08f3d50fc0396da$var$g.t.cookie;
    e && (l ? $f08f3d50fc0396da$var$De(c) : $f08f3d50fc0396da$export$6dde6a4e31d2b3a6(c, r, i));
    for (const { pe: e, ge: t, me: o } of $f08f3d50fc0396da$var$g.o.m)e.removeEventListener(t, o);
    t && t.remove(), s && s.classList.remove($f08f3d50fc0396da$var$a, $f08f3d50fc0396da$var$n, $f08f3d50fc0396da$var$o);
    const d = new $f08f3d50fc0396da$var$p;
    for(const e in $f08f3d50fc0396da$var$g)$f08f3d50fc0396da$var$g[e] = d[e];
    window._ccRun = !1;
};


var $989872f866ee3a88$export$2e2bcd8739ae039 = {
    install: (app)=>{
        app.config.globalProperties.$CookieConsent = $f08f3d50fc0396da$exports;
    }
};


globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
window.initTicketShop = function(elementId, settings) {
    const app = (0, $dDLnc.createApp)((0, $7a3585435420ab8e$export$2e2bcd8739ae039), settings);
    app.use((0, $2fn8G.default), (0, $4760d656fca54e3b$export$2e2bcd8739ae039));
    app.use((0, (/*@__PURE__*/$parcel$interopDefault($149de073a535e218$exports))));
    app.use((0, $3b7be1ea1c2d1789$export$2e2bcd8739ae039));
    app.use((0, $6f25fcfe138d84ae$export$2e2bcd8739ae039));
    app.use((0, $989872f866ee3a88$export$2e2bcd8739ae039));
    app.config.globalProperties.$filters = {
        currency (number) {
            const options = {
                symbol: " \u20AC",
                fractionCount: '2',
                thousandsSeparator: '.',
                fractionSeparator: ','
            };
            return (0, $fdb0bbdbc5657c38$export$2e2bcd8739ae039)(number, options);
        }
    };
    if (typeof window.initSentry !== "undefined") window.initSentry(app);
    app.mount(elementId);
};

})();
//# sourceMappingURL=ticketshop.js.map
